(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "../agentx-component-stores/src/TasksStore/index.ts":
/*!**********************************************************!*\
  !*** ../agentx-component-stores/src/TasksStore/index.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TasksStore: () => (/* reexport safe */ _tasks_store__WEBPACK_IMPORTED_MODULE_0__.TasksStore),
/* harmony export */   TasksType: () => (/* reexport safe */ _tasks_store_interface__WEBPACK_IMPORTED_MODULE_1__.TasksType)
/* harmony export */ });
/* harmony import */ var _tasks_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./tasks-store */ "../agentx-component-stores/src/TasksStore/tasks-store.ts");
/* harmony import */ var _tasks_store_interface__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./tasks-store-interface */ "../agentx-component-stores/src/TasksStore/tasks-store-interface.ts");




/***/ }),

/***/ "../agentx-component-stores/src/TasksStore/tasks-store-interface.ts":
/*!**************************************************************************!*\
  !*** ../agentx-component-stores/src/TasksStore/tasks-store-interface.ts ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TasksType: () => (/* binding */ TasksType)
/* harmony export */ });
var TasksType;
(function (TasksType) {
    TasksType["Open"] = "open";
    TasksType["Queued"] = "queued";
    TasksType["Scheduled"] = "scheduled";
    TasksType["Closed"] = "closed";
})(TasksType || (TasksType = {}));


/***/ }),

/***/ "../agentx-component-stores/src/TasksStore/tasks-store.ts":
/*!****************************************************************!*\
  !*** ../agentx-component-stores/src/TasksStore/tasks-store.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TasksStore: () => (/* binding */ TasksStore)
/* harmony export */ });
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! mobx */ "mobx");
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(mobx__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _logger_store_logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../logger/store-logger */ "../agentx-component-stores/src/logger/store-logger.ts");
/* harmony import */ var _tasks_store_interface__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./tasks-store-interface */ "../agentx-component-stores/src/TasksStore/tasks-store-interface.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



class TasksStore {
    constructor() {
        this.privateSelectedTask = undefined;
        //observable.map was chosen to allow for a simpler integration with AGGrid, do not use unless you have a similar requirement
        this.openTasks = mobx__WEBPACK_IMPORTED_MODULE_0__.observable.map();
        this.queuedTasks = mobx__WEBPACK_IMPORTED_MODULE_0__.observable.map();
        this.scheduledTasks = mobx__WEBPACK_IMPORTED_MODULE_0__.observable.map();
        this.closedTasks = mobx__WEBPACK_IMPORTED_MODULE_0__.observable.map();
        (0,mobx__WEBPACK_IMPORTED_MODULE_0__.makeObservable)(this);
    }
    get selectedTask() {
        return this.privateSelectedTask;
    }
    getTasksByType(tasksType) {
        switch (tasksType) {
            case _tasks_store_interface__WEBPACK_IMPORTED_MODULE_2__.TasksType.Open:
                return this.openTasks;
            case _tasks_store_interface__WEBPACK_IMPORTED_MODULE_2__.TasksType.Queued:
                return this.queuedTasks;
            case _tasks_store_interface__WEBPACK_IMPORTED_MODULE_2__.TasksType.Scheduled:
                return this.scheduledTasks;
            case _tasks_store_interface__WEBPACK_IMPORTED_MODULE_2__.TasksType.Closed:
                return this.closedTasks;
            default:
                throw new Error("Invalid tasks type");
        }
    }
    pollForQueuedTasks(sortBy) {
        return __awaiter(this, void 0, void 0, function* () {
            _logger_store_logger__WEBPACK_IMPORTED_MODULE_1__.logger.info("[TasksStore] NOT IMPLEMENTED - pollForQueuedTasks, sortBy:", sortBy);
        });
    }
    fetchNextPageOfTasks(tasksType) {
        return __awaiter(this, void 0, void 0, function* () {
            _logger_store_logger__WEBPACK_IMPORTED_MODULE_1__.logger.info("[TasksStore] NOT IMPLEMENTED - fetchNextPageOfTasks, tasksType:", tasksType);
            return false;
        });
    }
    setSelectedTask(taskId) {
        var _a, _b, _c;
        if (taskId !== "") {
            const task = (_c = (_b = (_a = this.openTasks.get(taskId)) !== null && _a !== void 0 ? _a : this.queuedTasks.get(taskId)) !== null && _b !== void 0 ? _b : this.scheduledTasks.get(taskId)) !== null && _c !== void 0 ? _c : this.closedTasks.get(taskId);
            if (task) {
                this.privateSelectedTask = task;
            }
        }
        else {
            this.privateSelectedTask = undefined;
        }
    }
}
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_0__.observable
], TasksStore.prototype, "privateSelectedTask", void 0);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_0__.computed
], TasksStore.prototype, "selectedTask", null);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_0__.observable.ref
], TasksStore.prototype, "openTasks", void 0);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_0__.observable.ref
], TasksStore.prototype, "queuedTasks", void 0);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_0__.observable.ref
], TasksStore.prototype, "scheduledTasks", void 0);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_0__.observable.ref
], TasksStore.prototype, "closedTasks", void 0);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_0__.action
], TasksStore.prototype, "pollForQueuedTasks", null);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_0__.action
], TasksStore.prototype, "fetchNextPageOfTasks", null);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_0__.action
], TasksStore.prototype, "setSelectedTask", null);


/***/ }),

/***/ "../agentx-component-stores/src/logger/store-logger.ts":
/*!*************************************************************!*\
  !*** ../agentx-component-stores/src/logger/store-logger.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   logger: () => (/* binding */ logger)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);

const logger = (0,_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.createLogger)("agentx-component-stores");


/***/ }),

/***/ "./src/assets/images/Cisco_Webex_Logo.svg":
/*!************************************************!*\
  !*** ./src/assets/images/Cisco_Webex_Logo.svg ***!
  \************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "images-mfe-wc/Cisco_Webex_Logo.4be28180.svg";

/***/ }),

/***/ "./src/assets/images/teams-icon-color.svg":
/*!************************************************!*\
  !*** ./src/assets/images/teams-icon-color.svg ***!
  \************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "images-mfe-wc/teams-icon-color.5a6d40fd.svg";

/***/ }),

/***/ "./src/assets/styles/common.scss":
/*!***************************************!*\
  !*** ./src/assets/styles/common.scss ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9hc3NldHMvc3R5bGVzL2NvbW1vbi5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0Usa0JBQUE7RUFDQSxVQUFBO0VBQ0EsV0FBQTtFQUNBLFVBQUE7RUFDQSxZQUFBO0VBQ0EsZ0JBQUE7RUFDQSxzQkFBQTtFQUNBLFNBQUE7QUFDRiIsInNvdXJjZXNDb250ZW50IjpbIi5zci1vbmx5IHtcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICB3aWR0aDogMXB4O1xuICBoZWlnaHQ6IDFweDtcbiAgcGFkZGluZzogMDtcbiAgbWFyZ2luOiAtMXB4O1xuICBvdmVyZmxvdzogaGlkZGVuO1xuICBjbGlwOiByZWN0KDAsIDAsIDAsIDApO1xuICBib3JkZXI6IDA7XG59XG4iXSwic291cmNlUm9vdCI6IiJ9 */`);
    

/***/ }),

/***/ "./src/assets/styles/variables.scss":
/*!******************************************!*\
  !*** ./src/assets/styles/variables.scss ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/AgentGStateSelector/GStateSelectorMenu/AgentGStateSelectorMenu.ts":
/*!******************************************************************************************!*\
  !*** ./src/components/AgentGStateSelector/GStateSelectorMenu/AgentGStateSelectorMenu.ts ***!
  \******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   GStateSelectorMenu: () => (/* binding */ GStateSelectorMenu)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_Common_SearchInput_searchInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../components/Common/SearchInput/searchInput */ "./src/components/Common/SearchInput/searchInput.ts");
/* harmony import */ var _TeamPerformanceWidget_components_agentStateSelector_agentStateSelectorInfinite_listError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../TeamPerformanceWidget/components/agentStateSelector/agentStateSelectorInfinite/listError */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/agentStateSelectorInfinite/listError.ts");
/* harmony import */ var _TeamPerformanceWidget_components_agentStateSelector_list__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../TeamPerformanceWidget/components/agentStateSelector/list */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/list.ts");
/* harmony import */ var _IdleCodesListComponent__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./IdleCodesListComponent */ "./src/components/AgentGStateSelector/GStateSelectorMenu/IdleCodesListComponent.ts");
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./index.scss */ "./src/components/AgentGStateSelector/GStateSelectorMenu/index.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var GStateSelectorMenu;
(function (GStateSelectorMenu) {
    /**
     * @element agentx-wc-gstate-selector-menu
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this.idleCodes = {
                data: [],
                meta: {
                    links: { first: "", last: "", next: "", self: "" },
                    orgid: "",
                    page: 0,
                    pageSize: 0,
                    totalPages: 0,
                    totalRecords: 0
                }
            };
            this.isOpen = false;
            this.isMultiChannel = false;
            this.isTpwStateSelector = false;
            this.orgId = "";
            this.isFullHeightList = () => {
                return !this.isMultiChannel;
            };
        }
        static get styles() {
            return [_index_scss__WEBPACK_IMPORTED_MODULE_6__["default"]];
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="state-selector-dropdown-container">
          <search-input></search-input>
          <agentx-wc-gstate-selector-idle-codes-list
            .idleCodes=${this.idleCodes}
            .isOpen=${this.isOpen}
            .isFullHeightList=${this.isFullHeightList()}
            .isTpwStateSelector=${this.isTpwStateSelector}
            .orgId=${this.orgId}
          ></agentx-wc-gstate-selector-idle-codes-list>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
    ], Element.prototype, "idleCodes", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ reflect: true, type: Boolean })
    ], Element.prototype, "isOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ reflect: true, type: Boolean })
    ], Element.prototype, "isMultiChannel", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ reflect: true, type: Boolean })
    ], Element.prototype, "isTpwStateSelector", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "orgId", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-gstate-selector-menu")
    ], Element);
    GStateSelectorMenu.Element = Element;
})(GStateSelectorMenu || (GStateSelectorMenu = {}));


/***/ }),

/***/ "./src/components/AgentGStateSelector/GStateSelectorMenu/AgentGStateSelectorUtils.ts":
/*!*******************************************************************************************!*\
  !*** ./src/components/AgentGStateSelector/GStateSelectorMenu/AgentGStateSelectorUtils.ts ***!
  \*******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   changeAgentState: () => (/* binding */ changeAgentState),
/* harmony export */   fetchIdleCodes: () => (/* binding */ fetchIdleCodes),
/* harmony export */   getDefaultAvailableIdleCode: () => (/* binding */ getDefaultAvailableIdleCode)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_3__);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};




const fetchIdleCodes = (orgId, page, search, PAGE_SIZE = 100) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const params = {
            orgId,
            page,
            search,
            pageSize: PAGE_SIZE
        };
        return yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.abs.fetchPaginatedIdleCodes(params);
    }
    catch (error) {
        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`event=fetchIdleCodes | Tracking ID: ${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.getTrackingIdFromErrorObject)(error) : ""} | Fetching idle codes from aux code is failed : ${error}`, error);
        throw error;
    }
});
const getPreviousStateTime = (currentTimerTimeStamp) => {
    const now = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(new Date().getTime());
    const start = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(currentTimerTimeStamp.getTime());
    const differenceInMS = now.diff(start).milliseconds;
    return Math.round(differenceInMS / 1000);
};
const sendBehavioralTelemetry = () => {
    var _a, _b, _c, _d;
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.AGENT_STATE_CHANGE, [
        (_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.webex_behavioral,
        (_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.prometheus
    ]);
};
const setStateChangeFailureTelemetry = (name, current, currentTimerTimeStamp) => {
    var _a, _b, _c, _d;
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.AGENT_STATE_CHANGE, {
        CurrentState: name,
        PreviousState: current,
        TimeInPreviousState: getPreviousStateTime(currentTimerTimeStamp),
        Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
        Reason: "AgentStateChangeFailure"
    }, [(_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.webex_behavioral, (_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.prometheus]);
};
const changeAgentState = (changeStateParams) => {
    const { name, id, current, currentTimerTimeStamp } = changeStateParams;
    sendBehavioralTelemetry();
    return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.agent
        .stateChange({
        data: {
            state: name === _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE ? _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE : _constants__WEBPACK_IMPORTED_MODULE_0__.IDLE,
            auxCodeIdArray: id.toString()
        }
    })
        .then((data) => {
        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[AgentGStateSelector] Agent state change success request: ${JSON.stringify(data)}`);
        return data;
    })
        .catch((err) => {
        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`event=AgentStateChangeFailure | [AgentGStateSelector] Agent state change failed request: ${(0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.getTrackingIdFromErrorObject)(err)}`, err);
        setStateChangeFailureTelemetry(name, current, currentTimerTimeStamp);
        throw err;
    });
};
const getDefaultAvailableIdleCode = (localizedName) => ({
    name: localizedName,
    id: "0",
    isDefault: false,
    isSystem: false
});


/***/ }),

/***/ "./src/components/AgentGStateSelector/GStateSelectorMenu/IdleCodesListComponent.ts":
/*!*****************************************************************************************!*\
  !*** ./src/components/AgentGStateSelector/GStateSelectorMenu/IdleCodesListComponent.ts ***!
  \*****************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Element: () => (/* binding */ Element)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_Common_SearchInput_searchInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../components/Common/SearchInput/searchInput */ "./src/components/Common/SearchInput/searchInput.ts");
/* harmony import */ var _Common_EmptyStateWrapper_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Common//EmptyStateWrapper/EmptyStateWrapper */ "./src/components/Common/EmptyStateWrapper/EmptyStateWrapper.ts");
/* harmony import */ var _TeamPerformanceWidget_components_agentStateSelector_agentStateSelectorInfinite_listError__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../TeamPerformanceWidget/components/agentStateSelector/agentStateSelectorInfinite/listError */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/agentStateSelectorInfinite/listError.ts");
/* harmony import */ var _TeamPerformanceWidget_components_agentStateSelector_list__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../TeamPerformanceWidget/components/agentStateSelector/list */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/list.ts");
/* harmony import */ var _AgentGStateSelectorUtils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./AgentGStateSelectorUtils */ "./src/components/AgentGStateSelector/GStateSelectorMenu/AgentGStateSelectorUtils.ts");
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./index.scss */ "./src/components/AgentGStateSelector/GStateSelectorMenu/index.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};











const MAX_FULL_HEIGHT = 324;
const MIN_FULL_HEIGHT = 216;
let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
    constructor() {
        super(...arguments);
        this.idleCodes = {
            data: [],
            meta: {
                links: { first: "", last: "", next: "", self: "" },
                orgid: "",
                page: 0,
                pageSize: 0,
                totalPages: 0,
                totalRecords: 0
            }
        };
        this.isOpen = false;
        this.isFullHeightList = true;
        this.isTpwStateSelector = false;
        this.orgId = "";
        this.initialData = [];
        this.currentPage = 0;
        this.totalRecords = 0;
        this.isPageLoading = false;
        this.pageFetchError = {
            isError: false,
            trackingId: ""
        };
        this.getFormattedIdleCodes = (item) => {
            return {
                name: item.name,
                id: item.id,
                index: item.index,
                ariaLabel: item.name,
                template: (data) => {
                    return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `<agent-state-selector-list
          .isOpen=${this.isOpen}
          .agentStateOption=${data}
        ></agent-state-selector-list>`;
                }
            };
        };
        this.getDynamicHeight = () => {
            const maxHeight = this.isFullHeightList ? MAX_FULL_HEIGHT : MIN_FULL_HEIGHT;
            return `${maxHeight}px`;
        };
        this.handleListItemChange = (event) => {
            //TODO: this component should only dispatch the event and let parent handle the state change
            const selectedIdleCode = this.initialData.find((item) => item.id === event.detail.selected[0]);
            const changeStateParams = {
                name: (selectedIdleCode === null || selectedIdleCode === void 0 ? void 0 : selectedIdleCode.name) || "",
                id: (selectedIdleCode === null || selectedIdleCode === void 0 ? void 0 : selectedIdleCode.id) || "",
                current: "",
                currentTimerTimeStamp: new Date() //TODO: previous state time stamp
            };
            (0,_AgentGStateSelectorUtils__WEBPACK_IMPORTED_MODULE_9__.changeAgentState)(changeStateParams);
            this.dispatchEvent(new CustomEvent("state-change-update", {
                detail: {
                    name: (selectedIdleCode === null || selectedIdleCode === void 0 ? void 0 : selectedIdleCode.name) || "",
                    id: (selectedIdleCode === null || selectedIdleCode === void 0 ? void 0 : selectedIdleCode.id) || ""
                },
                composed: true,
                bubbles: true
            }));
        };
        this.loadNextPage = () => __awaiter(this, void 0, void 0, function* () {
            // Load more items
            if (this.isOpen === false) {
                return; // Exit early if the dropdown is closed
            }
            try {
                this.isPageLoading = true;
                const { formattedListItems, totalRecords } = yield this.getListItems(this.currentPage);
                // Update initial data and total records
                this.updateInitialData(formattedListItems, totalRecords);
                this.pageFetchError = {
                    isError: false,
                    trackingId: ""
                };
            }
            catch (error) {
                // Handle errors gracefully
                this.handlePageFetchError(error);
            }
            finally {
                this.isPageLoading = false;
                document.dispatchEvent(new CustomEvent("on-widget-update"));
            }
        });
    }
    static get styles() {
        return [_index_scss__WEBPACK_IMPORTED_MODULE_10__["default"]];
    }
    getStyles() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      <style>
        .state-selector-list-container {
          height: ${this.isFullHeightList ? `${MAX_FULL_HEIGHT}px` : `${MIN_FULL_HEIGHT}px`};
        }
      </style>
    `;
    }
    connectedCallback() {
        super.connectedCallback();
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has("isOpen") && this.isOpen && this.isTpwStateSelector) {
            this.resetData();
            this.loadNextPage();
        }
        if (changedProperties.has("isOpen") && this.isOpen === false && this.isTpwStateSelector) {
            this.resetData();
        }
        if (changedProperties.has("idleCodes") && this.idleCodes && !this.isTpwStateSelector) {
            // add available status to the idle codes and increment the total records
            this.initialData = [(0,_AgentGStateSelectorUtils__WEBPACK_IMPORTED_MODULE_9__.getDefaultAvailableIdleCode)((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.stateChange.available")), ...this.idleCodes.data];
            this.totalRecords = this.idleCodes.meta.totalRecords + 1;
            this.currentPage = this.idleCodes.meta.page + 1;
        }
    }
    resetData() {
        this.currentPage = 0;
        this.initialData = [];
        this.totalRecords = 0;
    }
    // Precompute formatted data
    get formattedData() {
        return this.initialData.map(this.getFormattedIdleCodes);
    }
    getListItems(page) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield (0,_AgentGStateSelectorUtils__WEBPACK_IMPORTED_MODULE_9__.fetchIdleCodes)(this.orgId, page, "");
                const formattedListItems = response.data;
                return { formattedListItems, totalRecords: response.meta.totalRecords };
            }
            catch (error) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("event=getListItems | Error on fetching idle codes on Team Performance Widget Agent State Change Module", error);
                throw error;
            }
        });
    }
    /**
     * Updates the initial data and total records based on the current page and channel type.
     */
    updateInitialData(formattedListItems, totalRecords) {
        if (this.currentPage === 0) {
            // Add "Available" option for the first page
            formattedListItems.unshift((0,_AgentGStateSelectorUtils__WEBPACK_IMPORTED_MODULE_9__.getDefaultAvailableIdleCode)((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.stateChange.available")));
            this.totalRecords = totalRecords + 1;
        }
        else {
            this.totalRecords = totalRecords;
        }
        // Append new items to the existing data
        this.initialData = [...this.initialData, ...formattedListItems];
        this.currentPage += 1;
    }
    /**
     * Handles errors during page fetch and updates the error state.
     */
    handlePageFetchError(error) {
        const trackingId = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.getTrackingIdFromErrorObject)(error) : "";
        this.pageFetchError = { isError: true, trackingId };
        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("event=loadNextPage | Error fetching idle codes on Team Performance Widget Agent State Change Module", error);
    }
    renderState() {
        if (this.initialData.length === 0) {
            if (this.isPageLoading) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
          <div class="state-loading">
            <md-spinner size="18"></md-spinner>
          </div>
        `;
            }
            if (this.pageFetchError.isError) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
          <div class="state-error">
            <agentx-wc-empty-state-wrapper
              class="error-cloud-wrapper"
              illustration-type="error-cloud"
            ></agentx-wc-empty-state-wrapper>
            <div class="error-container">
              <p class="error-title">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorDetail:errorTitle")}</p>
            </div>
            <md-button @click=${() => this.loadNextPage()} id="reload-btn" color="blue">
              <span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorDetail:reloadButton")}</span>
            </md-button>
          </div>
        `;
            }
        }
        return lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing;
    }
    getStatusIndicator() {
        if (this.isPageLoading && this.initialData.length > 0) {
            return [
                {
                    id: "status-indicator",
                    name: "loading",
                    template: () => (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `<div class="infinite-scroll-spinner" part="spinner"><md-spinner size="18"></md-spinner></div>`
                }
            ];
        }
        if (this.pageFetchError.isError && this.initialData.length > 0) {
            return [
                {
                    id: "status-indicator",
                    name: "error",
                    template: () => (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `<agent-state-selector-list-error
              class="fetch-error"
              style="color: red;"
              trackingId="${this.pageFetchError.trackingId}"
              @error-retry="${this.loadNextPage}"
            >
            </agent-state-selector-list-error>`
                }
            ];
        }
        return [];
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      ${this.getStyles()}
      <div class="state-selector-list-container">
        ${this.renderState()}
        ${this.isOpen && this.initialData.length > 0
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
              <md-advance-list
                .items=${[...this.formattedData, ...this.getStatusIndicator()]}
                .isLoading=${this.isPageLoading}
                .isError=${this.pageFetchError.isError}
                containerHeight=${this.getDynamicHeight()}
                ariaRoleList="listbox"
                ariaLabelList="state selector"
                totalRecords=${this.totalRecords}
                @list-item-change=${this.handleListItemChange}
                @load-more=${this.loadNextPage}
              >
              </md-advance-list>
            `
            : ""}
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Object })
], Element.prototype, "idleCodes", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ reflect: true, type: Boolean })
], Element.prototype, "isOpen", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ reflect: true, type: Boolean })
], Element.prototype, "isFullHeightList", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ reflect: true, type: Boolean })
], Element.prototype, "isTpwStateSelector", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
], Element.prototype, "orgId", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], Element.prototype, "initialData", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], Element.prototype, "currentPage", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], Element.prototype, "totalRecords", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], Element.prototype, "isPageLoading", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], Element.prototype, "pageFetchError", void 0);
Element = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-gstate-selector-idle-codes-list")
], Element);



/***/ }),

/***/ "./src/components/AgentGStateSelector/GStateSelectorMenu/index.scss":
/*!**************************************************************************!*\
  !*** ./src/components/AgentGStateSelector/GStateSelectorMenu/index.scss ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`/* General Styles */
.state-selector-dropdown-container {
  line-height: 1.25rem;
  overflow: hidden;
}

/* Search Input Styles */
search-input::part(search-input-wrapper),
search-input::part(md-input-container) {
  padding: 8px;
}

/* Advance List Styles */
md-advance-list::part(spinner) {
  display: flex;
  justify-content: center;
}

md-advance-list::part(advance-list-item-wrapper) {
  padding: 8px 12px;
  overflow: hidden;
  line-height: 1.25rem;
}

.state-loading {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.state-error {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}
.state-error .error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.state-error .error-title {
  font-size: var(--font-size-medium);
  margin: 0 calc(var(--space-token-even) * 8);
  margin-bottom: auto;
  font-weight: 600;
  text-align: center;
  padding: 0;
  color: var(--list-text-color, #121212);
}
.state-error .error-subtitle {
  font-size: var(--font-size-medium);
  margin: 0 calc(var(--space-token-even) * 8);
  margin-bottom: auto;
  text-align: center;
  padding: 0;
}
.state-error .error-cloud-wrapper {
  height: auto;
}
.state-error .error-cloud-wrapper::part(container) {
  background-color: var(--md-secondary-white-bg-color);
}
.state-error .error-cloud-wrapper::part(img) {
  display: block;
  margin: auto;
  width: auto;
}
.state-error md-button {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0FnZW50R1N0YXRlU2VsZWN0b3IvR1N0YXRlU2VsZWN0b3JNZW51L2luZGV4LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsbUJBQUE7QUFDQTtFQUNFLG9CQUFBO0VBQ0EsZ0JBQUE7QUFDRjs7QUFFQSx3QkFBQTtBQUNBOztFQUVFLFlBQUE7QUFDRjs7QUFFQSx3QkFBQTtBQUNBO0VBQ0UsYUFBQTtFQUNBLHVCQUFBO0FBQ0Y7O0FBRUE7RUFDRSxpQkFBQTtFQUNBLGdCQUFBO0VBQ0Esb0JBQUE7QUFDRjs7QUFFQTtFQUNFLFlBQUE7RUFDQSxhQUFBO0VBQ0EsbUJBQUE7RUFDQSx1QkFBQTtBQUNGOztBQUVBO0VBQ0UsYUFBQTtFQUNBLHNCQUFBO0VBQ0EsdUJBQUE7RUFDQSxZQUFBO0FBQ0Y7QUFDRTtFQUNFLGFBQUE7RUFDQSxzQkFBQTtFQUNBLG1CQUFBO0VBQ0EsdUJBQUE7QUFDSjtBQUNFO0VBQ0Usa0NBQUE7RUFDQSwyQ0FBQTtFQUNBLG1CQUFBO0VBQ0EsZ0JBQUE7RUFDQSxrQkFBQTtFQUNBLFVBQUE7RUFDQSxzQ0FBQTtBQUNKO0FBQ0U7RUFDRSxrQ0FBQTtFQUNBLDJDQUFBO0VBQ0EsbUJBQUE7RUFDQSxrQkFBQTtFQUNBLFVBQUE7QUFDSjtBQUNFO0VBQ0UsWUFBQTtBQUNKO0FBRUU7RUFDRSxvREFBQTtBQUFKO0FBR0U7RUFDRSxjQUFBO0VBQ0EsWUFBQTtFQUNBLFdBQUE7QUFESjtBQUdFO0VBQ0UsYUFBQTtFQUNBLHVCQUFBO0VBQ0EsZ0JBQUE7QUFESiIsInNvdXJjZXNDb250ZW50IjpbIi8qIEdlbmVyYWwgU3R5bGVzICovXG4uc3RhdGUtc2VsZWN0b3ItZHJvcGRvd24tY29udGFpbmVyIHtcbiAgbGluZS1oZWlnaHQ6IDEuMjVyZW07XG4gIG92ZXJmbG93OiBoaWRkZW47XG59XG5cbi8qIFNlYXJjaCBJbnB1dCBTdHlsZXMgKi9cbnNlYXJjaC1pbnB1dDo6cGFydChzZWFyY2gtaW5wdXQtd3JhcHBlciksXG5zZWFyY2gtaW5wdXQ6OnBhcnQobWQtaW5wdXQtY29udGFpbmVyKSB7XG4gIHBhZGRpbmc6IDhweDtcbn1cblxuLyogQWR2YW5jZSBMaXN0IFN0eWxlcyAqL1xubWQtYWR2YW5jZS1saXN0OjpwYXJ0KHNwaW5uZXIpIHtcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG59XG5cbm1kLWFkdmFuY2UtbGlzdDo6cGFydChhZHZhbmNlLWxpc3QtaXRlbS13cmFwcGVyKSB7XG4gIHBhZGRpbmc6IDhweCAxMnB4O1xuICBvdmVyZmxvdzogaGlkZGVuO1xuICBsaW5lLWhlaWdodDogMS4yNXJlbTtcbn1cblxuLnN0YXRlLWxvYWRpbmcge1xuICBoZWlnaHQ6IDEwMCU7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xufVxuXG4uc3RhdGUtZXJyb3Ige1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgaGVpZ2h0OiAxMDAlO1xuXG4gIC5lcnJvci1jb250YWluZXIge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICB9XG4gIC5lcnJvci10aXRsZSB7XG4gICAgZm9udC1zaXplOiB2YXIoLS1mb250LXNpemUtbWVkaXVtKTtcbiAgICBtYXJnaW46IDAgY2FsYyh2YXIoLS1zcGFjZS10b2tlbi1ldmVuKSAqIDgpO1xuICAgIG1hcmdpbi1ib3R0b206IGF1dG87XG4gICAgZm9udC13ZWlnaHQ6IDYwMDtcbiAgICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gICAgcGFkZGluZzogMDtcbiAgICBjb2xvcjogdmFyKC0tbGlzdC10ZXh0LWNvbG9yLCAjMTIxMjEyKTtcbiAgfVxuICAuZXJyb3Itc3VidGl0bGUge1xuICAgIGZvbnQtc2l6ZTogdmFyKC0tZm9udC1zaXplLW1lZGl1bSk7XG4gICAgbWFyZ2luOiAwIGNhbGModmFyKC0tc3BhY2UtdG9rZW4tZXZlbikgKiA4KTtcbiAgICBtYXJnaW4tYm90dG9tOiBhdXRvO1xuICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgICBwYWRkaW5nOiAwO1xuICB9XG4gIC5lcnJvci1jbG91ZC13cmFwcGVyIHtcbiAgICBoZWlnaHQ6IGF1dG87XG4gIH1cblxuICAuZXJyb3ItY2xvdWQtd3JhcHBlcjo6cGFydChjb250YWluZXIpIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1tZC1zZWNvbmRhcnktd2hpdGUtYmctY29sb3IpO1xuICB9XG5cbiAgLmVycm9yLWNsb3VkLXdyYXBwZXI6OnBhcnQoaW1nKSB7XG4gICAgZGlzcGxheTogYmxvY2s7XG4gICAgbWFyZ2luOiBhdXRvO1xuICAgIHdpZHRoOiBhdXRvO1xuICB9XG4gIG1kLWJ1dHRvbiB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICBtYXJnaW4tdG9wOiAyNHB4O1xuICB9XG59XG4iXSwic291cmNlUm9vdCI6IiJ9 */`);
    

/***/ }),

/***/ "./src/components/AgentPerformanceReports/AgentPerformanceReports.scss":
/*!*****************************************************************************!*\
  !*** ./src/components/AgentPerformanceReports/AgentPerformanceReports.scss ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --header-height: 65px;
  --tab-height: 51px;
  --more-tab-height: 320px;
  position: relative;
  height: 100%;
}

.agent-performance-reports-container {
  height: 100%;
  display: flex;
}
.agent-performance-reports-container md-tabs {
  width: 100%;
}
.agent-performance-reports-container iframe {
  width: 100%;
  height: 98%;
  border-radius: 8px;
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.18);
}
.agent-performance-reports-container #agent-performance-reports-tabs::part(tabs-more-list) {
  max-height: var(--more-tab-height);
  border-bottom: 0;
}

:host([is-visual-rebrand]) iframe {
  margin-top: 8px;
  box-shadow: none;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0FnZW50UGVyZm9ybWFuY2VSZXBvcnRzL0FnZW50UGVyZm9ybWFuY2VSZXBvcnRzLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxxQkFBQTtFQUNBLGtCQUFBO0VBQ0Esd0JBQUE7RUFDQSxrQkFBQTtFQUNBLFlBQUE7QUFDRjs7QUFFQTtFQUNFLFlBQUE7RUFDQSxhQUFBO0FBQ0Y7QUFDRTtFQUNFLFdBQUE7QUFDSjtBQUVFO0VBQ0UsV0FBQTtFQUNBLFdBQUE7RUFDQSxrQkFBQTtFQUNBLHVDQUFBO0FBQUo7QUFHRTtFQUNFLGtDQUFBO0VBQ0EsZ0JBQUE7QUFESjs7QUFNRTtFQUNFLGVBQUE7RUFDQSxnQkFBQTtBQUhKIiwic291cmNlc0NvbnRlbnQiOlsiOmhvc3Qge1xuICAtLWhlYWRlci1oZWlnaHQ6IDY1cHg7XG4gIC0tdGFiLWhlaWdodDogNTFweDtcbiAgLS1tb3JlLXRhYi1oZWlnaHQ6IDMyMHB4O1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIGhlaWdodDogMTAwJTtcbn1cblxuLmFnZW50LXBlcmZvcm1hbmNlLXJlcG9ydHMtY29udGFpbmVyIHtcbiAgaGVpZ2h0OiAxMDAlO1xuICBkaXNwbGF5OiBmbGV4O1xuXG4gIG1kLXRhYnMge1xuICAgIHdpZHRoOiAxMDAlO1xuICB9XG5cbiAgaWZyYW1lIHtcbiAgICB3aWR0aDogMTAwJTtcbiAgICBoZWlnaHQ6IDk4JTtcbiAgICBib3JkZXItcmFkaXVzOiA4cHg7XG4gICAgYm94LXNoYWRvdzogMCAwIDFweCByZ2JhKDAsIDAsIDAsIDAuMTgpO1xuICB9XG5cbiAgI2FnZW50LXBlcmZvcm1hbmNlLXJlcG9ydHMtdGFiczo6cGFydCh0YWJzLW1vcmUtbGlzdCkge1xuICAgIG1heC1oZWlnaHQ6IHZhcigtLW1vcmUtdGFiLWhlaWdodCk7XG4gICAgYm9yZGVyLWJvdHRvbTogMDtcbiAgfVxufVxuXG46aG9zdChbaXMtdmlzdWFsLXJlYnJhbmRdKSB7XG4gIGlmcmFtZSB7XG4gICAgbWFyZ2luLXRvcDogOHB4O1xuICAgIGJveC1zaGFkb3c6IG5vbmU7XG4gIH1cbn1cbiJdLCJzb3VyY2VSb290IjoiIn0= */`);
    

/***/ }),

/***/ "./src/components/AgentPerformanceReports/AgentPerformanceReports.ts":
/*!***************************************************************************!*\
  !*** ./src/components/AgentPerformanceReports/AgentPerformanceReports.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AgentPerformanceReports: () => (/* binding */ AgentPerformanceReports)
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/config */ "./src/config.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @uuip/unified-ui-platform-common-components */ "@uuip/unified-ui-platform-common-components");
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _AgentPerformanceReports_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./AgentPerformanceReports.scss */ "./src/components/AgentPerformanceReports/AgentPerformanceReports.scss");
/* harmony import */ var _AnalyzerSessionHelper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./AnalyzerSessionHelper */ "./src/components/AgentPerformanceReports/AnalyzerSessionHelper.ts");
/* harmony import */ var _agentReportList__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./agentReportList */ "./src/components/AgentPerformanceReports/agentReportList.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/no-explicit-any */











var AgentPerformanceReports;
(function (AgentPerformanceReports) {
    /**
     * @element agentx-wc-agent-performance-reports
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_5__.LitElement) {
        constructor() {
            super(...arguments);
            this.isDarkTheme = false;
            this.isVisualRebrand = false;
            this.agentReportList = _agentReportList__WEBPACK_IMPORTED_MODULE_10__.agentReportList;
            this.isAnalyzerSessionSet = false;
            this.shouldShowAPSAgentStatsbyQueue = false;
            this.setMoreActionWidth = () => __awaiter(this, void 0, void 0, function* () {
                yield this.updateComplete;
                setTimeout(() => {
                    var _a, _b, _c, _d, _e;
                    const overlayContent = (_e = (_d = (_c = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-tabs")) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector("md-menu-overlay")) === null || _d === void 0 ? void 0 : _d.shadowRoot) === null || _e === void 0 ? void 0 : _e.querySelector(".overlay-content");
                    if (overlayContent) {
                        // Default custom width for menu-overlay is 227px.
                        overlayContent.style.minWidth = _constants__WEBPACK_IMPORTED_MODULE_1__.MIN_WIDTH;
                        overlayContent.style.width = "max-content";
                    }
                }, _constants__WEBPACK_IMPORTED_MODULE_1__.TIMEOUT_THOUSAND_MS);
            });
        }
        static get styles() {
            return _AgentPerformanceReports_scss__WEBPACK_IMPORTED_MODULE_8__["default"];
        }
        connectedCallback() {
            const _super = Object.create(null, {
                connectedCallback: { get: () => super.connectedCallback }
            });
            return __awaiter(this, void 0, void 0, function* () {
                _super.connectedCallback.call(this);
                this.isAnalyzerSessionSet = yield _AnalyzerSessionHelper__WEBPACK_IMPORTED_MODULE_9__.analyzerSessionHelper.create();
                this.addEventListener("selected-changed", this.handleTabClick);
                _agentReportList__WEBPACK_IMPORTED_MODULE_10__.agentReportList.forEach((data, index) => {
                    this.postApsMessage(data.tabId, data.reportId, (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)(`app:apsReports.${data.tabId}`), `report-${index}`);
                });
                this.setMoreActionWidth();
            });
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.removeEventListener("selected-changed", this.handleTabClick);
        }
        handleTabClick(event) {
            const tabTitle = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)(`app:apsReports.${_agentReportList__WEBPACK_IMPORTED_MODULE_10__.agentReportList[event.detail.value].tabId}`);
            const id = `report-${event.detail.value}`;
            this.postApsMessage(_agentReportList__WEBPACK_IMPORTED_MODULE_10__.agentReportList[event.detail.value].tabId, _agentReportList__WEBPACK_IMPORTED_MODULE_10__.agentReportList[event.detail.value].reportId, tabTitle, id);
        }
        postApsMessage(tabId, reportId, tabTitle, id) {
            var _a;
            const message = {
                event: "onReportClick",
                data: { reportId, reportName: tabTitle, tabId }
            };
            const frameElem = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`#${id}`);
            if (frameElem === null || frameElem === void 0 ? void 0 : frameElem.contentWindow) {
                frameElem.contentWindow.postMessage(JSON.stringify(message), "*");
            }
        }
        shouldRenderTabContent(tabId) {
            return !(tabId === "agentStatisticsByQueueRealtime" && !this.shouldShowAPSAgentStatsbyQueue);
        }
        render() {
            return this.isAnalyzerSessionSet
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
            <div class="agent-performance-reports-container">
              <md-tabs
                id="agent-performance-reports-tabs"
                persist-selection=${true}
                overflowLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)(`app:common.moreTabs`)}
                tabs-id="aps-tabs"
                ?newMomentum=${this.isVisualRebrand}
                ?scroll-arrow=${this.isVisualRebrand}
                variant=${this.isVisualRebrand ? "primary" : "ghost"}
                type=${this.isVisualRebrand ? "rounded" : "line"}
              >
                ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_7__.repeat)(this.agentReportList, ({ tabId, reportId, isDashboard }, index) => {
                    if (this.shouldRenderTabContent(tabId)) {
                        const tabTitle = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)(`app:apsReports.${tabId}`);
                        const id = `report-${index}`;
                        return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
                      <md-tab slot="tab" label="${tabTitle}" aria-label="${tabTitle}">${tabTitle}</md-tab>
                      <md-tab-panel slot="panel" class="aps-tab-panel">
                        <iframe
                          src="${_config__WEBPACK_IMPORTED_MODULE_0__.CONF.ANALYZER_HOST}/analyzer/view/${isDashboard
                            ? "embed"
                            : "iframe"}?rId=${reportId}&is_dark_theme=${this.isDarkTheme}&is_visual_rebrand=${this
                            .isVisualRebrand}"
                          title="${tabTitle}"
                          id="${id}"
                          frameborder="0"
                          class="report-frame"
                        ></iframe>
                      </md-tab-panel>
                    `;
                    }
                    return lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing;
                })}
              </md-tabs>
            </div>
          `
                : (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) ` <uuip-wc-content-loading></uuip-wc-content-loading> `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean, attribute: "is-dark-theme" })
    ], Element.prototype, "isDarkTheme", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean, attribute: "is-visual-rebrand" })
    ], Element.prototype, "isVisualRebrand", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Array })
    ], Element.prototype, "agentReportList", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ attribute: false })
    ], Element.prototype, "isAnalyzerSessionSet", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean, attribute: "show-aps-agent-stats-by-queue" })
    ], Element.prototype, "shouldShowAPSAgentStatsbyQueue", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.customElement)("agentx-wc-agent-performance-reports")
    ], Element);
    AgentPerformanceReports.Element = Element;
})(AgentPerformanceReports || (AgentPerformanceReports = {}));


/***/ }),

/***/ "./src/components/AgentPerformanceReports/AnalyzerSessionHelper.ts":
/*!*************************************************************************!*\
  !*** ./src/components/AgentPerformanceReports/AnalyzerSessionHelper.ts ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   analyzerSessionHelper: () => (/* binding */ analyzerSessionHelper)
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/config */ "./src/config.ts");

/**
 * *** AnalyzerSessionHelper used for workaround to create analyzer session before loading reports ***
 *
 * AnalyzerSessionHelper is a singleton instance, which created only
 *
 * creating analyzer session before stating to load reports is done to prevent
 * side effects of simultaneous session initializations by multiple reports
 * */
class AnalyzerSessionHelper {
    constructor() {
        this.analyzerSessionIframe = document.createElement("iframe");
        this.isAnalyzerSessionSet = false;
        this.initiated = false;
    }
    create() {
        const clusterId = localStorage.getItem("clusterId");
        if (this.isAnalyzerSessionSet) {
            return Promise.resolve(true);
        }
        if (this.initiated) {
            return this.promiseReference;
        }
        this.initiated = true;
        this.promiseReference = new Promise((resolve) => {
            this.analyzerSessionIframe.setAttribute("style", "display: none");
            this.analyzerSessionIframe.onload = () => {
                this.isAnalyzerSessionSet = true;
                resolve(true);
            };
            const clusterQueryParam = `?ciClusterId=${clusterId}`;
            const analyzerGetVersionUrl = `${_config__WEBPACK_IMPORTED_MODULE_0__.CONF.ANALYZER_HOST}/analyzer/version/get${clusterQueryParam}`;
            this.analyzerSessionIframe.src = analyzerGetVersionUrl;
            document.body.appendChild(this.analyzerSessionIframe);
            /* Analyzer sessions are valid only for 30 mins, on calling /version/get api, session time will be extended for 30 mins */
            this.intervalRef = setInterval(() => {
                this.analyzerSessionIframe.src = `${analyzerGetVersionUrl}&t=${Date.now()}`;
            }, 25 * 60 * 1000);
        });
        return this.promiseReference;
    }
    analyzerLogout() {
        let logoutTimeoutTracker = null;
        this.promiseReference = new Promise((resolve, reject) => {
            this.intervalRef && clearInterval(this.intervalRef); // stop analyzer session extender
            this.analyzerSessionIframe.setAttribute("style", "display: none");
            this.analyzerSessionIframe.onload = () => {
                logoutTimeoutTracker && clearTimeout(logoutTimeoutTracker);
                this.initiated = false;
                this.isAnalyzerSessionSet = false;
                resolve(true);
            };
            this.analyzerSessionIframe.src = `${_config__WEBPACK_IMPORTED_MODULE_0__.CONF.ANALYZER_HOST}/analyzer/app-logout`;
            document.body.appendChild(this.analyzerSessionIframe);
            /* Reject the promise if analyzer logout fails to complete in 5 sec to allow the desktop CI logout */
            logoutTimeoutTracker = setTimeout(() => {
                reject(new Error("Analyzer logout request timed out"));
            }, 5000);
        });
        return this.promiseReference;
    }
}
const analyzerSessionHelper = new AnalyzerSessionHelper();


/***/ }),

/***/ "./src/components/AgentPerformanceReports/agentReportList.ts":
/*!*******************************************************************!*\
  !*** ./src/components/AgentPerformanceReports/agentReportList.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   agentReportList: () => (/* binding */ agentReportList)
/* harmony export */ });
const agentReportList = [
    {
        reportId: "-1207",
        isDashboard: true,
        tabId: "agentSummary"
    },
    {
        reportId: "-1222",
        isDashboard: true,
        tabId: "agentHistoryStats"
    },
    {
        reportId: "-1225",
        isDashboard: true,
        tabId: "agentRealtimeStats"
    },
    {
        reportId: "-1229",
        isDashboard: true,
        tabId: "agentStatsByStateHist"
    },
    {
        reportId: "-1233",
        isDashboard: true,
        tabId: "agentStatsByStateRealtime"
    },
    {
        reportId: "-1234",
        isDashboard: false,
        tabId: "teamStatsHist"
    },
    {
        reportId: "-1235",
        isDashboard: false,
        tabId: "teamStatsRealtime"
    },
    {
        reportId: "-1209",
        isDashboard: false,
        tabId: "contactDetailsInQueueHist"
    },
    {
        reportId: "-1272",
        isDashboard: true,
        tabId: "contactDetailsInQueueRealtime"
    },
    {
        reportId: "-1289",
        isDashboard: true,
        tabId: "agentStatisticsByQueueRealtime"
    },
    {
        reportId: "-164",
        isDashboard: false,
        tabId: "outdialStatsHistoric"
    },
    {
        reportId: "-165",
        isDashboard: false,
        tabId: "outdialStatsRealtime"
    }
];


/***/ }),

/***/ "./src/components/AgentPerformanceWidget/AgentPerformanceDetailsWidget/AgentPerformanceDetailsWidget.scss":
/*!****************************************************************************************************************!*\
  !*** ./src/components/AgentPerformanceWidget/AgentPerformanceDetailsWidget/AgentPerformanceDetailsWidget.scss ***!
  \****************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --grid-header-gap: 8px;
  --grid-header-corner-radius: 9999rem;
  --search-box-width: 240px;
  --search-box-bottom-margin: 0px;
  --apdw-container-padding: 15px;
  --apdw-container-border-radius: 5px;
  --apdw-container-exterior-padding: 10px;
  --apdw-side-by-side-gap: 15px;
  --apdw-container-item-padding: 10px;
  --apdw-container-item-border-radius: 5px;
  --kmw-tile-padding: 1rem;
  --kmw-tile-margin: 0.5rem;
  --kmw-label-font-weight: bold;
  --kmw-label-font-size: 0.875rem;
  --kmw-value-font-size: 1.5rem;
  --kmw-value-font-weight: bold;
  --kmw-header-font-weight: bold;
  --kmw-header-font-size: 1rem;
  --kmw-header-margin: 1rem;
}

.container {
  background-color: var(--md-content-bg-color);
  padding: var(--apdw-container-padding);
  border-radius: var(--apdw-container-border-radius);
  box-shadow: var(--apdw-container-box-shadow);
  margin: var(--apdw-container-exterior-padding);
}

.side-by-side {
  display: flex;
  gap: var(--apdw-side-by-side-gap);
  padding: 0;
  background: none;
}

.container-item {
  flex: 1;
  padding: var(--apdw-container-item-padding);
  border-radius: var(--apdw-container-item-border-radius);
  text-align: center;
  background-color: var(--md-content-bg-color);
  box-shadow: var(--app-common-box-shadow);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/AgentPerformanceWidget/AgentPerformanceDetailsWidget/AgentPerformanceDetailsWidget.ts":
/*!**************************************************************************************************************!*\
  !*** ./src/components/AgentPerformanceWidget/AgentPerformanceDetailsWidget/AgentPerformanceDetailsWidget.ts ***!
  \**************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AgentPerformanceDetailsWidget: () => (/* binding */ AgentPerformanceDetailsWidget)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Common_CellRenderers_components_TableAgentNameElement__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Common/CellRenderers/components/TableAgentNameElement */ "./src/components/Common/CellRenderers/components/TableAgentNameElement.ts");
/* harmony import */ var _Common_CellRenderers_Formatters_DurationFormatter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../Common/CellRenderers/Formatters/DurationFormatter */ "./src/components/Common/CellRenderers/Formatters/DurationFormatter.ts");
/* harmony import */ var _Common_CellRenderers_Formatters_PercentageFormatter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Common/CellRenderers/Formatters/PercentageFormatter */ "./src/components/Common/CellRenderers/Formatters/PercentageFormatter.ts");
/* harmony import */ var _Common_WcChart_WcRadarChart__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Common/WcChart/WcRadarChart */ "./src/components/Common/WcChart/WcRadarChart.ts");
/* harmony import */ var _Common_WcGrid_RowDataLitElementBase__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Common/WcGrid/RowDataLitElementBase */ "./src/components/Common/WcGrid/RowDataLitElementBase.ts");
/* harmony import */ var _AgentPerformanceDetailsWidget_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./AgentPerformanceDetailsWidget.scss */ "./src/components/AgentPerformanceWidget/AgentPerformanceDetailsWidget/AgentPerformanceDetailsWidget.scss");
/* harmony import */ var _KeyMetricsWidget__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./KeyMetricsWidget */ "./src/components/AgentPerformanceWidget/AgentPerformanceDetailsWidget/KeyMetricsWidget.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};










let AgentPerformanceDetailsWidget = class AgentPerformanceDetailsWidget extends _Common_WcGrid_RowDataLitElementBase__WEBPACK_IMPORTED_MODULE_7__.RowDataLitElementBase {
    static get styles() {
        return _AgentPerformanceDetailsWidget_scss__WEBPACK_IMPORTED_MODULE_8__["default"];
    }
    generateKeyMetrics(rowData) {
        if (!rowData || !Array.isArray(rowData.anomalies)) {
            return [];
        }
        return rowData.anomalies
            .map((anomaly) => this.createMetric(rowData, anomaly))
            .sort((a, b) => Number(b.isAnomaly) - Number(a.isAnomaly));
    }
    createMetric(rowData, anomaly) {
        var _a;
        const { column, isAnomaly } = anomaly;
        return {
            columnKey: column,
            columnValue: this.getMetricValue((_a = rowData[column]) !== null && _a !== void 0 ? _a : "", true),
            isAnomaly,
            columnTitle: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${column}`)
        };
    }
    isDurationValue(value) {
        return (value === null || value === void 0 ? void 0 : value.duration) !== undefined;
    }
    isPercentageValue(value) {
        return (value === null || value === void 0 ? void 0 : value.ratio) !== undefined;
    }
    getMetricValue(rawValue, formatString) {
        if (!rawValue) {
            return formatString ? "" : 0;
        }
        if (this.isDurationValue(rawValue)) {
            return formatString ? (0,_Common_CellRenderers_Formatters_DurationFormatter__WEBPACK_IMPORTED_MODULE_4__.formatDuration)(rawValue.duration) : rawValue.duration;
        }
        if (this.isPercentageValue(rawValue)) {
            return formatString ? (0,_Common_CellRenderers_Formatters_PercentageFormatter__WEBPACK_IMPORTED_MODULE_5__.formatPercentage)(rawValue.ratio) : rawValue.ratio;
        }
        return formatString ? String(rawValue) : Number(rawValue);
    }
    getKeyMetrics() {
        var _a;
        return this.generateKeyMetrics((_a = this.data) !== null && _a !== void 0 ? _a : {});
    }
    getRadarChartData() {
        const wcRadarData = [];
        const anomaliesData = this.data.anomalies;
        if (!anomaliesData || anomaliesData.length === 0) {
            return [];
        }
        anomaliesData === null || anomaliesData === void 0 ? void 0 : anomaliesData.forEach((anomaly) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const columnKey = (_a = anomaly.column) !== null && _a !== void 0 ? _a : "";
            const comparisonColumnKey = (_b = anomaly.comparisonColumn) !== null && _b !== void 0 ? _b : "";
            if (!columnKey || !comparisonColumnKey) {
                return;
            }
            const agentValue = this.getMetricValue((_c = this.data[columnKey]) !== null && _c !== void 0 ? _c : 0, false);
            const teamAvgValue = this.getMetricValue((_d = this.data[comparisonColumnKey]) !== null && _d !== void 0 ? _d : 0, false);
            const wcRadarDataObj = {
                angleId: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${columnKey}`),
                angleDisplayName: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${columnKey}`),
                seriesDataArray: [
                    {
                        seriesId: "agent",
                        seriesDisplayName: (_f = (_e = this.data.agentName) === null || _e === void 0 ? void 0 : _e.toString()) !== null && _f !== void 0 ? _f : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:agentPerformance.details.agentSeries"),
                        angleValue: agentValue
                    },
                    {
                        seriesId: "teamAvg",
                        seriesDisplayName: (_h = (_g = this.data.teamName) === null || _g === void 0 ? void 0 : _g.toString()) !== null && _h !== void 0 ? _h : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:agentPerformance.details.teamSeries"),
                        angleValue: teamAvgValue
                    }
                ]
            };
            if (!wcRadarData.some((data) => data.angleId === wcRadarDataObj.angleId)) {
                wcRadarData.push(wcRadarDataObj);
            }
        });
        return wcRadarData;
    }
    get radarChartTitle() {
        return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:agentPerformance.details.chartTitle");
    }
    get radarChartSubtitle() {
        return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:agentPerformance.details.chartSubtitle");
    }
    render() {
        var _a, _b, _c, _d, _e, _f;
        const data = this.getRadarChartData();
        return this.data && Object.keys(this.data).length > 0
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
          <div class="container">
            <agentx-wc-table-agent-name
              .name=${(_c = (_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.agentName) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : ""}
              .email=${(_f = (_e = (_d = this.data) === null || _d === void 0 ? void 0 : _d.agentEmail) === null || _e === void 0 ? void 0 : _e.toString()) !== null && _f !== void 0 ? _f : ""}
            ></agentx-wc-table-agent-name>
          </div>
          <div class="container side-by-side">
            <div class="container-item">
              <agentx-wc-key-metrics-widget
                .titleString="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:agentPerformance.keyMetrics")}"
                .metrics="${this.getKeyMetrics()}"
              ></agentx-wc-key-metrics-widget>
            </div>
            <div class="container-item">
              <agentx-wc-radar-chart
                .metadata=${{ title: this.radarChartTitle, subtitle: this.radarChartSubtitle }}
                .data=${data}
                .isDarkMode=${this.isDarkMode}
              ></agentx-wc-radar-chart>
            </div>
          </div>
        `
            : lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing;
    }
};
AgentPerformanceDetailsWidget = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-agent-performance-details-widget")
], AgentPerformanceDetailsWidget);



/***/ }),

/***/ "./src/components/AgentPerformanceWidget/AgentPerformanceDetailsWidget/KeyMetricsWidget.scss":
/*!***************************************************************************************************!*\
  !*** ./src/components/AgentPerformanceWidget/AgentPerformanceDetailsWidget/KeyMetricsWidget.scss ***!
  \***************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  padding: 0 1rem 1rem 1rem;
}

.key-metrics-header {
  font-weight: var(--kmw-header-font-weight);
  font-size: var(--kmw-header-font-size);
  color: var(--md-secondary-text-color);
  margin: var(--kmw-header-margin);
  text-align: left;
}

.key-metric {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}

.key-metric-label {
  font-weight: var(--kmw-label-font-weight);
  font-size: var(--kmw-label-font-size);
  color: var(--md-secondary-text-color);
  margin-top: 0.25rem;
}

.key-metric-value {
  font-size: var(--kmw-value-font-size);
  font-weight: var(--kmw-value-font-weight);
  color: var(--md-primary-text-color);
}

.anomaly-cell {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.key-metric-card {
  min-width: 120px;
  max-width: 250px;
  margin: 10px;
  display: flex;
  flex: 1;
  height: 100%;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0FnZW50UGVyZm9ybWFuY2VXaWRnZXQvQWdlbnRQZXJmb3JtYW5jZURldGFpbHNXaWRnZXQvS2V5TWV0cmljc1dpZGdldC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBQTtFQUNBLDJEQUFBO0VBQ0EseUJBQUE7QUFDRjs7QUFFQTtFQUNFLDBDQUFBO0VBQ0Esc0NBQUE7RUFDQSxxQ0FBQTtFQUNBLGdDQUFBO0VBQ0EsZ0JBQUE7QUFDRjs7QUFFQTtFQUNFLGFBQUE7RUFDQSw4QkFBQTtFQUNBLHFCQUFBO0FBQ0Y7O0FBRUE7RUFDRSx5Q0FBQTtFQUNBLHFDQUFBO0VBQ0EscUNBQUE7RUFDQSxtQkFBQTtBQUNGOztBQUVBO0VBQ0UscUNBQUE7RUFDQSx5Q0FBQTtFQUNBLG1DQUFBO0FBQ0Y7O0FBRUE7RUFDRSxrQkFBQTtFQUNBLFdBQUE7RUFDQSxhQUFBO0VBQ0EsYUFBQTtFQUNBLG1CQUFBO0VBQ0EsWUFBQTtBQUNGOztBQUVBO0VBQ0UsZ0JBQUE7RUFDQSxnQkFBQTtFQUNBLFlBQUE7RUFDQSxhQUFBO0VBQ0EsT0FBQTtFQUNBLFlBQUE7QUFDRiIsInNvdXJjZXNDb250ZW50IjpbIi5jb250YWluZXIge1xuICBkaXNwbGF5OiBncmlkO1xuICBncmlkLXRlbXBsYXRlLWNvbHVtbnM6IHJlcGVhdChhdXRvLWZpdCwgbWlubWF4KDI1MHB4LCAxZnIpKTtcbiAgcGFkZGluZzogMCAxcmVtIDFyZW0gMXJlbTtcbn1cblxuLmtleS1tZXRyaWNzLWhlYWRlciB7XG4gIGZvbnQtd2VpZ2h0OiB2YXIoLS1rbXctaGVhZGVyLWZvbnQtd2VpZ2h0KTtcbiAgZm9udC1zaXplOiB2YXIoLS1rbXctaGVhZGVyLWZvbnQtc2l6ZSk7XG4gIGNvbG9yOiB2YXIoLS1tZC1zZWNvbmRhcnktdGV4dC1jb2xvcik7XG4gIG1hcmdpbjogdmFyKC0ta213LWhlYWRlci1tYXJnaW4pO1xuICB0ZXh0LWFsaWduOiBsZWZ0O1xufVxuXG4ua2V5LW1ldHJpYyB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcbiAgbWFyZ2luLWJvdHRvbTogMC41cmVtO1xufVxuXG4ua2V5LW1ldHJpYy1sYWJlbCB7XG4gIGZvbnQtd2VpZ2h0OiB2YXIoLS1rbXctbGFiZWwtZm9udC13ZWlnaHQpO1xuICBmb250LXNpemU6IHZhcigtLWttdy1sYWJlbC1mb250LXNpemUpO1xuICBjb2xvcjogdmFyKC0tbWQtc2Vjb25kYXJ5LXRleHQtY29sb3IpO1xuICBtYXJnaW4tdG9wOiAwLjI1cmVtO1xufVxuXG4ua2V5LW1ldHJpYy12YWx1ZSB7XG4gIGZvbnQtc2l6ZTogdmFyKC0ta213LXZhbHVlLWZvbnQtc2l6ZSk7XG4gIGZvbnQtd2VpZ2h0OiB2YXIoLS1rbXctdmFsdWUtZm9udC13ZWlnaHQpO1xuICBjb2xvcjogdmFyKC0tbWQtcHJpbWFyeS10ZXh0LWNvbG9yKTtcbn1cblxuLmFub21hbHktY2VsbCB7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiAwLjVyZW07XG4gIHJpZ2h0OiAwLjVyZW07XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGdhcDogMC4yNXJlbTtcbn1cblxuLmtleS1tZXRyaWMtY2FyZCB7XG4gIG1pbi13aWR0aDogMTIwcHg7XG4gIG1heC13aWR0aDogMjUwcHg7XG4gIG1hcmdpbjogMTBweDtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleDogMTtcbiAgaGVpZ2h0OiAxMDAlO1xufVxuIl0sInNvdXJjZVJvb3QiOiIifQ== */`);
    

/***/ }),

/***/ "./src/components/AgentPerformanceWidget/AgentPerformanceDetailsWidget/KeyMetricsWidget.ts":
/*!*************************************************************************************************!*\
  !*** ./src/components/AgentPerformanceWidget/AgentPerformanceDetailsWidget/KeyMetricsWidget.ts ***!
  \*************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   KeyMetricsWidget: () => (/* binding */ KeyMetricsWidget)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _KeyMetricsWidget_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./KeyMetricsWidget.scss */ "./src/components/AgentPerformanceWidget/AgentPerformanceDetailsWidget/KeyMetricsWidget.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var KeyMetricsWidget;
(function (KeyMetricsWidget) {
    let Element = class Element extends lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement {
        constructor() {
            super(...arguments);
            this.titleString = "";
            this.metrics = [];
        }
        static get styles() {
            return [_KeyMetricsWidget_scss__WEBPACK_IMPORTED_MODULE_2__["default"]];
        }
        renderKeyMetricCard(card) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <md-card-v2
          .identifier="${card.columnKey}"
          .header="${card.columnTitle}"
          .data="${card.columnValue}"
          .info="${card.isAnomaly ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:agentPerformance.anomalyDetected") : ""}"
          .expandable="${false}"
          class="key-metric-card"
        ></md-card-v2>
      `;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="key-metrics-header">${this.titleString}</div>
        <div class="container">${this.metrics.map((card) => this.renderKeyMetricCard(card))}</div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "titleString", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Array })
    ], Element.prototype, "metrics", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-key-metrics-widget")
    ], Element);
    KeyMetricsWidget.Element = Element;
})(KeyMetricsWidget || (KeyMetricsWidget = {}));


/***/ }),

/***/ "./src/components/AgentPerformanceWidget/AgentPerformanceWidget.scss":
/*!***************************************************************************!*\
  !*** ./src/components/AgentPerformanceWidget/AgentPerformanceWidget.scss ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  display: block;
  height: 100%;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0FnZW50UGVyZm9ybWFuY2VXaWRnZXQvQWdlbnRQZXJmb3JtYW5jZVdpZGdldC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsY0FBQTtFQUNBLFlBQUE7QUFDRiIsInNvdXJjZXNDb250ZW50IjpbIjpob3N0IHtcbiAgZGlzcGxheTogYmxvY2s7XG4gIGhlaWdodDogMTAwJTtcbn1cbiJdLCJzb3VyY2VSb290IjoiIn0= */`);
    

/***/ }),

/***/ "./src/components/AgentPerformanceWidget/AgentPerformanceWidget.ts":
/*!*************************************************************************!*\
  !*** ./src/components/AgentPerformanceWidget/AgentPerformanceWidget.ts ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AgentPerformanceWidget: () => (/* binding */ AgentPerformanceWidget)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Common_WcGrid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Common/WcGrid */ "./src/components/Common/WcGrid/index.ts");
/* harmony import */ var _Common_WcGrid_WcGridConfig__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Common/WcGrid/WcGridConfig */ "./src/components/Common/WcGrid/WcGridConfig.ts");
/* harmony import */ var _AgentPerformanceDetailsWidget_AgentPerformanceDetailsWidget__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./AgentPerformanceDetailsWidget/AgentPerformanceDetailsWidget */ "./src/components/AgentPerformanceWidget/AgentPerformanceDetailsWidget/AgentPerformanceDetailsWidget.ts");
/* harmony import */ var _AgentPerformanceWidget_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./AgentPerformanceWidget.scss */ "./src/components/AgentPerformanceWidget/AgentPerformanceWidget.scss");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./config */ "./src/components/AgentPerformanceWidget/config.ts");
/* harmony import */ var _FullWidthRowCellComponent__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./FullWidthRowCellComponent */ "./src/components/AgentPerformanceWidget/FullWidthRowCellComponent.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};










const ONE_DAY_MS = 24 * 60 * 60 * 1000;
const SEVEN_DAYS_MS = 7 * ONE_DAY_MS;
const getDefaultStartTime = () => Date.now() - SEVEN_DAYS_MS;
const getDefaultEndTime = () => {
    const now = Date.now();
    return now - (now % ONE_DAY_MS);
};
var AgentPerformanceWidget;
(function (AgentPerformanceWidget) {
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
        constructor() {
            super(...arguments);
            this.isDarkMode = false;
            this.startTime = getDefaultStartTime();
            this.endTime = getDefaultEndTime();
            this.gridHeaderLeftText = "";
            this.alertBannerText = "";
        }
        static get styles() {
            return _AgentPerformanceWidget_scss__WEBPACK_IMPORTED_MODULE_7__["default"];
        }
        getWcGridConfig() {
            const listConfig = {
                rowHeight: 100,
                rowClickEnabled: false,
                fullWidthRowComponent: "agent-performance-full-width-row-cell-component",
                detailsComponent: "agentx-wc-agent-performance-details-widget"
            };
            return new _Common_WcGrid_WcGridConfig__WEBPACK_IMPORTED_MODULE_5__.WcGridConfig({
                tableName: "agentPerformance",
                enableCharts: true,
                suppressContextMenu: false,
                headerConfig: {
                    resetGridStateButton: true,
                    filterButton: "small",
                    columnSelectButton: true,
                    refreshButton: true,
                    datePicker: true,
                    datePickerStartTime: this.startTime,
                    datePickerEndTime: this.endTime,
                    countLabelText: this.gridHeaderLeftText,
                    unsortedButton: false,
                    alertBannerText: this.alertBannerText
                }
            })
                .setListConfig(listConfig)
                .setCellSelection(true);
        }
        fetchRowData() {
            return __awaiter(this, void 0, void 0, function* () {
                const allColumns = [];
                for (const key in _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.AgentPerformanceTypes.DataFetcherTypes.ColumnName) {
                    allColumns.push(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.AgentPerformanceTypes.DataFetcherTypes.ColumnName[key]);
                }
                try {
                    const agentPerformanceData = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.agentPerformance.fetchPerformanceData(this.startTime, this.endTime, allColumns);
                    this.alertBannerText = "";
                    const gridRowData = agentPerformanceData.map((dataFetcherRow) => {
                        const agentRowObject = {};
                        dataFetcherRow.forEach((dataFetcherColumn) => {
                            if (dataFetcherColumn.value !== undefined) {
                                agentRowObject[dataFetcherColumn.name] = dataFetcherColumn.value;
                            }
                        });
                        return agentRowObject;
                    });
                    return gridRowData;
                }
                catch (error) {
                    this.alertBannerText = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:agentPerformance.errorFetchingData");
                    _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("Error fetching data", error);
                    return [];
                }
            });
        }
        onSearchDateRangeUpdated(e) {
            return __awaiter(this, void 0, void 0, function* () {
                e.stopPropagation();
                this.startTime = e.detail.startTime;
                this.endTime = e.detail.endTime;
                this.rowData = yield this.fetchRowData();
            });
        }
        onDisplayedRowCountChanged(e) {
            e.stopPropagation();
            const numberOfAgentsStr = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:agentPerformance.numberOfAgents");
            this.gridHeaderLeftText = `${numberOfAgentsStr} ${e.detail.count}`;
        }
        connectedCallback() {
            const _super = Object.create(null, {
                connectedCallback: { get: () => super.connectedCallback }
            });
            return __awaiter(this, void 0, void 0, function* () {
                _super.connectedCallback.call(this);
                this.rowData = yield this.fetchRowData();
            });
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <wc-grid
          .isDarkMode=${this.isDarkMode}
          .wcGridConfig=${this.getWcGridConfig()}
          .wcColumnDefs=${(0,_config__WEBPACK_IMPORTED_MODULE_8__.getWcColumnDefs)()}
          .rowData=${this.rowData}
          @search-date-range-updated=${this.onSearchDateRangeUpdated}
          @displayed-row-count-changed=${this.onDisplayedRowCountChanged}
        ></wc-grid>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isDarkMode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "startTime", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "endTime", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "gridHeaderLeftText", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "rowData", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "alertBannerText", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-agent-performance-widget")
    ], Element);
    AgentPerformanceWidget.Element = Element;
})(AgentPerformanceWidget || (AgentPerformanceWidget = {}));


/***/ }),

/***/ "./src/components/AgentPerformanceWidget/FullWidthRowCellComponent.scss":
/*!******************************************************************************!*\
  !*** ./src/components/AgentPerformanceWidget/FullWidthRowCellComponent.scss ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  align-items: left;
  height: 100%;
  width: 100%;
  min-width: 60px;
  padding: 8px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0FnZW50UGVyZm9ybWFuY2VXaWRnZXQvRnVsbFdpZHRoUm93Q2VsbENvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBQTtFQUNBLHNCQUFBO0VBQ0Esc0JBQUE7RUFDQSxpQkFBQTtFQUNBLFlBQUE7RUFDQSxXQUFBO0VBQ0EsZUFBQTtFQUNBLFlBQUE7QUFDRiIsInNvdXJjZXNDb250ZW50IjpbIjpob3N0IHtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgYWxpZ24taXRlbXM6IGxlZnQ7XG4gIGhlaWdodDogMTAwJTtcbiAgd2lkdGg6IDEwMCU7XG4gIG1pbi13aWR0aDogNjBweDtcbiAgcGFkZGluZzogOHB4O1xufVxuIl0sInNvdXJjZVJvb3QiOiIifQ== */`);
    

/***/ }),

/***/ "./src/components/AgentPerformanceWidget/FullWidthRowCellComponent.ts":
/*!****************************************************************************!*\
  !*** ./src/components/AgentPerformanceWidget/FullWidthRowCellComponent.ts ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FullWidthRowCellComponent: () => (/* binding */ FullWidthRowCellComponent)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Common_CellRenderers_components_TableAgentNameElement__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Common/CellRenderers/components/TableAgentNameElement */ "./src/components/Common/CellRenderers/components/TableAgentNameElement.ts");
/* harmony import */ var _Common_CellRenderers_components_TableDurationElement__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Common/CellRenderers/components/TableDurationElement */ "./src/components/Common/CellRenderers/components/TableDurationElement.ts");
/* harmony import */ var _Common_WcGrid_RowDataLitElementBase__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Common/WcGrid/RowDataLitElementBase */ "./src/components/Common/WcGrid/RowDataLitElementBase.ts");
/* harmony import */ var _FullWidthRowCellComponent_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./FullWidthRowCellComponent.scss */ "./src/components/AgentPerformanceWidget/FullWidthRowCellComponent.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







let FullWidthRowCellComponent = class FullWidthRowCellComponent extends _Common_WcGrid_RowDataLitElementBase__WEBPACK_IMPORTED_MODULE_5__.RowDataLitElementBase {
    static get styles() {
        return _FullWidthRowCellComponent_scss__WEBPACK_IMPORTED_MODULE_6__["default"];
    }
    get agentName() {
        return this.data[_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.AgentName];
    }
    get agentEmail() {
        return this.data[_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.AgentEmail];
    }
    get teamName() {
        return this.data[_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamName];
    }
    get connectedDuration() {
        const connectedDuration = this.data[_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConnectedDuration];
        return connectedDuration.duration;
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<div>
        <agentx-wc-table-agent-name name=${this.agentName} email=${this.agentEmail}></agentx-wc-table-agent-name>
      </div>
      <div>
        <div>
          <md-label>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:agentPerformance.team")} ${this.teamName}</md-label>
        </div>
      </div>
      <div>
        <agentx-wc-table-duration duration=${this.connectedDuration}></agentx-wc-table-duration>
      </div>`;
    }
};
FullWidthRowCellComponent = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agent-performance-full-width-row-cell-component")
], FullWidthRowCellComponent);



/***/ }),

/***/ "./src/components/AgentPerformanceWidget/config.ts":
/*!*********************************************************!*\
  !*** ./src/components/AgentPerformanceWidget/config.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getWcColumnDefs: () => (/* binding */ getWcColumnDefs)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Common_WcGrid_WcColumns_ActionsButtonsColumn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Common/WcGrid/WcColumns/ActionsButtonsColumn */ "./src/components/Common/WcGrid/WcColumns/ActionsButtonsColumn.ts");
/* harmony import */ var _Common_WcGrid_WcColumns_AgentNameColumn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Common/WcGrid/WcColumns/AgentNameColumn */ "./src/components/Common/WcGrid/WcColumns/AgentNameColumn.ts");
/* harmony import */ var _Common_WcGrid_WcColumns_AnomaliesColumn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Common/WcGrid/WcColumns/AnomaliesColumn */ "./src/components/Common/WcGrid/WcColumns/AnomaliesColumn.ts");
/* harmony import */ var _Common_WcGrid_WcColumns_DurationColumn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Common/WcGrid/WcColumns/DurationColumn */ "./src/components/Common/WcGrid/WcColumns/DurationColumn.ts");
/* harmony import */ var _Common_WcGrid_WcColumns_NumberColumn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Common/WcGrid/WcColumns/NumberColumn */ "./src/components/Common/WcGrid/WcColumns/NumberColumn.ts");
/* harmony import */ var _Common_WcGrid_WcColumns_PercentColumn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Common/WcGrid/WcColumns/PercentColumn */ "./src/components/Common/WcGrid/WcColumns/PercentColumn.ts");
/* harmony import */ var _Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../Common/WcGrid/WcColumns/StringColumn */ "./src/components/Common/WcGrid/WcColumns/StringColumn.ts");
/* harmony import */ var _Common_WcGrid_WcColumns_WcChartConfig__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../Common/WcGrid/WcColumns/WcChartConfig */ "./src/components/Common/WcGrid/WcColumns/WcChartConfig.ts");
/* harmony import */ var _Common_WcGrid_WcGridIntegratedChart__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../Common/WcGrid/WcGridIntegratedChart */ "./src/components/Common/WcGrid/WcGridIntegratedChart.ts");











const ACTIONS_COLUMN_NAME = "actions";
const primaryChartConfig = new _Common_WcGrid_WcColumns_WcChartConfig__WEBPACK_IMPORTED_MODULE_9__.WcChartConfig({
    chartDataType: _Common_WcGrid_WcGridIntegratedChart__WEBPACK_IMPORTED_MODULE_10__.ColumnChartDataType.Category,
    isPrimaryAxisInChart: true
});
const seriesChartConfig = new _Common_WcGrid_WcColumns_WcChartConfig__WEBPACK_IMPORTED_MODULE_9__.WcChartConfig({
    chartDataType: _Common_WcGrid_WcGridIntegratedChart__WEBPACK_IMPORTED_MODULE_10__.ColumnChartDataType.Series
});
const teamAvgSeriesChartConfig = new _Common_WcGrid_WcColumns_WcChartConfig__WEBPACK_IMPORTED_MODULE_9__.WcChartConfig({
    chartDataType: _Common_WcGrid_WcGridIntegratedChart__WEBPACK_IMPORTED_MODULE_10__.ColumnChartDataType.Series,
    isTeamAverageDataColumn: true
});
function getAllColumns() {
    return [
        new _Common_WcGrid_WcColumns_AgentNameColumn__WEBPACK_IMPORTED_MODULE_3__.AgentNameColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.AgentName}`), _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.AgentName).setChartConfig(primaryChartConfig),
        new _Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_8__.StringColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.AgentId}`), _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.AgentId),
        new _Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_8__.StringColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.AgentEmail}`), _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.AgentEmail),
        new _Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_8__.StringColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamName}`), _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamName),
        new _Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_8__.StringColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamId}`), _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamId),
        new _Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_8__.StringColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.SiteName}`), _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.SiteName),
        new _Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_8__.StringColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.SiteId}`), _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.SiteId),
        new _Common_WcGrid_WcColumns_NumberColumn__WEBPACK_IMPORTED_MODULE_6__.NumberColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConnectedCount}`), _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConnectedCount).setChartConfig(seriesChartConfig),
        new _Common_WcGrid_WcColumns_DurationColumn__WEBPACK_IMPORTED_MODULE_5__.DurationColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConnectedDuration}`), _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConnectedDuration).setChartConfig(seriesChartConfig),
        new _Common_WcGrid_WcColumns_NumberColumn__WEBPACK_IMPORTED_MODULE_6__.NumberColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConsultRequestCount}`), _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConsultRequestCount).setChartConfig(seriesChartConfig),
        new _Common_WcGrid_WcColumns_DurationColumn__WEBPACK_IMPORTED_MODULE_5__.DurationColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConsultRequestDuration}`), _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConsultRequestDuration).setChartConfig(seriesChartConfig),
        new _Common_WcGrid_WcColumns_NumberColumn__WEBPACK_IMPORTED_MODULE_6__.NumberColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConsultAnswerCount}`), _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConsultAnswerCount).setChartConfig(seriesChartConfig),
        new _Common_WcGrid_WcColumns_NumberColumn__WEBPACK_IMPORTED_MODULE_6__.NumberColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.HoldCount}`), _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.HoldCount).setChartConfig(seriesChartConfig),
        new _Common_WcGrid_WcColumns_DurationColumn__WEBPACK_IMPORTED_MODULE_5__.DurationColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.HoldDuration}`), _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.HoldDuration).setChartConfig(seriesChartConfig),
        new _Common_WcGrid_WcColumns_NumberColumn__WEBPACK_IMPORTED_MODULE_6__.NumberColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TransferCount}`), _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TransferCount).setChartConfig(seriesChartConfig),
        new _Common_WcGrid_WcColumns_DurationColumn__WEBPACK_IMPORTED_MODULE_5__.DurationColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.AverageHandleTime}`), _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.AverageHandleTime).setChartConfig(seriesChartConfig),
        new _Common_WcGrid_WcColumns_NumberColumn__WEBPACK_IMPORTED_MODULE_6__.NumberColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgConnectedCount}`), _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgConnectedCount).setChartConfig(teamAvgSeriesChartConfig),
        new _Common_WcGrid_WcColumns_DurationColumn__WEBPACK_IMPORTED_MODULE_5__.DurationColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgConnectedDuration}`), _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgConnectedDuration).setChartConfig(teamAvgSeriesChartConfig),
        new _Common_WcGrid_WcColumns_NumberColumn__WEBPACK_IMPORTED_MODULE_6__.NumberColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgHoldCount}`), _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgHoldCount).setChartConfig(teamAvgSeriesChartConfig),
        new _Common_WcGrid_WcColumns_DurationColumn__WEBPACK_IMPORTED_MODULE_5__.DurationColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgHoldDuration}`), _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgHoldDuration).setChartConfig(teamAvgSeriesChartConfig),
        new _Common_WcGrid_WcColumns_NumberColumn__WEBPACK_IMPORTED_MODULE_6__.NumberColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgTransferCount}`), _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgTransferCount).setChartConfig(teamAvgSeriesChartConfig),
        new _Common_WcGrid_WcColumns_DurationColumn__WEBPACK_IMPORTED_MODULE_5__.DurationColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgAverageHandleTime}`), _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgAverageHandleTime).setChartConfig(teamAvgSeriesChartConfig),
        new _Common_WcGrid_WcColumns_PercentColumn__WEBPACK_IMPORTED_MODULE_7__.PercentColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.HoldCountRatio}`), _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.HoldCountRatio).setChartConfig(seriesChartConfig),
        new _Common_WcGrid_WcColumns_PercentColumn__WEBPACK_IMPORTED_MODULE_7__.PercentColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.HoldDurationRatio}`), _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.HoldDurationRatio).setChartConfig(seriesChartConfig),
        new _Common_WcGrid_WcColumns_AnomaliesColumn__WEBPACK_IMPORTED_MODULE_4__.AnomaliesColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.Anomalies}`), _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.Anomalies),
        new _Common_WcGrid_WcColumns_ActionsButtonsColumn__WEBPACK_IMPORTED_MODULE_2__.ActionsButtonsColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:agentPerformance.columns.actions"), ACTIONS_COLUMN_NAME, [(0,_Common_WcGrid_WcColumns_ActionsButtonsColumn__WEBPACK_IMPORTED_MODULE_2__.getViewButtonConfig)()])
    ];
}
function getDefaultColumns() {
    const defaultColumns = new Set([
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.AgentName,
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamName,
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.Anomalies,
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConnectedCount,
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgConnectedCount,
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConnectedDuration,
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgConnectedDuration,
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.HoldCount,
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgHoldCount
    ]);
    return Array.from(defaultColumns);
}
function getWcColumnDefs() {
    const retColumns = [];
    const allColumns = getAllColumns();
    const defaultColumns = getDefaultColumns();
    defaultColumns.forEach((columnName) => {
        const column = allColumns.find((col) => col.getFieldName() === columnName);
        if (column) {
            column.setHidden(false);
            retColumns.push(column);
        }
    });
    allColumns.forEach((column) => {
        if (!defaultColumns.includes(column.getFieldName())) {
            retColumns.push(column);
        }
    });
    const actionsColumn = allColumns.find((col) => col.getFieldName() === ACTIONS_COLUMN_NAME);
    if (actionsColumn) {
        actionsColumn.setHidden(false);
    }
    return retColumns;
}


/***/ }),

/***/ "./src/components/CollapseArea/CollapseArea.scss":
/*!*******************************************************!*\
  !*** ./src/components/CollapseArea/CollapseArea.scss ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  display: block;
  height: 100%;
  position: relative;
  transition: width 350ms ease-in-out;
  width: auto;
  will-change: width;
  border-radius: var(--collapse-area-border-radius);
  box-shadow: var(--collapse-area-box-shadow);
  background: var(--collapse-area-background);
  /**
  * WARNING!!!
  * Do NOT use transform: translateX/Y/X/3d to not break fixed positioning maximized widget inside collapse area.
  * "will-change" rule is enough for gpu animation
  */
}
:host .collapse-area {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  border-right: calc(var(--collapse-area-divider-width, 2px) * -1);
}
:host .collapse-area .collapse-area-inner {
  bottom: 0;
  left: 0;
  overflow: hidden;
  position: absolute;
  right: 0;
  top: 0;
}
:host .collapse-area .collapse-area-divider {
  width: var(--collapse-area-divider-width, 2px);
  height: 100%;
  right: 0;
  background: var(--md-nav-divider-primary, --md-primary-seperator-color);
  position: absolute;
}
:host .collapse-area.hovered .collapse-area-divider {
  background: var(--md-nav-divider-primary-hover, --md-primary-seperator-color);
}
:host .displayTaskArea {
  display: none;
}

:host([collapsed]) {
  width: var(--collapse-area-collapsed-width, 0) !important;
  border-right: 0;
  background-color: var(--collapse-area-background, var(--md-primary-bg-color));
}
:host([collapsed]) .collapse-area-divider {
  width: var(--collapse-area-divider-collapsed-width, 0px);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/CollapseArea/CollapseArea.ts":
/*!*****************************************************!*\
  !*** ./src/components/CollapseArea/CollapseArea.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CollapseArea: () => (/* binding */ CollapseArea)
/* harmony export */ });
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/utils/WindowListenersHub */ "./src/utils/WindowListenersHub.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _CollapseArea_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./CollapseArea.scss */ "./src/components/CollapseArea/CollapseArea.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var CollapseArea;
(function (CollapseArea) {
    let Direction;
    (function (Direction) {
        Direction["Left"] = "left";
        Direction["Right"] = "right";
    })(Direction = CollapseArea.Direction || (CollapseArea.Direction = {}));
    let Event;
    (function (Event) {
        Event["Toggle"] = "toggle";
    })(Event = CollapseArea.Event || (CollapseArea.Event = {}));
    const VISIBLE_DISTANCE = 100; //px
    const isMouseCloseToRect = (e, rect) => {
        return (rect.left - VISIBLE_DISTANCE <= e.clientX &&
            rect.right + VISIBLE_DISTANCE >= e.clientX &&
            rect.top - VISIBLE_DISTANCE <= e.clientY &&
            rect.bottom + VISIBLE_DISTANCE >= e.clientY);
    };
    /**
     * @element agentx-wc-collapse-area
     * @fires toggle
     */
    let Element = class Element extends lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement {
        constructor() {
            super(...arguments);
            this.collapsed = false;
            this.direction = Direction.Left;
            this.forceTogglerVisibilityOnMouseOverSelectors = "";
            this.isMouseCloseToToggler = false;
            this.isMouseInSelfArea = false;
            this.isMouseOverSelector = false;
            this.isMouseOverOnCollapseButton = false;
            this.setHoverState = (e) => {
                this.isMouseOverOnCollapseButton = e.detail.hovered;
            };
            this.onSelfMouseEnter = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_0__.throttle)(() => (this.isMouseInSelfArea = true));
            this.onSelfMouseLeave = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_0__.throttle)(() => (this.isMouseInSelfArea = false));
            this.onWindowMouseMove = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_0__.throttle)((e) => {
                const _path = e.composedPath();
                const _selectors = Array.isArray(this.forceTogglerVisibilityOnMouseOverSelectors)
                    ? this.forceTogglerVisibilityOnMouseOverSelectors
                    : this.forceTogglerVisibilityOnMouseOverSelectors.split(" ");
                if (_path.length) {
                    this.isMouseOverSelector = !!_selectors.find((selector) => !!_path.find((eventTarget) => {
                        return (eventTarget && eventTarget.matches && eventTarget.matches(selector));
                    }));
                }
                this.isMouseCloseToToggler = isMouseCloseToRect(e, this.toggler.getBoundingClientRect());
            });
            this.onWindowMouseLeave = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_0__.throttle)(() => {
                this.isMouseOverSelector = false;
                this.isMouseCloseToToggler = false;
            });
        }
        get isTogglerVisible() {
            return this.isMouseCloseToToggler || this.isMouseInSelfArea || this.isMouseOverSelector;
        }
        connectedCallback() {
            super.connectedCallback();
            this.addEventListener("mouseenter", this.onSelfMouseEnter);
            this.addEventListener("mouseleave", this.onSelfMouseLeave);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_1__.WINDOW_LISTENERS_HUB.on("mouseenter", this.onWindowMouseMove);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_1__.WINDOW_LISTENERS_HUB.on("mousemove", this.onWindowMouseMove);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_1__.WINDOW_LISTENERS_HUB.on("mouseleave", this.onWindowMouseLeave);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_1__.WINDOW_LISTENERS_HUB.on("collapseHover", this.setHoverState);
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.removeEventListener("mouseenter", this.onSelfMouseEnter);
            this.removeEventListener("mouseleave", this.onSelfMouseLeave);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_1__.WINDOW_LISTENERS_HUB.off("mouseenter", this.onWindowMouseMove);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_1__.WINDOW_LISTENERS_HUB.off("mousemove", this.onWindowMouseMove);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_1__.WINDOW_LISTENERS_HUB.off("mouseleave", this.onWindowMouseLeave);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_1__.WINDOW_LISTENERS_HUB.off("collapseHover", this.setHoverState);
        }
        static get styles() {
            return _CollapseArea_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
        }
        toggle(e) {
            this.dispatchEvent(new CustomEvent(CollapseArea.Event.Toggle, {
                detail: {
                    collapsed: e.detail.collapsed
                }
            }));
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div
          class="collapse-area ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3__.classMap)({
                hovered: this.isMouseOverOnCollapseButton
            })}"
        >
          <div
            class="collapse-area-inner ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3__.classMap)({
                displayTaskArea: this.collapsed
            })}"
          >
            <slot></slot>
          </div>
          <div class="collapse-area-divider"></div>
          <agentx-wc-collapse-toggler
            .direction="${this.direction}"
            .collapsed="${this.collapsed}"
            .visible="${this.isTogglerVisible}"
            @toggle="${(e) => this.toggle(e)}"
          ></agentx-wc-collapse-toggler>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean, reflect: true })
    ], Element.prototype, "collapsed", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String, reflect: true })
    ], Element.prototype, "direction", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "forceTogglerVisibilityOnMouseOverSelectors", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "isMouseCloseToToggler", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "isMouseInSelfArea", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "isMouseOverSelector", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "isMouseOverOnCollapseButton", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.query)("agentx-wc-collapse-toggler")
    ], Element.prototype, "toggler", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-collapse-area")
    ], Element);
    CollapseArea.Element = Element;
})(CollapseArea || (CollapseArea = {}));


/***/ }),

/***/ "./src/components/CollapseArea/components/CollapseToggler.scss":
/*!*********************************************************************!*\
  !*** ./src/components/CollapseArea/components/CollapseToggler.scss ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --column-toggler-height: 44px;
  --column-toggler-width: var(--grabber-width, 12px);
  background-color: transparent;
  cursor: pointer;
  display: flex;
  height: var(--column-toggler-height);
  position: absolute;
  top: calc(50% - var(--column-toggler-height) / 2);
  width: var(--column-toggler-width);
}

:host([direction=left]) {
  left: auto;
  right: calc(var(--column-toggler-width) * -1);
}

:host([direction=right]) {
  left: calc(var(--column-toggler-width) * -1);
  right: auto;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0NvbGxhcHNlQXJlYS9jb21wb25lbnRzL0NvbGxhcHNlVG9nZ2xlci5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsNkJBQUE7RUFDQSxrREFBQTtFQUVBLDZCQUFBO0VBQ0EsZUFBQTtFQUNBLGFBQUE7RUFDQSxvQ0FBQTtFQUNBLGtCQUFBO0VBQ0EsaURBQUE7RUFDQSxrQ0FBQTtBQUFGOztBQUdBO0VBQ0UsVUFBQTtFQUNBLDZDQUFBO0FBQUY7O0FBR0E7RUFDRSw0Q0FBQTtFQUNBLFdBQUE7QUFBRiIsInNvdXJjZXNDb250ZW50IjpbIjpob3N0IHtcbiAgLS1jb2x1bW4tdG9nZ2xlci1oZWlnaHQ6IDQ0cHg7XG4gIC0tY29sdW1uLXRvZ2dsZXItd2lkdGg6IHZhcigtLWdyYWJiZXItd2lkdGgsIDEycHgpO1xuXG4gIGJhY2tncm91bmQtY29sb3I6IHRyYW5zcGFyZW50O1xuICBjdXJzb3I6IHBvaW50ZXI7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGhlaWdodDogdmFyKC0tY29sdW1uLXRvZ2dsZXItaGVpZ2h0KTtcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICB0b3A6IGNhbGMoNTAlIC0gKHZhcigtLWNvbHVtbi10b2dnbGVyLWhlaWdodCkgLyAyKSk7XG4gIHdpZHRoOiB2YXIoLS1jb2x1bW4tdG9nZ2xlci13aWR0aCk7XG59XG5cbjpob3N0KFtkaXJlY3Rpb249XCJsZWZ0XCJdKSB7XG4gIGxlZnQ6IGF1dG87XG4gIHJpZ2h0OiBjYWxjKHZhcigtLWNvbHVtbi10b2dnbGVyLXdpZHRoKSAqIC0xKTtcbn1cblxuOmhvc3QoW2RpcmVjdGlvbj1cInJpZ2h0XCJdKSB7XG4gIGxlZnQ6IGNhbGModmFyKC0tY29sdW1uLXRvZ2dsZXItd2lkdGgpICogLTEpO1xuICByaWdodDogYXV0bztcbn1cbiJdLCJzb3VyY2VSb290IjoiIn0= */`);
    

/***/ }),

/***/ "./src/components/CollapseArea/components/CollapseToggler.ts":
/*!*******************************************************************!*\
  !*** ./src/components/CollapseArea/components/CollapseToggler.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CollapseToggler: () => (/* binding */ CollapseToggler)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _CollapseToggler_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./CollapseToggler.scss */ "./src/components/CollapseArea/components/CollapseToggler.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};





var CollapseToggler;
(function (CollapseToggler) {
    let Event;
    (function (Event) {
        Event["Toggle"] = "toggle";
    })(Event = CollapseToggler.Event || (CollapseToggler.Event = {}));
    let HoverEvent;
    (function (HoverEvent) {
        HoverEvent["Hover"] = "collapseHover";
    })(HoverEvent = CollapseToggler.HoverEvent || (CollapseToggler.HoverEvent = {}));
    let Direction;
    (function (Direction) {
        Direction["Left"] = "left";
        Direction["Right"] = "right";
    })(Direction = CollapseToggler.Direction || (CollapseToggler.Direction = {}));
    /**
     * @element agentx-wc-collapse-toggler
     * @fires toggle
     */
    let Element = class Element extends lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement {
        constructor() {
            super(...arguments);
            this.collapsed = false;
            this.direction = Direction.Left;
            this.visible = true;
            this.hovered = false;
        }
        toggle() {
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.TASK_PANE_TOGGLE);
            this.dispatchEvent(new CustomEvent(CollapseToggler.Event.Toggle, {
                detail: {
                    collapsed: !this.collapsed
                }
            }));
        }
        grabberToggled(_e) {
            this.toggle();
        }
        grabberHoverChanged(e) {
            this.hovered = e.detail.hovered;
            this.dispatchEvent(new CustomEvent(CollapseToggler.HoverEvent.Hover, {
                bubbles: true,
                composed: true,
                detail: { hovered: this.hovered }
            }));
        }
        handleShortcutKeyEvent() {
            const { stopListen } = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.event.listenKeyPress((event) => {
                const { data } = event;
                if (data &&
                    data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.REGISTERED_KEYS.EXPAND_COLLAPSE_TASK_LIST_PANEL_KEY &&
                    data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.MODIFIERS.CTRL_SHIFT) {
                    if (this.grabber) {
                        this.grabber.toggleGrabber();
                    }
                    else {
                        this.toggle();
                    }
                }
            });
            this.stopListen = stopListen;
        }
        connectedCallback() {
            const _super = Object.create(null, {
                connectedCallback: { get: () => super.connectedCallback }
            });
            return __awaiter(this, void 0, void 0, function* () {
                _super.connectedCallback.call(this);
                this.handleShortcutKeyEvent();
            });
        }
        disconnectedCallback() {
            const _super = Object.create(null, {
                connectedCallback: { get: () => super.connectedCallback }
            });
            return __awaiter(this, void 0, void 0, function* () {
                _super.connectedCallback.call(this);
                this.stopListen();
            });
        }
        static get styles() {
            return _CollapseToggler_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
        }
        get grabberAlignment() {
            return this.direction === "left" ? "leading" : "trailing";
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <md-grabber
          alignment=${this.grabberAlignment}
          class="toggler"
          label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.agentTaskPanelExpand")}
          checkedLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.agentTaskPanelCollapsed")}
          .visible=${this.visible || this.collapsed}
          @grabber-toggled=${(e) => this.grabberToggled(e)}
          @grabber-hover-changed=${(e) => this.grabberHoverChanged(e)}
          ?checked=${!this.collapsed}
        >
        </md-grabber>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "collapsed", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String, reflect: true })
    ], Element.prototype, "direction", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "visible", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "hovered", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.query)(".toggler")
    ], Element.prototype, "grabber", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-collapse-toggler")
    ], Element);
    CollapseToggler.Element = Element;
})(CollapseToggler || (CollapseToggler = {}));


/***/ }),

/***/ "./src/components/Common/CellRenderers/ActionButtons.ts":
/*!**************************************************************!*\
  !*** ./src/components/Common/CellRenderers/ActionButtons.ts ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ActionButtonsCellRenderer: () => (/* binding */ ActionButtonsCellRenderer)
/* harmony export */ });
/* harmony import */ var _constants_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./constants/types */ "./src/components/Common/CellRenderers/constants/types.ts");
/* harmony import */ var _WcGrid_CellRenderers_BaseCellRenderer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../WcGrid/CellRenderers/BaseCellRenderer */ "./src/components/Common/WcGrid/CellRenderers/BaseCellRenderer.ts");


const ActionButtonsIconsMap = {
    [_constants_types__WEBPACK_IMPORTED_MODULE_0__.ActionButtons.view]: {
        label: "View",
        ariaLabel: "View",
        eventName: "action-button-open-details"
    },
    [_constants_types__WEBPACK_IMPORTED_MODULE_0__.ActionButtons.hearing]: {
        icon: "hearing-bold",
        outline: true,
        eventName: "action-button-listen-recording"
    },
    [_constants_types__WEBPACK_IMPORTED_MODULE_0__.ActionButtons.more]: {
        icon: "more-bold",
        outline: false,
        eventName: "action-button-more"
    },
    [_constants_types__WEBPACK_IMPORTED_MODULE_0__.ActionButtons.download]: {
        icon: "download-bold",
        outline: true,
        eventName: "action-button-download"
    },
    [_constants_types__WEBPACK_IMPORTED_MODULE_0__.ActionButtons.actions]: {
        icon: "download-bold",
        outline: true,
        eventName: "actions"
    }
};
class ActionButtonsCellRenderer extends _WcGrid_CellRenderers_BaseCellRenderer__WEBPACK_IMPORTED_MODULE_1__.BaseCellRenderer {
    render(params) {
        const actionsWidget = this.eGui.firstChild
            ? this.eGui.firstChild
            : document.createElement("agentx-wc-table-action-buttons");
        actionsWidget.buttons = this.getActionWidgetConfig(params.value.buttons, params.value.context);
        if (!this.eGui.firstChild) {
            this.eGui.appendChild(actionsWidget);
        }
    }
    onButtonClicked(eventName, context, option) {
        this.eGui.dispatchEvent(new CustomEvent(eventName, {
            composed: true,
            bubbles: true,
            detail: { context, option }
        }));
    }
    getActionWidgetConfig(buttons, context) {
        return buttons.map((button) => {
            return Object.assign(Object.assign({}, ActionButtonsIconsMap[button.type]), { id: button.type, options: button.options, onClick: (option) => this.onButtonClicked(ActionButtonsIconsMap[button.type].eventName, context, option) });
        });
    }
}


/***/ }),

/***/ "./src/components/Common/CellRenderers/AgentName.ts":
/*!**********************************************************!*\
  !*** ./src/components/Common/CellRenderers/AgentName.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AgentNameCellRenderer: () => (/* binding */ AgentNameCellRenderer)
/* harmony export */ });
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _WcGrid_CellRenderers_BaseCellRenderer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../WcGrid/CellRenderers/BaseCellRenderer */ "./src/components/Common/WcGrid/CellRenderers/BaseCellRenderer.ts");


class AgentNameCellRenderer extends _WcGrid_CellRenderers_BaseCellRenderer__WEBPACK_IMPORTED_MODULE_1__.BaseCellRenderer {
    render(params) {
        var _a;
        const widget = this.eGui.firstChild
            ? this.eGui.firstChild
            : document.createElement("agentx-wc-table-agent-name");
        if ((_a = params.data.lastAgent) === null || _a === void 0 ? void 0 : _a.name) {
            widget.name = params.data.lastAgent.name;
            // This Cell Renderer requires email column to be present in the grid
            widget.email = params.data.lastAgent.signInId;
        }
        else {
            _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.warn("[AgentNameCellRenderer] No lastAgent data found");
        }
        if (!this.eGui.firstChild) {
            this.eGui.appendChild(widget);
        }
    }
}


/***/ }),

/***/ "./src/components/Common/CellRenderers/Channel.ts":
/*!********************************************************!*\
  !*** ./src/components/Common/CellRenderers/Channel.ts ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ChannelCellRenderer: () => (/* binding */ ChannelCellRenderer)
/* harmony export */ });
/* harmony import */ var _WcGrid_CellRenderers_BaseCellRenderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../WcGrid/CellRenderers/BaseCellRenderer */ "./src/components/Common/WcGrid/CellRenderers/BaseCellRenderer.ts");

class ChannelCellRenderer extends _WcGrid_CellRenderers_BaseCellRenderer__WEBPACK_IMPORTED_MODULE_0__.BaseCellRenderer {
    render(params) {
        this.eGui.classList.add("channel-type-renderer");
        const channelTypeWidget = this.eGui.firstChild
            ? this.eGui.firstChild
            : document.createElement("agentx-wc-table-channel");
        channelTypeWidget.channelType = params.value.channelType;
        if (!this.eGui.firstChild) {
            this.eGui.appendChild(channelTypeWidget);
        }
    }
}


/***/ }),

/***/ "./src/components/Common/CellRenderers/CustomKeyboardNav.ts":
/*!******************************************************************!*\
  !*** ./src/components/Common/CellRenderers/CustomKeyboardNav.ts ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CustomKeyboardNav: () => (/* binding */ CustomKeyboardNav),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var CustomKeyboardNav;
(function (CustomKeyboardNav) {
    function getDeepActiveElement() {
        var _a, _b;
        let host = (_a = document.activeElement) !== null && _a !== void 0 ? _a : document.body;
        while ((_b = host === null || host === void 0 ? void 0 : host.shadowRoot) === null || _b === void 0 ? void 0 : _b.activeElement) {
            host = host.shadowRoot.activeElement;
        }
        return host;
    }
    CustomKeyboardNav.getDeepActiveElement = getDeepActiveElement;
    function isElementFocusable(element) {
        if (element.tabIndex < 0 || element.style.visibility === "hidden" || element.style.display === "none") {
            return false;
        }
        const focusableTags = ["A", "BUTTON", "INPUT", "TEXTAREA", "SELECT"];
        if (focusableTags.includes(element.tagName)) {
            return true;
        }
        return element.hasAttribute("tabindex") || element.isContentEditable;
    }
    function getFocusableElements(root) {
        var _a, _b;
        if (isElementFocusable(root)) {
            return [root];
        }
        const focusableElements = [];
        const children = [...((_b = (_a = root.shadowRoot) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : []), ...root.children];
        children.forEach((child) => {
            if (isElementFocusable(child)) {
                focusableElements.push(child);
            }
            else {
                focusableElements.push(...getFocusableElements(child));
            }
        });
        return focusableElements;
    }
    CustomKeyboardNav.getFocusableElements = getFocusableElements;
    function getFocusedElementIndex(elements) {
        if (elements) {
            const activeElement = getDeepActiveElement();
            return elements.findIndex((element) => {
                return element === activeElement;
            });
        }
        return -1;
    }
    function focusNext(root) {
        var _a;
        const elements = getFocusableElements(root);
        const length = (_a = elements.length) !== null && _a !== void 0 ? _a : 0;
        if (length > 0) {
            const nextIndex = getFocusedElementIndex(elements) + 1;
            if (nextIndex < length) {
                elements[nextIndex].focus();
                return true;
            }
        }
        return false;
    }
    CustomKeyboardNav.focusNext = focusNext;
    function focusPrevious(root) {
        var _a;
        const elements = getFocusableElements(root);
        const length = (_a = elements === null || elements === void 0 ? void 0 : elements.length) !== null && _a !== void 0 ? _a : 0;
        if (length > 0) {
            const index = getFocusedElementIndex(elements);
            if (index === -1) {
                elements[length - 1].focus();
                return true;
            }
            else if (index > 0) {
                elements[index - 1].focus();
                return true;
            }
        }
        return false;
    }
    CustomKeyboardNav.focusPrevious = focusPrevious;
})(CustomKeyboardNav || (CustomKeyboardNav = {}));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomKeyboardNav);


/***/ }),

/***/ "./src/components/Common/CellRenderers/Duration.ts":
/*!*********************************************************!*\
  !*** ./src/components/Common/CellRenderers/Duration.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DurationCellRenderer: () => (/* binding */ DurationCellRenderer)
/* harmony export */ });
/* harmony import */ var _WcGrid_CellRenderers_BaseCellRenderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../WcGrid/CellRenderers/BaseCellRenderer */ "./src/components/Common/WcGrid/CellRenderers/BaseCellRenderer.ts");

class DurationCellRenderer extends _WcGrid_CellRenderers_BaseCellRenderer__WEBPACK_IMPORTED_MODULE_0__.BaseCellRenderer {
    render(params) {
        const durationWidget = this.eGui.firstChild
            ? this.eGui.firstChild
            : document.createElement("agentx-wc-table-duration");
        durationWidget.duration = params.value.duration;
        durationWidget.createdTime = params.value.createdTime;
        durationWidget.isActive = params.value.active;
        if (!this.eGui.firstChild) {
            this.eGui.appendChild(durationWidget);
        }
    }
}


/***/ }),

/***/ "./src/components/Common/CellRenderers/Formatters/DurationFormatter.ts":
/*!*****************************************************************************!*\
  !*** ./src/components/Common/CellRenderers/Formatters/DurationFormatter.ts ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   formatDuration: () => (/* binding */ formatDuration)
/* harmony export */ });
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_0__);

const DURATION_DISPLAY_FORMAT = "hh:mm:ss";
function formatDuration(duration) {
    return luxon__WEBPACK_IMPORTED_MODULE_0__.Duration.fromMillis(duration).toFormat(DURATION_DISPLAY_FORMAT);
}


/***/ }),

/***/ "./src/components/Common/CellRenderers/Formatters/PercentageFormatter.ts":
/*!*******************************************************************************!*\
  !*** ./src/components/Common/CellRenderers/Formatters/PercentageFormatter.ts ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   formatPercentage: () => (/* binding */ formatPercentage)
/* harmony export */ });
function formatPercentage(value) {
    return `${Math.ceil(value * 100)}%`;
}


/***/ }),

/***/ "./src/components/Common/CellRenderers/InteractionsListItem.ts":
/*!*********************************************************************!*\
  !*** ./src/components/Common/CellRenderers/InteractionsListItem.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InteractionsListItemCellRenderer: () => (/* binding */ InteractionsListItemCellRenderer)
/* harmony export */ });
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Utils */ "./src/components/Common/CellRenderers/Utils.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _WcGrid_CellRenderers_BaseCellRenderer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../WcGrid/CellRenderers/BaseCellRenderer */ "./src/components/Common/WcGrid/CellRenderers/BaseCellRenderer.ts");



class InteractionsListItemCellRenderer extends _WcGrid_CellRenderers_BaseCellRenderer__WEBPACK_IMPORTED_MODULE_2__.BaseCellRenderer {
    render(params) {
        const listItemWidget = this.eGui.firstChild
            ? this.eGui.firstChild
            : document.createElement("agentx-wc-table-listitem");
        listItemWidget.channelType = (0,_Utils__WEBPACK_IMPORTED_MODULE_0__.getChannelAvatarType)(params.value.channelType);
        listItemWidget.primaryLabel = params.value.customerId;
        listItemWidget.secondRowTimer = params.value.timer.duration;
        listItemWidget.isSecondRowTimerActive = params.value.timer.isActive;
        listItemWidget.isSelected = this.isFocussedCell(params);
        switch (params.value.selectedTab) {
            case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.InteractionsServiceConstants.QueryType.Active:
                listItemWidget.secondRowLeft = params.value.agentName;
                listItemWidget.thirdRowLeft = params.value.queueName;
                listItemWidget.thirdRowRight = params.value.teamName;
                break;
            case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.InteractionsServiceConstants.QueryType.Queued:
                listItemWidget.secondRowLeft = params.value.queueName;
                listItemWidget.thirdRowLeft = params.value.message;
                break;
            case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.InteractionsServiceConstants.QueryType.Completed:
                listItemWidget.secondRowLeft = params.value.agentName;
                listItemWidget.thirdRowLeft = params.value.queueName;
                listItemWidget.thirdRowRight = params.value.wrapupCode;
                break;
        }
        if (!this.eGui.firstChild) {
            this.eGui.appendChild(listItemWidget);
        }
        this.eGui.setAttribute("tabindex", "0");
    }
    isFocussedCell(params) {
        const focusedCell = params.api.getFocusedCell();
        return focusedCell !== null && focusedCell.rowIndex === params.node.rowIndex;
    }
}


/***/ }),

/***/ "./src/components/Common/CellRenderers/QueueStatsListItem.ts":
/*!*******************************************************************!*\
  !*** ./src/components/Common/CellRenderers/QueueStatsListItem.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QueueStatsListItemCellRenderer: () => (/* binding */ QueueStatsListItemCellRenderer)
/* harmony export */ });
/* harmony import */ var _WcGrid_CellRenderers_BaseCellRenderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../WcGrid/CellRenderers/BaseCellRenderer */ "./src/components/Common/WcGrid/CellRenderers/BaseCellRenderer.ts");
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Utils */ "./src/components/Common/CellRenderers/Utils.ts");


const WAITING_IN_QUEUE = "Waiting in queue: ";
const AVG_WAIT_TIME = "Avg Wait time: ";
class QueueStatsListItemCellRenderer extends _WcGrid_CellRenderers_BaseCellRenderer__WEBPACK_IMPORTED_MODULE_0__.BaseCellRenderer {
    render(params) {
        const listItemWidget = this.eGui.firstChild
            ? this.eGui.firstChild
            : document.createElement("agentx-wc-table-listitem");
        listItemWidget.channelType = (0,_Utils__WEBPACK_IMPORTED_MODULE_1__.getChannelAvatarType)(params.value.channelType);
        listItemWidget.primaryLabel = params.value.queueName;
        listItemWidget.secondRowLeft = WAITING_IN_QUEUE + params.value.waitingInQueue;
        listItemWidget.thirdRowLeft = AVG_WAIT_TIME;
        listItemWidget.thirdRowTimer = params.value.avgWaitTime;
        listItemWidget.isSelected = this.isFocussedCell(params);
        if (!this.eGui.firstChild) {
            this.eGui.appendChild(listItemWidget);
        }
        this.eGui.setAttribute("tabindex", "0");
    }
    isFocussedCell(params) {
        const focusedCell = params.api.getFocusedCell();
        return !!focusedCell && focusedCell.rowIndex === params.node.rowIndex;
    }
}


/***/ }),

/***/ "./src/components/Common/CellRenderers/Sentiment.ts":
/*!**********************************************************!*\
  !*** ./src/components/Common/CellRenderers/Sentiment.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SentimentCellRenderer: () => (/* binding */ SentimentCellRenderer)
/* harmony export */ });
/* harmony import */ var _WcGrid_CellRenderers_BaseCellRenderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../WcGrid/CellRenderers/BaseCellRenderer */ "./src/components/Common/WcGrid/CellRenderers/BaseCellRenderer.ts");

const NEUTRAL_COLOR = "neutral";
const NEUTRAL_ICON = "emoji-passive-filled";
class SentimentCellRenderer extends _WcGrid_CellRenderers_BaseCellRenderer__WEBPACK_IMPORTED_MODULE_0__.BaseCellRenderer {
    render(params) {
        var _a;
        const sentimentWidget = this.eGui.firstChild
            ? this.eGui.firstChild
            : document.createElement("agentx-wc-table-sentiment");
        sentimentWidget.icon = NEUTRAL_ICON;
        sentimentWidget.color = NEUTRAL_COLOR;
        sentimentWidget.text = (_a = params.valueFormatted) !== null && _a !== void 0 ? _a : params.value;
        if (!this.eGui.firstChild) {
            this.eGui.appendChild(sentimentWidget);
        }
    }
}


/***/ }),

/***/ "./src/components/Common/CellRenderers/Utils.ts":
/*!******************************************************!*\
  !*** ./src/components/Common/CellRenderers/Utils.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   agentNameComparator: () => (/* binding */ agentNameComparator),
/* harmony export */   channelComparator: () => (/* binding */ channelComparator),
/* harmony export */   getAvatarAriaTranslationId: () => (/* binding */ getAvatarAriaTranslationId),
/* harmony export */   getChannelAvatarType: () => (/* binding */ getChannelAvatarType),
/* harmony export */   naturalStringComparator: () => (/* binding */ naturalStringComparator)
/* harmony export */ });
/* harmony import */ var _constants_channel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./constants/channel */ "./src/components/Common/CellRenderers/constants/channel.ts");

function naturalStringComparator(valueA, valueB) {
    return valueA.localeCompare(valueB, undefined, { numeric: true, sensitivity: "base" });
}
function agentNameComparator(valueA, valueB) {
    return naturalStringComparator(valueA.name, valueB.name);
}
const getChannelAvatarType = (channelType) => {
    var _a;
    if (!channelType) {
        return "";
    }
    return (_a = _constants_channel__WEBPACK_IMPORTED_MODULE_0__.CHANNEL_TYPE_TO_ICON_MAP[channelType]) !== null && _a !== void 0 ? _a : "";
};
const getAvatarAriaTranslationId = (avatarType) => {
    return _constants_channel__WEBPACK_IMPORTED_MODULE_0__.AVATAR_TYPE_TO_TRANSLATION_ID_MAP[avatarType];
};
function channelComparator(valueA, valueB) {
    const channelTypeA = valueA.channelType;
    const channelTypeB = valueB.channelType;
    return naturalStringComparator(channelTypeA, channelTypeB);
}


/***/ }),

/***/ "./src/components/Common/CellRenderers/components/TableActionButtonsElement.scss":
/*!***************************************************************************************!*\
  !*** ./src/components/Common/CellRenderers/components/TableActionButtonsElement.scss ***!
  \***************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding: 4px 0;
  width: 100%;
  height: 100%;
}

md-button {
  display: flex;
}

.options-list {
  padding-top: 8px;
  padding-bottom: 8px;
}

md-list-item {
  padding: 0.25rem 0.5rem;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0NvbW1vbi9DZWxsUmVuZGVyZXJzL2NvbXBvbmVudHMvVGFibGVBY3Rpb25CdXR0b25zRWxlbWVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBQTtFQUNBLG1CQUFBO0VBQ0EsbUJBQUE7RUFDQSwyQkFBQTtFQUNBLFFBQUE7RUFDQSxjQUFBO0VBQ0EsV0FBQTtFQUNBLFlBQUE7QUFDRjs7QUFFQTtFQUNFLGFBQUE7QUFDRjs7QUFFQTtFQUNFLGdCQUFBO0VBQ0EsbUJBQUE7QUFDRjs7QUFFQTtFQUNFLHVCQUFBO0FBQ0YiLCJzb3VyY2VzQ29udGVudCI6WyI6aG9zdCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiByb3c7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogZmxleC1zdGFydDtcbiAgZ2FwOiA4cHg7XG4gIHBhZGRpbmc6IDRweCAwO1xuICB3aWR0aDogMTAwJTtcbiAgaGVpZ2h0OiAxMDAlO1xufVxuXG5tZC1idXR0b24ge1xuICBkaXNwbGF5OiBmbGV4O1xufVxuXG4ub3B0aW9ucy1saXN0IHtcbiAgcGFkZGluZy10b3A6IDhweDtcbiAgcGFkZGluZy1ib3R0b206IDhweDtcbn1cblxubWQtbGlzdC1pdGVtIHtcbiAgcGFkZGluZzogMC4yNXJlbSAwLjVyZW07XG59XG4iXSwic291cmNlUm9vdCI6IiJ9 */`);
    

/***/ }),

/***/ "./src/components/Common/CellRenderers/components/TableActionButtonsElement.ts":
/*!*************************************************************************************!*\
  !*** ./src/components/Common/CellRenderers/components/TableActionButtonsElement.ts ***!
  \*************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableActionButtonsElement: () => (/* binding */ TableActionButtonsElement)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _TableActionButtonsElement_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./TableActionButtonsElement.scss */ "./src/components/Common/CellRenderers/components/TableActionButtonsElement.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





let TableActionButtonsElement = class TableActionButtonsElement extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
    constructor() {
        super(...arguments);
        this.buttons = [];
        this._expanded = false;
        this.onClickListOption = (button, option) => {
            var _a;
            this.menuOverlay.isOpen = false;
            (_a = button.onClick) === null || _a === void 0 ? void 0 : _a.call(button, option);
        };
    }
    static get styles() {
        return _TableActionButtonsElement_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
    }
    renderSingleIcon(button) {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <md-button
        id="${button.id}"
        ariaLabel="${button.ariaLabel ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(button.ariaLabel) : ""}"
        @click=${() => { var _a; return (_a = button.onClick) === null || _a === void 0 ? void 0 : _a.call(button); }}
        size="28"
        circle
        ?outline=${button.outline}
      >
        <md-icon slot="icon" name="${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_2__.ifDefined)(button.icon)}" iconSet="momentumDesign"></md-icon>
      </md-button>
    `;
    }
    renderOptionsList(button) {
        var _a;
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <md-list>
        ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_3__.repeat)((_a = button.options) !== null && _a !== void 0 ? _a : [], (option) => option, (option) => (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
            <md-list-item slot="list-item" @click=${() => this.onClickListOption(button, option)}
              >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(option)}</md-list-item
            >
          `)}
      </md-list>
    `;
    }
    renderDropDownIcon(button) {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <md-menu-overlay
        id="menu-overlay"
        size="small"
        show-arrow
        @menu-overlay-open=${() => {
            this._expanded = true;
        }}
        @menu-overlay-close=${() => {
            this._expanded = false;
        }}
      >
        <md-button
          slot="menu-trigger"
          id="${button.id}"
          ariaLabel="${button.ariaLabel ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(button.ariaLabel) : ""}"
          size="28"
          ?outline=${button.outline}
        >
          <md-icon slot="icon" name="${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_2__.ifDefined)(button.icon)}" iconSet="momentumDesign"></md-icon>
          <md-icon
            slot="icon"
            name="${this._expanded ? "arrow-up-bold" : "arrow-down-bold"}"
            iconSet="momentumDesign"
          ></md-icon>
        </md-button>

        <div class="options-list">${this._expanded ? this.renderOptionsList(button) : (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ``}</div>
      </md-menu-overlay>
    `;
    }
    renderLabelButton(button) {
        var _a;
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <md-link
        tag="a"
        inline
        inline-style="default"
        @click=${(e) => {
            var _a;
            e.preventDefault();
            (_a = button.onClick) === null || _a === void 0 ? void 0 : _a.call(button);
        }}
        aria-label="${button.ariaLabel ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(button.ariaLabel) : ""}"
      >
        ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)((_a = button.label) !== null && _a !== void 0 ? _a : "")}
      </md-link>
    `;
    }
    renderButton(button) {
        var _a, _b;
        if (button.icon) {
            const hasMoreOptions = (_b = (_a = button.options) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0 > 1;
            if (!hasMoreOptions) {
                return this.renderSingleIcon(button);
            }
            else {
                return this.renderDropDownIcon(button);
            }
        }
        else if (button.label) {
            return this.renderLabelButton(button);
        }
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ``;
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_3__.repeat)(this.buttons, (button) => button.id, (button) => this.renderButton(button))}
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Array })
], TableActionButtonsElement.prototype, "buttons", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
], TableActionButtonsElement.prototype, "_expanded", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.query)("#menu-overlay")
], TableActionButtonsElement.prototype, "menuOverlay", void 0);
TableActionButtonsElement = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-table-action-buttons")
], TableActionButtonsElement);



/***/ }),

/***/ "./src/components/Common/CellRenderers/components/TableAgentNameElement.scss":
/*!***********************************************************************************!*\
  !*** ./src/components/Common/CellRenderers/components/TableAgentNameElement.scss ***!
  \***********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  display: flex;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  gap: 8px;
}

.label {
  flex: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0NvbW1vbi9DZWxsUmVuZGVyZXJzL2NvbXBvbmVudHMvVGFibGVBZ2VudE5hbWVFbGVtZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxhQUFBO0VBQ0EsV0FBQTtFQUNBLFlBQUE7RUFDQSxzQkFBQTtFQUNBLG1CQUFBO0VBQ0EscUJBQUE7RUFDQSxtQkFBQTtFQUNBLFFBQUE7QUFDRjs7QUFFQTtFQUNFLE9BQUE7RUFDQSx1QkFBQTtFQUNBLGdCQUFBO0VBQ0EsbUJBQUE7QUFDRiIsInNvdXJjZXNDb250ZW50IjpbIjpob3N0IHtcbiAgZGlzcGxheTogZmxleDtcbiAgd2lkdGg6IDEwMCU7XG4gIGhlaWdodDogMTAwJTtcbiAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgZmxleC1kaXJlY3Rpb246IHJvdztcbiAganVzdGlmeS1jb250ZW50OiBsZWZ0O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBnYXA6IDhweDtcbn1cblxuLmxhYmVsIHtcbiAgZmxleDogMTtcbiAgdGV4dC1vdmVyZmxvdzogZWxsaXBzaXM7XG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIHdoaXRlLXNwYWNlOiBub3dyYXA7XG59XG4iXSwic291cmNlUm9vdCI6IiJ9 */`);
    

/***/ }),

/***/ "./src/components/Common/CellRenderers/components/TableAgentNameElement.ts":
/*!*********************************************************************************!*\
  !*** ./src/components/Common/CellRenderers/components/TableAgentNameElement.ts ***!
  \*********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableAgentNameElement: () => (/* binding */ TableAgentNameElement)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _TableAgentNameElement_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./TableAgentNameElement.scss */ "./src/components/Common/CellRenderers/components/TableAgentNameElement.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};






let TableAgentNameElement = class TableAgentNameElement extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
    constructor() {
        super(...arguments);
        this.name = null;
        this.email = "";
    }
    static get styles() {
        return _TableAgentNameElement_scss__WEBPACK_IMPORTED_MODULE_5__["default"];
    }
    update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has("email")) {
            this.fetchAvatarUrl();
        }
    }
    connectedCallback() {
        super.connectedCallback();
        this.fetchAvatarUrl();
    }
    fetchAvatarUrl() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.email && this.email.length > 0) {
                try {
                    this.avatarUrl = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.avatar.getAvatarUrl(this.email);
                }
                catch (err) {
                    _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[TableAgentNameElement] error: ", err);
                }
            }
        });
    }
    render() {
        if (this.name !== null) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <md-avatar
          size="24"
          alt="${this.name}"
          title="${this.name}"
          src="${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__.ifDefined)(this.avatarUrl)}"
          aria-hidden="true"
        ></md-avatar>
        <span class="label">${this.name}</span>
      `;
        }
        else {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) ``;
        }
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
], TableAgentNameElement.prototype, "name", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
], TableAgentNameElement.prototype, "email", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], TableAgentNameElement.prototype, "avatarUrl", void 0);
TableAgentNameElement = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-table-agent-name")
], TableAgentNameElement);



/***/ }),

/***/ "./src/components/Common/CellRenderers/components/TableChannelElement.ts":
/*!*******************************************************************************!*\
  !*** ./src/components/Common/CellRenderers/components/TableChannelElement.ts ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableChannelElement: () => (/* binding */ TableChannelElement)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Utils */ "./src/components/Common/CellRenderers/Utils.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





let TableChannelElement = class TableChannelElement extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
    constructor() {
        super(...arguments);
        this.channelType = "";
    }
    get avatarAriaLabel() {
        const ariaTranslationId = (0,_Utils__WEBPACK_IMPORTED_MODULE_4__.getAvatarAriaTranslationId)(this.channelType);
        return ariaTranslationId ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(ariaTranslationId) : undefined;
    }
    render() {
        return this.channelType !== ""
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<md-avatar
          type="${this.channelType}"
          avatar-style="table"
          label=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_3__.ifDefined)(this.avatarAriaLabel)}
        ></md-avatar>`
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}`;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], TableChannelElement.prototype, "channelType", void 0);
TableChannelElement = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-table-channel")
], TableChannelElement);



/***/ }),

/***/ "./src/components/Common/CellRenderers/components/TableDurationElement.scss":
/*!**********************************************************************************!*\
  !*** ./src/components/Common/CellRenderers/components/TableDurationElement.scss ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
  gap: 8px;
  width: 100%;
  height: 100%;
}

:host([no-padding]) {
  padding: 0;
}

.label {
  font-weight: 400;
  font-size: 14px;
  padding: 0px;
  margin: 0px;
  line-height: 20px;
  flex: 1;
  color: var(--md-secondary-text-color);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0NvbW1vbi9DZWxsUmVuZGVyZXJzL2NvbXBvbmVudHMvVGFibGVEdXJhdGlvbkVsZW1lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGFBQUE7RUFDQSxtQkFBQTtFQUNBLG1CQUFBO0VBQ0EscUJBQUE7RUFDQSxRQUFBO0VBQ0EsV0FBQTtFQUNBLFlBQUE7QUFDRjs7QUFFQTtFQUNFLFVBQUE7QUFDRjs7QUFFQTtFQUNFLGdCQUFBO0VBQ0EsZUFBQTtFQUNBLFlBQUE7RUFDQSxXQUFBO0VBQ0EsaUJBQUE7RUFDQSxPQUFBO0VBQ0EscUNBQUE7RUFDQSx1QkFBQTtFQUNBLGdCQUFBO0VBQ0EsbUJBQUE7QUFDRiIsInNvdXJjZXNDb250ZW50IjpbIjpob3N0IHtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IHJvdztcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAganVzdGlmeS1jb250ZW50OiBsZWZ0O1xuICBnYXA6IDhweDtcbiAgd2lkdGg6IDEwMCU7XG4gIGhlaWdodDogMTAwJTtcbn1cblxuOmhvc3QoW25vLXBhZGRpbmddKSB7XG4gIHBhZGRpbmc6IDA7XG59XG5cbi5sYWJlbCB7XG4gIGZvbnQtd2VpZ2h0OiA0MDA7XG4gIGZvbnQtc2l6ZTogMTRweDtcbiAgcGFkZGluZzogMHB4O1xuICBtYXJnaW46IDBweDtcbiAgbGluZS1oZWlnaHQ6IDIwcHg7XG4gIGZsZXg6IDE7XG4gIGNvbG9yOiB2YXIoLS1tZC1zZWNvbmRhcnktdGV4dC1jb2xvcik7XG4gIHRleHQtb3ZlcmZsb3c6IGVsbGlwc2lzO1xuICBvdmVyZmxvdzogaGlkZGVuO1xuICB3aGl0ZS1zcGFjZTogbm93cmFwO1xufVxuIl0sInNvdXJjZVJvb3QiOiIifQ== */`);
    

/***/ }),

/***/ "./src/components/Common/CellRenderers/components/TableDurationElement.ts":
/*!********************************************************************************!*\
  !*** ./src/components/Common/CellRenderers/components/TableDurationElement.ts ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableDurationElement: () => (/* binding */ TableDurationElement)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Formatters_DurationFormatter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Formatters/DurationFormatter */ "./src/components/Common/CellRenderers/Formatters/DurationFormatter.ts");
/* harmony import */ var _TableDurationElement_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./TableDurationElement.scss */ "./src/components/Common/CellRenderers/components/TableDurationElement.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




const ICON_COLOR = "var(--md-secondary-text-color)";
const ICON_TIMER = "recents-presence-filled";
let TableDurationElement = class TableDurationElement extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
    constructor() {
        super(...arguments);
        this.duration = 0;
        this.createdTime = 0;
        this.isActive = false;
        this.hideTimerIcon = false;
        this.visibleDuration = "";
    }
    static get styles() {
        return _TableDurationElement_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
    }
    updated(changedProperties) {
        if (changedProperties.has("duration") ||
            changedProperties.has("createdTime") ||
            changedProperties.has("isActive") ||
            changedProperties.has("hideTimerIcon")) {
            this.initializeProperties();
        }
        super.updated(changedProperties);
    }
    renderIcon() {
        if (this.hideTimerIcon) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ``;
        }
        else {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<md-icon
        name="${ICON_TIMER}"
        iconSet="momentumDesign"
        size="16"
        color="${ICON_COLOR}"
        ariaHidden="true"
      ></md-icon>`;
        }
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      ${this.renderIcon()}
      <span class="label">${this.visibleDuration}</span>
    `;
    }
    updateProperties(duration) {
        this.visibleDuration = (0,_Formatters_DurationFormatter__WEBPACK_IMPORTED_MODULE_2__.formatDuration)(duration);
    }
    initializeProperties() {
        if (!this.isActive) {
            this.updateProperties(this.duration);
        }
        else {
            if (this.intervalId) {
                clearInterval(this.intervalId);
                this.intervalId = undefined;
            }
            this.updateProperties(Date.now() - this.createdTime);
            this.intervalId = window.setInterval(() => {
                this.updateProperties(Date.now() - this.createdTime);
            }, 1000);
        }
    }
    connectedCallback() {
        super.connectedCallback();
        this.initializeProperties();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = undefined;
        }
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
], TableDurationElement.prototype, "duration", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
], TableDurationElement.prototype, "createdTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
], TableDurationElement.prototype, "isActive", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
], TableDurationElement.prototype, "hideTimerIcon", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
], TableDurationElement.prototype, "intervalId", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
], TableDurationElement.prototype, "visibleDuration", void 0);
TableDurationElement = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-table-duration")
], TableDurationElement);



/***/ }),

/***/ "./src/components/Common/CellRenderers/components/TableListItemElement.scss":
/*!**********************************************************************************!*\
  !*** ./src/components/Common/CellRenderers/components/TableListItemElement.scss ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  font-family: var(--font-family, var(--brand-font-regular));
  width: 100%;
}

.container {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  height: 100%;
  width: 100%;
  min-width: 60px;
  padding: 8px 0px;
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px; /* Icon placeholder width, actual icon will be 16x16 */
  height: 100%;
  margin-right: 12px;
  flex-shrink: 0;
}

.text-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-width: 0px;
}
.text-container .primary-label {
  font-size: var(--font-size-large, 16px);
  color: var(--md-primary-text-color);
  line-height: 24px;
  font-weight: 500;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  max-width: 90%;
}
.text-container .primary-label.selected {
  font-family: var(--brand-font-bold, "CiscoSansTT Bold");
  font-weight: 700;
}
.text-container .secondary-label,
.text-container .tertiary-label {
  font-size: 14px;
  font-weight: 400;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: flex;
  max-width: 90%;
  color: var(--md-secondary-text-color);
  line-height: 20px;
  gap: 5px;
}
.text-container .separator {
  color: var(--md-secondary-text-color);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Common/CellRenderers/components/TableListItemElement.ts":
/*!********************************************************************************!*\
  !*** ./src/components/Common/CellRenderers/components/TableListItemElement.ts ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableListItemElement: () => (/* binding */ TableListItemElement)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _TableListItemElement_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./TableListItemElement.scss */ "./src/components/Common/CellRenderers/components/TableListItemElement.scss");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_4__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





const SEPARATOR = "•";
let TableListItemElement = class TableListItemElement extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
    constructor() {
        super(...arguments);
        this.channelType = "";
        this.primaryLabel = "";
        this.secondRowLeft = "";
        this.isSecondRowTimerActive = false;
        this.thirdRowLeft = "";
        this.isThirdRowTimerActive = false;
        this.isSelected = false;
    }
    static get styles() {
        return _TableListItemElement_scss__WEBPACK_IMPORTED_MODULE_2__["default"];
    }
    renderIcon() {
        const avatarState = this.isSelected ? "active" : "rest";
        return this.channelType !== ""
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<md-avatar size="32" type="${this.channelType}" state=${avatarState} avatar-style="default"></md-avatar>`
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}`;
    }
    renderDuration(duration, isActive) {
        return duration === undefined
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}`
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<agentx-wc-table-duration
          no-padding
          duration=${duration}
          ?isActive=${isActive}
          ?hideTimerIcon=${true}
        ></agentx-wc-table-duration>`;
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <li class="container">
        <div class="icon-container">${this.renderIcon()}</div>
        <div class="text-container">
          <div class="primary-label ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3__.classMap)({ selected: this.isSelected })}">${this.primaryLabel}</div>
          <div class="secondary-label">
            ${this.secondRowLeft}
            ${this.secondRowTimer !== undefined ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<div class="separator">${SEPARATOR}</div>` : (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}`}
            ${this.renderDuration(this.secondRowTimer, this.isSecondRowTimerActive)}
          </div>
          <div class="tertiary-label">
            ${this.thirdRowLeft}
            ${this.thirdRowRight !== undefined
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<div class="separator">${SEPARATOR}</div>
                  ${this.thirdRowRight}`
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}`}
            ${this.renderDuration(this.thirdRowTimer, this.isThirdRowTimerActive)}
          </div>
        </div>
      </li>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], TableListItemElement.prototype, "channelType", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], TableListItemElement.prototype, "primaryLabel", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], TableListItemElement.prototype, "secondRowLeft", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
], TableListItemElement.prototype, "secondRowTimer", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
], TableListItemElement.prototype, "isSecondRowTimerActive", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], TableListItemElement.prototype, "thirdRowLeft", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], TableListItemElement.prototype, "thirdRowRight", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
], TableListItemElement.prototype, "thirdRowTimer", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
], TableListItemElement.prototype, "isThirdRowTimerActive", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
], TableListItemElement.prototype, "isSelected", void 0);
TableListItemElement = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-table-listitem")
], TableListItemElement);



/***/ }),

/***/ "./src/components/Common/CellRenderers/components/TableSentimentElement.scss":
/*!***********************************************************************************!*\
  !*** ./src/components/Common/CellRenderers/components/TableSentimentElement.scss ***!
  \***********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
}

md-chip {
  display: flex;
}
md-chip::part(chip) {
  display: flex;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0NvbW1vbi9DZWxsUmVuZGVyZXJzL2NvbXBvbmVudHMvVGFibGVTZW50aW1lbnRFbGVtZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxhQUFBO0VBQ0EsbUJBQUE7RUFDQSxZQUFBO0VBQ0EsV0FBQTtBQUNGOztBQUVBO0VBQ0UsYUFBQTtBQUNGO0FBQ0U7RUFDRSxhQUFBO0FBQ0oiLCJzb3VyY2VzQ29udGVudCI6WyI6aG9zdCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGhlaWdodDogMTAwJTtcbiAgd2lkdGg6IDEwMCU7XG59XG5cbm1kLWNoaXAge1xuICBkaXNwbGF5OiBmbGV4O1xuXG4gICY6OnBhcnQoY2hpcCkge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gIH1cbn1cbiJdLCJzb3VyY2VSb290IjoiIn0= */`);
    

/***/ }),

/***/ "./src/components/Common/CellRenderers/components/TableSentimentElement.ts":
/*!*********************************************************************************!*\
  !*** ./src/components/Common/CellRenderers/components/TableSentimentElement.ts ***!
  \*********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableSentimentElement: () => (/* binding */ TableSentimentElement)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _TableSentimentElement_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./TableSentimentElement.scss */ "./src/components/Common/CellRenderers/components/TableSentimentElement.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let TableSentimentElement = class TableSentimentElement extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
    constructor() {
        super(...arguments);
        this.color = "";
    }
    static get styles() {
        return _TableSentimentElement_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
    }
    renderIcon() {
        if (this.icon && this.icon !== "") {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<md-icon
        name="${this.icon}"
        size="16"
        iconSet="momentumDesign"
        slot="custom-left-content"
        ariaHidden="true"
      ></md-icon>`;
        }
        else {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}`;
        }
    }
    render() {
        if (this.text) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ` <md-chip value="${this.text}" color="${this.color}" small> ${this.renderIcon()} </md-chip> `;
        }
        else {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}`;
        }
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], TableSentimentElement.prototype, "icon", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], TableSentimentElement.prototype, "text", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], TableSentimentElement.prototype, "color", void 0);
TableSentimentElement = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-table-sentiment")
], TableSentimentElement);



/***/ }),

/***/ "./src/components/Common/CellRenderers/constants/channel.ts":
/*!******************************************************************!*\
  !*** ./src/components/Common/CellRenderers/constants/channel.ts ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AVATAR_TYPE_TO_TRANSLATION_ID_MAP: () => (/* binding */ AVATAR_TYPE_TO_TRANSLATION_ID_MAP),
/* harmony export */   CHANNEL_TYPE_TO_ICON_MAP: () => (/* binding */ CHANNEL_TYPE_TO_ICON_MAP)
/* harmony export */ });
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./types */ "./src/components/Common/CellRenderers/constants/types.ts");

const CHANNEL_TYPE_TO_ICON_MAP = {
    [_types__WEBPACK_IMPORTED_MODULE_0__.ChannelTypes.Telephony]: "channel-call",
    [_types__WEBPACK_IMPORTED_MODULE_0__.ChannelTypes.Chat]: "channel-chat",
    [_types__WEBPACK_IMPORTED_MODULE_0__.ChannelTypes.Email]: "channel-email-inbound",
    [_types__WEBPACK_IMPORTED_MODULE_0__.ChannelSubTypes.Facebook]: "channel-fb-messenger",
    [_types__WEBPACK_IMPORTED_MODULE_0__.ChannelSubTypes.Twitter]: "channel-twitter-x",
    [_types__WEBPACK_IMPORTED_MODULE_0__.ChannelSubTypes.SMS]: "channel-sms-inbound",
    [_types__WEBPACK_IMPORTED_MODULE_0__.ChannelSubTypes.WhatsApp]: "channel-whats-app",
    [_types__WEBPACK_IMPORTED_MODULE_0__.ChannelSubTypes.AppleMessages]: "channel-apple-chat",
    [_types__WEBPACK_IMPORTED_MODULE_0__.ChannelSubTypes.RCS]: "channel-we-chat",
    [_types__WEBPACK_IMPORTED_MODULE_0__.ChannelTypes.Social]: "channel-custom"
};
const AVATAR_TYPE_TO_TRANSLATION_ID_MAP = {
    "channel-call": "app:wcGrid.channels.telephony",
    "channel-chat": "app:wcGrid.channels.chat",
    "channel-email-inbound": "app:wcGrid.channels.email",
    "channel-fb-messenger": "app:wcGrid.channels.facebook",
    "channel-twitter-x": "app:wcGrid.channels.twitter",
    "channel-sms-inbound": "app:wcGrid.channels.sms",
    "channel-whats-app": "app:wcGrid.channels.whatsapp",
    "channel-apple-chat": "app:wcGrid.channels.appleMessages",
    "channel-we-chat": "app:wcGrid.channels.rcs",
    "channel-custom": "app:wcGrid.channels.social"
};


/***/ }),

/***/ "./src/components/Common/CellRenderers/constants/types.ts":
/*!****************************************************************!*\
  !*** ./src/components/Common/CellRenderers/constants/types.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ActionButtons: () => (/* binding */ ActionButtons),
/* harmony export */   ChannelSubTypes: () => (/* binding */ ChannelSubTypes),
/* harmony export */   ChannelTypes: () => (/* binding */ ChannelTypes),
/* harmony export */   InteractionsTab: () => (/* binding */ InteractionsTab)
/* harmony export */ });
var ChannelTypes;
(function (ChannelTypes) {
    ChannelTypes["Telephony"] = "telephony";
    ChannelTypes["Chat"] = "chat";
    ChannelTypes["Email"] = "email";
    ChannelTypes["Social"] = "social";
})(ChannelTypes || (ChannelTypes = {}));
var ChannelSubTypes;
(function (ChannelSubTypes) {
    ChannelSubTypes["Facebook"] = "facebook";
    ChannelSubTypes["Twitter"] = "twitter";
    ChannelSubTypes["SMS"] = "sms";
    ChannelSubTypes["WhatsApp"] = "whatsapp";
    ChannelSubTypes["AppleMessages"] = "appleMessages";
    ChannelSubTypes["RCS"] = "rcs";
    // ...
})(ChannelSubTypes || (ChannelSubTypes = {}));
var ActionButtons;
(function (ActionButtons) {
    ActionButtons["view"] = "view";
    ActionButtons["hearing"] = "hearing";
    ActionButtons["more"] = "more";
    ActionButtons["download"] = "download";
    ActionButtons["actions"] = "actions";
})(ActionButtons || (ActionButtons = {}));
var InteractionsTab;
(function (InteractionsTab) {
    InteractionsTab["Active"] = "Active";
    InteractionsTab["Queued"] = "Queued";
    InteractionsTab["Completed"] = "Completed";
})(InteractionsTab || (InteractionsTab = {}));


/***/ }),

/***/ "./src/components/Common/CellRenderers/filters/TimestampFilter.ts":
/*!************************************************************************!*\
  !*** ./src/components/Common/CellRenderers/filters/TimestampFilter.ts ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TimestampFilter: () => (/* binding */ TimestampFilter)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");

class TimestampFilter {
    constructor() {
        this.filterValue = null;
    }
    init(params) {
        this.params = params;
    }
    getGui() {
        const container = document.createElement("div");
        const options = [
            { label: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats:underOneMinute")}`, value: "under_1_minute" },
            { label: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats:oneToFiveMinutes")}`, value: "1_5_minutes" },
            { label: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats:fiveToTenMinutes")}`, value: "5_15_minutes" },
            { label: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats:overFifteenMinutes")}`, value: "over_15_minutes" }
        ];
        const name = `timestampFilter_${this.params.colDef.field}`;
        options.forEach((option) => {
            const label = document.createElement("label");
            const input = document.createElement("input");
            input.type = "radio";
            input.name = name;
            input.value = option.value;
            input.style.marginBottom = "10px";
            input.style.marginRight = "5px";
            input.style.marginLeft = "10px";
            input.checked = this.filterValue === option.value;
            input.classList.add("ag-input-field-input");
            input.addEventListener("click", (event) => {
                const target = event.target;
                if (this.filterValue === target.value) {
                    target.checked = false;
                    this.filterValue = null;
                }
                else {
                    this.filterValue = target.value;
                }
                this.params.filterChangedCallback();
            });
            label.appendChild(input);
            label.appendChild(document.createTextNode(option.label));
            container.appendChild(label);
            container.appendChild(document.createElement("br"));
        });
        return container;
    }
    doesFilterPass(params) {
        if (this.filterValue === null) {
            return true;
        }
        const field = this.params.colDef.field;
        const value = field ? params.data[field] : undefined;
        switch (this.filterValue) {
            case "under_1_minute":
                return value < 60 * 1000;
            case "1_5_minutes":
                return value >= 60 * 1000 && value <= 5 * 60 * 1000;
            case "5_15_minutes":
                return value > 5 * 60 * 1000 && value <= 15 * 60 * 1000;
            case "over_15_minutes":
                return value > 15 * 60 * 1000;
            default:
                return true;
        }
    }
    isFilterActive() {
        return this.filterValue !== null;
    }
    getModel() {
        return this.filterValue !== null ? { value: this.filterValue } : null;
    }
    setModel(model) {
        this.filterValue = model ? model.value : null;
    }
}


/***/ }),

/***/ "./src/components/Common/CellRenderers/index.ts":
/*!******************************************************!*\
  !*** ./src/components/Common/CellRenderers/index.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ActionButtonsCellRenderer: () => (/* reexport safe */ _ActionButtons__WEBPACK_IMPORTED_MODULE_0__.ActionButtonsCellRenderer),
/* harmony export */   AgentNameCellRenderer: () => (/* reexport safe */ _AgentName__WEBPACK_IMPORTED_MODULE_1__.AgentNameCellRenderer),
/* harmony export */   ChannelCellRenderer: () => (/* reexport safe */ _Channel__WEBPACK_IMPORTED_MODULE_2__.ChannelCellRenderer),
/* harmony export */   DurationCellRenderer: () => (/* reexport safe */ _Duration__WEBPACK_IMPORTED_MODULE_9__.DurationCellRenderer),
/* harmony export */   InteractionsListItemCellRenderer: () => (/* reexport safe */ _InteractionsListItem__WEBPACK_IMPORTED_MODULE_10__.InteractionsListItemCellRenderer),
/* harmony export */   QueueStatsListItemCellRenderer: () => (/* reexport safe */ _QueueStatsListItem__WEBPACK_IMPORTED_MODULE_11__.QueueStatsListItemCellRenderer),
/* harmony export */   SentimentCellRenderer: () => (/* reexport safe */ _Sentiment__WEBPACK_IMPORTED_MODULE_12__.SentimentCellRenderer),
/* harmony export */   TableActionButtonsElement: () => (/* reexport safe */ _components_TableActionButtonsElement__WEBPACK_IMPORTED_MODULE_3__.TableActionButtonsElement),
/* harmony export */   TableAgentNameElement: () => (/* reexport safe */ _components_TableAgentNameElement__WEBPACK_IMPORTED_MODULE_4__.TableAgentNameElement),
/* harmony export */   TableChannelElement: () => (/* reexport safe */ _components_TableChannelElement__WEBPACK_IMPORTED_MODULE_5__.TableChannelElement),
/* harmony export */   TableDurationElement: () => (/* reexport safe */ _components_TableDurationElement__WEBPACK_IMPORTED_MODULE_6__.TableDurationElement),
/* harmony export */   TableListItemElement: () => (/* reexport safe */ _components_TableListItemElement__WEBPACK_IMPORTED_MODULE_7__.TableListItemElement),
/* harmony export */   TableSentimentElement: () => (/* reexport safe */ _components_TableSentimentElement__WEBPACK_IMPORTED_MODULE_8__.TableSentimentElement)
/* harmony export */ });
/* harmony import */ var _ActionButtons__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ActionButtons */ "./src/components/Common/CellRenderers/ActionButtons.ts");
/* harmony import */ var _AgentName__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./AgentName */ "./src/components/Common/CellRenderers/AgentName.ts");
/* harmony import */ var _Channel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Channel */ "./src/components/Common/CellRenderers/Channel.ts");
/* harmony import */ var _components_TableActionButtonsElement__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./components/TableActionButtonsElement */ "./src/components/Common/CellRenderers/components/TableActionButtonsElement.ts");
/* harmony import */ var _components_TableAgentNameElement__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./components/TableAgentNameElement */ "./src/components/Common/CellRenderers/components/TableAgentNameElement.ts");
/* harmony import */ var _components_TableChannelElement__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./components/TableChannelElement */ "./src/components/Common/CellRenderers/components/TableChannelElement.ts");
/* harmony import */ var _components_TableDurationElement__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./components/TableDurationElement */ "./src/components/Common/CellRenderers/components/TableDurationElement.ts");
/* harmony import */ var _components_TableListItemElement__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./components/TableListItemElement */ "./src/components/Common/CellRenderers/components/TableListItemElement.ts");
/* harmony import */ var _components_TableSentimentElement__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./components/TableSentimentElement */ "./src/components/Common/CellRenderers/components/TableSentimentElement.ts");
/* harmony import */ var _Duration__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./Duration */ "./src/components/Common/CellRenderers/Duration.ts");
/* harmony import */ var _InteractionsListItem__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./InteractionsListItem */ "./src/components/Common/CellRenderers/InteractionsListItem.ts");
/* harmony import */ var _QueueStatsListItem__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./QueueStatsListItem */ "./src/components/Common/CellRenderers/QueueStatsListItem.ts");
/* harmony import */ var _Sentiment__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./Sentiment */ "./src/components/Common/CellRenderers/Sentiment.ts");















/***/ }),

/***/ "./src/components/Common/EmptyDisplayWrapper/EmptyDisplayWrapper.scss":
/*!****************************************************************************!*\
  !*** ./src/components/Common/EmptyDisplayWrapper/EmptyDisplayWrapper.scss ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 400px;
}
.empty-state .empty-header {
  text-align: center;
  font-size: var(--font-size-large);
  font-family: var(--font-family-bold);
  color: var(--md-primary-text-color);
  margin-top: 0;
  margin-bottom: 13px;
  line-height: 24px;
}
.empty-state .empty-body {
  text-align: center;
  width: 296px;
  font-size: var(--font-size-medium);
  font-family: var(--font-family);
  color: var(--md-secondary-text-color);
  margin-top: 0;
  margin-bottom: 13px;
}
.empty-state .empty-link {
  display: block;
  text-align: center;
  font-size: var(--font-size-large);
  font-family: var(--font-family);
  color: var(--md-primary-text-color);
  line-height: 24px;
}
.empty-state .loading {
  display: flex;
  margin-top: 22px;
  justify-content: center;
  transition: opacity 0.3s ease-in-out;
}
.empty-state .loading-visible {
  opacity: 1;
}
.empty-state .loading-hidden {
  opacity: 0;
}
.empty-state uuip-wc-empty-state::part(img) {
  background-color: transparent;
  box-sizing: border-box;
  height: 100px;
  width: 100px;
}
.empty-state uuip-wc-empty-state::part(container) {
  background-color: transparent;
}
.empty-state uuip-wc-empty-state.inverted::part(img) {
  filter: invert(1);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9hc3NldHMvc3R5bGVzL3ZhcmlhYmxlcy5zY3NzIiwid2VicGFjazovLy4vc3JjL2NvbXBvbmVudHMvQ29tbW9uL0VtcHR5RGlzcGxheVdyYXBwZXIvRW1wdHlEaXNwbGF5V3JhcHBlci5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsY0FBQTtFQUNBLHVCQUFBO0VBQ0Esd0JBQUE7RUFDQSx1QkFBQTtFQUVBLG1CQUFBO0VBQ0EsMkJBQUE7RUFDQSx1QkFBQTtFQUNBLDRCQUFBO0VBRUEsWUFBQTtFQUNBLDBCQUFBO0VBRUEsZ0JBQUE7RUFDQSx1QkFBQTtFQUNBLG9EQUFBO0VBQ0EsMkRBQUE7RUFFQSxnQkFBQTtFQUNBLDhEQUFBO0VBQ0E7O2NBQUE7RUFHQSxpSEFBQTtFQUVBLFdBQUE7RUFDQSw0QkFBQTtFQUNBLHdCQUFBO0VBQ0Esd0JBQUE7RUFDQSx3QkFBQTtFQUNBLHlCQUFBO0VBQ0Esd0JBQUE7RUFDQSxxQkFBQTtFQUNBLDZCQUFBO0VBQ0EseUJBQUE7RUFDQSwyQkFBQTtFQUNBLGlDQUFBO0VBRUEsa0JBQUE7RUFDQSwwQkFBQTtFQUNBLDJCQUFBO0VBQ0EsMkJBQUE7RUFDQSw0QkFBQTtFQUVBLGNBQUE7RUFDQSxtREFBQTtFQUNBLG1DQUFBO0VBQ0EsaUNBQUE7RUFFQSxlQUFBO0VBQ0Esc0JBQUE7RUFDQSx1QkFBQTtFQUVBLGVBQUE7RUFDQSxpREFBQTtFQUNBLGdEQUFBO0VBQ0Esd0JBQUE7RUFDQSxnREFBQTtFQUVBLG9CQUFBO0VBQ0EsWUFBQTtFQUNBLFlBQUE7RUFDQSxjQUFBO0VBQ0EsY0FBQTtFQUVBLHNCQUFBO0VBQ0EsZUFBQTtFQUNBLGlCQUFBO0VBQ0EsaUJBQUE7RUFDQSxpQkFBQTtBQ1ZGOztBQTFEQTtFQUNFLFlBQUE7RUFDQSxXQUFBO0VBQ0EsYUFBQTtFQUNBLHNCQUFBO0VBQ0EsbUJBQUE7RUFDQSx1QkFBQTtBQTZERjs7QUExREE7RUFDRSxhQUFBO0VBQ0Esc0JBQUE7RUFDQSxtQkFBQTtFQUNBLHVCQUFBO0VBQ0EsWUFBQTtBQTZERjtBQTNERTtFQUNFLGtCQUFBO0VBQ0EsaUNBQUE7RUFDQSxvQ0FBQTtFQUNBLG1DQUFBO0VBQ0EsYUFBQTtFQUNBLG1CQUFBO0VBQ0EsaUJBQUE7QUE2REo7QUExREU7RUFDRSxrQkFBQTtFQUNBLFlBQUE7RUFDQSxrQ0FBQTtFQUNBLCtCQUFBO0VBQ0EscUNBQUE7RUFDQSxhQUFBO0VBQ0EsbUJBQUE7QUE0REo7QUF6REU7RUFDRSxjQUFBO0VBQ0Esa0JBQUE7RUFDQSxpQ0FBQTtFQUNBLCtCQUFBO0VBQ0EsbUNBQUE7RUFDQSxpQkFBQTtBQTJESjtBQXhERTtFQUNFLGFBQUE7RUFDQSxnQkFBQTtFQUNBLHVCQUFBO0VBQ0Esb0NBQUE7QUEwREo7QUF2REU7RUFDRSxVQUFBO0FBeURKO0FBdERFO0VBQ0UsVUFBQTtBQXdESjtBQXJERTtFQUNFLDZCQUFBO0VBQ0Esc0JBQUE7RUFDQSxhQUFBO0VBQ0EsWUFBQTtBQXVESjtBQXBERTtFQUNFLDZCQUFBO0FBc0RKO0FBbkRFO0VBQ0UsaUJBQUE7QUFxREoiLCJzb3VyY2VzQ29udGVudCI6WyI6aG9zdCB7XG4gIC8qIEZvbnQgU2l6ZSAqL1xuICAtLWZvbnQtc2l6ZS1zbWFsbDogMTJweDtcbiAgLS1mb250LXNpemUtbWVkaXVtOiAxNHB4O1xuICAtLWZvbnQtc2l6ZS1sYXJnZTogMTZweDtcblxuICAvKiBTcGFjaW5nIHRva2VucyAqL1xuICAtLXNwYWNlLXRva2VuLWNhcmRpbmFsOiA1cHg7XG4gIC0tc3BhY2UtdG9rZW4tZXZlbjogMnB4O1xuICAtLXNwYWNlLWVycm9yLWlucHV0OiA0cHggOHB4O1xuXG4gIC8qIEhlaWdodHMgKi9cbiAgLS1lcnJvci1pbnB1dC1oZWlnaHQ6IDMycHg7XG5cbiAgLyogRm9udCBXZWlnaHQgKi9cbiAgLS1mb250LXdlaWdodC1saXRlOiAzMDA7XG4gIC0tZm9udC13ZWlnaHQ6IHZhcigtLWJyYW5kLWZvbnQtd2VpZ2h0LXJlZ3VsYXIsIDQwMCk7XG4gIC0tZm9udC13ZWlnaHQtbWVkaXVtOiB2YXIoLS1icmFuZC1mb250LXdlaWdodC1yZWd1bGFyLCA1MDApO1xuXG4gIC8qIEZvbnQgZmFtaWx5ICovXG4gIC0tZm9udC1mYW1pbHktYm9sZDogdmFyKC0tYnJhbmQtZm9udC1ib2xkLCBcIkNpc2NvU2Fuc1RUIEJvbGRcIik7XG4gIC0tZm9udC1mYW1pbHk6XG4gICAgdmFyKC0tYnJhbmQtZm9udC1yZWd1bGFyLCBcIkNpc2NvU2Fuc1RUIFJlZ3VsYXJcIiksIFwiQ2lzY29TYW5zVFQgUmVndWxhclwiLCBcIkhlbHZldGljYSBOZXVlXCIsIEhlbHZldGljYSwgQXJpYWwsXG4gICAgc2Fucy1zZXJpZjtcbiAgLS1mb250LWZhbWlseS1saWdodDogdmFyKC0tYnJhbmQtZm9udC1saWdodCwgXCJDaXNjb1NhbnNUVCBMaWdodFwiKSwgXCJIZWx2ZXRpY2EgTmV1ZVwiLCBIZWx2ZXRpY2EsIEFyaWFsLCBzYW5zLXNlcmlmO1xuXG4gIC8qIENvbG9ycyAqL1xuICAtLWxpZ2h0LWdyZWVuLWNvbG9yOiAjNDRjZjUwO1xuICAtLWNvbG9yLWdyYXktMTA6ICNlZGVkZWQ7XG4gIC0tY29sb3ItZ3JheS0zMDogI2QyZDVkNjtcbiAgLS1jb2xvci1ncmF5LTcwOiAjNTQ1NDU0O1xuICAtLWNvbG9yLWdyYXktMTAwOiAjMTIxMjEyO1xuICAtLWNvbG9yLWJsdWUtNzA6ICMwMDVlN2Q7XG4gIC0tY29sb3ItbGluazogIzAwYTBkMTtcbiAgLS1jb2xvci1lcnJvci1kZXRhaWw6ICM1MzU3NTk7XG4gIC0tY29sb3ItZ3JheS1ib3JkZXI6ICNjY2M7XG4gIC0tY29sb3ItZXJyb3ItdGV4dDogI2ExMjUxMjtcbiAgLS1jb2xvci1jb3VudC1ub3RpZmljYXRpb25zOiAjZmZmO1xuXG4gIC8qIEJvcmRlciByYWRpdXMgKi9cbiAgLS1ib3JkZXItcmFkaXVzLXNtYWxsOiA0cHg7XG4gIC0tYm9yZGVyLXJhZGl1cy1tZWRpdW06IDhweDtcbiAgLS1ib3JkZXItcmFkaXVzLWxhcmdlOiAxMnB4O1xuICAtLWJvcmRlci1yYWRpdXMtY2lyY2xlOiAxMDAlO1xuXG4gIC8qIEFuaW1hdGlvbiAqL1xuICAtLWVhc2UtaW4tb3V0LXF1aW50OiBjdWJpYy1iZXppZXIoMC44MywgMCwgMC4xNywgMSk7XG4gIC0tZGVmYXVsdC1hbmltYXRpb24tZHVyYXRpb246IDMwMG1zO1xuICAtLXF1aWNrLWFuaW1hdGlvbi1kdXJhdGlvbjogMTUwbXM7XG5cbiAgLyogc2Nyb2xsIGJhciAqL1xuICAtLXNjcm9sbGJhci13aWR0aDogNnB4O1xuICAtLXNjcm9sbGJhci1oZWlnaHQ6IDhweDtcblxuICAvKiBCb3ggc2hhZG93ICovXG4gIC0tYm94LXNoYWRvdzogMCAwIDRweCAycHggcmdiYSgwLCAxNjAsIDIwOSwgMC43NSk7XG4gIC0tYm94LXNoYWRvdy1ncmF5OiAwIDRweCA4cHggcmdiYSgwLCAwLCAwLCAwLjA4KTtcbiAgLS10cHctZmlsdGVyLWhlaWdodDogMHB4O1xuICAtLXdlYmtpdC1ib3gtc2hhZG93OiAwIDAgMXB4IHJnYmEoODQsIDg0LCA4NCwgMSk7XG5cbiAgLyogR2FwIGFuZCBwYWRkaW5nICovXG4gIC0tZ2FwLTQ6IDRweDtcbiAgLS1nYXAtODogOHB4O1xuICAtLWdhcC0xMDogMTBweDtcbiAgLS1nYXAtMTI6IDEycHg7XG5cbiAgLyogV2lkdGhzIGFuZCBoZWlnaHRzKi9cbiAgLS1sZW5ndGgtNDogNHB4O1xuICAtLWxlbmd0aC0yMDogMjBweDtcbiAgLS1sZW5ndGgtMjQ6IDI0cHg7XG4gIC0tbGVuZ3RoLTMyOiAzMnB4O1xufVxuIiwiQHVzZSBcIi4uLy4uLy4uL2Fzc2V0cy9zdHlsZXMvdmFyaWFibGVzXCIgYXMgKjtcblxuOmhvc3Qge1xuICBoZWlnaHQ6IDEwMCU7XG4gIHdpZHRoOiAxMDAlO1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbn1cblxuLmVtcHR5LXN0YXRlIHtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIHdpZHRoOiA0MDBweDtcblxuICAuZW1wdHktaGVhZGVyIHtcbiAgICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gICAgZm9udC1zaXplOiB2YXIoLS1mb250LXNpemUtbGFyZ2UpO1xuICAgIGZvbnQtZmFtaWx5OiB2YXIoLS1mb250LWZhbWlseS1ib2xkKTtcbiAgICBjb2xvcjogdmFyKC0tbWQtcHJpbWFyeS10ZXh0LWNvbG9yKTtcbiAgICBtYXJnaW4tdG9wOiAwO1xuICAgIG1hcmdpbi1ib3R0b206IDEzcHg7XG4gICAgbGluZS1oZWlnaHQ6IDI0cHg7XG4gIH1cblxuICAuZW1wdHktYm9keSB7XG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xuICAgIHdpZHRoOiAyOTZweDtcbiAgICBmb250LXNpemU6IHZhcigtLWZvbnQtc2l6ZS1tZWRpdW0pO1xuICAgIGZvbnQtZmFtaWx5OiB2YXIoLS1mb250LWZhbWlseSk7XG4gICAgY29sb3I6IHZhcigtLW1kLXNlY29uZGFyeS10ZXh0LWNvbG9yKTtcbiAgICBtYXJnaW4tdG9wOiAwO1xuICAgIG1hcmdpbi1ib3R0b206IDEzcHg7XG4gIH1cblxuICAuZW1wdHktbGluayB7XG4gICAgZGlzcGxheTogYmxvY2s7XG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xuICAgIGZvbnQtc2l6ZTogdmFyKC0tZm9udC1zaXplLWxhcmdlKTtcbiAgICBmb250LWZhbWlseTogdmFyKC0tZm9udC1mYW1pbHkpO1xuICAgIGNvbG9yOiB2YXIoLS1tZC1wcmltYXJ5LXRleHQtY29sb3IpO1xuICAgIGxpbmUtaGVpZ2h0OiAyNHB4O1xuICB9XG5cbiAgLmxvYWRpbmcge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgbWFyZ2luLXRvcDogMjJweDtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICB0cmFuc2l0aW9uOiBvcGFjaXR5IDAuM3MgZWFzZS1pbi1vdXQ7XG4gIH1cblxuICAubG9hZGluZy12aXNpYmxlIHtcbiAgICBvcGFjaXR5OiAxO1xuICB9XG5cbiAgLmxvYWRpbmctaGlkZGVuIHtcbiAgICBvcGFjaXR5OiAwO1xuICB9XG5cbiAgdXVpcC13Yy1lbXB0eS1zdGF0ZTo6cGFydChpbWcpIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiB0cmFuc3BhcmVudDtcbiAgICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICAgIGhlaWdodDogMTAwcHg7XG4gICAgd2lkdGg6IDEwMHB4O1xuICB9XG5cbiAgdXVpcC13Yy1lbXB0eS1zdGF0ZTo6cGFydChjb250YWluZXIpIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiB0cmFuc3BhcmVudDtcbiAgfVxuXG4gIHV1aXAtd2MtZW1wdHktc3RhdGUuaW52ZXJ0ZWQ6OnBhcnQoaW1nKSB7XG4gICAgZmlsdGVyOiBpbnZlcnQoMSk7XG4gIH1cbn1cbiJdLCJzb3VyY2VSb290IjoiIn0= */`);
    

/***/ }),

/***/ "./src/components/Common/EmptyDisplayWrapper/EmptyDisplayWrapper.ts":
/*!**************************************************************************!*\
  !*** ./src/components/Common/EmptyDisplayWrapper/EmptyDisplayWrapper.ts ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EmptyDisplayWrapper: () => (/* binding */ EmptyDisplayWrapper)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @uuip/unified-ui-platform-common-components */ "@uuip/unified-ui-platform-common-components");
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _EmptyDisplayWrapper_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./EmptyDisplayWrapper.scss */ "./src/components/Common/EmptyDisplayWrapper/EmptyDisplayWrapper.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */







let EmptyDisplayWrapper = class EmptyDisplayWrapper extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
    constructor() {
        super(...arguments);
        this.type = "";
        this.title = "";
        this.info = "";
        this.link = "";
        this.linkText = "";
        this.loading = false;
        this.isDarkMode = false;
    }
    static get styles() {
        return _EmptyDisplayWrapper_scss__WEBPACK_IMPORTED_MODULE_6__["default"];
    }
    get iconClassMap() {
        return {
            inverted: (this.type === "empty-state" || this.type === "empty-result") && !this.isDarkMode
        };
    }
    get imagePath() {
        switch (this.type) {
            case "empty-state":
                return "/images/design/illustrations/box-open-onetwozero-default.svg";
            case "empty-result":
                return "/images/design/illustrations/desert-open-results-oneninetwo-default.svg";
            case "error-cloud":
                return "/images/design/illustrations/cloud-failure-oneninetwo-onboarding-secondary.svg";
            default:
                return "/images/design/illustrations/box-open-onetwozero-default.svg";
        }
    }
    get spinnerClassMap() {
        return {
            "loading-visible": this.loading,
            "loading-hidden": !this.loading
        };
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      <div class="empty-state">
        ${this.type !== "empty-loading"
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `<uuip-wc-empty-state
                illustration-src="${this.imagePath}"
                class="empty-state-illustration ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_5__.classMap)(this.iconClassMap)}"
              ></uuip-wc-empty-state>`
            : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}

          <div>
            <h4 class="empty-header">${this.title}</h4>
            <p class="empty-body">${this.info}</p>
            ${this.link
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `<md-link class="empty-link" size="midsize" href="${this.link}"> ${this.linkText} </md-link>`
            : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}
            <div id="spinner" class="loading ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_5__.classMap)(this.spinnerClassMap)}">
              <md-spinner size="48"></md-spinner>
            </div>
          </div>
        </uuip-wc-empty-state>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String, attribute: "illustration-type" })
], EmptyDisplayWrapper.prototype, "type", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String, attribute: "title" })
], EmptyDisplayWrapper.prototype, "title", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String, attribute: "info-message" })
], EmptyDisplayWrapper.prototype, "info", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String, attribute: "link" })
], EmptyDisplayWrapper.prototype, "link", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String, attribute: "link-text" })
], EmptyDisplayWrapper.prototype, "linkText", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
], EmptyDisplayWrapper.prototype, "loading", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
], EmptyDisplayWrapper.prototype, "isDarkMode", void 0);
EmptyDisplayWrapper = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-empty-display-wrapper")
], EmptyDisplayWrapper);



/***/ }),

/***/ "./src/components/Common/EmptyStateWrapper/EmptyStateWrapper.scss":
/*!************************************************************************!*\
  !*** ./src/components/Common/EmptyStateWrapper/EmptyStateWrapper.scss ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  height: 100%;
  width: 100%;
  display: grid;
}

.empty-state {
  align-items: center;
  display: flex;
  justify-content: center;
  height: calc(100% - 15px);
  width: 100%;
  color: var(--md-secondary-text-color);
  background: var(--md-content-bg-color);
}
.empty-state__container {
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  font-size: var(--font-size-medium);
}
.empty-state__illustration {
  display: flex;
  width: 100%;
  height: auto;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0NvbW1vbi9FbXB0eVN0YXRlV3JhcHBlci9FbXB0eVN0YXRlV3JhcHBlci5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsWUFBQTtFQUNBLFdBQUE7RUFDQSxhQUFBO0FBQ0Y7O0FBRUE7RUFDRSxtQkFBQTtFQUNBLGFBQUE7RUFDQSx1QkFBQTtFQUNBLHlCQUFBO0VBQ0EsV0FBQTtFQUNBLHFDQUFBO0VBQ0Esc0NBQUE7QUFDRjtBQUNFO0VBQ0UsbUJBQUE7RUFDQSxhQUFBO0VBQ0EsdUJBQUE7RUFDQSxzQkFBQTtFQUNBLFdBQUE7RUFDQSxrQ0FBQTtBQUNKO0FBRUU7RUFDRSxhQUFBO0VBQ0EsV0FBQTtFQUNBLFlBQUE7QUFBSiIsInNvdXJjZXNDb250ZW50IjpbIjpob3N0IHtcbiAgaGVpZ2h0OiAxMDAlO1xuICB3aWR0aDogMTAwJTtcbiAgZGlzcGxheTogZ3JpZDtcbn1cblxuLmVtcHR5LXN0YXRlIHtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIGhlaWdodDogY2FsYygxMDAlIC0gMTVweCk7XG4gIHdpZHRoOiAxMDAlO1xuICBjb2xvcjogdmFyKC0tbWQtc2Vjb25kYXJ5LXRleHQtY29sb3IpO1xuICBiYWNrZ3JvdW5kOiB2YXIoLS1tZC1jb250ZW50LWJnLWNvbG9yKTtcblxuICAmX19jb250YWluZXIge1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIGZvbnQtc2l6ZTogdmFyKC0tZm9udC1zaXplLW1lZGl1bSk7XG4gIH1cblxuICAmX19pbGx1c3RyYXRpb24ge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgd2lkdGg6IDEwMCU7XG4gICAgaGVpZ2h0OiBhdXRvO1xuICB9XG59XG4iXSwic291cmNlUm9vdCI6IiJ9 */`);
    

/***/ }),

/***/ "./src/components/Common/EmptyStateWrapper/EmptyStateWrapper.ts":
/*!**********************************************************************!*\
  !*** ./src/components/Common/EmptyStateWrapper/EmptyStateWrapper.ts ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EmptyStateWrapper: () => (/* binding */ EmptyStateWrapper)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @uuip/unified-ui-platform-common-components */ "@uuip/unified-ui-platform-common-components");
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _EmptyStateWrapper_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./EmptyStateWrapper.scss */ "./src/components/Common/EmptyStateWrapper/EmptyStateWrapper.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */





var EmptyStateWrapper;
(function (EmptyStateWrapper) {
    /**
     * @element agentx-wc-empty-state-wrapper
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
        constructor() {
            super(...arguments);
            this.illustrationType = "";
        }
        static get styles() {
            return _EmptyStateWrapper_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
        }
        get imagePath() {
            switch (this.illustrationType) {
                case "empty-state":
                    return "/images/illustrations/box-open-120.svg";
                case "empty-result":
                    return "/images/illustrations/desert-open-results-192.svg";
                case "error-cloud":
                    return "/images/illustrations/cloud-failure-192-red-pink.svg";
                default:
                    return "/images/illustrations/box-open-120.svg";
            }
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div class="empty-state" part="container">
          <div class="empty-state__container">
            <img
              part="img"
              src="${this.imagePath}"
              alt="empty-state"
              aria-hidden="true"
              class="empty-state__illustration"
            />
            <slot></slot>
          </div>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String, attribute: "illustration-type" })
    ], Element.prototype, "illustrationType", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-empty-state-wrapper")
    ], Element);
    EmptyStateWrapper.Element = Element;
})(EmptyStateWrapper || (EmptyStateWrapper = {}));


/***/ }),

/***/ "./src/components/Common/Frame/Frame.scss":
/*!************************************************!*\
  !*** ./src/components/Common/Frame/Frame.scss ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.frame {
  display: flex;
  flex-direction: column;
  height: calc(100% - 1rem);
  padding: 0.75rem 1rem;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0NvbW1vbi9GcmFtZS9GcmFtZS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBQTtFQUNBLHNCQUFBO0VBQ0EseUJBQUE7RUFDQSxxQkFBQTtBQUNGIiwic291cmNlc0NvbnRlbnQiOlsiLmZyYW1lIHtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgaGVpZ2h0OiBjYWxjKDEwMCUgLSAxcmVtKTsgLy8gZXhjbHVkZSBwYWRkaW5nXG4gIHBhZGRpbmc6IDAuNzVyZW0gMXJlbTtcbn1cbiJdLCJzb3VyY2VSb290IjoiIn0= */`);
    

/***/ }),

/***/ "./src/components/Common/Frame/Frame.ts":
/*!**********************************************!*\
  !*** ./src/components/Common/Frame/Frame.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Frame: () => (/* binding */ Frame)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _Frame_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Frame.scss */ "./src/components/Common/Frame/Frame.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let Frame = class Frame extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement) {
    static getStyles() {
        return _Frame_scss__WEBPACK_IMPORTED_MODULE_2__["default"];
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
      <div class="frame">
        <slot></slot>
      </div>
    `;
    }
};
Frame = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("agentx-wc-frame")
], Frame);



/***/ }),

/***/ "./src/components/Common/GridExportButton/GridExportButton.scss":
/*!**********************************************************************!*\
  !*** ./src/components/Common/GridExportButton/GridExportButton.scss ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.export-overlay-container {
  padding: 0.5rem;
  width: 100%;
  background-color: var(--md-secondary-white-bg-color);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0NvbW1vbi9HcmlkRXhwb3J0QnV0dG9uL0dyaWRFeHBvcnRCdXR0b24uc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGVBQUE7RUFDQSxXQUFBO0VBQ0Esb0RBQUE7QUFDRiIsInNvdXJjZXNDb250ZW50IjpbIi5leHBvcnQtb3ZlcmxheS1jb250YWluZXIge1xuICBwYWRkaW5nOiAwLjVyZW07XG4gIHdpZHRoOiAxMDAlO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1tZC1zZWNvbmRhcnktd2hpdGUtYmctY29sb3IpO1xufVxuIl0sInNvdXJjZVJvb3QiOiIifQ== */`);
    

/***/ }),

/***/ "./src/components/Common/GridExportButton/GridExportButton.ts":
/*!********************************************************************!*\
  !*** ./src/components/Common/GridExportButton/GridExportButton.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   GridExportButton: () => (/* binding */ GridExportButton)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _GridExportButton_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./GridExportButton.scss */ "./src/components/Common/GridExportButton/GridExportButton.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



const CSV = "csv";
const EXCEL = "excel";
let GridExportButton = class GridExportButton extends lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement {
    constructor() {
        super(...arguments);
        this.exportFileNamePrefix = "";
        this.sheetName = "";
    }
    static get styles() {
        return _GridExportButton_scss__WEBPACK_IMPORTED_MODULE_2__["default"];
    }
    downloadTableData(downloadFormat) {
        var _a, _b;
        switch (downloadFormat) {
            case CSV:
                (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.exportDataAsCsv(this.getExportParams());
                break;
            case EXCEL:
                (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.exportDataAsExcel(this.getExportParams());
                break;
        }
    }
    getExportParams() {
        var _a;
        return Object.assign(Object.assign({}, ((_a = this.exportParams) !== null && _a !== void 0 ? _a : {})), { fileName: `${this.exportFileNamePrefix}_${new Date(Date.now()).toString()}`, sheetName: this.sheetName });
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <md-menu-overlay size="small">
        <div slot="menu-trigger">
          <slot name="menu-trigger">
            <md-button size="28" circle variant="ghost" class="download-btn">
              <md-icon slot="icon" name="export_16" ariaHidden="true"></md-icon>
            </md-button>
          </slot>
        </div>
        <div class="export-overlay-container">
          <md-list label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.downloadTableContent")}>
            <md-list-item
              slot="list-item"
              @click=${() => this.downloadTableData(CSV)}
              @keypress=${(e) => e.key === "Enter" && this.downloadTableData(CSV)}
              >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.csv")}</md-list-item
            >
            <md-list-item
              slot="list-item"
              @click=${() => this.downloadTableData(EXCEL)}
              @keypress=${(e) => e.key === "Enter" && this.downloadTableData(EXCEL)}
              >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.microsoftExcel")}</md-list-item
            >
          </md-list>
        </div>
      </md-menu-overlay>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], GridExportButton.prototype, "exportFileNamePrefix", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], GridExportButton.prototype, "sheetName", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
], GridExportButton.prototype, "gridApi", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
], GridExportButton.prototype, "exportParams", void 0);
GridExportButton = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-grid-export-button")
], GridExportButton);



/***/ }),

/***/ "./src/components/Common/Headers/PageHeader/PageHeader.scss":
/*!******************************************************************!*\
  !*** ./src/components/Common/Headers/PageHeader/PageHeader.scss ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5em;
}
.header.hidden {
  display: none;
}

.title {
  color: var(--md-primary-text-color);
  font-size: 1.25rem;
  font-weight: var(--brand-font-weight-bold);
}

.buttons {
  display: flex;
  flex-direction: row nowrap;
  gap: 4px;
}

.popout-button.hidden,
.close-button.hidden {
  display: none;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0NvbW1vbi9IZWFkZXJzL1BhZ2VIZWFkZXIvUGFnZUhlYWRlci5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBQTtFQUNBLDhCQUFBO0VBQ0EsbUJBQUE7RUFDQSxjQUFBO0FBQ0Y7QUFDRTtFQUNFLGFBQUE7QUFDSjs7QUFHQTtFQUNFLG1DQUFBO0VBQ0Esa0JBQUE7RUFDQSwwQ0FBQTtBQUFGOztBQUdBO0VBQ0UsYUFBQTtFQUNBLDBCQUFBO0VBQ0EsUUFBQTtBQUFGOztBQUdBOztFQUVFLGFBQUE7QUFBRiIsInNvdXJjZXNDb250ZW50IjpbIi5oZWFkZXIge1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIHBhZGRpbmc6IDAuNWVtO1xuXG4gICYuaGlkZGVuIHtcbiAgICBkaXNwbGF5OiBub25lO1xuICB9XG59XG5cbi50aXRsZSB7XG4gIGNvbG9yOiB2YXIoLS1tZC1wcmltYXJ5LXRleHQtY29sb3IpO1xuICBmb250LXNpemU6IDEuMjVyZW07XG4gIGZvbnQtd2VpZ2h0OiB2YXIoLS1icmFuZC1mb250LXdlaWdodC1ib2xkKTtcbn1cblxuLmJ1dHRvbnMge1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogcm93IG5vd3JhcDtcbiAgZ2FwOiA0cHg7XG59XG5cbi5wb3BvdXQtYnV0dG9uLmhpZGRlbixcbi5jbG9zZS1idXR0b24uaGlkZGVuIHtcbiAgZGlzcGxheTogbm9uZTtcbn1cbiJdLCJzb3VyY2VSb290IjoiIn0= */`);
    

/***/ }),

/***/ "./src/components/Common/Headers/PageHeader/PageHeader.ts":
/*!****************************************************************!*\
  !*** ./src/components/Common/Headers/PageHeader/PageHeader.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PageHeader: () => (/* binding */ PageHeader)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _PageHeader_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./PageHeader.scss */ "./src/components/Common/Headers/PageHeader/PageHeader.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let PageHeader = class PageHeader extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
    constructor() {
        super(...arguments);
        this.title = "";
        this.usePopoutButton = false;
        this.useCloseButton = false;
    }
    static getStyles() {
        return _PageHeader_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
    }
    popoutClicked() {
        this.dispatchEvent(new CustomEvent("page-header-popout", {
            bubbles: true,
            composed: true
        }));
    }
    closeClicked() {
        this.dispatchEvent(new CustomEvent("page-header-close", {
            bubbles: true,
            composed: true
        }));
    }
    get isHidden() {
        return this.title.length === 0 && !this.usePopoutButton && !this.useCloseButton;
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <div class="header ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_2__.classMap)({ hidden: this.isHidden })}">
        <div class="title">${this.title}</div>
        <div class="buttons">
          <md-button
            class="popout-button ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_2__.classMap)({ hidden: !this.usePopoutButton })}"
            @click="${this.popoutClicked}"
            circle
          >
            <md-icon slot="icon" name="pop-out-bold" iconSet="momentumDesign"></md-icon>
          </md-button>
          <md-button
            class="close-button ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_2__.classMap)({ hidden: !this.useCloseButton })}"
            @click="${this.closeClicked}"
            circle
            ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common:closeButton")}"
          >
            <md-icon slot="icon" name="cancel-bold" iconSet="momentumDesign"></md-icon>
          </md-button>
        </div>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], PageHeader.prototype, "title", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
], PageHeader.prototype, "usePopoutButton", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
], PageHeader.prototype, "useCloseButton", void 0);
PageHeader = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-page-header")
], PageHeader);



/***/ }),

/***/ "./src/components/Common/Headers/PanelHeader/PanelHeader.scss":
/*!********************************************************************!*\
  !*** ./src/components/Common/Headers/PanelHeader/PanelHeader.scss ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  padding-bottom: 0;
  padding-top: 0.875rem;
  margin: 0 8px;
}
.header.hidden {
  display: none;
}

.heading {
  color: var(--md-primary-text-color);
  font-size: var(--font-size-heading-small);
  font-weight: var(--brand-font-weight-bold);
  font-family: var(--brand-font-bold);
  line-height: var(--font-lineheight-heading-small);
}

.tooltip-span {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.more-actions-list {
  width: 100%;
}

.more-list-wrapper {
  width: 100%;
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  padding: 5px 0;
  margin: 0 2px;
}

.callback-span {
  margin-left: 0.5rem;
}

.more-actions-span {
  display: flex;
  justify-content: center;
  align-items: center;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0NvbW1vbi9IZWFkZXJzL1BhbmVsSGVhZGVyL1BhbmVsSGVhZGVyLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxhQUFBO0VBQ0EsOEJBQUE7RUFDQSxtQkFBQTtFQUNBLGVBQUE7RUFDQSxpQkFBQTtFQUNBLHFCQUFBO0VBQ0EsYUFBQTtBQUNGO0FBQ0U7RUFDRSxhQUFBO0FBQ0o7O0FBR0E7RUFDRSxtQ0FBQTtFQUNBLHlDQUFBO0VBQ0EsMENBQUE7RUFDQSxtQ0FBQTtFQUNBLGlEQUFBO0FBQUY7O0FBR0E7RUFDRSxhQUFBO0VBQ0EsbUJBQUE7RUFDQSxlQUFBO0FBQUY7O0FBRUE7RUFDRSxXQUFBO0FBQ0Y7O0FBRUE7RUFDRSxXQUFBO0VBQ0EsbUJBQUE7RUFDQSxhQUFBO0VBQ0EsWUFBQTtFQUNBLHVCQUFBO0VBQ0EsY0FBQTtFQUNBLGFBQUE7QUFDRjs7QUFDQTtFQUNFLG1CQUFBO0FBRUY7O0FBQUE7RUFDRSxhQUFBO0VBQ0EsdUJBQUE7RUFDQSxtQkFBQTtBQUdGIiwic291cmNlc0NvbnRlbnQiOlsiLmhlYWRlciB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgcGFkZGluZzogMC41cmVtO1xuICBwYWRkaW5nLWJvdHRvbTogMDtcbiAgcGFkZGluZy10b3A6IDAuODc1cmVtO1xuICBtYXJnaW46IDAgOHB4O1xuXG4gICYuaGlkZGVuIHtcbiAgICBkaXNwbGF5OiBub25lO1xuICB9XG59XG5cbi5oZWFkaW5nIHtcbiAgY29sb3I6IHZhcigtLW1kLXByaW1hcnktdGV4dC1jb2xvcik7XG4gIGZvbnQtc2l6ZTogdmFyKC0tZm9udC1zaXplLWhlYWRpbmctc21hbGwpO1xuICBmb250LXdlaWdodDogdmFyKC0tYnJhbmQtZm9udC13ZWlnaHQtYm9sZCk7XG4gIGZvbnQtZmFtaWx5OiB2YXIoLS1icmFuZC1mb250LWJvbGQpO1xuICBsaW5lLWhlaWdodDogdmFyKC0tZm9udC1saW5laGVpZ2h0LWhlYWRpbmctc21hbGwpO1xufVxuXG4udG9vbHRpcC1zcGFuIHtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgY3Vyc29yOiBwb2ludGVyO1xufVxuLm1vcmUtYWN0aW9ucy1saXN0IHtcbiAgd2lkdGg6IDEwMCU7XG59XG5cbi5tb3JlLWxpc3Qtd3JhcHBlciB7XG4gIHdpZHRoOiAxMDAlO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBkaXNwbGF5OiBmbGV4O1xuICBoZWlnaHQ6IDEwMCU7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBwYWRkaW5nOiA1cHggMDtcbiAgbWFyZ2luOiAwIDJweDtcbn1cbi5jYWxsYmFjay1zcGFuIHtcbiAgbWFyZ2luLWxlZnQ6IDAuNXJlbTtcbn1cbi5tb3JlLWFjdGlvbnMtc3BhbiB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xufVxuIl0sInNvdXJjZVJvb3QiOiIifQ== */`);
    

/***/ }),

/***/ "./src/components/Common/Headers/PanelHeader/PanelHeader.ts":
/*!******************************************************************!*\
  !*** ./src/components/Common/Headers/PanelHeader/PanelHeader.ts ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PanelHeader: () => (/* binding */ PanelHeader)
/* harmony export */ });
/* harmony import */ var _components_ScheduleAndManageCallBack_constant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/ScheduleAndManageCallBack/constant */ "./src/components/ScheduleAndManageCallBack/constant.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _PanelHeader_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./PanelHeader.scss */ "./src/components/Common/Headers/PanelHeader/PanelHeader.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






let PanelHeader = class PanelHeader extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
    constructor() {
        super(...arguments);
        this.heading = "";
    }
    static getStyles() {
        return _PanelHeader_scss__WEBPACK_IMPORTED_MODULE_5__["default"];
    }
    updated(changedProperties) {
        if (changedProperties.has("heading") || changedProperties.has("rightContentNodes")) {
            this.requestUpdate();
        }
        super.updated(changedProperties);
    }
    get isHidden() {
        return this.heading.length === 0 && (!this.rightContentNodes || this.rightContentNodes.length === 0);
    }
    handleListitemClick(e) {
        if (e.detail.selected === 0) {
            const callBackData = {
                callbackModalData: {
                    triggeredFrom: "TASK_PANEL"
                },
                callbackFormData: _components_ScheduleAndManageCallBack_constant__WEBPACK_IMPORTED_MODULE_0__.EMPTY_CALLBACK_FORM_DATA,
                isShow: true
            };
            const event = new CustomEvent("open-schedule-callback-modal", {
                detail: callBackData,
                bubbles: true,
                composed: true
            });
            this.dispatchEvent(event);
        }
    }
    renderAddButton() {
        if (_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.featureflag.isFeatureFlagEnabled(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WXCC_SCHEDULED_CALLBACK)) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <md-menu-overlay custom-width="200px" max-height="68px" placement="bottom" show-arrow>
          <md-button variant="primary" circle slot="menu-trigger">
            <md-icon slot="icon" name="plus-bold" iconSet="momentumDesign" size="16"></md-icon>
          </md-button>
          <div class="more-list-wrapper">
            <md-list class="more-actions-list" @list-item-change="${this.handleListitemClick}">
              <md-list-item slot="list-item">
                <span class="more-actions-span">
                  <md-icon slot="icon" name="call-return-bold" iconSet="momentumDesign"></md-icon>
                  <span class="callback-span">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:callback.scheduleACallback")}</span>
                </span>
              </md-list-item>
            </md-list>
          </div>
        </md-menu-overlay>
      `;
        }
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) ``;
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      <div class="header ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__.classMap)({ hidden: this.isHidden })}">
        <div class="heading">${this.heading}</div>
        <div slot="panel-header-right-content">${this.renderAddButton()}</div>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
], PanelHeader.prototype, "heading", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.queryAssignedNodes)("panel-header-right-content", true)
], PanelHeader.prototype, "rightContentNodes", void 0);
PanelHeader = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-panel-header")
], PanelHeader);



/***/ }),

/***/ "./src/components/Common/Headers/index.ts":
/*!************************************************!*\
  !*** ./src/components/Common/Headers/index.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PageHeader: () => (/* reexport safe */ _PageHeader_PageHeader__WEBPACK_IMPORTED_MODULE_1__.PageHeader),
/* harmony export */   PanelHeader: () => (/* reexport safe */ _PanelHeader_PanelHeader__WEBPACK_IMPORTED_MODULE_0__.PanelHeader)
/* harmony export */ });
/* harmony import */ var _PanelHeader_PanelHeader__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./PanelHeader/PanelHeader */ "./src/components/Common/Headers/PanelHeader/PanelHeader.ts");
/* harmony import */ var _PageHeader_PageHeader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./PageHeader/PageHeader */ "./src/components/Common/Headers/PageHeader/PageHeader.ts");




/***/ }),

/***/ "./src/components/Common/Panel/PanelFrame/PanelFrame.scss":
/*!****************************************************************!*\
  !*** ./src/components/Common/Panel/PanelFrame/PanelFrame.scss ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: visible hidden;
}

.panel-content {
  flex: 1;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0NvbW1vbi9QYW5lbC9QYW5lbEZyYW1lL1BhbmVsRnJhbWUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGFBQUE7RUFDQSxzQkFBQTtFQUNBLFlBQUE7RUFDQSxXQUFBO0VBQ0Esd0JBQUE7QUFDRjs7QUFFQTtFQUNFLE9BQUE7QUFDRiIsInNvdXJjZXNDb250ZW50IjpbIi5jb250YWluZXIge1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBoZWlnaHQ6IDEwMCU7XG4gIHdpZHRoOiAxMDAlO1xuICBvdmVyZmxvdzogdmlzaWJsZSBoaWRkZW47XG59XG5cbi5wYW5lbC1jb250ZW50IHtcbiAgZmxleDogMTtcbn1cbiJdLCJzb3VyY2VSb290IjoiIn0= */`);
    

/***/ }),

/***/ "./src/components/Common/Panel/PanelFrame/PanelFrame.ts":
/*!**************************************************************!*\
  !*** ./src/components/Common/Panel/PanelFrame/PanelFrame.ts ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PanelFrame: () => (/* binding */ PanelFrame)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _PanelFrame_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./PanelFrame.scss */ "./src/components/Common/Panel/PanelFrame/PanelFrame.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let PanelFrame = class PanelFrame extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement) {
    constructor() {
        super(...arguments);
        this.heading = "";
    }
    static getStyles() {
        return _PanelFrame_scss__WEBPACK_IMPORTED_MODULE_2__["default"];
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
      <div class="container">
        <agentx-wc-panel-header heading=${this.heading}>
          <slot slot="panel-header-right-content" name="header-extra-content"></slot>
        </agentx-wc-panel-header>
        <agentx-wc-frame class="panel-content">
          <slot></slot>
        </agentx-wc-frame>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: String })
], PanelFrame.prototype, "heading", void 0);
PanelFrame = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("agentx-wc-panel-frame")
], PanelFrame);



/***/ }),

/***/ "./src/components/Common/Panel/PanelLayout/PanelLayout.scss":
/*!******************************************************************!*\
  !*** ./src/components/Common/Panel/PanelLayout/PanelLayout.scss ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.container {
  display: flex;
  flex-direction: column;
  gap: 0.5em;
  height: 100%;
}

.top {
  width: 100%;
}
.top.hidden {
  display: none;
}

.bottom {
  display: flex;
  gap: 0.5em;
  flex: 1;
}

.left,
.right {
  flex: 1;
}
.left.hidden,
.right.hidden {
  display: none;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0NvbW1vbi9QYW5lbC9QYW5lbExheW91dC9QYW5lbExheW91dC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBQTtFQUNBLHNCQUFBO0VBQ0EsVUFBQTtFQUNBLFlBQUE7QUFDRjs7QUFFQTtFQUNFLFdBQUE7QUFDRjtBQUNFO0VBQ0UsYUFBQTtBQUNKOztBQUdBO0VBQ0UsYUFBQTtFQUNBLFVBQUE7RUFDQSxPQUFBO0FBQUY7O0FBR0E7O0VBRUUsT0FBQTtBQUFGO0FBRUU7O0VBQ0UsYUFBQTtBQUNKIiwic291cmNlc0NvbnRlbnQiOlsiLmNvbnRhaW5lciB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGdhcDogMC41ZW07XG4gIGhlaWdodDogMTAwJTtcbn1cblxuLnRvcCB7XG4gIHdpZHRoOiAxMDAlO1xuXG4gICYuaGlkZGVuIHtcbiAgICBkaXNwbGF5OiBub25lO1xuICB9XG59XG5cbi5ib3R0b20ge1xuICBkaXNwbGF5OiBmbGV4O1xuICBnYXA6IDAuNWVtO1xuICBmbGV4OiAxO1xufVxuXG4ubGVmdCxcbi5yaWdodCB7XG4gIGZsZXg6IDE7XG5cbiAgJi5oaWRkZW4ge1xuICAgIGRpc3BsYXk6IG5vbmU7XG4gIH1cbn1cbiJdLCJzb3VyY2VSb290IjoiIn0= */`);
    

/***/ }),

/***/ "./src/components/Common/Panel/PanelLayout/PanelLayout.ts":
/*!****************************************************************!*\
  !*** ./src/components/Common/Panel/PanelLayout/PanelLayout.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PanelLayout: () => (/* binding */ PanelLayout)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _PanelLayout_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./PanelLayout.scss */ "./src/components/Common/Panel/PanelLayout/PanelLayout.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let PanelLayout = class PanelLayout extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement) {
    constructor() {
        super(...arguments);
        this.showTopPanel = true;
        this.showLeftPanel = true;
        this.showRightPanel = true;
    }
    static getStyles() {
        return _PanelLayout_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
      <div class="container">
        <div class="top ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1__.classMap)({ hidden: !this.showTopPanel })}">
          <slot name="top"></slot>
        </div>
        <div class="bottom">
          <div class="left ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1__.classMap)({ hidden: !this.showLeftPanel })}">
            <slot name="left"></slot>
          </div>
          <div class="right ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1__.classMap)({ hidden: !this.showRightPanel })}">
            <slot name="right"></slot>
          </div>
        </div>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Boolean })
], PanelLayout.prototype, "showTopPanel", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Boolean })
], PanelLayout.prototype, "showLeftPanel", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Boolean })
], PanelLayout.prototype, "showRightPanel", void 0);
PanelLayout = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("agentx-wc-panel-layout")
], PanelLayout);



/***/ }),

/***/ "./src/components/Common/Panel/index.ts":
/*!**********************************************!*\
  !*** ./src/components/Common/Panel/index.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PanelFrame: () => (/* reexport safe */ _PanelFrame_PanelFrame__WEBPACK_IMPORTED_MODULE_0__.PanelFrame),
/* harmony export */   PanelLayout: () => (/* reexport safe */ _PanelLayout_PanelLayout__WEBPACK_IMPORTED_MODULE_1__.PanelLayout)
/* harmony export */ });
/* harmony import */ var _PanelFrame_PanelFrame__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./PanelFrame/PanelFrame */ "./src/components/Common/Panel/PanelFrame/PanelFrame.ts");
/* harmony import */ var _PanelLayout_PanelLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./PanelLayout/PanelLayout */ "./src/components/Common/Panel/PanelLayout/PanelLayout.ts");




/***/ }),

/***/ "./src/components/Common/SearchInput/searchInput.scss":
/*!************************************************************!*\
  !*** ./src/components/Common/SearchInput/searchInput.scss ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.state-input-wrapper {
  height: var(--state-input-height);
  padding: 0px 2px;
}
.state-input-wrapper md-input::part(md-input-container) {
  margin-bottom: 0px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0NvbW1vbi9TZWFyY2hJbnB1dC9zZWFyY2hJbnB1dC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsaUNBQUE7RUFDQSxnQkFBQTtBQUNGO0FBRUk7RUFDRSxrQkFBQTtBQUFOIiwic291cmNlc0NvbnRlbnQiOlsiLnN0YXRlLWlucHV0LXdyYXBwZXIge1xuICBoZWlnaHQ6IHZhcigtLXN0YXRlLWlucHV0LWhlaWdodCk7XG4gIHBhZGRpbmc6IDBweCAycHg7XG5cbiAgbWQtaW5wdXQge1xuICAgICY6OnBhcnQobWQtaW5wdXQtY29udGFpbmVyKSB7XG4gICAgICBtYXJnaW4tYm90dG9tOiAwcHg7XG4gICAgfVxuICB9XG59XG4iXSwic291cmNlUm9vdCI6IiJ9 */`);
    

/***/ }),

/***/ "./src/components/Common/SearchInput/searchInput.ts":
/*!**********************************************************!*\
  !*** ./src/components/Common/SearchInput/searchInput.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SearchInput: () => (/* binding */ SearchInput)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _searchInput_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./searchInput.scss */ "./src/components/Common/SearchInput/searchInput.scss");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_6__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var SearchInput;
(function (SearchInput) {
    /**
     * @element search-input
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.isPageLoading = false;
            this.isSearchPageLoading = false;
            this.reset = false;
            this.presetValue = "";
            this.placeholder = "";
            this.ariaLabel = "";
            this.searchQuery = "";
            this.handleSearchDebounced = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_4__.debounce)((event) => {
                const { value } = event.detail;
                this.searchQuery = value;
                if (this.presetValue) {
                    this.presetValue = "";
                }
                if (value === "") {
                    this.dispatchEvent(new CustomEvent("search-cleared", { detail: value }));
                }
                else if (value.length < _constants__WEBPACK_IMPORTED_MODULE_0__.SEARCH_THRESHOLD) {
                    this.dispatchEvent(new CustomEvent("search-too-short", { detail: value }));
                }
                else if (value.length >= _constants__WEBPACK_IMPORTED_MODULE_0__.SEARCH_THRESHOLD) {
                    this.dispatchEvent(new CustomEvent("search-term-valid", { detail: value }));
                }
            }, _constants__WEBPACK_IMPORTED_MODULE_0__.FILTER_CHANGE_DELAY);
            this.handleSearch = (event) => {
                this.handleSearchDebounced(event);
            };
        }
        static get styles() {
            return _searchInput_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            if (changedProperties.has("reset") && this.reset === false) {
                this.searchQuery = "";
            }
        }
        handleInputKeyDown(event) {
            this.dispatchEvent(new CustomEvent("input-keydown", { detail: event.detail }));
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="state-input-wrapper" part="search-input-wrapper">
          <md-input
            id="pillSearchInput"
            searchable
            newMomentum
            aria-label="${this.ariaLabel || (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.search")}"
            placeholder=${this.placeholder || (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.search")}
            clear
            clearAriaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common:clear")}"
            containerSize="medium-10"
            htmlId="pillSearchInput"
            name="pillSearchInput"
            value="${this.presetValue || this.searchQuery}"
            @input-change="${this.handleSearch}"
            @input-keydown="${this.handleInputKeyDown}"
            type="text"
            shape=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_5__.ifDefined)(!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_6__.themeManager.isMomentumV2Enabled ? "pill" : undefined)}
            .disabled=${this.isPageLoading && !this.isSearchPageLoading}
            autoFocus
          >
          </md-input>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ reflect: true, type: Boolean })
    ], Element.prototype, "isPageLoading", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ reflect: true, type: Boolean })
    ], Element.prototype, "isSearchPageLoading", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ reflect: true, type: Boolean })
    ], Element.prototype, "reset", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "presetValue", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "placeholder", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "ariaLabel", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "searchQuery", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.query)("md-input")
    ], Element.prototype, "input", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("search-input")
    ], Element);
    SearchInput.Element = Element;
})(SearchInput || (SearchInput = {}));


/***/ }),

/***/ "./src/components/Common/Table/TableManager.ts":
/*!*****************************************************!*\
  !*** ./src/components/Common/Table/TableManager.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableManager: () => (/* binding */ TableManager)
/* harmony export */ });
/* harmony import */ var _components_GridWidget_GridCacheUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/GridWidget/GridCacheUtils */ "./src/components/GridWidget/GridCacheUtils.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");


class TableManager {
    /* Public API */
    constructor(config) {
        this.columnDefinitions = {};
        this.defaultColumnStates = [];
        const { cacheName, columnDefinitions } = config;
        this.cacheName = cacheName;
        if (columnDefinitions.some((colDef) => colDef.colId === undefined)) {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[TableManager] setColumnDefinitions requires all column definitions to have colId specified");
            return;
        }
        this.columnDefinitions = Object.fromEntries(columnDefinitions.map((colDef) => [colDef.colId, colDef]));
    }
    /* Event Handlers */
    onGridReady(gridApi) {
        var _a, _b;
        this.gridApi = gridApi;
        (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.setGridOption("columnDefs", Object.values(this.columnDefinitions));
        this.defaultColumnStates = (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.getColumnState();
        const cachedColumnStates = this.cachedColumnStates;
        if (cachedColumnStates) {
            this.setColumnStates(cachedColumnStates);
        }
    }
    onReset() {
        var _a, _b, _c;
        this.deleteCachedColumnStates();
        (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.resetColumnState();
        (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.setFilterModel(null);
        (_c = this.gridApi) === null || _c === void 0 ? void 0 : _c.onFilterChanged();
    }
    onTableColumnResized(e) {
        this.handleTableEvent(e);
    }
    onTableColumnMoved(e) {
        if (e.source === "api") {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[TableManager] onTableColumnMoved triggered by API, ignoring event");
            return;
        }
        this.handleTableEvent(e);
    }
    onTableSortChanged(e) {
        this.handleTableEvent(e);
    }
    /* Private Methods */
    get cachedColumnStates() {
        var _a, _b;
        if (this.cacheName === undefined) {
            return null;
        }
        const cachedColumnStatesString = (_b = (_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem(this.cacheName)) !== null && _b !== void 0 ? _b : "";
        let cachedColumnStates = [];
        try {
            cachedColumnStates = JSON.parse(cachedColumnStatesString);
        }
        catch (err) {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[TableManager] Config: error caught loading config from local storage:", err);
            if (cachedColumnStatesString) {
                this.deleteCachedColumnStates();
            }
        }
        if (Array.isArray(cachedColumnStates) && cachedColumnStates.length && Array.isArray(this.defaultColumnStates)) {
            return (0,_components_GridWidget_GridCacheUtils__WEBPACK_IMPORTED_MODULE_0__.mergedSimplifiedStateWithDefault)(cachedColumnStates, this.defaultColumnStates);
        }
        return null;
    }
    setColumnStates(columnStates) {
        if (!this.gridApi) {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[TableManager] setColumnStates called before gridApi was set");
            return;
        }
        this.gridApi.applyColumnState({
            state: columnStates,
            applyOrder: true
        });
    }
    deleteCachedColumnStates() {
        var _a;
        if (this.cacheName) {
            (_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.removeItem(this.cacheName);
        }
    }
    handleTableEvent(e) {
        if (!this.gridApi) {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[TableManager] cacheColumnStates was called before gridApi was set");
            return;
        }
        if ("finished" in e && !e.finished) {
            return;
        }
        const newColumnStates = this.gridApi.getColumnState();
        this.writeColumnStateToLocalStorage(newColumnStates);
    }
    writeColumnStateToLocalStorage(columnState) {
        var _a;
        if (!this.gridApi) {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[TableManager] writeColumnStateToLocalStorage was called before gridApi was set");
            return;
        }
        if (!this.cacheName) {
            return;
        }
        const currentColumnState = (0,_components_GridWidget_GridCacheUtils__WEBPACK_IMPORTED_MODULE_0__.simplifyState)(columnState, this.defaultColumnStates);
        (_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.setItem(this.cacheName, JSON.stringify(currentColumnState));
    }
}


/***/ }),

/***/ "./src/components/Common/TableHeader/TableHeaderWidget.scss":
/*!******************************************************************!*\
  !*** ./src/components/Common/TableHeader/TableHeaderWidget.scss ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`#table-group {
  box-sizing: border-box;
  display: flex;
  height: 44px;
  padding: 0px 8px 0px 12px;
  flex-grow: 1;
  align-items: center;
  margin: 0px;
  border-radius: 8px;
  background: var(--md-glass-overlay-bg-color);
  box-shadow: var(--md-elevation-1);
}

.spacer {
  flex-grow: 1;
  display: flex;
}

#left-group {
  color: var(--md-primary-text-color);
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 8px;
}

#right-group {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 8px;
}

.separator {
  width: 1px;
  height: 16px;
  background: var(--md-separator-primary);
  display: inline-block;
  margin: 0;
  padding: 0;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0NvbW1vbi9UYWJsZUhlYWRlci9UYWJsZUhlYWRlcldpZGdldC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0Usc0JBQUE7RUFDQSxhQUFBO0VBQ0EsWUFBQTtFQUNBLHlCQUFBO0VBQ0EsWUFBQTtFQUNBLG1CQUFBO0VBQ0EsV0FBQTtFQUNBLGtCQUFBO0VBQ0EsNENBQUE7RUFDQSxpQ0FBQTtBQUNGOztBQUdBO0VBQ0UsWUFBQTtFQUNBLGFBQUE7QUFBRjs7QUFHQTtFQUNFLG1DQUFBO0VBQ0EsYUFBQTtFQUNBLHFCQUFBO0VBQ0EsbUJBQUE7RUFDQSxRQUFBO0FBQUY7O0FBR0E7RUFDRSxhQUFBO0VBQ0EscUJBQUE7RUFDQSxtQkFBQTtFQUNBLFFBQUE7QUFBRjs7QUFHQTtFQUNFLFVBQUE7RUFDQSxZQUFBO0VBQ0EsdUNBQUE7RUFDQSxxQkFBQTtFQUNBLFNBQUE7RUFDQSxVQUFBO0FBQUYiLCJzb3VyY2VzQ29udGVudCI6WyIjdGFibGUtZ3JvdXAge1xuICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICBkaXNwbGF5OiBmbGV4O1xuICBoZWlnaHQ6IDQ0cHg7XG4gIHBhZGRpbmc6IDBweCA4cHggMHB4IDEycHg7XG4gIGZsZXgtZ3JvdzogMTtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgbWFyZ2luOiAwcHg7XG4gIGJvcmRlci1yYWRpdXM6IDhweDtcbiAgYmFja2dyb3VuZDogdmFyKC0tbWQtZ2xhc3Mtb3ZlcmxheS1iZy1jb2xvcik7XG4gIGJveC1zaGFkb3c6IHZhcigtLW1kLWVsZXZhdGlvbi0xKTtcbiAgLy8gYmFja2Ryb3AtZmlsdGVyOiBibHVyKDEwcHgpO1xufVxuXG4uc3BhY2VyIHtcbiAgZmxleC1ncm93OiAxO1xuICBkaXNwbGF5OiBmbGV4O1xufVxuXG4jbGVmdC1ncm91cCB7XG4gIGNvbG9yOiB2YXIoLS1tZC1wcmltYXJ5LXRleHQtY29sb3IpO1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWZsb3c6IHJvdyBub3dyYXA7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGdhcDogOHB4O1xufVxuXG4jcmlnaHQtZ3JvdXAge1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWZsb3c6IHJvdyBub3dyYXA7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGdhcDogOHB4O1xufVxuXG4uc2VwYXJhdG9yIHtcbiAgd2lkdGg6IDFweDtcbiAgaGVpZ2h0OiAxNnB4O1xuICBiYWNrZ3JvdW5kOiB2YXIoLS1tZC1zZXBhcmF0b3ItcHJpbWFyeSk7XG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgbWFyZ2luOiAwO1xuICBwYWRkaW5nOiAwO1xufVxuIl0sInNvdXJjZVJvb3QiOiIifQ== */`);
    

/***/ }),

/***/ "./src/components/Common/TableHeader/TableHeaderWidget.ts":
/*!****************************************************************!*\
  !*** ./src/components/Common/TableHeader/TableHeaderWidget.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableHeaderWidget: () => (/* binding */ TableHeaderWidget)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _TableHeaderWidget_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./TableHeaderWidget.scss */ "./src/components/Common/TableHeader/TableHeaderWidget.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let TableHeaderWidget = class TableHeaderWidget extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
    constructor() {
        super(...arguments);
        this.rowCount = 0;
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    static get styles() {
        return _TableHeaderWidget_scss__WEBPACK_IMPORTED_MODULE_2__["default"];
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <div id="table-group">
        <slot name="left-group"></slot>

        <div class="spacer"></div>

        <slot name="right-group"></slot>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
], TableHeaderWidget.prototype, "rowCount", void 0);
TableHeaderWidget = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("table-header-widget")
], TableHeaderWidget);



/***/ }),

/***/ "./src/components/Common/Utils/GridUtils.ts":
/*!**************************************************!*\
  !*** ./src/components/Common/Utils/GridUtils.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   initializeGlobalGridProperties: () => (/* binding */ initializeGlobalGridProperties),
/* harmony export */   registerAgGridChartsModule: () => (/* binding */ registerAgGridChartsModule)
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/config */ "./src/config.ts");
/* harmony import */ var ag_charts_enterprise__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ag-charts-enterprise */ "ag-charts-enterprise");
/* harmony import */ var ag_charts_enterprise__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(ag_charts_enterprise__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ag-grid-enterprise */ "ag-grid-enterprise");
/* harmony import */ var ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_2__);



let isGlobalPropertiesInitialized = false;
let isAgGridChartsModuleRegistered = false;
function initializeGlobalGridProperties() {
    var _a;
    if (!isGlobalPropertiesInitialized) {
        ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_2__.LicenseManager.setLicenseKey((_a = _config__WEBPACK_IMPORTED_MODULE_0__.CONF.AG_GRID_LICENSE_KEY) !== null && _a !== void 0 ? _a : "");
        isGlobalPropertiesInitialized = true;
        ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_2__.ModuleRegistry.registerModules([ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_2__.AllEnterpriseModule]);
        (0,ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_2__.provideGlobalGridOptions)({ theme: "legacy" });
    }
}
function registerAgGridChartsModule() {
    var _a;
    if (!isAgGridChartsModuleRegistered) {
        ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_2__.ModuleRegistry.registerModules([ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_2__.IntegratedChartsModule.with(ag_charts_enterprise__WEBPACK_IMPORTED_MODULE_1__.AgChartsEnterpriseModule)]);
        ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_2__.LicenseManager.setLicenseKey((_a = _config__WEBPACK_IMPORTED_MODULE_0__.CONF.AG_CHARTS_LICENSE_KEY) !== null && _a !== void 0 ? _a : "");
        isAgGridChartsModuleRegistered = true;
    }
}


/***/ }),

/***/ "./src/components/Common/Utils/HighlightText.ts":
/*!******************************************************!*\
  !*** ./src/components/Common/Utils/HighlightText.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   highlightText: () => (/* binding */ highlightText)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _TeamPerformanceWidget_components_agentStateSelector_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../TeamPerformanceWidget/components/agentStateSelector/utils */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/utils/index.ts");


const highlightText = (text = "", highlight = "") => {
    if (!highlight.trim()) {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) ` <span>${text}</span> `;
    }
    const regex = new RegExp(`(${(0,_TeamPerformanceWidget_components_agentStateSelector_utils__WEBPACK_IMPORTED_MODULE_1__.escapeRegExp)(highlight)})`, "gi");
    const parts = text.split(regex);
    return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
    <span class="highlight-span">
      ${parts
        .filter((part) => part)
        .map((part) => 
    // prettier-ignore
    regex.test(part)
        ? (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `<b>${part}</b>`
        : (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `<span>${part}</span>`)}
    </span>
  `;
};


/***/ }),

/***/ "./src/components/Common/WcChart/WcRadarChart.scss":
/*!*********************************************************!*\
  !*** ./src/components/Common/WcChart/WcRadarChart.scss ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  display: grid;
}

.ag-radar-chart-container {
  min-height: 500px;
  overflow: hidden;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0NvbW1vbi9XY0NoYXJ0L1djUmFkYXJDaGFydC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBQTtBQUNGOztBQUVBO0VBQ0UsaUJBQUE7RUFDQSxnQkFBQTtBQUNGIiwic291cmNlc0NvbnRlbnQiOlsiOmhvc3Qge1xuICBkaXNwbGF5OiBncmlkO1xufVxuXG4uYWctcmFkYXItY2hhcnQtY29udGFpbmVyIHtcbiAgbWluLWhlaWdodDogNTAwcHg7XG4gIG92ZXJmbG93OiBoaWRkZW47XG59XG4iXSwic291cmNlUm9vdCI6IiJ9 */`);
    

/***/ }),

/***/ "./src/components/Common/WcChart/WcRadarChart.ts":
/*!*******************************************************!*\
  !*** ./src/components/Common/WcChart/WcRadarChart.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WcRadarChart: () => (/* binding */ WcRadarChart)
/* harmony export */ });
/* harmony import */ var _components_Common_Utils_GridUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/Utils/GridUtils */ "./src/components/Common/Utils/GridUtils.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var ag_charts_community__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ag-charts-community */ "ag-charts-community");
/* harmony import */ var ag_charts_community__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(ag_charts_community__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _WcRadarChart_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./WcRadarChart.scss */ "./src/components/Common/WcChart/WcRadarChart.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var WcRadarChart;
(function (WcRadarChart) {
    const NODE_TOOLTIP_RANGE = 10;
    const MAX_VALUE_FOR_METRIC = 1.2;
    /**
     * WcRadarChart
     * A web component for rendering a radar chart using ag-charts-community.
     * @element agentx-wc-radar-chart
     * @param isDarkMode - Indicates if dark mode is enabled.
     * @param metadata - Metadata for the chart, including title and subtitle.
     * @param data - Data array for the radar chart, including angle IDs, display names, and series data. Assumed to be non-normalized.
     * @event wc-radar-node-click - Fired when a node is clicked on the radar chart
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_4__.LitElement) {
        constructor() {
            super();
            this.isDarkMode = false;
            this.metadata = { title: "", subtitle: "" };
            this.data = [];
            this.rawDataCache = [];
            (0,_components_Common_Utils_GridUtils__WEBPACK_IMPORTED_MODULE_0__.registerAgGridChartsModule)();
            this.chartStyle = this.getChartStyles();
        }
        static get styles() {
            return [_WcRadarChart_scss__WEBPACK_IMPORTED_MODULE_5__["default"]];
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            if (changedProperties.has("data") || changedProperties.has("metadata") || changedProperties.has("isDarkMode")) {
                this.updateChart();
            }
        }
        /**
         * Gets the raw value for a specific angle and series
         * @param angleId The ID of the angle (eg. metric, unique property, etc.)
         * @param seriesId The ID of the series (eg. agent, team, group, etc.)
         */
        getRawValue(angleId, seriesId) {
            const dataPoint = this.rawDataCache.find((point) => point.angleId === angleId && point.seriesId === seriesId);
            return dataPoint === null || dataPoint === void 0 ? void 0 : dataPoint.rawValue;
        }
        updateChart() {
            var _a;
            if (!this.data || Object.keys(this.data).length < 1) {
                _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error("Data not provided to WcRadarChart");
                return;
            }
            if (this.activeChart) {
                this.activeChart.destroy();
                this.activeChart = undefined;
            }
            this.chartContainerElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".ag-radar-chart-container");
            if (this.chartContainerElement) {
                this.chartStyle = this.getChartStyles();
                const [chartSeries, chartData] = this.generateSeriesAndData();
                const chartOptions = {
                    container: this.chartContainerElement,
                    data: chartData,
                    title: {
                        enabled: this.metadata.title.length > 0,
                        text: this.metadata.title,
                        color: this.chartStyle.titleColor
                    },
                    subtitle: {
                        enabled: this.metadata.subtitle.length > 0,
                        text: this.metadata.subtitle,
                        color: this.chartStyle.subtitleColor
                    },
                    background: {
                        visible: true,
                        fill: this.chartStyle.backgroundColor
                    },
                    series: chartSeries,
                    axes: [
                        {
                            type: "angle-category",
                            label: {
                                enabled: true,
                                color: this.chartStyle.axesTextColor
                            }
                        },
                        {
                            type: "radius-number",
                            label: {
                                enabled: true,
                                color: this.chartStyle.axesTextColor
                            }
                        }
                    ],
                    theme: {
                        overrides: {
                            common: {
                                legend: {
                                    position: "right",
                                    enabled: true,
                                    orientation: "vertical",
                                    preventHidingAll: true,
                                    item: { label: { color: this.chartStyle.subtitleColor } }
                                },
                                tooltip: {
                                    enabled: true,
                                    range: NODE_TOOLTIP_RANGE
                                }
                            }
                        }
                    }
                };
                this.activeChart = ag_charts_community__WEBPACK_IMPORTED_MODULE_3__.AgCharts.create(chartOptions);
            }
        }
        fireNodeClickEvent(event) {
            this.dispatchEvent(new CustomEvent("wc-radar-node-click", {
                detail: {
                    event
                }
            }));
        }
        getCSSValue(cssProperty) {
            return this.chartContainerElement
                ? getComputedStyle(this.chartContainerElement).getPropertyValue(cssProperty)
                : "";
        }
        getChartStyles() {
            const titleColor = this.getCSSValue("--md-primary-text-color");
            const subtitleColor = this.getCSSValue("--md-secondary-text-color");
            const axesTextColor = this.getCSSValue("--md-secondary-text-color");
            const backgroundColor = this.getCSSValue("--md-content-bg-color");
            return {
                titleColor,
                subtitleColor,
                axesTextColor,
                backgroundColor
            };
        }
        generateRadarSeries(seriesMetadata) {
            const chartSeriesOptions = [];
            seriesMetadata.forEach((series) => {
                chartSeriesOptions.push({
                    type: "radar-area",
                    angleKey: "angleId",
                    radiusKey: series.seriesId,
                    radiusName: series.seriesDisplayName,
                    fillOpacity: 0.5,
                    listeners: {
                        nodeClick: (event) => {
                            this.fireNodeClickEvent(event);
                        }
                    },
                    nodeClickRange: "nearest",
                    marker: { enabled: true },
                    tooltip: {
                        renderer: (p) => this.renderTooltip(p)
                    },
                    connectMissingData: true
                });
            });
            return chartSeriesOptions;
        }
        generateSeriesAndData() {
            if (this.data.length < 1) {
                throw new Error("Data not provided to WcRadarChart");
            }
            const chartData = [];
            const collectedSeries = [];
            this.rawDataCache = [];
            const seriesAngles = {};
            const maxValuesByAngle = {};
            this.data.forEach((dataObj) => {
                dataObj.seriesDataArray.forEach((dataPoint) => {
                    if (!seriesAngles[dataPoint.seriesId]) {
                        seriesAngles[dataPoint.seriesId] = {};
                    }
                    const value = isNaN(dataPoint.angleValue) || dataPoint.angleValue < 0 ? 0 : dataPoint.angleValue;
                    seriesAngles[dataPoint.seriesId][dataObj.angleId] = value;
                    this.rawDataCache.push({
                        angleId: dataObj.angleId,
                        seriesId: dataPoint.seriesId,
                        rawValue: value
                    });
                    if (maxValuesByAngle[dataObj.angleId] === undefined || value > maxValuesByAngle[dataObj.angleId]) {
                        maxValuesByAngle[dataObj.angleId] = value;
                    }
                    if (!collectedSeries.some((s) => s.seriesId === dataPoint.seriesId)) {
                        collectedSeries.push({
                            seriesId: dataPoint.seriesId,
                            seriesDisplayName: dataPoint.seriesDisplayName
                        });
                    }
                });
            });
            this.data.forEach((dataObj) => {
                let chartDataObj = { angleId: dataObj.angleId, angleName: dataObj.angleDisplayName };
                dataObj.seriesDataArray.forEach((dataPoint) => {
                    const rawValue = isNaN(dataPoint.angleValue) || dataPoint.angleValue < 0 ? 0 : dataPoint.angleValue;
                    const maxVal = maxValuesByAngle[dataObj.angleId] * MAX_VALUE_FOR_METRIC;
                    const normalizedValue = maxVal > 0 ? (rawValue / maxVal) * 100 : 0;
                    chartDataObj = Object.assign(Object.assign({}, chartDataObj), { [dataPoint.seriesId]: normalizedValue });
                });
                chartData.push(chartDataObj);
            });
            return [this.generateRadarSeries(collectedSeries), chartData];
        }
        renderTooltip(params) {
            const rawValue = this.getRawValue(params.datum.angleId, params.radiusKey);
            return `<div style="padding: 5px; color: ${this.chartStyle.axesTextColor};">
              <div>${params.datum.angleName}</div>
              <div>${params.radiusName}: ${rawValue === null || rawValue === void 0 ? void 0 : rawValue.toFixed(2)} (${Number(params.datum[params.radiusKey]).toFixed(1)}%)</div>
            </div>
          `;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `<div class="ag-radar-chart-container"></div>`;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
    ], Element.prototype, "isDarkMode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Object })
    ], Element.prototype, "metadata", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Array })
    ], Element.prototype, "data", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "chartContainerElement", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "activeChart", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "rawDataCache", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "chartStyle", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.customElement)("agentx-wc-radar-chart")
    ], Element);
    WcRadarChart.Element = Element;
})(WcRadarChart || (WcRadarChart = {}));


/***/ }),

/***/ "./src/components/Common/WcGrid/CellComponents/AnomaliesCellComponent.scss":
/*!*********************************************************************************!*\
  !*** ./src/components/Common/WcGrid/CellComponents/AnomaliesCellComponent.scss ***!
  \*********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.anomaly-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
}

.anomaly-count {
  padding-top: 2px;
  font-size: var(--font-size-medium);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0NvbW1vbi9XY0dyaWQvQ2VsbENvbXBvbmVudHMvQW5vbWFsaWVzQ2VsbENvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBQTtFQUNBLFlBQUE7RUFDQSxXQUFBO0VBQ0EsbUJBQUE7RUFDQSx1QkFBQTtBQUNGOztBQUVBO0VBQ0UsYUFBQTtFQUNBLG1CQUFBO0VBQ0EsdUJBQUE7RUFDQSxRQUFBO0VBQ0EsZUFBQTtBQUNGOztBQUVBO0VBQ0UsZ0JBQUE7RUFDQSxrQ0FBQTtBQUNGIiwic291cmNlc0NvbnRlbnQiOlsiOmhvc3Qge1xuICBkaXNwbGF5OiBmbGV4O1xuICBoZWlnaHQ6IDEwMCU7XG4gIHdpZHRoOiAxMDAlO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbn1cblxuLmFub21hbHktY2VsbCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBnYXA6IDZweDtcbiAgY3Vyc29yOiBwb2ludGVyO1xufVxuXG4uYW5vbWFseS1jb3VudCB7XG4gIHBhZGRpbmctdG9wOiAycHg7XG4gIGZvbnQtc2l6ZTogdmFyKC0tZm9udC1zaXplLW1lZGl1bSk7XG59XG4iXSwic291cmNlUm9vdCI6IiJ9 */`);
    

/***/ }),

/***/ "./src/components/Common/WcGrid/CellComponents/AnomaliesCellComponent.ts":
/*!*******************************************************************************!*\
  !*** ./src/components/Common/WcGrid/CellComponents/AnomaliesCellComponent.ts ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AnomaliesCellComponent: () => (/* binding */ AnomaliesCellComponent)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _AnomaliesCellComponent_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./AnomaliesCellComponent.scss */ "./src/components/Common/WcGrid/CellComponents/AnomaliesCellComponent.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let AnomaliesCellComponent = class AnomaliesCellComponent extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
    constructor() {
        super(...arguments);
        this.anomalies = [];
    }
    static get styles() {
        return _AnomaliesCellComponent_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
    }
    renderAnomaly() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <div class="anomaly-cell">
        <md-icon
          name="show-filled"
          iconSet="momentumDesign"
          size="26"
          color="var(--md-alert-info-text-color)"
        ></md-icon>
        <span class="anomaly-count">${this.anomalies.length}</span>
      </div>
    `;
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${this.anomalies.length > 0 ? this.renderAnomaly() : lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}`;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Array })
], AnomaliesCellComponent.prototype, "anomalies", void 0);
AnomaliesCellComponent = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-anomalies-cell")
], AnomaliesCellComponent);



/***/ }),

/***/ "./src/components/Common/WcGrid/CellRenderers/BaseCellRenderer.ts":
/*!************************************************************************!*\
  !*** ./src/components/Common/WcGrid/CellRenderers/BaseCellRenderer.ts ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   BaseCellRenderer: () => (/* binding */ BaseCellRenderer)
/* harmony export */ });
class BaseCellRenderer {
    constructor() {
        this.eGui = document.createElement("div");
    }
    init(params) {
        this.eGui.classList.add("cell-renderer");
        this.render(params);
    }
    refresh(params) {
        this.render(params);
        return true;
    }
    getGui() {
        return this.eGui;
    }
    destroy() {
        this.eGui.remove();
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/CellRenderers/FullWidthRowCellRenderer.ts":
/*!********************************************************************************!*\
  !*** ./src/components/Common/WcGrid/CellRenderers/FullWidthRowCellRenderer.ts ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FullWidthRowCellRenderer: () => (/* binding */ FullWidthRowCellRenderer)
/* harmony export */ });
/* harmony import */ var _BaseCellRenderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BaseCellRenderer */ "./src/components/Common/WcGrid/CellRenderers/BaseCellRenderer.ts");

class FullWidthRowCellRenderer extends _BaseCellRenderer__WEBPACK_IMPORTED_MODULE_0__.BaseCellRenderer {
    render(params) {
        const fullWidthCellRendererParams = params.api.getGridOption("fullWidthCellRendererParams");
        if (!(fullWidthCellRendererParams === null || fullWidthCellRendererParams === void 0 ? void 0 : fullWidthCellRendererParams.componentName)) {
            return;
        }
        const component = document.createElement(fullWidthCellRendererParams.componentName);
        const widget = this.eGui.firstChild ? this.eGui.firstChild : component;
        widget.data = params.data;
        if (!this.eGui.firstChild) {
            this.eGui.appendChild(widget);
        }
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/CellRenderers/WcGridCellRenderer.ts":
/*!**************************************************************************!*\
  !*** ./src/components/Common/WcGrid/CellRenderers/WcGridCellRenderer.ts ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   createWcGridCellRendererClass: () => (/* binding */ createWcGridCellRendererClass)
/* harmony export */ });
class WcGridCellRenderer {
    constructor(elementTag, updateElementProperties) {
        this.elementTag = elementTag;
        this.updateElementProperties = updateElementProperties;
    }
    init(params) {
        this.eGui = this.createEGui();
        this.updateElementProperties(this.eGui, params);
    }
    refresh(params) {
        if (this.eGui) {
            this.updateElementProperties(this.eGui, params);
        }
        return true;
    }
    getGui() {
        var _a;
        return (_a = this.eGui) !== null && _a !== void 0 ? _a : this.createEGui();
    }
    createEGui() {
        return document.createElement(this.elementTag);
    }
}
function createWcGridCellRendererClass(elementTag, updateElementProperties) {
    return class extends WcGridCellRenderer {
        constructor() {
            super(elementTag, updateElementProperties);
        }
    };
}


/***/ }),

/***/ "./src/components/Common/WcGrid/DataSources/WcServerSideDataSource.ts":
/*!****************************************************************************!*\
  !*** ./src/components/Common/WcGrid/DataSources/WcServerSideDataSource.ts ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WcGridServerSideDataSource: () => (/* binding */ WcGridServerSideDataSource)
/* harmony export */ });
class WcGridServerSideDataSource {
    constructor(fetchRowsFunction) {
        this.fetchRowsFunction = fetchRowsFunction;
    }
    getRows(params) {
        var _a;
        const request = {
            startRow: params.request.startRow,
            endRow: params.request.endRow,
            filterModel: (_a = params.request.filterModel) !== null && _a !== void 0 ? _a : undefined,
            sortModel: params.request.sortModel
        };
        const success = (response) => {
            params.success({ rowData: response.rowData, rowCount: response.rowCount });
        };
        const fail = () => {
            params.fail();
        };
        this.fetchRowsFunction({ request, success, fail });
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/DataSources/WcServerSideDataSource.types.ts":
/*!**********************************************************************************!*\
  !*** ./src/components/Common/WcGrid/DataSources/WcServerSideDataSource.types.ts ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);



/***/ }),

/***/ "./src/components/Common/WcGrid/RowDataLitElementBase.ts":
/*!***************************************************************!*\
  !*** ./src/components/Common/WcGrid/RowDataLitElementBase.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   RowDataLitElementBase: () => (/* binding */ RowDataLitElementBase)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


class RowDataLitElementBase extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
    constructor() {
        super(...arguments);
        this.data = {};
        this.isDarkMode = false;
    }
}
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
], RowDataLitElementBase.prototype, "data", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
], RowDataLitElementBase.prototype, "isDarkMode", void 0);


/***/ }),

/***/ "./src/components/Common/WcGrid/WcAgGridWrapper.scss":
/*!***********************************************************!*\
  !*** ./src/components/Common/WcGrid/WcAgGridWrapper.scss ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  --grid-header-height: 60px;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  --webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  --sentiment-chip-padding: 8px;
  --sentiment-chip-negative-background: rgba(255, 232, 234, 1);
  --sentiment-chip-negative-color: rgba(171, 10, 21, 1);
  --sentiment-chip-neutral-background: rgba(222, 222, 222, 1);
  --sentiment-chip-neutral-color: rgba(0, 0, 0, 0.7);
  --sentiment-chip-positive-background: rgba(206, 245, 235, 1);
  --sentiment-chip-positive-color: rgba(24, 94, 70, 1);
  --visualizer-title-width: 100px;
  --visualizer-title-margin-left: 24px;
  --visualizer-container-max-height: 40px;
  --visualizer-container-max-width: 900px;
  --visualizer-container-gap: 16px;
  --visualizer-bar-max-width: 577px;
  --visualizer-bar-max-height: 4px;
  --player-controls-row-height: 50px;
  --player-controls-gap: 8px;
  --volume-popover-width: 180px;
  --volume-popover-height: 21px;
  --volume-popover-gap: 12px;
  --volume-popover-top-offset: 120%;
  --volume-popover-left-offset: 50%;
  --volume-popover-padding: 12px;
  --seek-bar-height: 8px;
  --seek-bar-thumb-size: 16px;
  --popover-arrow-size: 10px;
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  --interaction-details-height: 250px;
  --interaction-details-padding: 3px;
  --interaction-details-item-margin: 10px 0;
  --interaction-details-item-grid-template-columns: 150px auto;
  --webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

* {
  /* BASE LEVEL < 100 */
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-index-tpw-header: 1;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-index-task-collapse-area: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-navigation-bar: 12;
  --z-index-task-list: 12;
  --z-index-wrap-up: 13;
  --z-index-sticky-header: 14;
  --z-index-shortcutkey-modal: 15;
  /* MID LEVEL FLOATING > 100 < 1000 */
  --z-index-notification: 150;
  /* SUPER LEVEL > 1000 */
  --z-index-modal: 1040;
  --z-index-popover: 1041;
  --z-index-callback-modal: 1042;
  /* This below order needs to be unchanged. Highest priority is for connection loss overlay,
         followed by error modal since error can occur during app load such as teams failure/register failure. */
  --z-index-app-full-overlay: 1050;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1200;
}

:host {
  display: block;
  height: 100%;
  width: 100%;
  --grid-wrapper-h-padding: 12px;
  --grid-header-display: flex;
  --grid-cell-border-radius: 0px;
  --grid-focus-border-radius: 4px;
}

.ag-theme-alpine,
.ag-theme-alpine-dark {
  --ag-row-hover-color: var(--grid-row-hover-color, rgba(33, 150, 243, 0.1));
  --ag-header-cell-moving-background-color: var(--ag-row-hover-color);
  --ag-input-focus-border-color: transparent;
}

.grid-container {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  --grid-container-background-color: var(--md-glass-overlay-bg-color);
  background-color: var(--grid-container-background-color);
  border-radius: var(--grid-container-border-radius);
  padding-left: var(--grid-container-h-padding);
  padding-right: var(--grid-container-h-padding);
  padding-top: var(--grid-container-top-padding);
  --ag-row-hover-color: var(--grid-row-hover-color, rgba(33, 150, 243, 0.1));
  --ag-header-cell-moving-background-color: var(--ag-row-hover-color);
  --ag-text-color: var(--md-primary-text-color);
  --ag-subtle-text-color: var(--md-primary-text-color);
  --ag-drag-handle-color: var(--md-primary-text-color);
  --ag-input-background-color: var(--input-default-bg-color);
  --ag-input-text-color: var(--input-default-text-color);
  --ag-input-placeholder-text-color: var(--input-default-placeholder-color);
  --ag-input-border-radius: var(--input-border-radius);
  --ag-input-focus-text-color: var(--input-default-text-color);
  --ag-input-text-color: var(--input-default-text-color);
  --ag-checkbox-checked-shape-color: var(--checkbox-icon-color);
  --ag-checkbox-unchecked-background-color: var(--checkbox-bg-color);
  --ag-checkbox-unchecked-border-color: var(--checkbox-border-color);
  --ag-checkbox-checked-background-color: var(--checkbox-selected-bg-color);
  --ag-checkbox-checked-border-color: var(--checkbox-selected-border-color);
  --ag-checkbox-indeterminate-shape-color: var(--checkbox-icon-color);
  --ag-checkbox-indeterminate-background-color: var(--checkbox-selected-bg-color);
  --ag-checkbox-indeterminate-border-color: var(--checkbox-selected-border-color);
  --ag-picker-button-background-color: var(--combobox-bg-color);
  --ag-picker-button-focus-background-color: var(--combobox-focus-bg-color);
  --ag-picker-list-background-color: var(--combobox-bg-color);
  --md-tertiary-bg-color: transparent;
}
.grid-container.list-style {
  --grid-container-background-color: transparent;
  --grid-container-h-padding: 0px;
  --md-table-cell-border-bottom: none;
  --grid-container-top-padding: 0px;
  --grid-header-display: none;
  --md-glass-overlay-bg-color: transparent;
  --grid-cell-border-radius: 8px;
  --grid-focus-border-radius: 8px;
}
.grid-container .ag-overlay-wrapper {
  display: block;
}
.grid-container .ag-root-wrapper {
  border-right: 0px;
  border-left: 0px;
  border-bottom: 0px;
  border-color: var(--md-table-primary-bg-color);
  background-color: transparent;
}
.grid-container .ag-row {
  border-color: var(--md-table-primary-bg-color);
  border-bottom: var(--md-table-cell-border-bottom);
  z-index: 0;
}
.grid-container .ag-row,
.grid-container .ag-body-viewport {
  background-color: transparent;
}
.grid-container .ag-cell-focus {
  box-shadow: none;
  background-color: var(--list-hover-background);
  border-radius: var(--grid-cell-border-radius);
}
.grid-container .ag-row-hover {
  border-radius: var(--grid-cell-border-radius);
  overflow: hidden;
}
.grid-container .ag-cell {
  padding-left: var(--grid-wrapper-h-padding);
  padding-right: var(--grid-wrapper-h-padding);
}
.grid-container .ag-cell.ag-cell-focus:focus-within {
  outline: 2px solid var(--list-focus-border-color) !important;
  outline-offset: -2px;
  border-radius: var(--grid-focus-border-radius);
}
.grid-container .ag-ltr .ag-cell-focus:not(.ag-cell-range-selected):focus-within,
.grid-container .ag-ltr .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),
.grid-container .ag-ltr .ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group,
.grid-container .ag-ltr .ag-full-width-row.ag-full-width-focus:focus .ag-cell-wrapper.ag-row-group,
.grid-container .ag-ltr .ag-cell-range-single-cell,
.grid-container .ag-ltr .ag-cell-range-single-cell.ag-cell-range-handle,
.grid-container .ag-rtl .ag-cell-focus:not(.ag-cell-range-selected):focus-within,
.grid-container .ag-rtl .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),
.grid-container .ag-rtl .ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group,
.grid-container .ag-rtl .ag-full-width-row.ag-full-width-focus:focus .ag-cell-wrapper.ag-row-group,
.grid-container .ag-rtl .ag-cell-range-single-cell,
.grid-container .ag-rtl .ag-cell-range-single-cell.ag-cell-range-handle {
  border: none;
}
.grid-container .ag-cell,
.grid-container .ag-pinned-left-header,
.grid-container .ag-pinned-right-header,
.grid-container .ag-pinned-right-cols-container {
  color: var(--md-primary-text-color);
  border: none;
  border-width: 1px;
  border-right-style: solid;
  border-color: var(--md-table-column-divider-color) !important;
}
.grid-container .ag-header {
  z-index: var(--z-index-tpw-header);
  border: none;
  border-width: 1px;
  border-right-style: var(--md-table-border-style);
  border-bottom-style: solid;
  color: var(--md-primary-text-color);
  background-color: var(--md-table-header-bg-color);
  border-color: var(--md-table-header-border-bottom-color);
  display: var(--grid-header-display);
}
.grid-container.hide-header .ag-header {
  display: none;
}
.grid-container .ag-header-cell {
  padding-left: var(--grid-wrapper-h-padding);
  padding-right: var(--grid-wrapper-h-padding);
}
.grid-container .ag-header-cell.ag-header-active, .grid-container .ag-header-cell:focus {
  outline: 2px solid var(--list-focus-border-color) !important;
  outline-offset: -2px;
  border-radius: 4px;
}
.grid-container .ag-header-cell.ag-header-active::after, .grid-container .ag-header-cell:focus::after {
  border: none;
}
.grid-container .ag-header-cell-text {
  color: var(--md-table-header-text-color, var(--md-secondary-text-color));
  font-size: 14px;
  font-family: var(--brand-font-bold, "CiscoSansTT Regular"), sans-serif;
  font-weight: var(--brand-font-weight-bold, 100);
}
.grid-container .actions-cell {
  overflow: visible;
}
.grid-container .ag-row.ag-row-focus, .grid-container .ag-row.ag-full-width-focus {
  z-index: 1;
}
.grid-container .ag-full-width-focus {
  outline: 2px solid var(--list-focus-border-color) !important;
  outline-offset: -2px;
  border-radius: var(--grid-focus-border-radius);
}
.grid-container .ag-header-cell-resize {
  right: -5px;
}
.grid-container .ag-pinned-left-header .ag-header-cell-resize {
  right: -4px;
}
.grid-container .ag-header-cell-resize::after {
  height: 100%;
  top: 0;
  background-color: var(--md-table-primary-bg-color);
  width: 1px !important;
  box-shadow: none;
}
.grid-container .ag-pinned-right-header .ag-header-cell-resize::after {
  left: calc(50% - 1px);
  width: 2px !important;
}
.grid-container .ag-cell.ag-cell-last-left-pinned,
.grid-container .ag-pinned-left-header {
  border-width: 1px;
  right: 0px;
  left: auto !important;
}
.grid-container .ag-pinned-right-header {
  border-right: none;
}
.grid-container .ag-pinned-right-header,
.grid-container .ag-pinned-right-cols-container {
  border-left-style: solid;
  border-left-color: var(--md-table-pinned-border-color) !important;
  border-left-width: 1px;
  box-shadow: var(--pinned-column-elevation);
}
.grid-container .ag-pinned-right-header .ag-row,
.grid-container .ag-pinned-right-cols-container .ag-row {
  background-color: var(--md-table-pinned-bg-color);
}
.grid-container .ag-pinned-right-header .ag-row .ag-cell,
.grid-container .ag-pinned-right-cols-container .ag-row .ag-cell {
  border-left-style: none;
}
.grid-container .ag-pinned-right-header .ag-header-cell,
.grid-container .ag-pinned-right-cols-container .ag-header-cell {
  background-color: var(--pinned-column-header-bg-color);
}
.grid-container .ag-pinned-left-header,
.grid-container .ag-pinned-left-cols-container {
  border-right-style: solid;
  border-right-width: 1px;
  border-right-color: var(--md-table-pinned-border-color) !important;
  box-shadow: var(--pinned-column-elevation);
}
.grid-container .ag-pinned-left-header .ag-row,
.grid-container .ag-pinned-left-cols-container .ag-row {
  background-color: var(--md-table-pinned-bg-color);
}
.grid-container .ag-pinned-left-header .ag-row .ag-cell,
.grid-container .ag-pinned-left-cols-container .ag-row .ag-cell {
  border-right-style: none;
}
.grid-container .ag-pinned-left-header .ag-header-cell,
.grid-container .ag-pinned-left-cols-container .ag-header-cell {
  background-color: var(--pinned-column-header-bg-color);
}
.grid-container .ag-cell-expandable {
  font-weight: bold;
}
.grid-container .ag-row.ag-row-level-0.ag-full-width-row {
  background-color: var(--md-tertiary-bg-color);
}
.grid-container .ag-header-icon.ag-header-cell-menu-button {
  opacity: 1;
}
.grid-container div.ag-row {
  font-family: var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", sans-serif;
}
.grid-container .ag-theme-alpine .ag-menu-header,
.grid-container .ag-theme-alpine-dark .ag-menu-header {
  display: none;
}
.grid-container .ag-group-expanded,
.grid-container .ag-group-contracted {
  margin-right: 20px;
}
.grid-container .ag-menu {
  border-radius: var(--border-radius-medium);
  color: var(--md-primary-text-color);
  border-color: var(--md-menu-overlay-border-color);
  box-shadow: 0 1px 4px 1px var(--md-menu-overlay-border-color);
  margin-top: 25px;
  margin-left: 15px;
}
.grid-container .ag-header-icon {
  color: var(--md-secondary-text-color);
  padding-left: 8px;
}
.grid-container .ag-row.ag-row-level-0.ag-full-width-row .ag-row-group.ag-row-group-indent-0 {
  padding-left: 8px;
}
.grid-container .ag-row.ag-row-level-1.ag-full-width-row .ag-row-group.ag-row-group-indent-1 {
  padding-left: 8px;
}
.grid-container .ag-row.ag-row-level-2.ag-full-width-row .ag-row-group.ag-row-group-indent-2 {
  padding-left: 8px;
}
.grid-container .ag-row.ag-row-level-3.ag-full-width-row .ag-row-group.ag-row-group-indent-3 {
  padding-left: 8px;
}
.grid-container .ag-row.ag-row-level-4.ag-full-width-row .ag-row-group.ag-row-group-indent-4 {
  padding-left: 8px;
}
.grid-container .ag-row.ag-row-level-5.ag-full-width-row .ag-row-group.ag-row-group-indent-5 {
  padding-left: 8px;
}
.grid-container .ag-row.ag-row-level-6.ag-full-width-row .ag-row-group.ag-row-group-indent-6 {
  padding-left: 8px;
}
.grid-container .ag-row.ag-row-level-7.ag-full-width-row .ag-row-group.ag-row-group-indent-7 {
  padding-left: 8px;
}
.grid-container .ag-row.ag-row-level-8.ag-full-width-row .ag-row-group.ag-row-group-indent-8 {
  padding-left: 8px;
}
.grid-container .ag-row.ag-row-level-9.ag-full-width-row .ag-row-group.ag-row-group-indent-9 {
  padding-left: 8px;
}
.grid-container .ag-row.ag-row-level-10.ag-full-width-row .ag-row-group.ag-row-group-indent-10 {
  padding-left: 8px;
}
.grid-container .ag-row.ag-row-level-11.ag-full-width-row .ag-row-group.ag-row-group-indent-11 {
  padding-left: 8px;
}
.grid-container .ag-row.ag-row-level-12.ag-full-width-row .ag-row-group.ag-row-group-indent-12 {
  padding-left: 8px;
}
.grid-container .ag-row.ag-row-level-13.ag-full-width-row .ag-row-group.ag-row-group-indent-13 {
  padding-left: 8px;
}
.grid-container .ag-row.ag-row-level-14.ag-full-width-row .ag-row-group.ag-row-group-indent-14 {
  padding-left: 8px;
}
.grid-container .ag-row.ag-row-level-15.ag-full-width-row .ag-row-group.ag-row-group-indent-15 {
  padding-left: 8px;
}
.grid-container .ag-row.ag-row-level-16.ag-full-width-row .ag-row-group.ag-row-group-indent-16 {
  padding-left: 8px;
}
.grid-container .ag-row.ag-row-level-17.ag-full-width-row .ag-row-group.ag-row-group-indent-17 {
  padding-left: 8px;
}
.grid-container .ag-row.ag-row-level-18.ag-full-width-row .ag-row-group.ag-row-group-indent-18 {
  padding-left: 8px;
}
.grid-container .ag-row.ag-row-level-19.ag-full-width-row .ag-row-group.ag-row-group-indent-19 {
  padding-left: 8px;
}
.grid-container .ag-row.ag-row-level-1 div[role=gridcell][aria-colindex="1"],
.grid-container .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-container .ag-row.ag-row-level-2 div[role=gridcell][aria-colindex="1"],
.grid-container .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-container .ag-row.ag-row-level-3 div[role=gridcell][aria-colindex="1"],
.grid-container .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-container .ag-row.ag-row-level-4 div[role=gridcell][aria-colindex="1"],
.grid-container .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-container .ag-row.ag-row-level-5 div[role=gridcell][aria-colindex="1"],
.grid-container .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-container .ag-row.ag-row-level-6 div[role=gridcell][aria-colindex="1"],
.grid-container .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-container .ag-row.ag-row-level-7 div[role=gridcell][aria-colindex="1"],
.grid-container .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-container .ag-row.ag-row-level-8 div[role=gridcell][aria-colindex="1"],
.grid-container .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-container .ag-row.ag-row-level-9 div[role=gridcell][aria-colindex="1"],
.grid-container .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-container .ag-row.ag-row-level-10 div[role=gridcell][aria-colindex="1"],
.grid-container .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-container .ag-row.ag-row-level-11 div[role=gridcell][aria-colindex="1"],
.grid-container .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-container .ag-row.ag-row-level-12 div[role=gridcell][aria-colindex="1"],
.grid-container .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-container .ag-row.ag-row-level-13 div[role=gridcell][aria-colindex="1"],
.grid-container .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-container .ag-row.ag-row-level-14 div[role=gridcell][aria-colindex="1"],
.grid-container .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-container .ag-row.ag-row-level-15 div[role=gridcell][aria-colindex="1"],
.grid-container .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-container .ag-row.ag-row-level-16 div[role=gridcell][aria-colindex="1"],
.grid-container .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-container .ag-row.ag-row-level-17 div[role=gridcell][aria-colindex="1"],
.grid-container .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-container .ag-row.ag-row-level-18 div[role=gridcell][aria-colindex="1"],
.grid-container .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-container .ag-row.ag-row-level-19 div[role=gridcell][aria-colindex="1"],
.grid-container .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}

.channel-type-renderer {
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
}

.qmw-actions-cell {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin: 2px 0 0 6px;
  height: 100%;
}
.qmw-actions-cell .qmw-play-btn:focus {
  box-shadow: 0 0 0 0.125rem var(--button-focus-ring-color, #007aa3);
  border-radius: 2px;
}

.cell-renderer {
  width: 100%;
  height: 100%;
}

.listitem-cell-renderer {
  width: 100%;
  height: 100%;
  display: flex;
}

.ag-side-buttons,
.ag-tool-panel-horizontal-resize {
  display: none;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Common/WcGrid/WcAgGridWrapper.ts":
/*!*********************************************************!*\
  !*** ./src/components/Common/WcGrid/WcAgGridWrapper.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ToolPanelType: () => (/* binding */ ToolPanelType),
/* harmony export */   WcAgGridWrapper: () => (/* binding */ WcAgGridWrapper)
/* harmony export */ });
/* harmony import */ var _components_Common_CellRenderers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/CellRenderers */ "./src/components/Common/CellRenderers/index.ts");
/* harmony import */ var _components_Common_Utils_GridUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/components/Common/Utils/GridUtils */ "./src/components/Common/Utils/GridUtils.ts");
/* harmony import */ var _components_InteractionsTab__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/components/InteractionsTab */ "./src/components/InteractionsTab/index.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ag-grid-enterprise */ "ag-grid-enterprise");
/* harmony import */ var ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _CellRenderers_FullWidthRowCellRenderer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./CellRenderers/FullWidthRowCellRenderer */ "./src/components/Common/WcGrid/CellRenderers/FullWidthRowCellRenderer.ts");
/* harmony import */ var _DataSources_WcServerSideDataSource__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./DataSources/WcServerSideDataSource */ "./src/components/Common/WcGrid/DataSources/WcServerSideDataSource.ts");
/* harmony import */ var _WcAgGridWrapper_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./WcAgGridWrapper.scss */ "./src/components/Common/WcGrid/WcAgGridWrapper.scss");
/* harmony import */ var _WcGrid_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./WcGrid.types */ "./src/components/Common/WcGrid/WcGrid.types.ts");
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! mobx */ "mobx");
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(mobx__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _WcGridIntegratedChart__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./WcGridIntegratedChart */ "./src/components/Common/WcGrid/WcGridIntegratedChart.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};











//'observe' ties in perfectly with AGGrid's applyTransactionAsync API compared to reaction/autorun
//eslint-disable-next-line @typescript-eslint/no-restricted-imports


var ToolPanelType;
(function (ToolPanelType) {
    ToolPanelType["Columns"] = "columns";
    ToolPanelType["Filters"] = "filters";
})(ToolPanelType || (ToolPanelType = {}));
let WcAgGridWrapper = class WcAgGridWrapper extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_5__.LitElement) {
    constructor() {
        super();
        this.isDarkMode = false;
        this.isListView = false;
        this.wcColumnDefs = [];
        (0,_components_Common_Utils_GridUtils__WEBPACK_IMPORTED_MODULE_1__.initializeGlobalGridProperties)();
    }
    connectedCallback() {
        super.connectedCallback();
        this.createGridOptions();
        if (this.rowData && (0,mobx__WEBPACK_IMPORTED_MODULE_11__.isObservable)(this.rowData)) {
            this.observerDisposer = (0,mobx__WEBPACK_IMPORTED_MODULE_11__.observe)(this.rowData, (change) => {
                this.applyGridTransaction(this.gridApi, change);
            });
        }
    }
    createGridOptions() {
        var _a, _b, _c, _d;
        if (!this.wcGridConfig) {
            return;
        }
        this.gridOptions = this.wcGridConfig.toAgGridConfig();
        if (this.gridOptions.enableCharts) {
            (0,_components_Common_Utils_GridUtils__WEBPACK_IMPORTED_MODULE_1__.registerAgGridChartsModule)();
        }
        this.gridOptions.onGridReady = () => {
            this.onGridReady();
        };
        this.gridOptions.onModelUpdated = () => {
            this.fireDisplayedRowCountChangedEvent();
        };
        this.gridOptions.components = {
            actionButtonsRenderer: _components_Common_CellRenderers__WEBPACK_IMPORTED_MODULE_0__.ActionButtonsCellRenderer,
            agentNameRenderer: _components_Common_CellRenderers__WEBPACK_IMPORTED_MODULE_0__.AgentNameCellRenderer,
            durationRenderer: _components_Common_CellRenderers__WEBPACK_IMPORTED_MODULE_0__.DurationCellRenderer,
            channelRenderer: _components_Common_CellRenderers__WEBPACK_IMPORTED_MODULE_0__.ChannelCellRenderer,
            interactionsListItemRenderer: _components_Common_CellRenderers__WEBPACK_IMPORTED_MODULE_0__.InteractionsListItemCellRenderer,
            queueStatsListItemRenderer: _components_Common_CellRenderers__WEBPACK_IMPORTED_MODULE_0__.QueueStatsListItemCellRenderer,
            sentimentRenderer: _components_Common_CellRenderers__WEBPACK_IMPORTED_MODULE_0__.SentimentCellRenderer
        };
        this.gridOptions.defaultColDef = {
            resizable: true,
            sortable: true,
            flex: 1,
            minWidth: 200
        };
        const agGridColDef = [];
        this.wcColumnDefs.forEach((column) => {
            agGridColDef.push(column.toAgGridColDef());
        });
        this.gridOptions.columnDefs = agGridColDef;
        if (this.wcGridConfig.saveGridStateEnabled()) {
            this.gridOptions.onStateUpdated = (event) => {
                this.onStateUpdated(event);
            };
        }
        // Load grid state from local storage if it exists and saveGridState is true
        const cacheKey = this.wcGridConfig.getTableName();
        if (this.wcGridConfig.saveGridStateEnabled() && cacheKey !== "") {
            const cache = (_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem(cacheKey);
            if (cache) {
                this.gridOptions.initialState = JSON.parse(cache);
            }
        }
        if (this.wcGridConfig.serverSideRowModel && this.wcGridConfig.fetchServerRows) {
            this.gridOptions.serverSideDatasource = new _DataSources_WcServerSideDataSource__WEBPACK_IMPORTED_MODULE_8__.WcGridServerSideDataSource(this.wcGridConfig.fetchServerRows);
        }
        if (this.wcGridConfig.getListConfig()) {
            this.gridOptions.isFullWidthRow = () => {
                return this.isListView;
            };
            this.gridOptions.fullWidthCellRenderer = _CellRenderers_FullWidthRowCellRenderer__WEBPACK_IMPORTED_MODULE_7__.FullWidthRowCellRenderer;
            this.gridOptions.fullWidthCellRendererParams = {
                componentName: (_b = this.wcGridConfig.getListConfig()) === null || _b === void 0 ? void 0 : _b.fullWidthRowComponent
            };
            if (this.isListView) {
                this.gridOptions.rowHeight = (_d = (_c = this.wcGridConfig.getListConfig()) === null || _c === void 0 ? void 0 : _c.rowHeight) !== null && _d !== void 0 ? _d : 80;
            }
            else {
                this.gridOptions.rowHeight = 40;
            }
        }
        this.gridOptions.theme = ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_4__.themeAlpine.withParams({
            sideBarBackgroundColor: "transparent",
            chromeBackgroundColor: "transparent"
        });
        if (this.wcGridConfig.getCellSelection()) {
            this.gridOptions.getContextMenuItems = () => {
                return ["copy", "copyWithHeaders"];
            };
        }
        else {
            this.gridOptions.getContextMenuItems = () => {
                return [];
            };
        }
    }
    applyGridTransaction(api, change) {
        if (!api) {
            return;
        }
        switch (change.type) {
            case "add":
                api.applyTransactionAsync({ add: [change.newValue], remove: [], update: [] });
                break;
            case "update":
                api.applyTransactionAsync({ add: [], remove: [], update: [change.newValue] });
                break;
            case "delete":
                api.applyTransactionAsync({ add: [], remove: [change.oldValue], update: [] });
                break;
        }
    }
    fireDisplayedRowCountChangedEvent() {
        var _a;
        const rowCount = ((_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.getDisplayedRowCount()) || 0;
        this.dispatchEvent(new CustomEvent("displayed-row-count-changed", {
            detail: {
                count: rowCount
            },
            bubbles: true,
            composed: true
        }));
    }
    onGridReady() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.rowData) {
                return;
            }
            (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.setGridOption("rowData", Array.from(this.rowData.values()));
        });
    }
    static get styles() {
        return [_WcAgGridWrapper_scss__WEBPACK_IMPORTED_MODULE_9__["default"]];
    }
    onStateUpdated(event) {
        var _a;
        if (!this.wcGridConfig) {
            return;
        }
        const cacheKey = this.wcGridConfig.getTableName();
        if (this.wcGridConfig.saveGridStateEnabled() && cacheKey !== "") {
            (_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.setItem(cacheKey, JSON.stringify(event.state));
        }
    }
    initializeGrid() {
        var _a, _b;
        if (!this.gridOptions) {
            return;
        }
        this.gridApi = (0,ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_4__.createGrid)(this.gridDiv, this.gridOptions);
        if (this.gridApiCallback) {
            this.gridApiCallback(this.gridApi);
        }
        if (this.gridApi && this.gridOptions.enableCharts) {
            this.wcIntegratedChart = new _WcGridIntegratedChart__WEBPACK_IMPORTED_MODULE_12__.WcGridIntegratedChart(this.wcColumnDefs, this.gridApi);
        }
        // only listen for row click events if the grid can be collapsed
        if ((_a = this.wcGridConfig) === null || _a === void 0 ? void 0 : _a.getListConfig()) {
            this.addEventListener("view-selection-details", (event) => {
                var _a, _b;
                event.stopPropagation();
                if (event instanceof CustomEvent && ((_a = event.detail) === null || _a === void 0 ? void 0 : _a.rowId) && ((_b = event.detail) === null || _b === void 0 ? void 0 : _b.option)) {
                    const rowId = event.detail.rowId;
                    const option = event.detail.option;
                    // Don't include the data when the event leaves the WcGrid
                    this.dispatchEvent(new CustomEvent("view-event-clicked", {
                        bubbles: true,
                        composed: true,
                        detail: { rowId, option }
                    }));
                }
                this.onViewSelectionDetails(event);
            });
            if (((_b = this.wcGridConfig.getListConfig()) === null || _b === void 0 ? void 0 : _b.rowClickEnabled) || this.isListView) {
                this.gridApi.addEventListener("rowClicked", (event) => {
                    var _a, _b;
                    this.rowSelected((_b = (_a = event.node) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : "", event.data);
                });
            }
        }
    }
    onViewSelectionDetails(event) {
        var _a;
        event.stopPropagation();
        if (event instanceof CustomEvent && ((_a = event.detail) === null || _a === void 0 ? void 0 : _a.data)) {
            this.rowSelected(event.detail.rowId, event.detail.data);
        }
    }
    rowSelected(id, data) {
        this.dispatchEvent(new CustomEvent("row-clicked", {
            detail: {
                id,
                data
            },
            bubbles: true,
            composed: true
        }));
    }
    refreshIntegratedWcChart(event) {
        if (this.wcIntegratedChart && event) {
            this.wcIntegratedChart.refreshIntegratedChart(event);
        }
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.destroy();
        this.removeEventListener("view-selection-details", this.onViewSelectionDetails);
    }
    updated(changedProperties) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        super.updated(changedProperties);
        if (changedProperties.has("gridOptions")) {
            (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.destroy();
            if (this.gridOptions) {
                this.initializeGrid();
            }
        }
        else if (changedProperties.has("isListView")) {
            const rowHeight = this.isListView ? ((_d = (_c = (_b = this.wcGridConfig) === null || _b === void 0 ? void 0 : _b.getListConfig()) === null || _c === void 0 ? void 0 : _c.rowHeight) !== null && _d !== void 0 ? _d : 80) : 40;
            (_e = this.gridApi) === null || _e === void 0 ? void 0 : _e.setGridOption("rowHeight", rowHeight);
            (_f = this.gridApi) === null || _f === void 0 ? void 0 : _f.redrawRows();
        }
        else if (changedProperties.has("rowData") && this.rowData) {
            const initialRowData = Array.from((_h = (_g = this.rowData) === null || _g === void 0 ? void 0 : _g.values()) !== null && _h !== void 0 ? _h : []);
            (_j = this.gridApi) === null || _j === void 0 ? void 0 : _j.setGridOption("rowData", initialRowData);
            if (this.observerDisposer) {
                this.observerDisposer();
            }
            if ((0,mobx__WEBPACK_IMPORTED_MODULE_11__.isObservable)(this.rowData)) {
                this.observerDisposer = (0,mobx__WEBPACK_IMPORTED_MODULE_11__.observe)(this.rowData, (change) => {
                    this.applyGridTransaction(this.gridApi, change);
                });
            }
        }
    }
    get agGridLinkTemplate() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `<link href="/css/momentum-ui-icons.min.css" rel="stylesheet" />
      <link href="/css/momentum-ui.min.css" rel="stylesheet" />`;
    }
    resetWcGrid() {
        var _a;
        if (!this.wcGridConfig) {
            return;
        }
        // delete the config from local storage
        const cacheKey = this.wcGridConfig.getTableName();
        if (this.wcGridConfig.saveGridStateEnabled() && cacheKey !== "") {
            (_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.removeItem(cacheKey);
        }
        // re-create the grid options after deleting the cache
        this.createGridOptions();
    }
    toggleToolPanel(toolPanel) {
        const gridApi = this.gridApi;
        if (gridApi) {
            const openToolPanel = gridApi.getOpenedToolPanel();
            if (openToolPanel === toolPanel) {
                gridApi.closeToolPanel();
            }
            else {
                gridApi.openToolPanel(toolPanel);
            }
        }
    }
    get gridContainerClassMap() {
        return {
            "grid-container": true,
            "ag-theme-alpine": !this.isDarkMode,
            "ag-theme-alpine-dark": this.isDarkMode,
            "hide-header": this.isListView,
            "ag-row": !this.isListView,
            "ag-row-focus": this.isListView,
            "list-style": this.isListView
        };
    }
    exportGridData(exportType) {
        var _a, _b;
        if (!this.wcGridConfig) {
            return;
        }
        const fileName = `${this.wcGridConfig.getTableName()}_${new Date(Date.now()).toString()}`;
        const sheetName = this.wcGridConfig.getTableName();
        switch (exportType) {
            case _WcGrid_types__WEBPACK_IMPORTED_MODULE_10__.WcGridExportType.CSV:
                (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.exportDataAsCsv({ fileName });
                break;
            case _WcGrid_types__WEBPACK_IMPORTED_MODULE_10__.WcGridExportType.EXCEL:
                (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.exportDataAsExcel({ fileName, sheetName });
                break;
        }
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
      ${this.agGridLinkTemplate}
      <div
        data-testid="wc-grid"
        class=${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_6__.classMap)(this.gridContainerClassMap)}
        @wc-chart-columnn=${(e) => this.refreshIntegratedWcChart(e)}
      ></div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.query)(".grid-container")
], WcAgGridWrapper.prototype, "gridDiv", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
], WcAgGridWrapper.prototype, "isDarkMode", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
], WcAgGridWrapper.prototype, "isListView", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Object })
], WcAgGridWrapper.prototype, "wcGridConfig", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Array })
], WcAgGridWrapper.prototype, "wcColumnDefs", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Object, attribute: false })
], WcAgGridWrapper.prototype, "rowData", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Object, attribute: false })
], WcAgGridWrapper.prototype, "gridApiCallback", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], WcAgGridWrapper.prototype, "gridApi", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], WcAgGridWrapper.prototype, "gridOptions", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], WcAgGridWrapper.prototype, "wcIntegratedChart", void 0);
WcAgGridWrapper = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.customElement)("wc-ag-grid-wrapper")
], WcAgGridWrapper);



/***/ }),

/***/ "./src/components/Common/WcGrid/WcColumns/ActionsButtonsColumn.ts":
/*!************************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcColumns/ActionsButtonsColumn.ts ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ActionsButtonsColumn: () => (/* binding */ ActionsButtonsColumn),
/* harmony export */   getViewButtonConfig: () => (/* binding */ getViewButtonConfig)
/* harmony export */ });
/* harmony import */ var _components_Common_WcGrid_CellRenderers_WcGridCellRenderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/WcGrid/CellRenderers/WcGridCellRenderer */ "./src/components/Common/WcGrid/CellRenderers/WcGridCellRenderer.ts");
/* harmony import */ var _WcGridColumn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./WcGridColumn */ "./src/components/Common/WcGrid/WcColumns/WcGridColumn.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");



const getViewButtonConfig = () => ({
    id: "viewButton",
    icon: "view-list-filled",
    ariaLabel: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:common.view"),
    eventName: "view-selection-details"
});
function updateProperties(actionsWidget, params) {
    const rowId = params.node.id;
    const data = params.data;
    actionsWidget.buttons = params.buttons.map((button) => ({
        id: button.id,
        icon: button.icon,
        options: button.options,
        ariaLabel: button.ariaLabel,
        onClick: (option) => {
            actionsWidget.dispatchEvent(new CustomEvent(button.eventName, {
                composed: true,
                bubbles: true,
                detail: { rowId, option, data }
            }));
        }
    }));
}
function createCellRenderer() {
    return (0,_components_Common_WcGrid_CellRenderers_WcGridCellRenderer__WEBPACK_IMPORTED_MODULE_0__.createWcGridCellRendererClass)("agentx-wc-table-action-buttons", (actionsWidget, params) => updateProperties(actionsWidget, params));
}
class ActionsButtonsColumn extends _WcGridColumn__WEBPACK_IMPORTED_MODULE_1__.WcGridColumn {
    constructor(columnTitle, fieldName, buttonConfigs) {
        super(columnTitle, fieldName);
        this.buttonConfigs = [];
        this.buttonConfigs = buttonConfigs;
    }
    getExtendedColDef() {
        return {
            cellRenderer: createCellRenderer(),
            cellRendererParams: {
                buttons: this.buttonConfigs
            },
            filter: false,
            sortable: false
        };
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/WcColumns/AgentNameColumn.ts":
/*!*******************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcColumns/AgentNameColumn.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AgentNameColumn: () => (/* binding */ AgentNameColumn)
/* harmony export */ });
/* harmony import */ var _components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/CellRenderers/Utils */ "./src/components/Common/CellRenderers/Utils.ts");
/* harmony import */ var _CellRenderers_WcGridCellRenderer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../CellRenderers/WcGridCellRenderer */ "./src/components/Common/WcGrid/CellRenderers/WcGridCellRenderer.ts");
/* harmony import */ var _WcGridColumn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./WcGridColumn */ "./src/components/Common/WcGrid/WcColumns/WcGridColumn.ts");



const updateProperties = (agentNameElement, params) => {
    if (!params.data) {
        return;
    }
    agentNameElement.name = params.data.agentName;
    agentNameElement.email = params.data.agentEmail;
};
const AgentCellRenderer = (0,_CellRenderers_WcGridCellRenderer__WEBPACK_IMPORTED_MODULE_1__.createWcGridCellRendererClass)("agentx-wc-table-agent-name", updateProperties);
class AgentNameColumn extends _WcGridColumn__WEBPACK_IMPORTED_MODULE_2__.WcGridColumn {
    constructor(columnTitle, fieldName) {
        super(columnTitle, fieldName);
    }
    getExtendedColDef() {
        return {
            cellRenderer: AgentCellRenderer,
            filter: "agTextColumnFilter",
            comparator: _components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_0__.naturalStringComparator
        };
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/WcColumns/AnomaliesColumn.ts":
/*!*******************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcColumns/AnomaliesColumn.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AnomaliesColumn: () => (/* binding */ AnomaliesColumn)
/* harmony export */ });
/* harmony import */ var _CellComponents_AnomaliesCellComponent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../CellComponents/AnomaliesCellComponent */ "./src/components/Common/WcGrid/CellComponents/AnomaliesCellComponent.ts");
/* harmony import */ var _CellRenderers_WcGridCellRenderer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../CellRenderers/WcGridCellRenderer */ "./src/components/Common/WcGrid/CellRenderers/WcGridCellRenderer.ts");
/* harmony import */ var _WcGridColumn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./WcGridColumn */ "./src/components/Common/WcGrid/WcColumns/WcGridColumn.ts");



function getAnomalies(params) {
    var _a;
    if (!((_a = params.colDef) === null || _a === void 0 ? void 0 : _a.field)) {
        return [];
    }
    return (params.data[params.colDef.field] || []).filter((anomaly) => anomaly.isAnomaly === true);
}
function updateProperties(anomaliesCellWidget, params) {
    anomaliesCellWidget.anomalies = getAnomalies(params);
}
const AnomaliesCellRenderer = (0,_CellRenderers_WcGridCellRenderer__WEBPACK_IMPORTED_MODULE_1__.createWcGridCellRendererClass)("agentx-wc-anomalies-cell", updateProperties);
class AnomaliesColumn extends _WcGridColumn__WEBPACK_IMPORTED_MODULE_2__.WcGridColumn {
    constructor(columnTitle, fieldName) {
        super(columnTitle, fieldName);
    }
    getExtendedColDef() {
        return {
            cellRenderer: AnomaliesCellRenderer,
            filter: "agNumberColumnFilter",
            valueGetter: (params) => this.anomalyCountValueGetter(params)
        };
    }
    anomalyCountValueGetter(params) {
        return getAnomalies(params).length;
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/WcColumns/ChannelColumn.ts":
/*!*****************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcColumns/ChannelColumn.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ChannelColumn: () => (/* binding */ ChannelColumn),
/* harmony export */   channelValueFormatter: () => (/* binding */ channelValueFormatter),
/* harmony export */   channelValueGetter: () => (/* binding */ channelValueGetter)
/* harmony export */ });
/* harmony import */ var _components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/CellRenderers/Utils */ "./src/components/Common/CellRenderers/Utils.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _CellRenderers_constants_channel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../CellRenderers/constants/channel */ "./src/components/Common/CellRenderers/constants/channel.ts");
/* harmony import */ var _CellRenderers_constants_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../CellRenderers/constants/types */ "./src/components/Common/CellRenderers/constants/types.ts");
/* harmony import */ var _CellRenderers_WcGridCellRenderer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../CellRenderers/WcGridCellRenderer */ "./src/components/Common/WcGrid/CellRenderers/WcGridCellRenderer.ts");
/* harmony import */ var _WcGridColumn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./WcGridColumn */ "./src/components/Common/WcGrid/WcColumns/WcGridColumn.ts");






function getMappedIcon(channelType, channelSubType) {
    return channelType === _CellRenderers_constants_types__WEBPACK_IMPORTED_MODULE_3__.ChannelTypes.Social && channelSubType
        ? (0,_components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_0__.getChannelAvatarType)(channelSubType)
        : (0,_components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_0__.getChannelAvatarType)(channelType);
}
const updateProperties = (channelElement, params) => {
    var _a, _b;
    if (!params.data) {
        return;
    }
    const channelType = (_a = params.data.channelType) !== null && _a !== void 0 ? _a : undefined;
    const channelSubType = (_b = params.data.channelSubType) !== null && _b !== void 0 ? _b : undefined;
    channelElement.channelType = getMappedIcon(channelType, channelSubType);
};
const ChannelCellRenderer = (0,_CellRenderers_WcGridCellRenderer__WEBPACK_IMPORTED_MODULE_4__.createWcGridCellRendererClass)("agentx-wc-table-channel", updateProperties);
function channelValueGetter(params) {
    var _a, _b;
    const channelType = (_a = params.data[params.colDef.field]) !== null && _a !== void 0 ? _a : "";
    const channelSubType = (_b = params.data["channelSubType"]) !== null && _b !== void 0 ? _b : "";
    const type = channelType === _CellRenderers_constants_types__WEBPACK_IMPORTED_MODULE_3__.ChannelTypes.Social ? channelSubType : channelType;
    const value = (0,_components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_0__.getChannelAvatarType)(type);
    return {
        channelType: value
    };
}
function channelValueFormatter(params) {
    var _a, _b;
    const channelType = (_a = params.data[params.colDef.field]) !== null && _a !== void 0 ? _a : "";
    const channelSubType = (_b = params.data["channelSubType"]) !== null && _b !== void 0 ? _b : "";
    const type = channelType === _CellRenderers_constants_types__WEBPACK_IMPORTED_MODULE_3__.ChannelTypes.Social ? channelSubType : channelType;
    const translationId = (0,_components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_0__.getAvatarAriaTranslationId)(_CellRenderers_constants_channel__WEBPACK_IMPORTED_MODULE_2__.CHANNEL_TYPE_TO_ICON_MAP[type]);
    return translationId ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(translationId) : "";
}
class ChannelColumn extends _WcGridColumn__WEBPACK_IMPORTED_MODULE_5__.WcGridColumn {
    constructor(columnTitle, fieldName) {
        super(columnTitle, fieldName);
    }
    getExtendedColDef() {
        return {
            cellRenderer: ChannelCellRenderer,
            filter: "agTextColumnFilter",
            comparator: _components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_0__.channelComparator,
            useValueFormatterForExport: true,
            valueGetter: channelValueGetter,
            valueFormatter: channelValueFormatter
        };
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/WcColumns/DurationColumn.ts":
/*!******************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcColumns/DurationColumn.ts ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DurationColumn: () => (/* binding */ DurationColumn)
/* harmony export */ });
/* harmony import */ var _WcGridColumn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./WcGridColumn */ "./src/components/Common/WcGrid/WcColumns/WcGridColumn.ts");
/* harmony import */ var _CellRenderers_Formatters_DurationFormatter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../CellRenderers/Formatters/DurationFormatter */ "./src/components/Common/CellRenderers/Formatters/DurationFormatter.ts");
/* harmony import */ var _CellRenderers_WcGridCellRenderer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../CellRenderers/WcGridCellRenderer */ "./src/components/Common/WcGrid/CellRenderers/WcGridCellRenderer.ts");



const updateProperties = (durationWidget, params) => {
    var _a, _b, _c, _d;
    if (!((_a = params.colDef) === null || _a === void 0 ? void 0 : _a.field)) {
        return;
    }
    durationWidget.duration = params.data[(_b = params.colDef) === null || _b === void 0 ? void 0 : _b.field].duration;
    durationWidget.createdTime = params.data[(_c = params.colDef) === null || _c === void 0 ? void 0 : _c.field].createdTime;
    durationWidget.isActive = params.data[(_d = params.colDef) === null || _d === void 0 ? void 0 : _d.field].isActive;
};
const DurationCellRenderer = (0,_CellRenderers_WcGridCellRenderer__WEBPACK_IMPORTED_MODULE_2__.createWcGridCellRendererClass)("agentx-wc-table-duration", updateProperties);
class DurationColumn extends _WcGridColumn__WEBPACK_IMPORTED_MODULE_0__.WcGridColumn {
    constructor(columnTitle, fieldName) {
        super(columnTitle, fieldName);
    }
    getExtendedColDef() {
        return {
            cellRenderer: DurationCellRenderer,
            filter: "agNumberColumnFilter",
            valueGetter: this.durationValueGetter
        };
    }
    durationValueGetter(params) {
        var _a;
        const fieldName = params.column.getColDef().field;
        if (fieldName) {
            return (_a = params.data[fieldName].duration) !== null && _a !== void 0 ? _a : "";
        }
        return "";
    }
    getChartAxisLabelFormatter() {
        return (params) => {
            return (0,_CellRenderers_Formatters_DurationFormatter__WEBPACK_IMPORTED_MODULE_1__.formatDuration)(Number(params.value));
        };
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/WcColumns/NumberColumn.ts":
/*!****************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcColumns/NumberColumn.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NumberColumn: () => (/* binding */ NumberColumn)
/* harmony export */ });
/* harmony import */ var _WcGridColumn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./WcGridColumn */ "./src/components/Common/WcGrid/WcColumns/WcGridColumn.ts");

class NumberColumn extends _WcGridColumn__WEBPACK_IMPORTED_MODULE_0__.WcGridColumn {
    constructor(columnTitle, fieldName, precision = 0) {
        super(columnTitle, fieldName);
        this.precision = 0;
        this.precision = precision;
    }
    getExtendedColDef() {
        return {
            filter: "agNumberColumnFilter",
            valueFormatter: (params) => this.numberFormatter(params)
        };
    }
    numberFormatter(params) {
        const value = Number(params.value);
        if (isNaN(value)) {
            return "";
        }
        return value.toFixed(this.precision);
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/WcColumns/PercentColumn.ts":
/*!*****************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcColumns/PercentColumn.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PercentColumn: () => (/* binding */ PercentColumn)
/* harmony export */ });
/* harmony import */ var _WcGridColumn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./WcGridColumn */ "./src/components/Common/WcGrid/WcColumns/WcGridColumn.ts");
/* harmony import */ var _CellRenderers_Formatters_PercentageFormatter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../CellRenderers/Formatters/PercentageFormatter */ "./src/components/Common/CellRenderers/Formatters/PercentageFormatter.ts");


class PercentColumn extends _WcGridColumn__WEBPACK_IMPORTED_MODULE_0__.WcGridColumn {
    getExtendedColDef() {
        return {
            filter: "agNumberColumnFilter",
            valueFormatter: (params) => this.percentFormatter(params)
        };
    }
    percentFormatter(params) {
        return (0,_CellRenderers_Formatters_PercentageFormatter__WEBPACK_IMPORTED_MODULE_1__.formatPercentage)(params.value.ratio);
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/WcColumns/StringColumn.ts":
/*!****************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcColumns/StringColumn.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   StringColumn: () => (/* binding */ StringColumn)
/* harmony export */ });
/* harmony import */ var _WcGridColumn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./WcGridColumn */ "./src/components/Common/WcGrid/WcColumns/WcGridColumn.ts");

class StringColumn extends _WcGridColumn__WEBPACK_IMPORTED_MODULE_0__.WcGridColumn {
    getExtendedColDef() {
        return {
            filter: "agTextColumnFilter"
        };
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/WcColumns/WcChartConfig.ts":
/*!*****************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcColumns/WcChartConfig.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WcChartConfig: () => (/* binding */ WcChartConfig)
/* harmony export */ });
/* harmony import */ var _WcGridIntegratedChart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../WcGridIntegratedChart */ "./src/components/Common/WcGrid/WcGridIntegratedChart.ts");

class WcChartConfig {
    constructor(params) {
        var _a, _b;
        this.isChartingEnabled = false;
        this.chartDataType = _WcGridIntegratedChart__WEBPACK_IMPORTED_MODULE_0__.ColumnChartDataType.Excluded;
        this.isPrimaryAxisInChart = false;
        this.isTeamAverageDataColumn = false;
        this.chartDataType = params.chartDataType;
        this.isChartingEnabled = params.chartDataType !== _WcGridIntegratedChart__WEBPACK_IMPORTED_MODULE_0__.ColumnChartDataType.Excluded;
        this.isPrimaryAxisInChart = (_a = params.isPrimaryAxisInChart) !== null && _a !== void 0 ? _a : false;
        this.isTeamAverageDataColumn = (_b = params.isTeamAverageDataColumn) !== null && _b !== void 0 ? _b : false;
    }
    getIsChartingEnabled() {
        return this.isChartingEnabled;
    }
    getIsPrimaryAxisInChart() {
        return this.isPrimaryAxisInChart;
    }
    getIsTeamAverageDataColumn() {
        return this.isTeamAverageDataColumn;
    }
    getChartAxisLabelFormatter() {
        return undefined; // Default implementation, can be overridden
    }
    getColumnChartDataType() {
        return this.chartDataType;
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/WcColumns/WcColumnInnerHeader.scss":
/*!*************************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcColumns/WcColumnInnerHeader.scss ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.chart-button-container {
  padding: 5px;
  min-height: 20px;
  align-items: center;
}

.ag-header-cell-text {
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
}

.ag-header-cell-text-content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0NvbW1vbi9XY0dyaWQvV2NDb2x1bW5zL1djQ29sdW1uSW5uZXJIZWFkZXIuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLFlBQUE7RUFDQSxnQkFBQTtFQUNBLG1CQUFBO0FBQ0Y7O0FBRUE7RUFDRSx1QkFBQTtFQUNBLGFBQUE7RUFDQSxtQkFBQTtBQUNGOztBQUVBO0VBQ0UsZ0JBQUE7RUFDQSx1QkFBQTtFQUNBLG1CQUFBO0FBQ0YiLCJzb3VyY2VzQ29udGVudCI6WyIuY2hhcnQtYnV0dG9uLWNvbnRhaW5lciB7XG4gIHBhZGRpbmc6IDVweDtcbiAgbWluLWhlaWdodDogMjBweDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbn1cblxuLmFnLWhlYWRlci1jZWxsLXRleHQge1xuICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpcztcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbn1cblxuLmFnLWhlYWRlci1jZWxsLXRleHQtY29udGVudCB7XG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIHRleHQtb3ZlcmZsb3c6IGVsbGlwc2lzO1xuICB3aGl0ZS1zcGFjZTogbm93cmFwO1xufVxuIl0sInNvdXJjZVJvb3QiOiIifQ== */`);
    

/***/ }),

/***/ "./src/components/Common/WcGrid/WcColumns/WcColumnInnerHeader.ts":
/*!***********************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcColumns/WcColumnInnerHeader.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WcColumnInnerHeader: () => (/* binding */ WcColumnInnerHeader)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _WcColumnInnerHeader_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./WcColumnInnerHeader.scss */ "./src/components/Common/WcGrid/WcColumns/WcColumnInnerHeader.scss");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let WcColumnInnerHeader = class WcColumnInnerHeader extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement) {
    static get styles() {
        return [_WcColumnInnerHeader_scss__WEBPACK_IMPORTED_MODULE_1__["default"]];
    }
    onChartButtonClicked(event) {
        var _a, _b;
        event.stopPropagation();
        const customEvent = new CustomEvent("wc-chart-column", {
            detail: {
                columns: [(_b = (_a = this.params) === null || _a === void 0 ? void 0 : _a.chartButton) === null || _b === void 0 ? void 0 : _b.columnField]
            },
            bubbles: true,
            composed: true
        });
        this.dispatchEvent(customEvent);
    }
    render() {
        var _a;
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
      <div class="ag-header-cell-text">
        ${((_a = this.params) === null || _a === void 0 ? void 0 : _a.chartButton)
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
              <span class="chart-button-container">
                <md-button class="chart-button" @click="${this.onChartButtonClicked}" size="20" circle>
                  <md-icon name="add-poll-regular" iconSet="momentumDesign"></md-icon>
                </md-button>
              </span>
            `
            : null}
        <span class="ag-header-cell-text-content">${this.params.displayName}</span>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Object })
], WcColumnInnerHeader.prototype, "params", void 0);
WcColumnInnerHeader = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("wc-grid-column-inner-header")
], WcColumnInnerHeader);



/***/ }),

/***/ "./src/components/Common/WcGrid/WcColumns/WcColumnInnerHeaderRenderer.ts":
/*!*******************************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcColumns/WcColumnInnerHeaderRenderer.ts ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WcColumnInnerHeaderRenderer: () => (/* binding */ WcColumnInnerHeaderRenderer)
/* harmony export */ });
/* harmony import */ var _WcColumnInnerHeader__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./WcColumnInnerHeader */ "./src/components/Common/WcGrid/WcColumns/WcColumnInnerHeader.ts");

class WcColumnInnerHeaderRenderer {
    constructor() {
        this.eGui = document.createElement("div");
        this.innerHeaderElement = document.createElement("wc-grid-column-inner-header");
        this.eGui.appendChild(this.innerHeaderElement);
    }
    init(params) {
        this.innerHeaderElement.params = params;
    }
    getGui() {
        return this.eGui;
    }
    refresh(params) {
        this.innerHeaderElement.params = params;
        return true;
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/WcColumns/WcGridColumn.ts":
/*!****************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcColumns/WcGridColumn.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WcGridColumn: () => (/* binding */ WcGridColumn)
/* harmony export */ });
/* harmony import */ var _WcColumnInnerHeaderRenderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./WcColumnInnerHeaderRenderer */ "./src/components/Common/WcGrid/WcColumns/WcColumnInnerHeaderRenderer.ts");

class WcGridColumn {
    constructor(columnTitle, fieldName) {
        this.columnTitle = columnTitle;
        this.fieldName = fieldName;
        this.hidden = true;
        this.flex = 1;
    }
    setHidden(hidden) {
        this.hidden = hidden;
        return this;
    }
    setFlex(flex) {
        this.flex = flex;
        return this;
    }
    getFieldName() {
        return this.fieldName;
    }
    toAgGridColDef() {
        return Object.assign(Object.assign({}, this.getCommonColDef()), this.getExtendedColDef());
    }
    getExtendedColDef() {
        return {};
    }
    getCommonColDef() {
        var _a, _b;
        const colDef = {};
        if ((_a = this.chartConfig) === null || _a === void 0 ? void 0 : _a.getIsChartingEnabled()) {
            colDef.headerComponentParams = {
                innerHeaderComponent: _WcColumnInnerHeaderRenderer__WEBPACK_IMPORTED_MODULE_0__.WcColumnInnerHeaderRenderer,
                innerHeaderComponentParams: {
                    chartButton: {
                        columnField: this.fieldName
                    }
                },
                chartDataType: (_b = this.chartConfig) === null || _b === void 0 ? void 0 : _b.getColumnChartDataType()
            };
        }
        return Object.assign({ headerName: this.columnTitle, field: this.fieldName, colId: this.fieldName, resizable: true, sortable: true, suppressHeaderMenuButton: true, suppressHeaderFilterButton: true, hide: this.hidden, flex: this.flex }, colDef);
    }
    getChartConfig() {
        return this.chartConfig;
    }
    setChartConfig(chartConfig) {
        this.chartConfig = chartConfig;
        return this;
    }
    getChartAxisLabelFormatter() {
        return undefined; // Default implementation, can be overridden
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/WcDetailsView.scss":
/*!*********************************************************!*\
  !*** ./src/components/Common/WcGrid/WcDetailsView.scss ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.details-view {
  width: 100%;
  height: 100%;
  display: block;
}

.details-wrapper {
  padding: 0.5rem;
  display: var(--details-wrapper-display, none);
}

.details-header {
  display: flex;
  flex-direction: row;
}

.details-header-title {
  flex: 2 1 auto;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0NvbW1vbi9XY0dyaWQvV2NEZXRhaWxzVmlldy5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsV0FBQTtFQUNBLFlBQUE7RUFDQSxjQUFBO0FBQ0Y7O0FBRUE7RUFDRSxlQUFBO0VBQ0EsNkNBQUE7QUFDRjs7QUFDQTtFQUNFLGFBQUE7RUFDQSxtQkFBQTtBQUVGOztBQUNBO0VBQ0UsY0FBQTtBQUVGIiwic291cmNlc0NvbnRlbnQiOlsiLmRldGFpbHMtdmlldyB7XG4gIHdpZHRoOiAxMDAlO1xuICBoZWlnaHQ6IDEwMCU7XG4gIGRpc3BsYXk6IGJsb2NrO1xufVxuXG4uZGV0YWlscy13cmFwcGVyIHtcbiAgcGFkZGluZzogMC41cmVtO1xuICBkaXNwbGF5OiB2YXIoLS1kZXRhaWxzLXdyYXBwZXItZGlzcGxheSwgbm9uZSk7XG59XG4uZGV0YWlscy1oZWFkZXIge1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogcm93O1xufVxuXG4uZGV0YWlscy1oZWFkZXItdGl0bGUge1xuICBmbGV4OiAyIDEgYXV0bztcbn1cbiJdLCJzb3VyY2VSb290IjoiIn0= */`);
    

/***/ }),

/***/ "./src/components/Common/WcGrid/WcDetailsView.ts":
/*!*******************************************************!*\
  !*** ./src/components/Common/WcGrid/WcDetailsView.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WcGridDetailsView: () => (/* binding */ WcGridDetailsView)
/* harmony export */ });
/* harmony import */ var _components_InteractionsTab__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/InteractionsTab */ "./src/components/InteractionsTab/index.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _WcDetailsView_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./WcDetailsView.scss */ "./src/components/Common/WcGrid/WcDetailsView.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let WcGridDetailsView = class WcGridDetailsView extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
    constructor() {
        super(...arguments);
        this.isDarkMode = false;
        this.gridRowData = {};
    }
    static get styles() {
        return [_WcDetailsView_scss__WEBPACK_IMPORTED_MODULE_3__["default"]];
    }
    onCloseClicked() {
        this.dispatchEvent(new CustomEvent("wc-details-view-close-clicked", {
            bubbles: true,
            composed: true
        }));
    }
    updated(changedProperties) {
        var _a, _b;
        super.updated(changedProperties);
        if (changedProperties.has("gridRowData") || changedProperties.has("isDarkMode")) {
            const detailsWrapperDiv = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".details-view");
            const detailsContentDiv = detailsWrapperDiv.querySelector(".details-content");
            const listConfig = (_b = this.wcGridConfig) === null || _b === void 0 ? void 0 : _b.getListConfig();
            if (detailsContentDiv && listConfig && listConfig.detailsComponent !== "") {
                const component = document.createElement(listConfig.detailsComponent);
                component.isDarkMode = this.isDarkMode;
                component.data = this.gridRowData;
                detailsContentDiv.innerHTML = "";
                detailsContentDiv.appendChild(component);
            }
        }
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
      <div class="details-view">
        <div class="details-header">
          <div class="details-header-title"></div>
          <div class="details-header-close" @click=${this.onCloseClicked}>
            <md-icon name="cancel-bold" size="16" iconset="momentumDesign"></md-icon>
          </div>
        </div>
        <div data-testid="details-content" class="details-content"></div>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
], WcGridDetailsView.prototype, "isDarkMode", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
], WcGridDetailsView.prototype, "gridRowData", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
], WcGridDetailsView.prototype, "wcGridConfig", void 0);
WcGridDetailsView = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("wc-details-view")
], WcGridDetailsView);



/***/ }),

/***/ "./src/components/Common/WcGrid/WcGrid.constants.ts":
/*!**********************************************************!*\
  !*** ./src/components/Common/WcGrid/WcGrid.constants.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SortOrder: () => (/* binding */ SortOrder),
/* harmony export */   wcCustomIcons: () => (/* binding */ wcCustomIcons)
/* harmony export */ });
//See https://www.ag-grid.com/javascript-data-grid/custom-icons/#icon-names for full list of icons
const wcCustomIcons = {
    filter: '<md-icon name="filter-bold" iconSet="momentumDesign" size="16"></md-icon>',
    sortAscending: `<div class="sorted up">
          <md-icon name="sort-ascending-bold" iconSet="momentumDesign" size="16"></md-icon>
          </div>`,
    sortDescending: `<div class="sorted down">
          <md-icon name="sort-descending-bold" iconSet="momentumDesign" size="16"></md-icon>
          </div>`,
    clipboardCopy: '<md-icon name="copy-bold" iconSet="momentumDesign" size="16" class="icon-copy_16" />',
    advancedFilterBuilderDrag: '<md-icon name="dragger-vertical-bold" iconSet="momentumDesign" size="16"></md-icon>',
    rowDrag: '<md-icon name="dragger-vertical-bold" iconSet="momentumDesign" size="16"></md-icon>',
    columnDrag: '<md-icon name="dragger-vertical-bold" iconSet="momentumDesign" size="16"></md-icon>',
    columnSelectClosed: '<md-icon name="arrow-right-bold" iconSet="momentumDesign" size="16"></md-icon>',
    columnSelectOpen: '<md-icon name="arrow-down-bold" iconSet="momentumDesign" size="16"></md-icon>',
    filterActive: '<md-icon name="filter-bold" iconSet="momentumDesign" size="16"></md-icon>',
    menu: '<md-icon name="settings-bold" iconSet="momentumDesign" size="16" class="settings-icon"><md-icon/>'
};
const SortOrder = {
    Ascending: "asc",
    Descending: "desc"
};


/***/ }),

/***/ "./src/components/Common/WcGrid/WcGrid.scss":
/*!**************************************************!*\
  !*** ./src/components/Common/WcGrid/WcGrid.scss ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  height: 100%;
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  box-sizing: border-box;
}

.column-1 {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 23.75%;
}

.column-2 {
  flex: 1 0 76.25%;
}

wc-details-view {
  width: 76.25%;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0NvbW1vbi9XY0dyaWQvV2NHcmlkLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxZQUFBO0VBQ0EsV0FBQTtFQUNBLGFBQUE7RUFDQSxpQkFBQTtFQUNBLG1CQUFBO0VBQ0Esc0JBQUE7QUFDRjs7QUFFQTtFQUNFLGFBQUE7RUFDQSxzQkFBQTtFQUNBLE9BQUE7RUFDQSxpQkFBQTtBQUNGOztBQUVBO0VBQ0UsZ0JBQUE7QUFDRjs7QUFFQTtFQUNFLGFBQUE7QUFDRiIsInNvdXJjZXNDb250ZW50IjpbIjpob3N0IHtcbiAgaGVpZ2h0OiAxMDAlO1xuICB3aWR0aDogMTAwJTtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC13cmFwOiBub3dyYXA7XG4gIGZsZXgtZGlyZWN0aW9uOiByb3c7XG4gIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG59XG5cbi5jb2x1bW4tMSB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGZsZXg6IDE7XG4gIG1pbi13aWR0aDogMjMuNzUlO1xufVxuXG4uY29sdW1uLTIge1xuICBmbGV4OiAxIDAgNzYuMjUlO1xufVxuXG53Yy1kZXRhaWxzLXZpZXcge1xuICB3aWR0aDogNzYuMjUlO1xufVxuIl0sInNvdXJjZVJvb3QiOiIifQ== */`);
    

/***/ }),

/***/ "./src/components/Common/WcGrid/WcGrid.ts":
/*!************************************************!*\
  !*** ./src/components/Common/WcGrid/WcGrid.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WcGridWidget: () => (/* binding */ WcGridWidget)
/* harmony export */ });
/* harmony import */ var _components_InteractionsTab__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/InteractionsTab */ "./src/components/InteractionsTab/index.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _WcAgGridWrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./WcAgGridWrapper */ "./src/components/Common/WcGrid/WcAgGridWrapper.ts");
/* harmony import */ var _WcDetailsView__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./WcDetailsView */ "./src/components/Common/WcGrid/WcDetailsView.ts");
/* harmony import */ var _WcGrid_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./WcGrid.types */ "./src/components/Common/WcGrid/WcGrid.types.ts");
/* harmony import */ var _WcGridHeader_WcGridHeader__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./WcGridHeader/WcGridHeader */ "./src/components/Common/WcGrid/WcGridHeader/WcGridHeader.ts");
/* harmony import */ var _WcGrid_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./WcGrid.scss */ "./src/components/Common/WcGrid/WcGrid.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};










function getWcGridExportType(e) {
    var _a;
    if (!((_a = e.detail) === null || _a === void 0 ? void 0 : _a.exportType) ||
        typeof e.detail.exportType !== "string" ||
        !Object.values(_WcGrid_types__WEBPACK_IMPORTED_MODULE_6__.WcGridExportType).includes(e.detail.exportType)) {
        return undefined;
    }
    return e.detail.exportType;
}
let WcGridWidget = class WcGridWidget extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
    constructor() {
        super(...arguments);
        this.isDarkMode = false;
        this.wcColumnDefs = [];
        this.isList = false;
        this.selectedRowData = {};
    }
    static get styles() {
        return [_WcGrid_scss__WEBPACK_IMPORTED_MODULE_8__["default"]];
    }
    get toolbarWidget() {
        var _a;
        return (_a = this.toolbarNodes) === null || _a === void 0 ? void 0 : _a[0];
    }
    get gridWidget() {
        var _a;
        return (_a = this.gridNodes) === null || _a === void 0 ? void 0 : _a[0];
    }
    get detailsWidget() {
        var _a;
        return (_a = this.detailsNodes) === null || _a === void 0 ? void 0 : _a[0];
    }
    toggleCollapsedState() {
        this.isList = !this.isList;
    }
    onRowClicked(event) {
        if (!this.isList) {
            this.toggleCollapsedState();
            if (this.gridWidget) {
                this.gridWidget.isListView = this.isList;
            }
        }
        this.selectedRowData = event.detail.data;
    }
    onExportGridDataClicked(e) {
        var _a;
        e.stopPropagation();
        const exportType = getWcGridExportType(e);
        if (!exportType) {
            return;
        }
        (_a = this.gridWidget) === null || _a === void 0 ? void 0 : _a.exportGridData(exportType);
    }
    get renderDetailsView() {
        var _a, _b;
        return !this.isList || !((_b = (_a = this.wcGridConfig) === null || _a === void 0 ? void 0 : _a.getListConfig()) === null || _b === void 0 ? void 0 : _b.detailsComponent)
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}`
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<slot name="details" class="column-2" @wc-details-view-close-clicked=${this.toggleCollapsedState}>
          <wc-details-view
            .isDarkMode=${this.isDarkMode}
            .wcGridConfig=${this.wcGridConfig}
            .gridRowData=${this.selectedRowData}
          ></wc-details-view>
        </slot>`;
    }
    get renderToolbar() {
        var _a;
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<slot
      name="toolbar"
      @filter-button-clicked=${() => {
            var _a;
            (_a = this.gridWidget) === null || _a === void 0 ? void 0 : _a.toggleToolPanel(_WcAgGridWrapper__WEBPACK_IMPORTED_MODULE_4__.ToolPanelType.Filters);
        }}
      @column-select=${() => {
            var _a;
            (_a = this.gridWidget) === null || _a === void 0 ? void 0 : _a.toggleToolPanel(_WcAgGridWrapper__WEBPACK_IMPORTED_MODULE_4__.ToolPanelType.Columns);
        }}
      @export-grid-clicked=${(e) => this.onExportGridDataClicked(e)}
      @reset-wc-grid-state=${() => {
            var _a;
            (_a = this.gridWidget) === null || _a === void 0 ? void 0 : _a.resetWcGrid();
        }}
      ><wc-grid-header
        .wcGridHeaderConfig=${(_a = this.wcGridConfig) === null || _a === void 0 ? void 0 : _a.getHeaderConfig()}
        .gridIsCollapsed=${this.isList}
      ></wc-grid-header
    ></slot>`;
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
      <div class="column-1">
        ${this.renderToolbar}
        <slot
          name="grid"
          @row-clicked=${(e) => {
            this.onRowClicked(e);
        }}
          ><wc-ag-grid-wrapper
            .isDarkMode=${this.isDarkMode}
            .isListView=${this.isList}
            .wcGridConfig=${this.wcGridConfig}
            .wcColumnDefs=${this.wcColumnDefs}
            .rowData=${this.rowData}
            .gridApiCallback=${this.gridApiCallback}
          ></wc-ag-grid-wrapper>
        </slot>
      </div>
      ${this.renderDetailsView}
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
], WcGridWidget.prototype, "isDarkMode", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
], WcGridWidget.prototype, "wcGridConfig", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Array })
], WcGridWidget.prototype, "wcColumnDefs", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
], WcGridWidget.prototype, "rowData", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
], WcGridWidget.prototype, "isList", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object, attribute: false })
], WcGridWidget.prototype, "gridApiCallback", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], WcGridWidget.prototype, "selectedRowData", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.queryAssignedNodes)("toolbar", true)
], WcGridWidget.prototype, "toolbarNodes", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.queryAssignedNodes)("grid", true)
], WcGridWidget.prototype, "gridNodes", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.queryAssignedNodes)("details", true)
], WcGridWidget.prototype, "detailsNodes", void 0);
WcGridWidget = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("wc-grid")
], WcGridWidget);



/***/ }),

/***/ "./src/components/Common/WcGrid/WcGrid.types.ts":
/*!******************************************************!*\
  !*** ./src/components/Common/WcGrid/WcGrid.types.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WcGridExportType: () => (/* binding */ WcGridExportType)
/* harmony export */ });
var WcGridExportType;
(function (WcGridExportType) {
    WcGridExportType["CSV"] = "csv";
    WcGridExportType["EXCEL"] = "excel";
})(WcGridExportType || (WcGridExportType = {}));


/***/ }),

/***/ "./src/components/Common/WcGrid/WcGridConfig.ts":
/*!******************************************************!*\
  !*** ./src/components/Common/WcGrid/WcGridConfig.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WcGridConfig: () => (/* binding */ WcGridConfig)
/* harmony export */ });
/* harmony import */ var _WcGrid_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./WcGrid.constants */ "./src/components/Common/WcGrid/WcGrid.constants.ts");
/* harmony import */ var _WcGridLocaleText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./WcGridLocaleText */ "./src/components/Common/WcGrid/WcGridLocaleText.ts");


class WcGridConfig {
    constructor(params) {
        var _a, _b;
        this.serverSideRowModel = false;
        this.tableName = "";
        this.enableCharts = false;
        this.suppressContextMenu = true;
        this.headerConfig = {};
        this.cellSelection = false;
        this.tableName = params.tableName;
        this.headerConfig = params.headerConfig;
        this.enableCharts = params.enableCharts;
        this.serverSideRowModel = (_a = params.serverSideRowModel) !== null && _a !== void 0 ? _a : false;
        this.fetchServerRows = params.fetchServerRows;
        this.suppressContextMenu = (_b = params.suppressContextMenu) !== null && _b !== void 0 ? _b : true;
    }
    setListConfig(listConfig) {
        this.listConfig = listConfig;
        return this;
    }
    setCellSelection(cellSelection) {
        this.cellSelection = cellSelection;
        return this;
    }
    getCellSelection() {
        return this.cellSelection;
    }
    getListConfig() {
        return this.listConfig;
    }
    toAgGridConfig() {
        var _a;
        const filtersToolPanel = {
            id: "filters",
            labelDefault: "Filters",
            labelKey: "filters",
            iconKey: "filter",
            toolPanel: "agFiltersToolPanel",
            toolPanelParams: {
                suppressExpandAll: true,
                suppressFilterSearch: false
            }
        };
        const columnsToolPanel = {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel",
            toolPanelParams: {
                suppressRowGroups: true,
                suppressValues: true,
                suppressPivots: true,
                suppressPivotMode: true,
                suppressColumnFilter: false,
                suppressColumnSelectAll: false,
                suppressColumnExpandAll: true
            }
        };
        const toolPanelsArray = [];
        if (this.headerConfig.filterButton) {
            toolPanelsArray.push(filtersToolPanel);
        }
        if ((_a = this.headerConfig) === null || _a === void 0 ? void 0 : _a.columnSelectButton) {
            toolPanelsArray.push(columnsToolPanel);
        }
        const sidebar = {
            toolPanels: toolPanelsArray,
            hiddenByDefault: false
        };
        return {
            sideBar: sidebar,
            icons: _WcGrid_constants__WEBPACK_IMPORTED_MODULE_0__.wcCustomIcons,
            enableCharts: this.enableCharts,
            cellSelection: this.cellSelection,
            animateRows: false,
            suppressAnimationFrame: true,
            rowModelType: this.serverSideRowModel ? "serverSide" : "clientSide",
            blockLoadDebounceMillis: this.serverSideRowModel ? 1000 : undefined,
            localeText: _WcGridLocaleText__WEBPACK_IMPORTED_MODULE_1__.wcGridLocaleText,
            columnMenu: "new",
            suppressContextMenu: this.suppressContextMenu
        };
    }
    getHeaderConfig() {
        return this.headerConfig;
    }
    saveGridStateEnabled() {
        var _a, _b;
        return (_b = (_a = this.headerConfig) === null || _a === void 0 ? void 0 : _a.resetGridStateButton) !== null && _b !== void 0 ? _b : false;
    }
    getTableName() {
        return this.tableName;
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/WcGridHeader/WcGridHeader.scss":
/*!*********************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcGridHeader/WcGridHeader.scss ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.wc-grid-header {
  display: flex;
  height: 44px;
  padding: 0px 8px 0px 12px;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 12px;
  border-radius: 8px;
  background: var(--md-glass-overlay-bg-color);
  box-shadow: var(--md-elevation-1);
  line-height: 1;
}

.left-group {
  margin-right: auto;
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
}
.left-group > *:not(:first-child) {
  margin-left: 16px;
}

.count-label {
  color: var(--md-secondary-text-color);
}

.refresh-label {
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  column-gap: 4px;
}
.refresh-label > md-icon {
  line-height: 0;
}

.center-group {
  margin-right: auto;
}

.right-group {
  display: flex;
  flex-flow: row;
  align-items: center;
  gap: 8px;
}

.date-range-picker {
  top: 8px;
  position: relative;
  width: 225px;
}

md-alert-banner {
  display: block;
  margin: 0 8px 8px 8px;
}

.export-overlay-container {
  padding: 0.5rem;
  width: 100%;
  background-color: var(--md-secondary-white-bg-color);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Common/WcGrid/WcGridHeader/WcGridHeader.ts":
/*!*******************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcGridHeader/WcGridHeader.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WcGridHeaderWidget: () => (/* binding */ WcGridHeaderWidget)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _WcGrid_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../WcGrid.types */ "./src/components/Common/WcGrid/WcGrid.types.ts");
/* harmony import */ var _WcGridHeader_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./WcGridHeader.scss */ "./src/components/Common/WcGrid/WcGridHeader/WcGridHeader.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






let WcGridHeaderWidget = class WcGridHeaderWidget extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
    constructor() {
        super(...arguments);
        this.gridIsCollapsed = false;
        this.datePickerStartTime = 0;
        this.datePickerEndTime = 0;
    }
    connectedCallback() {
        var _a, _b, _c, _d;
        super.connectedCallback();
        this.datePickerStartTime = (_b = (_a = this.wcGridHeaderConfig) === null || _a === void 0 ? void 0 : _a.datePickerStartTime) !== null && _b !== void 0 ? _b : 0;
        this.datePickerEndTime = (_d = (_c = this.wcGridHeaderConfig) === null || _c === void 0 ? void 0 : _c.datePickerEndTime) !== null && _d !== void 0 ? _d : 0;
    }
    static get styles() {
        return [_WcGridHeader_scss__WEBPACK_IMPORTED_MODULE_5__["default"]];
    }
    onResetWcGrid(e) {
        var _a, _b, _c, _d;
        e.stopPropagation();
        this.datePickerStartTime = (_b = (_a = this.wcGridHeaderConfig) === null || _a === void 0 ? void 0 : _a.datePickerStartTime) !== null && _b !== void 0 ? _b : 0;
        this.datePickerEndTime = (_d = (_c = this.wcGridHeaderConfig) === null || _c === void 0 ? void 0 : _c.datePickerEndTime) !== null && _d !== void 0 ? _d : 0;
        this.dispatchEvent(new CustomEvent("reset-wc-grid-state", {
            bubbles: true,
            composed: true
        }));
    }
    onColumnSelect(e) {
        e.stopPropagation();
        this.dispatchEvent(new CustomEvent("column-select", {
            bubbles: true,
            composed: true
        }));
    }
    onFilterButtonClicked(e) {
        e.stopPropagation();
        this.dispatchEvent(new CustomEvent("filter-button-clicked", {
            bubbles: true,
            composed: true
        }));
    }
    onUnsortedButtonClicked(e) {
        e.stopPropagation();
        this.dispatchEvent(new CustomEvent("unsorted-button-clicked", {
            bubbles: true,
            composed: true
        }));
    }
    showGridHeader() {
        if (!this.wcGridHeaderConfig) {
            return false;
        }
        return Boolean(this.wcGridHeaderConfig.resetGridStateButton ||
            this.wcGridHeaderConfig.filterButton ||
            this.wcGridHeaderConfig.unsortedButton ||
            this.wcGridHeaderConfig.columnSelectButton ||
            this.wcGridHeaderConfig.refreshButton ||
            this.wcGridHeaderConfig.datePicker ||
            this.wcGridHeaderConfig.countLabelText ||
            this.wcGridHeaderConfig.refreshLabelText ||
            this.wcGridHeaderConfig.alertBannerText ||
            this.wcGridHeaderConfig.exportButton);
    }
    onRefreshClicked(e) {
        e.stopPropagation();
        this.dispatchEvent(new CustomEvent("refresh-grid-clicked", {
            bubbles: true,
            composed: true
        }));
    }
    onExportClicked(e, exportType) {
        e.stopPropagation();
        this.dispatchEvent(new CustomEvent("export-grid-clicked", {
            bubbles: true,
            composed: true,
            detail: { exportType }
        }));
    }
    renderCountLabel() {
        var _a;
        if (!((_a = this.wcGridHeaderConfig) === null || _a === void 0 ? void 0 : _a.countLabelText)) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}`;
        }
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ` <span class="count-label" id="count-label">${this.wcGridHeaderConfig.countLabelText}</span> `;
    }
    renderRefreshLabel() {
        var _a;
        if (!((_a = this.wcGridHeaderConfig) === null || _a === void 0 ? void 0 : _a.refreshLabelText)) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}`;
        }
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <span class="refresh-label" id="refresh-label">
        <md-icon name="recents-bold" iconSet="momentumDesign" size="14" slot="left-group" class="time-icon"></md-icon>
        ${this.wcGridHeaderConfig.refreshLabelText}
      </span>
    `;
    }
    renderResetButton() {
        var _a;
        if (!((_a = this.wcGridHeaderConfig) === null || _a === void 0 ? void 0 : _a.resetGridStateButton)) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}`;
        }
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<md-button
      id="reset-customization-button"
      circle
      size="28"
      variant="ghost"
      @click=${this.onResetWcGrid}
      ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:wcGrid:reset")}
    >
      <md-icon slot="icon" name="reset-bold" iconSet="momentumDesign" size="16"></md-icon>
    </md-button>`;
    }
    renderColumnSelectButton() {
        var _a;
        if (!((_a = this.wcGridHeaderConfig) === null || _a === void 0 ? void 0 : _a.columnSelectButton)) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}`;
        }
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<md-button
      id="customization-button"
      circle
      size="28"
      variant="ghost"
      @click=${this.onColumnSelect}
      ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:wcGrid:customization")}
    >
      <md-icon slot="icon" iconSet="momentumDesign" name="settings-bold" size="16"></md-icon>
    </md-button>`;
    }
    renderFilterButton() {
        var _a;
        if (!((_a = this.wcGridHeaderConfig) === null || _a === void 0 ? void 0 : _a.filterButton)) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}`;
        }
        if (this.wcGridHeaderConfig.filterButton === "small") {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <md-button
          id="filter-button"
          circle
          variant="ghost"
          size="28"
          @click=${this.onFilterButtonClicked}
          ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:wcGrid:filter")}
        >
          <md-icon slot="icon" iconSet="momentumDesign" name="filter-bold" size="16" ariaHidden="true"></md-icon>
        </md-button>
      `;
        }
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <md-button
        id="filter-button"
        variant="secondary"
        size="28"
        @click=${this.onFilterButtonClicked}
        ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:wcGrid:filter")}
      >
        <md-icon slot="icon" iconSet="momentumDesign" name="filter-bold" size="16" ariaHidden="true"></md-icon>
        ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:wcGrid:filter")}
      </md-button>
    `;
    }
    renderRefreshButton() {
        var _a;
        if (!((_a = this.wcGridHeaderConfig) === null || _a === void 0 ? void 0 : _a.refreshButton)) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}`;
        }
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<md-button id="refresh-grid-button" circle size="28" variant="ghost" @click=${this.onRefreshClicked}>
      <md-icon slot="icon" name="refresh-bold" iconSet="momentumDesign" size="16"></md-icon>
    </md-button>`;
    }
    renderUnsortedButton() {
        var _a;
        if (!((_a = this.wcGridHeaderConfig) === null || _a === void 0 ? void 0 : _a.unsortedButton)) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}`;
        }
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <md-button id="unsorted-button" circle variant="ghost" size="28" @click=${this.onUnsortedButtonClicked}>
        <md-icon slot="icon" iconSet="momentumDesign" name="unsorted-bold" size="16" ariaHidden="true"></md-icon>
      </md-button>
    `;
    }
    renderDatePicker() {
        var _a, _b, _c;
        if (!((_a = this.wcGridHeaderConfig) === null || _a === void 0 ? void 0 : _a.datePicker)) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}`;
        }
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <md-date-range-picker
        class="date-range-picker"
        .startDate=${(_b = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(this.datePickerStartTime).toISODate()) !== null && _b !== void 0 ? _b : ""}
        .endDate=${(_c = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(this.datePickerEndTime).toISODate()) !== null && _c !== void 0 ? _c : ""}
        .useISOFormat=${false}
        .controlButtons=${{
            apply: { value: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.apply") },
            cancel: { value: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.cancelButton") }
        }}
        .shouldCloseOnSelect=${true}
        @date-range-change=${this.onDateRangeChange}
      >
      </md-date-range-picker>
    `;
    }
    onDateRangeChange(e) {
        e.stopPropagation();
        if (!e.detail || typeof e.detail.startDate !== "string" || typeof e.detail.endDate !== "string") {
            return;
        }
        this.datePickerStartTime = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromISO(e.detail.startDate).toMillis();
        this.datePickerEndTime = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromISO(e.detail.endDate).toMillis();
        this.dispatchEvent(new CustomEvent("search-date-range-updated", {
            detail: {
                startTime: this.datePickerStartTime,
                endTime: this.datePickerEndTime
            },
            bubbles: true,
            composed: true
        }));
    }
    renderExportButton() {
        var _a;
        if (!((_a = this.wcGridHeaderConfig) === null || _a === void 0 ? void 0 : _a.exportButton)) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}`;
        }
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ` <md-menu-overlay size="small">
      <div slot="menu-trigger">
        <slot name="menu-trigger">
          <md-button size="28" circle variant="ghost" ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:wcGrid:export")}>
            <md-icon slot="icon" name="export-bold" iconSet="momentumDesign" ariaHidden="true"></md-icon>
          </md-button>
        </slot>
      </div>
      <div class="export-overlay-container">
        <md-list>
          <md-list-item
            slot="list-item"
            @click=${(e) => this.onExportClicked(e, _WcGrid_types__WEBPACK_IMPORTED_MODULE_4__.WcGridExportType.CSV)}
            @keypress=${(e) => e.key === "Enter" && this.onExportClicked(e, _WcGrid_types__WEBPACK_IMPORTED_MODULE_4__.WcGridExportType.CSV)}
            >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:wcGrid:csv")}</md-list-item
          >
          <md-list-item
            slot="list-item"
            @click=${(e) => this.onExportClicked(e, _WcGrid_types__WEBPACK_IMPORTED_MODULE_4__.WcGridExportType.EXCEL)}
            @keypress=${(e) => e.key === "Enter" && this.onExportClicked(e, _WcGrid_types__WEBPACK_IMPORTED_MODULE_4__.WcGridExportType.EXCEL)}
            >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:wcGrid:excel")}</md-list-item
          >
        </md-list>
      </div>
    </md-menu-overlay>`;
    }
    renderAlertBanner() {
        var _a, _b;
        if (!((_a = this.wcGridHeaderConfig) === null || _a === void 0 ? void 0 : _a.alertBannerText) || this.gridIsCollapsed) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}`;
        }
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ` <md-alert-banner
      data-testid="wc-grid-alert-banner"
      type="default"
      show
      showBannerTypeIcon
      showRefreshButton
      @alertBanner-refresh-button-click=${(e) => this.onRefreshClicked(e)}
    >
      ${(_b = this.wcGridHeaderConfig) === null || _b === void 0 ? void 0 : _b.alertBannerText}
    </md-alert-banner>`;
    }
    renderRightButtons() {
        if (this.gridIsCollapsed) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${this.renderFilterButton()}`;
        }
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${this.renderDatePicker()} ${this.renderRefreshButton()} ${this.renderResetButton()}
    ${this.renderColumnSelectButton()} ${this.renderUnsortedButton()} ${this.renderExportButton()}
    ${this.renderFilterButton()}`;
    }
    renderLeftButtons() {
        if (this.gridIsCollapsed) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${this.renderCountLabel()}`;
        }
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${this.renderCountLabel()} ${this.renderRefreshLabel()}`;
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      ${this.showGridHeader()
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<div class="wc-grid-header">
            <div class="left-group">${this.renderLeftButtons()}</div>
            <div class="center-group"></div>
            <div class="right-group">${this.renderRightButtons()}</div>
          </div>`
            : lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}
      ${this.renderAlertBanner()}
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
], WcGridHeaderWidget.prototype, "wcGridHeaderConfig", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
], WcGridHeaderWidget.prototype, "gridIsCollapsed", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
], WcGridHeaderWidget.prototype, "datePickerStartTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
], WcGridHeaderWidget.prototype, "datePickerEndTime", void 0);
WcGridHeaderWidget = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("wc-grid-header")
], WcGridHeaderWidget);



/***/ }),

/***/ "./src/components/Common/WcGrid/WcGridIntegratedChart.ts":
/*!***************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcGridIntegratedChart.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ColumnChartDataType: () => (/* binding */ ColumnChartDataType),
/* harmony export */   WcGridIntegratedChart: () => (/* binding */ WcGridIntegratedChart)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");


var ColumnChartDataType;
(function (ColumnChartDataType) {
    ColumnChartDataType["Category"] = "category";
    ColumnChartDataType["Series"] = "series";
    ColumnChartDataType["Time"] = "time";
    ColumnChartDataType["Excluded"] = "excluded";
})(ColumnChartDataType || (ColumnChartDataType = {}));
const MIN_NUMBER_OF_COLUMNS = 2;
/**
 *  Support charting for columns from WcGrid.
 *  Limitations:
 * - Supports 'range' application charts only
 * - Supports 'columnLineCombo' chart-types only
 * - Supports 2 data columns in addition to the primary category, eg. 'agentName'
 */
class WcGridIntegratedChart {
    constructor(wcColumnDefs, gridApi) {
        this.wcColumnDefs = wcColumnDefs;
        this.gridApi = gridApi;
        this.nonPrimaryColumnsInChart = [];
        this.primaryAxisColumn = "";
        const primaryAxisColumns = wcColumnDefs.filter((col) => { var _a; return (_a = col.getChartConfig()) === null || _a === void 0 ? void 0 : _a.getIsPrimaryAxisInChart(); });
        if (primaryAxisColumns.length !== 1) {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`Invalid number (${primaryAxisColumns.length}) of primary axis columns found. Exactly one column must be set as the primary axis.`);
            return;
        }
        const fieldName = primaryAxisColumns[0].getFieldName();
        if (!fieldName || fieldName === "") {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`Primary axis column must have a valid field name.`);
            return;
        }
        this.primaryAxisColumn = fieldName;
    }
    refreshIntegratedChart(event) {
        if (!this.gridApi) {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("Grid API not found");
            return;
        }
        if (this.wcColumnDefs.length < MIN_NUMBER_OF_COLUMNS) {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`Minimum (${MIN_NUMBER_OF_COLUMNS}) columns required to create chart`);
            return;
        }
        if (event.detail.columns.length < 1) {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("Minimum 1 column must be requested to chart data");
            return;
        }
        const requestedFields = event.detail.columns;
        const chartInstances = this.gridApi.getChartModels();
        if (chartInstances && (chartInstances === null || chartInstances === void 0 ? void 0 : chartInstances.length) > 0) {
            this.updateExistingChartCellRanges(requestedFields);
        }
        else {
            this.createNewIntegratedChart(requestedFields);
        }
    }
    createNewIntegratedChart(requestedFields) {
        this.nonPrimaryColumnsInChart = [...requestedFields];
        this.gridApi.createRangeChart({
            chartType: "columnLineCombo",
            seriesChartTypes: this.getSeriesChartTypes(this.nonPrimaryColumnsInChart),
            cellRange: {
                columns: [...this.nonPrimaryColumnsInChart, this.primaryAxisColumn]
            },
            chartThemeOverrides: {
                common: {
                    title: { enabled: true, text: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:agentPerformance.chart.title") },
                    subtitle: { enabled: true, text: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:agentPerformance.chart.subtitle") },
                    axes: {
                        number: {
                            label: {
                                formatter: this.getAxisLabelFormatter(this.nonPrimaryColumnsInChart)
                            }
                        }
                    },
                    legend: {
                        position: "bottom",
                        enabled: true,
                        preventHidingAll: true
                    }
                }
            }
        });
    }
    updateExistingChartCellRanges(requestedFields) {
        // Limit to 2 data columns in addition to the primary category column
        if (this.nonPrimaryColumnsInChart.length === 2) {
            this.nonPrimaryColumnsInChart = [...this.nonPrimaryColumnsInChart.slice(1)];
        }
        this.nonPrimaryColumnsInChart.push(...requestedFields);
        this.gridApi.updateChart({
            chartId: this.getExistingChartId(this.gridApi),
            type: "rangeChartUpdate",
            seriesChartTypes: this.getSeriesChartTypes(this.nonPrimaryColumnsInChart),
            cellRange: {
                columns: [...this.nonPrimaryColumnsInChart, this.primaryAxisColumn]
            },
            chartThemeOverrides: {
                common: {
                    axes: {
                        number: {
                            label: {
                                formatter: this.getAxisLabelFormatter(this.nonPrimaryColumnsInChart)
                            }
                        }
                    }
                }
            }
        });
    }
    getWcGridColumnsForFields(columnFields) {
        return this.wcColumnDefs.filter((col) => columnFields.includes(col.getFieldName()));
    }
    getSeriesChartTypes(requestedFields) {
        return this.getWcGridColumnsForFields(requestedFields).map((col) => {
            var _a, _b, _c;
            return {
                colId: col.getFieldName(),
                secondaryAxis: (_b = (_a = col.getChartConfig()) === null || _a === void 0 ? void 0 : _a.getIsPrimaryAxisInChart()) !== null && _b !== void 0 ? _b : false,
                chartType: ((_c = col.getChartConfig()) === null || _c === void 0 ? void 0 : _c.getIsTeamAverageDataColumn()) ? "line" : "groupedColumn"
            };
        });
    }
    getAxisLabelFormatter(columnFields) {
        var _a;
        return (_a = this.getWcGridColumnsForFields(columnFields)
            .find((col) => {
            return col.getChartAxisLabelFormatter() !== undefined;
        })) === null || _a === void 0 ? void 0 : _a.getChartAxisLabelFormatter();
    }
    getExistingChartId(gridApi) {
        var _a, _b, _c;
        return (_c = (_b = (_a = gridApi.getChartModels()) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.chartId) !== null && _c !== void 0 ? _c : "";
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/WcGridLocaleText.ts":
/*!**********************************************************!*\
  !*** ./src/components/Common/WcGrid/WcGridLocaleText.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   wcGridLocaleText: () => (/* binding */ wcGridLocaleText)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);



// prettier-ignore
const agGridLocaleText = {
    get selectAll() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.selectAll"); },
    get selectAllSearchResults() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.selectAllSearchResults"); },
    get addCurrentSelectionToFilter() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.addCurrentSelectionToFilter"); },
    get searchOoo() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.searchOoo"); },
    get blanks() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.blanks"); },
    get noMatches() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.noMatches"); },
    get filterOoo() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.filterOoo"); },
    get equals() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.equals"); },
    get notEqual() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.notEqual"); },
    get blank() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.blank"); },
    get notBlank() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.notBlank"); },
    get empty() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.empty"); },
    get lessThan() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.lessThan"); },
    get greaterThan() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.greaterThan"); },
    get lessThanOrEqual() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.lessThanOrEqual"); },
    get greaterThanOrEqual() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.greaterThanOrEqual"); },
    get inRange() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.inRange"); },
    get inRangeStart() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.inRangeStart"); },
    get inRangeEnd() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.inRangeEnd"); },
    get contains() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.contains"); },
    get notContains() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.notContains"); },
    get startsWith() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.startsWith"); },
    get endsWith() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.endsWith"); },
    get before() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.before"); },
    get after() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.after"); },
    get andCondition() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.andCondition"); },
    get orCondition() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.orCondition"); },
    get applyFilter() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.applyFilter"); },
    get resetFilter() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.resetFilter"); },
    get clearFilter() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.clearFilter"); },
    get cancelFilter() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.cancelFilter"); },
    get textFilter() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.textFilter"); },
    get numberFilter() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.numberFilter"); },
    get dateFilter() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.dateFilter"); },
    get setFilter() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.setFilter"); },
    get groupFilterSelect() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.groupFilterSelect"); },
    get advancedFilterContains() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterContains"); },
    get advancedFilterNotContains() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterNotContains"); },
    get advancedFilterTextEquals() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterTextEquals"); },
    get advancedFilterTextNotEqual() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterTextNotEqual"); },
    get advancedFilterStartsWith() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterStartsWith"); },
    get advancedFilterEndsWith() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterEndsWith"); },
    get advancedFilterBlank() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterBlank"); },
    get advancedFilterNotBlank() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterNotBlank"); },
    get advancedFilterTrue() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterTrue"); },
    get advancedFilterFalse() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterFalse"); },
    get advancedFilterAnd() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterAnd"); },
    get advancedFilterOr() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterOr"); },
    get advancedFilterApply() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterApply"); },
    get advancedFilterBuilder() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterBuilder"); },
    get advancedFilterValidationMissingColumn() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterValidationMissingColumn"); },
    get advancedFilterValidationMissingOption() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterValidationMissingOption"); },
    get advancedFilterValidationMissingValue() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterValidationMissingValue"); },
    get advancedFilterValidationInvalidColumn() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterValidationInvalidColumn"); },
    get advancedFilterValidationInvalidOption() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterValidationInvalidOption"); },
    get advancedFilterValidationMissingQuote() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterValidationMissingQuote"); },
    get advancedFilterValidationNotANumber() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterValidationNotANumber"); },
    get advancedFilterValidationInvalidDate() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterValidationInvalidDate"); },
    get advancedFilterValidationMissingCondition() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterValidationMissingCondition"); },
    get advancedFilterValidationJoinOperatorMismatch() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterValidationJoinOperatorMismatch"); },
    get advancedFilterValidationInvalidJoinOperator() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterValidationInvalidJoinOperator"); },
    get advancedFilterValidationMissingEndBracket() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterValidationMissingEndBracket"); },
    get advancedFilterValidationExtraEndBracket() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterValidationExtraEndBracket"); },
    get advancedFilterValidationMessage() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterValidationMessage"); },
    get advancedFilterValidationMessageAtEnd() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterValidationMessageAtEnd"); },
    get advancedFilterBuilderTitle() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterBuilderTitle"); },
    get advancedFilterBuilderApply() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterBuilderApply"); },
    get advancedFilterBuilderCancel() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterBuilderCancel"); },
    get advancedFilterBuilderAddButtonTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterBuilderAddButtonTooltip"); },
    get advancedFilterBuilderRemoveButtonTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterBuilderRemoveButtonTooltip"); },
    get advancedFilterBuilderMoveUpButtonTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterBuilderMoveUpButtonTooltip"); },
    get advancedFilterBuilderMoveDownButtonTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterBuilderMoveDownButtonTooltip"); },
    get advancedFilterBuilderAddJoin() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterBuilderAddJoin"); },
    get advancedFilterBuilderAddCondition() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterBuilderAddCondition"); },
    get advancedFilterBuilderSelectColumn() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterBuilderSelectColumn"); },
    get advancedFilterBuilderSelectOption() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterBuilderSelectOption"); },
    get advancedFilterBuilderEnterValue() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterBuilderEnterValue"); },
    get advancedFilterBuilderValidationAlreadyApplied() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterBuilderValidationAlreadyApplied"); },
    get advancedFilterBuilderValidationIncomplete() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterBuilderValidationIncomplete"); },
    get advancedFilterBuilderValidationSelectColumn() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterBuilderValidationSelectColumn"); },
    get advancedFilterBuilderValidationSelectOption() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterBuilderValidationSelectOption"); },
    get advancedFilterBuilderValidationEnterValue() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedFilterBuilderValidationEnterValue"); },
    get columns() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.columns"); },
    get filters() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.filters"); },
    get pivotMode() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.pivotMode"); },
    get groups() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.groups"); },
    get rowGroupColumnsEmptyMessage() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.rowGroupColumnsEmptyMessage"); },
    get values() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.values"); },
    get valueColumnsEmptyMessage() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.valueColumnsEmptyMessage"); },
    get pivots() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.pivots"); },
    get pivotColumnsEmptyMessage() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.pivotColumnsEmptyMessage"); },
    get group() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.group"); },
    get rowDragRow() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.rowDragRow"); },
    get rowDragRows() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.rowDragRows"); },
    get loadingOoo() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.loadingOoo"); },
    get loadingError() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.loadingError"); },
    get noRowsToShow() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.noRowsToShow"); },
    get enabled() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.enabled"); },
    get pinColumn() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.pinColumn"); },
    get pinLeft() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.pinLeft"); },
    get pinRight() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.pinRight"); },
    get noPin() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.noPin"); },
    get valueAggregation() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.valueAggregation"); },
    get noAggregation() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.noAggregation"); },
    get autosizeThisColumn() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.autosizeThisColumn"); },
    get autosizeAllColumns() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.autosizeAllColumns"); },
    get groupBy() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.groupBy"); },
    get ungroupBy() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ungroupBy"); },
    get ungroupAll() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ungroupAll"); },
    get addToValues() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.addToValues"); },
    get removeFromValues() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.removeFromValues"); },
    get addToLabels() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.addToLabels"); },
    get removeFromLabels() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.removeFromLabels"); },
    get resetColumns() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.resetColumns"); },
    get expandAll() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.expandAll"); },
    get collapseAll() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.collapseAll"); },
    get copy() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.copy"); },
    get copyWithHeaders() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.copyWithHeaders"); },
    get copyWithGroupHeaders() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.copyWithGroupHeaders"); },
    get cut() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.cut"); },
    get paste() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.paste"); },
    get export() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.export"); },
    get csvExport() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.csvExport"); },
    get excelExport() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.excelExport"); },
    get columnFilter() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.columnFilter"); },
    get columnChooser() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.columnChooser"); },
    get chooseColumns() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.chooseColumns"); },
    get sortAscending() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.sortAscending"); },
    get sortDescending() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.sortDescending"); },
    get sortUnSort() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.sortUnSort"); },
    get sum() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.sum"); },
    get first() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.first"); },
    get last() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.last"); },
    get min() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.min"); },
    get max() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.max"); },
    get none() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.none"); },
    get count() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.count"); },
    get avg() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.avg"); },
    get filteredRows() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.filteredRows"); },
    get selectedRows() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.selectedRows"); },
    get totalRows() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.totalRows"); },
    get totalAndFilteredRows() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.totalAndFilteredRows"); },
    get more() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.more"); },
    get to() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.to"); },
    get of() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.of"); },
    get page() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.page"); },
    get nextPage() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.nextPage"); },
    get lastPage() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.lastPage"); },
    get firstPage() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.firstPage"); },
    get previousPage() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.previousPage"); },
    get pageSizeSelectorLabel() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.pageSizeSelectorLabel"); },
    get footerTotal() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.footerTotal"); },
    get pivotColumnGroupTotals() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.pivotColumnGroupTotals"); },
    get pivotChartAndPivotMode() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.pivotChartAndPivotMode"); },
    get pivotChart() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.pivotChart"); },
    get chartRange() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.chartRange"); },
    get columnChart() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.columnChart"); },
    get groupedColumn() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.groupedColumn"); },
    get stackedColumn() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.stackedColumn"); },
    get normalizedColumn() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.normalizedColumn"); },
    get barChart() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.barChart"); },
    get groupedBar() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.groupedBar"); },
    get stackedBar() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.stackedBar"); },
    get normalizedBar() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.normalizedBar"); },
    get pieChart() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.pieChart"); },
    get pie() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.pie"); },
    get donut() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.donut"); },
    get lineChart() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.lineChart"); },
    get stackedLine() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.stackedLine"); },
    get normalizedLine() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.normalizedLine"); },
    get xyChart() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.xyChart"); },
    get scatter() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.scatter"); },
    get bubble() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.bubble"); },
    get areaChart() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.areaChart"); },
    get area() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.area"); },
    get stackedArea() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.stackedArea"); },
    get normalizedArea() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.normalizedArea"); },
    get histogramChart() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.histogramChart"); },
    get polarChart() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.polarChart"); },
    get radarLine() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.radarLine"); },
    get radarArea() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.radarArea"); },
    get nightingale() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.nightingale"); },
    get radialColumn() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.radialColumn"); },
    get radialBar() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.radialBar"); },
    get statisticalChart() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.statisticalChart"); },
    get boxPlot() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.boxPlot"); },
    get rangeBar() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.rangeBar"); },
    get rangeArea() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.rangeArea"); },
    get hierarchicalChart() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.hierarchicalChart"); },
    get treemap() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.treemap"); },
    get sunburst() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.sunburst"); },
    get specializedChart() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.specializedChart"); },
    get waterfall() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.waterfall"); },
    get heatmap() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.heatmap"); },
    get combinationChart() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.combinationChart"); },
    get columnLineCombo() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.columnLineCombo"); },
    get AreaColumnCombo() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.AreaColumnCombo"); },
    get pivotChartTitle() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.pivotChartTitle"); },
    get rangeChartTitle() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.rangeChartTitle"); },
    get settings() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.settings"); },
    get data() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.data"); },
    get format() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.format"); },
    get categories() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.categories"); },
    get defaultCategory() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.defaultCategory"); },
    get series() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.series"); },
    get switchCategorySeries() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.switchCategorySeries"); },
    get categoryValues() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.categoryValues"); },
    get seriesLabels() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.seriesLabels"); },
    get aggregate() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.aggregate"); },
    get xyValues() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.xyValues"); },
    get paired() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.paired"); },
    get axis() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.axis"); },
    get xAxis() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.xAxis"); },
    get yAxis() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.yAxis"); },
    get polarAxis() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.polarAxis"); },
    get radiusAxis() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.radiusAxis"); },
    get navigator() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.navigator"); },
    get zoom() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.zoom"); },
    get animation() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.animation"); },
    get crosshair() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.crosshair"); },
    get color() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.color"); },
    get thickness() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.thickness"); },
    get preferredLength() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.preferredLength"); },
    get xType() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.xType"); },
    get axisType() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.axisType"); },
    get automatic() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.automatic"); },
    get category() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.category"); },
    get number() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.number"); },
    get time() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.time"); },
    get timeFormat() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.timeFormat"); },
    get autoRotate() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.autoRotate"); },
    get labelRotation() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.labelRotation"); },
    get circle() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.circle"); },
    get polygon() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.polygon"); },
    get square() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.square"); },
    get cross() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.cross"); },
    get diamond() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.diamond"); },
    get plus() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.plus"); },
    get triangle() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.triangle"); },
    get heart() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.heart"); },
    get orientation() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.orientation"); },
    get fixed() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.fixed"); },
    get parallel() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.parallel"); },
    get perpendicular() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.perpendicular"); },
    get radiusAxisPosition() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.radiusAxisPosition"); },
    get ticks() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ticks"); },
    get gridLines() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.gridLines"); },
    get width() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.width"); },
    get height() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.height"); },
    get length() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.length"); },
    get padding() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.padding"); },
    get spacing() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.spacing"); },
    get chartStyle() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.chartStyle"); },
    get title() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.title"); },
    get chartTitles() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.chartTitles"); },
    get chartTitle() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.chartTitle"); },
    get chartSubtitle() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.chartSubtitle"); },
    get horizontalAxisTitle() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.horizontalAxisTitle"); },
    get verticalAxisTitle() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.verticalAxisTitle"); },
    get polarAxisTitle() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.polarAxisTitle"); },
    get titlePlaceholder() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.titlePlaceholder"); },
    get background() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.background"); },
    get font() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.font"); },
    get weight() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.weight"); },
    get top() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.top"); },
    get right() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.right"); },
    get bottom() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.bottom"); },
    get left() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.left"); },
    get labels() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.labels"); },
    get calloutLabels() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.calloutLabels"); },
    get sectorLabels() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.sectorLabels"); },
    get positionRatio() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.positionRatio"); },
    get size() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.size"); },
    get shape() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.shape"); },
    get minSize() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.minSize"); },
    get maxSize() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.maxSize"); },
    get legend() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.legend"); },
    get position() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.position"); },
    get markerSize() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.markerSize"); },
    get markerStroke() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.markerStroke"); },
    get markerPadding() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.markerPadding"); },
    get itemSpacing() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.itemSpacing"); },
    get itemPaddingX() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.itemPaddingX"); },
    get itemPaddingY() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.itemPaddingY"); },
    get layoutHorizontalSpacing() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.layoutHorizontalSpacing"); },
    get layoutVerticalSpacing() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.layoutVerticalSpacing"); },
    get strokeWidth() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.strokeWidth"); },
    get offset() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.offset"); },
    get offsets() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.offsets"); },
    get tooltips() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.tooltips"); },
    get callout() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.callout"); },
    get markers() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.markers"); },
    get shadow() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.shadow"); },
    get blur() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.blur"); },
    get xOffset() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.xOffset"); },
    get yOffset() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.yOffset"); },
    get lineWidth() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.lineWidth"); },
    get lineDash() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.lineDash"); },
    get lineDashOffset() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.lineDashOffset"); },
    get scrollingZoom() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.scrollingZoom"); },
    get scrollingStep() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.scrollingStep"); },
    get selectingZoom() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.selectingZoom"); },
    get durationMillis() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.durationMillis"); },
    get crosshairLabel() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.crosshairLabel"); },
    get crosshairSnap() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.crosshairSnap"); },
    get normal() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.normal"); },
    get bold() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.bold"); },
    get italic() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.italic"); },
    get boldItalic() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.boldItalic"); },
    get predefined() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.predefined"); },
    get fillOpacity() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.fillOpacity"); },
    get strokeColor() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.strokeColor"); },
    get strokeOpacity() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.strokeOpacity"); },
    get miniChart() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.miniChart"); },
    get histogramBinCount() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.histogramBinCount"); },
    get connectorLine() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.connectorLine"); },
    get seriesItems() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.seriesItems"); },
    get seriesItemType() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.seriesItemType"); },
    get seriesItemPositive() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.seriesItemPositive"); },
    get seriesItemNegative() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.seriesItemNegative"); },
    get seriesItemLabels() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.seriesItemLabels"); },
    get columnGroup() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.columnGroup"); },
    get barGroup() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.barGroup"); },
    get pieGroup() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.pieGroup"); },
    get lineGroup() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.lineGroup"); },
    get scatterGroup() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.scatterGroup"); },
    get areaGroup() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.areaGroup"); },
    get polarGroup() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.polarGroup"); },
    get statisticalGroup() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.statisticalGroup"); },
    get hierarchicalGroup() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.hierarchicalGroup"); },
    get specializedGroup() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.specializedGroup"); },
    get combinationGroup() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.combinationGroup"); },
    get groupedColumnTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.groupedColumnTooltip"); },
    get stackedColumnTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.stackedColumnTooltip"); },
    get normalizedColumnTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.normalizedColumnTooltip"); },
    get groupedBarTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.groupedBarTooltip"); },
    get stackedBarTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.stackedBarTooltip"); },
    get normalizedBarTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.normalizedBarTooltip"); },
    get pieTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.pieTooltip"); },
    get donutTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.donutTooltip"); },
    get lineTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.lineTooltip"); },
    get stackedLineTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.stackedLineTooltip"); },
    get normalizedLineTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.normalizedLineTooltip"); },
    get groupedAreaTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.groupedAreaTooltip"); },
    get stackedAreaTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.stackedAreaTooltip"); },
    get normalizedAreaTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.normalizedAreaTooltip"); },
    get scatterTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.scatterTooltip"); },
    get bubbleTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.bubbleTooltip"); },
    get histogramTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.histogramTooltip"); },
    get radialColumnTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.radialColumnTooltip"); },
    get radialBarTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.radialBarTooltip"); },
    get radarLineTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.radarLineTooltip"); },
    get radarAreaTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.radarAreaTooltip"); },
    get nightingaleTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.nightingaleTooltip"); },
    get rangeBarTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.rangeBarTooltip"); },
    get rangeAreaTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.rangeAreaTooltip"); },
    get boxPlotTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.boxPlotTooltip"); },
    get treemapTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.treemapTooltip"); },
    get sunburstTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.sunburstTooltip"); },
    get waterfallTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.waterfallTooltip"); },
    get heatmapTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.heatmapTooltip"); },
    get columnLineComboTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.columnLineComboTooltip"); },
    get areaColumnComboTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.areaColumnComboTooltip"); },
    get customComboTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.customComboTooltip"); },
    get innerRadius() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.innerRadius"); },
    get startAngle() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.startAngle"); },
    get endAngle() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.endAngle"); },
    get reverseDirection() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.reverseDirection"); },
    get groupPadding() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.groupPadding"); },
    get seriesPadding() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.seriesPadding"); },
    get tile() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.tile"); },
    get whisker() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.whisker"); },
    get cap() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.cap"); },
    get capLengthRatio() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.capLengthRatio"); },
    get labelPlacement() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.labelPlacement"); },
    get inside() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.inside"); },
    get outside() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.outside"); },
    get noDataToChart() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.noDataToChart"); },
    get pivotChartRequiresPivotMode() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.pivotChartRequiresPivotMode"); },
    get chartSettingsToolbarTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.chartSettingsToolbarTooltip"); },
    get chartLinkToolbarTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.chartLinkToolbarTooltip"); },
    get chartUnlinkToolbarTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.chartUnlinkToolbarTooltip"); },
    get chartDownloadToolbarTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.chartDownloadToolbarTooltip"); },
    get chartMenuToolbarTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.chartMenuToolbarTooltip"); },
    get chartEdit() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.chartEdit"); },
    get chartAdvancedSettings() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.chartAdvancedSettings"); },
    get chartLink() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.chartLink"); },
    get chartUnlink() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.chartUnlink"); },
    get chartDownload() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.chartDownload"); },
    get histogramFrequency() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.histogramFrequency"); },
    get seriesChartType() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.seriesChartType"); },
    get seriesType() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.seriesType"); },
    get secondaryAxis() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.secondaryAxis"); },
    get seriesAdd() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.seriesAdd"); },
    get categoryAdd() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.categoryAdd"); },
    get bar() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.bar"); },
    get column() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.column"); },
    get histogram() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.histogram"); },
    get advancedSettings() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.advancedSettings"); },
    get direction() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.direction"); },
    get horizontal() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.horizontal"); },
    get vertical() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.vertical"); },
    get seriesGroupType() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.seriesGroupType"); },
    get groupedSeriesGroupType() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.groupedSeriesGroupType"); },
    get stackedSeriesGroupType() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.stackedSeriesGroupType"); },
    get normalizedSeriesGroupType() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.normalizedSeriesGroupType"); },
    get legendEnabled() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.legendEnabled"); },
    get invalidColor() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.invalidColor"); },
    get groupedColumnFull() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.groupedColumnFull"); },
    get stackedColumnFull() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.stackedColumnFull"); },
    get normalizedColumnFull() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.normalizedColumnFull"); },
    get groupedBarFull() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.groupedBarFull"); },
    get stackedBarFull() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.stackedBarFull"); },
    get normalizedBarFull() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.normalizedBarFull"); },
    get stackedAreaFull() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.stackedAreaFull"); },
    get normalizedAreaFull() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.normalizedAreaFull"); },
    get customCombo() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.customCombo"); },
    get funnel() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.funnel"); },
    get coneFunnel() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.coneFunnel"); },
    get pyramid() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.pyramid"); },
    get funnelGroup() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.funnelGroup"); },
    get funnelTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.funnelTooltip"); },
    get coneFunnelTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.coneFunnelTooltip"); },
    get pyramidTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.pyramidTooltip"); },
    get dropOff() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.dropOff"); },
    get stageLabels() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.stageLabels"); },
    get reverse() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.reverse"); },
    get ariaAdvancedFilterBuilderItem() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaAdvancedFilterBuilderItem"); },
    get ariaAdvancedFilterBuilderItemValidation() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaAdvancedFilterBuilderItemValidation"); },
    get ariaAdvancedFilterBuilderList() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaAdvancedFilterBuilderList"); },
    get ariaAdvancedFilterBuilderFilterItem() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaAdvancedFilterBuilderFilterItem"); },
    get ariaAdvancedFilterBuilderGroupItem() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaAdvancedFilterBuilderGroupItem"); },
    get ariaAdvancedFilterBuilderColumn() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaAdvancedFilterBuilderColumn"); },
    get ariaAdvancedFilterBuilderOption() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaAdvancedFilterBuilderOption"); },
    get ariaAdvancedFilterBuilderValueP() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaAdvancedFilterBuilderValueP"); },
    get ariaAdvancedFilterBuilderJoinOperator() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaAdvancedFilterBuilderJoinOperator"); },
    get ariaAdvancedFilterInput() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaAdvancedFilterInput"); },
    get ariaChecked() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaChecked"); },
    get ariaColumn() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaColumn"); },
    get ariaColumnGroup() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaColumnGroup"); },
    get ariaColumnFiltered() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaColumnFiltered"); },
    get ariaColumnSelectAll() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaColumnSelectAll"); },
    get ariaDateFilterInput() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaDateFilterInput"); },
    get ariaDefaultListName() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaDefaultListName"); },
    get ariaFilterColumnsInput() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaFilterColumnsInput"); },
    get ariaFilterFromValue() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaFilterFromValue"); },
    get ariaFilterInput() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaFilterInput"); },
    get ariaFilterList() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaFilterList"); },
    get ariaFilterToValue() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaFilterToValue"); },
    get ariaFilterValue() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaFilterValue"); },
    get ariaFilterMenuOpen() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaFilterMenuOpen"); },
    get ariaFilteringOperator() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaFilteringOperator"); },
    get ariaHidden() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaHidden"); },
    get ariaIndeterminate() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaIndeterminate"); },
    get ariaInputEditor() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaInputEditor"); },
    get ariaMenuColumn() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaMenuColumn"); },
    get ariaFilterColumn() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaFilterColumn"); },
    get ariaRowDeselect() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaRowDeselect"); },
    get ariaHeaderSelection() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaHeaderSelection"); },
    get ariaSelectAllCells() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaSelectAllCells"); },
    get ariaRowSelectAll() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaRowSelectAll"); },
    get ariaRowToggleSelection() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaRowToggleSelection"); },
    get ariaRowSelect() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaRowSelect"); },
    get ariaRowSelectionDisabled() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaRowSelectionDisabled"); },
    get ariaSearch() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaSearch"); },
    get ariaSortableColumn() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaSortableColumn"); },
    get ariaToggleVisibility() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaToggleVisibility"); },
    get ariaToggleCellValue() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaToggleCellValue"); },
    get ariaUnchecked() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaUnchecked"); },
    get ariaVisible() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaVisible"); },
    get ariaSearchFilterValues() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaSearchFilterValues"); },
    get ariaPageSizeSelectorLabel() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaPageSizeSelectorLabel"); },
    get ariaChartMenuClose() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaChartMenuClose"); },
    get ariaChartSelected() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaChartSelected"); },
    get ariaSkeletonCellLoadingFailed() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaSkeletonCellLoadingFailed"); },
    get ariaSkeletonCellLoading() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaSkeletonCellLoading"); },
    get ariaRowGroupDropZonePanelLabel() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaRowGroupDropZonePanelLabel"); },
    get ariaValuesDropZonePanelLabel() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaValuesDropZonePanelLabel"); },
    get ariaPivotDropZonePanelLabel() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaPivotDropZonePanelLabel"); },
    get ariaDropZoneColumnComponentDescription() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaDropZoneColumnComponentDescription"); },
    get ariaDropZoneColumnValueItemDescription() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaDropZoneColumnValueItemDescription"); },
    get ariaDropZoneColumnGroupItemDescription() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaDropZoneColumnGroupItemDescription"); },
    get ariaDropZoneColumnComponentAggFuncSeparator() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaDropZoneColumnComponentAggFuncSeparator"); },
    get ariaDropZoneColumnComponentSortAscending() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaDropZoneColumnComponentSortAscending"); },
    get ariaDropZoneColumnComponentSortDescending() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaDropZoneColumnComponentSortDescending"); },
    get ariaLabelDialog() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaLabelDialog"); },
    get ariaLabelColumnMenu() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaLabelColumnMenu"); },
    get ariaLabelColumnFilter() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaLabelColumnFilter"); },
    get ariaLabelCellEditor() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaLabelCellEditor"); },
    get ariaLabelSelectField() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaLabelSelectField"); },
    get ariaLabelLoadingContextMenu() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaLabelLoadingContextMenu"); },
    get ariaLabelRichSelectField() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaLabelRichSelectField"); },
    get ariaLabelRichSelectToggleSelection() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaLabelRichSelectToggleSelection"); },
    get ariaLabelRichSelectDeselectAllItems() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaLabelRichSelectDeselectAllItems"); },
    get ariaLabelRichSelectDeleteSelection() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaLabelRichSelectDeleteSelection"); },
    get ariaLabelTooltip() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaLabelTooltip"); },
    get ariaLabelContextMenu() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaLabelContextMenu"); },
    get ariaLabelSubMenu() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaLabelSubMenu"); },
    get ariaLabelAggregationFunction() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaLabelAggregationFunction"); },
    get ariaLabelAdvancedFilterAutocomplete() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaLabelAdvancedFilterAutocomplete"); },
    get ariaLabelAdvancedFilterBuilderAddField() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaLabelAdvancedFilterBuilderAddField"); },
    get ariaLabelAdvancedFilterBuilderColumnSelectField() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaLabelAdvancedFilterBuilderColumnSelectField"); },
    get ariaLabelAdvancedFilterBuilderOptionSelectField() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaLabelAdvancedFilterBuilderOptionSelectField"); },
    get ariaLabelAdvancedFilterBuilderJoinSelectField() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaLabelAdvancedFilterBuilderJoinSelectField"); },
    get ariaColumnPanelList() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaColumnPanelList"); },
    get ariaFilterPanelList() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.ariaFilterPanelList"); },
    get true() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.true"); },
    get false() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.false"); },
    get invalidDate() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.invalidDate"); },
    get invalidNumber() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.invalidNumber"); },
    get january() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.january"); },
    get february() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.february"); },
    get march() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.march"); },
    get april() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.april"); },
    get may() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.may"); },
    get june() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.june"); },
    get july() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.july"); },
    get august() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.august"); },
    get september() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.september"); },
    get october() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.october"); },
    get november() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.november"); },
    get december() { return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.december"); }
};
const ignoredMissingAgGridTranslations = [
    "dateFormatOoo",
    "advancedFilterEquals",
    "advancedFilterNotEqual",
    "advancedFilterGreaterThan",
    "advancedFilterGreaterThanOrEqual",
    "advancedFilterLessThan",
    "advancedFilterLessThanOrEqual",
    "ctrlC",
    "ctrlX",
    "ctrlV",
    "pageLastRowUnknown",
    "thousandSeparator",
    "decimalSeparator",
    "timeFormatSlashesDDMMYYYY",
    "timeFormatSlashesMMDDYYYY",
    "timeFormatSlashesDDMMYY",
    "timeFormatSlashesMMDDYY",
    "timeFormatDotsDDMYYYY",
    "timeFormatDotsMDDYY",
    "timeFormatDashesYYYYMMDD",
    "timeFormatSpacesDDMMMMYYYY",
    "timeFormatHHMMSS",
    "timeFormatHHMMSSAmPm",
    "line",
    "stackedLineFull",
    "normalizedLineFull"
];
const wcGridLocaleText = new Proxy(agGridLocaleText, {
    get(target, prop, receiver) {
        if (prop in target) {
            return Reflect.get(target, prop, receiver);
        }
        if (!ignoredMissingAgGridTranslations.includes(String(prop))) {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`[WcGridLocaleText] Missing translation for localeText key: "${String(prop)}"`);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.MISSING_TRANSLATION, { [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.MISSING_TRANSLATION]: `app.ag-grid.${String(prop)}` }, [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.SERVICE_PROVIDERS.webex_business]);
        }
        return undefined;
    }
});


/***/ }),

/***/ "./src/components/Common/WcGrid/WcGridTabs/WcGridTabs.styles.scss":
/*!************************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcGridTabs/WcGridTabs.styles.scss ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`::part(tabs-content) {
  overflow-y: hidden;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0NvbW1vbi9XY0dyaWQvV2NHcmlkVGFicy9XY0dyaWRUYWJzLnN0eWxlcy5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0Usa0JBQUE7QUFDRiIsInNvdXJjZXNDb250ZW50IjpbIjo6cGFydCh0YWJzLWNvbnRlbnQpIHtcbiAgb3ZlcmZsb3cteTogaGlkZGVuO1xufVxuIl0sInNvdXJjZVJvb3QiOiIifQ== */`);
    

/***/ }),

/***/ "./src/components/Common/WcGrid/WcGridTabs/WcGridTabs.ts":
/*!***************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcGridTabs/WcGridTabs.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WcGridTabs: () => (/* binding */ WcGridTabs),
/* harmony export */   WcGridTabsConfig: () => (/* binding */ WcGridTabsConfig)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html_directives_repeat_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html/directives/repeat.js */ "lit-html/directives/repeat.js");
/* harmony import */ var lit_html_directives_repeat_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _WcGridTabs_styles_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./WcGridTabs.styles.scss */ "./src/components/Common/WcGrid/WcGridTabs/WcGridTabs.styles.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








class WcGridTabsConfig {
    constructor() {
        this.tabs = [];
    }
}
let WcGridTabs = class WcGridTabs extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_2__.MobxLitElement) {
    static get styles() {
        return [_WcGridTabs_styles_scss__WEBPACK_IMPORTED_MODULE_7__["default"]];
    }
    get tabTypes() {
        var _a, _b;
        return (_b = (_a = this.wcGridTabsConfig) === null || _a === void 0 ? void 0 : _a.tabs.map((tab) => tab.type)) !== null && _b !== void 0 ? _b : [];
    }
    get selectedTabIndex() {
        if (!this.selectedTab) {
            return 0;
        }
        const index = this.tabTypes.indexOf(this.selectedTab);
        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`Selected tab index: ${index}`);
        return index >= 0 ? index : 0;
    }
    onSelectedTabChanged(e) {
        e.stopPropagation();
        const { value, tabsOrder } = e.detail;
        const tab = tabsOrder[value];
        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`Selected tab changed to ${tab}`);
        if (tab === this.selectedTab) {
            return;
        }
        this.selectedTab = tab;
    }
    getTabPanelContent(type, template) {
        if (type === this.selectedTab) {
            return template;
        }
        return lit_html__WEBPACK_IMPORTED_MODULE_5__.nothing;
    }
    updated(changedProperties) {
        var _a, _b, _c;
        super.updated(changedProperties);
        if (changedProperties.has("wcGridTabsConfig")) {
            const currentTabExists = this.tabTypes.includes((_a = this.selectedTab) !== null && _a !== void 0 ? _a : "");
            if (!currentTabExists) {
                this.selectedTab = (_c = (_b = this.wcGridTabsConfig) === null || _b === void 0 ? void 0 : _b.defaultTab) !== null && _c !== void 0 ? _c : this.tabTypes[0];
            }
        }
    }
    render() {
        var _a, _b;
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
      <md-tabs
        selected-index=${this.selectedTabIndex}
        newMomentum
        type="rounded"
        variant="primary"
        scroll-arrow
        @selected-changed=${(e) => {
            this.onSelectedTabChanged(e);
        }}
      >
        ${(0,lit_html_directives_repeat_js__WEBPACK_IMPORTED_MODULE_6__.repeat)((_b = (_a = this.wcGridTabsConfig) === null || _a === void 0 ? void 0 : _a.tabs) !== null && _b !== void 0 ? _b : [], (tab) => tab.type, (tab) => {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
              <md-tab slot="tab" type="rounded" variant="primary" newMomentum name="${tab.type}">${tab.title}</md-tab>
              <md-tab-panel slot="panel">${this.getTabPanelContent(tab.type, tab.tabTemplate)}</md-tab-panel>
            `;
        })}
      </md-tabs>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Object })
], WcGridTabs.prototype, "wcGridTabsConfig", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
], WcGridTabs.prototype, "selectedTab", void 0);
WcGridTabs = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.customElement)("wc-grid-tabs")
], WcGridTabs);



/***/ }),

/***/ "./src/components/Common/WcGrid/index.ts":
/*!***********************************************!*\
  !*** ./src/components/Common/WcGrid/index.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SortOrder: () => (/* reexport safe */ _WcGrid_constants__WEBPACK_IMPORTED_MODULE_3__.SortOrder),
/* harmony export */   WcGridColumn: () => (/* reexport safe */ _WcColumns_WcGridColumn__WEBPACK_IMPORTED_MODULE_1__.WcGridColumn),
/* harmony export */   WcGridConfig: () => (/* reexport safe */ _WcGridConfig__WEBPACK_IMPORTED_MODULE_5__.WcGridConfig),
/* harmony export */   WcGridExportType: () => (/* reexport safe */ _WcGrid_types__WEBPACK_IMPORTED_MODULE_4__.WcGridExportType),
/* harmony export */   WcGridWidget: () => (/* reexport safe */ _WcGrid__WEBPACK_IMPORTED_MODULE_2__.WcGridWidget)
/* harmony export */ });
/* harmony import */ var _DataSources_WcServerSideDataSource_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DataSources/WcServerSideDataSource.types */ "./src/components/Common/WcGrid/DataSources/WcServerSideDataSource.types.ts");
/* harmony import */ var _WcColumns_WcGridColumn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./WcColumns/WcGridColumn */ "./src/components/Common/WcGrid/WcColumns/WcGridColumn.ts");
/* harmony import */ var _WcGrid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./WcGrid */ "./src/components/Common/WcGrid/WcGrid.ts");
/* harmony import */ var _WcGrid_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./WcGrid.constants */ "./src/components/Common/WcGrid/WcGrid.constants.ts");
/* harmony import */ var _WcGrid_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./WcGrid.types */ "./src/components/Common/WcGrid/WcGrid.types.ts");
/* harmony import */ var _WcGridConfig__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./WcGridConfig */ "./src/components/Common/WcGrid/WcGridConfig.ts");








/***/ }),

/***/ "./src/components/Common/WidgetError/WidgetError.scss":
/*!************************************************************!*\
  !*** ./src/components/Common/WidgetError/WidgetError.scss ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

* {
  /* BASE LEVEL < 100 */
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-index-tpw-header: 1;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-index-task-collapse-area: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-navigation-bar: 12;
  --z-index-task-list: 12;
  --z-index-wrap-up: 13;
  --z-index-sticky-header: 14;
  --z-index-shortcutkey-modal: 15;
  /* MID LEVEL FLOATING > 100 < 1000 */
  --z-index-notification: 150;
  /* SUPER LEVEL > 1000 */
  --z-index-modal: 1040;
  --z-index-popover: 1041;
  --z-index-callback-modal: 1042;
  /* This below order needs to be unchanged. Highest priority is for connection loss overlay,
         followed by error modal since error can occur during app load such as teams failure/register failure. */
  --z-index-app-full-overlay: 1050;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1200;
}

:host {
  height: 100%;
  width: 100%;
  display: flex;
}

.widget-error {
  align-items: center;
  justify-content: center;
  display: flex;
  width: 100%;
  height: 100%;
  border-radius: var(--border-radius-medium);
  background-color: var(--md-primary-bg-color);
  color: var(--md-primary-text-color);
  max-height: 312px;
}
.widget-error-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.widget-error-icon {
  background-color: var(--badge-red-bg-color);
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  margin-bottom: calc(var(--space-token-cardinal) * 2);
}
.widget-error-icon md-icon {
  color: var(--input-error-message-text-color);
}
.widget-error-heading {
  font-size: var(--font-size-large);
  margin: 0 auto calc(var(--space-token-cardinal) * 6);
  text-align: center;
}
.widget-error-detail {
  padding: calc(var(--space-token-cardinal) * 2);
  display: flex;
  flex-direction: column;
  max-width: 80%;
  margin: 0 auto;
  align-items: center;
  overflow: hidden;
}
.widget-error-toggle {
  text-decoration: underline;
  margin-bottom: calc(var(--space-token-cardinal) * 2) 0;
  cursor: pointer;
  position: relative;
  z-index: var(--z-overflow-scroll-button, 1);
}
.widget-error-info {
  max-height: 0;
  opacity: 0;
  display: flex;
  flex-direction: column;
  text-align: center;
  transition: max-height 0.25s, opacity 0.25s;
  font-size: var(--font-size-small);
}
.widget-error-info.visible {
  max-height: 100px;
  opacity: 1;
}
.widget-error-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: calc(var(--space-token-cardinal) * 2) 0;
}
.widget-error .trackingid-label {
  display: flex;
  flex: 0 0 auto;
}
.widget-error .trackingid-input {
  margin: 0 calc(var(--space-token-cardinal) * 2);
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.widget-error .copy-trackingid-icon {
  color: var(--md-default-focus-outline-color);
  display: flex;
  flex: 0 0 auto;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Common/WidgetError/WidgetError.ts":
/*!**********************************************************!*\
  !*** ./src/components/Common/WidgetError/WidgetError.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WidgetError: () => (/* binding */ WidgetError)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _WidgetError_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./WidgetError.scss */ "./src/components/Common/WidgetError/WidgetError.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var WidgetError;
(function (WidgetError) {
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.show = false;
            this.hideDetails = false;
            this.isCopied = false;
        }
        retry() {
            this.dispatchEvent(new CustomEvent("reload", {
                composed: true,
                bubbles: true
            }));
        }
        copyTrackingID() {
            var _a;
            const text = (_a = this.detail) === null || _a === void 0 ? void 0 : _a.trackingId;
            const inputTemp = document.createElement("input");
            if (inputTemp && text) {
                inputTemp.value = text;
                document.body.appendChild(inputTemp);
                inputTemp.select();
                document.execCommand("copy");
                document.body.removeChild(inputTemp);
                this.isCopied = true;
                setTimeout(() => {
                    this.isCopied = false;
                }, 1500);
            }
        }
        showMore() {
            this.show = !this.show;
        }
        get widgetErrorClassMap() {
            return {
                visible: this.show
            };
        }
        static get styles() {
            return _WidgetError_scss__WEBPACK_IMPORTED_MODULE_5__["default"];
        }
        render() {
            var _a, _b, _c;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="widget-error">
          <div class="widget-error-content">
            <div class="widget-error-icon">
              <md-icon name="icon-warning_32"></md-icon>
            </div>
            <strong class="widget-error-heading">${((_a = this.detail) === null || _a === void 0 ? void 0 : _a.header) || (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:commonWebComp.loadFail")}</strong>
            ${!this.hideDetails
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
                  <md-button ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:commonWebComp.tryAgain")}" @click=${this.retry} variant="primary"
                    >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:commonWebComp.tryAgain")}</md-button
                  >
                  <div class="widget-error-detail">
                    <span class="widget-error-toggle" @click="${this.showMore}" part="widget-error-btn">
                      ${this.show
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorDetail.errorLessButton")} `
                    : (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorDetail.errorMoreButton")} `}
                    </span>
                    <div class="widget-error-info ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__.classMap)(this.widgetErrorClassMap)}">
                      <span>${(_b = this.detail) === null || _b === void 0 ? void 0 : _b.message}</span>
                      <div class="widget-error-wrapper">
                        <label class="trackingid-label">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorModal.trackingIdLabel")}:</label>
                        <div id="trackingid-input" class="trackingid-input">${(_c = this.detail) === null || _c === void 0 ? void 0 : _c.trackingId}</div>
                        <md-icon
                          id="copy-trackingid-icon"
                          name=${this.isCopied ? "icon-check_12" : "icon-copy_12"}
                          title=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorModal.trackingIdTitle")}
                          class="copy-trackingid-icon"
                          @click=${this.copyTrackingID}
                          ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorModal.trackingIdTitle")}
                          tabindex="0"
                        ></md-icon>
                      </div>
                    </div>
                  </div>
                `
                : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
          </div>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "show", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "detail", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "hideDetails", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "isCopied", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.query)(".trackingid-input")
    ], Element.prototype, "trackID", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-widget-error")
    ], Element);
    WidgetError.Element = Element;
})(WidgetError || (WidgetError = {}));


/***/ }),

/***/ "./src/components/Common/WidgetLoader/WidgetLoader.scss":
/*!**************************************************************!*\
  !*** ./src/components/Common/WidgetLoader/WidgetLoader.scss ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

.widget-loader {
  justify-content: center;
  display: flex;
  width: 100%;
  height: 100%;
  border-radius: var(--border-radius-medium);
  background-color: var(--md-primary-bg-color);
  color: var(--md-primary-text-color);
  max-height: 312px;
}
.widget-loader-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.widget-loader-heading {
  font-size: var(--font-size-large);
  padding-top: calc(var(--space-token-even) * 3);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Common/WidgetLoader/WidgetLoader.ts":
/*!************************************************************!*\
  !*** ./src/components/Common/WidgetLoader/WidgetLoader.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WidgetLoader: () => (/* binding */ WidgetLoader)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _WidgetLoader_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./WidgetLoader.scss */ "./src/components/Common/WidgetLoader/WidgetLoader.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */




var WidgetLoader;
(function (WidgetLoader) {
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        static get styles() {
            return _WidgetLoader_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="widget-loader">
          <div class="widget-loader-wrapper">
            <md-spinner role="alert" aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:commonWebComp.loading")} size="56"></md-spinner>
            <strong class="widget-loader-heading">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:commonWebComp.loading")}...</strong>
          </div>
        </div>
      `;
        }
    };
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-widget-loader")
    ], Element);
    WidgetLoader.Element = Element;
})(WidgetLoader || (WidgetLoader = {}));


/***/ }),

/***/ "./src/components/CountDownTimer/CountDownTimer.ts":
/*!*********************************************************!*\
  !*** ./src/components/CountDownTimer/CountDownTimer.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CountDownTimer: () => (/* binding */ CountDownTimer)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _open_wc_testing_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @open-wc/testing-helpers */ "@open-wc/testing-helpers");
/* harmony import */ var _open_wc_testing_helpers__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_open_wc_testing_helpers__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _TeamPerformanceWidget_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../TeamPerformanceWidget/TeamPerformanceUtils */ "./src/components/TeamPerformanceWidget/TeamPerformanceUtils.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var CountDownTimer;
(function (CountDownTimer) {
    /**
     * @element agentx-wc-count-down-timer
     * @fires close-inactivity-modal
     * @fires countdown-start
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
        constructor() {
            super(...arguments);
            this.countdownStartTime = 0; //seconds
            this.isDurationTimer = false;
            this.showDefaultHours = true;
            this.duration = "0";
            this.futureTimeStamp = luxon__WEBPACK_IMPORTED_MODULE_5__.DateTime.local().plus({ seconds: this.countdownStartTime });
            this.durationTimer = () => {
                this.durationTime = (0,_TeamPerformanceWidget_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_6__.getTimerValue)(this.duration, this.showDefaultHours);
            };
            this.countdownTimer = () => {
                if (parseInt(this.futureTimeStamp.diff(luxon__WEBPACK_IMPORTED_MODULE_5__.DateTime.local()).toFormat("ss")) > 0) {
                    this.requestUpdate();
                }
                else {
                    _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_2__.clearInterval(this.intervalId);
                    this.dispatchEvent(new CustomEvent("close-inactivity-modal", { bubbles: true, detail: true }));
                }
            };
        }
        connectedCallback() {
            super.connectedCallback();
            if (this.isDurationTimer) {
                if (this.duration !== "0") {
                    this.intervalId = setInterval(this.durationTimer, 1000);
                }
            }
            else {
                this.futureTimeStamp = luxon__WEBPACK_IMPORTED_MODULE_5__.DateTime.local().plus({ seconds: this.countdownStartTime });
                this.intervalId = _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_2__.setInterval(this.countdownTimer, 1000);
                this.dispatchEvent(new CustomEvent("countdown-start", { bubbles: true, detail: { intervalId: this.intervalId } }));
            }
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            clearInterval(this.intervalId);
        }
        render() {
            var _a;
            return !this.isDurationTimer
                ? this.countdownStartTime > 0
                    ? (0,_open_wc_testing_helpers__WEBPACK_IMPORTED_MODULE_1__.html) `
              <span class="timeperiod">
                <time role="timer">${this.futureTimeStamp.diff(luxon__WEBPACK_IMPORTED_MODULE_5__.DateTime.local()).toFormat("ss")}</time>
              </span>
            `
                    : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing
                : (0,_open_wc_testing_helpers__WEBPACK_IMPORTED_MODULE_1__.html) `
            <time role="timer" datetime=${(_a = this.durationTime) !== null && _a !== void 0 ? _a : ""}>
              ${this.durationTime && this.durationTime !== "Invalid Duration" ? this.durationTime : "-"}
            </time>
          `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)()
    ], Element.prototype, "countdownStartTime", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)()
    ], Element.prototype, "isDurationTimer", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)()
    ], Element.prototype, "showDefaultHours", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)()
    ], Element.prototype, "duration", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "futureTimeStamp", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "intervalId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "durationTime", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-count-down-timer")
    ], Element);
    CountDownTimer.Element = Element;
})(CountDownTimer || (CountDownTimer = {}));


/***/ }),

/***/ "./src/components/EmergencyNotification/EmergencyNotificationContent.scss":
/*!********************************************************************************!*\
  !*** ./src/components/EmergencyNotification/EmergencyNotificationContent.scss ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.emergency-notification-content {
  font-size: 14px;
  line-height: 21px;
}
.emergency-notification-content .md-alert-banner__text {
  padding: 0;
}

.heading {
  font-weight: 700;
  margin: 8px 0px;
}

label {
  color: var(--md-secondary-text-color);
}

md-link::part(link) {
  color: var(--alert-banner-warning-text-color);
}

.emergency-modal-warning-content {
  display: flex;
  text-align: start;
  margin-left: -1.75rem;
  margin-right: -1.75rem;
}

.emergency-modal-warning-text {
  margin-left: 10px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0VtZXJnZW5jeU5vdGlmaWNhdGlvbi9FbWVyZ2VuY3lOb3RpZmljYXRpb25Db250ZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxlQUFBO0VBQ0EsaUJBQUE7QUFDRjtBQUFFO0VBQ0UsVUFBQTtBQUVKOztBQUVBO0VBQ0UsZ0JBQUE7RUFDQSxlQUFBO0FBQ0Y7O0FBRUE7RUFDRSxxQ0FBQTtBQUNGOztBQUVBO0VBQ0UsNkNBQUE7QUFDRjs7QUFFQTtFQUNFLGFBQUE7RUFDQSxpQkFBQTtFQUNBLHFCQUFBO0VBQ0Esc0JBQUE7QUFDRjs7QUFFQTtFQUNFLGlCQUFBO0FBQ0YiLCJzb3VyY2VzQ29udGVudCI6WyIuZW1lcmdlbmN5LW5vdGlmaWNhdGlvbi1jb250ZW50IHtcbiAgZm9udC1zaXplOiAxNHB4O1xuICBsaW5lLWhlaWdodDogMjFweDtcbiAgLm1kLWFsZXJ0LWJhbm5lcl9fdGV4dCB7XG4gICAgcGFkZGluZzogMDtcbiAgfVxufVxuXG4uaGVhZGluZyB7XG4gIGZvbnQtd2VpZ2h0OiA3MDA7XG4gIG1hcmdpbjogOHB4IDBweDtcbn1cblxubGFiZWwge1xuICBjb2xvcjogdmFyKC0tbWQtc2Vjb25kYXJ5LXRleHQtY29sb3IpO1xufVxuXG5tZC1saW5rOjpwYXJ0KGxpbmspIHtcbiAgY29sb3I6IHZhcigtLWFsZXJ0LWJhbm5lci13YXJuaW5nLXRleHQtY29sb3IpO1xufVxuXG4uZW1lcmdlbmN5LW1vZGFsLXdhcm5pbmctY29udGVudCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIHRleHQtYWxpZ246IHN0YXJ0O1xuICBtYXJnaW4tbGVmdDogLTEuNzVyZW07XG4gIG1hcmdpbi1yaWdodDogLTEuNzVyZW07XG59XG5cbi5lbWVyZ2VuY3ktbW9kYWwtd2FybmluZy10ZXh0IHtcbiAgbWFyZ2luLWxlZnQ6IDEwcHg7XG59XG4iXSwic291cmNlUm9vdCI6IiJ9 */`);
    

/***/ }),

/***/ "./src/components/EmergencyNotification/EmergencyNotificationContent.ts":
/*!******************************************************************************!*\
  !*** ./src/components/EmergencyNotification/EmergencyNotificationContent.ts ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EmergencyNotificationContent: () => (/* binding */ EmergencyNotificationContent)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _EmergencyNotificationContent_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./EmergencyNotificationContent.scss */ "./src/components/EmergencyNotification/EmergencyNotificationContent.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};





var EmergencyNotificationContent;
(function (EmergencyNotificationContent) {
    /**
     * @element agentx-wc-emergency-notification-content
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
        static get styles() {
            return _EmergencyNotificationContent_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
        }
        firstUpdated() {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function* () {
                const link = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-link");
                if (link) {
                    yield link.updateComplete;
                    const linkAnchor = (_b = link.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("a");
                    linkAnchor === null || linkAnchor === void 0 ? void 0 : linkAnchor.focus();
                }
            });
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div class="emergency-notification-container">
          <div class="emergency-notification-content">
            <md-alert-banner class="md-alert-banner-wrapper" show type="warning">
              <div class="emergency-modal-warning-content">
                <md-icon aria-hidden="true" name="warning-badge-filled" size="14" iconSet="momentumDesign"></md-icon>
                <div
                  class="emergency-modal-warning-text"
                  aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:emergencyServiceNotification.updateCurrentAddressContent")}"
                >
                  ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:emergencyServiceNotification.updateCurrentAddressContent")}
                  <md-link
                    inline
                    class="help-section-link"
                    aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:emergencyServiceNotification.seeHelpSection")}
                    tag="a"
                    href=${_constants__WEBPACK_IMPORTED_MODULE_0__.emergency911HelpLink}
                    target="_blank"
                    >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:emergencyServiceNotification.seeHelpSection")}</md-link
                  >
                </div>
              </div>
            </md-alert-banner>
          </div>
          <div class="emergency-notification-content">
            <div class="heading">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:emergencyServiceNotification.dialingEmergencyServices")}</div>
            <label>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:emergencyServiceNotification.dialingEmergencyServicesContent")}</label>
          </div>
        </div>
      `;
        }
    };
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-emergency-notification-content")
    ], Element);
    EmergencyNotificationContent.Element = Element;
})(EmergencyNotificationContent || (EmergencyNotificationContent = {}));


/***/ }),

/***/ "./src/components/EvaluationManager/EvaluationManagerForm.scss":
/*!*********************************************************************!*\
  !*** ./src/components/EvaluationManager/EvaluationManagerForm.scss ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  /* Spacing */
  --spacing-small: 10px;
  --spacing-medium: 16px;
  --spacing-large: 20px;
  --gap-medium: 12px;
  --button-padding-vertical: 10px;
  --button-padding-horizontal: 20px;
  /* Borders */
  --border-radius-small: 8px;
  /* Widths */
  --max-input-width: 400px;
  /* Heights */
  --full-height: 100%;
}

.evaluation-manager__form md-input::part(input) {
  max-width: var(--max-input-width);
}
.evaluation-manager__form .form-item__container {
  border-radius: var(--border-radius-small);
  margin: 0 var(--spacing-small) var(--spacing-large);
  display: grid;
  grid-template-rows: auto auto;
  padding: var(--spacing-medium);
  border: 1px solid var(--color-link);
  border-left-width: 25px;
}
.evaluation-manager__form .remove-item__button {
  justify-self: end;
  align-self: start;
}
.evaluation-manager__form .form__footer {
  display: flex;
  justify-content: flex-end;
  gap: var(--gap-medium);
  padding: var(--button-padding-vertical) var(--button-padding-horizontal);
}
.evaluation-manager__form .outer__details {
  display: grid;
  grid-template-columns: 2fr 1fr;
}
.evaluation-manager__form .questions__container {
  margin-left: var(--spacing-large);
}
.evaluation-manager__form .answers__container {
  margin-left: var(--spacing-large);
}
.evaluation-manager__form .answers__container .answer {
  align-items: center;
  display: grid;
  width: 25%;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: var(--grid-template-rows);
  background: white;
}
.evaluation-manager__form .form-header__container {
  display: flex;
}
.evaluation-manager__form .form-header__container .form-header__name {
  margin-top: 0.2rem;
  font-size: 1rem;
  font-weight: 700;
  flex-grow: 1;
}
.evaluation-manager__form .form-header__container .form-header__name span {
  font-style: italic;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/EvaluationManager/EvaluationManagerForm.ts":
/*!*******************************************************************!*\
  !*** ./src/components/EvaluationManager/EvaluationManagerForm.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EvaluationManagerForm: () => (/* binding */ EvaluationManagerForm),
/* harmony export */   FormActionType: () => (/* binding */ FormActionType)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! mobx */ "mobx");
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(mobx__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _EvaluationManagerForm_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./EvaluationManagerForm.scss */ "./src/components/EvaluationManager/EvaluationManagerForm.scss");
/* harmony import */ var _EvaluationManagerTable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./EvaluationManagerTable */ "./src/components/EvaluationManager/EvaluationManagerTable.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};





// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Tech debt, mobx observables should only be defined in a store



var FormActionType;
(function (FormActionType) {
    FormActionType["SAVE"] = "Save";
    FormActionType["PUBLISH"] = "Publish";
})(FormActionType || (FormActionType = {}));
let EvaluationManagerForm = class EvaluationManagerForm extends _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_2__.MobxLitElement {
    updated(changedProperties) {
        if (changedProperties.has("selectedForm") && this.selectedForm) {
            this.updateForm(this.selectedForm);
        }
    }
    constructor() {
        super();
        this.formData = {
            id: "",
            name: "",
            description: "",
            sections: [],
            status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.AgentPerformanceTypes.EvaluationStatus.DRAFT
        };
        this.mode = _EvaluationManagerTable__WEBPACK_IMPORTED_MODULE_7__.ViewMode.CREATE;
        (0,mobx__WEBPACK_IMPORTED_MODULE_5__.makeObservable)(this);
        this.initializeFormData();
    }
    //Mobx actions for updating form data
    initializeFormData() {
        this.formData = {
            id: "",
            name: "",
            description: "",
            sections: [],
            status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.AgentPerformanceTypes.EvaluationStatus.DRAFT
        };
    }
    updateForm(form) {
        this.formData = form;
    }
    updateSectionField(index, name) {
        this.formData.sections[index].name = name;
    }
    addSection() {
        this.formData.sections = [...this.formData.sections, { id: "", name: "", questions: [] }];
    }
    removeSection(index) {
        this.formData.sections.splice(index, 1);
    }
    updateField(field, value) {
        this.formData[field] = value;
    }
    updateQuestionTooltipText(sectionIndex, questionIndex, value) {
        this.formData.sections[sectionIndex].questions[questionIndex].tooltipText = value;
    }
    updateQuestionField(sectionIndex, questionIndex, value) {
        this.formData.sections[sectionIndex].questions[questionIndex].text = value;
    }
    addQuestion(sectionIndex) {
        this.formData.sections[sectionIndex].questions.push({
            id: "",
            text: "",
            tooltipText: "",
            type: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.AgentPerformanceTypes.QuestionType.SINGLE_CHOICE,
            weight: 0,
            autoFailThreshold: 0,
            options: [
                { text: "Yes", weight: "100", autoFail: false },
                { text: "No", weight: "0", autoFail: false }
            ]
        });
    }
    removeQuestion(sectionIndex, questionIndex) {
        this.formData.sections[sectionIndex].questions.splice(questionIndex, 1);
    }
    updateAnswerField(sectionIndex, questionIndex, optionIndex, field, value) {
        this.formData.sections[sectionIndex].questions[questionIndex].options[optionIndex][field] = value;
    }
    getFormData() {
        return this.formData;
    }
    handleInput(callback) {
        return (event) => {
            const input = event.target;
            callback(input.value);
        };
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
      <md-form class="evaluation-manager__form">
        <div>${this.renderFormHeader()}</div>
        <div>${this.renderFormDetails()}</div>

        <h4>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.sectionsHeader")}</h4>
        <div>${this.formData.sections.map((section, sectionIndex) => this.renderSection(section, sectionIndex))}</div>

        <md-button class="add-section__button" variant="primary" @click=${this.addSection}
          >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.addSection")}</md-button
        >

        <div class="form__footer">
          <md-button
            class="draft__button"
            @click=${() => this.handleFormAction(FormActionType.SAVE)}
            variant="secondary"
            >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.saveAsDraft")}</md-button
          >
          <md-button
            class="publish__button"
            @click=${() => this.handleFormAction(FormActionType.PUBLISH)}
            variant="primary"
            >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.publishForm")}</md-button
          >
        </div>
      </md-form>
    `;
    }
    handleFormAction(formAction) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const formId = yield this.persistForm();
                if (!formId) {
                    return;
                }
                if (formAction === FormActionType.PUBLISH) {
                    const { orgId } = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.conf.profile;
                    yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.agentPerformance.publishEvaluationForm({ orgId, formId });
                }
                this.dispatchSetModeEvent(_EvaluationManagerTable__WEBPACK_IMPORTED_MODULE_7__.ViewMode.LIST);
            }
            catch (error) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("Failed to save evaluation form", error);
            }
        });
    }
    persistForm() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.conf.profile) {
                    throw new Error("Profile not found. Cannot persist form.");
                }
                const { orgId } = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.conf.profile;
                const cleanFormData = this.omitEmptyIds();
                if (this.mode === _EvaluationManagerTable__WEBPACK_IMPORTED_MODULE_7__.ViewMode.EDIT && this.selectedForm) {
                    yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.agentPerformance.updateEvaluationForm({
                        orgId,
                        formId: this.selectedForm.id,
                        data: cleanFormData
                    });
                    return this.selectedForm.id;
                }
                else {
                    const savedForm = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.agentPerformance.saveEvaluationForm({
                        orgId,
                        data: cleanFormData
                    });
                    if (!(savedForm === null || savedForm === void 0 ? void 0 : savedForm.id)) {
                        throw new Error("Failed to retrieve saved form ID.");
                    }
                    return savedForm.id;
                }
            }
            catch (error) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("Failed to persist form", error);
                return null;
            }
        });
    }
    omitEmptyIds() {
        return JSON.parse(JSON.stringify((0,mobx__WEBPACK_IMPORTED_MODULE_5__.toJS)(this.formData), (key, value) => {
            return key === "id" && !value ? undefined : value;
        }));
    }
    dispatchSetModeEvent(mode) {
        this.dispatchEvent(new CustomEvent("set-mode-event", {
            detail: { mode },
            bubbles: true,
            composed: true
        }));
    }
    renderFormHeader() {
        var _a;
        const title = this.mode === _EvaluationManagerTable__WEBPACK_IMPORTED_MODULE_7__.ViewMode.EDIT
            ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.editingForm", ((_a = this.selectedForm) === null || _a === void 0 ? void 0 : _a.name) || (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.form"))
            : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.createNewForm");
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
      <div class="form-header__container">
        <h3 class="form-header__name">${title}</h3>
        <div class="close-icon">
          <md-button
            variant="white"
            @click=${() => this.dispatchSetModeEvent(_EvaluationManagerTable__WEBPACK_IMPORTED_MODULE_7__.ViewMode.LIST)}
            circle
            ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.close")}
          >
            <md-icon name="cancel-bold" iconSet="momentumDesign"></md-icon>
          </md-button>
        </div>
      </div>
    `;
    }
    renderFormDetails() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
      <md-input
        name="name"
        label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.formNameLabel")}"
        value=${this.formData.name}
        placeholder="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.formNameLabel")}"
        @input=${this.handleInput((value) => this.updateField("name", value))}
      ></md-input>

      <md-input
        name="description"
        label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.formDescriptionLabel")}"
        value=${this.formData.description}
        placeholder="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.formDescriptionLabel")}"
        @input=${this.handleInput((value) => this.updateField("description", value))}
      ></md-input>
    `;
    }
    renderSection(section, sectionIndex) {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
      <div class="form-item__container">
        <div class="outer__details">
          <div class="section__inputs">
            <md-input
              label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.sectionNameLabel")}"
              value=${section.name}
              placeholder="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.sectionNameLabel")}"
              @input=${this.handleInput((value) => this.updateSectionField(sectionIndex, value))}
            ></md-input>
            </div>
            <md-button
                class="remove-item__button section"
                circle
                color="red"
                outline
                @click=${() => this.removeSection(sectionIndex)}
              >
                <md-icon name="delete-bold" size="16" iconSet="momentumDesign"></md-icon>
              </md-button>

            <div class="questions__container">
              <h4>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.questionsHeader")}</h4>
              <div>
                ${section.questions.map((question, questionIndex) => this.renderQuestion(sectionIndex, question, questionIndex))}
              </div>
              <md-button class="add-question__button" variant="primary" @click=${() => this.addQuestion(sectionIndex)}>
                ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.addQuestion")}
              </md-button>
            </div>
          </div>
        </div>
      </div>
    `;
    }
    renderQuestion(sectionIndex, question, questionIndex) {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
      <div class="form-item__container">
        <div class="outer__details">
          <div class="question__inputs">
            <md-input
              class="question__input"
              label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.questionsLabel")} ${questionIndex + 1}"
              value=${question.text}
              placeholder="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.questionPlaceholder")}"
              @input=${this.handleInput((value) => this.updateQuestionField(sectionIndex, questionIndex, value))}
            ></md-input>

            <md-input
              class="question__input"
              label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.questionDescription")}"
              value=${question.tooltipText || ""}
              placeholder="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.questionDescription")}"
              @input=${this.handleInput((value) => this.updateQuestionTooltipText(sectionIndex, questionIndex, value))}
            ></md-input>
          </div>
          <md-button
            class="remove-item__button question"
            circle
            color="red"
            outline
            @click=${() => this.removeQuestion(sectionIndex, questionIndex)}
          >
            <md-icon name="delete-bold" size="16" iconSet="momentumDesign"></md-icon>
          </md-button>
        </div>

        <div class="answers__container">
          <h4>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.answersHeader")}</h4>
          <div>
            ${question.options.map((option, optionIndex) => this.renderAnswer(sectionIndex, questionIndex, option, optionIndex))}
          </div>
        </div>
      </div>
    `;
    }
    renderAnswer(sectionIndex, questionIndex, option, optionIndex) {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
      <div class="answer">
        <span>${option.text}</span>

        <md-input
          label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.weightLabel")}"
          type="number"
          name="weight"
          value=${option.weight}
          @input=${this.handleInput((value) => this.updateAnswerField(sectionIndex, questionIndex, optionIndex, "weight", value))}
        ></md-input>
      </div>
    `;
    }
    static get styles() {
        return _EvaluationManagerForm_scss__WEBPACK_IMPORTED_MODULE_6__["default"];
    }
};
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.observable
], EvaluationManagerForm.prototype, "formData", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
], EvaluationManagerForm.prototype, "mode", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Object })
], EvaluationManagerForm.prototype, "selectedForm", void 0);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.action
], EvaluationManagerForm.prototype, "initializeFormData", null);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.action
], EvaluationManagerForm.prototype, "updateForm", null);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.action
], EvaluationManagerForm.prototype, "updateSectionField", null);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.action
], EvaluationManagerForm.prototype, "addSection", null);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.action
], EvaluationManagerForm.prototype, "removeSection", null);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.action
], EvaluationManagerForm.prototype, "updateField", null);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.action
], EvaluationManagerForm.prototype, "updateQuestionTooltipText", null);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.action
], EvaluationManagerForm.prototype, "updateQuestionField", null);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.action
], EvaluationManagerForm.prototype, "addQuestion", null);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.action
], EvaluationManagerForm.prototype, "removeQuestion", null);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.action
], EvaluationManagerForm.prototype, "updateAnswerField", null);
EvaluationManagerForm = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.customElement)("agentx-wc-evaluation-manager-form")
], EvaluationManagerForm);



/***/ }),

/***/ "./src/components/EvaluationManager/EvaluationManagerTable.scss":
/*!**********************************************************************!*\
  !*** ./src/components/EvaluationManager/EvaluationManagerTable.scss ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  /* Spacing */
  --spacing-small: 10px;
  --spacing-medium: 16px;
  --spacing-large: 20px;
  --gap-medium: 12px;
  --button-padding-vertical: 10px;
  --button-padding-horizontal: 20px;
  /* Borders */
  --border-radius-small: 8px;
  /* Widths */
  --max-input-width: 400px;
  /* Heights */
  --full-height: 100%;
}

:host {
  height: var(--full-height);
}

.table__container {
  height: var(--full-height);
  padding: var(--spacing-large);
}

.table__header {
  display: flex;
  justify-content: end;
  align-items: center;
  padding-bottom: var(--spacing-small);
}

.create__button {
  padding: var(--button-padding-vertical) var(--button-padding-horizontal);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/EvaluationManager/EvaluationManagerTable.ts":
/*!********************************************************************!*\
  !*** ./src/components/EvaluationManager/EvaluationManagerTable.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EvaluationManagerTable: () => (/* binding */ EvaluationManagerTable),
/* harmony export */   ViewMode: () => (/* binding */ ViewMode),
/* harmony export */   formDefinitionColumn: () => (/* binding */ formDefinitionColumn)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Common_WcGrid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Common/WcGrid */ "./src/components/Common/WcGrid/index.ts");
/* harmony import */ var _Common_WcGrid_WcColumns_ActionsButtonsColumn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Common/WcGrid/WcColumns/ActionsButtonsColumn */ "./src/components/Common/WcGrid/WcColumns/ActionsButtonsColumn.ts");
/* harmony import */ var _Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Common/WcGrid/WcColumns/StringColumn */ "./src/components/Common/WcGrid/WcColumns/StringColumn.ts");
/* harmony import */ var _Common_WcGrid_WcGrid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Common/WcGrid/WcGrid */ "./src/components/Common/WcGrid/WcGrid.ts");
/* harmony import */ var _EvaluationManagerTable_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./EvaluationManagerTable.scss */ "./src/components/EvaluationManager/EvaluationManagerTable.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};









var formDefinitionColumn;
(function (formDefinitionColumn) {
    formDefinitionColumn["Name"] = "name";
    formDefinitionColumn["Description"] = "description";
    formDefinitionColumn["Status"] = "status";
    formDefinitionColumn["Actions"] = "actions";
    formDefinitionColumn["ID"] = "id";
})(formDefinitionColumn || (formDefinitionColumn = {}));
var ViewMode;
(function (ViewMode) {
    ViewMode["LIST"] = "list";
    ViewMode["CREATE"] = "create";
    ViewMode["EDIT"] = "edit";
    ViewMode["LOADING"] = "loading";
})(ViewMode || (ViewMode = {}));
let EvaluationManagerTable = class EvaluationManagerTable extends lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement {
    constructor() {
        super(...arguments);
        this.mode = ViewMode.LIST;
        this.orgEvaluationForms = { data: [] };
        this.evalButtonConfig = [
            {
                id: "editButton",
                icon: "edit-bold",
                ariaLabel: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:evaluations.editButton"),
                eventName: "edit-evaluation-form"
            },
            {
                id: "deleteButton",
                icon: "delete-bold",
                ariaLabel: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:evaluations.deleteButton"),
                eventName: "delete-evaluation-form"
            },
            {
                id: "archiveButton",
                icon: "archive-bold",
                ariaLabel: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:evaluations.archiveButton"),
                eventName: "archive-evaluation-form"
            }
        ];
    }
    connectedCallback() {
        const _super = Object.create(null, {
            connectedCallback: { get: () => super.connectedCallback }
        });
        return __awaiter(this, void 0, void 0, function* () {
            _super.connectedCallback.call(this);
            this.rowData = yield this.fetchRowData();
        });
    }
    getWcGridConfig() {
        return new _Common_WcGrid__WEBPACK_IMPORTED_MODULE_4__.WcGridConfig({
            tableName: "evaluationManager",
            enableCharts: false,
            headerConfig: {
                datePicker: false,
                resetGridStateButton: true,
                filterButton: "small",
                refreshButton: true,
                columnSelectButton: false
            }
        });
    }
    setMode(mode) {
        this.mode = mode;
    }
    fetchRowData() {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.orgEvaluationForms = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.agentPerformance.fetchOrgEvaluationForms({
                    orgId: ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) || ""
                });
                const gridRowData = (_c = (_b = this.orgEvaluationForms) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.filter((form) => form.status !== _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.AgentPerformanceTypes.EvaluationStatus.ARCHIVED).map((form) => {
                    return {
                        name: form.name,
                        id: form.id,
                        description: form.description,
                        status: form.status
                    };
                });
                return gridRowData;
            }
            catch (error) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("Error fetching evaluation forms:", error);
                return [];
            }
        });
    }
    getWcColumnDefs() {
        const columns = [
            new _Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_6__.StringColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:evaluations.columns.${formDefinitionColumn.Name}`), formDefinitionColumn.Name).setHidden(false),
            new _Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_6__.StringColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:evaluations.columns.${formDefinitionColumn.ID}`), formDefinitionColumn.ID).setHidden(false),
            new _Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_6__.StringColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:evaluations.columns.${formDefinitionColumn.Description}`), formDefinitionColumn.Description).setHidden(false),
            new _Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_6__.StringColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:evaluations.columns.${formDefinitionColumn.Status}`), formDefinitionColumn.Status).setHidden(false),
            new _Common_WcGrid_WcColumns_ActionsButtonsColumn__WEBPACK_IMPORTED_MODULE_5__.ActionsButtonsColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${formDefinitionColumn.Actions}`), formDefinitionColumn.Actions, this.evalButtonConfig).setHidden(false)
        ];
        return columns;
    }
    handleSetModeEvent(event) {
        if (event.detail.mode === ViewMode.LIST) {
            this.clearSelectedForm();
        }
        this.setMode(event.detail.mode);
    }
    editForm(event) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const formId = (_a = event.detail.data) === null || _a === void 0 ? void 0 : _a.id;
            this.setMode(ViewMode.EDIT);
            try {
                const formDetails = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.agentPerformance.fetchEvaluationForm({
                    orgId: ((_b = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.profile) === null || _b === void 0 ? void 0 : _b.orgId) || "",
                    formId
                });
                this.selectedForm = formDetails;
            }
            catch (error) {
                this.setMode(ViewMode.LIST);
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("Error fetching form details", error);
            }
        });
    }
    clearSelectedForm() {
        this.selectedForm = undefined;
    }
    deleteForm(event) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const formId = (_a = event.detail.data) === null || _a === void 0 ? void 0 : _a.id;
            try {
                yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.agentPerformance.deleteEvaluationForm({
                    orgId: ((_b = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.profile) === null || _b === void 0 ? void 0 : _b.orgId) || "",
                    formId
                });
                this.rowData = yield this.fetchRowData();
            }
            catch (error) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("Error deleting form", error);
            }
        });
    }
    archiveForm(event) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const formId = (_a = event.detail.data) === null || _a === void 0 ? void 0 : _a.id;
            try {
                yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.agentPerformance.archiveEvaluationForm({
                    orgId: ((_b = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.profile) === null || _b === void 0 ? void 0 : _b.orgId) || "",
                    formId
                });
                this.rowData = yield this.fetchRowData();
            }
            catch (error) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("Error archiving form", error);
            }
        });
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      <div class="table__container">
        ${this.mode === ViewMode.LIST
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
              <div class="table__header">
                <md-button class="create__button" variant="primary" @click=${() => this.setMode(ViewMode.CREATE)}>
                  ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.createNewForm")}
                </md-button>
              </div>
              <wc-grid
                .wcGridConfig=${this.getWcGridConfig()}
                .wcColumnDefs=${this.getWcColumnDefs()}
                .rowData=${this.rowData}
                @delete-evaluation-form=${this.deleteForm}
                @edit-evaluation-form=${this.editForm}
                @archive-evaluation-form=${this.archiveForm}
              ></wc-grid>
            `
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
              <agentx-wc-evaluation-manager-form
                @set-mode-event=${this.handleSetModeEvent}
                .mode=${this.mode}
                .selectedForm=${this.selectedForm}
              ></agentx-wc-evaluation-manager-form>
            `}
      </div>
    `;
    }
    static get styles() {
        return _EvaluationManagerTable_scss__WEBPACK_IMPORTED_MODULE_8__["default"];
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
], EvaluationManagerTable.prototype, "mode", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], EvaluationManagerTable.prototype, "orgEvaluationForms", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], EvaluationManagerTable.prototype, "selectedForm", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], EvaluationManagerTable.prototype, "rowData", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], EvaluationManagerTable.prototype, "evalButtonConfig", void 0);
EvaluationManagerTable = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-evaluation-manager-table")
], EvaluationManagerTable);



/***/ }),

/***/ "./src/components/GranularStateSelector/GranularStateSelector.ts":
/*!***********************************************************************!*\
  !*** ./src/components/GranularStateSelector/GranularStateSelector.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   GranularStateSelector: () => (/* binding */ GranularStateSelector)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let GranularStateSelector = class GranularStateSelector extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
    constructor() {
        super(...arguments);
        this.granularAgentStateProps = {};
        this.isStateMenuOpen = false;
    }
    connectedCallback() {
        super.connectedCallback();
    }
    render() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) `
      <md-menu-overlay
        size="small"
        position="bottom"
        id="menu-overlay"
        max-height="180px"
        class="state-menu-overlay"
        @menu-overlay-open=${() => (this.isStateMenuOpen = true)}
        @menu-overlay-close=${() => (this.isStateMenuOpen = false)}
      >
        <agentx-wc-granular-state-selector-indicator
          slot="menu-trigger"
          .channelsStatesMap=${this.granularAgentStateProps.channelsStatesMap}
          .isStateMenuOpen=${this.isStateMenuOpen}
        ></agentx-wc-granular-state-selector-indicator>
      </md-menu-overlay>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ attribute: false })
], GranularStateSelector.prototype, "granularAgentStateProps", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
], GranularStateSelector.prototype, "isStateMenuOpen", void 0);
GranularStateSelector = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-granular-state-selector")
], GranularStateSelector);



/***/ }),

/***/ "./src/components/GranularStateSelector/GranularStateSelectorIndicator.scss":
/*!**********************************************************************************!*\
  !*** ./src/components/GranularStateSelector/GranularStateSelectorIndicator.scss ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

* {
  /* BASE LEVEL < 100 */
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-index-tpw-header: 1;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-index-task-collapse-area: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-navigation-bar: 12;
  --z-index-task-list: 12;
  --z-index-wrap-up: 13;
  --z-index-sticky-header: 14;
  --z-index-shortcutkey-modal: 15;
  /* MID LEVEL FLOATING > 100 < 1000 */
  --z-index-notification: 150;
  /* SUPER LEVEL > 1000 */
  --z-index-modal: 1040;
  --z-index-popover: 1041;
  --z-index-callback-modal: 1042;
  /* This below order needs to be unchanged. Highest priority is for connection loss overlay,
         followed by error modal since error can occur during app load such as teams failure/register failure. */
  --z-index-app-full-overlay: 1050;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1200;
}

.flex-center, .state-selector-chevron, .rest-channel-icons, .current-state-time, .status-indicator-container, .primary-channel-icon, .current-state-info, .status-button__children, .agent-state-button {
  display: inline-flex;
  align-items: center;
}

.agent-state-button {
  justify-content: center;
  width: 360px;
  padding: var(--gap-8) var(--gap-10);
}

.agent-state-button::part(button-children) {
  width: auto;
  max-width: unset;
  height: var(--length-24);
}

.status-button__children {
  width: 352px;
  justify-content: space-between;
}

.current-state-info {
  gap: var(--gap-8);
  width: 219px;
  text-overflow: ellipsis;
}

.primary-channel-icon {
  justify-content: center;
}

.status-indicator-container {
  justify-content: space-between;
  width: 100%;
  font-size: var(--font-size-medium);
}

.current-state-name {
  max-width: 96px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.current-state-time {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
  font-size: var(--font-size-medium);
  padding-left: var(--space-token-even);
}

.rest-channel-icons {
  justify-content: flex-end;
  width: 106px;
  flex-shrink: 0;
  gap: var(--gap-4);
}

.rest-channels-border {
  border-left: 1px solid var(--color-gray-30);
}

.state-selector-chevron {
  padding-left: var(--gap-4);
}

.state-time-divider {
  padding: 0 var(--space-token-even);
}

.split-separator {
  margin: rem-calc(0 0);
  opacity: 0.4;
}

@media (max-width: 600px) {
  .agent-state-button {
    width: 157px;
  }
  .status-button__children {
    width: 147px;
  }
  .rest-channel-icons {
    width: 106px;
    padding-left: 5px;
  }
  .status-indicator-container {
    display: none;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/GranularStateSelector/GranularStateSelectorIndicator.ts":
/*!********************************************************************************!*\
  !*** ./src/components/GranularStateSelector/GranularStateSelectorIndicator.ts ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   GranularStateSelectorIndicator: () => (/* binding */ GranularStateSelectorIndicator)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _GranularStateSelectorIndicator_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./GranularStateSelectorIndicator.scss */ "./src/components/GranularStateSelector/GranularStateSelectorIndicator.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





let GranularStateSelectorIndicator = class GranularStateSelectorIndicator extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
    constructor() {
        super(...arguments);
        this.channelsStatesMap = {};
        this.isStateMenuOpen = false;
        this.stateIndicatorAriaLabelVal = ""; // TODO : CX-18926 construct this as accessibility.
        this.filteredChannels = [];
        this.filterChannels = () => {
            this.filteredChannels = _constants__WEBPACK_IMPORTED_MODULE_0__.channelOrder.filter((channel) => { var _a, _b; return (_b = (_a = this.channelsStatesMap) === null || _a === void 0 ? void 0 : _a[channel]) === null || _b === void 0 ? void 0 : _b.agentState; });
        };
        this.getPresenceTypeForChannel = (channel) => {
            var _a, _b;
            const newAgentState = ((_b = (_a = this.channelsStatesMap) === null || _a === void 0 ? void 0 : _a[channel]) === null || _b === void 0 ? void 0 : _b.agentState.toLowerCase()) || _constants__WEBPACK_IMPORTED_MODULE_0__.IDLE.toLowerCase();
            return _constants__WEBPACK_IMPORTED_MODULE_0__.presenceTypeMap.get(newAgentState) || _constants__WEBPACK_IMPORTED_MODULE_0__.IDLE.toLowerCase();
        };
        this.getPrimaryStateAvatar = () => {
            var _a, _b;
            const primaryChannel = this.filteredChannels[0];
            return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `<md-avatar
      state="rest"
      avatar-style="default"
      size="24"
      title=${_constants__WEBPACK_IMPORTED_MODULE_0__.channelAvatars[primaryChannel].title}
      type=${_constants__WEBPACK_IMPORTED_MODULE_0__.channelAvatars[primaryChannel].type}
      presence-type=${this.getPresenceTypeForChannel(primaryChannel)}
      label=${_constants__WEBPACK_IMPORTED_MODULE_0__.channelAvatars[primaryChannel].title + ((_b = (_a = this.channelsStatesMap) === null || _a === void 0 ? void 0 : _a[primaryChannel]) === null || _b === void 0 ? void 0 : _b.agentState)}
      newMomentum
    ></md-avatar>`;
        };
        this.getRestChannelAvatars = () => {
            const restChannels = this.filteredChannels.slice(1);
            if (restChannels.length === 0) {
                return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) ``;
            }
            else {
                return restChannels.map((channel) => {
                    var _a, _b;
                    return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `<md-avatar
          state="rest"
          avatar-style="default"
          size="24"
          title=${_constants__WEBPACK_IMPORTED_MODULE_0__.channelAvatars[channel].title}
          type=${_constants__WEBPACK_IMPORTED_MODULE_0__.channelAvatars[channel].type}
          presence-type=${this.getPresenceTypeForChannel(channel)}
          label=${_constants__WEBPACK_IMPORTED_MODULE_0__.channelAvatars[channel].title + ((_b = (_a = this.channelsStatesMap) === null || _a === void 0 ? void 0 : _a[channel]) === null || _b === void 0 ? void 0 : _b.agentState)}
          newMomentum
        ></md-avatar>`;
                });
            }
        };
        this.getCurrentState = () => {
            var _a, _b;
            const primaryChannel = this.filteredChannels[0];
            const stateOfAgent = (_b = (_a = this.channelsStatesMap) === null || _a === void 0 ? void 0 : _a[primaryChannel]) === null || _b === void 0 ? void 0 : _b.agentState;
            return stateOfAgent === _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE ? `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.stateChange.available")} -` : `${stateOfAgent} -`;
        };
        this.getTimeInAllIdleState = (currentStateTimestamp, lastIdleCodeChangeTimestamp) => {
            return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
      ${this.getTimeInCurrentState(currentStateTimestamp)}
      <span class="state-time-divider">/</span>
      <agentx-wc-task-list-timer
        .startTimestamp=${lastIdleCodeChangeTimestamp || Date.now()}
      ></agentx-wc-task-list-timer>
    `;
        };
        this.getTimeInCurrentState = (currentStateTimestamp) => {
            return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) ` <agentx-wc-task-list-timer .startTimestamp=${currentStateTimestamp}></agentx-wc-task-list-timer> `;
        };
        this.getTimer = () => {
            var _a, _b, _c, _d;
            const currentStateTimestamp = (_b = (_a = this.channelsStatesMap) === null || _a === void 0 ? void 0 : _a[this.filteredChannels[0]]) === null || _b === void 0 ? void 0 : _b.stateChangeTimestamp;
            const lastIdleCodeChangeTimestamp = (_d = (_c = this.channelsStatesMap) === null || _c === void 0 ? void 0 : _c[this.filteredChannels[0]]) === null || _d === void 0 ? void 0 : _d.lastIdleCodeChangeTimestamp;
            return !lastIdleCodeChangeTimestamp
                ? this.getTimeInCurrentState(currentStateTimestamp)
                : this.getTimeInAllIdleState(currentStateTimestamp, lastIdleCodeChangeTimestamp);
        };
    }
    static get styles() {
        return _GranularStateSelectorIndicator_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
    }
    connectedCallback() {
        super.connectedCallback();
        this.filterChannels();
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has("channelsStatesMap")) {
            this.filterChannels();
        }
    }
    render() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
      <md-button
        size="32"
        ariaLabel=${this.stateIndicatorAriaLabelVal}
        ariaExpanded=${this.isStateMenuOpen}
        class="agent-state-button"
        variant="dropdown"
        rounded
        .disabled="${this.filteredChannels.length === 0}"
      >
        ${this.filteredChannels.length > 0
            ? (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) ` <div class="status-button__children">
              <div class="current-state-info">
                <div class="primary-channel-icon">${this.getPrimaryStateAvatar()}</div>
                <div class="status-indicator-container">
                  <div class="current-state-name">${this.getCurrentState()}</div>
                  <span class="current-state-time">${this.getTimer()}</span>
                </div>
              </div>
              ${this.filteredChannels.length > 1
                ? (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `<span aria-hidden="true" class="split-separator"> | </span>`
                : (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) ``}
              <div class="rest-channel-icons">
                ${this.getRestChannelAvatars()}
                <div class="state-selector-chevron">
                  <md-icon
                    slot="input-section-right"
                    name=${this.isStateMenuOpen ? _constants__WEBPACK_IMPORTED_MODULE_0__.CHEVRON_ICON.UP : _constants__WEBPACK_IMPORTED_MODULE_0__.CHEVRON_ICON.DOWN}
                    iconset="momentumDesign"
                  ></md-icon>
                </div>
              </div>
            </div>`
            : (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `<div class="status-button__children" />`}
      </md-button>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
], GranularStateSelectorIndicator.prototype, "channelsStatesMap", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
], GranularStateSelectorIndicator.prototype, "isStateMenuOpen", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], GranularStateSelectorIndicator.prototype, "stateIndicatorAriaLabelVal", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], GranularStateSelectorIndicator.prototype, "filteredChannels", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.query)(".rest-channel-icons")
], GranularStateSelectorIndicator.prototype, "restChannels", void 0);
GranularStateSelectorIndicator = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-granular-state-selector-indicator")
], GranularStateSelectorIndicator);



/***/ }),

/***/ "./src/components/GridWidget/Grid.scss":
/*!*********************************************!*\
  !*** ./src/components/GridWidget/Grid.scss ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  --grid-header-height: 60px;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  --webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  --sentiment-chip-padding: 8px;
  --sentiment-chip-negative-background: rgba(255, 232, 234, 1);
  --sentiment-chip-negative-color: rgba(171, 10, 21, 1);
  --sentiment-chip-neutral-background: rgba(222, 222, 222, 1);
  --sentiment-chip-neutral-color: rgba(0, 0, 0, 0.7);
  --sentiment-chip-positive-background: rgba(206, 245, 235, 1);
  --sentiment-chip-positive-color: rgba(24, 94, 70, 1);
  --visualizer-title-width: 100px;
  --visualizer-title-margin-left: 24px;
  --visualizer-container-max-height: 40px;
  --visualizer-container-max-width: 900px;
  --visualizer-container-gap: 16px;
  --visualizer-bar-max-width: 577px;
  --visualizer-bar-max-height: 4px;
  --player-controls-row-height: 50px;
  --player-controls-gap: 8px;
  --volume-popover-width: 180px;
  --volume-popover-height: 21px;
  --volume-popover-gap: 12px;
  --volume-popover-top-offset: 120%;
  --volume-popover-left-offset: 50%;
  --volume-popover-padding: 12px;
  --seek-bar-height: 8px;
  --seek-bar-thumb-size: 16px;
  --popover-arrow-size: 10px;
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  --interaction-details-height: 250px;
  --interaction-details-padding: 3px;
  --interaction-details-item-margin: 10px 0;
  --interaction-details-item-grid-template-columns: 150px auto;
  --webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

* {
  /* BASE LEVEL < 100 */
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-index-tpw-header: 1;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-index-task-collapse-area: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-navigation-bar: 12;
  --z-index-task-list: 12;
  --z-index-wrap-up: 13;
  --z-index-sticky-header: 14;
  --z-index-shortcutkey-modal: 15;
  /* MID LEVEL FLOATING > 100 < 1000 */
  --z-index-notification: 150;
  /* SUPER LEVEL > 1000 */
  --z-index-modal: 1040;
  --z-index-popover: 1041;
  --z-index-callback-modal: 1042;
  /* This below order needs to be unchanged. Highest priority is for connection loss overlay,
         followed by error modal since error can occur during app load such as teams failure/register failure. */
  --z-index-app-full-overlay: 1050;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1200;
}

:host {
  --grid-wrapper-h-padding: 12px;
  --grid-header-display: flex;
  --grid-cell-border-radius: 0px;
  --grid-focus-border-radius: 4px;
}

.ag-theme-alpine,
.ag-theme-alpine-dark {
  --ag-row-hover-color: var(--grid-row-hover-color, rgba(33, 150, 243, 0.1));
  --ag-header-cell-moving-background-color: var(--ag-row-hover-color);
  --ag-input-focus-border-color: transparent;
}

.hide {
  display: none;
}

.grid-wrapper {
  height: 100%;
  --ag-row-hover-color: var(--grid-row-hover-color, rgba(33, 150, 243, 0.1));
  --ag-header-cell-moving-background-color: var(--ag-row-hover-color);
  --ag-text-color: var(--md-primary-text-color);
  --ag-subtle-text-color: var(--md-primary-text-color);
  --ag-drag-handle-color: var(--md-primary-text-color);
  --ag-input-background-color: var(--input-default-bg-color);
  --ag-input-text-color: var(--input-default-text-color);
  --ag-input-placeholder-text-color: var(--input-default-placeholder-color);
  --ag-input-border-radius: var(--input-border-radius);
  --ag-input-focus-text-color: var(--input-default-text-color);
  --ag-input-text-color: var(--input-default-text-color);
  --ag-checkbox-checked-shape-color: var(--checkbox-icon-color);
  --ag-checkbox-unchecked-background-color: var(--checkbox-bg-color);
  --ag-checkbox-unchecked-border-color: var(--checkbox-border-color);
  --ag-checkbox-checked-background-color: var(--checkbox-selected-bg-color);
  --ag-checkbox-checked-border-color: var(--checkbox-selected-border-color);
  --ag-checkbox-indeterminate-shape-color: var(--checkbox-icon-color);
  --ag-checkbox-indeterminate-background-color: var(--checkbox-selected-bg-color);
  --ag-checkbox-indeterminate-border-color: var(--checkbox-selected-border-color);
  --ag-picker-button-background-color: var(--combobox-bg-color);
  --ag-picker-button-focus-background-color: var(--combobox-focus-bg-color);
  --ag-picker-list-background-color: var(--combobox-bg-color);
}
.grid-wrapper .grid-container {
  height: calc(100% - (var(--grid-header-height)));
  background-color: var(--md-glass-overlay-bg-color);
  border-radius: var(--grid-container-border-radius);
  padding-left: var(--grid-container-h-padding);
  padding-right: var(--grid-container-h-padding);
  padding-top: var(--grid-container-top-padding);
}
.grid-wrapper .grid-container .ag-overlay-wrapper {
  display: block;
}
.grid-wrapper .grid-container .ag-root-wrapper {
  border-right: 0px;
  border-left: 0px;
  border-bottom: 0px;
  border-color: var(--md-table-primary-bg-color);
  background-color: transparent;
}
.grid-wrapper .grid-container .ag-row {
  border-color: var(--md-table-primary-bg-color);
  border-bottom: var(--md-table-cell-border-bottom);
  z-index: 0;
}
.grid-wrapper .grid-container .ag-row,
.grid-wrapper .grid-container .ag-body-viewport {
  background-color: transparent;
}
.grid-wrapper .grid-container .ag-cell-focus {
  box-shadow: none;
  background-color: var(--list-hover-background);
  border-radius: var(--grid-cell-border-radius);
}
.grid-wrapper .grid-container .ag-row-hover {
  border-radius: var(--grid-cell-border-radius);
  overflow: hidden;
}
.grid-wrapper .grid-container .ag-cell {
  padding-left: var(--grid-wrapper-h-padding);
  padding-right: var(--grid-wrapper-h-padding);
}
.grid-wrapper .grid-container .ag-cell.ag-cell-focus:focus-within {
  outline: 2px solid var(--list-focus-border-color) !important;
  outline-offset: -2px;
  border-radius: var(--grid-focus-border-radius);
}
.grid-wrapper .grid-container .ag-ltr .ag-cell-focus:not(.ag-cell-range-selected):focus-within,
.grid-wrapper .grid-container .ag-ltr .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),
.grid-wrapper .grid-container .ag-ltr .ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group,
.grid-wrapper .grid-container .ag-ltr .ag-cell-range-single-cell,
.grid-wrapper .grid-container .ag-ltr .ag-cell-range-single-cell.ag-cell-range-handle,
.grid-wrapper .grid-container .ag-rtl .ag-cell-focus:not(.ag-cell-range-selected):focus-within,
.grid-wrapper .grid-container .ag-rtl .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),
.grid-wrapper .grid-container .ag-rtl .ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group,
.grid-wrapper .grid-container .ag-rtl .ag-cell-range-single-cell,
.grid-wrapper .grid-container .ag-rtl .ag-cell-range-single-cell.ag-cell-range-handle {
  border: none;
}
.grid-wrapper .grid-container .ag-cell,
.grid-wrapper .grid-container .ag-pinned-left-header,
.grid-wrapper .grid-container .ag-pinned-right-header,
.grid-wrapper .grid-container .ag-pinned-right-cols-container {
  color: var(--md-primary-text-color);
  border: none;
  border-width: 1px;
  border-right-style: solid;
  border-color: var(--md-table-column-divider-color) !important;
}
.grid-wrapper .grid-container .ag-header {
  z-index: var(--z-index-tpw-header);
  border: none;
  border-width: 1px;
  border-right-style: var(--md-table-border-style);
  border-bottom-style: solid;
  color: var(--md-primary-text-color);
  background-color: var(--md-table-header-bg-color);
  border-color: var(--md-table-header-border-bottom-color);
  display: var(--grid-header-display);
}
.grid-wrapper .grid-container .ag-header-cell {
  padding-left: var(--grid-wrapper-h-padding);
  padding-right: var(--grid-wrapper-h-padding);
}
.grid-wrapper .grid-container .ag-header-cell.ag-header-active, .grid-wrapper .grid-container .ag-header-cell:focus {
  outline: 2px solid var(--list-focus-border-color) !important;
  outline-offset: -2px;
  border-radius: 4px;
}
.grid-wrapper .grid-container .ag-header-cell.ag-header-active::after, .grid-wrapper .grid-container .ag-header-cell:focus::after {
  border: none;
}
.grid-wrapper .grid-container .ag-header-cell-text {
  color: var(--md-table-header-text-color, var(--md-secondary-text-color));
  font-size: 14px;
  font-family: var(--brand-font-bold, "CiscoSansTT Regular"), sans-serif;
  font-weight: var(--brand-font-weight-bold, 100);
}
.grid-wrapper .grid-container .actions-cell {
  overflow: visible;
}
.grid-wrapper .grid-container .ag-row.ag-row-focus {
  z-index: 1;
}
.grid-wrapper .grid-container .ag-header-cell-resize {
  right: -5px;
}
.grid-wrapper .grid-container .ag-pinned-left-header .ag-header-cell-resize {
  right: -4px;
}
.grid-wrapper .grid-container .ag-header-cell-resize::after {
  height: 100%;
  top: 0;
  background-color: var(--md-table-primary-bg-color);
  width: 1px !important;
  box-shadow: none;
}
.grid-wrapper .grid-container .ag-pinned-right-header .ag-header-cell-resize::after {
  left: calc(50% - 1px);
  width: 2px !important;
}
.grid-wrapper .grid-container .ag-cell.ag-cell-last-left-pinned,
.grid-wrapper .grid-container .ag-pinned-left-header {
  border-width: 1px;
  right: 0px;
  left: auto !important;
}
.grid-wrapper .grid-container .ag-pinned-right-header {
  border-right: none;
}
.grid-wrapper .grid-container .ag-pinned-right-header,
.grid-wrapper .grid-container .ag-pinned-right-cols-container {
  border-left-style: solid;
  border-left-color: var(--md-table-pinned-border-color) !important;
  border-left-width: 1px;
  box-shadow: var(--pinned-column-elevation);
}
.grid-wrapper .grid-container .ag-pinned-right-header .ag-row,
.grid-wrapper .grid-container .ag-pinned-right-cols-container .ag-row {
  background-color: var(--md-table-pinned-bg-color);
}
.grid-wrapper .grid-container .ag-pinned-right-header .ag-row .ag-cell,
.grid-wrapper .grid-container .ag-pinned-right-cols-container .ag-row .ag-cell {
  border-left-style: none;
}
.grid-wrapper .grid-container .ag-pinned-right-header .ag-header-cell,
.grid-wrapper .grid-container .ag-pinned-right-cols-container .ag-header-cell {
  background-color: var(--pinned-column-header-bg-color);
}
.grid-wrapper .grid-container .ag-pinned-left-header,
.grid-wrapper .grid-container .ag-pinned-left-cols-container {
  border-right-style: solid;
  border-right-width: 1px;
  border-right-color: var(--md-table-pinned-border-color) !important;
  box-shadow: var(--pinned-column-elevation);
}
.grid-wrapper .grid-container .ag-pinned-left-header .ag-row,
.grid-wrapper .grid-container .ag-pinned-left-cols-container .ag-row {
  background-color: var(--md-table-pinned-bg-color);
}
.grid-wrapper .grid-container .ag-pinned-left-header .ag-row .ag-cell,
.grid-wrapper .grid-container .ag-pinned-left-cols-container .ag-row .ag-cell {
  border-right-style: none;
}
.grid-wrapper .grid-container .ag-pinned-left-header .ag-header-cell,
.grid-wrapper .grid-container .ag-pinned-left-cols-container .ag-header-cell {
  background-color: var(--pinned-column-header-bg-color);
}
.grid-wrapper .grid-container .ag-cell-expandable {
  font-weight: bold;
}
.grid-wrapper .grid-container .ag-row.ag-row-level-0.ag-full-width-row {
  background-color: var(--md-tertiary-bg-color);
}
.grid-wrapper .grid-container .ag-header-icon.ag-header-cell-menu-button {
  opacity: 1;
}
.grid-wrapper .grid-container div.ag-row {
  font-family: var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", sans-serif;
}
.grid-wrapper .grid-container .ag-theme-alpine .ag-menu-header,
.grid-wrapper .grid-container .ag-theme-alpine-dark .ag-menu-header {
  display: none;
}
.grid-wrapper .grid-container .ag-group-expanded,
.grid-wrapper .grid-container .ag-group-contracted {
  margin-right: 20px;
}
.grid-wrapper .ag-menu {
  border-radius: var(--border-radius-medium);
  color: var(--md-primary-text-color);
  border-color: var(--md-menu-overlay-border-color);
  box-shadow: 0 1px 4px 1px var(--md-menu-overlay-border-color);
  margin-top: 25px;
  margin-left: 15px;
}
.grid-wrapper .ag-header-icon {
  color: var(--md-secondary-text-color);
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-0.ag-full-width-row .ag-row-group.ag-row-group-indent-0 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-1.ag-full-width-row .ag-row-group.ag-row-group-indent-1 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-2.ag-full-width-row .ag-row-group.ag-row-group-indent-2 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-3.ag-full-width-row .ag-row-group.ag-row-group-indent-3 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-4.ag-full-width-row .ag-row-group.ag-row-group-indent-4 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-5.ag-full-width-row .ag-row-group.ag-row-group-indent-5 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-6.ag-full-width-row .ag-row-group.ag-row-group-indent-6 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-7.ag-full-width-row .ag-row-group.ag-row-group-indent-7 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-8.ag-full-width-row .ag-row-group.ag-row-group-indent-8 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-9.ag-full-width-row .ag-row-group.ag-row-group-indent-9 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-10.ag-full-width-row .ag-row-group.ag-row-group-indent-10 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-11.ag-full-width-row .ag-row-group.ag-row-group-indent-11 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-12.ag-full-width-row .ag-row-group.ag-row-group-indent-12 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-13.ag-full-width-row .ag-row-group.ag-row-group-indent-13 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-14.ag-full-width-row .ag-row-group.ag-row-group-indent-14 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-15.ag-full-width-row .ag-row-group.ag-row-group-indent-15 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-16.ag-full-width-row .ag-row-group.ag-row-group-indent-16 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-17.ag-full-width-row .ag-row-group.ag-row-group-indent-17 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-18.ag-full-width-row .ag-row-group.ag-row-group-indent-18 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-19.ag-full-width-row .ag-row-group.ag-row-group-indent-19 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-1 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-2 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-3 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-4 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-5 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-6 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-7 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-8 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-9 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-10 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-11 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-12 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-13 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-14 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-15 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-16 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-17 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-18 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-19 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}

.channel-type-renderer {
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  padding-top: 8px;
}

.qmw-actions-cell {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin: 2px 0 0 6px;
  height: 100%;
}
.qmw-actions-cell .qmw-play-btn:focus {
  box-shadow: 0 0 0 0.125rem var(--button-focus-ring-color, #007aa3);
  border-radius: 2px;
}

.cell-renderer {
  width: 100%;
  height: 100%;
}

.listitem-cell-renderer {
  width: 100%;
  height: 100%;
  display: flex;
}

.ag-side-buttons,
.ag-tool-panel-horizontal-resize {
  display: none;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/GridWidget/Grid.ts":
/*!*******************************************!*\
  !*** ./src/components/GridWidget/Grid.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   GridWidget: () => (/* binding */ GridWidget)
/* harmony export */ });
/* harmony import */ var _components_Common_Utils_GridUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/Utils/GridUtils */ "./src/components/Common/Utils/GridUtils.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ag-grid-enterprise */ "ag-grid-enterprise");
/* harmony import */ var ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Grid_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./Grid.scss */ "./src/components/GridWidget/Grid.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var GridWidget;
(function (GridWidget) {
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
        get areScriptsLoaded() {
            return this.isAgGridLoaded && this.isAlpineLoaded;
        }
        get gridWrapperClassMap() {
            return {
                "grid-wrapper": true,
                hide: !this.areScriptsLoaded && !this.newTheme
            };
        }
        get gridContainerClassMap() {
            return {
                "grid-container": true,
                "ag-theme-alpine": !this.isDarkMode,
                "ag-theme-alpine-dark": this.isDarkMode
            };
        }
        getGridApi() {
            return this.gridApi;
        }
        static get styles() {
            return [_Grid_scss__WEBPACK_IMPORTED_MODULE_5__["default"]];
        }
        constructor() {
            super();
            this.gridOptions = {};
            this.isDarkMode = false;
            this.isLoggedIntoStation = false;
            this.newTheme = false;
            this.isAgGridLoaded = false;
            this.isAlpineLoaded = false;
            (0,_components_Common_Utils_GridUtils__WEBPACK_IMPORTED_MODULE_0__.initializeGlobalGridProperties)();
        }
        initializeGrid() {
            this.gridApi = (0,ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_2__.createGrid)(this._gridDiv, this.gridOptions);
        }
        firstUpdated(changedProperties) {
            super.firstUpdated(changedProperties);
            this.loadAGGridScript();
        }
        createHTMLLink(href) {
            const linkElement = document.createElement("link");
            linkElement.setAttribute("rel", "stylesheet");
            linkElement.setAttribute("href", href);
            return linkElement;
        }
        loadAGGridScript() {
            var _a;
            const momentumIcons = this.createHTMLLink("/css/momentum-ui-icons.min.css");
            const momentumCore = this.createHTMLLink("/css/momentum-ui.min.css");
            const rootElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".grid-wrapper");
            rootElement === null || rootElement === void 0 ? void 0 : rootElement.prepend(momentumIcons);
            rootElement === null || rootElement === void 0 ? void 0 : rootElement.prepend(momentumCore);
            if (!this.newTheme) {
                const agGridLink = this.createHTMLLink("ag-grid/ag-grid.css");
                const agThemeAlpineLink = this.createHTMLLink("ag-grid/ag-theme-alpine.css");
                rootElement === null || rootElement === void 0 ? void 0 : rootElement.prepend(agThemeAlpineLink);
                rootElement === null || rootElement === void 0 ? void 0 : rootElement.prepend(agGridLink);
                agGridLink.onload = () => {
                    this.isAgGridLoaded = true;
                };
                agThemeAlpineLink.onload = () => {
                    this.isAlpineLoaded = true;
                };
            }
        }
        updated(changedProperties) {
            var _a;
            super.updated(changedProperties);
            if (changedProperties.has("gridOptions") && this.isLoggedIntoStation) {
                if (changedProperties.get("gridOptions")) {
                    (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.destroy();
                }
                this.initializeGrid();
            }
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div class=${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__.classMap)(this.gridWrapperClassMap)}>
          ${this.newTheme
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `<div id="agentx-wc-ag-grid-container" class=${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__.classMap)(this.gridContainerClassMap)}></div>`
                : (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `<div
                id="agentx-wc-ag-grid-container"
                style="width: 100%; height: 100%;"
                class=${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__.classMap)(this.gridContainerClassMap)}
              ></div>`}
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.query)("#agentx-wc-ag-grid-container")
    ], Element.prototype, "_gridDiv", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Object })
    ], Element.prototype, "gridOptions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isDarkMode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isLoggedIntoStation", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "newTheme", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "gridApi", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "isAgGridLoaded", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "isAlpineLoaded", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-ag-grid")
    ], Element);
    GridWidget.Element = Element;
})(GridWidget || (GridWidget = {}));


/***/ }),

/***/ "./src/components/GridWidget/GridCacheUtils.ts":
/*!*****************************************************!*\
  !*** ./src/components/GridWidget/GridCacheUtils.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   mergedSimplifiedStateWithDefault: () => (/* binding */ mergedSimplifiedStateWithDefault),
/* harmony export */   simplifyState: () => (/* binding */ simplifyState)
/* harmony export */ });
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");

function simplifyState(stateToSimplify, defaultState) {
    if (!stateToSimplify) {
        _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.error("[GridCacheUtils] stateToSimplify is null state found. stateToSimplify:");
        return stateToSimplify;
    }
    else if (stateToSimplify === defaultState) {
        _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info("[GridCacheUtils] stateToSimplify === defaultState:");
        return null;
    }
    const simplifiedColumnStates = [];
    stateToSimplify.forEach((column) => {
        const defaultColumn = defaultState.find((defCol) => defCol.colId === column.colId);
        if (!defaultColumn) {
            _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info("[GridCacheUtils] column with colId ", column.colId, " not found in default state.");
            return;
        }
        let simplifiedColumn = {};
        simplifiedColumn.colId = column.colId;
        for (const key in column) {
            const k = key;
            if (column[k] !== defaultColumn[k]) {
                simplifiedColumn = Object.assign(Object.assign({}, simplifiedColumn), { [key]: column[k] });
            }
        }
        simplifiedColumnStates.push(simplifiedColumn);
    });
    return simplifiedColumnStates.length > 0 ? simplifiedColumnStates : null;
}
function mergedSimplifiedStateWithDefault(simplifiedState, defaultState) {
    if (!simplifiedState) {
        return null;
    }
    const mergedState = [];
    for (const simplifiedColumn of simplifiedState) {
        const defaultColumn = defaultState.find((col) => col.colId === simplifiedColumn.colId);
        if (defaultColumn) {
            const defaultColumnShallowCopy = Object.assign({}, defaultColumn);
            Object.assign(defaultColumnShallowCopy, simplifiedColumn);
            mergedState.push(defaultColumnShallowCopy);
        }
    }
    return mergedState;
}


/***/ }),

/***/ "./src/components/GridWidget/KeySuppressor.ts":
/*!****************************************************!*\
  !*** ./src/components/GridWidget/KeySuppressor.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   KeySuppressor: () => (/* binding */ KeySuppressor)
/* harmony export */ });
/* harmony import */ var _Common_CellRenderers_CustomKeyboardNav__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Common/CellRenderers/CustomKeyboardNav */ "./src/components/Common/CellRenderers/CustomKeyboardNav.ts");

class KeySuppressor {
    constructor(colIds, querySelector) {
        this.colIds = [];
        this.querySelector = "";
        this.suppressKeyboardEvent = ({ event }) => {
            const { key, shiftKey } = event;
            const path = this.getEventPath(event);
            const isTabForward = key === "Tab" && shiftKey === false;
            const isTabBackward = key === "Tab" && shiftKey === true;
            let suppressEvent = false;
            // Handle cell children tabbing
            if (isTabForward || isTabBackward) {
                const eGridCell = path.find((el) => {
                    var _a, _b;
                    if (el.attributes === undefined) {
                        return false;
                    }
                    const colId = (_b = (_a = el.attributes.getNamedItem("col-id")) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.toLocaleLowerCase();
                    return colId && this.colIds.includes(colId);
                });
                if (eGridCell) {
                    const actionButtons = eGridCell.querySelector(this.querySelector);
                    if (actionButtons) {
                        if (isTabForward) {
                            suppressEvent = _Common_CellRenderers_CustomKeyboardNav__WEBPACK_IMPORTED_MODULE_0__["default"].focusNext(actionButtons);
                        }
                        else {
                            suppressEvent = _Common_CellRenderers_CustomKeyboardNav__WEBPACK_IMPORTED_MODULE_0__["default"].focusPrevious(actionButtons);
                        }
                    }
                }
            }
            if (suppressEvent) {
                event.preventDefault();
            }
            return suppressEvent;
        };
        this.colIds = colIds;
        this.querySelector = querySelector;
    }
    getEventPath(event) {
        const path = [];
        let currentTarget = event.target;
        while (currentTarget) {
            path.push(currentTarget);
            currentTarget = currentTarget.parentElement;
        }
        return path;
    }
}


/***/ }),

/***/ "./src/components/IframeBase/IframeBase.scss":
/*!***************************************************!*\
  !*** ./src/components/IframeBase/IframeBase.scss ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host .iframe {
  width: 100%;
  height: 100%;
  border: 0;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0lmcmFtZUJhc2UvSWZyYW1lQmFzZS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNFO0VBQ0UsV0FBQTtFQUNBLFlBQUE7RUFDQSxTQUFBO0FBQUoiLCJzb3VyY2VzQ29udGVudCI6WyI6aG9zdCB7XG4gIC5pZnJhbWUge1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIGhlaWdodDogMTAwJTtcbiAgICBib3JkZXI6IDA7XG4gIH1cbn1cbiJdLCJzb3VyY2VSb290IjoiIn0= */`);
    

/***/ }),

/***/ "./src/components/IframeBase/IframeBase.ts":
/*!*************************************************!*\
  !*** ./src/components/IframeBase/IframeBase.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   IframeBase: () => (/* binding */ IframeBase)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @uuip/unified-ui-platform-common-components */ "@uuip/unified-ui-platform-common-components");
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _IframeBase_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./IframeBase.scss */ "./src/components/IframeBase/IframeBase.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var IframeBase;
(function (IframeBase) {
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.src = "";
            this.isDarkTheme = false;
            this.allowedParams = "";
            this.title = "";
            this.finalUrl = this.src;
        }
        static get styles() {
            return _IframeBase_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
        }
        render() {
            if (this.src) {
                const url = new URL(this.src);
                url.searchParams.set("is_dark_theme", this.isDarkTheme.toString());
                this.finalUrl = url.href;
            }
            return this.src
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
            <iframe class="iframe" allow="${this.allowedParams}" src="${this.finalUrl}" title="${this.title}"></iframe>
          `
                : (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
            <uuip-wc-content-error>
              <span>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common:badUrl")}}</span>
            </uuip-wc-content-error>
          `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "src", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean, attribute: "is-dark-theme" })
    ], Element.prototype, "isDarkTheme", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "allowedParams", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "title", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "finalUrl", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-iframe")
    ], Element);
    IframeBase.Element = Element;
})(IframeBase || (IframeBase = {}));


/***/ }),

/***/ "./src/components/IframeLogin/IframeLogin.scss":
/*!*****************************************************!*\
  !*** ./src/components/IframeLogin/IframeLogin.scss ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  --logo-width: 190px;
  --logo-height: 1.5rem;
  --max-logo-height: 80px;
  --max-wrapper-width: 262px;
}

.login-container {
  width: 100vw;
  height: 100vh;
  display: flex;
}

.login-wrapper {
  margin: auto;
  display: flex;
  width: 100%;
  max-width: var(--max-wrapper-width);
  flex-direction: column;
  align-items: center;
}

.ci-login-logo {
  width: 100%;
  max-width: var(--logo-width);
  max-height: var(--max-logo-height);
  margin-bottom: calc(var(--space-token-cardinal) * 9);
  font-size: 5rem;
}

.ci-login-logo img {
  width: var(--logo-width);
  height: var(--logo-height);
}

.user-message {
  text-align: center;
  font-size: var(--font-size-medium);
  font-style: normal;
  font-family: var(--font-family-light);
  font-weight: var(--font-weight-lite);
  line-height: calc(var(--space-token-cardinal) * 4);
}

.signin-button {
  margin-bottom: calc(var(--space-token-cardinal) * 5);
}

.signin-div {
  width: 180px;
}
.signin-div span {
  margin: auto;
  font-family: var(--font-family);
  font-size: var(--font-size-medium);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/IframeLogin/IframeLogin.ts":
/*!***************************************************!*\
  !*** ./src/components/IframeLogin/IframeLogin.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   IframeLogin: () => (/* binding */ IframeLogin)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _IframeLogin_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./IframeLogin.scss */ "./src/components/IframeLogin/IframeLogin.scss");
/* harmony import */ var _img_Cisco_Webex_Logo_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @img/Cisco_Webex_Logo.svg */ "./src/assets/images/Cisco_Webex_Logo.svg");
/* harmony import */ var _img_Cisco_Webex_Logo_svg__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_img_Cisco_Webex_Logo_svg__WEBPACK_IMPORTED_MODULE_5__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var IframeLogin;
(function (IframeLogin) {
    /**
     * @element agentx-wc-iframe-login
     * @fires request-iframe-login
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
        constructor() {
            super(...arguments);
            this.isLoading = false;
        }
        static get styles() {
            return _IframeLogin_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
        }
        login() {
            this.dispatchEvent(new CustomEvent("request-iframe-login", { bubbles: true, composed: true }));
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[IframeLogin]: request-iframe-login");
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div class="login-container">
          <div class="login-wrapper">
            <div class="ci-login-logo">
              <img src=${(_img_Cisco_Webex_Logo_svg__WEBPACK_IMPORTED_MODULE_5___default())} alt="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.webex")}" />
            </div>
            <div class="signin-button">
              ${this.isLoading
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) ` <md-spinner></md-spinner> `
                : (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                    <md-button ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:iframeLogin.signIn")}" variant="primary" @click="${this.login}"
                      ><div class="signin-div">
                        <span> ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:iframeLogin.signIn")} </span>
                      </div>
                    </md-button>
                  `}
            </div>
            <div class="user-message">
              ${this.isLoading ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:iframeLogin.signingIn") : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:iframeLogin.userMessage")}
            </div>
          </div>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isLoading", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-iframe-login")
    ], Element);
    IframeLogin.Element = Element;
})(IframeLogin || (IframeLogin = {}));


/***/ }),

/***/ "./src/components/ImiChatWrapper/ImiChatWrapper.scss":
/*!***********************************************************!*\
  !*** ./src/components/ImiChatWrapper/ImiChatWrapper.scss ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.imi-chat {
  width: 100%;
  height: 100%;
  position: relative;
}

.widget-loader {
  justify-content: center;
  display: flex;
  width: 100%;
  height: 100%;
  border-radius: var(--border-radius-medium);
  background-color: var(--md-primary-bg-color);
  color: var(--md-primary-text-color);
}
.widget-loader-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.hidden {
  display: none;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0ltaUNoYXRXcmFwcGVyL0ltaUNoYXRXcmFwcGVyLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxXQUFBO0VBQ0EsWUFBQTtFQUNBLGtCQUFBO0FBQ0Y7O0FBRUE7RUFDRSx1QkFBQTtFQUNBLGFBQUE7RUFDQSxXQUFBO0VBQ0EsWUFBQTtFQUNBLDBDQUFBO0VBQ0EsNENBQUE7RUFDQSxtQ0FBQTtBQUNGO0FBQ0U7RUFDRSxhQUFBO0VBQ0Esc0JBQUE7RUFDQSx1QkFBQTtFQUNBLG1CQUFBO0FBQ0o7O0FBR0E7RUFDRSxhQUFBO0FBQUYiLCJzb3VyY2VzQ29udGVudCI6WyIuaW1pLWNoYXQge1xuICB3aWR0aDogMTAwJTtcbiAgaGVpZ2h0OiAxMDAlO1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG59XG5cbi53aWRnZXQtbG9hZGVyIHtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIHdpZHRoOiAxMDAlO1xuICBoZWlnaHQ6IDEwMCU7XG4gIGJvcmRlci1yYWRpdXM6IHZhcigtLWJvcmRlci1yYWRpdXMtbWVkaXVtKTtcbiAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tbWQtcHJpbWFyeS1iZy1jb2xvcik7XG4gIGNvbG9yOiB2YXIoLS1tZC1wcmltYXJ5LXRleHQtY29sb3IpO1xuXG4gICYtd3JhcHBlciB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIH1cbn1cblxuLmhpZGRlbiB7XG4gIGRpc3BsYXk6IG5vbmU7XG59XG4iXSwic291cmNlUm9vdCI6IiJ9 */`);
    

/***/ }),

/***/ "./src/components/ImiChatWrapper/ImiChatWrapper.ts":
/*!*********************************************************!*\
  !*** ./src/components/ImiChatWrapper/ImiChatWrapper.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ImiChatWrapper: () => (/* binding */ ImiChatWrapper)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _ImiChatWrapper_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./ImiChatWrapper.scss */ "./src/components/ImiChatWrapper/ImiChatWrapper.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var ImiChatWrapper;
(function (ImiChatWrapper) {
    /**
     * @element imi-chat-wrapper
     * @fires update-imi-init-status
     *
     */
    let ImiChatWrapperWidget = class ImiChatWrapperWidget extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.convId = "";
            this.isDarkMode = false;
            this.isLoading = true;
        }
        update(changedProperties) {
            super.update(changedProperties);
            changedProperties.forEach((oldValue, name) => {
                if (name === "convId") {
                    this.evt("update-imi-init-status", true);
                }
            });
        }
        evt(name, detail) {
            this.dispatchEvent(new CustomEvent(name, { bubbles: true, composed: true, detail }));
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[IMIWrapper] Dispatching", name, detail);
        }
        connectedCallback() {
            super.connectedCallback();
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[IMIWrapper: Render] => Is imi-chat-widget defined`);
        }
        static get styles() {
            return _ImiChatWrapper_scss__WEBPACK_IMPORTED_MODULE_5__["default"];
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="imi-chat ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__.classMap)({ hidden: this.isLoading })}">
          <imi-engage conversationid="${this.convId}" theme="${this.isDarkMode ? "DARK" : "LIGHT"}" lang="en-US">
          </imi-engage>
        </div>
        ${this.isLoading
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
              <div class="widget-loader">
                <div class="widget-loader-wrapper">
                  <md-spinner aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:commonWebComp.loading")} size="56"></md-spinner>
                </div>
              </div>
            `
                : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], ImiChatWrapperWidget.prototype, "convId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean, attribute: "is-dark-mode" })
    ], ImiChatWrapperWidget.prototype, "isDarkMode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], ImiChatWrapperWidget.prototype, "isLoading", void 0);
    ImiChatWrapperWidget = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("imi-chat-wrapper")
    ], ImiChatWrapperWidget);
    ImiChatWrapper.ImiChatWrapperWidget = ImiChatWrapperWidget;
})(ImiChatWrapper || (ImiChatWrapper = {}));


/***/ }),

/***/ "./src/components/InteractionsTab/InteractionsServerSideDataSource/InteractionsServerSideDataSource.ts":
/*!*************************************************************************************************************!*\
  !*** ./src/components/InteractionsTab/InteractionsServerSideDataSource/InteractionsServerSideDataSource.ts ***!
  \*************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InteractionServerSideDataSource: () => (/* binding */ InteractionServerSideDataSource)
/* harmony export */ });
/* harmony import */ var _components_Common_WcGrid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/WcGrid */ "./src/components/Common/WcGrid/index.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../config */ "./src/components/InteractionsTab/config.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};




const getSortByFromModel = (sortModel) => {
    let sortBy = undefined;
    if (sortModel && sortModel.length > 0) {
        const sort = sortModel[0];
        if (sort.colId && sort.sort) {
            sortBy = {
                fields: (0,_config__WEBPACK_IMPORTED_MODULE_3__.mapColumnIdToQueryField)(sort.colId),
                order: sort.sort === _components_Common_WcGrid__WEBPACK_IMPORTED_MODULE_0__.SortOrder.Ascending
                    ? _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.InteractionsServiceConstants.SortOrder.Ascending
                    : _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.InteractionsServiceConstants.SortOrder.Descending
            };
        }
    }
    return sortBy;
};
const fetchCompletedRows = (interactionsStore, timeRange, sortBy, success) => __awaiter(void 0, void 0, void 0, function* () {
    let rowCount;
    const areMore = yield interactionsStore.fetchCompletedInteractions(timeRange.start, timeRange.end, sortBy);
    if (!areMore) {
        // By defining a rowCount we let the grid know that there are no more rows to fetch
        rowCount = interactionsStore.completedInteractions.size;
    }
    const tasksArray = Array.from(interactionsStore.completedInteractions.values());
    //Temporarily coerce the type to WcGridRowData until we flatten Tasks data structure.
    const rowData = tasksArray;
    success({ rowData, rowCount });
});
class InteractionServerSideDataSource {
    constructor(timeRange, interactionsStore) {
        this.timeRange = timeRange;
        this.interactionsStore = interactionsStore;
    }
    fetchServerSideRows(params) {
        return __awaiter(this, void 0, void 0, function* () {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[InteractionsTabWidget] Fetching rows for grid", params);
            const sortBy = getSortByFromModel(params.request.sortModel);
            try {
                yield fetchCompletedRows(this.interactionsStore, this.timeRange, sortBy, params.success);
            }
            catch (error) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[InteractionsTabWidget] Failed to fetch rows for grid", error);
                params.fail();
            }
        });
    }
}


/***/ }),

/***/ "./src/components/InteractionsTab/InteractionsTabDateRangePicker/InteractionsTabDateRangePicker.scss":
/*!***********************************************************************************************************!*\
  !*** ./src/components/InteractionsTab/InteractionsTabDateRangePicker/InteractionsTabDateRangePicker.scss ***!
  \***********************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.date-range-picker-controls {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin: 0.25rem 0.75rem 0.75rem;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0ludGVyYWN0aW9uc1RhYi9JbnRlcmFjdGlvbnNUYWJEYXRlUmFuZ2VQaWNrZXIvSW50ZXJhY3Rpb25zVGFiRGF0ZVJhbmdlUGlja2VyLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxhQUFBO0VBQ0EseUJBQUE7RUFDQSxXQUFBO0VBQ0EsK0JBQUE7QUFDRiIsInNvdXJjZXNDb250ZW50IjpbIi5kYXRlLXJhbmdlLXBpY2tlci1jb250cm9scyB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogZmxleC1lbmQ7XG4gIGdhcDogMC41cmVtO1xuICBtYXJnaW46IDAuMjVyZW0gMC43NXJlbSAwLjc1cmVtO1xufVxuIl0sInNvdXJjZVJvb3QiOiIifQ== */`);
    

/***/ }),

/***/ "./src/components/InteractionsTab/InteractionsTabDateRangePicker/InteractionsTabDateRangePicker.ts":
/*!*********************************************************************************************************!*\
  !*** ./src/components/InteractionsTab/InteractionsTabDateRangePicker/InteractionsTabDateRangePicker.ts ***!
  \*********************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InteractionsTabDateRangePicker: () => (/* binding */ InteractionsTabDateRangePicker)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _InteractionsTabDateRangePicker_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./InteractionsTabDateRangePicker.scss */ "./src/components/InteractionsTab/InteractionsTabDateRangePicker/InteractionsTabDateRangePicker.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





/**
 * @element agentx-wc-interactions-tab-date-range-picker
 */
let InteractionsTabDateRangePicker = class InteractionsTabDateRangePicker extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
    constructor() {
        super(...arguments);
        this.startTime = 0;
        this.endTime = 0;
    }
    static get styles() {
        return _InteractionsTabDateRangePicker_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
    }
    render() {
        var _a, _b;
        const startDate = (_a = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(this.startTime).toISODate()) !== null && _a !== void 0 ? _a : "";
        const endDate = (_b = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(this.endTime).toISODate()) !== null && _b !== void 0 ? _b : "";
        const datePickerValue = `${startDate} - ${endDate}`;
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
      <md-date-range-picker
        value=${datePickerValue}
        .endDate=${endDate}
        .startDate=${startDate}
        @date-range-change=${this.onDateRangeChange}
      >
        <div slot="time-picker" class="date-range-picker-controls">
          <md-button
            class="date-range-cancel-button"
            variant="secondary"
            size="28"
            @click=${this.onCancelDateRangeSelection}
          >
            <span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.cancelButton")}</span>
          </md-button>
          <md-button
            class="date-range-apply-button"
            variant="primary"
            size="28"
            @click=${this.onAcceptDateRangeSelection}
          >
            <span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.apply")}</span>
          </md-button>
        </div>
      </md-date-range-picker>
    `;
    }
    onDateRangeChange(e) {
        var _a;
        if (!((_a = e.detail) === null || _a === void 0 ? void 0 : _a.startDate) || !e.detail.endDate) {
            return;
        }
        this.pendingStartTime = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromISO(e.detail.startDate).toMillis();
        this.pendingEndTime = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromISO(e.detail.endDate).toMillis();
    }
    onCancelDateRangeSelection() {
        this.dateRangePicker.setOpen(false);
    }
    onAcceptDateRangeSelection() {
        this.dateRangePicker.setOpen(false);
        if (!this.pendingStartTime ||
            !this.pendingEndTime ||
            (this.pendingStartTime === this.startTime && this.pendingEndTime === this.endTime)) {
            return;
        }
        this.startTime = this.pendingStartTime;
        this.endTime = this.pendingEndTime;
        this.dispatchEvent(new CustomEvent("search-date-range-updated", {
            detail: {
                startTime: this.startTime,
                endTime: this.endTime
            },
            bubbles: true,
            composed: true
        }));
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Number })
], InteractionsTabDateRangePicker.prototype, "startTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Number })
], InteractionsTabDateRangePicker.prototype, "endTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], InteractionsTabDateRangePicker.prototype, "pendingStartTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], InteractionsTabDateRangePicker.prototype, "pendingEndTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.query)("md-date-range-picker")
], InteractionsTabDateRangePicker.prototype, "dateRangePicker", void 0);
InteractionsTabDateRangePicker = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-interactions-tab-date-range-picker")
], InteractionsTabDateRangePicker);



/***/ }),

/***/ "./src/components/InteractionsTab/InteractionsTabDetailsView/InteractionsTabDetailsWidget.scss":
/*!*****************************************************************************************************!*\
  !*** ./src/components/InteractionsTab/InteractionsTabDetailsView/InteractionsTabDetailsWidget.scss ***!
  \*****************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.panel-layout {
  flex: 1;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0ludGVyYWN0aW9uc1RhYi9JbnRlcmFjdGlvbnNUYWJEZXRhaWxzVmlldy9JbnRlcmFjdGlvbnNUYWJEZXRhaWxzV2lkZ2V0LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxPQUFBO0FBQ0YiLCJzb3VyY2VzQ29udGVudCI6WyIucGFuZWwtbGF5b3V0IHtcbiAgZmxleDogMTtcbn1cbiJdLCJzb3VyY2VSb290IjoiIn0= */`);
    

/***/ }),

/***/ "./src/components/InteractionsTab/InteractionsTabDetailsView/InteractionsTabDetailsWidget.ts":
/*!***************************************************************************************************!*\
  !*** ./src/components/InteractionsTab/InteractionsTabDetailsView/InteractionsTabDetailsWidget.ts ***!
  \***************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InteractionsTabDetailsWidget: () => (/* binding */ InteractionsTabDetailsWidget)
/* harmony export */ });
/* harmony import */ var _components_Common_Headers_PageHeader_PageHeader__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/Headers/PageHeader/PageHeader */ "./src/components/Common/Headers/PageHeader/PageHeader.ts");
/* harmony import */ var _components_Common_Panel_PanelFrame_PanelFrame__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/components/Common/Panel/PanelFrame/PanelFrame */ "./src/components/Common/Panel/PanelFrame/PanelFrame.ts");
/* harmony import */ var _components_Common_Panel_PanelLayout_PanelLayout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/components/Common/Panel/PanelLayout/PanelLayout */ "./src/components/Common/Panel/PanelLayout/PanelLayout.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _InteractionsTabDetailsWidget_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./InteractionsTabDetailsWidget.scss */ "./src/components/InteractionsTab/InteractionsTabDetailsView/InteractionsTabDetailsWidget.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









let InteractionsTabDetailsWidget = class InteractionsTabDetailsWidget extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__.i18nMixin)(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_4__.MobxLitElement) {
    static getStyles() {
        return _InteractionsTabDetailsWidget_scss__WEBPACK_IMPORTED_MODULE_8__["default"];
    }
    closeDetails() {
        var _a;
        this.dispatchEvent(new CustomEvent("interactions-details-close", {
            bubbles: true,
            composed: true
        }));
        (_a = this.interactionsStore) === null || _a === void 0 ? void 0 : _a.setSelectedInteraction("");
    }
    render() {
        var _a, _b;
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_7__.html) `
      <agentx-wc-frame>
        <agentx-wc-page-header
          title="${((_b = (_a = this.interactionsStore) === null || _a === void 0 ? void 0 : _a.selectedInteraction) === null || _b === void 0 ? void 0 : _b.id) || ""}"
          useCloseButton
          @page-header-close="${this.closeDetails}"
        ></agentx-wc-page-header>
        <agentx-wc-panel-layout class="panel-layout" showTopPanel showLeftPanel showRightPanel>
          <slot name="top-panel-content" slot="top">
            <agentx-wc-panel-frame heading="Top panel">
              <div>Top panel content</div>
            </agentx-wc-panel-frame>
          </slot>
          <agentx-wc-panel-frame slot="left" heading="Left panel">
            <md-button slot="header-extra-content" circle>X</md-button>
            <div>Left panel content</div>
          </agentx-wc-panel-frame>
          <agentx-wc-panel-frame slot="right">
            <div>Right panel content</div>
          </agentx-wc-panel-frame>
        </agentx-wc-panel-layout>
      </agentx-wc-frame>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Object, attribute: false })
], InteractionsTabDetailsWidget.prototype, "interactionsStore", void 0);
InteractionsTabDetailsWidget = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.customElement)("agentx-wc-interactions-tab-details-widget")
], InteractionsTabDetailsWidget);



/***/ }),

/***/ "./src/components/InteractionsTab/InteractionsTabWidget/InteractionsTabAlertBanner.ts":
/*!********************************************************************************************!*\
  !*** ./src/components/InteractionsTab/InteractionsTabWidget/InteractionsTabAlertBanner.ts ***!
  \********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InteractionsAlertBanner: () => (/* binding */ InteractionsAlertBanner)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let InteractionsAlertBanner = class InteractionsAlertBanner extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
    constructor() {
        super(...arguments);
        this.pendingInteractionsCount = 0;
    }
    render() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) `
      <md-alert-banner type="default" ?show=${this.pendingInteractionsCount > 0} showBannerTypeIcon showRefreshButton>
        ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:interactions:refreshToSeeNewInteractions", "Refresh to see new Interactions", {
            count: this.pendingInteractionsCount
        })}
      </md-alert-banner>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
], InteractionsAlertBanner.prototype, "pendingInteractionsCount", void 0);
InteractionsAlertBanner = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("interactions-tab-alert-banner")
], InteractionsAlertBanner);



/***/ }),

/***/ "./src/components/InteractionsTab/InteractionsTabWidget/InteractionsTabListItem.scss":
/*!*******************************************************************************************!*\
  !*** ./src/components/InteractionsTab/InteractionsTabWidget/InteractionsTabListItem.scss ***!
  \*******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  font-family: var(--font-family, var(--brand-font-regular));
  width: 100%;
}

.container {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  height: 100%;
  width: 100%;
  min-width: 60px;
  padding: 8px 0px;
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px; /* Icon placeholder width, actual icon will be 16x16 */
  height: 100%;
  margin-right: 12px;
  flex-shrink: 0;
}

.text-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-width: 0px;
}
.text-container .primary-label {
  font-size: var(--font-size-large, 16px);
  color: var(--md-primary-text-color);
  line-height: 24px;
  font-weight: 500;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  max-width: 90%;
}
.text-container .primary-label[data-selected=true] {
  font-family: var(--brand-font-bold, "CiscoSansTT Bold");
  font-weight: 700;
}
.text-container .secondary-label,
.text-container .tertiary-label {
  font-size: 14px;
  font-weight: 400;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: flex;
  max-width: 90%;
  color: var(--md-secondary-text-color);
  line-height: 20px;
  gap: 5px;
}
.text-container .separator {
  color: var(--md-secondary-text-color);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/InteractionsTab/InteractionsTabWidget/InteractionsTabListItem.ts":
/*!*****************************************************************************************!*\
  !*** ./src/components/InteractionsTab/InteractionsTabWidget/InteractionsTabListItem.ts ***!
  \*****************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableListItemElement: () => (/* binding */ TableListItemElement)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _InteractionsTabListItem_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./InteractionsTabListItem.scss */ "./src/components/InteractionsTab/InteractionsTabWidget/InteractionsTabListItem.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




const SEPARATOR = "•";
//TODO: Wire this up with data from WcGrid full width renderer
let TableListItemElement = class TableListItemElement extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
    constructor() {
        super(...arguments);
        this.channelType = "";
        this.primaryLabel = "";
        this.secondRowLeft = "";
        this.isSecondRowTimerActive = false;
        this.thirdRowLeft = "";
        this.isThirdRowTimerActive = false;
    }
    static get styles() {
        return _InteractionsTabListItem_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
    }
    renderIcon() {
        return this.channelType !== ""
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<md-avatar size="32" type="${this.channelType}" state="rest" avatar-style="default"></md-avatar>`
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}`;
    }
    renderDuration(duration, isActive) {
        return duration === undefined
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}`
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<agentx-wc-table-duration
          no-padding
          duration=${duration}
          ?isActive=${isActive}
          ?hideTimerIcon=${true}
        ></agentx-wc-table-duration>`;
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <li class="container">
        <div class="icon-container">${this.renderIcon()}</div>
        <div class="text-container">
          <div class="primary-label">${this.primaryLabel}</div>
          <div class="secondary-label">
            ${this.secondRowLeft}
            ${this.secondRowTimer !== undefined ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<div class="separator">${SEPARATOR}</div>` : (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}`}
            ${this.renderDuration(this.secondRowTimer, this.isSecondRowTimerActive)}
          </div>
          <div class="tertiary-label">
            ${this.thirdRowLeft}
            ${this.thirdRowRight !== undefined
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<div class="separator">${SEPARATOR}</div>
                  ${this.thirdRowRight}`
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}`}
            ${this.renderDuration(this.thirdRowTimer, this.isThirdRowTimerActive)}
          </div>
        </div>
      </li>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
], TableListItemElement.prototype, "data", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], TableListItemElement.prototype, "channelType", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], TableListItemElement.prototype, "primaryLabel", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], TableListItemElement.prototype, "secondRowLeft", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
], TableListItemElement.prototype, "secondRowTimer", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
], TableListItemElement.prototype, "isSecondRowTimerActive", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], TableListItemElement.prototype, "thirdRowLeft", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], TableListItemElement.prototype, "thirdRowRight", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
], TableListItemElement.prototype, "thirdRowTimer", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
], TableListItemElement.prototype, "isThirdRowTimerActive", void 0);
TableListItemElement = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("interactions-listitem")
], TableListItemElement);



/***/ }),

/***/ "./src/components/InteractionsTab/InteractionsTabWidget/InteractionsTabWidget.scss":
/*!*****************************************************************************************!*\
  !*** ./src/components/InteractionsTab/InteractionsTabWidget/InteractionsTabWidget.scss ***!
  \*****************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  display: block;
  height: 100%;
  width: 100%;
}

md-alert-banner {
  display: block;
  margin-bottom: 8px;
}

agentx-wc-interactions-tab-table-header {
  margin-top: 8px;
  margin-bottom: 8px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0ludGVyYWN0aW9uc1RhYi9JbnRlcmFjdGlvbnNUYWJXaWRnZXQvSW50ZXJhY3Rpb25zVGFiV2lkZ2V0LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxjQUFBO0VBQ0EsWUFBQTtFQUNBLFdBQUE7QUFDRjs7QUFFQTtFQUNFLGNBQUE7RUFDQSxrQkFBQTtBQUNGOztBQUVBO0VBQ0UsZUFBQTtFQUNBLGtCQUFBO0FBQ0Y7O0FBRUE7RUFDRSxhQUFBO0VBQ0Esc0JBQUE7RUFDQSxZQUFBO0VBQ0EsV0FBQTtBQUNGIiwic291cmNlc0NvbnRlbnQiOlsiOmhvc3Qge1xuICBkaXNwbGF5OiBibG9jaztcbiAgaGVpZ2h0OiAxMDAlO1xuICB3aWR0aDogMTAwJTtcbn1cblxubWQtYWxlcnQtYmFubmVyIHtcbiAgZGlzcGxheTogYmxvY2s7XG4gIG1hcmdpbi1ib3R0b206IDhweDtcbn1cblxuYWdlbnR4LXdjLWludGVyYWN0aW9ucy10YWItdGFibGUtaGVhZGVyIHtcbiAgbWFyZ2luLXRvcDogOHB4O1xuICBtYXJnaW4tYm90dG9tOiA4cHg7XG59XG5cbi5lbXB0eS1zdGF0ZSB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGhlaWdodDogMTAwJTtcbiAgd2lkdGg6IDEwMCU7XG59XG4iXSwic291cmNlUm9vdCI6IiJ9 */`);
    

/***/ }),

/***/ "./src/components/InteractionsTab/InteractionsTabWidget/InteractionsTabWidget.ts":
/*!***************************************************************************************!*\
  !*** ./src/components/InteractionsTab/InteractionsTabWidget/InteractionsTabWidget.ts ***!
  \***************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InteractionsTabWidget: () => (/* binding */ InteractionsTabWidget)
/* harmony export */ });
/* harmony import */ var _components_Common_WcGrid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/WcGrid */ "./src/components/Common/WcGrid/index.ts");
/* harmony import */ var _components_Common_WcGrid_WcAgGridWrapper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/components/Common/WcGrid/WcAgGridWrapper */ "./src/components/Common/WcGrid/WcAgGridWrapper.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lit_html_directives_repeat_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! lit-html/directives/repeat.js */ "lit-html/directives/repeat.js");
/* harmony import */ var lit_html_directives_repeat_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! mobx */ "mobx");
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(mobx__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _InteractionsServerSideDataSource_InteractionsServerSideDataSource__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../InteractionsServerSideDataSource/InteractionsServerSideDataSource */ "./src/components/InteractionsTab/InteractionsServerSideDataSource/InteractionsServerSideDataSource.ts");
/* harmony import */ var _InteractionsTabWidgetEmptyState_InteractionsTabWidgetEmptyState__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../InteractionsTabWidgetEmptyState/InteractionsTabWidgetEmptyState */ "./src/components/InteractionsTab/InteractionsTabWidgetEmptyState/InteractionsTabWidgetEmptyState.ts");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../config */ "./src/components/InteractionsTab/config.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../constants */ "./src/components/InteractionsTab/constants.ts");
/* harmony import */ var _InteractionsTabAlertBanner__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./InteractionsTabAlertBanner */ "./src/components/InteractionsTab/InteractionsTabWidget/InteractionsTabAlertBanner.ts");
/* harmony import */ var _InteractionsTabListItem__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./InteractionsTabListItem */ "./src/components/InteractionsTab/InteractionsTabWidget/InteractionsTabListItem.ts");
/* harmony import */ var _InteractionsTabWidget_scss__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./InteractionsTabWidget.scss */ "./src/components/InteractionsTab/InteractionsTabWidget/InteractionsTabWidget.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

















let InteractionsTabWidget = class InteractionsTabWidget extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.i18nMixin)(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_4__.MobxLitElement) {
    constructor() {
        super(...arguments);
        this.isActionsColumnEnabled = false;
        this.tabColumnDefinitions = this.calculateTabColumnDefinitions();
        this.selectedTab = _constants__WEBPACK_IMPORTED_MODULE_13__.DEFAULT_SELECTED_TAB;
        this.maximumSentimentValue = 5.0;
        this.isDarkMode = false;
        this.isRTDIntialized = false;
        this.pendingInteractionsCount = 0; // TODO liroddy - in future when fully wired up with WS we can remove this
        this.userRole = "";
        this.completedTimeRange = {
            start: _constants__WEBPACK_IMPORTED_MODULE_13__.DEFAULT_SEARCH_START_TIME,
            end: _constants__WEBPACK_IMPORTED_MODULE_13__.DEFAULT_SEARCH_END_TIME
        };
        this.displayedRowCount = 0;
        this.isLoading = true;
        this.gridConfig = this.getGridConfigForTab(_constants__WEBPACK_IMPORTED_MODULE_13__.DEFAULT_SELECTED_TAB);
        this.isCollapsed = false;
        this.api = null;
        //DO NOT ADD ANY MORE GridOptions, move them into WcGrid.
        this.gridOptions = {
            //TODO: re-use "displayed-row-count-changed" event from WcGrid, preferably within WcGrid + the header.
            onModelUpdated: (_event) => {
                if (this.api) {
                    this.displayedRowCount = this.api.getDisplayedRowCount();
                }
            },
            //TODO: Move to WcColumnDefs, have a designated column that defines the row id function.
            getRowId: (params) => {
                var _a, _b;
                return (_b = (_a = params.data) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : "";
            }
        };
    }
    calculateTabColumnDefinitions() {
        return {
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryType.Active]: (0,_config__WEBPACK_IMPORTED_MODULE_12__.getActiveTabDefaultColumnDefinitions)(this.isActionsColumnEnabled),
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryType.Queued]: (0,_config__WEBPACK_IMPORTED_MODULE_12__.getQueuedTabDefaultColumnDefinitions)(this.isActionsColumnEnabled),
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryType.Completed]: (0,_config__WEBPACK_IMPORTED_MODULE_12__.getCompletedTabDefaultColumnDefinitions)(this.isActionsColumnEnabled)
        };
    }
    static get styles() {
        return _InteractionsTabWidget_scss__WEBPACK_IMPORTED_MODULE_16__["default"];
    }
    get openTabLabel() {
        return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:interactions:active");
    }
    get queuedTabLabel() {
        return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:interactions:queued");
    }
    get closedTabLabel() {
        return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:interactions:completed");
    }
    get optionalCompletedTimeRange() {
        return this.selectedTab === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryType.Completed ? this.completedTimeRange : undefined;
    }
    get currentDataSet() {
        var _a, _b;
        const dataSetMap = {
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryType.Active]: (_a = this.interactionsStore) === null || _a === void 0 ? void 0 : _a.activeInteractions,
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryType.Queued]: (_b = this.interactionsStore) === null || _b === void 0 ? void 0 : _b.queuedInteractions,
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryType.Completed]: undefined
        };
        return dataSetMap[this.selectedTab];
    }
    get tabsToRender() {
        return [
            {
                name: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryType.Active,
                label: this.openTabLabel,
                ariaLabel: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:interactions.activeAriaLabel")
            },
            {
                name: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryType.Queued,
                label: this.queuedTabLabel,
                ariaLabel: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:interactions.queuedAriaLabel")
            },
            {
                name: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryType.Completed,
                label: this.closedTabLabel,
                ariaLabel: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:interactions.completedAriaLabel")
            }
        ];
    }
    /*
     * We need to rethink how WcGridHeaderConfig is implemented, having it on the WcGridConfig
     * means we refresh the entire grid everytime we change the header config.
     */
    getGridConfigForTab(selectedTab, isList = false) {
        const headerConfig = {
            countLabelText: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:interactions:x_interaction", "X interactions", {
                count: this.displayedRowCount
            }),
            refreshLabelText: this.refreshedMinutesAgo
                ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:interactions:refreshed_x_minutes_ago", "Refreshed X minutes ago", {
                    count: this.refreshedMinutesAgo
                })
                : undefined,
            alertBannerText: this.pendingInteractionsCount > 0
                ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:interactions:refreshToSeeNewInteractions", undefined, {
                    count: this.pendingInteractionsCount
                })
                : undefined,
            resetGridStateButton: true,
            filterButton: this.isCollapsed ? "small" : "large",
            columnSelectButton: true,
            refreshButton: false,
            datePicker: selectedTab === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryType.Completed,
            datePickerStartTime: this.completedTimeRange.start,
            datePickerEndTime: this.completedTimeRange.end,
            unsortedButton: this.isCollapsed,
            exportButton: true
        };
        if (this.interactionsStore) {
            this.serverDataSource = new _InteractionsServerSideDataSource_InteractionsServerSideDataSource__WEBPACK_IMPORTED_MODULE_10__.InteractionServerSideDataSource(this.completedTimeRange, this.interactionsStore);
        }
        const wcConfig = new _components_Common_WcGrid__WEBPACK_IMPORTED_MODULE_0__.WcGridConfig({
            tableName: `InteractionsTab-${selectedTab}`,
            enableCharts: false,
            headerConfig,
            serverSideRowModel: selectedTab === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryType.Completed,
            fetchServerRows: (params) => { var _a; return (_a = this.serverDataSource) === null || _a === void 0 ? void 0 : _a.fetchServerSideRows(params); }
        });
        if (isList) {
            wcConfig.setListConfig({
                rowHeight: 80,
                rowClickEnabled: true,
                fullWidthRowComponent: "interactions-listitem",
                detailsComponent: ""
            });
        }
        return wcConfig;
    }
    //TEMPORARY, will be removed DO NOT COPY, DO NOT BASE TESTS OFF THIS.
    updateGridApi(gridApi) {
        this.api = gridApi;
        //TODO: Move to WcColumnDefs
        this.gridOptions.columnDefs = this.tabColumnDefinitions[this.selectedTab];
        gridApi.updateGridOptions(this.gridOptions);
    }
    connectedCallback() {
        super.connectedCallback();
        _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[InteractionsTabWidget] connectedCallback");
        if (this.interactionsStore) {
            this.connectedCallbackDisposer = (0,mobx__WEBPACK_IMPORTED_MODULE_9__.autorun)(() => {
                var _a;
                this.isCollapsed = ((_a = this.interactionsStore) === null || _a === void 0 ? void 0 : _a.selectedInteraction) !== undefined;
                this.gridConfig = this.getGridConfigForTab(this.selectedTab, this.isCollapsed);
            });
        }
        this.setupGridForTab(this.selectedTab);
    }
    disconnectedCallback() {
        var _a, _b;
        super.disconnectedCallback();
        (_a = this.interactionsStore) === null || _a === void 0 ? void 0 : _a.stopInteractionUpdates(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryType.Active);
        (_b = this.interactionsStore) === null || _b === void 0 ? void 0 : _b.stopInteractionUpdates(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryType.Queued);
        if (this.connectedCallbackDisposer) {
            this.connectedCallbackDisposer();
            this.connectedCallbackDisposer = undefined;
        }
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has("isRTDIntialized") && this.isRTDIntialized) {
            this.setupGridForTab(this.selectedTab);
        }
        else if (changedProperties.has("isActionsColumnEnabled")) {
            this.tabColumnDefinitions = this.calculateTabColumnDefinitions();
            this.gridConfig = this.getGridConfigForTab(this.selectedTab, this.isCollapsed);
        }
    }
    render() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_7__.html) `
      <md-tabs
        .selectedIndex=${Object.values(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryType).indexOf(this.selectedTab)}
        @selected-changed=${this.onSelectedTabChanged}
        newMomentum
        type="rounded"
        variant="primary"
        aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:interactions.tablistAriaLabel")}"
      >
        ${(0,lit_html_directives_repeat_js__WEBPACK_IMPORTED_MODULE_8__.repeat)(this.tabsToRender, (tab) => tab.name, (tab) => (0,lit_html__WEBPACK_IMPORTED_MODULE_7__.html) `
            <md-tab slot="tab" aria-label="${tab.ariaLabel}" name="${tab.name}">${tab.label}</md-tab>
            <md-tab-panel slot="panel">
              ${tab.name === this.selectedTab ? this.renderGridContainer : lit_html__WEBPACK_IMPORTED_MODULE_7__.nothing}
            </md-tab-panel>
          `)}
      </md-tabs>
    `;
    }
    get renderEmptyStateAlertBanner() {
        if (this.pendingInteractionsCount === 0) {
            return (0,lit_html__WEBPACK_IMPORTED_MODULE_7__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_7__.nothing}`;
        }
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_7__.html) `<interactions-tab-alert-banner
      .pendingInteractionsCount=${this.pendingInteractionsCount}
    ></interactions-tab-alert-banner>`;
    }
    get emptyState() {
        var _a, _b;
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_7__.html) `<div class="empty-state">
      ${this.renderEmptyStateAlertBanner}
      <agentx-wc-interactions-tab-widget-empty-state
        selectedTab="${this.selectedTab}"
        .startTime=${(_a = this.optionalCompletedTimeRange) === null || _a === void 0 ? void 0 : _a.start}
        .endTime=${(_b = this.optionalCompletedTimeRange) === null || _b === void 0 ? void 0 : _b.end}
        @search-date-range-updated=${this.onDateRangeUpdated}
      ></agentx-wc-interactions-tab-widget-empty-state>
    </div> `;
    }
    get renderGridView() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_7__.html) `
      <wc-grid
        @action-button-open-details=${(e) => {
            var _a;
            if (e.detail.context.interactionId) {
                (_a = this.interactionsStore) === null || _a === void 0 ? void 0 : _a.setSelectedInteraction(e.detail.context.interactionId);
            }
            else {
                _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.warn("No interactionId provided in action-button-open-details event");
            }
        }}
        @row-clicked=${this.onRowClicked}
        @reset-wc-grid-state=${this.onGridReset}
        @search-date-range-updated=${this.onDateRangeUpdated}
        .isListView=${this.isCollapsed}
        .rowData=${this.currentDataSet}
      >
        <wc-grid-header
          slot="toolbar"
          .wcGridHeaderConfig=${this.gridConfig.getHeaderConfig()}
          .gridIsCollapsed=${this.isCollapsed}
        ></wc-grid-header>
        <wc-ag-grid-wrapper
          slot="grid"
          data-testid="interactions-ag-grid"
          .isDarkMode=${this.isDarkMode}
          .isListView=${this.isCollapsed}
          .wcGridConfig=${this.gridConfig}
          .rowData=${this.currentDataSet}
          .gridApiCallback=${
        //DO NOT USE, DO NOT COPY, This is temporary and will be removed
        (gridApi) => {
            this.updateGridApi(gridApi);
        }}
        ></wc-ag-grid-wrapper>
      </wc-grid>
    `;
    }
    get renderGridContainer() {
        return this.isLoading ? this.emptyState : this.renderGridView;
    }
    onGridReset(e) {
        e.stopPropagation();
        this.updateDateRange(_constants__WEBPACK_IMPORTED_MODULE_13__.DEFAULT_SEARCH_START_TIME, _constants__WEBPACK_IMPORTED_MODULE_13__.DEFAULT_SEARCH_END_TIME);
    }
    onRowClicked(e) {
        var _a, _b, _c;
        const id = (_b = (_a = e.detail) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.id;
        if (typeof id !== "string") {
            _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error("[InteractionsTabWidget] Invalid row clicked event, missing id", e.detail);
            return;
        }
        (_c = this.interactionsStore) === null || _c === void 0 ? void 0 : _c.setSelectedInteraction(id);
    }
    setupGridForTab(selectedTab) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isRTDIntialized) {
                return;
            }
            this.gridConfig = this.getGridConfigForTab(selectedTab);
            if (!this.interactionsStore) {
                _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error("[App:Interactions] interactionsStore is undefined");
                return;
            }
            const tabActions = {
                [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryType.Active]: (interactionsStore) => __awaiter(this, void 0, void 0, function* () {
                    yield interactionsStore.subscribeToInteractions(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryType.Active);
                }),
                [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryType.Queued]: (interactionsStore) => __awaiter(this, void 0, void 0, function* () {
                    yield interactionsStore.subscribeToInteractions(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryType.Queued);
                }),
                [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryType.Completed]: () => __awaiter(this, void 0, void 0, function* () {
                    // Completed tab uses server-side data source, so no subscription needed
                })
            };
            const action = tabActions[this.selectedTab];
            if (action) {
                try {
                    yield action(this.interactionsStore);
                }
                catch (error) {
                    //TODO: Update header
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error("[App:Interactions] Failed to load interactions for tab", { tab: this.selectedTab, error });
                }
            }
            else {
                _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error("[App:Interactions] Can't find action for selected tab", this.selectedTab);
            }
            this.isLoading = false;
        });
    }
    onSelectedTabChanged(e) {
        var _a;
        const { value, tabsOrder } = e.detail;
        if (typeof value !== "number" || !Array.isArray(tabsOrder)) {
            _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error("[InteractionsTabWidget] Invalid tab change event, missing fields", e.detail);
            return;
        }
        if (tabsOrder[value] === undefined) {
            _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error("[InteractionsTabWidget] Invalid tab change event, invalid selection", e.detail);
            return;
        }
        if (this.selectedTab === tabsOrder[value]) {
            return;
        }
        this.isLoading = true;
        if (this.selectedTab !== _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryType.Completed) {
            (_a = this.interactionsStore) === null || _a === void 0 ? void 0 : _a.stopInteractionUpdates(this.selectedTab);
        }
        this.selectedTab = tabsOrder[value];
        this.api = undefined;
        this.setupGridForTab(this.selectedTab);
    }
    updateDateRange(startTime, endTime) {
        var _a;
        if (this.selectedTab !== _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryType.Completed) {
            _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error("[InteractionsTabWidget] Date range updates are only allowed for the completed tab.", {
                selectedTab: this.selectedTab
            });
            return;
        }
        if (startTime === this.completedTimeRange.start && endTime === this.completedTimeRange.end) {
            return;
        }
        this.completedTimeRange = {
            start: startTime,
            end: endTime
        };
        if (this.serverDataSource) {
            this.serverDataSource.timeRange = this.completedTimeRange;
            (_a = this.api) === null || _a === void 0 ? void 0 : _a.refreshServerSide({ purge: true });
        }
    }
    onDateRangeUpdated(e) {
        var _a;
        e.stopPropagation();
        const { startTime, endTime } = (_a = e.detail) !== null && _a !== void 0 ? _a : {};
        if (typeof startTime !== "number" || typeof endTime !== "number") {
            return;
        }
        this.updateDateRange(startTime, endTime);
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Boolean })
], InteractionsTabWidget.prototype, "isActionsColumnEnabled", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Object, attribute: false })
], InteractionsTabWidget.prototype, "interactionsStore", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: String })
], InteractionsTabWidget.prototype, "selectedTab", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Number })
], InteractionsTabWidget.prototype, "maximumSentimentValue", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Boolean })
], InteractionsTabWidget.prototype, "isDarkMode", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Boolean })
], InteractionsTabWidget.prototype, "isRTDIntialized", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Number })
], InteractionsTabWidget.prototype, "pendingInteractionsCount", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Number })
], InteractionsTabWidget.prototype, "refreshedMinutesAgo", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: String, attribute: "user-role" })
], InteractionsTabWidget.prototype, "userRole", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], InteractionsTabWidget.prototype, "completedTimeRange", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], InteractionsTabWidget.prototype, "displayedRowCount", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], InteractionsTabWidget.prototype, "isLoading", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], InteractionsTabWidget.prototype, "gridConfig", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], InteractionsTabWidget.prototype, "isCollapsed", void 0);
InteractionsTabWidget = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.customElement)("agentx-wc-interactions-tab-widget")
], InteractionsTabWidget);



/***/ }),

/***/ "./src/components/InteractionsTab/InteractionsTabWidgetEmptyState/InteractionsTabWidgetEmptyState.scss":
/*!*************************************************************************************************************!*\
  !*** ./src/components/InteractionsTab/InteractionsTabWidgetEmptyState/InteractionsTabWidgetEmptyState.scss ***!
  \*************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host,
md-theme {
  width: 100%;
  height: 100%;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  text-align: center;
}
.empty-state .error-header {
  color: var(--md-primary-text-color);
  font-size: var(--body-primary-font-size, 16px);
  line-height: 24px;
  margin-bottom: 8px;
}
.empty-state .error-body {
  color: var(--md-secondary-text-color);
  font-size: var(--body-secondary-font-size, 14px);
  line-height: 20px;
}
.empty-state uuip-wc-empty-state::part(img) {
  width: 192px;
  height: 192px;
}
.empty-state uuip-wc-empty-state::part(container) {
  background-color: transparent;
}

agentx-wc-interactions-tab-date-range-picker {
  margin-top: 10px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL0ludGVyYWN0aW9uc1RhYi9JbnRlcmFjdGlvbnNUYWJXaWRnZXRFbXB0eVN0YXRlL0ludGVyYWN0aW9uc1RhYldpZGdldEVtcHR5U3RhdGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7RUFFRSxXQUFBO0VBQ0EsWUFBQTtBQUNGOztBQUVBO0VBQ0UsYUFBQTtFQUNBLHNCQUFBO0VBQ0EsbUJBQUE7RUFDQSx1QkFBQTtFQUNBLFdBQUE7RUFDQSxZQUFBO0VBQ0Esa0JBQUE7QUFDRjtBQUNFO0VBQ0UsbUNBQUE7RUFDQSw4Q0FBQTtFQUNBLGlCQUFBO0VBQ0Esa0JBQUE7QUFDSjtBQUVFO0VBQ0UscUNBQUE7RUFDQSxnREFBQTtFQUNBLGlCQUFBO0FBQUo7QUFHRTtFQUNFLFlBQUE7RUFDQSxhQUFBO0FBREo7QUFJRTtFQUNFLDZCQUFBO0FBRko7O0FBTUE7RUFDRSxnQkFBQTtBQUhGIiwic291cmNlc0NvbnRlbnQiOlsiOmhvc3QsXG5tZC10aGVtZSB7XG4gIHdpZHRoOiAxMDAlO1xuICBoZWlnaHQ6IDEwMCU7XG59XG5cbi5lbXB0eS1zdGF0ZSB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICB3aWR0aDogMTAwJTtcbiAgaGVpZ2h0OiAxMDAlO1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG5cbiAgLmVycm9yLWhlYWRlciB7XG4gICAgY29sb3I6IHZhcigtLW1kLXByaW1hcnktdGV4dC1jb2xvcik7XG4gICAgZm9udC1zaXplOiB2YXIoLS1ib2R5LXByaW1hcnktZm9udC1zaXplLCAxNnB4KTtcbiAgICBsaW5lLWhlaWdodDogMjRweDtcbiAgICBtYXJnaW4tYm90dG9tOiA4cHg7XG4gIH1cblxuICAuZXJyb3ItYm9keSB7XG4gICAgY29sb3I6IHZhcigtLW1kLXNlY29uZGFyeS10ZXh0LWNvbG9yKTtcbiAgICBmb250LXNpemU6IHZhcigtLWJvZHktc2Vjb25kYXJ5LWZvbnQtc2l6ZSwgMTRweCk7XG4gICAgbGluZS1oZWlnaHQ6IDIwcHg7XG4gIH1cblxuICB1dWlwLXdjLWVtcHR5LXN0YXRlOjpwYXJ0KGltZykge1xuICAgIHdpZHRoOiAxOTJweDtcbiAgICBoZWlnaHQ6IDE5MnB4O1xuICB9XG5cbiAgdXVpcC13Yy1lbXB0eS1zdGF0ZTo6cGFydChjb250YWluZXIpIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiB0cmFuc3BhcmVudDtcbiAgfVxufVxuXG5hZ2VudHgtd2MtaW50ZXJhY3Rpb25zLXRhYi1kYXRlLXJhbmdlLXBpY2tlciB7XG4gIG1hcmdpbi10b3A6IDEwcHg7XG59XG4iXSwic291cmNlUm9vdCI6IiJ9 */`);
    

/***/ }),

/***/ "./src/components/InteractionsTab/InteractionsTabWidgetEmptyState/InteractionsTabWidgetEmptyState.ts":
/*!***********************************************************************************************************!*\
  !*** ./src/components/InteractionsTab/InteractionsTabWidgetEmptyState/InteractionsTabWidgetEmptyState.ts ***!
  \***********************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InteractionsTabWidgetEmptyState: () => (/* binding */ InteractionsTabWidgetEmptyState)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @uuip/unified-ui-platform-common-components */ "@uuip/unified-ui-platform-common-components");
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../constants */ "./src/components/InteractionsTab/constants.ts");
/* harmony import */ var _InteractionsTabDateRangePicker_InteractionsTabDateRangePicker__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../InteractionsTabDateRangePicker/InteractionsTabDateRangePicker */ "./src/components/InteractionsTab/InteractionsTabDateRangePicker/InteractionsTabDateRangePicker.ts");
/* harmony import */ var _InteractionsTabWidgetEmptyState_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./InteractionsTabWidgetEmptyState.scss */ "./src/components/InteractionsTab/InteractionsTabWidgetEmptyState/InteractionsTabWidgetEmptyState.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








let InteractionsTabWidgetEmptyState = class InteractionsTabWidgetEmptyState extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
    constructor() {
        super(...arguments);
        this.selectedTab = _constants__WEBPACK_IMPORTED_MODULE_5__.DEFAULT_SELECTED_TAB;
    }
    get openHeader() {
        return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:interactions:no_active_interactions");
    }
    get queuedHeader() {
        return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:interactions:no_queued_interactions");
    }
    get closedHeader() {
        return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:interactions:no_completed_interactions");
    }
    get openBody() {
        return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:interactions:no_active_interactions_description");
    }
    get queuedBody() {
        return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:interactions:no_queued_interactions_description");
    }
    get closedBody() {
        return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:interactions:no_completed_interactions_description");
    }
    get headerText() {
        switch (this.selectedTab) {
            case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.InteractionsServiceConstants.QueryType.Active:
                return this.openHeader;
            case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.InteractionsServiceConstants.QueryType.Queued:
                return this.queuedHeader;
            case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.InteractionsServiceConstants.QueryType.Completed:
                return this.closedHeader;
            default:
                return "";
        }
    }
    get bodyText() {
        switch (this.selectedTab) {
            case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.InteractionsServiceConstants.QueryType.Active:
                return this.openBody;
            case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.InteractionsServiceConstants.QueryType.Queued:
                return this.queuedBody;
            case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.InteractionsServiceConstants.QueryType.Completed:
                return this.closedBody;
            default:
                return "";
        }
    }
    get isDateRangePickerVisible() {
        return this.selectedTab === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.InteractionsServiceConstants.QueryType.Completed && this.startTime && this.endTime;
    }
    static get styles() {
        return _InteractionsTabWidgetEmptyState_scss__WEBPACK_IMPORTED_MODULE_7__["default"];
    }
    render() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_4__.html) `
      <div class="empty-state">
        <uuip-wc-empty-state
          illustration-src="/images/illustrations/cliff-open-192-cobalt-lime.svg"
          class="empty-state-illustration"
          illustration-name="cliff-open-192-cobalt-lime"
        >
          <div class="error-text">
            <h4 class="error-header">${this.headerText}</h4>
            <p class="error-body">
              ${this.bodyText} <br />
              <md-link
                size="midsize"
                inline
                inline-style="default"
                ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:interactions.no_interactions_learn_more")}
                href="/"
              >
                ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:interactions.no_interactions_learn_more")}
              </md-link>
            </p>
          </div>
          ${this.isDateRangePickerVisible
            ? (0,lit_html__WEBPACK_IMPORTED_MODULE_4__.html) `
                <agentx-wc-interactions-tab-date-range-picker
                  .startTime=${this.startTime}
                  .endTime=${this.endTime}
                ></agentx-wc-interactions-tab-date-range-picker>
              `
            : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}
        </uuip-wc-empty-state>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)()
], InteractionsTabWidgetEmptyState.prototype, "selectedTab", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Number })
], InteractionsTabWidgetEmptyState.prototype, "startTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Number })
], InteractionsTabWidgetEmptyState.prototype, "endTime", void 0);
InteractionsTabWidgetEmptyState = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-interactions-tab-widget-empty-state")
], InteractionsTabWidgetEmptyState);



/***/ }),

/***/ "./src/components/InteractionsTab/config.ts":
/*!**************************************************!*\
  !*** ./src/components/InteractionsTab/config.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   actionsValueGetter: () => (/* binding */ actionsValueGetter),
/* harmony export */   channelValueFormatter: () => (/* binding */ channelValueFormatter),
/* harmony export */   channelValueGetter: () => (/* binding */ channelValueGetter),
/* harmony export */   conferencesValueGetter: () => (/* binding */ conferencesValueGetter),
/* harmony export */   consultsValueGetter: () => (/* binding */ consultsValueGetter),
/* harmony export */   csatValueFormatter: () => (/* binding */ csatValueFormatter),
/* harmony export */   customerIdValueGetter: () => (/* binding */ customerIdValueGetter),
/* harmony export */   durationValueFormatter: () => (/* binding */ durationValueFormatter),
/* harmony export */   emailCcValueGetter: () => (/* binding */ emailCcValueGetter),
/* harmony export */   formatDuration: () => (/* binding */ formatDuration),
/* harmony export */   getActiveTabDefaultColumnDefinitions: () => (/* binding */ getActiveTabDefaultColumnDefinitions),
/* harmony export */   getCompletedTabDefaultColumnDefinitions: () => (/* binding */ getCompletedTabDefaultColumnDefinitions),
/* harmony export */   getQueuedTabDefaultColumnDefinitions: () => (/* binding */ getQueuedTabDefaultColumnDefinitions),
/* harmony export */   mapColumnIdToQueryField: () => (/* binding */ mapColumnIdToQueryField),
/* harmony export */   skillsValueGetter: () => (/* binding */ skillsValueGetter),
/* harmony export */   timeValueGetter: () => (/* binding */ timeValueGetter)
/* harmony export */ });
/* harmony import */ var _components_Common_CellRenderers_constants_channel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/CellRenderers/constants/channel */ "./src/components/Common/CellRenderers/constants/channel.ts");
/* harmony import */ var _components_Common_CellRenderers_constants_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/components/Common/CellRenderers/constants/types */ "./src/components/Common/CellRenderers/constants/types.ts");
/* harmony import */ var _components_Common_CellRenderers_filters_TimestampFilter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/components/Common/CellRenderers/filters/TimestampFilter */ "./src/components/Common/CellRenderers/filters/TimestampFilter.ts");
/* harmony import */ var _components_InteractionsTab_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/components/InteractionsTab/constants */ "./src/components/InteractionsTab/constants.ts");
/* harmony import */ var _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @/components/InteractionsTab/types */ "./src/components/InteractionsTab/types.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../Common/CellRenderers/Utils */ "./src/components/Common/CellRenderers/Utils.ts");
/* harmony import */ var _GridWidget_KeySuppressor__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../GridWidget/KeySuppressor */ "./src/components/GridWidget/KeySuppressor.ts");










const keySuppressor = new _GridWidget_KeySuppressor__WEBPACK_IMPORTED_MODULE_9__.KeySuppressor(["actions"], "agentx-wc-table-action-buttons");
function formatDuration(milliseconds) {
    if (typeof milliseconds !== "number" || milliseconds <= 0) {
        return "00:00:00";
    }
    return luxon__WEBPACK_IMPORTED_MODULE_7__.Duration.fromMillis(milliseconds).toFormat("hh:mm:ss");
}
function durationValueFormatter(params) {
    if (params === null || params === void 0 ? void 0 : params.value) {
        if (typeof params.value === "number") {
            // e.g. WaitTime
            return formatDuration(params.value);
        }
        else if (params.value.duration && params.value.duration > 0) {
            // e.g. TotalDuration
            return formatDuration(params.value.duration);
        }
        else if (params.value.createdTime && params.value.createdTime > 0) {
            // e.g. HandleTime
            const diff = Date.now() >= params.value.createdTime
                ? luxon__WEBPACK_IMPORTED_MODULE_7__.Duration.fromMillis(Date.now() - params.value.createdTime)
                : luxon__WEBPACK_IMPORTED_MODULE_7__.Duration.fromMillis(0);
            return formatDuration(diff.milliseconds);
        }
    }
    return "00:00:00";
}
function csatValueFormatter(params) {
    var _a;
    return params.value ? ((_a = params.value.toFixed(1)) !== null && _a !== void 0 ? _a : "0.0") : "0.0";
}
function timeValueGetter(params) {
    var _a, _b, _c;
    const createdTime = (_a = params.data["createdTime"]) !== null && _a !== void 0 ? _a : 0;
    const active = (_b = params.data["isActive"]) !== null && _b !== void 0 ? _b : false;
    const duration = (_c = params.data[params.colDef.field]) !== null && _c !== void 0 ? _c : 0;
    return {
        duration,
        createdTime,
        active
    };
}
function channelValueGetter(params) {
    const channelType = params.data[params.colDef.field];
    const channelSubType = params.data["channelSubType"];
    const type = channelType === _components_Common_CellRenderers_constants_types__WEBPACK_IMPORTED_MODULE_1__.ChannelTypes.Social ? channelSubType : channelType;
    const value = _components_Common_CellRenderers_constants_channel__WEBPACK_IMPORTED_MODULE_0__.CHANNEL_TYPE_TO_ICON_MAP[type];
    return {
        channelType: value,
        type
    };
}
function getTranslatedChannelType(channelType) {
    const translationId = (0,_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_8__.getAvatarAriaTranslationId)(channelType);
    return translationId ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)(translationId) : _components_InteractionsTab_constants__WEBPACK_IMPORTED_MODULE_3__.DEFAULT_EMPTY_VALUE;
}
function channelValueFormatter(params) {
    if (!params.value) {
        return _components_InteractionsTab_constants__WEBPACK_IMPORTED_MODULE_3__.DEFAULT_EMPTY_VALUE;
    }
    return getTranslatedChannelType(params.value.channelType);
}
function customerIdValueGetter(params) {
    var _a;
    const customer = (_a = params.data[params.colDef.field]) !== null && _a !== void 0 ? _a : null;
    if (customer) {
        if (customer.phoneNumber && customer.phoneNumber.length > 0) {
            return customer.phoneNumber.toString();
        }
        else if (customer.email && customer.email.length > 0) {
            return customer.email;
        }
    }
    return _components_InteractionsTab_constants__WEBPACK_IMPORTED_MODULE_3__.DEFAULT_EMPTY_VALUE;
}
function emailCcValueGetter(params) {
    var _a, _b;
    const emailCcList = (_a = params.data[params.colDef.field]) !== null && _a !== void 0 ? _a : "";
    const emailBccList = (_b = params.data["emailBccList"]) !== null && _b !== void 0 ? _b : "";
    const emailList = emailCcList
        .split(",")
        .concat(emailBccList.split(","))
        .filter((email) => email.length > 0);
    return emailList.length > 0 ? emailList.join(", ") : _components_InteractionsTab_constants__WEBPACK_IMPORTED_MODULE_3__.DEFAULT_EMPTY_VALUE;
}
function consultsValueGetter(params) {
    var _a, _b, _c;
    const consults = (_a = params.data[params.colDef.field]) !== null && _a !== void 0 ? _a : [];
    const consultsCount = (_b = params.data["consultCount"]) !== null && _b !== void 0 ? _b : 0;
    const consultsDuration = (_c = params.data["consultDuration"]) !== null && _c !== void 0 ? _c : 0;
    const consultContacts = consults
        .map((consult) => `${consult.name}:${consult.id}`)
        .join(", ");
    let consultInfo = _components_InteractionsTab_constants__WEBPACK_IMPORTED_MODULE_3__.DEFAULT_EMPTY_VALUE;
    if (consultsCount !== 0) {
        consultInfo = `${consultsCount}`;
    }
    if (consultsDuration !== 0) {
        consultInfo = `${consultInfo} (${formatDuration(consultsDuration)})`;
    }
    if (consultContacts.length > 0) {
        consultInfo = `${consultInfo}: ${consultContacts}`;
    }
    return consultInfo;
}
function conferencesValueGetter(params) {
    var _a, _b, _c;
    const conferenceCount = (_a = params.data[params.colDef.field]) !== null && _a !== void 0 ? _a : 0;
    const conferenceDuration = (_b = params.data["conferenceDuration"]) !== null && _b !== void 0 ? _b : 0;
    const contributors = (_c = params.data["contributors"]) !== null && _c !== void 0 ? _c : [];
    const contributorContacts = contributors
        .map((contributor) => `${contributor.name}:${contributor.id}`)
        .join(", ");
    let conferenceInfo = _components_InteractionsTab_constants__WEBPACK_IMPORTED_MODULE_3__.DEFAULT_EMPTY_VALUE;
    if (conferenceCount !== 0) {
        conferenceInfo = `${conferenceCount}`;
    }
    if (conferenceDuration !== 0) {
        conferenceInfo = `${conferenceInfo} (${formatDuration(conferenceDuration)})`;
    }
    if (contributorContacts.length > 0) {
        conferenceInfo = `${conferenceInfo}: ${contributorContacts}`;
    }
    return conferenceInfo;
}
function skillsValueGetter(params) {
    var _a, _b, _c;
    const matchedSkills = (_a = params.data["matchedSkills"]) !== null && _a !== void 0 ? _a : "";
    const requiredSkills = (_b = params.data["requiredSkills"]) !== null && _b !== void 0 ? _b : "";
    const matchedSkillsProfile = (_c = params.data["matchedSkillsProfile"]) !== null && _c !== void 0 ? _c : "";
    const parts = [];
    if (matchedSkills) {
        parts.push(matchedSkills);
    }
    if (requiredSkills) {
        parts.push(requiredSkills);
    }
    if (matchedSkillsProfile) {
        parts.push(matchedSkillsProfile);
    }
    return parts.join("; ");
}
function actionsValueGetter(params) {
    return {
        buttons: [
            { type: _components_Common_CellRenderers_constants_types__WEBPACK_IMPORTED_MODULE_1__.ActionButtons.view },
            { type: _components_Common_CellRenderers_constants_types__WEBPACK_IMPORTED_MODULE_1__.ActionButtons.download, options: ["audio", "transcript"] },
            { type: _components_Common_CellRenderers_constants_types__WEBPACK_IMPORTED_MODULE_1__.ActionButtons.more }
        ],
        context: {
            interactionId: params.data["id"]
        }
    };
}
const COLUMN_DEFINITION_FIELDS = {
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Id]: "id",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Channel]: "channelType",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.StartTime]: "createdTime",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.EndTime]: "endedTime",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.CustomerName]: "customer.name",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Customer]: "customer",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Direction]: "direction",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.EntryPoint]: "lastEntryPoint.name",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Queue]: "lastQueue.name",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Team]: "lastTeam.name",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Site]: "lastSite.name",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.ContactStatus]: "status",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Agent]: "lastAgent.name",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.CSAT]: "csatScore",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.HandleTime]: "connectedDuration",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Transfers]: "transferCount",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.BlindTransfers]: "blindTransferCount",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.HoldTime]: "holdDuration",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Timestamp]: "lastActivityTime",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.WrapUpTime]: "wrapupDuration",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.TotalContactDuration]: "totalDuration",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Recipients]: "emailToList",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.CCRecipients]: "emailCcList",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.EmailSubject]: "channelMetadata.email.subject",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.WrapUpReason]: "lastWrapupCodeName",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.ConsultingAgents]: "consults",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.ConferencingAgents]: "conferenceCount",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Skills]: "skills",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.QueuedFrom]: "previousQueue.name",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.TransferredToQueue]: "agentToQueueTransferCount",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.TransferredByAgent]: "previousAgentName",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.WaitTime]: "queueDuration",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Actions]: "actions"
};
function mapColumnIdToQueryField(columnId) {
    var _a;
    const COLUMN_ID_TO_QUERY_FIELD_MAP = {
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Id]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.Id],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Channel]: [
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.ChannelType,
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.ChannelSubType
        ],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.StartTime]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.CreatedTime],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.EndTime]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.EndedTime],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.CustomerName]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.CustomerName],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Customer]: [
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.CustomerEmail,
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.CustomerPhone
        ],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Direction]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.Direction],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.EntryPoint]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.EntryPointName],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Queue]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.QueueName],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Team]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.TeamName],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Site]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.SiteName],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.ContactStatus]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.Status],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Agent]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.AgentName],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.CSAT]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.CSATScore],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.HandleTime]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.ConnectedDuration],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Transfers]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.TransferCount],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.BlindTransfers]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.BlindTransferCount],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.HoldTime]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.HoldDuration],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Timestamp]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.LastActivityTime],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.WrapUpTime]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.WrapUpDuration],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.TotalContactDuration]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.ConnectedDuration],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Recipients]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.EmailToList],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.CCRecipients]: [
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.EmailCcList,
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.EmailBccList
        ],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.EmailSubject]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.EmailSubject],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.WrapUpReason]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.WrapUpCodeName],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.ConferencingAgents]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.ConferenceCount],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Skills]: [
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.MatchedSkills,
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.RequiredSkills,
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.MatchedSkillsProfile
        ],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.QueuedFrom]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.PreviousQueueName],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.TransferredToQueue]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.AgentToQueueTransferCount],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.TransferredByAgent]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.PreviousAgentName],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.WaitTime]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryField.QueueDuration]
    };
    return (_a = COLUMN_ID_TO_QUERY_FIELD_MAP[columnId]) !== null && _a !== void 0 ? _a : [];
}
const defaultFilterParams = {
    maxNumConditions: 1,
    defaultToNothingSelected: true,
    suppressSelectAll: true
};
const textFilterParams = Object.assign(Object.assign({}, defaultFilterParams), { filterOptions: ["contains", "equals"] });
const numberFilterParams = Object.assign(Object.assign({}, defaultFilterParams), { filterOptions: ["equals", "greaterThan", "greaterThanOrEqual", "lessThan", "lessThanOrEqual"] });
const dateFilterParams = Object.assign(Object.assign({}, defaultFilterParams), { defaultOption: "lessThan", filterOptions: ["greaterThan", "lessThan", "inRange"], comparator: (filterLocalDateAtMidnight, cellValue) => {
        const filterMs = filterLocalDateAtMidnight.getTime();
        if (cellValue > filterMs) {
            return 1;
        }
        else if (cellValue < filterMs) {
            return -1;
        }
        return 0;
    } });
function dateTimeValueFormatter(params) {
    if (!params.value || typeof params.value !== "number") {
        return _components_InteractionsTab_constants__WEBPACK_IMPORTED_MODULE_3__.DEFAULT_EMPTY_VALUE;
    }
    const date = luxon__WEBPACK_IMPORTED_MODULE_7__.DateTime.fromMillis(params.value);
    return date.isValid ? date.toLocaleString(luxon__WEBPACK_IMPORTED_MODULE_7__.DateTime.DATETIME_SHORT_WITH_SECONDS) : "";
}
function getChannelTypeValues() {
    const keys = Object.values(_components_Common_CellRenderers_constants_types__WEBPACK_IMPORTED_MODULE_1__.ChannelTypes).filter((key) => key !== _components_Common_CellRenderers_constants_types__WEBPACK_IMPORTED_MODULE_1__.ChannelTypes.Social);
    keys.push(...Object.values(_components_Common_CellRenderers_constants_types__WEBPACK_IMPORTED_MODULE_1__.ChannelSubTypes));
    return keys.map((key) => {
        return { channelType: _components_Common_CellRenderers_constants_channel__WEBPACK_IMPORTED_MODULE_0__.CHANNEL_TYPE_TO_ICON_MAP[key], type: key };
    });
}
function getContactStatusValues() {
    // TODO: where should these come from and what's the full list?
    return [
        "on-hold",
        "consulting",
        "connected",
        "wrapup",
        "wrapup-assistance",
        "consult-done",
        "conferencing",
        "consult",
        "consult-error",
        "postcall-started-main",
        "postcall-started-consult",
        "parked",
        "ended"
    ];
}
function getBaseColumnDefinition(colId) {
    return {
        colId,
        field: COLUMN_DEFINITION_FIELDS[colId],
        autoHeight: false
    };
}
const ALL_INTERACTIONS_COLUMN_DEFINTIONS = {
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Id]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Id)), { comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_8__.naturalStringComparator, filter: "agTextColumnFilter", filterParams: Object.assign({ filterOptions: ["equals"] }, defaultFilterParams) }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Channel]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Channel)), { valueGetter: channelValueGetter, valueFormatter: channelValueFormatter, useValueFormatterForExport: true, cellRenderer: "channelRenderer", comparator: (valueA, valueB) => (0,_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_8__.naturalStringComparator)(valueA.text, valueB.text), filter: "agSetColumnFilter", filterParams: Object.assign({ values: getChannelTypeValues(), valueFormatter: channelValueFormatter, comparator: (valueA, valueB) => (0,_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_8__.naturalStringComparator)(getTranslatedChannelType(valueA.channelType), getTranslatedChannelType(valueB.channelType)), keyCreator: (params) => params.value.type }, defaultFilterParams) }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.StartTime]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.StartTime)), { valueFormatter: dateTimeValueFormatter, useValueFormatterForExport: true, filter: "agDateColumnFilter", filterParams: dateFilterParams }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.EndTime]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.EndTime)), { valueFormatter: dateTimeValueFormatter, useValueFormatterForExport: true, filter: "agDateColumnFilter", filterParams: dateFilterParams }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.CustomerName]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.CustomerName)), { comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_8__.naturalStringComparator, filter: "agTextColumnFilter", filterParams: textFilterParams }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Customer]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Customer)), { valueGetter: customerIdValueGetter, comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_8__.naturalStringComparator, filter: "agTextColumnFilter", filterParams: textFilterParams }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Direction]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Direction)), { comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_8__.naturalStringComparator, filter: "agSetColumnFilter", filterParams: Object.assign({ values: ["inbound", "outbound"], valueFormatter: (params) => (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)(`app:common:direction:${params.value}`), comparator: (valueA, valueB) => (0,_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_8__.naturalStringComparator)((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)(`app:common:direction:${valueA}`), (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)(`app:common:direction:${valueB}`)), suppressMiniFilter: true }, defaultFilterParams) }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.EntryPoint]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.EntryPoint)), { comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_8__.naturalStringComparator, filter: "agTextColumnFilter", filterParams: textFilterParams }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Queue]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Queue)), { comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_8__.naturalStringComparator, filter: "agTextColumnFilter", filterParams: textFilterParams }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Team]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Team)), { comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_8__.naturalStringComparator, filter: "agTextColumnFilter", filterParams: textFilterParams }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Site]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Site)), { comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_8__.naturalStringComparator, filter: "agTextColumnFilter", filterParams: textFilterParams }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.ContactStatus]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.ContactStatus)), { comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_8__.naturalStringComparator, filter: "agSetColumnFilter", filterParams: Object.assign({ values: getContactStatusValues(), valueFormatter: (params) => (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)(`app:common:contactStatus:${params.value}`), comparator: (valueA, valueB) => (0,_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_8__.naturalStringComparator)((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)(`app:common:contactStatus:${valueA}`), (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)(`app:common:contactStatus:${valueB}`)) }, defaultFilterParams) }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Agent]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Agent)), { comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_8__.agentNameComparator, cellRenderer: "agentNameRenderer", valueFormatter: (params) => { var _a; return (_a = params.data.lastAgent) === null || _a === void 0 ? void 0 : _a.name; }, useValueFormatterForExport: true, filter: "agTextColumnFilter", filterParams: textFilterParams, filterValueGetter: (params) => { var _a; return (_a = params.data.lastAgent) === null || _a === void 0 ? void 0 : _a.name; } }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.CSAT]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.CSAT)), { cellRenderer: "sentimentRenderer", valueFormatter: csatValueFormatter, useValueFormatterForExport: true, filter: "agSetColumnFilter", filterParams: Object.assign({ values: ["1", "2", "3", "4", "5"], suppressMiniFilter: true }, defaultFilterParams) }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.HandleTime]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.HandleTime)), { valueGetter: timeValueGetter, cellRenderer: "durationRenderer", valueFormatter: durationValueFormatter, useValueFormatterForExport: true, filter: _components_Common_CellRenderers_filters_TimestampFilter__WEBPACK_IMPORTED_MODULE_2__.TimestampFilter }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Transfers]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Transfers)), { filter: "agNumberColumnFilter", filterParams: numberFilterParams }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.BlindTransfers]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.BlindTransfers)), { filter: "agNumberColumnFilter", filterParams: numberFilterParams }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.HoldTime]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.HoldTime)), { valueFormatter: durationValueFormatter, useValueFormatterForExport: true, filter: _components_Common_CellRenderers_filters_TimestampFilter__WEBPACK_IMPORTED_MODULE_2__.TimestampFilter }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Timestamp]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Timestamp)), { valueFormatter: dateTimeValueFormatter, useValueFormatterForExport: true, filter: "agDateColumnFilter", filterParams: dateFilterParams }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.WrapUpTime]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.WrapUpTime)), { valueFormatter: durationValueFormatter, useValueFormatterForExport: true, filter: _components_Common_CellRenderers_filters_TimestampFilter__WEBPACK_IMPORTED_MODULE_2__.TimestampFilter }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.TotalContactDuration]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.TotalContactDuration)), { valueGetter: timeValueGetter, cellRenderer: "durationRenderer", valueFormatter: durationValueFormatter, useValueFormatterForExport: true, filter: _components_Common_CellRenderers_filters_TimestampFilter__WEBPACK_IMPORTED_MODULE_2__.TimestampFilter }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Recipients]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Recipients)), { comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_8__.naturalStringComparator, filter: "agTextColumnFilter", filterParams: textFilterParams }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.CCRecipients]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.CCRecipients)), { valueGetter: emailCcValueGetter, comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_8__.naturalStringComparator, filter: "agTextColumnFilter", filterParams: textFilterParams }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.EmailSubject]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.EmailSubject)), { comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_8__.naturalStringComparator, filter: "agTextColumnFilter", filterParams: textFilterParams }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.WrapUpReason]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.WrapUpReason)), { comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_8__.naturalStringComparator, filter: "agTextColumnFilter", filterParams: textFilterParams }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.ConsultingAgents]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.ConsultingAgents)), { valueGetter: consultsValueGetter, comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_8__.naturalStringComparator, filter: "agTextColumnFilter", filterParams: textFilterParams }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.ConferencingAgents]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.ConferencingAgents)), { valueGetter: conferencesValueGetter, comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_8__.naturalStringComparator, filter: "agTextColumnFilter", filterParams: textFilterParams }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Skills]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Skills)), { valueGetter: skillsValueGetter, comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_8__.naturalStringComparator, filter: "agTextColumnFilter", filterParams: textFilterParams }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.QueuedFrom]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.QueuedFrom)), { comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_8__.naturalStringComparator, filter: "agTextColumnFilter", filterParams: textFilterParams }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.TransferredToQueue]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.TransferredToQueue)), { filter: "agNumberColumnFilter", filterParams: numberFilterParams }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.TransferredByAgent]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.TransferredByAgent)), { comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_8__.naturalStringComparator, filter: "agTextColumnFilter", filterParams: textFilterParams }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.WaitTime]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.WaitTime)), { valueFormatter: durationValueFormatter, useValueFormatterForExport: true, filter: _components_Common_CellRenderers_filters_TimestampFilter__WEBPACK_IMPORTED_MODULE_2__.TimestampFilter }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Actions]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Actions)), { sortable: false, pinned: "right", lockPinned: true, cellRenderer: "actionButtonsRenderer", valueGetter: actionsValueGetter, cellClass: "actions-cell", suppressKeyboardEvent: keySuppressor.suppressKeyboardEvent, autoHeight: true, valueFormatter: () => " ", useValueFormatterForExport: true })
};
function reduceColumnDefinitions({ allColumns, availableColumns, selectedColumns, isActionsColumnEnabled }) {
    if (!isActionsColumnEnabled) {
        availableColumns = availableColumns.filter((colId) => colId !== _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Actions);
    }
    return availableColumns.map((colId) => (Object.assign(Object.assign({}, allColumns[colId]), { headerName: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)(`app:interactions.columns.${colId}`), hide: !selectedColumns.includes(colId) })));
}
function getActiveTabDefaultColumnDefinitions(isActionsColumnEnabled) {
    return reduceColumnDefinitions({
        allColumns: ALL_INTERACTIONS_COLUMN_DEFINTIONS,
        availableColumns: [
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Id,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Channel,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.StartTime,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.CustomerName,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Customer,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Direction,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.EntryPoint,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Queue,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Team,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Site,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.ContactStatus,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Agent,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.CSAT,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Transfers,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.BlindTransfers,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.HoldTime,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Timestamp,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Recipients,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.CCRecipients,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.EmailSubject,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.ConsultingAgents,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.ConferencingAgents,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Skills,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.QueuedFrom,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.TransferredToQueue,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.TransferredByAgent,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.WaitTime,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Actions
        ],
        selectedColumns: [
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Id,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Channel,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Queue,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Team,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.ContactStatus,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Agent,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Actions
        ],
        isActionsColumnEnabled
    });
}
function getQueuedTabDefaultColumnDefinitions(isActionsColumnEnabled) {
    return reduceColumnDefinitions({
        allColumns: ALL_INTERACTIONS_COLUMN_DEFINTIONS,
        availableColumns: [
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Id,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Channel,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.StartTime,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.CustomerName,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Customer,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Direction,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.EntryPoint,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Queue,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Team,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Site,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.ContactStatus,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.CSAT,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Transfers,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.BlindTransfers,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.HoldTime,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Timestamp,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.TotalContactDuration,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Recipients,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.CCRecipients,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.EmailSubject,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Skills,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.QueuedFrom,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.TransferredToQueue,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.TransferredByAgent,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.WaitTime,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Actions
        ],
        selectedColumns: [
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Id,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Channel,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Queue,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.TotalContactDuration,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Skills,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.WaitTime,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Actions
        ],
        isActionsColumnEnabled
    });
}
function getCompletedTabDefaultColumnDefinitions(isActionsColumnEnabled) {
    return reduceColumnDefinitions({
        allColumns: ALL_INTERACTIONS_COLUMN_DEFINTIONS,
        availableColumns: [
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Id,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Channel,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.StartTime,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.EndTime,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.CustomerName,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Customer,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Direction,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.EntryPoint,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Queue,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Team,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Site,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.ContactStatus,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Agent,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.CSAT,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.HandleTime,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Transfers,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.BlindTransfers,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.HoldTime,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Timestamp,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.WrapUpTime,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.TotalContactDuration,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Recipients,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.CCRecipients,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.EmailSubject,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.WrapUpReason,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.ConsultingAgents,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.ConferencingAgents,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Skills,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.QueuedFrom,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.TransferredToQueue,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.TransferredByAgent,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.WaitTime,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Actions
        ],
        selectedColumns: [
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Id,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Channel,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.StartTime,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Queue,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Agent,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.CSAT,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.TotalContactDuration,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.WrapUpReason,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_4__.InteractionsTableColumnId.Actions
        ],
        isActionsColumnEnabled
    });
}


/***/ }),

/***/ "./src/components/InteractionsTab/constants.ts":
/*!*****************************************************!*\
  !*** ./src/components/InteractionsTab/constants.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   COLLAPSED_COLUMN_WIDTH: () => (/* binding */ COLLAPSED_COLUMN_WIDTH),
/* harmony export */   DEFAULT_COLUMN_WIDTH: () => (/* binding */ DEFAULT_COLUMN_WIDTH),
/* harmony export */   DEFAULT_EMPTY_VALUE: () => (/* binding */ DEFAULT_EMPTY_VALUE),
/* harmony export */   DEFAULT_SEARCH_END_TIME: () => (/* binding */ DEFAULT_SEARCH_END_TIME),
/* harmony export */   DEFAULT_SEARCH_START_TIME: () => (/* binding */ DEFAULT_SEARCH_START_TIME),
/* harmony export */   DEFAULT_SELECTED_TAB: () => (/* binding */ DEFAULT_SELECTED_TAB),
/* harmony export */   ICON_EMOJI_HAPPY: () => (/* binding */ ICON_EMOJI_HAPPY),
/* harmony export */   ICON_EMOJI_PASSIVE: () => (/* binding */ ICON_EMOJI_PASSIVE),
/* harmony export */   ICON_EMOJI_SAD: () => (/* binding */ ICON_EMOJI_SAD),
/* harmony export */   SENTIMENT_NEGATIVE: () => (/* binding */ SENTIMENT_NEGATIVE),
/* harmony export */   SENTIMENT_NEUTRAL: () => (/* binding */ SENTIMENT_NEUTRAL),
/* harmony export */   SENTIMENT_POSITIVE: () => (/* binding */ SENTIMENT_POSITIVE)
/* harmony export */ });
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_1__);


const ICON_EMOJI_SAD = "emoji-sad-filled";
const ICON_EMOJI_PASSIVE = "emoji-passive-filled";
const ICON_EMOJI_HAPPY = "emoji-happy-filled";
const SENTIMENT_NEGATIVE = "negative";
const SENTIMENT_NEUTRAL = "neutral";
const SENTIMENT_POSITIVE = "positive";
const DEFAULT_COLUMN_WIDTH = 200; // default column width in px used by ag-grid
const COLLAPSED_COLUMN_WIDTH = 284;
const DEFAULT_SEARCH_START_TIME = luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.local().minus({ days: 1 }).toMillis();
const DEFAULT_SEARCH_END_TIME = luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.local().minus({ seconds: 1 }).toMillis();
const DEFAULT_SELECTED_TAB = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.InteractionsServiceConstants.QueryType.Active;
const DEFAULT_EMPTY_VALUE = "";


/***/ }),

/***/ "./src/components/InteractionsTab/index.ts":
/*!*************************************************!*\
  !*** ./src/components/InteractionsTab/index.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InteractionsTabDetailsWidget: () => (/* reexport safe */ _InteractionsTabDetailsView_InteractionsTabDetailsWidget__WEBPACK_IMPORTED_MODULE_0__.InteractionsTabDetailsWidget),
/* harmony export */   InteractionsTabWidget: () => (/* reexport safe */ _InteractionsTabWidget_InteractionsTabWidget__WEBPACK_IMPORTED_MODULE_1__.InteractionsTabWidget)
/* harmony export */ });
/* harmony import */ var _InteractionsTabDetailsView_InteractionsTabDetailsWidget__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./InteractionsTabDetailsView/InteractionsTabDetailsWidget */ "./src/components/InteractionsTab/InteractionsTabDetailsView/InteractionsTabDetailsWidget.ts");
/* harmony import */ var _InteractionsTabWidget_InteractionsTabWidget__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./InteractionsTabWidget/InteractionsTabWidget */ "./src/components/InteractionsTab/InteractionsTabWidget/InteractionsTabWidget.ts");




/***/ }),

/***/ "./src/components/InteractionsTab/types.ts":
/*!*************************************************!*\
  !*** ./src/components/InteractionsTab/types.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InteractionsTableColumnId: () => (/* binding */ InteractionsTableColumnId)
/* harmony export */ });
var InteractionsTableColumnId;
(function (InteractionsTableColumnId) {
    InteractionsTableColumnId["Id"] = "id";
    InteractionsTableColumnId["Channel"] = "channel";
    InteractionsTableColumnId["StartTime"] = "start_time";
    InteractionsTableColumnId["EndTime"] = "end_time";
    InteractionsTableColumnId["CustomerName"] = "customer_name";
    InteractionsTableColumnId["Customer"] = "customer";
    InteractionsTableColumnId["Direction"] = "direction";
    InteractionsTableColumnId["EntryPoint"] = "entry_point";
    InteractionsTableColumnId["Queue"] = "queue";
    InteractionsTableColumnId["Team"] = "team";
    InteractionsTableColumnId["Site"] = "site";
    InteractionsTableColumnId["ContactStatus"] = "contact_status";
    InteractionsTableColumnId["Agent"] = "agent";
    InteractionsTableColumnId["CSAT"] = "csat";
    InteractionsTableColumnId["HandleTime"] = "handle_time";
    InteractionsTableColumnId["Transfers"] = "transfers";
    InteractionsTableColumnId["BlindTransfers"] = "blind_transfers";
    InteractionsTableColumnId["HoldTime"] = "hold_time";
    InteractionsTableColumnId["Timestamp"] = "timestamp";
    InteractionsTableColumnId["WrapUpTime"] = "wrap_up_time";
    InteractionsTableColumnId["TotalContactDuration"] = "total_contact_duration";
    InteractionsTableColumnId["Recipients"] = "recipients";
    InteractionsTableColumnId["CCRecipients"] = "cc_recipients";
    InteractionsTableColumnId["EmailSubject"] = "email_subject";
    InteractionsTableColumnId["WrapUpReason"] = "wrap_up_reason";
    InteractionsTableColumnId["ConsultingAgents"] = "consulting_agents";
    InteractionsTableColumnId["ConferencingAgents"] = "conferencing_agents";
    InteractionsTableColumnId["Skills"] = "skills";
    InteractionsTableColumnId["QueuedFrom"] = "queued_from";
    InteractionsTableColumnId["TransferredToQueue"] = "transferred_to_queue";
    InteractionsTableColumnId["TransferredByAgent"] = "transferred_by_agent";
    InteractionsTableColumnId["WaitTime"] = "wait_time";
    InteractionsTableColumnId["Actions"] = "actions";
})(InteractionsTableColumnId || (InteractionsTableColumnId = {}));


/***/ }),

/***/ "./src/components/IvrTranscripts/IvrTranscripts.scss":
/*!***********************************************************!*\
  !*** ./src/components/IvrTranscripts/IvrTranscripts.scss ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  --transcript-badge-left-max-width: 130px;
  --transcript-wrapper-padding: calc(var(--space-token-cardinal) * 3);
  --transcript-wrapper-margin: calc(var(--space-token-even) * 2);
  --header-height: 48px;
  --transcript-padding: calc(var(--space-token-even) * 4);
  color: var(--md-primary-text-color);
  font-family: var(--font-family);
  font-weight: var(--font-weight);
}

.ivr-transcripts {
  position: absolute;
  background: var(--md-secondary-bg-color);
  height: calc(100% - (var(--transcript-padding) + var(--header-height)));
  width: calc(100% - var(--transcript-padding));
  overflow: hidden;
  padding: var(--transcript-padding);
  display: flex;
}

.transcript-wrapper {
  width: 100%;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/IvrTranscripts/IvrTranscripts.ts":
/*!*********************************************************!*\
  !*** ./src/components/IvrTranscripts/IvrTranscripts.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DEFAULT_TRANSCRIPT_COLOR: () => (/* binding */ DEFAULT_TRANSCRIPT_COLOR),
/* harmony export */   IvrTranscripts: () => (/* binding */ IvrTranscripts)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Common_WidgetError_WidgetError__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Common/WidgetError/WidgetError */ "./src/components/Common/WidgetError/WidgetError.ts");
/* harmony import */ var _Common_WidgetLoader_WidgetLoader__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../Common/WidgetLoader/WidgetLoader */ "./src/components/Common/WidgetLoader/WidgetLoader.ts");
/* harmony import */ var _components_IntentWrapper_IntentWrapper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./components/IntentWrapper/IntentWrapper */ "./src/components/IvrTranscripts/components/IntentWrapper/IntentWrapper.ts");
/* harmony import */ var _components_TranscriptWrapper_TranscriptWrapper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./components/TranscriptWrapper/TranscriptWrapper */ "./src/components/IvrTranscripts/components/TranscriptWrapper/TranscriptWrapper.ts");
/* harmony import */ var _IvrTranscripts_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./IvrTranscripts.scss */ "./src/components/IvrTranscripts/IvrTranscripts.scss");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./utils/utils */ "./src/components/IvrTranscripts/utils/utils.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/no-explicit-any */













const DEFAULT_TRANSCRIPT_COLOR = "default";
const CONVERSATION_API_TIMEOUT = 5;
var IvrTranscripts;
(function (IvrTranscripts) {
    /**
     * @element agentx-wc-ivr-transcripts
     * @fires save-ivr-conversation
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_5__.LitElement) {
        constructor() {
            super(...arguments);
            this.selectedIntent = -1;
            this.ivrConversations = undefined;
            this.orgId = "";
            this.interactionId = "";
            this.isLoading = false;
            this.trackingId = "";
            this.setSelectedIntent = (index) => {
                this.selectedIntent = index;
            };
            this.reFetchTranscriptData = () => {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[IvrTranscript] re-fetching ivr transcript data");
                this.fetchIvrConversations();
            };
        }
        static get styles() {
            return _IvrTranscripts_scss__WEBPACK_IMPORTED_MODULE_11__["default"];
        }
        connectedCallback() {
            const _super = Object.create(null, {
                connectedCallback: { get: () => super.connectedCallback }
            });
            return __awaiter(this, void 0, void 0, function* () {
                _super.connectedCallback.call(this);
                if (!this.ivrConversations) {
                    this.fetchIvrConversations();
                }
            });
        }
        fetchIvrConversations() {
            return __awaiter(this, void 0, void 0, function* () {
                this.isLoading = true;
                this.ivrConversations = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.mediaStorage.fetchIVRTranscript(this.orgId, this.interactionId, CONVERSATION_API_TIMEOUT);
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.TrackingUtils.trackInitialCallEvents(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry, {
                    eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.IVR_TRANSCRIPT,
                    interactionId: this.interactionId,
                    contactDirection: "INBOUND",
                    mediaType: "telephony",
                    status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS,
                    ivrConversation: JSON.stringify(this.ivrConversations)
                });
                this.dispatchEvent(new CustomEvent("save-ivr-conversation", {
                    detail: {
                        interactionId: this.interactionId,
                        ivrConversation: this.ivrConversations
                    }
                }));
                this.isLoading = false;
            });
        }
        render() {
            return this.ivrConversations
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
            <div class="ivr-transcripts">
              ${(0,_utils_utils__WEBPACK_IMPORTED_MODULE_12__.showIntent)(this.ivrConversations)
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
                    <agentx-wc-ivr-intent-wrapper
                      .transcriptList=${this.ivrConversations}
                      @on-intent-select="${(e) => this.setSelectedIntent(e.detail.index)}"
                    ></agentx-wc-ivr-intent-wrapper>
                  `
                    : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
              <agentx-wc-ivr-transcript-wrapper
                class="transcript-wrapper"
                .transcriptList=${this.ivrConversations}
                selectedIntent=${this.selectedIntent}
              ></agentx-wc-ivr-transcript-wrapper>
            </div>
          `
                : this.isLoading
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) ` <agentx-wc-widget-loader></agentx-wc-widget-loader> `
                    : (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) ` <agentx-wc-widget-error @retry="${() => this.reFetchTranscriptData()}"></agentx-wc-widget-error> `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Number })
    ], Element.prototype, "selectedIntent", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Array })
    ], Element.prototype, "ivrConversations", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "orgId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "interactionId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isLoading", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "trackingId", void 0);
    __decorate([
        _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4__.Decorator.Handle({
            "Service.mediaStorage.metaData": ({ ctx, details }) => {
                var _a, _b;
                ctx.isLoading = false;
                ctx.trackingId = (_b = (_a = details.axiosError) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b.trackingid;
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`[IvrTranscript] Failed to fetch Transcript Meta data  ${JSON.stringify(details)}`);
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.TrackingUtils.trackInitialCallEvents(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry, {
                    eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.IVR_TRANSCRIPT,
                    interactionId: ctx.trackingId,
                    contactDirection: "INBOUND",
                    mediaType: "telephony",
                    status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
                    reasonCode: "TRANSCRIPT_FETCH_FAIL"
                });
            },
            "Service.mediaStorage.conversation": ({ ctx, details }) => {
                var _a, _b;
                ctx.isLoading = false;
                ctx.trackingId = (_b = (_a = details.axiosError) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b.trackingid;
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`[IvrTranscript] Failed to fetch Conversation Meta data  ${JSON.stringify(details)}`);
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.TrackingUtils.trackInitialCallEvents(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry, {
                    eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.IVR_TRANSCRIPT,
                    interactionId: ctx.trackingId,
                    contactDirection: "INBOUND",
                    mediaType: "telephony",
                    status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
                    reasonCode: "CONVERSATION_FETCH_FAIL"
                });
            }
        })
    ], Element.prototype, "fetchIvrConversations", null);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.customElement)("agentx-wc-ivr-transcripts")
    ], Element);
    IvrTranscripts.Element = Element;
})(IvrTranscripts || (IvrTranscripts = {}));


/***/ }),

/***/ "./src/components/IvrTranscripts/components/ConfidenceBadge/Confidence.scss":
/*!**********************************************************************************!*\
  !*** ./src/components/IvrTranscripts/components/ConfidenceBadge/Confidence.scss ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

.badge-left-split {
  padding-left: calc(var(--space-token-cardinal) * 2);
  font-weight: bold;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: var(--transcript-badge-left-max-width);
  display: inline-block;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/IvrTranscripts/components/ConfidenceBadge/ConfidenceBadge.ts":
/*!*************************************************************************************!*\
  !*** ./src/components/IvrTranscripts/components/ConfidenceBadge/ConfidenceBadge.ts ***!
  \*************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ConfidenceBadge: () => (/* binding */ ConfidenceBadge)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _IvrTranscripts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../IvrTranscripts */ "./src/components/IvrTranscripts/IvrTranscripts.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/utils */ "./src/components/IvrTranscripts/utils/utils.ts");
/* harmony import */ var _Confidence_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./Confidence.scss */ "./src/components/IvrTranscripts/components/ConfidenceBadge/Confidence.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */






var ConfidenceBadge;
(function (ConfidenceBadge) {
    /**
     * @element agentx-wc-confidence-badge
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.confidence = 1;
            this.intentName = undefined;
            this.color = _IvrTranscripts__WEBPACK_IMPORTED_MODULE_3__.DEFAULT_TRANSCRIPT_COLOR;
        }
        static get styles() {
            return _Confidence_scss__WEBPACK_IMPORTED_MODULE_5__["default"];
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-badge split color=${this.color} textColor="var(--md-primary-text-color)">
          <span slot="split-left" title=${this.intentName ? this.intentName : ""} class="badge-left-split"
            >${this.intentName}</span
          >
          <span slot="split-right"
            >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:ivrTranscripts.confidence")}: ${this.confidence ? (0,_utils_utils__WEBPACK_IMPORTED_MODULE_4__.getRoundedValue)(this.confidence) : 0}</span
          >
        </md-badge>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Number })
    ], Element.prototype, "confidence", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "intentName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "color", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-confidence-badge")
    ], Element);
    ConfidenceBadge.Element = Element;
})(ConfidenceBadge || (ConfidenceBadge = {}));


/***/ }),

/***/ "./src/components/IvrTranscripts/components/Intent/Intent.scss":
/*!*********************************************************************!*\
  !*** ./src/components/IvrTranscripts/components/Intent/Intent.scss ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

.ivr-intent {
  background-color: var(--md-primary-bg-color);
  padding: calc(var(--space-token-cardinal) * 3);
  border-radius: var(--border-radius-large);
  margin: 0 calc(var(--space-token-even) * 4) calc(var(--space-token-even) * 4) 0;
}

.transcript-timer {
  font-family: var(--font-family-light);
  font-size: var(--font-size-small);
  float: right;
  padding-right: calc(var(--space-token-even) * 2);
}

.intent-params {
  padding: calc(var(--space-token-even) * 2);
  display: flex;
}

.intent-params span:first-child {
  width: 33.3333333333%;
  display: inline-block;
  font-family: var(--font-family-light);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.intent-params span:last-child {
  padding-left: calc(var(--space-token-even) * 4);
  width: 66.6666666667%;
  display: inline-block;
  word-break: break-word;
}

.params-wrapper .intent-params:first-child {
  padding-top: calc(var(--space-token-even) * 4);
}

.params-wrapper .intent-params:last-child {
  padding-bottom: 0;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/IvrTranscripts/components/Intent/Intent.ts":
/*!*******************************************************************!*\
  !*** ./src/components/IvrTranscripts/components/Intent/Intent.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Intent: () => (/* binding */ Intent)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _IvrTranscripts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../IvrTranscripts */ "./src/components/IvrTranscripts/IvrTranscripts.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../utils/utils */ "./src/components/IvrTranscripts/utils/utils.ts");
/* harmony import */ var _ConfidenceBadge_ConfidenceBadge__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../ConfidenceBadge/ConfidenceBadge */ "./src/components/IvrTranscripts/components/ConfidenceBadge/ConfidenceBadge.ts");
/* harmony import */ var _Intent_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./Intent.scss */ "./src/components/IvrTranscripts/components/Intent/Intent.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */









var Intent;
(function (Intent) {
    /**
     * @element agentx-wc-ivr-intent
     * @fires item-selected
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.confidence = 1;
            this.intentName = undefined;
            this.color = _IvrTranscripts__WEBPACK_IMPORTED_MODULE_5__.DEFAULT_TRANSCRIPT_COLOR;
            this.timestamp = new Date().getTime();
            this.params = {};
            this.renderSubParams = (subParams) => {
                const subParamKeys = subParams ? Object.keys(subParams) : [];
                return (0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_4__.repeat)(subParamKeys, (key) => {
                    return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` <div>${key}: ${subParams[key]}</div> `;
                });
            };
            this.renderParamValue = (value) => {
                return typeof value === "string" || typeof value === "number"
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` <span>${value}</span> `
                    : (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` <span>${this.renderSubParams(value)}</span> `;
            };
            this.renderParams = () => {
                const params = Object.keys(this.params).length > 0 ? (0,_utils_utils__WEBPACK_IMPORTED_MODULE_6__.removeEmptyValues)(this.params) : null;
                const paramKeys = params ? Object.keys(params) : [];
                return (0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_4__.repeat)(paramKeys, (key) => {
                    return (params &&
                        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
            <div class="intent-params">
              <span title=${key}>${key}</span>
              ${this.renderParamValue(params[key])}
            </div>
          `);
                });
            };
        }
        static get styles() {
            return _Intent_scss__WEBPACK_IMPORTED_MODULE_8__["default"];
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="ivr-intent">
          <agentx-wc-confidence-badge
            intentName=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_3__.ifDefined)(this.intentName)}
            confidence=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_3__.ifDefined)(this.confidence)}
            color=${this.color}
          ></agentx-wc-confidence-badge>
          <span class="transcript-timer">${(0,_utils_utils__WEBPACK_IMPORTED_MODULE_6__.getTime)(this.timestamp)}</span>
          <div class="params-wrapper">${this.renderParams()}</div>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Number })
    ], Element.prototype, "confidence", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "intentName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "color", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Number })
    ], Element.prototype, "timestamp", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "params", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-ivr-intent")
    ], Element);
    Intent.Element = Element;
})(Intent || (Intent = {}));


/***/ }),

/***/ "./src/components/IvrTranscripts/components/IntentWrapper/IntentWrapper.scss":
/*!***********************************************************************************!*\
  !*** ./src/components/IvrTranscripts/components/IntentWrapper/IntentWrapper.scss ***!
  \***********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

.ivr-intent-wrapper {
  width: 373px;
  height: 100%;
}

.scroll-content {
  height: 100%;
  overflow: scroll;
  -ms-overflow-style: none;
}

.scroll-content::-webkit-scrollbar {
  display: none;
}

.ivr-intent-item {
  cursor: pointer;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/IvrTranscripts/components/IntentWrapper/IntentWrapper.ts":
/*!*********************************************************************************!*\
  !*** ./src/components/IvrTranscripts/components/IntentWrapper/IntentWrapper.ts ***!
  \*********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   IntentWrapper: () => (/* binding */ IntentWrapper)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../utils/utils */ "./src/components/IvrTranscripts/utils/utils.ts");
/* harmony import */ var _Intent_Intent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Intent/Intent */ "./src/components/IvrTranscripts/components/Intent/Intent.ts");
/* harmony import */ var _IntentWrapper_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./IntentWrapper.scss */ "./src/components/IvrTranscripts/components/IntentWrapper/IntentWrapper.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */









var IntentWrapper;
(function (IntentWrapper) {
    /**
     * @element agentx-wc-ivr-intent-wrapper
     * @fires on-intent-select
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.transcriptList = null;
            this.toggleIntentSelection = (index) => {
                this.dispatchEvent(new CustomEvent("on-intent-select", {
                    detail: {
                        index
                    }
                }));
            };
            this.renderIntentList = (transcriptList) => {
                let colorIndex = -1;
                return (0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_5__.repeat)(transcriptList, (transcript, index) => {
                    var _a, _b;
                    if (((_a = transcript.bot) === null || _a === void 0 ? void 0 : _a.parameters) && (0,_utils_utils__WEBPACK_IMPORTED_MODULE_6__.hasParamData)(transcript.bot)) {
                        colorIndex++;
                    }
                    return ((_b = transcript.bot) === null || _b === void 0 ? void 0 : _b.parameters) && (0,_utils_utils__WEBPACK_IMPORTED_MODULE_6__.hasParamData)(transcript.bot)
                        ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
              <agentx-wc-ivr-intent
                confidence=${transcript.bot.confidence}
                intentName=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__.ifDefined)(transcript.bot.intentName)}
                color=${(0,_utils_utils__WEBPACK_IMPORTED_MODULE_6__.getColorByIndex)(colorIndex)}
                timestamp=${transcript.bot.timestamp}
                .params=${transcript.bot.parameters}
                tabindex=${0}
                class="ivr-intent-item"
                @focus="${() => this.toggleIntentSelection(index)}"
                @blur="${() => this.toggleIntentSelection(-1)}"
              ></agentx-wc-ivr-intent>
            `
                        : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing;
                });
            };
        }
        static get styles() {
            return _IntentWrapper_scss__WEBPACK_IMPORTED_MODULE_8__["default"];
        }
        render() {
            return (this.transcriptList &&
                (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
          <div class="scroll-content">
            <div class="ivr-intent-wrapper">${this.renderIntentList(this.transcriptList)}</div>
          </div>
        `);
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Array })
    ], Element.prototype, "transcriptList", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-ivr-intent-wrapper")
    ], Element);
    IntentWrapper.Element = Element;
})(IntentWrapper || (IntentWrapper = {}));


/***/ }),

/***/ "./src/components/IvrTranscripts/components/TranscriptItem/TranscriptItem.scss":
/*!*************************************************************************************!*\
  !*** ./src/components/IvrTranscripts/components/TranscriptItem/TranscriptItem.scss ***!
  \*************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

.transcript-item {
  font-size: var(--font-size-small);
  display: flex;
  margin-bottom: calc(var(--space-token-even) * 8);
}

.blur-content {
  filter: opacity(0.3);
}

.transcript-content {
  margin-left: calc(var(--space-token-cardinal) * 2);
}

.transcript-text {
  font-size: var(--font-size-medium);
  margin-bottom: calc(var(--space-token-even) * 4);
}

.transcript-head {
  font-family: var(--font-family-light);
}

.transcript-header {
  padding-right: calc(var(--space-token-even) * 7);
  text-transform: capitalize;
}

.transcript-avatar {
  padding-top: calc(var(--space-token-even) * 2);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/IvrTranscripts/components/TranscriptItem/TranscriptItem.ts":
/*!***********************************************************************************!*\
  !*** ./src/components/IvrTranscripts/components/TranscriptItem/TranscriptItem.ts ***!
  \***********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TranscriptItem: () => (/* binding */ TranscriptItem)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _IvrTranscripts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../IvrTranscripts */ "./src/components/IvrTranscripts/IvrTranscripts.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../utils/utils */ "./src/components/IvrTranscripts/utils/utils.ts");
/* harmony import */ var _TranscriptItem_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./TranscriptItem.scss */ "./src/components/IvrTranscripts/components/TranscriptItem/TranscriptItem.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */









const MIN_SENTIMENT = 0;
var TranscriptItem;
(function (TranscriptItem) {
    /**
     * @element agentx-wc-ivr-transcript-item
     * @fires item-selected
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.type = "customer";
            this.sentiment = undefined;
            this.confidence = undefined;
            this.intentName = undefined;
            this.content = "";
            this.timestamp = new Date().getTime();
            this.color = _IvrTranscripts__WEBPACK_IMPORTED_MODULE_6__.DEFAULT_TRANSCRIPT_COLOR;
            this.params = {};
            this.selected = true;
            this.botName = "";
            this.getLocalisedCustomerTitle = () => {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:ivrTranscripts.customer`);
            };
            this.getLocalisedBotTitle = () => {
                return this.botName ? this.botName : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:ivrTranscripts.bot`);
            };
            this.isBot = () => {
                return this.type === "bot";
            };
            this.isCustomer = () => {
                return this.type === "customer";
            };
            this.getTitle = () => {
                return this.isCustomer() ? this.getLocalisedCustomerTitle() : this.getLocalisedBotTitle();
            };
            this.getFormattedTime = () => {
                return (0,_utils_utils__WEBPACK_IMPORTED_MODULE_7__.getDate)(luxon__WEBPACK_IMPORTED_MODULE_5__.DateTime.local().toMillis()) !== (0,_utils_utils__WEBPACK_IMPORTED_MODULE_7__.getDate)(this.timestamp)
                    ? (0,_utils_utils__WEBPACK_IMPORTED_MODULE_7__.getDateTime)(this.timestamp)
                    : (0,_utils_utils__WEBPACK_IMPORTED_MODULE_7__.getTime)(this.timestamp);
            };
            this.renderAvatar = () => {
                return this.isCustomer()
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
            <md-avatar
              aria-label=${this.getLocalisedCustomerTitle()}
              title=${this.getLocalisedCustomerTitle()}
              size=${28}
            ></md-avatar>
          `
                    : (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
            <md-avatar
              aria-label=${this.getLocalisedBotTitle()}
              title=${this.getLocalisedBotTitle()}
              size=${28}
              icon-name="icon-bot_12"
            ></md-avatar>
          `;
            };
            this.renderSentimentBadgeText = () => {
                return `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:ivrTranscripts.sentiment")}: ${(0,_utils_utils__WEBPACK_IMPORTED_MODULE_7__.getRoundedValue)(this.sentiment ? this.sentiment : 0)}`;
            };
            this.renderBadge = () => {
                return this.isCustomer() && (this.sentiment || this.sentiment === 0)
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
            <md-badge
              color=${this.sentiment >= MIN_SENTIMENT ? "default" : "red"}
              textColor="var(--md-primary-text-color)"
              aria-label=${this.renderSentimentBadgeText()}
            >
              ${this.renderSentimentBadgeText()}
            </md-badge>
          `
                    : this.isBot() && (this.confidence || this.confidence === 0) && this.intentName
                        ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
              <agentx-wc-confidence-badge
                intentName=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__.ifDefined)(this.intentName)}
                confidence=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__.ifDefined)(this.confidence)}
                color=${this.color}
              ></agentx-wc-confidence-badge>
            `
                        : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing;
            };
        }
        static get styles() {
            return _TranscriptItem_scss__WEBPACK_IMPORTED_MODULE_8__["default"];
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="transcript-item ${this.selected ? lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing : "blur-content"} ">
          <div class="transcript-avatar">${this.renderAvatar()}</div>
          <div class="transcript-content">
            <div class="transcript-head">
              <span class="transcript-header"> ${this.getTitle()} </span>
              <span class="transcript-timer"> ${this.getFormattedTime()} </span>
            </div>
            <div class="transcript-text">${(0,_utils_utils__WEBPACK_IMPORTED_MODULE_7__.getHighlightedTranscriptContent)(this.params, this.content, this.color)}</div>
            ${this.renderBadge()}
          </div>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "type", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Number })
    ], Element.prototype, "sentiment", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Number })
    ], Element.prototype, "confidence", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "intentName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "content", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Number })
    ], Element.prototype, "timestamp", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "color", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "params", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "selected", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "botName", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-ivr-transcript-item")
    ], Element);
    TranscriptItem.Element = Element;
})(TranscriptItem || (TranscriptItem = {}));


/***/ }),

/***/ "./src/components/IvrTranscripts/components/TranscriptWrapper/TranscriptWrapper.scss":
/*!*******************************************************************************************!*\
  !*** ./src/components/IvrTranscripts/components/TranscriptWrapper/TranscriptWrapper.scss ***!
  \*******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

.transcript-wrapper {
  padding: var(--transcript-wrapper-padding);
  margin: var(--transcript-wrapper-margin);
  height: 100%;
}

.scroll-content {
  height: 100%;
  overflow: scroll;
  -ms-overflow-style: none;
  scroll-behavior: smooth;
  border-radius: var(--border-radius-large);
  background-color: var(--md-primary-bg-color);
}

.scroll-content::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  border-radius: 12px;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: 0 0 1px rgb(84, 84, 84);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/IvrTranscripts/components/TranscriptWrapper/TranscriptWrapper.ts":
/*!*****************************************************************************************!*\
  !*** ./src/components/IvrTranscripts/components/TranscriptWrapper/TranscriptWrapper.ts ***!
  \*****************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TranscriptWrapper: () => (/* binding */ TranscriptWrapper)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _IvrTranscripts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../IvrTranscripts */ "./src/components/IvrTranscripts/IvrTranscripts.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../utils/utils */ "./src/components/IvrTranscripts/utils/utils.ts");
/* harmony import */ var _TranscriptItem_TranscriptItem__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../TranscriptItem/TranscriptItem */ "./src/components/IvrTranscripts/components/TranscriptItem/TranscriptItem.ts");
/* harmony import */ var _TranscriptWrapper_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./TranscriptWrapper.scss */ "./src/components/IvrTranscripts/components/TranscriptWrapper/TranscriptWrapper.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */










var TranscriptWrapper;
(function (TranscriptWrapper) {
    /**
     * @element agentx-wc-ivr-transcript-wrapper
     * @fires item-selected
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.transcriptList = null;
            this.selectedIntent = -1;
            this.renderCustomerTranscript = (transcript, color, selected, index) => {
                const templateId = `customer-transcript-${index}`;
                return transcript.customer
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
            <agentx-wc-ivr-transcript-item
              type="customer"
              .sentiment=${transcript.customer.sentiment}
              content=${transcript.customer.query}
              .params=${transcript.bot && transcript.bot.parameters ? transcript.bot.parameters : {}}
              color=${color}
              .timestamp=${transcript.customer.timestamp}
              .selected=${selected}
              id=${templateId}
            ></agentx-wc-ivr-transcript-item>
          `
                    : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing;
            };
            this.renderBotTranscript = (transcript, color, selected, index) => {
                const templateId = `bot-transcript-${index}`;
                return transcript.bot
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
            <agentx-wc-ivr-transcript-item
              type="bot"
              content=${transcript.bot.reply}
              .timestamp=${transcript.bot.timestamp}
              .confidence=${transcript.bot.confidence}
              intentName=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__.ifDefined)(transcript.bot.intentName)}
              color=${color}
              .selected=${selected}
              botName=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__.ifDefined)(transcript.bot.botName)}
              id=${templateId}
            ></agentx-wc-ivr-transcript-item>
          `
                    : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing;
            };
            this.renderTranscript = (transcript, color, selected, index) => {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        ${this.renderCustomerTranscript(transcript, color, selected, index)}
        ${this.renderBotTranscript(transcript, color, selected, index)}
      `;
            };
            this.renderTranscriptList = (transcriptList) => {
                let colorIndex = -1;
                return (0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_5__.repeat)(transcriptList, (transcript, index) => {
                    var _a;
                    let color = _IvrTranscripts__WEBPACK_IMPORTED_MODULE_6__.DEFAULT_TRANSCRIPT_COLOR;
                    const selected = this.selectedIntent === index || this.selectedIntent === -1;
                    if (((_a = transcript.bot) === null || _a === void 0 ? void 0 : _a.parameters) && (0,_utils_utils__WEBPACK_IMPORTED_MODULE_7__.hasParamData)(transcript.bot)) {
                        colorIndex++;
                        color = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_7__.getColorByIndex)(colorIndex);
                    }
                    return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` ${this.renderTranscript(transcript, color, selected, index)} `;
                });
            };
        }
        static get styles() {
            return _TranscriptWrapper_scss__WEBPACK_IMPORTED_MODULE_9__["default"];
        }
        updated() {
            var _a, _b, _c;
            if (this.selectedIntent >= 0) {
                const customerSelectedTemplateId = `#customer-transcript-${this.selectedIntent}`;
                const botSelectedTemplateId = `#bot-transcript-${this.selectedIntent}`;
                const selectedTemplate = ((_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(customerSelectedTemplateId))
                    ? (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector(customerSelectedTemplateId)
                    : (_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector(botSelectedTemplateId);
                if (selectedTemplate instanceof HTMLElement && this.scrollContainer) {
                    this.scrollContainer.scrollTop = selectedTemplate.offsetTop - this.scrollContainer.clientHeight / 4;
                }
            }
        }
        render() {
            return (this.transcriptList &&
                (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
          <div class="scroll-content" id="scroll-container">
            <div class="transcript-wrapper">${this.renderTranscriptList(this.transcriptList)}</div>
          </div>
        `);
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Array })
    ], Element.prototype, "transcriptList", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Number })
    ], Element.prototype, "selectedIntent", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.query)("#scroll-container")
    ], Element.prototype, "scrollContainer", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-ivr-transcript-wrapper")
    ], Element);
    TranscriptWrapper.Element = Element;
})(TranscriptWrapper || (TranscriptWrapper = {}));


/***/ }),

/***/ "./src/components/IvrTranscripts/utils/utils.ts":
/*!******************************************************!*\
  !*** ./src/components/IvrTranscripts/utils/utils.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getColorByIndex: () => (/* binding */ getColorByIndex),
/* harmony export */   getDate: () => (/* binding */ getDate),
/* harmony export */   getDateTime: () => (/* binding */ getDateTime),
/* harmony export */   getHighlightedTranscriptContent: () => (/* binding */ getHighlightedTranscriptContent),
/* harmony export */   getRoundedValue: () => (/* binding */ getRoundedValue),
/* harmony export */   getTime: () => (/* binding */ getTime),
/* harmony export */   hasParamData: () => (/* binding */ hasParamData),
/* harmony export */   removeEmptyValues: () => (/* binding */ removeEmptyValues),
/* harmony export */   showIntent: () => (/* binding */ showIntent)
/* harmony export */ });
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_0__);

const MERIDIEM_TIME_FORMAT = "hh:mm a";
const DATE_TIME_FORMAT = "dd/LL/yy, hh:mm a";
const DATE_FORMAT = "dd/LL/yy";
const IVR_COLORS = [
    "blue",
    "purple",
    "orange",
    "cyan",
    "violet",
    "green",
    "mint",
    "yellow"
];
const getColorByIndex = (index) => {
    return IVR_COLORS[index % IVR_COLORS.length];
};
const getTime = (timestamp) => {
    return luxon__WEBPACK_IMPORTED_MODULE_0__.DateTime.fromMillis(timestamp).toFormat(MERIDIEM_TIME_FORMAT);
};
const getDateTime = (timestamp) => {
    return luxon__WEBPACK_IMPORTED_MODULE_0__.DateTime.fromMillis(timestamp).toFormat(DATE_TIME_FORMAT);
};
const getDate = (timestamp) => {
    return luxon__WEBPACK_IMPORTED_MODULE_0__.DateTime.fromMillis(timestamp).toFormat(DATE_FORMAT);
};
const getBgStyle = (color) => {
    return `background-color:var(--badge-${color}-bg-color)`;
};
const getHilightedText = (content, param, color) => {
    return param
        ? content.replace(new RegExp(param, "gi"), `<span style=${getBgStyle(color)} >${param}</span>`)
        : content;
};
const getSubContent = (content, params, color) => {
    const paramSubValues = params ? Object.values(params) : [];
    paramSubValues.forEach((param) => {
        param = typeof param === "string" ? param : param.toString();
        content = getHilightedText(content, param, color);
    });
    return content;
};
const getHighlightedTranscriptContent = (params, content, color) => {
    const paramValues = params
        ? Object.values(params)
        : [];
    let htmlContent = content;
    paramValues.forEach((param) => {
        if (typeof param === "string" || typeof param === "number") {
            param = typeof param === "string" ? param : param.toString();
            htmlContent = getHilightedText(htmlContent, param, color);
        }
        else {
            htmlContent = getSubContent(htmlContent, param, color);
        }
    });
    const contentHtml = document.createElement("div");
    contentHtml.innerHTML = htmlContent;
    return contentHtml;
};
const hasParamData = (botTranscript) => {
    return botTranscript.parameters
        ? Object.values(botTranscript.parameters).filter((value) => {
            return value !== "";
        }).length !== 0
        : false;
};
const getRoundedValue = (num) => {
    return Math.round((num + Number.EPSILON) * 100) / 100;
};
const showIntent = (data) => {
    // This method will check the parameters of the botTranscript and return true if any of the parameters is not empty.
    // This method will check first level and one nested object level.
    return data.some((item) => {
        var _a;
        const botParameters = (_a = item === null || item === void 0 ? void 0 : item.bot) === null || _a === void 0 ? void 0 : _a.parameters;
        if (!botParameters) {
            return false;
        }
        // Check direct properties of botParameters
        return Object.values(botParameters).some((value) => {
            if (typeof value === "object" && !Array.isArray(value)) {
                // If the value is an object, check its properties for emptiness
                return Object.values(value !== null && value !== void 0 ? value : {}).some((innerValue) => innerValue !== "");
            }
            // Otherwise, check if the value is not an empty string
            return value !== "";
        });
    });
};
const removeEmptyValues = (data) => {
    const cleanedIntentData = {};
    // Iterate over entries using forEach and add non-empty key-value pairs to the new object
    Object.entries(data).forEach(([key, value]) => {
        if (value && value !== "") {
            if (typeof value === "object" && !Array.isArray(value)) {
                // Validate the same in nested objects
                if (Object.keys(value).length > 0) {
                    const cleanedValues = removeEmptyValues(value);
                    if (cleanedValues && Object.keys(cleanedValues).length > 0) {
                        cleanedIntentData[key] = cleanedValues;
                    }
                }
            }
            else {
                cleanedIntentData[key] = value;
            }
        }
    });
    return cleanedIntentData;
};


/***/ }),

/***/ "./src/components/MenuNotifications/MenuNotifications.scss":
/*!*****************************************************************!*\
  !*** ./src/components/MenuNotifications/MenuNotifications.scss ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  display: inline-block;
}

.wc-menu-notification-wrap {
  height: 456px;
  padding: 1rem 0;
  width: 100%;
  overflow: hidden;
  position: relative;
}

.wc-menu-notification_list {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.wc-menu-notification_list md-list-item::part(list-item) {
  padding: 0;
  border-radius: 5px;
  background: none;
}
.wc-menu-notification_count {
  position: absolute;
  display: inline-flex;
  right: -4px;
  top: -4px;
}

.wc-menu-notification-icon_wrap {
  position: relative;
  display: inline-block;
}

.wc-full-menu-notification .wc-menu-notification_title {
  margin-top: 0px;
  margin-bottom: 13px;
  padding-left: 16px;
  font-size: var(--font-size-medium);
  font-weight: bold;
}
.wc-full-menu-notification .wc-menu-notification_list {
  width: 100%;
  max-height: 380px;
  overflow: hidden;
  overflow-y: auto;
}
.wc-full-menu-notification .wc-menu-cleaner {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid var(--md-primary-seperator-color);
  color: var(--md-alert-info-text-color);
}

.wc-empty-menu-notification {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
}

uuip-wc-empty-state::part(container) {
  background: transparent;
}

uuip-wc-empty-state::part(img) {
  max-width: 84px;
  margin: 0 auto;
}

agentx-wc-empty-state-wrapper::part(container) {
  background: transparent;
}

agentx-wc-empty-state-wrapper::part(img) {
  max-width: 84px;
  margin: 0 auto;
}

.wc-empty-menu-notification .empty-text {
  color: var(--md-primary-text-color);
}

.wc-menu-notification-item {
  margin: var(--space-token-cardinal);
  cursor: default;
  background-color: var(--alert-default-bg-color);
}

.wc-notification-datediff {
  font-size: var(--font-size-small);
  padding-right: 0.3rem;
  white-space: nowrap;
  color: var(--md-primary-text-color);
}

@media (forced-colors: active) {
  .wc-notification-datediff {
    forced-color-adjust: auto;
    color: CanvasText !important;
  }
  .wc-menu-notification_list {
    forced-color-adjust: auto;
    background-color: Canvas !important;
    color: CanvasText !important;
  }
  .wc-menu-notification_list md-list-item::part(list-item) {
    forced-color-adjust: auto;
    background-color: Canvas !important;
    color: CanvasText !important;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/MenuNotifications/MenuNotifications.ts":
/*!***************************************************************!*\
  !*** ./src/components/MenuNotifications/MenuNotifications.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MenuNotification: () => (/* binding */ MenuNotification)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @uuip/unified-ui-platform-common-components */ "@uuip/unified-ui-platform-common-components");
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! lit-html/directives/style-map */ "lit-html/directives/style-map");
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _assets_styles_common_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../assets/styles/common.scss */ "./src/assets/styles/common.scss");
/* harmony import */ var _Common_EmptyStateWrapper_EmptyStateWrapper_ts__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../Common/EmptyStateWrapper/EmptyStateWrapper.ts */ "./src/components/Common/EmptyStateWrapper/EmptyStateWrapper.ts");
/* harmony import */ var _MenuNotifications_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./MenuNotifications.scss */ "./src/components/MenuNotifications/MenuNotifications.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};















var MenuNotification;
(function (MenuNotification) {
    const MAX_UNREAD_NOTIFICATIONS_NON_DISPLAY = 99; // Count
    const TIME_FROM_UPDATE_INTERVAL = 5000; // ms
    MenuNotification.webexNotificationType = "webex_message";
    /**
     * @element agentx-wc-menu-notification
     * @fires clear-notifications
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_6__.LitElement) {
        constructor() {
            super(...arguments);
            this.isModalOpen = false;
            this.unreadNotifications = [];
            this.unreadNotificationsHash = {};
            this.notificationsTimesFrom = {};
            this.notificationTimeUpdateRef = undefined;
            this.updateCollections = () => {
                this.unreadNotifications = [...this.notificationsService.pended, ...this.notificationsService.activated].sort((n1, n2) => {
                    // Sorting from new to old
                    return n1.timestamp > n2.timestamp ? -1 : n1.timestamp < n2.timestamp ? 1 : 0;
                });
                this.unreadNotifications = this.unreadNotifications.filter(({ data }) => {
                    const { type } = data;
                    return type !== MenuNotification.webexNotificationType && type !== _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_4__.ToasterNotificationItemContent.FullTextTransientNotification;
                });
                this.unreadNotificationsHash = this.unreadNotifications.reduce((acc, n) => {
                    acc[n.timestamp] = n;
                    return acc;
                }, {});
                if (this.unreadNotifications.length) {
                    this.startTimeupdate();
                }
                else {
                    this.stopTimeupdate();
                }
            };
        }
        static get styles() {
            return [_MenuNotifications_scss__WEBPACK_IMPORTED_MODULE_13__["default"], _assets_styles_common_scss__WEBPACK_IMPORTED_MODULE_11__["default"]];
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.unbindServiceEvents();
            this.stopTimeupdate();
            if (this.stopListen) {
                this.stopListen();
            }
        }
        firstUpdated(changedProperties) {
            super.firstUpdated(changedProperties);
            this.updateCollections();
            this.bindServiceEvents();
        }
        bindServiceEvents() {
            // Listening for all service status events
            _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_5__.Notifications.ServiceMeta.STATUS_EVENTS.forEach((eventName) => this.notificationsService.addEventListener(eventName, this.updateCollections));
        }
        unbindServiceEvents() {
            // Stop Listening for all service status events
            _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_5__.Notifications.ServiceMeta.STATUS_EVENTS.forEach((eventName) => this.notificationsService.removeEventListener(eventName, this.updateCollections));
        }
        startTimeupdate() {
            this.stopTimeupdate();
            this.notificationsTimesFrom = this.unreadNotifications.reduce((acc, n) => {
                acc[n.timestamp] = Math.round(luxon__WEBPACK_IMPORTED_MODULE_10__.DateTime.local().diff(luxon__WEBPACK_IMPORTED_MODULE_10__.DateTime.fromISO(n.timestamp), "minutes").minutes);
                return acc;
            }, {});
            this.notificationTimeUpdateRef = window.setTimeout(() => this.startTimeupdate(), TIME_FROM_UPDATE_INTERVAL);
        }
        stopTimeupdate() {
            window.clearTimeout(this.notificationTimeUpdateRef);
            this.notificationTimeUpdateRef = undefined;
        }
        get unreadNotificationsCount() {
            return this.unreadNotifications.length;
        }
        executeOpenMenuNotification(key) {
            if (key.data &&
                key.data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.MODIFIERS.CTRL_ALT &&
                key.data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.REGISTERED_KEYS.OPEN_NOTIFICATION_CENTER_KEY &&
                this.refMenuElem &&
                this.refMenuElem.firstElementChild) {
                this.refMenuElem.firstElementChild.click();
            }
        }
        connectedCallback() {
            super.connectedCallback();
            const { stopListen } = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.event.listenKeyPress((key) => this.executeOpenMenuNotification(key));
            this.stopListen = stopListen;
        }
        handleClearAll() {
            // Deactivating => clear
            const deactivatedNotifications = this.notificationsService.deactivateAll(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_5__.Notifications.ItemMeta.DeactivateEventReason.UserNegative);
            // Notify outer
            this.dispatchEvent(new CustomEvent("clear-notifications", {
                detail: {
                    notifications: deactivatedNotifications
                }
            }));
            setTimeout(() => {
                if (this.liveRegion) {
                    this.liveRegion.textContent = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:menuNotifications.notificationMenuEmptyStateNew");
                }
            }, _constants__WEBPACK_IMPORTED_MODULE_0__.TIMEOUT_TEN_MS);
        }
        // like 10 or 99+
        get unreadNotificationsCountText() {
            return this.unreadNotificationsCount > 0
                ? this.unreadNotificationsCount > MAX_UNREAD_NOTIFICATIONS_NON_DISPLAY
                    ? `${MAX_UNREAD_NOTIFICATIONS_NON_DISPLAY}+`
                    : this.unreadNotificationsCount
                : null;
        }
        renderCount() {
            return this.unreadNotificationsCountText
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
            <md-badge class="wc-menu-notification_count" color="unreadcount" outlined>
              <span> ${this.unreadNotificationsCountText} </span>
            </md-badge>
          `
                : lit_html__WEBPACK_IMPORTED_MODULE_7__.nothing;
        }
        render() {
            const unreadNotificationsCountText = `(${this.unreadNotificationsCount})`;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
        <md-menu-overlay
          id="menu-notification"
          @menu-overlay-open=${() => {
                this.isModalOpen = true;
            }}
          @menu-overlay-close=${() => {
                this.isModalOpen = false;
                if (this.liveRegion) {
                    this.liveRegion.textContent = "";
                }
            }}
        >
          <span slot="menu-trigger" class="wc-menu-notification-icon_wrap">
            <md-tooltip slot="menu-trigger" placement="bottom" message=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:notifications.notificationLable")}>
              <md-button
                class="notification-btn"
                variant="ghost"
                size="32"
                circle
                ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:notifications.notificationAriaLabel", "Notification Center", {
                count: this.unreadNotificationsCount
            })}
                ariaExpanded=${this.isModalOpen}
                ariaHaspopup="true"
                ><md-icon name="alert-bold" size="20" iconSet="momentumDesign"></md-icon
              ></md-button>
            </md-tooltip>

            ${this.renderCount()}
          </span>
          <div class="wc-menu-notification-wrap">
            ${this.unreadNotificationsCount > 0
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
                  <div class="wc-full-menu-notification">
                    <h2 class="wc-menu-notification_title">
                      ${`${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:menuNotifications.notificationMenuTitle")} ${unreadNotificationsCountText}`}
                    </h2>
                    <md-list
                      class="wc-menu-notification_list"
                      label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:menuNotifications.notifications")}
                      role="list"
                    >
                      ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_8__.repeat)(this.unreadNotifications, (n) => n.timestamp, (n) => (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
                          <md-list-item
                            class="wc-menu-notification-item"
                            slot="list-item"
                            role="listitem"
                            aria-label="${n.title}, ${this.notificationsTimesFrom[n.timestamp]} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.minutes")},  ${typeof n.data == "object" ? n.data.text : n.data} "
                          >
                            <uuip-wc-toaster-notification-item-content .notification=${n}>
                            </uuip-wc-toaster-notification-item-content>
                            <span class="wc-notification-datediff"
                              >${this.notificationsTimesFrom[n.timestamp]}
                              ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:menuNotifications.notificationMenuTime")}</span
                            >
                          </md-list-item>
                        `)}
                    </md-list>
                    <div class="wc-menu-cleaner">
                      <md-button
                        color="color-none"
                        @click=${() => this.handleClearAll()}
                        ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:menuNotifications.notificationMenuClearBtn")}"
                      >
                        <md-icon
                          slot="icon"
                          name="check_16"
                          style=${(0,lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_9__.styleMap)({ color: "var(--md-alert-info-text-color)" })}
                        ></md-icon>
                        <span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:menuNotifications.notificationMenuClearBtn")}</span>
                      </md-button>
                    </div>
                  </div>
                `
                : (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
                  <div class="wc-empty-menu-notification">
                    <agentx-wc-empty-state-wrapper illustration-type="empty-state">
                      <div id="live-region" class="sr-only" aria-live="polite"></div>
                      <p
                        class="empty-text"
                        aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:menuNotifications.notificationMenuEmptyStateNew")}
                        tabindex="0"
                      >
                        ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:menuNotifications.notificationMenuEmptyStateNew")}
                      </p>
                    </agentx-wc-empty-state-wrapper>
                  </div>
                `}
          </div>
        </md-menu-overlay>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Object })
    ], Element.prototype, "notificationsService", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.query)("#menu-notification")
    ], Element.prototype, "refMenuElem", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.query)("#live-region")
    ], Element.prototype, "liveRegion", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
    ], Element.prototype, "isModalOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
    ], Element.prototype, "unreadNotifications", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
    ], Element.prototype, "notificationsTimesFrom", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.customElement)("agentx-wc-menu-notification")
    ], Element);
    MenuNotification.Element = Element;
})(MenuNotification || (MenuNotification = {}));


/***/ }),

/***/ "./src/components/MoreActions/components/MoreActionsContainer/MoreActionsWidget.ts":
/*!*****************************************************************************************!*\
  !*** ./src/components/MoreActions/components/MoreActionsContainer/MoreActionsWidget.ts ***!
  \*****************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MoreActionsWidget: () => (/* binding */ MoreActionsWidget)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../styles.scss */ "./src/components/MoreActions/styles.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */





var MoreActionsWidget;
(function (MoreActionsWidget) {
    /**
     * @element agentx-wc-more-actions-widget
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.tabsUniqueId = "";
            this.isResetTabOrderEnabled = false;
            this.isMenuOpen = false;
        }
        static get styles() {
            return _styles_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-menu-overlay
          custom-width="226px"
          size="small"
          @menu-overlay-open="${() => {
                this.isMenuOpen = true;
                document.dispatchEvent(new CustomEvent("agentx-more-actions-opened"));
            }}"
          @menu-overlay-close="${() => {
                this.isMenuOpen = false;
            }}"
          class="more-actions-menu-overlay"
        >
          <md-tooltip placement="top" message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:notes.moreActions")}" slot="menu-trigger">
            <md-button
              circle
              type="button"
              ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:notes.moreActions")}"
              class="menu-trigger-button more-actions-header-button"
              ariaExpanded="${this.isMenuOpen ? "true" : "false"}"
            >
              <md-icon name="more-adr-bold" iconSet="momentumDesign" size="16"></md-icon>
            </md-button>
          </md-tooltip>
          <div class="show-more-actions-list">
            ${this.isResetTabOrderEnabled
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` <agentx-wc-reset-tab-order tabs-unique-id=${this.tabsUniqueId}></agentx-wc-reset-tab-order> `
                : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
            <slot name="custom-action"></slot>
          </div>
        </md-menu-overlay>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ attribute: "tabs-unique-id" })
    ], Element.prototype, "tabsUniqueId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isResetTabOrderEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isMenuOpen", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-more-actions-widget")
    ], Element);
    MoreActionsWidget.Element = Element;
})(MoreActionsWidget || (MoreActionsWidget = {}));


/***/ }),

/***/ "./src/components/MoreActions/components/ResetTabOrderAction/ResetTabOrderAction.ts":
/*!******************************************************************************************!*\
  !*** ./src/components/MoreActions/components/ResetTabOrderAction/ResetTabOrderAction.ts ***!
  \******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ResetTabOrderAction: () => (/* binding */ ResetTabOrderAction)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../styles.scss */ "./src/components/MoreActions/styles.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */




var ResetTabOrderAction;
(function (ResetTabOrderAction) {
    /**
     * @element agentx-wc-reset-tab-order
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.tabsUniqueId = "";
        }
        handleResetTabs() {
            this.dispatchEvent(new CustomEvent("clear-tab-order-prefs", {
                detail: {
                    compUniqueId: this.tabsUniqueId
                },
                composed: true,
                bubbles: true
            }));
        }
        static get styles() {
            return _styles_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-button hasRemoveStyle class="reset-action-button" @click=${() => this.handleResetTabs()}>
          <md-icon slot="icon" aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:panelTwo.resetTabOrder")} name="icon-refresh_16"></md-icon
          ><span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:panelTwo.resetTabOrder")}</span>
        </md-button>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ attribute: "tabs-unique-id" })
    ], Element.prototype, "tabsUniqueId", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-reset-tab-order")
    ], Element);
    ResetTabOrderAction.Element = Element;
})(ResetTabOrderAction || (ResetTabOrderAction = {}));


/***/ }),

/***/ "./src/components/MoreActions/styles.scss":
/*!************************************************!*\
  !*** ./src/components/MoreActions/styles.scss ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --show-more-actions-padding: 4px;
  position: relative;
  height: 100%;
}

md-menu-overlay::part(overlay-content) {
  overflow: visible;
}

.reset-action-button::part(button) {
  font-size: var(--font-size-medium);
  padding: var(--show-more-actions-padding);
  width: 100%;
}
.reset-action-button::part(button):hover, .reset-action-button::part(button):focus {
  background-color: var(--md-alert-info-bg-color, --md-alert-info-bg-color-default);
}
.reset-action-button::part(button-children) {
  place-content: start;
}

.more-actions-header-button {
  background-color: rgba(0, 0, 0, 0);
}

.more-actions-header-button::part(button) {
  background-color: rgba(0, 0, 0, 0);
}
.more-actions-header-button::part(button):active {
  background-color: var(--button-white-pressed-bg-color);
}
.more-actions-header-button::part(button):focus, .more-actions-header-button::part(button):hover {
  background-color: var(--button-white-hover-bg-color);
  color: var(--button-secondary-text-color, #121212);
}

.more-actions-menu-overlay {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  margin-left: var(--more-actions-margin-left);
  margin-right: var(--more-actions-margin-right);
}

.show-more-actions-list {
  display: flex;
  width: 100%;
  flex-direction: column;
  text-align: left;
  max-height: 200px;
  overflow: auto;
  overflow-x: hidden;
  border-radius: 7px;
  border: 2px solid var(--md-focus-border-color);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Navigation/Navigation.scss":
/*!***************************************************!*\
  !*** ./src/components/Navigation/Navigation.scss ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

* {
  /* BASE LEVEL < 100 */
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-index-tpw-header: 1;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-index-task-collapse-area: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-navigation-bar: 12;
  --z-index-task-list: 12;
  --z-index-wrap-up: 13;
  --z-index-sticky-header: 14;
  --z-index-shortcutkey-modal: 15;
  /* MID LEVEL FLOATING > 100 < 1000 */
  --z-index-notification: 150;
  /* SUPER LEVEL > 1000 */
  --z-index-modal: 1040;
  --z-index-popover: 1041;
  --z-index-callback-modal: 1042;
  /* This below order needs to be unchanged. Highest priority is for connection loss overlay,
         followed by error modal since error can occur during app load such as teams failure/register failure. */
  --z-index-app-full-overlay: 1050;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1200;
}

nav {
  --nav-size: var(--nav-bar-width, 56px);
  --nav-item-height: 48px;
  --header-size: 64px;
  --mobile-logo-size: 28px;
  --nav-item-bottom-padding: 2px;
  height: 100%;
  max-width: var(--nav-size);
}
nav.momentum-style {
  --nav-item-height: 40px;
  --nav-item-bottom-padding: 4px;
}
nav .container {
  flex: 1;
  justify-content: space-between;
  max-height: calc(100vh - var(--nav-item-height));
  padding-bottom: calc(var(--space-token-cardinal) * 2);
  box-sizing: border-box;
}

.column {
  display: flex;
  flex-direction: column;
  width: var(--nav-size);
}

.nav-list {
  overflow-y: auto;
  margin: 0;
  text-indent: 0;
  list-style-type: none;
  padding: 4px 0;
}
.nav-list.primary {
  flex: 1;
  overflow: hidden;
  min-height: 50%;
}
.nav-list.secondary {
  height: auto;
  overflow: hidden;
}
.nav-list__item {
  padding-left: 4px;
  padding-bottom: var(--nav-item-bottom-padding);
}

.scroll-button-placer {
  max-height: 0;
  width: 100%;
  position: relative;
}

.nav-scroll-button {
  height: var(--nav-item-height);
  width: 100%;
  position: absolute;
  left: 0;
  z-index: var(--z-overflow-scroll-button, 1);
  display: flex;
  justify-content: center;
  color: var(--button-secondary-text-color, #121212);
  backdrop-filter: blur(10px);
}
.nav-scroll-button:not(.visual-rebrand) {
  background-color: var(--md-secondary-white-bg-color);
}
.nav-scroll-button:not(.visual-rebrand):hover {
  background-color: var(--md-tertiary-bg-color, --md-tertiary-bg-color-default);
}
.nav-scroll-button:not(.visual-rebrand):active {
  background-color: var(--md-quaternary-bg-color, --md-quaternary-bg-color-default);
}
.nav-scroll-button.visual-rebrand {
  backdrop-filter: blur(12px);
}
.nav-scroll-button.visual-rebrand:hover {
  backdrop-filter: blur(16px);
}
.nav-scroll-button.visual-rebrand:active {
  backdrop-filter: blur(20px);
}
.nav-scroll-button::part(button) {
  width: 100%;
}
.nav-scroll-button.top {
  top: 0;
}
.nav-scroll-button.bottom {
  bottom: 100%;
}

.hamburger-container {
  width: var(--nav-size);
  height: var(--header-size);
  align-items: center;
  justify-content: center;
  display: none;
}

.hamburger-container-tooltip {
  display: none;
}

.hidable-container {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  background-color: var(--md-navigation-bg-color);
}
.hidable-container .logo {
  display: none;
}

.reload-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(var(--nav-size) - 8px);
  height: var(--nav-item-height);
  padding-left: 4px;
}
.reload-button .reload-icon {
  justify-content: center;
  color: var(--md-alert-success-text-color, var(--light-green-color));
}

@media (max-width: 736px) {
  :host {
    position: absolute;
    z-index: auto;
  }
  :host([shownavlist]) {
    z-index: var(--z-navigation-bar);
  }
  .shadow {
    box-shadow: var(--box-shadow-gray);
  }
  nav .logo--img {
    width: var(--mobile-logo-size);
    height: var(--mobile-logo-size);
    margin: calc(var(--space-token-cardinal) * 4);
  }
  nav .container {
    padding-bottom: 0;
  }
  nav .top-container .logo {
    display: none;
  }
  nav .hamburger-container {
    display: flex;
    background-color: var(--md-header-bg-color);
    color: var(--md-primary-text-color);
    border-bottom: 1px solid var(--md-header-separator-color);
  }
  nav .hamburger-container-tooltip {
    display: block;
  }
  nav .hidable-container {
    position: relative;
    left: -100%;
    pointer-events: none;
    display: none;
    background-color: var(--nav-overlay-bg-color, var(--md-secondary-white-bg-color));
  }
  nav .hidable-container.show-nav-list {
    left: 0;
    pointer-events: initial;
    display: block;
  }
  nav .hidable-container .logo {
    display: flex;
  }
  nav .hidable-container .nav-list .not-responsive {
    display: none;
  }
}
@media (forced-colors: active) {
  .column {
    outline: 1px solid CanvasText !important;
  }
  nav .hidable-container {
    border-right: 1px solid CanvasText;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Navigation/Navigation.ts":
/*!*************************************************!*\
  !*** ./src/components/Navigation/Navigation.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Navigation: () => (/* binding */ Navigation)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../constants */ "./src/constants.ts");
/* harmony import */ var _Navigation_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./Navigation.scss */ "./src/components/Navigation/Navigation.scss");
/* harmony import */ var _comp_NavigationItem__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./comp/NavigationItem */ "./src/components/Navigation/comp/NavigationItem.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */













var Navigation;
(function (Navigation) {
    const DIRECTION = {
        UP: -1,
        DOWN: 1
    };
    const SCROLL_MARGIN = 20;
    const localizedLabels = {
        scrollDown: "app:navigation.scrollDown",
        hideNav: "app:navigation.hideNav",
        showNav: "app:navigation.showNav",
        scrollUp: "app:navigation.scrollUp",
        reload: "app:navigation.reload",
        hamburgerLabel: "app:navigation.hamburgerLabel",
        navigationRegionLabel: "app:navigation.navigationRegionLabel"
    };
    let RouteName;
    (function (RouteName) {
        RouteName["TASK"] = "task";
        RouteName["TASKPANEL"] = "task-panel";
        RouteName["APS"] = "aps";
        RouteName["METRICS"] = "wxm-metrics";
        RouteName["DEFAULT_HOME"] = "defaulthome";
    })(RouteName = Navigation.RouteName || (Navigation.RouteName = {}));
    const NAVIGATION_CUSTOM_ELEMENT = "agentx-wc-navigation";
    const FEEDBACK = "app:navigation.shareFeedback";
    /**
     * @element agentx-wc-navigation
     * @fires item-selected
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__.MobxLitElement) {
        constructor() {
            super(...arguments);
            this.selectedNavigateTo = null;
            this.items = [];
            this.agentDetails = {};
            this.popoverCount = null;
            this.navtitle = "Cisco Systems Inc.";
            this.darkTheme = false;
            this.userRole = [];
            /**
             * The reload button will show if agentx is loaded in an iframe or this property is set to true.
             * The purpose of this is to be used in test environments to force the reload button to render.
             */
            this.showReload = false;
            this.top = [];
            this.bottom = [];
            this.itemSelectedIdx = 0;
            this.showNavList = false;
            this.showTopScrollButton = false;
            this.showBottomScrollButton = false;
            this.userRoleString = "";
            this.isAgent = () => {
                return this.userRoleString === _constants__WEBPACK_IMPORTED_MODULE_10__.AGENT;
            };
            this.newTabHelpMenu = () => {
                var _a, _b, _c;
                let url = this.isAgent() ? _constants__WEBPACK_IMPORTED_MODULE_10__.HELP_LINK.AGENT_HELP : _constants__WEBPACK_IMPORTED_MODULE_10__.HELP_LINK.SUPERVISOR_HELP;
                const langForUrl = (_b = (_a = this.agentDetails) === null || _a === void 0 ? void 0 : _a.selectedLanguage) === null || _b === void 0 ? void 0 : _b.toLowerCase();
                // Ensure langForUrl is a valid key in languageCodes
                if (langForUrl in _constants__WEBPACK_IMPORTED_MODULE_10__.helpPageLangCode) {
                    url = url.replace("en-us", _constants__WEBPACK_IMPORTED_MODULE_10__.helpPageLangCode[langForUrl]);
                }
                (_c = window.open(url, "_blank")) === null || _c === void 0 ? void 0 : _c.focus();
            };
            this.bottomClickHandler = (item) => {
                var _a;
                if (item.icon.indexOf("help") >= 0) {
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.HELP_ICON_CLICKED);
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.HELP_ICON_CLICKED, {
                        Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS
                    });
                    this.newTabHelpMenu();
                }
                else if (item.label === FEEDBACK) {
                    const queryString = `&a=${this.agentDetails.orgId}&t=${this.agentDetails.teamId}&i=${this.agentDetails.agentId}&selectedLanguage=${this.agentDetails.selectedLanguage}`;
                    const url = `${item.navigateTo}${queryString}`;
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.SURVEY_ICON_CLICKED, {
                        Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS
                    });
                    (_a = window.open(url, "_blank")) === null || _a === void 0 ? void 0 : _a.focus();
                }
                else {
                    this.selected(item.navigateTo);
                }
            };
            this.onPrimaryScroll = (event) => {
                const target = event.target;
                this.showTopScrollButton = target.scrollTop >= SCROLL_MARGIN;
                this.showBottomScrollButton = target.scrollHeight - target.clientHeight - SCROLL_MARGIN >= target.scrollTop;
            };
            this.scrollNavList = (direction) => this.primaryNav.scrollBy({
                top: (direction * this.primaryNav.clientHeight) / 2,
                behavior: "smooth"
            });
            this.handleScrollButtonCreation = () => {
                // dispatching a custom event to initiate the scroll buttons
                if (this.primaryNav) {
                    this.primaryNav.dispatchEvent(new CustomEvent("scroll"));
                }
            };
        }
        connectedCallback() {
            super.connectedCallback();
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.shortcut.event.listenKeyPress((event) => {
                const { data } = event;
                if (data && data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.shortcut.MODIFIERS.CTRL_ALT) {
                    if (data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.shortcut.REGISTERED_KEYS.OPEN_NAVIGATION_TAB_KEY) {
                        this.showNavList = !this.showNavList;
                        this.getHamburgerButton(this.showNavList);
                    }
                    if (data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.shortcut.REGISTERED_KEYS.REFRESH_KEY && window !== window.top) {
                        location.reload();
                    }
                }
            });
            window.addEventListener("resize", this.handleScrollButtonCreation);
        }
        disconnectedCallback() {
            window.removeEventListener("resize", this.handleScrollButtonCreation);
            super.disconnectedCallback();
        }
        registerShortcutKey(topItems) {
            const registerKey = [];
            topItems.forEach((item, index) => {
                registerKey.push({
                    widgetElement: NAVIGATION_CUSTOM_ELEMENT,
                    group: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.navigation.componentName"),
                    action: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.open")} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(item.label)} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.page")}`,
                    modifierKeys: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.shortcut.MODIFIERS.CTRL_ALT,
                    key: (index + 1).toString(),
                    listenKeyPress: (event) => {
                        const { data } = event;
                        if (data) {
                            const { key, modifierKeys } = data;
                            const nav = Number(key);
                            if (modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.shortcut.MODIFIERS.CTRL_ALT && nav <= this.top.length && nav > 0) {
                                this.selected(this.items[nav - 1].navigateTo);
                            }
                        }
                    },
                    role: "all"
                });
            });
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.shortcut.register(registerKey);
        }
        handleFocusNavigation() {
            const navi = this.renderRoot.querySelector(".nav-selected");
            if (navi) {
                navi.scrollIntoView({ block: "center" });
            }
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            changedProperties.forEach((oldValue, name) => {
                if (name === "items" || name === "selectedNavigateTo" || name === "itemSelectedIdx") {
                    // Updating render collections
                    if (name === "items") {
                        this.top = this.items.filter((i) => i.align === "top");
                        if (Array.isArray(this.top) && this.top.length > 0) {
                            const isTaskContain = this.top.findIndex((item) => item.navigateTo === "task");
                            if (isTaskContain >= 0) {
                                this.top[isTaskContain].taskBadge = true;
                            }
                            else {
                                this.top[0].taskBadge = true;
                            }
                        }
                        this.bottom = this.items.filter((i) => i.align === "bottom");
                        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.shortcut.unregisterKeys(NAVIGATION_CUSTOM_ELEMENT);
                        this.registerShortcutKey(this.top);
                        this.handleFocusNavigation();
                    }
                    if (oldValue === -1) {
                        this.handleFocusNavigation();
                    }
                    // Updating Select
                    if (this.selectedNavigateTo) {
                        this.itemSelectedIdx = this.top.findIndex((i) => i.navigateTo === this.selectedNavigateTo);
                    }
                }
            });
            if (this.showNavList !== changedProperties.get("showNavList")) {
                this.evt("navbar-toggled", { showNavList: this.showNavList });
            }
            // dispatching a custom event to initiate the scroll buttons
            this.handleScrollButtonCreation();
            // setting the userRoleString on update of role
            this.setUserRoleString();
        }
        selected(navigateTo) {
            (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.checkForTelemetryTracking)(navigateTo);
            this.evt("item-selected", { navigateTo });
        }
        // ROST: create decorator fot custom event
        evt(name, detail) {
            this.dispatchEvent(new CustomEvent(name, { bubbles: true, composed: true, detail }));
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[Navigation]: Dispatching event", name, detail);
        }
        static get styles() {
            return _Navigation_scss__WEBPACK_IMPORTED_MODULE_11__["default"];
        }
        setUserRoleString() {
            this.userRoleString = this.userRole && this.userRole.length > 0 ? this.userRole.join("_") : "";
        }
        getScrollButtonClassMap(dir) {
            return {
                top: dir === DIRECTION.UP,
                bottom: DIRECTION.UP,
                "nav-scroll-button": true,
                "visual-rebrand": _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isVisualRebrandEnabled
            };
        }
        getScrollButton(dir) {
            const scrollBtnDirectionLabel = dir === DIRECTION.UP ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(localizedLabels.scrollUp) : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(localizedLabels.scrollDown);
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
        <md-button
          @click=${() => this.scrollNavList(dir)}
          ariaLabel="${scrollBtnDirectionLabel}"
          role="scrollbar"
          title="${scrollBtnDirectionLabel}"
          class="${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_8__.classMap)(this.getScrollButtonClassMap(dir))}"
          hasRemoveStyle
        >
          <md-icon
            class="nav-scroll-icon"
            name="${dir === DIRECTION.UP ? "arrow-up-bold" : "arrow-down-bold"}"
            size="24"
            iconSet="momentumDesign"
            title="${scrollBtnDirectionLabel}"
          ></md-icon>
        </md-button>
      `;
        }
        getHamburgerButton(isNavShown) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
        <md-button
          ariaLabel="${isNavShown ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(localizedLabels.hideNav) : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(localizedLabels.showNav)}"
          ariaExpanded="${isNavShown}"
          variant="ghost"
          class="nav-button"
          circle
          size="40"
          @click=${() => {
                this.showNavList = !isNavShown;
                if (this.showNavList) {
                    this.setAttribute("showNavList", "");
                }
                else {
                    this.removeAttribute("showNavList");
                }
            }}
        >
          <md-icon
            name="${isNavShown ? "cancel-bold" : "list-menu-bold"}"
            class="nav-button-content"
            iconSet="momentumDesign"
            size="24"
          ></md-icon>
        </md-button>
      `;
        }
        get navClassMap() {
            return {
                shadow: this.showNavList,
                "momentum-style": _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled
            };
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
        <nav aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(localizedLabels.navigationRegionLabel)}" class="column ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_8__.classMap)(this.navClassMap)}">
          <div class="top-container">
            <md-tooltip
              slot="menu-trigger"
              placement="bottom"
              class="hamburger-container-tooltip"
              message=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(localizedLabels.hamburgerLabel)}
            >
              <div class="hamburger-container">${this.getHamburgerButton(this.showNavList)}</div>
            </md-tooltip>
          </div>
          <div class="${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_8__.classMap)({ "show-nav-list": this.showNavList, "hidable-container": true })}">
            <div class="column container">
              <div class="scroll-button-placer">
                ${this.showTopScrollButton ? this.getScrollButton(DIRECTION.UP) : lit_html__WEBPACK_IMPORTED_MODULE_7__.nothing}
              </div>
              <ul
                @scroll=${this.onPrimaryScroll}
                id="primaryNav"
                aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:navigation.mainSectionlabel")}"
                class="nav-list primary"
              >
                ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_9__.repeat)(this.top, (item, index) => (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
                    <li
                      class="nav-list__item ${this.itemSelectedIdx === index ? "nav-selected" : ""}"
                      aria-label="${item.label.includes("home") && this.popoverCount
                ? `${this.popoverCount} contact requests`
                : ""}"
                    >
                      <md-tooltip message="${item.label.startsWith("app:") ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(item.label) : item.label}">
                        <agentx-wc-navigation-item
                          uid="${index}"
                          .item="${item}"
                          .popoverCount="${this.popoverCount}"
                          ?momentumStyle=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled}
                          ?selected="${this.itemSelectedIdx === index}"
                          @selected="${(e) => this.selected(e.detail.item.navigateTo)}"
                        ></agentx-wc-navigation-item>
                      </md-tooltip>
                    </li>
                  `)}
              </ul>

              <div class="scroll-button-placer">
                ${this.showBottomScrollButton ? this.getScrollButton(DIRECTION.DOWN) : lit_html__WEBPACK_IMPORTED_MODULE_7__.nothing}
              </div>
              <div>
                <!-- Bottom of the navigation bar is designated for quick links - they will not have 'selected' state -->
                <ul class="nav-list secondary">
                  ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_9__.repeat)(this.bottom, (item) => (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
                      <li class="nav-list__item">
                        <md-tooltip message="${item.label.startsWith("app:") ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(item.label) : item.label}">
                          <agentx-wc-navigation-item
                            .item="${item}"
                            .popoverCount="${this.popoverCount}"
                            .darkTheme="${this.darkTheme}"
                            ?selected="${false}"
                            ?momentumStyle=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled}
                            @selected="${(e) => this.bottomClickHandler(e.detail.item)}"
                          ></agentx-wc-navigation-item>
                        </md-tooltip>
                      </li>
                    `)}
                </ul>
                <!-- Display reload icon if agentx loaded in an iframe -->
                ${window !== window.top || this.showReload
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
                      <md-tooltip message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(localizedLabels.reload)}">
                        <md-button
                          @click=${() => location.reload()}
                          ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(localizedLabels.reload)}"
                          class="reload-button"
                          size="40"
                          circle
                          variant="ghost"
                        >
                          <md-icon
                            aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(localizedLabels.reload)}"
                            title="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(localizedLabels.reload)}"
                            name="refresh-bold"
                            class="reload-icon"
                            iconSet="momentumDesign"
                            size="24"
                          ></md-icon>
                        </md-button>
                      </md-tooltip>
                    `
                : ""}
              </div>
            </div>
          </div>
        </nav>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: String })
    ], Element.prototype, "selectedNavigateTo", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Array })
    ], Element.prototype, "items", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Object })
    ], Element.prototype, "agentDetails", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Number })
    ], Element.prototype, "popoverCount", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: String })
    ], Element.prototype, "navtitle", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Boolean })
    ], Element.prototype, "darkTheme", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Array })
    ], Element.prototype, "userRole", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Boolean, attribute: "show-reload" })
    ], Element.prototype, "showReload", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
    ], Element.prototype, "top", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
    ], Element.prototype, "bottom", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
    ], Element.prototype, "itemSelectedIdx", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
    ], Element.prototype, "showNavList", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
    ], Element.prototype, "showTopScrollButton", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
    ], Element.prototype, "showBottomScrollButton", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
    ], Element.prototype, "userRoleString", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.query)("#primaryNav")
    ], Element.prototype, "primaryNav", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.customElement)(NAVIGATION_CUSTOM_ELEMENT)
    ], Element);
    Navigation.Element = Element;
})(Navigation || (Navigation = {}));


/***/ }),

/***/ "./src/components/Navigation/comp/NavigationItem.scss":
/*!************************************************************!*\
  !*** ./src/components/Navigation/comp/NavigationItem.scss ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  display: flex;
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;
  text-indent: 0;
  list-style: none;
}

.nav-button {
  display: flex;
  border-radius: 3px;
  color: var(--md-primary-text-color);
  width: calc(var(--nav-size) - 8px);
  height: var(--nav-item-height);
  align-items: center;
  justify-content: center;
}
.nav-button:not(.nav-button__momentum):hover {
  background-color: var(--md-tertiary-bg-color);
}
.nav-button:not(.nav-button__momentum).nav-button__selected {
  position: relative;
  background-color: var(--md-quaternary-bg-color);
}
.nav-button:not(.nav-button__momentum).nav-button__selected::before {
  content: "";
  position: absolute;
  z-index: var(--z-index-expand-collapse, 2);
  width: 3px;
  height: 100%;
  background-color: var(--md-primary-text-color);
  top: 0;
  left: -3px;
  border-radius: 2px;
}
.nav-button:not(.nav-button__momentum) .wc-unread-popover-count {
  position: absolute;
  left: 1.3rem;
  top: 0.4rem;
  transform: translate(-20%, -10%);
}
.nav-button.nav-button__momentum {
  position: relative;
}
.nav-button.nav-button__momentum::before {
  content: "";
  position: absolute;
  z-index: var(--z-index-expand-collapse, 2);
  background-color: var(--md-primary-text-color);
  top: 50%;
  transform: translateY(-50%);
  left: -8px;
  border-radius: 0px 4px 4px 0px;
  width: 4px;
  height: 16px;
}
.nav-button.nav-button__momentum .wc-unread-popover-count {
  position: absolute;
  display: inline-flex;
  right: 2px;
  top: 2px;
}
.nav-button.nav-button__momentum:not(.nav-button__visual-rebrand).nav-button__selected::before {
  left: -4px;
}
.nav-button.nav-button__momentum.nav-button__visual-rebrand::before {
  transition: left 0.2s ease;
}
.nav-button.nav-button__momentum.nav-button__visual-rebrand:hover::before {
  left: -4px;
}
.nav-button.nav-button__momentum.nav-button__visual-rebrand:active::before {
  left: -8px;
}
.nav-button.nav-button__momentum.nav-button__visual-rebrand:active::part(button) {
  background-color: var(--button-primary-bg-color);
  color: var(--button-primary-text-color);
}
.nav-button .nav-scroll-icon {
  color: var(--md-primary-text-color);
}
.nav-button .nav-button-content {
  width: calc(var(--nav-size) - 0.125rem);
  height: calc(var(--nav-item-height) - 0.25rem);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 !important;
}
.nav-button .nav-button-content.hidden {
  display: none;
}
.nav-button .nav-button-content.img-loading {
  background-image: linear-gradient(-45deg, rgba(255, 255, 255, 0.125) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.125) 50%, rgba(255, 255, 255, 0.125) 75%, transparent 75%, transparent);
  background-size: calc(var(--nav-size) / 2) calc(var(--nav-size) / 2);
  animation: cssProgressActive 1s linear infinite;
}
@keyframes cssProgressActive {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: calc(var(--nav-size) / 2) calc(var(--nav-size) / 2);
  }
}

@media (forced-colors: active) {
  .nav-button.nav-button__selected::before {
    background-color: CanvasText !important;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Navigation/comp/NavigationItem.ts":
/*!**********************************************************!*\
  !*** ./src/components/Navigation/comp/NavigationItem.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NavigationItem: () => (/* binding */ NavigationItem)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html/directives/style-map */ "lit-html/directives/style-map");
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _NavigationItem_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./NavigationItem.scss */ "./src/components/Navigation/comp/NavigationItem.scss");
/* harmony import */ var _NavigationItemIconUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./NavigationItemIconUtils */ "./src/components/Navigation/comp/NavigationItemIconUtils.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_9__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};










const DEFAULT_ICON_SIZE = 24;
const DEFAULT_ICON_SIZE_LEGACY = 20;
const isImageUrl = (url) => {
    if (!url || url.length < 4) {
        return false;
    }
    const validImageExtensions = ["png", "gif", "jpg", "jpeg", "svg", "bmp", "ico"];
    const image = url.substring(url.lastIndexOf("/")).toLowerCase();
    return validImageExtensions.find((ext) => image.includes(ext));
};
var NavigationItem;
(function (NavigationItem) {
    /**
     * @element agentx-wc-navigation-item
     * @fires selected
     */
    let Element = class Element extends _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_9__.MobxLitElement {
        constructor() {
            super(...arguments);
            this.selected = false;
            this.darkTheme = false;
            this.momentumStyle = false;
            this.popoverCount = null;
            this.uid = null;
            this.isImgLoaded = false;
            this.isImgError = false;
            this.onBtnClick = () => {
                this.dispatchEvent(new CustomEvent("selected", {
                    detail: {
                        item: this.item
                    }
                }));
            };
        }
        connectedCallback() {
            super.connectedCallback();
        }
        get label() {
            var _a, _b;
            return (_b = (_a = this.item) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : "";
        }
        get iconSize() {
            var _a, _b;
            return (_b = (_a = this.item) === null || _a === void 0 ? void 0 : _a.iconSize) !== null && _b !== void 0 ? _b : DEFAULT_ICON_SIZE;
        }
        get legacyIconSize() {
            var _a, _b;
            return (_b = (_a = this.item) === null || _a === void 0 ? void 0 : _a.iconSize) !== null && _b !== void 0 ? _b : DEFAULT_ICON_SIZE_LEGACY;
        }
        get iconName() {
            return this.momentumStyle && this.selected && this.item.iconActive ? this.item.iconActive : this.item.icon;
        }
        get isMomentum() {
            return this.item && this.item.iconType === "momentum";
        }
        get isImg() {
            return this.item && this.item.iconType === "other" && !!isImageUrl(this.item.icon);
        }
        get isMomentumDesignIconSet() {
            return this.item && this.item.iconType.toLowerCase() === "momentumdesign";
        }
        get btnCssClassInfo() {
            return {
                "nav-button__imaged": this.isImg,
                "nav-button__selected": this.selected,
                "nav-button__momentum": this.momentumStyle,
                "nav-button__visual-rebrand": _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8__.themeManager.isVisualRebrandEnabled
            };
        }
        static get styles() {
            return _NavigationItem_scss__WEBPACK_IMPORTED_MODULE_6__["default"];
        }
        get buttonVariant() {
            if (!this.momentumStyle) {
                return undefined;
            }
            if (!this.selected) {
                return "tab";
            }
            return _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8__.themeManager.isVisualRebrandEnabled ? "primary" : "tab";
        }
        get computedAriaLabel() {
            if (this.label.startsWith("app:")) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(this.label, this.label, { count: this.popoverCount ? this.popoverCount : 0 });
            }
            else if (this.label.includes("Feedback")) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:navigation.shareFeedback");
            }
            return this.label;
        }
        render() {
            return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-button
          id="navigation-item-${this.uid}"
          ariaHaspopup="false"
          ariaLabel=${this.computedAriaLabel}
          @click=${this.onBtnClick}
          ?hasRemoveStyle=${!this.momentumStyle}
          ?circle="${this.momentumStyle}"
          size="${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__.ifDefined)(this.momentumStyle ? "40" : undefined)}"
          variant="${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__.ifDefined)(this.buttonVariant)}"
          ?isActive=${this.selected}
          class="nav-button ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3__.classMap)(this.btnCssClassInfo)}"
          role="link"
          aria-current=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__.ifDefined)(this.selected ? "page" : undefined)}
        >
          ${this.renderIcon()} ${this.item.taskBadge ? this.renderBadge() : null}
        </md-button>
      `;
        }
        renderBadge() {
            if (this.popoverCount) {
                return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) `
          <md-badge class="wc-unread-popover-count" color="unreadcount" id="wc-unread-popover-count">
            <span>${this.popoverCount}</span>
          </md-badge>
        `;
            }
            return "";
        }
        renderMomentumIcon() {
            if (this.isMomentumDesignIconSet) {
                return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) `
          <md-icon
            name="${this.iconName}"
            class="nav-button-content"
            size=${this.iconSize}
            iconSet="momentumDesign"
          ></md-icon>
        `;
            }
            const mdIconName = (0,_NavigationItemIconUtils__WEBPACK_IMPORTED_MODULE_7__.getMomentumDesignIconName)(this.iconName, this.selected, this.momentumStyle && !this.item.iconActive);
            if (mdIconName) {
                return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) `
          <md-icon
            name="${mdIconName}"
            class="nav-button-content"
            size=${this.iconSize}
            iconSet="momentumDesign"
          ></md-icon>
        `;
            }
            return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) ` <md-icon name="icon-${this.iconName}_${this.legacyIconSize}" class="nav-button-content"></md-icon> `;
        }
        renderIcon() {
            if (this.isMomentum || this.isMomentumDesignIconSet) {
                return this.renderMomentumIcon();
            }
            if (this.isImg) {
                return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) `
          <div
            class="nav-button-content ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3__.classMap)({
                    hidden: this.isImgError,
                    "img-loading": !this.isImgError && !this.isImgLoaded
                })}"
          >
            <img
              src="${this.item.icon}"
              alt="${this.label}"
              style="${(0,lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_5__.styleMap)({
                    "max-height": `${this.iconSize}px`,
                    "max-width": `${this.iconSize}px`
                })}"
              @load="${() => {
                    this.isImgError = false;
                    this.isImgLoaded = true;
                }}"
              @error="${() => (this.isImgError = true)}"
            />
          </div>
          <md-icon
            name="icon-warning_20"
            title=${this.label}
            class="nav-button-content ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3__.classMap)({ hidden: !this.isImgError })}"
          ></md-icon>
        `;
            }
            return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) ` <span>${this.label}</span> `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
    ], Element.prototype, "item", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "selected", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "darkTheme", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "momentumStyle", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
    ], Element.prototype, "popoverCount", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
    ], Element.prototype, "uid", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "isImgLoaded", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "isImgError", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-navigation-item")
    ], Element);
    NavigationItem.Element = Element;
})(NavigationItem || (NavigationItem = {}));


/***/ }),

/***/ "./src/components/Navigation/comp/NavigationItemIconUtils.ts":
/*!*******************************************************************!*\
  !*** ./src/components/Navigation/comp/NavigationItemIconUtils.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getMomentumDesignIconName: () => (/* binding */ getMomentumDesignIconName)
/* harmony export */ });
const iconMap = {
    survey: "survey-bold",
    team: "meetings-team-bold",
    "team-active": "meetings-team-filled",
    home: "home-bold",
    "home-active": "home-filled",
    waveform: "noise-removal-bold",
    note: "notes-bold",
    analysis: "analysis-bold",
    "analysis-active": "analysis-filled",
    "view-list": "view-list-bold",
    "queue-contact": "queue-contact-bold",
    "help-circle": "help-circle-bold",
    "help-circle-active": "help-circle-filled",
    headset: "headset-bold",
    "headset-selected": "headset-filled",
    inbox: "inbox-bold"
};
const momentumDesignIconNames = new Set([
    ...Object.values(iconMap),
    "queue-contact-filled",
    "inbox-filled",
    "survey-filled"
]);
function getIconFilledName(name) {
    return iconMap[name] ? iconMap[name].replace("-bold", "-filled") : `${name}-filled`;
}
function getMomentumDesignIconName(name, isSelected, autoFillIcon) {
    //If an active icon is not configured and its momentum style
    //auto map to filled version of icon
    if (isSelected && autoFillIcon) {
        const filledName = getIconFilledName(name);
        if (momentumDesignIconNames.has(filledName)) {
            return filledName;
        }
    }
    if (iconMap[name]) {
        return iconMap[name];
    }
    //To allow for users to specify momentum design names
    if (momentumDesignIconNames.has(name)) {
        return name;
    }
    return undefined;
}


/***/ }),

/***/ "./src/components/QualityMonitoringWidget/QualityMonitoring.scss":
/*!***********************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/QualityMonitoring.scss ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

* {
  /* BASE LEVEL < 100 */
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-index-tpw-header: 1;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-index-task-collapse-area: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-navigation-bar: 12;
  --z-index-task-list: 12;
  --z-index-wrap-up: 13;
  --z-index-sticky-header: 14;
  --z-index-shortcutkey-modal: 15;
  /* MID LEVEL FLOATING > 100 < 1000 */
  --z-index-notification: 150;
  /* SUPER LEVEL > 1000 */
  --z-index-modal: 1040;
  --z-index-popover: 1041;
  --z-index-callback-modal: 1042;
  /* This below order needs to be unchanged. Highest priority is for connection loss overlay,
         followed by error modal since error can occur during app load such as teams failure/register failure. */
  --z-index-app-full-overlay: 1050;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1200;
}

:host {
  --grid-header-height: 60px;
  --visualizer-title-width: 100px;
  --visualizer-title-margin-left: 24px;
  --visualizer-container-max-height: 40px;
  --visualizer-container-max-width: 900px;
  --visualizer-container-gap: 16px;
  --visualizer-bar-max-width: 577px;
  --visualizer-bar-max-height: 4px;
  --player-controls-row-height: 50px;
  --player-controls-gap: 8px;
  --volume-popover-width: 180px;
  --volume-popover-height: 21px;
  --volume-popover-gap: 12px;
  --volume-popover-top-offset: 120%;
  --volume-popover-left-offset: 50%;
  --volume-popover-padding: 12px;
  --seek-bar-height: 8px;
  --seek-bar-thumb-size: 16px;
  --seek-bar-top-margin: 16px;
  --seek-bar-bottom-margin: 8px;
  --popover-arrow-size: 10px;
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  --interaction-details-height: 220px;
  --interaction-details-vertical-padding: 12px;
  --interaction-details-optional-horizontal-margin: 24px;
  --interaction-details-item-bottom-margin: 4px;
  --interaction-details-item-grid-template-columns: 150px auto;
  --webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  --chapters-container-height: 292px;
  --chapters-container-height-no-border: 250px;
  --chapters-container-height-hidden-tabs: 350px;
  --chapters-container-height: 292px;
  --chapters-container-height-hidden-tabs-no-border: 300px;
  --chapters-container-padding-right: 18px;
  --chapter-container-padding-top: 5px;
  --chapter-container-padding-bottom: 12px;
  --chapter-time-width: 60px;
  --chapter-title-width: 300px;
  --transcript-height: 285px;
  --transcript-height-no-chapters: 410px;
  --transcript-height-chapters-no-consults: 350px;
}

.qm-wrapper {
  height: 100%;
}

.qm-grid-header {
  height: var(--grid-header-height);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/QualityMonitoring.ts":
/*!*********************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/QualityMonitoring.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QualityMonitoringWidget: () => (/* binding */ QualityMonitoringWidget)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_EmptyGrid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./components/EmptyGrid */ "./src/components/QualityMonitoringWidget/components/EmptyGrid.ts");
/* harmony import */ var _components_evaluations_EvaluationViewer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./components/evaluations/EvaluationViewer */ "./src/components/QualityMonitoringWidget/components/evaluations/EvaluationViewer.ts");
/* harmony import */ var _components_GridError__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./components/GridError */ "./src/components/QualityMonitoringWidget/components/GridError.ts");
/* harmony import */ var _components_GridHeader__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./components/GridHeader */ "./src/components/QualityMonitoringWidget/components/GridHeader.ts");
/* harmony import */ var _components_Recording__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./components/Recording */ "./src/components/QualityMonitoringWidget/components/Recording.ts");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./config */ "./src/components/QualityMonitoringWidget/config.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./constants */ "./src/components/QualityMonitoringWidget/constants.ts");
/* harmony import */ var _QualityMonitoring_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./QualityMonitoring.scss */ "./src/components/QualityMonitoringWidget/QualityMonitoring.scss");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./utils */ "./src/components/QualityMonitoringWidget/utils.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};














var QualityMonitoringWidget;
(function (QualityMonitoringWidget) {
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
        constructor() {
            super(...arguments);
            this.isDarkMode = false;
            this.isLoggedIntoStation = false;
            this.isQMWShowConsultRecordingsEnabled = false;
            this.isRecordingsRicherMetadataEnabled = false;
            this.isRecordingTranscriptionEnabled = false;
            this.isAutoCsatEnabled = false;
            this.isGridEmpty = false;
            // filter defaults to the last 24 hour period
            this.startTime = luxon__WEBPACK_IMPORTED_MODULE_4__.DateTime.local().minus({ days: 1 }).toMillis();
            this.endTime = luxon__WEBPACK_IMPORTED_MODULE_4__.DateTime.local().minus({ seconds: 1 }).toMillis();
            this.hasError = false;
            this.trackingID = "";
            this.activeSessionId = "";
            this.activeAni = "";
            this.activeAgentName = "";
            this.queue = "";
            this.isModalOpen = false;
            this.modalOpenTime = 0;
            this.activeSessionStartTime = 0;
            this.gridOptions = {};
            this.evaluationData = null;
            this.transcript = null;
            this.activeAgentId = "";
            this.onGridReady = (event) => {
                var _a;
                (_a = event.api) === null || _a === void 0 ? void 0 : _a.setGridOption("serverSideDatasource", this.createDatasource());
            };
            this.getGridConfigs = () => {
                return {
                    isAutoCsatEnabled: this.isAutoCsatEnabled
                };
            };
            this.createDatasource = () => {
                const getPage = (startRow = 0) => {
                    if (startRow && startRow !== 0) {
                        return startRow / _constants__WEBPACK_IMPORTED_MODULE_11__.MAX_ROWS_IN_RESPONSE;
                    }
                    else {
                        return startRow;
                    }
                };
                const fetchData = (params) => __awaiter(this, void 0, void 0, function* () {
                    const startTime = this.startTime;
                    const endTime = this.endTime;
                    const pageNumber = getPage(params.request.startRow);
                    const searchData = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.qmw.fetchTasks({ startTime, endTime, pageNumber });
                    _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[App:QMW] Fetched tahoe data succesfully");
                    const taskData = searchData.data.task.tasks;
                    const pageInfoData = searchData.data.task.pageInfo;
                    this.setHasError(false);
                    this.setIsGridEmpty(taskData.length ? false : true);
                    if (pageInfoData.hasNextPage) {
                        params.success({ rowData: taskData });
                    }
                    else {
                        let rowCount = taskData.length;
                        if (pageNumber !== 0) {
                            const previousRowCount = pageNumber * _constants__WEBPACK_IMPORTED_MODULE_11__.MAX_ROWS_IN_RESPONSE;
                            rowCount = rowCount + previousRowCount;
                        }
                        params.success({ rowData: taskData, rowCount });
                    }
                });
                return {
                    getRows: (params) => __awaiter(this, void 0, void 0, function* () {
                        try {
                            yield fetchData(params);
                        }
                        catch (err) {
                            if ((0,_utils__WEBPACK_IMPORTED_MODULE_13__.errorIsRetryable)(err === null || err === void 0 ? void 0 : err.details)) {
                                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[App:QMW] Failed to fetch tahoe data due to rate limit. Retrying`);
                                yield (0,_utils__WEBPACK_IMPORTED_MODULE_13__.wait)(err === null || err === void 0 ? void 0 : err.details);
                                yield fetchData(params);
                            }
                            else {
                                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`[App:QMW] Failed to fetch tahoe data`);
                                params.fail();
                                this.setHasError(true);
                                this.setTrackingID((0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.getTrackingIdFromErrorObject)(err));
                            }
                        }
                    })
                };
            };
        }
        get gridApi() {
            var _a;
            return (_a = this.gridWidget) === null || _a === void 0 ? void 0 : _a.getGridApi();
        }
        static get styles() {
            return _QualityMonitoring_scss__WEBPACK_IMPORTED_MODULE_12__["default"];
        }
        connectedCallback() {
            var _a;
            super.connectedCallback();
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.POST_INTERACTION_VISITED, {}, [
                (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.SERVICE_PROVIDERS) === null || _a === void 0 ? void 0 : _a.webex_behavioral
            ]);
            this.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_11__.QMW_ERR_RETRY, this.handleErrorResetTry);
            this.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_11__.QMW_ACTIONS_BTN_CLICK, this.handlePlayBtnClick);
            this.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_11__.QMW_EVALUATE_BTN_CLICK, this.handleEvaluateBtnClick);
            this.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_11__.TRANSCRIPT_LOADED, this.handleTranscriptLoaded);
            this.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_11__.QMW_RECORDINGS_MODAL_CLOSE_BTN_CLK, this.handleModalCloseClick);
            this.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_11__.QMW_FILTERS_UPDATED, this.handleFiltersUpdated);
            this.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_11__.SET_ACTIVE_AGENT_ID, this.setActiveAgentId);
            this.initializeGrid();
        }
        firstUpdated(changedProperties) {
            super.firstUpdated(changedProperties);
            this.getLocalFilters();
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_11__.QMW_ERR_RETRY, this.handleErrorResetTry);
            this.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_11__.QMW_ACTIONS_BTN_CLICK, this.handlePlayBtnClick);
            this.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_11__.QMW_EVALUATE_BTN_CLICK, this.handleEvaluateBtnClick);
            this.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_11__.TRANSCRIPT_LOADED, this.handleTranscriptLoaded);
            this.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_11__.QMW_RECORDINGS_MODAL_CLOSE_BTN_CLK, this.handleModalCloseClick);
            this.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_11__.QMW_FILTERS_UPDATED, this.handleFiltersUpdated);
            this.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_11__.SET_ACTIVE_AGENT_ID, this.setActiveAgentId);
        }
        getLocalFilters() {
            const storedFilters = JSON.parse(localStorage.getItem("qmwFilters") || "{}");
            if (Object.keys(storedFilters).length) {
                this.startTime = storedFilters.startTime;
                this.endTime = storedFilters.endTime;
            }
        }
        setLocalFilters() {
            localStorage.setItem("qmwFilters", JSON.stringify({
                startTime: this.startTime,
                endTime: this.endTime
            }));
        }
        getHasError() {
            return this.hasError;
        }
        setHasError(hasError) {
            this.hasError = hasError;
        }
        getIsGridEmpty() {
            return this.isGridEmpty;
        }
        setIsGridEmpty(isGridEmpty) {
            this.isGridEmpty = isGridEmpty;
        }
        getTrackingId() {
            return this.trackingID;
        }
        setTrackingID(trackingID) {
            this.trackingID = trackingID;
        }
        getActiveSessionId() {
            return this.activeSessionId;
        }
        setActiveSessionId(sessionId) {
            this.activeSessionId = sessionId;
        }
        getActiveAni() {
            return this.activeAni;
        }
        setActiveAni(ani) {
            this.activeAni = ani;
        }
        getActiveAgentName() {
            return this.activeAgentName;
        }
        setActiveAgentName(agentName) {
            this.activeAgentName = agentName;
        }
        setQueue(queueName) {
            this.queue = queueName;
        }
        getIsModalOpen() {
            return this.isModalOpen;
        }
        setIsModalOpen(isModalOpen) {
            var _a;
            this.isModalOpen = isModalOpen;
            if (isModalOpen) {
                this.modalOpenTime = Date.now();
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.PI_RECORDING_DETAILS_MODAL_CLOSED, [
                    (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.SERVICE_PROVIDERS) === null || _a === void 0 ? void 0 : _a.webex_behavioral
                ]);
            }
        }
        initializeGrid() {
            this.gridOptions = Object.assign(Object.assign({}, (0,_config__WEBPACK_IMPORTED_MODULE_10__.getBaseGridConfigs)(this.getGridConfigs)), { onGridReady: (e) => this.onGridReady(e) });
        }
        handleErrorResetTry() {
            this.setHasError(false);
            this.setTrackingID("");
        }
        setActiveAgentId(e) {
            this.activeAgentId = e.detail.agentId;
        }
        handlePlayBtnClick(e) {
            var _a, _b, _c, _d, _e;
            this.setActiveSessionId((_a = e === null || e === void 0 ? void 0 : e.detail) === null || _a === void 0 ? void 0 : _a.sessionId);
            this.setActiveAni((_b = e === null || e === void 0 ? void 0 : e.detail) === null || _b === void 0 ? void 0 : _b.ani);
            this.setActiveAgentName((_c = e === null || e === void 0 ? void 0 : e.detail) === null || _c === void 0 ? void 0 : _c.agentName);
            this.setQueue((_d = e === null || e === void 0 ? void 0 : e.detail) === null || _d === void 0 ? void 0 : _d.queueName);
            this.activeSessionStartTime = (_e = e === null || e === void 0 ? void 0 : e.detail) === null || _e === void 0 ? void 0 : _e.activeSessionStartTime;
            this.setIsModalOpen(true);
        }
        handleTranscriptLoaded(e) {
            this.transcript = e.detail.transcript;
        }
        handleModalCloseClick(e) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
            this.setActiveSessionId("");
            this.setActiveAni("");
            this.setActiveAgentName("");
            this.setQueue("");
            this.activeSessionStartTime = 0;
            this.setIsModalOpen(false);
            if ((_a = e === null || e === void 0 ? void 0 : e.detail) === null || _a === void 0 ? void 0 : _a.showEnhancedRecordings) {
                const fields = {
                    ["numCustomerChapters"]: (_b = e === null || e === void 0 ? void 0 : e.detail) === null || _b === void 0 ? void 0 : _b.numCustomerChapters,
                    ["numConsultChapters"]: (_c = e === null || e === void 0 ? void 0 : e.detail) === null || _c === void 0 ? void 0 : _c.numConsultChapters,
                    ["numMultiPartyConferences"]: (_d = e === null || e === void 0 ? void 0 : e.detail) === null || _d === void 0 ? void 0 : _d.numMultiPartyConferences,
                    ["hasDataFetchError"]: (_e = e === null || e === void 0 ? void 0 : e.detail) === null || _e === void 0 ? void 0 : _e.hasDataFetchError,
                    ["hasRecordingPlaybackError"]: (_f = e === null || e === void 0 ? void 0 : e.detail) === null || _f === void 0 ? void 0 : _f.hasRecordingPlaybackError,
                    ["chapterClickedTimes"]: (_g = e === null || e === void 0 ? void 0 : e.detail) === null || _g === void 0 ? void 0 : _g.chapterClickedTimes,
                    ["visualizerClickedTimes"]: (_h = e === null || e === void 0 ? void 0 : e.detail) === null || _h === void 0 ? void 0 : _h.visualizerClickedTimes,
                    ["seekBarChangedTimes"]: (_j = e === null || e === void 0 ? void 0 : e.detail) === null || _j === void 0 ? void 0 : _j.seekBarChangedTimes,
                    ["volumeControlChangedTimes"]: (_k = e === null || e === void 0 ? void 0 : e.detail) === null || _k === void 0 ? void 0 : _k.volumeControlChangedTimes,
                    ["playbackRateControlChangedTimes"]: (_l = e === null || e === void 0 ? void 0 : e.detail) === null || _l === void 0 ? void 0 : _l.playbackRateControlChangedTimes,
                    ["playClickedTimes"]: (_m = e === null || e === void 0 ? void 0 : e.detail) === null || _m === void 0 ? void 0 : _m.playClickedTimes,
                    ["transcriptAvailable"]: (_o = e === null || e === void 0 ? void 0 : e.detail) === null || _o === void 0 ? void 0 : _o.transcriptAvailable,
                    ["hasTranscriptError"]: (_p = e === null || e === void 0 ? void 0 : e.detail) === null || _p === void 0 ? void 0 : _p.hasTranscriptError,
                    ["transcriptErrorMessage"]: (_q = e === null || e === void 0 ? void 0 : e.detail) === null || _q === void 0 ? void 0 : _q.transcriptErrorMessage,
                    ["transcriptChapterClickedTimes"]: (_r = e === null || e === void 0 ? void 0 : e.detail) === null || _r === void 0 ? void 0 : _r.transcriptChapterClickedTimes
                };
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.PI_RECORDING_DETAILS_MODAL_CLOSED, fields, [
                    (_s = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.SERVICE_PROVIDERS) === null || _s === void 0 ? void 0 : _s.webex_behavioral
                ]);
            }
        }
        handleEvaluateBtnClick(event) {
            this.evaluationData = event === null || event === void 0 ? void 0 : event.detail;
        }
        handleFiltersUpdated(e) {
            var _a, _b, _c, _d;
            this.startTime = (_a = e === null || e === void 0 ? void 0 : e.detail) === null || _a === void 0 ? void 0 : _a.startTime;
            this.endTime = (_b = e === null || e === void 0 ? void 0 : e.detail) === null || _b === void 0 ? void 0 : _b.endTime;
            this.setLocalFilters();
            (_c = this.gridApi) === null || _c === void 0 ? void 0 : _c.onFilterChanged();
            this.gridOptions = Object.assign({}, this.gridOptions);
            const totalTimeInSeconds = (this.endTime - this.startTime) / 1000;
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.PI_TIME_FILTER_SELECTED, {
                [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.PI_TIME_FILTER_DURATION_SELECTED]: totalTimeInSeconds
            }, [(_d = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.webex_behavioral]);
        }
        renderComponent() {
            if (this.hasError) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
          <agentx-wc-qmw-grid-error .trackingID=${this.trackingID} .errorElement=${_constants__WEBPACK_IMPORTED_MODULE_11__.GRID}></agentx-wc-qmw-grid-error>
        `;
            }
            else if (this.isGridEmpty) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) ` <agentx-wc-qmw-empty-grid .emptyElement=${_constants__WEBPACK_IMPORTED_MODULE_11__.GRID}></agentx-wc-qmw-empty-grid> `;
            }
            else {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
          ${!this.evaluationData
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                <agentx-wc-ag-grid
                  .gridOptions=${this.gridOptions}
                  .isDarkMode=${this.isDarkMode}
                  .isLoggedIntoStation=${this.isLoggedIntoStation}
                ></agentx-wc-ag-grid>
              `
                    : (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                <agentx-wc-evaluation-viewer
                  @clear-evaluation-data=${this.clearEvaluationData}
                  .evaluationData=${this.evaluationData}
                  .transcript=${this.transcript}
                  .agentId=${this.activeAgentId}
                ></agentx-wc-evaluation-viewer>
              `}
        `;
            }
        }
        clearEvaluationData() {
            this.evaluationData = null;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div class="qm-wrapper">
          ${!this.evaluationData
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                <agentx-wc-qmw-filter-header
                  .startDate=${this.startTime}
                  .endDate=${this.endTime}
                ></agentx-wc-qmw-filter-header>
              `
                : ""}
          ${this.renderComponent()}
          <agentx-wc-qmw-recording-details
            .sessionId=${this.activeSessionId}
            .ani=${this.activeAni}
            .queue=${this.queue}
            .agentName=${this.activeAgentName}
            .isModalOpen=${this.isModalOpen}
            .startTimeFromGrid=${this.activeSessionStartTime}
            .showConsultRecordings=${this.isQMWShowConsultRecordingsEnabled}
            .showEnhancedRecordings=${this.isRecordingsRicherMetadataEnabled}
            .showTranscript=${this.isRecordingTranscriptionEnabled}
          ></agentx-wc-qmw-recording-details>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.query)("#agentx-wc-qm-grid-container")
    ], Element.prototype, "_gridDiv", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isDarkMode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isLoggedIntoStation", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isQMWShowConsultRecordingsEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isRecordingsRicherMetadataEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isRecordingTranscriptionEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isAutoCsatEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "isGridEmpty", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "startTime", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "endTime", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "hasError", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "trackingID", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "activeSessionId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "activeAni", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "activeAgentName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "queue", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "isModalOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "modalOpenTime", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "activeSessionStartTime", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "gridOptions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "evaluationData", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "transcript", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "activeAgentId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.query)("agentx-wc-ag-grid")
    ], Element.prototype, "gridWidget", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-quality-monitoring-grid")
    ], Element);
    QualityMonitoringWidget.Element = Element;
})(QualityMonitoringWidget || (QualityMonitoringWidget = {}));


/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/ActionsRenderer.ts":
/*!******************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/ActionsRenderer.ts ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ActionsRenderer)
/* harmony export */ });
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants */ "./src/components/QualityMonitoringWidget/constants.ts");


class ActionsRenderer {
    constructor() {
        this.eGui = document.createElement("div");
    }
    renderActionBtns(params) {
        var _a, _b;
        const actions = [
            {
                className: "qmw-play__btn",
                icon: "play-regular",
                tooltip: (_a = params.colDef) === null || _a === void 0 ? void 0 : _a.cellEditorParams.i18n.playRecording,
                eventName: _constants__WEBPACK_IMPORTED_MODULE_1__.QMW_ACTIONS_BTN_CLICK,
                handler: () => {
                    var _a, _b, _c, _d, _e, _f;
                    return ({
                        sessionId: (_a = params.data) === null || _a === void 0 ? void 0 : _a.id,
                        ani: (_b = params.data) === null || _b === void 0 ? void 0 : _b.origin,
                        agentName: (_c = params.data) === null || _c === void 0 ? void 0 : _c.owner.name,
                        activeSessionStartTime: (_d = params.data) === null || _d === void 0 ? void 0 : _d.createdTime,
                        queueName: (_f = (_e = params.data) === null || _e === void 0 ? void 0 : _e.lastQueue) === null || _f === void 0 ? void 0 : _f.name
                    });
                },
                shouldRender: true
            },
            {
                className: "qmw-evaluate__btn",
                icon: "webinar-light",
                tooltip: (_b = params.colDef) === null || _b === void 0 ? void 0 : _b.cellEditorParams.i18n.evaluateTask,
                eventName: _constants__WEBPACK_IMPORTED_MODULE_1__.QMW_EVALUATE_BTN_CLICK,
                handler: () => {
                    var _a, _b, _c, _d, _e, _f;
                    return ({
                        sessionId: (_a = params.data) === null || _a === void 0 ? void 0 : _a.id,
                        ani: (_b = params.data) === null || _b === void 0 ? void 0 : _b.origin,
                        agentName: (_c = params.data) === null || _c === void 0 ? void 0 : _c.owner.name,
                        activeSessionStartTime: (_d = params.data) === null || _d === void 0 ? void 0 : _d.createdTime,
                        queueName: (_f = (_e = params.data) === null || _e === void 0 ? void 0 : _e.lastQueue) === null || _f === void 0 ? void 0 : _f.name
                    });
                },
                shouldRender: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.featureflag.isWxccDesktopQMEvaluationsEnabled()
            }
        ];
        const filteredActions = actions.filter((action) => action.shouldRender);
        this.eGui.classList.add("qmw-actions-cell");
        this.eGui.innerHTML = filteredActions
            .map((action) => `
      <md-tooltip message="${action.tooltip}" placement="bottom">
        <button class="md-button--none qmw-actions-btn ${action.className}" aria-label="${action.tooltip}">
          <md-icon
            slot="icon"
            name="${action.icon}"
            iconSet="momentumDesign"
            size="16"
            ></md-icon>
        </button>
      </md-tooltip>
    `)
            .join("");
        actions.forEach((action) => {
            const btn = this.eGui.querySelector(`.${action.className}`);
            const handleClick = () => {
                btn === null || btn === void 0 ? void 0 : btn.dispatchEvent(new CustomEvent(action.eventName, {
                    bubbles: true,
                    composed: true,
                    detail: action.handler()
                }));
            };
            btn === null || btn === void 0 ? void 0 : btn.addEventListener("click", handleClick);
            btn === null || btn === void 0 ? void 0 : btn.addEventListener("keydown", (event) => {
                if (event.key === "Enter") {
                    handleClick();
                }
            });
        });
    }
    init(params) {
        this.renderActionBtns(params);
    }
    refresh(params) {
        this.renderActionBtns(params);
        return true;
    }
    getGui() {
        return this.eGui;
    }
    destroy() {
        this.eGui.remove();
    }
}


/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/AudioPlayer.scss":
/*!****************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/AudioPlayer.scss ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  --grid-header-height: 60px;
  --visualizer-title-width: 100px;
  --visualizer-title-margin-left: 24px;
  --visualizer-container-max-height: 40px;
  --visualizer-container-max-width: 900px;
  --visualizer-container-gap: 16px;
  --visualizer-bar-max-width: 577px;
  --visualizer-bar-max-height: 4px;
  --player-controls-row-height: 50px;
  --player-controls-gap: 8px;
  --volume-popover-width: 180px;
  --volume-popover-height: 21px;
  --volume-popover-gap: 12px;
  --volume-popover-top-offset: 120%;
  --volume-popover-left-offset: 50%;
  --volume-popover-padding: 12px;
  --seek-bar-height: 8px;
  --seek-bar-thumb-size: 16px;
  --seek-bar-top-margin: 16px;
  --seek-bar-bottom-margin: 8px;
  --popover-arrow-size: 10px;
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  --interaction-details-height: 220px;
  --interaction-details-vertical-padding: 12px;
  --interaction-details-optional-horizontal-margin: 24px;
  --interaction-details-item-bottom-margin: 4px;
  --interaction-details-item-grid-template-columns: 150px auto;
  --webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  --chapters-container-height: 292px;
  --chapters-container-height-no-border: 250px;
  --chapters-container-height-hidden-tabs: 350px;
  --chapters-container-height: 292px;
  --chapters-container-height-hidden-tabs-no-border: 300px;
  --chapters-container-padding-right: 18px;
  --chapter-container-padding-top: 5px;
  --chapter-container-padding-bottom: 12px;
  --chapter-time-width: 60px;
  --chapter-title-width: 300px;
  --transcript-height: 285px;
  --transcript-height-no-chapters: 410px;
  --transcript-height-chapters-no-consults: 350px;
}

.controls-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: var(--player-controls-row-height);
}

.player-controls {
  display: flex;
  flex: 1;
  align-items: center;
  gap: var(--player-controls-gap);
}

.playback-controls {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.player-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  background-color: var(--md-primary-bg-color);
  border-radius: 4px;
  border: 1px solid var(--md-gray-20);
}

.audio-player-transcript-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  background-color: var(--md-primary-bg-color);
}
.audio-player-transcript-container .audio-player-tabs-view-container {
  padding-left: 4px;
}

.row {
  display: flex;
}

.column {
  flex: 1;
  width: 45%;
  margin: 5px;
}

li {
  list-style-type: none;
}

.controls-seekbar-container {
  display: block;
  padding-inline-end: 3em;
  width: -webkit-fill-available;
}

.controls-seekbar-container.consult-chapters {
  margin-inline-start: 11.4em;
}

.controls-seekbar-container.no-consult-chapters {
  margin-inline-start: 2.4em;
}

.chapter-manager {
  display: none;
}

md-slider {
  padding-top: var(--seek-bar-top-margin);
  padding-bottom: var(--seek-bar-bottom-margin);
}

.interaction-details.with-margin {
  margin: 0 var(--interaction-details-optional-horizontal-margin);
}

.audio-player-transcript-view {
  max-height: var(--transcript-height);
}
.audio-player-transcript-view.no-chapters {
  max-height: var(--transcript-height-no-chapters);
}
.audio-player-transcript-view.chapters-no-consults {
  max-height: var(--transcript-height-chapters-no-consults);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/AudioPlayer.ts":
/*!**************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/AudioPlayer.ts ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AudioPlayer: () => (/* binding */ AudioPlayer),
/* harmony export */   AudioPlayerControlClicked: () => (/* binding */ AudioPlayerControlClicked)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../utils */ "./src/components/QualityMonitoringWidget/utils.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./../constants */ "./src/components/QualityMonitoringWidget/constants.ts");
/* harmony import */ var _AudioPlayer_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./AudioPlayer.scss */ "./src/components/QualityMonitoringWidget/components/AudioPlayer.scss");
/* harmony import */ var _player_ChapterManager__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./player/ChapterManager */ "./src/components/QualityMonitoringWidget/components/player/ChapterManager.ts");
/* harmony import */ var _player_ChaptersListView__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./player/ChaptersListView */ "./src/components/QualityMonitoringWidget/components/player/ChaptersListView.ts");
/* harmony import */ var _player_InteractionDetailsView__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./player/InteractionDetailsView */ "./src/components/QualityMonitoringWidget/components/player/InteractionDetailsView.ts");
/* harmony import */ var _player_PlaybackRateView__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./player/PlaybackRateView */ "./src/components/QualityMonitoringWidget/components/player/PlaybackRateView.ts");
/* harmony import */ var _player_PlayerTime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./player/PlayerTime */ "./src/components/QualityMonitoringWidget/components/player/PlayerTime.ts");
/* harmony import */ var _player_TranscriptView__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./player/TranscriptView */ "./src/components/QualityMonitoringWidget/components/player/TranscriptView.ts");
/* harmony import */ var _player_VisualizerView__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./player/VisualizerView */ "./src/components/QualityMonitoringWidget/components/player/VisualizerView.ts");
/* harmony import */ var _player_VolumeControlView__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./player/VolumeControlView */ "./src/components/QualityMonitoringWidget/components/player/VolumeControlView.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
















var SeekDirection;
(function (SeekDirection) {
    SeekDirection["FORWARD"] = "forward";
    SeekDirection["BACKWARD"] = "backward";
})(SeekDirection || (SeekDirection = {}));
const ONE_SECOND_IN_MILLIS = 1000;
const TICK_INTERVAL_DEFAULT = 100;
var AudioPlayerControlClicked;
(function (AudioPlayerControlClicked) {
    AudioPlayerControlClicked[AudioPlayerControlClicked["CHAPTER_CLICKED"] = 0] = "CHAPTER_CLICKED";
    AudioPlayerControlClicked[AudioPlayerControlClicked["VISUALIZER_CLICKED"] = 1] = "VISUALIZER_CLICKED";
    AudioPlayerControlClicked[AudioPlayerControlClicked["SEEK_BAR_CHANGED"] = 2] = "SEEK_BAR_CHANGED";
    AudioPlayerControlClicked[AudioPlayerControlClicked["VOLUME_CONTROL_CHANGED"] = 3] = "VOLUME_CONTROL_CHANGED";
    AudioPlayerControlClicked[AudioPlayerControlClicked["PLAYBACK_RATE_CONTROL_CHANGED"] = 4] = "PLAYBACK_RATE_CONTROL_CHANGED";
    AudioPlayerControlClicked[AudioPlayerControlClicked["PLAY_CLICKED"] = 5] = "PLAY_CLICKED";
    AudioPlayerControlClicked[AudioPlayerControlClicked["TRANSCRIPT_CLICKED"] = 6] = "TRANSCRIPT_CLICKED";
})(AudioPlayerControlClicked || (AudioPlayerControlClicked = {}));
/**
 * @element agentx-wc-audio-player
 */
let AudioPlayer = class AudioPlayer extends lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement {
    constructor() {
        super(...arguments);
        this.customerChapters = [];
        this.consultChapters = [];
        this.interactionDetailInfo = new Map();
        this.agentName = "";
        this.transcriptAvailable = false;
        this.currentTime = 0;
        this.playPauseIcon = "icon-play_16";
        this.playbackRate = 1;
        this.tickInterval = 100;
        this.isSeeking = false;
        this.transcriptSeekTime = 0;
    }
    static get styles() {
        return _AudioPlayer_scss__WEBPACK_IMPORTED_MODULE_7__["default"];
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.interactionRecordingDetails !== undefined) {
            this.chapterManager = new _player_ChapterManager__WEBPACK_IMPORTED_MODULE_8__.ChapterManager(this.interactionRecordingDetails, this.customerChapters, this.consultChapters);
            this.chapterManager.registerCallback(this);
            this.currentChapter = this.chapterManager.getCustomerChapters()[0];
        }
    }
    getChapterManager() {
        return this.chapterManager;
    }
    dispatchControlClickedEvent(control) {
        this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_6__.QMW_AUDIO_PLAYER_CONTROL_CLICKED, { bubbles: true, composed: true, detail: { control } }));
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.onStop();
    }
    handleChapterClicked(event) {
        const isCustomerTrackType = (0,_utils__WEBPACK_IMPORTED_MODULE_5__.isCustomerTrack)(event.detail[1]);
        const clickedChapter = isCustomerTrackType
            ? this.chapterManager.getCustomerChapters()[event.detail[0]]
            : this.chapterManager.getConsultChapters()[event.detail[0]];
        if (clickedChapter !== this.currentChapter) {
            this.chapterManager.setCustomerWaveformSelected(clickedChapter.getIsCustomerChapter(), clickedChapter.startTimeMillis);
        }
        this.chapterManager.seek(clickedChapter.startTimeMillis);
        this.dispatchControlClickedEvent(AudioPlayerControlClicked.CHAPTER_CLICKED);
    }
    handleTranscriptClicked(event) {
        this.chapterManager.setCustomerWaveformSelected(true, event.detail.milliseconds);
        this.chapterManager.seek(event.detail.milliseconds);
        this.dispatchControlClickedEvent(AudioPlayerControlClicked.TRANSCRIPT_CLICKED);
    }
    handleVisualizerClicked(event) {
        this.chapterManager.setCustomerWaveformSelected(event.detail, this.currentTime);
        this.dispatchControlClickedEvent(AudioPlayerControlClicked.VISUALIZER_CLICKED);
    }
    handleSeekBarChanged(event) {
        this.chapterManager.seek(event.detail.newValue * ONE_SECOND_IN_MILLIS);
        this.dispatchControlClickedEvent(AudioPlayerControlClicked.SEEK_BAR_CHANGED);
    }
    handleVolumeControlChanged(event) {
        this.handleVolumeChanged(event.detail);
        this.dispatchControlClickedEvent(AudioPlayerControlClicked.VOLUME_CONTROL_CHANGED);
    }
    handlePlaybackRateControlChanged(event) {
        this.handlePlaybackRateChanged(event.detail);
        this.dispatchControlClickedEvent(AudioPlayerControlClicked.PLAYBACK_RATE_CONTROL_CHANGED);
    }
    handlePlayClicked() {
        const audioPlayers = this.getAudioPlayers();
        if (audioPlayers.length === 0) {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.warn("[App:QMW] No audio players available to play.");
            return;
        }
        if (this.chapterManager.isRunning()) {
            this.chapterManager.stop();
        }
        else {
            this.chapterManager.start();
        }
        this.dispatchControlClickedEvent(AudioPlayerControlClicked.PLAY_CLICKED);
    }
    getAudioPlayers() {
        var _a, _b;
        return (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll("audio")) !== null && _b !== void 0 ? _b : [];
    }
    handlePlaybackRateChanged(speed) {
        this.playbackRate = speed;
        this.chapterManager.setPlaybackRate(speed);
        const audioPlayers = this.getAudioPlayers();
        audioPlayers.forEach((audioPlayer) => {
            audioPlayer.playbackRate = this.playbackRate;
        });
        this.tickInterval = TICK_INTERVAL_DEFAULT * this.playbackRate;
    }
    handleVolumeChanged(volume) {
        const audioPlayers = this.getAudioPlayers();
        audioPlayers.forEach((audioPlayer) => {
            audioPlayer.volume = volume / 100;
        });
    }
    seekTenSeconds(direction) {
        const tenSecondsInMilliseconds = 10 * ONE_SECOND_IN_MILLIS;
        this.chapterManager.seek(this.chapterManager.getCurrentTime() +
            (direction === SeekDirection.FORWARD ? tenSecondsInMilliseconds : -tenSecondsInMilliseconds));
    }
    getAudioPlayer(url) {
        const audioPlayers = this.getAudioPlayers();
        return Array.from(audioPlayers.values()).find((audioPlayer) => {
            return audioPlayer.id === url;
        });
    }
    playTrack(timeMillis) {
        var _a, _b;
        const targetChapter = this.chapterManager.getChapterByTime(timeMillis);
        const currentAudioPlayer = this.getCurrentlyPlayingAudioPlayer();
        const audioPlayer = this.getAudioPlayer((_a = targetChapter === null || targetChapter === void 0 ? void 0 : targetChapter.getDownloadUrl()) !== null && _a !== void 0 ? _a : "");
        if (audioPlayer && ((currentAudioPlayer === null || currentAudioPlayer === void 0 ? void 0 : currentAudioPlayer.src) !== audioPlayer.src || this.isSeeking)) {
            audioPlayer.currentTime = (timeMillis - ((_b = targetChapter === null || targetChapter === void 0 ? void 0 : targetChapter.getStartTimeInAudioFile()) !== null && _b !== void 0 ? _b : 0)) / ONE_SECOND_IN_MILLIS;
            const playPromise = audioPlayer.play();
            if (playPromise !== undefined) {
                playPromise
                    .then(function () {
                    _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[App:QMW] QMW recording playback started`);
                })
                    .catch(function (error) {
                    _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`[App:QMW] exception while attempting to start playing the audio file ${error}`);
                });
            }
        }
        this.timeoutTimer = setInterval(() => {
            var _a, _b, _c;
            const mostCurrentAudioPlayer = this.getCurrentlyPlayingAudioPlayer();
            if (mostCurrentAudioPlayer === undefined) {
                const targetTime = this.chapterManager.getCurrentTime() + this.tickInterval;
                if (targetTime > ((_b = (_a = this.interactionRecordingDetails) === null || _a === void 0 ? void 0 : _a.endTimeMillis) !== null && _b !== void 0 ? _b : 0)) {
                    this.chapterManager.stop();
                    return;
                }
                this.chapterManager.audioPlayerTick(targetTime);
            }
            else {
                this.chapterManager.audioPlayerTick(mostCurrentAudioPlayer.currentTime * ONE_SECOND_IN_MILLIS + ((_c = targetChapter === null || targetChapter === void 0 ? void 0 : targetChapter.getStartTimeInAudioFile()) !== null && _c !== void 0 ? _c : 0));
            }
        }, this.tickInterval);
    }
    stopAllTracks() {
        if (this.timeoutTimer) {
            clearInterval(this.timeoutTimer);
        }
        const audioPlayers = this.getAudioPlayers();
        audioPlayers.forEach((audioPlayer) => {
            audioPlayer.pause();
        });
    }
    getPlayerAndPlay(chapterUrlToPlay = "") {
        const currentAudioPlayer = this.getCurrentlyPlayingAudioPlayer();
        const nextAudioPlayer = this.getAudioPlayer(chapterUrlToPlay);
        if (currentAudioPlayer !== undefined && currentAudioPlayer !== nextAudioPlayer) {
            this.stopAllTracks();
        }
        else if (this.timeoutTimer) {
            clearInterval(this.timeoutTimer);
        }
        this.playTrack(this.chapterManager.getCurrentTime());
    }
    getCurrentlyPlayingAudioPlayer() {
        const audioPlayers = this.getAudioPlayers();
        return Array.from(audioPlayers.values()).find((audioPlayer) => {
            return !audioPlayer.paused;
        });
    }
    // implement IChapterManagerCallback::onChapterChanged
    onChapterChanged(chapter) {
        var _a;
        this.currentChapter = chapter;
        if (!chapter) {
            this.stopAllTracks();
        }
        if (!this.chapterManager.isRunning()) {
            return;
        }
        this.getPlayerAndPlay((_a = chapter === null || chapter === void 0 ? void 0 : chapter.getDownloadUrl()) !== null && _a !== void 0 ? _a : "");
    }
    // implement IChapterManagerCallback::onTick
    onTick(time) {
        this.currentTime = time;
    }
    // implement IChapterManagerCallback::onSeek
    onSeek(time) {
        this.currentTime = time;
        this.transcriptSeekTime = time;
        if (!this.chapterManager.isRunning()) {
            return;
        }
        const chapterToPlay = this.chapterManager.getChapterByTime(time);
        this.isSeeking = true;
        this.getPlayerAndPlay(chapterToPlay === null || chapterToPlay === void 0 ? void 0 : chapterToPlay.getDownloadUrl());
        this.isSeeking = false;
    }
    // implement IChapterManagerCallback::onStart
    onStart(time) {
        this.playPauseIcon = "icon-pause_16";
        this.playTrack(time);
    }
    // implement IChapterManagerCallback::onStop
    onStop() {
        this.playPauseIcon = "icon-play_16";
        this.stopAllTracks();
    }
    displayMinimalView() {
        return this.chapterManager.getCustomerChapters().length <= 1;
    }
    displayLargerTranscriptView() {
        return this.chapterManager.getConsultChapters().length === 0 && !this.displayMinimalView();
    }
    getAudioPlayerComponent() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
      <div class="player-container">
        <agentx-wc-visualizer-view
          ?hidden=${this.displayMinimalView()}
          .customerChapters=${this.chapterManager.getCustomerChapters()}
          .consultChapters=${this.chapterManager.getConsultChapters()}
          .currentChapter=${this.currentChapter}
          .mainChapterLength=${(_b = (_a = this.interactionRecordingDetails) === null || _a === void 0 ? void 0 : _a.getDuration()) !== null && _b !== void 0 ? _b : 0}
          @visualizer-clicked=${this.handleVisualizerClicked}
        ></agentx-wc-visualizer-view>

        <div
          class="controls-seekbar-container ${this.chapterManager.getConsultChapters().length > 0
            ? "consult-chapters"
            : "no-consult-chapters"}"
        >
          <md-slider
            @slider-changing=${this.handleSeekBarChanged}
            aria-Label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.seekBar")}
            hide-value="false"
            now=${this.currentTime / ONE_SECOND_IN_MILLIS}
            max=${((_d = (_c = this.interactionRecordingDetails) === null || _c === void 0 ? void 0 : _c.getDuration()) !== null && _d !== void 0 ? _d : 0) / ONE_SECOND_IN_MILLIS}
            .step="0.1"
          ></md-slider>

          <div class="controls-row">
            <div class="chapter-manager">
              ${this.chapterManager
            .getAudioUrls()
            .map((url) => (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) ` <audio src=${url} preload="metadata" id=${url} controls></audio> `)}
            </div>

            <div class="player-controls">
              <md-tooltip
                message="${this.chapterManager.isRunning() ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioPauseBtn") : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioPlayBtn")}"
                placement="top-end"
              >
                <md-button
                  variant="ghost"
                  circle
                  id="playerPlayButton"
                  aria-Label="${this.chapterManager.isRunning()
            ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioPauseBtn")
            : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioPlayBtn")}"
                  size=${_constants__WEBPACK_IMPORTED_MODULE_6__.QMW_RECORDINGS_PLAYER_BUTTON_SIZE}
                  @click=${this.handlePlayClicked}
                >
                  <md-icon slot="icon" name="${this.playPauseIcon}"></md-icon>
                </md-button>
              </md-tooltip>
              <agentx-wc-audio-player-time
                .currentTime=${this.currentTime}
                .mainChapterLength=${(_f = (_e = this.interactionRecordingDetails) === null || _e === void 0 ? void 0 : _e.getDuration()) !== null && _f !== void 0 ? _f : 0}
              ></agentx-wc-audio-player-time>
              <div class="skip-time-container">
                <md-tooltip message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.rewind10")}" placement="top">
                  <md-button
                    variant="ghost"
                    circle
                    id="playerRewind10SecondsButton"
                    aria-Label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.rewindTenSeconds")}
                    size=${_constants__WEBPACK_IMPORTED_MODULE_6__.QMW_RECORDINGS_PLAYER_BUTTON_SIZE}
                    .disabled=${this.currentTime <= 0}
                    @click=${(event) => {
            this.currentTime <= 0 ? event.preventDefault() : this.seekTenSeconds(SeekDirection.BACKWARD);
        }}
                  >
                    <md-icon name="rewind-ten-sec-bold" class="icon" size="20" iconSet="momentumDesign"></md-icon>
                  </md-button>
                </md-tooltip>
                <md-tooltip message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.fastForward10")}" placement="top">
                  <md-button
                    variant="ghost"
                    circle
                    id="playerForward10SecondsButton"
                    aria-Label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.fastForward10")}
                    size=${_constants__WEBPACK_IMPORTED_MODULE_6__.QMW_RECORDINGS_PLAYER_BUTTON_SIZE}
                    .disabled=${this.currentTime >= ((_h = (_g = this.interactionRecordingDetails) === null || _g === void 0 ? void 0 : _g.getDuration()) !== null && _h !== void 0 ? _h : 0)}
                    @click=${(event) => {
            var _a, _b;
            this.currentTime >= ((_b = (_a = this.interactionRecordingDetails) === null || _a === void 0 ? void 0 : _a.getDuration()) !== null && _b !== void 0 ? _b : 0)
                ? event.preventDefault()
                : this.seekTenSeconds(SeekDirection.FORWARD);
        }}
                  >
                    <md-icon name="forward-ten-sec-bold" class="icon" size="20" iconSet="momentumDesign"></md-icon>
                  </md-button>
                </md-tooltip>
              </div>
              <agentx-wc-audio-player-playback-rate-control
                @playback-rate-changed=${this.handlePlaybackRateControlChanged}
                .playbackRate=${this.playbackRate}
              >
              </agentx-wc-audio-player-playback-rate-control>
              <div class="skip-chapter-container" ?hidden=${this.displayMinimalView()}>
                <md-tooltip message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.previousChapter")}" placement="top">
                  <md-button
                    variant="ghost"
                    circle
                    id="playerPreviousChapterButton"
                    aria-Label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.previousChapter")}
                    size=${_constants__WEBPACK_IMPORTED_MODULE_6__.QMW_RECORDINGS_PLAYER_BUTTON_SIZE}
                    .disabled=${!this.chapterManager.isPreviousChapterAvailable()}
                    @click=${() => {
            if (this.chapterManager.isPreviousChapterAvailable()) {
                this.chapterManager.seekToPreviousChapter();
            }
        }}
                  >
                    <md-icon name="arrow-left-bold" class="icon" size="20" iconSet="momentumDesign"></md-icon>
                  </md-button>
                </md-tooltip>
                <md-tooltip message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.nextChapter")}" placement="top">
                  <md-button
                    variant="ghost"
                    circle
                    id="playerNextChapterButton"
                    aria-Label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.nextChapter")}
                    size=${_constants__WEBPACK_IMPORTED_MODULE_6__.QMW_RECORDINGS_PLAYER_BUTTON_SIZE}
                    .disabled=${this.chapterManager.getNextChapter() === undefined}
                    @click=${() => {
            if (this.chapterManager.getNextChapter() !== undefined) {
                this.chapterManager.seekToNextChapter();
            }
        }}
                  >
                    <md-icon name="arrow-right-bold" class="icon" size="20" iconSet="momentumDesign"></md-icon>
                  </md-button>
                </md-tooltip>
              </div>
              <agentx-wc-audio-player-volume-control @volume-changed=${this.handleVolumeControlChanged}>
              </agentx-wc-audio-player-volume-control>
            </div>
          </div>
        </div>
      </div>
    `;
    }
    getChapterListComponent() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
      <agentx-wc-chapters-list
        .customerChapters=${this.chapterManager.getCustomerChapters()}
        .consultChapters=${this.chapterManager.getConsultChapters()}
        .currentChapter=${this.currentChapter}
        .mainChapter=${this.chapterManager.getInteractionRecordingDetails()}
        .agentName=${this.agentName}
        .transcriptAvailable=${this.transcriptAvailable}
        @chapter-clicked=${this.handleChapterClicked}
      ></agentx-wc-chapters-list>
    `;
    }
    getTranscriptComponent() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `<agentx-wc-transcript-view
      .customerTranscript=${this.customerTranscript}
      @transcript-clicked=${this.handleTranscriptClicked}
      .playbackTime=${this.currentTime}
      .seekTime=${this.transcriptSeekTime}
    ></agentx-wc-transcript-view>`;
    }
    getInteractionDetailsComponent() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
      <agentx-wc-interaction-details
        .interactionDetailInfo=${this.interactionDetailInfo}
      ></agentx-wc-interaction-details>
    `;
    }
    render() {
        if (!this.interactionRecordingDetails) {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[App:QMW] Interaction record details not defined, cannot initialize chapters");
        }
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) ` ${this.interactionRecordingDetails
            ? (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
          <div class="audio-player-transcript-container">
            ${this.getAudioPlayerComponent()}
            ${this.transcriptAvailable
                ? (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
                  <div class="audio-player-tabs-view-container">
                    <md-tabs>
                      ${this.displayMinimalView()
                    ? lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing
                    : (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
                            <md-tab slot="tab" aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.chapters")}>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.chapters")}</md-tab>
                            <md-tab-panel class="panel-view" slot="panel">
                              ${this.getChapterListComponent()}
                            </md-tab-panel>
                          `}
                      <md-tab slot="tab" aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.transcript")}>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.transcript")}</md-tab>
                      <md-tab-panel
                        class="audio-player-transcript-view ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__.classMap)({
                    "no-chapters": this.displayMinimalView(),
                    "chapters-no-consults": this.displayLargerTranscriptView()
                })}"
                        slot="panel"
                      >
                        ${this.getTranscriptComponent()}
                      </md-tab-panel>
                      <md-tab slot="tab" aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.interactionDetailsHeader")}
                        >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.interactionDetailsHeader")}</md-tab
                      >
                      <md-tab-panel
                        slot="panel"
                        class="audio-player-interactions-view ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__.classMap)({ "no-chapters": this.displayMinimalView() })}"
                      >
                        ${this.getInteractionDetailsComponent()}
                      </md-tab-panel>
                    </md-tabs>
                  </div>
                `
                : (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
                  <div class="row">
                    <div class="column" ?hidden=${this.displayMinimalView()}>${this.getChapterListComponent()}</div>
                    <div class="column interaction-details ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__.classMap)({ "with-margin": !this.displayMinimalView() })}">
                      ${this.getInteractionDetailsComponent()}
                    </div>
                  </div>
                `}
          </div>
        `
            : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}`;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
], AudioPlayer.prototype, "interactionRecordingDetails", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Array })
], AudioPlayer.prototype, "customerChapters", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Array })
], AudioPlayer.prototype, "consultChapters", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
], AudioPlayer.prototype, "customerTranscript", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
], AudioPlayer.prototype, "interactionDetailInfo", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
], AudioPlayer.prototype, "agentName", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
], AudioPlayer.prototype, "transcriptAvailable", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], AudioPlayer.prototype, "currentChapter", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], AudioPlayer.prototype, "currentTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], AudioPlayer.prototype, "playPauseIcon", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], AudioPlayer.prototype, "playbackRate", void 0);
AudioPlayer = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-audio-player")
], AudioPlayer);



/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/EmptyGrid.scss":
/*!**************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/EmptyGrid.scss ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --grid-header-height: 60px;
  --visualizer-title-width: 100px;
  --visualizer-title-margin-left: 24px;
  --visualizer-container-max-height: 40px;
  --visualizer-container-max-width: 900px;
  --visualizer-container-gap: 16px;
  --visualizer-bar-max-width: 577px;
  --visualizer-bar-max-height: 4px;
  --player-controls-row-height: 50px;
  --player-controls-gap: 8px;
  --volume-popover-width: 180px;
  --volume-popover-height: 21px;
  --volume-popover-gap: 12px;
  --volume-popover-top-offset: 120%;
  --volume-popover-left-offset: 50%;
  --volume-popover-padding: 12px;
  --seek-bar-height: 8px;
  --seek-bar-thumb-size: 16px;
  --seek-bar-top-margin: 16px;
  --seek-bar-bottom-margin: 8px;
  --popover-arrow-size: 10px;
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  --interaction-details-height: 220px;
  --interaction-details-vertical-padding: 12px;
  --interaction-details-optional-horizontal-margin: 24px;
  --interaction-details-item-bottom-margin: 4px;
  --interaction-details-item-grid-template-columns: 150px auto;
  --webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  --chapters-container-height: 292px;
  --chapters-container-height-no-border: 250px;
  --chapters-container-height-hidden-tabs: 350px;
  --chapters-container-height: 292px;
  --chapters-container-height-hidden-tabs-no-border: 300px;
  --chapters-container-padding-right: 18px;
  --chapter-container-padding-top: 5px;
  --chapter-container-padding-bottom: 12px;
  --chapter-time-width: 60px;
  --chapter-title-width: 300px;
  --transcript-height: 285px;
  --transcript-height-no-chapters: 410px;
  --transcript-height-chapters-no-consults: 350px;
}

.agentx-wc-qmw-empty-grid {
  height: calc(100% - (var(--grid-header-height)));
  background-color: var(--md-secondary-bg-color);
}
.agentx-wc-qmw-empty-grid agentx-wc-empty-state-wrapper::part(img) {
  width: 120px;
}
.agentx-wc-qmw-empty-grid-container {
  height: 70%;
}
.agentx-wc-qmw-empty-grid-container-modal {
  height: 100%;
}
.agentx-wc-qmw-empty-grid-message {
  margin: 0;
  text-align: center;
  font-weight: 700;
  font-size: var(--font-size-large);
  color: var(--md-primary-text-color);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/EmptyGrid.ts":
/*!************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/EmptyGrid.ts ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EmptyGrid: () => (/* binding */ EmptyGrid)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Common_EmptyStateWrapper_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Common/EmptyStateWrapper/EmptyStateWrapper */ "./src/components/Common/EmptyStateWrapper/EmptyStateWrapper.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../constants */ "./src/components/QualityMonitoringWidget/constants.ts");
/* harmony import */ var _EmptyGrid_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./EmptyGrid.scss */ "./src/components/QualityMonitoringWidget/components/EmptyGrid.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var EmptyGrid;
(function (EmptyGrid) {
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this.emptyElement = "";
        }
        static get styles() {
            return _EmptyGrid_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
        }
        getMessageText() {
            if (this.emptyElement === _constants__WEBPACK_IMPORTED_MODULE_3__.RECORDING) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ` <p role="alert" class="agentx-wc-qmw-empty-grid-message">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.noRecording")}</p> `;
            }
            else {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
          <p role="alert" class="agentx-wc-qmw-empty-grid-message">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.noData")}</p>
          <p role="alert" class="agentx-wc-qmw-empty-grid-message">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.useFilterBtn")}</p>
        `;
            }
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <section class="agentx-wc-qmw-empty-grid">
        <div class=${this.emptyElement !== _constants__WEBPACK_IMPORTED_MODULE_3__.RECORDING
                ? "agentx-wc-qmw-empty-grid-container"
                : "agentx-wc-qmw-empty-grid-container-modal"}>
          <agentx-wc-empty-state-wrapper illustration-type="empty-state">
          ${this.getMessageText()}
          </agentx-wc-empty-state-wrapper>
        <div>
        </section>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "emptyElement", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-qmw-empty-grid")
    ], Element);
    EmptyGrid.Element = Element;
})(EmptyGrid || (EmptyGrid = {}));


/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/GridError.scss":
/*!**************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/GridError.scss ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.grid-height {
  height: calc(100% - (var(--grid-header-height)));
}
.grid-height .agentx-wc-qmw-error-content {
  height: 70%;
}

.agentx-wc-qmw-error-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.agentx-wc-qmw-error-icon {
  height: 60px;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--badge-red-bg-color);
  border-radius: var(--border-radius-circle);
}
.agentx-wc-qmw-error-heading {
  font-weight: 700;
  font-size: var(--font-size-large);
  color: var(--md-primary-text-color);
}
.agentx-wc-qmw-error-toggle {
  font-weight: 400;
  margin-top: 16px;
  color: var(--md-primary-text-color);
}
.agentx-wc-qmw-error-toggle-text {
  text-decoration: underline;
}
.agentx-wc-qmw-error-detail {
  font-size: var(--font-size-small);
  text-align: center;
  width: 400px;
  color: var(--md-primary-text-color);
}
.agentx-wc-qmw-error-tracking-id-wrapper {
  display: flex;
  align-items: center;
}
.agentx-wc-qmw-error-tracking-id-wrapper p {
  font-size: var(--font-size-small);
  color: var(--md-primary-text-color);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/GridError.ts":
/*!************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/GridError.ts ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   GridError: () => (/* binding */ GridError)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../constants */ "./src/components/QualityMonitoringWidget/constants.ts");
/* harmony import */ var _GridError_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./GridError.scss */ "./src/components/QualityMonitoringWidget/components/GridError.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var GridError;
(function (GridError) {
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.trackingID = "";
            this.errorElement = _constants__WEBPACK_IMPORTED_MODULE_4__.GRID;
            this.shouldKnowMore = false;
            this.isCopied = false;
            this.handleShowMoreBtnClick = () => {
                this.setShouldKnowMore(!this.getShouldKnowMore());
            };
            this.handleCopyClick = () => {
                const clipboard = window.navigator.clipboard;
                clipboard.writeText(this.trackingID);
                this.setIsCopied(true);
                setTimeout(() => {
                    this.setIsCopied(false);
                }, _constants__WEBPACK_IMPORTED_MODULE_4__.COPY_CLICK_TIMEOUT);
            };
            this.handleRetryBtnClick = () => {
                this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_4__.QMW_ERR_RETRY, {
                    bubbles: true,
                    composed: true,
                    detail: true
                }));
            };
        }
        static get styles() {
            return _GridError_scss__WEBPACK_IMPORTED_MODULE_5__["default"];
        }
        getIsCopied() {
            return this.isCopied;
        }
        setIsCopied(isCopied) {
            this.isCopied = isCopied;
        }
        getShouldKnowMore() {
            return this.shouldKnowMore;
        }
        setShouldKnowMore(shouldKnowMore) {
            this.shouldKnowMore = shouldKnowMore;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <section class=${this.errorElement !== _constants__WEBPACK_IMPORTED_MODULE_4__.RECORDING ? "agentx-wc-qmw-error grid-height" : "agentx-wc-qmw-error"}>
          <div class="agentx-wc-qmw-error-content">
            <span class=${"agentx-wc-qmw-error-icon"}>
              <md-icon .name=${"icon-warning_32"} .color=${"var(--md-alert-error-text-color)"}></md-icon>
            </span>
            <h1 class="agentx-wc-qmw-error-heading">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:commonWebComp.loadFail")}</h1>
            <md-button
              @click=${this.handleRetryBtnClick}
              variant="primary"
              .ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:commonWebComp.tryAgain")}
              >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:commonWebComp.tryAgain")}</md-button
            >

            ${this.trackingID
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
            <md-button @click=${this.handleShowMoreBtnClick} .color=${"color-none"} class=${"agentx-wc-qmw-error-toggle"}
            .ariaLabel= ${!this.shouldKnowMore ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorDetail.errorMoreButton") : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorDetail.errorLessButton")}>
              <span class=${"agentx-wc-qmw-error-toggle-text"}>
              ${!this.shouldKnowMore ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorDetail.errorMoreButton") : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorDetail.errorLessButton")}
              <span>
            </md-button>
            `
                : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
            ${this.trackingID && this.shouldKnowMore
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
                  <div>
                    <p class="agentx-wc-qmw-error-detail">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.pleaseShare")}</p>
                    <div class="agentx-wc-qmw-error-tracking-id-wrapper">
                      <p>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorModal.trackingIdLabel")}: ${this.trackingID}</p>
                      <md-button
                        @click=${this.handleCopyClick}
                        .color=${"color-none"}
                        .ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorModal.copy")}
                      >
                        <md-icon .name=${!this.isCopied ? "copy_14" : "icon-check_12"}></md-icon>
                      </md-button>
                    </div>
                  </div>
                `
                : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
          </div>
        </section>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "trackingID", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "errorElement", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "shouldKnowMore", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "isCopied", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-qmw-grid-error")
    ], Element);
    GridError.Element = Element;
})(GridError || (GridError = {}));


/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/GridHeader.scss":
/*!***************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/GridHeader.scss ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.grid-header-container {
  padding: 1rem 1rem 0;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.grid-header-action-container {
  display: flex;
  margin-bottom: 1rem;
}

.filter-panel {
  display: block;
}

.filters-menu-header-wrapper {
  justify-content: flex-start;
  padding: 0.75rem 1.25rem;
  border-bottom: 1px solid var(--md-primary-seperator-color);
  color: var(--md-primary-text-color);
}

.date-range-container {
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  color: var(--md-primary-text-color);
}
.date-range-container div {
  display: flex;
}
.date-range-container span {
  padding-right: 0.25rem;
}
.date-range-container .date-time-wrapper {
  display: flex;
}
.date-range-container .date-time-container {
  display: block;
}
.date-range-container .date-time-container:first-child {
  padding-right: 1rem;
}
.date-range-container .date-range-label md-tooltip {
  display: flex;
  align-items: center;
}
.date-range-container .date-info-icon {
  display: flex;
}

.filters-footer-container {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 1.25rem 0;
  border-top: 1px solid var(--md-primary-seperator-color);
  display: flex;
  justify-content: flex-end;
}
.filters-footer-container .panel-button:last-child {
  padding-left: 1rem;
  padding-right: 1.25rem;
}

.custom-menu-overlay.overlay-container {
  border-radius: var(--border-radius-medium);
  box-shadow: var(--box-shadow-gray);
  box-sizing: border-box;
  display: block;
  position: absolute;
  z-index: 999;
  right: 0;
  height: calc(80% - var(--grid-header-height));
}
.custom-menu-overlay.overlay-container .overlay-content {
  background-color: var(--md-secondary-white-bg-color);
  border: 1px solid var(--md-menu-overlay-border-color, --gray-20);
  border-radius: var(--border-radius-medium);
  max-width: calc(100vw - var(--vw-padding) * 2);
  overflow-y: auto;
  height: 100%;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/GridHeader.ts":
/*!*************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/GridHeader.ts ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QualityMonitoringGridHeader: () => (/* binding */ QualityMonitoringGridHeader)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../constants */ "./src/components/QualityMonitoringWidget/constants.ts");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../utils */ "./src/components/QualityMonitoringWidget/utils.ts");
/* harmony import */ var _GridHeader_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./GridHeader.scss */ "./src/components/QualityMonitoringWidget/components/GridHeader.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var QualityMonitoringGridHeader;
(function (QualityMonitoringGridHeader) {
    /**
     * @element agentx-wc-qmw-filter-header
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this.startDate = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.local().minus({ days: 1 }).toMillis();
            this.endDate = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.local().minus({ seconds: 1 }).toMillis();
            this.activeFilters = [
                {
                    filterName: "date-filter",
                    displayIcon: "calendar-month-bold",
                    displayText: "",
                    tooltipTranslateLink: "app:qmw:dateRangeFilterTooltip"
                }
            ];
            this.filterPanelShow = false;
            this.startDatePickerValue = "";
            this.endDatePickerValue = "";
            this.maxStartDate = "";
            this.maxEndDate = "";
            this.minStartDate = "";
            this.minEndDate = "";
            this.boundHandleKeyDown = {};
            this.isFormInvalid = false;
            this.handleOutsideFilterPanelClick = (event) => {
                const path = event.composedPath();
                if (path.length) {
                    const insideSelfClick = !!path.find((element) => element.id === "qmw-filter-panel");
                    const btnClick = !!path.find((element) => element.id === "toggle-filter-button");
                    if (!btnClick && !insideSelfClick && this.filterPanelShow) {
                        this.toggleFilterPanel();
                    }
                }
            };
            this.handleKeyDown = (event) => {
                if (this.filterPanelShow && event.code === "Escape") {
                    this.toggleFilterPanel();
                }
            };
        }
        static get styles() {
            return _GridHeader_scss__WEBPACK_IMPORTED_MODULE_6__["default"];
        }
        connectedCallback() {
            super.connectedCallback();
            this.setInitialDatePickerBounds();
            this.boundHandleKeyDown = this.handleKeyDown;
            document.addEventListener("keydown", this.boundHandleKeyDown);
            document.addEventListener("click", this.handleOutsideFilterPanelClick);
        }
        firstUpdated(changedProperties) {
            super.firstUpdated(changedProperties);
            this.updateDateFilterPillText();
            this.updateDatePickerValues();
        }
        update(changedProperties) {
            super.update(changedProperties);
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            document.removeEventListener("keydown", this.boundHandleKeyDown);
            document.removeEventListener("click", this.handleOutsideFilterPanelClick);
        }
        dateTimePickerBoundsFormat(date) {
            return luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(date).toISODate() || "";
        }
        updateDateFilterPillText() {
            const dateFilterIndex = this.activeFilters.map((filter) => filter.filterName).indexOf("date-filter");
            this.activeFilters[dateFilterIndex].displayText = `${(0,_utils__WEBPACK_IMPORTED_MODULE_5__.dateFormatterShortWithSeconds)(this.startDate)} - ${(0,_utils__WEBPACK_IMPORTED_MODULE_5__.dateFormatterShortWithSeconds)(this.endDate)}`;
        }
        updateDatePickerValues() {
            this.startDatePickerValue =
                luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(this.startDate).startOf("second").toISO({ suppressMilliseconds: true }) || "";
            this.endDatePickerValue =
                luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(this.endDate).startOf("second").toISO({ suppressMilliseconds: true }) || "";
        }
        toggleFilterPanel() {
            this.filterPanelShow = !this.filterPanelShow;
            const defaultStartDate = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.local().minus({ days: 1 }).toMillis();
            const defaultEndDate = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.local().minus({ days: 1 }).toMillis();
            // If a user wants to pick a new date range they shouldn't be restricted
            // within a month of the previous range
            if (this.filterPanelShow) {
                this.isFormInvalid = false;
                if (this.startDate !== defaultStartDate || this.endDate !== defaultEndDate) {
                    // If a previously applied filter is used, make sure its valid
                    // This will not cause an error state in the component because it is immediately followed
                    // by setting the 13 month bounds. Filter clearing and an error message for the user
                    // would make this better in the future
                    this.setDatePickerBounds("start", this.startDate);
                    this.setDatePickerBounds("end", this.endDate);
                }
                this.setInitialDatePickerBounds();
            }
            else {
                // If a user changed the dates but didn't apply them before closing,
                // reset dates to last applied
                this.startDate = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromISO(this.startDatePickerValue).toMillis();
                this.endDate = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromISO(this.endDatePickerValue).toMillis();
            }
        }
        handleApplyButton() {
            this.updateDateFilterPillText();
            this.updateDatePickerValues();
            this.toggleFilterPanel();
            this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_4__.QMW_FILTERS_UPDATED, {
                bubbles: true,
                composed: true,
                detail: {
                    startTime: this.startDate,
                    endTime: this.endDate
                }
            }));
        }
        setInitialDatePickerBounds() {
            const minDateObject = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.local().minus({ months: 13 }).toMillis();
            this.minEndDate = this.dateTimePickerBoundsFormat(minDateObject);
            this.minStartDate = this.minEndDate;
            this.maxStartDate = this.dateTimePickerBoundsFormat(luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.local().toMillis());
            this.maxEndDate = this.dateTimePickerBoundsFormat(luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.local().toMillis());
        }
        setDatePickerBounds(datePicked, newDate) {
            if (datePicked === "start") {
                const today = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.local().endOf("day").toMillis();
                // check if 31 days after new start date is after today
                const monthAfterStart = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(newDate).plus({ days: 30 }).endOf("day").toMillis();
                this.maxEndDate =
                    today < monthAfterStart
                        ? this.dateTimePickerBoundsFormat(today)
                        : this.dateTimePickerBoundsFormat(monthAfterStart);
                // set minimum end date to day after new start date
                this.minEndDate = this.dateTimePickerBoundsFormat(luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(newDate).plus({ minutes: 1 }).startOf("day").toMillis());
            }
            else if (datePicked === "end") {
                const minDate = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.local().minus({ months: 13 }).startOf("day").toMillis();
                // check if 31 days before new end date is before 13 months ago
                const monthBeforeEnd = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(newDate).minus({ days: 30 }).startOf("day").toMillis();
                this.minStartDate =
                    minDate > monthBeforeEnd
                        ? this.dateTimePickerBoundsFormat(minDate)
                        : this.dateTimePickerBoundsFormat(monthBeforeEnd);
                // set maximum start date to day before new end date
                this.maxStartDate = this.dateTimePickerBoundsFormat(luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(newDate).minus({ minutes: 1 }).endOf("day").toMillis());
            }
            this.dateValidator(this.startDate, this.endDate);
        }
        dateValidator(startDate, endDate) {
            const minStartDate = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromISO(this.minStartDate).startOf("day").toMillis();
            const maxStartDate = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromISO(this.maxStartDate).endOf("day").toMillis();
            const minEndDate = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromISO(this.minEndDate).startOf("day").toMillis();
            const maxEndDate = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromISO(this.maxEndDate).endOf("day").toMillis();
            this.isFormInvalid =
                startDate >= endDate ||
                    !(minStartDate <= startDate && startDate <= maxStartDate) ||
                    !(minEndDate <= endDate && endDate <= maxEndDate);
            return this.isFormInvalid;
        }
        handleStartDate(e) {
            var _a;
            this.startDate = (_a = e.detail) === null || _a === void 0 ? void 0 : _a.dateTime.toMillis();
            this.setDatePickerBounds("start", this.startDate);
        }
        handleEndDate(e) {
            var _a;
            this.endDate = (_a = e.detail) === null || _a === void 0 ? void 0 : _a.dateTime.toMillis();
            this.setDatePickerBounds("end", this.endDate);
        }
        renderActiveFilters() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="active-filter-container">
          ${this.activeFilters.map((filter) => {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
              <md-tooltip placement="bottom" message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(filter.tooltipTranslateLink)}">
                <md-badge color="grey" id="${filter.filterName}">
                  <md-icon name="${filter.displayIcon}" iconSet="momentumDesign" size="16"></md-icon>
                  ${filter.displayText}
                </md-badge>
              </md-tooltip>
            `;
            })}
        </div>
      `;
        }
        renderFilterPanel() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div id="qmw-filter-panel" class="filters-panel custom-menu-overlay overlay-container" role="dialog">
          <div class="filters-panel-container overlay-content" part="overlay-content">
            <div class="filters-menu-header-wrapper">
              <span>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.filters")}</span>
            </div>
            <div class="date-range-container">
              <div class="date-range-label">
                <span>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.dateRange")}</span>
                <md-tooltip placement="bottom" message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw:dateRangeLabelTooltip")}">
                  <md-icon class="date-info-icon" name="info-badge-filled" size="16" iconSet="momentumDesign"></md-icon>
                </md-tooltip>
              </div>
              <div class="date-time-wrapper">
                <div class="date-time-container">
                  <label>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.startDate")}</label>
                  <md-date-time-picker
                    id="start-date"
                    maxDate=${this.maxStartDate}
                    minDate=${this.minStartDate}
                    value=${this.startDatePickerValue}
                    @date-time-change=${this.handleStartDate}
                  ></md-date-time-picker>
                </div>
                <div class="date-time-container">
                  <label>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.endDate")}</label>
                  <md-date-time-picker
                    id="end-date"
                    maxDate=${this.maxEndDate}
                    minDate=${this.minEndDate}
                    value=${this.endDatePickerValue}
                    @date-time-change=${this.handleEndDate}
                  ></md-date-time-picker>
                </div>
              </div>
            </div>
            <div class="filters-footer-container">
              <md-button class="panel-button" variant="secondary" @button-click=${this.toggleFilterPanel}
                >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.close")}</md-button
              >
              <md-button
                class="panel-button"
                variant="primary"
                ?disabled=${this.isFormInvalid}
                @button-click=${this.handleApplyButton}
                >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.apply")}</md-button
              >
            </div>
          </div>
        </div>
      `;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="grid-header-container">
          ${this.renderActiveFilters()}
          <div class="grid-header-action-container">
            <md-button
              slot="menu-trigger"
              class="filter-button"
              variant="secondary"
              size="32"
              id="toggle-filter-button"
              @click=${() => this.toggleFilterPanel()}
            >
              <md-icon slot="icon" name="filter-bold" size="16" iconSet="momentumDesign"></md-icon>
              <span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.filters")}</span>
            </md-button>
          </div>
        </div>
        ${this.filterPanelShow ? this.renderFilterPanel() : lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
    ], Element.prototype, "startDate", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
    ], Element.prototype, "endDate", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "activeFilters", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "filterPanelShow", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "startDatePickerValue", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "endDatePickerValue", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "maxStartDate", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "maxEndDate", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "minStartDate", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "minEndDate", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "boundHandleKeyDown", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "isFormInvalid", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-qmw-filter-header")
    ], Element);
    QualityMonitoringGridHeader.Element = Element;
})(QualityMonitoringGridHeader || (QualityMonitoringGridHeader = {}));


/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/Recording.scss":
/*!**************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/Recording.scss ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

.agentx-wc-qmw-recording-modal-properties-container {
  margin-bottom: 24px;
  margin-top: 0;
}
.agentx-wc-qmw-recording-modal-properties, .agentx-wc-qmw-recording-modal-consult-info {
  display: grid;
  grid-template-columns: 80px auto;
  margin: 10px 0;
  margin-top: 0;
}
.agentx-wc-qmw-recording-modal-properties dt, .agentx-wc-qmw-recording-modal-consult-info dt {
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
}
.agentx-wc-qmw-recording-modal-playback-error-text {
  line-height: 125%;
  text-align: left;
  margin: 0;
}
.agentx-wc-qmw-recording-modal dd {
  margin-inline-start: 20px;
}
.agentx-wc-qmw-recording-modal #scrollable-content {
  overflow: hidden auto;
  max-height: 440px;
  padding-right: 10px;
  padding-top: 0;
}
.agentx-wc-qmw-recording-modal #scrollable-content::-webkit-scrollbar {
  width: calc(var(--space-token-even) * 4);
}
.agentx-wc-qmw-recording-modal #scrollable-content::-webkit-scrollbar-track {
  background: transparent;
}
.agentx-wc-qmw-recording-modal #scrollable-content::-webkit-scrollbar-thumb {
  background-color: var(--md-gray-20);
  border-radius: var(--border-radius-small);
}
.agentx-wc-qmw-recording-modal #scrollable-content .agentx-wc-qmw-recording-modal-consult-container {
  margin-bottom: 10px;
}
.agentx-wc-qmw-recording-modal #scrollable-content span {
  margin-left: 10px;
}
.agentx-wc-qmw-recording-modal #scrollable-content hr {
  color: var(--md-gray-20);
  opacity: 0.5;
}
.agentx-wc-qmw-recording-modal #scrollable-content #consult-recordings p {
  font-size: 14px;
  font-weight: 600;
}

md-modal::part(modal-body) {
  padding-right: 3px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9hc3NldHMvc3R5bGVzL3ZhcmlhYmxlcy5zY3NzIiwid2VicGFjazovLy4vc3JjL2NvbXBvbmVudHMvUXVhbGl0eU1vbml0b3JpbmdXaWRnZXQvY29tcG9uZW50cy9SZWNvcmRpbmcuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGNBQUE7RUFDQSx1QkFBQTtFQUNBLHdCQUFBO0VBQ0EsdUJBQUE7RUFFQSxtQkFBQTtFQUNBLDJCQUFBO0VBQ0EsdUJBQUE7RUFDQSw0QkFBQTtFQUVBLFlBQUE7RUFDQSwwQkFBQTtFQUVBLGdCQUFBO0VBQ0EsdUJBQUE7RUFDQSxvREFBQTtFQUNBLDJEQUFBO0VBRUEsZ0JBQUE7RUFDQSw4REFBQTtFQUNBOztjQUFBO0VBR0EsaUhBQUE7RUFFQSxXQUFBO0VBQ0EsNEJBQUE7RUFDQSx3QkFBQTtFQUNBLHdCQUFBO0VBQ0Esd0JBQUE7RUFDQSx5QkFBQTtFQUNBLHdCQUFBO0VBQ0EscUJBQUE7RUFDQSw2QkFBQTtFQUNBLHlCQUFBO0VBQ0EsMkJBQUE7RUFDQSxpQ0FBQTtFQUVBLGtCQUFBO0VBQ0EsMEJBQUE7RUFDQSwyQkFBQTtFQUNBLDJCQUFBO0VBQ0EsNEJBQUE7RUFFQSxjQUFBO0VBQ0EsbURBQUE7RUFDQSxtQ0FBQTtFQUNBLGlDQUFBO0VBRUEsZUFBQTtFQUNBLHNCQUFBO0VBQ0EsdUJBQUE7RUFFQSxlQUFBO0VBQ0EsaURBQUE7RUFDQSxnREFBQTtFQUNBLHdCQUFBO0VBQ0EsZ0RBQUE7RUFFQSxvQkFBQTtFQUNBLFlBQUE7RUFDQSxZQUFBO0VBQ0EsY0FBQTtFQUNBLGNBQUE7RUFFQSxzQkFBQTtFQUNBLGVBQUE7RUFDQSxpQkFBQTtFQUNBLGlCQUFBO0VBQ0EsaUJBQUE7QUNWRjs7QUF6REU7RUFDRSxtQkFBQTtFQUNBLGFBQUE7QUE0REo7QUF6REU7RUFFRSxhQUFBO0VBQ0EsZ0NBQUE7RUFDQSxjQUFBO0VBQ0EsYUFBQTtBQTBESjtBQXpESTtFQUNFLGdCQUFBO0VBQ0EsbUJBQUE7RUFDQSxtQkFBQTtBQTJETjtBQXZERTtFQUNFLGlCQUFBO0VBQ0EsZ0JBQUE7RUFDQSxTQUFBO0FBeURKO0FBdERFO0VBQ0UseUJBQUE7QUF3REo7QUFyREU7RUFDRSxxQkFBQTtFQUNBLGlCQUFBO0VBQ0EsbUJBQUE7RUFDQSxjQUFBO0FBdURKO0FBckRJO0VBQ0Usd0NBQUE7QUF1RE47QUFyREk7RUFDRSx1QkFBQTtBQXVETjtBQXJESTtFQUNFLG1DQUFBO0VBQ0EseUNBQUE7QUF1RE47QUFyREk7RUFDRSxtQkFBQTtBQXVETjtBQXJESTtFQUNFLGlCQUFBO0FBdUROO0FBckRJO0VBQ0Usd0JBQUE7RUFDQSxZQUFBO0FBdUROO0FBcERNO0VBQ0UsZUFBQTtFQUNBLGdCQUFBO0FBc0RSOztBQWhEQTtFQUNFLGtCQUFBO0FBbURGIiwic291cmNlc0NvbnRlbnQiOlsiOmhvc3Qge1xuICAvKiBGb250IFNpemUgKi9cbiAgLS1mb250LXNpemUtc21hbGw6IDEycHg7XG4gIC0tZm9udC1zaXplLW1lZGl1bTogMTRweDtcbiAgLS1mb250LXNpemUtbGFyZ2U6IDE2cHg7XG5cbiAgLyogU3BhY2luZyB0b2tlbnMgKi9cbiAgLS1zcGFjZS10b2tlbi1jYXJkaW5hbDogNXB4O1xuICAtLXNwYWNlLXRva2VuLWV2ZW46IDJweDtcbiAgLS1zcGFjZS1lcnJvci1pbnB1dDogNHB4IDhweDtcblxuICAvKiBIZWlnaHRzICovXG4gIC0tZXJyb3ItaW5wdXQtaGVpZ2h0OiAzMnB4O1xuXG4gIC8qIEZvbnQgV2VpZ2h0ICovXG4gIC0tZm9udC13ZWlnaHQtbGl0ZTogMzAwO1xuICAtLWZvbnQtd2VpZ2h0OiB2YXIoLS1icmFuZC1mb250LXdlaWdodC1yZWd1bGFyLCA0MDApO1xuICAtLWZvbnQtd2VpZ2h0LW1lZGl1bTogdmFyKC0tYnJhbmQtZm9udC13ZWlnaHQtcmVndWxhciwgNTAwKTtcblxuICAvKiBGb250IGZhbWlseSAqL1xuICAtLWZvbnQtZmFtaWx5LWJvbGQ6IHZhcigtLWJyYW5kLWZvbnQtYm9sZCwgXCJDaXNjb1NhbnNUVCBCb2xkXCIpO1xuICAtLWZvbnQtZmFtaWx5OlxuICAgIHZhcigtLWJyYW5kLWZvbnQtcmVndWxhciwgXCJDaXNjb1NhbnNUVCBSZWd1bGFyXCIpLCBcIkNpc2NvU2Fuc1RUIFJlZ3VsYXJcIiwgXCJIZWx2ZXRpY2EgTmV1ZVwiLCBIZWx2ZXRpY2EsIEFyaWFsLFxuICAgIHNhbnMtc2VyaWY7XG4gIC0tZm9udC1mYW1pbHktbGlnaHQ6IHZhcigtLWJyYW5kLWZvbnQtbGlnaHQsIFwiQ2lzY29TYW5zVFQgTGlnaHRcIiksIFwiSGVsdmV0aWNhIE5ldWVcIiwgSGVsdmV0aWNhLCBBcmlhbCwgc2Fucy1zZXJpZjtcblxuICAvKiBDb2xvcnMgKi9cbiAgLS1saWdodC1ncmVlbi1jb2xvcjogIzQ0Y2Y1MDtcbiAgLS1jb2xvci1ncmF5LTEwOiAjZWRlZGVkO1xuICAtLWNvbG9yLWdyYXktMzA6ICNkMmQ1ZDY7XG4gIC0tY29sb3ItZ3JheS03MDogIzU0NTQ1NDtcbiAgLS1jb2xvci1ncmF5LTEwMDogIzEyMTIxMjtcbiAgLS1jb2xvci1ibHVlLTcwOiAjMDA1ZTdkO1xuICAtLWNvbG9yLWxpbms6ICMwMGEwZDE7XG4gIC0tY29sb3ItZXJyb3ItZGV0YWlsOiAjNTM1NzU5O1xuICAtLWNvbG9yLWdyYXktYm9yZGVyOiAjY2NjO1xuICAtLWNvbG9yLWVycm9yLXRleHQ6ICNhMTI1MTI7XG4gIC0tY29sb3ItY291bnQtbm90aWZpY2F0aW9uczogI2ZmZjtcblxuICAvKiBCb3JkZXIgcmFkaXVzICovXG4gIC0tYm9yZGVyLXJhZGl1cy1zbWFsbDogNHB4O1xuICAtLWJvcmRlci1yYWRpdXMtbWVkaXVtOiA4cHg7XG4gIC0tYm9yZGVyLXJhZGl1cy1sYXJnZTogMTJweDtcbiAgLS1ib3JkZXItcmFkaXVzLWNpcmNsZTogMTAwJTtcblxuICAvKiBBbmltYXRpb24gKi9cbiAgLS1lYXNlLWluLW91dC1xdWludDogY3ViaWMtYmV6aWVyKDAuODMsIDAsIDAuMTcsIDEpO1xuICAtLWRlZmF1bHQtYW5pbWF0aW9uLWR1cmF0aW9uOiAzMDBtcztcbiAgLS1xdWljay1hbmltYXRpb24tZHVyYXRpb246IDE1MG1zO1xuXG4gIC8qIHNjcm9sbCBiYXIgKi9cbiAgLS1zY3JvbGxiYXItd2lkdGg6IDZweDtcbiAgLS1zY3JvbGxiYXItaGVpZ2h0OiA4cHg7XG5cbiAgLyogQm94IHNoYWRvdyAqL1xuICAtLWJveC1zaGFkb3c6IDAgMCA0cHggMnB4IHJnYmEoMCwgMTYwLCAyMDksIDAuNzUpO1xuICAtLWJveC1zaGFkb3ctZ3JheTogMCA0cHggOHB4IHJnYmEoMCwgMCwgMCwgMC4wOCk7XG4gIC0tdHB3LWZpbHRlci1oZWlnaHQ6IDBweDtcbiAgLS13ZWJraXQtYm94LXNoYWRvdzogMCAwIDFweCByZ2JhKDg0LCA4NCwgODQsIDEpO1xuXG4gIC8qIEdhcCBhbmQgcGFkZGluZyAqL1xuICAtLWdhcC00OiA0cHg7XG4gIC0tZ2FwLTg6IDhweDtcbiAgLS1nYXAtMTA6IDEwcHg7XG4gIC0tZ2FwLTEyOiAxMnB4O1xuXG4gIC8qIFdpZHRocyBhbmQgaGVpZ2h0cyovXG4gIC0tbGVuZ3RoLTQ6IDRweDtcbiAgLS1sZW5ndGgtMjA6IDIwcHg7XG4gIC0tbGVuZ3RoLTI0OiAyNHB4O1xuICAtLWxlbmd0aC0zMjogMzJweDtcbn1cbiIsIkB1c2UgXCJAY3NzL3ZhcmlhYmxlc1wiIGFzICo7XG5cbi5hZ2VudHgtd2MtcW13LXJlY29yZGluZy1tb2RhbCB7XG4gICYtcHJvcGVydGllcy1jb250YWluZXIge1xuICAgIG1hcmdpbi1ib3R0b206IDI0cHg7XG4gICAgbWFyZ2luLXRvcDogMDtcbiAgfVxuXG4gICYtcHJvcGVydGllcyxcbiAgJi1jb25zdWx0LWluZm8ge1xuICAgIGRpc3BsYXk6IGdyaWQ7XG4gICAgZ3JpZC10ZW1wbGF0ZS1jb2x1bW5zOiA4MHB4IGF1dG87XG4gICAgbWFyZ2luOiAxMHB4IDA7XG4gICAgbWFyZ2luLXRvcDogMDtcbiAgICBkdCB7XG4gICAgICBvdmVyZmxvdzogaGlkZGVuO1xuICAgICAgdGV4dC1vdmVyZmxvdzogY2xpcDtcbiAgICAgIHdoaXRlLXNwYWNlOiBub3dyYXA7XG4gICAgfVxuICB9XG5cbiAgJi1wbGF5YmFjay1lcnJvci10ZXh0IHtcbiAgICBsaW5lLWhlaWdodDogMTI1JTtcbiAgICB0ZXh0LWFsaWduOiBsZWZ0O1xuICAgIG1hcmdpbjogMDtcbiAgfVxuXG4gIGRkIHtcbiAgICBtYXJnaW4taW5saW5lLXN0YXJ0OiAyMHB4O1xuICB9XG5cbiAgI3Njcm9sbGFibGUtY29udGVudCB7XG4gICAgb3ZlcmZsb3c6IGhpZGRlbiBhdXRvO1xuICAgIG1heC1oZWlnaHQ6IDQ0MHB4O1xuICAgIHBhZGRpbmctcmlnaHQ6IDEwcHg7XG4gICAgcGFkZGluZy10b3A6IDA7XG5cbiAgICAmOjotd2Via2l0LXNjcm9sbGJhciB7XG4gICAgICB3aWR0aDogY2FsYyh2YXIoLS1zcGFjZS10b2tlbi1ldmVuKSAqIDQpO1xuICAgIH1cbiAgICAmOjotd2Via2l0LXNjcm9sbGJhci10cmFjayB7XG4gICAgICBiYWNrZ3JvdW5kOiB0cmFuc3BhcmVudDtcbiAgICB9XG4gICAgJjo6LXdlYmtpdC1zY3JvbGxiYXItdGh1bWIge1xuICAgICAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tbWQtZ3JheS0yMCk7XG4gICAgICBib3JkZXItcmFkaXVzOiB2YXIoLS1ib3JkZXItcmFkaXVzLXNtYWxsKTtcbiAgICB9XG4gICAgLmFnZW50eC13Yy1xbXctcmVjb3JkaW5nLW1vZGFsLWNvbnN1bHQtY29udGFpbmVyIHtcbiAgICAgIG1hcmdpbi1ib3R0b206IDEwcHg7XG4gICAgfVxuICAgIHNwYW4ge1xuICAgICAgbWFyZ2luLWxlZnQ6IDEwcHg7XG4gICAgfVxuICAgIGhyIHtcbiAgICAgIGNvbG9yOiB2YXIoLS1tZC1ncmF5LTIwKTtcbiAgICAgIG9wYWNpdHk6IDAuNTtcbiAgICB9XG4gICAgI2NvbnN1bHQtcmVjb3JkaW5ncyB7XG4gICAgICBwIHtcbiAgICAgICAgZm9udC1zaXplOiAxNHB4O1xuICAgICAgICBmb250LXdlaWdodDogNjAwO1xuICAgICAgfVxuICAgIH1cbiAgfVxufVxuXG5tZC1tb2RhbDo6cGFydChtb2RhbC1ib2R5KSB7XG4gIHBhZGRpbmctcmlnaHQ6IDNweDtcbn1cbiJdLCJzb3VyY2VSb290IjoiIn0= */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/Recording.ts":
/*!************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/Recording.ts ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   RecordingDetails: () => (/* binding */ RecordingDetails)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! axios */ "axios");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../constants */ "./src/components/QualityMonitoringWidget/constants.ts");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils */ "./src/components/QualityMonitoringWidget/utils.ts");
/* harmony import */ var _AudioPlayer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./AudioPlayer */ "./src/components/QualityMonitoringWidget/components/AudioPlayer.ts");
/* harmony import */ var _Recording_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./Recording.scss */ "./src/components/QualityMonitoringWidget/components/Recording.scss");
/* harmony import */ var _player_Chapter__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./player/Chapter */ "./src/components/QualityMonitoringWidget/components/player/Chapter.ts");
/* harmony import */ var _player_Transcript__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./player/Transcript */ "./src/components/QualityMonitoringWidget/components/player/Transcript.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};













var RecordingLegType;
(function (RecordingLegType) {
    RecordingLegType["Main"] = "main";
    RecordingLegType["Consult"] = "consult";
})(RecordingLegType || (RecordingLegType = {}));
var InteractionDetailType;
(function (InteractionDetailType) {
    InteractionDetailType[InteractionDetailType["SessionId"] = 0] = "SessionId";
    InteractionDetailType[InteractionDetailType["Agent"] = 1] = "Agent";
    InteractionDetailType[InteractionDetailType["StartTime"] = 2] = "StartTime";
    InteractionDetailType[InteractionDetailType["EndTime"] = 3] = "EndTime";
    InteractionDetailType[InteractionDetailType["Ani"] = 4] = "Ani";
    InteractionDetailType[InteractionDetailType["Duration"] = 5] = "Duration";
    InteractionDetailType[InteractionDetailType["Queue"] = 6] = "Queue";
    InteractionDetailType[InteractionDetailType["ConsultedAgents"] = 7] = "ConsultedAgents";
    InteractionDetailType[InteractionDetailType["ConferenceAgents"] = 8] = "ConferenceAgents";
})(InteractionDetailType || (InteractionDetailType = {}));
var RecordingDetails;
(function (RecordingDetails) {
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_4__.LitElement) {
        constructor() {
            super(...arguments);
            this.ani = "";
            this.queue = "";
            this.isModalOpen = false;
            this.showConsultRecordings = false;
            this.showEnhancedRecordings = false;
            this.showTranscript = false;
            this.startTimeFromGrid = 0;
            this.showInModal = true;
            this.seekEvaluationTime = 0;
            this.isLoading = false;
            this.absoluteStartTime = 0;
            this.absoluteStopTime = 0;
            this.consultAudioSources = [];
            this.hasDataFetchError = false;
            this.hasRecordingPlaybackError = false;
            this.trackingID = "";
            this.isEmpty = false;
            this.customerChaptersData = [];
            this.consultChaptersData = [];
            this.interactionDetailInfo = new Map();
            this.captureResults = null;
            this.captureMetaDataResults = null;
            this.audioPlayerControlsClicked = new Map();
            this.transcriptAvailable = false;
            this.hasTranscriptError = false;
            this.transcriptErrorMessage = "";
            this.audioLabels = {
                playBtn: {
                    ariaLabel: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioPlayBtn"),
                    tooltipText: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioPlayBtn")
                },
                pauseBtn: {
                    ariaLabel: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioPauseBtn"),
                    tooltipText: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioPauseBtn")
                },
                duration: {
                    ariaLabel: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioDuration"),
                    tooltipText: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioDuration")
                },
                timeline: {
                    ariaLabel: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioTimeline"),
                    tooltipText: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioTimeline")
                },
                volumeBtn: {
                    ariaLabel: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioVolumeBtn"),
                    tooltipText: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioVolumeBtn")
                },
                volumeSlider: {
                    ariaLabel: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioVolumeSlider"),
                    tooltipText: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioVolumeSlider")
                },
                playbackSpeedBtn: {
                    ariaLabel: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioPlaybackSpeed"),
                    tooltipText: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioPlaybackSpeed")
                }
            };
        }
        static get styles() {
            return _Recording_scss__WEBPACK_IMPORTED_MODULE_9__["default"];
        }
        processRequiredRecordingMediaData() {
            var _a, _b, _c;
            // Validate media data
            if (!this.captureResults) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[App:QMW] Null capture (media) data for session id: ${this.sessionId}`);
                return false;
            }
            const mainRecordingMediaData = (_a = this.captureResults) === null || _a === void 0 ? void 0 : _a.data[0].recording.find((rec) => rec.attributes.callType === RecordingLegType.Main && rec.segment === false);
            if (!mainRecordingMediaData ||
                mainRecordingMediaData.attributes.filePath === "" ||
                mainRecordingMediaData.attributes.stopTime === 0) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[App:QMW] Cannot find valid recording (RecordingLegType.Main, non-segment) in capture results for session id: ${this.sessionId}`);
                return false;
            }
            // Create main Interaction Recording object
            const { startTime, stopTime, filePath } = mainRecordingMediaData.attributes;
            this.absoluteStartTime = startTime;
            this.absoluteStopTime = stopTime;
            this.interactionRecordingData = new _player_Chapter__WEBPACK_IMPORTED_MODULE_10__.Chapter(filePath, 0, Math.abs(stopTime - startTime), [], _utils__WEBPACK_IMPORTED_MODULE_7__.ChapterType.Main);
            // Set interaction details
            this.interactionDetailInfo.set(this.getLocalizedString(InteractionDetailType.SessionId), (_b = this.sessionId) !== null && _b !== void 0 ? _b : "");
            this.interactionDetailInfo.set(this.getLocalizedString(InteractionDetailType.Agent), (_c = this.agentName) !== null && _c !== void 0 ? _c : "");
            this.interactionDetailInfo.set(this.getLocalizedString(InteractionDetailType.StartTime), (0,_utils__WEBPACK_IMPORTED_MODULE_7__.dateFormatterShortWithSeconds)(startTime));
            this.interactionDetailInfo.set(this.getLocalizedString(InteractionDetailType.EndTime), (0,_utils__WEBPACK_IMPORTED_MODULE_7__.dateFormatterShortWithSeconds)(stopTime));
            this.interactionDetailInfo.set(this.getLocalizedString(InteractionDetailType.Ani), this.ani);
            this.interactionDetailInfo.set(this.getLocalizedString(InteractionDetailType.Queue), this.queue);
            this.interactionDetailInfo.set(this.getLocalizedString(InteractionDetailType.Duration), (0,_utils__WEBPACK_IMPORTED_MODULE_7__.relativeTimeFormatter)(stopTime - startTime));
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[App:QMW] Successfully processed capture data (media). Main recording start time: ${this.absoluteStartTime}, stop time: ${this.absoluteStopTime}`);
            return true;
        }
        processRicherMetadata() {
            var _a, _b;
            // Validate metadata
            if (!this.captureMetaDataResults ||
                !this.captureMetaDataResults.data ||
                !this.captureMetaDataResults.data.taskDetails ||
                this.captureMetaDataResults.data.taskDetails.tasks.length === 0 ||
                this.captureMetaDataResults.data.taskDetails.tasks[0].activities.nodes.length === 0) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[App:QMW] Invalid capture metadata for session id: ${this.sessionId}`);
                return false;
            }
            if (!this.captureResults || !this.captureResults.data || !this.captureResults.data[0].recording) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[App:QMW] Null capture (media) data for session id: ${this.sessionId}`);
                return false;
            }
            // Process metadata into chapter data
            const chapterData = (0,_utils__WEBPACK_IMPORTED_MODULE_7__.createCaptureData)(this.captureResults.data[0].recording, this.captureMetaDataResults.data.taskDetails.tasks[0].activities.nodes);
            if (chapterData.customerChaptersMetaData.length <= 0) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[App:QMW] No customer chapter metadata found in results for session id: ${this.sessionId}`);
                return false;
            }
            // Create chapter objects for customer and consult chapters
            const createChapterObj = (metaData, firstChapterStartTime) => {
                const startTimeRelative = Math.abs(metaData.startTime - firstChapterStartTime);
                const endTimeRelative = startTimeRelative + Math.abs(metaData.startTime - metaData.endTime);
                return new _player_Chapter__WEBPACK_IMPORTED_MODULE_10__.Chapter(metaData.fileLocation, startTimeRelative, endTimeRelative, metaData.involvedAgentNames, metaData.chapterType);
            };
            const firstChapterStartTime = chapterData.customerChaptersMetaData[0].startTime;
            chapterData.customerChaptersMetaData.forEach((metaData) => {
                this.customerChaptersData.push(createChapterObj(metaData, firstChapterStartTime));
            });
            chapterData.consultChaptersMetaData.forEach((metaData) => {
                this.consultChaptersData.push(createChapterObj(metaData, firstChapterStartTime));
            });
            // Set InteractionDetails for agents in consult and conference
            const consultedAgents = (0,_utils__WEBPACK_IMPORTED_MODULE_7__.createArrayOfAgents)((_a = this.agentName) !== null && _a !== void 0 ? _a : "", chapterData.consultChaptersMetaData, _utils__WEBPACK_IMPORTED_MODULE_7__.ChapterType.Consulting);
            if (consultedAgents.length > 0) {
                this.interactionDetailInfo.set(this.getLocalizedString(InteractionDetailType.ConsultedAgents), consultedAgents.join(", "));
            }
            const conferencedAgents = (0,_utils__WEBPACK_IMPORTED_MODULE_7__.createArrayOfAgents)((_b = this.agentName) !== null && _b !== void 0 ? _b : "", chapterData.customerChaptersMetaData, _utils__WEBPACK_IMPORTED_MODULE_7__.ChapterType.Conferencing);
            if (conferencedAgents.length > 0) {
                this.interactionDetailInfo.set(this.getLocalizedString(InteractionDetailType.ConferenceAgents), conferencedAgents.join(", "));
            }
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[App:QMW] Successfully processed capture metadata. Customer/Consult chapters: ${this.customerChaptersData.length}/${this.consultChaptersData.length}`);
            return true;
        }
        processTranscriptionData() {
            return __awaiter(this, void 0, void 0, function* () {
                if (this.captureResults && this.captureResults.data[0].transcription) {
                    try {
                        const transcriptJson = yield axios__WEBPACK_IMPORTED_MODULE_3___default().get(this.captureResults.data[0].transcription[0].filePath);
                        this.customerTranscript = new _player_Transcript__WEBPACK_IMPORTED_MODULE_11__.Transcript(transcriptJson.data);
                        this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_6__.TRANSCRIPT_LOADED, {
                            detail: { transcript: transcriptJson.data },
                            bubbles: true,
                            composed: true
                        }));
                    }
                    catch (error) {
                        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`[App:QMW] Failed to fetch transcription data`, error);
                        this.hasTranscriptError = true;
                        this.transcriptErrorMessage = error.message;
                        return false;
                    }
                    _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[App:QMW] Successfully fetched and created transcription data`);
                    this.transcriptAvailable = true;
                    return true;
                }
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`[App:QMW] Failed to fetch transcription data. Capture data does not contain transcription data`);
                this.hasTranscriptError = true;
                this.transcriptErrorMessage = "Capture data does not contain transcription data";
                return false;
            });
        }
        fetchData() {
            var _a, _b, _c, _d, _e, _f;
            return __awaiter(this, void 0, void 0, function* () {
                this.resetData();
                if (this.sessionId && this.sessionId.length > 0) {
                    if (this.showEnhancedRecordings) {
                        // Fetch capture data (media)
                        this.captureResults = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.qmw.fetchCapture({ taskId: this.sessionId });
                        const isMediaFetchSuccessful = this.captureResults.data.length > 0 && this.captureResults.data[0].recording.length > 0;
                        // Fetch capture metadata (events)
                        this.captureMetaDataResults = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.qmw.fetchCaptureMetaData({
                            taskId: this.sessionId,
                            startTime: this.startTimeFromGrid
                        });
                        if (this.captureMetaDataResults) {
                            const agentId = (_f = (_e = (_d = (_c = (_b = (_a = this.captureMetaDataResults) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.taskDetails) === null || _c === void 0 ? void 0 : _c.tasks[0]) === null || _d === void 0 ? void 0 : _d.activities) === null || _e === void 0 ? void 0 : _e.nodes[0]) === null || _f === void 0 ? void 0 : _f.agentId;
                            if (agentId) {
                                this.dispatchSetActiveAgentId(agentId);
                            }
                        }
                        return isMediaFetchSuccessful;
                    }
                    // Note: This is the old way of fetching data, we will deprecate this after GA for enhanced recordings feature
                    else {
                        const captureDataResponse = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.qmw.fetchCapture({ taskId: this.sessionId });
                        // captures API takes a list of task IDs and returns an array in data for each task, we are only passing in 1 task id and thus taking the first obj in the array
                        const capture = captureDataResponse.data[0];
                        const { recording } = capture;
                        if (recording.length) {
                            recording.forEach((rec) => {
                                if (rec.attributes.callType === RecordingLegType.Main && rec.segment === false) {
                                    this.mainAudioSource = {
                                        audioSrc: rec.attributes.filePath,
                                        absoluteStartTime: rec.attributes.startTime,
                                        absoluteEndTime: rec.attributes.stopTime
                                    };
                                }
                                else if (rec.attributes.callType === RecordingLegType.Consult && this.showConsultRecordings) {
                                    this.consultAudioSources.push({
                                        audioSrc: rec.attributes.filePath,
                                        absoluteStartTime: rec.attributes.startTime,
                                        absoluteEndTime: rec.attributes.stopTime
                                    });
                                }
                            });
                            this.consultAudioSources.sort((a, b) => a.absoluteStartTime - b.absoluteStartTime);
                            this.isEmpty = false;
                            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[App:QMW] Fetched capture data successfully`);
                            return true;
                        }
                        else {
                            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[App:QMW] Fetched capture data successfully but failed to find a recording");
                            return true;
                        }
                    }
                }
                else {
                    _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[App:QMW] Invalid session id: ${this.sessionId}`);
                    return false;
                }
            });
        }
        dispatchSetActiveAgentId(agentId) {
            this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_6__.SET_ACTIVE_AGENT_ID, {
                detail: { agentId },
                bubbles: true,
                composed: true
            }));
        }
        resetData() {
            this.isEmpty = true;
            this.mainAudioSource = undefined;
            // Enhanced recording data
            this.captureResults = null;
            this.captureMetaDataResults = null;
            this.interactionDetailInfo.clear();
            this.consultAudioSources = [];
            this.consultChaptersData = [];
            this.customerChaptersData = [];
            this.interactionRecordingData = undefined;
            this.audioPlayerControlsClicked.clear();
        }
        getLocalizedString(detailType) {
            switch (detailType) {
                case InteractionDetailType.SessionId:
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.sessionId");
                case InteractionDetailType.Agent:
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.agent");
                case InteractionDetailType.StartTime:
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.startTime");
                case InteractionDetailType.EndTime:
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.endTime");
                case InteractionDetailType.Ani:
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.ani");
                case InteractionDetailType.Duration:
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.duration");
                case InteractionDetailType.Queue:
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.queue");
                case InteractionDetailType.ConsultedAgents:
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.consultedAgents");
                case InteractionDetailType.ConferenceAgents:
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.conferenceAgents");
                default:
                    return "";
            }
        }
        handleCloseModal() {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_6__.QMW_RECORDINGS_MODAL_CLOSE_BTN_CLK, {
                bubbles: true,
                composed: true,
                detail: {
                    showEnhancedRecordings: this.showEnhancedRecordings,
                    numCustomerChapters: this.customerChaptersData.length,
                    numConsultChapters: this.consultChaptersData.length,
                    numMultiPartyConferences: this.customerChaptersData.filter((chapter) => chapter.chapterType === _utils__WEBPACK_IMPORTED_MODULE_7__.ChapterType.Conferencing).length,
                    chapterClickedTimes: (_a = this.audioPlayerControlsClicked.get(_AudioPlayer__WEBPACK_IMPORTED_MODULE_8__.AudioPlayerControlClicked.CHAPTER_CLICKED)) !== null && _a !== void 0 ? _a : 0,
                    visualizerClickedTimes: (_b = this.audioPlayerControlsClicked.get(_AudioPlayer__WEBPACK_IMPORTED_MODULE_8__.AudioPlayerControlClicked.VISUALIZER_CLICKED)) !== null && _b !== void 0 ? _b : 0,
                    seekBarChangedTimes: (_c = this.audioPlayerControlsClicked.get(_AudioPlayer__WEBPACK_IMPORTED_MODULE_8__.AudioPlayerControlClicked.SEEK_BAR_CHANGED)) !== null && _c !== void 0 ? _c : 0,
                    volumeControlChangedTimes: (_d = this.audioPlayerControlsClicked.get(_AudioPlayer__WEBPACK_IMPORTED_MODULE_8__.AudioPlayerControlClicked.VOLUME_CONTROL_CHANGED)) !== null && _d !== void 0 ? _d : 0,
                    playbackRateControlChangedTimes: (_e = this.audioPlayerControlsClicked.get(_AudioPlayer__WEBPACK_IMPORTED_MODULE_8__.AudioPlayerControlClicked.PLAYBACK_RATE_CONTROL_CHANGED)) !== null && _e !== void 0 ? _e : 0,
                    playClickedTimes: (_f = this.audioPlayerControlsClicked.get(_AudioPlayer__WEBPACK_IMPORTED_MODULE_8__.AudioPlayerControlClicked.PLAY_CLICKED)) !== null && _f !== void 0 ? _f : 0,
                    hasDataFetchError: this.getHasDataFetchError(),
                    hasRecordingPlaybackError: this.getHasRecordingPlaybackError(),
                    transcriptAvailable: this.transcriptAvailable,
                    hasTranscriptError: this.hasTranscriptError,
                    transcriptErrorMessage: (_g = this.transcriptErrorMessage) !== null && _g !== void 0 ? _g : "No Error Message",
                    transcriptChapterClickedTimes: (_h = this.audioPlayerControlsClicked.get(_AudioPlayer__WEBPACK_IMPORTED_MODULE_8__.AudioPlayerControlClicked.TRANSCRIPT_CLICKED)) !== null && _h !== void 0 ? _h : 0
                }
            }));
            this.setHasRecordingPlaybackError(false);
        }
        handleRecordingPlaybackError() {
            this.setHasRecordingPlaybackError(true);
        }
        handleDataFetchErrorRetry() {
            this.setHasDataFetchError(false);
            this.setTrackingID("");
        }
        audioPlayerControlClicked(e) {
            var _a, _b;
            const control = (_a = e === null || e === void 0 ? void 0 : e.detail) === null || _a === void 0 ? void 0 : _a.control;
            if (control !== undefined) {
                this.audioPlayerControlsClicked.set(control, ((_b = this.audioPlayerControlsClicked.get(control)) !== null && _b !== void 0 ? _b : 0) + 1);
            }
        }
        connectedCallback() {
            super.connectedCallback();
            this.addEventListener("playback-error", this.handleRecordingPlaybackError);
            this.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_6__.QMW_ERR_RETRY, this.handleDataFetchErrorRetry);
            this.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_6__.QMW_AUDIO_PLAYER_CONTROL_CLICKED, this.audioPlayerControlClicked);
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.removeEventListener("playback-error", this.handleRecordingPlaybackError);
            this.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_6__.QMW_ERR_RETRY, this.handleDataFetchErrorRetry);
            this.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_6__.QMW_AUDIO_PLAYER_CONTROL_CLICKED, this.audioPlayerControlClicked);
        }
        updated(changedProperties) {
            const _super = Object.create(null, {
                updated: { get: () => super.updated }
            });
            return __awaiter(this, void 0, void 0, function* () {
                _super.updated.call(this, changedProperties);
                if (changedProperties.has("seekEvaluationTime") && this.audioPlayer) {
                    const chapterManager = this.audioPlayer.getChapterManager();
                    chapterManager.seek(this.seekEvaluationTime);
                }
                if (changedProperties.has("sessionId") ||
                    (changedProperties.has("hasDataFetchError") && changedProperties.get("hasDataFetchError"))) {
                    this.setIsLoading(true);
                    try {
                        if (this.showEnhancedRecordings) {
                            const isFetchSuccess = yield this.fetchData();
                            const isMediaDataValidated = this.processRequiredRecordingMediaData();
                            this.isEmpty = !isMediaDataValidated;
                            if (!this.isEmpty) {
                                this.processRicherMetadata();
                            }
                            if (!(this.showTranscript && (yield this.processTranscriptionData()))) {
                                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`[App:QMW] Failed to create transcription for this Recording`);
                                this.transcriptAvailable = false;
                            }
                            this.setHasDataFetchError(!isFetchSuccess);
                        }
                        else {
                            yield this.fetchData();
                            this.setHasDataFetchError(false);
                        }
                    }
                    catch (err) {
                        if ((0,_utils__WEBPACK_IMPORTED_MODULE_7__.errorIsRetryable)(err === null || err === void 0 ? void 0 : err.details)) {
                            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[App:QMW] Failed to fetch capture data due to rate limit. Retrying`);
                            yield (0,_utils__WEBPACK_IMPORTED_MODULE_7__.wait)(err === null || err === void 0 ? void 0 : err.details);
                            yield this.fetchData();
                            if (this.showEnhancedRecordings) {
                                const isMediaDataValidated = this.processRequiredRecordingMediaData();
                                this.isEmpty = !isMediaDataValidated;
                                if (!this.isEmpty) {
                                    this.processRicherMetadata();
                                }
                            }
                        }
                        else {
                            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`[App:QMW] Failed to fetch capture data`);
                            this.setHasDataFetchError(true);
                            this.setTrackingID((0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.getTrackingIdFromErrorObject)(err));
                        }
                    }
                    finally {
                        this.setIsLoading(false);
                    }
                }
            });
        }
        getHasDataFetchError() {
            return this.hasDataFetchError;
        }
        setHasDataFetchError(hasError) {
            this.hasDataFetchError = hasError;
        }
        getIsLoading() {
            return this.isLoading;
        }
        setIsLoading(isLoading) {
            this.isLoading = isLoading;
        }
        getTrackingId() {
            return this.trackingID;
        }
        setTrackingID(trackingID) {
            this.trackingID = trackingID;
        }
        getHasRecordingPlaybackError() {
            return this.hasRecordingPlaybackError;
        }
        setHasRecordingPlaybackError(hasRecordingPlaybackError) {
            this.hasRecordingPlaybackError = hasRecordingPlaybackError;
        }
        getRelativeTimesText(audioSource) {
            if (audioSource && this.mainAudioSource) {
                const startTimeDiff = audioSource.absoluteStartTime - this.mainAudioSource.absoluteStartTime;
                const endTimeDiff = audioSource.absoluteEndTime - this.mainAudioSource.absoluteStartTime;
                const startTimeFormatted = (0,_utils__WEBPACK_IMPORTED_MODULE_7__.relativeTimeFormatter)(startTimeDiff, endTimeDiff);
                const endTimeFormatted = (0,_utils__WEBPACK_IMPORTED_MODULE_7__.relativeTimeFormatter)(endTimeDiff, endTimeDiff);
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
          ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.startTime")} ${startTimeFormatted} <span></span>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.endTime")} ${endTimeFormatted}
        `;
            }
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) ``;
        }
        getConsultRecordingsComponent() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
        ${this.consultAudioSources.length > 0
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
              <div id="consult-recordings">
                <hr />
                <p>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.consultRecordings")} ${this.consultAudioSources.length}</p>
                ${this.consultAudioSources.slice(0).map((audioSource) => (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
                    <dl class="agentx-wc-qmw-recording-modal-consult-container">
                      <div class="agentx-wc-qmw-recording-modal-consult-info">
                        <dt>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.consult")} ${this.consultAudioSources.indexOf(audioSource) + 1}</dt>
                        <dd>${this.getRelativeTimesText(audioSource)}</dd>
                      </div>
                    </dl>
                    <md-audio-player
                      class="audioplayer"
                      src=${audioSource.audioSrc}
                      .labelMap=${this.audioLabels}
                    ></md-audio-player>
                  `)}
              </div>
            `
                : lit_html__WEBPACK_IMPORTED_MODULE_5__.nothing}
      `;
        }
        getEnhancedAudioPlayerComponent() {
            var _a;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
        <agentx-wc-audio-player
          .interactionRecordingDetails=${this.interactionRecordingData}
          .customerChapters=${this.customerChaptersData}
          .consultChapters=${this.consultChaptersData}
          .interactionDetailInfo=${this.interactionDetailInfo}
          .agentName=${(_a = this.agentName) !== null && _a !== void 0 ? _a : ""}
          .customerTranscript=${this.customerTranscript}
          .transcriptAvailable=${this.transcriptAvailable}
        ></agentx-wc-audio-player>
      `;
        }
        getAudioSourceComponent() {
            const isDataValidForEnhancedView = this.showEnhancedRecordings && this.customerChaptersData.length > 0 && this.sessionId;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
        ${isDataValidForEnhancedView
                ? this.getEnhancedAudioPlayerComponent()
                : this.mainAudioSource
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
                <md-audio-player
                  class="audioplayer"
                  src=${this.mainAudioSource.audioSrc}
                  .labelMap=${this.audioLabels}
                ></md-audio-player>
                ${this.getConsultRecordingsComponent()}
              `
                    : lit_html__WEBPACK_IMPORTED_MODULE_5__.nothing}
      `;
        }
        renderRecordingModalComponent() {
            var _a, _b;
            if (this.hasDataFetchError && !this.isLoading) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
          <agentx-wc-qmw-grid-error
            .trackingID=${this.trackingID}
            .errorElement=${_constants__WEBPACK_IMPORTED_MODULE_6__.RECORDING}
          ></agentx-wc-qmw-grid-error>
        `;
            }
            if (this.isLoading) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) ` <agentx-wc-widget-loader></agentx-wc-widget-loader> `;
            }
            if (this.isEmpty) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) ` <agentx-wc-qmw-empty-grid .emptyElement=${_constants__WEBPACK_IMPORTED_MODULE_6__.RECORDING}></agentx-wc-qmw-empty-grid> `;
            }
            // Note: After GA for enhanced recordings feature, we will deprecate the HTML below and use the enhanced recording component
            if (!this.showEnhancedRecordings) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
          <div id="scrollable-content">
            <md-alert-banner .show=${this.hasRecordingPlaybackError} type="error">
              <p class="agentx-wc-qmw-recording-modal-playback-error-text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.recordingPlaybackError")}</p>
            </md-alert-banner>
            <dl class="agentx-wc-qmw-recording-modal-properties-container">
              <div class="agentx-wc-qmw-recording-modal-properties">
                <dt>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.sessionId")}</dt>
                <dd>${this.sessionId}</dd>
              </div>
              <div class="agentx-wc-qmw-recording-modal-properties">
                <dt>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.ani")}</dt>
                <dd>${this.ani}</dd>
              </div>
              <div class="agentx-wc-qmw-recording-modal-properties">
                <dt>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.startTime")}</dt>
                <dd>${(0,_utils__WEBPACK_IMPORTED_MODULE_7__.dateFormatterShortWithSeconds)(((_a = this.mainAudioSource) === null || _a === void 0 ? void 0 : _a.absoluteStartTime) || 0)}</dd>
              </div>
              <div class="agentx-wc-qmw-recording-modal-properties">
                <dt>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.endTime")}</dt>
                <dd>${(0,_utils__WEBPACK_IMPORTED_MODULE_7__.dateFormatterShortWithSeconds)(((_b = this.mainAudioSource) === null || _b === void 0 ? void 0 : _b.absoluteEndTime) || 0)}</dd>
              </div>
              <div class="agentx-wc-qmw-recording-modal-properties">
                <dt>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.agent")}</dt>
                <dd>${this.agentName}</dd>
              </div>
              ${this.getAudioSourceComponent()}
            </dl>
          </div>
        `;
            }
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
        <md-alert-banner .show=${this.hasRecordingPlaybackError} type="error">
          <p class="agentx-wc-qmw-recording-modal-playback-error-text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.recordingPlaybackError")}</p>
        </md-alert-banner>
        ${this.getAudioSourceComponent()}
      `;
        }
        renderWithEnhancedRecordings() {
            const ariaLabelCloseText = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.close");
            if (!this.showInModal) {
                // Render only the recording modal content
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) ` <section>${this.renderRecordingModalComponent()}</section> `;
            }
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
        <md-modal
          .show=${this.isModalOpen}
          size="large"
          .hideFooter=${true}
          .showCloseButton=${true}
          ariaLabelClose=${ariaLabelCloseText}
          .backdropClickExit=${true}
          headerLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.recordingPlayback")}
          @close-modal=${() => this.handleCloseModal()}
          class="agentx-wc-qmw-recording-modal"
          .disableInitialFocus=${true}
        >
          <section>${this.renderRecordingModalComponent()}</section>
          <section slot="footer">
            <md-button variant="secondary" @click=${() => (this.isModalOpen = false)} ariaLabel=${ariaLabelCloseText}>
              ${ariaLabelCloseText}
            </md-button>
          </section>
        </md-modal>
      `;
        }
        render() {
            const ariaLabelCloseText = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.close");
            // Note: After GA for enhanced recordings feature, we will deprecate the HTML below and use the enhanced recording component
            if (!this.showEnhancedRecordings) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
          <md-modal
            .show=${this.isModalOpen}
            size="small"
            .hideFooter=${true}
            .showCloseButton=${true}
            ariaLabelClose=${ariaLabelCloseText}
            .backdropClickExit=${true}
            headerLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.recordingPlayback")}
            @close-modal=${() => this.handleCloseModal()}
            class="agentx-wc-qmw-recording-modal"
            .disableInitialFocus=${true}
          >
            ${this.renderRecordingModalComponent()}
            <section slot="footer">
              <md-button variant="secondary" @click=${() => (this.isModalOpen = false)} ariaLabel=${ariaLabelCloseText}>
                ${ariaLabelCloseText}
              </md-button>
            </section>
          </md-modal>
        `;
            }
            else {
                return this.renderWithEnhancedRecordings();
            }
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
    ], Element.prototype, "sessionId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
    ], Element.prototype, "ani", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
    ], Element.prototype, "queue", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
    ], Element.prototype, "agentName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
    ], Element.prototype, "isModalOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
    ], Element.prototype, "showConsultRecordings", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
    ], Element.prototype, "showEnhancedRecordings", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
    ], Element.prototype, "showTranscript", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Number })
    ], Element.prototype, "startTimeFromGrid", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
    ], Element.prototype, "showInModal", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Number })
    ], Element.prototype, "seekEvaluationTime", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "isLoading", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "absoluteStartTime", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "absoluteStopTime", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "mainAudioSource", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "consultAudioSources", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "hasDataFetchError", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "hasRecordingPlaybackError", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "trackingID", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "isEmpty", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "interactionRecordingData", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "customerChaptersData", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "consultChaptersData", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "customerTranscript", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "interactionDetailInfo", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "captureResults", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "captureMetaDataResults", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "audioPlayerControlsClicked", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.query)("agentx-wc-audio-player")
    ], Element.prototype, "audioPlayer", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.customElement)("agentx-wc-qmw-recording-details")
    ], Element);
    RecordingDetails.Element = Element;
})(RecordingDetails || (RecordingDetails = {}));


/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/evaluations/EvaluationConfirmationModal.scss":
/*!********************************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/evaluations/EvaluationConfirmationModal.scss ***!
  \********************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.btn-wrapper .discard {
  margin-left: 10px;
}
.btn-wrapper .discard,
.btn-wrapper .return {
  float: right;
  margin-right: 10px;
}

.header-width {
  width: 100%;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL1F1YWxpdHlNb25pdG9yaW5nV2lkZ2V0L2NvbXBvbmVudHMvZXZhbHVhdGlvbnMvRXZhbHVhdGlvbkNvbmZpcm1hdGlvbk1vZGFsLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0U7RUFDRSxpQkFBQTtBQUFKO0FBRUU7O0VBRUUsWUFBQTtFQUNBLGtCQUFBO0FBQUo7O0FBSUE7RUFDRSxXQUFBO0FBREYiLCJzb3VyY2VzQ29udGVudCI6WyIuYnRuLXdyYXBwZXIge1xuICAuZGlzY2FyZCB7XG4gICAgbWFyZ2luLWxlZnQ6IDEwcHg7XG4gIH1cbiAgLmRpc2NhcmQsXG4gIC5yZXR1cm4ge1xuICAgIGZsb2F0OiByaWdodDtcbiAgICBtYXJnaW4tcmlnaHQ6IDEwcHg7XG4gIH1cbn1cblxuLmhlYWRlci13aWR0aCB7XG4gIHdpZHRoOiAxMDAlO1xufVxuIl0sInNvdXJjZVJvb3QiOiIifQ== */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/evaluations/EvaluationConfirmationModal.ts":
/*!******************************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/evaluations/EvaluationConfirmationModal.ts ***!
  \******************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EvaluationConfirmationModal: () => (/* binding */ EvaluationConfirmationModal)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html_lib_part__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html/lib/part */ "lit-html/lib/part");
/* harmony import */ var lit_html_lib_part__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html_lib_part__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _EvaluationConfirmationModal_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./EvaluationConfirmationModal.scss */ "./src/components/QualityMonitoringWidget/components/evaluations/EvaluationConfirmationModal.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let EvaluationConfirmationModal = class EvaluationConfirmationModal extends lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement {
    constructor() {
        super(...arguments);
        this.showModal = false;
    }
    static get styles() {
        return _EvaluationConfirmationModal_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
    }
    confirmExit() {
        this.dispatchEvent(new CustomEvent("confirm-exit"));
    }
    declineExit() {
        this.dispatchEvent(new CustomEvent("decline-exit"));
    }
    render() {
        return this.showModal
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
          <md-modal
            applicationId="evaluationConfirmation"
            ?show=${this.showModal}
            id="evaluationConfirmationModal"
            size="dialog"
            .hideFooter=${true}
            headerLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.evaluationConfirmation")}
            ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.evaluationConfirmation")}
            tabindex="${"-1"}"
            ?showclosebutton=${false}
            .ariaLabelClose=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.evaluationConfirmationReturn")}
          >
            <div class="modal-body">
              <span>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.evaluationConfirmationMessage")}</span>
            </div>
            <div slot="footer" class="btn-wrapper">
              <md-button
                class="discard"
                variant="primary"
                @click="${this.confirmExit}"
                type="submit"
                ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.evaluationConfirmationDiscard")}
              >
                ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.evaluationConfirmationDiscard")}</md-button
              >
              <md-button
                class="return"
                variant="secondary"
                ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.evaluationConfirmationReturn")}
                type="reset"
                @click="${this.declineExit}"
              >
                ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.evaluationConfirmationReturn")}</md-button
              >
            </div>
          </md-modal>
        `
            : lit_html_lib_part__WEBPACK_IMPORTED_MODULE_2__.nothing;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
], EvaluationConfirmationModal.prototype, "showModal", void 0);
EvaluationConfirmationModal = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-qmw-evaluation-confirmation-modal")
], EvaluationConfirmationModal);



/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/evaluations/EvaluationForm.scss":
/*!*******************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/evaluations/EvaluationForm.scss ***!
  \*******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

.form__container {
  display: grid;
  grid-template-rows: auto 1fr auto;
  height: 90%;
}
.form__container .form__content {
  overflow-y: auto;
  padding: 10px;
}
.form__container .form__content .section-header h4 {
  margin: 0;
}
.form__container .form__content .section-header h4 .section-name {
  font-weight: normal;
}
.form__container .form__content .section__content {
  padding: 1rem 1rem 0px 1rem;
}
.form__container .form__content .section__content .question__container {
  padding-bottom: 24px;
}
.form__container .form__content .section__content .label__container {
  display: flex;
}
.form__container .form__content .section__content .label__container .tooltip__container {
  display: inline-block;
  top: 0.2rem;
  position: relative;
}
.form__container .form__content .section__content .options__container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.form__container .form__content .section__content .comment-btn__wrapper {
  display: flex;
  align-items: flex-end;
  margin-top: 50px;
}
.form__container .form__content .section__content .radio-group__wrapper {
  flex: 1;
}
.form__container .form__content .section__content .comment__input textarea {
  width: 95%;
  padding: 0.5rem;
  border: 1px solid var(--color-gray-border);
  border-radius: 5px;
  resize: none;
}
.form__container .form__content .ai-assist__container {
  padding: 5px;
}
.form__container .form__content .ai-assist__container .transcript__container {
  margin-top: 8px;
}
.form__container .form__content .ai-assist__container .transcript-content {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow: hidden;
  transition: max-height 300ms ease-out, opacity 250ms ease-out;
}
.form__container .form__content .ai-assist__container .transcript-entry {
  display: flex;
  width: 100%;
}
.form__container .form__content .ai-assist__container .transcript-timestamp {
  flex: 0 0 auto;
  margin-right: 8px;
}
.form__container .form__content .ai-assist__container .transcript-content__text {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}
.form__container .form__content .ai-assist__container .transcript-content.expanded {
  max-height: 500px;
  opacity: 1;
}
.form__container .form__content .ai-assist__container .transcript-content.collapsed {
  max-height: 0;
  opacity: 0;
}
.form__container .form__content .ai-assist__container .detection-points__container {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding-left: 20px;
}
.form__container .form__content .ai-assist-placeholder {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px;
  border-radius: 10px;
  border: 1px solid var(--color-gray-border);
  height: 35px;
  margin-bottom: 12px;
}
.form__container md-radiogroup {
  display: flex;
  padding: 1rem;
}
.form__container .form__footer {
  position: sticky;
  bottom: 0;
  background: #fff;
  padding: 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/evaluations/EvaluationForm.ts":
/*!*****************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/evaluations/EvaluationForm.ts ***!
  \*****************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EvaluationForm: () => (/* binding */ EvaluationForm)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! mobx */ "mobx");
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(mobx__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../utils */ "./src/components/QualityMonitoringWidget/utils.ts");
/* harmony import */ var _EvaluationForm_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./EvaluationForm.scss */ "./src/components/QualityMonitoringWidget/components/evaluations/EvaluationForm.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









const DEBOUNCE_SAVE = 2000;
const COMMENT_INPUT_ROWS = 3;
let EvaluationForm = class EvaluationForm extends lit_element__WEBPACK_IMPORTED_MODULE_4__.LitElement {
    constructor() {
        super(...arguments);
        this.evaluationForm = {
            id: "",
            name: "",
            sections: [],
            status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.AgentPerformanceTypes.EvaluationStatus.ACTIVE
        };
        this.evaluationMode = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.AgentPerformanceTypes.EvaluationMode.CREATE;
        this.pendingAiEvaluationResults = false;
        this.commentVisibility = {};
        this.expandedTranscripts = new Map();
        this.radioAlignment = "vertical";
        this.debouncedHandleAutoSave = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.debounce)(() => this.handleAutoSave(), DEBOUNCE_SAVE);
    }
    static get styles() {
        return _EvaluationForm_scss__WEBPACK_IMPORTED_MODULE_8__["default"];
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.evaluationForm) {
            this.commentVisibility = Object.fromEntries(this.evaluationForm.sections.flatMap((section) => section.questions.map((question) => {
                if (question.comment) {
                    return [question.id, true];
                }
                return [question.id, false];
            })));
        }
    }
    firstUpdated() {
        requestAnimationFrame(() => {
            const firstRadio = this.renderRoot.querySelector("md-radio");
            if (firstRadio) {
                firstRadio.focus();
            }
        });
    }
    render() {
        var _a;
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
      <div class="form__container">
        <!-- FORM-CONTENT -->
        <div class="form__content">
          <md-accordion multiple="true" class="section-accordion">
            ${(_a = this.evaluationForm) === null || _a === void 0 ? void 0 : _a.sections.map((section, sectionIndex) => (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
                <!-- FORM-SECTION -->

                <md-accordion-item slot="accordion-item" expanded class="section-accordion-item">
                  <div slot="header-content" class="section-header">
                    <h4>
                      ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.formSectionHeader", "", { count: sectionIndex + 1 })}
                      <span class="section-name">${section.name}</span>
                    </h4>
                  </div>
                  <div class="section__content">
                    ${section.questions.map((question, questionIndex) => {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
                        <!-- QUESTIONS -->
                        <div class="question__container">
                          <div class="label__container">
                            <label class="question-label">
                              ${this.getQuestionNumber(sectionIndex, questionIndex)}. ${question.text}
                              (${this.getWeightForQuestion(question)})
                              ${question.tooltipText
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
                                    <div class="tooltip__container">
                                      <md-tooltip message="${question.tooltipText}" placement="top">
                                        <md-icon name="info-circle-bold" size="16" iconSet="momentumDesign"></md-icon>
                                      </md-tooltip>
                                    </div>
                                  `
                : ""}
                            </label>
                          </div>
                          <!-- OPTIONS -->
                          <div class="options__container">
                            ${this.getOptionsSection(question, sectionIndex)} ${this.renderCommentButton(question.id)}
                          </div>
                          ${this.renderAIAssistSection(question)} ${this.renderCommentSection(question, sectionIndex)}
                        </div>
                      `;
        })}
                  </div>
                </md-accordion-item>
              `)}
          </md-accordion>
        </div>
        ${this.renderFormFooter()}
      </div>
    `;
    }
    handleSubmit(event) {
        event.preventDefault();
        this.dispatchEvent(new CustomEvent("evaluation-submit", {
            detail: { message: "Form submitted" },
            bubbles: true,
            composed: true
        }));
    }
    handleAutoSave() {
        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[Evaluation Form] Auto save request firing");
        this.dispatchEvent(new CustomEvent("evaluation-auto-save", {
            detail: { message: "Auto save request" },
            bubbles: true,
            composed: true
        }));
    }
    getQuestionNumber(sectionIndex, questionIndex) {
        var _a;
        const previousSections = (_a = this.evaluationForm) === null || _a === void 0 ? void 0 : _a.sections.slice(0, sectionIndex);
        const previousQuestionsCount = (previousSections === null || previousSections === void 0 ? void 0 : previousSections.reduce((count, section) => count + section.questions.length, 0)) || 0;
        return previousQuestionsCount + questionIndex + 1;
    }
    renderFormFooter() {
        if (this.evaluationMode === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.AgentPerformanceTypes.EvaluationMode.VIEW) {
            return lit_html__WEBPACK_IMPORTED_MODULE_5__.nothing;
        }
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
      <div class="form__footer">
        <md-button type="button" variant="secondary" @click=${this.handleDiscard}> ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.discard")} </md-button>
        <md-button type="submit" variant="primary" @click=${this.handleSubmit}> ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.submit")} </md-button>
      </div>
    `;
    }
    handleDiscard() {
        this.dispatchEvent(new CustomEvent("evaluation-form-discard", {
            bubbles: true,
            composed: true
        }));
    }
    getOptionsSection(question, sectionIndex) {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
      <md-form>
        <div class="radio-group__wrapper">
          <md-radiogroup
            group-label=${question.id}
            .alignment=${this.radioAlignment}
            ?disabled=${this.evaluationMode === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.AgentPerformanceTypes.EvaluationMode.VIEW}
            @radio-change=${(event) => this.handleRadioChange(event, sectionIndex, question.id)}
          >
            ${question.options.map((option) => (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
                <md-radio slot="radio" .value=${option.text} .checked=${question.selectedAnswer === option.text}
                  >${option.text}</md-radio
                >
              `)}
          </md-radiogroup>
        </div>
      </md-form>
    `;
    }
    renderCommentSection(question, sectionIndex) {
        if (!this.commentVisibility[question.id]) {
            return lit_html__WEBPACK_IMPORTED_MODULE_5__.nothing;
        }
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
      <div class="comment__input">
        <label>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.comment")}</label>
        <textarea
          ?disabled=${this.evaluationMode === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.AgentPerformanceTypes.EvaluationMode.VIEW}
          rows="${COMMENT_INPUT_ROWS}"
          @input=${(event) => this.handleCommentInput(event, sectionIndex, question.id)}
        >
${question.comment}</textarea
        >
      </div>
    `;
    }
    toggleCommentVisibility(questionId) {
        this.commentVisibility = Object.assign(Object.assign({}, this.commentVisibility), { [questionId]: !this.commentVisibility[questionId] });
    }
    handleRadioChange(event, sectionIndex, questionId) {
        const selectedAnswer = event.detail.selected;
        this.updateFormSubmission(sectionIndex, questionId, (question) => (Object.assign(Object.assign({}, question), { selectedAnswer })));
    }
    handleCommentInput(event, sectionIndex, questionId) {
        const text = event.target.value;
        this.updateFormSubmission(sectionIndex, questionId, (question) => (Object.assign(Object.assign({}, question), { comment: text })));
    }
    renderCommentButton(questionId) {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) ` <div>
      <div class="comment-btn__wrapper">
        <md-tooltip placement="top" message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.addComment")}">
          <md-button circle variant="secondary" size="28" @click=${() => this.toggleCommentVisibility(questionId)}>
            <md-icon name="commenting-light" size="16" iconSet="momentumDesign"></md-icon>
          </md-button>
        </md-tooltip>
      </div>
    </div>`;
    }
    getWeightForQuestion(question) {
        const maxWeight = Math.max(...question.options.map((option) => Number(option.weight) || 0));
        return `${maxWeight}%`;
    }
    dispatchChapterSelectedEvent(timestamp) {
        this.dispatchEvent(new CustomEvent("seek-audio", {
            bubbles: true,
            composed: true,
            detail: { seekTo: timestamp }
        }));
    }
    renderAIAssistSection(question) {
        const aiEvalDetails = (0,mobx__WEBPACK_IMPORTED_MODULE_6__.toJS)(question.aiEvalDetails);
        if (this.evaluationMode === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.AgentPerformanceTypes.EvaluationMode.VIEW) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) ``;
        }
        if (this.pendingAiEvaluationResults) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
        <div class="ai-assist-placeholder">
          <md-spinner size="24"></md-spinner>
          <span>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.generatingAIResults")}</span>
        </div>
      `;
        }
        if (!(aiEvalDetails === null || aiEvalDetails === void 0 ? void 0 : aiEvalDetails.length) && !this.pendingAiEvaluationResults) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
        <div class="ai-assist-placeholder">
          <span>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.noAIEvaluation")}</span>
        </div>
      `;
        }
        // currently we are only supporting single choice questions, so array will only have one element for now
        const questionEvaluation = aiEvalDetails === null || aiEvalDetails === void 0 ? void 0 : aiEvalDetails[0];
        return questionEvaluation ? this.renderAIAssistContent(questionEvaluation) : (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_5__.nothing}`;
    }
    toggleTranscriptExpansion(questionId) {
        const isExpanded = this.expandedTranscripts.get(questionId) || false;
        this.expandedTranscripts.set(questionId, !isExpanded);
        this.requestUpdate();
    }
    isTranscriptExpanded(questionId) {
        return this.expandedTranscripts.get(questionId) || false;
    }
    renderAIAssistContent(questionEvaluation) {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
      <div class="ai-assist__container">
        <div>
          <strong>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.aiSuggestion")}</strong>
          <span class="ai-suggestion">${questionEvaluation.text}</span>
          <md-icon name="cisco-ai-assistant-color" size="16" iconSet="svg"></md-icon>
        </div>

        ${this.renderJustification(questionEvaluation)} ${this.renderConfidence(questionEvaluation)}
        ${this.renderTranscripts(questionEvaluation)}
      </div>
    `;
    }
    renderConfidence(questionEvaluation) {
        return (questionEvaluation === null || questionEvaluation === void 0 ? void 0 : questionEvaluation.confidence)
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
          <strong> ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.aiAssistConfidence")}</strong> <span>${questionEvaluation.confidence.toString()}%</span>
        `
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_5__.nothing}`;
    }
    renderJustification(questionEvaluation) {
        return (questionEvaluation === null || questionEvaluation === void 0 ? void 0 : questionEvaluation.justification)
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
          <div>
            <strong>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.justification")}</strong>
            <span class="ai-justification">${questionEvaluation.justification}</span>
          </div>
        `
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_5__.nothing}`;
    }
    renderTranscripts(questionEvaluation) {
        var _a;
        if (!((_a = questionEvaluation === null || questionEvaluation === void 0 ? void 0 : questionEvaluation.detectionPoints) === null || _a === void 0 ? void 0 : _a.length)) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_5__.nothing}`;
        }
        return questionEvaluation.detectionPoints.length === 1
            ? this.renderTranscriptEntry(questionEvaluation.detectionPoints[0])
            : this.renderMultipleDetectionPoints(questionEvaluation);
    }
    renderMultipleDetectionPoints(questionEvaluation) {
        const detectionPoints = questionEvaluation.detectionPoints;
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
      <div class="transcript__container">
        <md-link tag="span" @click=${() => this.toggleTranscriptExpansion(questionEvaluation.id)}>
          ${this.isTranscriptExpanded(questionEvaluation.id)
            ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.hideTranscripts")
            : `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.showTranscripts")} (${detectionPoints.length})`}
        </md-link>

        <div class="transcript-content ${this.isTranscriptExpanded(questionEvaluation.id) ? "expanded" : "collapsed"}">
          ${detectionPoints.map((detectionPoint) => this.renderTranscriptEntry(detectionPoint))}
        </div>
      </div>
    `;
    }
    renderTranscriptEntry(detectionPoint) {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
      <span class="transcript-entry">
        <md-link
          class="transcript-timestamp"
          tag="span"
          @click=${() => this.dispatchChapterSelectedEvent(detectionPoint.startTimeMs)}
        >
          ${(0,_utils__WEBPACK_IMPORTED_MODULE_7__.relativeTimeFormatter)(detectionPoint.startTimeMs)}
        </md-link>
        <span class="transcript-content__text"> ${detectionPoint.text} </span>
      </span>
    `;
    }
    updateFormSubmission(sectionIndex, questionId, updateCallback) {
        this.evaluationForm = Object.assign(Object.assign({}, this.evaluationForm), { sections: this.evaluationForm.sections.map((section, index) => index === sectionIndex
                ? Object.assign(Object.assign({}, section), { questions: section.questions.map((question) => question.id === questionId ? updateCallback(question) : question) }) : section) });
        this.dispatchEvent(new CustomEvent("evaluation-updated", {
            detail: { evaluationForm: this.evaluationForm },
            bubbles: true,
            composed: true
        }));
        this.debouncedHandleAutoSave();
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Object })
], EvaluationForm.prototype, "evaluationForm", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
], EvaluationForm.prototype, "evaluationMode", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
], EvaluationForm.prototype, "pendingAiEvaluationResults", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
], EvaluationForm.prototype, "commentVisibility", void 0);
EvaluationForm = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.customElement)("agentx-wc-evaluation-form")
], EvaluationForm);



/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/evaluations/EvaluationViewer.scss":
/*!*********************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/evaluations/EvaluationViewer.scss ***!
  \*********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

.content {
  display: grid;
  grid-template-rows: auto 1fr;
  grid-template-columns: 2fr 1fr;
  column-gap: 1rem;
  height: calc(100% - 15px);
  padding: 0 1rem 1rem 1rem;
  background-color: white;
}
.content .header {
  grid-column: 1/-1;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.content .header span {
  font-weight: 400;
}
.content .loading__container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40%;
}
.content .empty-state__container {
  margin-top: 10rem;
}
.content .form-header__container {
  display: flex;
}
.content .form-header__container .form-header__name {
  margin-top: 0.2rem;
  font-size: 1rem;
  font-weight: 700;
  flex-grow: 1;
}
.content .form-header__container .form-header__name span {
  font-style: italic;
}
.content .loading__container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40%;
}
.content .empty-state__container {
  margin-top: 10rem;
}
.content .empty-state__header {
  display: flex;
  justify-content: flex-end;
}
.content .empty-state__header .close-icon {
  display: flex;
}
.content .left-panel,
.content .right-panel {
  padding: 1rem 1rem 0 1rem;
  border: 1px solid var(--color-gray-border);
  overflow-y: auto;
}

.saving-indicator {
  display: flex;
  align-items: center;
  gap: 3px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/evaluations/EvaluationViewer.ts":
/*!*******************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/evaluations/EvaluationViewer.ts ***!
  \*******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EvaluationViewer: () => (/* binding */ EvaluationViewer)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! mobx */ "mobx");
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(mobx__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _EvaluationConfirmationModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./EvaluationConfirmationModal */ "./src/components/QualityMonitoringWidget/components/evaluations/EvaluationConfirmationModal.ts");
/* harmony import */ var _EvaluationForm__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./EvaluationForm */ "./src/components/QualityMonitoringWidget/components/evaluations/EvaluationForm.ts");
/* harmony import */ var _EvaluationViewer_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./EvaluationViewer.scss */ "./src/components/QualityMonitoringWidget/components/evaluations/EvaluationViewer.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};





// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Tech debt, mobx observables should only be defined in a store




var FormStatus;
(function (FormStatus) {
    FormStatus["LOADING"] = "loading";
    FormStatus["SUCCESS"] = "success";
    FormStatus["NOT_FOUND"] = "not_found";
    FormStatus["ERROR"] = "error";
    FormStatus["EVALUATION_NOT_FOUND"] = "evaluation_not_found";
})(FormStatus || (FormStatus = {}));
const EVALUATION_VIEWER = "Evaluation Viewer";
const POLLING_INTERVAL_MS = 3000;
const MAX_ATTEMPTS = 10;
let EvaluationViewer = class EvaluationViewer extends _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_2__.MobxLitElement {
    constructor() {
        super();
        this.evaluationData = {
            sessionId: "",
            agentName: "",
            activeSessionStartTime: 0,
            ani: "",
            queueName: ""
        };
        this.evaluationTimestamp = 0;
        this.evaluationMode = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.AgentPerformanceTypes.EvaluationMode.CREATE;
        this.agentId = "";
        this.evaluationForms = { data: [] };
        this.formStatus = FormStatus.LOADING;
        this.pendingAiEvaluationResults = true;
        this.showExitConfirmationModal = false;
        this.formSaved = false;
        this.isSavingForm = false;
        this.evaluationNotFound = false;
        this.evaluation = {
            status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.AgentPerformanceTypes.EvaluationStatus.DRAFT,
            interaction: {
                interactionId: "",
                agent: {
                    userId: "",
                    ccUserId: "",
                    displayName: ""
                }
            },
            formId: "",
            createdAt: "",
            lastModifiedAt: "",
            answers: [],
            lastModifiedBy: undefined
        };
        (0,mobx__WEBPACK_IMPORTED_MODULE_5__.makeObservable)(this);
    }
    static get styles() {
        return _EvaluationViewer_scss__WEBPACK_IMPORTED_MODULE_8__["default"];
    }
    updateEvaluationFormQuestion(sectionIndex, questionIndex, aiEvalDetails) {
        this.evaluationForm.sections[sectionIndex].questions[questionIndex].aiEvalDetails = aiEvalDetails;
    }
    initializeFormData() {
        this.evaluationForm = {
            id: "",
            name: "",
            sections: [],
            status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.AgentPerformanceTypes.EvaluationStatus.DRAFT
        };
    }
    updateForm(form) {
        this.evaluationForm = form;
    }
    updateFormWithEvaluation() {
        var _a;
        (_a = this.evaluation.answers) === null || _a === void 0 ? void 0 : _a.forEach((answer) => {
            this.updateQuestionWithAnswer(answer);
        });
    }
    updateQuestionWithAnswer(answer) {
        this.evaluationForm.sections.forEach((section) => {
            section.questions.forEach((question) => {
                var _a;
                if (question.id === answer.questionId) {
                    question.comment = answer.comment;
                    question.selectedAnswer = (_a = answer.selectedOptions) === null || _a === void 0 ? void 0 : _a.map((option) => option.text).join(", ");
                }
            });
        });
    }
    attachAIAssistEvaluationsToForm(suggestedAnswers) {
        this.pendingAiEvaluationResults = false;
        suggestedAnswers.forEach((suggestedAnswer) => {
            var _a;
            (_a = this.evaluationForm.sections) === null || _a === void 0 ? void 0 : _a.forEach((section, sectionIndex) => {
                section.questions.forEach((question, questionIndex) => {
                    if (question.id === suggestedAnswer.questionId) {
                        this.updateEvaluationFormQuestion(sectionIndex, questionIndex, suggestedAnswer.selectedOptions);
                    }
                });
            });
        });
    }
    updateEvaluationWithFormAnswers() {
        this.evaluation.answers = this.getEvaluationAnswers();
    }
    getEvaluationAnswers() {
        var _a;
        return (_a = this.evaluationForm.sections) === null || _a === void 0 ? void 0 : _a.flatMap((section) => section.questions.map((question) => ({
            questionId: question.id,
            comment: question.comment,
            selectedOptions: this.getSelectedOptions(question)
        })));
    }
    getSelectedOptions(question) {
        return question.selectedAnswer
            ? question.selectedAnswer.split(", ").map((text) => {
                var _a, _b;
                return ({
                    id: ((_a = question.options.find((option) => option.text === text)) === null || _a === void 0 ? void 0 : _a.id) || 0,
                    weight: Number((_b = question.options.find((option) => option.text === text)) === null || _b === void 0 ? void 0 : _b.weight) || 0,
                    text
                });
            })
            : [];
    }
    createInMemoryEvaluation() {
        var _a;
        if (!this.evaluation) {
            return;
        }
        // mobx observable proxy object to plain object
        const evaluationFormProps = (0,mobx__WEBPACK_IMPORTED_MODULE_5__.toJS)(this.evaluationForm);
        this.evaluation.interaction = {
            interactionId: this.evaluationData.sessionId,
            agent: {
                userId: this.evaluationData.agentName,
                ccUserId: this.evaluationData.agentName,
                displayName: this.evaluationData.agentName
            }
        };
        this.evaluation.formId = evaluationFormProps.id;
        this.evaluation.createdAt = this.evaluation.createdAt || new Date().toISOString();
        this.evaluation.lastModifiedAt = new Date().toISOString();
        this.evaluation.answers = (_a = evaluationFormProps.sections) === null || _a === void 0 ? void 0 : _a.flatMap((section) => section.questions.map((question) => ({
            questionId: question.id,
            comment: question.comment,
            selectedOptions: [
                {
                    id: Number(question.options[0].id),
                    weight: Number(question.options[0].weight),
                    text: question.options[0].text
                }
            ]
        })));
    }
    connectedCallback() {
        super.connectedCallback();
        this.initializeFormData();
        this.getEvaluation(this.evaluationData.sessionId);
    }
    render() {
        return this.evaluationData
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
          <div class="content">
            <div class="header">
              <h3 class="header-left">${this.getEvaluationHeader()} ${this.getSubmissionDetails()}</h3>
              <h3 class="header-right">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.sessionId")}:<strong>${this.evaluationData.sessionId}</strong></h3>
            </div>
            <div class="left-panel">${this.getEnhancedAudioPlayerComponent(this.evaluationData)}</div>
            <div class="right-panel">${this.renderFormHeader()}${this.renderFormContent()}</div>
          </div>
          <agentx-wc-qmw-evaluation-confirmation-modal
            .showModal=${this.showExitConfirmationModal}
            @confirm-exit="${this.handleDiscard}"
            @decline-exit="${this.toggleModal}"
          ></agentx-wc-qmw-evaluation-confirmation-modal>
        `
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `<agentx-wc-qmw-evaluation-confirmation-modal
          .showModal=${this.showExitConfirmationModal}
          @confirm-exit="${this.handleDiscard}"
          @decline-exit="${this.toggleModal}"
        ></agentx-wc-qmw-evaluation-confirmation-modal>`;
    }
    getEvaluation(interactionId) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            this.formStatus = FormStatus.LOADING;
            try {
                this.evaluation = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.agentPerformance.fetchEvaluation({
                    interactionId,
                    orgId: ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) || ""
                });
                this.setupEvaluationForm((_b = this.evaluation) === null || _b === void 0 ? void 0 : _b.formId);
                if (this.evaluation.status === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.AgentPerformanceTypes.EvaluationStatus.PUBLISHED) {
                    this.evaluationMode = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.AgentPerformanceTypes.EvaluationMode.VIEW;
                }
            }
            catch (error) {
                this.formStatus = FormStatus.EVALUATION_NOT_FOUND;
                this.evaluationNotFound = true;
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[Evaluation Viewer] Failed to fetch submitted evaluation", error);
            }
        });
    }
    getOrgEvaluationForms() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.formStatus = FormStatus.LOADING;
            try {
                this.evaluationForms = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.agentPerformance.fetchOrgEvaluationForms({
                    orgId: ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) || ""
                });
                this.formStatus = FormStatus.SUCCESS;
            }
            catch (error) {
                this.formStatus = FormStatus.ERROR;
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[Evaluation Viewer] Failed to fetch evaluation forms", error);
            }
        });
    }
    setupEvaluationForm(formId) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getSelectedForm(formId);
            if (this.evaluationNotFound) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[Evaluation Viewer] Creating new evaluation form");
                this.createEvaluation();
            }
            else {
                this.updateFormWithEvaluation();
            }
            const aiAssistEvaluations = yield this.getAIAssistEvaluations();
            if (aiAssistEvaluations && ((_a = aiAssistEvaluations.suggestedAnswers) === null || _a === void 0 ? void 0 : _a.length)) {
                this.attachAIAssistEvaluationsToForm(aiAssistEvaluations.suggestedAnswers);
            }
            else {
                try {
                    yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.agentPerformance.triggerAIEvaluation({
                        orgId: ((_b = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.conf.profile) === null || _b === void 0 ? void 0 : _b.orgId) || "",
                        formId: this.evaluationForm.id,
                        interactionId: this.evaluationData.sessionId,
                        transcript: this.transcript,
                        agent: { ccUserId: this.agentId, displayName: this.evaluationData.agentName }
                    });
                    this.startPollingForResult();
                }
                catch (error) {
                    this.pendingAiEvaluationResults = false;
                    _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[Evaluation Viewer] Failed to trigger AI evaluation", error);
                }
            }
        });
    }
    getSelectedForm(formId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.formStatus = FormStatus.LOADING;
            try {
                const formResponse = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.agentPerformance.fetchEvaluationForm({
                    orgId: ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) || "",
                    formId
                });
                this.updateForm(formResponse);
                this.formStatus = this.evaluationForm.id ? FormStatus.SUCCESS : FormStatus.NOT_FOUND;
            }
            catch (error) {
                this.formStatus = FormStatus.ERROR;
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[Evaluation Viewer] Failed to fetch selected evaluation form", error);
            }
        });
    }
    getAIAssistEvaluations() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.agentPerformance.fetchAIAssistedEvaluations({
                    orgId: ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) || "",
                    interactionId: this.evaluationData.sessionId
                });
            }
            catch (error) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[Evaluation Viewer] Failed to fetch AI evaluations", error);
                return {
                    interaction: { interactionId: this.evaluationData.sessionId },
                    formId: this.evaluationForm.id,
                    suggestedAnswers: []
                };
            }
        });
    }
    getEvaluationHeader() {
        const agentName = this.evaluationData.agentName || (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.agent");
        switch (this.evaluationMode) {
            case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.AgentPerformanceTypes.EvaluationMode.VIEW:
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.viewEvaluation", agentName);
            case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.AgentPerformanceTypes.EvaluationMode.EDIT:
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.editEvaluation", agentName);
            case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.AgentPerformanceTypes.EvaluationMode.CREATE:
            default:
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.newEvaluation", agentName);
        }
    }
    renderFormContent() {
        var _a;
        switch (this.formStatus) {
            case FormStatus.LOADING:
                return this.renderLoadingState();
            case FormStatus.ERROR:
                return this.renderErrorState();
            case FormStatus.NOT_FOUND:
                return this.renderEmptyState();
            case FormStatus.EVALUATION_NOT_FOUND:
                this.getOrgEvaluationForms();
                return this.renderLoadingState();
            default:
                return ((_a = this.evaluationForm) === null || _a === void 0 ? void 0 : _a.id) ? this.renderEvaluationForm() : this.renderSelectionDropdown();
        }
    }
    getSubmissionDetails() {
        var _a, _b;
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
      ${this.evaluationMode !== _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.AgentPerformanceTypes.EvaluationMode.CREATE
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
            ${((_a = this.evaluation.lastModifiedBy) === null || _a === void 0 ? void 0 : _a.displayName)
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `<span>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.submittedBy", (_b = this.evaluation.lastModifiedBy) === null || _b === void 0 ? void 0 : _b.displayName)}</span>`
                : ""}
            ${this.evaluation.lastModifiedAt
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `<span>
                  ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.submittedOn", "", {
                    defaultValue: this.evaluation.lastModifiedAt,
                    interpolation: { escapeValue: false }
                })}
                </span>`
                : ""}
          `
            : ""}
    `;
    }
    renderLoadingState() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
      <div class="loading__container">
        <md-loading size="small"></md-loading>
      </div>
    `;
    }
    renderEvaluationForm() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
      <agentx-wc-evaluation-form
        @evaluation-auto-save=${this.handleEvaluationAutoSave}
        @evaluation-submit=${this.handleEvaluationSubmit}
        @evaluation-updated=${this.handleEvaluationUpdated}
        @evaluation-form-discard=${this.toggleModal}
        @seek-audio=${this.seekToEvaluationAudio}
        .evaluationForm=${this.evaluationForm}
        .evaluationMode=${this.evaluationMode}
        .pendingAiEvaluationResults=${this.pendingAiEvaluationResults}
      ></agentx-wc-evaluation-form>
    `;
    }
    startPollingForResult() {
        let attempts = 0;
        this.pollingIntervalId = window.setInterval(() => __awaiter(this, void 0, void 0, function* () {
            var _a;
            attempts++;
            if (attempts > MAX_ATTEMPTS) {
                this.stopPolling();
                this.pendingAiEvaluationResults = false;
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[Evaluation Viewer] request to fetch AI evaluation has reached max attempts");
                return;
            }
            const aiEvaluation = yield this.getAIAssistEvaluations();
            if ((_a = aiEvaluation === null || aiEvaluation === void 0 ? void 0 : aiEvaluation.suggestedAnswers) === null || _a === void 0 ? void 0 : _a.length) {
                this.stopPolling();
                this.attachAIAssistEvaluationsToForm(aiEvaluation.suggestedAnswers);
            }
        }), POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollingIntervalId !== undefined) {
            clearInterval(this.pollingIntervalId);
            this.pollingIntervalId = undefined;
        }
    }
    handleEvaluationSubmit() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.submitEvaluation();
            this.dispatchEvent(new CustomEvent("clear-evaluation-data", {
                bubbles: true,
                composed: true
            }));
        });
    }
    handleEvaluationAutoSave() {
        return __awaiter(this, void 0, void 0, function* () {
            this.updateEvaluationWithFormAnswers();
            yield this.saveEvaluation();
        });
    }
    saveEvaluation() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.formSaved = false;
            this.isSavingForm = true;
            let evaluation = this.evaluation;
            try {
                evaluation = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.agentPerformance.saveEvaluation({
                    orgId: ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) || "",
                    evaluationId: evaluation.id || "",
                    data: this.evaluation
                });
                this.isSavingForm = false;
                this.formSaved = true;
                if (evaluation.id) {
                    this.evaluation = evaluation;
                    _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[Evaluation Viewer] Evaluation form saved successfully");
                }
            }
            catch (error) {
                this.isSavingForm = false;
                this.formSaved = false;
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[Evaluation Viewer] Failed to save evaluation form", error);
            }
        });
    }
    submitEvaluation() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const evaluation = this.evaluation;
            try {
                this.evaluation = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.agentPerformance.publishEvaluation({
                    orgId: ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) || "",
                    evaluationId: evaluation.id || "",
                    data: evaluation
                });
            }
            catch (error) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[Evaluation Viewer] Failed to submit evaluation", error);
            }
        });
    }
    discardEvaluation() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const evaluation = this.evaluation;
            try {
                yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.agentPerformance.archiveEvaluation({
                    orgId: ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) || "",
                    evaluationId: evaluation.id || ""
                });
            }
            catch (error) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[Evaluation Viewer] Failed to discard evaluation", error);
            }
        });
    }
    createEvaluation() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.createInMemoryEvaluation();
            const evaluation = this.evaluation;
            try {
                this.evaluation = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.agentPerformance.createEvaluation({
                    orgId: ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) || "",
                    data: evaluation
                });
            }
            catch (error) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[Evaluation Viewer] Failed to create evaluation", error);
            }
        });
    }
    handleEvaluationUpdated(event) {
        this.updateForm(event.detail.evaluationForm);
    }
    renderSelectionDropdown() {
        var _a;
        return this.transcript && this.agentId
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
          <div class="evaluation__dropdown">
            <h3>Select Evaluation Form</h3>
            <md-dropdown
              .options="${this.evaluationForms.data}"
              title="${((_a = this.evaluationForms.data) === null || _a === void 0 ? void 0 : _a.length) ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.select") : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.noFormsFound")}"
              option-id="id"
              option-value="name"
              @dropdown-selected="${(e) => {
                const option = e.detail.option;
                if (option && typeof option === "object") {
                    this.setupEvaluationForm(option.id);
                }
                else {
                    _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[Evaluation Viewer] Unexpected option in evaluation form dropdown", option);
                }
            }}"
            ></md-dropdown>
          </div>
        `
            : this.renderLoadingState();
    }
    renderEmptyState() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
      <div class="empty-state__container">
        <agentx-wc-empty-display-wrapper
          illustration-type="empty-result"
          title="Form not found"
          info-message="No form found for this team. Please contact your system administrator"
        ></agentx-wc-empty-display-wrapper>
      </div>
    `;
    }
    renderErrorState() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
      <div class="empty-state__container">
        <agentx-wc-qmw-grid-error
          .errorElement=${EVALUATION_VIEWER}
          @qmw-error-retry=${() => this.getSelectedForm(this.evaluationForm.id)}
        ></agentx-wc-qmw-grid-error>
      </div>
    `;
    }
    renderFormSavingIndicator() {
        if (!this.isSavingForm && !this.formSaved) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) ``;
        }
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
      <div class="saving-indicator">
        ${this.isSavingForm ? (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.evaluationSaving")}<md-spinner size="16"></md-spinner>` : ""}
        ${this.formSaved ? (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `<div class="saved-indicator">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.evaluationSaveSuccess")}</div>` : ""}
      </div>
    `;
    }
    renderFormHeader() {
        if (!this.evaluationForm) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) ``;
        }
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
      ${this.renderFormSavingIndicator()}
      <div class="form-header__container">
        <h3 class="form-header__name">
          ${this.evaluationForm.name}
          <span>${this.isEditMode && this.evaluationForm.name ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.editing") : ""}</span>
        </h3>
        <div class="close-icon">
          <md-button variant="white" @click=${this.closeView} circle ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.close")}>
            <md-icon name="cancel-bold" iconSet="momentumDesign"></md-icon>
          </md-button>
        </div>
      </div>
    `;
    }
    toggleModal() {
        this.showExitConfirmationModal = !this.showExitConfirmationModal;
    }
    closeView() {
        this.dispatchEvent(new CustomEvent("clear-evaluation-data", {
            bubbles: true,
            composed: true
        }));
    }
    getEnhancedAudioPlayerComponent(evaluationData) {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
      <agentx-wc-qmw-recording-details
        .sessionId=${evaluationData.sessionId}
        .ani=${evaluationData.ani}
        .queue=${evaluationData.queueName}
        .agentName=${evaluationData.agentName}
        .startTimeFromGrid=${evaluationData.activeSessionStartTime}
        .showConsultRecordings=${true}
        .showEnhancedRecordings=${true}
        .showInModal=${false}
        .seekEvaluationTime="${this.evaluationTimestamp}"
        .showTranscript=${true}
      ></agentx-wc-qmw-recording-details>
    `;
    }
    get isEditMode() {
        return this.evaluationMode === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.AgentPerformanceTypes.EvaluationMode.EDIT;
    }
    handleDiscard() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.discardEvaluation();
            this.toggleModal();
            this.dispatchEvent(new CustomEvent("clear-evaluation-data", {
                bubbles: true,
                composed: true
            }));
        });
    }
    seekToEvaluationAudio(event) {
        this.evaluationTimestamp = event.detail.seekTo;
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.stopPolling();
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Object })
], EvaluationViewer.prototype, "evaluationData", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Number })
], EvaluationViewer.prototype, "evaluationTimestamp", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
], EvaluationViewer.prototype, "evaluationMode", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Object })
], EvaluationViewer.prototype, "transcript", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
], EvaluationViewer.prototype, "agentId", void 0);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.observable
], EvaluationViewer.prototype, "evaluationForm", void 0);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.action
], EvaluationViewer.prototype, "updateEvaluationFormQuestion", null);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.action
], EvaluationViewer.prototype, "initializeFormData", null);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.action
], EvaluationViewer.prototype, "updateForm", null);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.action
], EvaluationViewer.prototype, "updateFormWithEvaluation", null);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
], EvaluationViewer.prototype, "evaluationForms", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
], EvaluationViewer.prototype, "formStatus", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
], EvaluationViewer.prototype, "pendingAiEvaluationResults", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
], EvaluationViewer.prototype, "showExitConfirmationModal", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
], EvaluationViewer.prototype, "formSaved", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
], EvaluationViewer.prototype, "isSavingForm", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
], EvaluationViewer.prototype, "pollingIntervalId", void 0);
EvaluationViewer = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.customElement)("agentx-wc-evaluation-viewer")
], EvaluationViewer);



/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/Chapter.ts":
/*!*****************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/Chapter.ts ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Chapter: () => (/* binding */ Chapter)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../utils */ "./src/components/QualityMonitoringWidget/utils.ts");


class Chapter {
    constructor(url, startTimeMillis, endTimeMillis, otherParticipantNames, chapterType = _utils__WEBPACK_IMPORTED_MODULE_1__.ChapterType.Main) {
        this.startTimeMillis = 0;
        this.endTimeMillis = 0;
        this.chapterType = _utils__WEBPACK_IMPORTED_MODULE_1__.ChapterType.Main;
        this.url = url;
        this.startTimeMillis = startTimeMillis;
        this.endTimeMillis = endTimeMillis;
        this.otherParticipantNames = otherParticipantNames;
        this.chapterType = chapterType;
    }
    getStartTimeInAudioFile() {
        if (this.getIsCustomerChapter()) {
            return 0;
        }
        return this.startTimeMillis;
    }
    getEndTimeSeconds() {
        return Math.floor(this.endTimeMillis / 1000);
    }
    getStartTimeSeconds() {
        return Math.floor(this.startTimeMillis / 1000);
    }
    getDuration() {
        return this.endTimeMillis - this.startTimeMillis;
    }
    getIsCustomerChapter() {
        return (0,_utils__WEBPACK_IMPORTED_MODULE_1__.isCustomerTrack)(this.chapterType);
    }
    getTrackTitle(agentName) {
        switch (this.chapterType) {
            case _utils__WEBPACK_IMPORTED_MODULE_1__.ChapterType.Consulting:
                if (this.otherParticipantNames.length > 1) {
                    return `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.consult")}: ${this.otherParticipantNames[0]} - ${this.otherParticipantNames[1]}`;
                }
                return `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.consult")}: ${this.otherParticipantNames[0]}`;
            case _utils__WEBPACK_IMPORTED_MODULE_1__.ChapterType.Hold:
                return `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.onHold")}`;
            case _utils__WEBPACK_IMPORTED_MODULE_1__.ChapterType.ConsultRequest:
                if (this.otherParticipantNames.length > 1) {
                    return `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.consultRequest")}: ${this.otherParticipantNames[0]} - ${this.otherParticipantNames[1]}`;
                }
                return `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.consultRequest")}: ${this.otherParticipantNames[0]}`;
            case _utils__WEBPACK_IMPORTED_MODULE_1__.ChapterType.Conferencing: {
                const joinConferenceAgents = this.otherParticipantNames.reduce((acc, name, index) => {
                    acc += ` ${index !== 0 ? "- " : ""}${name}`;
                    return acc;
                }, "");
                return `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.conference")}:${joinConferenceAgents} - ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.customer")}`;
            }
            case _utils__WEBPACK_IMPORTED_MODULE_1__.ChapterType.Main:
            default:
                return `${agentName} - ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.customer")}`;
        }
    }
    getDownloadUrl() {
        return this.url;
    }
}


/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/ChapterManager.ts":
/*!************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/ChapterManager.ts ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ChapterManager: () => (/* binding */ ChapterManager)
/* harmony export */ });
class ChapterManager {
    constructor(interactionRecordingDetails, customerChapters, consultChapters) {
        this.customerChapters = [];
        this.consultChapters = [];
        this.callbacks = [];
        this.isCustomerWaveformSelected = true;
        this.time = 0;
        this.running = false;
        this.playbackRate = 1;
        this.interactionRecordingDetails = interactionRecordingDetails;
        this.customerChapters = customerChapters;
        this.consultChapters = consultChapters;
    }
    registerCallback(callback) {
        this.callbacks.push(callback);
    }
    getCurrentTime() {
        return this.time;
    }
    isRunning() {
        return this.running;
    }
    start() {
        this.running = true;
        for (const callback of this.callbacks) {
            callback.onStart(this.time);
        }
    }
    stop() {
        this.running = false;
        for (const callback of this.callbacks) {
            callback.onStop();
        }
    }
    seek(time) {
        var _a, _b;
        time = Math.max(0, time);
        time = Math.min((_b = (_a = this.interactionRecordingDetails) === null || _a === void 0 ? void 0 : _a.endTimeMillis) !== null && _b !== void 0 ? _b : 0, time);
        this.time = time;
        for (const callback of this.callbacks) {
            callback.onSeek(this.time);
        }
        this.hasChapterChanged(time, true);
    }
    audioPlayerTick(time) {
        this.time = time;
        for (const callback of this.callbacks) {
            callback.onTick(this.time);
        }
        this.hasChapterChanged(time);
    }
    getCustomerWaveformSelected() {
        return this.isCustomerWaveformSelected;
    }
    setCustomerWaveformSelected(customerWaveformSelected, time) {
        if (this.isCustomerWaveformSelected === customerWaveformSelected) {
            return;
        }
        this.isCustomerWaveformSelected = customerWaveformSelected;
        this.hasChapterChanged(time, true);
    }
    getCustomerChapters() {
        return this.customerChapters;
    }
    getConsultChapters() {
        return this.consultChapters;
    }
    getInteractionRecordingDetails() {
        return this.interactionRecordingDetails;
    }
    getChapterByTime(time) {
        var _a, _b, _c, _d, _e, _f;
        if (time < 0) {
            time = 0;
        }
        if (time >= ((_b = (_a = this.interactionRecordingDetails) === null || _a === void 0 ? void 0 : _a.endTimeMillis) !== null && _b !== void 0 ? _b : 0)) {
            time = (_d = (_c = this.interactionRecordingDetails) === null || _c === void 0 ? void 0 : _c.endTimeMillis) !== null && _d !== void 0 ? _d : 0;
            return (_f = (_e = this.getSelectedChapters()) === null || _e === void 0 ? void 0 : _e.slice(-1)[0]) !== null && _f !== void 0 ? _f : undefined;
        }
        return this.getSelectedChapters().find((chapter) => time >= chapter.startTimeMillis && time < chapter.endTimeMillis);
    }
    getAudioUrls() {
        const urlsSet = new Set();
        const allChapters = [...this.getCustomerChapters(), ...this.getConsultChapters()];
        allChapters.forEach((chapter) => {
            if (chapter.getDownloadUrl() === "") {
                return;
            }
            urlsSet.add(chapter.getDownloadUrl());
        });
        return Array.from(urlsSet.values());
    }
    setPlaybackRate(playbackRate) {
        if (this.playbackRate === playbackRate) {
            return;
        }
        this.playbackRate = playbackRate;
    }
    getCurrentChapter() {
        return this.getChapterByTime(this.getCurrentTime());
    }
    getNextChapter() {
        const currentChapter = this.getCurrentChapter();
        let chapters = this.consultChapters;
        if (currentChapter !== undefined) {
            chapters = currentChapter.getIsCustomerChapter() ? this.customerChapters : this.consultChapters;
        }
        return chapters.find((chapter) => chapter.startTimeMillis > this.getCurrentTime());
    }
    getPreviousChapter() {
        const currentChapter = this.getCurrentChapter();
        if (currentChapter !== undefined) {
            const chapters = currentChapter.getIsCustomerChapter() ? this.customerChapters : this.consultChapters;
            // choosing to loop instead of the reverse and find, to avoid creating a duplicate array
            for (let i = chapters.length - 1; i >= 0; i--) {
                if (chapters[i].endTimeMillis <= currentChapter.startTimeMillis) {
                    return chapters[i];
                }
            }
        }
        return undefined;
    }
    isPreviousChapterAvailable() {
        const currentChapter = this.getCurrentChapter();
        if (currentChapter !== undefined) {
            // If we've started the current chapter, return to start time of current chapter
            return this.getCurrentTime() > currentChapter.startTimeMillis ? true : this.getPreviousChapter() !== undefined;
        }
        return false;
    }
    seekToPreviousChapter() {
        let timeToSeek = this.getCurrentTime();
        const currentChapter = this.getCurrentChapter();
        if (currentChapter !== undefined) {
            // if we're within 1 second of the start of the current chapter, go to the previous chapter
            if (this.getCurrentTime() - currentChapter.startTimeMillis < 1000) {
                const previousChapter = this.getPreviousChapter();
                if (previousChapter !== undefined) {
                    timeToSeek = previousChapter.startTimeMillis;
                }
            }
            else {
                timeToSeek = currentChapter.startTimeMillis;
            }
            this.seek(timeToSeek);
        }
    }
    seekToNextChapter() {
        let timeToSeek = this.getCurrentTime();
        const nextChapter = this.getNextChapter();
        if (nextChapter !== undefined) {
            timeToSeek = nextChapter.startTimeMillis;
        }
        this.seek(timeToSeek);
    }
    hasChapterChanged(time, seekEvent = false) {
        const tickInterval = 100 * this.playbackRate;
        const currentChapter = this.getChapterByTime(time - 2 * tickInterval);
        const nextChapter = this.getChapterByTime(time);
        if (seekEvent || currentChapter !== nextChapter) {
            for (const callback of this.callbacks) {
                callback.onChapterChanged(nextChapter);
            }
        }
    }
    getSelectedChapters() {
        return this.isCustomerWaveformSelected ? this.customerChapters : this.consultChapters;
    }
}


/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/ChaptersListView.scss":
/*!****************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/ChaptersListView.scss ***!
  \****************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.chapters-container {
  border-right: 1px solid var(--md-menu-overlay-border-color, --gray-20);
  overflow-y: auto;
  height: var(--chapters-container-height);
  padding-right: var(--chapters-container-padding-right);
}
.chapters-container.no-border {
  height: var(--chapters-container-height-no-border);
  border-right: none;
}
.chapters-container.hidden-tabs {
  height: var(--chapters-container-height-hidden-tabs);
}
.chapters-container.hidden-tabs.no-border {
  height: var(--chapters-container-height-hidden-tabs-no-border);
}

.chapter-container {
  display: grid;
  padding-top: var(--chapter-container-padding-top);
  padding-bottom: var(--chapter-container-padding-bottom);
  grid-template-columns: 1fr 10fr;
}

.hidden-tabs md-tabs::part(tabs-list) {
  display: none;
}

.chapter-item {
  text-align: left;
}

.chapter-time {
  grid-column: 1;
  grid-row: 1/span 2;
  width: var(--chapter-time-width);
}

.chapter-title {
  grid-column: 2;
  grid-row: 1;
  width: var(--chapter-title-width);
}

.spacer {
  grid-column: 1;
  grid-row: 2;
}

.chapter-length {
  grid-column: 2/span 2;
  grid-row: 2;
}

.selected-chapter {
  font-weight: bold;
}

h4 {
  margin-bottom: 0;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/ChaptersListView.ts":
/*!**************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/ChaptersListView.ts ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ChaptersListView: () => (/* binding */ ChaptersListView)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils */ "./src/components/QualityMonitoringWidget/utils.ts");
/* harmony import */ var _ChaptersListView_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./ChaptersListView.scss */ "./src/components/QualityMonitoringWidget/components/player/ChaptersListView.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







/**
 * @element agentx-wc-chapters-list
 * @fires chapter-clicked
 */
let ChaptersListView = class ChaptersListView extends lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement {
    constructor() {
        super(...arguments);
        this.customerChapters = [];
        this.consultChapters = [];
        this.agentName = "";
        this.selectedTabIndex = 0;
        this.transcriptAvailable = false;
        this.SCROLL_OFFSET = 16;
    }
    static get styles() {
        return _ChaptersListView_scss__WEBPACK_IMPORTED_MODULE_6__["default"];
    }
    updated(_changedProperties) {
        super.updated(_changedProperties);
        this.selectedTabIndex = this.isCurrentChapterCustomer() ? 0 : 1;
        this.handleChapterChange(this.currentChapter);
    }
    handleChapterChange(currentChapter) {
        var _a;
        if (!currentChapter) {
            return;
        }
        const chaptersContainer = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".chapters-container");
        const scrollableRect = chaptersContainer === null || chaptersContainer === void 0 ? void 0 : chaptersContainer.getBoundingClientRect();
        const { top: scrollableTop, height: scrollableHeight } = scrollableRect;
        requestAnimationFrame(() => {
            var _a;
            const content = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".selected-chapter");
            if (content) {
                const { top, bottom } = content.getBoundingClientRect();
                const isInView = top >= scrollableTop && bottom + this.SCROLL_OFFSET <= scrollableTop + scrollableHeight;
                if (!isInView && content.scrollIntoView) {
                    content.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }
        });
    }
    dispatchChapterSelectedEvent(chapterItem) {
        const isCustomerTrack = chapterItem.getIsCustomerChapter();
        const index = isCustomerTrack
            ? this.customerChapters.indexOf(chapterItem)
            : this.consultChapters.indexOf(chapterItem);
        this.dispatchEvent(new CustomEvent("chapter-clicked", {
            detail: [index, chapterItem.chapterType],
            bubbles: true,
            composed: true
        }));
    }
    isCurrentChapterCustomer() {
        return this.currentChapter !== undefined && this.customerChapters.includes(this.currentChapter);
    }
    getItemFontClass(chapterItem) {
        return this.currentChapter === chapterItem ? "selected-chapter" : "";
    }
    handleKeydownEvent(event, chapterItem) {
        if (event.code === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Space || event.code === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Enter) {
            this.dispatchChapterSelectedEvent(chapterItem);
        }
    }
    render() {
        const sections = [this.customerChapters, this.consultChapters];
        const customerSegmentsString = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:qmw.customerSegments");
        const consultSegmentsString = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:qmw.consultSegments");
        const chaptersString = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:qmw.chapters");
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
      <h4>${chaptersString} (${this.customerChapters.length + this.consultChapters.length})</h4>
      <div
        class="chapters-container ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__.classMap)({
            "hidden-tabs": !this.consultChapters.length,
            "no-border": this.transcriptAvailable
        })}"
      >
        <md-tabs selected-index="${this.selectedTabIndex}">
          ${sections.map((section, index) => section.length === 0
            ? (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) ``
            : (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
                  <md-tab slot="tab">
                    <span>${index === 0 ? customerSegmentsString : consultSegmentsString} (${section.length})</span>
                  </md-tab>
                  <md-tab-panel slot="panel">
                    ${section.map((chapterItem) => {
                var _a, _b;
                return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
                        <div class="chapter-container ${this.getItemFontClass(chapterItem)}">
                          <div class="grid-item chapter-time">
                            <md-link
                              tag="span"
                              @click="${() => this.dispatchChapterSelectedEvent(chapterItem)}"
                              @keydown="${(event) => this.handleKeydownEvent(event, chapterItem)}"
                              aria-label="${chapterItem.getTrackTitle(this.agentName)}"
                            >
                              ${(0,_utils__WEBPACK_IMPORTED_MODULE_5__.relativeTimeFormatter)(chapterItem.startTimeMillis, (_a = this.mainChapter) === null || _a === void 0 ? void 0 : _a.endTimeMillis)}
                            </md-link>
                          </div>
                          <div class="chapter-item chapter-title">
                            <md-label>${chapterItem.getTrackTitle(this.agentName)}</md-label>
                          </div>
                          <div class="chapter-item chapter-length">
                            <md-label>
                              ${(0,_utils__WEBPACK_IMPORTED_MODULE_5__.relativeTimeFormatter)(chapterItem.getDuration(), (_b = this.mainChapter) === null || _b === void 0 ? void 0 : _b.endTimeMillis)}
                            </md-label>
                          </div>
                        </div>
                      `;
            })}
                  </md-tab-panel>
                `)}
        </md-tabs>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Array })
], ChaptersListView.prototype, "customerChapters", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Array })
], ChaptersListView.prototype, "consultChapters", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
], ChaptersListView.prototype, "mainChapter", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
], ChaptersListView.prototype, "currentChapter", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
], ChaptersListView.prototype, "agentName", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Number })
], ChaptersListView.prototype, "selectedTabIndex", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
], ChaptersListView.prototype, "transcriptAvailable", void 0);
ChaptersListView = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-chapters-list")
], ChaptersListView);



/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/InteractionDetailsView.scss":
/*!**********************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/InteractionDetailsView.scss ***!
  \**********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --grid-header-height: 60px;
  --visualizer-title-width: 100px;
  --visualizer-title-margin-left: 24px;
  --visualizer-container-max-height: 40px;
  --visualizer-container-max-width: 900px;
  --visualizer-container-gap: 16px;
  --visualizer-bar-max-width: 577px;
  --visualizer-bar-max-height: 4px;
  --player-controls-row-height: 50px;
  --player-controls-gap: 8px;
  --volume-popover-width: 180px;
  --volume-popover-height: 21px;
  --volume-popover-gap: 12px;
  --volume-popover-top-offset: 120%;
  --volume-popover-left-offset: 50%;
  --volume-popover-padding: 12px;
  --seek-bar-height: 8px;
  --seek-bar-thumb-size: 16px;
  --seek-bar-top-margin: 16px;
  --seek-bar-bottom-margin: 8px;
  --popover-arrow-size: 10px;
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  --interaction-details-height: 220px;
  --interaction-details-vertical-padding: 12px;
  --interaction-details-optional-horizontal-margin: 24px;
  --interaction-details-item-bottom-margin: 4px;
  --interaction-details-item-grid-template-columns: 150px auto;
  --webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  --chapters-container-height: 292px;
  --chapters-container-height-no-border: 250px;
  --chapters-container-height-hidden-tabs: 350px;
  --chapters-container-height: 292px;
  --chapters-container-height-hidden-tabs-no-border: 300px;
  --chapters-container-padding-right: 18px;
  --chapter-container-padding-top: 5px;
  --chapter-container-padding-bottom: 12px;
  --chapter-time-width: 60px;
  --chapter-title-width: 300px;
  --transcript-height: 285px;
  --transcript-height-no-chapters: 410px;
  --transcript-height-chapters-no-consults: 350px;
}

.metrics-tab {
  padding: var(--interaction-details-vertical-padding) 0;
  max-height: var(--interaction-details-height);
}

.detail-item {
  display: grid;
  grid-template-columns: var(--interaction-details-item-grid-template-columns);
  justify-content: start;
  margin-bottom: var(--interaction-details-item-bottom-margin);
  color: var(--md-secondary-text-color);
}

h4 {
  margin-bottom: 0;
}

.detail-value {
  text-align: left;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL1F1YWxpdHlNb25pdG9yaW5nV2lkZ2V0L3ZhcmlhYmxlcy5zY3NzIiwid2VicGFjazovLy4vc3JjL2NvbXBvbmVudHMvUXVhbGl0eU1vbml0b3JpbmdXaWRnZXQvY29tcG9uZW50cy9wbGF5ZXIvSW50ZXJhY3Rpb25EZXRhaWxzVmlldy5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsMEJBQUE7RUFHQSwrQkFBQTtFQUNBLG9DQUFBO0VBQ0EsdUNBQUE7RUFDQSx1Q0FBQTtFQUNBLGdDQUFBO0VBQ0EsaUNBQUE7RUFDQSxnQ0FBQTtFQUdBLGtDQUFBO0VBQ0EsMEJBQUE7RUFHQSw2QkFBQTtFQUNBLDZCQUFBO0VBQ0EsMEJBQUE7RUFDQSxpQ0FBQTtFQUNBLGlDQUFBO0VBQ0EsOEJBQUE7RUFHQSxzQkFBQTtFQUNBLDJCQUFBO0VBQ0EsMkJBQUE7RUFDQSw2QkFBQTtFQUdBLDBCQUFBO0VBR0Esc0JBQUE7RUFDQSx1QkFBQTtFQUdBLG1DQUFBO0VBQ0EsNENBQUE7RUFDQSxzREFBQTtFQUNBLDZDQUFBO0VBQ0EsNERBQUE7RUFFQSxxREFBQTtFQUdBLGtDQUFBO0VBQ0EsNENBQUE7RUFDQSw4Q0FBQTtFQUNBLGtDQUFBO0VBQ0Esd0RBQUE7RUFFQSx3Q0FBQTtFQUNBLG9DQUFBO0VBQ0Esd0NBQUE7RUFDQSwwQkFBQTtFQUNBLDRCQUFBO0VBR0EsMEJBQUE7RUFDQSxzQ0FBQTtFQUNBLCtDQUFBO0FDbkJGOztBQXpDQTtFQUNFLHNEQUFBO0VBQ0EsNkNBQUE7QUE0Q0Y7O0FBekNBO0VBQ0UsYUFBQTtFQUNBLDRFQUFBO0VBQ0Esc0JBQUE7RUFDQSw0REFBQTtFQUNBLHFDQUFBO0FBNENGOztBQXpDQTtFQUNFLGdCQUFBO0FBNENGOztBQXpDQTtFQUNFLGdCQUFBO0FBNENGIiwic291cmNlc0NvbnRlbnQiOlsiOmhvc3Qge1xuICAtLWdyaWQtaGVhZGVyLWhlaWdodDogNjBweDtcblxuICAvLyBwbGF5ZXIgdmlzdWFsaXplclxuICAtLXZpc3VhbGl6ZXItdGl0bGUtd2lkdGg6IDEwMHB4O1xuICAtLXZpc3VhbGl6ZXItdGl0bGUtbWFyZ2luLWxlZnQ6IDI0cHg7XG4gIC0tdmlzdWFsaXplci1jb250YWluZXItbWF4LWhlaWdodDogNDBweDtcbiAgLS12aXN1YWxpemVyLWNvbnRhaW5lci1tYXgtd2lkdGg6IDkwMHB4O1xuICAtLXZpc3VhbGl6ZXItY29udGFpbmVyLWdhcDogMTZweDtcbiAgLS12aXN1YWxpemVyLWJhci1tYXgtd2lkdGg6IDU3N3B4O1xuICAtLXZpc3VhbGl6ZXItYmFyLW1heC1oZWlnaHQ6IDRweDtcblxuICAvLyBwbGF5ZXIgY29udHJvbHNcbiAgLS1wbGF5ZXItY29udHJvbHMtcm93LWhlaWdodDogNTBweDtcbiAgLS1wbGF5ZXItY29udHJvbHMtZ2FwOiA4cHg7XG5cbiAgLy8gcGxheWVyIHZvbHVtZVxuICAtLXZvbHVtZS1wb3BvdmVyLXdpZHRoOiAxODBweDtcbiAgLS12b2x1bWUtcG9wb3Zlci1oZWlnaHQ6IDIxcHg7XG4gIC0tdm9sdW1lLXBvcG92ZXItZ2FwOiAxMnB4O1xuICAtLXZvbHVtZS1wb3BvdmVyLXRvcC1vZmZzZXQ6IDEyMCU7XG4gIC0tdm9sdW1lLXBvcG92ZXItbGVmdC1vZmZzZXQ6IDUwJTtcbiAgLS12b2x1bWUtcG9wb3Zlci1wYWRkaW5nOiAxMnB4O1xuXG4gIC8vIHBsYXllciBzZWVrYmFyXG4gIC0tc2Vlay1iYXItaGVpZ2h0OiA4cHg7XG4gIC0tc2Vlay1iYXItdGh1bWItc2l6ZTogMTZweDtcbiAgLS1zZWVrLWJhci10b3AtbWFyZ2luOiAxNnB4O1xuICAtLXNlZWstYmFyLWJvdHRvbS1tYXJnaW46IDhweDtcblxuICAvLyBwb3BvdmVyIGFycm93c1xuICAtLXBvcG92ZXItYXJyb3ctc2l6ZTogMTBweDtcblxuICAvLyBzY3JvbGwgYmFyXG4gIC0tc2Nyb2xsYmFyLXdpZHRoOiA2cHg7XG4gIC0tc2Nyb2xsYmFyLWhlaWdodDogOHB4O1xuXG4gIC8vIGludGVyYWN0aW9uIGRldGFpbHNcbiAgLS1pbnRlcmFjdGlvbi1kZXRhaWxzLWhlaWdodDogMjIwcHg7XG4gIC0taW50ZXJhY3Rpb24tZGV0YWlscy12ZXJ0aWNhbC1wYWRkaW5nOiAxMnB4O1xuICAtLWludGVyYWN0aW9uLWRldGFpbHMtb3B0aW9uYWwtaG9yaXpvbnRhbC1tYXJnaW46IDI0cHg7XG4gIC0taW50ZXJhY3Rpb24tZGV0YWlscy1pdGVtLWJvdHRvbS1tYXJnaW46IDRweDtcbiAgLS1pbnRlcmFjdGlvbi1kZXRhaWxzLWl0ZW0tZ3JpZC10ZW1wbGF0ZS1jb2x1bW5zOiAxNTBweCBhdXRvO1xuXG4gIC0td2Via2l0LWJveC1zaGFkb3c6IDAgMCAxcHggcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjUpO1xuXG4gIC8vIGNoYXB0ZXJzIGxpc3Qgdmlld1xuICAtLWNoYXB0ZXJzLWNvbnRhaW5lci1oZWlnaHQ6IDI5MnB4O1xuICAtLWNoYXB0ZXJzLWNvbnRhaW5lci1oZWlnaHQtbm8tYm9yZGVyOiAyNTBweDtcbiAgLS1jaGFwdGVycy1jb250YWluZXItaGVpZ2h0LWhpZGRlbi10YWJzOiAzNTBweDtcbiAgLS1jaGFwdGVycy1jb250YWluZXItaGVpZ2h0OiAyOTJweDtcbiAgLS1jaGFwdGVycy1jb250YWluZXItaGVpZ2h0LWhpZGRlbi10YWJzLW5vLWJvcmRlcjogMzAwcHg7XG5cbiAgLS1jaGFwdGVycy1jb250YWluZXItcGFkZGluZy1yaWdodDogMThweDtcbiAgLS1jaGFwdGVyLWNvbnRhaW5lci1wYWRkaW5nLXRvcDogNXB4O1xuICAtLWNoYXB0ZXItY29udGFpbmVyLXBhZGRpbmctYm90dG9tOiAxMnB4O1xuICAtLWNoYXB0ZXItdGltZS13aWR0aDogNjBweDtcbiAgLS1jaGFwdGVyLXRpdGxlLXdpZHRoOiAzMDBweDtcblxuICAvLyBhdWRpbyBwbGF5ZXIgdHJhbnNjcmlwdFxuICAtLXRyYW5zY3JpcHQtaGVpZ2h0OiAyODVweDtcbiAgLS10cmFuc2NyaXB0LWhlaWdodC1uby1jaGFwdGVyczogNDEwcHg7XG4gIC0tdHJhbnNjcmlwdC1oZWlnaHQtY2hhcHRlcnMtbm8tY29uc3VsdHM6IDM1MHB4O1xufVxuIiwiQHVzZSBcIi4uLy4uL3ZhcmlhYmxlcy5zY3NzXCIgYXMgKjtcblxuLm1ldHJpY3MtdGFiIHtcbiAgcGFkZGluZzogdmFyKC0taW50ZXJhY3Rpb24tZGV0YWlscy12ZXJ0aWNhbC1wYWRkaW5nKSAwO1xuICBtYXgtaGVpZ2h0OiB2YXIoLS1pbnRlcmFjdGlvbi1kZXRhaWxzLWhlaWdodCk7XG59XG5cbi5kZXRhaWwtaXRlbSB7XG4gIGRpc3BsYXk6IGdyaWQ7XG4gIGdyaWQtdGVtcGxhdGUtY29sdW1uczogdmFyKC0taW50ZXJhY3Rpb24tZGV0YWlscy1pdGVtLWdyaWQtdGVtcGxhdGUtY29sdW1ucyk7XG4gIGp1c3RpZnktY29udGVudDogc3RhcnQ7XG4gIG1hcmdpbi1ib3R0b206IHZhcigtLWludGVyYWN0aW9uLWRldGFpbHMtaXRlbS1ib3R0b20tbWFyZ2luKTtcbiAgY29sb3I6IHZhcigtLW1kLXNlY29uZGFyeS10ZXh0LWNvbG9yKTtcbn1cblxuaDQge1xuICBtYXJnaW4tYm90dG9tOiAwO1xufVxuXG4uZGV0YWlsLXZhbHVlIHtcbiAgdGV4dC1hbGlnbjogbGVmdDtcbn1cbiJdLCJzb3VyY2VSb290IjoiIn0= */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/InteractionDetailsView.ts":
/*!********************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/InteractionDetailsView.ts ***!
  \********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InteractionDetailsView: () => (/* binding */ InteractionDetailsView)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _InteractionDetailsView_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./InteractionDetailsView.scss */ "./src/components/QualityMonitoringWidget/components/player/InteractionDetailsView.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




/**
 * @element agentx-wc-interaction-details
 */
let InteractionDetailsView = class InteractionDetailsView extends lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement {
    constructor() {
        super(...arguments);
        this.interactionDetailInfo = new Map();
    }
    static get styles() {
        return _InteractionDetailsView_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
    }
    render() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) `
      <h4>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.interactionDetailsHeader")}</h4>
      <div class="tab-content">
        <div class="metrics-tab">
          ${Array.from(this.interactionDetailInfo.entries()).map(([key, value]) => (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) `
              <div class="detail-item">
                <dt class="detail-key">${key}</dt>
                <dd class="detail-value">${value}</dd>
              </div>
            `)}
        </div>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
], InteractionDetailsView.prototype, "interactionDetailInfo", void 0);
InteractionDetailsView = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-interaction-details")
], InteractionDetailsView);



/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/PlaybackRateView.scss":
/*!****************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/PlaybackRateView.scss ***!
  \****************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --grid-header-height: 60px;
  --visualizer-title-width: 100px;
  --visualizer-title-margin-left: 24px;
  --visualizer-container-max-height: 40px;
  --visualizer-container-max-width: 900px;
  --visualizer-container-gap: 16px;
  --visualizer-bar-max-width: 577px;
  --visualizer-bar-max-height: 4px;
  --player-controls-row-height: 50px;
  --player-controls-gap: 8px;
  --volume-popover-width: 180px;
  --volume-popover-height: 21px;
  --volume-popover-gap: 12px;
  --volume-popover-top-offset: 120%;
  --volume-popover-left-offset: 50%;
  --volume-popover-padding: 12px;
  --seek-bar-height: 8px;
  --seek-bar-thumb-size: 16px;
  --seek-bar-top-margin: 16px;
  --seek-bar-bottom-margin: 8px;
  --popover-arrow-size: 10px;
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  --interaction-details-height: 220px;
  --interaction-details-vertical-padding: 12px;
  --interaction-details-optional-horizontal-margin: 24px;
  --interaction-details-item-bottom-margin: 4px;
  --interaction-details-item-grid-template-columns: 150px auto;
  --webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  --chapters-container-height: 292px;
  --chapters-container-height-no-border: 250px;
  --chapters-container-height-hidden-tabs: 350px;
  --chapters-container-height: 292px;
  --chapters-container-height-hidden-tabs-no-border: 300px;
  --chapters-container-padding-right: 18px;
  --chapter-container-padding-top: 5px;
  --chapter-container-padding-bottom: 12px;
  --chapter-time-width: 60px;
  --chapter-title-width: 300px;
  --transcript-height: 285px;
  --transcript-height-no-chapters: 410px;
  --transcript-height-chapters-no-consults: 350px;
}

.popover-arrow,
.popover-arrow-border {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  border-left: var(--popover-arrow-size) solid transparent;
  border-right: var(--popover-arrow-size) solid transparent;
}

.popover-arrow {
  top: -9px;
  border-bottom: var(--popover-arrow-size) solid var(--md-primary-bg-color);
}

.popover-arrow-border {
  top: -10px;
  border-bottom: var(--popover-arrow-size) solid var(--md-menu-overlay-border-color, --gray-20);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/PlaybackRateView.ts":
/*!**************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/PlaybackRateView.ts ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PlaybackRateView: () => (/* binding */ PlaybackRateView)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../constants */ "./src/constants.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../constants */ "./src/components/QualityMonitoringWidget/constants.ts");
/* harmony import */ var _PlaybackRateView_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./PlaybackRateView.scss */ "./src/components/QualityMonitoringWidget/components/player/PlaybackRateView.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





/**
 * @element agentx-wc-audio-player-playback-rate-control
 * @fires playback-rate-changed
 */
let PlaybackRateView = class PlaybackRateView extends lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement {
    constructor() {
        super(...arguments);
        this.playbackRate = 1;
    }
    static get styles() {
        return _PlaybackRateView_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
    }
    handleKeydownEvent(event, speed) {
        var _a;
        if (event.code === _constants__WEBPACK_IMPORTED_MODULE_2__.Key.Space || event.code === _constants__WEBPACK_IMPORTED_MODULE_2__.Key.Enter) {
            this.handlePlaybackRateChanged(speed);
        }
        else if (event.code === _constants__WEBPACK_IMPORTED_MODULE_2__.Key.Escape) {
            const menuOverlay = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-menu-overlay");
            if (menuOverlay) {
                event.stopPropagation();
                menuOverlay.isOpen = false;
            }
        }
    }
    handlePlaybackRateChanged(speed) {
        var _a;
        this.dispatchEvent(new CustomEvent("playback-rate-changed", {
            detail: speed,
            bubbles: true,
            composed: true
        }));
        const menuOverlay = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-menu-overlay");
        if (menuOverlay) {
            menuOverlay.isOpen = false;
        }
    }
    get playbackOptions() {
        return _constants__WEBPACK_IMPORTED_MODULE_3__.QMW_RECORDINGS_PLAYBACK_RATES.map((speed) => {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <md-list-item
          slot="list-item"
          data-speed="${speed}"
          @click=${() => this.handlePlaybackRateChanged(speed)}
          @keydown="${(event) => this.handleKeydownEvent(event, speed)}}"
        >
          ${speed}X
        </md-list-item>
      `;
        });
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <md-tooltip message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioPlaybackSpeed")}" placement="top">
        <md-menu-overlay class="playback-overlay" custom-width="130px" allow-hover-toggle>
          <md-button
            variant="ghost"
            slot="menu-trigger"
            size=${_constants__WEBPACK_IMPORTED_MODULE_3__.QMW_RECORDINGS_PLAYER_BUTTON_SIZE}
            circle
            ariaExpanded="false"
            ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioPlaybackSpeed")}"
          >
            ${this.playbackRate}X
          </md-button>
          <div class="speed-overlay-container">
            <md-list label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.selectAudioPlaybackSpeed")}>${this.playbackOptions}</md-list>
            <div class="popover-arrow-border"></div>
            <div class="popover-arrow"></div>
          </div>
        </md-menu-overlay>
      </md-tooltip>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
], PlaybackRateView.prototype, "playbackRate", void 0);
PlaybackRateView = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-audio-player-playback-rate-control")
], PlaybackRateView);



/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/PlayerTime.scss":
/*!**********************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/PlayerTime.scss ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.player-time span {
  display: inline-block;
  min-width: 3em;
  text-align: center;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL1F1YWxpdHlNb25pdG9yaW5nV2lkZ2V0L2NvbXBvbmVudHMvcGxheWVyL1BsYXllclRpbWUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLHFCQUFBO0VBQ0EsY0FBQTtFQUNBLGtCQUFBO0FBQ0YiLCJzb3VyY2VzQ29udGVudCI6WyIucGxheWVyLXRpbWUgc3BhbiB7XG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgbWluLXdpZHRoOiAzZW07XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbn1cbiJdLCJzb3VyY2VSb290IjoiIn0= */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/PlayerTime.ts":
/*!********************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/PlayerTime.ts ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PlayerTime: () => (/* binding */ PlayerTime)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils */ "./src/components/QualityMonitoringWidget/utils.ts");
/* harmony import */ var _PlayerTime_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./PlayerTime.scss */ "./src/components/QualityMonitoringWidget/components/player/PlayerTime.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




/**
 * @element agentx-wc-audio-player-time
 */
let PlayerTime = class PlayerTime extends lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement {
    constructor() {
        super(...arguments);
        this.currentTime = 0;
        this.mainChapterLength = 0;
    }
    static get styles() {
        return _PlayerTime_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
    }
    render() {
        const time = (0,_utils__WEBPACK_IMPORTED_MODULE_2__.relativeTimeFormatter)(this.currentTime, this.mainChapterLength);
        const totalTime = (0,_utils__WEBPACK_IMPORTED_MODULE_2__.relativeTimeFormatter)(this.mainChapterLength, this.mainChapterLength);
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_1__.html) `<output class="player-time"> <span>${time}</span>/<span>${totalTime}</span> </output>`;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Number })
], PlayerTime.prototype, "currentTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Number })
], PlayerTime.prototype, "mainChapterLength", void 0);
PlayerTime = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("agentx-wc-audio-player-time")
], PlayerTime);



/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/Transcript.ts":
/*!********************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/Transcript.ts ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Transcript: () => (/* binding */ Transcript)
/* harmony export */ });
class Transcript {
    constructor(transcriptJson) {
        this.sentences = [];
        this.transcriptJson = transcriptJson;
        this.processTranscriptData();
    }
    processTranscriptData() {
        this.transcriptJson.responseContents.sort((a, b) => {
            var _a, _b, _c, _d;
            const aStartTime = ((_a = a.recognitionResult.alternatives[0].words[0]) === null || _a === void 0 ? void 0 : _a.start_time.seconds) * 1e9 +
                ((_b = a.recognitionResult.alternatives[0].words[0]) === null || _b === void 0 ? void 0 : _b.start_time.nanos);
            const bStartTime = ((_c = b.recognitionResult.alternatives[0].words[0]) === null || _c === void 0 ? void 0 : _c.start_time.seconds) * 1e9 +
                ((_d = b.recognitionResult.alternatives[0].words[0]) === null || _d === void 0 ? void 0 : _d.start_time.nanos);
            return aStartTime - bStartTime;
        });
        this.transcriptJson.responseContents.forEach((content) => {
            this.createSentence(content);
        });
    }
    createSentence(content) {
        content.recognitionResult.alternatives.forEach((alternative) => {
            var _a, _b, _c, _d;
            const sentence = {
                startTime: ((_a = alternative.words[0]) === null || _a === void 0 ? void 0 : _a.start_time.seconds) * 1000 + ((_b = alternative.words[0]) === null || _b === void 0 ? void 0 : _b.start_time.nanos) / 1e6,
                endTime: ((_c = alternative.words[alternative.words.length - 1]) === null || _c === void 0 ? void 0 : _c.end_time.seconds) * 1000 +
                    ((_d = alternative.words[alternative.words.length - 1]) === null || _d === void 0 ? void 0 : _d.end_time.nanos) / 1e6,
                speaker: content.recognitionResult.role,
                text: alternative.transcript
            };
            this.sentences.push(sentence);
        });
    }
    getSentences() {
        return this.sentences;
    }
}


/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/TranscriptMessageView.scss":
/*!*********************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/TranscriptMessageView.scss ***!
  \*********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.transcript-message-container {
  display: grid;
  grid-template-columns: 1fr auto;
}
.transcript-message-container .message {
  margin-left: 32px;
}
.transcript-message-container .timestamp {
  margin-right: 10px;
}
.transcript-message-container .is-active {
  font-weight: bold;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL1F1YWxpdHlNb25pdG9yaW5nV2lkZ2V0L2NvbXBvbmVudHMvcGxheWVyL1RyYW5zY3JpcHRNZXNzYWdlVmlldy5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBQTtFQUNBLCtCQUFBO0FBQ0Y7QUFDRTtFQUNFLGlCQUFBO0FBQ0o7QUFDRTtFQUNFLGtCQUFBO0FBQ0o7QUFDRTtFQUNFLGlCQUFBO0FBQ0oiLCJzb3VyY2VzQ29udGVudCI6WyIudHJhbnNjcmlwdC1tZXNzYWdlLWNvbnRhaW5lciB7XG4gIGRpc3BsYXk6IGdyaWQ7XG4gIGdyaWQtdGVtcGxhdGUtY29sdW1uczogMWZyIGF1dG87XG5cbiAgLm1lc3NhZ2Uge1xuICAgIG1hcmdpbi1sZWZ0OiAzMnB4O1xuICB9XG4gIC50aW1lc3RhbXAge1xuICAgIG1hcmdpbi1yaWdodDogMTBweDtcbiAgfVxuICAuaXMtYWN0aXZlIHtcbiAgICBmb250LXdlaWdodDogYm9sZDtcbiAgfVxufVxuIl0sInNvdXJjZVJvb3QiOiIifQ== */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/TranscriptMessageView.ts":
/*!*******************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/TranscriptMessageView.ts ***!
  \*******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TranscriptMessageView: () => (/* binding */ TranscriptMessageView)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Common_CellRenderers_components_TableAgentNameElement__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Common/CellRenderers/components/TableAgentNameElement */ "./src/components/Common/CellRenderers/components/TableAgentNameElement.ts");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils */ "./src/components/QualityMonitoringWidget/utils.ts");
/* harmony import */ var _TranscriptMessageView_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./TranscriptMessageView.scss */ "./src/components/QualityMonitoringWidget/components/player/TranscriptMessageView.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





/**
 * @element agentx-wc-transcript-message-view
 * @fires timestamp-clicked
 */
let TranscriptMessageView = class TranscriptMessageView extends lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement {
    constructor() {
        super(...arguments);
        this.playbackTime = 0;
        this.email = "";
    }
    static get styles() {
        return _TranscriptMessageView_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
    }
    dispatchTimestampClicked(milliseconds) {
        this.dispatchEvent(new CustomEvent("timestamp-clicked", {
            detail: { milliseconds },
            bubbles: true,
            composed: true
        }));
    }
    getIsActiveMessage() {
        return !!(this.transcriptSentence &&
            this.playbackTime >= this.transcriptSentence.startTime &&
            this.playbackTime <= this.transcriptSentence.endTime);
    }
    render() {
        var _a, _b, _c, _d;
        const hasValidTimes = !Number.isNaN((_a = this.transcriptSentence) === null || _a === void 0 ? void 0 : _a.startTime) && !Number.isNaN((_b = this.transcriptSentence) === null || _b === void 0 ? void 0 : _b.endTime);
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_1__.html) `
      ${this.transcriptSentence
            ? (0,lit_html__WEBPACK_IMPORTED_MODULE_1__.html) ` <div class="transcript-message-container">
            <div>
              <div class="agent-name">
                <agentx-wc-table-agent-name
                  .name=${(_c = this.transcriptSentence) === null || _c === void 0 ? void 0 : _c.speaker}
                  .email=${this.email}
                ></agentx-wc-table-agent-name>
              </div>
              <div class="message ${this.getIsActiveMessage() ? "is-active" : ""}">
                ${(_d = this.transcriptSentence) === null || _d === void 0 ? void 0 : _d.text}
              </div>
            </div>
            ${hasValidTimes
                ? (0,lit_html__WEBPACK_IMPORTED_MODULE_1__.html) `<md-link
                  class="timestamp ${this.getIsActiveMessage() ? "is-active" : ""}"
                  tag="span"
                  @click="${() => this.transcriptSentence && this.dispatchTimestampClicked(this.transcriptSentence.startTime)}"
                  >${(0,_utils__WEBPACK_IMPORTED_MODULE_3__.relativeTimeFormatter)(this.transcriptSentence.startTime)}</md-link
                >`
                : ""}
          </div>`
            : ""}
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Object })
], TranscriptMessageView.prototype, "transcriptSentence", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Number })
], TranscriptMessageView.prototype, "playbackTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: String })
], TranscriptMessageView.prototype, "email", void 0);
TranscriptMessageView = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("agentx-wc-transcript-message-view")
], TranscriptMessageView);



/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/TranscriptView.scss":
/*!**************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/TranscriptView.scss ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.transcript-container {
  padding-top: 24px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL1F1YWxpdHlNb25pdG9yaW5nV2lkZ2V0L2NvbXBvbmVudHMvcGxheWVyL1RyYW5zY3JpcHRWaWV3LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxpQkFBQTtBQUNGIiwic291cmNlc0NvbnRlbnQiOlsiLnRyYW5zY3JpcHQtY29udGFpbmVyIHtcbiAgcGFkZGluZy10b3A6IDI0cHg7XG59XG4iXSwic291cmNlUm9vdCI6IiJ9 */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/TranscriptView.ts":
/*!************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/TranscriptView.ts ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TranscriptView: () => (/* binding */ TranscriptView)
/* harmony export */ });
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _TranscriptMessageView__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./TranscriptMessageView */ "./src/components/QualityMonitoringWidget/components/player/TranscriptMessageView.ts");
/* harmony import */ var _TranscriptView_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./TranscriptView.scss */ "./src/components/QualityMonitoringWidget/components/player/TranscriptView.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





/**
 * @element agentx-wc-transcript-view
 * @fires transcript-clicked
 */
let TranscriptView = class TranscriptView extends lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement {
    constructor() {
        super(...arguments);
        this.playbackTime = 0;
        this.seekTime = 0;
        this.currentActiveElement = null;
    }
    updated(_changedProperties) {
        if (_changedProperties.has("seekTime")) {
            this.scrollToSentenceAtSeekTime();
        }
        super.updated(_changedProperties);
    }
    static get styles() {
        return _TranscriptView_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
    }
    scrollToSentenceAtSeekTime() {
        var _a;
        const transcriptMessages = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll("agentx-wc-transcript-message-view");
        if (transcriptMessages.length === 0) {
            _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.error("No transcript messages found");
            return;
        }
        const newActiveElement = Array.from(transcriptMessages).find((sentenceElement) => {
            const transcriptSentence = sentenceElement.transcriptSentence;
            return (transcriptSentence &&
                transcriptSentence.startTime <= this.seekTime &&
                transcriptSentence.endTime >= this.seekTime);
        });
        if (newActiveElement && newActiveElement !== this.currentActiveElement) {
            this.currentActiveElement = newActiveElement;
            this.currentActiveElement.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }
    dispatchTranscriptClicked(event) {
        this.dispatchEvent(new CustomEvent("transcript-clicked", {
            detail: { milliseconds: event.detail.milliseconds },
            bubbles: true,
            composed: true
        }));
    }
    render() {
        var _a;
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) ` <div class="transcript-container">
      ${(_a = this.customerTranscript) === null || _a === void 0 ? void 0 : _a.getSentences().map((sentence) => (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) `
          <agentx-wc-transcript-message-view
            @timestamp-clicked=${this.dispatchTranscriptClicked}
            .transcriptSentence=${sentence}
            .playbackTime=${this.playbackTime}
          ></agentx-wc-transcript-message-view>
          <br />
        `)}
    </div>`;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
], TranscriptView.prototype, "customerTranscript", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
], TranscriptView.prototype, "playbackTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
], TranscriptView.prototype, "seekTime", void 0);
TranscriptView = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-transcript-view")
], TranscriptView);



/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/VisualizerView.scss":
/*!**************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/VisualizerView.scss ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  --grid-header-height: 60px;
  --visualizer-title-width: 100px;
  --visualizer-title-margin-left: 24px;
  --visualizer-container-max-height: 40px;
  --visualizer-container-max-width: 900px;
  --visualizer-container-gap: 16px;
  --visualizer-bar-max-width: 577px;
  --visualizer-bar-max-height: 4px;
  --player-controls-row-height: 50px;
  --player-controls-gap: 8px;
  --volume-popover-width: 180px;
  --volume-popover-height: 21px;
  --volume-popover-gap: 12px;
  --volume-popover-top-offset: 120%;
  --volume-popover-left-offset: 50%;
  --volume-popover-padding: 12px;
  --seek-bar-height: 8px;
  --seek-bar-thumb-size: 16px;
  --seek-bar-top-margin: 16px;
  --seek-bar-bottom-margin: 8px;
  --popover-arrow-size: 10px;
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  --interaction-details-height: 220px;
  --interaction-details-vertical-padding: 12px;
  --interaction-details-optional-horizontal-margin: 24px;
  --interaction-details-item-bottom-margin: 4px;
  --interaction-details-item-grid-template-columns: 150px auto;
  --webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  --chapters-container-height: 292px;
  --chapters-container-height-no-border: 250px;
  --chapters-container-height-hidden-tabs: 350px;
  --chapters-container-height: 292px;
  --chapters-container-height-hidden-tabs-no-border: 300px;
  --chapters-container-padding-right: 18px;
  --chapter-container-padding-top: 5px;
  --chapter-container-padding-bottom: 12px;
  --chapter-time-width: 60px;
  --chapter-title-width: 300px;
  --transcript-height: 285px;
  --transcript-height-no-chapters: 410px;
  --transcript-height-chapters-no-consults: 350px;
}

.visualizers-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: var(--visualizer-container-gap);
  gap: var(--visualizer-container-gap);
}

.visualizer-container {
  display: flex;
  max-height: var(--visualizer-container-max-height);
  align-items: center;
  border-radius: 4px;
  border: 1px solid;
  cursor: pointer;
  border-color: var(--md-gray-20, #dedede);
  background-color: var(--md-primary-bg-color);
}

.visualizer-container:hover {
  background-color: var(--md-secondary-bg-color, #f7f7f7);
}

.visualizer-container:focus {
  border-color: var(--blue-40-color, #1170cf);
  background-color: var(--md-secondary-bg-color, #f7f7f7);
}

.containerSelected {
  border-color: var(--md-blue-60, #1170cf);
}

.visualizer-bar {
  flex-grow: 1;
  width: var(--visualizer-bar-max-width);
  height: var(--visualizer-bar-max-height);
  margin: 18px 21px;
  border-radius: 2px;
  background-color: var(--md-gray-20, #8d8f92);
}

.visualizer-title {
  flex: 1;
  max-width: var(--visualizer-title-width);
  margin-left: var(--visualizer-title-margin-left);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/VisualizerView.ts":
/*!************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/VisualizerView.ts ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   VisualizerView: () => (/* binding */ VisualizerView)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _css_variables_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @css/variables.scss */ "./src/assets/styles/variables.scss");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils */ "./src/components/QualityMonitoringWidget/utils.ts");
/* harmony import */ var _VisualizerView_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./VisualizerView.scss */ "./src/components/QualityMonitoringWidget/components/player/VisualizerView.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






/**
 * @element agentx-wc-visualizer-view
 * @fires visualizer-clicked
 */
let VisualizerView = class VisualizerView extends lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement {
    constructor() {
        super(...arguments);
        this.customerChapters = [];
        this.consultChapters = [];
        this.currentChapter = undefined;
        this.mainChapterLength = 0;
    }
    static get styles() {
        return _VisualizerView_scss__WEBPACK_IMPORTED_MODULE_5__["default"];
    }
    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        // Default first chapter to be selected
        this.currentChapter = this.customerChapters[0];
        // Update the visualizer bar styles based on the loaded chapters
        this.updateBarStyle();
        this.requestUpdate();
    }
    getVisualizerTitle(isCustomerVisualizer) {
        return isCustomerVisualizer ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.customer") : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.consult");
    }
    handleVisualizerClick(isCustomerVisualizer) {
        this.dispatchEvent(new CustomEvent("visualizer-clicked", {
            detail: isCustomerVisualizer,
            bubbles: true,
            composed: true
        }));
    }
    updateBarStyle() {
        var _a, _b;
        const customerBar = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById("customer-bar");
        const consultBar = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.getElementById("consult-bar");
        const customerBarStyle = (0,_utils__WEBPACK_IMPORTED_MODULE_4__.generateLinearStylingForChaptersView)(true, this.customerChapters, this.mainChapterLength);
        const consultBarStyle = (0,_utils__WEBPACK_IMPORTED_MODULE_4__.generateLinearStylingForChaptersView)(false, this.consultChapters, this.mainChapterLength);
        if (customerBar) {
            customerBar.style.background = `linear-gradient(to right, ${customerBarStyle})`;
        }
        if (consultBar) {
            consultBar.style.background = `linear-gradient(to right, ${consultBarStyle})`;
        }
    }
    getVisualizerStyleClass(isCustomerVisualizer) {
        var _a, _b;
        return isCustomerVisualizer === ((_b = (_a = this.currentChapter) === null || _a === void 0 ? void 0 : _a.getIsCustomerChapter()) !== null && _b !== void 0 ? _b : false) ? "containerSelected" : "";
    }
    renderVisualizer(isCustomerVisualizer) {
        if (this.consultChapters.length > 0) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div
          class="visualizer-container ${this.getVisualizerStyleClass(isCustomerVisualizer)}"
          id="${isCustomerVisualizer ? "customer-container" : "consult-container"}"
          tabindex="0"
          aria-label=${this.getVisualizerTitle(isCustomerVisualizer)}
          @click="${() => this.handleVisualizerClick(isCustomerVisualizer)}"
          @keydown="${() => this.handleVisualizerClick(isCustomerVisualizer)}"
        >
          <h4 class="visualizer-title">${this.getVisualizerTitle(isCustomerVisualizer)}</h4>
          <div class="visualizer-bar" id=${isCustomerVisualizer ? "customer-bar" : "consult-bar"}></div>
        </div>
      `;
        }
        else {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="visualizer-container selected">
          <div class="visualizer-bar" id="customer-bar"></div>
        </div>
      `;
        }
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
      <div class="visualizers-container">
        ${this.renderVisualizer(true)} ${this.consultChapters.length > 0 ? this.renderVisualizer(false) : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Array })
], VisualizerView.prototype, "customerChapters", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Array })
], VisualizerView.prototype, "consultChapters", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
], VisualizerView.prototype, "currentChapter", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Number })
], VisualizerView.prototype, "mainChapterLength", void 0);
VisualizerView = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-visualizer-view")
], VisualizerView);



/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/VolumeControlView.scss":
/*!*****************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/VolumeControlView.scss ***!
  \*****************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  --grid-header-height: 60px;
  --visualizer-title-width: 100px;
  --visualizer-title-margin-left: 24px;
  --visualizer-container-max-height: 40px;
  --visualizer-container-max-width: 900px;
  --visualizer-container-gap: 16px;
  --visualizer-bar-max-width: 577px;
  --visualizer-bar-max-height: 4px;
  --player-controls-row-height: 50px;
  --player-controls-gap: 8px;
  --volume-popover-width: 180px;
  --volume-popover-height: 21px;
  --volume-popover-gap: 12px;
  --volume-popover-top-offset: 120%;
  --volume-popover-left-offset: 50%;
  --volume-popover-padding: 12px;
  --seek-bar-height: 8px;
  --seek-bar-thumb-size: 16px;
  --seek-bar-top-margin: 16px;
  --seek-bar-bottom-margin: 8px;
  --popover-arrow-size: 10px;
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  --interaction-details-height: 220px;
  --interaction-details-vertical-padding: 12px;
  --interaction-details-optional-horizontal-margin: 24px;
  --interaction-details-item-bottom-margin: 4px;
  --interaction-details-item-grid-template-columns: 150px auto;
  --webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  --chapters-container-height: 292px;
  --chapters-container-height-no-border: 250px;
  --chapters-container-height-hidden-tabs: 350px;
  --chapters-container-height: 292px;
  --chapters-container-height-hidden-tabs-no-border: 300px;
  --chapters-container-padding-right: 18px;
  --chapter-container-padding-top: 5px;
  --chapter-container-padding-bottom: 12px;
  --chapter-time-width: 60px;
  --chapter-title-width: 300px;
  --transcript-height: 285px;
  --transcript-height-no-chapters: 410px;
  --transcript-height-chapters-no-consults: 350px;
}

.volume-container {
  position: relative;
  display: inline-block;
  z-index: 1;
}

.volume-popover {
  display: none;
  position: absolute;
  top: var(--volume-popover-top-offset);
  left: var(--volume-popover-left-offset);
  transform: translateX(-50%);
  background-color: var(--md-primary-bg-color);
  border: 1px solid var(--md-menu-overlay-border-color, --gray-20);
  padding: var(--volume-popover-padding);
  width: var(--volume-popover-width);
  height: var(--volume-popover-height);
  border-radius: var(--border-radius-medium);
  align-items: center;
  justify-content: space-between;
  gap: var(--volume-popover-gap);
}

.volume-container:hover .volume-popover {
  display: flex;
}

.popover-arrow,
.popover-arrow-border {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  border-left: var(--popover-arrow-size) solid transparent;
  border-right: var(--popover-arrow-size) solid transparent;
}

.popover-arrow {
  top: -9px;
  border-bottom: var(--popover-arrow-size) solid var(--md-primary-bg-color);
}

.popover-arrow-border {
  top: -10px;
  border-bottom: var(--popover-arrow-size) solid var(--md-menu-overlay-border-color, --gray-20);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/VolumeControlView.ts":
/*!***************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/VolumeControlView.ts ***!
  \***************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   VolumeControlView: () => (/* binding */ VolumeControlView)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../constants */ "./src/constants.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../constants */ "./src/components/QualityMonitoringWidget/constants.ts");
/* harmony import */ var _VolumeControlView_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./VolumeControlView.scss */ "./src/components/QualityMonitoringWidget/components/player/VolumeControlView.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





/**
 * @element agentx-wc-audio-player-volume-control
 * @fires volume-changed
 */
let VolumeControlView = class VolumeControlView extends lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement {
    constructor() {
        super(...arguments);
        this.volume = 50;
        this.preMutedVolume = 50;
    }
    static get styles() {
        return _VolumeControlView_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
    }
    get buttonIcon() {
        return this.volume === 0 ? "icon-speaker-disconnected_16" : "icon-speaker_16";
    }
    dispatchVolumeControlChangeEvent() {
        this.dispatchEvent(new CustomEvent("volume-changed", {
            detail: this.volume,
            bubbles: true,
            composed: true
        }));
    }
    handleButtonClick() {
        if (this.volume === 0) {
            this.volume = this.preMutedVolume;
        }
        else {
            this.preMutedVolume = this.volume;
            this.volume = 0;
        }
        this.dispatchVolumeControlChangeEvent();
    }
    isMuted() {
        return this.volume === 0;
    }
    handleVolumeChanged(e) {
        var _a;
        const popover = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".volume-popover");
        const popoverStyle = window.getComputedStyle(popover);
        if (popoverStyle.display === "none") {
            return;
        }
        const newVolume = e.detail.value;
        this.volume = newVolume;
        this.dispatchVolumeControlChangeEvent();
    }
    handleKeydownEvent(event) {
        var _a, _b;
        const popover = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".volume-popover");
        const popoverStyle = window.getComputedStyle(popover);
        if (event.code === _constants__WEBPACK_IMPORTED_MODULE_2__.Key.Enter || event.code === _constants__WEBPACK_IMPORTED_MODULE_2__.Key.Space) {
            if (popoverStyle.display === "none") {
                event.stopPropagation();
                popover.style.display = "flex";
                const slider = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("md-slider");
                slider.focus();
                return;
            }
        }
        else if (event.code === _constants__WEBPACK_IMPORTED_MODULE_2__.Key.Escape) {
            event.stopPropagation();
            popover.style.display = "none";
        }
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <div class="volume-container">
        <md-tooltip
          message="${this.isMuted() ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioVolumeUnmuteBtn") : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioVolumeMuteBtn")}"
          placement="top"
        >
          <md-button
            variant="ghost"
            circle
            class="volume-button"
            ariaLabel="${this.isMuted() ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioVolumeUnmuteBtn") : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioVolumeMuteBtn")}"
            size=${_constants__WEBPACK_IMPORTED_MODULE_3__.QMW_RECORDINGS_PLAYER_BUTTON_SIZE}
            @click=${this.handleButtonClick}
            @keydown="${(event) => {
            this.handleKeydownEvent(event);
        }}"
          >
            <md-icon slot="icon" name=${this.buttonIcon}></md-icon>
          </md-button>
        </md-tooltip>
        <div class="volume-popover">
          <md-icon slot="icon" name="icon-speaker-disconnected_16"></md-icon>
          <md-slider
            @slider-change=${this.handleVolumeChanged}
            ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioVolumeSlider")}
            hide-value="true"
            now=${this.volume}
            @keydown="${this.handleKeydownEvent}"
          ></md-slider>
          <md-icon slot="icon" name="icon-speaker_16"></md-icon>
          <div class="popover-arrow-border"></div>
          <div class="popover-arrow"></div>
        </div>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
], VolumeControlView.prototype, "volume", void 0);
VolumeControlView = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-audio-player-volume-control")
], VolumeControlView);



/***/ }),

/***/ "./src/components/QualityMonitoringWidget/config.ts":
/*!**********************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/config.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   autoCSatTemplate: () => (/* binding */ autoCSatTemplate),
/* harmony export */   getAgent: () => (/* binding */ getAgent),
/* harmony export */   getAutoCsat: () => (/* binding */ getAutoCsat),
/* harmony export */   getBaseGridConfigs: () => (/* binding */ getBaseGridConfigs),
/* harmony export */   getDate: () => (/* binding */ getDate),
/* harmony export */   getDuration: () => (/* binding */ getDuration),
/* harmony export */   getQueue: () => (/* binding */ getQueue),
/* harmony export */   getTeam: () => (/* binding */ getTeam),
/* harmony export */   suppressKeyboardEvent: () => (/* binding */ suppressKeyboardEvent)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _TeamPerformanceWidget_utils_KeyboardNavigationUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../TeamPerformanceWidget/utils/KeyboardNavigationUtils */ "./src/components/TeamPerformanceWidget/utils/KeyboardNavigationUtils.ts");
/* harmony import */ var _components_ActionsRenderer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./components/ActionsRenderer */ "./src/components/QualityMonitoringWidget/components/ActionsRenderer.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./constants */ "./src/components/QualityMonitoringWidget/constants.ts");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./utils */ "./src/components/QualityMonitoringWidget/utils.ts");






const getAgent = (params) => {
    return params.data.owner.name;
};
const getTeam = (params) => {
    return params.data.lastTeam.name;
};
const getAutoCsat = (params) => {
    var _a;
    return (_a = params.data.autoCsat) !== null && _a !== void 0 ? _a : 0;
};
const getQueue = (params) => {
    return params.data.lastQueue.name;
};
const getDuration = (params) => {
    return luxon__WEBPACK_IMPORTED_MODULE_1__.Duration.fromMillis(params.data.connectedDuration).shiftTo("hours", "minutes", "seconds").toFormat("hh:mm:ss");
};
const getDate = (params) => {
    return (0,_utils__WEBPACK_IMPORTED_MODULE_5__.dateFormatterShortWithSeconds)(params.data.createdTime);
};
const suppressKeyboardEvent = (params) => {
    const { event } = params;
    if (event.code === "Tab" || event.key === "Tab") {
        const cellElement = event.target instanceof HTMLElement ? event.target.closest(".ag-cell") : null;
        if (!cellElement) {
            return false; // Cell element not found, do not suppress
        }
        const focusableChildElements = cellElement.querySelectorAll('button, [href], input:not(.ag-hidden), select, textarea, [tabindex]:not([tabindex="-1"])');
        const forwardTab = !event.shiftKey;
        const reverseTab = event.shiftKey;
        const lastFocusableElement = focusableChildElements[focusableChildElements.length - 1];
        const firstFocusableElement = focusableChildElements[0];
        if (focusableChildElements.length === 0 ||
            (forwardTab && event.target === lastFocusableElement) ||
            (reverseTab && event.target === firstFocusableElement)) {
            return false; // Do not suppress
        }
        else if (reverseTab && event.target === cellElement) {
            event.preventDefault();
            firstFocusableElement.focus(); // Set focus on the first focusable child element
            return true; // Suppress
        }
        return true; // Suppress
    }
    else {
        return false; // Do not suppress by default
    }
};
const autoCSatTemplate = (params) => {
    return `<div class="ag-cell-label-container" role="presentation">
  <span data-ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>
  <span data-ref="eFilterButton" class="ag-header-icon ag-header-cell-filter-button" aria-hidden="true"></span>
  <div data-ref="eLabel" class="ag-header-cell-label" role="presentation" style="display: flex; justify-content: space-between; align-items: center;">
    <span data-ref="eText" class="ag-header-cell-text">${params.text}</span>
    <md-tooltip placement="top" message="${params.tooltip}">
      <md-icon aria-label="${params.tooltip}" iconSet="momentumDesign" name="info-badge-filled"></md-icon>
    </md-tooltip>
  </div>
</div>`;
};
const getBaseGridConfigs = (configs) => {
    return {
        components: {
            actionsRenderer: _components_ActionsRenderer__WEBPACK_IMPORTED_MODULE_3__["default"]
        },
        columnDefs: [
            {
                field: "id",
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.sessionId")}`,
                suppressHeaderMenuButton: true,
                width: _constants__WEBPACK_IMPORTED_MODULE_4__.SESSION_ID_COLUMN_WIDTH
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.queue")}`,
                suppressHeaderMenuButton: true,
                valueGetter: getQueue
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.team")}`,
                suppressHeaderMenuButton: true,
                valueGetter: getTeam
            },
            {
                field: "autoCSAT",
                hide: !configs().isAutoCsatEnabled,
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.autoCsat")}`,
                suppressHeaderMenuButton: true,
                valueGetter: getAutoCsat,
                headerComponentParams: {
                    template: autoCSatTemplate({
                        text: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.autoCsat"),
                        tooltip: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.autoCsatTooltip")
                    })
                }
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.agent")}`,
                suppressHeaderMenuButton: true,
                valueGetter: getAgent
            },
            {
                field: "origin",
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.ani")}`,
                suppressHeaderMenuButton: true
            },
            {
                field: "destination",
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.dnis")}`,
                suppressHeaderMenuButton: true
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.duration")}`,
                suppressHeaderMenuButton: true,
                valueGetter: getDuration
            },
            {
                field: "lastWrapupCodeName",
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.wrapupCodes")}`,
                suppressHeaderMenuButton: true
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.date")}`,
                suppressHeaderMenuButton: true,
                valueGetter: getDate
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.actions")}`,
                suppressHeaderMenuButton: true,
                pinned: "right",
                lockPinned: true,
                cellRenderer: "actionsRenderer",
                field: "actions",
                width: 117,
                cellEditorParams: {
                    i18n: {
                        playRecording: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.playRecording"),
                        evaluateTask: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.evaluateTask")
                    }
                }
            }
        ],
        defaultColDef: {
            suppressKeyboardEvent,
            suppressHeaderKeyboardEvent: _TeamPerformanceWidget_utils_KeyboardNavigationUtils__WEBPACK_IMPORTED_MODULE_2__.suppressHeaderKeyboardEvent,
            resizable: true,
            sortable: false
        },
        columnMenu: "legacy",
        rowModelType: "serverSide",
        cacheBlockSize: _constants__WEBPACK_IMPORTED_MODULE_4__.MAX_ROWS_IN_RESPONSE,
        maxBlocksInCache: 2,
        suppressContextMenu: true,
        blockLoadDebounceMillis: 1000,
        suppressAnimationFrame: true,
        animateRows: false,
        localeText: {
            loadingOoo: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app.ag-grid.loading")
        }
    };
};


/***/ }),

/***/ "./src/components/QualityMonitoringWidget/constants.ts":
/*!*************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/constants.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   COPY_CLICK_TIMEOUT: () => (/* binding */ COPY_CLICK_TIMEOUT),
/* harmony export */   GRID: () => (/* binding */ GRID),
/* harmony export */   MAX_ROWS_IN_RESPONSE: () => (/* binding */ MAX_ROWS_IN_RESPONSE),
/* harmony export */   QMW_ACTIONS_BTN_CLICK: () => (/* binding */ QMW_ACTIONS_BTN_CLICK),
/* harmony export */   QMW_AUDIO_PLAYER_CONTROL_CLICKED: () => (/* binding */ QMW_AUDIO_PLAYER_CONTROL_CLICKED),
/* harmony export */   QMW_ERR_RETRY: () => (/* binding */ QMW_ERR_RETRY),
/* harmony export */   QMW_EVALUATE_BTN_CLICK: () => (/* binding */ QMW_EVALUATE_BTN_CLICK),
/* harmony export */   QMW_FILTERS_UPDATED: () => (/* binding */ QMW_FILTERS_UPDATED),
/* harmony export */   QMW_RECORDINGS_MODAL_CLOSE_BTN_CLK: () => (/* binding */ QMW_RECORDINGS_MODAL_CLOSE_BTN_CLK),
/* harmony export */   QMW_RECORDINGS_PLAYBACK_RATES: () => (/* binding */ QMW_RECORDINGS_PLAYBACK_RATES),
/* harmony export */   QMW_RECORDINGS_PLAYER_BUTTON_SIZE: () => (/* binding */ QMW_RECORDINGS_PLAYER_BUTTON_SIZE),
/* harmony export */   RECORDING: () => (/* binding */ RECORDING),
/* harmony export */   SESSION_ID_COLUMN_WIDTH: () => (/* binding */ SESSION_ID_COLUMN_WIDTH),
/* harmony export */   SET_ACTIVE_AGENT_ID: () => (/* binding */ SET_ACTIVE_AGENT_ID),
/* harmony export */   TRANSCRIPT_LOADED: () => (/* binding */ TRANSCRIPT_LOADED)
/* harmony export */ });
const COPY_CLICK_TIMEOUT = 500;
const GRID = "GRID";
const MAX_ROWS_IN_RESPONSE = 500;
const QMW_ACTIONS_BTN_CLICK = "qmw-play-btn-clicked";
const QMW_EVALUATE_BTN_CLICK = "qmw-evaluate-btn-clicked";
const QMW_ERR_RETRY = "qmw-error-retry";
const QMW_RECORDINGS_MODAL_CLOSE_BTN_CLK = "qmw-recordings-modal-close-btn-clicked";
const QMW_AUDIO_PLAYER_CONTROL_CLICKED = "qmw-audio-player-action-clicked";
const RECORDING = "RECORDING";
const SESSION_ID_COLUMN_WIDTH = 350;
const QMW_FILTERS_UPDATED = "qmw-filters-updated";
const QMW_RECORDINGS_PLAYBACK_RATES = [0.5, 0.75, 1, 1.25, 1.5, 2];
const QMW_RECORDINGS_PLAYER_BUTTON_SIZE = 40;
const TRANSCRIPT_LOADED = "transcript-loaded";
const SET_ACTIVE_AGENT_ID = "set-active-agent-id";


/***/ }),

/***/ "./src/components/QualityMonitoringWidget/utils.ts":
/*!*********************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/utils.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ChapterType: () => (/* binding */ ChapterType),
/* harmony export */   RecordingEvent: () => (/* binding */ RecordingEvent),
/* harmony export */   createArrayOfAgents: () => (/* binding */ createArrayOfAgents),
/* harmony export */   createCaptureData: () => (/* binding */ createCaptureData),
/* harmony export */   dateFormatterShortWithSeconds: () => (/* binding */ dateFormatterShortWithSeconds),
/* harmony export */   errorIsRetryable: () => (/* binding */ errorIsRetryable),
/* harmony export */   generateLinearStylingForChaptersView: () => (/* binding */ generateLinearStylingForChaptersView),
/* harmony export */   isCustomerTrack: () => (/* binding */ isCustomerTrack),
/* harmony export */   relativeTimeFormatter: () => (/* binding */ relativeTimeFormatter),
/* harmony export */   wait: () => (/* binding */ wait)
/* harmony export */ });
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_1__);


const dateFormatterShortWithSeconds = (dateInMilliseconds) => {
    return luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.fromMillis(dateInMilliseconds).toFormat("D tt");
};
const relativeTimeFormatter = (timeInMilliseconds, totalTimeInMilliSeconds = 0) => {
    if (totalTimeInMilliSeconds <= timeInMilliseconds) {
        totalTimeInMilliSeconds = timeInMilliseconds;
    }
    let format = "mm:ss";
    if (luxon__WEBPACK_IMPORTED_MODULE_1__.Duration.fromMillis(totalTimeInMilliSeconds).as("hours") >= 1) {
        format = "hh:mm:ss";
    }
    return luxon__WEBPACK_IMPORTED_MODULE_1__.Duration.fromMillis(timeInMilliseconds).shiftTo("hours", "minutes", "seconds").toFormat(format);
};
const errorIsRetryable = (errorDetails) => {
    const { statusCode, retryAfter } = errorDetails;
    return statusCode === 429 && !!retryAfter;
};
const wait = (errorDetails) => {
    const { retryAfter } = errorDetails;
    return new Promise((resolve) => setTimeout(resolve, retryAfter));
};
var ChapterType;
(function (ChapterType) {
    ChapterType["Main"] = "Main";
    ChapterType["Hold"] = "Hold";
    ChapterType["Customer"] = "Customer";
    ChapterType["ConsultRequest"] = "ConsultRequest";
    ChapterType["Consulting"] = "Consulting";
    ChapterType["Conferencing"] = "Conferencing";
})(ChapterType || (ChapterType = {}));
const isCustomerTrack = (chapterType) => {
    return (chapterType === ChapterType.Customer ||
        chapterType === ChapterType.Conferencing ||
        chapterType === ChapterType.Hold ||
        chapterType === ChapterType.Main);
};
var RecordingEvent;
(function (RecordingEvent) {
    RecordingEvent["JOIN_CONFERENCE"] = "join-conference";
    RecordingEvent["CONFERENCE_DONE"] = "conference-done";
    RecordingEvent["FABRICATED_CONFERENCE_LEAVE"] = "fabricated-conference-leave";
    RecordingEvent["FABRICATED_HOLD_DONE"] = "fabricated-hold-done";
    RecordingEvent["HOLD"] = "on-hold";
    RecordingEvent["ENDED"] = "ended";
    RecordingEvent["RECORDING_AVAILABLE"] = "recording-available";
    RecordingEvent["RECORDING_STARTED"] = "recording-started";
    RecordingEvent["CONSULT_REQUESTED"] = "consult";
    RecordingEvent["CONSULT_DONE"] = "consult-done";
    RecordingEvent["CONSULTING"] = "consulting";
})(RecordingEvent || (RecordingEvent = {}));
const createArrayOfAgents = (primaryAgentName, metaData, chapterType) => {
    if (metaData.length <= 0) {
        return [];
    }
    return Array.from(new Set(metaData
        .filter((chapterMetaData) => chapterMetaData.chapterType === chapterType)
        .flatMap((chapterMetaData) => chapterMetaData.involvedAgentNames)
        .filter((agentName) => agentName !== primaryAgentName)));
};
const MIN_NUMBER_AGENTS_IN_CONFERENCE = 2;
const MAXIMUM_SUPPORTED_EVENTS = 100;
/**
 * Generates fabricated leave conference and hold done events based on the given capture metadata.
 * The event fabrication mainly accounts for consuming events in chronological order to track 'involvedAgentsInConference' and 'lastChapter' correctly.
 * The events from /search endpoint may overlap in the case of conferences, such as hold events, agent leaving the call , or agent joining the call.
 * Reasons to fabricate:
 * - Leave conference event: because there is no explicit event for it from /search.
 * - Hold done event: because hold-done events from /search cannot be trusted (e.g., unexpected isolated hold-done event during conferences). Bug: CX-16318
 *
 * @param captureMetaDatas - The capture metadata containing the events.
 * @returns The fabricated leave conference and hold done events.
 */
const generateFabricatedLeaveConferenceAndHoldDoneEvents = (captureMetaDatas) => {
    const joinConferenceAndHoldEvents = captureMetaDatas.filter((captureMetaData) => captureMetaData.eventName === RecordingEvent.JOIN_CONFERENCE || captureMetaData.eventName === RecordingEvent.HOLD);
    const fabricatedLeaveConferenceAndHoldDoneEvents = [];
    joinConferenceAndHoldEvents.sort((a, b) => a.createdTime - b.createdTime);
    joinConferenceAndHoldEvents.forEach((event) => {
        if (event.eventName === RecordingEvent.JOIN_CONFERENCE) {
            fabricatedLeaveConferenceAndHoldDoneEvents.push({
                eventName: RecordingEvent.FABRICATED_CONFERENCE_LEAVE,
                createdTime: event.endedTime,
                endedTime: event.endedTime,
                agentName: event.agentName,
                duration: 0,
                destinationAgentName: event.destinationAgentName
            });
        }
        else if (event.eventName === RecordingEvent.HOLD) {
            fabricatedLeaveConferenceAndHoldDoneEvents.push({
                eventName: RecordingEvent.FABRICATED_HOLD_DONE,
                createdTime: event.endedTime,
                endedTime: event.endedTime,
                agentName: event.agentName,
                duration: 0,
                destinationAgentName: event.destinationAgentName
            });
        }
    });
    fabricatedLeaveConferenceAndHoldDoneEvents.sort((a, b) => a.createdTime - b.createdTime);
    return fabricatedLeaveConferenceAndHoldDoneEvents;
};
const addNewCustomerChapter = (startTime, endTime, mainRecordingFilePath, customerChaptersMetaData) => {
    customerChaptersMetaData.push({
        chapterType: ChapterType.Customer,
        startTime,
        endTime,
        involvedAgentNames: [],
        fileLocation: mainRecordingFilePath
    });
};
const removeAgentNameFromArray = (agentName, agentNames) => {
    const index = agentNames.indexOf(agentName);
    if (index > -1) {
        agentNames.splice(index, 1);
    }
};
const updateChapterEndTime = (chapter, endTime) => {
    if (chapter) {
        chapter.endTime = endTime;
    }
};
const handleEventDuringHold = (involvedAgentsInConference, event) => {
    if (event.eventName === RecordingEvent.JOIN_CONFERENCE) {
        involvedAgentsInConference.push(event.agentName);
    }
    else if (event.eventName === RecordingEvent.FABRICATED_CONFERENCE_LEAVE) {
        removeAgentNameFromArray(event.agentName, involvedAgentsInConference);
    }
};
const handleEventHoldDone = (lastChapter, customerChaptersMetaData, mainRecordingFilePath, involvedAgentsInConference, event) => {
    if (involvedAgentsInConference.length >= MIN_NUMBER_AGENTS_IN_CONFERENCE) {
        updateChapterEndTime(lastChapter, event.createdTime);
        customerChaptersMetaData.push({
            chapterType: ChapterType.Conferencing,
            startTime: event.createdTime,
            endTime: -1,
            involvedAgentNames: [...involvedAgentsInConference],
            fileLocation: mainRecordingFilePath
        });
    }
    else if ((lastChapter === null || lastChapter === void 0 ? void 0 : lastChapter.chapterType) === ChapterType.Customer) {
        updateChapterEndTime(lastChapter, event.endedTime);
    }
    else {
        updateChapterEndTime(lastChapter, event.createdTime);
        addNewCustomerChapter(event.createdTime, -1, mainRecordingFilePath, customerChaptersMetaData);
    }
};
const handleEventAgentJoinsConference = (lastChapter, customerChaptersMetaData, mainRecordingFilePath, involvedAgentsInConference, event) => {
    involvedAgentsInConference.push(event.agentName);
    if (lastChapter &&
        lastChapter.chapterType === ChapterType.Conferencing &&
        lastChapter.startTime === event.createdTime) {
        // Collapse two consecutive join-conference chapters together - this is the start of a new conference
        lastChapter.involvedAgentNames.push(event.agentName);
        return;
    }
    updateChapterEndTime(lastChapter, event.createdTime);
    customerChaptersMetaData.push({
        chapterType: ChapterType.Conferencing,
        startTime: event.createdTime,
        endTime: event.endedTime,
        involvedAgentNames: [...involvedAgentsInConference],
        fileLocation: mainRecordingFilePath
    });
};
const generateConsultChapters = (captureMetaDatas) => {
    const consultChaptersMetaData = [];
    const consultEvents = captureMetaDatas.filter((captureMetaData) => captureMetaData.eventName === RecordingEvent.CONSULT_REQUESTED ||
        captureMetaData.eventName === RecordingEvent.CONSULTING ||
        captureMetaData.eventName === RecordingEvent.CONSULT_DONE);
    consultEvents.sort((a, b) => a.createdTime - b.createdTime);
    consultEvents.forEach((currentEvent) => {
        const involvedAgents = [currentEvent.agentName].concat(currentEvent.destinationAgentName);
        if (currentEvent.eventName === RecordingEvent.CONSULT_REQUESTED) {
            consultChaptersMetaData.push({
                chapterType: ChapterType.ConsultRequest,
                startTime: currentEvent.createdTime,
                endTime: currentEvent.endedTime,
                involvedAgentNames: involvedAgents,
                fileLocation: ""
            });
        }
        else if (currentEvent.eventName === RecordingEvent.CONSULTING) {
            if (consultChaptersMetaData.length > 0) {
                updateChapterEndTime(consultChaptersMetaData[consultChaptersMetaData.length - 1], currentEvent.createdTime);
            }
            consultChaptersMetaData.push({
                chapterType: ChapterType.Consulting,
                startTime: currentEvent.createdTime,
                endTime: currentEvent.endedTime,
                involvedAgentNames: involvedAgents,
                fileLocation: ""
            });
        }
    });
    return consultChaptersMetaData;
};
const generateCustomerChapters = (captureMetaDatas, mainRecordingFilePath) => {
    const customerChaptersMetaData = [];
    const involvedAgentsInConference = [];
    const fabricatedLeaveConferenceAndHoldDoneEvents = generateFabricatedLeaveConferenceAndHoldDoneEvents(captureMetaDatas);
    let customerEvents = captureMetaDatas.filter((captureMetaData) => captureMetaData.eventName !== RecordingEvent.CONSULT_REQUESTED &&
        captureMetaData.eventName !== RecordingEvent.CONSULTING &&
        captureMetaData.eventName !== RecordingEvent.CONSULT_DONE);
    customerEvents = [...customerEvents, ...fabricatedLeaveConferenceAndHoldDoneEvents];
    customerEvents.sort((a, b) => a.createdTime - b.createdTime);
    customerEvents.forEach((event) => {
        const lastChapter = customerChaptersMetaData.length > 0 ? customerChaptersMetaData[customerChaptersMetaData.length - 1] : null;
        if (event.eventName === RecordingEvent.RECORDING_STARTED) {
            addNewCustomerChapter(event.createdTime, -1, mainRecordingFilePath, customerChaptersMetaData);
            return;
        }
        if (event.eventName === RecordingEvent.ENDED) {
            updateChapterEndTime(lastChapter, event.createdTime);
            return;
        }
        if (event.eventName === RecordingEvent.HOLD) {
            updateChapterEndTime(lastChapter, event.createdTime);
            customerChaptersMetaData.push({
                chapterType: ChapterType.Hold,
                startTime: event.createdTime,
                endTime: event.endedTime,
                involvedAgentNames: [],
                fileLocation: mainRecordingFilePath
            });
            return;
        }
        // Currently ongoing hold
        if (lastChapter && lastChapter.chapterType === ChapterType.Hold && event.createdTime < lastChapter.endTime) {
            handleEventDuringHold(involvedAgentsInConference, event);
            return;
        }
        // Customer/Conference off hold
        if (event.eventName === RecordingEvent.FABRICATED_HOLD_DONE) {
            handleEventHoldDone(lastChapter, customerChaptersMetaData, mainRecordingFilePath, involvedAgentsInConference, event);
            return;
        }
        // Agent leaves conference
        if (event.eventName === RecordingEvent.FABRICATED_CONFERENCE_LEAVE) {
            removeAgentNameFromArray(event.agentName, involvedAgentsInConference);
            // Check if the conference is still ongoing
            if (involvedAgentsInConference.length >= MIN_NUMBER_AGENTS_IN_CONFERENCE) {
                updateChapterEndTime(lastChapter, event.createdTime);
                customerChaptersMetaData.push({
                    chapterType: ChapterType.Conferencing,
                    startTime: event.createdTime,
                    endTime: -1,
                    involvedAgentNames: [...involvedAgentsInConference],
                    fileLocation: mainRecordingFilePath
                });
            }
            return;
        }
        // Conference ends
        if (event.eventName === RecordingEvent.CONFERENCE_DONE) {
            if (involvedAgentsInConference.length >= MIN_NUMBER_AGENTS_IN_CONFERENCE) {
                updateChapterEndTime(lastChapter, event.createdTime);
                addNewCustomerChapter(event.createdTime, event.endedTime, mainRecordingFilePath, customerChaptersMetaData);
                involvedAgentsInConference.splice(0, involvedAgentsInConference.length);
            }
            return;
        }
        // Agent joins conference
        if (event.eventName === RecordingEvent.JOIN_CONFERENCE) {
            handleEventAgentJoinsConference(lastChapter, customerChaptersMetaData, mainRecordingFilePath, involvedAgentsInConference, event);
        }
    });
    return customerChaptersMetaData;
};
const createCustomerChapterFromMainRecording = (recordingDatas) => {
    const customerChaptersMetaData = [];
    const mainRecording = recordingDatas.find((data) => data.segment === false && data.attributes.callType === "main");
    if (mainRecording) {
        addNewCustomerChapter(mainRecording.attributes.startTime, mainRecording.attributes.stopTime, mainRecording.attributes.filePath, customerChaptersMetaData);
    }
    return customerChaptersMetaData;
};
/**
 * Creates the capture data for the Quality Monitoring Widget.
 *
 * @param recordingDatas - An array of recording data.
 * @param captureMetaDatas - An array of capture metadata.
 * @returns The customer and consult chapter metadata.
 */
const createCaptureData = (recordingDatas, captureMetaDatas) => {
    var _a, _b;
    const returnChapterMetaDatas = {
        customerChaptersMetaData: [],
        consultChaptersMetaData: []
    };
    if (recordingDatas.length === 0) {
        return returnChapterMetaDatas;
    }
    // If the captureMetaData is >= 100, it means that the search endpoint has returned the maximum client-supported number of events
    // However, if the recording is available, we can generate a single customer chapter
    if (captureMetaDatas.length >= MAXIMUM_SUPPORTED_EVENTS &&
        captureMetaDatas.some((event) => event.eventName === RecordingEvent.RECORDING_AVAILABLE)) {
        _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info(`[App:QMW] Received maximum number client-supported events: ${MAXIMUM_SUPPORTED_EVENTS}. Generating single customer chapter with available recording data.`);
        returnChapterMetaDatas.customerChaptersMetaData = createCustomerChapterFromMainRecording(recordingDatas);
        return returnChapterMetaDatas;
    }
    // Get the customer legs
    const mainRecordingFilePath = (_b = (_a = recordingDatas.find((data) => data.segment === false && data.attributes.callType === "main")) === null || _a === void 0 ? void 0 : _a.attributes.filePath) !== null && _b !== void 0 ? _b : "";
    returnChapterMetaDatas.customerChaptersMetaData = generateCustomerChapters(captureMetaDatas, mainRecordingFilePath);
    // Get the consult legs
    returnChapterMetaDatas.consultChaptersMetaData = generateConsultChapters(captureMetaDatas);
    // Match recording media
    const consultMedia = recordingDatas.filter((recordingMedia) => recordingMedia.attributes.callType === "consult" && recordingMedia.segment === false);
    consultMedia.sort((a, b) => a.attributes.startTime - b.attributes.startTime);
    let consultIdx = 0;
    returnChapterMetaDatas.consultChaptersMetaData.forEach((consult) => {
        if (consult.chapterType === ChapterType.Consulting && consultIdx < consultMedia.length) {
            consult.fileLocation = consultMedia[consultIdx].attributes.filePath;
            consultIdx++;
        }
    });
    return returnChapterMetaDatas;
};
const generateLinearStylingForChaptersView = (isCustomerVisualizer, chapters, mainChapterLength) => {
    const noAudioTrackColor = "var(--md-gray-20, #DEDEDE)";
    const trackWithAudioColor = "var(--md-gray-60, #707070)";
    const mainColor = isCustomerVisualizer ? trackWithAudioColor : noAudioTrackColor;
    const chapterGap = 0.5;
    let prevEndMark = 0;
    let startMark = 0;
    let style = ``;
    if (mainChapterLength === 0) {
        return style;
    }
    // Open first chapter
    if (chapters[0]) {
        startMark = Number(((chapters[0].startTimeMillis / mainChapterLength) * 100).toFixed(2));
    }
    if (startMark > 0) {
        style += `${mainColor} 0%, ${mainColor} ${startMark - chapterGap}%, `;
        style += `${noAudioTrackColor} ${startMark - chapterGap}%, ${noAudioTrackColor} ${startMark}%, `;
        prevEndMark = startMark;
    }
    chapters.forEach((track, index) => {
        startMark = Number(((track.startTimeMillis / mainChapterLength) * 100).toFixed(2));
        const endMark = Number(((track.endTimeMillis / mainChapterLength) * 100).toFixed(2));
        // Close gap between this and previous end mark
        if (index > 0 && index < chapters.length - 1 && prevEndMark !== startMark) {
            style += `${mainColor} ${prevEndMark}%, ${mainColor} ${startMark}%, `;
        }
        // Check if add the gap
        if (Math.abs(endMark - startMark) > chapterGap && Math.abs(100 - endMark) > chapterGap) {
            style += `${trackWithAudioColor} ${startMark}%, ${trackWithAudioColor} ${endMark - chapterGap}%, `;
            style += `${noAudioTrackColor} ${endMark - chapterGap}%, ${noAudioTrackColor} ${endMark}%, `;
        }
        else {
            style += `${trackWithAudioColor} ${startMark}%, ${trackWithAudioColor} ${endMark}%, `;
        }
        prevEndMark = endMark;
    });
    // Close final chapter
    style += `${mainColor} ${prevEndMark}%, ${mainColor} 100%`;
    return style;
};


/***/ }),

/***/ "./src/components/QueueStatsTab/QueueStatsDetail/QueueStatsDetail.scss":
/*!*****************************************************************************!*\
  !*** ./src/components/QueueStatsTab/QueueStatsDetail/QueueStatsDetail.scss ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  overflow: auto;
  gap: 8px;
}

.queue-detail {
  min-width: 1030px;
}

.header-container {
  margin-right: 16px;
}

.detail-container {
  box-sizing: border-box;
}

.customize-button {
  margin: 8px;
}

.spacer {
  flex-grow: 1;
  display: flex;
}

.section-label {
  font-size: var(--font-size-large);
  font-weight: 700;
  font-family: var(--brand-font-bold, "CiscoSansTT Bold");
  line-height: 24px;
  align-items: center;
  color: var(--md-primary-text-color);
}

.section-info {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  line-height: 15px;
  height: 44px;
  margin: 8px 16px 4px 16px;
}
.section-info-icon {
  color: var(--md-secondary-text-color);
}

.details-title {
  font-weight: 700;
  font-size: var(--font-size-heading-small, 20px);
  color: var(--md-primary-text-color);
  font-family: var(--brand-font-bold, "CiscoSansTT Bold");
  line-height: var(--font-lineheight-heading-small);
}

.tab-header {
  display: flex;
  margin: 12px 0px;
  align-items: center;
  justify-content: space-between;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QueueStatsTab/QueueStatsDetail/QueueStatsDetail.ts":
/*!***************************************************************************!*\
  !*** ./src/components/QueueStatsTab/QueueStatsDetail/QueueStatsDetail.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QueueStatsDetail: () => (/* binding */ QueueStatsDetail)
/* harmony export */ });
/* harmony import */ var _components_Common_CellRenderers_constants_channel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/CellRenderers/constants/channel */ "./src/components/Common/CellRenderers/constants/channel.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html_directives_if_defined_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html/directives/if-defined.js */ "lit-html/directives/if-defined.js");
/* harmony import */ var lit_html_directives_if_defined_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_QueueStatsHeader_QueueStatsHeader__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../components/QueueStatsHeader/QueueStatsHeader */ "./src/components/QueueStatsTab/components/QueueStatsHeader/QueueStatsHeader.ts");
/* harmony import */ var _QueueStatsUtils_QueueStatsUtils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../QueueStatsUtils/QueueStatsUtils */ "./src/components/QueueStatsTab/QueueStatsUtils/QueueStatsUtils.ts");
/* harmony import */ var _QueueStatsDetail_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./QueueStatsDetail.scss */ "./src/components/QueueStatsTab/QueueStatsDetail/QueueStatsDetail.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};










const queueStatsDataSet = "wxcc.rtd.queuestats";
const hasConnectionStatusChanged = (value, oldValue) => {
    return (value === null || value === void 0 ? void 0 : value.empty) !== (oldValue === null || oldValue === void 0 ? void 0 : oldValue.empty) || (value === null || value === void 0 ? void 0 : value.error) !== (oldValue === null || oldValue === void 0 ? void 0 : oldValue.error) || (value === null || value === void 0 ? void 0 : value.loading) !== (oldValue === null || oldValue === void 0 ? void 0 : oldValue.loading);
};
/**
 * @element agentx-wc-queue-stats-detail
 * @fires header-close-clicked
 */
let QueueStatsDetail = class QueueStatsDetail extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_4__.LitElement) {
    constructor() {
        super(...arguments);
        this.queueId = "";
        this.orgId = "";
        this.isRTDIntialized = false;
        this.queueStatsSubscription = {};
        this.queueDataMap = new Map();
        this.state = { loading: true, empty: true, error: false };
        this.subscribeQueueStatsDataSet = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("[App:QSD] Subscribing to queue stats dataset");
            this.state = Object.assign(Object.assign({}, this.state), { loading: true });
            return (_a = window.wxcc) === null || _a === void 0 ? void 0 : _a.rtdwc.subscribe({
                datasetName: queueStatsDataSet,
                update: (queueStatsData, deltaData) => {
                    const updatedInfo = (0,_QueueStatsUtils_QueueStatsUtils__WEBPACK_IMPORTED_MODULE_8__.getQueueStatsData)(queueStatsData.datasetValues, this.queueDataMap, queueStatsData.type, deltaData === null || deltaData === void 0 ? void 0 : deltaData.datasetValues);
                    this.state = Object.assign(Object.assign({}, this.state), { loading: false, empty: updatedInfo.model.size === 0 });
                    this.queueDataMap = updatedInfo.model;
                    this.filterQueueData();
                }
            });
        });
    }
    static get styles() {
        return _QueueStatsDetail_scss__WEBPACK_IMPORTED_MODULE_9__["default"];
    }
    connectedCallback() {
        _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("[App:QSD] Connected callback");
        super.connectedCallback();
        this.setupQueueStatsSubscription();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.unsubscribeQueueStatsSubscription();
    }
    setupQueueStatsSubscription() {
        return __awaiter(this, void 0, void 0, function* () {
            _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("[App:QSD] Setting up queue stats details subscription");
            if (!this.isRTDIntialized) {
                _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("[App:QSD] QueueStats subscription skipped as RTD is not initialized");
                return;
            }
            try {
                const [queueStats] = yield Promise.all([this.subscribeQueueStatsDataSet()]);
                this.queueStatsSubscription = queueStats;
            }
            catch (error) {
                _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error("[App:QSD] QueueStats Details subscription failed", error);
                this.state = Object.assign(Object.assign({}, this.state), { error: true });
            }
        });
    }
    unsubscribeQueueStatsSubscription() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if ((_a = this.queueStatsSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe) {
                _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("[App:QSD] Unsubscribe queue stats dataset");
                this.queueStatsSubscription.unsubscribe();
            }
        });
    }
    filterQueueData() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.queueId) {
                const queueData = this.queueDataMap.get(this.queueId);
                if (queueData) {
                    this.queueData = queueData;
                    this.getQueueInfo();
                }
            }
        });
    }
    getQueueInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const queueInfo = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.cms.fetchQueueDetailsById({
                    orgId: this.orgId,
                    queueId: this.queueId
                });
                this.queueInfo = queueInfo;
            }
            catch (error) {
                _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error("[App:QSD] Failed to fetch queue info", error);
            }
        });
    }
    getIconForChannelType() {
        var _a, _b;
        return ((_b = _components_Common_CellRenderers_constants_channel__WEBPACK_IMPORTED_MODULE_0__.CHANNEL_TYPE_TO_ICON_MAP[(_a = this.queueData) === null || _a === void 0 ? void 0 : _a.channelType]) !== null && _b !== void 0 ? _b : "channel-call");
    }
    updated(_changedProperties) {
        if (_changedProperties.has("queueId")) {
            this.filterQueueData();
        }
        if (_changedProperties.has("isRTDIntialized")) {
            this.onRTDInitializedUpdated();
        }
    }
    onRTDInitializedUpdated() {
        // handle subscribe on page refresh for the queue stats tab
        if (this.isRTDIntialized) {
            this.setupQueueStatsSubscription();
        }
    }
    onCloseDetailsViewClicked() {
        this.dispatchEvent(new CustomEvent("header-close-clicked", {
            bubbles: true,
            composed: true
        }));
    }
    render() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_5__.html) `
      <div class="queue-detail">
        <div class="header-container">
          <div class="tab-header">
            <div>
              <span class="details-title">${(_a = this.queueData) === null || _a === void 0 ? void 0 : _a.queueName}</span>
            </div>
            <md-tooltip placement="top" message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:closeDetails")}">
              <md-button
                id="close-details"
                circle
                size="28"
                variant="ghost"
                ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:closeDetails")}
                @click=${this.onCloseDetailsViewClicked}
              >
                <md-icon iconSet="momentumDesign" name="cancel-bold" size="16"></md-icon>
              </md-button>
            </md-tooltip>
          </div>
          <agentx-wc-queue-stats-header
            avatarChannelType=${this.getIconForChannelType()}
            queueName=${(0,lit_html_directives_if_defined_js__WEBPACK_IMPORTED_MODULE_6__.ifDefined)((_b = this.queueData) === null || _b === void 0 ? void 0 : _b.queueName)}
            .avgWaitTime=${Number((_d = (_c = this.queueData) === null || _c === void 0 ? void 0 : _c.avgWaitTime) !== null && _d !== void 0 ? _d : 0)}
            .agentAssignedBy=${(_f = (_e = this.queueInfo) === null || _e === void 0 ? void 0 : _e.queueRoutingType) !== null && _f !== void 0 ? _f : ""}
            .agentSelection=${(_h = (_g = this.queueInfo) === null || _g === void 0 ? void 0 : _g.routingType) !== null && _h !== void 0 ? _h : ""}
            .queueSkills=${(_k = (_j = this.queueInfo) === null || _j === void 0 ? void 0 : _j.queueSkillRequirements) !== null && _k !== void 0 ? _k : []}
          ></agentx-wc-queue-stats-header>
        </div>
        <div class="detail-container">
          <div class="section-info">
            <span class="section-label">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:widgetsSectionTitle")}</span>
            <md-tooltip placement="top" message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:widgetsSectionTooltip")}">
              <md-button circle size="20" variant="ghost">
                <md-icon
                  class="section-info-icon"
                  slot="icon"
                  iconSet="momentumDesign"
                  name="info-badge-filled"
                  size="16"
                ></md-icon>
              </md-button>
            </md-tooltip>
            <div class="spacer"></div>
          </div>
          <agentx-queue-stats-widgets .queueData=${this.queueData} .state=${this.state}> </agentx-queue-stats-widgets>
        </div>
        <agentx-wc-queue-performance-details-view .queueData=${this.queueData}>
        </agentx-wc-queue-performance-details-view>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
], QueueStatsDetail.prototype, "queueId", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
], QueueStatsDetail.prototype, "orgId", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
], QueueStatsDetail.prototype, "isRTDIntialized", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
], QueueStatsDetail.prototype, "queueStatsSubscription", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
], QueueStatsDetail.prototype, "queueDataMap", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
], QueueStatsDetail.prototype, "queueInfo", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
], QueueStatsDetail.prototype, "queueData", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)({ hasChanged: hasConnectionStatusChanged })
], QueueStatsDetail.prototype, "state", void 0);
QueueStatsDetail = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.customElement)("agentx-wc-queue-stats-detail")
], QueueStatsDetail);



/***/ }),

/***/ "./src/components/QueueStatsTab/QueueStatsLanding/QueueStatsLanding.scss":
/*!*******************************************************************************!*\
  !*** ./src/components/QueueStatsTab/QueueStatsLanding/QueueStatsLanding.scss ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  box-sizing: border-box;
  flex: 1;
  height: 100%;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QueueStatsTab/QueueStatsLanding/QueueStatsLanding.ts":
/*!*****************************************************************************!*\
  !*** ./src/components/QueueStatsTab/QueueStatsLanding/QueueStatsLanding.ts ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QueueStatsLanding: () => (/* binding */ QueueStatsLanding)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _QueueStatsLanding_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./QueueStatsLanding.scss */ "./src/components/QueueStatsTab/QueueStatsLanding/QueueStatsLanding.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




/**
 * @element agentx-wc-queue-stats-landing
 */
let QueueStatsLanding = class QueueStatsLanding extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
    constructor() {
        super(...arguments);
        this.isDarkMode = false;
        this.isExpanded = false;
        this.isRTDIntialized = false;
        this.selectedQueueId = "";
    }
    static get styles() {
        return _QueueStatsLanding_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
    }
    render() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) `
      <agentx-wc-queues-monitoring-grid
        .isDarkMode=${this.isDarkMode}
        .isTableExpanded=${!this.isExpanded}
        .isRTDIntialized=${this.isRTDIntialized}
        selectedQueueId=${this.selectedQueueId}
      ></agentx-wc-queues-monitoring-grid>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
], QueueStatsLanding.prototype, "isDarkMode", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
], QueueStatsLanding.prototype, "isExpanded", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
], QueueStatsLanding.prototype, "isRTDIntialized", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], QueueStatsLanding.prototype, "selectedQueueId", void 0);
QueueStatsLanding = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-queue-stats-landing")
], QueueStatsLanding);



/***/ }),

/***/ "./src/components/QueueStatsTab/QueueStatsUtils/QueueStatsUtils.ts":
/*!*************************************************************************!*\
  !*** ./src/components/QueueStatsTab/QueueStatsUtils/QueueStatsUtils.ts ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getQueueStatsData: () => (/* binding */ getQueueStatsData)
/* harmony export */ });
/* harmony import */ var _components_QueuesMonitoringWidget_QueueModelData__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../components/QueuesMonitoringWidget/QueueModelData */ "./src/components/QueueStatsTab/components/QueuesMonitoringWidget/QueueModelData.ts");

const REALTIME_FEED = "RealtimeFeed";
const SUBSCRIPTION_RESPONSE = "SubscriptionResponse";
function setAvgHandleTime(updatedQueueStatus) {
    var _a, _b, _c;
    return updatedQueueStatus.totalContactsHandled > 0
        ? ((((_a = updatedQueueStatus.totalConnectedDuration) !== null && _a !== void 0 ? _a : 0) +
            ((_b = updatedQueueStatus.totalWrapUpDuration) !== null && _b !== void 0 ? _b : 0) +
            ((_c = updatedQueueStatus.totalHoldDuration) !== null && _c !== void 0 ? _c : 0)) /
            updatedQueueStatus.totalContactsHandled)
            .toFixed(2)
            .toString()
        : _components_QueuesMonitoringWidget_QueueModelData__WEBPACK_IMPORTED_MODULE_0__.QueueModel.EMPTY_DATA.avgHandleTime;
}
function getMappedDataFromQueueStatus(updatedQueueStatus, oldQueueData) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    return Object.assign(Object.assign(Object.assign({}, _components_QueuesMonitoringWidget_QueueModelData__WEBPACK_IMPORTED_MODULE_0__.QueueModel.EMPTY_DATA), oldQueueData), { queueId: updatedQueueStatus.queueId, queueName: updatedQueueStatus.queueName, abandoned: ((_a = updatedQueueStatus.totalContactsAbandoned) === null || _a === void 0 ? void 0 : _a.toString()) || _components_QueuesMonitoringWidget_QueueModelData__WEBPACK_IMPORTED_MODULE_0__.QueueModel.EMPTY_DATA.abandoned, avgWaitTime: updatedQueueStatus.totalContactsHandled > 0
            ? (updatedQueueStatus.totalQueueDuration / updatedQueueStatus.totalQueuedContacts).toFixed(2)
            : _components_QueuesMonitoringWidget_QueueModelData__WEBPACK_IMPORTED_MODULE_0__.QueueModel.EMPTY_DATA.avgWaitTime, avgHandleTime: setAvgHandleTime(updatedQueueStatus), channelType: updatedQueueStatus.channelType, handledInteractions: updatedQueueStatus.totalContactsHandled.toString(), inQueue: updatedQueueStatus.queuedContactsCount.toString(), longestWaitTime: updatedQueueStatus.maxQueueDuration.toString(), presentedInteractions: updatedQueueStatus.totalQueuedContacts.toString(), transferred: String((_c = (_b = updatedQueueStatus.totalContactsTransferred) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : _components_QueuesMonitoringWidget_QueueModelData__WEBPACK_IMPORTED_MODULE_0__.QueueModel.EMPTY_DATA.transferred), available: String((_e = (_d = updatedQueueStatus.availableCount) === null || _d === void 0 ? void 0 : _d.toString()) !== null && _e !== void 0 ? _e : _components_QueuesMonitoringWidget_QueueModelData__WEBPACK_IMPORTED_MODULE_0__.QueueModel.EMPTY_DATA.available), idle: String((_g = (_f = updatedQueueStatus.idleCount) === null || _f === void 0 ? void 0 : _f.toString()) !== null && _g !== void 0 ? _g : _components_QueuesMonitoringWidget_QueueModelData__WEBPACK_IMPORTED_MODULE_0__.QueueModel.EMPTY_DATA.idle), engaged: String((_j = (_h = updatedQueueStatus.contactsInProgress) === null || _h === void 0 ? void 0 : _h.toString()) !== null && _j !== void 0 ? _j : _components_QueuesMonitoringWidget_QueueModelData__WEBPACK_IMPORTED_MODULE_0__.QueueModel.EMPTY_DATA.engaged), rona: String((_l = (_k = updatedQueueStatus.totalContactsRona) === null || _k === void 0 ? void 0 : _k.toString()) !== null && _l !== void 0 ? _l : _components_QueuesMonitoringWidget_QueueModelData__WEBPACK_IMPORTED_MODULE_0__.QueueModel.EMPTY_DATA.rona), ringing: String((_o = (_m = updatedQueueStatus.contactsRinging) === null || _m === void 0 ? void 0 : _m.toString()) !== null && _o !== void 0 ? _o : _components_QueuesMonitoringWidget_QueueModelData__WEBPACK_IMPORTED_MODULE_0__.QueueModel.EMPTY_DATA.ringing), assignmentType: String((_q = (_p = updatedQueueStatus === null || updatedQueueStatus === void 0 ? void 0 : updatedQueueStatus.agentAssignmentType) === null || _p === void 0 ? void 0 : _p.trim()) !== null && _q !== void 0 ? _q : _components_QueuesMonitoringWidget_QueueModelData__WEBPACK_IMPORTED_MODULE_0__.QueueModel.EMPTY_DATA.assignmentType), actions: "Actions" });
}
function convertQueueStatusArrayToMap(agentGlobalStatusData) {
    const rowDataMap = new Map();
    agentGlobalStatusData === null || agentGlobalStatusData === void 0 ? void 0 : agentGlobalStatusData.forEach((queueStats) => {
        rowDataMap.set(queueStats.data.queueId, getMappedDataFromQueueStatus(queueStats.data, undefined));
    });
    return rowDataMap;
}
const updateExistingMapFromQueueStatus = ({ newQueueStats, currentDataMap, updated, added }) => {
    const rowDataMap = new Map(currentDataMap);
    newQueueStats === null || newQueueStats === void 0 ? void 0 : newQueueStats.forEach((queueData) => {
        const existingData = currentDataMap.get(queueData.data.queueId);
        const newData = getMappedDataFromQueueStatus(queueData.data, existingData);
        if (existingData) {
            updated.push(newData);
        }
        else {
            added.push(newData);
        }
        rowDataMap.set(queueData.data.queueId, newData);
    });
    return rowDataMap;
};
function getQueueStatsData(newQueueStats, currentDataMap, type, deltaData) {
    const updated = [];
    const added = [];
    let model;
    if (type === SUBSCRIPTION_RESPONSE) {
        model =
            currentDataMap.size === 0
                ? convertQueueStatusArrayToMap(newQueueStats)
                : new Map([...currentDataMap, ...convertQueueStatusArrayToMap(newQueueStats)]);
    }
    else if (deltaData && type === REALTIME_FEED) {
        model = updateExistingMapFromQueueStatus({
            newQueueStats: deltaData,
            currentDataMap,
            updated,
            added
        });
    }
    else {
        model = updateExistingMapFromQueueStatus({
            newQueueStats,
            currentDataMap,
            updated,
            added
        });
    }
    return { model, updated, added };
}


/***/ }),

/***/ "./src/components/QueueStatsTab/components/QueueData/QueueDataWidget.scss":
/*!********************************************************************************!*\
  !*** ./src/components/QueueStatsTab/components/QueueData/QueueDataWidget.scss ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  display: flex;
  height: 372px;
  width: 100%;
  background-color: var(--md-table-sub-nav-bg-color);
  border-radius: 8px;
  overflow: hidden;
}

ul {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 16px;
  margin: 12px 16px;
}

li {
  flex: 1 1 50%;
  margin-bottom: 12px;
}

strong {
  font-weight: bold;
  margin-right: 4px;
}

.label {
  color: var(--md-primary-text-color);
  font-family: var(--font-family-bold);
  font-weight: var(--brand-font-weight-bold);
  font-size: var(--font-size-body-midsize);
}

.value {
  color: var(--md-secondary-text-color);
  font-family: var(--font-family-fixed);
  font-weight: var(--brand-font-weight-regular);
  font-size: var(--font-size-body-midsize);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL1F1ZXVlU3RhdHNUYWIvY29tcG9uZW50cy9RdWV1ZURhdGEvUXVldWVEYXRhV2lkZ2V0LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxhQUFBO0VBQ0EsYUFBQTtFQUNBLFdBQUE7RUFFQSxrREFBQTtFQUNBLGtCQUFBO0VBQ0EsZ0JBQUE7QUFBRjs7QUFHQTtFQUNFLGFBQUE7RUFDQSxlQUFBO0VBQ0EsZ0JBQUE7RUFDQSxhQUFBO0VBQ0EsaUJBQUE7QUFBRjs7QUFHQTtFQUNFLGFBQUE7RUFDQSxtQkFBQTtBQUFGOztBQUdBO0VBQ0UsaUJBQUE7RUFDQSxpQkFBQTtBQUFGOztBQUdBO0VBQ0UsbUNBQUE7RUFDQSxvQ0FBQTtFQUNBLDBDQUFBO0VBQ0Esd0NBQUE7QUFBRjs7QUFHQTtFQUNFLHFDQUFBO0VBQ0EscUNBQUE7RUFDQSw2Q0FBQTtFQUNBLHdDQUFBO0FBQUYiLCJzb3VyY2VzQ29udGVudCI6WyI6aG9zdCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGhlaWdodDogMzcycHg7XG4gIHdpZHRoOiAxMDAlO1xuICAvLyB0ZW1wIHVzZSB0aGlzIHRoZW1lIHByb3BlcnR5XG4gIGJhY2tncm91bmQtY29sb3I6IHZhcigtLW1kLXRhYmxlLXN1Yi1uYXYtYmctY29sb3IpO1xuICBib3JkZXItcmFkaXVzOiA4cHg7XG4gIG92ZXJmbG93OiBoaWRkZW47XG59XG5cbnVsIHtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC13cmFwOiB3cmFwO1xuICBsaXN0LXN0eWxlOiBub25lO1xuICBwYWRkaW5nOiAxNnB4O1xuICBtYXJnaW46IDEycHggMTZweDtcbn1cblxubGkge1xuICBmbGV4OiAxIDEgNTAlO1xuICBtYXJnaW4tYm90dG9tOiAxMnB4O1xufVxuXG5zdHJvbmcge1xuICBmb250LXdlaWdodDogYm9sZDtcbiAgbWFyZ2luLXJpZ2h0OiA0cHg7XG59XG5cbi5sYWJlbCB7XG4gIGNvbG9yOiB2YXIoLS1tZC1wcmltYXJ5LXRleHQtY29sb3IpO1xuICBmb250LWZhbWlseTogdmFyKC0tZm9udC1mYW1pbHktYm9sZCk7XG4gIGZvbnQtd2VpZ2h0OiB2YXIoLS1icmFuZC1mb250LXdlaWdodC1ib2xkKTtcbiAgZm9udC1zaXplOiB2YXIoLS1mb250LXNpemUtYm9keS1taWRzaXplKTtcbn1cblxuLnZhbHVlIHtcbiAgY29sb3I6IHZhcigtLW1kLXNlY29uZGFyeS10ZXh0LWNvbG9yKTtcbiAgZm9udC1mYW1pbHk6IHZhcigtLWZvbnQtZmFtaWx5LWZpeGVkKTtcbiAgZm9udC13ZWlnaHQ6IHZhcigtLWJyYW5kLWZvbnQtd2VpZ2h0LXJlZ3VsYXIpO1xuICBmb250LXNpemU6IHZhcigtLWZvbnQtc2l6ZS1ib2R5LW1pZHNpemUpO1xufVxuIl0sInNvdXJjZVJvb3QiOiIifQ== */`);
    

/***/ }),

/***/ "./src/components/QueueStatsTab/components/QueueData/QueueDataWidget.ts":
/*!******************************************************************************!*\
  !*** ./src/components/QueueStatsTab/components/QueueData/QueueDataWidget.ts ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QueueDataWidget: () => (/* binding */ QueueDataWidget)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Common_CellRenderers_Formatters_DurationFormatter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../Common/CellRenderers/Formatters/DurationFormatter */ "./src/components/Common/CellRenderers/Formatters/DurationFormatter.ts");
/* harmony import */ var _QueueDataWidget_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./QueueDataWidget.scss */ "./src/components/QueueStatsTab/components/QueueData/QueueDataWidget.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





let QueueDataWidget = class QueueDataWidget extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
    static get styles() {
        return _QueueDataWidget_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
    }
    render() {
        const labels = {
            queueName: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats.name"),
            abandoned: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats.abandoned"),
            available: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats.available"),
            avgHandleTime: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats.avgHandleTime"),
            avgWaitTime: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats.avgWaitTime"),
            channelType: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats.channels"),
            engaged: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats.engaged"),
            handledInteractions: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats.handled"),
            idle: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats.idle"),
            inQueue: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats.waiting"),
            longestWaitTime: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats.longestWaitTime"),
            presentedInteractions: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats.presented"),
            rona: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats.rona"),
            transferred: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats.transferred"),
            ringing: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats.ringing")
            // assignmentType: t("app:queueStats.assignedBy")
        };
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) `
      <ul>
        ${this.queueData
            ? Object.entries(this.queueData)
                .filter(([key]) => key !== "queueId" && labels[key])
                .map(([key, value]) => {
                const formattedValue = ["avgHandleTime", "avgWaitTime", "longestWaitTime"].includes(key) && !isNaN(Number(value))
                    ? (0,_Common_CellRenderers_Formatters_DurationFormatter__WEBPACK_IMPORTED_MODULE_3__.formatDuration)(Number(value))
                    : value;
                return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) `
                  <li>
                    <span class="label">${labels[key]}:</span>
                    <span class="value">${formattedValue}</span>
                  </li>
                `;
            })
            : (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) `<li>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats.noDataAvailable")}</li>`}
      </ul>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
], QueueDataWidget.prototype, "queueData", void 0);
QueueDataWidget = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-queue-data-widget")
], QueueDataWidget);



/***/ }),

/***/ "./src/components/QueueStatsTab/components/QueueStatsHeader/QueueStatsHeader.scss":
/*!****************************************************************************************!*\
  !*** ./src/components/QueueStatsTab/components/QueueStatsHeader/QueueStatsHeader.scss ***!
  \****************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

.header-container {
  display: flex;
  flex-wrap: wrap;
  padding: 16px 12px;
  height: fit-content;
  background-color: var(--md-glass-overlay-bg-color);
  border-radius: 8px;
  gap: 8px;
}

.icon-container {
  width: 32px;
  height: 32px;
  flex: 0 0 auto;
  flex-shrink: 0;
}

.details-container {
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  gap: 8px;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
}
.details-container .separator {
  width: 4px;
  height: 4px;
  background: var(--md-separator-primary);
  border-radius: 50%;
  flex-shrink: 0;
}

.detail {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 0 1 auto;
  min-width: 0;
  gap: 5px;
  white-space: nowrap;
}
.detail-info-icon {
  vertical-align: text-top;
}
.detail-timer {
  margin: 2px 0;
}
.detail .detail-key {
  color: var(--md-primary-text-color);
  font-family: var(--font-family-bold);
  font-weight: bold;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.detail .detail-value {
  font-family: var(--font-family);
  color: var(--md-secondary-text-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QueueStatsTab/components/QueueStatsHeader/QueueStatsHeader.ts":
/*!**************************************************************************************!*\
  !*** ./src/components/QueueStatsTab/components/QueueStatsHeader/QueueStatsHeader.ts ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QueueStatsHeader: () => (/* binding */ QueueStatsHeader)
/* harmony export */ });
/* harmony import */ var _components_Common_CellRenderers_components_TableDurationElement__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/CellRenderers/components/TableDurationElement */ "./src/components/Common/CellRenderers/components/TableDurationElement.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _QueueStatsHeader_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./QueueStatsHeader.scss */ "./src/components/QueueStatsTab/components/QueueStatsHeader/QueueStatsHeader.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





/**
 * @element agentx-wc-queue-stats-header
 */
let QueueStatsHeader = class QueueStatsHeader extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
    constructor() {
        super(...arguments);
        this.avatarChannelType = "";
        this.avgWaitTime = 0;
        this.agentAssignedBy = "";
        this.agentSelection = "";
        this.queueSkills = [];
        this.queueName = "";
    }
    get agentAssignedByLabel() {
        switch (this.agentAssignedBy) {
            case "TEAM_BASED":
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:agentAssignedByTeam");
            case "SKILLS_BASED":
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:agentAssignedBySkills");
            default:
                return "";
        }
    }
    get agentAssignedByTooltip() {
        switch (this.agentAssignedBy) {
            case "TEAM_BASED":
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:agentAssignedByTeamTooltip");
            case "SKILLS_BASED":
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:agentAssignedBySkillsTooltip");
            default:
                return "";
        }
    }
    get agentSelectedByLabel() {
        switch (this.agentSelection) {
            case "LONGEST_AVAILABLE_AGENT":
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:agentSelectionLongestAvailable");
            case "BEST_AVAILABLE_AGENT":
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:agentSelectionBestAvailable");
            default:
                return "";
        }
    }
    get agentSelectedByTooltip() {
        switch (this.agentSelection) {
            case "LONGEST_AVAILABLE_AGENT":
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:agentSelectionLongestAvailableTooltip");
            case "BEST_AVAILABLE_AGENT":
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:agentSelectionBestAvailableTooltip");
            default:
                return "";
        }
    }
    static get styles() {
        return _QueueStatsHeader_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
    }
    renderIcon() {
        return this.avatarChannelType !== ""
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<md-avatar type="${this.avatarChannelType}" size="32"></md-avatar>`
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}`;
    }
    renderAssignedBy(value) {
        var _a;
        return value !== ""
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` <div class="detail">
          <span class="detail-key">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:assignedBy")}:</span>
          <span class="detail-value">${this.agentAssignedByLabel}</span>
          <md-tooltip placement="top" message="${this.agentAssignedByTooltip}">
            <md-button class="detail-info-icon" circle size="20" variant="ghost">
              <md-icon
                slot="icon"
                iconSet="momentumDesign"
                name="info-badge-filled"
                color="var(--md-secondary-text-color)"
                size="16"
              ></md-icon>
            </md-button>
          </md-tooltip>
          ${this.renderSeparator(this.agentSelection !== "" || ((_a = this.queueSkills) === null || _a === void 0 ? void 0 : _a.length) > 0)}
        </div>`
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}`;
    }
    renderAgentSelection(value) {
        var _a;
        return value !== ""
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<div class="detail">
          <label class="detail-key">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:agentSelectionBy")}:</label>
          <label class="detail-value">${this.agentSelectedByLabel}</label>
          <md-tooltip placement="top" message="${this.agentSelectedByTooltip}">
            <md-button class="detail-info-icon" circle size="20" variant="ghost">
              <md-icon
                slot="icon"
                iconSet="momentumDesign"
                name="info-badge-filled"
                color="var(--md-secondary-text-color)"
                size="16"
              ></md-icon>
            </md-button>
          </md-tooltip>
          ${this.renderSeparator(((_a = this.queueSkills) === null || _a === void 0 ? void 0 : _a.length) > 0)}
        </div>`
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}`;
    }
    renderQueueSkills(skills) {
        if ((skills === null || skills === void 0 ? void 0 : skills.length) > 0) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<div class="detail">
        <span class="detail-key">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:queueSkills")}:</span>
        <span class="detail-value">${skills[0]}${skills.length > 1 ? "," : ""}</span>
        ${this.renderMoreSkills(skills)}
      </div>`;
        }
        else {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}`;
        }
    }
    renderMoreSkills(skills) {
        return skills.length > 1
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<md-tooltip placement="top">
          <div slot="tooltip-content">${skills.slice(1).map((item) => (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<div>${item}</div>`)}</div>
          <md-link tag="span" inline inline-style="default">+${skills.length - 1} more</md-link>
        </md-tooltip>`
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}`;
    }
    renderAvgWaitTime(avgWaitTime) {
        var _a;
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<div class="detail">
      <span class="detail-key">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:avgWaitTime")}:</span>
      <span class="detail-value">
        <agentx-wc-table-duration
          class="detail-timer"
          no-padding
          duration=${avgWaitTime}
          .isActive=${false}
          ?hideTimerIcon=${true}
        ></agentx-wc-table-duration>
      </span>
      ${this.renderSeparator(this.agentAssignedBy !== "" || this.agentSelection !== "" || ((_a = this.queueSkills) === null || _a === void 0 ? void 0 : _a.length) > 0)}
    </div>`;
    }
    renderSeparator(show) {
        if (show) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<div class="separator"></div>`;
        }
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}`;
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
      <div class="header-container">
        <div class="icon-container">${this.renderIcon()}</div>
        <div class="details-container">
          ${this.renderAvgWaitTime(this.avgWaitTime)} ${this.renderAssignedBy(this.agentAssignedBy)}
          ${this.renderAgentSelection(this.agentSelection)} ${this.renderQueueSkills(this.queueSkills)}
        </div>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String, reflect: true })
], QueueStatsHeader.prototype, "avatarChannelType", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Number })
], QueueStatsHeader.prototype, "avgWaitTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
], QueueStatsHeader.prototype, "agentAssignedBy", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
], QueueStatsHeader.prototype, "agentSelection", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Array })
], QueueStatsHeader.prototype, "queueSkills", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
], QueueStatsHeader.prototype, "queueName", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], QueueStatsHeader.prototype, "agentAssignedByLabel", null);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], QueueStatsHeader.prototype, "agentAssignedByTooltip", null);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], QueueStatsHeader.prototype, "agentSelectedByLabel", null);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], QueueStatsHeader.prototype, "agentSelectedByTooltip", null);
QueueStatsHeader = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-queue-stats-header")
], QueueStatsHeader);



/***/ }),

/***/ "./src/components/QueueStatsTab/components/QueueStatsPerformanceDetailsView/QueueStatsPerformanceDetailsView.scss":
/*!************************************************************************************************************************!*\
  !*** ./src/components/QueueStatsTab/components/QueueStatsPerformanceDetailsView/QueueStatsPerformanceDetailsView.scss ***!
  \************************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

.header {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  line-height: 15px;
  height: 44px;
  margin: 8px 16px 4px 16px;
}
.header .title {
  font-size: var(--font-size-large);
  font-weight: 700;
  font-family: var(--brand-font-bold, "CiscoSansTT Bold");
  line-height: 24px;
  align-items: center;
  color: var(--md-primary-text-color);
}

.tabs-container {
  display: flex;
  flex: 1;
  height: 444px;
  padding: 16px;
  margin: 0 16px 16px 0;
  background-color: var(--md-glass-overlay-bg-color);
  border-radius: var(--grid-container-border-radius);
}
.tabs-container md-tabs {
  width: 100%;
}
.tabs-container md-tabs .tab-panel {
  padding-top: 16px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QueueStatsTab/components/QueueStatsPerformanceDetailsView/QueueStatsPerformanceDetailsView.ts":
/*!**********************************************************************************************************************!*\
  !*** ./src/components/QueueStatsTab/components/QueueStatsPerformanceDetailsView/QueueStatsPerformanceDetailsView.ts ***!
  \**********************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PerformanceDetailsTab: () => (/* binding */ PerformanceDetailsTab),
/* harmony export */   QueueStatsPerformanceDetailsView: () => (/* binding */ QueueStatsPerformanceDetailsView)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_repeat_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/repeat.js */ "lit-html/directives/repeat.js");
/* harmony import */ var lit_html_directives_repeat_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _QueueStatsPerformanceDetailsView_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./QueueStatsPerformanceDetailsView.scss */ "./src/components/QueueStatsTab/components/QueueStatsPerformanceDetailsView/QueueStatsPerformanceDetailsView.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var PerformanceDetailsTab;
(function (PerformanceDetailsTab) {
    PerformanceDetailsTab["Agents"] = "agents";
    PerformanceDetailsTab["QueueData"] = "queueData";
})(PerformanceDetailsTab || (PerformanceDetailsTab = {}));
/**
 * @element agentx-wc-queue-performance-details-view
 */
let QueueStatsPerformanceDetailsView = class QueueStatsPerformanceDetailsView extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
    constructor() {
        super(...arguments);
        this.selectedTab = PerformanceDetailsTab.Agents;
    }
    static get styles() {
        return _QueueStatsPerformanceDetailsView_scss__WEBPACK_IMPORTED_MODULE_5__["default"];
    }
    get tabsToRender() {
        return [
            {
                name: PerformanceDetailsTab.Agents,
                label: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats:performanceDetailsAgents"),
                ariaLabel: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats:performanceDetailsAgentsAriaLabel")
            },
            {
                name: PerformanceDetailsTab.QueueData,
                label: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats:performanceDetailsQueueData"),
                ariaLabel: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats:performanceDetailsQueueDataAriaLabel")
            }
        ];
    }
    renderAgentsView() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) ` <span>${this.selectedTab} </span> `;
    }
    renderQueueDataView() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) ` <agentx-wc-queue-data-widget .queueData=${this.queueData}></agentx-wc-queue-data-widget> `;
    }
    renderPanelView() {
        switch (this.selectedTab) {
            case PerformanceDetailsTab.Agents:
                return this.renderAgentsView();
            case PerformanceDetailsTab.QueueData:
                return this.renderQueueDataView();
            default:
                return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}`;
        }
    }
    render() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
      <div class="header">
        <span class="title">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats:performanceDetails")}</span>
      </div>
      <div class="tabs-container">
        <md-tabs
          .selectedIndex="${Object.values(PerformanceDetailsTab).indexOf(this.selectedTab)}"
          @selected-changed="${this.onSelectedTabChanged}"
          direction="horizontal"
          aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("")}"
        >
          ${(0,lit_html_directives_repeat_js__WEBPACK_IMPORTED_MODULE_4__.repeat)(this.tabsToRender, (tab) => tab.name, (tab) => (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
              <md-tab slot="tab" aria-label="${tab.ariaLabel}" name="${tab.name}">${tab.label}</md-tab>
              <md-tab-panel slot="panel">
                <div class="tab-panel">${this.renderPanelView()}</div>
              </md-tab-panel>
            `)}
        </md-tabs>
      </div>
    `;
    }
    onSelectedTabChanged(event) {
        const { value } = event.detail;
        if (typeof value !== "number") {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[QueueStatsPerformanceDetailsView] Invalid tab change event, missing fields");
            return;
        }
        const selection = Object.values(PerformanceDetailsTab)[value];
        if (this.selectedTab === selection || selection === undefined) {
            return;
        }
        this.selectedTab = selection;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
], QueueStatsPerformanceDetailsView.prototype, "selectedTab", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
], QueueStatsPerformanceDetailsView.prototype, "queueData", void 0);
QueueStatsPerformanceDetailsView = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-queue-performance-details-view")
], QueueStatsPerformanceDetailsView);



/***/ }),

/***/ "./src/components/QueueStatsTab/components/QueueStatsWidgets/QueueStatsWidgets.scss":
/*!******************************************************************************************!*\
  !*** ./src/components/QueueStatsTab/components/QueueStatsWidgets/QueueStatsWidgets.scss ***!
  \******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host uuip-dynamic-widgets::part(container) {
  gap: 16px;
  margin: 0 16px 16px 0;
  grid-template-rows: auto;
}

::part(advanced-layout-widget-container) {
  background: transparent;
  box-shadow: none;
  background-color: transparent;
}

::part(dynamic-area-container) {
  background-color: transparent;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QueueStatsTab/components/QueueStatsWidgets/QueueStatsWidgets.ts":
/*!****************************************************************************************!*\
  !*** ./src/components/QueueStatsTab/components/QueueStatsWidgets/QueueStatsWidgets.ts ***!
  \****************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CardState: () => (/* binding */ CardState),
/* harmony export */   QueueStatsWidgets: () => (/* binding */ QueueStatsWidgets)
/* harmony export */ });
/* harmony import */ var _components_QueueStatsTab_components_QueuesInteractionsWidget_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/QueueStatsTab/components/QueuesInteractionsWidget/types */ "./src/components/QueueStatsTab/components/QueuesInteractionsWidget/types.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_html_directives_repeat_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html/directives/repeat.js */ "lit-html/directives/repeat.js");
/* harmony import */ var lit_html_directives_repeat_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_QueuesMonitoringWidget_QueueModelData__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../components/QueuesMonitoringWidget/QueueModelData */ "./src/components/QueueStatsTab/components/QueuesMonitoringWidget/QueueModelData.ts");
/* harmony import */ var _QueueStatsWidgets_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./QueueStatsWidgets.scss */ "./src/components/QueueStatsTab/components/QueueStatsWidgets/QueueStatsWidgets.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









const TIME_FORMAT = "hh:mm:ss";
const topRowCards = new Set([
    _components_QueueStatsTab_components_QueuesInteractionsWidget_types__WEBPACK_IMPORTED_MODULE_0__.CardType.WAITING_IN_QUEUE,
    _components_QueueStatsTab_components_QueuesInteractionsWidget_types__WEBPACK_IMPORTED_MODULE_0__.CardType.AVG_WAIT_TIME,
    _components_QueueStatsTab_components_QueuesInteractionsWidget_types__WEBPACK_IMPORTED_MODULE_0__.CardType.LONGEST_WAIT_TIME,
    _components_QueueStatsTab_components_QueuesInteractionsWidget_types__WEBPACK_IMPORTED_MODULE_0__.CardType.ABANDONED
]);
var CardState;
(function (CardState) {
    CardState["DEFAULT"] = "default";
    CardState["ACTIVE"] = "active";
    CardState["INACTIVE"] = "inactive";
})(CardState || (CardState = {}));
const hasConnectionStatusChanged = (value, oldValue) => {
    return (value === null || value === void 0 ? void 0 : value.empty) !== (oldValue === null || oldValue === void 0 ? void 0 : oldValue.empty) || (value === null || value === void 0 ? void 0 : value.error) !== (oldValue === null || oldValue === void 0 ? void 0 : oldValue.error) || (value === null || value === void 0 ? void 0 : value.loading) !== (oldValue === null || oldValue === void 0 ? void 0 : oldValue.loading);
};
/**
 * @element agentx-queue-stats-widgets
 */
let QueueStatsWidgets = class QueueStatsWidgets extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
    constructor() {
        super(...arguments);
        this.selectedWidgetId = "";
        this.state = {
            loading: true,
            empty: true,
            error: false
        };
        this.handleCardToggled = (event) => {
            const toggledEvent = event === null || event === void 0 ? void 0 : event.detail;
            if (toggledEvent.active) {
                this.selectedWidgetId = toggledEvent.identifier || "";
            }
            else {
                this.selectedWidgetId = "";
            }
        };
    }
    static get styles() {
        return _QueueStatsWidgets_scss__WEBPACK_IMPORTED_MODULE_8__["default"];
    }
    connectedCallback() {
        super.connectedCallback();
        _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("[App:QSW] Connected callback");
        this.addEventListener("expand-card-toggled", this.handleCardToggled);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("[App:QSW] Disconnected callback");
        this.removeEventListener("expand-card-toggled", this.handleCardToggled);
    }
    createSlot(slot) {
        return {
            comp: "slot",
            attributes: {
                name: slot
            }
        };
    }
    createCard(id, header, data, info, expandable = false) {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_4__.html) `
      <md-card-v2
        identifier=${id}
        state=${this.widgetState(id)}
        header=${header}
        data=${data}
        info=${info}
        ?expandable=${expandable}
        style="display: block"
      ></md-card-v2>
    `;
    }
    createWaitingInQueueWidget() {
        var _a, _b;
        return this.createCard(_components_QueueStatsTab_components_QueuesInteractionsWidget_types__WEBPACK_IMPORTED_MODULE_0__.CardType.WAITING_IN_QUEUE, (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats.widgetWaiting"), (_b = (_a = this.queueData) === null || _a === void 0 ? void 0 : _a.inQueue) !== null && _b !== void 0 ? _b : _components_QueuesMonitoringWidget_QueueModelData__WEBPACK_IMPORTED_MODULE_7__.QueueModel.EMPTY_DATA.inQueue, (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats.widgetWaitingTooltip"), true);
    }
    createAvgWaitTimeWidget() {
        var _a, _b;
        return this.createCard(_components_QueueStatsTab_components_QueuesInteractionsWidget_types__WEBPACK_IMPORTED_MODULE_0__.CardType.AVG_WAIT_TIME, (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats.widgetAvgWaitTime"), luxon__WEBPACK_IMPORTED_MODULE_6__.Duration.fromMillis(Number((_b = (_a = this.queueData) === null || _a === void 0 ? void 0 : _a.avgWaitTime) !== null && _b !== void 0 ? _b : _components_QueuesMonitoringWidget_QueueModelData__WEBPACK_IMPORTED_MODULE_7__.QueueModel.EMPTY_DATA.avgWaitTime)).toFormat(TIME_FORMAT), (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats.widgetAvgWaitTimeTooltip"), true);
    }
    createLongestWaitingWidget() {
        var _a, _b;
        return this.createCard(_components_QueueStatsTab_components_QueuesInteractionsWidget_types__WEBPACK_IMPORTED_MODULE_0__.CardType.LONGEST_WAIT_TIME, (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats.widgetLongestWaitTime"), luxon__WEBPACK_IMPORTED_MODULE_6__.Duration.fromMillis(Number((_b = (_a = this.queueData) === null || _a === void 0 ? void 0 : _a.longestWaitTime) !== null && _b !== void 0 ? _b : _components_QueuesMonitoringWidget_QueueModelData__WEBPACK_IMPORTED_MODULE_7__.QueueModel.EMPTY_DATA.longestWaitTime)).toFormat(TIME_FORMAT), (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats.widgetLongestWaitTimeTooltip"), true);
    }
    createAbandonedWidget() {
        var _a, _b;
        return this.createCard(_components_QueueStatsTab_components_QueuesInteractionsWidget_types__WEBPACK_IMPORTED_MODULE_0__.CardType.ABANDONED, (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats.widgetAbandoned"), (_b = (_a = this.queueData) === null || _a === void 0 ? void 0 : _a.abandoned) !== null && _b !== void 0 ? _b : _components_QueuesMonitoringWidget_QueueModelData__WEBPACK_IMPORTED_MODULE_7__.QueueModel.EMPTY_DATA.abandoned, (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats.widgetAbandonedTooltip"));
    }
    createAvgHandleTimeWidget() {
        var _a, _b;
        return this.createCard(_components_QueueStatsTab_components_QueuesInteractionsWidget_types__WEBPACK_IMPORTED_MODULE_0__.CardType.AVG_HANDLED_TIME, (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats.widgetAvgHandledTime"), luxon__WEBPACK_IMPORTED_MODULE_6__.Duration.fromMillis(Number((_b = (_a = this.queueData) === null || _a === void 0 ? void 0 : _a.avgHandleTime) !== null && _b !== void 0 ? _b : _components_QueuesMonitoringWidget_QueueModelData__WEBPACK_IMPORTED_MODULE_7__.QueueModel.EMPTY_DATA.avgHandleTime)).toFormat(TIME_FORMAT), (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats.widgetAvgHandledTimeTooltip"), true);
    }
    createAvailableAgentsWidget() {
        var _a, _b;
        return this.createCard(_components_QueueStatsTab_components_QueuesInteractionsWidget_types__WEBPACK_IMPORTED_MODULE_0__.CardType.AVAILABLE_AGENTS, (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats.widgetAvailableAgents"), (_b = (_a = this.queueData) === null || _a === void 0 ? void 0 : _a.available) !== null && _b !== void 0 ? _b : _components_QueuesMonitoringWidget_QueueModelData__WEBPACK_IMPORTED_MODULE_7__.QueueModel.EMPTY_DATA.available, (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats.widgetAvailableAgentsTooltip"));
    }
    createIdleAgentsWidget() {
        var _a, _b;
        return this.createCard(_components_QueueStatsTab_components_QueuesInteractionsWidget_types__WEBPACK_IMPORTED_MODULE_0__.CardType.IDLE_AGENTS, (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats.widgetIdleAgents"), (_b = (_a = this.queueData) === null || _a === void 0 ? void 0 : _a.idle) !== null && _b !== void 0 ? _b : _components_QueuesMonitoringWidget_QueueModelData__WEBPACK_IMPORTED_MODULE_7__.QueueModel.EMPTY_DATA.idle, (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats.widgetIdleAgentsTooltip"));
    }
    createRonaWidget() {
        var _a, _b;
        return this.createCard(_components_QueueStatsTab_components_QueuesInteractionsWidget_types__WEBPACK_IMPORTED_MODULE_0__.CardType.RONA, (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats.widgetRONA"), (_b = (_a = this.queueData) === null || _a === void 0 ? void 0 : _a.rona) !== null && _b !== void 0 ? _b : _components_QueuesMonitoringWidget_QueueModelData__WEBPACK_IMPORTED_MODULE_7__.QueueModel.EMPTY_DATA.rona, (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats.widgetRONATooltip"));
    }
    createInteractionsInfoWidget() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_4__.html) `
      <agentx-wc-queue-interactions-widget
        selected=${this.selectedWidgetId}
      ></agentx-wc-queue-interactions-widget>
    `;
    }
    widgetState(identifier) {
        if (this.selectedWidgetId === identifier) {
            return CardState.ACTIVE;
        }
        return this.selectedWidgetId === "" ? CardState.DEFAULT : CardState.INACTIVE;
    }
    get renderLoading() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_4__.html) `
      <agentx-wc-empty-display-wrapper
        illustration-type="empty-loading"
        title=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:loading")}
        .loading=${this.state.loading}
      >
      </agentx-wc-empty-display-wrapper>
    `;
    }
    get renderConnectionError() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_4__.html) `
      <agentx-wc-empty-display-wrapper
        illustration-type="error-cloud"
        title=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:errorTitle")}
        info-message=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:errorMessage")}
      >
      </agentx-wc-empty-display-wrapper>
    `;
    }
    get widgetSlots() {
        return [
            {
                slot: "SLOT_1",
                comp: this.createWaitingInQueueWidget()
            },
            {
                slot: "SLOT_2",
                comp: this.createAvgWaitTimeWidget()
            },
            {
                slot: "SLOT_3",
                comp: this.createLongestWaitingWidget()
            },
            {
                slot: "SLOT_4",
                comp: this.createAbandonedWidget()
            },
            {
                slot: "SLOT_5",
                comp: this.createInteractionsInfoWidget()
            },
            {
                slot: "SLOT_6",
                comp: this.createAvgHandleTimeWidget()
            },
            {
                slot: "SLOT_7",
                comp: this.createAvailableAgentsWidget()
            },
            {
                slot: "SLOT_8",
                comp: this.createIdleAgentsWidget()
            },
            {
                slot: "SLOT_9",
                comp: this.createRonaWidget()
            }
        ];
    }
    widgetsGrid() {
        const slots = Array.from({ length: this.widgetSlots.length }, (_, i) => `SLOT_${i + 1}`);
        const widgets = Object.fromEntries(slots.map((slot, index) => [`comp${index + 1}`, this.createSlot(slot)]));
        return {
            id: "queue_widgets",
            widgets,
            layout: this.getGridLayout()
        };
    }
    getGridLayout() {
        const cardSelected = Object.values(_components_QueueStatsTab_components_QueuesInteractionsWidget_types__WEBPACK_IMPORTED_MODULE_0__.CardType).includes(this.selectedWidgetId);
        return {
            areas: this.getGridAreas(cardSelected),
            size: {
                cols: [1, 1, 1, 1],
                rows: cardSelected ? [1, 1, 1] : [1, 1]
            }
        };
    }
    getGridAreas(cardSelected) {
        return cardSelected
            ? this.selectionGridAreas()
            : [
                ["comp1", "comp2", "comp3", "comp4"],
                ["comp6", "comp7", "comp8", "comp9"]
            ];
    }
    selectionGridAreas() {
        const topRowGrid = [
            ["comp1", "comp2", "comp3", "comp4"],
            ["comp5", "comp5", "comp5", "comp5"],
            ["comp6", "comp7", "comp8", "comp9"]
        ];
        const bottomRowGrid = [
            ["comp1", "comp2", "comp3", "comp4"],
            ["comp6", "comp7", "comp8", "comp9"],
            ["comp5", "comp5", "comp5", "comp5"]
        ];
        return topRowCards.has(this.selectedWidgetId) ? topRowGrid : bottomRowGrid;
    }
    render() {
        if (this.state.error) {
            return (0,lit_html__WEBPACK_IMPORTED_MODULE_4__.html) `${this.renderConnectionError}`;
        }
        if (this.state.empty) {
            return (0,lit_html__WEBPACK_IMPORTED_MODULE_4__.html) `${this.renderLoading}`;
        }
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_4__.html) `
      <uuip-dynamic-widgets .page=${this.widgetsGrid()} width="100%" height="auto">
        ${(0,lit_html_directives_repeat_js__WEBPACK_IMPORTED_MODULE_5__.repeat)(this.widgetSlots, (widget) => widget.slot, (widget) => (0,lit_html__WEBPACK_IMPORTED_MODULE_4__.html) ` <div slot=${widget.slot}>${widget.comp}</div> `)}
      </uuip-dynamic-widgets>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
], QueueStatsWidgets.prototype, "selectedWidgetId", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Object })
], QueueStatsWidgets.prototype, "queueData", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Object, hasChanged: hasConnectionStatusChanged })
], QueueStatsWidgets.prototype, "state", void 0);
QueueStatsWidgets = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-queue-stats-widgets")
], QueueStatsWidgets);



/***/ }),

/***/ "./src/components/QueueStatsTab/components/QueuesInteractionsWidget/QueueInteractionsWidget.scss":
/*!*******************************************************************************************************!*\
  !*** ./src/components/QueueStatsTab/components/QueuesInteractionsWidget/QueueInteractionsWidget.scss ***!
  \*******************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  display: block;
  height: 380px;
  background-color: var(--md-glass-overlay-bg-color);
  border-radius: var(--grid-container-border-radius);
  padding: 22px;
}

h2 {
  color: var(--md-primary-text-color);
  font-family: var(--font-family-bold);
  font-weight: var(--brand-font-weight-bold);
  font-size: var(--font-size-body-midsize);
  margin-bottom: 0;
}

p {
  color: var(--md-secondary-text-color);
  font-family: var(--font-family-regular);
  font-size: var(--font-size-body-midsize);
  font-weight: 400;
  margin-top: 0;
  margin-bottom: 0;
}

wc-ag-grid-wrapper {
  height: 274px;
  --md-glass-overlay-bg-color: transparent;
  --grid-container-border-radius: 0;
  --grid-container-h-padding: 0;
  --grid-container-top-padding: 0;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL1F1ZXVlU3RhdHNUYWIvY29tcG9uZW50cy9RdWV1ZXNJbnRlcmFjdGlvbnNXaWRnZXQvUXVldWVJbnRlcmFjdGlvbnNXaWRnZXQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGNBQUE7RUFDQSxhQUFBO0VBQ0Esa0RBQUE7RUFDQSxrREFBQTtFQUNBLGFBQUE7QUFDRjs7QUFFQTtFQUNFLG1DQUFBO0VBQ0Esb0NBQUE7RUFDQSwwQ0FBQTtFQUNBLHdDQUFBO0VBQ0EsZ0JBQUE7QUFDRjs7QUFFQTtFQUNFLHFDQUFBO0VBQ0EsdUNBQUE7RUFDQSx3Q0FBQTtFQUNBLGdCQUFBO0VBQ0EsYUFBQTtFQUNBLGdCQUFBO0FBQ0Y7O0FBRUE7RUFDRSxhQUFBO0VBQ0Esd0NBQUE7RUFDQSxpQ0FBQTtFQUNBLDZCQUFBO0VBQ0EsK0JBQUE7QUFDRiIsInNvdXJjZXNDb250ZW50IjpbIjpob3N0IHtcbiAgZGlzcGxheTogYmxvY2s7XG4gIGhlaWdodDogMzgwcHg7XG4gIGJhY2tncm91bmQtY29sb3I6IHZhcigtLW1kLWdsYXNzLW92ZXJsYXktYmctY29sb3IpO1xuICBib3JkZXItcmFkaXVzOiB2YXIoLS1ncmlkLWNvbnRhaW5lci1ib3JkZXItcmFkaXVzKTtcbiAgcGFkZGluZzogMjJweDtcbn1cblxuaDIge1xuICBjb2xvcjogdmFyKC0tbWQtcHJpbWFyeS10ZXh0LWNvbG9yKTtcbiAgZm9udC1mYW1pbHk6IHZhcigtLWZvbnQtZmFtaWx5LWJvbGQpO1xuICBmb250LXdlaWdodDogdmFyKC0tYnJhbmQtZm9udC13ZWlnaHQtYm9sZCk7XG4gIGZvbnQtc2l6ZTogdmFyKC0tZm9udC1zaXplLWJvZHktbWlkc2l6ZSk7XG4gIG1hcmdpbi1ib3R0b206IDA7XG59XG5cbnAge1xuICBjb2xvcjogdmFyKC0tbWQtc2Vjb25kYXJ5LXRleHQtY29sb3IpO1xuICBmb250LWZhbWlseTogdmFyKC0tZm9udC1mYW1pbHktcmVndWxhcik7XG4gIGZvbnQtc2l6ZTogdmFyKC0tZm9udC1zaXplLWJvZHktbWlkc2l6ZSk7XG4gIGZvbnQtd2VpZ2h0OiA0MDA7XG4gIG1hcmdpbi10b3A6IDA7XG4gIG1hcmdpbi1ib3R0b206IDA7XG59XG5cbndjLWFnLWdyaWQtd3JhcHBlciB7XG4gIGhlaWdodDogMjc0cHg7XG4gIC0tbWQtZ2xhc3Mtb3ZlcmxheS1iZy1jb2xvcjogdHJhbnNwYXJlbnQ7XG4gIC0tZ3JpZC1jb250YWluZXItYm9yZGVyLXJhZGl1czogMDtcbiAgLS1ncmlkLWNvbnRhaW5lci1oLXBhZGRpbmc6IDA7XG4gIC0tZ3JpZC1jb250YWluZXItdG9wLXBhZGRpbmc6IDA7XG59XG4iXSwic291cmNlUm9vdCI6IiJ9 */`);
    

/***/ }),

/***/ "./src/components/QueueStatsTab/components/QueuesInteractionsWidget/QueueInteractionsWidget.ts":
/*!*****************************************************************************************************!*\
  !*** ./src/components/QueueStatsTab/components/QueuesInteractionsWidget/QueueInteractionsWidget.ts ***!
  \*****************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QueueInteractionsWidget: () => (/* binding */ QueueInteractionsWidget)
/* harmony export */ });
/* harmony import */ var _components_Common_WcGrid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/WcGrid */ "./src/components/Common/WcGrid/index.ts");
/* harmony import */ var _components_Common_WcGrid_WcGridConfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/components/Common/WcGrid/WcGridConfig */ "./src/components/Common/WcGrid/WcGridConfig.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _QueueInteractionsWidget_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./QueueInteractionsWidget.scss */ "./src/components/QueueStatsTab/components/QueuesInteractionsWidget/QueueInteractionsWidget.scss");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./config */ "./src/components/QueueStatsTab/components/QueuesInteractionsWidget/config.ts");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./types */ "./src/components/QueueStatsTab/components/QueuesInteractionsWidget/types.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};









let QueueInteractionsWidget = class QueueInteractionsWidget extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.i18nMixin)(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__.MobxLitElement) {
    constructor() {
        super(...arguments);
        this.isDarkMode = false;
        this.cardName = "";
        this.selected = _types__WEBPACK_IMPORTED_MODULE_8__.CardType.WAITING_IN_QUEUE;
        this.tempRowData = [];
    }
    static get styles() {
        return _QueueInteractionsWidget_scss__WEBPACK_IMPORTED_MODULE_6__["default"];
    }
    updated(changedProperties) {
        if (changedProperties.has("selected")) {
            this.updateCardName();
        }
    }
    connectedCallback() {
        const _super = Object.create(null, {
            connectedCallback: { get: () => super.connectedCallback }
        });
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            _super.connectedCallback.call(this);
            (_a = this.interactionsStore) === null || _a === void 0 ? void 0 : _a.subscribeToInteractions(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.InteractionsServiceConstants.QueryType.Queued);
            //Until interactions data structure is fixed use temp data
            this.tempRowData = yield this.fetchRowData();
        });
    }
    updateCardName() {
        const cardNameMap = {
            [_types__WEBPACK_IMPORTED_MODULE_8__.CardType.WAITING_IN_QUEUE]: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats.widgetWaiting"),
            [_types__WEBPACK_IMPORTED_MODULE_8__.CardType.AVG_WAIT_TIME]: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats.widgetAvgWaitTime"),
            [_types__WEBPACK_IMPORTED_MODULE_8__.CardType.LONGEST_WAIT_TIME]: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats.widgetLongestWaitTime"),
            [_types__WEBPACK_IMPORTED_MODULE_8__.CardType.ABANDONED]: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats.widgetAbandoned"),
            [_types__WEBPACK_IMPORTED_MODULE_8__.CardType.AVG_HANDLED_TIME]: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats.widgetAvgHandledTime"),
            [_types__WEBPACK_IMPORTED_MODULE_8__.CardType.AVAILABLE_AGENTS]: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats.widgetAvailableAgents"),
            [_types__WEBPACK_IMPORTED_MODULE_8__.CardType.IDLE_AGENTS]: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats.widgetIdleAgents"),
            [_types__WEBPACK_IMPORTED_MODULE_8__.CardType.RONA]: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats.widgetRONA")
        };
        this.cardName = cardNameMap[this.selected] || "";
    }
    getColumnDefs() {
        return this.selected === _types__WEBPACK_IMPORTED_MODULE_8__.CardType.LONGEST_WAIT_TIME ? (0,_config__WEBPACK_IMPORTED_MODULE_7__.getLongestColumnDefs)() : (0,_config__WEBPACK_IMPORTED_MODULE_7__.getDefaultColumnDefs)();
    }
    getWcGridConfig() {
        return new _components_Common_WcGrid_WcGridConfig__WEBPACK_IMPORTED_MODULE_1__.WcGridConfig({
            tableName: "queueInteractionsWidget",
            enableCharts: false,
            headerConfig: {}
        });
    }
    fetchRowData() {
        return __awaiter(this, void 0, void 0, function* () {
            return Array.from({ length: 2 }, () => ({
                customerID: "5dcf33a-5ec6-42ff-af0d-eec4a4760927",
                totalContactDuration: Math.floor(Math.random() * 100000).toString(),
                timeInQueue: Math.floor(Math.random() * 100000).toString(),
                handleTime: Math.floor(Math.random() * 100000).toString(),
                agentName: `Ronan Carroll`
            }));
        });
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
      <h2>${this.cardName}</h2>
      <p>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats:queueInteractionsInfo")}</p>
      <wc-ag-grid-wrapper
        .isDarkMode=${this.isDarkMode}
        .wcGridConfig=${this.getWcGridConfig()}
        .wcColumnDefs=${this.getColumnDefs()}
        .rowData=${this.tempRowData /*this.interactionsStore?.queuedInteractions*/}
      ></wc-ag-grid-wrapper>
      <p>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats:queueInteractionsGridInfo")}</p>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
], QueueInteractionsWidget.prototype, "isDarkMode", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
], QueueInteractionsWidget.prototype, "cardName", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
], QueueInteractionsWidget.prototype, "selected", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Object })
], QueueInteractionsWidget.prototype, "interactionsStore", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Array })
], QueueInteractionsWidget.prototype, "tempRowData", void 0);
QueueInteractionsWidget = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.customElement)("agentx-wc-queue-interactions-widget")
], QueueInteractionsWidget);



/***/ }),

/***/ "./src/components/QueueStatsTab/components/QueuesInteractionsWidget/config.ts":
/*!************************************************************************************!*\
  !*** ./src/components/QueueStatsTab/components/QueuesInteractionsWidget/config.ts ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getDefaultColumnDefs: () => (/* binding */ getDefaultColumnDefs),
/* harmony export */   getLongestColumnDefs: () => (/* binding */ getLongestColumnDefs),
/* harmony export */   getWcColumnDefs: () => (/* binding */ getWcColumnDefs)
/* harmony export */ });
/* harmony import */ var _components_Common_WcGrid_WcColumns_AgentNameColumn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/WcGrid/WcColumns/AgentNameColumn */ "./src/components/Common/WcGrid/WcColumns/AgentNameColumn.ts");
/* harmony import */ var _components_Common_WcGrid_WcColumns_DurationColumn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/components/Common/WcGrid/WcColumns/DurationColumn */ "./src/components/Common/WcGrid/WcColumns/DurationColumn.ts");
/* harmony import */ var _components_Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/components/Common/WcGrid/WcColumns/StringColumn */ "./src/components/Common/WcGrid/WcColumns/StringColumn.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./types */ "./src/components/QueueStatsTab/components/QueuesInteractionsWidget/types.ts");





function getAllColumns() {
    return [
        new _components_Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_2__.StringColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__.t)("app:queueStats.customerId"), _types__WEBPACK_IMPORTED_MODULE_4__.QueueInteractionsColumnId.CustomerID),
        new _components_Common_WcGrid_WcColumns_DurationColumn__WEBPACK_IMPORTED_MODULE_1__.DurationColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__.t)("app:queueStats.totalContactDuration"), _types__WEBPACK_IMPORTED_MODULE_4__.QueueInteractionsColumnId.TotalContactDuration),
        new _components_Common_WcGrid_WcColumns_DurationColumn__WEBPACK_IMPORTED_MODULE_1__.DurationColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__.t)("app:queueStats.timeInQueue"), _types__WEBPACK_IMPORTED_MODULE_4__.QueueInteractionsColumnId.TimeInQueue),
        new _components_Common_WcGrid_WcColumns_DurationColumn__WEBPACK_IMPORTED_MODULE_1__.DurationColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__.t)("app:queueStats.handleTime"), _types__WEBPACK_IMPORTED_MODULE_4__.QueueInteractionsColumnId.HandleTime),
        new _components_Common_WcGrid_WcColumns_AgentNameColumn__WEBPACK_IMPORTED_MODULE_0__.AgentNameColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__.t)("app:queueStats.agent"), _types__WEBPACK_IMPORTED_MODULE_4__.QueueInteractionsColumnId.Agent)
    ];
}
function setColumnVisibility(allColumns, visibleColumns) {
    allColumns.forEach((column) => {
        column.setHidden(!visibleColumns.includes(column.getFieldName()));
    });
    return allColumns;
}
function getWcColumnDefs() {
    const allColumns = getAllColumns();
    const defaultColumns = [
        _types__WEBPACK_IMPORTED_MODULE_4__.QueueInteractionsColumnId.CustomerID,
        _types__WEBPACK_IMPORTED_MODULE_4__.QueueInteractionsColumnId.TotalContactDuration,
        _types__WEBPACK_IMPORTED_MODULE_4__.QueueInteractionsColumnId.TimeInQueue,
        _types__WEBPACK_IMPORTED_MODULE_4__.QueueInteractionsColumnId.HandleTime,
        _types__WEBPACK_IMPORTED_MODULE_4__.QueueInteractionsColumnId.Agent
    ];
    return setColumnVisibility(allColumns, defaultColumns);
}
function getDefaultColumnDefs() {
    const allColumns = getAllColumns();
    const defaultColumns = [
        _types__WEBPACK_IMPORTED_MODULE_4__.QueueInteractionsColumnId.CustomerID,
        _types__WEBPACK_IMPORTED_MODULE_4__.QueueInteractionsColumnId.TotalContactDuration,
        _types__WEBPACK_IMPORTED_MODULE_4__.QueueInteractionsColumnId.HandleTime,
        _types__WEBPACK_IMPORTED_MODULE_4__.QueueInteractionsColumnId.Agent
    ];
    return setColumnVisibility(allColumns, defaultColumns);
}
function getLongestColumnDefs() {
    const allColumns = getAllColumns();
    const defaultColumns = [
        _types__WEBPACK_IMPORTED_MODULE_4__.QueueInteractionsColumnId.CustomerID,
        _types__WEBPACK_IMPORTED_MODULE_4__.QueueInteractionsColumnId.TotalContactDuration,
        _types__WEBPACK_IMPORTED_MODULE_4__.QueueInteractionsColumnId.TimeInQueue
    ];
    return setColumnVisibility(allColumns, defaultColumns);
}


/***/ }),

/***/ "./src/components/QueueStatsTab/components/QueuesInteractionsWidget/types.ts":
/*!***********************************************************************************!*\
  !*** ./src/components/QueueStatsTab/components/QueuesInteractionsWidget/types.ts ***!
  \***********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CardType: () => (/* binding */ CardType),
/* harmony export */   QueueInteractionsColumnId: () => (/* binding */ QueueInteractionsColumnId)
/* harmony export */ });
var QueueInteractionsColumnId;
(function (QueueInteractionsColumnId) {
    QueueInteractionsColumnId["Id"] = "id";
    QueueInteractionsColumnId["CustomerID"] = "customerID";
    QueueInteractionsColumnId["TotalContactDuration"] = "totalContactDuration";
    QueueInteractionsColumnId["TimeInQueue"] = "timeInQueue";
    QueueInteractionsColumnId["HandleTime"] = "handleTime";
    QueueInteractionsColumnId["Agent"] = "agentName";
})(QueueInteractionsColumnId || (QueueInteractionsColumnId = {}));
var CardType;
(function (CardType) {
    CardType["WAITING_IN_QUEUE"] = "WaitingInQueue";
    CardType["AVG_WAIT_TIME"] = "AvgWaitTime";
    CardType["LONGEST_WAIT_TIME"] = "LongestWaitTime";
    CardType["ABANDONED"] = "Abandoned";
    CardType["AVG_HANDLED_TIME"] = "AvgHandledTime";
    CardType["AVAILABLE_AGENTS"] = "AvailableAgents";
    CardType["IDLE_AGENTS"] = "IdleAgents";
    CardType["RONA"] = "RONA";
})(CardType || (CardType = {}));


/***/ }),

/***/ "./src/components/QueueStatsTab/components/QueuesMonitoringWidget/QueueModelData.ts":
/*!******************************************************************************************!*\
  !*** ./src/components/QueueStatsTab/components/QueuesMonitoringWidget/QueueModelData.ts ***!
  \******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QueueModel: () => (/* binding */ QueueModel)
/* harmony export */ });
var QueueModel;
(function (QueueModel) {
    QueueModel.EMPTY_DATA = {
        queueId: "",
        queueName: "",
        abandoned: "0",
        available: "0",
        avgHandleTime: "0",
        avgWaitTime: "0",
        channelType: "",
        engaged: "0",
        handledInteractions: "0",
        idle: "0",
        inQueue: "0",
        longestWaitTime: "0",
        presentedInteractions: "0",
        rona: "0",
        transferred: "0",
        ringing: "0",
        assignmentType: "",
        actions: ""
    };
})(QueueModel || (QueueModel = {}));


/***/ }),

/***/ "./src/components/QueueStatsTab/components/QueuesMonitoringWidget/QueuesMonitoring.scss":
/*!**********************************************************************************************!*\
  !*** ./src/components/QueueStatsTab/components/QueuesMonitoringWidget/QueuesMonitoring.scss ***!
  \**********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  display: block;
  height: 100%;
}

.queues-monitoring-header {
  display: block;
  box-sizing: border-box;
  margin: 0px 0px 12px 0px;
}

.tab-header {
  display: flex;
  font-size: 20px;
  height: 52px;
  box-sizing: border-box;
  align-items: center;
  padding: 0 12px;
  font-weight: 700;
  font-family: var(--brand-font-regular, "CiscoSansTT Regular");
  color: var(--md-primary-text-color);
}

.separator {
  margin-right: 5px;
}

[slot=left-group] {
  display: inline-block;
  color: var(--md-secondary-text-color);
  font-size: var(--font-size-body-midsize);
}

wc-ag-grid-wrapper.listView {
  --grid-container-h-padding: 0px;
  --md-table-cell-border-bottom: none;
  --grid-container-top-padding: 0px;
  --grid-header-display: none;
  --md-glass-overlay-bg-color: transparent;
  --grid-cell-border-radius: 8px;
  --grid-focus-border-radius: 8px;
}

.customize-menu-overlay {
  display: inline-block;
}

.customize-menu-overlay::part(overlay) {
  width: 600px;
  height: 725px;
}

md-menu-overlay::part(overlay-content) {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

agentx-wc-table-customization-menu {
  width: 100%;
  height: 100%;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QueueStatsTab/components/QueuesMonitoringWidget/QueuesMonitoringWidget.ts":
/*!**************************************************************************************************!*\
  !*** ./src/components/QueueStatsTab/components/QueuesMonitoringWidget/QueuesMonitoringWidget.ts ***!
  \**************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   GridState: () => (/* binding */ GridState),
/* harmony export */   QueuesMonitoringWidget: () => (/* binding */ QueuesMonitoringWidget)
/* harmony export */ });
/* harmony import */ var _components_Common_Table_TableManager__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/Table/TableManager */ "./src/components/Common/Table/TableManager.ts");
/* harmony import */ var _components_Common_WcGrid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/components/Common/WcGrid */ "./src/components/Common/WcGrid/index.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Common_EmptyDisplayWrapper_EmptyDisplayWrapper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../Common/EmptyDisplayWrapper/EmptyDisplayWrapper */ "./src/components/Common/EmptyDisplayWrapper/EmptyDisplayWrapper.ts");
/* harmony import */ var _Common_TableHeader_TableHeaderWidget_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../Common/TableHeader/TableHeaderWidget.scss */ "./src/components/Common/TableHeader/TableHeaderWidget.scss");
/* harmony import */ var _QueueStatsUtils_QueueStatsUtils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../QueueStatsUtils/QueueStatsUtils */ "./src/components/QueueStatsTab/QueueStatsUtils/QueueStatsUtils.ts");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./config */ "./src/components/QueueStatsTab/components/QueuesMonitoringWidget/config.ts");
/* harmony import */ var _QueuesMonitoring_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./QueuesMonitoring.scss */ "./src/components/QueueStatsTab/components/QueuesMonitoringWidget/QueuesMonitoring.scss");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./types */ "./src/components/QueueStatsTab/components/QueuesMonitoringWidget/types.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};













const queueStatsDataSet = "wxcc.rtd.queuestats";
const defaultRowHeight = 40;
const listViewRowHeight = 80;
var GridState;
(function (GridState) {
    GridState["Expanded"] = "expanded";
    GridState["Collapsed"] = "collapsed";
})(GridState || (GridState = {}));
const hasConnectionStatusChanged = (value, oldValue) => {
    return (value === null || value === void 0 ? void 0 : value.empty) !== (oldValue === null || oldValue === void 0 ? void 0 : oldValue.empty) || (value === null || value === void 0 ? void 0 : value.error) !== (oldValue === null || oldValue === void 0 ? void 0 : oldValue.error) || (value === null || value === void 0 ? void 0 : value.loading) !== (oldValue === null || oldValue === void 0 ? void 0 : oldValue.loading);
};
/**
 * @element agentx-wc-queues-monitoring-grid
 * @fires queue-selected
 * @fires grid-sidebar-toggled
 */
let QueuesMonitoringWidget = class QueuesMonitoringWidget extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_5__.LitElement) {
    constructor() {
        super(...arguments);
        this.tableManagers = {
            [GridState.Expanded]: new _components_Common_Table_TableManager__WEBPACK_IMPORTED_MODULE_0__.TableManager({
                cacheName: "wxcc_queues_monitoring_table",
                columnDefinitions: (0,_config__WEBPACK_IMPORTED_MODULE_10__.getGridConfigs)()
            }),
            [GridState.Collapsed]: new _components_Common_Table_TableManager__WEBPACK_IMPORTED_MODULE_0__.TableManager({
                columnDefinitions: (0,_config__WEBPACK_IMPORTED_MODULE_10__.getCollapsedGridConfigs)()
            })
        };
        this.isDarkMode = false;
        this.isTableExpanded = true;
        this.isRTDIntialized = false;
        this.selectedQueueId = "";
        this.state = {
            loading: true,
            empty: true,
            error: false
        };
        this.queueStatusData = [];
        this.queueDataMap = new Map();
        this.queueStatsSubscription = {};
        this.rowCount = 0;
        this.wcGridConfig = new _components_Common_WcGrid__WEBPACK_IMPORTED_MODULE_1__.WcGridConfig({
            tableName: "QueuesMonitoringWidget",
            enableCharts: false,
            headerConfig: {}
        });
        this.subscribeQueueStatsDataSet = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:QMW] Subscribing to queue stats dataset");
            this.state = Object.assign(Object.assign({}, this.state), { loading: true });
            const response = yield ((_a = window.wxcc) === null || _a === void 0 ? void 0 : _a.rtdwc.subscribe({
                datasetName: queueStatsDataSet,
                update: (data, deltaData) => {
                    this.setQueueStatsData(data.datasetValues, data.type, deltaData === null || deltaData === void 0 ? void 0 : deltaData.datasetValues);
                }
            }));
            _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:QMW] subscribed QueueStats successfully");
            return response;
        });
        this.updateRowCount = () => {
            var _a, _b, _c, _d;
            this.rowCount = (_b = (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.getDisplayedRowCount()) !== null && _b !== void 0 ? _b : 0;
            if (this.rowCount === 0) {
                (_c = this.gridApi) === null || _c === void 0 ? void 0 : _c.showNoRowsOverlay();
            }
            else {
                (_d = this.gridApi) === null || _d === void 0 ? void 0 : _d.hideOverlay();
            }
            _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info(`[App:QMW] displayedRowCount updated to ${this.rowCount}`);
        };
    }
    static get styles() {
        return [_Common_TableHeader_TableHeaderWidget_scss__WEBPACK_IMPORTED_MODULE_8__["default"], _QueuesMonitoring_scss__WEBPACK_IMPORTED_MODULE_11__["default"]];
    }
    connectedCallback() {
        _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:QMW] Connected callback");
        super.connectedCallback();
    }
    toggleTableView() {
        _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:QMW] Toggle expanded view");
        if (this.gridApi) {
            this.getTableManager().onGridReady(this.gridApi);
            this.gridApi.setGridOption("rowHeight", this.isTableExpanded ? defaultRowHeight : listViewRowHeight);
            this.gridApi.resetRowHeights();
            this.gridApi.closeToolPanel();
            this.setQueueSelected();
        }
    }
    onRTDInitializedUpdated() {
        // handle subscribe on page refresh for the queue stats tab
        if (this.isRTDIntialized) {
            this.setupQueueStatsSubscription();
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:QMW] Disconnected callback");
        this.unsubscribeQueueStatsSubscription();
    }
    getTableManager() {
        return this.tableManagers[this.isTableExpanded ? GridState.Expanded : GridState.Collapsed];
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has("isTableExpanded")) {
            this.toggleTableView();
        }
        if (changedProperties.has("isRTDIntialized")) {
            this.onRTDInitializedUpdated();
        }
    }
    setupQueueStatsSubscription() {
        return __awaiter(this, void 0, void 0, function* () {
            _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:QMW] Setting up queue stats subscription");
            if (!this.isRTDIntialized) {
                _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:QMW] QueueStats subscription skipped as RTD is not initialized");
                return;
            }
            try {
                this.queueStatsSubscription = yield this.subscribeQueueStatsDataSet();
            }
            catch (error) {
                _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error("[App:QMW] QueueStats subscription failed", error);
                this.state = Object.assign(Object.assign({}, this.state), { error: true });
            }
        });
    }
    unsubscribeQueueStatsSubscription() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if ((_a = this.queueStatsSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe) {
                _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:QMW] Unsubscribe queue stats dataset");
                this.queueStatsSubscription.unsubscribe();
            }
        });
    }
    setQueueStatsData(queueStatusData, type, deltaData) {
        var _a;
        const updatedInfo = (0,_QueueStatsUtils_QueueStatsUtils__WEBPACK_IMPORTED_MODULE_9__.getQueueStatsData)(queueStatusData, this.queueDataMap, type, deltaData);
        this.queueDataMap = updatedInfo.model;
        this.state = Object.assign(Object.assign({}, this.state), { loading: false, empty: updatedInfo.model.size === 0 });
        if (this.queueStatusData.length !== 0 && (updatedInfo.added.length > 0 || updatedInfo.updated.length > 0)) {
            (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.applyTransactionAsync({ add: updatedInfo.added, update: updatedInfo.updated }, () => { var _a; return (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.refreshClientSideRowModel("group"); });
            this.queueStatusData = Array.from(this.queueDataMap, (item) => item[1]);
        }
        else {
            this.queueStatusData = Array.from(this.queueDataMap, (item) => item[1]);
        }
    }
    initializeGridOptions() {
        var _a;
        _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:QMW] Initializing");
        const gridOptions = Object.assign(Object.assign({}, (0,_config__WEBPACK_IMPORTED_MODULE_10__.getBaseGridConfigs)()), { rowHeight: this.isTableExpanded ? defaultRowHeight : listViewRowHeight, onColumnResized: (e) => this.getTableManager().onTableColumnResized(e), onSortChanged: (e) => this.getTableManager().onTableSortChanged(e), onColumnMoved: (e) => this.onColumnMoved(e), onModelUpdated: this.updateRowCount, getRowId: (params) => params.data.queueId, onFirstDataRendered: () => this.setQueueSelected(), onCellFocused: (e) => {
                var _a, _b, _c, _d;
                if (typeof e.column !== "string" &&
                    ((_a = e.column) === null || _a === void 0 ? void 0 : _a.getColId()) === _types__WEBPACK_IMPORTED_MODULE_12__.QueueStatsTableColumnId.ListView &&
                    e.rowIndex !== null) {
                    const displayedRow = (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.getDisplayedRowAtIndex(e.rowIndex);
                    if (displayedRow === null || displayedRow === void 0 ? void 0 : displayedRow.data) {
                        this.selectedQueueId = displayedRow.data.queueId;
                        (_c = this.gridApi) === null || _c === void 0 ? void 0 : _c.ensureIndexVisible(e.rowIndex, null);
                        (_d = this.gridApi) === null || _d === void 0 ? void 0 : _d.refreshCells();
                        this.dispatchEvent(new CustomEvent("queue-selected", {
                            composed: true,
                            bubbles: true,
                            detail: { queueId: this.selectedQueueId }
                        }));
                    }
                }
            }, onToolPanelVisibleChanged: (e) => {
                this.dispatchEvent(new CustomEvent("grid-sidebar-toggled", {
                    composed: true,
                    bubbles: true,
                    detail: {
                        visible: e.visible
                    }
                }));
            } });
        (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.updateGridOptions(gridOptions);
    }
    onGridReady(gridApi) {
        _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:QMW] Grid ready");
        this.gridApi = gridApi;
        this.initializeGridOptions();
        this.getTableManager().onGridReady(gridApi);
    }
    onColumnMoved(e) {
        if (!e.finished) {
            return;
        }
        const manager = this.getTableManager();
        manager.onTableColumnMoved(e);
    }
    onResetCustomization(e) {
        e.stopPropagation();
        const manager = this.getTableManager();
        manager.onReset();
    }
    setQueueSelected() {
        var _a, _b;
        if (!this.isTableExpanded && this.selectedQueueId.length > 0) {
            const allQueues = Array.from(this.queueDataMap, (item) => item[0]);
            const selectedQueueIndex = allQueues.indexOf(this.selectedQueueId);
            if (selectedQueueIndex !== -1) {
                (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.ensureIndexVisible(selectedQueueIndex, null);
                (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.setFocusedCell(selectedQueueIndex, _types__WEBPACK_IMPORTED_MODULE_12__.QueueStatsTableColumnId.ListView);
            }
        }
    }
    get renderToolbar() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_6__.html) `<table-header-widget class="queues-monitoring-header">
      <span slot="left-group">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats:x_queues", undefined, { count: this.rowCount })}</span>
      <div slot="right-group">
        <md-tooltip placement="top" message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats:reset")}">
          <md-button
            id="reset-customization-button"
            circle
            size="28"
            variant="ghost"
            @click=${this.onResetCustomization}
            ?hidden="${!this.isTableExpanded}"
            ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats:reset")}
          >
            <md-icon slot="icon" name="reset-bold" iconSet="momentumDesign" size="16"></md-icon>
          </md-button>
        </md-tooltip>

        <md-tooltip placement="top" message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats:customizeBtn")}">
          <md-button
            circle
            size="28"
            variant="ghost"
            ?hidden="${!this.isTableExpanded}"
            ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats:customizeBtn")}
            @click=${() => this.onCustomizeButtonClicked()}
          >
            <md-icon slot="icon" iconSet="momentumDesign" name="settings-bold" size="16"></md-icon>
          </md-button>
        </md-tooltip>

        ${this.isTableExpanded ? (0,lit_html__WEBPACK_IMPORTED_MODULE_6__.html) `<div class="separator"></div>` : (0,lit_html__WEBPACK_IMPORTED_MODULE_6__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}`}

        <md-tooltip placement="top" message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats:filter")}" ?disabled=${this.isTableExpanded}>
          <md-button
            ?circle="${!this.isTableExpanded}"
            variant="${this.isTableExpanded ? "secondary" : "ghost"}"
            size="28"
            ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats:filter")}
            @click=${() => this.onFilterButtonClicked()}
          >
            <md-icon slot="icon" iconSet="momentumDesign" name="filter-bold" size="16" ariaHidden="true"></md-icon>
            <span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats:filter")}</span>
          </md-button>
        </md-tooltip>
      </div>
    </table-header-widget>`;
    }
    get renderGrid() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_6__.html) `
      <wc-ag-grid-wrapper
        class=${this.isTableExpanded ? "" : "listView"}
        .wcGridConfig=${this.wcGridConfig}
        .rowData=${this.queueStatusData}
        .isDarkMode=${this.isDarkMode}
        .gridApiCallback=${
        //DO NOT USE, DO NOT COPY, This is temporary and will be removed (https://jira-eng-sjc12.cisco.com/jira/browse/CX-18449)
        (gridApi) => {
            this.onGridReady(gridApi);
        }}
      ></wc-ag-grid-wrapper>
    `;
    }
    get renderEmptyGrid() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_6__.html) `
      <agentx-wc-empty-display-wrapper
        illustration-type="empty-state"
        title=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats:emptyTitle")}
        info-message=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats:emptyMessage")}
        .isDarkMode=${this.isDarkMode}
        .loading=${this.state.loading}
      >
      </agentx-wc-empty-display-wrapper>
    `;
    }
    get renderConnectionError() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_6__.html) `
      <agentx-wc-empty-display-wrapper
        illustration-type="error-cloud"
        title=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats:errorTitle")}
        info-message=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats:errorMessage")}
      >
      </agentx-wc-empty-display-wrapper>
    `;
    }
    get renderContent() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_6__.html) `${this.renderToolbar}${this.renderGrid}`;
    }
    render() {
        if (this.state.error) {
            return (0,lit_html__WEBPACK_IMPORTED_MODULE_6__.html) `${this.renderConnectionError}`;
        }
        if (this.state.empty) {
            return (0,lit_html__WEBPACK_IMPORTED_MODULE_6__.html) `${this.renderEmptyGrid}`;
        }
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_6__.html) `${this.renderContent}`;
    }
    onFilterButtonClicked() {
        const gridApi = this.gridApi;
        if (gridApi) {
            const openToolPanel = gridApi.getOpenedToolPanel();
            if (openToolPanel === "filters") {
                gridApi.closeToolPanel();
            }
            else {
                gridApi.openToolPanel("filters");
            }
        }
    }
    onCustomizeButtonClicked() {
        const gridApi = this.gridApi;
        if (gridApi) {
            const openToolPanel = gridApi.getOpenedToolPanel();
            if (openToolPanel === "columns") {
                gridApi.closeToolPanel();
            }
            else {
                gridApi.openToolPanel("columns");
            }
        }
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], QueuesMonitoringWidget.prototype, "tableManagers", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
], QueuesMonitoringWidget.prototype, "isDarkMode", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
], QueuesMonitoringWidget.prototype, "isTableExpanded", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
], QueuesMonitoringWidget.prototype, "isRTDIntialized", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
], QueuesMonitoringWidget.prototype, "selectedQueueId", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)({ hasChanged: hasConnectionStatusChanged })
], QueuesMonitoringWidget.prototype, "state", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], QueuesMonitoringWidget.prototype, "queueStatusData", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], QueuesMonitoringWidget.prototype, "queueDataMap", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], QueuesMonitoringWidget.prototype, "queueStatsSubscription", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], QueuesMonitoringWidget.prototype, "rowCount", void 0);
QueuesMonitoringWidget = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.customElement)("agentx-wc-queues-monitoring-grid")
], QueuesMonitoringWidget);



/***/ }),

/***/ "./src/components/QueueStatsTab/components/QueuesMonitoringWidget/config.ts":
/*!**********************************************************************************!*\
  !*** ./src/components/QueueStatsTab/components/QueuesMonitoringWidget/config.ts ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   actionsValueGetter: () => (/* binding */ actionsValueGetter),
/* harmony export */   channelValueGetter: () => (/* binding */ channelValueGetter),
/* harmony export */   compactViewValueGetter: () => (/* binding */ compactViewValueGetter),
/* harmony export */   getBaseGridConfigs: () => (/* binding */ getBaseGridConfigs),
/* harmony export */   getCollapsedGridConfigs: () => (/* binding */ getCollapsedGridConfigs),
/* harmony export */   getGridConfigs: () => (/* binding */ getGridConfigs),
/* harmony export */   timeValueGetter: () => (/* binding */ timeValueGetter)
/* harmony export */ });
/* harmony import */ var _components_Common_CellRenderers_constants_channel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/CellRenderers/constants/channel */ "./src/components/Common/CellRenderers/constants/channel.ts");
/* harmony import */ var _components_Common_CellRenderers_constants_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/components/Common/CellRenderers/constants/types */ "./src/components/Common/CellRenderers/constants/types.ts");
/* harmony import */ var _components_Common_CellRenderers_filters_TimestampFilter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/components/Common/CellRenderers/filters/TimestampFilter */ "./src/components/Common/CellRenderers/filters/TimestampFilter.ts");
/* harmony import */ var _components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/components/Common/CellRenderers/Utils */ "./src/components/Common/CellRenderers/Utils.ts");
/* harmony import */ var _components_GridWidget_KeySuppressor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @/components/GridWidget/KeySuppressor */ "./src/components/GridWidget/KeySuppressor.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ag-grid-enterprise */ "ag-grid-enterprise");
/* harmony import */ var ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./types */ "./src/components/QueueStatsTab/components/QueuesMonitoringWidget/types.ts");









const keySuppressor = new _components_GridWidget_KeySuppressor__WEBPACK_IMPORTED_MODULE_4__.KeySuppressor(["actions"], "agentx-wc-table-action-buttons");
const theme = ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_7__.themeAlpine.withParams({
    sideBarBackgroundColor: "transparent",
    chromeBackgroundColor: "transparent",
    sidePanelBorder: false
});
function getGridConfigs() {
    const selectedColumns = [
        _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Id,
        _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.QueueName,
        // QueueStatsTableColumnId.AssignmentType,        // enable when working
        _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.ChannelType,
        _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.InQueue,
        _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.AvgWaitTime,
        _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.AvgHandleTime,
        // QueueStatsTableColumnId.Available,             // enable when working
        // QueueStatsTableColumnId.Idle,                  // enable when working
        _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Engaged,
        _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Rona,
        _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Abandoned,
        // QueueStatsTableColumnId.LongestWaitTime,       // Overflow
        // QueueStatsTableColumnId.PresentedInteractions, // Overflow
        // QueueStatsTableColumnId.HandledInteractions,   // Overflow
        // QueueStatsTableColumnId.Transferred,           // enable when working
        // QueueStatsTableColumnId.Ringing,               // Overflow
        _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.ListView
    ];
    if (_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.SERVICE.featureflag.isQueueStatsDetailViewEnabled()) {
        selectedColumns.push(_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Actions);
    }
    const baseColumns = [
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.QueueName,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.QueueName,
            headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats.name")}`,
            flex: 1,
            hide: !selectedColumns.includes(_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.QueueName),
            comparator: _components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_3__.naturalStringComparator,
            filter: "agSetColumnFilter",
            filterParams: {
                defaultToNothingSelected: true
            },
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true
        },
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.AssignmentType,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.AssignmentType,
            headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats.assignedBy")}`,
            flex: 1,
            hide: !selectedColumns.includes(_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.AssignmentType),
            comparator: _components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_3__.naturalStringComparator,
            filter: "agSetColumnFilter",
            filterParams: {
                defaultToNothingSelected: true
            },
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true
        },
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.ChannelType,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.ChannelType,
            headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats.channels")}`,
            valueGetter: channelValueGetter,
            cellRenderer: "channelRenderer",
            flex: 1,
            hide: !selectedColumns.includes(_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.ChannelType),
            comparator: (valueA, valueB) => (0,_components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_3__.naturalStringComparator)(valueA.text, valueB.text),
            filter: "agSetColumnFilter",
            filterParams: {
                defaultToNothingSelected: true,
                suppressSelectAll: true
            },
            filterValueGetter: channelFilterValueGetter,
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true
        },
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.InQueue,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.InQueue,
            headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats.waiting")}`,
            flex: 1,
            hide: !selectedColumns.includes(_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.InQueue),
            comparator: _components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_3__.naturalStringComparator,
            filter: "agNumberColumnFilter",
            filterValueGetter: (params) => {
                return parseInt(params.data[_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.InQueue], 10) || 0;
            },
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true
        },
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.AvgWaitTime,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.AvgWaitTime,
            headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats.avgWaitTime")}`,
            filter: _components_Common_CellRenderers_filters_TimestampFilter__WEBPACK_IMPORTED_MODULE_2__.TimestampFilter,
            valueGetter: timeValueGetter,
            cellRenderer: "durationRenderer",
            flex: 1,
            hide: !selectedColumns.includes(_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.AvgWaitTime),
            comparator: (valueA, valueB) => (0,_components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_3__.naturalStringComparator)(valueA.duration, valueB.duration),
            filterParams: {
                defaultToNothingSelected: true,
                suppressSelectAll: true
            },
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true
        },
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.AvgHandleTime,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.AvgHandleTime,
            headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats.avgHandleTime")}`,
            filter: _components_Common_CellRenderers_filters_TimestampFilter__WEBPACK_IMPORTED_MODULE_2__.TimestampFilter,
            valueGetter: timeValueGetter,
            cellRenderer: "durationRenderer",
            flex: 1,
            hide: !selectedColumns.includes(_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.AvgWaitTime),
            comparator: (valueA, valueB) => (0,_components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_3__.naturalStringComparator)(valueA.duration, valueB.duration),
            filterParams: {
                defaultToNothingSelected: true,
                suppressSelectAll: true
            },
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true
        },
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Available,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Available,
            headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats.available")}`,
            flex: 1,
            hide: !selectedColumns.includes(_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Available),
            comparator: _components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_3__.naturalStringComparator,
            filter: "agNumberColumnFilter",
            filterValueGetter: (params) => {
                return parseInt(params.data[_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.HandledInteractions], 10) || 0;
            },
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true
        },
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Idle,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Idle,
            headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats.idle")}`,
            flex: 1,
            hide: !selectedColumns.includes(_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Idle),
            comparator: _components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_3__.naturalStringComparator,
            filter: "agNumberColumnFilter",
            filterValueGetter: (params) => {
                return parseInt(params.data[_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.HandledInteractions], 10) || 0;
            },
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true
        },
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Engaged,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Engaged,
            headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats.engaged")}`,
            flex: 1,
            hide: !selectedColumns.includes(_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Engaged),
            comparator: _components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_3__.naturalStringComparator,
            filter: "agNumberColumnFilter",
            filterValueGetter: (params) => {
                return parseInt(params.data[_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.HandledInteractions], 10) || 0;
            },
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true
        },
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Rona,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Rona,
            headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats.rona")}`,
            flex: 1,
            hide: !selectedColumns.includes(_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Rona),
            comparator: _components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_3__.naturalStringComparator,
            filter: "agNumberColumnFilter",
            filterValueGetter: (params) => {
                return parseInt(params.data[_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.HandledInteractions], 10) || 0;
            },
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true
        },
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Abandoned,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Abandoned,
            headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats.abandoned")}`,
            flex: 1,
            hide: !selectedColumns.includes(_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Abandoned),
            comparator: _components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_3__.naturalStringComparator,
            filter: "agNumberColumnFilter",
            filterValueGetter: (params) => {
                return parseInt(params.data[_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Abandoned], 10) || 0;
            },
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true
        },
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.LongestWaitTime,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.LongestWaitTime,
            valueGetter: timeValueGetter,
            cellRenderer: "durationRenderer",
            headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats.longestWaitTime")}`,
            flex: 1,
            hide: !selectedColumns.includes(_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.LongestWaitTime),
            comparator: (valueA, valueB) => (0,_components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_3__.naturalStringComparator)(valueA.duration, valueB.duration),
            filter: _components_Common_CellRenderers_filters_TimestampFilter__WEBPACK_IMPORTED_MODULE_2__.TimestampFilter,
            filterParams: {
                defaultToNothingSelected: true,
                suppressSelectAll: true
            },
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true
        },
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.PresentedInteractions,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.PresentedInteractions,
            headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats.presented")}`,
            flex: 1,
            hide: !selectedColumns.includes(_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.PresentedInteractions),
            comparator: _components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_3__.naturalStringComparator,
            filter: "agNumberColumnFilter",
            filterValueGetter: (params) => {
                return parseInt(params.data[_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.PresentedInteractions], 10) || 0;
            },
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true
        },
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.HandledInteractions,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.HandledInteractions,
            headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats.handled")}`,
            flex: 1,
            hide: !selectedColumns.includes(_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.HandledInteractions),
            comparator: _components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_3__.naturalStringComparator,
            filter: "agNumberColumnFilter",
            filterValueGetter: (params) => {
                return parseInt(params.data[_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.HandledInteractions], 10) || 0;
            },
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true
        },
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Transferred,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Transferred,
            headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats.transferred")}`,
            flex: 1,
            hide: !selectedColumns.includes(_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Transferred),
            comparator: _components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_3__.naturalStringComparator,
            filter: "agNumberColumnFilter",
            filterValueGetter: (params) => {
                return parseInt(params.data[_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Transferred], 10) || 0;
            },
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true
        },
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Ringing,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Ringing,
            headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats.ringing")}`,
            flex: 1,
            hide: !selectedColumns.includes(_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Ringing),
            comparator: _components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_3__.naturalStringComparator,
            filter: "agNumberColumnFilter",
            filterValueGetter: (params) => {
                return parseInt(params.data[_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.HandledInteractions], 10) || 0;
            },
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true
        }
    ];
    const actionColumn = [
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Actions,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Actions,
            headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats.actions")}`,
            sortable: false,
            pinned: "right",
            lockPosition: "right",
            lockPinned: true,
            cellRenderer: "actionButtonsRenderer",
            valueGetter: actionsValueGetter,
            cellClass: "actions-cell",
            width: 80,
            hide: !_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.SERVICE.featureflag.isQueueStatsDetailViewEnabled(),
            filter: false,
            suppressMovable: true,
            lockVisible: true,
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true
        }
    ];
    return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.SERVICE.featureflag.isQueueStatsDetailViewEnabled() ? [...baseColumns, ...actionColumn] : baseColumns;
}
function actionsValueGetter(params) {
    return {
        buttons: [{ type: _components_Common_CellRenderers_constants_types__WEBPACK_IMPORTED_MODULE_1__.ActionButtons.view }],
        context: { eventId: params.data["queueId"] }
    };
}
function timeValueGetter(params) {
    return {
        duration: params.data[params.colDef.field] || 0,
        createdTime: 0,
        isActive: false
    };
}
function channelValueGetter(params) {
    const channelType = params.data[params.colDef.field] || "";
    const type = channelType;
    const value = _components_Common_CellRenderers_constants_channel__WEBPACK_IMPORTED_MODULE_0__.CHANNEL_TYPE_TO_ICON_MAP[type];
    return {
        channelType: value
    };
}
function channelFilterValueGetter(params) {
    return params.data[params.colDef.field] || "";
}
function compactViewValueGetter(params) {
    const channelType = params.data[_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.ChannelType] || "";
    const type = channelType;
    const queueNameLabel = params.data[_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.QueueName];
    const waitInQueue = params.data[_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.InQueue];
    const averageWaitTime = params.data[_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.AvgWaitTime];
    return {
        channelType: type,
        queueName: queueNameLabel,
        waitingInQueue: waitInQueue,
        avgWaitTime: averageWaitTime
    };
}
const getBaseGridConfigs = () => {
    const columnDefs = getGridConfigs();
    return {
        theme,
        columnDefs,
        defaultColDef: {
            resizable: true,
            suppressHeaderMenuButton: true,
            sortable: true,
            suppressKeyboardEvent: keySuppressor.suppressKeyboardEvent
        },
        suppressContextMenu: true,
        overlayNoRowsTemplate: `<agentx-wc-empty-display-wrapper
        illustration-type="empty-state"
        title="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats:emptyTitle")}"
        info-message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats:emptyMessage")}"
      >
      </agentx-wc-empty-display-wrapper>`,
        rowBuffer: 20,
        debug: location.hostname === "localhost",
        sideBar: {
            toolPanels: [
                {
                    id: "columns",
                    labelDefault: "Columns",
                    labelKey: "columns",
                    iconKey: "columns",
                    toolPanel: "agColumnsToolPanel",
                    toolPanelParams: {
                        suppressRowGroups: true,
                        suppressValues: true,
                        suppressPivots: true,
                        suppressPivotMode: true,
                        suppressColumnFilter: true,
                        suppressColumnSelectAll: true,
                        suppressColumnExpandAll: true
                    },
                    minWidth: 200,
                    width: 200,
                    maxWidth: 200
                },
                {
                    id: "filters",
                    labelDefault: "Filters",
                    labelKey: "filters",
                    iconKey: "filter",
                    toolPanel: "agFiltersToolPanel",
                    toolPanelParams: {
                        suppressExpandAll: true,
                        suppressFilterSearch: true
                    },
                    minWidth: 200,
                    width: 200,
                    maxWidth: 200
                }
            ]
        }
    };
};
function getCollapsedGridConfigs() {
    return [
        ...getGridConfigs().map((colDef) => {
            return Object.assign(Object.assign({}, colDef), { hide: true });
        }),
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.ListView,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.ListView,
            headerName: "List View",
            valueGetter: compactViewValueGetter,
            cellRenderer: "queueStatsListItemRenderer",
            flex: 1,
            autoHeight: true
        }
    ];
}


/***/ }),

/***/ "./src/components/QueueStatsTab/components/QueuesMonitoringWidget/types.ts":
/*!*********************************************************************************!*\
  !*** ./src/components/QueueStatsTab/components/QueuesMonitoringWidget/types.ts ***!
  \*********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QueueStatsTableColumnId: () => (/* binding */ QueueStatsTableColumnId)
/* harmony export */ });
var QueueStatsTableColumnId;
(function (QueueStatsTableColumnId) {
    QueueStatsTableColumnId["Id"] = "id";
    QueueStatsTableColumnId["QueueName"] = "queueName";
    QueueStatsTableColumnId["Abandoned"] = "abandoned";
    QueueStatsTableColumnId["Available"] = "available";
    QueueStatsTableColumnId["AvgHandleTime"] = "avgHandleTime";
    QueueStatsTableColumnId["AvgWaitTime"] = "avgWaitTime";
    QueueStatsTableColumnId["ChannelType"] = "channelType";
    QueueStatsTableColumnId["Engaged"] = "engaged";
    QueueStatsTableColumnId["HandledInteractions"] = "handledInteractions";
    QueueStatsTableColumnId["Idle"] = "idle";
    QueueStatsTableColumnId["InQueue"] = "inQueue";
    QueueStatsTableColumnId["ListView"] = "listView";
    QueueStatsTableColumnId["LongestWaitTime"] = "longestWaitTime";
    QueueStatsTableColumnId["PresentedInteractions"] = "presentedInteractions";
    QueueStatsTableColumnId["Rona"] = "rona";
    QueueStatsTableColumnId["Transferred"] = "transferred";
    QueueStatsTableColumnId["Ringing"] = "ringing";
    QueueStatsTableColumnId["AssignmentType"] = "assignmentType";
    QueueStatsTableColumnId["Actions"] = "actions";
})(QueueStatsTableColumnId || (QueueStatsTableColumnId = {}));


/***/ }),

/***/ "./src/components/QueueStatsTab/index.ts":
/*!***********************************************!*\
  !*** ./src/components/QueueStatsTab/index.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QueueDataWidget: () => (/* reexport safe */ _components_QueueData_QueueDataWidget__WEBPACK_IMPORTED_MODULE_1__.QueueDataWidget),
/* harmony export */   QueueInteractionsWidget: () => (/* reexport safe */ _components_QueuesInteractionsWidget_QueueInteractionsWidget__WEBPACK_IMPORTED_MODULE_2__.QueueInteractionsWidget),
/* harmony export */   QueueStatsDetail: () => (/* reexport safe */ _QueueStatsDetail_QueueStatsDetail__WEBPACK_IMPORTED_MODULE_7__.QueueStatsDetail),
/* harmony export */   QueueStatsHeader: () => (/* reexport safe */ _components_QueueStatsHeader_QueueStatsHeader__WEBPACK_IMPORTED_MODULE_4__.QueueStatsHeader),
/* harmony export */   QueueStatsLanding: () => (/* reexport safe */ _QueueStatsLanding_QueueStatsLanding__WEBPACK_IMPORTED_MODULE_8__.QueueStatsLanding),
/* harmony export */   QueueStatsPerformanceDetailsView: () => (/* reexport safe */ _components_QueueStatsPerformanceDetailsView_QueueStatsPerformanceDetailsView__WEBPACK_IMPORTED_MODULE_5__.QueueStatsPerformanceDetailsView),
/* harmony export */   QueueStatsWidgets: () => (/* reexport safe */ _components_QueueStatsWidgets_QueueStatsWidgets__WEBPACK_IMPORTED_MODULE_6__.QueueStatsWidgets),
/* harmony export */   QueuesMonitoringWidget: () => (/* reexport safe */ _components_QueuesMonitoringWidget_QueuesMonitoringWidget__WEBPACK_IMPORTED_MODULE_3__.QueuesMonitoringWidget),
/* harmony export */   TableHeaderWidget: () => (/* reexport safe */ _Common_TableHeader_TableHeaderWidget__WEBPACK_IMPORTED_MODULE_0__.TableHeaderWidget)
/* harmony export */ });
/* harmony import */ var _Common_TableHeader_TableHeaderWidget__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Common/TableHeader/TableHeaderWidget */ "./src/components/Common/TableHeader/TableHeaderWidget.ts");
/* harmony import */ var _components_QueueData_QueueDataWidget__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components/QueueData/QueueDataWidget */ "./src/components/QueueStatsTab/components/QueueData/QueueDataWidget.ts");
/* harmony import */ var _components_QueuesInteractionsWidget_QueueInteractionsWidget__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./components/QueuesInteractionsWidget/QueueInteractionsWidget */ "./src/components/QueueStatsTab/components/QueuesInteractionsWidget/QueueInteractionsWidget.ts");
/* harmony import */ var _components_QueuesMonitoringWidget_QueuesMonitoringWidget__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./components/QueuesMonitoringWidget/QueuesMonitoringWidget */ "./src/components/QueueStatsTab/components/QueuesMonitoringWidget/QueuesMonitoringWidget.ts");
/* harmony import */ var _components_QueueStatsHeader_QueueStatsHeader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./components/QueueStatsHeader/QueueStatsHeader */ "./src/components/QueueStatsTab/components/QueueStatsHeader/QueueStatsHeader.ts");
/* harmony import */ var _components_QueueStatsPerformanceDetailsView_QueueStatsPerformanceDetailsView__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./components/QueueStatsPerformanceDetailsView/QueueStatsPerformanceDetailsView */ "./src/components/QueueStatsTab/components/QueueStatsPerformanceDetailsView/QueueStatsPerformanceDetailsView.ts");
/* harmony import */ var _components_QueueStatsWidgets_QueueStatsWidgets__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./components/QueueStatsWidgets/QueueStatsWidgets */ "./src/components/QueueStatsTab/components/QueueStatsWidgets/QueueStatsWidgets.ts");
/* harmony import */ var _QueueStatsDetail_QueueStatsDetail__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./QueueStatsDetail/QueueStatsDetail */ "./src/components/QueueStatsTab/QueueStatsDetail/QueueStatsDetail.ts");
/* harmony import */ var _QueueStatsLanding_QueueStatsLanding__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./QueueStatsLanding/QueueStatsLanding */ "./src/components/QueueStatsTab/QueueStatsLanding/QueueStatsLanding.ts");











/***/ }),

/***/ "./src/components/RealtimeTranscript/RealtimeTranscript.scss":
/*!*******************************************************************!*\
  !*** ./src/components/RealtimeTranscript/RealtimeTranscript.scss ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.transcript-container {
  height: 100%;
}

.transcript-empty-state {
  height: 100%;
  width: 100%;
}
.transcript-empty-state uuip-wc-empty-state::part(img) {
  width: 192px;
  height: 192px;
}
.transcript-empty-state uuip-wc-empty-state::part(container) {
  background-color: transparent;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL1JlYWx0aW1lVHJhbnNjcmlwdC9SZWFsdGltZVRyYW5zY3JpcHQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLFlBQUE7QUFDRjs7QUFFQTtFQUNFLFlBQUE7RUFDQSxXQUFBO0FBQ0Y7QUFDRTtFQUNFLFlBQUE7RUFDQSxhQUFBO0FBQ0o7QUFFRTtFQUNFLDZCQUFBO0FBQUoiLCJzb3VyY2VzQ29udGVudCI6WyIudHJhbnNjcmlwdC1jb250YWluZXIge1xuICBoZWlnaHQ6IDEwMCU7XG59XG5cbi50cmFuc2NyaXB0LWVtcHR5LXN0YXRlIHtcbiAgaGVpZ2h0OiAxMDAlO1xuICB3aWR0aDogMTAwJTtcblxuICB1dWlwLXdjLWVtcHR5LXN0YXRlOjpwYXJ0KGltZykge1xuICAgIHdpZHRoOiAxOTJweDtcbiAgICBoZWlnaHQ6IDE5MnB4O1xuICB9XG5cbiAgdXVpcC13Yy1lbXB0eS1zdGF0ZTo6cGFydChjb250YWluZXIpIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiB0cmFuc3BhcmVudDtcbiAgfVxufVxuIl0sInNvdXJjZVJvb3QiOiIifQ== */`);
    

/***/ }),

/***/ "./src/components/RealtimeTranscript/RealtimeTranscript.ts":
/*!*****************************************************************!*\
  !*** ./src/components/RealtimeTranscript/RealtimeTranscript.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   RealtimeTranscript: () => (/* binding */ RealtimeTranscript)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @uuip/unified-ui-platform-common-components */ "@uuip/unified-ui-platform-common-components");
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _RealtimeTranscript_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./RealtimeTranscript.scss */ "./src/components/RealtimeTranscript/RealtimeTranscript.scss");
/* harmony import */ var _utils_TranscriptUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./utils/TranscriptUtils */ "./src/components/RealtimeTranscript/utils/TranscriptUtils.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};







/**
 * @element agentx-wc-realtime-transcript
 */
let RealtimeTranscript = class RealtimeTranscript extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_4__.LitElement) {
    constructor() {
        super(...arguments);
        this.isSingleAgent = false;
        this.selfAvatar = undefined;
        this.interactionId = "";
        this.agentId = "";
        this.orgId = "";
        this.transcripts = [];
        this.isConnectionLost = false;
        this.stopRequestSent = false;
        this.transcriptionStartTime = null;
        this.callStartTime = null;
        this.activeObserver = null;
        this.handleTranscriptionEvent = (event) => {
            if (event.data.data.conversationId !== this.interactionId) {
                return;
            }
            this.upsertNewTranscript(event);
        };
        this.stopTranscripts = (agentId, orgId, interaction) => __awaiter(this, void 0, void 0, function* () {
            if (this.stopRequestSent || interaction !== this.interactionId) {
                return;
            }
            this.stopRequestSent = true;
            const payload = {
                agentId,
                orgId,
                eventType: "CUSTOM_EVENT",
                eventName: "GET_TRANSCRIPTS",
                eventDetails: {
                    data: {
                        interactionId: this.interactionId,
                        action: "STOP",
                        actionTimeStamp: Date.now()
                    }
                }
            };
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`Requesting real-time transcription to stop for interactionId: ${this.interactionId}`);
            try {
                yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.apiAIAssistant.sendEvent(payload);
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`Transcript stop request sent successfully for interactionId: ${this.interactionId}`);
            }
            catch (error) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`Failed to send transcript stop request to AI Assistant Service: ${error}`, error);
            }
        });
        this.handleMonitoringEnded = (event) => {
            this.stopTranscripts(event.data.supervisorId, event.data.orgId, event.data.taskId);
        };
        this.handleAgentWrapUp = (event) => {
            this.stopTranscripts(event.data.agentId, event.data.orgId, event.data.interactionId);
        };
        this.handleConsultConferenceEnded = (event) => {
            if (event.data.destAgentId === this.agentId) {
                this.stopTranscripts(event.data.destAgentId, event.data.orgId, event.data.interactionId);
            }
        };
        this.handleConversationEnding = (event) => {
            if (event.data.interactionId !== this.interactionId || this.transcripts.length === 0) {
                return;
            }
            const terminatingParty = event.data.terminatingParty || (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:realtimeTranscripts.you");
            const endMessage = this.createMessageObject("END", "", "AGENT", terminatingParty + (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:realtimeTranscripts.callEnded"), Date.now());
            this.transcripts = [...this.transcripts, endMessage];
            this.sendMetric(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.REALTIME_TRANSCRIPTS_DURATION);
            this.stopTranscripts(event.data.agentId, event.data.orgId, event.data.interactionId);
        };
        this.handleConnectionStatusChanged = (event) => {
            if (this.isConnectionLost !== event.isConnectionLost) {
                this.isConnectionLost = event.isConnectionLost;
                const errorMessage = this.createMessageObject("ERROR", "", "", this.isConnectionLost
                    ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:realtimeTranscripts.transcriptsServiceNotAvailable")
                    : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:realtimeTranscripts.transcriptsServiceRestored"), Date.now());
                this.transcripts = [...this.transcripts, errorMessage];
            }
        };
        this.handleFeedbackClick = (event) => {
            this.sendMetric(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.REALTIME_TRANSCRIPTS_FEEDBACK_CLICKED, {
                type: event.detail.type
            });
        };
        this.handleJumpToBottomClick = () => {
            this.sendMetric(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.REALTIME_TRANSCRIPTS_JUMP_TO_BOTTOM_CLICKED);
        };
    }
    get transcriptionDurationSeconds() {
        if (!this.transcriptionStartTime) {
            return 0;
        }
        return (Date.now() - this.transcriptionStartTime) / 1000;
    }
    connectedCallback() {
        super.connectedCallback();
        this.callStartTime = Date.now();
        this.initializeListeners();
        this.sendMetric(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.REALTIME_TRANSCRIPTS_LOADED);
        this.setupActiveObserver();
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        if (this.transcriptsAvailable()) {
            this.stopTranscripts(this.agentId, this.orgId, this.interactionId);
        }
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.aiAssistant.eRealtimeTranscriptionAvailable.stopListen(this.handleTranscriptionEvent);
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.contact.eAgentContactEnded.stopListen(this.handleConversationEnding);
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.connectionConfig.OnConnectionLost.stopListen(this.handleConnectionStatusChanged);
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.contact.eAgentWrapup.stopListen(this.handleAgentWrapUp);
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.contact.eAgentConsultConferenceEnded.stopListen(this.handleConsultConferenceEnded);
        (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.supervisor) === null || _a === void 0 ? void 0 : _a.eMonitoringEnded.stopListen(this.handleMonitoringEnded);
        if (this.activeObserver) {
            this.activeObserver.disconnect();
            this.activeObserver = null;
        }
    }
    setupActiveObserver() {
        this.activeObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    // Send telemetry when the component is actually visible
                    this.sendMetric(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.REALTIME_TRANSCRIPTS_VISIBLE);
                }
            });
        });
        this.activeObserver.observe(this);
    }
    initializeListeners() {
        var _a;
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.aiAssistant.eRealtimeTranscriptionAvailable.listen(this.handleTranscriptionEvent);
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.contact.eAgentContactEnded.listen(this.handleConversationEnding);
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.connectionConfig.OnConnectionLost.listen(this.handleConnectionStatusChanged);
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.contact.eAgentWrapup.listen(this.handleAgentWrapUp);
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.contact.eAgentConsultConferenceEnded.listen(this.handleConsultConferenceEnded);
        (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.supervisor) === null || _a === void 0 ? void 0 : _a.eMonitoringEnded.listen(this.handleMonitoringEnded);
    }
    static get styles() {
        return _RealtimeTranscript_scss__WEBPACK_IMPORTED_MODULE_5__["default"];
    }
    getMessages() {
        return this.transcripts;
    }
    upsertNewTranscript(event) {
        const { messageId, publishTimestamp, content, role } = event.data.data;
        if (content === "") {
            return;
        }
        if (this.transcripts.length === 0 && this.callStartTime) {
            this.transcripts.push(this.createMessageObject("START", "", "", (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:realtimeTranscripts.callStarted"), this.callStartTime));
        }
        // Find existing message or insertion point
        const { existingIndex, insertPosition } = this.findMessagePosition(messageId, publishTimestamp);
        if (existingIndex >= 0) {
            // Replace the object at the existing index with a copy of it having the content changed
            if (this.transcripts[existingIndex].content === content) {
                return;
            }
            this.transcripts[existingIndex] = Object.assign(Object.assign({}, this.transcripts[existingIndex]), { content });
        }
        else {
            this.transcripts.splice(insertPosition + 1, 0, this.createMessageObject("CHAT", messageId, role, content, publishTimestamp));
        }
        this.transcripts = [...this.transcripts];
        // Send telemetry for the first transcription event
        if (!this.transcriptionStartTime) {
            this.transcriptionStartTime = Date.now();
            this.sendMetric(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.REALTIME_TRANSCRIPTS_AVAILABLE);
        }
    }
    findMessagePosition(messageId, timestamp) {
        let existingIndex = -1;
        let insertPosition = -1;
        for (let i = this.transcripts.length - 1; i >= 0; i--) {
            if (this.transcripts[i].id === messageId) {
                existingIndex = i;
                break;
            }
            if (insertPosition === -1 && this.transcripts[i].rawTimestamp <= timestamp) {
                insertPosition = i;
            }
        }
        return { existingIndex, insertPosition };
    }
    createMessageObject(type, messageId, role, content, timestamp) {
        const isSelfMessage = this.isSingleAgent && role === "AGENT" && type === "CHAT";
        const isLongTimestampFormat = type === "START" || type === "END";
        const avatarAvailable = !!this.selfAvatar;
        const title = role === "AGENT"
            ? isSelfMessage
                ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:realtimeTranscripts.you")
                : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:realtimeTranscripts.agent")
            : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:realtimeTranscripts.customer");
        return {
            id: messageId,
            rawTimestamp: timestamp,
            displayType: isSelfMessage && !avatarAvailable ? "SELF" : type,
            title,
            content,
            timestamp: (0,_utils_TranscriptUtils__WEBPACK_IMPORTED_MODULE_6__.FormatDateTime)(timestamp, isLongTimestampFormat),
            avatarUrl: isSelfMessage ? this.selfAvatar || "" : "",
            status: ""
        };
    }
    sendMetric(type, additionalData = {}) {
        const baseData = {
            interactionId: this.interactionId
        };
        if (type === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.REALTIME_TRANSCRIPTS_DURATION) {
            baseData.duration = this.transcriptionDurationSeconds;
        }
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(type, Object.assign(Object.assign({}, baseData), additionalData));
    }
    transcriptsAvailable() {
        return this.transcriptionStartTime !== null;
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
      ${this.transcripts.length === 0
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `<div class="transcript-empty-state">
            <uuip-wc-empty-state
              illustration-src="/images/illustrations/cliff-open-192-cobalt-lime.svg"
              class="empty-state-illustration"
              illustration-name="cliff-open-192-cobalt-lime"
            >
              <p>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:realtimeTranscripts.transcriptsNotAvailable")}</p>
            </uuip-wc-empty-state>
          </div>`
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) ` <div class="transcript-container">
            <uuip-wc-chat-message-list
              ?showFeedback=${true}
              .messageList=${this.transcripts}
              .interactionId=${this.interactionId}
              .localization=${{
                feedbackText: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:realtimeTranscripts.feedbackText"),
                tooltipHelpful: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:realtimeTranscripts.feedbackHelpful"),
                tooltipNotHelpful: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:realtimeTranscripts.feedbackNotHelpful")
            }}
              @feedback-clicked=${this.handleFeedbackClick}
              @jump-to-bottom-clicked=${this.handleJumpToBottomClick}
            ></uuip-wc-chat-message-list>
          </div>`}
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
], RealtimeTranscript.prototype, "isSingleAgent", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
], RealtimeTranscript.prototype, "selfAvatar", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
], RealtimeTranscript.prototype, "interactionId", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
], RealtimeTranscript.prototype, "agentId", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
], RealtimeTranscript.prototype, "orgId", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
], RealtimeTranscript.prototype, "transcripts", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
], RealtimeTranscript.prototype, "isConnectionLost", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
], RealtimeTranscript.prototype, "stopRequestSent", void 0);
RealtimeTranscript = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.customElement)("agentx-wc-realtime-transcript")
], RealtimeTranscript);



/***/ }),

/***/ "./src/components/RealtimeTranscript/utils/TranscriptUtils.ts":
/*!********************************************************************!*\
  !*** ./src/components/RealtimeTranscript/utils/TranscriptUtils.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FormatDateTime: () => (/* binding */ FormatDateTime),
/* harmony export */   getLocaleTimezone: () => (/* binding */ getLocaleTimezone)
/* harmony export */ });
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");

function getLocaleTimezone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function FormatDateTime(timestamp, longFormat = false) {
    const dateTime = new Date(timestamp);
    if (isNaN(dateTime.getTime())) {
        _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.warn("invalid timestamp");
        return "";
    }
    const timeOptions = {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
        timeZone: getLocaleTimezone()
    };
    if (longFormat) {
        const dateOptions = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        };
        const datePart = dateTime.toLocaleDateString("en-US", dateOptions);
        const timePart = dateTime.toLocaleTimeString("en-US", timeOptions);
        return `${datePart} ${timePart}`;
    }
    return dateTime.toLocaleTimeString("en-US", timeOptions);
}


/***/ }),

/***/ "./src/components/ScheduleAndManageCallBack/CallBackForm.scss":
/*!********************************************************************!*\
  !*** ./src/components/ScheduleAndManageCallBack/CallBackForm.scss ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.callback-form-footer-btn-grp {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
}

.call-between-time {
  display: flex;
  gap: 8px;
}

.assign-to,
.date-n-time-section {
  margin-bottom: 8px;
}

.form-group {
  margin-bottom: 8px;
}
.form-group md-label {
  display: block;
  margin-bottom: 8px;
}
.form-group md-input {
  display: block;
  margin-bottom: -8px;
}

.time-from,
.time-to {
  width: 198px;
}

.word-counter {
  display: flex;
  margin-top: -10px;
  justify-content: flex-end;
}

.date-n-time-section {
  margin-top: 8px;
}

.date-time-section-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--md-primary-text-color);
}

.form-wrapper {
  padding-left: 2px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL1NjaGVkdWxlQW5kTWFuYWdlQ2FsbEJhY2svQ2FsbEJhY2tGb3JtLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxhQUFBO0VBQ0EseUJBQUE7RUFDQSxRQUFBO0VBQ0EsZ0JBQUE7QUFDRjs7QUFFQTtFQUNFLGFBQUE7RUFDQSxRQUFBO0FBQ0Y7O0FBRUE7O0VBRUUsa0JBQUE7QUFDRjs7QUFFQTtFQUNFLGtCQUFBO0FBQ0Y7QUFBRTtFQUNFLGNBQUE7RUFDQSxrQkFBQTtBQUVKO0FBQ0U7RUFDRSxjQUFBO0VBQ0EsbUJBQUE7QUFDSjs7QUFHQTs7RUFFRSxZQUFBO0FBQUY7O0FBR0E7RUFDRSxhQUFBO0VBQ0EsaUJBQUE7RUFDQSx5QkFBQTtBQUFGOztBQUdBO0VBQ0UsZUFBQTtBQUFGOztBQUdBO0VBQ0UsYUFBQTtFQUNBLG1CQUFBO0VBQ0EsUUFBQTtFQUNBLG1DQUFBO0FBQUY7O0FBR0E7RUFDRSxpQkFBQTtBQUFGIiwic291cmNlc0NvbnRlbnQiOlsiLmNhbGxiYWNrLWZvcm0tZm9vdGVyLWJ0bi1ncnAge1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtZW5kO1xuICBnYXA6IDhweDtcbiAgbWFyZ2luLXRvcDogMTZweDtcbn1cblxuLmNhbGwtYmV0d2Vlbi10aW1lIHtcbiAgZGlzcGxheTogZmxleDtcbiAgZ2FwOiA4cHg7XG59XG5cbi5hc3NpZ24tdG8sXG4uZGF0ZS1uLXRpbWUtc2VjdGlvbiB7XG4gIG1hcmdpbi1ib3R0b206IDhweDtcbn1cblxuLmZvcm0tZ3JvdXAge1xuICBtYXJnaW4tYm90dG9tOiA4cHg7XG4gIG1kLWxhYmVsIHtcbiAgICBkaXNwbGF5OiBibG9jaztcbiAgICBtYXJnaW4tYm90dG9tOiA4cHg7XG4gIH1cblxuICBtZC1pbnB1dCB7XG4gICAgZGlzcGxheTogYmxvY2s7XG4gICAgbWFyZ2luLWJvdHRvbTogLThweDtcbiAgfVxufVxuXG4udGltZS1mcm9tLFxuLnRpbWUtdG8ge1xuICB3aWR0aDogMTk4cHg7XG59XG5cbi53b3JkLWNvdW50ZXIge1xuICBkaXNwbGF5OiBmbGV4O1xuICBtYXJnaW4tdG9wOiAtMTBweDtcbiAganVzdGlmeS1jb250ZW50OiBmbGV4LWVuZDtcbn1cblxuLmRhdGUtbi10aW1lLXNlY3Rpb24ge1xuICBtYXJnaW4tdG9wOiA4cHg7XG59XG5cbi5kYXRlLXRpbWUtc2VjdGlvbi13cmFwcGVyIHtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgZ2FwOiA4cHg7XG4gIGNvbG9yOiB2YXIoLS1tZC1wcmltYXJ5LXRleHQtY29sb3IpO1xufVxuXG4uZm9ybS13cmFwcGVyIHtcbiAgcGFkZGluZy1sZWZ0OiAycHg7XG59XG4iXSwic291cmNlUm9vdCI6IiJ9 */`);
    

/***/ }),

/***/ "./src/components/ScheduleAndManageCallBack/CallBackForm.ts":
/*!******************************************************************!*\
  !*** ./src/components/ScheduleAndManageCallBack/CallBackForm.ts ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CallbackForm: () => (/* binding */ CallbackForm)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _CallBackForm_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./CallBackForm.scss */ "./src/components/ScheduleAndManageCallBack/CallBackForm.scss");
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./constant */ "./src/components/ScheduleAndManageCallBack/constant.ts");
/* harmony import */ var _ScheduleAndManageCallbackUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./ScheduleAndManageCallbackUtils */ "./src/components/ScheduleAndManageCallBack/ScheduleAndManageCallbackUtils.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







let CallbackForm = class CallbackForm extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_1__.MobxLitElement) {
    constructor() {
        super(...arguments);
        this.callbackFormData = _constant__WEBPACK_IMPORTED_MODULE_5__.EMPTY_CALLBACK_FORM_DATA;
        //TODO: this type will be changed once we get to know the api contract on what format it needs to be send to backend.
        this.finalCallbackFormData = null;
        this.timeZoneData = _constant__WEBPACK_IMPORTED_MODULE_5__.TIME_ZONE_DATA;
        this.timeSlots = _constant__WEBPACK_IMPORTED_MODULE_5__.TIME_SLOTS;
        this.queueValue = "";
        this.timeZoneValue = "";
        this.timeFromValue = "";
        this.timeToValue = "";
        this.callbackDate = {
            day: "",
            month: "",
            year: ""
        };
        this.userLocale = _constant__WEBPACK_IMPORTED_MODULE_5__.EN_US_LOCALE;
        this.defaultTimeZones = (0,_ScheduleAndManageCallbackUtils__WEBPACK_IMPORTED_MODULE_6__.getDefaultTimeZones)();
        this.setInitialTimeZoneData = () => {
            this.timeZoneData = (0,_ScheduleAndManageCallbackUtils__WEBPACK_IMPORTED_MODULE_6__.getTimezonesWithOffset)(this.defaultTimeZones, this.userLocale, this.callbackDate);
        };
        this.handleScheduleSubmitForm = (e) => {
            var _a;
            e.preventDefault();
            const form = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById("scheduledCallBackForm");
            if (!form) {
                return;
            }
            const customerNameInput = form.querySelector("#customer-name");
            const phoneInput = form.querySelector("#phone");
            const datePicker = form.querySelector("md-datepicker");
            const callbackReasonInput = form.querySelector("#callback-reason");
            // Create the final data object
            this.finalCallbackFormData = Object.assign(Object.assign({}, this.finalCallbackFormData), { customerName: (customerNameInput === null || customerNameInput === void 0 ? void 0 : customerNameInput.value) || "", phoneNumber: (phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.value) || "", timeZone: this.timeZoneValue || "", date: (datePicker === null || datePicker === void 0 ? void 0 : datePicker.value) || "", callTimeFrom: this.timeFromValue || "", callTimeTo: this.timeToValue || "", queueName: this.queueValue || "", callBackReason: (callbackReasonInput === null || callbackReasonInput === void 0 ? void 0 : callbackReasonInput.value) || "" });
        };
        this.handleSelectedTimeZone = (e) => {
            this.timeZoneValue = e.detail.value;
        };
        this.handleSelectedTimeFrom = (e) => {
            this.timeFromValue = e.detail.option;
        };
        this.handleSelectedTimeTo = (e) => {
            this.timeToValue = e.detail.option;
        };
        this.handleSelectedQueue = (e) => {
            this.queueValue = e.detail.selected[0];
        };
        this.handleSelectedDate = (e) => {
            const dateValue = e.detail.data;
            if (!dateValue.invalid) {
                this.callbackDate = {
                    day: dateValue.c.day,
                    month: dateValue.c.month,
                    year: dateValue.c.year
                };
            }
            this.timeZoneData = (0,_ScheduleAndManageCallbackUtils__WEBPACK_IMPORTED_MODULE_6__.getTimezonesWithOffset)(this.defaultTimeZones, this.userLocale, this.callbackDate);
            if (this.timeZoneValue) {
                const selectedCustomerTimeRegion = (0,_ScheduleAndManageCallbackUtils__WEBPACK_IMPORTED_MODULE_6__.getTimeRegionFromTimeZone)(this.timeZoneValue);
                this.timeZoneValue = this.timeZoneData.find((tz) => tz.includes(selectedCustomerTimeRegion)) || "";
            }
        };
    }
    updated(changedProperties) {
        super.updated(changedProperties);
    }
    connectedCallback() {
        super.connectedCallback();
        this.finalCallbackFormData = Object.assign({}, this.callbackFormData);
        this.focusTimeout = window.setTimeout(() => {
            var _a, _b, _c;
            const inputField = (_c = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-input#phone")) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector("input");
            inputField === null || inputField === void 0 ? void 0 : inputField.focus();
        }, 50);
        this.userLocale = navigator.language || _constant__WEBPACK_IMPORTED_MODULE_5__.EN_US_LOCALE;
        this.setInitialTimeZoneData();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        clearTimeout(this.focusTimeout);
    }
    static get styles() {
        return _CallBackForm_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      <div>
        <form id="scheduledCallBackForm" class="form-wrapper">
          <div style="width: 400px" class="form-inner-wrapper">
            <div class="form-group">
              <md-input
                ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.phoneNumber")}"
                label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.phoneNumber")}"
                id="phone"
                name="phone"
                type="tel"
                value="${this.callbackFormData.phoneNumber}"
                newmomentum
                placeholder="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.phoneNumber")}"
              ></md-input>
            </div>

            <div class="form-group">
              <md-input
                ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.customerName")}"
                label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.customerName")}"
                id="customer-name"
                value="${this.callbackFormData.customerName}"
                name="name"
                newmomentum
                placeholder="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.customerNamePlaceholder")}"
                required
              ></md-input>
            </div>

            <div class="date-time-section-wrapper">
              <h4 class="date-n-time-section">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.selectDateAndTime")}</h4>

              <md-tooltip
                placement="right"
                class="date-time-tooltip"
                id="date-time-tooltip"
                message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.scheduleCallbackInfo")}"
              >
                <md-icon
                  tabindex="0"
                  arialabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.scheduleCallbackInfo")}"
                  name="info-badge-filled"
                  size="16"
                  aria-hidden="true"
                  iconset="momentumDesign"
                ></md-icon>
              </md-tooltip>
            </div>

            <div class="form-group">
              <md-datepicker
                label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.date")}"
                id="datePicker"
                weekStart="Monday"
                placeholder="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.datePlaceholder")}"
                value="${this.callbackFormData.date}"
                newMomentum
                @date-selection-change="${this.handleSelectedDate}"
                locale="${this.userLocale}"
              ></md-datepicker>
            </div>

            <div class="form-group">
              <md-label for="subject">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.callBetween")}</md-label>
              <div class="call-between-time">
                <div class="time-from">
                  <md-dropdown
                    .options="${this.timeSlots}"
                    .defaultOption="${this.callbackFormData.callTimeFrom
            ? this.callbackFormData.callTimeFrom
            : this.timeSlots[0]}"
                    @dropdown-selected="${this.handleSelectedTimeFrom}"
                    custom-tab-index="0"
                    visible-option="7"
                    input-value=""
                    id="time-from-dropdown"
                    left-icon="recents-bold"
                    arialabel=""
                    newmomentum
                  ></md-dropdown>
                </div>

                <div class="time-to">
                  <md-dropdown
                    .options="${this.timeSlots}"
                    .defaultOption="${this.callbackFormData.callTimeTo
            ? this.callbackFormData.callTimeTo
            : this.timeSlots[0]}"
                    @dropdown-selected="${this.handleSelectedTimeTo}"
                    custom-tab-index="0"
                    visible-option="7"
                    input-value=""
                    id="time-to-dropdown"
                    left-icon="recents-bold"
                    arialabel=""
                    newmomentum
                  ></md-dropdown>
                </div>
              </div>
            </div>

            <div class="form-group">
              <md-label for="subject">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.timezone")}</md-label>
              <md-combobox
                class="customer-timezone-combobox"
                .options=${this.timeZoneData}
                .value="${[this.callbackFormData.timeZone]}"
                htmlId="customerTimezone"
                @change-selected="${this.handleSelectedTimeZone}"
                placeholder="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.timezonePlaceholder")}"
                newMomentum
                id="timezone-combobox"
                ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.timezone")}"
                .inputValue="${this.timeZoneValue || ""}"
                searchable
                use-virtual-scroll
              ></md-combobox>
            </div>

            <div class="form-group">
              <md-label for="message">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.queue")}</md-label>
              <md-combobox
                class="queue-name"
                .options=${[]}
                .value="${[this.callbackFormData.queueName]}"
                htmlId="queueName"
                @change-selected="${(e) => {
            this.handleSelectedQueue(e);
        }}"
                placeholder="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.queuePlaceholder")}"
                newMomentum
                id="callback-queue-name"
                ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.queue")}"
                searchable
              ></md-combobox>
            </div>

            <div class="form-group">
              <md-input
                id="callback-reason"
                label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.callbackReason")}"
                value="${this.callbackFormData.callBackReason}"
                name="message"
                rows="5"
                multiline
                placeholder="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.callbackReasonPlaceholder")}"
              ></md-input>
            </div>
            <span class="word-counter">00/250</span>
          </div>

          <div class="form-group callback-form-footer-btn-grp">
            <md-button outline>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.cancel")} </md-button>
            <md-button
              test-id="schedule-callback-btn"
              @click=${this.handleScheduleSubmitForm}
              type="submit"
              variant="primary"
              >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.schedule")}
            </md-button>
          </div>
        </form>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Object })
], CallbackForm.prototype, "callbackFormData", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], CallbackForm.prototype, "finalCallbackFormData", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], CallbackForm.prototype, "timeZoneData", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], CallbackForm.prototype, "timeSlots", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], CallbackForm.prototype, "queueValue", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], CallbackForm.prototype, "timeZoneValue", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], CallbackForm.prototype, "timeFromValue", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], CallbackForm.prototype, "timeToValue", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], CallbackForm.prototype, "callbackDate", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], CallbackForm.prototype, "userLocale", void 0);
CallbackForm = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-callback-form")
], CallbackForm);



/***/ }),

/***/ "./src/components/ScheduleAndManageCallBack/CallBackModal.scss":
/*!*********************************************************************!*\
  !*** ./src/components/ScheduleAndManageCallBack/CallBackModal.scss ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

* {
  /* BASE LEVEL < 100 */
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-index-tpw-header: 1;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-index-task-collapse-area: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-navigation-bar: 12;
  --z-index-task-list: 12;
  --z-index-wrap-up: 13;
  --z-index-sticky-header: 14;
  --z-index-shortcutkey-modal: 15;
  /* MID LEVEL FLOATING > 100 < 1000 */
  --z-index-notification: 150;
  /* SUPER LEVEL > 1000 */
  --z-index-modal: 1040;
  --z-index-popover: 1041;
  --z-index-callback-modal: 1042;
  /* This below order needs to be unchanged. Highest priority is for connection loss overlay,
         followed by error modal since error can occur during app load such as teams failure/register failure. */
  --z-index-app-full-overlay: 1050;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1200;
}

:host {
  color: var(--md-primary-text-color);
  font-family: var(--font-family);
}

#call-back-modal::part(floating) {
  overflow: hidden;
  z-index: var(--z-index-callback-modal);
  position: absolute;
  top: 30%;
  bottom: 50%;
}

@media (max-width: 880px) {
  #call-back-modal::part(floating) {
    overflow: hidden;
    left: 0;
    top: var(--nav-header-height);
  }
}
@media (max-width: 736px) {
  #call-back-modal::part(floating) {
    overflow: hidden;
    left: 0;
    top: var(--nav-header-height);
  }
  [full-screen]#call-back-modal::part(floating) {
    z-index: var(--z-index-callback-modal);
  }
}
md-floating-modal::part(floating) {
  min-height: 320px;
  width: 580px;
}

.date-time-tooltip {
  height: 15px;
}

.request-callback-header {
  margin: 0px 0px 16px 2px;
  color: var(--md-primary-text-color);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/ScheduleAndManageCallBack/CallbackModal.ts":
/*!*******************************************************************!*\
  !*** ./src/components/ScheduleAndManageCallBack/CallbackModal.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CallBackModal: () => (/* binding */ CallBackModal)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @uuip/unified-ui-platform-common-components */ "@uuip/unified-ui-platform-common-components");
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Common_EmptyStateWrapper_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Common/EmptyStateWrapper/EmptyStateWrapper */ "./src/components/Common/EmptyStateWrapper/EmptyStateWrapper.ts");
/* harmony import */ var _CallBackForm__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./CallBackForm */ "./src/components/ScheduleAndManageCallBack/CallBackForm.ts");
/* harmony import */ var _CallBackModal_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./CallBackModal.scss */ "./src/components/ScheduleAndManageCallBack/CallBackModal.scss");
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./constant */ "./src/components/ScheduleAndManageCallBack/constant.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









let CallBackModal = class CallBackModal extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
    constructor() {
        super(...arguments);
        this.isModalOpen = false;
        this.callbackModalData = {
            triggeredFrom: ""
        };
        this.callbackFormData = {
            customerName: "",
            phoneNumber: "",
            timeZone: "",
            date: "",
            callTimeFrom: "",
            callTimeTo: "",
            assignTo: "",
            queueName: "",
            callBackReason: ""
        };
        this.headerDesc = "";
        this.selectedTabIndex = 0;
        this.istabView = () => {
            return this.callbackModalData.triggeredFrom.toUpperCase() === _constant__WEBPACK_IMPORTED_MODULE_8__.INTERACTION_CONTROL;
        };
        this.getModalTitle = () => {
            const triggeredFrom = this.callbackModalData.triggeredFrom.toUpperCase();
            if (triggeredFrom === _constant__WEBPACK_IMPORTED_MODULE_8__.INTERACTION_CONTROL) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.scheduleAndManageCallbacksHeader");
            }
            else if (triggeredFrom === _constant__WEBPACK_IMPORTED_MODULE_8__.TASK_PANEL) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.scheduleCallbackHeader");
            }
            else if (triggeredFrom === _constant__WEBPACK_IMPORTED_MODULE_8__.TASK_PANEL_EDIT) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.editCallbackHeader");
            }
            return "";
        };
        this.lessWidth = 734;
        this.midWidth = 920;
        this.defaultWidth = 500;
        this.handleTabChange = (e) => {
            this.selectedTabIndex = e.detail.value;
        };
        this.calculateCenterPosition = (modalWidth = 500, modalHeight = 1150) => {
            const x = (window.innerWidth - modalWidth) / 2;
            const y = (window.innerHeight - modalHeight) / 2;
            return { x, y };
        };
    }
    handleCloseModal() {
        const event = new CustomEvent("ax-close-schedule-callback-modal", {
            detail: false,
            bubbles: true,
            composed: true
        });
        this.dispatchEvent(event);
    }
    static get styles() {
        return _CallBackModal_scss__WEBPACK_IMPORTED_MODULE_7__["default"];
    }
    getHeightWidth() {
        if (window.innerWidth < this.lessWidth) {
            return {
                width: window.innerWidth * 0.7,
                height: window.innerHeight * 0.8
            };
        }
        else if (window.innerWidth < this.midWidth) {
            return {
                width: window.innerWidth * 0.5,
                height: window.innerHeight * 0.8
            };
        }
        else {
            return { width: this.defaultWidth, height: window.innerHeight * 0.8 };
        }
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      <md-floating-modal
        ?show=${this.isModalOpen}
        class="call-back-modal"
        id="call-back-modal"
        .full-screen=${false}
        label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.scheduleAndManageCallbacksHeader")}
        maximize-aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.maximizeScreenLabel")}
        minimize-aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.minimizeModal")}
        resize-aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.restoreScreenLabel")}
        close-aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.closeModal")}
        @floating-modal-close=${() => this.handleCloseModal()}
        .position=${this.calculateCenterPosition()}
        .containerRect=${this.getHeightWidth()}
        .maximizable=${false}
        .resizable=${false}
      >
        <h4 class="callback-modal-header" slot="header">${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__.ifDefined)(this.getModalTitle())}</h4>
        ${this.istabView()
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
              <md-tabs class="md-tab-scheduled-callback" @selected-changed=${this.handleTabChange} selected="0">
                <md-tab slot="tab" class="schedule-callback" aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.scheduleACallback")}>
                  <md-icon
                    name=${this.selectedTabIndex === 0 ? "call-return-filled" : "call-return-bold"}
                    size="16"
                    aria-hidden="true"
                    iconSet="momentumDesign"
                  ></md-icon>
                  <span>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.scheduleACallback")}</span>
                </md-tab>
                <md-tab-panel aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.createCallbackRequest")} slot="panel">
                  ${this.callbackModalData.triggeredFrom.toUpperCase() === _constant__WEBPACK_IMPORTED_MODULE_8__.INTERACTION_CONTROL
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                        <div id="request-callback-header" class="request-callback-header" style="">
                          ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.createCallbackRequest")}
                        </div>
                      `
                : null}

                  <agentx-wc-callback-form .callbackFormData=${this.callbackFormData}></agentx-wc-callback-form>
                </md-tab-panel>
                <md-tab slot="tab" class="manage-callback" aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.manageCallbacks")}>
                  <md-icon
                    name=${this.selectedTabIndex === 1 ? "edit-filled" : "edit-bold"}
                    size="16"
                    aria-hidden="true"
                    iconSet="momentumDesign"
                  ></md-icon>
                  <span>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:callback.manageCallbacks")}</span>
                </md-tab>
                <md-tab-panel slot="panel">
                  <agentx-wc-callback-list></agentx-wc-callback-list>
                </md-tab-panel>
              </md-tabs>
            `
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) ` <agentx-wc-callback-form .callbackFormData=${this.callbackFormData}></agentx-wc-callback-form> `}
      </md-floating-modal>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
], CallBackModal.prototype, "isModalOpen", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Object })
], CallBackModal.prototype, "callbackModalData", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Object })
], CallBackModal.prototype, "callbackFormData", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], CallBackModal.prototype, "headerDesc", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], CallBackModal.prototype, "selectedTabIndex", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], CallBackModal.prototype, "lessWidth", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], CallBackModal.prototype, "midWidth", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], CallBackModal.prototype, "defaultWidth", void 0);
CallBackModal = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-callback-modal")
], CallBackModal);



/***/ }),

/***/ "./src/components/ScheduleAndManageCallBack/ScheduleAndManageCallbackUtils.ts":
/*!************************************************************************************!*\
  !*** ./src/components/ScheduleAndManageCallBack/ScheduleAndManageCallbackUtils.ts ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getDefaultTimeZones: () => (/* binding */ getDefaultTimeZones),
/* harmony export */   getTimeRegionFromTimeZone: () => (/* binding */ getTimeRegionFromTimeZone),
/* harmony export */   getTimezonesWithOffset: () => (/* binding */ getTimezonesWithOffset),
/* harmony export */   isValidDate: () => (/* binding */ isValidDate)
/* harmony export */ });
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./constant */ "./src/components/ScheduleAndManageCallBack/constant.ts");


const isValidDate = (date) => {
    const { day, month, year } = {
        day: Number(date.day),
        month: Number(date.month),
        year: Number(date.year)
    };
    if (!day || !month || !year || isNaN(day) || isNaN(month) || isNaN(year)) {
        return false;
    }
    // Checking if the values are correct
    const d = new Date(year, month - 1, day);
    return d.getFullYear() === year && d.getMonth() === month - 1 && d.getDate() === day;
};
const getTimezonesWithOffset = (timezones, userLocale, callbackDate) => {
    let date;
    if (!callbackDate || !isValidDate(callbackDate)) {
        date = new Date();
    }
    else {
        const { day, month, year } = callbackDate;
        date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
    }
    return timezones
        .map((tz) => {
        var _a;
        try {
            const dtf = new Intl.DateTimeFormat(userLocale, {
                timeZone: tz,
                hour: "2-digit",
                hour12: false,
                timeZoneName: "shortOffset"
            });
            const parts = dtf.formatToParts(date);
            const offset = ((_a = parts.find((p) => p.type === "timeZoneName")) === null || _a === void 0 ? void 0 : _a.value) || "";
            return `(${offset}) ${tz}`;
        }
        catch (_b) {
            return null;
        }
    })
        .filter((tz) => tz !== null);
};
const getDefaultTimeZones = () => {
    var _a, _b;
    const supported = (_b = (_a = Intl).supportedValuesOf) === null || _b === void 0 ? void 0 : _b.call(_a, "timeZone");
    if (Array.isArray(supported)) {
        _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info("Intl.supportedValuesOf('timeZone') supported");
        return supported;
    }
    _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info("Intl.supportedValuesOf('timeZone') not supported, falling back to default");
    return _constant__WEBPACK_IMPORTED_MODULE_1__.TIME_ZONE_LIST;
};
const getTimeRegionFromTimeZone = (timeZone) => {
    const timeZoneParts = timeZone.split(" ");
    return timeZoneParts.length > 1 ? timeZoneParts[1] : timeZone;
};


/***/ }),

/***/ "./src/components/ScheduleAndManageCallBack/constant.ts":
/*!**************************************************************!*\
  !*** ./src/components/ScheduleAndManageCallBack/constant.ts ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EMPTY_CALLBACK_FORM_DATA: () => (/* binding */ EMPTY_CALLBACK_FORM_DATA),
/* harmony export */   EN_US_LOCALE: () => (/* binding */ EN_US_LOCALE),
/* harmony export */   INTERACTION_CONTROL: () => (/* binding */ INTERACTION_CONTROL),
/* harmony export */   RETRY: () => (/* binding */ RETRY),
/* harmony export */   TASK_PANEL: () => (/* binding */ TASK_PANEL),
/* harmony export */   TASK_PANEL_EDIT: () => (/* binding */ TASK_PANEL_EDIT),
/* harmony export */   TIME_SLOTS: () => (/* binding */ TIME_SLOTS),
/* harmony export */   TIME_ZONE_DATA: () => (/* binding */ TIME_ZONE_DATA),
/* harmony export */   TIME_ZONE_LIST: () => (/* binding */ TIME_ZONE_LIST)
/* harmony export */ });
const TIME_SLOTS = [
    "00:00",
    "01:00",
    "02:00",
    "03:00",
    "04:00",
    "05:00",
    "06:00",
    "07:00",
    "08:00",
    "09:00",
    "10:00",
    "11:00",
    "12:00",
    "13:00",
    "14:00",
    "15:00",
    "16:00",
    "17:00",
    "18:00",
    "19:00",
    "20:00",
    "21:00",
    "22:00",
    "23:00"
];
//sample data
const TIME_ZONE_DATA = [
    "Baker Island Time, UTC -12",
    "Niue Time, UTC -11",
    "Hawaii-Aleutian Standard Time, UTC -10",
    "Alaska Standard Time, UTC -9",
    "Pacific Standard Time, UTC -8",
    "Mountain Standard Time, UTC -7",
    "Central Standard Time, UTC -6",
    "Eastern Standard Time, UTC -5",
    "Atlantic Standard Time, UTC -4",
    "Argentina Time, UTC -3",
    "South Georgia Time, UTC -2",
    "Cape Verde Time, UTC -1",
    "Coordinated Universal Time, UTC",
    "Central European Time, UTC +1",
    "Eastern European Time, UTC +2",
    "Moscow Standard Time, UTC +3",
    "Gulf Standard Time, UTC +4",
    "Pakistan Standard Time, UTC +5",
    "Bangladesh Standard Time, UTC +6",
    "Indochina Time, UTC +7",
    "China Standard Time, UTC +8",
    "Japan Standard Time, UTC +9",
    "Australian Eastern Standard Time, UTC +10",
    "Solomon Islands Time, UTC +11",
    "New Zealand Standard Time, UTC +12"
];
const INTERACTION_CONTROL = "INTERACTION_CONTROL";
const TASK_PANEL = "TASK_PANEL";
const TASK_PANEL_EDIT = "TASK_PANEL_EDIT";
const RETRY = "retry";
const EMPTY_CALLBACK_FORM_DATA = {
    customerName: "",
    phoneNumber: "",
    timeZone: "",
    date: "",
    callTimeFrom: "",
    callTimeTo: "",
    assignTo: "",
    queueName: "",
    callBackReason: ""
};
const EN_US_LOCALE = "en-US";
const TIME_ZONE_LIST = [
    "Africa/Abidjan",
    "Africa/Accra",
    "Africa/Addis_Ababa",
    "Africa/Algiers",
    "Africa/Asmara",
    "Africa/Bamako",
    "Africa/Bangui",
    "Africa/Banjul",
    "Africa/Bissau",
    "Africa/Blantyre",
    "Africa/Brazzaville",
    "Africa/Bujumbura",
    "Africa/Cairo",
    "Africa/Casablanca",
    "Africa/Ceuta",
    "Africa/Conakry",
    "Africa/Dakar",
    "Africa/Dar_es_Salaam",
    "Africa/Djibouti",
    "Africa/Douala",
    "Africa/El_Aaiun",
    "Africa/Freetown",
    "Africa/Gaborone",
    "Africa/Harare",
    "Africa/Johannesburg",
    "Africa/Juba",
    "Africa/Kampala",
    "Africa/Khartoum",
    "Africa/Kigali",
    "Africa/Kinshasa",
    "Africa/Lagos",
    "Africa/Libreville",
    "Africa/Lome",
    "Africa/Luanda",
    "Africa/Lubumbashi",
    "Africa/Lusaka",
    "Africa/Malabo",
    "Africa/Maputo",
    "Africa/Maseru",
    "Africa/Mbabane",
    "Africa/Mogadishu",
    "Africa/Monrovia",
    "Africa/Nairobi",
    "Africa/Ndjamena",
    "Africa/Niamey",
    "Africa/Nouakchott",
    "Africa/Ouagadougou",
    "Africa/Porto-Novo",
    "Africa/Sao_Tome",
    "Africa/Tripoli",
    "Africa/Tunis",
    "Africa/Windhoek",
    "America/Adak",
    "America/Anchorage",
    "America/Anguilla",
    "America/Antigua",
    "America/Araguaina",
    "America/Argentina/Buenos_Aires",
    "America/Argentina/Catamarca",
    "America/Argentina/Cordoba",
    "America/Argentina/Jujuy",
    "America/Argentina/La_Rioja",
    "America/Argentina/Mendoza",
    "America/Argentina/Rio_Gallegos",
    "America/Argentina/Salta",
    "America/Argentina/San_Juan",
    "America/Argentina/San_Luis",
    "America/Argentina/Tucuman",
    "America/Argentina/Ushuaia",
    "America/Aruba",
    "America/Asuncion",
    "America/Atikokan",
    "America/Bahia",
    "America/Bahia_Banderas",
    "America/Barbados",
    "America/Belem",
    "America/Belize",
    "America/Blanc-Sablon",
    "America/Boa_Vista",
    "America/Bogota",
    "America/Boise",
    "America/Cambridge_Bay",
    "America/Campo_Grande",
    "America/Cancun",
    "America/Caracas",
    "America/Cayenne",
    "America/Cayman",
    "America/Chicago",
    "America/Chihuahua",
    "America/Ciudad_Juarez",
    "America/Costa_Rica",
    "America/Creston",
    "America/Cuiaba",
    "America/Curacao",
    "America/Danmarkshavn",
    "America/Dawson",
    "America/Dawson_Creek",
    "America/Denver",
    "America/Detroit",
    "America/Dominica",
    "America/Edmonton",
    "America/Eirunepe",
    "America/El_Salvador",
    "America/Fort_Nelson",
    "America/Fortaleza",
    "America/Glace_Bay",
    "America/Goose_Bay",
    "America/Grand_Turk",
    "America/Grenada",
    "America/Guadeloupe",
    "America/Guatemala",
    "America/Guayaquil",
    "America/Guyana",
    "America/Halifax",
    "America/Havana",
    "America/Hermosillo",
    "America/Indiana/Indianapolis",
    "America/Indiana/Knox",
    "America/Indiana/Marengo",
    "America/Indiana/Petersburg",
    "America/Indiana/Tell_City",
    "America/Indiana/Vevay",
    "America/Indiana/Vincennes",
    "America/Indiana/Winamac",
    "America/Inuvik",
    "America/Iqaluit",
    "America/Jamaica",
    "America/Juneau",
    "America/Kentucky/Louisville",
    "America/Kentucky/Monticello",
    "America/La_Paz",
    "America/Lima",
    "America/Los_Angeles",
    "America/Lower_Princes",
    "America/Maceio",
    "America/Managua",
    "America/Manaus",
    "America/Marigot",
    "America/Martinique",
    "America/Matamoros",
    "America/Mazatlan",
    "America/Menominee",
    "America/Merida",
    "America/Metlakatla",
    "America/Mexico_City",
    "America/Miquelon",
    "America/Moncton",
    "America/Monterrey",
    "America/Montevideo",
    "America/Montserrat",
    "America/Nassau",
    "America/New_York",
    "America/Nipigon",
    "America/Nome",
    "America/Noronha",
    "America/North_Dakota/Beulah",
    "America/North_Dakota/Center",
    "America/North_Dakota/New_Salem",
    "America/Nuuk",
    "America/Ojinaga",
    "America/Panama",
    "America/Pangnirtung",
    "America/Paramaribo",
    "America/Phoenix",
    "America/Port-au-Prince",
    "America/Port_of_Spain",
    "America/Porto_Velho",
    "America/Puerto_Rico",
    "America/Punta_Arenas",
    "America/Rainy_River",
    "America/Rankin_Inlet",
    "America/Recife",
    "America/Regina",
    "America/Resolute",
    "America/Rio_Branco",
    "America/Santarem",
    "America/Santiago",
    "America/Santo_Domingo",
    "America/Sao_Paulo",
    "America/Scoresbysund",
    "America/Sitka",
    "America/St_Barthelemy",
    "America/St_Johns",
    "America/St_Kitts",
    "America/St_Lucia",
    "America/St_Thomas",
    "America/St_Vincent",
    "America/Swift_Current",
    "America/Tegucigalpa",
    "America/Thule",
    "America/Thunder_Bay",
    "America/Tijuana",
    "America/Toronto",
    "America/Tortola",
    "America/Vancouver",
    "America/Whitehorse",
    "America/Winnipeg",
    "America/Yakutat",
    "America/Yellowknife",
    "Antarctica/Casey",
    "Antarctica/Davis",
    "Antarctica/DumontDUrville",
    "Antarctica/Macquarie",
    "Antarctica/Mawson",
    "Antarctica/McMurdo",
    "Antarctica/Palmer",
    "Antarctica/Rothera",
    "Antarctica/Syowa",
    "Antarctica/Troll",
    "Antarctica/Vostok",
    "Arctic/Longyearbyen",
    "Asia/Aden",
    "Asia/Almaty",
    "Asia/Amman",
    "Asia/Anadyr",
    "Asia/Aqtau",
    "Asia/Aqtobe",
    "Asia/Ashgabat",
    "Asia/Atyrau",
    "Asia/Baghdad",
    "Asia/Bahrain",
    "Asia/Baku",
    "Asia/Bangkok",
    "Asia/Barnaul",
    "Asia/Beirut",
    "Asia/Bishkek",
    "Asia/Brunei",
    "Asia/Chita",
    "Asia/Choibalsan",
    "Asia/Colombo",
    "Asia/Damascus",
    "Asia/Dhaka",
    "Asia/Dili",
    "Asia/Dubai",
    "Asia/Dushanbe",
    "Asia/Famagusta",
    "Asia/Gaza",
    "Asia/Hebron",
    "Asia/Ho_Chi_Minh",
    "Asia/Hong_Kong",
    "Asia/Hovd",
    "Asia/Irkutsk",
    "Asia/Jakarta",
    "Asia/Jayapura",
    "Asia/Jerusalem",
    "Asia/Kabul",
    "Asia/Kamchatka",
    "Asia/Karachi",
    "Asia/Kathmandu",
    "Asia/Khandyga",
    "Asia/Kolkata",
    "Asia/Krasnoyarsk",
    "Asia/Kuala_Lumpur",
    "Asia/Kuching",
    "Asia/Kuwait",
    "Asia/Macau",
    "Asia/Magadan",
    "Asia/Makassar",
    "Asia/Manila",
    "Asia/Muscat",
    "Asia/Nicosia",
    "Asia/Novokuznetsk",
    "Asia/Novosibirsk",
    "Asia/Omsk",
    "Asia/Oral",
    "Asia/Phnom_Penh",
    "Asia/Pontianak",
    "Asia/Pyongyang",
    "Asia/Qatar",
    "Asia/Qostanay",
    "Asia/Qyzylorda",
    "Asia/Riyadh",
    "Asia/Sakhalin",
    "Asia/Samarkand",
    "Asia/Seoul",
    "Asia/Shanghai",
    "Asia/Singapore",
    "Asia/Srednekolymsk",
    "Asia/Taipei",
    "Asia/Tashkent",
    "Asia/Tbilisi",
    "Asia/Tehran",
    "Asia/Thimphu",
    "Asia/Tokyo",
    "Asia/Tomsk",
    "Asia/Ulaanbaatar",
    "Asia/Urumqi",
    "Asia/Ust-Nera",
    "Asia/Vientiane",
    "Asia/Vladivostok",
    "Asia/Yakutsk",
    "Asia/Yangon",
    "Asia/Yekaterinburg",
    "Asia/Yerevan",
    "Atlantic/Azores",
    "Atlantic/Bermuda",
    "Atlantic/Canary",
    "Atlantic/Cape_Verde",
    "Atlantic/Faroe",
    "Atlantic/Madeira",
    "Atlantic/Reykjavik",
    "Atlantic/South_Georgia",
    "Atlantic/St_Helena",
    "Atlantic/Stanley",
    "Australia/Adelaide",
    "Australia/Brisbane",
    "Australia/Broken_Hill",
    "Australia/Currie",
    "Australia/Darwin",
    "Australia/Eucla",
    "Australia/Hobart",
    "Australia/Lindeman",
    "Australia/Lord_Howe",
    "Australia/Melbourne",
    "Australia/Perth",
    "Australia/Sydney",
    "Europe/Amsterdam",
    "Europe/Andorra",
    "Europe/Astrakhan",
    "Europe/Athens",
    "Europe/Belgrade",
    "Europe/Berlin",
    "Europe/Bratislava",
    "Europe/Brussels",
    "Europe/Bucharest",
    "Europe/Budapest",
    "Europe/Busingen",
    "Europe/Chisinau",
    "Europe/Copenhagen",
    "Europe/Dublin",
    "Europe/Gibraltar",
    "Europe/Guernsey",
    "Europe/Helsinki",
    "Europe/Isle_of_Man",
    "Europe/Istanbul",
    "Europe/Jersey",
    "Europe/Kaliningrad",
    "Europe/Kiev",
    "Europe/Kirov",
    "Europe/Lisbon",
    "Europe/Ljubljana",
    "Europe/London",
    "Europe/Luxembourg",
    "Europe/Madrid",
    "Europe/Malta",
    "Europe/Mariehamn",
    "Europe/Minsk",
    "Europe/Monaco",
    "Europe/Moscow",
    "Europe/Oslo",
    "Europe/Paris",
    "Europe/Podgorica",
    "Europe/Prague",
    "Europe/Riga",
    "Europe/Rome",
    "Europe/Samara",
    "Europe/San_Marino",
    "Europe/Sarajevo",
    "Europe/Saratov",
    "Europe/Simferopol",
    "Europe/Skopje",
    "Europe/Sofia",
    "Europe/Stockholm",
    "Europe/Tallinn",
    "Europe/Tirane",
    "Europe/Ulyanovsk",
    "Europe/Uzhgorod",
    "Europe/Vaduz",
    "Europe/Vatican",
    "Europe/Vienna",
    "Europe/Vilnius",
    "Europe/Volgograd",
    "Europe/Warsaw",
    "Europe/Zagreb",
    "Europe/Zaporozhye",
    "Europe/Zurich",
    "Indian/Antananarivo",
    "Indian/Chagos",
    "Indian/Christmas",
    "Indian/Cocos",
    "Indian/Comoro",
    "Indian/Kerguelen",
    "Indian/Mahe",
    "Indian/Maldives",
    "Indian/Mauritius",
    "Indian/Mayotte",
    "Indian/Reunion",
    "Pacific/Apia",
    "Pacific/Auckland",
    "Pacific/Bougainville",
    "Pacific/Chatham",
    "Pacific/Chuuk",
    "Pacific/Easter",
    "Pacific/Efate",
    "Pacific/Enderbury",
    "Pacific/Fakaofo",
    "Pacific/Fiji",
    "Pacific/Funafuti",
    "Pacific/Galapagos",
    "Pacific/Gambier",
    "Pacific/Guadalcanal",
    "Pacific/Guam",
    "Pacific/Honolulu",
    "Pacific/Kanton",
    "Pacific/Kiritimati",
    "Pacific/Kosrae",
    "Pacific/Kwajalein",
    "Pacific/Majuro",
    "Pacific/Marquesas",
    "Pacific/Midway",
    "Pacific/Nauru",
    "Pacific/Niue",
    "Pacific/Norfolk",
    "Pacific/Noumea",
    "Pacific/Pago_Pago",
    "Pacific/Palau",
    "Pacific/Pitcairn",
    "Pacific/Pohnpei",
    "Pacific/Port_Moresby",
    "Pacific/Rarotonga",
    "Pacific/Saipan",
    "Pacific/Tahiti",
    "Pacific/Tarawa",
    "Pacific/Tongatapu",
    "Pacific/Wake",
    "Pacific/Wallis"
];


/***/ }),

/***/ "./src/components/ScreenPop/ScreenPop.scss":
/*!*************************************************!*\
  !*** ./src/components/ScreenPop/ScreenPop.scss ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host .screen-pop {
  width: 100%;
  height: 100vh;
  border: 0;
}

.screen-pop-tab {
  overflow: hidden;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL1NjcmVlblBvcC9TY3JlZW5Qb3Auc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDRTtFQUNFLFdBQUE7RUFDQSxhQUFBO0VBQ0EsU0FBQTtBQUFKOztBQUlBO0VBQ0UsZ0JBQUE7QUFERiIsInNvdXJjZXNDb250ZW50IjpbIjpob3N0IHtcbiAgLnNjcmVlbi1wb3Age1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIGhlaWdodDogMTAwdmg7XG4gICAgYm9yZGVyOiAwO1xuICB9XG59XG5cbi5zY3JlZW4tcG9wLXRhYiB7XG4gIG92ZXJmbG93OiBoaWRkZW47XG59XG4iXSwic291cmNlUm9vdCI6IiJ9 */`);
    

/***/ }),

/***/ "./src/components/ScreenPop/ScreenPop.ts":
/*!***********************************************!*\
  !*** ./src/components/ScreenPop/ScreenPop.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ScreenPop: () => (/* binding */ ScreenPop)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _IframeBase_IframeBase__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../IframeBase/IframeBase */ "./src/components/IframeBase/IframeBase.ts");
/* harmony import */ var _ScreenPop_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./ScreenPop.scss */ "./src/components/ScreenPop/ScreenPop.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};







const HTTPS_PROTOCOL = "https://";
const HTTP_PROTOCOL = "http://";
const SCREEN_POP_CONFIG = "screenPopConfig";
var ScreenPop;
(function (ScreenPop) {
    ScreenPop.TARGET_INSIDE_DESKTOP = "insideDesktop";
    ScreenPop.TARGET_SAME_BROWSER_TAB = "sameBrowserTab";
    const ALLOWED_PARAMS = "battery *;camera *;display-capture *; encrypted-media *;fullscreen *;geolocation *;gyroscope *;microphone *;speaker-selection *;web-share *;clipboard-write; clipboard-read;";
    ScreenPop.getAlreadyOpenedScreenPopConfig = () => {
        const configStr = sessionStorage.getItem(SCREEN_POP_CONFIG);
        if (configStr) {
            return JSON.parse(configStr);
        }
        return null;
    };
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
        constructor() {
            super(...arguments);
            this.screenPopUrl = null;
            this.selectedTab = 0;
        }
        static get styles() {
            return _ScreenPop_scss__WEBPACK_IMPORTED_MODULE_6__["default"];
        }
        connectedCallback() {
            const _super = Object.create(null, {
                connectedCallback: { get: () => super.connectedCallback }
            });
            return __awaiter(this, void 0, void 0, function* () {
                _super.connectedCallback.call(this);
                this.addEventListener("selected-changed", this.preserveSelectedTab);
                this.selectedTab = this.setSelectedTab();
            });
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.removeEventListener("selected-changed", this.preserveSelectedTab);
        }
        setSelectedTab() {
            if (this.screenPopUrl) {
                this.screenPopUrl.forEach((data, index) => {
                    if (data.isSelected) {
                        this.selectedTab = index;
                    }
                });
            }
            return this.selectedTab;
        }
        telemetryTracker(screenPopData) {
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.SCREEN_POP_INSIDE_DESKTOP_REFERRED, {
                [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.SCREEN_POP_INTERACTION]: screenPopData.interactionId,
                [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.MEDIA_TYPE]: screenPopData.mediaType
            });
        }
        preserveSelectedTab(e) {
            if (this.screenPopUrl) {
                const interactionId = e.detail.tabsOrder[e.detail.value];
                const screenPopData = JSON.parse(JSON.stringify(this.screenPopUrl));
                const modifiedData = screenPopData.map((data, index) => {
                    if (index === e.detail.value) {
                        data.isSelected = true;
                    }
                    else {
                        data.isSelected = false;
                    }
                    return data;
                });
                const existingScreenPopData = ScreenPop.getAlreadyOpenedScreenPopConfig() || [];
                let newData = existingScreenPopData.filter((data) => {
                    return data.interactionId !== interactionId;
                });
                newData = [...newData, ...modifiedData];
                sessionStorage.setItem(SCREEN_POP_CONFIG, JSON.stringify(newData));
                this.dispatchEvent(new CustomEvent("ax-update-screen-pop", {
                    bubbles: true,
                    composed: true,
                    detail: newData
                }));
                const selectedTabData = newData.filter((data) => data.isSelected);
                this.telemetryTracker(selectedTabData[0]);
            }
        }
        render() {
            return this.screenPopUrl
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
            <md-tabs selected=${this.setSelectedTab()}>
              ${this.screenPopUrl.map((data) => {
                    return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                  <md-tab
                    name=${data.interactionId}
                    slot="tab"
                    class="widget-pane-tab"
                    aria-label=${data.screenPopDesktopLabel}
                    role="tab"
                  >
                    <span class="tab-header-content">
                      <span>${data.screenPopDesktopLabel}</span>
                    </span>
                  </md-tab>

                  <md-tab-panel class="screen-pop-tab" slot="panel">
                    <agentx-wc-iframe
                      allowedParams=${ALLOWED_PARAMS}
                      class="screen-pop"
                      src="${data.screenPopUrl}"
                    ></agentx-wc-iframe>
                  </md-tab-panel>
                `;
                })}
            </md-tabs>
          `
                : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Array })
    ], Element.prototype, "screenPopUrl", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Number })
    ], Element.prototype, "selectedTab", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-screen-pop")
    ], Element);
    ScreenPop.Element = Element;
    /**;
     * Open screen pop (i.e. browser window) after constructing final url based on Screen POP event
     * @param screenPopDetail
     */
    ScreenPop.constructScreenPopUrl = (screenPopDetail, mediaType, saveToSessionStorage = false) => {
        const settings = screenPopDetail.data;
        let screenPopUrl = "";
        if (settings) {
            const baseUrl = settings.screenPopUrl;
            const url = new URL(baseUrl.indexOf(HTTPS_PROTOCOL) > -1 || baseUrl.indexOf(HTTP_PROTOCOL) > -1
                ? baseUrl
                : HTTPS_PROTOCOL.concat(baseUrl));
            if (settings.queryParameters) {
                Object.keys(settings.queryParameters).forEach((paramKey) => {
                    url.searchParams.set(paramKey.trim(), settings.queryParameters[paramKey].trim());
                });
            }
            screenPopUrl = url.href;
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[ScreenPop] Final screen pop url", url);
            if (saveToSessionStorage) {
                const existingScreenPopData = ScreenPop.getAlreadyOpenedScreenPopConfig() || [];
                const screenPopConfig = {
                    interactionId: screenPopDetail.data.interactionId,
                    screenPopDesktopLabel: screenPopDetail.data.screenPopDesktopLabel || (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:notifications.screenPopDesktopDefaultLabel"),
                    screenPopUrl,
                    target: settings.target,
                    mediaType,
                    screenPopName: settings.screenPopName
                };
                // get duplicate screenPop event
                const filteredScreenPop = existingScreenPopData.filter((obj) => {
                    return (obj.screenPopName === screenPopConfig.screenPopName && obj.interactionId === screenPopConfig.interactionId);
                });
                // push screenPop if no duplicates found.
                if (filteredScreenPop.length === 0) {
                    existingScreenPopData.push(screenPopConfig);
                    sessionStorage.setItem(SCREEN_POP_CONFIG, JSON.stringify(existingScreenPopData));
                }
            }
        }
        return screenPopUrl;
    };
    ScreenPop.removeScreenPopFromSession = () => {
        return sessionStorage.removeItem(SCREEN_POP_CONFIG);
    };
    ScreenPop.screenPopNavConfig = {
        navRouteName: "screenpop",
        navRoutePath: "/screenpop",
        navIcon: {
            label: "Screen-pop",
            icon: "pop-out",
            iconType: "momentum",
            navigateTo: "screenpop",
            align: "bottom"
        },
        area: "main-routed"
    };
})(ScreenPop || (ScreenPop = {}));


/***/ }),

/***/ "./src/components/ShortcutKey/ShortcutKeyModal.scss":
/*!**********************************************************!*\
  !*** ./src/components/ShortcutKey/ShortcutKeyModal.scss ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

* {
  /* BASE LEVEL < 100 */
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-index-tpw-header: 1;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-index-task-collapse-area: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-navigation-bar: 12;
  --z-index-task-list: 12;
  --z-index-wrap-up: 13;
  --z-index-sticky-header: 14;
  --z-index-shortcutkey-modal: 15;
  /* MID LEVEL FLOATING > 100 < 1000 */
  --z-index-notification: 150;
  /* SUPER LEVEL > 1000 */
  --z-index-modal: 1040;
  --z-index-popover: 1041;
  --z-index-callback-modal: 1042;
  /* This below order needs to be unchanged. Highest priority is for connection loss overlay,
         followed by error modal since error can occur during app load such as teams failure/register failure. */
  --z-index-app-full-overlay: 1050;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1200;
}

:host {
  --search-width: calc(var(--space-token-cardinal) * 52);
  --border-outline: 1px solid var(--md-quaternary-bg-color);
  --shortcut-header-height: calc(calc(var(--space-token-cardinal) * 12) + var(--space-token-even));
  --shortcut-header-conflict-height: calc(calc(var(--space-token-cardinal) * 25));
  --nav-header-height: 64px;
  color: var(--md-primary-text-color);
  font-family: var(--font-family);
}

.column-group,
.column-shortcut-key,
.column-action {
  overflow: hidden !important;
  display: flex;
  padding: calc(var(--space-token-cardinal) * 2) 0;
  padding-left: calc(var(--space-token-cardinal) * 4);
  padding-right: var(--space-token-cardinal);
  border-bottom: var(--border-outline);
  overflow-wrap: break-word;
  cursor: default !important;
}

.column-group,
.column-shortcut-key {
  width: 30%;
  border-left: var(--border-outline);
  border-right: var(--border-outline);
}

.column-action {
  width: 40%;
}

.input-search-field {
  max-width: var(--search-width);
}

.column-titles {
  display: flex;
  background-color: var(--md-secondary-bg-color);
  font-size: var(--font-size-medium);
  font-weight: bold;
  border-top: var(--border-outline);
  width: calc(100% - var(--space-token-even) * 6);
}

@supports (-moz-osx-font-smoothing: auto) {
  .column-titles {
    width: 100%;
  }
  .shortcut-key-list-item {
    margin-right: 0 !important;
  }
}
.group-sort-btn,
.action-sort-btn,
.shortcutkey-sort-btn {
  margin-left: calc(var(--space-token-even) * 4);
  cursor: pointer;
}

.shortcut-key-list-item {
  font-size: var(--font-size-small);
  border: 0 !important;
  margin-right: calc(var(--space-token-even) * 2);
}
.shortcut-key-list-item::part(list-item) {
  padding: 0;
  display: flex;
  align-items: stretch;
}

.shortcut-key-list-item > .column-group,
.shortcut-key-list-item > .column-shortcut-key,
.shortcut-key-list-item > .column-action {
  padding-top: calc(var(--space-token-even) * 6);
  padding-bottom: calc(var(--space-token-even) * 6);
}

.conflict-warning-icon {
  position: absolute;
  left: 70%;
}

.conflict-warning-message {
  background-color: var(--badge-red-bg-color);
  text-align: center;
  color: var(--badge-red-text-color);
  padding: calc(var(--space-token-cardinal) * 2) 0;
  margin: calc(var(--space-token-cardinal) * 2) 0;
}

.search-illustration {
  display: block;
  height: 50vh;
  padding-left: var(--space-token-even);
}

.search-message {
  padding: calc(var(--space-token-cardinal) * 2);
  color: var(--md-primary-text-color);
}

.search-result {
  width: 100% !important;
}

.icon-warning {
  color: var(--button-red-bg-color);
}

uuip-wc-empty-state::part(img) {
  width: 100px;
  background: transparent;
}

uuip-wc-empty-state::part(container) {
  background: transparent;
}

agentx-wc-empty-state-wrapper::part(img) {
  width: 100px;
  background: transparent;
}

agentx-wc-empty-state-wrapper::part(container) {
  background: transparent;
}

.shortcut-key-list-box {
  padding-bottom: var(--space-token-even);
}

.shortcut-list {
  overflow-y: scroll;
  height: calc(100% - var(--shortcut-header-height));
  scrollbar-width: thin;
  padding-left: var(--space-token-even);
  margin-bottom: 12px;
}
.shortcut-list::-webkit-scrollbar {
  width: calc(var(--space-token-even) * 4);
}
.shortcut-list::-webkit-scrollbar-thumb {
  border-radius: var(--border-radius-large);
  background-color: var(--md-presence-away-bg-color);
}

.shortcut-list-conflict {
  height: calc(100% - var(--shortcut-header-conflict-height));
  margin-bottom: 11px;
}

.shortcut-header {
  position: sticky;
  top: 0;
  background-color: var(--md-tertiary-white-bg-color);
  padding-left: var(--space-token-even);
}

.ellipsis-text {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#shortcut-key-modal::part(floating) {
  overflow: hidden;
  height: 80%;
  width: 50%;
  left: 10%;
  top: 10%;
  z-index: calc(var(--z-index-task-collapse-area) + 1);
}

@media (max-width: 880px) {
  #shortcut-key-modal::part(floating) {
    overflow: hidden;
    height: 80%;
    width: 50%;
    left: 0;
    top: var(--nav-header-height);
  }
}
@media (max-width: 736px) {
  #shortcut-key-modal::part(floating) {
    overflow: hidden;
    height: calc(100% - var(--nav-header-height));
    width: 100%;
    left: 0;
    top: var(--nav-header-height);
  }
  [full-screen]#shortcut-key-modal::part(floating) {
    z-index: var(--z-index-shortcutkey-modal);
  }
}
md-floating-modal::part(floating) {
  min-width: 480px;
  min-height: 320px;
  user-select: text;
}

.sr-only {
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/ShortcutKey/ShortcutKeyModal.ts":
/*!********************************************************!*\
  !*** ./src/components/ShortcutKey/ShortcutKeyModal.ts ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ShortcutKey: () => (/* binding */ ShortcutKey)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @uuip/unified-ui-platform-common-components */ "@uuip/unified-ui-platform-common-components");
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Common_EmptyStateWrapper_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Common/EmptyStateWrapper/EmptyStateWrapper */ "./src/components/Common/EmptyStateWrapper/EmptyStateWrapper.ts");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _ShortcutKeyModal_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./ShortcutKeyModal.scss */ "./src/components/ShortcutKey/ShortcutKeyModal.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};











var ShortcutKey;
(function (ShortcutKey) {
    let ShortcutKeyModal = class ShortcutKeyModal extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_8__.MobxLitElement) {
        constructor() {
            super(...arguments);
            this.isModalOpen = false;
            this.isShortcutKeyConflict = false;
            this.altOrOptionKey = "";
            this.shortcutKeyData = [];
            this.shortcutKeys = [];
            this.isSearchEmpty = false;
            this.ShortkeyTable = {
                config: {
                    isStickyHeader: true,
                    cellTemplates: {
                        _warn_: { templateName: "tmp2" }
                    },
                    default: {
                        sort: {
                            colId: "c1",
                            order: "ascending"
                        }
                    },
                    rows: {
                        isDraggable: false
                    },
                    cols: {
                        isResizable: true,
                        define: [
                            { id: "c1", title: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.group"), sorter: "byString", width: "30%" },
                            { id: "c2", title: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.action"), sorter: "byString", width: "40%" },
                            { id: "c3", title: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.shortcutKey"), sorter: "byString", width: "30%" }
                        ]
                    },
                    head: {
                        tableDescription: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.tableDescription")
                    }
                },
                data: {
                    list2d: [["", "", ""]]
                }
            };
            this.SEARCH = "";
            this.ACTION = "";
            this.GROUP = "";
            this.SHORTCUTKEY = "";
            this.resultsLabel = "{{count}} search results available";
            this.inputKeydownHandler = (event) => {
                const { srcEvent } = event.detail;
                if (this.shortcutList) {
                    if (srcEvent.code === "Tab") {
                        this.shortcutList.rovingPreventFocus = false;
                    }
                    else {
                        this.shortcutList.rovingPreventFocus = true;
                    }
                }
            };
        }
        updateConstant() {
            this.SEARCH = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.search");
            this.GROUP = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.group");
            this.ACTION = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.action");
            this.SHORTCUTKEY = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.shortcutKey");
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            this.updateConstant();
            changedProperties.forEach((oldValue, name) => {
                if (name === "isModalOpen") {
                    const regis = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.getRegisteredKeys();
                    this.combineShortcutKey(regis);
                    this.requestUpdate();
                }
            });
            if (this.shortcutList) {
                this.shortcutList.rovingPreventFocus = true;
            }
            if (this.searchInput && this.searchInput.shadowRoot.querySelector("input")) {
                this.searchInput.shadowRoot.querySelector("input").focus();
            }
        }
        combineShortcutKey(regis) {
            this.shortcutKeyData = [];
            regis.forEach((value) => {
                const keyData = [];
                value.action = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(value.action);
                value.group = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(value.group);
                keyData.push(value.group, value.action, `${this.formatShortcutKey(value.modifierKeys)} + ${value.key.toUpperCase()}${value.isConflict ? " _warn_" : ""}`);
                this.shortcutKeyData.push(keyData);
                this.shortcutKeys = this.shortcutKeyData;
            });
            this.ShortkeyTable = Object.assign(Object.assign({}, this.ShortkeyTable), { data: {
                    list2d: this.shortcutKeyData
                } });
        }
        handleSearchInput(searchQuery) {
            const lowercasedValue = searchQuery.toLowerCase().trim();
            const filteredData = this.shortcutKeys.filter((item) => {
                return item.join().toLowerCase().indexOf(lowercasedValue) > -1 ? item : false;
            });
            this.ShortkeyTable = Object.assign(Object.assign({}, this.ShortkeyTable), { data: {
                    list2d: filteredData
                } });
            this.isSearchEmpty = !filteredData.length;
            if (this.isSearchEmpty) {
                this.liveRegion.textContent = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.noSearchResult");
            }
            else {
                const countLabel = this.ShortkeyTable.data.list2d.length;
                this.liveRegion.textContent = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys:searchResultsCount", this.resultsLabel, {
                    count: countLabel
                });
            }
            this.requestUpdate();
        }
        handleCloseModal() {
            const event = new CustomEvent("ax-close-shortcut-key-modal", {
                detail: false,
                bubbles: true,
                composed: true
            });
            this.dispatchEvent(event);
        }
        static get styles() {
            return _ShortcutKeyModal_scss__WEBPACK_IMPORTED_MODULE_9__["default"];
        }
        formatShortcutKey(keyCombination) {
            keyCombination = keyCombination.toUpperCase();
            this.altOrOptionKey = this.detectOS();
            keyCombination = keyCombination.replace(/CTRLKEY/gi, "Ctrl");
            keyCombination = keyCombination.replace(/SHIFTKEY/gi, "Shift");
            keyCombination = keyCombination.replace(/ALTKEY/gi, this.altOrOptionKey);
            keyCombination = keyCombination.replace(/_/gi, " + ");
            return keyCombination;
        }
        detectOS() {
            if (navigator.userAgent.indexOf("Mac") !== -1) {
                return "Option";
            }
            return "Alt";
        }
        renderSearchImage() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
        <div class="search-illustration">
          <agentx-wc-empty-state-wrapper illustration-type="empty-result">
            <span class="search-message">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.noSearchResult")}</span>
          </agentx-wc-empty-state-wrapper>
        </div>
      `;
        }
        renderConflict() {
            if (this.isShortcutKeyConflict) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) ` <div class="conflict-warning-message">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.conflict")}</div> `;
            }
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) ``;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
        <md-floating-modal
          ?show=${this.isModalOpen}
          class="shortcut-key-modal"
          id="shortcut-key-modal"
          heading=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.keyboardShortcuts")}
          label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.keyboardShortcuts")}
          maximize-aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.maximizeScreenLabel")}
          minimize-aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.minimizeModal")}
          resize-aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.restoreScreenLabel")}
          close-aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.closeModal")}
          @floating-modal-close=${() => this.handleCloseModal()}
        >
          <div class="shortcut-header">
            ${this.renderConflict()}
            <div class="input-search-field">
              <md-input
                htmlid="inputSearchClearPill"
                class="input-field"
                placeholder=${this.SEARCH}
                ariaLabel=${this.SEARCH}
                searchable=""
                shape=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_7__.ifDefined)(!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isMomentumV2Enabled ? "pill" : undefined)}
                ?newMomentum=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isMomentumV2Enabled}
                clear=""
                value=""
                autoFocus
                @input-keydown=${(event) => this.inputKeydownHandler(event)}
                @input-change=${(e) => this.handleSearchInput(e.detail.value)}
              ></md-input>
            </div>
          </div>
          ${!this.isSearchEmpty
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
                <div class="shortcut-list ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_5__.classMap)({ "shortcut-list-conflict": this.isShortcutKeyConflict })}">
                  <md-table-advanced
                    .config=${this.ShortkeyTable.config}
                    .data=${this.ShortkeyTable.data}
                    isRowFocusable="false"
                  >
                    <template id="tmp1">
                      <md-icon class="warn-icon" name="warning_20" color="blue"></md-icon>
                    </template>

                    <template id="tmp2">
                      <md-icon class="warn-icon" name="warning_20" color="yellow"></md-icon>
                    </template>

                    <template id="tmp3">
                      <md-icon class="warn-icon" name="error_20" color="red"></md-icon>
                    </template>
                  </md-table-advanced>
                </div>
              `
                : this.renderSearchImage()}
          <div id="live-region" class="sr-only" aria-live="polite"></div>
        </md-floating-modal>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
    ], ShortcutKeyModal.prototype, "isModalOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
    ], ShortcutKeyModal.prototype, "isShortcutKeyConflict", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
    ], ShortcutKeyModal.prototype, "altOrOptionKey", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], ShortcutKeyModal.prototype, "shortcutKeyData", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], ShortcutKeyModal.prototype, "shortcutKeys", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], ShortcutKeyModal.prototype, "isSearchEmpty", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], ShortcutKeyModal.prototype, "ShortkeyTable", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.query)(".shortcut-key-list-box")
    ], ShortcutKeyModal.prototype, "shortcutList", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.query)(".input-field")
    ], ShortcutKeyModal.prototype, "searchInput", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.query)("#live-region")
    ], ShortcutKeyModal.prototype, "liveRegion", void 0);
    ShortcutKeyModal = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.customElement)("agentx-wc-shortcut-keys-modal")
    ], ShortcutKeyModal);
    ShortcutKey.ShortcutKeyModal = ShortcutKeyModal;
})(ShortcutKey || (ShortcutKey = {}));


/***/ }),

/***/ "./src/components/StateSelector/StatePreviewItem.scss":
/*!************************************************************!*\
  !*** ./src/components/StateSelector/StatePreviewItem.scss ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

* {
  /* BASE LEVEL < 100 */
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-index-tpw-header: 1;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-index-task-collapse-area: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-navigation-bar: 12;
  --z-index-task-list: 12;
  --z-index-wrap-up: 13;
  --z-index-sticky-header: 14;
  --z-index-shortcutkey-modal: 15;
  /* MID LEVEL FLOATING > 100 < 1000 */
  --z-index-notification: 150;
  /* SUPER LEVEL > 1000 */
  --z-index-modal: 1040;
  --z-index-popover: 1041;
  --z-index-callback-modal: 1042;
  /* This below order needs to be unchanged. Highest priority is for connection loss overlay,
         followed by error modal since error can occur during app load such as teams failure/register failure. */
  --z-index-app-full-overlay: 1050;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1200;
}

.flex-center, .sub-timer-label, .state-names, .state-avater-container, .state-list-item {
  display: flex;
  align-items: center;
}

.ellipsis-text {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 220px;
}

.font-styling, .state-subname, .idle-timer, .main-timer, .state-names {
  font-style: normal;
  font-weight: 400;
}

.state-list-item {
  gap: 12px;
}

.state-avater-container {
  height: 40px;
}

.state-timer {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.state-details {
  width: 100%;
  justify-content: center;
}

.state-names {
  height: 20px;
  font-size: 14px;
}

.main-timer {
  display: flex;
  align-items: right;
  font-size: 14px;
}

.sub-timer {
  display: flex;
  align-items: right;
}

.sub-timer-label {
  width: 100%;
  padding-left: 44px;
}

.idle-timer {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding-top: 5px;
  font-size: 12px;
  line-height: 16px;
}

.state-subname {
  height: 20px;
  font-size: 12px;
}

.item-separator {
  padding-right: 2px;
}

.state-capacity {
  padding: 0 2px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/StateSelector/StatePreviewItem.ts":
/*!**********************************************************!*\
  !*** ./src/components/StateSelector/StatePreviewItem.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ELEMENT: () => (/* binding */ ELEMENT)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../constants */ "./src/constants.ts");
/* harmony import */ var _TaskList_comp_TaskTimer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../TaskList/comp/TaskTimer */ "./src/components/TaskList/comp/TaskTimer.ts");
/* harmony import */ var _StatePreviewItem_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./StatePreviewItem.scss */ "./src/components/StateSelector/StatePreviewItem.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







let ELEMENT = class ELEMENT extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
    constructor() {
        super(...arguments);
        this.previewItemData = {
            channelName: "",
            channelState: "",
            capacity: "",
            channelStateChangeTimestamp: 0,
            status: "",
            type: "",
            channelIdleCodeName: "",
            channelPendingIdle: false,
            ariaLabel: ""
        };
    }
    static get styles() {
        return _StatePreviewItem_scss__WEBPACK_IMPORTED_MODULE_6__["default"];
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
      <div class="state-list-item">
        <div class="state-avater-container">
          <md-avatar
            class="state-avatar"
            title="${this.previewItemData.channelName}"
            type="${this.previewItemData.type}"
            size="32"
            avatar-style="default"
            presence-type="${this.previewItemData.status}"
            state="rest"
            newMomentum
          ></md-avatar>
        </div>
        <div class="state-details">
          <div class="state-names ellipsis-text">
            <strong>${this.previewItemData.channelName}</strong>
            <span class="item-separator">:</span>
            ${this.previewItemData.channelState === _constants__WEBPACK_IMPORTED_MODULE_4__.IDLE
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<span>${this.previewItemData.channelIdleCodeName} </span>`
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<span>${this.previewItemData.channelState} </span>`}
            ${this.previewItemData.channelName === _constants__WEBPACK_IMPORTED_MODULE_4__.VOICE_LABEL ||
            this.previewItemData.channelState === _constants__WEBPACK_IMPORTED_MODULE_4__.IDLE ||
            this.previewItemData.channelState === _constants__WEBPACK_IMPORTED_MODULE_4__.AVAILABLE
            ? lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<span class="state-capacity">${this.previewItemData.capacity}</span>`}
          </div>
          ${this.previewItemData.channelPendingIdle
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<div class="state-subname">
                  <span class="ellipsis-text"
                    >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:granularStateControl.pendingLabel")} ${this.previewItemData.channelIdleCodeName}</span
                  >
                </div>`
            : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
        </div>
        <div class="state-timer">
          ${this.previewItemData.channelIdleCodeChangeTimestamp
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<div class="main-timer">
                  <agentx-wc-task-list-timer
                    startTimestamp=${this.previewItemData.channelIdleCodeChangeTimestamp}
                  ></agentx-wc-task-list-timer>
                </div>`
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<div class="main-timer">
                  <agentx-wc-task-list-timer
                    startTimestamp=${this.previewItemData.channelStateChangeTimestamp}
                  ></agentx-wc-task-list-timer>
                </div>`}
        </div>
      </div>
        ${this.previewItemData.channelIdleCodeChangeTimestamp
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<div class="idle-timer">
                <div class="sub-timer-label">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:granularStateControl.idleDurationLabel")}</div>
                <div class="sub-timer">
                  <agentx-wc-task-list-timer
                    startTimestamp=${this.previewItemData.channelStateChangeTimestamp}
                  ></agentx-wc-task-list-timer>
                </div>
              </div>`
            : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
], ELEMENT.prototype, "previewItemData", void 0);
ELEMENT = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-state-preview-item")
], ELEMENT);



/***/ }),

/***/ "./src/components/StateSelector/StatePreviewOverlay.scss":
/*!***************************************************************!*\
  !*** ./src/components/StateSelector/StatePreviewOverlay.scss ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

* {
  /* BASE LEVEL < 100 */
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-index-tpw-header: 1;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-index-task-collapse-area: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-navigation-bar: 12;
  --z-index-task-list: 12;
  --z-index-wrap-up: 13;
  --z-index-sticky-header: 14;
  --z-index-shortcutkey-modal: 15;
  /* MID LEVEL FLOATING > 100 < 1000 */
  --z-index-notification: 150;
  /* SUPER LEVEL > 1000 */
  --z-index-modal: 1040;
  --z-index-popover: 1041;
  --z-index-callback-modal: 1042;
  /* This below order needs to be unchanged. Highest priority is for connection loss overlay,
         followed by error modal since error can occur during app load such as teams failure/register failure. */
  --z-index-app-full-overlay: 1050;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1200;
}

.advance-list {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.state-list-template {
  position: relative;
  min-height: 1.25rem;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  width: calc(100% - 2px);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/StateSelector/StatePreviewOverlay.ts":
/*!*************************************************************!*\
  !*** ./src/components/StateSelector/StatePreviewOverlay.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   StatePreviewOverlay: () => (/* binding */ StatePreviewOverlay)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @uuip/unified-ui-platform-common-components */ "@uuip/unified-ui-platform-common-components");
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../constants */ "./src/constants.ts");
/* harmony import */ var _Common_EmptyStateWrapper_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Common/EmptyStateWrapper/EmptyStateWrapper */ "./src/components/Common/EmptyStateWrapper/EmptyStateWrapper.ts");
/* harmony import */ var _StatePreviewItem__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./StatePreviewItem */ "./src/components/StateSelector/StatePreviewItem.ts");
/* harmony import */ var _StatePreviewOverlay_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./StatePreviewOverlay.scss */ "./src/components/StateSelector/StatePreviewOverlay.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









var StatePreviewOverlay;
(function (StatePreviewOverlay) {
    let ELEMENT = class ELEMENT extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_1__.MobxLitElement) {
        constructor() {
            super(...arguments);
            this.menuOptions = _constants__WEBPACK_IMPORTED_MODULE_5__.STATE_PREVIEW_OPTIONS;
            this.items = [];
            this.renderStateCardTemplate = (data) => {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
        <div>
          <agentx-wc-state-preview-item .previewItemData="${data}"></agentx-wc-state-preview-item>
        </div>
      `;
            };
            this.getFormattedStateList = (item) => {
                return {
                    channelName: item.channelName,
                    channelState: item.channelState,
                    capacity: `(${item.channelAvailableCount}/${item.channelTotalCount})`,
                    channelStateChangeTimestamp: item.channelStateChangeTimestamp,
                    channelIdleCodeChangeTimestamp: item.channelIdleCodeChangeTimestamp,
                    status: `${item.channelStatus}`,
                    type: `${this.getAvatarType(item.channelName)}`,
                    channelIdleCodeName: `${item.channelIdleCodeName}`,
                    channelPendingIdle: item.channelPendingIdle,
                    ariaLabel: item.channelName,
                    template: (data) => {
                        return this.getStateListTemplate(data);
                    }
                };
            };
        }
        static get styles() {
            return _StatePreviewOverlay_scss__WEBPACK_IMPORTED_MODULE_8__["default"];
        }
        getAvatarType(channelType) {
            const avatarMap = _constants__WEBPACK_IMPORTED_MODULE_5__.CHANNEL_AVATAR_MAP;
            return avatarMap[channelType];
        }
        getStatus(state) {
            const statusMap = _constants__WEBPACK_IMPORTED_MODULE_5__.CHANNEL_STATUS_MAP;
            return statusMap[state];
        }
        getChannelLabel(channelName) {
            const channelNameMap = _constants__WEBPACK_IMPORTED_MODULE_5__.CHANNEL_NAME_MAP;
            return channelNameMap[channelName];
        }
        getStateListTemplate(data) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) ` <div class="state-list-template" style="width:100%;">${this.renderStateCardTemplate(data)}</div> `;
        }
        get formattedData() {
            this.items = Object.keys(this.menuOptions).map((channelKey, index) => {
                var _a, _b;
                const channel = this.menuOptions[channelKey];
                return {
                    id: index + 1,
                    channelName: this.getChannelLabel(channelKey),
                    channelStatus: this.getStatus(channel.agentState),
                    channelState: channel.agentState,
                    channelIdleCodeName: (_a = channel.idleCodeName) !== null && _a !== void 0 ? _a : "",
                    channelAvailableCount: channel.availableChannelCount,
                    channelTotalCount: channel.totalChannelCount,
                    channelStateChangeTimestamp: channel.stateChangeTimestamp,
                    channelIdleCodeChangeTimestamp: (_b = channel.lastIdleCodeChangeTimestamp) !== null && _b !== void 0 ? _b : null,
                    channelPendingIdle: channel.pendingIdle
                };
            });
            return this.items.map((item) => this.getFormattedStateList(item));
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
        <md-advance-list
          class="advance-list"
          .items=${this.formattedData}
          ariaRoleList="listbox"
          ariaLabelList="state selector"
          .isNonSelectable=${true}
        >
        </md-advance-list>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Object })
    ], ELEMENT.prototype, "menuOptions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], ELEMENT.prototype, "items", void 0);
    ELEMENT = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.customElement)("agentx-wc-state-preview-overlay")
    ], ELEMENT);
    StatePreviewOverlay.ELEMENT = ELEMENT;
})(StatePreviewOverlay || (StatePreviewOverlay = {}));


/***/ }),

/***/ "./src/components/StationLogin/AppLoadingScreen.scss":
/*!***********************************************************!*\
  !*** ./src/components/StationLogin/AppLoadingScreen.scss ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`* {
  /* BASE LEVEL < 100 */
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-index-tpw-header: 1;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-index-task-collapse-area: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-navigation-bar: 12;
  --z-index-task-list: 12;
  --z-index-wrap-up: 13;
  --z-index-sticky-header: 14;
  --z-index-shortcutkey-modal: 15;
  /* MID LEVEL FLOATING > 100 < 1000 */
  --z-index-notification: 150;
  /* SUPER LEVEL > 1000 */
  --z-index-modal: 1040;
  --z-index-popover: 1041;
  --z-index-callback-modal: 1042;
  /* This below order needs to be unchanged. Highest priority is for connection loss overlay,
         followed by error modal since error can occur during app load such as teams failure/register failure. */
  --z-index-app-full-overlay: 1050;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1200;
}

:host {
  background-color: white;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-index-app-full-overlay, 1050);
}

.loading-logo {
  animation: fadeIn 250ms linear forwards;
  margin-bottom: 20vh;
}

.md-loading {
  position: absolute;
  bottom: 20vh;
  margin-left: -1em;
  left: 50vw;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/StationLogin/AppLoadingScreen.ts":
/*!*********************************************************!*\
  !*** ./src/components/StationLogin/AppLoadingScreen.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AgentXLoadingScreen: () => (/* binding */ AgentXLoadingScreen)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _assets_styles_common_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../assets/styles/common.scss */ "./src/assets/styles/common.scss");
/* harmony import */ var _AppLoadingScreen_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./AppLoadingScreen.scss */ "./src/components/StationLogin/AppLoadingScreen.scss");
/* harmony import */ var _src_logo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./src/logo */ "./src/components/StationLogin/src/logo.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let AgentXLoadingScreen = class AgentXLoadingScreen extends lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement {
    static get styles() {
        return [_AppLoadingScreen_scss__WEBPACK_IMPORTED_MODULE_2__["default"], _assets_styles_common_scss__WEBPACK_IMPORTED_MODULE_1__["default"]];
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
      <div class="loading-screen">
        <span class="loading-logo" aria-hidden="true">${(0,_src_logo__WEBPACK_IMPORTED_MODULE_3__["default"])(150)}</span>
        <md-loading class="md-loading" aria-hidden="true"></md-loading>
        <span class="sr-only" role="status">Loading</span>
      </div>
    `;
    }
};
AgentXLoadingScreen = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("agentx-wc-loading-screen")
], AgentXLoadingScreen);



/***/ }),

/***/ "./src/components/StationLogin/src/logo.ts":
/*!*************************************************!*\
  !*** ./src/components/StationLogin/src/logo.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_0__);

/* eslint-disable max-len */
// sonar.issue.ignore.block
const appLogo = (size) => (0,lit_html__WEBPACK_IMPORTED_MODULE_0__.html) `
  <svg
    width=${size}
    height=${size}
    viewBox="0 0 ${size} ${size}"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <rect width=${size} height=${size} fill="url(#pattern0)" />
    <defs>
      <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use xlink:href="#image0" transform="translate(-0.000480307) scale(0.000960615)" />
      </pattern>
      <image
        id="image0"
        width="1042"
        height="1041"
        xlink:href="data:image/png;base64,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"
      />
    </defs>
  </svg>
`;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (appLogo);


/***/ }),

/***/ "./src/components/SupervisorFilters/ChannelFilter/ChannelFilter.ts":
/*!*************************************************************************!*\
  !*** ./src/components/SupervisorFilters/ChannelFilter/ChannelFilter.ts ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ChannelFilter: () => (/* binding */ ChannelFilter)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lit-html/directives/style-map */ "lit-html/directives/style-map");
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./../../../utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./../index.scss */ "./src/components/SupervisorFilters/index.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};










let ChannelFilter = class ChannelFilter extends _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_2__.MobxLitElement {
    constructor() {
        super(...arguments);
        this.languageResources = "/i18n/{{lng}}/{{ns}}.json";
        this.selectedChannelList = [];
        this.selectedChannelListKey = "selected-channel-list";
        this.channelFilterSelectedEventKey = "channel-filter-selected";
        this.value = [];
        this.items = [];
        this.infiniteScrollingEnabled = false;
        this.lastSelectedIdByOrder = "";
        this.selectAllItems = false;
        this.arrowIcon = "arrow-down-bold";
        this.isMenuOverlayOpen = false;
        this.disableReset = false;
        this.channelList = _constants__WEBPACK_IMPORTED_MODULE_0__.channelList;
        this.changeHandler = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_8__.debounce)((e) => {
            let selectedItems = e.detail.selected;
            this.disableReset = selectedItems.length === 0;
            if (this.infiniteScrollingEnabled) {
                selectedItems = this.updateSelectedItem(e);
            }
            sessionStorage.setItem(this.selectedChannelListKey, JSON.stringify(selectedItems));
            window.dispatchEvent(new CustomEvent(this.channelFilterSelectedEventKey, {
                detail: selectedItems,
                bubbles: true,
                composed: true
            }));
        }, _constants__WEBPACK_IMPORTED_MODULE_0__.SELECTED_CHANGE_DELAY);
        this.getLocalizedChannelList = () => {
            const localizedChannelList = [];
            this.channelList.forEach((ent) => {
                localizedChannelList.push({ name: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(`app:agentProfile.${ent.name}`), value: ent.value });
            });
            return localizedChannelList;
        };
    }
    static get styles() {
        return _index_scss__WEBPACK_IMPORTED_MODULE_9__["default"];
    }
    connectedCallback() {
        super.connectedCallback();
        // getting the FF from the service, because the Channel filter is being configured from layout json. So if we add this FF in STORE then all the layouts need to be updated.
        this.infiniteScrollingEnabled = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.featureflag.isFeatureFlagEnabled(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.FEATURE_FLAGS.MANAGED_FILTER_INFINITE_SCROLLING);
        if (this.infiniteScrollingEnabled) {
            this.value = this.populateValueFromCache();
            //
            // this setTimeout is work around. advance list using infinite scrolling lit component, and it has bug of overlapping element.
            setTimeout(() => {
                this.items = this.generateAdvanceListTemplate();
                this.selectAllItems = this.value.length === this.channelList.length;
            }, 0);
        }
        this.disableReset = this.value.length === 0;
    }
    updateSelectedItem(e) {
        const selectedItems = [];
        e.detail.selected.forEach((name) => {
            const item = this.channelList.find((channel) => channel.name === name);
            selectedItems.push({ name: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(`app:agentProfile.${item === null || item === void 0 ? void 0 : item.name}`), value: item === null || item === void 0 ? void 0 : item.value });
        });
        this.value = e.detail.selected;
        if (this.value.length === this.items.length) {
            this.selectAllItems = true;
        }
        else {
            this.selectAllItems = false;
        }
        return selectedItems;
    }
    naturalSort(a, b) {
        return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
    }
    updateSelectAllCheckboxOnClick() {
        if (this.selectAllItems) {
            this.resetFilter();
        }
        else {
            this.selectAllItems = true;
        }
    }
    resetFilter() {
        this.selectAllItems = false;
        this.value = [];
        this.disableReset = true;
        sessionStorage.removeItem(this.selectedChannelListKey);
    }
    generateAdvanceListTemplate() {
        const items = [];
        this.channelList.forEach((channel) => {
            const id = `${channel.name}`;
            items.push({
                name: channel.name,
                id,
                index: items.length,
                ariaLabel: channel.name,
                template: (data, index) => (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `<div class="channel-filter-item" aria-hidden="true" indexing="${index}">
            <md-checkbox>${data.name}</md-checkbox>
          </div>`
            });
        });
        return items;
    }
    sortSelectedItem(sortedItems) {
        const selectedItems = sortedItems.filter((item) => this.value.includes(item.id));
        if (selectedItems.length > 0) {
            this.lastSelectedIdByOrder = selectedItems[selectedItems.length - 1].name;
        }
        else {
            this.lastSelectedIdByOrder = "";
        }
        return selectedItems;
    }
    sortUnSelectedItem(sortedItems) {
        return sortedItems.filter((item) => !this.value.includes(item.id));
    }
    populateValueFromCache() {
        const cachedValueStr = sessionStorage.getItem(this.selectedChannelListKey);
        if (!cachedValueStr) {
            return [];
        }
        try {
            const parsedValue = JSON.parse(cachedValueStr);
            return Array.isArray(parsedValue) ? parsedValue.map((item) => item.name) : [];
        }
        catch (_a) {
            return [];
        }
    }
    getSortedItems() {
        // sort all records in natural order
        const sortedItems = [...this.items].sort((a, b) => this.naturalSort(a.name, b.name));
        if (this.infiniteScrollingEnabled) {
            return [...this.sortSelectedItem(sortedItems), ...this.sortUnSelectedItem(sortedItems)];
        }
        else {
            return sortedItems;
        }
    }
    getDropdownHeader() {
        const { length } = this.value;
        const ALL_LABEL = `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.all")}`;
        if (length === _constants__WEBPACK_IMPORTED_MODULE_0__.channelList.length) {
            return `${ALL_LABEL} (${_constants__WEBPACK_IMPORTED_MODULE_0__.channelList.length})`;
        }
        if (length > 0) {
            return `${length} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.selected")}`;
        }
        if (_constants__WEBPACK_IMPORTED_MODULE_0__.channelList.length > 0) {
            return `${ALL_LABEL} (${_constants__WEBPACK_IMPORTED_MODULE_0__.channelList.length})`;
        }
        return `${ALL_LABEL}`;
    }
    getFilterIcon() {
        return _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `<md-icon name="filter-bold" class="filter-icon" size="16" iconSet="momentumDesign"></md-icon>`
            : "";
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `<div
      class="filter-container channel-filter"
      style=${(0,lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_7__.styleMap)({
            width: `${this.style.width || "250px"}`
        })}
    >
      ${!this.infiniteScrollingEnabled
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
            <md-combobox
              .options=${this.getLocalizedChannelList()}
              option-id="value"
              option-value="name"
              shape=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__.ifDefined)(!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled ? "pill" : undefined)}
              ?newMomentum=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled}
              ?is-dropdown-arrow=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled}
              ?show-filter-icon=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled}
              ?compact=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled}
              is-multi
              show-selected-count
              no-clear-icon
              allow-select-all
              placeholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:supervisorProfile.selectChannel")}
              all-i18n=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.all")}
              selected-all-i18n=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.selected")}
              select-all-i18n=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.selectAll")}
              @change-selected=${this.changeHandler}
              .value=${this.selectedChannelList}
              ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:pageSubHeader.channelType")}
              comboboxId="inp-channelType"
            ></md-combobox>
          `
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
            <md-menu-overlay
              class="queueDropdown "
              size="small"
              @menu-overlay-open=${() => {
                this.items = this.getSortedItems();
                this.arrowIcon = "arrow-up-bold";
                this.isMenuOverlayOpen = true;
            }}
              @menu-overlay-close=${() => {
                this.arrowIcon = "arrow-down-bold";
                this.isMenuOverlayOpen = false;
            }}
            >
              <md-button
                variant="dropdown"
                is-placeholder-text
                slot="menu-trigger"
                width="250px"
                ariaHasPopup="listbox"
                ariaExpanded=${this.isMenuOverlayOpen}
                ariaLabel=${`${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:pageSubHeader.channelType")} ${this.getDropdownHeader()}`}
                .rounded=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled}
              >
                <div class="channel-filter-dropdown-button">
                  <span class="channel-filter-icon-text"> ${this.getFilterIcon()} ${this.getDropdownHeader()} </span>
                  <md-icon slot="input-section-right" name=${this.arrowIcon} iconset="momentumDesign"></md-icon>
                </div>
              </md-button>

              <div class="channel-filter-advance-list-container">
                <div class="channel-filter-select-all">
                  <md-checkbox
                    id="select-all"
                    @checkbox-change=${this.updateSelectAllCheckboxOnClick}
                    .checked=${this.selectAllItems}
                    >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.selectAll")}</md-checkbox
                  >
                </div>
                <md-advance-list
                  .items=${this.items}
                  .value=${this.value}
                  ariaRoleList="listbox"
                  containerHeight="165px"
                  ariaLabelList=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:supervisorProfile.selectChannel")}
                  .lastSelectedIdByOrder=${this.lastSelectedIdByOrder}
                  is-multi
                  .groupOnMultiSelect=${this.infiniteScrollingEnabled}
                  .selectAllItems=${this.selectAllItems}
                  @list-item-change=${this.changeHandler}
                >
                </md-advance-list>
                <div class="channel-filter-item-reset">
                  <md-button ?disabled=${this.disableReset} @button-click=${this.resetFilter} size="36"
                    >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:supervisorProfile.resetFilter")}</md-button
                  >
                </div>
              </div>
            </md-menu-overlay>
          `}
    </div>`;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Array })
], ChannelFilter.prototype, "selectedChannelList", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
], ChannelFilter.prototype, "selectedChannelListKey", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
], ChannelFilter.prototype, "channelFilterSelectedEventKey", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Array })
], ChannelFilter.prototype, "value", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Array })
], ChannelFilter.prototype, "items", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], ChannelFilter.prototype, "infiniteScrollingEnabled", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], ChannelFilter.prototype, "lastSelectedIdByOrder", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], ChannelFilter.prototype, "selectAllItems", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], ChannelFilter.prototype, "arrowIcon", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], ChannelFilter.prototype, "isMenuOverlayOpen", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], ChannelFilter.prototype, "disableReset", void 0);
ChannelFilter = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.customElement)("agentx-wc-channel-filter")
], ChannelFilter);



/***/ }),

/***/ "./src/components/SupervisorFilters/QueueFilter/QueueFilter.ts":
/*!*********************************************************************!*\
  !*** ./src/components/SupervisorFilters/QueueFilter/QueueFilter.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QueueFilter: () => (/* binding */ QueueFilter)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! lit-html/directives/style-map */ "lit-html/directives/style-map");
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _common_FilterDropdown__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../common/FilterDropdown */ "./src/components/SupervisorFilters/common/FilterDropdown.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./../../../utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./../index.scss */ "./src/components/SupervisorFilters/index.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};













let QueueFilter = class QueueFilter extends _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__.MobxLitElement {
    constructor() {
        super(...arguments);
        this.selectedQueueList = [];
        this.managedQueues = [];
        this.selectedQueueListKey = "selected-queue-list";
        this.queueFilterSelectedEventKey = "queue-filter-selected";
        this.fetchManagedQueueEventKey = "fetch-managed-queue";
        this.isLoading = true;
        this.isError = false;
        this.paginatedManagedQueues = [];
        this.filterManagedQueues = [];
        this.currentPage = 0;
        this.totalRecords = 0;
        this.infiniteScrollingEnabled = false;
        this.isPageLoading = false;
        this.pageFetchError = {
            isError: false,
            trackingId: ""
        };
        this.totalQueueRecords = 0;
        this.searchQuery = "";
        this.languageResources = "/i18n/{{lng}}/{{ns}}.json";
        this.changeHandler = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_11__.debounce)((e) => {
            sessionStorage.setItem(this.selectedQueueListKey, JSON.stringify(e.detail.selected));
            window.dispatchEvent(new CustomEvent(this.queueFilterSelectedEventKey, {
                detail: e.detail.selected,
                bubbles: true,
                composed: true
            }));
        }, _constants__WEBPACK_IMPORTED_MODULE_0__.SELECTED_CHANGE_DELAY);
        this.handleSearchQueryChange = (event) => {
            this.searchQuery = event.detail.searchQuery;
            if (this.searchQuery === "") {
                this.isPageLoading = false;
                this.filterManagedQueues = [];
                this.totalRecords = this.totalQueueRecords;
                return;
            }
            if (this.totalQueueRecords > 0 &&
                (this.paginatedManagedQueues.length === this.totalQueueRecords || this.totalQueueRecords <= 100)) {
                this.handleLocalSearch();
            }
            else {
                this.getManagedQueuesList(event);
            }
        };
    }
    static get styles() {
        return _index_scss__WEBPACK_IMPORTED_MODULE_12__["default"];
    }
    connectedCallback() {
        super.connectedCallback();
        this.infiniteScrollingEnabled = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.featureflag.isFeatureFlagEnabled(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.FEATURE_FLAGS.MANAGED_FILTER_INFINITE_SCROLLING);
        this.addEventListener("reload", this.fetchQueues);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener("reload", this.fetchQueues);
    }
    fetchQueues() {
        window.dispatchEvent(new CustomEvent(this.fetchManagedQueueEventKey, {
            detail: "",
            bubbles: true,
            composed: true
        }));
    }
    getFetchErrorMessage() {
        return JSON.stringify({
            header: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:errorDetail:errorTitle"),
            message: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:errorModal:trackingIdDescription"),
            trackingId: this.isError
        });
    }
    isFilterApplied() {
        return this.searchQuery && this.searchQuery.length > 0;
    }
    updateQueueData(data) {
        if (this.isFilterApplied()) {
            this.filterManagedQueues = [...this.filterManagedQueues, ...data];
        }
        else {
            this.paginatedManagedQueues = [...this.paginatedManagedQueues, ...data];
        }
    }
    resetQueueData(data) {
        if (this.isFilterApplied()) {
            this.filterManagedQueues = data;
        }
        else {
            this.paginatedManagedQueues = data;
        }
    }
    handleLoadPageSuccess(response, reset) {
        const formatQueue = response.data.map((queue) => {
            return {
                queueId: queue.id,
                queueName: queue.name
            };
        });
        if (reset) {
            this.resetQueueData(formatQueue);
        }
        else {
            this.updateQueueData(formatQueue);
        }
        this.currentPage = response.meta.page;
        this.totalRecords = response.meta.totalRecords;
        this.isPageLoading = false;
        if (!this.isFilterApplied()) {
            this.totalQueueRecords = response.meta.totalRecords;
        }
        this.pageFetchError = {
            isError: false,
            trackingId: ""
        };
        _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info(`event=getManagedQueuesList | Managed Queues page ${this.currentPage} fetched successfully`);
    }
    handleLoadPageError(error) {
        this.isPageLoading = false;
        this.pageFetchError = {
            isError: true,
            trackingId: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.getTrackingIdFromErrorObject)(error) : ""
        };
        _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error("event=getManagedQueuesList | Error on fetching managed queues on ESD Queue Filters", error);
    }
    fetchManagedQueues(pageNumber, searchQuery) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.abs.fetchQueueList({
                payload: {
                    pageSize: _constants__WEBPACK_IMPORTED_MODULE_0__.RECORDS_ONE_HUNDRED,
                    pageNumber,
                    search: searchQuery !== null && searchQuery !== void 0 ? searchQuery : "",
                    desktopProfileFilter: false
                },
                orgId: ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) || ""
            });
        });
    }
    handleLocalSearch() {
        if (this.paginatedManagedQueues.length > 0) {
            this.isPageLoading = true;
            const data = this.paginatedManagedQueues.filter((queue) => queue.queueName.toLowerCase().includes(this.searchQuery.toLowerCase()));
            this.isPageLoading = false;
            this.totalRecords = data.length;
            this.filterManagedQueues = data;
        }
        else {
            this.filterManagedQueues = [];
        }
    }
    getManagedQueuesList(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const { isFirstPageRequest, searchQuery } = event.detail;
            this.isPageLoading = true;
            this.searchQuery = searchQuery;
            const pageNumber = isFirstPageRequest ? 0 : this.currentPage + 1;
            try {
                const response = yield this.fetchManagedQueues(pageNumber, this.searchQuery);
                this.handleLoadPageSuccess(response, isFirstPageRequest);
            }
            catch (error) {
                this.handleLoadPageError(error);
            }
        });
    }
    getSelectedQueueIds() {
        return this.selectedQueueList.length === 0 ? [] : this.selectedQueueList.map((q) => q.queueId);
    }
    getPaginatedQueueList() {
        return this.isFilterApplied() ? this.filterManagedQueues : this.paginatedManagedQueues;
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
      <div
        class="filter-container"
        style=${(0,lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_9__.styleMap)({
            width: `${this.style.width || "250px"}`
        })}
      >
        ${!this.infiniteScrollingEnabled
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
              <md-combobox
                .options=${this.managedQueues}
                option-id="queueId"
                option-value="queueName"
                .value=${this.selectedQueueList}
                use-virtual-scroll
                shape=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_8__.ifDefined)(!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled ? "pill" : undefined)}
                ?newMomentum=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled}
                ?is-dropdown-arrow=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled}
                ?show-filter-icon=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled}
                ?compact=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled}
                is-multi
                show-selected-count
                no-clear-icon
                allow-select-all
                placeholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:supervisorProfile.selectQueue")}
                all-i18n=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.all")}
                selected-all-i18n=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.selected")}
                select-all-i18n=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.selectAll")}
                @change-selected=${this.changeHandler}
                @combobox-on-expand=${this.fetchQueues}
                show-custom-error=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_8__.ifDefined)(this.isError ? true : undefined)}
                show-loader=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_8__.ifDefined)(this.isLoading ? true : undefined)}
                ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:pageSubHeader.queueName")}
                comboboxId="inp-queueName"
              >
                ${this.isLoading
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
                      <div slot="custom-loader" part="custom-loader">
                        <agentx-wc-widget-loader></agentx-wc-widget-loader>
                      </div>
                    `
                : lit_html__WEBPACK_IMPORTED_MODULE_7__.nothing}
                ${this.isError
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
                      <div slot="custom-error" part="custom-error">
                        <agentx-wc-widget-error detail="${this.getFetchErrorMessage()}"></agentx-wc-widget-error>
                      </div>
                    `
                : lit_html__WEBPACK_IMPORTED_MODULE_7__.nothing}
              </md-combobox>
            `
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
              <agentx-wc-filter-dropdown
                .data=${this.getPaginatedQueueList()}
                .meta=${{
                totalRecords: this.totalRecords,
                fieldNames: { name: "queueName", id: "queueId" }
            }}
                filterLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:supervisorProfile.selectQueue")}
                buttonLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:pageSubHeader.queueName")}
                .defaultHeaderLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:supervisorProfile.selectQueue")}
                .value=${this.getSelectedQueueIds()}
                .selectedItems=${this.selectedQueueList}
                .isPageLoading=${this.isPageLoading}
                .pageFetchError=${this.pageFetchError}
                selectedFilterKey=${this.selectedQueueListKey}
                filterSelectedEventKey=${this.queueFilterSelectedEventKey}
                .groupOnMultiSelect=${true}
                @load-data=${this.getManagedQueuesList}
                overallRecords=${this.totalQueueRecords}
                @search-query-change=${this.handleSearchQueryChange}
              >
              </agentx-wc-filter-dropdown>
            `}
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Array, reflect: true })
], QueueFilter.prototype, "selectedQueueList", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Array, reflect: true })
], QueueFilter.prototype, "managedQueues", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: String })
], QueueFilter.prototype, "selectedQueueListKey", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: String })
], QueueFilter.prototype, "queueFilterSelectedEventKey", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: String })
], QueueFilter.prototype, "fetchManagedQueueEventKey", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Boolean, reflect: true })
], QueueFilter.prototype, "isLoading", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Boolean, reflect: true })
], QueueFilter.prototype, "isError", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], QueueFilter.prototype, "paginatedManagedQueues", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], QueueFilter.prototype, "filterManagedQueues", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], QueueFilter.prototype, "currentPage", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], QueueFilter.prototype, "totalRecords", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], QueueFilter.prototype, "infiniteScrollingEnabled", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], QueueFilter.prototype, "isPageLoading", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], QueueFilter.prototype, "pageFetchError", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], QueueFilter.prototype, "totalQueueRecords", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], QueueFilter.prototype, "searchQuery", void 0);
QueueFilter = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.customElement)("agentx-wc-queue-filter")
], QueueFilter);



/***/ }),

/***/ "./src/components/SupervisorFilters/TeamFilter/TeamFilter.ts":
/*!*******************************************************************!*\
  !*** ./src/components/SupervisorFilters/TeamFilter/TeamFilter.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TeamFilter: () => (/* binding */ TeamFilter)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! lit-html/directives/style-map */ "lit-html/directives/style-map");
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _common_FilterDropdown__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../common/FilterDropdown */ "./src/components/SupervisorFilters/common/FilterDropdown.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./../../../utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./../index.scss */ "./src/components/SupervisorFilters/index.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};













let TeamFilter = class TeamFilter extends _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__.MobxLitElement {
    constructor() {
        super(...arguments);
        this.selectedTeamList = [];
        this.managedTeams = [];
        this.selectedTeamListKey = "selected-team-list";
        this.teamFilterSelectedEventKey = "team-filter-selected";
        this.fetchManagedTeamEventKey = "fetch-managed-team";
        this.isLoading = true;
        this.isError = false;
        this.paginatedManagedTeams = [];
        this.filterManagedTeams = [];
        this.currentPage = 0;
        this.totalRecords = 0;
        this.infiniteScrollingEnabled = false;
        this.isPageLoading = false;
        this.pageFetchError = {
            isError: false,
            trackingId: ""
        };
        this.totalTeamRecords = 0;
        this.searchQuery = "";
        this.languageResources = "/i18n/{{lng}}/{{ns}}.json";
        this.changeHandler = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_11__.debounce)((e) => {
            sessionStorage.setItem(this.selectedTeamListKey, JSON.stringify(e.detail.selected));
            window.dispatchEvent(new CustomEvent(this.teamFilterSelectedEventKey, {
                detail: e.detail.selected,
                bubbles: true,
                composed: true
            }));
        }, _constants__WEBPACK_IMPORTED_MODULE_0__.SELECTED_CHANGE_DELAY);
        this.handleSearchQueryChange = (event) => {
            this.searchQuery = event.detail.searchQuery;
            if (this.searchQuery === "") {
                this.isPageLoading = false;
                this.filterManagedTeams = [];
                this.totalRecords = this.totalTeamRecords;
                return;
            }
            if (this.totalTeamRecords > 0 &&
                (this.totalRecords === this.paginatedManagedTeams.length || this.totalTeamRecords <= 100)) {
                this.handleLocalSearch();
            }
            else {
                this.getTeamList(event);
            }
        };
    }
    static get styles() {
        return _index_scss__WEBPACK_IMPORTED_MODULE_12__["default"];
    }
    connectedCallback() {
        super.connectedCallback();
        this.infiniteScrollingEnabled = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.featureflag.isFeatureFlagEnabled(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.FEATURE_FLAGS.MANAGED_FILTER_INFINITE_SCROLLING);
        this.addEventListener("reload", this.fetchTeams);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener("reload", this.fetchTeams);
    }
    fetchTeams() {
        window.dispatchEvent(new CustomEvent(this.fetchManagedTeamEventKey, {
            detail: "",
            bubbles: true,
            composed: true
        }));
    }
    getFetchErrorMessage() {
        return JSON.stringify({
            header: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:errorDetail:errorTitle"),
            message: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:errorModal:trackingIdDescription"),
            trackingId: this.isError
        });
    }
    isFilterApplied() {
        return this.searchQuery && this.searchQuery.length > 0;
    }
    updateTeamData(data) {
        if (this.isFilterApplied()) {
            this.filterManagedTeams = [...this.filterManagedTeams, ...data];
        }
        else {
            this.paginatedManagedTeams = [...this.paginatedManagedTeams, ...data];
        }
    }
    resetTeamData(data) {
        if (this.isFilterApplied()) {
            this.filterManagedTeams = data;
        }
        else {
            this.paginatedManagedTeams = data;
        }
    }
    handleLoadPageSuccess(response, reset) {
        if (reset) {
            this.resetTeamData(response.data);
        }
        else {
            this.updateTeamData(response.data);
        }
        this.currentPage = response.meta.page;
        this.totalRecords = response.meta.totalRecords;
        this.isPageLoading = false;
        if (!this.isFilterApplied()) {
            this.totalTeamRecords = response.meta.totalRecords;
        }
        this.pageFetchError = {
            isError: false,
            trackingId: ""
        };
    }
    handleLoadPageError(error) {
        this.isPageLoading = false;
        this.pageFetchError = {
            isError: true,
            trackingId: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.getTrackingIdFromErrorObject)(error) : ""
        };
        _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error("event=getTeamList | Error on fetching managed teams on ESD Team Filters", error);
    }
    fetchManagedTeams(pageNumber, reset, searchQuery) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const orgId = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId;
            return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.abs.fetchPaginatedTeamsList({
                orgId,
                page: pageNumber,
                pageSize: 100,
                search: searchQuery !== null && searchQuery !== void 0 ? searchQuery : "",
                customFilter: "",
                supervisorView: true
            });
        });
    }
    handleLocalSearch() {
        if (this.paginatedManagedTeams.length > 0) {
            this.isPageLoading = true;
            const data = this.paginatedManagedTeams.filter((team) => team.teamName.toLowerCase().includes(this.searchQuery.toLowerCase()));
            this.isPageLoading = false;
            this.totalRecords = data.length;
            this.filterManagedTeams = data;
        }
        else {
            this.filterManagedTeams = [];
        }
    }
    getTeamList(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const { isFirstPageRequest, searchQuery } = event.detail;
            this.isPageLoading = true;
            this.searchQuery = searchQuery;
            const pageNumber = isFirstPageRequest ? 0 : this.currentPage + 1;
            try {
                const response = yield this.fetchManagedTeams(pageNumber, isFirstPageRequest, this.searchQuery);
                this.handleLoadPageSuccess(response, isFirstPageRequest);
            }
            catch (error) {
                this.handleLoadPageError(error);
            }
        });
    }
    getSelectedTeamList() {
        return this.selectedTeamList.map((team) => team.teamId) || [];
    }
    getPaginatedTeamList() {
        if (this.isFilterApplied()) {
            return this.filterManagedTeams;
        }
        return this.paginatedManagedTeams;
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
      <div
        class="filter-container"
        style=${(0,lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_9__.styleMap)({
            width: `${this.style.width || "250px"}`
        })}
      >
        ${!this.infiniteScrollingEnabled
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) ` <md-combobox
              .options=${this.managedTeams}
              option-id="teamId"
              option-value="teamName"
              .value=${this.selectedTeamList}
              use-virtual-scroll
              shape=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_8__.ifDefined)(!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled ? "pill" : undefined)}
              ?newMomentum=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled}
              ?is-dropdown-arrow=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled}
              ?show-filter-icon=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled}
              ?compact=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled}
              is-multi
              show-selected-count
              no-clear-icon
              allow-select-all
              placeholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:supervisorProfile.selectTeam")}
              all-i18n=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.all")}
              selected-all-i18n=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.selected")}
              select-all-i18n=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.selectAll")}
              @change-selected=${this.changeHandler}
              @combobox-on-expand=${this.fetchTeams}
              show-custom-error=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_8__.ifDefined)(this.isError ? true : undefined)}
              show-loader=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_8__.ifDefined)(this.isLoading ? true : undefined)}
              ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:pageSubHeader.managedTeams")}
              comboboxId="inp-managedTeams"
            >
              ${this.isLoading
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
                    <div slot="custom-loader" part="custom-loader">
                      <agentx-wc-widget-loader></agentx-wc-widget-loader>
                    </div>
                  `
                : lit_html__WEBPACK_IMPORTED_MODULE_7__.nothing}
              ${this.isError
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
                    <div slot="custom-error" part="custom-error">
                      <agentx-wc-widget-error .detail="${this.getFetchErrorMessage()}"></agentx-wc-widget-error>
                    </div>
                  `
                : lit_html__WEBPACK_IMPORTED_MODULE_7__.nothing}
            </md-combobox>`
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) ` <agentx-wc-filter-dropdown
              .data=${this.getPaginatedTeamList()}
              .meta=${{
                totalRecords: this.totalRecords,
                fieldNames: { name: "teamName", id: "teamId" }
            }}
              filterLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:supervisorProfile.selectTeam")}
              buttonLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:pageSubHeader.managedTeams")}
              .defaultHeaderLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:supervisorProfile.selectTeam")}
              .value=${this.getSelectedTeamList()}
              .selectedItems=${this.selectedTeamList}
              .isPageLoading=${this.isPageLoading}
              .pageFetchError=${this.pageFetchError}
              selectedFilterKey=${this.selectedTeamListKey}
              filterSelectedEventKey=${this.teamFilterSelectedEventKey}
              .groupOnMultiSelect=${true}
              @load-data=${this.getTeamList}
              overAllRecords=${this.totalTeamRecords}
              @search-query-change=${this.handleSearchQueryChange}
            ></agentx-wc-filter-dropdown>`}
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Array, reflect: true })
], TeamFilter.prototype, "selectedTeamList", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Array, reflect: true })
], TeamFilter.prototype, "managedTeams", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: String })
], TeamFilter.prototype, "selectedTeamListKey", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: String })
], TeamFilter.prototype, "teamFilterSelectedEventKey", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: String })
], TeamFilter.prototype, "fetchManagedTeamEventKey", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Boolean, reflect: true })
], TeamFilter.prototype, "isLoading", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Boolean, reflect: true })
], TeamFilter.prototype, "isError", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], TeamFilter.prototype, "paginatedManagedTeams", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], TeamFilter.prototype, "filterManagedTeams", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], TeamFilter.prototype, "currentPage", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], TeamFilter.prototype, "totalRecords", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], TeamFilter.prototype, "infiniteScrollingEnabled", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], TeamFilter.prototype, "isPageLoading", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], TeamFilter.prototype, "pageFetchError", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], TeamFilter.prototype, "totalTeamRecords", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], TeamFilter.prototype, "searchQuery", void 0);
TeamFilter = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.customElement)("agentx-wc-team-filter")
], TeamFilter);



/***/ }),

/***/ "./src/components/SupervisorFilters/common/FilterDropdown.ts":
/*!*******************************************************************!*\
  !*** ./src/components/SupervisorFilters/common/FilterDropdown.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FilterDropdown: () => (/* binding */ FilterDropdown)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! lit-html/directives/style-map */ "lit-html/directives/style-map");
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Common_SearchInput_searchInput__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Common/SearchInput/searchInput */ "./src/components/Common/SearchInput/searchInput.ts");
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./index.scss */ "./src/components/SupervisorFilters/common/index.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};











let FilterDropdown = class FilterDropdown extends _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__.MobxLitElement {
    constructor() {
        super(...arguments);
        this.languageResources = "/i18n/{{lng}}/{{ns}}.json";
        this.data = [];
        this.meta = {
            totalRecords: 0,
            fieldNames: {
                id: "id",
                name: "name"
            }
        };
        this.filterLabel = "";
        this.buttonLabel = "";
        this.value = [];
        this.selectedItems = [];
        this.selectedFilterKey = "";
        this.filterSelectedEventKey = "";
        this.isPageLoading = false;
        this.pageFetchError = {
            isError: false,
            trackingId: ""
        };
        this.defaultHeaderLabel = "";
        this.groupOnMultiSelect = true;
        this.overAllRecords = 0;
        this.items = [];
        this.lastSelectedIdByOrder = "";
        this.selectAllItems = false;
        this.arrowIcon = "arrow-down-bold";
        this.isMenuOverlayOpen = false;
        this.dropDownHeaderLabel = "";
        this.lastSelectedItems = [];
        this.isDataTemplateGenerating = false;
        this.searchQuery = "";
        this.isSearchQueryTooShort = false;
        this.setSearchQueryInInput = true;
        this.disableReset = false;
        this.changeHandler = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.debounce)((e) => {
            const selectedItems = this.updateSelectedItem(e.detail.selected);
            this.disableReset = selectedItems.length === 0;
            this.value = e.detail.selected;
            this.updateSelectAllState();
            this.updateCachedForSelectedValue(selectedItems);
            this.dropDownHeaderLabel = this.getDropdownHeader();
        }, _constants__WEBPACK_IMPORTED_MODULE_0__.SELECTED_CHANGE_DELAY);
        this.loadNextPage = (event, isFirstPageRequest = false) => {
            this.isDataTemplateGenerating = true;
            this.dispatchEvent(new CustomEvent("load-data", {
                detail: {
                    isFirstPageRequest,
                    searchQuery: this.searchQuery
                }
            }));
        };
        this.loadNextPageOnScroll = () => {
            if (this.isMenuOverlayOpen && this.data.length > 0) {
                this.loadNextPage(undefined, false);
            }
        };
    }
    static get styles() {
        return _index_scss__WEBPACK_IMPORTED_MODULE_10__["default"];
    }
    connectedCallback() {
        var _a;
        super.connectedCallback();
        this.dropDownHeaderLabel = this.getDropdownHeader();
        if ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) {
            this.loadNextPage(undefined, true);
        }
        this.disableReset = this.value.length === 0;
    }
    updated(_changedProperties) {
        if (_changedProperties.has("data")) {
            if (this.isMenuOverlayOpen) {
                this.items = this.generateAdvanceListTemplate();
                this.isDataTemplateGenerating = false;
            }
            this.dropDownHeaderLabel = this.getDropdownHeader();
        }
        if (_changedProperties.has("pageFetchError") && this.pageFetchError.isError) {
            this.isDataTemplateGenerating = false;
        }
        if ((_changedProperties.has("value") || _changedProperties.has("items")) && this.items.length !== 0) {
            this.updateSelectAllState();
        }
    }
    updateSelectAllState() {
        const allItemsIds = new Set(this.items.map((obj) => obj.id));
        this.selectAllItems = this.value.length === this.items.length && this.value.every((id) => allItemsIds.has(id));
    }
    naturalSort(a, b) {
        return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
    }
    getSortedItems(items) {
        return [...items].sort((a, b) => this.naturalSort(a[this.meta.fieldNames.name], b[this.meta.fieldNames.name]));
    }
    sortSelectedItems() {
        const sortedItems = this.getSortedItems(this.lastSelectedItems);
        this.findLastSelectedIdByOrder(sortedItems);
        return sortedItems;
    }
    removeUnSelectedItems(sortedItems, sortedSelectedItems) {
        return sortedItems.filter((item) => !sortedSelectedItems.some((selectedItem) => selectedItem[this.meta.fieldNames.id] === item[this.meta.fieldNames.id]));
    }
    findLastSelectedIdByOrder(sortedSelectedItems) {
        this.lastSelectedIdByOrder =
            sortedSelectedItems.length > 0
                ? sortedSelectedItems[sortedSelectedItems.length - 1][this.meta.fieldNames.id]
                : "";
    }
    sortAndMergeData() {
        var _a;
        if (((_a = this.searchQuery) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            return this.data;
        }
        const sortedSelectedItems = this.sortSelectedItems();
        return [...sortedSelectedItems, ...this.removeUnSelectedItems(this.data, sortedSelectedItems)];
    }
    generateAdvanceListTemplate() {
        const items = [];
        if (this.data.length > 0) {
            this.sortAndMergeData().forEach((channel) => {
                const id = `${channel[this.meta.fieldNames.id]}`;
                items.push({
                    name: channel[this.meta.fieldNames.name],
                    id,
                    index: items.length,
                    ariaLabel: channel.name,
                    template: (data, index) => (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `<div class="common-filter-item" indexing="${index}">
              <md-checkbox>${data.name}</md-checkbox>
            </div>`
                });
            });
        }
        return items;
    }
    getDropdownHeader() {
        const { length } = this.value;
        const ALL_LABEL = `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.all")}`;
        if (length === this.overAllRecords) {
            return `${ALL_LABEL} (${this.overAllRecords})`;
        }
        if (length > 0) {
            return `${length} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.selected")}`;
        }
        if (this.overAllRecords > 0) {
            return `${ALL_LABEL} (${this.overAllRecords})`;
        }
        return `${ALL_LABEL}`;
    }
    updateSelectedItem(newUpdatedItems) {
        const selectedItems = [];
        newUpdatedItems.forEach((id) => {
            const item = this.lastSelectedItems.find((option) => option[this.meta.fieldNames.id] === id) ||
                this.data.find((option) => option[this.meta.fieldNames.id] === id);
            if (item) {
                selectedItems.push({
                    [this.meta.fieldNames.id]: item[this.meta.fieldNames.id],
                    [this.meta.fieldNames.name]: item[this.meta.fieldNames.name]
                });
            }
        });
        return selectedItems;
    }
    updateCachedForSelectedValue(value) {
        sessionStorage.setItem(this.selectedFilterKey, JSON.stringify(value));
        window.dispatchEvent(new CustomEvent(this.filterSelectedEventKey, {
            detail: value,
            bubbles: true,
            composed: true
        }));
    }
    resetSelectionFilters() {
        this.selectAllItems = false;
        this.value = [];
        this.disableReset = true;
        this.updateCachedForSelectedValue([]);
        this.dropDownHeaderLabel = this.getDropdownHeader();
    }
    resetFilter() {
        this.resetSelectionFilters();
        this.searchQuery = "";
        this.setSearchQueryInInput = false;
        this.isSearchQueryTooShort = false;
        this.handleSearch(true);
    }
    updateSelectAllCheckboxOnClick() {
        if (this.selectAllItems) {
            this.resetSelectionFilters();
        }
        else {
            this.selectAllItems = true;
        }
    }
    handleSearch(isFirstPageRequest = false) {
        if (this.searchQuery.length > 0) {
            this.isDataTemplateGenerating = true;
        }
        this.dispatchEvent(new CustomEvent("search-query-change", {
            detail: {
                isFirstPageRequest,
                searchQuery: this.searchQuery
            }
        }));
    }
    getDynamicHeight(itemsLength) {
        const minHeight = Math.max(itemsLength * 36.86, 0);
        return `${Math.min(minHeight, 260)}px`;
    }
    handleSearchCleared(e) {
        this.searchQuery = e.detail;
        this.isSearchQueryTooShort = false;
        this.lastSelectedItems = this.selectedItems;
        this.handleSearch(true);
    }
    handleSearchTooShort(e) {
        this.searchQuery = e.detail;
        this.setSearchQueryInInput = true;
        this.isSearchQueryTooShort = true;
    }
    handleSearchTermValid(e) {
        this.searchQuery = e.detail;
        this.setSearchQueryInInput = true;
        this.isSearchQueryTooShort = false;
        this.lastSelectedItems = this.selectedItems;
        this.handleSearch(true);
    }
    handleOverlayClose() {
        this.arrowIcon = "arrow-down-bold";
        this.isMenuOverlayOpen = false;
        this.selectAllItems = false;
        this.items = [];
        this.searchQuery = "";
        this.isSearchQueryTooShort = false;
        this.handleSearch(true);
    }
    handleOverlayOpen() {
        this.arrowIcon = "arrow-up-bold";
        this.isDataTemplateGenerating = true;
        this.isMenuOverlayOpen = true;
        this.lastSelectedItems = this.selectedItems;
        setTimeout(() => {
            this.items = this.generateAdvanceListTemplate();
            this.isDataTemplateGenerating = false;
            document.dispatchEvent(new CustomEvent("on-widget-update"));
        }, 0);
    }
    getLastSelectedItemIdByOrder() {
        return this.searchQuery && this.searchQuery.length > 0 ? "" : this.lastSelectedIdByOrder;
    }
    getFilterIcon() {
        return _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `<md-icon name="filter-bold" class="filter-icon" size="16" iconSet="momentumDesign"></md-icon>`
            : "";
    }
    renderState() {
        var _a;
        if (this.data.length === 0) {
            if (this.isPageLoading) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
          <div class="state-loading">
            <md-spinner size="24"></md-spinner>
          </div>
        `;
            }
            if (this.pageFetchError.isError) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
          <div class="state-error">
            <agentx-wc-empty-state-wrapper
              class="error-cloud-wrapper"
              illustration-type="error-cloud"
            ></agentx-wc-empty-state-wrapper>
            <div class="error-container">
              <p class="error-title">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:errorDetail:errorTitle")}</p>
            </div>
            <md-button @click=${() => this.loadNextPage(undefined, true)} id="reload-btn" color="blue">
              <span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:errorDetail:reloadButton")}</span>
            </md-button>
          </div>
        `;
            }
            if (!this.isPageLoading && !this.pageFetchError.isError && ((_a = this.searchQuery) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
          <div class="state-no-match">
            <agentx-wc-empty-state-wrapper
              class="empty-state-wrapper"
              illustration-type="empty-result"
            ></agentx-wc-empty-state-wrapper>
            <span class="empty-title">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.nomatchfound")}</span>
          </div>
        `;
            }
        }
        else if (this.isSearchQueryTooShort) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
        <div class="search-block-error">
          <div class="search-error">
            <md-icon name="info-badge-filled" iconSet="momentumDesign" size="16" class="search-error-info"></md-icon>
            ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:supervisorProfile.searchError")}
          </div>
        </div>
      `;
        }
        return lit_html__WEBPACK_IMPORTED_MODULE_7__.nothing;
    }
    renderSelectAllCheckbox() {
        if (this.overAllRecords <= 100 && this.data.length > 0 && !this.isSearchQueryTooShort) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
        <div class="common-filter-select-all">
          <md-checkbox
            id="select-all"
            @checkbox-change=${this.updateSelectAllCheckboxOnClick}
            .checked=${this.selectAllItems}
            >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.selectAll")}</md-checkbox
          >
        </div>
      `;
        }
        return lit_html__WEBPACK_IMPORTED_MODULE_7__.nothing;
    }
    getStatusIndicator() {
        if (this.isDataTemplateGenerating && this.items.length > 0) {
            return [
                {
                    id: "status-indicator",
                    name: "loading",
                    template: () => (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `<div class="infinite-scroll-spinner" part="spinner"><md-spinner size="18"></md-spinner></div>`
                }
            ];
        }
        if (this.pageFetchError.isError && this.items.length > 0) {
            return [
                {
                    id: "status-indicator",
                    name: "error",
                    template: () => (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `<agent-state-selector-list-error
              class="fetch-error"
              style="color: red;"
              trackingId="${this.pageFetchError.trackingId}"
              @error-retry="${this.loadNextPage}"
            >
            </agent-state-selector-list-error>`
                }
            ];
        }
        return [];
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
      <div
        class="common-filter"
        style=${(0,lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_8__.styleMap)({
            width: `${this.style.width || "250px"}`
        })}
      >
        <md-menu-overlay
          class="common-filter-dropdown"
          size="small"
          @menu-overlay-open=${this.handleOverlayOpen}
          @menu-overlay-close=${this.handleOverlayClose}
        >
          <md-button
            variant="dropdown"
            is-placeholder-text
            slot="menu-trigger"
            width="250px"
            ariaHasPopup="listbox"
            ariaExpanded=${this.isMenuOverlayOpen}
            ariaLabel=${`${this.buttonLabel} ${this.dropDownHeaderLabel}`}
            .rounded=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled}
          >
            <div class="common-filter-dropdown-button">
              <span class="common-filter-icon-text"> ${this.getFilterIcon()} ${this.dropDownHeaderLabel} </span>
              <md-icon slot="input-section-right" name=${this.arrowIcon} iconset="momentumDesign"></md-icon>
            </div>
          </md-button>

          <search-input
            class="search-wrapper"
            .isPageLoading=${this.isPageLoading}
            .reset=${this.setSearchQueryInInput && this.isMenuOverlayOpen}
            @search-cleared="${this.handleSearchCleared}"
            @search-too-short="${this.handleSearchTooShort}"
            @search-term-valid="${this.handleSearchTermValid}"
          >
          </search-input>

          <div class="common-filter-advance-list-container">
            ${this.renderSelectAllCheckbox()} ${this.renderState()}
            ${this.isMenuOverlayOpen && !this.isSearchQueryTooShort
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
                  <md-advance-list
                    .items=${this.items.concat(this.getStatusIndicator())}
                    .value=${[...this.value]}
                    ariaRoleList="listbox"
                    containerHeight=${this.getDynamicHeight(this.items.length)}
                    ariaLabelList=${this.filterLabel}
                    totalRecords=${this.meta.totalRecords}
                    .lastSelectedIdByOrder=${this.getLastSelectedItemIdByOrder()}
                    is-multi
                    .groupOnMultiSelect=${this.groupOnMultiSelect}
                    .selectAllItems=${this.selectAllItems}
                    .isLoading=${this.isDataTemplateGenerating}
                    .isError=${this.pageFetchError.isError}
                    @list-item-change=${this.changeHandler}
                    @load-more=${this.loadNextPageOnScroll}
                  >
                  </md-advance-list>
                `
            : lit_html__WEBPACK_IMPORTED_MODULE_7__.nothing}
            <div class="common-filter-item-reset">
              <md-button ?disabled=${this.disableReset} @button-click=${this.resetFilter} size="36"
                >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:supervisorProfile.resetFilter")}</md-button
              >
            </div>
          </div>
        </md-menu-overlay>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Array })
], FilterDropdown.prototype, "data", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Object })
], FilterDropdown.prototype, "meta", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: String })
], FilterDropdown.prototype, "filterLabel", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: String })
], FilterDropdown.prototype, "buttonLabel", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Array })
], FilterDropdown.prototype, "value", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Array })
], FilterDropdown.prototype, "selectedItems", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: String })
], FilterDropdown.prototype, "selectedFilterKey", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: String })
], FilterDropdown.prototype, "filterSelectedEventKey", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Boolean })
], FilterDropdown.prototype, "isPageLoading", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Object })
], FilterDropdown.prototype, "pageFetchError", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: String })
], FilterDropdown.prototype, "defaultHeaderLabel", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Boolean })
], FilterDropdown.prototype, "groupOnMultiSelect", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Number })
], FilterDropdown.prototype, "overAllRecords", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], FilterDropdown.prototype, "items", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], FilterDropdown.prototype, "lastSelectedIdByOrder", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], FilterDropdown.prototype, "selectAllItems", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], FilterDropdown.prototype, "arrowIcon", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], FilterDropdown.prototype, "isMenuOverlayOpen", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], FilterDropdown.prototype, "dropDownHeaderLabel", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], FilterDropdown.prototype, "lastSelectedItems", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], FilterDropdown.prototype, "isDataTemplateGenerating", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], FilterDropdown.prototype, "searchQuery", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], FilterDropdown.prototype, "isSearchQueryTooShort", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], FilterDropdown.prototype, "setSearchQueryInInput", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], FilterDropdown.prototype, "disableReset", void 0);
FilterDropdown = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.customElement)("agentx-wc-filter-dropdown")
], FilterDropdown);



/***/ }),

/***/ "./src/components/SupervisorFilters/common/index.scss":
/*!************************************************************!*\
  !*** ./src/components/SupervisorFilters/common/index.scss ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --filter-min-width: 150px;
  --column-gap: 6px;
  --filter-min-height: 260px;
}

.common-filter {
  min-width: var(--filter-min-width);
}
.common-filter md-advance-list::part(advance-list-item-wrapper) {
  padding: 9px 12px;
  overflow: hidden;
}
.common-filter md-advance-list::part(spinner) {
  display: flex;
  justify-content: center;
}
.common-filter .common-filter-advance-list-container {
  width: 100%;
  overflow: hidden;
}
.common-filter .common-filter-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.common-filter .common-filter-select-all {
  padding: 6px 0 7px 14px;
  border-bottom: var(--line-separator);
}
.common-filter .common-filter-item-reset {
  border-top: var(--line-separator);
  padding: 8px 0 8px 20px;
}
.common-filter .common-filter-dropdown-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.common-filter .common-filter-icon-text {
  display: flex;
  column-gap: var(--column-gap);
}
.common-filter .common-filter-dropdown::part(overlay-content) {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.common-filter .search-wrapper {
  padding: 13px 16px 0px 16px;
  border-bottom: var(--line-separator);
}
.common-filter .state-loading {
  height: var(--filter-min-height);
  display: flex;
  align-items: center;
  justify-content: center;
}
.common-filter .state-error {
  padding: 30px 0 16px 0;
  display: grid;
}
.common-filter .state-error .error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.common-filter .state-error .error-title {
  font-size: var(--font-size-medium);
  margin: 0 calc(var(--space-token-even) * 8);
  margin-bottom: auto;
  font-weight: 600;
  text-align: center;
  padding: 0;
  color: var(--list-text-color, #121212);
}
.common-filter .state-error .error-subtitle {
  font-size: var(--font-size-medium);
  margin: 0 calc(var(--space-token-even) * 8);
  margin-bottom: auto;
  text-align: center;
  padding: 0;
}
.common-filter .state-error .error-cloud-wrapper {
  height: auto;
}
.common-filter .state-error .error-cloud-wrapper::part(container) {
  background-color: var(--md-secondary-white-bg-color);
}
.common-filter .state-error .error-cloud-wrapper::part(img) {
  display: block;
  margin: auto;
  width: auto;
}
.common-filter .state-error md-button {
  margin: 24px auto auto auto;
}
.common-filter .state-no-match {
  height: calc(var(--filter-min-height) - 48);
  padding: calc(var(--space-token-even) * 12) calc(var(--space-token-even) * 12);
  position: relative;
  text-align: center;
}
.common-filter .state-no-match .empty-title {
  font-size: var(--font-size-medium);
  margin: 0 calc(var(--space-token-even) * 8);
  margin-bottom: auto;
  color: var(--list-text-color, #121212);
}
.common-filter .state-no-match .empty-state-wrapper::part(container) {
  background-color: var(--md-secondary-white-bg-color);
}
.common-filter .state-no-match .empty-state-wrapper::part(img) {
  display: block;
  margin: auto;
  width: auto;
}

.search-block-error {
  display: flex;
  align-items: center;
  padding: 16px;
  min-height: 216px;
}

.search-error {
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;
  font-size: var(--font-size-small);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/SupervisorFilters/index.scss":
/*!*****************************************************!*\
  !*** ./src/components/SupervisorFilters/index.scss ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --filter-min-width: 150px;
  --filter-count-width: 100px;
  --line-separator: 1px solid var(--md-gray-20, #dedede);
  --column-gap: 6px;
}

.filter-container {
  min-width: var(--filter-min-width);
}
.filter-container md-combobox::part(multiwrap-input) {
  width: calc(100% - var(--filter-count-width));
}
.filter-container md-combobox::part(custom-error),
.filter-container md-combobox::part(custom-loader) {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--md-primary-bg-color);
  padding: 30px 0px;
  min-height: 300px;
}
.filter-container md-advance-list::part(advance-list-item-wrapper) {
  padding: 9px 12px;
  overflow: hidden;
}
.filter-container md-advance-list::part(spinner) {
  display: flex;
  justify-content: center;
}
.filter-container .channel-filter-advance-list-container {
  width: 100%;
  overflow: hidden;
}
.filter-container .channel-filter-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.filter-container .channel-filter-select-all {
  padding: 6px 0 7px 14px;
  border-bottom: var(--line-separator);
}
.filter-container .channel-filter-item-reset {
  border-top: var(--line-separator);
  padding: 8px 0 8px 20px;
}
.filter-container .channel-filter-dropdown-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.filter-container .channel-filter-icon-text {
  display: flex;
  column-gap: var(--column-gap);
}
.filter-container .queue-filter-advance-list-container {
  width: 100%;
  overflow: hidden;
  padding-top: 10px;
}
.filter-container .queue-filter-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.filter-container .queue-filter-select-all {
  padding: 0 0 7px 14px;
  border-bottom: var(--line-separator);
}
.filter-container .queue-filter-item-reset {
  border-top: var(--line-separator);
  padding: 6px 0 6px 10px;
}
.filter-container .queue-filter-dropdown-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.filter-container .queue-filter-icon-text {
  display: flex;
  column-gap: var(--column-gap);
}
.filter-container .managed-queues-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--md-primary-bg-color);
  padding: 68px 0px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL1N1cGVydmlzb3JGaWx0ZXJzL2luZGV4LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSx5QkFBQTtFQUNBLDJCQUFBO0VBQ0Esc0RBQUE7RUFDQSxpQkFBQTtBQUNGOztBQUVBO0VBQ0Usa0NBQUE7QUFDRjtBQUNFO0VBQ0UsNkNBQUE7QUFDSjtBQUVFOztFQUVFLGFBQUE7RUFDQSxtQkFBQTtFQUNBLHVCQUFBO0VBQ0EsNENBQUE7RUFDQSxpQkFBQTtFQUNBLGlCQUFBO0FBQUo7QUFHRTtFQUNFLGlCQUFBO0VBQ0EsZ0JBQUE7QUFESjtBQUdFO0VBQ0UsYUFBQTtFQUNBLHVCQUFBO0FBREo7QUFJSTtFQUNFLFdBQUE7RUFDQSxnQkFBQTtBQUZOO0FBSUk7RUFDRSxhQUFBO0VBQ0EsMkJBQUE7RUFDQSxtQkFBQTtBQUZOO0FBS0k7RUFDRSx1QkFBQTtFQUNBLG9DQUFBO0FBSE47QUFNSTtFQUNFLGlDQUFBO0VBQ0EsdUJBQUE7QUFKTjtBQU9JO0VBQ0UsYUFBQTtFQUNBLG1CQUFBO0VBQ0EsbUJBQUE7RUFDQSw4QkFBQTtFQUNBLFdBQUE7QUFMTjtBQVFJO0VBQ0UsYUFBQTtFQUNBLDZCQUFBO0FBTk47QUFXSTtFQUNFLFdBQUE7RUFDQSxnQkFBQTtFQUNBLGlCQUFBO0FBVE47QUFXSTtFQUNFLGFBQUE7RUFDQSwyQkFBQTtFQUNBLG1CQUFBO0FBVE47QUFZSTtFQUNFLHFCQUFBO0VBQ0Esb0NBQUE7QUFWTjtBQWFJO0VBQ0UsaUNBQUE7RUFDQSx1QkFBQTtBQVhOO0FBY0k7RUFDRSxhQUFBO0VBQ0EsbUJBQUE7RUFDQSxtQkFBQTtFQUNBLDhCQUFBO0VBQ0EsV0FBQTtBQVpOO0FBZUk7RUFDRSxhQUFBO0VBQ0EsNkJBQUE7QUFiTjtBQWlCRTtFQUNFLGFBQUE7RUFDQSxtQkFBQTtFQUNBLHVCQUFBO0VBQ0EsNENBQUE7RUFDQSxpQkFBQTtBQWZKIiwic291cmNlc0NvbnRlbnQiOlsiOmhvc3Qge1xuICAtLWZpbHRlci1taW4td2lkdGg6IDE1MHB4O1xuICAtLWZpbHRlci1jb3VudC13aWR0aDogMTAwcHg7XG4gIC0tbGluZS1zZXBhcmF0b3I6IDFweCBzb2xpZCB2YXIoLS1tZC1ncmF5LTIwLCAjZGVkZWRlKTtcbiAgLS1jb2x1bW4tZ2FwOiA2cHg7XG59XG5cbi5maWx0ZXItY29udGFpbmVyIHtcbiAgbWluLXdpZHRoOiB2YXIoLS1maWx0ZXItbWluLXdpZHRoKTtcblxuICBtZC1jb21ib2JveDo6cGFydChtdWx0aXdyYXAtaW5wdXQpIHtcbiAgICB3aWR0aDogY2FsYygxMDAlIC0gdmFyKC0tZmlsdGVyLWNvdW50LXdpZHRoKSk7XG4gIH1cblxuICBtZC1jb21ib2JveDo6cGFydChjdXN0b20tZXJyb3IpLFxuICBtZC1jb21ib2JveDo6cGFydChjdXN0b20tbG9hZGVyKSB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICAgIGJhY2tncm91bmQtY29sb3I6IHZhcigtLW1kLXByaW1hcnktYmctY29sb3IpO1xuICAgIHBhZGRpbmc6IDMwcHggMHB4O1xuICAgIG1pbi1oZWlnaHQ6IDMwMHB4O1xuICB9XG5cbiAgbWQtYWR2YW5jZS1saXN0OjpwYXJ0KGFkdmFuY2UtbGlzdC1pdGVtLXdyYXBwZXIpIHtcbiAgICBwYWRkaW5nOiA5cHggMTJweDtcbiAgICBvdmVyZmxvdzogaGlkZGVuO1xuICB9XG4gIG1kLWFkdmFuY2UtbGlzdDo6cGFydChzcGlubmVyKSB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgfVxuICAuY2hhbm5lbC1maWx0ZXIge1xuICAgICYtYWR2YW5jZS1saXN0LWNvbnRhaW5lciB7XG4gICAgICB3aWR0aDogMTAwJTtcbiAgICAgIG92ZXJmbG93OiBoaWRkZW47XG4gICAgfVxuICAgICYtaXRlbSB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAganVzdGlmeS1jb250ZW50OiBmbGV4LXN0YXJ0O1xuICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICB9XG5cbiAgICAmLXNlbGVjdC1hbGwge1xuICAgICAgcGFkZGluZzogNnB4IDAgN3B4IDE0cHg7XG4gICAgICBib3JkZXItYm90dG9tOiB2YXIoLS1saW5lLXNlcGFyYXRvcik7XG4gICAgfVxuXG4gICAgJi1pdGVtLXJlc2V0IHtcbiAgICAgIGJvcmRlci10b3A6IHZhcigtLWxpbmUtc2VwYXJhdG9yKTtcbiAgICAgIHBhZGRpbmc6IDhweCAwIDhweCAyMHB4O1xuICAgIH1cblxuICAgICYtZHJvcGRvd24tYnV0dG9uIHtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBmbGV4LWRpcmVjdGlvbjogcm93O1xuICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcbiAgICAgIHdpZHRoOiAxMDAlO1xuICAgIH1cblxuICAgICYtaWNvbi10ZXh0IHtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBjb2x1bW4tZ2FwOiB2YXIoLS1jb2x1bW4tZ2FwKTtcbiAgICB9XG4gIH1cblxuICAucXVldWUtZmlsdGVyIHtcbiAgICAmLWFkdmFuY2UtbGlzdC1jb250YWluZXIge1xuICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICBvdmVyZmxvdzogaGlkZGVuO1xuICAgICAgcGFkZGluZy10b3A6IDEwcHg7XG4gICAgfVxuICAgICYtaXRlbSB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAganVzdGlmeS1jb250ZW50OiBmbGV4LXN0YXJ0O1xuICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICB9XG5cbiAgICAmLXNlbGVjdC1hbGwge1xuICAgICAgcGFkZGluZzogMCAwIDdweCAxNHB4O1xuICAgICAgYm9yZGVyLWJvdHRvbTogdmFyKC0tbGluZS1zZXBhcmF0b3IpO1xuICAgIH1cblxuICAgICYtaXRlbS1yZXNldCB7XG4gICAgICBib3JkZXItdG9wOiB2YXIoLS1saW5lLXNlcGFyYXRvcik7XG4gICAgICBwYWRkaW5nOiA2cHggMCA2cHggMTBweDtcbiAgICB9XG5cbiAgICAmLWRyb3Bkb3duLWJ1dHRvbiB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgZmxleC1kaXJlY3Rpb246IHJvdztcbiAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gICAgICB3aWR0aDogMTAwJTtcbiAgICB9XG5cbiAgICAmLWljb24tdGV4dCB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgY29sdW1uLWdhcDogdmFyKC0tY29sdW1uLWdhcCk7XG4gICAgfVxuICB9XG5cbiAgLm1hbmFnZWQtcXVldWVzLWxvYWRlciB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICAgIGJhY2tncm91bmQtY29sb3I6IHZhcigtLW1kLXByaW1hcnktYmctY29sb3IpO1xuICAgIHBhZGRpbmc6IDY4cHggMHB4O1xuICB9XG59XG4iXSwic291cmNlUm9vdCI6IiJ9 */`);
    

/***/ }),

/***/ "./src/components/TaskList/TaskList.scss":
/*!***********************************************!*\
  !*** ./src/components/TaskList/TaskList.scss ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  --border-color: rgba(0, 0, 0, 0.12);
  background-color: var(--md-task-list-bg-color, #f7f7f7);
  border-right: 1px solid var(--border-color);
  display: flex;
  height: 100%;
  width: clamp(rem-calc(270), 25%, rem-calc(570));
  overflow: auto;
  padding: var(--space-token-even);
}

.ax-activity-list-wrapper {
  animation: fadeIn 300ms 1 250ms forwards;
  opacity: 0;
  width: calc(100% - 3px * 2);
  margin-left: 3px;
  margin-right: 3px;
}

.ax-activity-list-item {
  box-sizing: border-box;
  margin-bottom: calc(var(--space-token-even) * 2);
  width: 100%;
}

.ax-activity-list-item::part(list-item) {
  background-color: transparent;
  padding: calc(var(--space-token-even) / 2);
  border-radius: 0.5rem;
}

.ax-activity-list-item::part(list-item):focus {
  background-color: transparent;
}

.ax-activity-list-item::part(list-item):hover {
  background-color: transparent;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
}
.empty-state uuip-wc-empty-state::part(container) {
  background-color: var(--md-task-list-bg-color);
}
.empty-state uuip-wc-empty-state::part(img) {
  width: 84px;
  height: 84px;
}
.empty-state .empty-text {
  color: var(--md-primary-text-color);
}

.empty-state::before {
  content: "";
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/TaskList/TaskList.ts":
/*!*********************************************!*\
  !*** ./src/components/TaskList/TaskList.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TaskList: () => (/* binding */ TaskList)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @uuip/unified-ui-platform-common-components */ "@uuip/unified-ui-platform-common-components");
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./../../constants */ "./src/constants.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./../../utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _TaskList_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./TaskList.scss */ "./src/components/TaskList/TaskList.scss");
/* harmony import */ var _comp_TaskListItem__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./comp/TaskListItem */ "./src/components/TaskList/comp/TaskListItem.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */











var TaskList;
(function (TaskList) {
    /**
     * @element agentx-wc-task-list
     * @fires task-selected
     * @fires task-removed
     * @fires handle-new-replies
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_5__.LitElement) {
        constructor() {
            super(...arguments);
            this.selectedId = null;
            this.agentId = "";
            this.taskList = [];
            this.unreadMessages = {};
            this.hasOfferContact = false;
            this.isInteractionModelOpen = false;
            this.clickEvent = false;
            this.newUnreadTaskMessage = {};
            this.isDarkMode = false;
            this.isProgressiveCampaignEnabled = false;
            this.isProgressiveCampaign1NEnabled = false;
            this.isPreviewCampaignEnabled = false;
            this.monitoringOwnerName = "";
            this.timerAriaLabel = "";
            this.isRestytle = false;
            this.newReplyList = new Map();
            this.handleNewReplies = "handle-new-replies";
            this.checkVisibilityScroll = () => {
                Array.from(this.newReplyList.keys()).forEach((key) => {
                    this.updateNewReplyList(key);
                });
                const isShowUp = !!this.newReplyList.size && [...this.newReplyList][0][1].value === "top";
                this.dispatchEvent(new CustomEvent(this.handleNewReplies, {
                    bubbles: true,
                    cancelable: false,
                    detail: { show: !!this.newReplyList.size, isShowUp }
                }));
            };
            this.onScrollHadler = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_8__.debounce)(this.checkVisibilityScroll, 300);
        }
        connectedCallback() {
            super.connectedCallback();
            this.handleShortcutKeyEvent();
            if (this.parentElement) {
                if (window.ResizeObserver) {
                    this.resizerObserver = new window.ResizeObserver(this.onScrollHadler);
                    this.resizerObserver.observe(this.parentElement);
                }
                this.parentElement.addEventListener("scroll", this.onScrollHadler);
            }
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.stopListen();
            if (this.parentElement && window.ResizeObserver && this.resizerObserver) {
                this.resizerObserver.unobserve(this.parentElement);
                this.parentElement.removeEventListener("scroll", this.onScrollHadler);
            }
        }
        handleShortcutKeyEvent() {
            const { stopListen } = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.event.listenKeyPress((event) => {
                const { data } = event;
                if (data &&
                    data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.REGISTERED_KEYS.SWITCH_TASK_KEY &&
                    data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.MODIFIERS.CTRL_SHIFT) {
                    this.switchTask();
                }
            });
            this.stopListen = stopListen;
        }
        update(changedProperties) {
            var _a;
            super.update(changedProperties);
            if (changedProperties.has("clickEvent")) {
                this.highlightNewReplies();
            }
            if (changedProperties.has("newUnreadTaskMessage") &&
                ((_a = this.newUnreadTaskMessage) === null || _a === void 0 ? void 0 : _a.interactionId) &&
                !this.newReplyList.has(this.newUnreadTaskMessage.interactionId)) {
                this.updateNewReplyList(this.newUnreadTaskMessage.interactionId);
                const isShowUp = !!this.newReplyList.size && [...this.newReplyList][0][1].value === "top";
                this.dispatchEvent(new CustomEvent(this.handleNewReplies, {
                    bubbles: true,
                    cancelable: false,
                    detail: { show: !!this.newReplyList.size, isShowUp }
                }));
            }
        }
        highlightNewReplies() {
            if (this.taskListElement) {
                const element = this.taskListElement.querySelector(`#task-${[...this.newReplyList.keys()][0]}`);
                if (element) {
                    element.focus();
                }
            }
            const index = [...this.newReplyList.keys()];
            this.newReplyList.delete(index[0]);
            const isShowUp = !!this.newReplyList.size && [...this.newReplyList][0][1].value === "top";
            this.dispatchEvent(new CustomEvent(this.handleNewReplies, {
                bubbles: true,
                cancelable: false,
                detail: { show: !!this.newReplyList.size, isShowUp }
            }));
        }
        updateNewReplyList(key) {
            var _a;
            const element = (_a = this.taskListElement) === null || _a === void 0 ? void 0 : _a.querySelector(`#task-${key}`);
            if (element && this.parentElement) {
                const { isVisible, arrowDir } = Object.assign({}, (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_8__.isTaskItemCardVisible)(element, this.parentElement));
                if (!isVisible) {
                    this.newReplyList.set(key, { value: arrowDir });
                }
                else {
                    this.newReplyList.delete(key);
                }
            }
        }
        updated(changedProperties) {
            super.updated(changedProperties);
        }
        switchTask() {
            if (this.taskList.length > 0) {
                const index = this.taskList.findIndex((task) => task.interactionId === this.selectedId);
                if (index < 0 || index === this.taskList.length - 1) {
                    this.selectedTask(this.taskList[0].interactionId);
                }
                else {
                    this.selectedTask(this.taskList[index + 1].interactionId);
                }
            }
        }
        handleTaskItemKeyDown(event, taskId) {
            if (event.code === _constants__WEBPACK_IMPORTED_MODULE_7__.Key.Enter || event.code === _constants__WEBPACK_IMPORTED_MODULE_7__.Key.Space) {
                this.selectedTask(taskId);
            }
        }
        selectedTask(taskId) {
            if (this.isInteractionModelOpen) {
                return;
            }
            this.evt("task-selected", { taskId });
        }
        // ROST: create decorator fot custom event
        evt(name, detail) {
            this.dispatchEvent(new CustomEvent(name, { bubbles: true, composed: true, detail }));
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[TaskList] Dispatching event", name, detail);
        }
        get selectedListItem() {
            return this.taskList.findIndex((task) => task.interactionId === this.selectedId);
        }
        static get styles() {
            return _TaskList_scss__WEBPACK_IMPORTED_MODULE_9__["default"];
        }
        renderEmptyImage() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <div class="empty-state">
          <uuip-wc-empty-state
            illustration-src="    /images/illustrations/horns-success-192.svg  "
            illustration-alt="empty-state"
          >
            <p class="empty-text" role="tooltip" aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:taskBar.emptyStateMessage")} tabindex="0">
              ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:taskBar.emptyStateMessageNew")}
            </p>
          </uuip-wc-empty-state>
        </div>
      `;
        }
        render() {
            return this.taskList.length > 0
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
            <md-list
              label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:taskBar.taskList", "Agent Task List with {{count}} tasks", {
                    count: this.taskList.length
                })}"
              class="ax-activity-list-wrapper"
              .activated=${this.selectedListItem}
              role="listbox"
            >
              ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_6__.repeat)(this.taskList, (task) => {
                    return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
                  <md-list-item
                    slot="list-item"
                    id="task-${task.interactionId}"
                    @click=${() => this.selectedTask(task.interactionId)}
                    @keydown=${(event) => this.handleTaskItemKeyDown(event, task.interactionId)}
                    class="ax-activity-list-item"
                    role="option"
                    @focus=${() => {
                        this.timerAriaLabel = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_8__.updateTimerAriaLabel)(task.timeStamp);
                    }}
                  >
                    <agentx-wc-task-list-item
                      .task=${task}
                      .isProgressiveCampaignEnabled=${this.isProgressiveCampaignEnabled}
                      .isProgressiveCampaign1NEnabled=${this.isProgressiveCampaign1NEnabled}
                      .isPreviewCampaignEnabled=${this.isPreviewCampaignEnabled}
                      ?selected=${task.interactionId === this.selectedId}
                      .unreadMessage="${this.unreadMessages[task.interactionId]
                        ? this.unreadMessages[task.interactionId]
                        : {}}"
                      .isInteractionModelOpen=${this.isInteractionModelOpen}
                      .isDarkMode=${this.isDarkMode}
                      .monitoringOwnerName=${this.monitoringOwnerName}
                      .timerAriaLabel=${this.timerAriaLabel}
                      ?is-restyle=${this.isRestytle}
                    ></agentx-wc-task-list-item>
                  </md-list-item>
                `;
                })}
            </md-list>
          `
                : !this.hasOfferContact
                    ? this.renderEmptyImage()
                    : null;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "selectedId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "agentId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Array })
    ], Element.prototype, "taskList", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Object })
    ], Element.prototype, "unreadMessages", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "hasOfferContact", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isInteractionModelOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "clickEvent", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Object })
    ], Element.prototype, "newUnreadTaskMessage", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isDarkMode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isProgressiveCampaignEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isProgressiveCampaign1NEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isPreviewCampaignEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "monitoringOwnerName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "timerAriaLabel", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean, attribute: "is-restyle" })
    ], Element.prototype, "isRestytle", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.query)(".ax-activity-list-wrapper")
    ], Element.prototype, "taskListElement", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.customElement)("agentx-wc-task-list")
    ], Element);
    TaskList.Element = Element;
})(TaskList || (TaskList = {}));


/***/ }),

/***/ "./src/components/TaskList/comp/TaskListItem.scss":
/*!********************************************************!*\
  !*** ./src/components/TaskList/comp/TaskListItem.scss ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --border-color: rgba(0, 0, 0, 0.12);
  --background-color: #b8f2ff;
  align-items: center;
  display: flex;
  font: inherit;
  max-height: 100%;
  width: 100%;
}

.ax-list-item {
  box-sizing: border-box;
  width: 100%;
  outline-offset: -3px;
}

.not-allowed-cursor,
.not-allowed-cursor::part(task-item-container) {
  cursor: not-allowed !important;
}

.channel-icon {
  position: relative;
  top: 0.1rem;
}

.ax-list-item::part(task-item-container) {
  margin: 2px;
}
.ax-list-item::part(task-item-container):focus {
  outline: none;
}
.ax-list-item::part(task-item-container):focus::after {
  box-shadow: none;
}

agentx-wc-task-list-timer {
  margin-bottom: 8.5px;
}

@media (forced-colors: active) {
  :host {
    --border-color: CanvasText !important;
    --background-color: Canvas !important;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL1Rhc2tMaXN0L2NvbXAvVGFza0xpc3RJdGVtLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxtQ0FBQTtFQUNBLDJCQUFBO0VBQ0EsbUJBQUE7RUFDQSxhQUFBO0VBQ0EsYUFBQTtFQUNBLGdCQUFBO0VBQ0EsV0FBQTtBQUNGOztBQUVBO0VBQ0Usc0JBQUE7RUFDQSxXQUFBO0VBQ0Esb0JBQUE7QUFDRjs7QUFFQTs7RUFFRSw4QkFBQTtBQUNGOztBQUNBO0VBQ0Usa0JBQUE7RUFDQSxXQUFBO0FBRUY7O0FBQ0E7RUFDRSxXQUFBO0FBRUY7QUFBRTtFQUNFLGFBQUE7QUFFSjtBQUFJO0VBQ0UsZ0JBQUE7QUFFTjs7QUFHQTtFQUNFLG9CQUFBO0FBQUY7O0FBR0E7RUFDRTtJQUNFLHFDQUFBO0lBQ0EscUNBQUE7RUFBRjtBQUNGIiwic291cmNlc0NvbnRlbnQiOlsiOmhvc3Qge1xuICAtLWJvcmRlci1jb2xvcjogcmdiYSgwLCAwLCAwLCAwLjEyKTtcbiAgLS1iYWNrZ3JvdW5kLWNvbG9yOiAjYjhmMmZmO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBkaXNwbGF5OiBmbGV4O1xuICBmb250OiBpbmhlcml0O1xuICBtYXgtaGVpZ2h0OiAxMDAlO1xuICB3aWR0aDogMTAwJTtcbn1cblxuLmF4LWxpc3QtaXRlbSB7XG4gIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gIHdpZHRoOiAxMDAlO1xuICBvdXRsaW5lLW9mZnNldDogLTNweDtcbn1cblxuLm5vdC1hbGxvd2VkLWN1cnNvcixcbi5ub3QtYWxsb3dlZC1jdXJzb3I6OnBhcnQodGFzay1pdGVtLWNvbnRhaW5lcikge1xuICBjdXJzb3I6IG5vdC1hbGxvd2VkICFpbXBvcnRhbnQ7XG59XG4uY2hhbm5lbC1pY29uIHtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICB0b3A6IDAuMXJlbTtcbn1cblxuLmF4LWxpc3QtaXRlbTo6cGFydCh0YXNrLWl0ZW0tY29udGFpbmVyKSB7XG4gIG1hcmdpbjogMnB4O1xuXG4gICY6Zm9jdXMge1xuICAgIG91dGxpbmU6IG5vbmU7XG5cbiAgICAmOjphZnRlciB7XG4gICAgICBib3gtc2hhZG93OiBub25lO1xuICAgIH1cbiAgfVxufVxuXG5hZ2VudHgtd2MtdGFzay1saXN0LXRpbWVyIHtcbiAgbWFyZ2luLWJvdHRvbTogOC41cHg7XG59XG5cbkBtZWRpYSAoZm9yY2VkLWNvbG9yczogYWN0aXZlKSB7XG4gIDpob3N0IHtcbiAgICAtLWJvcmRlci1jb2xvcjogQ2FudmFzVGV4dCAhaW1wb3J0YW50O1xuICAgIC0tYmFja2dyb3VuZC1jb2xvcjogQ2FudmFzICFpbXBvcnRhbnQ7XG4gIH1cbn1cbiJdLCJzb3VyY2VSb290IjoiIn0= */`);
    

/***/ }),

/***/ "./src/components/TaskList/comp/TaskListItem.ts":
/*!******************************************************!*\
  !*** ./src/components/TaskList/comp/TaskListItem.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TaskListItem: () => (/* binding */ TaskListItem)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _TaskListItem_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./TaskListItem.scss */ "./src/components/TaskList/comp/TaskListItem.scss");
/* harmony import */ var _TaskTimer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./TaskTimer */ "./src/components/TaskList/comp/TaskTimer.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};










let TaskListItem = class TaskListItem extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_4__.LitElement) {
    constructor() {
        super(...arguments);
        this.selected = false;
        this.unreadMessage = {};
        this.isInteractionModelOpen = false;
        this.isDarkMode = false;
        this.isProgressiveCampaignEnabled = false;
        this.isProgressiveCampaign1NEnabled = false;
        this.isPreviewCampaignEnabled = false;
        this.monitoringOwnerName = "";
        this.timerAriaLabel = "";
        this.isRestyle = false;
    }
    static get styles() {
        return _TaskListItem_scss__WEBPACK_IMPORTED_MODULE_8__["default"];
    }
    static get meetingAlertCss() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.css) `
      :host .md-alert.md-alert--meeting {
        background-color: transparent;
        box-shadow: none;
        margin: 0;
        width: 100%;
        border-radius: 0;
        border: none;
      }
      :host .md-alert.md-alert--meeting.ax-list-item-content .md-alert__content--wide {
        width: auto;
      }
    `;
    }
    isProgressive1NCampaignCall(outboundType) {
        return ((outboundType === _constants__WEBPACK_IMPORTED_MODULE_0__.OUTBOUND_TYPE.CAMPAIGN_OUTDIAL_CUSTOMER ||
            outboundType === _constants__WEBPACK_IMPORTED_MODULE_0__.OUTBOUND_TYPE.OUTDIAL_RESERVATION ||
            outboundType === _constants__WEBPACK_IMPORTED_MODULE_0__.OUTBOUND_TYPE.CAMPAIGN_PREDICTIVE_OUTDIAL_CUSTOMER ||
            outboundType === _constants__WEBPACK_IMPORTED_MODULE_0__.OUTBOUND_TYPE.CAMPAIGN) &&
            this.isProgressiveCampaign1NEnabled);
    }
    isCampaignOutBoundTypes(outboundType) {
        return ((outboundType === _constants__WEBPACK_IMPORTED_MODULE_0__.OUTBOUND_TYPE.PROGRESSIVE_CAMPAIGN && this.isProgressiveCampaignEnabled) ||
            this.isProgressive1NCampaignCall(outboundType));
    }
    getChannelType() {
        switch (this.task.mediaType) {
            case _constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.SOCIAL:
                return this.task.mediaChannel;
            case _constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.VOICE: {
                if ((this.task.outboundType === "OUTDIAL_RESERVATION" ||
                    this.task.outboundType === "STANDARD_PREVIEW_CAMPAIGN" ||
                    this.task.outboundType === "DIRECT_PREVIEW_CAMPAIGN") &&
                    this.isPreviewCampaignEnabled) {
                    return _constants__WEBPACK_IMPORTED_MODULE_0__.TASKLIST_ITEMSTATUS.PREVIEW_CAMPAIGN_ICON;
                }
                else if (this.task.outboundType === _constants__WEBPACK_IMPORTED_MODULE_0__.OUTBOUND_TYPE.CALLBACK ||
                    this.task.outboundType === _constants__WEBPACK_IMPORTED_MODULE_0__.OUTBOUND_TYPE.COURTESY_CALLBACK) {
                    return _constants__WEBPACK_IMPORTED_MODULE_0__.TASKLIST_ITEMSTATUS.CALLBACK_ICON;
                }
                else if (this.isCampaignOutBoundTypes(this.task.outboundType)) {
                    return _constants__WEBPACK_IMPORTED_MODULE_0__.TASKLIST_ITEMSTATUS.CAMPAIGN_ICON;
                }
                else if (this.task.contactDirection === _constants__WEBPACK_IMPORTED_MODULE_0__.CONTACT_DIRECTION.OUTBOUND) {
                    return _constants__WEBPACK_IMPORTED_MODULE_0__.TASKLIST_ITEMSTATUS.OUTBOUND_ICON;
                }
                else {
                    return this.task.mediaType;
                }
            }
            default:
                return this.task.mediaType;
        }
    }
    getStatus() {
        if (this.task.isConferencing) {
            return _constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE;
        }
        else if (this.task.state === _constants__WEBPACK_IMPORTED_MODULE_0__.CONSULTING) {
            return _constants__WEBPACK_IMPORTED_MODULE_0__.CONSULTING;
        }
        else if (this.task.isHold) {
            return _constants__WEBPACK_IMPORTED_MODULE_0__.Play;
        }
        else if (this.task.outboundType === _constants__WEBPACK_IMPORTED_MODULE_0__.OUTBOUND_TYPE.COURTESY_CALLBACK) {
            return "";
        }
        else {
            return "";
        }
    }
    getMediaTypeForMdTaskItem() {
        var _a;
        const mediaType = this.getChannelType();
        if ((0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.isIconSrc)(this.task.mediaType, this.task.mediaChannel, this.task.contactDirection, (_a = this.task.outboundType) !== null && _a !== void 0 ? _a : "")) {
            return _constants__WEBPACK_IMPORTED_MODULE_0__.ICON_SRC;
        }
        return mediaType;
    }
    getTaskTitle() {
        var _a;
        const mediaType = this.task.mediaType;
        if (mediaType === "telephony") {
            return this.task.contactDirection === "INBOUND" ? this.task.displayAni : this.task.dnis;
        }
        else if ((0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.isDigitalOutboundCase)(this.task.mediaChannel, this.task.contactDirection, (_a = this.task.outboundType) !== null && _a !== void 0 ? _a : "")) {
            return this.task.dnis;
        }
        else if (mediaType === "social") {
            return this.task.customerName ? this.task.customerName : this.task.appUser;
        }
        else if (mediaType === _constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.MIDCALL_MONITORING) {
            return this.monitoringOwnerName || this.task.ownerName;
        }
        return this.task.customerName;
    }
    getTitleForAriaLabel() {
        const phoneNumberRegex = /^[0-9+-]+$/;
        const title = this.getTaskTitle() || "";
        if (phoneNumberRegex.test(title)) {
            return (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.makeTelephonyReadable)(title);
        }
        return this.getTaskTitle();
    }
    getTaskAriaLabel() {
        return `${this.getChannelType()}, ${this.getTitleForAriaLabel()}, ${this.task.virtualTeamName}, ${this.unreadMessage.unreadMessageCount
            ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:taskBar.newMessages", "{{count}} new messages", { count: this.unreadMessage.unreadMessageCount })
            : ""}, ${this.unreadMessage.lastUnreadMessage ? this.unreadMessage.lastUnreadMessage : ""} ${this.timerAriaLabel !== "" ? `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:outdial.outboundTaskTime")} ${this.timerAriaLabel}` : ""}`;
    }
    getAniTeamName() {
        var _a;
        if (this.task.mediaType === _constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.MIDCALL_MONITORING) {
            return this.task.displayAni;
        }
        if ((0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.isDigitalOutboundCase)(this.task.mediaChannel, this.task.contactDirection, (_a = this.task.outboundType) !== null && _a !== void 0 ? _a : "")) {
            return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(_constants__WEBPACK_IMPORTED_MODULE_0__.DIGITAL_OUTBOUND);
        }
        return this.task.virtualTeamName;
    }
    render() {
        var _a;
        const listItemClassInfo = {
            "ax-activity-item-selected": this.selected,
            "not-allowed-cursor": this.isInteractionModelOpen && !this.selected
        };
        return this.task
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
          <md-task-item
            class="ax-list-item ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_6__.classMap)(listItemClassInfo)}"
            tabindex="-1"
            mediaType="${this.getMediaTypeForMdTaskItem()}"
            title="${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_7__.ifDefined)(this.getTaskTitle())}"
            status="${this.getStatus()}"
            accepted
            ?selected="${this.selected}"
            ?is-restyle="${this.isRestyle}"
            lastmessage="${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_7__.ifDefined)(this.unreadMessage.lastUnreadMessage ? this.unreadMessage.lastUnreadMessage : undefined)}"
            quantity="${this.unreadMessage.unreadMessageCount ? this.unreadMessage.unreadMessageCount : 0}"
            customAriaLabel="${this.getTaskAriaLabel()}"
            iconSrc="${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_7__.ifDefined)((0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.getImageSrcTaskList)(this.task.mediaType, this.task.mediaChannel, this.isDarkMode, this.selected, this.task.contactDirection, (_a = this.task.outboundType) !== null && _a !== void 0 ? _a : ""))}"
          >
            <span slot="queue">
              ${this.task.mediaType === _constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.MIDCALL_MONITORING
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) ` <md-icon class="channel-icon" name="handset-active_10"></md-icon> `
                : lit_html__WEBPACK_IMPORTED_MODULE_5__.nothing}
              <span className="queue-name"> ${this.getAniTeamName()} </span>
            </span>
            <agentx-wc-task-list-timer startTimestamp=${this.task.timeStamp}></agentx-wc-task-list-timer>
          </md-task-item>
        `
            : lit_html__WEBPACK_IMPORTED_MODULE_5__.nothing;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Object })
], TaskListItem.prototype, "task", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
], TaskListItem.prototype, "selected", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Object })
], TaskListItem.prototype, "unreadMessage", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
], TaskListItem.prototype, "isInteractionModelOpen", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
], TaskListItem.prototype, "isDarkMode", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
], TaskListItem.prototype, "isProgressiveCampaignEnabled", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
], TaskListItem.prototype, "isProgressiveCampaign1NEnabled", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
], TaskListItem.prototype, "isPreviewCampaignEnabled", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
], TaskListItem.prototype, "monitoringOwnerName", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
], TaskListItem.prototype, "timerAriaLabel", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean, attribute: "is-restyle" })
], TaskListItem.prototype, "isRestyle", void 0);
TaskListItem = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.customElement)("agentx-wc-task-list-item")
], TaskListItem);



/***/ }),

/***/ "./src/components/TaskList/comp/TaskTimer.ts":
/*!***************************************************!*\
  !*** ./src/components/TaskList/comp/TaskTimer.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TaskTimer: () => (/* binding */ TaskTimer)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_1__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


const formatDuration = (diff) => {
    if (diff.shiftTo("hours", "minute").get("hours") < 1) {
        return diff.toFormat("mm:ss");
    }
    return diff.toFormat("hh:mm:ss");
};
let TaskTimer = class TaskTimer extends lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement {
    constructor() {
        super(...arguments);
        this.startTimestamp = 0;
    }
    connectedCallback() {
        super.connectedCallback();
        this.intervalId = window.setInterval(() => this.requestUpdate(), 100);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        clearInterval(this.intervalId);
    }
    render() {
        const start = luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.fromMillis(this.startTimestamp);
        const now = luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.utc();
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) ` <div role="timer" class="ax-activity-timer">${formatDuration(now.diff(start))}</div> `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Number })
], TaskTimer.prototype, "startTimestamp", void 0);
TaskTimer = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("agentx-wc-task-list-timer")
], TaskTimer);



/***/ }),

/***/ "./src/components/TasksTab/TasksTabList/TabPanels/BaseTasksTabListPanel.ts":
/*!*********************************************************************************!*\
  !*** ./src/components/TasksTab/TasksTabList/TabPanels/BaseTasksTabListPanel.ts ***!
  \*********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   BaseTasksListTabPanel: () => (/* binding */ BaseTasksListTabPanel)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_Common_WcGrid_WcGridConfig__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @/components/Common/WcGrid/WcGridConfig */ "./src/components/Common/WcGrid/WcGridConfig.ts");
/* harmony import */ var _components_Common_WcGrid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @/components/Common/WcGrid */ "./src/components/Common/WcGrid/index.ts");
/* harmony import */ var _TasksTab_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../TasksTab.utils */ "./src/components/TasksTab/TasksTabList/TasksTab.utils.ts");
/* harmony import */ var _CellRenderComponents_ClosedTaskListItemCellRenderer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./CellRenderComponents/ClosedTaskListItemCellRenderer */ "./src/components/TasksTab/TasksTabList/TabPanels/CellRenderComponents/ClosedTaskListItemCellRenderer.ts");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./config */ "./src/components/TasksTab/TasksTabList/TabPanels/config.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};










class BaseTasksListTabPanel extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_2__.MobxLitElement) {
    constructor() {
        super(...arguments);
        this.tasksType = undefined;
        this.tasksStore = undefined;
        this.isEmptyStateVisible = false;
    }
    get taskCount() {
        if (!this.tasksStore) {
            return 0;
        }
        if (!this.tasksType) {
            return 0;
        }
        return this.tasksStore.getTasksByType(this.tasksType).size;
    }
    connectedCallback() {
        super.connectedCallback();
        this.countLabelText = (0,_TasksTab_utils__WEBPACK_IMPORTED_MODULE_7__.getToolbarCountLabel)(this.taskCount, this.tasksType);
        this.setupReactionForTab();
    }
    disconnectedCallback() {
        if (this.connectedCallbackDisposer) {
            this.connectedCallbackDisposer();
            this.connectedCallbackDisposer = undefined;
        }
        if (this.selectedTabDisposer) {
            this.selectedTabDisposer();
            this.selectedTabDisposer = undefined;
        }
        if (this.collectionDisposer) {
            this.collectionDisposer();
            this.collectionDisposer = undefined;
        }
        super.disconnectedCallback();
    }
    setupReactionForTab() {
        /* subclass to override */
    }
    get cellRendererComponentName() {
        /* subclass to override if they want a different cell renderer */
        return "agentx-wc-closed-task-listitem";
    }
    fetchRowData() {
        return Promise.resolve([]);
    }
    setupAutoRun(tasksMap) {
        if (!tasksMap) {
            return;
        }
        this.isEmptyStateVisible = tasksMap.size <= 0;
        if (this.collectionDisposer) {
            this.collectionDisposer();
            this.collectionDisposer = undefined;
        }
    }
    onTaskListChanged(change) {
        if (change.type === "add") {
            this.onTaskAdded(change.newValue);
        }
        else if (change.type === "delete") {
            this.onTaskRemoved(change.oldValue);
        }
        else if (change.type === "update") {
            this.onTaskUpdated(change.newValue, change.oldValue);
        }
    }
    onTaskAdded(task) {
        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.debug("Task added:", task);
        this.fetchRowData();
    }
    onTaskRemoved(task) {
        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.debug("Task removed:", task);
        this.fetchRowData();
    }
    onTaskUpdated(newTask, oldTask) {
        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.debug("Task updated:", newTask, oldTask);
        this.fetchRowData();
    }
    getWcGridConfig() {
        return new _components_Common_WcGrid_WcGridConfig__WEBPACK_IMPORTED_MODULE_5__.WcGridConfig({
            tableName: `tasksList_${this.tasksType}`,
            enableCharts: false,
            headerConfig: {
                filterButton: "small",
                countLabelText: this.countLabelText
            }
        }).setListConfig({
            rowClickEnabled: true,
            rowHeight: 80,
            fullWidthRowComponent: this.cellRendererComponentName,
            detailsComponent: ""
        });
    }
    getWcGridColumns() {
        return (0,_config__WEBPACK_IMPORTED_MODULE_9__.getWcColumnDefsByType)(this.tasksType);
    }
    onDisplayedRowCountChanged(e) {
        e.stopPropagation();
        this.countLabelText = (0,_TasksTab_utils__WEBPACK_IMPORTED_MODULE_7__.getToolbarCountLabel)(e.detail.count, this.tasksType);
    }
    renderGridTemplate() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `<wc-grid
      class="tasks-list"
      .isDarkMode=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__.themeManager.isDarkMode}
      .wcGridConfig=${this.getWcGridConfig()}
      .wcColumnDefs=${this.getWcGridColumns()}
      @displayed-row-count-changed=${this.onDisplayedRowCountChanged}
      .isListView=${true}
    ></wc-grid>`;
    }
    renderErrorTemplate() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `<div class="error-message">No task type set</div>`;
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `${this.tasksType ? this.renderGridTemplate() : this.renderErrorTemplate()}`;
    }
}
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String, attribute: "tasks-type", reflect: true })
], BaseTasksListTabPanel.prototype, "tasksType", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Object })
], BaseTasksListTabPanel.prototype, "tasksStore", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
], BaseTasksListTabPanel.prototype, "isEmptyStateVisible", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.query)("wc-grid")
], BaseTasksListTabPanel.prototype, "wcGrid", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
], BaseTasksListTabPanel.prototype, "countLabelText", void 0);


/***/ }),

/***/ "./src/components/TasksTab/TasksTabList/TabPanels/CellRenderComponents/BaseTaskListItemCellRenderer.ts":
/*!*************************************************************************************************************!*\
  !*** ./src/components/TasksTab/TasksTabList/TabPanels/CellRenderComponents/BaseTaskListItemCellRenderer.ts ***!
  \*************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   BaseTaskListItemCellRendererComponent: () => (/* binding */ BaseTaskListItemCellRendererComponent)
/* harmony export */ });
/* harmony import */ var _components_Common_CellRenderers_components_TableDurationElement__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/CellRenderers/components/TableDurationElement */ "./src/components/Common/CellRenderers/components/TableDurationElement.ts");
/* harmony import */ var _components_Common_CellRenderers_constants_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/components/Common/CellRenderers/constants/types */ "./src/components/Common/CellRenderers/constants/types.ts");
/* harmony import */ var _components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/components/Common/CellRenderers/Utils */ "./src/components/Common/CellRenderers/Utils.ts");
/* harmony import */ var _components_Common_WcGrid_RowDataLitElementBase__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/components/Common/WcGrid/RowDataLitElementBase */ "./src/components/Common/WcGrid/RowDataLitElementBase.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _TaskListItem_styles_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./TaskListItem.styles.scss */ "./src/components/TasksTab/TasksTabList/TabPanels/CellRenderComponents/TaskListItem.styles.scss");







class BaseTaskListItemCellRendererComponent extends _components_Common_WcGrid_RowDataLitElementBase__WEBPACK_IMPORTED_MODULE_3__.RowDataLitElementBase {
    static get styles() {
        return [_TaskListItem_styles_scss__WEBPACK_IMPORTED_MODULE_6__["default"]];
    }
    get channelAvatarType() {
        const type = this.data["channelType"];
        const channelSubType = this.data["channelSubType"];
        return type === _components_Common_CellRenderers_constants_types__WEBPACK_IMPORTED_MODULE_1__.ChannelTypes.Social && channelSubType
            ? (0,_components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_2__.getChannelAvatarType)(channelSubType)
            : (0,_components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_2__.getChannelAvatarType)(type);
    }
    get taskTitle() {
        return this.data["taskName"];
    }
    get queueName() {
        return this.data["queueName"];
    }
    get handleTime() {
        return this.data["handleTime"];
    }
    get isSelected() {
        return this.data["isSelected"];
    }
    get handleTimeLabel() {
        return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_4__.t)("app:tasks.handleTime");
    }
    get avatarTemplate() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `<md-avatar
      size="32"
      type="${this.channelAvatarType}"
      state=${this.isSelected ? "active" : "rest"}
      avatar-style="default"
    ></md-avatar>`;
    }
}


/***/ }),

/***/ "./src/components/TasksTab/TasksTabList/TabPanels/CellRenderComponents/ClosedTaskListItemCellRenderer.ts":
/*!***************************************************************************************************************!*\
  !*** ./src/components/TasksTab/TasksTabList/TabPanels/CellRenderComponents/ClosedTaskListItemCellRenderer.ts ***!
  \***************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ClosedTaskListItemCellRendererComponent: () => (/* binding */ ClosedTaskListItemCellRendererComponent)
/* harmony export */ });
/* harmony import */ var _components_Common_CellRenderers_components_TableDurationElement__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/CellRenderers/components/TableDurationElement */ "./src/components/Common/CellRenderers/components/TableDurationElement.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _BaseTaskListItemCellRenderer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./BaseTaskListItemCellRenderer */ "./src/components/TasksTab/TasksTabList/TabPanels/CellRenderComponents/BaseTaskListItemCellRenderer.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






let ClosedTaskListItemCellRendererComponent = class ClosedTaskListItemCellRendererComponent extends _BaseTaskListItemCellRenderer__WEBPACK_IMPORTED_MODULE_5__.BaseTaskListItemCellRendererComponent {
    get wrapUpCode() {
        return this.data["wrapUpCode"];
    }
    get wrapUpCodeLabel() {
        return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tasks.wrapUpCode");
    }
    get titleTemplate() {
        const titleClassMap = {
            title: true,
            selected: this.isSelected
        };
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<div class="${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__.classMap)(titleClassMap)}">
      <span>${this.taskTitle}</span>
    </div>`;
    }
    get secondRowTemplate() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` <div class="row">
      <span class="value">${this.queueName}</span>
      ${this.handleTime !== undefined
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` <div class="bullet"></div>
            <span class="label">${this.handleTimeLabel}</span>
            <agentx-wc-table-duration duration=${this.handleTime} hideTimerIcon></agentx-wc-table-duration>`
            : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
    </div>`;
    }
    get thirdRowTemplate() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
      <div class="row">
        <span class="label">${this.wrapUpCodeLabel}</span>
        <span class="value">${this.wrapUpCode}</span>
      </div>
    `;
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
      <li class="container">
        <div class="avatar-container">${this.avatarTemplate}</div>
        <div class="text-container">${this.titleTemplate} ${this.secondRowTemplate} ${this.thirdRowTemplate}</div>
      </li>
    `;
    }
};
ClosedTaskListItemCellRendererComponent = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-closed-task-listitem")
], ClosedTaskListItemCellRendererComponent);



/***/ }),

/***/ "./src/components/TasksTab/TasksTabList/TabPanels/CellRenderComponents/QueuedTaskListItemCellRenderer.ts":
/*!***************************************************************************************************************!*\
  !*** ./src/components/TasksTab/TasksTabList/TabPanels/CellRenderComponents/QueuedTaskListItemCellRenderer.ts ***!
  \***************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QueuedTaskListItemCellRendererComponent: () => (/* binding */ QueuedTaskListItemCellRendererComponent)
/* harmony export */ });
/* harmony import */ var _components_Common_CellRenderers_components_TableDurationElement__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/CellRenderers/components/TableDurationElement */ "./src/components/Common/CellRenderers/components/TableDurationElement.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _BaseTaskListItemCellRenderer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./BaseTaskListItemCellRenderer */ "./src/components/TasksTab/TasksTabList/TabPanels/CellRenderComponents/BaseTaskListItemCellRenderer.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






let QueuedTaskListItemCellRendererComponent = class QueuedTaskListItemCellRendererComponent extends _BaseTaskListItemCellRenderer__WEBPACK_IMPORTED_MODULE_5__.BaseTaskListItemCellRendererComponent {
    get subject() {
        return this.data["subject"];
    }
    get subjectLabel() {
        return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tasks.subject");
    }
    get titleTemplate() {
        const titleClassMap = {
            title: true,
            selected: this.isSelected
        };
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<div class="${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__.classMap)(titleClassMap)}">
      <span>${this.taskTitle}</span>
    </div>`;
    }
    get secondRowTemplate() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` <div class="row">
      <span class="value">${this.queueName}</span>
      ${this.handleTime !== undefined
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` <div class="bullet"></div>
            <span class="label">${this.handleTimeLabel}</span>
            <agentx-wc-table-duration duration=${this.handleTime} hideTimerIcon></agentx-wc-table-duration>`
            : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
    </div>`;
    }
    get thirdRowTemplate() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
      <div class="row">
        <span class="label">${this.subjectLabel}</span>
        <span class="value">${this.subject}</span>
      </div>
    `;
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
      <li class="container">
        <div class="avatar-container">${this.avatarTemplate}</div>
        <div class="text-container">${this.titleTemplate} ${this.secondRowTemplate} ${this.thirdRowTemplate}</div>
      </li>
    `;
    }
};
QueuedTaskListItemCellRendererComponent = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-queued-task-listitem")
], QueuedTaskListItemCellRendererComponent);



/***/ }),

/***/ "./src/components/TasksTab/TasksTabList/TabPanels/CellRenderComponents/TaskListItem.styles.scss":
/*!******************************************************************************************************!*\
  !*** ./src/components/TasksTab/TasksTabList/TabPanels/CellRenderComponents/TaskListItem.styles.scss ***!
  \******************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  font-family: var(--font-family, var(--brand-font-regular));
  width: 100%;
}

.container {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  height: 100%;
  width: 100%;
  min-width: 60px;
  padding: 8px 12px;
}

.avatar-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 100%;
  margin-right: 12px;
  flex-shrink: 0;
}

.text-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-width: 0px;
}
.text-container .title {
  font-size: var(--font-size-large, 16px);
  color: var(--md-primary-text-color);
  line-height: 24px;
  font-weight: 500;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  max-width: 90%;
}
.text-container .title.selected {
  font-family: var(--brand-font-bold, "CiscoSansTT Bold");
  font-weight: 700;
}
.text-container .row {
  font-size: 14px;
  font-weight: 400;
  align-items: center;
  display: flex;
  color: var(--md-secondary-text-color);
  line-height: 20px;
  gap: 5px;
}
.text-container .value {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 48px;
}
.text-container .bullet {
  height: 0.25rem;
  border-radius: 50%;
  display: block;
  aspect-ratio: 1;
  background-color: var(--md-secondary-seperator-color);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/TasksTab/TasksTabList/TabPanels/ClosedTaskListPanel.ts":
/*!*******************************************************************************!*\
  !*** ./src/components/TasksTab/TasksTabList/TabPanels/ClosedTaskListPanel.ts ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ClosedTasksListTabPanel: () => (/* binding */ ClosedTasksListTabPanel)
/* harmony export */ });
/* harmony import */ var _component_stores_TasksStore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @component-stores/TasksStore */ "../agentx-component-stores/src/TasksStore/index.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! mobx */ "mobx");
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(mobx__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _BaseTasksTabListPanel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./BaseTasksTabListPanel */ "./src/components/TasksTab/TasksTabList/TabPanels/BaseTasksTabListPanel.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};




let ClosedTasksListTabPanel = class ClosedTasksListTabPanel extends _BaseTasksTabListPanel__WEBPACK_IMPORTED_MODULE_3__.BaseTasksListTabPanel {
    constructor() {
        super();
        this.tasksType = _component_stores_TasksStore__WEBPACK_IMPORTED_MODULE_0__.TasksType.Closed;
    }
    setupReactionForTab() {
        if (!this.tasksStore) {
            return;
        }
        this.setupAutoRun(this.tasksStore.closedTasks);
        this.selectedTabDisposer = (0,mobx__WEBPACK_IMPORTED_MODULE_2__.reaction)(() => { var _a; return (_a = this.tasksStore) === null || _a === void 0 ? void 0 : _a.closedTasks; }, (newClosedTasks, oldClosedTasks) => {
            var _a;
            if (newClosedTasks !== oldClosedTasks) {
                this.setupAutoRun((_a = this.tasksStore) === null || _a === void 0 ? void 0 : _a.closedTasks);
            }
        });
    }
    fetchRowData() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.tasksStore) {
                return [];
            }
            return Array.from(this.tasksStore.closedTasks.values()).map((task) => {
                return this.mapTaskToRowData(task);
            });
        });
    }
    get cellRendererComponentName() {
        return "agentx-wc-closed-task-listitem";
    }
    /**
     * Maps a Task object to the row data format expected by the grid
     * @param task The Task object from the store
     * @returns A row data object for the grid
     */
    mapTaskToRowData(task) {
        return {
            id: task.id,
            taskName: task.customerName,
            channelType: task.channelType,
            channelSubType: task.subChannelType,
            queueName: "%Queue%",
            handleTime: task.talkDuration,
            wrapUpCode: task.wrapUpCode
        };
    }
};
ClosedTasksListTabPanel = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-closed-tasks-tab-list-panel")
], ClosedTasksListTabPanel);



/***/ }),

/***/ "./src/components/TasksTab/TasksTabList/TabPanels/QueuedTaskListPanel.ts":
/*!*******************************************************************************!*\
  !*** ./src/components/TasksTab/TasksTabList/TabPanels/QueuedTaskListPanel.ts ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QueuedTasksListTabPanel: () => (/* binding */ QueuedTasksListTabPanel)
/* harmony export */ });
/* harmony import */ var _component_stores_TasksStore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @component-stores/TasksStore */ "../agentx-component-stores/src/TasksStore/index.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! mobx */ "mobx");
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(mobx__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _BaseTasksTabListPanel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./BaseTasksTabListPanel */ "./src/components/TasksTab/TasksTabList/TabPanels/BaseTasksTabListPanel.ts");
/* harmony import */ var _CellRenderComponents_QueuedTaskListItemCellRenderer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./CellRenderComponents/QueuedTaskListItemCellRenderer */ "./src/components/TasksTab/TasksTabList/TabPanels/CellRenderComponents/QueuedTaskListItemCellRenderer.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};





let QueuedTasksListTabPanel = class QueuedTasksListTabPanel extends _BaseTasksTabListPanel__WEBPACK_IMPORTED_MODULE_3__.BaseTasksListTabPanel {
    constructor() {
        super();
        this.tasksType = _component_stores_TasksStore__WEBPACK_IMPORTED_MODULE_0__.TasksType.Queued;
    }
    setupReactionForTab() {
        if (!this.tasksStore) {
            return;
        }
        if (this.tasksStore.queuedTasks.size > 0) {
            this.setupAutoRun(this.tasksStore.queuedTasks);
        }
        this.selectedTabDisposer = (0,mobx__WEBPACK_IMPORTED_MODULE_2__.reaction)(() => { var _a; return (_a = this.tasksStore) === null || _a === void 0 ? void 0 : _a.queuedTasks; }, () => {
            var _a;
            this.setupAutoRun((_a = this.tasksStore) === null || _a === void 0 ? void 0 : _a.queuedTasks);
        });
    }
    fetchRowData() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.tasksStore) {
                return [];
            }
            return Array.from(this.tasksStore.queuedTasks.values()).map((task) => {
                return this.mapTaskToRowData(task);
            });
        });
    }
    get cellRendererComponentName() {
        return "agentx-wc-queued-task-listitem";
    }
    /**
     * Maps a Task object to the row data format expected by the grid
     * @param task The Task object from the store
     * @returns A row data object for the grid
     */
    mapTaskToRowData(task) {
        return {
            id: task.id,
            taskName: task.customerName,
            channelType: task.channelType,
            channelSubType: task.subChannelType,
            queueName: "%Queue%",
            handleTime: task.talkDuration,
            subject: task.subject
        };
    }
};
QueuedTasksListTabPanel = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-queued-tasks-tab-list-panel")
], QueuedTasksListTabPanel);



/***/ }),

/***/ "./src/components/TasksTab/TasksTabList/TabPanels/TasksListPanelWrapper.styles.scss":
/*!******************************************************************************************!*\
  !*** ./src/components/TasksTab/TasksTabList/TabPanels/TasksListPanelWrapper.styles.scss ***!
  \******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.task-list-wrapper-toolbar {
  display: block;
  box-sizing: border-box;
  margin: 8px 0px 12px 0px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL1Rhc2tzVGFiL1Rhc2tzVGFiTGlzdC9UYWJQYW5lbHMvVGFza3NMaXN0UGFuZWxXcmFwcGVyLnN0eWxlcy5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsY0FBQTtFQUNBLHNCQUFBO0VBQ0Esd0JBQUE7QUFDRiIsInNvdXJjZXNDb250ZW50IjpbIi50YXNrLWxpc3Qtd3JhcHBlci10b29sYmFyIHtcbiAgZGlzcGxheTogYmxvY2s7XG4gIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gIG1hcmdpbjogOHB4IDBweCAxMnB4IDBweDtcbn1cbiJdLCJzb3VyY2VSb290IjoiIn0= */`);
    

/***/ }),

/***/ "./src/components/TasksTab/TasksTabList/TabPanels/TasksListPanelWrapper.ts":
/*!*********************************************************************************!*\
  !*** ./src/components/TasksTab/TasksTabList/TabPanels/TasksListPanelWrapper.ts ***!
  \*********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TaskListPanelWrapper: () => (/* binding */ TaskListPanelWrapper)
/* harmony export */ });
/* harmony import */ var _components_Common_TableHeader_TableHeaderWidget__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/TableHeader/TableHeaderWidget */ "./src/components/Common/TableHeader/TableHeaderWidget.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _component_stores_TasksStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @component-stores/TasksStore */ "../agentx-component-stores/src/TasksStore/index.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _TasksTab_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../TasksTab.utils */ "./src/components/TasksTab/TasksTabList/TasksTab.utils.ts");
/* harmony import */ var _TasksListPanelWrapper_styles_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./TasksListPanelWrapper.styles.scss */ "./src/components/TasksTab/TasksTabList/TabPanels/TasksListPanelWrapper.styles.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






let TaskListPanelWrapper = class TaskListPanelWrapper extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
    constructor() {
        super(...arguments);
        this.tasksType = _component_stores_TasksStore__WEBPACK_IMPORTED_MODULE_2__.TasksType.Open;
        this.rowCount = 0;
    }
    static get styles() {
        return _TasksListPanelWrapper_styles_scss__WEBPACK_IMPORTED_MODULE_5__["default"];
    }
    get toolbarTemplate() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `<table-header-widget class="task-list-wrapper-toolbar">
      <span slot="left-group">${(0,_TasksTab_utils__WEBPACK_IMPORTED_MODULE_4__.getToolbarCountLabel)(this.rowCount, this.tasksType)}</span>
    </table-header-widget>`;
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      ${this.toolbarTemplate}
      <div class="task-list-wrapper">
        <slot></slot>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String, attribute: "tasks-type", reflect: true })
], TaskListPanelWrapper.prototype, "tasksType", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Number, attribute: "row-count" })
], TaskListPanelWrapper.prototype, "rowCount", void 0);
TaskListPanelWrapper = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-task-list-panel-wrapper")
], TaskListPanelWrapper);



/***/ }),

/***/ "./src/components/TasksTab/TasksTabList/TabPanels/config.ts":
/*!******************************************************************!*\
  !*** ./src/components/TasksTab/TasksTabList/TabPanels/config.ts ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TasksColumnName: () => (/* binding */ TasksColumnName),
/* harmony export */   getClosedColumns: () => (/* binding */ getClosedColumns),
/* harmony export */   getOpenColumns: () => (/* binding */ getOpenColumns),
/* harmony export */   getQueuedColumns: () => (/* binding */ getQueuedColumns),
/* harmony export */   getWcColumnDefs: () => (/* binding */ getWcColumnDefs),
/* harmony export */   getWcColumnDefsByType: () => (/* binding */ getWcColumnDefsByType)
/* harmony export */ });
/* harmony import */ var _components_Common_WcGrid_WcColumns_ChannelColumn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/WcGrid/WcColumns/ChannelColumn */ "./src/components/Common/WcGrid/WcColumns/ChannelColumn.ts");
/* harmony import */ var _components_Common_WcGrid_WcColumns_DurationColumn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/components/Common/WcGrid/WcColumns/DurationColumn */ "./src/components/Common/WcGrid/WcColumns/DurationColumn.ts");
/* harmony import */ var _components_Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/components/Common/WcGrid/WcColumns/StringColumn */ "./src/components/Common/WcGrid/WcColumns/StringColumn.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _component_stores_TasksStore__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @component-stores/TasksStore */ "../agentx-component-stores/src/TasksStore/index.ts");





var TasksColumnName;
(function (TasksColumnName) {
    TasksColumnName["TaskName"] = "taskName";
    TasksColumnName["QueueName"] = "queueName";
    TasksColumnName["HandleTime"] = "handleTime";
    TasksColumnName["Channel"] = "channelType";
    TasksColumnName["ChannelSubType"] = "channelSubType";
    TasksColumnName["WrapUpCode"] = "wrapUpCode";
    TasksColumnName["Subject"] = "subject";
    TasksColumnName["Message"] = "message";
    TasksColumnName["UnreadCount"] = "unreadCount";
})(TasksColumnName || (TasksColumnName = {}));
function getClosedColumns() {
    const defaultColumns = new Set([
        TasksColumnName.TaskName,
        TasksColumnName.QueueName,
        TasksColumnName.Channel,
        TasksColumnName.HandleTime,
        TasksColumnName.WrapUpCode
    ]);
    return Array.from(defaultColumns);
}
function getOpenColumns() {
    const defaultColumns = new Set([
        TasksColumnName.TaskName,
        TasksColumnName.QueueName,
        TasksColumnName.Channel,
        TasksColumnName.HandleTime,
        TasksColumnName.Subject,
        TasksColumnName.UnreadCount
    ]);
    return Array.from(defaultColumns);
}
function getQueuedColumns() {
    const defaultColumns = new Set([
        TasksColumnName.TaskName,
        TasksColumnName.QueueName,
        TasksColumnName.Channel,
        TasksColumnName.HandleTime,
        TasksColumnName.Subject
    ]);
    return Array.from(defaultColumns);
}
function getAllColumns() {
    return [
        new _components_Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_2__.StringColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__.t)(`app:tasks.columns.${TasksColumnName.TaskName}`), TasksColumnName.TaskName),
        new _components_Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_2__.StringColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__.t)(`app:tasks.columns.${TasksColumnName.QueueName}`), TasksColumnName.QueueName),
        new _components_Common_WcGrid_WcColumns_ChannelColumn__WEBPACK_IMPORTED_MODULE_0__.ChannelColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__.t)(`app:tasks.columns.${TasksColumnName.Channel}`), TasksColumnName.Channel),
        new _components_Common_WcGrid_WcColumns_DurationColumn__WEBPACK_IMPORTED_MODULE_1__.DurationColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__.t)(`app:tasks.columns.${TasksColumnName.HandleTime}`), TasksColumnName.HandleTime),
        new _components_Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_2__.StringColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__.t)(`app:tasks.columns.${TasksColumnName.WrapUpCode}`), TasksColumnName.WrapUpCode),
        new _components_Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_2__.StringColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__.t)(`app:tasks.columns.${TasksColumnName.Subject}`), TasksColumnName.Subject),
        new _components_Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_2__.StringColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__.t)(`app:tasks.columns.${TasksColumnName.UnreadCount}`), TasksColumnName.UnreadCount)
    ];
}
function getWcColumnDefs(columnNames) {
    const retColumns = [];
    const allColumns = getAllColumns();
    columnNames.forEach((columnName) => {
        const column = allColumns.find((col) => col.getFieldName() === columnName);
        if (column) {
            column.setHidden(false);
            retColumns.push(column);
        }
    });
    return retColumns;
}
function getWcColumnDefsByType(type) {
    if (type === _component_stores_TasksStore__WEBPACK_IMPORTED_MODULE_4__.TasksType.Closed) {
        return getWcColumnDefs(getClosedColumns());
    }
    if (type === _component_stores_TasksStore__WEBPACK_IMPORTED_MODULE_4__.TasksType.Open) {
        return getWcColumnDefs(getOpenColumns());
    }
    if (type === _component_stores_TasksStore__WEBPACK_IMPORTED_MODULE_4__.TasksType.Queued) {
        return getWcColumnDefs(getQueuedColumns());
    }
    return [];
}


/***/ }),

/***/ "./src/components/TasksTab/TasksTabList/TasksTab.utils.ts":
/*!****************************************************************!*\
  !*** ./src/components/TasksTab/TasksTabList/TasksTab.utils.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getElementSafe: () => (/* binding */ getElementSafe),
/* harmony export */   getTabName: () => (/* binding */ getTabName),
/* harmony export */   getToolbarCountLabel: () => (/* binding */ getToolbarCountLabel)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _component_stores_TasksStore_tasks_store_interface__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @component-stores/TasksStore/tasks-store-interface */ "../agentx-component-stores/src/TasksStore/tasks-store-interface.ts");


function getToolbarCountLabel(count, type) {
    switch (type) {
        case _component_stores_TasksStore_tasks_store_interface__WEBPACK_IMPORTED_MODULE_1__.TasksType.Open:
            return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tasks:x_open_tasks", "X open tasks", { count });
        case _component_stores_TasksStore_tasks_store_interface__WEBPACK_IMPORTED_MODULE_1__.TasksType.Queued:
            return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tasks:x_queued_tasks", "X queued tasks", { count });
        case _component_stores_TasksStore_tasks_store_interface__WEBPACK_IMPORTED_MODULE_1__.TasksType.Scheduled:
            return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tasks:x_scheduled_tasks", "X scheduled tasks", { count });
        case _component_stores_TasksStore_tasks_store_interface__WEBPACK_IMPORTED_MODULE_1__.TasksType.Closed:
            return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tasks:x_closed_tasks", "X closed tasks", { count });
        default:
            return `Unknown task type: ${type !== null && type !== void 0 ? type : "undefined"}`;
    }
}
function getTabName(type) {
    switch (type) {
        case _component_stores_TasksStore_tasks_store_interface__WEBPACK_IMPORTED_MODULE_1__.TasksType.Open:
            return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tasks:open");
        case _component_stores_TasksStore_tasks_store_interface__WEBPACK_IMPORTED_MODULE_1__.TasksType.Queued:
            return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tasks:queued");
        case _component_stores_TasksStore_tasks_store_interface__WEBPACK_IMPORTED_MODULE_1__.TasksType.Scheduled:
            return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tasks:callback");
        case _component_stores_TasksStore_tasks_store_interface__WEBPACK_IMPORTED_MODULE_1__.TasksType.Closed:
            return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tasks:closed");
        default:
            return `Unknown task type: ${type !== null && type !== void 0 ? type : "undefined"}`;
    }
}
function getElementSafe(elements, index) {
    return index >= 0 && index < elements.length ? elements[index] : undefined;
}


/***/ }),

/***/ "./src/components/TasksTab/TasksTabList/TasksTabList.styles.scss":
/*!***********************************************************************!*\
  !*** ./src/components/TasksTab/TasksTabList/TasksTabList.styles.scss ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  flex-grow: 1;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL1Rhc2tzVGFiL1Rhc2tzVGFiTGlzdC9UYXNrc1RhYkxpc3Quc3R5bGVzLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxZQUFBO0FBQ0YiLCJzb3VyY2VzQ29udGVudCI6WyI6aG9zdCB7XG4gIGZsZXgtZ3JvdzogMTtcbn1cbiJdLCJzb3VyY2VSb290IjoiIn0= */`);
    

/***/ }),

/***/ "./src/components/TasksTab/TasksTabList/TasksTabList.ts":
/*!**************************************************************!*\
  !*** ./src/components/TasksTab/TasksTabList/TasksTabList.ts ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TasksTabList: () => (/* binding */ TasksTabList)
/* harmony export */ });
/* harmony import */ var _components_Common_WcGrid_WcGridTabs_WcGridTabs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/WcGrid/WcGridTabs/WcGridTabs */ "./src/components/Common/WcGrid/WcGridTabs/WcGridTabs.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _component_stores_TasksStore_tasks_store_interface__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @component-stores/TasksStore/tasks-store-interface */ "../agentx-component-stores/src/TasksStore/tasks-store-interface.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _TasksTab_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./TasksTab.utils */ "./src/components/TasksTab/TasksTabList/TasksTab.utils.ts");
/* harmony import */ var _TasksTabList_styles_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./TasksTabList.styles.scss */ "./src/components/TasksTab/TasksTabList/TasksTabList.styles.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








let TasksTabList = class TasksTabList extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__.MobxLitElement) {
    static get styles() {
        return _TasksTabList_styles_scss__WEBPACK_IMPORTED_MODULE_7__["default"];
    }
    get tabTypes() {
        return this.allTabTypes.filter((type) => this.isTabEnabled(type));
    }
    getTabTypeByIndex(index) {
        var _a;
        return (_a = (0,_TasksTab_utils__WEBPACK_IMPORTED_MODULE_6__.getElementSafe)(this.tabTypes, index)) !== null && _a !== void 0 ? _a : _component_stores_TasksStore_tasks_store_interface__WEBPACK_IMPORTED_MODULE_4__.TasksType.Open;
    }
    isTabEnabled(type) {
        switch (type) {
            case _component_stores_TasksStore_tasks_store_interface__WEBPACK_IMPORTED_MODULE_4__.TasksType.Queued:
                return this.isQueuedTasksEnabled;
            case _component_stores_TasksStore_tasks_store_interface__WEBPACK_IMPORTED_MODULE_4__.TasksType.Scheduled:
                return this.isScheduledTasksEnabled;
            default:
                return true;
        }
    }
    getDefaultTabTemplate(type) {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `<div>No content provided for tab of type: ${type}</div>`;
    }
    getTabTemplate(type) {
        switch (type) {
            case _component_stores_TasksStore_tasks_store_interface__WEBPACK_IMPORTED_MODULE_4__.TasksType.Open:
                return this.openTasksTemplate ? this.openTasksTemplate : this.getDefaultTabTemplate(type);
            case _component_stores_TasksStore_tasks_store_interface__WEBPACK_IMPORTED_MODULE_4__.TasksType.Queued:
                return this.queuedTasksTemplate ? this.queuedTasksTemplate : this.getDefaultTabTemplate(type);
            case _component_stores_TasksStore_tasks_store_interface__WEBPACK_IMPORTED_MODULE_4__.TasksType.Scheduled:
                return this.scheduledTasksTemplate ? this.scheduledTasksTemplate : this.getDefaultTabTemplate(type);
            case _component_stores_TasksStore_tasks_store_interface__WEBPACK_IMPORTED_MODULE_4__.TasksType.Closed:
                return this.closedTasksTemplate ? this.closedTasksTemplate : this.getDefaultTabTemplate(type);
            default:
                return this.getDefaultTabTemplate(type);
        }
    }
    getWcTabConfig(type) {
        return {
            type,
            title: (0,_TasksTab_utils__WEBPACK_IMPORTED_MODULE_6__.getTabName)(type),
            tabTemplate: this.getTabTemplate(type)
        };
    }
    getWcTabsConfig() {
        const tabs = this.tabTypes.map((type) => this.getWcTabConfig(type));
        return {
            tabs,
            defaultTab: this.getTabTypeByIndex(0)
        };
    }
    constructor() {
        super();
        this.isQueuedTasksEnabled = false;
        this.isScheduledTasksEnabled = false;
        this.allTabTypes = [_component_stores_TasksStore_tasks_store_interface__WEBPACK_IMPORTED_MODULE_4__.TasksType.Open, _component_stores_TasksStore_tasks_store_interface__WEBPACK_IMPORTED_MODULE_4__.TasksType.Queued, _component_stores_TasksStore_tasks_store_interface__WEBPACK_IMPORTED_MODULE_4__.TasksType.Scheduled, _component_stores_TasksStore_tasks_store_interface__WEBPACK_IMPORTED_MODULE_4__.TasksType.Closed];
        _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("Tasks tab list constructor");
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) ` <wc-grid-tabs .wcGridTabsConfig=${this.getWcTabsConfig()}> </wc-grid-tabs> `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean, attribute: "is-queued-tasks-enabled" })
], TasksTabList.prototype, "isQueuedTasksEnabled", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean, attribute: "is-scheduled-tasks-enabled" })
], TasksTabList.prototype, "isScheduledTasksEnabled", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Object })
], TasksTabList.prototype, "openTasksTemplate", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Object })
], TasksTabList.prototype, "queuedTasksTemplate", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Object })
], TasksTabList.prototype, "scheduledTasksTemplate", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Object })
], TasksTabList.prototype, "closedTasksTemplate", void 0);
TasksTabList = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.customElement)("agentx-wc-tasks-tab-list")
], TasksTabList);



/***/ }),

/***/ "./src/components/TasksTab/index.ts":
/*!******************************************!*\
  !*** ./src/components/TasksTab/index.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ClosedTasksListTabPanel: () => (/* reexport safe */ _TasksTabList_TabPanels_ClosedTaskListPanel__WEBPACK_IMPORTED_MODULE_0__.ClosedTasksListTabPanel),
/* harmony export */   QueuedTasksListTabPanel: () => (/* reexport safe */ _TasksTabList_TabPanels_QueuedTaskListPanel__WEBPACK_IMPORTED_MODULE_1__.QueuedTasksListTabPanel),
/* harmony export */   TaskListPanelWrapper: () => (/* reexport safe */ _TasksTabList_TabPanels_TasksListPanelWrapper__WEBPACK_IMPORTED_MODULE_2__.TaskListPanelWrapper),
/* harmony export */   TasksTabList: () => (/* reexport safe */ _TasksTabList_TasksTabList__WEBPACK_IMPORTED_MODULE_3__.TasksTabList)
/* harmony export */ });
/* harmony import */ var _TasksTabList_TabPanels_ClosedTaskListPanel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TasksTabList/TabPanels/ClosedTaskListPanel */ "./src/components/TasksTab/TasksTabList/TabPanels/ClosedTaskListPanel.ts");
/* harmony import */ var _TasksTabList_TabPanels_QueuedTaskListPanel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./TasksTabList/TabPanels/QueuedTaskListPanel */ "./src/components/TasksTab/TasksTabList/TabPanels/QueuedTaskListPanel.ts");
/* harmony import */ var _TasksTabList_TabPanels_TasksListPanelWrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./TasksTabList/TabPanels/TasksListPanelWrapper */ "./src/components/TasksTab/TasksTabList/TabPanels/TasksListPanelWrapper.ts");
/* harmony import */ var _TasksTabList_TasksTabList__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./TasksTabList/TasksTabList */ "./src/components/TasksTab/TasksTabList/TasksTabList.ts");






/***/ }),

/***/ "./src/components/TeamPerformanceWidget/CellRenderer/ActionRenderer.ts":
/*!*****************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/CellRenderer/ActionRenderer.ts ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AGENT_STATE_CHANGE: () => (/* binding */ AGENT_STATE_CHANGE),
/* harmony export */   REVIEW_AND_MONITOR: () => (/* binding */ REVIEW_AND_MONITOR),
/* harmony export */   SEND_MESSAGE: () => (/* binding */ SEND_MESSAGE),
/* harmony export */   SIGNOUT_AGENT: () => (/* binding */ SIGNOUT_AGENT),
/* harmony export */   SKILL_PROFILE_CHANGE: () => (/* binding */ SKILL_PROFILE_CHANGE),
/* harmony export */   "default": () => (/* binding */ ActionsRenderer)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Utils */ "./src/components/TeamPerformanceWidget/Utils.ts");
/* harmony import */ var _utils_WebexChat_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils/WebexChat.utils */ "./src/components/TeamPerformanceWidget/utils/WebexChat.utils.ts");
/* harmony import */ var _BaseComponent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./BaseComponent */ "./src/components/TeamPerformanceWidget/CellRenderer/BaseComponent.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__);






// Component names
const SEND_MESSAGE = "SEND_MESSAGE";
const AGENT_STATE_CHANGE = "AGENT_STATE_CHANGE";
const SKILL_PROFILE_CHANGE = "SKILL_PROFILE_CHANGE";
const REVIEW_AND_MONITOR = "REVIEW_AND_MONITOR";
const SIGNOUT_AGENT = "SIGNOUT_AGENT";
const ACTION_ELEMENT_DEFAULT_WIDTH = 40; // 40px
const SHOW_TOOLTIP = "data-show-tooltip";
const ARIA_LABEL = "aria-label";
const ARIA_DESCRIPTION = "aria-description";
const TWP_CUSTOM_TOOLTIP = "tpw-custom-tooltip";
const DATA_MESSAGE = "data-message";
class ActionsRenderer extends _BaseComponent__WEBPACK_IMPORTED_MODULE_4__["default"] {
    constructor() {
        super();
        this.actionCellConfigs = {};
        this.paramsData = {};
        this.localization = {};
        this.contextMenuList = [];
        this.selectedModeClassName = () => {
            return this.actionCellConfigs.isDarkMode ? "dark-mode" : "light-mode";
        };
        this.getActionCellValues = () => {
            return Object.assign(Object.assign({}, this.paramsData), { agentId: this.actionCellConfigs.agentId, onActiveCall: this.actionCellConfigs.onActiveCall, contactStatus: this.actionCellConfigs.contactStatus });
        };
        this.getTooltipMessage = () => {
            if (this.actionCellConfigs.voiceChannelCount === 0) {
                return this.localization.notHaveChannels;
            }
            else if (this.actionCellConfigs.isConsultCall) {
                return this.localization.cannotMonitorConsult;
            }
            else if (this.isWrapUp) {
                return this.localization.cannotMonitorWrapUp;
            }
            else if (this.isMainCallInPostCall) {
                return this.localization.cannotMonitorPostCall;
            }
            else if (this.isWrapUpAssistance) {
                return this.localization.cannotMonitorWrapUpAssistance;
            }
            else if (this.actionCellConfigs.isMCMEnabled) {
                return this.localization.reviewAndMonitor;
            }
            else {
                return this.localization.review;
            }
        };
        this.handleOpenReviewAndMonitorModal = () => {
            var _a;
            if (!!this.actionCellConfigs.isReviewAndMonitorEnabled &&
                !this.actionCellConfigs.onActiveCall &&
                ((_a = this.actionCellConfigs) === null || _a === void 0 ? void 0 : _a.handleAIDModal)) {
                this.actionCellConfigs.handleAIDModal(this.actionCellConfigs.agentId);
            }
        };
        this.getWebexToolTip = () => {
            if (this.actionCellConfigs.isWebExSendingMessage) {
                return this.localization.webexChatSendingMessage;
            }
            else if (this.actionCellConfigs.isWebExSendingMessageError) {
                return this.localization.webexChatTPWErrorMessage;
            }
            else {
                return this.localization.webexChatSendMessage;
            }
        };
        this.removeAllChildNodes = (parent) => {
            while (parent.firstChild) {
                parent.removeChild(parent.firstChild);
            }
        };
        this.validateDarkToLightModeTransition = (element) => {
            var _a, _b, _c;
            const firstChild = element === null || element === void 0 ? void 0 : element.firstChild;
            if (firstChild instanceof Element) {
                const response = (_a = firstChild === null || firstChild === void 0 ? void 0 : firstChild.classList) === null || _a === void 0 ? void 0 : _a.contains(this.selectedModeClassName());
                if (!response) {
                    // On true, Update the class name list.
                    (_b = firstChild === null || firstChild === void 0 ? void 0 : firstChild.classList) === null || _b === void 0 ? void 0 : _b.remove("dark-mode", "light-mode"); // Remove the class name
                    (_c = firstChild === null || firstChild === void 0 ? void 0 : firstChild.classList) === null || _c === void 0 ? void 0 : _c.add(this.selectedModeClassName());
                }
                return !response;
            }
            return false;
        };
        this.eGui = document.createElement("div");
        // section-one - Is Used to show the monitor svg image and monitoring status text
        // section-two - Is used to show the chat, kebab, additional icons.
        this.eGui.innerHTML = `<div class="section-one"></div><div class="section-one"></div>`;
        this.eGui.classList.add("ActionCell");
    }
    get isWrapUp() {
        return this.actionCellConfigs.isMPCorPersistEnabled && this.actionCellConfigs.isWrapUp;
    }
    get isWrapUpAssistance() {
        return (this.actionCellConfigs.isMPCorPersistEnabled &&
            !this.actionCellConfigs.isPostCallEnabled &&
            this.actionCellConfigs.isWrapUpAssistance);
    }
    get isMainCallInPostCall() {
        return (this.actionCellConfigs.isMPCorPersistEnabled &&
            this.actionCellConfigs.isPostCallEnabled &&
            this.actionCellConfigs.isMainCallInPostCall);
    }
    getIsMonitoring() {
        return (this.actionCellConfigs.monitoredBy &&
            this.actionCellConfigs.monitoredBy !== "" &&
            this.actionCellConfigs.monitoredBy !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE);
    }
    getReviewMonitorIcon() {
        const iconElement = document.createElement("md-icon");
        iconElement.classList.add("aid-icon", this.selectedModeClassName());
        iconElement.iconSet = "momentumDesign";
        iconElement.name = "monitoring-regular";
        iconElement.size = "20";
        iconElement.ariaLabel = this.actionCellConfigs.isMCMEnabled
            ? this.localization.reviewAndMonitor
            : this.localization.review;
        return iconElement;
    }
    isReviewMonitorDisabled() {
        /*monitoredBy here is ensuring that the monitoring is successfully started,
         isSupervisorMonitoring can only ensure If same supervisor has started monitoring or not(not the successful landing
        isSuprvisorMonitoring is required to disable start monitoring button in AID for the phase of clicking start monitoring to successful monitoring  on supervisor desktop*/
        return ((this.actionCellConfigs.isSupervisorMonitoring && this.actionCellConfigs.monitoredBy) ||
            !this.actionCellConfigs.isReviewAndMonitorEnabled ||
            this.actionCellConfigs.onActiveCall ||
            this.actionCellConfigs.isConsultCall ||
            this.actionCellConfigs.voiceChannelCount === 0);
    }
    renderReviewAndMonitorIcon() {
        const monitorDisabled = this.isReviewMonitorDisabled();
        const toolTipMessage = this.getTooltipMessage();
        const customClassNames = ["review-monitor-icon", `review-monitor-${this.actionCellConfigs.agentId}`];
        const button = this.createButtonElement(customClassNames, monitorDisabled);
        if (this.actionCellConfigs.voiceChannelCount === 0 || this.actionCellConfigs.isConsultCall) {
            button.setAttribute(SHOW_TOOLTIP, "true");
        }
        // Append the Review Monitor SVG Icon.
        const childElement = this.getReviewMonitorIcon();
        button.appendChild(childElement);
        button.onclick = () => {
            this.handleOpenReviewAndMonitorModal();
        };
        button.setAttribute(ARIA_LABEL, `${toolTipMessage}`);
        button.classList.add(TWP_CUSTOM_TOOLTIP);
        button.setAttribute(DATA_MESSAGE, toolTipMessage);
        return button;
    }
    stateChangeError() {
        return this.actionCellConfigs.agentStateChangeError;
    }
    getStateChangeTooltip() {
        if (this.actionCellConfigs.agentStateChanging) {
            return this.localization.stateChange.progress;
        }
        else if (this.actionCellConfigs.agentStateChangeError) {
            return this.localization.stateChange.failed;
        }
        else {
            return this.localization.stateChange.default;
        }
    }
    isAgentStateChangeDisabled() {
        return this.actionCellConfigs.agentId === this.actionCellConfigs.supervisorId;
    }
    renderStateChangeIcon() {
        const customClassNames = ["state-change-action", `state-change-${this.actionCellConfigs.agentId}`];
        const stateChangeDisabled = this.isAgentStateChangeDisabled();
        const button = this.createButtonElement(customClassNames, stateChangeDisabled);
        if (this.actionCellConfigs.agentStateChanging) {
            const iconElement = this.createIconElement(["md-spinner", "md-spinner--14"]);
            button.appendChild(iconElement);
        }
        else {
            const iconElement = this.createIconElement(["icon-recurring_14"]);
            button.appendChild(iconElement);
            if (this.stateChangeError()) {
                const errorElement = document.createElement("div");
                errorElement.classList.add("error-icon");
                const errorIcon = this.createIconElement(["icon-priority-active-two_12"]);
                errorElement.appendChild(errorIcon);
                button.appendChild(errorElement);
            }
        }
        button.onclick = (e) => {
            e.stopPropagation();
            if (!stateChangeDisabled) {
                const actionCellValues = this.getActionCellValues();
                this.actionCellConfigs.handleStateChangeSelector(actionCellValues, button);
            }
        };
        const toolTipMessage = this.getStateChangeTooltip();
        button.setAttribute(ARIA_LABEL, `${toolTipMessage}`);
        button.classList.add(TWP_CUSTOM_TOOLTIP);
        button.setAttribute(DATA_MESSAGE, toolTipMessage);
        return button;
    }
    getMonitorLabel() {
        const paraElement = document.createElement("p");
        paraElement.classList.add("monitoring-label");
        paraElement.setAttribute(ARIA_LABEL, "");
        paraElement.setAttribute("role", "status");
        let toolTipMessage = "";
        if (this.actionCellConfigs.isSupervisorMonitoring) {
            if (this.actionCellConfigs.isBarged) {
                paraElement.innerText = this.localization.bargedIn;
                paraElement.setAttribute(ARIA_LABEL, `${this.localization.bargedIn} ${this.localization.alreadyBargedIn}`);
                toolTipMessage = this.localization.alreadyBargedIn;
            }
            else {
                paraElement.innerText = this.localization.monitoring;
                paraElement.setAttribute(ARIA_LABEL, `${this.localization.monitoring} ${this.localization.ownMonitoring}`);
                toolTipMessage = this.localization.ownMonitoring;
            }
        }
        else if (this.actionCellConfigs.isBarged) {
            paraElement.innerText = this.localization.bargedIn;
            paraElement.setAttribute(ARIA_LABEL, `${this.localization.bargedIn} ${this.actionCellConfigs.monitoredBy} ${this.localization.supervisorBargedIn}`);
            toolTipMessage = `${this.actionCellConfigs.monitoredBy} ${this.localization.supervisorBargedIn}`;
        }
        else {
            paraElement.innerText = this.localization.beingMonitored;
            paraElement.setAttribute(ARIA_LABEL, `${this.localization.beingMonitored} ${this.actionCellConfigs.monitoredBy} ${this.localization.supervisorMonitoring}`);
            toolTipMessage = `${this.actionCellConfigs.monitoredBy} ${this.localization.supervisorMonitoring}`;
        }
        const toolTipWrapper = this.toolTipElement(toolTipMessage);
        toolTipWrapper.appendChild(paraElement);
        return toolTipWrapper;
    }
    callMonitoringLabel() {
        const divElement = this.getMonitorLabel();
        divElement.classList.add("monitoring-container");
        divElement.style.width = `${this.actionCellConfigs.actionCellWidth}px`;
        return divElement;
    }
    renderKebabIcon() {
        var _a, _b;
        const customClassNames = ["kebab-action", `more-action-${this.actionCellConfigs.agentId}`];
        const button = this.createButtonElement(customClassNames);
        button.setAttribute("aria-haspopup", "true");
        button.title = (_a = this.localization) === null || _a === void 0 ? void 0 : _a.moreAction;
        button.ariaLabel = (_b = this.localization) === null || _b === void 0 ? void 0 : _b.moreAction;
        const iconElement = this.createIconElement(["icon-more-android_16", "kebab-menu-icon"]);
        button.appendChild(iconElement);
        button.onclick = (e) => {
            e.stopPropagation();
            const actionCellValues = this.getActionCellValues();
            this.actionCellConfigs.handleContextMenu(actionCellValues, button, this.contextMenuList);
        };
        const element = document.createElement("div");
        element.classList.add("more-actions");
        element.appendChild(button);
        return element;
    }
    renderKebabWrapper() {
        const element = document.createElement("div");
        element.classList.add("more-actions");
        const button = this.renderKebabIcon();
        element.appendChild(button);
        return element;
    }
    isWebexChatDisabled() {
        if (this.actionCellConfigs.isSupervisorySendMessageEnabled) {
            return (this.actionCellConfigs.agentId === this.actionCellConfigs.supervisorId ||
                this.actionCellConfigs.agentEmail === "");
        }
        // Disable webex chat
        return true;
    }
    webExMessageError() {
        return (this.actionCellConfigs.isWebExSendingMessageError ||
            (0,_utils_WebexChat_utils__WEBPACK_IMPORTED_MODULE_3__.getPersistedError)(this.actionCellConfigs.agentName, this.actionCellConfigs.agentEmail));
    }
    sectionTwoActionComponents() {
        // This method will return the list of components required
        const actionComponents = [];
        if (this.actionCellConfigs.webexEnabled) {
            // Webex Component is enabled.
            actionComponents.push(SEND_MESSAGE);
        }
        if (this.actionCellConfigs.isStateChangeBySupervisorEnabled) {
            // Agent state change Component is enabled.
            actionComponents.push(AGENT_STATE_CHANGE);
        }
        if (_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.SERVICE.featureflag.isFeatureFlagEnabled(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.FEATURE_FLAGS.DESKTOP_SKILL_PROFILE)) {
            actionComponents.push(SKILL_PROFILE_CHANGE);
        }
        if (this.actionCellConfigs.isSignoutBySupervisorEnabled) {
            actionComponents.push(SIGNOUT_AGENT);
        }
        return actionComponents;
    }
    renderActionElement(componentName) {
        switch (componentName) {
            case SEND_MESSAGE:
                return this.renderChatIcon();
            case AGENT_STATE_CHANGE:
                return this.renderStateChangeIcon();
            case SIGNOUT_AGENT:
                return this.renderSignoutIcon();
            default:
                return null;
        }
    }
    showKebabMenu(sectionTwoActionComponents) {
        var _a, _b;
        // should only ever be reviewAndMonitor button but rather do this than have a magic number here
        const section1ChildCount = (_b = (_a = this.eGui.querySelector(".section-one")) === null || _a === void 0 ? void 0 : _a.childElementCount) !== null && _b !== void 0 ? _b : 0;
        const actionButtonCount = section1ChildCount + sectionTwoActionComponents.length;
        return ACTION_ELEMENT_DEFAULT_WIDTH * actionButtonCount >= this.actionCellConfigs.actionCellWidth;
    }
    getActionCellElements(sectionTwoActionComponents) {
        const elements = []; // Stores the array of action cell components
        let contextMenuList = [];
        const showKebabMenu = this.showKebabMenu(sectionTwoActionComponents);
        if (showKebabMenu) {
            // subtract ACTION_ELEMENT_DEFAULT_WIDTH to cater for the reviwAndMonitor Icon.
            // there seems to be a loop here where the width relies on the its own width and count of icons
            // sometimes things arent rendered yet so sizes are 0
            // ideally we would pull the sections widths from the sections directly, but there is possible race conditions.
            // this could be refactored not need the width to calculate the possible elements at all
            // `const noOfPossibleElements = this.eGui.querySelector(".section-one")?.childElementCount ?? 0;`
            const sectionTwoWidth = this.actionCellConfigs.actionCellWidth - ACTION_ELEMENT_DEFAULT_WIDTH;
            const noOfPossibleElements = Math.round(sectionTwoWidth / ACTION_ELEMENT_DEFAULT_WIDTH);
            if (noOfPossibleElements > 1) {
                const renderComponents = [];
                // Append the list of possible component to render this width.
                for (let i = 1; i < noOfPossibleElements; i++) {
                    const index = i - 1;
                    const componentName = sectionTwoActionComponents[index];
                    renderComponents.push(componentName);
                    const element = this.renderActionElement(componentName);
                    if (element) {
                        elements.push(element);
                    }
                }
                const kebabElements = sectionTwoActionComponents.filter((componentName) => !renderComponents.includes(componentName));
                contextMenuList = kebabElements;
            }
            else {
                contextMenuList = sectionTwoActionComponents;
            }
            // Append the kebab Icon
            const kebabIcon = this.renderKebabWrapper();
            elements.push(kebabIcon);
        }
        else {
            // Render all the action items in action cell, context menu list is not required
            sectionTwoActionComponents.forEach((componentName) => {
                const element = this.renderActionElement(componentName);
                if (element) {
                    elements.push(element);
                }
            });
        }
        return [elements, contextMenuList];
    }
    renderChatIcon() {
        const customClassNames = ["aid-chat", `agentx-webex-chat-${this.actionCellConfigs.agentId}`];
        const isDisabled = this.isWebexChatDisabled();
        const button = this.createButtonElement(customClassNames, isDisabled);
        if (this.actionCellConfigs.isWebExSendingMessage) {
            const iconElement = this.createIconElement(["md-spinner", "md-spinner--14"]);
            button.appendChild(iconElement);
        }
        else {
            const iconElement = this.createIconElement(["icon-chat_14"]);
            button.appendChild(iconElement);
            if (this.webExMessageError()) {
                const errorElement = document.createElement("div");
                errorElement.classList.add("error-icon");
                const webexErrorIcon = this.createIconElement(["icon-priority-active-two_12"]);
                errorElement.appendChild(webexErrorIcon);
                button.appendChild(errorElement);
            }
        }
        button.onclick = (e) => {
            e.stopPropagation();
            if (!isDisabled) {
                const actionCellValues = this.getActionCellValues();
                this.actionCellConfigs.handleWebexChat(actionCellValues, button);
            }
        };
        const toolTipMessage = this.getWebexToolTip();
        button.setAttribute("aria-label", `${toolTipMessage} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.to")} ${this.actionCellConfigs.agentName}`);
        button.classList.add(TWP_CUSTOM_TOOLTIP);
        button.setAttribute(DATA_MESSAGE, toolTipMessage);
        return button;
    }
    renderSignoutIcon() {
        const customClassNames = ["signout-icon", `signout-${this.actionCellConfigs.agentId}`];
        const isDisabled = (0,_Utils__WEBPACK_IMPORTED_MODULE_2__.isAgentSignoutDisabled)(this.actionCellConfigs);
        const button = this.createButtonElement(customClassNames, isDisabled);
        if (this.actionCellConfigs.signoutPending) {
            const iconElement = this.createIconElement(["md-spinner", "md-spinner--14"]);
            button.appendChild(iconElement);
        }
        else if (this.actionCellConfigs.signoutError) {
            const iconElement = this.createIconElement(["icon-sign-out_16"]);
            const errorElement = document.createElement("div");
            errorElement.classList.add("error-icon");
            const webexErrorIcon = this.createIconElement(["icon-priority-active-two_12"]);
            errorElement.appendChild(webexErrorIcon);
            iconElement.appendChild(errorElement);
            button.appendChild(iconElement);
        }
        else {
            const iconElement = this.createIconElement(["icon-sign-out_16"]);
            button.appendChild(iconElement);
        }
        button.onclick = (e) => {
            var _a;
            if (!isDisabled) {
                e.stopPropagation();
                const event = {
                    detail: {
                        agentId: (_a = this.actionCellConfigs) === null || _a === void 0 ? void 0 : _a.agentId
                    }
                };
                const actionCellValues = this.getActionCellValues();
                this.actionCellConfigs.handleAgentSignout(actionCellValues, event);
            }
        };
        const toolTipMessage = (0,_Utils__WEBPACK_IMPORTED_MODULE_2__.getSignoutTooltip)(this.actionCellConfigs, isDisabled);
        button.setAttribute(ARIA_LABEL, `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.signoutAgentMenu")} ${this.actionCellConfigs.agentName}`);
        button.setAttribute(ARIA_DESCRIPTION, `${toolTipMessage}`);
        button.classList.add(TWP_CUSTOM_TOOLTIP);
        button.setAttribute(DATA_MESSAGE, toolTipMessage);
        return button;
    }
    renderElement() {
        const element = document.createElement("div");
        element.classList.add("ActionCell");
        const section1 = document.createElement("div");
        section1.classList.add("section-one");
        const section2 = document.createElement("div");
        section2.classList.add("section-two");
        // SECTION ONE
        const isMonitoring = this.getIsMonitoring();
        if (!isMonitoring) {
            // There is no monitoring in progress.
            // Add the review and monitor icon
            const reviewAndMonitorButtonElement = this.renderReviewAndMonitorIcon();
            section1.appendChild(reviewAndMonitorButtonElement);
        }
        else {
            // Call monitoring in progress.
            // Show the monitoring label text.
            const labelElement = this.callMonitoringLabel();
            section1.appendChild(labelElement);
        }
        // SECTION TWO
        // Check whether we need to render the kebab icon or chat icon based on the action cell width
        const sectionTwoActionComponents = this.sectionTwoActionComponents();
        if (isMonitoring || sectionTwoActionComponents.length > 0) {
            if (isMonitoring) {
                // All the action components will added to the context menu list
                this.contextMenuList = sectionTwoActionComponents;
                const kebabWrapper = this.renderKebabWrapper();
                section2 === null || section2 === void 0 ? void 0 : section2.appendChild(kebabWrapper);
            }
            else {
                // Render action cell components
                const [elements, contextMenuList] = this.getActionCellElements(sectionTwoActionComponents);
                elements.forEach((el) => {
                    section2 === null || section2 === void 0 ? void 0 : section2.appendChild(el);
                });
                this.contextMenuList = contextMenuList;
            }
        }
        else {
            this.contextMenuList = [];
        }
        element.appendChild(section1);
        element.appendChild(section2);
        this.eGui = element;
    }
    init(params) {
        this.paramsData = params.value;
        this.setActionCellConfigs(params);
        this.renderElement();
    }
    getGui() {
        return this.eGui;
    }
    refreshElement() {
        // This method will execute when refresh function is called.
        const section1 = this.eGui.querySelector(".section-one");
        const isMonitoring = this.getIsMonitoring();
        if (!isMonitoring) {
            // There is no monitoring call in progress.
            // Update the monitor icon
            const reviewAndMonitorIcon = this.eGui.getElementsByClassName("review-monitor-icon");
            if (reviewAndMonitorIcon && reviewAndMonitorIcon.length > 0) {
                // Update the Icon...
                const reviewMonitorStatusDisabled = this.isReviewMonitorDisabled();
                const reviewMonitorSelectedIcon = reviewAndMonitorIcon[0];
                const hasDisabledAttribute = reviewMonitorSelectedIcon === null || reviewMonitorSelectedIcon === void 0 ? void 0 : reviewMonitorSelectedIcon.classList.contains("disabled");
                if (reviewMonitorStatusDisabled !== hasDisabledAttribute) {
                    if (reviewMonitorStatusDisabled) {
                        reviewMonitorSelectedIcon.classList.add("disabled");
                        reviewMonitorSelectedIcon.setAttribute("aria-disabled", "true");
                    }
                    else {
                        reviewMonitorSelectedIcon.classList.remove("disabled");
                        reviewMonitorSelectedIcon.removeAttribute("aria-disabled");
                    }
                }
                const toolTipMessage = this.getTooltipMessage();
                const ToolTipElement = section1.querySelector(`.${TWP_CUSTOM_TOOLTIP}`);
                if (ToolTipElement) {
                    ToolTipElement.setAttribute(DATA_MESSAGE, toolTipMessage);
                }
                if (this.actionCellConfigs.isConsultCall ||
                    this.isWrapUp ||
                    this.isWrapUpAssistance ||
                    this.isMainCallInPostCall ||
                    this.actionCellConfigs.voiceChannelCount === 0) {
                    reviewAndMonitorIcon[0].setAttribute(SHOW_TOOLTIP, "true");
                }
                else {
                    reviewMonitorSelectedIcon.removeAttribute(SHOW_TOOLTIP);
                }
            }
            else {
                // Render the monitor icon.'
                const reviewAndMonitorButtonElement = this.renderReviewAndMonitorIcon();
                section1 === null || section1 === void 0 ? void 0 : section1.replaceChildren(reviewAndMonitorButtonElement);
            }
        }
        else {
            // Call monitoring in progress, Render the monitoring label text
            const labelElement = this.callMonitoringLabel();
            section1 === null || section1 === void 0 ? void 0 : section1.replaceChildren(labelElement);
        }
        // Check whether we need to render the kebab icon or chat icon based on the action cell width
        const section2 = this.eGui.querySelector(".section-two");
        const sectionTwoActionComponents = this.sectionTwoActionComponents();
        if (isMonitoring || sectionTwoActionComponents.length > 0) {
            if (isMonitoring) {
                // All the action components will added to the context menu list
                this.contextMenuList = sectionTwoActionComponents;
                const kebabWrapper = this.renderKebabWrapper();
                section2 === null || section2 === void 0 ? void 0 : section2.replaceChildren(kebabWrapper);
            }
            else {
                // Render action cell components
                const [elements, contextMenuList] = this.getActionCellElements(sectionTwoActionComponents);
                section2 === null || section2 === void 0 ? void 0 : section2.replaceChildren(...elements);
                this.contextMenuList = contextMenuList;
            }
        }
        else {
            // Remove the child elements.
            // section2.removeChildren
            this.removeAllChildNodes(section2);
        }
    }
    setActionCellConfigs(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        const cellEditorParams = (_a = params === null || params === void 0 ? void 0 : params.colDef) === null || _a === void 0 ? void 0 : _a.cellEditorParams();
        const actionCellValues = ((_b = params === null || params === void 0 ? void 0 : params.data) === null || _b === void 0 ? void 0 : _b.actions) && Object.keys((_c = params === null || params === void 0 ? void 0 : params.data) === null || _c === void 0 ? void 0 : _c.actions).length > 0 ? (_d = params === null || params === void 0 ? void 0 : params.data) === null || _d === void 0 ? void 0 : _d.actions : {};
        this.actionCellConfigs = Object.assign(Object.assign({}, actionCellValues), { isDarkMode: (_e = cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.isDarkMode) !== null && _e !== void 0 ? _e : false, webexEnabled: (_f = cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.webexEnabled) !== null && _f !== void 0 ? _f : false, isMCMEnabled: (_g = cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.isMCMEnabled) !== null && _g !== void 0 ? _g : false, isMPCorPersistEnabled: (_h = cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.isMPCorPersistEnabled) !== null && _h !== void 0 ? _h : false, isPostCallEnabled: (_j = cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.isPostCallEnabled) !== null && _j !== void 0 ? _j : false, isStateChangeBySupervisorEnabled: (_k = cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.isStateChangeBySupervisorEnabled) !== null && _k !== void 0 ? _k : false, isSignoutBySupervisorEnabled: (_l = cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.isSignoutBySupervisorEnabled) !== null && _l !== void 0 ? _l : false, isSupervisorySendMessageEnabled: (_m = cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.isSupervisorySendMessageEnabled) !== null && _m !== void 0 ? _m : false, voiceChannelCount: (_o = cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.voiceChannelCount) !== null && _o !== void 0 ? _o : 0, onActiveCall: (_p = cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.onActiveCall) !== null && _p !== void 0 ? _p : false, handleAIDModal: cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.handleAIDModal, handleContextMenu: cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.handleContextMenu, handleStateChangeSelector: cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.handleStateChangeSelector, handleWebexChat: cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.handleWebexChat, actionCellWidth: cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.actionCellWidth, handleAgentSignout: cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.handleAgentSignout, contactStatus: (_r = (_q = params === null || params === void 0 ? void 0 : params.data) === null || _q === void 0 ? void 0 : _q.contactStatus) !== null && _r !== void 0 ? _r : "" });
        // i18nMixin was not extended in this function,
        // All the required localization text are received as a property from cellEditorParams
        this.localization = cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.actionCellLocalizationValues;
    }
    refresh(params) {
        // Update the params
        this.paramsData = params.value;
        this.setActionCellConfigs(params);
        this.refreshElement();
        return true;
    }
    destroy() {
        this.eGui.remove();
    }
}


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/CellRenderer/AgentStateRenderer.ts":
/*!*********************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/CellRenderer/AgentStateRenderer.ts ***!
  \*********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ AgentStateRenderer)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../constants */ "./src/constants.ts");
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Utils */ "./src/components/TeamPerformanceWidget/Utils.ts");
/* harmony import */ var _BaseComponent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./BaseComponent */ "./src/components/TeamPerformanceWidget/CellRenderer/BaseComponent.ts");




class AgentStateRenderer extends _BaseComponent__WEBPACK_IMPORTED_MODULE_3__["default"] {
    constructor() {
        super();
        this.supervisorId = "";
        this.agentState = "";
        this.getToolTipMessage = (params) => {
            if (params.data.reason === _constants__WEBPACK_IMPORTED_MODULE_1__.PRESENCE_SYNC) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.stateChangeByCollab");
            }
            const name = this.supervisorId === params.data.changedById ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.stateChange.you") : params.data.changedByName;
            return `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.SetBy", "", { defaultValue: name })}`;
        };
        this.createInfoIconElement = (params) => {
            const iconElement = this.createIconElement(["agent-state-info", "icon-info_16"]);
            const toolTipMessage = this.getToolTipMessage(params);
            const infoToolTipWrapper = this.toolTipElement(toolTipMessage);
            infoToolTipWrapper.appendChild(iconElement);
            return infoToolTipWrapper;
        };
        this.updateParamsValues = (params) => {
            var _a, _b;
            this.supervisorId = (_a = params === null || params === void 0 ? void 0 : params.colDef) === null || _a === void 0 ? void 0 : _a.cellEditorParams.supervisorId;
            this.agentState = (_b = params === null || params === void 0 ? void 0 : params.data) === null || _b === void 0 ? void 0 : _b.agentState;
        };
        // This method will execute when state value is changed. Value will update using the element reference.
        this.refreshAgentStateRenderer = (params) => {
            this.updateParamsValues(params);
            // Update the agent state by element reference
            const agentStateName = this.eGui.querySelector(".agent-state-name");
            if (agentStateName) {
                agentStateName.textContent = (0,_Utils__WEBPACK_IMPORTED_MODULE_2__.localiseAvailableState)(this.agentState);
            }
            // Update the tooltip.
            const tooltipElement = this.eGui.querySelector(".tpw-custom-tooltip");
            if (this.checkExtStateChange(params)) {
                if (tooltipElement) {
                    // Update the existing tooltip message.
                    const toolTipMessage = this.getToolTipMessage(params);
                    tooltipElement.setAttribute("data-message", toolTipMessage);
                }
                else {
                    // Append the info element before the agent state name.
                    const infoIconElement = this.createInfoIconElement(params);
                    this.eGui.insertBefore(infoIconElement, agentStateName);
                }
            }
            else {
                // Remove the existing tooltip element
                tooltipElement === null || tooltipElement === void 0 ? void 0 : tooltipElement.remove();
            }
        };
        this.eGui = document.createElement("div");
    }
    renderAgentStateRenderer(params) {
        const element = document.createElement("div");
        element.classList.add("agent-state-container");
        // Check whether the info icon needs to be present or not
        if (this.checkExtStateChange(params)) {
            const infoIconElement = this.createInfoIconElement(params);
            element.appendChild(infoIconElement);
            element.setAttribute("aria-label", this.getToolTipMessage(params));
        }
        // Agent state indicator that shows the state of the agent
        element.appendChild(this.createStateElement());
        this.eGui = element;
    }
    // This method will check if state is changed by supervisor or PRESENCE_SYNC.
    checkExtStateChange(params) {
        if (params.data.reason === _constants__WEBPACK_IMPORTED_MODULE_1__.PRESENCE_SYNC) {
            return true;
        }
        const { changedBy, changedById, changedByName } = params.data;
        return changedBy ? changedBy !== _constants__WEBPACK_IMPORTED_MODULE_1__.CHANGED_BY_ROLE.SELF : changedById && changedByName;
    }
    createStateElement() {
        const element = document.createElement("span");
        element.classList.add("agent-state-name");
        element.textContent = (0,_Utils__WEBPACK_IMPORTED_MODULE_2__.localiseAvailableState)(this.agentState);
        return element;
    }
    init(params) {
        this.updateParamsValues(params);
        this.renderAgentStateRenderer(params);
    }
    refresh(params) {
        this.refreshAgentStateRenderer(params);
        return true;
    }
    getGui() {
        return this.eGui;
    }
    destroy() {
        this.eGui.remove();
    }
}


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/CellRenderer/BaseComponent.ts":
/*!****************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/CellRenderer/BaseComponent.ts ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ BaseComponent)
/* harmony export */ });
const BUTTON_DEFAULT_CLASSNAMES = ["aid-button", "btn-action"];
const ICON_DEFAULT_CLASSNAMES = ["md-icon", "icon"];
class BaseComponent {
    constructor() {
        var _a, _b;
        this.createIconElement = (classList) => {
            const iconElement = document.createElement("i");
            // Add Default momentum class names for icon element.
            iconElement.classList.add(...ICON_DEFAULT_CLASSNAMES);
            // Add custom class names.
            if (Array.isArray(classList)) {
                iconElement.classList.add(...classList);
            }
            return iconElement;
        };
        this.createToolTip = (reference, message, placement = "top") => {
            var _a;
            const popperElement = this.createToolTipContent(message);
            (_a = this.themeSelector) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new CustomEvent("tooltip-create", {
                bubbles: true,
                composed: true,
                detail: {
                    placement,
                    reference,
                    popper: popperElement
                }
            }));
        };
        this.destroyToolTip = () => {
            var _a;
            (_a = this.themeSelector) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new CustomEvent("tooltip-destroy", {
                bubbles: true,
                composed: true,
                detail: {}
            }));
        };
        this.createToolTipContent = (message) => {
            const popperElement = document.createElement("div");
            popperElement.classList.add("md-tooltip__popper");
            popperElement.innerHTML = `<div class="md-tooltip__content" part="tooltip-content">
                                ${message}
                               </div>
                               <div id="arrow" class="md-tooltip__arrow" data-popper-arrow></div>`;
            return popperElement;
        };
        this.toolTipElement = (message) => {
            const element = document.createElement("div");
            element.classList.add("tpw-custom-tooltip");
            element.setAttribute("data-message", message);
            element.onmouseenter = (event) => {
                var _a;
                if (!event.target.firstChild.disabled || ((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.firstChild.getAttribute("data-show-tooltip"))) {
                    const content = element.getAttribute("data-message");
                    if (content) {
                        this.createToolTip(event.target.firstChild, content);
                    }
                }
            };
            element.onmouseleave = () => {
                this.destroyToolTip();
            };
            element.onkeydown = () => {
                this.destroyToolTip();
            };
            return element;
        };
        this.themeSelector = (_b = (_a = document === null || document === void 0 ? void 0 : document.querySelector("agentx-app")) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("md-theme");
    }
    createButtonElement(classList, isDisabled = false) {
        const button = document.createElement("button");
        button.classList.add(...BUTTON_DEFAULT_CLASSNAMES);
        // Add custom class names.
        if (Array.isArray(classList)) {
            button.classList.add(...classList);
        }
        button.setAttribute("type", "button");
        button.tabIndex = 0;
        if (isDisabled) {
            button.classList.add("disabled");
            button.setAttribute("aria-disabled", "true");
        }
        const onmouseenter = (event) => {
            var _a;
            if (!event.target.firstChild.classList.contains("disabled") ||
                ((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.firstChild.getAttribute("data-show-tooltip"))) {
                const content = button.getAttribute("data-message");
                if (content) {
                    this.createToolTip(button, content);
                }
            }
        };
        button.onmouseleave = () => {
            this.destroyToolTip();
        };
        button.onkeydown = () => {
            this.destroyToolTip();
        };
        button.onmouseenter = onmouseenter;
        button.onfocus = onmouseenter;
        return button;
    }
}


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/CellRenderer/DurationRenderer.ts":
/*!*******************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/CellRenderer/DurationRenderer.ts ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_1__);


class DurationRenderer {
    init(params) {
        this.oldTimestamp =
            typeof params.value === "string" && params.value !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE ? Number(params.value) : 0;
        this.display = document.createElement("div");
        this.display.classList.add("timer-display");
        this.getGui();
    }
    initiateInterval() {
        this.intervalId = setInterval(() => {
            if (this.oldTimestamp && this.display) {
                const diff = Date.now() >= this.oldTimestamp
                    ? luxon__WEBPACK_IMPORTED_MODULE_1__.Duration.fromMillis(Date.now() - this.oldTimestamp)
                    : luxon__WEBPACK_IMPORTED_MODULE_1__.Duration.fromMillis(0);
                this.display.textContent = diff.toFormat("hh:mm:ss");
            }
        }, 1000);
    }
    getGui() {
        const container = document.createElement("div");
        container.classList.add("timer-container");
        if (this.display) {
            container.appendChild(this.display);
        }
        if (this.oldTimestamp !== 0) {
            this.initiateInterval();
        }
        else if (this.display) {
            this.display.textContent = _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE;
        }
        return container;
    }
    refresh(params) {
        if ((params.value === _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE || params.value === "0") && this.display) {
            if (this.intervalId) {
                clearInterval(this.intervalId);
                this.intervalId = null;
            }
            this.display.textContent = _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE;
        }
        else {
            if (this.intervalId) {
                clearInterval(this.intervalId);
                this.intervalId = null;
            }
            this.initiateInterval();
        }
        this.oldTimestamp =
            typeof params.value === "string" && params.value !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE ? Number(params.value) : 0;
        return true;
    }
    destroy() {
        var _a;
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
        if (this.display) {
            (_a = this.display) === null || _a === void 0 ? void 0 : _a.remove();
        }
    }
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (DurationRenderer);


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/CellRenderer/GroupRowInnerRenderer.ts":
/*!************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/CellRenderer/GroupRowInnerRenderer.ts ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ GroupRowInnerRenderer)
/* harmony export */ });
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Utils */ "./src/components/TeamPerformanceWidget/Utils.ts");

class GroupRowInnerRenderer {
    constructor() {
        this.eGui = document.createElement("div");
    }
    init(params) {
        this.updateValue(params);
    }
    updateValue(params) {
        var _a, _b, _c;
        this.eGui.innerHTML = `
      <span class="groupTitle">
        ${(0,_Utils__WEBPACK_IMPORTED_MODULE_0__.columnHeaderMapping)()[(_a = params.node) === null || _a === void 0 ? void 0 : _a.field]}: ${(0,_Utils__WEBPACK_IMPORTED_MODULE_0__.localiseAvailableState)((_b = params.node) === null || _b === void 0 ? void 0 : _b.key)} ( ${(_c = params.node) === null || _c === void 0 ? void 0 : _c.allChildrenCount} Agents )
      </span>
    `;
    }
    refresh(params) {
        this.updateValue(params);
        return true;
    }
    getGui() {
        return this.eGui;
    }
}


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/CellRenderer/NameRenderer.ts":
/*!***************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/CellRenderer/NameRenderer.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ NameRenderer)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__);



class NameRenderer {
    constructor() {
        this.eGui = document.createElement("div");
        this.getAvatar = (id, className, agentName, title, type) => {
            const avatarDiv = `<div id="${id}" class="${className}" alt="${agentName}" aria-label="${agentName}" title="${agentName}">
                            <span class="md-avatar__letter">${title}</span>
                          </div>`;
            const avatar = `<md-avatar
        type="${type}"
        id="${id}"
        alt="${agentName}"
        aria-label="${agentName}"
        title="${agentName}"
        size="24"
        newMomentum
      >
      </md-avatar>`;
            return _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isMomentumAvatarEnabled ? avatar : avatarDiv;
        };
        this.prettyTitle = (agentName) => {
            if (agentName === null || agentName === void 0 ? void 0 : agentName.length) {
                const fullName = agentName.trim().split(" ");
                if (fullName.length === 1) {
                    return fullName[0].charAt(0);
                }
                else {
                    return `${fullName[0].charAt(0)}${fullName[fullName.length - 1].charAt(0)}`;
                }
            }
            return "";
        };
        this.avatarType = (agentState) => {
            return agentState === (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.stateChange.available") ? "active" : "idle";
        };
    }
    renderNameRenderer(params) {
        var _a, _b, _c, _d;
        const title = this.prettyTitle((_a = params === null || params === void 0 ? void 0 : params.data) === null || _a === void 0 ? void 0 : _a.agentName);
        const type = this.avatarType((_b = params === null || params === void 0 ? void 0 : params.data) === null || _b === void 0 ? void 0 : _b.agentState);
        const agentId = (_c = params === null || params === void 0 ? void 0 : params.data) === null || _c === void 0 ? void 0 : _c.agentId;
        const agentName = ((_d = params === null || params === void 0 ? void 0 : params.data) === null || _d === void 0 ? void 0 : _d.agentName) || _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE;
        const id = `avatar-renderer-${agentId}`;
        const className = `md-avatar md-avatar--28 md-avatar--${type}`;
        const avatar = this.getAvatar(id, className, agentName, title, type);
        const agentNameSpan = `<span class="name-span-renderer">${agentName}</span>`;
        this.eGui.innerHTML = avatar + agentNameSpan;
    }
    init(params) {
        this.eGui.classList.add("avatar-center");
        this.renderNameRenderer(params);
    }
    refresh(params) {
        this.renderNameRenderer(params);
        return true;
    }
    getGui() {
        return this.eGui;
    }
}


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/ColumnMenu/ColumnMenu.scss":
/*!*************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/ColumnMenu/ColumnMenu.scss ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --column-menu-width: 260px;
}

.column-menu-wrapper {
  width: var(--column-menu-width);
  background-color: var(--md-secondary-white-bg-color);
}

.filter-tab-wrapper {
  width: 100%;
  background-color: var(--md-secondary-white-bg-color);
  display: block;
  overflow: hidden;
}

.filter-tab-header {
  padding: 1rem 1rem 0rem;
  border-bottom: 1px solid var(--md-menu-overlay-border-color);
  padding-bottom: 0.5rem;
}

.filter-tab-checkbox-group-wrapper .virtual-scroll {
  padding: 0 0 0 1rem;
  max-height: 240px;
}

.filter-tab-checkbox {
  margin: 0.5rem 0;
  padding-top: 3.5px;
  padding-bottom: 3px;
}

.select-all-checkbox {
  padding-right: 5.5rem;
}

.pin-tab-wrapper {
  padding: 0.5rem;
}

.pin-tab-radio-btn {
  margin-bottom: 0.5rem;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL1RlYW1QZXJmb3JtYW5jZVdpZGdldC9Db2x1bW5NZW51L0NvbHVtbk1lbnUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLDBCQUFBO0FBQ0Y7O0FBRUE7RUFDRSwrQkFBQTtFQUNBLG9EQUFBO0FBQ0Y7O0FBRUE7RUFDRSxXQUFBO0VBQ0Esb0RBQUE7RUFDQSxjQUFBO0VBQ0EsZ0JBQUE7QUFDRjs7QUFFQTtFQUNFLHVCQUFBO0VBQ0EsNERBQUE7RUFDQSxzQkFBQTtBQUNGOztBQUVBO0VBQ0UsbUJBQUE7RUFDQSxpQkFBQTtBQUNGOztBQUVBO0VBQ0UsZ0JBQUE7RUFDQSxrQkFBQTtFQUNBLG1CQUFBO0FBQ0Y7O0FBRUE7RUFDRSxxQkFBQTtBQUNGOztBQUVBO0VBQ0UsZUFBQTtBQUNGOztBQUVBO0VBQ0UscUJBQUE7QUFDRiIsInNvdXJjZXNDb250ZW50IjpbIjpob3N0IHtcbiAgLS1jb2x1bW4tbWVudS13aWR0aDogMjYwcHg7XG59XG5cbi5jb2x1bW4tbWVudS13cmFwcGVyIHtcbiAgd2lkdGg6IHZhcigtLWNvbHVtbi1tZW51LXdpZHRoKTtcbiAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tbWQtc2Vjb25kYXJ5LXdoaXRlLWJnLWNvbG9yKTtcbn1cblxuLmZpbHRlci10YWItd3JhcHBlciB7XG4gIHdpZHRoOiAxMDAlO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1tZC1zZWNvbmRhcnktd2hpdGUtYmctY29sb3IpO1xuICBkaXNwbGF5OiBibG9jaztcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbn1cblxuLmZpbHRlci10YWItaGVhZGVyIHtcbiAgcGFkZGluZzogMXJlbSAxcmVtIDByZW07XG4gIGJvcmRlci1ib3R0b206IDFweCBzb2xpZCB2YXIoLS1tZC1tZW51LW92ZXJsYXktYm9yZGVyLWNvbG9yKTtcbiAgcGFkZGluZy1ib3R0b206IDAuNXJlbTtcbn1cblxuLmZpbHRlci10YWItY2hlY2tib3gtZ3JvdXAtd3JhcHBlciAudmlydHVhbC1zY3JvbGwge1xuICBwYWRkaW5nOiAwIDAgMCAxcmVtO1xuICBtYXgtaGVpZ2h0OiAyNDBweDtcbn1cblxuLmZpbHRlci10YWItY2hlY2tib3gge1xuICBtYXJnaW46IDAuNXJlbSAwO1xuICBwYWRkaW5nLXRvcDogMy41cHg7XG4gIHBhZGRpbmctYm90dG9tOiAzcHg7XG59XG5cbi5zZWxlY3QtYWxsLWNoZWNrYm94IHtcbiAgcGFkZGluZy1yaWdodDogNS41cmVtO1xufVxuXG4ucGluLXRhYi13cmFwcGVyIHtcbiAgcGFkZGluZzogMC41cmVtO1xufVxuXG4ucGluLXRhYi1yYWRpby1idG4ge1xuICBtYXJnaW4tYm90dG9tOiAwLjVyZW07XG59XG4iXSwic291cmNlUm9vdCI6IiJ9 */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/ColumnMenu/ColumnMenu.ts":
/*!***********************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/ColumnMenu/ColumnMenu.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ColumnMenu: () => (/* binding */ ColumnMenu)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ColumnMenu_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./ColumnMenu.scss */ "./src/components/TeamPerformanceWidget/ColumnMenu/ColumnMenu.scss");
/* harmony import */ var _FilterColumnMenu__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./FilterColumnMenu */ "./src/components/TeamPerformanceWidget/ColumnMenu/FilterColumnMenu.ts");
/* harmony import */ var _PinColumnMenu__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./PinColumnMenu */ "./src/components/TeamPerformanceWidget/ColumnMenu/PinColumnMenu.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};






var ColumnMenu;
(function (ColumnMenu) {
    /**
     * @element agentx-wc-tpw-column-menu
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this._columnParams = {};
            this._columnFilterModel = {};
            this.selectedTab = 0;
            this.handleTabFocus = (index = 0) => __awaiter(this, void 0, void 0, function* () {
                yield this.updateComplete;
                setTimeout(() => {
                    var _a, _b, _c, _d;
                    const element = (_c = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-tabs")) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelectorAll("md-tab");
                    if (element && element[index]) {
                        (_d = element[index]) === null || _d === void 0 ? void 0 : _d.focus();
                    }
                }, 50);
            });
            this.handleTabSelection = (e) => {
                // selected-changed
                this.selectedTab = e.detail.value;
                this.handleTabFocus(e.detail.value);
            };
            this.handleTabPanelFocus = (e) => {
                if (e.code === "Tab") {
                    e.stopPropagation();
                    // Check active focus element
                    setTimeout(() => {
                        var _a;
                        const activeElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.activeElement;
                        if (!activeElement) {
                            // If focus elements are not there in Table panel, Focus to the selected tab header
                            this.handleTabFocus(this.selectedTab);
                        }
                    }, 50); //delay for modal to load
                }
            };
        }
        get columnParams() {
            return this._columnParams;
        }
        set columnParams(value) {
            const oldValue = this._columnParams;
            this._columnParams = value;
            this.requestUpdate("columnParams", oldValue);
        }
        get columnFilterModel() {
            return this._columnFilterModel;
        }
        set columnFilterModel(value) {
            const oldValue = this._columnFilterModel;
            this._columnFilterModel = value;
            this.requestUpdate("columnFilterModel", oldValue);
        }
        static get styles() {
            return _ColumnMenu_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
        }
        connectedCallback() {
            super.connectedCallback();
            this.handleTabFocus(this.selectedTab);
        }
        firstUpdated(changedProperties) {
            super.firstUpdated(changedProperties);
            this.handleTabFocus(this.selectedTab);
        }
        handleTabKeyDown(e) {
            var _a;
            if (((_a = e.detail) === null || _a === void 0 ? void 0 : _a.key) === "Tab") {
                setTimeout(() => {
                    var _a, _b, _c;
                    // Focus to the tab panel - selected element.
                    const columnMenuEl = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-tabs md-tab-panel[selected] filter-column-menu");
                    const searchInputWrapper = (_b = columnMenuEl === null || columnMenuEl === void 0 ? void 0 : columnMenuEl.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("md-input");
                    const searchInput = (_c = searchInputWrapper === null || searchInputWrapper === void 0 ? void 0 : searchInputWrapper.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector("input");
                    searchInput === null || searchInput === void 0 ? void 0 : searchInput.focus();
                }, 50); //delay for modal to load
            }
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="column-menu-wrapper">
          <md-tabs
            .selected="${this.selectedTab}"
            justified
            @selected-changed="${(e) => {
                this.handleTabSelection(e);
            }}"
            roving-prevent-focus
            @tab-keydown="${(e) => {
                this.handleTabKeyDown(e);
            }}"
          >
            ${!this.columnParams.suppressFilterTab
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
                  <md-tab
                    slot="tab"
                    name="Filter"
                    aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.filter")}
                    .disabled=${this.columnParams.showWarningTooltip}
                  >
                    <md-tooltip
                      message=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.FilterMenuWarning")}
                      placement="bottom"
                      .disabled=${!this.columnParams.showWarningTooltip}
                    >
                      <md-icon name="filter-bold" size="16" iconSet="momentumDesign"></md-icon>
                    </md-tooltip>
                  </md-tab>
                  <md-tab-panel
                    slot="panel"
                    .focusablePanel=${"false"}
                    @keydown="${(e) => {
                    this.handleTabPanelFocus(e);
                }}"
                  >
                    <filter-column-menu
                      .columnParams=${this.columnParams}
                      .columnFilterModel=${this.columnFilterModel}
                    ></filter-column-menu>
                  </md-tab-panel>
                `
                : lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}
            <md-tab slot="tab" name="Pin" aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.pin")}>
              <md-icon name="pin-bold" size="16" iconSet="momentumDesign"></md-icon>
            </md-tab>
            <md-tab-panel
              slot="panel"
              @keydown="${(e) => {
                this.handleTabPanelFocus(e);
            }}"
            >
              <pin-column-menu .columnParams=${this.columnParams}></pin-column-menu>
            </md-tab-panel>
          </md-tabs>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
    ], Element.prototype, "columnParams", null);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
    ], Element.prototype, "columnFilterModel", null);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "selectedTab", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-tpw-column-menu")
    ], Element);
    ColumnMenu.Element = Element;
})(ColumnMenu || (ColumnMenu = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/ColumnMenu/ColumnMenuRenderer.ts":
/*!*******************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/ColumnMenu/ColumnMenuRenderer.ts ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ColumnMenuRenderer)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../TeamPerformanceUtils */ "./src/components/TeamPerformanceWidget/TeamPerformanceUtils.ts");


class ColumnMenuRenderer {
    constructor() {
        this.params = {};
        this.filterModel = {};
        this.listener = (event) => {
            var _a, _b;
            if (event.key === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Escape) {
                this.params.api.hidePopupMenu();
                document.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.COLUMN_MENU_FOCUS, { detail: (_b = (_a = this.params) === null || _a === void 0 ? void 0 : _a.column) === null || _b === void 0 ? void 0 : _b.colId }));
            }
        };
        this.eGui = document.createElement("div");
    }
    init(params) {
        this.valueGetter = params.valueGetter;
        this.params = params;
        this.setupGui(params);
        this.eGui.addEventListener("keydown", this.listener);
    }
    destroy() {
        this.eGui.removeEventListener("keydown", this.listener);
    }
    setupGui(params) {
        this.eGui.innerHTML = `
        <agentx-wc-tpw-column-menu></agentx-wc-tpw-column-menu>
    `;
        this.columnMenuElement = this.eGui.querySelector("agentx-wc-tpw-column-menu");
        this.columnMenuElement.columnParams = params;
        this.columnMenuElement.columnFilterModel = this.filterModel;
    }
    getGui() {
        return this.eGui;
    }
    doesFilterPass(params) {
        let passed = true;
        Object.keys(this.filterModel).forEach((filterWord) => {
            const rowValue = this.valueGetter(params);
            if (rowValue === filterWord) {
                passed = this.filterModel[filterWord];
            }
        });
        return passed;
    }
    isFilterActive() {
        return typeof this.filterModel !== "undefined" && this.filterModel !== null
            ? !(0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_1__.checkIfFilterModelIsEmpty)(this.filterModel)
            : false;
    }
    getModel() {
        return this.filterModel;
    }
    setModel(newFilterModel) {
        var _a;
        this.filterModel = newFilterModel;
        if (this.columnMenuElement) {
            this.columnMenuElement.columnFilterModel = this.filterModel;
        }
        (_a = this.params) === null || _a === void 0 ? void 0 : _a.filterChangedCallback();
    }
}


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/ColumnMenu/FilterColumnMenu.ts":
/*!*****************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/ColumnMenu/FilterColumnMenu.ts ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FilterColumnMenu: () => (/* binding */ FilterColumnMenu)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_virtualizer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-virtualizer */ "lit-virtualizer");
/* harmony import */ var lit_virtualizer__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_virtualizer__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _assets_styles_common_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../assets/styles/common.scss */ "./src/assets/styles/common.scss");
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Utils */ "./src/components/TeamPerformanceWidget/Utils.ts");
/* harmony import */ var _ColumnMenu_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./ColumnMenu.scss */ "./src/components/TeamPerformanceWidget/ColumnMenu/ColumnMenu.scss");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_10__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};











var FilterColumnMenu;
(function (FilterColumnMenu) {
    /**
     * @element filter-column-menu
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_10__.MobxLitElement) {
        constructor() {
            super(...arguments);
            this._columnParams = {};
            this._columnFilterModel = {};
            this.columnRowData = [];
            this.columnRowDataObj = {}; //RowData mapping to get on which data filter is applied
            this.filteredColumnRowData = [];
            this.handleFilterDataUpdate = (e) => {
                if (e.detail && e.detail.colId === this.columnParams.column.colId) {
                    this.updateColumnRowData();
                }
            };
            this.handleSearchFilters = (event) => __awaiter(this, void 0, void 0, function* () {
                const searchTerm = event.detail.value.toLowerCase();
                const updatedFilterList = [];
                this.columnRowData.forEach((data) => {
                    if (data === null || data === void 0 ? void 0 : data.toLowerCase().includes(searchTerm)) {
                        updatedFilterList.push(data);
                    }
                });
                this.filteredColumnRowData = [...updatedFilterList];
            });
            this.isSelectAllChecked = () => {
                let selectAll = true;
                Object.keys(this.columnRowDataObj).forEach((rowData) => {
                    if (!this.columnRowDataObj[rowData]) {
                        selectAll = false;
                    }
                });
                return selectAll;
            };
            this.localiseAvailableInFilterColumn = (key) => {
                return this.getColumnId() === "agentState" && key === _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.stateChange.available") : key;
            };
            this.getCheckBoxLabel = (optionsList, rowData, currentIndex) => {
                const totalOptionsCount = Object.keys(optionsList).length;
                return `${rowData} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.optionsLabel")} ${currentIndex + 1} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.of")} ${totalOptionsCount}`;
            };
            this.renderColumnData = (rowData, index) => {
                const label = this.getCheckBoxLabel(this.columnRowDataObj, rowData, index);
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div class="filter-wrapper">
          <md-checkbox
            tabIndex="0"
            class="filter-tab-checkbox"
            slot="checkbox"
            ?checked=${this.columnRowDataObj[rowData]}
            @checkbox-change=${(event) => this.handleFiltering(event, false, rowData)}
            aria-label=${label}
            >${this.localiseAvailableInFilterColumn(rowData)}</md-checkbox
          >
        </div>
      `;
            };
        }
        get columnParams() {
            return this._columnParams;
        }
        set columnParams(value) {
            const oldValue = this._columnParams;
            this._columnParams = value;
            this.requestUpdate("columnParams", oldValue);
        }
        get columnFilterModel() {
            return this._columnFilterModel;
        }
        set columnFilterModel(value) {
            const oldValue = this._columnFilterModel;
            this._columnFilterModel = value;
            this.requestUpdate("columnFilterModel", oldValue);
        }
        static get styles() {
            return [_ColumnMenu_scss__WEBPACK_IMPORTED_MODULE_7__["default"], _assets_styles_common_scss__WEBPACK_IMPORTED_MODULE_5__["default"]];
        }
        getColumnId() {
            var _a, _b;
            if (((_a = this.columnParams.column) === null || _a === void 0 ? void 0 : _a.colId) === "agentNameDetails") {
                return "agentName";
            }
            return (_b = this.columnParams.column) === null || _b === void 0 ? void 0 : _b.colId;
        }
        getGridRowData() {
            var _a, _b;
            const currentColId = this.getColumnId();
            const rowMap = {};
            // to get all the row nodes without filtering
            (_b = (_a = this.columnParams) === null || _a === void 0 ? void 0 : _a.rowModel) === null || _b === void 0 ? void 0 : _b.forEachNode((row) => {
                if (!row.group) {
                    const key = row.data[currentColId];
                    rowMap[key] = false;
                }
            });
            // to select those row nodes which are selected by user i.e this.filterModel
            for (const key in this.columnFilterModel) {
                if (this.columnFilterModel[key]) {
                    rowMap[key] = true;
                }
            }
            return rowMap;
        }
        updateColumnRowData() {
            this.columnRowDataObj = this.getGridRowData();
            this.columnRowData = Object.keys(this.columnRowDataObj);
            this.filteredColumnRowData = [...this.columnRowData];
        }
        connectedCallback() {
            super.connectedCallback();
            window.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_0__.TPW_FILTER_DATA_UPDATE, this.handleFilterDataUpdate);
            this.updateColumnRowData();
            this.requestUpdate();
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.columnRowData = [];
            this.columnRowDataObj = {};
            this.filteredColumnRowData = [];
            this.liveRegion.textContent = "";
            window.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_0__.TPW_FILTER_DATA_UPDATE, this.handleFilterDataUpdate);
        }
        updateColumnFilterModel(event, isSelectAllChecked, rowData) {
            const isCheckboxChecked = (0,_Utils__WEBPACK_IMPORTED_MODULE_6__.getIsCheckboxChecked)(event);
            if (isSelectAllChecked === false && rowData) {
                this.columnRowDataObj[rowData] = isCheckboxChecked;
                this.setLiveRegionText(isCheckboxChecked, rowData);
            }
            else {
                Object.keys(this.columnRowDataObj).forEach((rowObjData) => {
                    this.columnRowDataObj[rowObjData] = isCheckboxChecked;
                });
                this.setLiveRegionText(isCheckboxChecked, (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.all"));
            }
        }
        setLiveRegionText(isChecked, count) {
            if (isChecked) {
                this.liveRegion.textContent = `${count} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.filterAppliedLabel")}`;
            }
            else {
                this.liveRegion.textContent = `${count} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.filterRemovedLabel")}`;
            }
        }
        handleFilterUpdateEventDispatch() {
            var _a;
            this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.TPW_FILTER_UPDATED, {
                bubbles: true,
                composed: true,
                detail: {
                    field: (_a = this.columnParams.colDef) === null || _a === void 0 ? void 0 : _a.field,
                    data: this.columnRowDataObj
                }
            }));
        }
        handleFiltering(event, isSelectAllChecked, rowData) {
            var _a, _b;
            if (event) {
                this.updateColumnFilterModel(event, isSelectAllChecked, rowData || "");
                this.handleFilterUpdateEventDispatch();
                this.filteredColumnRowData = [...this.columnRowData];
                const currentRow = this.getColumnId();
                (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.TPW_COLUMN_FILTERED, {
                    FilteredColumnName: currentRow
                }, [(_b = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.webex_behavioral]);
                this.requestUpdate();
            }
        }
        renderSearchInput() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `<md-input
        clear
        clearAriaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common:clear")}"
        htmlId="pillSearchInput"
        name="pillSearchInput"
        shape=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_9__.ifDefined)(!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8__.themeManager.isMomentumV2Enabled ? "pill" : undefined)}
        ?newMomentum=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8__.themeManager.isMomentumV2Enabled}
        ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.search")}
        placeholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.search")}
        searchable
        class="search-filter-input"
        @input-change=${(event) => this.handleSearchFilters(event)}
      >
      </md-input>`;
        }
        renderSelectAllCheckbox() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <md-checkbox
          tabIndex="0"
          class="filter-tab-checkbox select-all-checkbox"
          ?checked=${this.isSelectAllChecked()}
          @checkbox-change=${(event) => this.handleFiltering(event, true)}
          >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.selectAll")}</md-checkbox
        >
      `;
        }
        renderVirtualColumnRowDataCheckbox() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <lit-virtualizer
          class="virtual-scroll"
          .renderItem=${this.renderColumnData}
          .items=${this.filteredColumnRowData}
        ></lit-virtualizer>
      `;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div class="filter-tab-wrapper">
          <div class="filter-tab-header">${this.renderSearchInput()} ${this.renderSelectAllCheckbox()}</div>
          <div class="filter-tab-checkbox-group-wrapper">${this.renderVirtualColumnRowDataCheckbox()}</div>
          <div id="live-region" class="sr-only" aria-live="polite"></div>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Object })
    ], Element.prototype, "columnParams", null);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Object })
    ], Element.prototype, "columnFilterModel", null);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "columnRowData", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "columnRowDataObj", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "filteredColumnRowData", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.query)(".search-filter-input")
    ], Element.prototype, "searchInputElement", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.query)("#live-region")
    ], Element.prototype, "liveRegion", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("filter-column-menu")
    ], Element);
    FilterColumnMenu.Element = Element;
})(FilterColumnMenu || (FilterColumnMenu = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/ColumnMenu/PinColumnMenu.ts":
/*!**************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/ColumnMenu/PinColumnMenu.ts ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PinColumnMenu: () => (/* binding */ PinColumnMenu)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ColumnMenu_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ColumnMenu.scss */ "./src/components/TeamPerformanceWidget/ColumnMenu/ColumnMenu.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var PinColumnMenu;
(function (PinColumnMenu) {
    /**
     * @element pin-column-menu
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this.pinnedDirection = ["left", "right", null];
            this.coulmnPinnedDirection = null;
        }
        get columnParams() {
            return this._columnParams;
        }
        set columnParams(value) {
            const oldValue = this._columnParams;
            this._columnParams = value;
            this.requestUpdate("columnParams", oldValue);
        }
        static get styles() {
            return _ColumnMenu_scss__WEBPACK_IMPORTED_MODULE_2__["default"];
        }
        get columnPinnedDirectionIndex() {
            return this.pinnedDirection.indexOf(this.coulmnPinnedDirection);
        }
        getColumnPinnedDirectionValue(pinnedType) {
            var _a;
            return (_a = pinnedType === null || pinnedType === void 0 ? void 0 : pinnedType.toString()) !== null && _a !== void 0 ? _a : "";
        }
        handlePinnedDirectionChange(pinDirection) {
            var _a, _b, _c;
            if (!this.columnParams) {
                return;
            }
            (_a = this.columnParams.api) === null || _a === void 0 ? void 0 : _a.setColumnsPinned([this.columnParams.column.getColId()], pinDirection);
            (_b = this.columnParams.api) === null || _b === void 0 ? void 0 : _b.hidePopupMenu();
            this.coulmnPinnedDirection = (_c = this.columnParams.column) === null || _c === void 0 ? void 0 : _c.getPinned();
        }
        getCheckBoxLabel(pinDirection) {
            switch (pinDirection) {
                case "left":
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.pinToLeft");
                case "right":
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.pinToRight");
                default:
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.none");
            }
        }
        connectedCallback() {
            var _a, _b;
            super.connectedCallback();
            this.coulmnPinnedDirection = (_b = (_a = this.columnParams) === null || _a === void 0 ? void 0 : _a.column) === null || _b === void 0 ? void 0 : _b.getPinned();
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="pin-tab-wrapper">
          <md-radiogroup
            group-label="group_process"
            checked=${this.columnPinnedDirectionIndex}
            @radio-change=${(event) => this.handlePinnedDirectionChange(event.detail.selected)}
          >
            ${this.pinnedDirection.map((pinDirection) => {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
                <md-radio
                  class="pin-tab-radio-btn"
                  slot="radio"
                  value=${this.getColumnPinnedDirectionValue(pinDirection)}
                >
                  ${this.getCheckBoxLabel(pinDirection)}
                </md-radio>
              `;
            })}
          </md-radiogroup>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
    ], Element.prototype, "columnParams", null);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Array })
    ], Element.prototype, "pinnedDirection", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "coulmnPinnedDirection", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("pin-column-menu")
    ], Element);
    PinColumnMenu.Element = Element;
})(PinColumnMenu || (PinColumnMenu = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/ContextMenu.ts":
/*!*************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/ContextMenu.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TeamPerformanceContextMenu: () => (/* binding */ TeamPerformanceContextMenu)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _CellRenderer_ActionRenderer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./CellRenderer/ActionRenderer */ "./src/components/TeamPerformanceWidget/CellRenderer/ActionRenderer.ts");
/* harmony import */ var _contextMenu_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./contextMenu.scss */ "./src/components/TeamPerformanceWidget/contextMenu.scss");
/* harmony import */ var _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./TeamPerformanceUtils */ "./src/components/TeamPerformanceWidget/TeamPerformanceUtils.ts");
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./Utils */ "./src/components/TeamPerformanceWidget/Utils.ts");
/* harmony import */ var _utils_WebexChat_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./utils/WebexChat.utils */ "./src/components/TeamPerformanceWidget/utils/WebexChat.utils.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









const cannotMonitorConsult = "app:tpw.cannotMonitorConsult";
const cannotMonitorWrapUp = "app:tpw.cannotMonitorWrapUp";
const cannotMonitorWrapUpAssistance = "app:tpw.cannotMonitorWrapUpAssistance";
const cannotMonitorPostCall = "app:tpw:cannotMonitorPostCall";
const reviewAndMonitor = "app:tpw.reviewAndMonitor";
const review = "app:tpw.review";
var TeamPerformanceContextMenu;
(function (TeamPerformanceContextMenu) {
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.isOpen = false;
            this.contextMenuList = [];
            this.listItems = [];
            this.isMCMEnabled = false;
            this.isMPCorPersistEnabled = false;
            this.isPostCallEnabled = false;
            this.webexEnabled = false;
            this.isSupervisorySendMessageEnabled = false;
            this.agentId = "";
            this.isSameSupervisorBarged = () => {
                return this.actionCellConfigs.isSupervisorMonitoring && this.actionCellConfigs.isBarged;
            };
            this.getIsMonitoring = () => {
                return (this.actionCellConfigs.monitoredBy &&
                    this.actionCellConfigs.monitoredBy !== "" &&
                    this.actionCellConfigs.monitoredBy !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE);
            };
            this.getTooltipMessage = () => {
                if (this.isWrapUp) {
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(cannotMonitorWrapUp);
                }
                else if (this.isMainCallInPostCall) {
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(cannotMonitorPostCall);
                }
                else if (this.isWrapUpAssistance) {
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(cannotMonitorWrapUpAssistance);
                }
                else if (this.actionCellConfigs.isConsultCall) {
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(cannotMonitorConsult);
                }
                else if (this.isSameSupervisorBarged()) {
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.alreadyBargedIn");
                }
                else if (this.actionCellConfigs.isSupervisorMonitoring) {
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.alreadyMonitoring");
                }
                else if (this.isMCMEnabled) {
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(reviewAndMonitor);
                }
                else {
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(review);
                }
            };
            this.getReviewButton = (disabled = false) => {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-button
          id=${this.actionCellConfigs.agentId}
          aria-colindex="12"
          tabIndex="-1"
          class="aid-button btn-action"
          ariaLabel="${this.isMCMEnabled ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(reviewAndMonitor) : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(review)}"
          size="size-none"
          .disabled=${disabled}
          color="color-none"
          @click=${(event) => {
                    if (disabled) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                }}
        >
          <p class="rm-text ${disabled ? "disabled" : ""}">${this.isMCMEnabled ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(reviewAndMonitor) : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(review)}</p>
        </md-button>
      `;
            };
            this.getIsReviewAndMonitorTooltipNeeded = () => {
                return ((!this.actionCellConfigs.isSupervisorMonitoring &&
                    this.actionCellConfigs.isReviewAndMonitorEnabled &&
                    !this.actionCellConfigs.onActiveCall) ||
                    this.actionCellConfigs.isConsultCall ||
                    this.isWrapUp ||
                    this.isWrapUpAssistance ||
                    this.isMainCallInPostCall ||
                    this.isSameSupervisorBarged() ||
                    this.actionCellConfigs.isSupervisorMonitoring);
            };
            this.renderReviewAndMonitorWrapper = () => {
                // This Tooltip scanerio need to validate...
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="${`review-monitor-wrapper list `}">
          ${this.getIsReviewAndMonitorTooltipNeeded()
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
                <md-tooltip class="aid-tooltip" message="${this.getTooltipMessage()}" placement="top">
                  ${this.getReviewButton(this.actionCellConfigs.isConsultCall ||
                        this.isWrapUp ||
                        this.isWrapUpAssistance ||
                        this.isMainCallInPostCall ||
                        this.isSameSupervisorBarged() ||
                        this.actionCellConfigs.isSupervisorMonitoring)}
                </md-tooltip>
              `
                    : this.getReviewButton(true)}
        </div>
      `;
            };
            this.webExMessageError = () => {
                var _a, _b;
                const agentEmail = (_b = (_a = this.actionCellConfigs) === null || _a === void 0 ? void 0 : _a.agentEmail) !== null && _b !== void 0 ? _b : "";
                return (this.actionCellConfigs.isWebExSendingMessageError ||
                    (0,_utils_WebexChat_utils__WEBPACK_IMPORTED_MODULE_8__.getPersistedError)(this.actionCellConfigs.agentName, agentEmail));
            };
            this.handleAidModal = () => {
                var _a, _b, _c;
                const selectChatElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-list-item.review-and-monitor");
                if (selectChatElement) {
                    const mdButton = selectChatElement === null || selectChatElement === void 0 ? void 0 : selectChatElement.querySelector("md-button");
                    if (mdButton) {
                        const isReviewAndMonitorDisabled = (_c = (_b = mdButton.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("button")) === null || _c === void 0 ? void 0 : _c.hasAttribute("disabled");
                        if (isReviewAndMonitorDisabled) {
                            return false;
                        }
                    }
                }
                this.dispatchEvent((0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_6__.createGenericEvent)(_constants__WEBPACK_IMPORTED_MODULE_0__.HANDLE_AID_MODAL_EVENT, {
                    agentId: this.actionCellConfigs.agentId
                }));
                return true;
            };
            this.handleSendMessage = () => {
                var _a;
                const selectChatElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-list-item.webex-send-message");
                if (selectChatElement) {
                    this.dispatchEvent((0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_6__.createGenericEvent)(_constants__WEBPACK_IMPORTED_MODULE_0__.HANDLE_WEBEX_CHAT_EVENT, {
                        event: selectChatElement
                    }));
                }
            };
            this.handleAgentStateChange = () => {
                var _a, _b;
                const selectChatElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-list-item.agent-state-change");
                this.dispatchEvent((0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_6__.createGenericEvent)(_constants__WEBPACK_IMPORTED_MODULE_0__.HANDLE_STATE_CHANGE_EVENT, {
                    event: selectChatElement,
                    agentId: (_b = this.actionCellConfigs) === null || _b === void 0 ? void 0 : _b.agentId
                }));
            };
            this.handleSkillProfileChange = () => {
                var _a, _b;
                const selectSkillProfileElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-list-item.skill-profile-change");
                this.dispatchEvent((0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_6__.createGenericEvent)(_constants__WEBPACK_IMPORTED_MODULE_0__.HANDLE_SKILL_PROFILE_CHANGE_EVENT, {
                    event: selectSkillProfileElement,
                    agentId: (_b = this.actionCellConfigs) === null || _b === void 0 ? void 0 : _b.agentId
                }));
            };
            this.handleAgentSignout = () => {
                var _a, _b;
                const selectChatElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-list-item.agent-signout");
                this.dispatchEvent((0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_6__.createGenericEvent)(_constants__WEBPACK_IMPORTED_MODULE_0__.HANDLE_AGENT_SIGNOUT_EVENT, {
                    event: selectChatElement,
                    agentId: (_b = this.actionCellConfigs) === null || _b === void 0 ? void 0 : _b.agentId
                }));
            };
            this.handleSelection = (selected) => {
                const components = this.getComponents();
                if (components[selected]) {
                    if (components[selected] === _CellRenderer_ActionRenderer__WEBPACK_IMPORTED_MODULE_4__.REVIEW_AND_MONITOR) {
                        this.handleAidModal();
                    }
                    else if (components[selected] === _CellRenderer_ActionRenderer__WEBPACK_IMPORTED_MODULE_4__.SEND_MESSAGE) {
                        this.handleSendMessage();
                    }
                    else if (components[selected] === _CellRenderer_ActionRenderer__WEBPACK_IMPORTED_MODULE_4__.AGENT_STATE_CHANGE) {
                        this.handleAgentStateChange();
                    }
                    else if (components[selected] === _CellRenderer_ActionRenderer__WEBPACK_IMPORTED_MODULE_4__.SKILL_PROFILE_CHANGE) {
                        this.handleSkillProfileChange();
                    }
                    else if (components[selected] === _CellRenderer_ActionRenderer__WEBPACK_IMPORTED_MODULE_4__.SIGNOUT_AGENT) {
                        this.handleAgentSignout();
                    }
                }
                return true;
            };
            this.isAgentStateDisabled = () => {
                return this.actionCellConfigs.agentId === this.actionCellConfigs.supervisorId;
            };
            this.isWebexChatDisabled = () => {
                if (this.isSupervisorySendMessageEnabled) {
                    return (this.actionCellConfigs.agentId === this.actionCellConfigs.supervisorId ||
                        this.actionCellConfigs.agentEmail === "");
                }
                // Disable webex chat
                return true;
            };
            this.getComponents = () => {
                const isMonitoring = this.getIsMonitoring();
                const contextMenuList = Array.isArray(this.contextMenuList) ? this.contextMenuList : [];
                if (isMonitoring) {
                    return [_CellRenderer_ActionRenderer__WEBPACK_IMPORTED_MODULE_4__.REVIEW_AND_MONITOR, ...contextMenuList];
                }
                else {
                    return contextMenuList;
                }
            };
            this.focusLitItem = () => {
                var _a, _b, _c, _d, _e;
                const listItem = (_a = this.list) === null || _a === void 0 ? void 0 : _a.querySelector("md-list-item:not([disabled])");
                listItem === null || listItem === void 0 ? void 0 : listItem.focus();
                // Set the selected and activated index based on the list-item
                const listItems = (_b = this.list) === null || _b === void 0 ? void 0 : _b.querySelectorAll("md-list-item");
                const index = (_c = Array.from(listItems)) === null || _c === void 0 ? void 0 : _c.findIndex((it) => !it.disabled);
                if (index >= 0) {
                    (_d = this.list) === null || _d === void 0 ? void 0 : _d.setAttribute("activated", `${index}`);
                    (_e = this.list) === null || _e === void 0 ? void 0 : _e.setAttribute("selected", `${index}`);
                }
            };
            this.renderSpinner = () => {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` <md-spinner size="14"></md-spinner> `;
            };
            this.renderErrorElement = () => {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="error-icon">
          <md-icon slot="icon" name="icon-priority-active-two_12"></md-icon>
        </div>
      `;
            };
            this.renderComponentName = (label, isDisabled, isLoading, isError, subMenu = false) => {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="list-type-container">
          <div class="list-text-wrapper">
            <p class="list-text ${isDisabled ? "disabled" : ""}">
              ${label}
            </p>

            ${isLoading ? this.renderSpinner() : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
            ${!isLoading && isError ? this.renderErrorElement() : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}

          </div>
          ${subMenu ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` <md-icon class="list-arrow-icon" iconSet="momentumDesign" name="arrow-right-bold"></md-icon> ` : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
          </div>
        </div>
      `;
            };
            this.handleReviewMonitorDisabled = () => {
                const { isReviewAndMonitorEnabled, isConsultCall, isSupervisorMonitoring, onActiveCall } = this.actionCellConfigs;
                if (!isReviewAndMonitorEnabled) {
                    return !isConsultCall;
                }
                else if (isSupervisorMonitoring) {
                    return false;
                }
                else if (onActiveCall) {
                    return true;
                }
                return false;
            };
            this.getLabelOnReviewAndMonitor = () => {
                const defaultLabel = this.isMCMEnabled ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(reviewAndMonitor) : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(review);
                if (this.actionCellConfigs.isConsultCall) {
                    return `${defaultLabel} - ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(cannotMonitorConsult)}`;
                }
                return defaultLabel;
            };
            this.isDisabledCursor = () => {
                return (this.isSameSupervisorBarged() ||
                    this.actionCellConfigs.isSupervisorMonitoring ||
                    this.actionCellConfigs.isConsultCall);
            };
            this.renderReviewAndMonitor = () => {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-list-item
          class=${`review-and-monitor  ${this.isDisabledCursor() ? "disabled-cursor" : ""} `}
          .disabled="${this.handleReviewMonitorDisabled()}"
          aria-label="${this.getLabelOnReviewAndMonitor()}"
          slot="list-item"
          role="menuitem"
        >
          ${this.renderReviewAndMonitorWrapper()}
        </md-list-item>
      `;
            };
            this.renderSendMessage = () => {
                const isDisabled = this.isWebexChatDisabled();
                const label = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:notifications.webexChatSendMessage");
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-list-item class="webex-send-message" .disabled="${isDisabled}" slot="list-item" role="menuitem">
          ${this.renderComponentName(label, isDisabled, this.actionCellConfigs.isWebExSendingMessage || false, this.webExMessageError())}
        </md-list-item>
      `;
            };
            this.renderAgentStateChange = () => {
                const isDisabled = this.isAgentStateDisabled();
                const label = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.stateChange.default");
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-list-item class="agent-state-change" .disabled="${isDisabled}" slot="list-item" role="menuitem">
          ${this.renderComponentName(label, false, this.actionCellConfigs.agentStateChanging || false, this.actionCellConfigs.agentStateChangeError || false, true)}
        </md-list-item>
      `;
            };
            this.renderSkillProfileChange = () => {
                const label = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.skillProfile.default");
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-list-item class="skill-profile-change" slot="list-item" role="menuitem">
          ${this.renderComponentName(label, false, false, false, false)}
        </md-list-item>
      `;
            };
            this.renderSignoutAgent = () => {
                const isDisabled = (0,_Utils__WEBPACK_IMPORTED_MODULE_7__.isAgentSignoutDisabled)(this.actionCellConfigs);
                const tooltipText = (0,_Utils__WEBPACK_IMPORTED_MODULE_7__.getSignoutTooltip)(this.actionCellConfigs, isDisabled);
                const label = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.signoutAgentMenu");
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-list-item
          class="agent-signout"
          slot="list-item"
          aria-label=${tooltipText}
          .disabled=${isDisabled}
          role="menuitem"
        >
          <md-tooltip message=${tooltipText} placement="left">
            ${this.renderComponentName(label, false, this.actionCellConfigs.signoutPending || false, this.actionCellConfigs.signoutError || false, false)}
          </md-tooltip>
        </md-list-item>
      `;
            };
            // Render the list items
            this.renderElements = (componentName) => {
                switch (componentName) {
                    case _CellRenderer_ActionRenderer__WEBPACK_IMPORTED_MODULE_4__.REVIEW_AND_MONITOR:
                        return this.renderReviewAndMonitor();
                    case _CellRenderer_ActionRenderer__WEBPACK_IMPORTED_MODULE_4__.SEND_MESSAGE:
                        return this.renderSendMessage();
                    case _CellRenderer_ActionRenderer__WEBPACK_IMPORTED_MODULE_4__.AGENT_STATE_CHANGE:
                        return this.renderAgentStateChange();
                    case _CellRenderer_ActionRenderer__WEBPACK_IMPORTED_MODULE_4__.SKILL_PROFILE_CHANGE:
                        return this.renderSkillProfileChange();
                    case _CellRenderer_ActionRenderer__WEBPACK_IMPORTED_MODULE_4__.SIGNOUT_AGENT:
                        return this.renderSignoutAgent();
                    default:
                        return lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing;
                }
            };
        }
        static get styles() {
            return _contextMenu_scss__WEBPACK_IMPORTED_MODULE_5__["default"];
        }
        get isWrapUp() {
            return this.isMPCorPersistEnabled && this.actionCellConfigs.isWrapUp;
        }
        get isWrapUpAssistance() {
            return this.isMPCorPersistEnabled && !this.isPostCallEnabled && this.actionCellConfigs.isWrapUpAssistance;
        }
        get isMainCallInPostCall() {
            return this.isMPCorPersistEnabled && this.isPostCallEnabled && this.actionCellConfigs.isMainCallInPostCall;
        }
        updated(_changedProperties) {
            super.updated(_changedProperties);
            if ((_changedProperties.has("agentId") ||
                _changedProperties.has("isOpen") ||
                _changedProperties.has("contextMenuList")) &&
                this.isOpen &&
                this.list) {
                setTimeout(() => {
                    this.focusLitItem();
                }, 0);
            }
        }
        render() {
            const items = this.getComponents();
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="overlay-content kebab-menu-container">
          <md-list
            label="Kebab Menu Items"
            @list-item-change="${(event) => {
                this.handleSelection(event.detail.selected);
            }}"
          >
            ${items.map((componentName) => {
                return this.renderElements(componentName);
            })}
          </md-list>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "actionCellConfigs", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Array })
    ], Element.prototype, "contextMenuList", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "listItems", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isMCMEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isMPCorPersistEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isPostCallEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "webexEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ attribute: false })
    ], Element.prototype, "handleWebexChat", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isSupervisorySendMessageEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "agentId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.query)("md-list")
    ], Element.prototype, "list", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-tpw-context-menu")
    ], Element);
    TeamPerformanceContextMenu.Element = Element;
})(TeamPerformanceContextMenu || (TeamPerformanceContextMenu = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/GridConfig.ts":
/*!************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/GridConfig.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   gridConfig: () => (/* binding */ gridConfig)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _CellRenderer_ActionRenderer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./CellRenderer/ActionRenderer */ "./src/components/TeamPerformanceWidget/CellRenderer/ActionRenderer.ts");
/* harmony import */ var _CellRenderer_AgentStateRenderer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./CellRenderer/AgentStateRenderer */ "./src/components/TeamPerformanceWidget/CellRenderer/AgentStateRenderer.ts");
/* harmony import */ var _CellRenderer_DurationRenderer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./CellRenderer/DurationRenderer */ "./src/components/TeamPerformanceWidget/CellRenderer/DurationRenderer.ts");
/* harmony import */ var _CellRenderer_GroupRowInnerRenderer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./CellRenderer/GroupRowInnerRenderer */ "./src/components/TeamPerformanceWidget/CellRenderer/GroupRowInnerRenderer.ts");
/* harmony import */ var _CellRenderer_NameRenderer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./CellRenderer/NameRenderer */ "./src/components/TeamPerformanceWidget/CellRenderer/NameRenderer.ts");
/* harmony import */ var _ColumnMenu_ColumnMenuRenderer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./ColumnMenu/ColumnMenuRenderer */ "./src/components/TeamPerformanceWidget/ColumnMenu/ColumnMenuRenderer.ts");
/* harmony import */ var _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./TeamPerformanceUtils */ "./src/components/TeamPerformanceWidget/TeamPerformanceUtils.ts");
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./Utils */ "./src/components/TeamPerformanceWidget/Utils.ts");
/* harmony import */ var _utils_KeyboardNavigationUtils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./utils/KeyboardNavigationUtils */ "./src/components/TeamPerformanceWidget/utils/KeyboardNavigationUtils.ts");












const gridConfig = (configs, isServerSidePaginated = false) => {
    const AGENT_NAME = `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.AgentName")}`;
    function template(header, tooltip, isAgentNameColumn = false) {
        const ariaLabel = `${header ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(header) : ""} ${tooltip ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(tooltip) : ""}`.trim();
        return `<div class="ag-cell-label-container" role="presentation">
        ${isServerSidePaginated && isAgentNameColumn
            ? `<md-tooltip message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.ColumnHeaderWarning")}" placement="bottom">`
            : ``}
          <div data-ref="eLabel" class="ag-header-cell-label" role="button">
            <span data-ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>
            <span data-ref="eText" class="ag-header-cell-text" role="columnheader" ${ariaLabel ? `aria-label="${ariaLabel}"` : ""}></span>
            <span data-ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.ascendingAriaLabel")}"></span>
            <span data-ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.descendingAriaLabel")}"></span>
            <span data-ref="eSortNone" class="ag-header-icon ag-sort-none-icon" aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.noSortAriaLabel")}"></span>
          </div>
        ${isServerSidePaginated && isAgentNameColumn ? `</md-tooltip>` : ``}
        <span data-ref="eFilter" class="ag-header-icon ag-filter-icon" aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnHeaderFilterIconLabel")}"></span>
        <span data-ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnHeaderFilterMenuAriaLabel")}" role="button"></span>
        <span data-ref="eFilterButton" class="ag-header-icon ag-header-cell-filter-button" aria-hidden="true"></span>
      </div>`;
    }
    return {
        components: {
            actionBtnsCellRenderer: _CellRenderer_ActionRenderer__WEBPACK_IMPORTED_MODULE_3__["default"],
            nameRenderer: _CellRenderer_NameRenderer__WEBPACK_IMPORTED_MODULE_7__["default"],
            columnMenuRenderer: _ColumnMenu_ColumnMenuRenderer__WEBPACK_IMPORTED_MODULE_8__["default"],
            groupRowInnerRenderer: _CellRenderer_GroupRowInnerRenderer__WEBPACK_IMPORTED_MODULE_6__["default"],
            durationRenderer: _CellRenderer_DurationRenderer__WEBPACK_IMPORTED_MODULE_5__["default"],
            agentStateRenderer: _CellRenderer_AgentStateRenderer__WEBPACK_IMPORTED_MODULE_4__["default"]
        },
        groupDisplayType: "groupRows",
        groupRowRendererParams: {
            innerRenderer: "groupRowInnerRenderer",
            suppressCount: true
        },
        pagination: false,
        rowBuffer: 20,
        suppressDragLeaveHidesColumns: true,
        suppressScrollOnNewData: true,
        suppressContextMenu: true,
        overlayLoadingTemplate: `<agentx-wc-widget-loader></agentx-wc-widget-loader>`,
        overlayNoRowsTemplate: `<agentx-wc-tpw-empty-grid is-error="${configs().isError ? "1" : "0"}"></agentx-wc-tpw-empty-grid>`,
        defaultColDef: {
            enableCellChangeFlash: false,
            resizable: true,
            enablePivot: false,
            enableRowGroup: true,
            enableValue: true,
            menuTabs: ["filterMenuTab"],
            sortable: true,
            rowGroup: false,
            sort: undefined,
            minWidth: 88,
            suppressKeyboardEvent: _utils_KeyboardNavigationUtils__WEBPACK_IMPORTED_MODULE_11__.suppressKeyboardEvent,
            suppressHeaderKeyboardEvent: _utils_KeyboardNavigationUtils__WEBPACK_IMPORTED_MODULE_11__.suppressHeaderKeyboardEvent,
            suppressHeaderFilterButton: true
        },
        columnMenu: "legacy",
        icons: {
            menu: '<md-icon name="settings-bold" iconSet="momentumDesign" size="16" class="settings-icon"></md-icon>',
            menuAlt: '<md-icon name="settings-bold" iconSet="momentumDesign" size="16" class="settings-icon"></md-icon>',
            filter: '<md-icon name="filter-bold" iconSet="momentumDesign" size="16" class="filter-icon"></md-icon>',
            sortAscending: `<div class="sorted up">
        <md-icon name="sort-descending-bold" iconSet="momentumDesign" size="16"></md-icon>
      </div>`,
            sortDescending: `<div class="sorted down">
        <md-icon name="sort-ascending-bold" iconSet="momentumDesign" size="16"></md-icon>
      </div>`,
            groupContracted: '<md-icon name="plus-bold" iconSet="momentumDesign" size="16" class="icon-group"></md-icon>',
            groupExpanded: '<md-icon name="minus-bold" iconSet="momentumDesign" size="16" class="icon-group"></md-icon>',
            clipboardCopy: '<md-icon name="copy-bold" iconSet="momentumDesign" size="16" class="icon-copy_16"></md-icon>'
        },
        alwaysShowHorizontalScroll: true,
        alwaysShowVerticalScroll: false,
        tabToNextCell: _utils_KeyboardNavigationUtils__WEBPACK_IMPORTED_MODULE_11__.onTabToNextCell,
        suppressAnimationFrame: true,
        animateRows: false,
        columnDefs: [
            {
                headerName: AGENT_NAME,
                headerComponentParams: {
                    template: template(AGENT_NAME, AGENT_NAME, true)
                },
                getQuickFilterText: (params) => {
                    return params.value ? params.value.agentName : "";
                },
                field: "agentNameDetails",
                keyCreator: (params) => params.value.agentName,
                resizable: true,
                cellClass: "suppress-movable-col",
                cellRenderer: "nameRenderer",
                filter: "columnMenuRenderer",
                sortable: true,
                comparator: _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_9__.agentNameComparator,
                filterParams: {
                    suppressFilterTab: false,
                    showWarningTooltip: isServerSidePaginated,
                    valueGetter: (params) => {
                        return params.data.agentName;
                    }
                },
                headerTooltip: AGENT_NAME,
                tooltipComponentParams: { color: "#ececec" },
                pinned: "left",
                lockPinned: true,
                tooltipField: "agentName",
                width: 300,
                hide: false,
                suppressMovable: true,
                lockPosition: true
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.AgentState")}`,
                headerTooltip: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.AgentState")}`,
                field: "agentState",
                sortable: !isServerSidePaginated,
                resizable: true,
                filter: "columnMenuRenderer",
                filterParams: {
                    suppressFilterTab: false,
                    showWarningTooltip: isServerSidePaginated,
                    valueGetter: (params) => {
                        return params.data.agentState;
                    }
                },
                cellRenderer: "agentStateRenderer",
                cellEditorParams: {
                    supervisorId: configs().supervisorId
                },
                comparator: _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_9__.stringComparator,
                tooltipValueGetter: (params) => {
                    var _a;
                    // CX-14895 : Available name is not showing in non-english languages when placing the cursor above the Agent Availability Status.
                    return (0,_Utils__WEBPACK_IMPORTED_MODULE_10__.localiseAvailableState)((_a = params === null || params === void 0 ? void 0 : params.value) !== null && _a !== void 0 ? _a : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE);
                },
                pinned: false,
                width: 200,
                hide: false,
                headerComponentParams: {
                    template: `${template()}`
                }
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.AgentStateDuration")}`,
                headerTooltip: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.AgentStateDurationToolTip")}`,
                field: "agentStateDuration",
                resizable: true,
                sortable: !isServerSidePaginated,
                cellRenderer: "durationRenderer",
                comparator: _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_9__.durationComparator,
                filter: "columnMenuRenderer",
                pinned: undefined,
                width: 200,
                hide: false,
                filterParams: {
                    suppressFilterTab: true
                },
                getQuickFilterText: () => {
                    return "";
                },
                headerComponentParams: {
                    template: `${template("app:tpw.AgentStateDuration", "app:tpw.AgentStateDurationToolTip")}`
                }
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.PhoneNumber")}`,
                headerTooltip: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.PhoneNumber")}`,
                field: "phoneNumber",
                sortable: !isServerSidePaginated,
                resizable: true,
                filter: "columnMenuRenderer",
                comparator: _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_9__.stringComparator,
                pinned: undefined,
                tooltipField: "phoneNumber",
                width: 200,
                hide: false,
                headerComponentParams: {
                    template: `${template()}`
                },
                filterParams: {
                    suppressFilterTab: false,
                    showWarningTooltip: isServerSidePaginated,
                    valueGetter: (params) => {
                        return params.data.phoneNumber;
                    }
                }
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.Site")}`,
                headerTooltip: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.Site")}`,
                field: "siteName",
                sortable: !isServerSidePaginated,
                resizable: true,
                filter: "columnMenuRenderer",
                comparator: _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_9__.stringComparator,
                tooltipField: "siteName",
                pinned: undefined,
                hide: false,
                width: 104,
                headerComponentParams: {
                    template: `${template()}`
                },
                filterParams: {
                    suppressFilterTab: false,
                    showWarningTooltip: isServerSidePaginated,
                    valueGetter: (params) => {
                        return params.data.siteName;
                    }
                }
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.Team")}`,
                headerTooltip: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.Team")}`,
                field: "teamName",
                sortable: !isServerSidePaginated,
                resizable: true,
                filter: "columnMenuRenderer",
                comparator: _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_9__.stringComparator,
                tooltipField: "teamName",
                pinned: undefined,
                hide: false,
                width: 160,
                headerComponentParams: {
                    template: `${template()}`
                },
                filterParams: {
                    suppressFilterTab: false,
                    showWarningTooltip: isServerSidePaginated,
                    valueGetter: (params) => {
                        return params.data.teamName;
                    }
                }
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.Channels")}`,
                headerTooltip: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.Channels")}`,
                field: "channelsName",
                sortable: !isServerSidePaginated,
                resizable: true,
                filter: "columnMenuRenderer",
                filterParams: {
                    suppressFilterTab: false,
                    showWarningTooltip: isServerSidePaginated,
                    valueGetter: (params) => {
                        return params.data.channelsName;
                    }
                },
                comparator: _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_9__.stringComparator,
                tooltipField: "channelsName",
                pinned: undefined,
                hide: true,
                sort: undefined,
                width: 130,
                headerComponentParams: {
                    template: `${template()}`
                }
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.ContactQueue")}`,
                headerTooltip: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.ContactQueue")}`,
                field: "contactQueueName",
                sortable: !isServerSidePaginated,
                resizable: true,
                filter: "columnMenuRenderer",
                filterParams: {
                    suppressFilterTab: false,
                    showWarningTooltip: isServerSidePaginated,
                    valueGetter: (params) => {
                        return params.data.contactQueueName;
                    }
                },
                comparator: _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_9__.stringComparator,
                tooltipField: "contactQueueName",
                pinned: undefined,
                hide: true,
                width: 130,
                headerComponentParams: {
                    template: `${template()}`
                }
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.ContactStatus")}`,
                headerTooltip: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.ContactStatus")}`,
                field: "contactStatus",
                sortable: !isServerSidePaginated,
                resizable: true,
                filter: "columnMenuRenderer",
                comparator: _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_9__.stringComparator,
                tooltipField: "contactStatus",
                pinned: undefined,
                width: 224,
                hide: false,
                filterParams: {
                    suppressFilterTab: false,
                    showWarningTooltip: isServerSidePaginated,
                    valueGetter: (params) => {
                        return params.data.contactStatus;
                    }
                },
                headerComponentParams: {
                    template: `${template()}`
                }
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.TimeInContactStatus")}`,
                headerTooltip: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.TimeInContactStatusToolTip")}`,
                field: "contactStatusTime",
                sortable: !isServerSidePaginated,
                resizable: true,
                filter: "columnMenuRenderer",
                comparator: _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_9__.durationComparator,
                cellRenderer: "durationRenderer",
                rowGroup: false,
                pinned: undefined,
                width: 224,
                hide: false,
                filterParams: {
                    suppressFilterTab: true
                },
                getQuickFilterText: () => {
                    return "";
                },
                headerComponentParams: {
                    template: `${template("app:tpw.TimeInContactStatus", "app:tpw.TimeInContactStatusToolTip")}`
                }
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.AgentInteractionTime")}`,
                headerTooltip: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.AgentInteractionTimeToolTip")}`,
                field: "agentInteractionTime",
                sortable: !isServerSidePaginated,
                resizable: true,
                cellRenderer: "durationRenderer",
                comparator: _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_9__.durationComparator,
                filter: "columnMenuRenderer",
                pinned: undefined,
                width: 224,
                hide: false,
                filterParams: {
                    suppressFilterTab: true
                },
                getQuickFilterText: () => {
                    return "";
                },
                headerComponentParams: {
                    template: `${template("app:tpw.AgentInteractionTime", "app:tpw.AgentInteractionTimeToolTip")}`
                }
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.TotalContactDuration")}`,
                headerTooltip: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.TotalContactDurationToolTip")}`,
                field: "totalContactDuration",
                sortable: !isServerSidePaginated,
                resizable: true,
                cellRenderer: "durationRenderer",
                comparator: _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_9__.durationComparator,
                filter: "columnMenuRenderer",
                pinned: undefined,
                width: 224,
                hide: false,
                filterParams: {
                    suppressFilterTab: true
                },
                getQuickFilterText: () => {
                    return "";
                },
                headerComponentParams: {
                    template: `${template("app:tpw.TotalContactDuration", "app:tpw.TotalContactDurationToolTip")}`
                }
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.SignInTime")}`,
                headerTooltip: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.SignInTime")}`,
                field: "loginTime",
                sortable: !isServerSidePaginated,
                resizable: true,
                filter: "columnMenuRenderer",
                tooltipField: "loginTime",
                comparator: _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_9__.dateComparator,
                pinned: undefined,
                width: 200,
                hide: false,
                sort: "asc",
                filterParams: {
                    suppressFilterTab: true
                },
                getQuickFilterText: () => {
                    return "";
                },
                headerComponentParams: {
                    template: `${template()}`
                }
            },
            ...(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.featureflag.isFeatureFlagEnabled(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_SKILL_PROFILE)
                ? [
                    {
                        headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.SkillProfile")}`,
                        headerTooltip: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.SkillProfile")}`,
                        field: "skillProfile",
                        sortable: !isServerSidePaginated,
                        resizable: true,
                        comparator: _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_9__.stringComparator,
                        filter: "columnMenuRenderer",
                        pinned: undefined,
                        width: 176,
                        hide: false,
                        headerComponentParams: {
                            template: `${template()}`
                        }
                    }
                ]
                : []),
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.Actions")}`,
                headerTooltip: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.Actions")}`,
                field: "actions",
                sortable: false,
                resizable: true,
                cellRenderer: "actionBtnsCellRenderer",
                cellClass: "action-class",
                cellEditorParams: configs,
                pinned: "right",
                lockPinned: true,
                width: 117,
                hide: false,
                suppressMovable: true,
                filter: "columnMenuRenderer",
                filterParams: {
                    suppressFilterTab: true
                },
                getQuickFilterText: () => {
                    return "";
                },
                headerComponentParams: {
                    template: `<div class="ag-cell-label-container" role="presentation">
            <div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
              <span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>
            </div>
            <span data-ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" role="button"></span>
          </div>`
                }
            }
        ]
    };
};


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/GridHeader/Customization/Customization.ts":
/*!****************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/GridHeader/Customization/Customization.ts ***!
  \****************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Customization: () => (/* binding */ Customization)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Utils */ "./src/components/TeamPerformanceWidget/Utils.ts");
/* harmony import */ var _GridHeader_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../GridHeader.scss */ "./src/components/TeamPerformanceWidget/GridHeader/GridHeader.scss");
/* harmony import */ var _GroupByCustomization__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./GroupByCustomization */ "./src/components/TeamPerformanceWidget/GridHeader/Customization/GroupByCustomization.ts");
/* harmony import */ var _ShowHideCustomization__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./ShowHideCustomization */ "./src/components/TeamPerformanceWidget/GridHeader/Customization/ShowHideCustomization.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};







var Customization;
(function (Customization) {
    /**
     * @element agentx-wc-tpw-customization
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.gridOptions = {};
            this.isServerSidePaginated = false;
            this.isModalOpen = false;
            this.visibleColumns = {};
            this.rowGroupedColumns = [];
            this.columnRowGroupChangedHandler = () => {
                this === null || this === void 0 ? void 0 : this.initializeRowGroupedColumns();
            };
            this.columnValueChangedHandler = () => {
                // reset visible columns.
                this.visibleColumns = {};
                this.initializeVisibleColumns();
            };
            this.handleVisibleColumnsUpdate = (event) => {
                this.visibleColumns = event.detail;
            };
        }
        static get styles() {
            return _GridHeader_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
        }
        initializeRowGroupedColumns() {
            var _a, _b;
            if (this.gridApi) {
                const rowGroupuColumns = (_b = (_a = this.gridApi.getRowGroupColumns()) === null || _a === void 0 ? void 0 : _a.map((column) => column.colId)) !== null && _b !== void 0 ? _b : [];
                const isChanged = (rowGroupuColumns.length === 0 && this.rowGroupedColumns.length === 0) === false;
                if (isChanged) {
                    this.rowGroupedColumns = rowGroupuColumns;
                }
            }
        }
        connectedCallback() {
            var _a, _b;
            super.connectedCallback();
            (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.addEventListener("columnRowGroupChanged", this.columnRowGroupChangedHandler);
            (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.addEventListener("gridColumnsChanged", this.columnValueChangedHandler);
            window.addEventListener("tpw-update-visible-columns", this.handleVisibleColumnsUpdate);
        }
        disconnectedCallback() {
            var _a, _b;
            super.disconnectedCallback();
            (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.removeEventListener("columnRowGroupChanged", this.columnRowGroupChangedHandler);
            (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.removeEventListener("gridColumnsChanged", this.columnValueChangedHandler);
            window.removeEventListener("tpw-update-visible-columns", this.handleVisibleColumnsUpdate);
        }
        initializeVisibleColumns() {
            if (Object.keys(this.visibleColumns).length === 0 && this.gridApi) {
                const columnsState = this.gridApi.getColumnState();
                columnsState === null || columnsState === void 0 ? void 0 : columnsState.forEach((column) => {
                    if (!_Utils__WEBPACK_IMPORTED_MODULE_3__.fixedColumns[column.colId]) {
                        this.visibleColumns[column.colId] = !column.hide;
                    }
                });
            }
        }
        updated(changedProperties) {
            const _super = Object.create(null, {
                updated: { get: () => super.updated }
            });
            return __awaiter(this, void 0, void 0, function* () {
                _super.updated.call(this, changedProperties);
                if (Object.keys(this.visibleColumns).length === 0) {
                    this.initializeRowGroupedColumns();
                    this.initializeVisibleColumns();
                }
            });
        }
        handleKeyPressed(e) {
            var _a, _b, _c, _d;
            if (e.code === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Enter || e.code === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Space) {
                (_d = (_c = (_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.children[0]) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector(".menu-trigger-button")) === null || _d === void 0 ? void 0 : _d.click();
            }
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-menu-overlay
          custom-width="154px"
          @menu-overlay-open=${() => {
                this.isModalOpen = true;
            }}
          @menu-overlay-close=${() => {
                this.isModalOpen = false;
            }}
          class="customization"
        >
          <md-button slot="menu-trigger" variant="ghost" ariaExpanded=${this.isModalOpen} class="customization-btn"
            ><md-icon slot="icon" aria-hidden="true" name="icon-settings_16"></md-icon
            ><span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.customization")}</span></md-button
          >
          <div class="customization-menu-overlay">
            <md-list label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.customization")}" role="menu">
              <md-list-item
                class="custom-list"
                slot="list-item"
                aria-haspopup="menu"
                role="menuitem"
                @keypress=${(e) => this.handleKeyPressed(e)}
              >
                <agentx-wc-tpw-show-hide
                  .gridApi=${this.gridApi}
                  .gridOptions=${this.gridOptions}
                  .visibleColumns=${this.visibleColumns}
                ></agentx-wc-tpw-show-hide>
              </md-list-item>

              <md-list-item
                class="custom-list"
                slot="list-item"
                aria-haspopup="menu"
                role="menuitem"
                .disabled=${this.isServerSidePaginated}
                @keypress=${(e) => this.handleKeyPressed(e)}
              >
                <agentx-wc-tpw-group-by
                  .gridApi=${this.gridApi}
                  .gridOptions=${this.gridOptions}
                  .visibleColumns=${this.visibleColumns}
                  .rowGroupedColumns=${this.rowGroupedColumns}
                  .isServerSidePaginated=${this.isServerSidePaginated}
                ></agentx-wc-tpw-group-by>
              </md-list-item>
            </md-list>
          </div>
        </md-menu-overlay>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "gridOptions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "gridApi", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isServerSidePaginated", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "isModalOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "visibleColumns", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "rowGroupedColumns", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-tpw-customization")
    ], Element);
    Customization.Element = Element;
})(Customization || (Customization = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/GridHeader/Customization/GroupByCustomization.ts":
/*!***********************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/GridHeader/Customization/GroupByCustomization.ts ***!
  \***********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   GroupByCustomization: () => (/* binding */ GroupByCustomization)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Utils */ "./src/components/TeamPerformanceWidget/Utils.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _GridHeader_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../GridHeader.scss */ "./src/components/TeamPerformanceWidget/GridHeader/GridHeader.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var GroupByCustomization;
(function (GroupByCustomization) {
    /**
     * @element agentx-wc-tpw-group-by
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_4__.MobxLitElement) {
        constructor() {
            super(...arguments);
            this.gridOptions = {};
            this.rowGroupedColumns = [];
            this.visibleColumns = {};
            this.isServerSidePaginated = false;
            this.groupBySearchTerm = "";
            this.handleSearch = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__.debounce)((event) => {
                var _a, _b;
                event.stopPropagation();
                const searchTerm = (_b = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.toLowerCase();
                this.groupBySearchTerm = searchTerm;
                setTimeout(() => {
                    this.handleFocus(event);
                }, 100);
                this.requestUpdate();
            }, 300);
        }
        static get styles() {
            return _GridHeader_scss__WEBPACK_IMPORTED_MODULE_7__["default"];
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.gridOptions = {};
            this.rowGroupedColumns = [];
            this.visibleColumns = {};
        }
        getColumnsHeaderName() {
            var _a, _b;
            return (_b = (_a = this.gridOptions) === null || _a === void 0 ? void 0 : _a.columnDefs) === null || _b === void 0 ? void 0 : _b.filter((column) => {
                var _a;
                return (_a = column.headerName) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase().includes(this.groupBySearchTerm);
            });
        }
        handleGroupByRowData(event, columnDetail) {
            var _a, _b;
            if (event) {
                const isCheckboxChecked = (0,_Utils__WEBPACK_IMPORTED_MODULE_3__.getIsCheckboxChecked)(event);
                if (isCheckboxChecked && columnDetail.field) {
                    this.rowGroupedColumns.push(columnDetail.field);
                }
                else {
                    this.rowGroupedColumns = this.rowGroupedColumns.filter((column) => {
                        return column !== columnDetail.field;
                    });
                }
                (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.setRowGroupColumns(this.rowGroupedColumns);
                if (columnDetail.field && this.visibleColumns[columnDetail.field] === false) {
                    (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.setColumnsVisible([columnDetail.field], false);
                }
            }
        }
        handleFocus(event) {
            var _a, _b;
            const searchInput = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".group-by-header-wrapper md-input");
            const input = (_b = searchInput === null || searchInput === void 0 ? void 0 : searchInput.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("input");
            if (searchInput && input) {
                input.focus({ focusVisible: true });
            }
            event.stopPropagation();
        }
        handleClick(event) {
            // the click event, unless stopped from bubbling up to parent, will fire that handler and cause focus issues
            event.stopPropagation();
        }
        renderMenuTriggerButton() {
            const buttonStyle = this.isServerSidePaginated ? `color: var(--md-gray-40);` : ``;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <style>
          .menu-trigger-button {
            ${buttonStyle};
          }
        </style>
        <div class="menu-trigger-button" slot="menu-trigger">
          <md-tooltip
            message=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.CustomizeMenuWarning")}
            placement="bottom"
            .disabled=${!this.isServerSidePaginated}
          >
            <span>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.groupBy")}</span>
          </md-tooltip>
          <div>
            <md-icon ariaHidden="true" slot="icon" name="arrow-right-bold" size="12" iconSet="momentumDesign"></md-icon>
          </div>
        </div>
      `;
        }
        render() {
            var _a;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-menu-overlay
          .disabled=${this.isServerSidePaginated}
          placement="right-start"
          size="small"
          @menu-overlay-open=${(event) => this.handleFocus(event)}
        >
          ${this.renderMenuTriggerButton()}
          <div class="overlay-container">
            <div class="group-by-header-wrapper">
              <md-input
                clear
                clearAriaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common:clear")}"
                htmlId="pillSearchInput"
                name="pillSearchInput"
                shape=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__.ifDefined)(!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled ? "pill" : undefined)}
                ?newMomentum=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled}
                placeholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.search")}
                ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.search")}
                searchable
                @input-change=${(event) => this.handleSearch(event)}
                @click=${(event) => this.handleClick(event)}
              >
              </md-input>
            </div>
            <div class="checkbox-container-group-column">
              <md-checkboxgroup group-label="column_titles">
                ${(_a = this.getColumnsHeaderName()) === null || _a === void 0 ? void 0 : _a.map((column) => {
                if (column.field && !_Utils__WEBPACK_IMPORTED_MODULE_3__.fixedColumns[column.field] && !_Utils__WEBPACK_IMPORTED_MODULE_3__.hiddenGroupColumn[column.field]) {
                    return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
                      <md-checkbox
                        class="checkbox"
                        slot="checkbox"
                        ?checked=${this.rowGroupedColumns.indexOf(column.field) !== -1}
                        @checkbox-change=${(event) => this.handleGroupByRowData(event, column)}
                        >${column.headerName}</md-checkbox
                      >
                    `;
                }
                else {
                    return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ``;
                }
            })}
              </md-checkboxgroup>
            </div>
          </div>
        </md-menu-overlay>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "gridOptions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "gridApi", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Array })
    ], Element.prototype, "rowGroupedColumns", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "visibleColumns", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isServerSidePaginated", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "groupBySearchTerm", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-tpw-group-by")
    ], Element);
    GroupByCustomization.Element = Element;
})(GroupByCustomization || (GroupByCustomization = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/GridHeader/Customization/ShowHideCustomization.ts":
/*!************************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/GridHeader/Customization/ShowHideCustomization.ts ***!
  \************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ShowHideCustomization: () => (/* binding */ ShowHideCustomization)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Utils */ "./src/components/TeamPerformanceWidget/Utils.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _GridHeader_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../GridHeader.scss */ "./src/components/TeamPerformanceWidget/GridHeader/GridHeader.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var ShowHideCustomization;
(function (ShowHideCustomization) {
    /**
     * @element agentx-wc-tpw-show-hide
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_4__.MobxLitElement) {
        constructor() {
            super(...arguments);
            this.gridOptions = {};
            this.visibleColumns = {};
            this.showHideSearchTerm = "";
            this.isSelectedAll = () => {
                return Object.values(this.visibleColumns).every(Boolean);
            };
            this.handleSearch = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__.debounce)((event) => {
                var _a, _b;
                const searchTerm = (_b = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.toLowerCase();
                this.showHideSearchTerm = searchTerm;
                setTimeout(() => {
                    this.handleFocus(event);
                }, 100);
                this.requestUpdate();
            }, 300);
        }
        static get styles() {
            return _GridHeader_scss__WEBPACK_IMPORTED_MODULE_7__["default"];
        }
        handleFocus(event) {
            var _a, _b;
            const searchInput = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".show-hide-header-wrapper md-input");
            const input = (_b = searchInput === null || searchInput === void 0 ? void 0 : searchInput.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("input");
            if (searchInput && input) {
                input.focus({ focusVisible: true });
            }
            event.stopPropagation();
        }
        handleClick(event) {
            // the click event, unless stopped from bubbling up to parent, will fire that handler and cause focus issues
            event.stopPropagation();
        }
        getColumnsHeaderName() {
            var _a, _b;
            return (_b = (_a = this.gridOptions) === null || _a === void 0 ? void 0 : _a.columnDefs) === null || _b === void 0 ? void 0 : _b.filter((column) => {
                var _a;
                return (_a = column.headerName) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase().includes(this.showHideSearchTerm);
            });
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.gridOptions = {};
            this.visibleColumns = {};
        }
        dispatchVisibleColumnsUpdateEvent() {
            this.dispatchEvent(new CustomEvent("tpw-update-visible-columns", {
                bubbles: true,
                composed: true,
                detail: this.visibleColumns
            }));
        }
        handleShowHideColumn(event, columnDetail) {
            var _a, _b, _c;
            if (event) {
                const isCheckboxChecked = (0,_Utils__WEBPACK_IMPORTED_MODULE_3__.getIsCheckboxChecked)(event);
                if (columnDetail === null || columnDetail === void 0 ? void 0 : columnDetail.field) {
                    this.visibleColumns[columnDetail.field] = isCheckboxChecked;
                    (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.setColumnsVisible([columnDetail.field], isCheckboxChecked);
                }
                else {
                    Object.keys(this.visibleColumns).forEach((column) => (this.visibleColumns[column] = isCheckboxChecked));
                    (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.setColumnsVisible(Object.keys(this.visibleColumns), isCheckboxChecked);
                }
                (_c = this.gridApi) === null || _c === void 0 ? void 0 : _c.sizeColumnsToFit();
                this.dispatchVisibleColumnsUpdateEvent();
                this.requestUpdate();
            }
        }
        renderMenuTriggerButton() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="menu-trigger-button" slot="menu-trigger">
          <span>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.showHide")}</span>
          <div>
            <md-icon ariaHidden="true" slot="icon" name="arrow-right-bold" size="12" iconSet="momentumDesign"></md-icon>
          </div>
        </div>
      `;
        }
        render() {
            var _a;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-menu-overlay
          max-height="344px"
          placement="right-start"
          size="small"
          @menu-overlay-open=${(event) => this.handleFocus(event)}
        >
          ${this.renderMenuTriggerButton()}
          <div class="overlay-container">
            <div class="show-hide-header-wrapper">
              <md-input
                clear
                clearAriaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common:clear")}"
                htmlId="pillSearchInput"
                name="pillSearchInput"
                shape=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__.ifDefined)(!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled ? "pill" : undefined)}
                ?newMomentum=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled}
                placeholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.search")}
                ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.search")}
                searchable
                @input-change=${(event) => this.handleSearch(event)}
                @click=${(event) => this.handleClick(event)}
              >
              </md-input>
              <md-checkbox
                class="checkbox select-all-checkbox"
                ?checked=${this.isSelectedAll()}
                @checkbox-change=${(event) => this.handleShowHideColumn(event)}
                >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.selectAll")}</md-checkbox
              >
            </div>
            <div class="checkbox-container-showhide-column">
              <md-checkboxgroup group-label="column_titles">
                ${(_a = this.getColumnsHeaderName()) === null || _a === void 0 ? void 0 : _a.map((column) => {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
                    <md-checkbox
                      class="checkbox"
                      slot="checkbox"
                      ?disabled=${!!(column.field && _Utils__WEBPACK_IMPORTED_MODULE_3__.fixedColumns[column.field])}
                      ?checked=${!!(column.field && (this.visibleColumns[column.field] || _Utils__WEBPACK_IMPORTED_MODULE_3__.fixedColumns[column.field]))}
                      @checkbox-change=${(event) => this.handleShowHideColumn(event, column)}
                      >${column.headerName}</md-checkbox
                    >
                  `;
            })}
              </md-checkboxgroup>
            </div>
          </div>
        </md-menu-overlay>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "gridOptions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "gridApi", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "visibleColumns", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "showHideSearchTerm", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-tpw-show-hide")
    ], Element);
    ShowHideCustomization.Element = Element;
})(ShowHideCustomization || (ShowHideCustomization = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/GridHeader/GridHeader.scss":
/*!*************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/GridHeader/GridHeader.scss ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.grid-header-container {
  padding: 1rem 1rem 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.grid-header-action-container {
  display: flex;
}

.search-wrapper {
  display: flex;
}

.grid-search-input::part(input) {
  width: 324px;
}

.result-count-wrapper {
  font-size: var(--font-size-medium);
  color: var(--md-secondary-text-color);
  margin: 4px 16px;
}

.customization::part(overlay-content) {
  overflow: visible;
}

.customization-menu-overlay {
  width: 100%;
  border-radius: var(--border-radius-medium);
  background-color: var(--md-secondary-white-bg-color);
}

.menu-trigger-button {
  padding: 0.5rem 1.25rem;
  justify-content: space-between;
  display: flex;
  font-size: var(--font-size-medium);
}

.overlay-container {
  width: 100%;
  background-color: var(--md-secondary-white-bg-color);
  display: block;
  overflow: hidden;
}

.show-hide-header-wrapper {
  padding: 1rem 1rem 0rem;
  border-bottom: 1px solid var(--md-primary-seperator-color);
  padding-bottom: 8px;
}

.group-by-header-wrapper {
  padding: 1rem 1rem 0rem;
}

.checkbox-container-group-column {
  padding: 0.5rem 1rem;
  overflow: auto;
  height: calc(100% - 80px);
}

.checkbox-container-showhide-column {
  padding: 0.5rem 1rem;
  overflow: auto;
  height: calc(100% - 130px);
}

.checkbox {
  margin: 0.5rem 0;
  padding-top: 3px;
  padding-bottom: 3px;
}

.select-all-checkbox {
  padding-right: 5.5rem;
}

.switch-view-button::part(button-group) {
  height: 2.25rem;
}

.reset-btn-wrapper .reset-submit {
  margin-left: 10px;
}
.reset-btn-wrapper .reset-submit,
.reset-btn-wrapper .reset-close {
  float: right;
}

.header-width {
  width: 100%;
}

.reset-header {
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
}

.conflict-warning {
  margin-right: 4px;
  vertical-align: middle;
}

.conflict-warning-info {
  margin-left: 4px;
  vertical-align: middle;
}

md-menu-overlay md-list md-list-item.custom-list::part(list-item) {
  display: block;
  padding: 0;
}

md-list-item.custom-list[disabled]::part(list-item) {
  pointer-events: auto;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/GridHeader/GridHeader.ts":
/*!***********************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/GridHeader/GridHeader.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableHeader: () => (/* binding */ TableHeader)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html/directives/style-map */ "lit-html/directives/style-map");
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Common_GridExportButton_GridExportButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Common/GridExportButton/GridExportButton */ "./src/components/Common/GridExportButton/GridExportButton.ts");
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Utils */ "./src/components/TeamPerformanceWidget/Utils.ts");
/* harmony import */ var _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./../TeamPerformanceUtils */ "./src/components/TeamPerformanceWidget/TeamPerformanceUtils.ts");
/* harmony import */ var _Customization_Customization__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./Customization/Customization */ "./src/components/TeamPerformanceWidget/GridHeader/Customization/Customization.ts");
/* harmony import */ var _GridHeader_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./GridHeader.scss */ "./src/components/TeamPerformanceWidget/GridHeader/GridHeader.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};











const EXCEL_SHEET_NAME = "Team Performance Details";
const FILENAME_PREFIX = "TPW";
var TableHeader;
(function (TableHeader) {
    /**
     * @element agentx-wc-tpw-grid-header
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
        constructor() {
            super(...arguments);
            this.gridOptions = {};
            this.displayedRowCount = 0;
            this.isServerSidePaginated = false;
            this.isModalOpen = false;
            this.debounceSearch = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.debounce)((searchTerm) => {
                this.dispatchSearchEvent({ searchTerm });
            }, 300);
        }
        static get styles() {
            return _GridHeader_scss__WEBPACK_IMPORTED_MODULE_10__["default"];
        }
        resetTable() {
            this.dispatchEvent(new CustomEvent("tpw-reset-table", {
                bubbles: true,
                composed: true,
                detail: { clearAllFilter: true }
            }));
            this.cancelModal();
        }
        showConfirmationModal() {
            this.isModalOpen = true;
        }
        cancelModal() {
            var _a, _b;
            this.isModalOpen = false;
            (_b = (_a = this.closeModalButton) === null || _a === void 0 ? void 0 : _a.shadowRoot.querySelector("button")) === null || _b === void 0 ? void 0 : _b.focus();
        }
        dispatchSearchEvent(detail) {
            this.dispatchEvent(new CustomEvent("tpw-search-updated", {
                bubbles: true,
                composed: true,
                detail
            }));
        }
        handleSearch(searchTerm) {
            var _a;
            if (!this.isServerSidePaginated) {
                (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.setGridOption("quickFilterText", searchTerm);
                this.dispatchSearchEvent(true);
            }
            else {
                this.debounceSearch(searchTerm);
            }
            this.requestUpdate();
        }
        getExportParams() {
            return {
                allColumns: true,
                processCellCallback(params) {
                    var _a, _b, _c;
                    if (params.value &&
                        params.value !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE &&
                        _Utils__WEBPACK_IMPORTED_MODULE_7__.durationColumns.includes((_a = params === null || params === void 0 ? void 0 : params.column) === null || _a === void 0 ? void 0 : _a.colId)) {
                        return (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_8__.getTimerValue)(params.value, true);
                    }
                    if (((_b = params === null || params === void 0 ? void 0 : params.column) === null || _b === void 0 ? void 0 : _b.colId) === _constants__WEBPACK_IMPORTED_MODULE_0__.ACTIONS) {
                        return "";
                    }
                    if (((_c = params === null || params === void 0 ? void 0 : params.column) === null || _c === void 0 ? void 0 : _c.colId) === "agentNameDetails") {
                        return params.value.agentName;
                    }
                    else {
                        return params.value;
                    }
                },
                processRowGroupCallback(params) {
                    var _a;
                    return `row group: ${(_a = params === null || params === void 0 ? void 0 : params.node) === null || _a === void 0 ? void 0 : _a.key}`;
                },
                processHeaderCallback(params) {
                    var _a;
                    if (((_a = params === null || params === void 0 ? void 0 : params.column) === null || _a === void 0 ? void 0 : _a.colId) === _constants__WEBPACK_IMPORTED_MODULE_0__.ACTIONS) {
                        return "";
                    }
                    else {
                        return params.column.userProvidedColDef.headerName;
                    }
                }
            };
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.gridOptions = {};
        }
        warningTooltip() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <md-tooltip message=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.agentWarning")} placement="bottom">
          <md-icon style="cursor: pointer" class="conflict-warning-info" name="icon-info_14"></md-icon>
        </md-tooltip>
      `;
        }
        renderIcon() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) ` <md-icon class="conflict-warning" name="icon-warning_14"></md-icon> `;
        }
        renderSearchRenderer() {
            const styles = { color: this.isServerSidePaginated ? "var(--md-yellow-70)" : "var(--md-secondary-text-color)" };
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div class="search-wrapper">
          <md-input
            htmlId="inputSearchClearPill"
            containerSize="small-12"
            placeholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.search")}
            ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.widgetTitle")}
            searchable
            clear
            clearAriaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common:clear")}"
            class="grid-search-input"
            @input-change=${(event) => this.handleSearch(event.detail.value)}
            newMomentum
          ></md-input>
          <span aria-live="polite" class="result-count-wrapper" style=${(0,lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_5__.styleMap)(styles)}>
            ${this.isServerSidePaginated ? this.renderIcon() : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}
            ${(0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_8__.getDisplayedRowCountText)(this.displayedRowCount)}
            ${this.isServerSidePaginated ? this.warningTooltip() : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}
          </span>
        </div>
      `;
        }
        renderResetTable() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <md-button class="reset-table" variant="ghost" @click=${() => this.showConfirmationModal()}
          ><md-icon slot="icon" name="reset_16" ariaHidden="true"></md-icon
          ><span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.resetTable")}</span></md-button
        >
        <md-modal
          applicationId="reset"
          ?show=${this.isModalOpen}
          id="actionModal"
          size="dialog"
          .hideFooter=${true}
          .hideHeader=${true}
          tabindex="${this.isModalOpen ? "0" : "-1"}"
          ?showclosebutton=${true}
          @close-modal=${this.cancelModal}
          .ariaLabelClose=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.closeResetToDefaultView")}
          aria-labelledby="reset-header"
          aria-label=""
        >
          <div slot="header" class="header-width">
            <span aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.resetToDefaultView")} id="reset-header" class="reset-header"
              >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.resetToDefaultView")}</span
            >
          </div>
          <div class="modal-body">
            <span>
              ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.resetConfirmationText")} <br />
              ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.resetConfirmationSubText")}
            </span>
          </div>
          <div slot="footer" class="reset-btn-wrapper">
            <md-button
              class="reset-submit"
              variant="primary"
              @click=${() => this.resetTable()}
              type="submit"
              ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.resetTable")}
            >
              ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.resetTable")}</md-button
            >
            <md-button
              class="reset-close"
              variant="secondary"
              ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.cancel")}
              type="reset"
              @click=${this.cancelModal}
            >
              ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.cancel")}</md-button
            >
          </div>
        </md-modal>
      `;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div class="grid-header-container">
          ${this.renderSearchRenderer()}
          <div class="grid-header-action-container">
            ${this.renderResetTable()}
            <agentx-wc-tpw-customization
              .gridApi=${this.gridApi}
              .gridOptions=${this.gridOptions}
              .isServerSidePaginated=${this.isServerSidePaginated}
            ></agentx-wc-tpw-customization>
            <agentx-wc-grid-export-button
              .gridApi=${this.gridApi}
              .exportParams=${this.getExportParams()}
              .sheetName=${EXCEL_SHEET_NAME}
              .exportFileNamePrefix=${FILENAME_PREFIX}
            >
              <md-button slot="menu-trigger" variant="ghost" class="download-btn">
                <md-icon slot="icon" name="export_16" ariaHidden="true"></md-icon>
                <span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.download")}</span>
              </md-button>
            </agentx-wc-grid-export-button>
          </div>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Object })
    ], Element.prototype, "gridOptions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Object })
    ], Element.prototype, "gridApi", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Number, reflect: true })
    ], Element.prototype, "displayedRowCount", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isServerSidePaginated", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "isModalOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.query)(".reset-table")
    ], Element.prototype, "closeModalButton", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-tpw-grid-header")
    ], Element);
    TableHeader.Element = Element;
})(TableHeader || (TableHeader = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/TeamPerformance.scss":
/*!*******************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/TeamPerformance.scss ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

* {
  /* BASE LEVEL < 100 */
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-index-tpw-header: 1;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-index-task-collapse-area: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-navigation-bar: 12;
  --z-index-task-list: 12;
  --z-index-wrap-up: 13;
  --z-index-sticky-header: 14;
  --z-index-shortcutkey-modal: 15;
  /* MID LEVEL FLOATING > 100 < 1000 */
  --z-index-notification: 150;
  /* SUPER LEVEL > 1000 */
  --z-index-modal: 1040;
  --z-index-popover: 1041;
  --z-index-callback-modal: 1042;
  /* This below order needs to be unchanged. Highest priority is for connection loss overlay,
         followed by error modal since error can occur during app load such as teams failure/register failure. */
  --z-index-app-full-overlay: 1050;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1200;
}

:host {
  --tpw-search-height: 66px;
  --tpw-h-padding: 12px;
}

.ag-theme-alpine,
.ag-theme-alpine-dark {
  --ag-row-hover-color: var(--grid-row-hover-color, rgba(33, 150, 243, 0.1));
  --ag-header-cell-moving-background-color: var(--ag-row-hover-color);
  --ag-input-focus-border-color: transparent;
}

:focus {
  box-shadow: none;
}

.tpw-wrapper {
  --ag-row-border-color: var(--list-focus-border-color);
  height: 100%;
}
.tpw-wrapper .grid-container {
  height: calc(100% - (var(--tpw-filter-height) + var(--tpw-search-height)));
  background-color: var(--md-glass-overlay-bg-color);
  border-top-left-radius: var(--grid-container-border-radius);
  border-top-right-radius: var(--grid-container-border-radius);
  padding-left: var(--grid-container-h-padding);
  padding-right: var(--grid-container-h-padding);
  padding-top: var(--grid-container-top-padding);
}
.tpw-wrapper .grid-container .ag-overlay-wrapper {
  display: block;
}
.tpw-wrapper .grid-container .ag-root-wrapper {
  border-right: 0px;
  border-left: 0px;
  border-bottom: 0px;
  border-color: var(--md-table-primary-bg-color);
  background-color: transparent;
}
.tpw-wrapper .grid-container .ag-row {
  border-color: var(--md-table-primary-bg-color);
  border-bottom: var(--md-table-cell-border-bottom);
  z-index: 0;
}
.tpw-wrapper .grid-container .ag-body-horizontal-scroll {
  overflow-x: auto;
  overflow-y: auto;
}
.tpw-wrapper .grid-container .ag-row,
.tpw-wrapper .grid-container .ag-body-viewport {
  background-color: transparent;
}
.tpw-wrapper .grid-container .ag-cell-focus {
  box-shadow: none;
}
.tpw-wrapper .grid-container .ag-cell-focus:focus-within {
  outline: 2px solid var(--list-focus-border-color) !important;
  outline-offset: -2px;
  border-radius: 4px;
}
.tpw-wrapper .grid-container .ag-cell,
.tpw-wrapper .grid-container .ag-pinned-left-header,
.tpw-wrapper .grid-container .ag-pinned-right-header,
.tpw-wrapper .grid-container .ag-pinned-right-cols-container {
  color: var(--md-primary-text-color);
  border: none;
  border-width: 1px;
  border-right-style: solid;
  border-color: var(--md-table-column-divider-color) !important;
}
.tpw-wrapper .grid-container .ag-cell.ag-cell-focus:focus-within,
.tpw-wrapper .grid-container .ag-pinned-left-header.ag-cell-focus:focus-within,
.tpw-wrapper .grid-container .ag-pinned-right-header.ag-cell-focus:focus-within,
.tpw-wrapper .grid-container .ag-pinned-right-cols-container.ag-cell-focus:focus-within {
  outline: 2px solid var(--list-focus-border-color) !important;
  outline-offset: -2px;
  border-radius: 4px;
}
.tpw-wrapper .grid-container .ag-cell {
  line-height: 38px;
  padding-left: var(--tpw-h-padding);
  padding-right: var(--tpw-h-padding);
}
.tpw-wrapper .grid-container .ag-cell-label-container {
  flex-direction: row !important;
  border: none;
  outline: none;
}
.tpw-wrapper .grid-container .ag-ltr .ag-cell-focus:not(.ag-cell-range-selected):focus-within,
.tpw-wrapper .grid-container .ag-ltr .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),
.tpw-wrapper .grid-container .ag-ltr .ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group,
.tpw-wrapper .grid-container .ag-ltr .ag-cell-range-single-cell,
.tpw-wrapper .grid-container .ag-ltr .ag-cell-range-single-cell.ag-cell-range-handle,
.tpw-wrapper .grid-container .ag-rtl .ag-cell-focus:not(.ag-cell-range-selected):focus-within,
.tpw-wrapper .grid-container .ag-rtl .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),
.tpw-wrapper .grid-container .ag-rtl .ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group,
.tpw-wrapper .grid-container .ag-rtl .ag-cell-range-single-cell,
.tpw-wrapper .grid-container .ag-rtl .ag-cell-range-single-cell.ag-cell-range-handle {
  border: none;
  outline: initial;
}
.tpw-wrapper .grid-container .ag-header {
  z-index: var(--z-index-tpw-header);
  border: none;
  border-width: 1px;
  border-right-style: var(--md-table-border-style);
  border-bottom-style: solid;
  color: var(--md-primary-text-color);
  background-color: var(--md-table-header-bg-color);
  border-color: var(--md-table-header-border-bottom-color);
}
.tpw-wrapper .grid-container .ag-header-cell-text {
  color: var(--md-table-header-text-color, var(--md-secondary-text-color));
  font-size: 14px;
  font-family: var(--brand-font-bold, "CiscoSansTT Regular"), sans-serif;
  font-weight: var(--brand-font-weight-bold, 400);
}
.tpw-wrapper .grid-container .ag-header-cell {
  padding-left: var(--tpw-h-padding);
  padding-right: var(--tpw-h-padding);
}
.tpw-wrapper .grid-container .ag-header-cell.ag-header-active {
  outline: 2px solid var(--list-focus-border-color) !important;
  outline-offset: -2px;
  border-radius: 4px;
}
.tpw-wrapper .grid-container .ag-header-cell.ag-header-active::after {
  border: none;
}
.tpw-wrapper .grid-container .ag-header-cell:focus {
  box-shadow: none;
}
.tpw-wrapper .grid-container .action-class {
  overflow: visible;
}
.tpw-wrapper .grid-container .ag-row.ag-row-focus {
  z-index: 1;
}
.tpw-wrapper .grid-container .ag-header-cell-resize {
  right: -5px;
}
.tpw-wrapper .grid-container .ag-pinned-left-header .ag-header-cell-resize {
  right: -4px;
}
.tpw-wrapper .grid-container .ag-header-cell-resize::after {
  height: 100%;
  top: 0;
  background-color: var(--md-table-primary-bg-color);
  width: 1px !important;
}
.tpw-wrapper .grid-container .ag-pinned-right-header .ag-header-cell-resize::after {
  left: calc(50% - 1px);
  width: 2px !important;
}
.tpw-wrapper .grid-container .ag-cell.ag-cell-last-left-pinned,
.tpw-wrapper .grid-container .ag-pinned-left-header {
  border-width: 1px;
  right: 0px;
  left: auto !important;
}
.tpw-wrapper .grid-container .ag-cell.ag-cell-last-left-pinned:has(.ag-header-active),
.tpw-wrapper .grid-container .ag-pinned-left-header:has(.ag-header-active) {
  border-right: 2px solid var(--list-focus-border-color) !important;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.tpw-wrapper .grid-container .ag-pinned-right-header {
  border-right: none;
  left: 0;
}
.tpw-wrapper .grid-container .ag-pinned-right-header:has(.ag-header-active) {
  border-right: 2px solid var(--list-focus-border-color) !important;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.tpw-wrapper .grid-container .ag-pinned-right-header,
.tpw-wrapper .grid-container .ag-pinned-right-cols-container {
  border-left-style: solid;
  border-left-color: var(--md-table-pinned-border-color) !important;
  border-left-width: 1px;
  box-shadow: var(--pinned-column-elevation);
}
.tpw-wrapper .grid-container .ag-pinned-right-header .ag-row,
.tpw-wrapper .grid-container .ag-pinned-right-cols-container .ag-row {
  background-color: var(--md-table-pinned-bg-color);
}
.tpw-wrapper .grid-container .ag-pinned-right-header .ag-row .ag-cell,
.tpw-wrapper .grid-container .ag-pinned-right-cols-container .ag-row .ag-cell {
  border-left-style: none;
}
.tpw-wrapper .grid-container .ag-pinned-right-header .ag-header-cell,
.tpw-wrapper .grid-container .ag-pinned-right-cols-container .ag-header-cell {
  background-color: var(--pinned-column-header-bg-color);
}
.tpw-wrapper .grid-container .ag-pinned-left-header,
.tpw-wrapper .grid-container .ag-pinned-left-cols-container {
  border-right-style: solid;
  border-right-width: 1px;
  border-right-color: var(--md-table-pinned-border-color) !important;
  box-shadow: var(--pinned-column-elevation);
}
.tpw-wrapper .grid-container .ag-pinned-left-header .ag-row,
.tpw-wrapper .grid-container .ag-pinned-left-cols-container .ag-row {
  background-color: var(--md-table-pinned-bg-color);
}
.tpw-wrapper .grid-container .ag-pinned-left-header .ag-row .ag-cell,
.tpw-wrapper .grid-container .ag-pinned-left-cols-container .ag-row .ag-cell {
  border-right-style: none;
}
.tpw-wrapper .grid-container .ag-pinned-left-header .ag-header-cell,
.tpw-wrapper .grid-container .ag-pinned-left-cols-container .ag-header-cell {
  background-color: var(--pinned-column-header-bg-color);
}
.tpw-wrapper .grid-container .ag-cell-expandable {
  font-weight: bold;
}
.tpw-wrapper .grid-container .ag-row.ag-row-level-0.ag-full-width-row {
  background-color: var(--md-tertiary-bg-color);
}
.tpw-wrapper .grid-container .ag-header-icon.ag-header-cell-menu-button {
  opacity: 1;
}
.tpw-wrapper .grid-container div.ag-row {
  font-family: var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", sans-serif;
}
.tpw-wrapper .grid-container .ag-theme-alpine .ag-menu-header,
.tpw-wrapper .grid-container .ag-theme-alpine-dark .ag-menu-header {
  display: none;
}
.tpw-wrapper .grid-container .ag-group-expanded,
.tpw-wrapper .grid-container .ag-group-contracted {
  margin-right: 20px;
}
.tpw-wrapper .ag-menu {
  border-radius: var(--border-radius-medium);
  color: var(--md-primary-text-color);
  border-color: var(--md-menu-overlay-border-color);
  box-shadow: 0 1px 4px 1px var(--md-menu-overlay-border-color);
  margin-top: 25px;
  margin-left: 15px;
}
.tpw-wrapper .ag-header-icon {
  color: var(--md-secondary-text-color);
  padding-left: 8px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}
.tpw-wrapper .ag-row.ag-row-level-0.ag-full-width-row .ag-row-group.ag-row-group-indent-0 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-1.ag-full-width-row .ag-row-group.ag-row-group-indent-1 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-2.ag-full-width-row .ag-row-group.ag-row-group-indent-2 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-3.ag-full-width-row .ag-row-group.ag-row-group-indent-3 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-4.ag-full-width-row .ag-row-group.ag-row-group-indent-4 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-5.ag-full-width-row .ag-row-group.ag-row-group-indent-5 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-6.ag-full-width-row .ag-row-group.ag-row-group-indent-6 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-7.ag-full-width-row .ag-row-group.ag-row-group-indent-7 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-8.ag-full-width-row .ag-row-group.ag-row-group-indent-8 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-9.ag-full-width-row .ag-row-group.ag-row-group-indent-9 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-10.ag-full-width-row .ag-row-group.ag-row-group-indent-10 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-11.ag-full-width-row .ag-row-group.ag-row-group-indent-11 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-12.ag-full-width-row .ag-row-group.ag-row-group-indent-12 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-13.ag-full-width-row .ag-row-group.ag-row-group-indent-13 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-14.ag-full-width-row .ag-row-group.ag-row-group-indent-14 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-15.ag-full-width-row .ag-row-group.ag-row-group-indent-15 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-16.ag-full-width-row .ag-row-group.ag-row-group-indent-16 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-17.ag-full-width-row .ag-row-group.ag-row-group-indent-17 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-18.ag-full-width-row .ag-row-group.ag-row-group-indent-18 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-19.ag-full-width-row .ag-row-group.ag-row-group-indent-19 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-1 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-2 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-3 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-4 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-5 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-6 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-7 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-8 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-9 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-10 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-11 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-12 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-13 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-14 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-15 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-16 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-17 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-18 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-19 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .tpw-action-wrapper {
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.tpw-wrapper .tpw-action-wrapper div:nth-child(2) {
  padding-bottom: 3px;
}
.tpw-wrapper .sorted {
  display: flex;
  flex-direction: column;
}
.tpw-wrapper .sorted md-icon {
  display: flex;
  color: var(--md-primary-text-color);
}
.tpw-wrapper .icon-group {
  border: 1px solid black;
  padding: 0px 3px;
  border-radius: 3px;
  border-color: var(--md-button-secondary-hover-bg-color);
  height: 18px;
  line-height: 18px;
  font-weight: bold;
}
.tpw-wrapper .ActionCell {
  display: flex;
  justify-content: left;
  width: calc(100% + 18px);
  margin-left: -10px;
  height: 100%;
}
.tpw-wrapper .ActionCell .more-actions {
  display: flex;
  margin-left: auto;
}
.tpw-wrapper .ActionCell .aid-icon {
  height: calc(var(--space-token-even) * 10);
  min-width: calc(var(--space-token-even) * 10);
}
.tpw-wrapper .ActionCell .btn-action {
  padding: 0px calc(var(--space-token-even) * 2);
  margin: 0px calc(var(--space-token-even) * 2);
}
.tpw-wrapper .ActionCell .aid-chat {
  position: relative;
}
.tpw-wrapper .ActionCell .state-change-action {
  position: relative;
}
.tpw-wrapper .ActionCell .kebab-menu {
  margin-left: auto;
}
.tpw-wrapper .ActionCell .kebab-menu-icon {
  cursor: pointer;
}
.tpw-wrapper .ActionCell .kebab-menu-container {
  padding: 0 !important;
}
.tpw-wrapper .ActionCell .monitoring-label {
  margin: 0 calc(var(--space-token-even) * 6);
  color: var(--md-default-focus-outline-color, #005e7d);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0;
  margin-top: 0;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  margin-right: 10px;
}
.tpw-wrapper .ActionCell .review-monitor-icon {
  min-width: calc(var(--space-token-even) * 10);
}
.tpw-wrapper .ActionCell .section-one {
  display: flex;
  height: 100%;
}
.tpw-wrapper .ActionCell .section-one .monitoring-container {
  max-width: max-content;
}
.tpw-wrapper .ActionCell .section-two {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
}
.tpw-wrapper .ActionCell .section-two .kebab-action {
  width: 1.5rem;
  margin: 0 0 0 auto;
  padding: 0;
}
.tpw-wrapper .ActionCell .aid-button {
  align-items: center;
  justify-content: center;
  display: flex;
  width: 2rem;
  border: none;
  background: none;
  cursor: pointer;
  vertical-align: middle;
  height: 100%;
}
.tpw-wrapper .ActionCell .aid-button.disabled {
  cursor: not-allowed;
  color: var(--md-button-disabled-text-color);
}
.tpw-wrapper .ActionCell .aid-button .error-icon {
  position: absolute;
  top: -9px;
  right: 6px;
  color: var(--md-input-chat-error-color, #a12512);
}
.tpw-wrapper .ActionCell .aid-button .error-icon .md-icon {
  background-color: white;
  border-radius: 50%;
}
.tpw-wrapper .ActionCell .aid-button:focus {
  box-shadow: 0 0 0 0.125rem var(--button-focus-ring-color, #007aa3);
  border-radius: 2px;
}
.tpw-wrapper .ActionCell .aid-button[disabled] {
  cursor: no-drop;
}

.grid-rendering {
  display: none;
}

.name-span-renderer {
  padding: 0px 38px 5px 10px;
  width: -webkit-fill-available;
  width: -moz-available;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  height: -webkit-fill-available;
  height: -moz-available;
}

.name-avatar-renderer {
  vertical-align: top;
}

.avatar-center {
  display: flex;
  align-items: center;
  height: 100%;
}
.avatar-center .md-avatar {
  font-size: 0.875rem;
  height: 2.5rem;
  line-height: 1.25rem;
  width: 2.5rem;
  border-radius: 100%;
  display: inline-flex;
  font-family: var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial, sans-serif;
  position: relative;
  text-transform: uppercase;
  user-select: none;
}
.avatar-center .md-avatar--28 {
  font-size: 0.6125rem;
  height: 1.75rem;
  line-height: 0.875rem;
  width: 1.75rem;
  min-width: 1.75rem;
}
.avatar-center .md-avatar__letter {
  place-content: center;
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
  border-radius: 100%;
  height: 100%;
  width: 100%;
  background-color: var(--avatar-letter-legacy-bg-color, var(--avatar-letter-bg-color, #ededed));
  color: var(--avatar-letter-legacy-text-color, var(--avatar-letter-text-color, #292929));
}
.avatar-center .md-avatar--active::after {
  place-content: center;
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
  border-radius: 100%;
  height: 100%;
  width: 100%;
  box-shadow: rgb(0, 171, 80) 0px 0px 0px 0.0625rem inset, var(--avatar-presence-cutout-bg-color, rgba(255, 255, 255, 0.24)) 0px 0px 0px 0.125rem inset;
  content: "";
  left: 0px;
  position: absolute;
}
.avatar-center .md-avatar--idle::after {
  place-content: center;
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
  border-radius: 100%;
  height: 100%;
  width: 100%;
  box-shadow: rgb(204, 204, 204) 0px 0px 0px 0.0625rem inset, var(--avatar-presence-cutout-bg-color, rgba(255, 255, 255, 0.24)) 0px 0px 0px 0.125rem inset;
  content: "";
  left: 0px;
  position: absolute;
}

.agent-state-container {
  display: flex;
}
.agent-state-container .agent-state-info {
  margin-right: 5px;
  height: auto;
  padding-top: 10px;
  align-items: center;
}
.agent-state-container .agent-state-name {
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
}

webex-chat {
  width: 370px;
}

.context-menu-wrapper {
  width: max-content;
  overflow: visible;
}

.custom-menu-overlay.overlay-container {
  border-radius: 0.5rem;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.16), 0 0 1px rgba(0, 0, 0, 0.14);
  box-sizing: border-box;
  display: none;
  position: absolute;
  z-index: 1000;
}
.custom-menu-overlay.overlay-container[data-show] {
  display: block;
}
.custom-menu-overlay.overlay-container .overlay-content {
  background-color: var(--md-secondary-white-bg-color);
  border: 1px solid var(--md-menu-overlay-border-color, --gray-20);
  border-radius: 0.5rem;
  display: flex;
  justify-content: space-around;
  max-width: calc(100vw - var(--vw-padding) * 2);
  overflow-y: auto;
}

.agent-state-selector .overlay-content {
  width: 260px;
}
.agent-state-selector .overlay-content agentx-wc-tpw-agent-state-selector-infinite {
  width: 100%;
}
.agent-state-selector agentx-wc-tpw-agent-state-selector {
  width: 100%;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/TeamPerformance.ts":
/*!*****************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/TeamPerformance.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TeamPerformance: () => (/* binding */ TeamPerformance)
/* harmony export */ });
/* harmony import */ var _components_Common_Utils_GridUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/Utils/GridUtils */ "./src/components/Common/Utils/GridUtils.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @/utils/WindowListenersHub */ "./src/utils/WindowListenersHub.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @/utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _popperjs_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @popperjs/core */ "@popperjs/core");
/* harmony import */ var _popperjs_core__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_popperjs_core__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _popperjs_core_lib_popper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @popperjs/core/lib/popper */ "@popperjs/core/lib/popper");
/* harmony import */ var _popperjs_core_lib_popper__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_popperjs_core_lib_popper__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @uuip/unified-ui-platform-common-components */ "@uuip/unified-ui-platform-common-components");
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ag-grid-enterprise */ "ag-grid-enterprise");
/* harmony import */ var ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var lit_html_lib_part__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! lit-html/lib/part */ "lit-html/lib/part");
/* harmony import */ var lit_html_lib_part__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lit_html_lib_part__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! lodash */ "lodash");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! mobx */ "mobx");
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(mobx__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _Common_WidgetLoader_WidgetLoader__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../Common/WidgetLoader/WidgetLoader */ "./src/components/Common/WidgetLoader/WidgetLoader.ts");
/* harmony import */ var _ColumnMenu_ColumnMenu__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./ColumnMenu/ColumnMenu */ "./src/components/TeamPerformanceWidget/ColumnMenu/ColumnMenu.ts");
/* harmony import */ var _ContextMenu__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./ContextMenu */ "./src/components/TeamPerformanceWidget/ContextMenu.ts");
/* harmony import */ var _GridConfig__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./GridConfig */ "./src/components/TeamPerformanceWidget/GridConfig.ts");
/* harmony import */ var _GridHeader_GridHeader__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./GridHeader/GridHeader */ "./src/components/TeamPerformanceWidget/GridHeader/GridHeader.ts");
/* harmony import */ var _TeamPerformance_scss__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./TeamPerformance.scss */ "./src/components/TeamPerformanceWidget/TeamPerformance.scss");
/* harmony import */ var _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./TeamPerformanceUtils */ "./src/components/TeamPerformanceWidget/TeamPerformanceUtils.ts");
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./Utils */ "./src/components/TeamPerformanceWidget/Utils.ts");
/* harmony import */ var _components_ActiveInteraction__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./components/ActiveInteraction */ "./src/components/TeamPerformanceWidget/components/ActiveInteraction.ts");
/* harmony import */ var _components_AppliedFilters__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./components/AppliedFilters */ "./src/components/TeamPerformanceWidget/components/AppliedFilters.ts");
/* harmony import */ var _components_EmptyGrid__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./components/EmptyGrid */ "./src/components/TeamPerformanceWidget/components/EmptyGrid.ts");
/* harmony import */ var _components_ReviewAndMonitorWrapper__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./components/ReviewAndMonitorWrapper */ "./src/components/TeamPerformanceWidget/components/ReviewAndMonitorWrapper.ts");
/* harmony import */ var _components_SignoutModal__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./components/SignoutModal */ "./src/components/TeamPerformanceWidget/components/SignoutModal.ts");
/* harmony import */ var _components_StateSelector__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./components/StateSelector */ "./src/components/TeamPerformanceWidget/components/StateSelector.ts");
/* harmony import */ var _components_WebexChat__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./components/WebexChat */ "./src/components/TeamPerformanceWidget/components/WebexChat.ts");
/* harmony import */ var _components_agentStateSelector__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./components/agentStateSelector */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/index.ts");
/* harmony import */ var _components_agentStateSelector_agentStateSelectorInfinite__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./components/agentStateSelector/agentStateSelectorInfinite */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/agentStateSelectorInfinite/index.ts");
/* harmony import */ var _components_skillProfile_SkillProfileDialog__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./components/skillProfile/SkillProfileDialog */ "./src/components/TeamPerformanceWidget/components/skillProfile/SkillProfileDialog.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */




































var FocusComponent;
(function (FocusComponent) {
    FocusComponent["SEND_MESSAGE"] = "send-message";
    FocusComponent["STATE_CHANGE"] = "state-change";
    FocusComponent["SIGNOUT"] = "signout";
})(FocusComponent || (FocusComponent = {}));
const globalStatusDataSet = "wxcc.rtd.agentglobalstatus";
const agentChannelStatusDataSet = "wxcc.rtd.agentchannelstatus";
const contactStatsDataSet = "wxcc.rtd.contactstats";
var TeamPerformance;
(function (TeamPerformance) {
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.i18nMixin)(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_6__.MobxLitElement) {
        static get styles() {
            return _TeamPerformance_scss__WEBPACK_IMPORTED_MODULE_23__["default"];
        }
        //toggle subscription reset the subscription flags for future coming subscriptions
        toggleSubscriptionFlags() {
            this.isAgentGlobalSubscribed = false;
            this.isChannelStatusSubscribed = false;
            this.isContactStatusSubscribed = false;
        }
        //setRowDara convert map data to array data to make compatible for ag-grid
        setRowData() {
            var _a, _b, _c, _d;
            this.agentStatusData = Array.from(this.agentDataMap, (item) => item[1]);
            (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.setGridOption("rowData", this.agentStatusData);
            (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.refreshHeader();
            (_c = this.gridApi) === null || _c === void 0 ? void 0 : _c.setGridOption("loading", false);
            (_d = this.gridApi) === null || _d === void 0 ? void 0 : _d.hideOverlay();
        }
        //isFirstSubscription checks whether the subscription_response received is the very first subscription
        isFirstSubscription(type) {
            return (!this.isChannelStatusSubscribed &&
                !this.isAgentGlobalSubscribed &&
                !this.isContactStatusSubscribed &&
                (type === _constants__WEBPACK_IMPORTED_MODULE_1__.SUBSCRIPTION_RESPONSE || this.agentStatusData.length === 0));
        }
        updateDisplayRowCountOnDataUpdate() {
            if (this.delayId) {
                _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_12__.clearInterval(this.delayId);
            }
            this.delayId = (0,mobx__WEBPACK_IMPORTED_MODULE_17__.toJS)(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_12__.setTimeout(() => {
                this.getDisplayedRowCount();
            }, 100));
        }
        setAgentGlobalStatusData(agentGlobalStatusData, type, deltaData) {
            if (this.isAgentGlobalSubscribed && type === _constants__WEBPACK_IMPORTED_MODULE_1__.SUBSCRIPTION_RESPONSE) {
                this.toggleSubscriptionFlags();
            }
            if (this.isFirstSubscription(type)) {
                //Directly map the value received if the received data is first subscription data
                this.agentDataMap = (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.convertGlobalStatusArrayToMap)(agentGlobalStatusData, _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.i18n.language, this.tpwConfigs.supervisorAnalyserId);
                this.enrichCMSDataWithRTDData();
                this.setRowData();
                this.isAgentGlobalSubscribed = true;
            }
            else if (!this.isChannelStatusSubscribed && !this.isContactStatusSubscribed && this.isAgentGlobalSubscribed) {
                //Directly map the value received if the received data is chunked subscription data
                this.agentDataMap = new Map([
                    ...this.agentDataMap,
                    ...(0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.convertGlobalStatusArrayToMap)(agentGlobalStatusData, _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.i18n.language, this.tpwConfigs.supervisorAnalyserId)
                ]);
                this.enrichCMSDataWithRTDData();
                this.setRowData();
            }
            else if (this.isChannelStatusSubscribed || this.isContactStatusSubscribed || type === _constants__WEBPACK_IMPORTED_MODULE_1__.REALTIME_FEED) {
                if (type === _constants__WEBPACK_IMPORTED_MODULE_1__.SUBSCRIPTION_RESPONSE) {
                    this.isAgentGlobalSubscribed = true;
                }
                if (deltaData && type === _constants__WEBPACK_IMPORTED_MODULE_1__.REALTIME_FEED) {
                    this.agentDataMap = (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.updateExistingMapFromGlobalStatus)({
                        agentGlobalStatusData: deltaData,
                        oldDataMap: this.agentDataMap,
                        browserLanguage: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.i18n.language,
                        gridApi: this.gridApi,
                        comp: this,
                        supervisorAnalyserId: this.tpwConfigs.supervisorAnalyserId,
                        isServerSideGrid: this.isServerSidePaginated,
                        isShowSignedOutAgentsEnabled: this.tpwConfigs.isShowSignedOutAgentsEnabled
                    });
                }
                else {
                    this.agentDataMap = (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.updateExistingMapFromGlobalStatus)({
                        agentGlobalStatusData,
                        oldDataMap: this.agentDataMap,
                        browserLanguage: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.i18n.language,
                        gridApi: this.gridApi,
                        comp: this,
                        supervisorAnalyserId: this.tpwConfigs.supervisorAnalyserId,
                        isServerSideGrid: this.isServerSidePaginated,
                        isShowSignedOutAgentsEnabled: this.tpwConfigs.isShowSignedOutAgentsEnabled
                    });
                }
                this.enrichCMSDataWithRTDData();
                this.agentStatusData = Array.from(this.agentDataMap, (item) => item[1]);
            }
            if (this.appliedGroups && this.appliedGroups.length > 0) {
                this.updateGroupFilter();
            }
            this.updateDisplayRowCountOnDataUpdate();
        }
        setAgentContactStatsData(contactStatsData, type, deltaData) {
            if (!deltaData || (deltaData && deltaData.length > 0 && deltaData[0].operation !== "DELETE")) {
                let filteredData = [];
                if (deltaData) {
                    filteredData = (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.filterContactStatsData)(deltaData);
                }
                else {
                    filteredData = (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.filterContactStatsData)(contactStatsData);
                }
                if (filteredData && filteredData.length > 0) {
                    if (this.isContactStatusSubscribed && type === _constants__WEBPACK_IMPORTED_MODULE_1__.SUBSCRIPTION_RESPONSE) {
                        this.toggleSubscriptionFlags();
                    }
                    if (this.isFirstSubscription(type)) {
                        //Directly map the value received if the received data is first subscription data
                        this.agentDataMap = (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.convertContactStatusArrayToMap)(contactStatsData, this.tpwConfigs.supervisorAnalyserId, this.tpwConfigs.isMPCorPersistEnabled);
                        this.enrichCMSDataWithRTDData();
                        this.setRowData();
                        this.isContactStatusSubscribed = true;
                    }
                    else if (this.isContactStatusSubscribed &&
                        !this.isChannelStatusSubscribed &&
                        !this.isAgentGlobalSubscribed) {
                        //Directly map the value received if the received data is chunked subscription data
                        //chunked data is new data so directly appending the data recieved in subscription
                        this.agentDataMap = new Map([
                            ...this.agentDataMap,
                            ...(0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.convertContactStatusArrayToMap)(filteredData, this.tpwConfigs.supervisorAnalyserId, this.tpwConfigs.isMPCorPersistEnabled)
                        ]);
                        this.enrichCMSDataWithRTDData();
                        this.setRowData();
                    }
                    else if (this.isAgentGlobalSubscribed || this.isChannelStatusSubscribed || type === _constants__WEBPACK_IMPORTED_MODULE_1__.REALTIME_FEED) {
                        if (type === _constants__WEBPACK_IMPORTED_MODULE_1__.SUBSCRIPTION_RESPONSE) {
                            this.isContactStatusSubscribed = true;
                        }
                        //updating the existing data id the subscription is not the first subscription or if the type of response is relatimefeed
                        this.agentDataMap = (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.updateExistingMapFromContactStats)(filteredData, this.agentDataMap, this.gridApi, this.tpwConfigs.supervisorAnalyserId, this, this.tpwConfigs.isMPCorPersistEnabled, this.isServerSidePaginated);
                        this.enrichCMSDataWithRTDData();
                        this.agentStatusData = Array.from(this.agentDataMap, (item) => item[1]);
                        this.monitoringInProgress = this.agentStatusData.some((agentDetails) => { var _a; return (_a = agentDetails.actions) === null || _a === void 0 ? void 0 : _a.isSupervisorMonitoring; });
                    }
                    this.updateSelectedAgentDetails();
                }
                this.updateDisplayRowCountOnDataUpdate();
            }
        }
        setAgentChannelStatusData(agentChannelStatusData, type, deltaData) {
            if (!deltaData || (deltaData && deltaData.length > 0 && deltaData[0].operation !== "DELETE")) {
                let filteredData = [];
                if (deltaData) {
                    filteredData = (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.filteredTelephonyChannelData)(deltaData);
                }
                else {
                    filteredData = (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.filteredTelephonyChannelData)(agentChannelStatusData);
                }
                if (filteredData && filteredData.length > 0) {
                    if (this.isChannelStatusSubscribed && type === _constants__WEBPACK_IMPORTED_MODULE_1__.SUBSCRIPTION_RESPONSE) {
                        this.toggleSubscriptionFlags();
                    }
                    if (this.isFirstSubscription(type)) {
                        //Directly map the value received if the received data is first subscription data
                        this.agentDataMap = (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.convertChannelStatusArrayToMap)(filteredData, this.tpwConfigs.supervisorAnalyserId);
                        this.enrichCMSDataWithRTDData();
                        this.setRowData();
                        this.isChannelStatusSubscribed = true;
                    }
                    else if (this.isChannelStatusSubscribed &&
                        !this.isAgentGlobalSubscribed &&
                        !this.isContactStatusSubscribed) {
                        //Directly map the value received if the received data is chunked subscription data
                        //chunked data is new data so directly appending the data recieved in subscription
                        this.agentDataMap = new Map([
                            ...this.agentDataMap,
                            ...(0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.convertChannelStatusArrayToMap)(filteredData, this.tpwConfigs.supervisorAnalyserId)
                        ]);
                        this.enrichCMSDataWithRTDData();
                        this.setRowData();
                    }
                    else if (this.isAgentGlobalSubscribed || this.isContactStatusSubscribed || type === _constants__WEBPACK_IMPORTED_MODULE_1__.REALTIME_FEED) {
                        if (type === _constants__WEBPACK_IMPORTED_MODULE_1__.SUBSCRIPTION_RESPONSE) {
                            this.isChannelStatusSubscribed = true;
                        }
                        //updating the existing data id the subscription is not the first subscription or if the type of response is relatimefeed
                        this.agentDataMap = (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.updateExistingMapFromChannelStatus)(filteredData, this.agentDataMap, this.gridApi, this.tpwConfigs.supervisorAnalyserId, this, this.isServerSidePaginated);
                        this.enrichCMSDataWithRTDData();
                        this.agentStatusData = Array.from(this.agentDataMap, (item) => item[1]);
                        //updating the selectedAgentDetails to update the contact status change received from channel status when any AID modal is open
                        this.updateSelectedAgentDetails();
                    }
                    if (this.appliedGroups && this.appliedGroups.length > 0) {
                        this.updateGroupFilter();
                    }
                    this.updateDisplayRowCountOnDataUpdate();
                }
            }
        }
        fetchAllAgents(pageNumber = 0, searchValue = "", sortOrder = "") {
            return __awaiter(this, void 0, void 0, function* () {
                const allAgentsResponse = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.abs.fetchAgentsByOrgId({
                    orgId: this.tpwConfigs.orgId,
                    page: pageNumber,
                    pageSize: this.tpwConfigs.requestedPageSize,
                    searchValue,
                    sortOrder
                });
                const totalRecords = allAgentsResponse.meta.totalRecords;
                const fetchedAgents = allAgentsResponse.data;
                if (!this.isServerSidePaginated) {
                    this.isServerSidePaginated = totalRecords > this.tpwConfigs.requestedPageSize;
                }
                if (this.isServerSidePaginated) {
                    this.displayedRowCount = totalRecords;
                }
                this.cmsAgentData = [
                    ...fetchedAgents.map((agent) => ({
                        agentId: agent.id,
                        agentName: `${agent.firstName} ${agent.lastName}`,
                        agentEmail: agent.email
                    })),
                    ...this.cmsAgentData
                ];
                return (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.convertCmsAgentDataArrayToMap)([
                    ...fetchedAgents.map((agent) => ({
                        agentId: agent.id,
                        agentName: `${agent.firstName} ${agent.lastName}`,
                        agentEmail: agent.email
                    }))
                ]);
            });
        }
        fetchAgentStatus() {
            return __awaiter(this, void 0, void 0, function* () {
                this.requestTimerId = (0,mobx__WEBPACK_IMPORTED_MODULE_17__.toJS)(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_12__.setTimeout(() => {
                    var _a, _b;
                    if (this.agentStatusData.length === 0) {
                        // Show "No Records" if the data is not received within the timeout.
                        this.isRequestTimeout = true;
                        (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.setGridOption("loading", false);
                        (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.showNoRowsOverlay();
                    }
                }, _constants__WEBPACK_IMPORTED_MODULE_1__.TPW_DATA_WAIT_TIME));
                try {
                    // subscribe to contact stats dataset
                    const [globalStatus, channelStatus, contactStats] = yield Promise.all([
                        this.subscribeGlobalStatusDataSet(),
                        this.subscribeAgentChannelStatusDataSet(),
                        this.subscribeContactStatsDataSet()
                    ]);
                    this.globalStatusSubscription = globalStatus;
                    this.channelStatusSubscription = channelStatus;
                    this.contactStatsSubscription = contactStats;
                }
                catch (error) {
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error("[App:TPW] Subscription failed", error);
                    this.isError = true;
                }
            });
        }
        handleStateChangeContext(event) {
            var _a;
            const detail = { selectedAgentId: event.detail.agentId };
            this.updateSelectedAgentId(detail);
            this.closeOverlayContent({ closeContextMenu: false });
            (_a = this.stateSelector) === null || _a === void 0 ? void 0 : _a.toggleAttribute("data-show", true);
            setTimeout(() => {
                this.popperInstance = this.createPopperInstance(event.detail.event, this.stateSelector, "left-start");
                this.stateSelectorOpened = true;
                this.popperInstance.update();
            }, 0);
        }
        handleWebexChatContext(event) {
            var _a;
            this.closeOverlayContent({ closeContextMenu: false });
            (_a = this.overlayElement) === null || _a === void 0 ? void 0 : _a.toggleAttribute("data-show", true);
            setTimeout(() => {
                this.popperInstance = this.createPopperInstance(event.detail.event, this.overlayElement, "left-start");
                this.webexChatOpened = true;
                this.popperInstance.update();
            }, 0);
        }
        fireSignedOutAgentNotification(success, trackingId) {
            var _a;
            const event = new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_1__.AGENT_SIGNOUT_RESULT, {
                detail: { agentName: (_a = this.selectedAgentDetails) === null || _a === void 0 ? void 0 : _a.agentName, result: success, trackingId },
                bubbles: true,
                composed: true
            });
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_4__.WINDOW_LISTENERS_HUB.dispatch(event);
        }
        setSignoutState(pending, wasError) {
            this.isSigningOutAgent = pending;
            const updateCell = new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_1__.UPDATE_ACTION_CELL_VALUE_EVENT, {
                composed: true,
                bubbles: true,
                detail: {
                    agentId: this.selectedAgentId,
                    signoutError: wasError,
                    signoutPending: pending
                }
            });
            this.updateActionCellValue(updateCell, FocusComponent.SIGNOUT);
        }
        confirmAgentSignout() {
            var _a, _b, _c, _d, _e;
            return __awaiter(this, void 0, void 0, function* () {
                this.setSignoutState(true, false);
                this.isSignoutModalOpen = false;
                try {
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:TPW] event=signoutAgentBySupervisor for agent ", this.selectedAgentId);
                    yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.aqm.supervisor.signoutAgent({
                        orgId: this.tpwConfigs.orgId,
                        data: { agentId: this.selectedAgentId, logoutReason: _constants__WEBPACK_IMPORTED_MODULE_1__.AGENT_SIGNOUT_REASON }
                    });
                    (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry.TELEM_EVENT.SIGNOUT_REQUESTED, {
                        Status: "Success",
                        SignedoutAgentId: this.selectedAgentId
                    }, [(_b = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.webex_behavioral]);
                    this.setSignoutState(false, false);
                    this.fireSignedOutAgentNotification(true);
                }
                catch (error) {
                    this.setSignoutState(false, true);
                    const trackingId = (_c = error.details.trackingId) === null || _c === void 0 ? void 0 : _c.split("_")[1];
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error("[App:TPW] event=signoutAgentBySupervisorFailed for agent ", this.selectedAgentId, error);
                    this.fireSignedOutAgentNotification(false, trackingId);
                    (_d = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry) === null || _d === void 0 ? void 0 : _d.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry.TELEM_EVENT.SIGNOUT_REQUESTED, {
                        Status: "Failed",
                        SignedoutAgentId: this.selectedAgentId,
                        TrackingId: trackingId
                    }, [(_e = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry.SERVICE_PROVIDERS) === null || _e === void 0 ? void 0 : _e.webex_behavioral]);
                }
            });
        }
        declineAgentSignout() {
            this.isSignoutModalOpen = false;
            if (!this.returnFocusToSignoutIcon()) {
                this.returnFocusToMoreActionIcon();
            }
        }
        closeOverlayContent(config = {
            closeWebexSendMessage: true,
            closeContextMenu: true,
            closeStateChange: true
        }) {
            if (!Object.prototype.hasOwnProperty.call(config, "closeWebexSendMessage") || config.closeWebexSendMessage) {
                this.closeWebExChat();
            }
            if (!Object.prototype.hasOwnProperty.call(config, "closeContextMenu") || config.closeContextMenu) {
                this.closeContextMenu();
            }
            if (!Object.prototype.hasOwnProperty.call(config, "closeStateChange") || config.closeStateChange) {
                this.closeStateChangeOverlay();
            }
        }
        createPopperInstance(reference, popper, placement = "auto") {
            return (0,_popperjs_core__WEBPACK_IMPORTED_MODULE_9__.createPopper)(reference, popper, {
                placement,
                modifiers: [
                    ..._popperjs_core_lib_popper__WEBPACK_IMPORTED_MODULE_10__.defaultModifiers,
                    _popperjs_core_lib_popper__WEBPACK_IMPORTED_MODULE_10__.flip,
                    _popperjs_core_lib_popper__WEBPACK_IMPORTED_MODULE_10__.offset,
                    _popperjs_core_lib_popper__WEBPACK_IMPORTED_MODULE_10__.preventOverflow,
                    _popperjs_core_lib_popper__WEBPACK_IMPORTED_MODULE_10__.arrow,
                    {
                        name: "preventOverflow",
                        options: {
                            altAxis: true,
                            padding: 16
                        }
                    },
                    {
                        name: "offset",
                        options: {
                            offset: (({ innerPlacement, innerReference }) => {
                                if (innerPlacement === "left-end" || innerPlacement === "right-end") {
                                    return [innerReference.height + innerReference.y + 3, 14];
                                }
                                else if (innerPlacement === "left") {
                                    return [100, 15];
                                }
                                else {
                                    return [0, 5];
                                }
                            })
                        }
                    },
                    {
                        name: "computeStyles",
                        options: {
                            adaptive: false // this will recompute popper position
                        }
                    }
                ]
            });
        }
        updated(changedProperties) {
            var _a;
            super.updated(changedProperties);
            if (this.isError) {
                _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_12__.setTimeout(() => {
                    // showing row count 0 if error occurs in any subscription
                    this.displayedRowCount = 0;
                    this.showFailedToLoadDataEmptyGrid();
                }, 50);
            }
            const previousTPWConfigValue = changedProperties.get("tpwConfigs");
            if (this.filters && (changedProperties.has("appliedFilters") || changedProperties.has("appliedGroups"))) {
                setTimeout(() => {
                    var _a;
                    this.style.setProperty("--tpw-filter-height", `${((_a = this.filters.getBoundingClientRect()) === null || _a === void 0 ? void 0 : _a.height) || 0}px`);
                }, 50);
            }
            if (changedProperties.has("isError") ||
                changedProperties.has("isRequestTimeout") ||
                changedProperties.has("agentStatusData")) {
                this.handleAccessibility();
            }
            const isStateChangeFeatureFlagUpdated = () => {
                return (previousTPWConfigValue["isStateChangeBySupervisorEnabled"] !==
                    this.tpwConfigs.isStateChangeBySupervisorEnabled);
            };
            if (changedProperties.has("tpwConfigs") &&
                previousTPWConfigValue &&
                (previousTPWConfigValue["isDarkMode"] !== this.tpwConfigs.isDarkMode ||
                    previousTPWConfigValue["onActiveCall"] !== this.tpwConfigs.onActiveCall ||
                    isStateChangeFeatureFlagUpdated())) {
                (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.refreshCells({ force: true, columns: ["actions"] });
                // If feature flag values are changed, Validate the context menu visibility
                if (isStateChangeFeatureFlagUpdated() && this.contextMenuOpened && this.selectedActionCellValue.agentId) {
                    // Context menu is already opened while updating the FF value. So Update the context menu values.
                    this.updateContextMenuValuesTimeout = setTimeout(() => this.updateContextMenuValues(), _constants__WEBPACK_IMPORTED_MODULE_1__.TIMEOUT_THOUSAND_MS);
                }
            }
            if ((changedProperties.has("gridId") || changedProperties.has("tpwConfigs")) &&
                !this.isGridInitialized &&
                this.gridId &&
                this.tpwConfigs.isStationLoginSuccess) {
                // Initialize the grid only if it hasn't been initialized yet
                // and if gridId is not empty and isStationLoginSuccess is true
                _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:TPW] initializing grid");
                this.initializeGrid();
                this.isGridInitialized = true; // Set the flag to true to prevent re-initialization
            }
        }
        updateContextMenuValues() {
            var _a, _b;
            // Check, Is context menu is required after FF Changes.
            const moreActionsElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`.more-action-${(_b = this.selectedActionCellValue) === null || _b === void 0 ? void 0 : _b.agentId}`);
            if (moreActionsElement) {
                // Update the values on existing opened context menu.
                moreActionsElement === null || moreActionsElement === void 0 ? void 0 : moreActionsElement.click();
            }
            else {
                // Context Menu is not required to display, Remove the Context menu and it's overlay contents.
                this.closeOverlayContent();
            }
        }
        // This method will be helpful to Screen Reader to read the "No Records" text.
        handleAccessibility() {
            var _a;
            const overlay = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".ag-overlay");
            if (this.isError || this.isRequestTimeout || this.agentStatusData.length === 0) {
                // error, no records
                overlay === null || overlay === void 0 ? void 0 : overlay.removeAttribute("aria-hidden");
            }
            else {
                // If records are exist
                overlay === null || overlay === void 0 ? void 0 : overlay.setAttribute("aria-hidden", "true");
            }
        }
        createHTMLLink(href) {
            const linkElement = document.createElement("link");
            linkElement.setAttribute("rel", "stylesheet");
            linkElement.setAttribute("href", href);
            return linkElement;
        }
        loadAGGridScript() {
            var _a;
            const agGridLink = this.createHTMLLink("ag-grid/ag-grid.css");
            const agThemeAlpineLink = this.createHTMLLink("ag-grid/ag-theme-alpine.css");
            const momentumIcons = this.createHTMLLink("/css/momentum-ui-icons.min.css");
            const momentumCore = this.createHTMLLink("/css/momentum-ui.min.css");
            const rootElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".tpw-wrapper");
            rootElement === null || rootElement === void 0 ? void 0 : rootElement.prepend(agThemeAlpineLink);
            rootElement === null || rootElement === void 0 ? void 0 : rootElement.prepend(agGridLink);
            rootElement === null || rootElement === void 0 ? void 0 : rootElement.prepend(momentumIcons);
            rootElement === null || rootElement === void 0 ? void 0 : rootElement.prepend(momentumCore);
            agGridLink.onload = () => {
                this.isAgGridLoaded = true;
            };
            agThemeAlpineLink.onload = () => {
                this.isAlpineLoaded = true;
            };
        }
        firstUpdated(changedProperties) {
            super.firstUpdated(changedProperties);
            this.loadAGGridScript();
            this.gridId = this.tpwConfigs.gridId;
        }
        onRowGroupuOpened(event) {
            const { node } = event;
            if (node.field && node.key) {
                this.addGroupToState(node.expanded, { field: node.field, key: node.key });
            }
        }
        addGroupToState(status, node) {
            var _a;
            if (status) {
                this.expandedGroupState.push(`${node.field}:${node.key}`);
            }
            else {
                const index = this.expandedGroupState.indexOf(`${node.field}:${node.key}`);
                (_a = this.expandedGroupState) === null || _a === void 0 ? void 0 : _a.splice(index, 1);
            }
            this.saveGridConfigs();
        }
        initializeGrid() {
            const setGridOptions = (fetchedAgents = new Map()) => {
                this.gridOptions = Object.assign(Object.assign(Object.assign({}, (0,_GridConfig__WEBPACK_IMPORTED_MODULE_21__.gridConfig)(this.getGridConfigs, this.isServerSidePaginated)), { debounceVerticalScrollbar: true, suppressAnimationFrame: true, enableBrowserTooltips: true, tooltipShowDelay: 2, rowData: this.agentStatusData.length === 0 ? null : this.agentStatusData, onGridReady: () => this.onGridReady(fetchedAgents), onDisplayedColumnsChanged: this.saveGridConfigs, onColumnResized: this.refreshColumn, onColumnPinned: this.refreshColumn, onSortChanged: this.onSortChanged, getRowId: (params) => params.data.agentId, onRowGroupOpened: (event) => this.onRowGroupuOpened(event), isGroupOpenByDefault: (params) => { var _a; return (_a = this.expandedGroupState) === null || _a === void 0 ? void 0 : _a.includes(`${params.field}:${params.key}`); }, rowHeight: 40, suppressGroupChangesColumnVisibility: "suppressHideOnGroup", onBodyScroll: () => {
                        this.closeOverlayContent();
                    } }), (this.isServerSidePaginated && {
                    rowModelType: "serverSide",
                    cacheBlockSize: this.tpwConfigs.requestedPageSize,
                    maxBlocksInCache: 1,
                    animateRows: true,
                    maxConcurrentDatasourceRequests: 1
                }));
                this.gridApi = this.createGridInstance(this.eGridDiv, this.gridOptions);
            };
            if (this.tpwConfigs.isShowSignedOutAgentsEnabled) {
                this.fetchAllAgents()
                    .then((fetchedAgents) => {
                    setGridOptions(fetchedAgents);
                })
                    .catch((error) => {
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error("[App:TPW]: Failed to fetch agents from CMS on initialize grid:", error.message);
                    setGridOptions();
                });
            }
            else {
                setGridOptions();
            }
        }
        createGridInstance(element, options) {
            return (0,ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_13__.createGrid)(element, options);
        }
        getActionColumnWidth() {
            var _a, _b;
            const actionColumn = (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.getColumnState().find((col) => col.colId === "actions");
            if (actionColumn) {
                return (_b = actionColumn.width) !== null && _b !== void 0 ? _b : 0;
            }
            return 0;
        }
        enrichCMSDataWithRTDData(fetchedAgents) {
            if (this.tpwConfigs.isShowSignedOutAgentsEnabled) {
                if (this.isServerSidePaginated && fetchedAgents) {
                    this.agentDataMap.forEach((agent) => {
                        const agentId = agent.agentId;
                        if (fetchedAgents.has(agentId)) {
                            const existingAgentData = this.agentDataMap.get(agentId);
                            const mergedAgentData = Object.assign(Object.assign({}, existingAgentData), agent);
                            fetchedAgents.set(agentId, mergedAgentData);
                        }
                    });
                    return fetchedAgents;
                }
                else {
                    this.agentDataMap = new Map([...(0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.convertCmsAgentDataArrayToMap)(this.cmsAgentData), ...this.agentDataMap]);
                    this.agentStatusData = Array.from(this.agentDataMap, (item) => item[1]);
                }
            }
            return new Map();
        }
        updateSelectedAgentDetails() {
            var _a;
            this.selectedAgentDetails =
                (_a = this.agentStatusData.find((agentData) => agentData.agentId === this.selectedAgentId)) !== null && _a !== void 0 ? _a : {};
        }
        constructor() {
            super();
            this.tpwConfigs = {
                gridId: "tpw-configs",
                orgId: "",
                isDarkMode: false,
                webexEnabled: false,
                isMCMEnabled: false,
                supervisorId: "",
                supervisorName: "",
                isStateChangeBySupervisorEnabled: false,
                isSignoutBySupervisorEnabled: false,
                supervisorEmail: "",
                supervisorAnalyserId: "",
                role: "",
                onActiveCall: false,
                isSupervisorySendMessageEnabled: false,
                isStationLoginSuccess: false,
                isEnvironmentProd: false,
                idleCodes: { isFetchingSuccess: false, data: [] },
                voiceChannelCount: 0,
                isMPCorPersistEnabled: false,
                isShowSignedOutAgentsEnabled: false,
                isWxccCoreDisallowPendingLogoutStateChangeEnabled: false,
                requestedPageSize: 0,
                isDesktopAuxCodesInfiniteScrollEnabled: false,
                isPostCallEnabled: false
            };
            this.gridId = "tpw-configs";
            this.agentStatusData = [];
            this.agentStatusDataServer = [];
            this.isModalOpen = false;
            this.isSignoutModalOpen = false;
            this.isGridRendered = false;
            this.appliedFilters = _Utils__WEBPACK_IMPORTED_MODULE_25__.initialFilterModel;
            this.gridOptions = {};
            this.displayedRowCount = 0;
            this.isError = false;
            this.isRequestTimeout = false;
            this.requestTimerId = 0;
            this.delayId = 0;
            this.globalStatusSubscription = {};
            this.channelStatusSubscription = {};
            this.contactStatsSubscription = {};
            this.appliedGroups = [];
            this.selectedAgentId = "";
            this.expandedGroupState = [];
            this.agentDataMap = new Map();
            this.cmsAgentData = [];
            this.isAgentGlobalSubscribed = false;
            this.isChannelStatusSubscribed = false;
            this.isContactStatusSubscribed = false;
            this.popperInstance = null;
            this.contextMenuInstance = null;
            this.selectedActionCellValue = {};
            this.resizeObserver = null;
            this.monitoringInProgress = false;
            this.updateContextMenuValuesTimeout = null;
            this.isGridInitialized = false;
            this.isSkillProfileDialogOpen = false;
            this.contextMenuOpened = false;
            this.webexChatOpened = false;
            this.stateSelectorInstance = null;
            this.stateSelectorOpened = false;
            this.contextMenuList = [];
            this.isServerSidePaginated = false;
            this.searchTerm = "";
            this.isSigningOutAgent = false;
            this.isAgGridLoaded = false;
            this.isAlpineLoaded = false;
            this.isMomentumAvatarEnabledReactionDisposer = undefined;
            this.subscribeGlobalStatusDataSet = () => __awaiter(this, void 0, void 0, function* () {
                var _a;
                try {
                    // Subscribe to wxcc.rtd.globalstatus
                    const response = yield ((_a = window.wxcc) === null || _a === void 0 ? void 0 : _a.rtdwc.subscribe({
                        datasetName: globalStatusDataSet,
                        update: (data, deltaData) => {
                            this.setAgentGlobalStatusData(data.datasetValues, data.type, deltaData === null || deltaData === void 0 ? void 0 : deltaData.datasetValues);
                        }
                    }));
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:TPW] subscribed AgentGlobalStatus successfully");
                    return response;
                }
                catch (error) {
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error("[App:TPW] Failed to subscribe AgentGlobalStatus", error);
                    throw error;
                }
            });
            this.subscribeAgentChannelStatusDataSet = () => __awaiter(this, void 0, void 0, function* () {
                var _b;
                try {
                    // Subscribe to wxcc.rtd.agentchannelstatus
                    const response = yield ((_b = window.wxcc) === null || _b === void 0 ? void 0 : _b.rtdwc.subscribe({
                        datasetName: agentChannelStatusDataSet,
                        update: (data, deltaData) => {
                            this.setAgentChannelStatusData(data === null || data === void 0 ? void 0 : data.datasetValues, data.type, deltaData === null || deltaData === void 0 ? void 0 : deltaData.datasetValues);
                        }
                    }));
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:TPW] subscribed AgentChannelStatus successfully");
                    return response;
                }
                catch (error) {
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error("[App:TPW] Failed to subscribe AgentChannelStatus", error);
                    throw error;
                }
            });
            this.subscribeContactStatsDataSet = () => __awaiter(this, void 0, void 0, function* () {
                var _c;
                try {
                    // Subscribe to wxcc.rtd.contactstatus
                    const response = yield ((_c = window.wxcc) === null || _c === void 0 ? void 0 : _c.rtdwc.subscribe({
                        datasetName: contactStatsDataSet,
                        update: (data, deltaData) => {
                            this.setAgentContactStatsData(data === null || data === void 0 ? void 0 : data.datasetValues, data.type, deltaData === null || deltaData === void 0 ? void 0 : deltaData.datasetValues);
                        }
                    }));
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:TPW] subscribed ContactStats successfully");
                    return response;
                }
                catch (error) {
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error("[App:TPW] Failed to subscribe ContactStats", error);
                    throw error;
                }
            });
            this.handleAgentSignout = (values, event) => {
                this.selectedActionCellValue = values;
                const detail = { selectedAgentId: event.detail.agentId };
                this.updateSelectedAgentId(detail);
                this.isSignoutModalOpen = true;
            };
            this.handleAgentSignoutContext = (event) => {
                const detail = { selectedAgentId: event.detail.agentId };
                this.updateSelectedAgentId(detail);
                this.isSignoutModalOpen = true;
            };
            this.handleSkillProfileChangeContext = (event) => {
                const detail = { selectedAgentId: event.detail.agentId };
                this.updateSelectedAgentId(detail);
                this.closeOverlayContent();
                this.isSkillProfileDialogOpen = true;
            };
            this.handleStateChangeSelector = (values, event) => __awaiter(this, void 0, void 0, function* () {
                var _d;
                const detail = { selectedAgentId: values.agentId };
                this.updateSelectedAgentId(detail);
                // Close the existing popper instance
                this.closeOverlayContent({ closeStateChange: false });
                this.selectedActionCellValue = values;
                (_d = this.stateSelector) === null || _d === void 0 ? void 0 : _d.toggleAttribute("data-show", true);
                this.stateSelectorInstance = this.createPopperInstance(event, this.stateSelector, "bottom");
                this.stateSelectorOpened = true;
                this.positionStateSelectorInstance();
            });
            this.handleAIDModal = (agentId) => {
                this.closeOverlayContent();
                this.handleModal({ detail: { modalIsOpen: true } });
                this.selectedAgentId = agentId;
                const detail = { selectedAgentId: agentId };
                this.updateSelectedAgentId(detail);
            };
            this.handleContextMenu = (values, event, contextMenuList) => {
                var _a;
                this.closeOverlayContent({ closeContextMenu: false });
                this.contextMenuList = contextMenuList;
                this.selectedActionCellValue = values;
                (_a = this.contextMenu) === null || _a === void 0 ? void 0 : _a.toggleAttribute("data-show", true);
                setTimeout(() => {
                    this.contextMenuInstance = this.createPopperInstance(event, this.contextMenu, "bottom");
                    this.contextMenuOpened = true;
                    this.contextMenuInstance.update();
                }, 0);
            };
            this.handleWebexChat = (values, event) => {
                var _a;
                this.closeOverlayContent({ closeWebexSendMessage: false });
                this.selectedActionCellValue = values;
                (_a = this.overlayElement) === null || _a === void 0 ? void 0 : _a.toggleAttribute("data-show", true);
                setTimeout(() => {
                    this.popperInstance = this.createPopperInstance(event, this.overlayElement, "bottom");
                    this.webexChatOpened = true;
                    this.popperInstance.update();
                }, 0);
            };
            this.closeOverlayContentHandler = (_event) => {
                this.closeOverlayContent();
            };
            this.getGridConfigs = () => {
                return {
                    webexEnabled: this.tpwConfigs.webexEnabled,
                    isDarkMode: this.tpwConfigs.isDarkMode,
                    isMCMEnabled: this.tpwConfigs.isMCMEnabled,
                    isError: this.isError,
                    supervisorId: this.tpwConfigs.supervisorId,
                    isStateChangeBySupervisorEnabled: this.tpwConfigs.isStateChangeBySupervisorEnabled,
                    isSignoutBySupervisorEnabled: this.tpwConfigs.isSignoutBySupervisorEnabled,
                    onActiveCall: this.tpwConfigs.onActiveCall,
                    isSupervisorySendMessageEnabled: this.tpwConfigs.isSupervisorySendMessageEnabled,
                    actionCellLocalizationValues: this.actionCellLocalizationValues(),
                    actionCellWidth: this.getActionColumnWidth(),
                    voiceChannelCount: this.tpwConfigs.voiceChannelCount,
                    isMPCorPersistEnabled: this.tpwConfigs.isMPCorPersistEnabled,
                    isPostCallEnabled: this.tpwConfigs.isPostCallEnabled,
                    isDesktopAuxCodesInfiniteScrollEnabled: this.tpwConfigs.isDesktopAuxCodesInfiniteScrollEnabled,
                    handleAIDModal: this.handleAIDModal,
                    handleStateChangeSelector: this.handleStateChangeSelector,
                    handleContextMenu: this.handleContextMenu,
                    handleWebexChat: this.handleWebexChat,
                    handleAgentSignout: this.handleAgentSignout
                };
            };
            this.actionCellLocalizationValues = () => {
                return {
                    monitoring: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.monitoring"),
                    ownMonitoring: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.ownMonitoring"),
                    supervisorMonitoring: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.supervisorMonitoring"),
                    beingMonitored: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.beingMonitored"),
                    cannotMonitorConsult: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.cannotMonitorConsult"),
                    reviewAndMonitor: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.reviewAndMonitor"),
                    review: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.review"),
                    signingoutTooltip: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.signingoutTooltip"),
                    signingoutErrorTooltip: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.signingoutErrorTooltip"),
                    selfSignoutWarningTooltip: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.selfSignoutWarningTooltip"),
                    signoutTooltip: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.signoutTooltip"),
                    signoutBlockedTooltip: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.signoutBlockedTooltip"),
                    webexChatSendMessage: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:notifications.webexChatSendMessage"),
                    webexChatSendingMessage: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:notifications.webexChatSendingMessage"),
                    webexChatTPWErrorMessage: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:notifications.webexChatTPWErrorMessage"),
                    moreAction: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:notes:moreActions"),
                    stateChange: {
                        default: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.stateChange.default"),
                        progress: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.stateChange.progress"),
                        failed: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.stateChange.failed")
                    },
                    skillProfile: {
                        default: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.skillProfile.default")
                    },
                    alreadyBargedIn: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.alreadyBargedIn"),
                    supervisorBargedIn: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.supervisorBargedIn"),
                    cannotMonitorBargedcall: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.cannotMonitorBargedCall"),
                    bargedIn: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.bargedIn"),
                    notHaveChannels: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.notHaveChannels"),
                    cannotMonitorWrapUp: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.cannotMonitorWrapUp"),
                    cannotMonitorWrapUpAssistance: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.cannotMonitorWrapUpAssistance"),
                    cannotMonitorPostCall: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.cannotMonitorPostCall")
                };
            };
            this.showFailedToLoadDataEmptyGrid = () => {
                var _a, _b, _c;
                (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.setGridOption("loading", false);
                (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.hideOverlay();
                (_c = this.gridApi) === null || _c === void 0 ? void 0 : _c.showNoRowsOverlay();
                this.emptyGrid.setAttribute("is-error", "1");
            };
            this.handleModal = (e) => {
                var _a;
                this.isModalOpen = (_a = e.detail) === null || _a === void 0 ? void 0 : _a.modalIsOpen;
                if (this.isModalOpen) {
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry.TELEM_EVENT.AID_OPENED, {
                        SupervisorId: this.tpwConfigs.supervisorId,
                        Role: this.tpwConfigs.role
                    });
                }
            };
            this.positionStateSelectorInstance = () => {
                setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                    var _a;
                    yield ((_a = this.stateSelectorInstance) === null || _a === void 0 ? void 0 : _a.update());
                }), 0);
            };
            this.refreshColumn = (event) => {
                var _a, _b;
                const column = event.column;
                if (!column) {
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error("Trying to refresh a column that doesn't exist!");
                    return;
                }
                const columnId = (_a = event.column) === null || _a === void 0 ? void 0 : _a.getColId();
                if (column && columnId === "actions") {
                    (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.refreshCells({ force: true, columns: [columnId] });
                }
                this.debouncedSaveGridConfigs();
            };
            this.onGridReady = (fetchedAgents = new Map()) => {
                var _a, _b, _c, _d, _e;
                const storedGridConfigs = JSON.parse((_a = localStorage.getItem(this.tpwConfigs.gridId)) !== null && _a !== void 0 ? _a : "{}");
                if (Object.keys(storedGridConfigs).length) {
                    this.expandedGroupState = storedGridConfigs.rowGroupState || [];
                    const defaultState = (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.getColumnState().filter((item) => item.colId !== "agentInteractionTime");
                    if (!lodash__WEBPACK_IMPORTED_MODULE_16___default().isEqual(storedGridConfigs.columnState, defaultState)) {
                        (_c = this.gridApi) === null || _c === void 0 ? void 0 : _c.applyColumnState({
                            state: storedGridConfigs.columnState,
                            applyOrder: true
                        });
                    }
                    this.updateFilterModel(storedGridConfigs.filterModel);
                }
                (_d = this.gridApi) === null || _d === void 0 ? void 0 : _d.setGridOption("loading", true);
                this.isGridRendered = true;
                this.fetchAgentStatus();
                if (this.tpwConfigs.isShowSignedOutAgentsEnabled) {
                    if (this.isServerSidePaginated) {
                        (_e = this.gridApi) === null || _e === void 0 ? void 0 : _e.setGridOption("serverSideDatasource", this.createDatasource());
                    }
                    else {
                        this.agentDataMap = fetchedAgents;
                        this.setRowData();
                    }
                }
                this.getDisplayedRowCount();
                this.requestUpdate();
                this.handleAccessibility();
            };
            this.createDatasource = () => {
                const getPage = (startRow = 1) => {
                    if (startRow && startRow !== 0) {
                        return Math.ceil(startRow / this.tpwConfigs.requestedPageSize);
                    }
                    else {
                        return startRow;
                    }
                };
                const getSortOrder = (sortOrder) => {
                    const order = sortOrder.find((order) => order.colId === "agentNameDetails");
                    if (order) {
                        return order.sort;
                    }
                    return "asc"; //default
                };
                const fetchData = (params) => __awaiter(this, void 0, void 0, function* () {
                    const pageNumber = getPage(params.request.startRow);
                    const sortOrder = getSortOrder(params.request.sortModel);
                    const fetchedAgents = yield this.fetchAllAgents(pageNumber, this.searchTerm, sortOrder);
                    const enrichedAgents = this.enrichCMSDataWithRTDData(fetchedAgents);
                    const lastRow = enrichedAgents.size < this.tpwConfigs.requestedPageSize
                        ? pageNumber * this.tpwConfigs.requestedPageSize + enrichedAgents.size
                        : -1;
                    params.success({ rowData: Array.from(enrichedAgents.values()), rowCount: lastRow });
                });
                return {
                    getRows: (params) => __awaiter(this, void 0, void 0, function* () {
                        try {
                            yield fetchData(params);
                        }
                        catch (err) {
                            _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error(`Failed to fetch data paginated data. Error: ${err}`);
                            params.fail();
                        }
                    })
                };
            };
            this.onSortChanged = () => {
                var _a;
                this.saveGridConfigs();
                const columnState = (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.getColumnState();
                if (columnState) {
                    const sortedColumns = columnState.filter((column) => column.sort != null);
                    sortedColumns.forEach((column) => {
                        var _a, _b;
                        (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry.TELEM_EVENT.TPW_COLUMN_SORTED, {
                            ColumnName: column.colId,
                            ColumnSortOrder: column.sort
                        }, [(_b = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.webex_behavioral]);
                    });
                }
            };
            this.saveGridConfigs = () => {
                var _a;
                const columnState = (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.getColumnState();
                if (columnState) {
                    const groupedRow = columnState.filter((a) => a.rowGroup);
                    this.appliedGroups = groupedRow;
                }
                if (this.isGridRendered) {
                    localStorage.setItem(this.tpwConfigs.gridId, JSON.stringify({
                        filterModel: this.appliedFilters,
                        columnState,
                        rowGroupState: this.expandedGroupState
                    }));
                }
            };
            this.debouncedSaveGridConfigs = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_5__.debounce)(this.saveGridConfigs, 300);
            this.updateSelectedAgentId = (detail) => {
                if (detail.selectedAgentId && this.agentStatusData && this.agentStatusData.length > 0) {
                    this.selectedAgentId = detail.selectedAgentId;
                    this.updateSelectedAgentDetails();
                }
            };
            this.handleOutSideClick = (event) => {
                let insideMenuClick = false;
                const path = event.composedPath();
                if (path.length) {
                    insideMenuClick = !!path.find((element) => element === this.overlayElement || element === this.contextMenu || element === this.stateSelector);
                    if (!insideMenuClick || event.code === "Escape") {
                        if (event.type === "keydown" && event.code === "Escape") {
                            if (this.contextMenuOpened) {
                                this.returnFocusToMoreActionIcon();
                            }
                            else if (this.webexChatOpened) {
                                this.returnFocusToChatIcon();
                            }
                            else if (this.stateSelectorOpened) {
                                this.returnFocusToChangeStateIcon();
                            }
                            else if (this.isModalOpen) {
                                this.handleFocusOnCloseOfReviewAndMonitor();
                            }
                        }
                        else if (event.type === "click" && this.isSigningOutAgent) {
                            this.returnFocusToSignoutIcon();
                            return; //while selecting sign out option ignore the click which interacts with the modal choice
                        }
                        this.closeOverlayContent();
                    }
                }
            };
            this.handleFocusOnEscape = (e) => {
                const headerElement = this.eGridDiv.querySelector(`.ag-header-cell[col-id="${e.detail}"]`);
                if (headerElement) {
                    headerElement.focus();
                }
            };
            this.handleTPWMonitorModal = (e) => {
                this.handleModal(e);
                this.handleFocusOnCloseOfReviewAndMonitor();
            };
            this.setUpdatedFilter = (event, fromRenderer) => {
                event.stopPropagation();
                let updatedFilter = {};
                if (fromRenderer) {
                    updatedFilter = Object.assign(Object.assign({}, this.appliedFilters), { [event.detail.field]: (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.checkIfFilterModelIsEmpty)(event.detail.data)
                            ? {}
                            : Object.assign(Object.assign({}, this.appliedFilters[event.detail.field]), event.detail.data) });
                }
                else {
                    updatedFilter = event.detail.clearAllFilter
                        ? _Utils__WEBPACK_IMPORTED_MODULE_25__.initialFilterModel
                        : Object.assign(Object.assign({}, this.appliedFilters), { [event.detail.field]: event.detail.data });
                }
                this.updateFilterModel(updatedFilter);
                this.getDisplayedRowCount();
                this.saveGridConfigs();
                this.requestUpdate();
            };
            this.updateGroupState = (rowGroupCol) => {
                this.expandedGroupState = this.expandedGroupState.filter((item) => {
                    return rowGroupCol.some((col) => {
                        return item.includes(col);
                    });
                });
            };
            this.updateGroupStateAfterData = (rowGroupCol) => {
                let groups = [];
                rowGroupCol.forEach((col) => {
                    groups = [
                        ...groups,
                        ...new Set(this.agentStatusData.map((item) => {
                            if (col === "agentNameDetails") {
                                return `${col}:${item[col].agentName}`;
                            }
                            return `${col}:${item[col]}`;
                        }))
                    ];
                });
                this.expandedGroupState = this.expandedGroupState.filter((groupState) => {
                    return groups.includes(groupState);
                });
            };
            this.setUpdatedGroupFilter = (event) => {
                var _a;
                event.stopPropagation();
                const { clearAllFilter, field } = event.detail;
                let updatedFilter;
                if (clearAllFilter) {
                    updatedFilter = [];
                    this.appliedGroups = [];
                }
                else {
                    const updatedGroupTemp = this.appliedGroups.filter((a) => a.colId !== field);
                    updatedFilter = updatedGroupTemp.map((a) => a.colId);
                    this.appliedGroups = updatedGroupTemp;
                }
                (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.setRowGroupColumns(updatedFilter);
                this.updateGroupState(updatedFilter);
                this.getDisplayedRowCount();
                this.saveGridConfigs();
                this.requestUpdate();
            };
            this.updateGroupFilter = () => {
                const updatedFilter = this.appliedGroups.map((a) => a.colId);
                this.updateGroupStateAfterData(updatedFilter);
            };
            this.closeContextMenu = () => {
                var _a, _b;
                (_a = this.contextMenu) === null || _a === void 0 ? void 0 : _a.toggleAttribute("data-show", false);
                (_b = this.contextMenuInstance) === null || _b === void 0 ? void 0 : _b.destroy();
                this.contextMenuOpened = false;
                setTimeout(() => {
                    this.contextMenuInstance = null;
                }, 0);
            };
            this.closeWebExChat = () => {
                var _a, _b;
                (_a = this.overlayElement) === null || _a === void 0 ? void 0 : _a.toggleAttribute("data-show", false);
                (_b = this.popperInstance) === null || _b === void 0 ? void 0 : _b.destroy();
                this.webexChatOpened = false;
                setTimeout(() => {
                    this.popperInstance = null;
                }, 0);
            };
            this.closeStateChangeOverlay = () => {
                var _a;
                if (this.stateSelectorOpened) {
                    (_a = this.stateSelector) === null || _a === void 0 ? void 0 : _a.toggleAttribute("data-show", false);
                    this.stateSelectorOpened = false;
                    setTimeout(() => {
                        var _a;
                        (_a = this.stateSelectorInstance) === null || _a === void 0 ? void 0 : _a.destroy();
                        this.stateSelectorInstance = null;
                    }, 0);
                }
            };
            this.updateActionCellValue = (params, focusComponent) => {
                var _a, _b, _c, _d, _e, _f;
                const rowNode = (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.getRowNode((_b = params.detail) === null || _b === void 0 ? void 0 : _b.agentId);
                rowNode === null || rowNode === void 0 ? void 0 : rowNode.setDataValue("actions", Object.assign(Object.assign({}, rowNode.data.actions), params === null || params === void 0 ? void 0 : params.detail));
                if (((_c = this.selectedActionCellValue) === null || _c === void 0 ? void 0 : _c.agentId) === ((_d = params.detail) === null || _d === void 0 ? void 0 : _d.agentId)) {
                    this.selectedActionCellValue = Object.assign(Object.assign({}, this.selectedActionCellValue), params === null || params === void 0 ? void 0 : params.detail);
                    this.focusOnComponent(focusComponent);
                }
                // Update Action Cell value to internal properties
                if (this.agentDataMap) {
                    const currentValue = this.agentDataMap.get((_e = params.detail) === null || _e === void 0 ? void 0 : _e.agentId);
                    if (currentValue === null || currentValue === void 0 ? void 0 : currentValue.actions) {
                        // Update only action cell values.
                        const mapValue = Object.assign(Object.assign({}, currentValue), { actions: Object.assign(Object.assign({}, currentValue.actions), params === null || params === void 0 ? void 0 : params.detail) });
                        this.agentDataMap.set((_f = params.detail) === null || _f === void 0 ? void 0 : _f.agentId, mapValue);
                    }
                }
            };
            (0,_components_Common_Utils_GridUtils__WEBPACK_IMPORTED_MODULE_0__.initializeGlobalGridProperties)();
        }
        connectedCallback() {
            const _super = Object.create(null, {
                connectedCallback: { get: () => super.connectedCallback }
            });
            return __awaiter(this, void 0, void 0, function* () {
                _super.connectedCallback.call(this);
                window.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_1__.TPW_MONITOR_MODAL, this.handleTPWMonitorModal);
                window.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_1__.TPW_FILTER_MODAL_UPDATED, this.saveGridConfigs);
                window.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_1__.TPW_AGENT_STATE_SELECTOR_LOADING_CHANGED, this.positionStateSelectorInstance);
                document.addEventListener("click", this.handleOutSideClick);
                document.addEventListener("keydown", this.handleOutSideClick);
                document.addEventListener("scroll", this.closeOverlayContentHandler, { passive: true });
                document.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_1__.COLUMN_MENU_FOCUS, this.handleFocusOnEscape);
                this.isMomentumAvatarEnabledReactionDisposer = (0,mobx__WEBPACK_IMPORTED_MODULE_17__.reaction)(() => _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8__.themeManager.isMomentumAvatarEnabled, () => {
                    var _a;
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:TPW] isMomentumAvatarEnabled changed refreshing agentNameDetails: ", _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8__.themeManager.isMomentumAvatarEnabled);
                    (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.refreshCells({ force: true, columns: ["agentNameDetails"] });
                });
            });
        }
        disconnectedCallback() {
            var _a, _b, _c;
            super.disconnectedCallback();
            if ((_a = this.contactStatsSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe) {
                this.contactStatsSubscription.unsubscribe();
            }
            if ((_b = this.channelStatusSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe) {
                this.channelStatusSubscription.unsubscribe();
            }
            if ((_c = this.globalStatusSubscription) === null || _c === void 0 ? void 0 : _c.unsubscribe) {
                this.globalStatusSubscription.unsubscribe();
            }
            _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_12__.clearTimeout(this.requestTimerId);
            _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_12__.clearTimeout(this.delayId);
            window.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_1__.TPW_MONITOR_MODAL, this.handleTPWMonitorModal);
            window.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_1__.TPW_FILTER_MODAL_UPDATED, this.saveGridConfigs);
            window.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_1__.TPW_AGENT_STATE_SELECTOR_LOADING_CHANGED, this.positionStateSelectorInstance);
            document.removeEventListener("click", this.handleOutSideClick);
            document.removeEventListener("keydown", this.handleOutSideClick);
            document.removeEventListener("scroll", this.closeOverlayContentHandler);
            document.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_1__.COLUMN_MENU_FOCUS, this.handleFocusOnEscape);
            this.agentDataMap = new Map();
            this.agentStatusData = [];
            this.tpwConfigs = {};
            if (this.updateContextMenuValuesTimeout) {
                clearTimeout(this.updateContextMenuValuesTimeout);
            }
            if (this.isMomentumAvatarEnabledReactionDisposer) {
                this.isMomentumAvatarEnabledReactionDisposer();
            }
        }
        updateFilterModel(filterModel) {
            var _a;
            this.appliedFilters = filterModel;
            (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.setFilterModel(filterModel);
        }
        resetColumnState() {
            var _a;
            (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.resetColumnState();
        }
        getDisplayedRowCount() {
            var _a;
            if (this.isServerSidePaginated) {
                return;
            }
            let filteredRowCount = 0;
            (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.forEachNodeAfterFilter((rowNode, _index) => {
                if (rowNode.data) {
                    filteredRowCount++;
                }
            });
            this.displayedRowCount = filteredRowCount;
        }
        returnFocusToChatIcon() {
            var _a, _b, _c, _d, _e;
            // Focus back to the Chat Icon
            if (this.contextMenuOpened) {
                // Context Menu is opened.
                // Focus to the list
                if (this.contextMenu) {
                    const contextMenuElement = (_c = (_b = (_a = this.contextMenu) === null || _a === void 0 ? void 0 : _a.querySelector("agentx-wc-tpw-context-menu")) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector(".webex-send-message");
                    if (contextMenuElement) {
                        contextMenuElement === null || contextMenuElement === void 0 ? void 0 : contextMenuElement.focus();
                    }
                }
            }
            else {
                // Focus to the chat icon inside action cell.
                const webexButtonElement = (_d = this.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector(`.agentx-webex-chat-${(_e = this.selectedActionCellValue) === null || _e === void 0 ? void 0 : _e.agentId}`);
                if (webexButtonElement) {
                    webexButtonElement === null || webexButtonElement === void 0 ? void 0 : webexButtonElement.focus();
                }
            }
        }
        returnFocusToMoreActionIcon() {
            var _a, _b;
            const moreActionsButtonElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`.more-action-${(_b = this.selectedActionCellValue) === null || _b === void 0 ? void 0 : _b.agentId}`);
            if (moreActionsButtonElement) {
                moreActionsButtonElement === null || moreActionsButtonElement === void 0 ? void 0 : moreActionsButtonElement.focus();
            }
        }
        returnFocusToChangeStateIcon() {
            var _a, _b;
            const stateChangeButtonElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`.state-change-${(_b = this.selectedActionCellValue) === null || _b === void 0 ? void 0 : _b.agentId}`);
            if (stateChangeButtonElement) {
                stateChangeButtonElement === null || stateChangeButtonElement === void 0 ? void 0 : stateChangeButtonElement.focus();
            }
        }
        returnFocusToSignoutIcon() {
            var _a, _b;
            const signoutButtonElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`.signout-${(_b = this.selectedActionCellValue) === null || _b === void 0 ? void 0 : _b.agentId}`);
            if (signoutButtonElement) {
                signoutButtonElement === null || signoutButtonElement === void 0 ? void 0 : signoutButtonElement.focus();
                return true;
            }
            return false;
        }
        handleFocusOnCloseOfReviewAndMonitor() {
            var _a;
            const reviewAndMonitorButton = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`.review-monitor-${this.selectedAgentId}`);
            if (reviewAndMonitorButton) {
                reviewAndMonitorButton === null || reviewAndMonitorButton === void 0 ? void 0 : reviewAndMonitorButton.focus();
            }
            else {
                this.returnFocusToMoreActionIcon();
            }
        }
        focusOnComponent(focusComponent) {
            switch (focusComponent) {
                case FocusComponent.SEND_MESSAGE:
                    this.returnFocusToChatIcon();
                    break;
                case FocusComponent.STATE_CHANGE:
                    this.returnFocusToChangeStateIcon();
                    break;
                case FocusComponent.SIGNOUT:
                    this.returnFocusToSignoutIcon();
                    break;
            }
        }
        render() {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.html) `
        ${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.featureflag.isFeatureFlagEnabled(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.FEATURE_FLAGS.DESKTOP_SKILL_PROFILE)
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.html) `
              <skill-profile-dialog
                .isOpen="${this.isSkillProfileDialogOpen}"
                .agentName="${(_a = this.selectedAgentDetails) === null || _a === void 0 ? void 0 : _a.agentName}"
                .agentEmail="${(_c = (_b = this.selectedAgentDetails) === null || _b === void 0 ? void 0 : _b.agentEmail) !== null && _c !== void 0 ? _c : ""}"
                .orgId="${this.tpwConfigs.orgId}"
                @dialog-closed="${() => {
                    this.isSkillProfileDialogOpen = false;
                }}"
              ></skill-profile-dialog>
            `
                : lit_html_lib_part__WEBPACK_IMPORTED_MODULE_15__.nothing}
        ${this.tpwConfigs.isSignoutBySupervisorEnabled
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.html) `
              <agentx-wc-tpw-signout-modal
                .isSignoutModalOpen=${this.isSignoutModalOpen}
                .selectedAgentDetails=${this.selectedAgentDetails}
                @confirm-signout="${this.confirmAgentSignout}"
                @decline-signout="${this.declineAgentSignout}"
              ></agentx-wc-tpw-signout-modal>
            `
                : lit_html_lib_part__WEBPACK_IMPORTED_MODULE_15__.nothing}
        <div class="tpw-wrapper">
          <agentx-wc-tpw-grid-header
            .gridApi=${this.gridApi}
            .gridOptions=${this.gridOptions}
            .displayedRowCount=${this.displayedRowCount}
            .isServerSidePaginated=${this.isServerSidePaginated}
            @tpw-search-updated=${(searchTerm) => {
                var _a;
                if (this.isServerSidePaginated) {
                    this.searchTerm = searchTerm.detail.searchTerm;
                    (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.refreshServerSide({ purge: true });
                }
                else {
                    this.getDisplayedRowCount();
                }
            }}
            @tpw-reset-table=${(event) => {
                this.expandedGroupState = [];
                this.setUpdatedFilter(event);
                this.resetColumnState();
            }}
          ></agentx-wc-tpw-grid-header>

          <agentx-wc-tpw-applied-filters
            id="filters"
            .appliedFilters=${this.appliedFilters}
            .appliedGroups=${this.appliedGroups}
            .gridOptions=${this.gridOptions}
            @tpw-group-filter-updated=${(event) => this.setUpdatedGroupFilter(event)}
            @tpw-filter-updated=${(event) => this.setUpdatedFilter(event)}
          ></agentx-wc-tpw-applied-filters>
          <div
            class=${`grid-container ${this.isGridRendered ? "" : "grid-rendering"} ${this.tpwConfigs.isDarkMode ? "ag-theme-alpine-dark" : "ag-theme-alpine"}`}
            id="agentx-wc-tpw-grid-container"
            @tpw-filter-updated=${(event) => this.setUpdatedFilter(event, true)}
          ></div>
          <agentx-wc-aid
            @tpw-monitor-modal=${(e) => {
                this.handleModal(e);
                this.handleFocusOnCloseOfReviewAndMonitor();
            }}
            .selectedAgentDetails=${this.selectedAgentDetails}
            .isModalOpen=${this.isModalOpen}
            .isMCMEnabled=${this.tpwConfigs.isMCMEnabled}
            .role=${this.tpwConfigs.role}
            .monitoringInProgress=${this.monitoringInProgress}
            .isMPCorPersistEnabled=${this.tpwConfigs.isMPCorPersistEnabled}
            .isPostCallEnabled=${this.tpwConfigs.isPostCallEnabled}
          ></agentx-wc-aid>

          <div class="tpw-chat-wrapper custom-menu-overlay overlay-container" role="dialog">
            <div class="overlay-content" part="overlay-content">
              <webex-chat
                .isOpen="${this.webexChatOpened}"
                name="${(_d = this.selectedActionCellValue) === null || _d === void 0 ? void 0 : _d.agentName}"
                agentId="${(_e = this.selectedActionCellValue) === null || _e === void 0 ? void 0 : _e.agentId}"
                agentEmail="${(_f = this.selectedActionCellValue) === null || _f === void 0 ? void 0 : _f.agentEmail}"
                @webexchat-overlay-close="${() => {
                this.closeWebExChat();
                this.returnFocusToChatIcon();
            }}"
                @update-actions-cell-value="${(event) => this.updateActionCellValue(event, FocusComponent.SEND_MESSAGE)}"
              ></webex-chat>
            </div>
          </div>

          <div class="context-menu-wrapper custom-menu-overlay overlay-container" role="menu">
            <agentx-wc-tpw-context-menu
              .isOpen="${this.contextMenuOpened}"
              .contextMenuList="${this.contextMenuList}"
              agentId="${(_g = this.selectedActionCellValue) === null || _g === void 0 ? void 0 : _g.agentId}"
              .actionCellConfigs="${this.selectedActionCellValue}"
              .isMCMEnabled=${this.tpwConfigs.isMCMEnabled}
              .webexEnabled=${this.tpwConfigs.webexEnabled}
              .isMPCorPersistEnabled=${this.tpwConfigs.isMPCorPersistEnabled}
              .isPostCallEnabled=${this.tpwConfigs.isPostCallEnabled}
              .isSupervisorySendMessageEnabled=${this.tpwConfigs.isSupervisorySendMessageEnabled}
              @handle-webex-chat=${this.handleWebexChatContext}
              @handle-state-change="${this.handleStateChangeContext}"
              @handle-agent-signout="${this.handleAgentSignoutContext}"
              @handle-skill-profile-change="${this.handleSkillProfileChangeContext}"
              @handle-aid-modal=${(event) => this.handleAIDModal(event.detail.agentId)}
            ></agentx-wc-tpw-context-menu>
          </div>

          ${this.tpwConfigs.isStateChangeBySupervisorEnabled
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.html) ` <div class="agent-state-selector custom-menu-overlay overlay-container" role="dialog">
                <div class="overlay-content" part="overlay-content">
                  ${this.tpwConfigs.isDesktopAuxCodesInfiniteScrollEnabled
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.html) ` <agentx-wc-tpw-agent-state-selector-infinite
                        .isWxccCoreDisallowPendingLogoutStateChangeEnabled="${this.tpwConfigs
                        .isWxccCoreDisallowPendingLogoutStateChangeEnabled}"
                        .orgId="${this.tpwConfigs.orgId}"
                        .selectedAgentDetails=${this.selectedAgentDetails}
                        .isOpen="${this.stateSelectorOpened}"
                        agentId="${(_h = this.selectedActionCellValue) === null || _h === void 0 ? void 0 : _h.agentId}"
                        @update-actions-cell-value="${(event) => this.updateActionCellValue(event, FocusComponent.STATE_CHANGE)}"
                        @state-change-overlay-close="${() => {
                        this.closeStateChangeOverlay();
                        this.returnFocusToChangeStateIcon();
                    }}"
                      ></agentx-wc-tpw-agent-state-selector-infinite>`
                    : (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.html) ` <agentx-wc-tpw-agent-state-selector
                        .isWxccCoreDisallowPendingLogoutStateChangeEnabled="${this.tpwConfigs
                        .isWxccCoreDisallowPendingLogoutStateChangeEnabled}"
                        .orgId="${this.tpwConfigs.orgId}"
                        .selectedAgentDetails=${this.selectedAgentDetails}
                        .orgIdleCodes="${this.tpwConfigs.idleCodes}"
                        .isOpen="${this.stateSelectorOpened}"
                        agentId="${(_j = this.selectedActionCellValue) === null || _j === void 0 ? void 0 : _j.agentId}"
                        @update-actions-cell-value="${(event) => this.updateActionCellValue(event, FocusComponent.STATE_CHANGE)}"
                        @state-change-overlay-close="${() => {
                        this.closeStateChangeOverlay();
                        this.returnFocusToChangeStateIcon();
                    }}"
                      ></agentx-wc-tpw-agent-state-selector>`}
                </div>
              </div>`
                : lit_html_lib_part__WEBPACK_IMPORTED_MODULE_15__.nothing}
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.property)({ type: Object })
    ], Element.prototype, "tpwConfigs", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "gridId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "agentStatusData", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "agentStatusDataServer", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "isModalOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "isSignoutModalOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "isGridRendered", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "appliedFilters", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "gridApi", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "gridOptions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "displayedRowCount", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "isError", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "isRequestTimeout", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "requestTimerId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "delayId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "selectedAgentDetails", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "globalStatusSubscription", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "channelStatusSubscription", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "contactStatsSubscription", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "appliedGroups", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "selectedAgentId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "expandedGroupState", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "agentDataMap", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "cmsAgentData", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "isAgentGlobalSubscribed", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "isChannelStatusSubscribed", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "isContactStatusSubscribed", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "popperInstance", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "contextMenuInstance", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "selectedActionCellValue", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "resizeObserver", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "monitoringInProgress", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "updateContextMenuValuesTimeout", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "isGridInitialized", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "isSkillProfileDialogOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.query)("#agentx-wc-tpw-grid-container")
    ], Element.prototype, "eGridDiv", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.query)("agentx-wc-tpw-empty-grid")
    ], Element.prototype, "emptyGrid", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.query)("#filters")
    ], Element.prototype, "filters", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.query)(".tpw-chat-wrapper")
    ], Element.prototype, "overlayElement", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.query)(".context-menu-wrapper")
    ], Element.prototype, "contextMenu", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "contextMenuOpened", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "webexChatOpened", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "stateSelectorInstance", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.query)(".agent-state-selector")
    ], Element.prototype, "stateSelector", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "stateSelectorOpened", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "contextMenuList", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "isServerSidePaginated", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "searchTerm", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "isSigningOutAgent", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "isAgGridLoaded", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "isAlpineLoaded", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.customElement)("agentx-wc-team-performance-widget")
    ], Element);
    TeamPerformance.Element = Element;
})(TeamPerformance || (TeamPerformance = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/TeamPerformanceUtils.ts":
/*!**********************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/TeamPerformanceUtils.ts ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   agentNameComparator: () => (/* binding */ agentNameComparator),
/* harmony export */   checkIfFilterModelIsEmpty: () => (/* binding */ checkIfFilterModelIsEmpty),
/* harmony export */   convertChannelStatusArrayToMap: () => (/* binding */ convertChannelStatusArrayToMap),
/* harmony export */   convertCmsAgentDataArrayToMap: () => (/* binding */ convertCmsAgentDataArrayToMap),
/* harmony export */   convertContactStatusArrayToMap: () => (/* binding */ convertContactStatusArrayToMap),
/* harmony export */   convertGlobalStatusArrayToMap: () => (/* binding */ convertGlobalStatusArrayToMap),
/* harmony export */   createGenericEvent: () => (/* binding */ createGenericEvent),
/* harmony export */   dateComparator: () => (/* binding */ dateComparator),
/* harmony export */   disptachFilterDataUpdateEvent: () => (/* binding */ disptachFilterDataUpdateEvent),
/* harmony export */   disptachFilterUpdateEvent: () => (/* binding */ disptachFilterUpdateEvent),
/* harmony export */   durationComparator: () => (/* binding */ durationComparator),
/* harmony export */   filterContactStatsData: () => (/* binding */ filterContactStatsData),
/* harmony export */   filteredTelephonyChannelData: () => (/* binding */ filteredTelephonyChannelData),
/* harmony export */   formatDuration: () => (/* binding */ formatDuration),
/* harmony export */   getAgentInteractionTime: () => (/* binding */ getAgentInteractionTime),
/* harmony export */   getAgentState: () => (/* binding */ getAgentState),
/* harmony export */   getAvatarUrlFromCache: () => (/* binding */ getAvatarUrlFromCache),
/* harmony export */   getContactStatsDetailsForAllParticipants: () => (/* binding */ getContactStatsDetailsForAllParticipants),
/* harmony export */   getDateFormat: () => (/* binding */ getDateFormat),
/* harmony export */   getDisplayedRowCountText: () => (/* binding */ getDisplayedRowCountText),
/* harmony export */   getFormattedDurationTime: () => (/* binding */ getFormattedDurationTime),
/* harmony export */   getParticipantsDetails: () => (/* binding */ getParticipantsDetails),
/* harmony export */   getTimerValue: () => (/* binding */ getTimerValue),
/* harmony export */   mapAgentContactStatus: () => (/* binding */ mapAgentContactStatus),
/* harmony export */   stringComparator: () => (/* binding */ stringComparator),
/* harmony export */   transformChannelStatus: () => (/* binding */ transformChannelStatus),
/* harmony export */   updateAvatarUrlCache: () => (/* binding */ updateAvatarUrlCache),
/* harmony export */   updateContactStatsForDestinationAgent: () => (/* binding */ updateContactStatsForDestinationAgent),
/* harmony export */   updateExistingMapFromChannelStatus: () => (/* binding */ updateExistingMapFromChannelStatus),
/* harmony export */   updateExistingMapFromContactStats: () => (/* binding */ updateExistingMapFromContactStats),
/* harmony export */   updateExistingMapFromGlobalStatus: () => (/* binding */ updateExistingMapFromGlobalStatus)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Utils */ "./src/components/TeamPerformanceWidget/Utils.ts");




const cacheKey = (agentId) => `avt-${agentId}`;
const createGenericEvent = (key, detail) => {
    return new CustomEvent(key, {
        composed: true,
        bubbles: true,
        detail: Object.assign({}, detail)
    });
};
// on filter update save the grid configs to local storage
const disptachFilterUpdateEvent = (comp) => {
    comp.dispatchEvent(createGenericEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.TPW_FILTER_MODAL_UPDATED, {}));
};
const disptachFilterDataUpdateEvent = (key) => {
    window.dispatchEvent(createGenericEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.TPW_FILTER_DATA_UPDATE, { colId: key }));
};
/**
 * Checks if applied filters exists for that specific column key for which filter is applied
 * @param comp
 * @param key
 * @returns Boolean
 */
const checkIfFilterAppliedExists = (comp, key) => {
    return (comp.appliedFilters &&
        Object.prototype.hasOwnProperty.call(comp.appliedFilters, key) &&
        Object.keys(comp.appliedFilters[key]).length !== 0);
};
const isReviewAndMonitorEnabled = (contactStatus) => {
    return !!contactStatus && !_Utils__WEBPACK_IMPORTED_MODULE_3__.disableForContactStatus.includes(contactStatus);
};
/**
 * Add the new row entry data into the filter model
 * @param comp
 * @param key
 * @param rowData
 */
const updateAppliedFilter = (comp, key, rowData, oldData) => {
    if (checkIfFilterAppliedExists(comp, key)) {
        const k = rowData[key];
        if (oldData && oldData[key] === _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE && k !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE) {
            delete comp.appliedFilters[key][_constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE];
        }
        if (key === "agentNameDetails") {
            // agentNameDetails is a object, Contains the agentName property.
            if (!Object.prototype.hasOwnProperty.call(comp.appliedFilters[key], k.agentName)) {
                comp.appliedFilters[key][k.agentName] = false;
            }
        }
        else if (!Object.prototype.hasOwnProperty.call(comp.appliedFilters[key], k)) {
            comp.appliedFilters[key][k] = false;
        }
    }
};
const getDateFormat = (date, lang = "en-US") => {
    const dateTime = luxon__WEBPACK_IMPORTED_MODULE_2__.DateTime.fromJSDate(new Date(date)).setLocale(lang);
    if (lang.startsWith("ja")) {
        return `${dateTime.toLocaleString(luxon__WEBPACK_IMPORTED_MODULE_2__.DateTime.DATE_SHORT)}, ${dateTime.toLocaleString(luxon__WEBPACK_IMPORTED_MODULE_2__.DateTime.TIME_SIMPLE)}`;
    }
    else {
        return dateTime.toLocaleString(luxon__WEBPACK_IMPORTED_MODULE_2__.DateTime.DATETIME_SHORT);
    }
};
const getAvatarUrlFromCache = (agentId) => {
    const url = sessionStorage.getItem(cacheKey(agentId));
    return (typeof url === "string" && url.trim() === "") || url ? url : undefined;
};
const updateAvatarUrlCache = (agentId, url) => {
    sessionStorage.setItem(cacheKey(agentId), url ? url : "");
};
const getDisplayedRowCountText = (displayedRowCount) => {
    return displayedRowCount === 1
        ? `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.displaying")} ${displayedRowCount} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.agent")}`
        : `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.displaying")} ${displayedRowCount} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.agents")}`;
};
const formatDuration = (duration, showDefaultHours = true) => {
    if (!showDefaultHours && duration.shiftTo("hours", "minute").get("hours") < 1) {
        return duration.toFormat("mm:ss");
    }
    return duration.toFormat("hh:mm:ss");
};
const getFormattedDurationTime = (durationTime, showDefaultHours) => {
    if (durationTime) {
        if (durationTime.shiftTo("seconds").seconds < 0) {
            return undefined;
        }
        const formattedDurationTime = formatDuration(durationTime, showDefaultHours);
        if (formattedDurationTime &&
            formattedDurationTime !== "Invalid DateTime" &&
            formattedDurationTime.split(":")[0].length === 1) {
            return `0${formattedDurationTime}`;
        }
        return formattedDurationTime;
    }
    return undefined;
};
const getTimerValue = (duration, showDefaultHours) => {
    if (duration === _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE) {
        return "Invalid Duration";
    }
    const start = luxon__WEBPACK_IMPORTED_MODULE_2__.DateTime.fromMillis(Number(duration));
    return getFormattedDurationTime(luxon__WEBPACK_IMPORTED_MODULE_2__.DateTime.utc().diff(start), showDefaultHours);
};
const getAgentState = (state, idleCodeName) => {
    if (state) {
        if (idleCodeName) {
            return idleCodeName;
        }
        else if (state === _constants__WEBPACK_IMPORTED_MODULE_0__.LOGGED_OUT) {
            return _constants__WEBPACK_IMPORTED_MODULE_0__.SIGNED_OUT;
        }
        else {
            return state;
        }
    }
    return _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE;
};
const stringComparator = (valueA, valueB) => {
    const nameA = valueA === null || valueA === void 0 ? void 0 : valueA.toLocaleLowerCase();
    const nameB = valueB === null || valueB === void 0 ? void 0 : valueB.toLocaleLowerCase();
    if (nameA < nameB) {
        return -1;
    }
    if (nameA > nameB) {
        return 1;
    }
    return 0;
};
const agentNameComparator = (valueA, valueB) => {
    const firstValue = typeof valueA === "object" ? valueA["agentName"] : valueA;
    const secondValue = typeof valueB === "object" ? valueB["agentName"] : valueB;
    const nameA = firstValue === null || firstValue === void 0 ? void 0 : firstValue.toLocaleLowerCase();
    const nameB = secondValue === null || secondValue === void 0 ? void 0 : secondValue.toLocaleLowerCase();
    if (nameA < nameB) {
        return -1;
    }
    if (nameA > nameB) {
        return 1;
    }
    return 0;
};
const durationComparator = (valueA, valueB) => {
    if (valueA < valueB) {
        return 1;
    }
    if (valueA > valueB) {
        return -1;
    }
    return 0;
};
const dateComparator = (valueA, valueB) => {
    if (valueA === _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE && valueB !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE) {
        return 1;
    }
    if (valueA !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE && valueB === _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE) {
        return -1;
    }
    if (valueA === _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE && valueB === _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE) {
        return 0;
    }
    if (valueA < valueB) {
        return -1;
    }
    if (valueA > valueB) {
        return 1;
    }
    return 0;
};
const checkIfFilterModelIsEmpty = (filterModel) => {
    return Object.values(filterModel).every((item) => !item);
};
const getParticipatedSupervisorName = (isSameSupervisor, monitoringSupervisorName) => {
    return isSameSupervisor ? `, ${monitoringSupervisorName} (${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.you")})` : `, ${monitoringSupervisorName}`;
};
const getParticipantsDetails = (agentContact, newEventName, isMPCorPersistEnabled, supervisorId) => {
    var _a;
    const destinationAgent = (_a = agentContact.destinationAgentName) !== null && _a !== void 0 ? _a : agentContact.destinationAgentDNIS;
    const bargedInSupervisor = agentContact.isBarged === "true" && agentContact.monitorFullName
        ? getParticipatedSupervisorName(!!supervisorId && supervisorId === agentContact.monitorUserId, agentContact.monitorFullName)
        : "";
    let participantDetails = {
        activeParticipantsName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
        consultedParticipantName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
        participants: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE
    };
    const participatingAgentList = agentContact.participatingAgentList
        ? JSON.parse(agentContact.participatingAgentList)
        : undefined;
    if (isMPCorPersistEnabled) {
        participantDetails.participants = participatingAgentList === null || participatingAgentList === void 0 ? void 0 : participatingAgentList.reduce((acc, participatingAgent) => {
            const value = participatingAgent.type === "agent" ? participatingAgent.name : participatingAgent.dn;
            if (value) {
                acc.push(value);
            }
            return acc;
        }, []).join(", ").concat(bargedInSupervisor);
    }
    else if (newEventName === _constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE_REQUESTED ||
        newEventName === _constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE_STARTED ||
        newEventName === _constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_COMPLETED_CONFERENCE ||
        newEventName === _constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_STARTED_CONFERENCE) {
        participantDetails = {
            activeParticipantsName: destinationAgent
                ? `${agentContact.agentName}, ${destinationAgent}${bargedInSupervisor}`
                : agentContact.agentName,
            consultedParticipantName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE
        };
    }
    else if (newEventName === _constants__WEBPACK_IMPORTED_MODULE_0__.TRANSFER_COMPLETED) {
        participantDetails = {
            activeParticipantsName: !agentContact.destinationAgentName && agentContact.destinationAgentDNIS
                ? `${agentContact.destinationAgentDNIS}${bargedInSupervisor}`
                : agentContact.agentName,
            consultedParticipantName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE
        };
    }
    else {
        participantDetails = {
            activeParticipantsName: `${agentContact.agentName}${bargedInSupervisor}`,
            consultedParticipantName: destinationAgent !== null && destinationAgent !== void 0 ? destinationAgent : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE
        };
    }
    return participantDetails;
};
const mapAgentContactStatus = (contactStatus, oldContactStatus) => {
    if (contactStatus) {
        switch (contactStatus.toLowerCase()) {
            case _constants__WEBPACK_IMPORTED_MODULE_0__.CONNECTED:
            case _constants__WEBPACK_IMPORTED_MODULE_0__.WRAP_UP:
            case _constants__WEBPACK_IMPORTED_MODULE_0__.WRAP_UP_ASSISTANCE:
            case _constants__WEBPACK_IMPORTED_MODULE_0__.POST_CALL_STARTED:
            case _constants__WEBPACK_IMPORTED_MODULE_0__.POST_CALL_CONSULT_STARTED:
            case _constants__WEBPACK_IMPORTED_MODULE_0__.ON_HOLD:
            case _constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_DONE:
            case _constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCING:
            case _constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_ERROR:
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(`app:tpw.contactStatus.${contactStatus.toLowerCase()}`);
            case "":
                return _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE;
            case _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE_CONSULTING:
            case _constants__WEBPACK_IMPORTED_MODULE_0__.CONNECTED_CONSULTING:
            case _constants__WEBPACK_IMPORTED_MODULE_0__.IDLE_CONSULTING:
            case _constants__WEBPACK_IMPORTED_MODULE_0__.CONSULTING:
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(`app:tpw.contactStatus.consulting`);
            default:
                return oldContactStatus;
        }
    }
    return _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE;
};
const getContactStatsDetailsForAllParticipants = (contactData, oldDataMap, newDataForPrimaryAgent, supervisorId) => {
    var _a;
    const newDataForParticipants = [];
    const existingDataForParticipants = [];
    const oldParticipantsList = (_a = oldDataMap === null || oldDataMap === void 0 ? void 0 : oldDataMap.get(newDataForPrimaryAgent.agentId)) === null || _a === void 0 ? void 0 : _a.participatingAgentList;
    const newParticipantsList = contactData.data.participatingAgentList
        ? JSON.parse(contactData.data.participatingAgentList)
        : undefined;
    const removedParticipants = oldParticipantsList === null || oldParticipantsList === void 0 ? void 0 : oldParticipantsList.filter((oldParticipant) => !(newParticipantsList === null || newParticipantsList === void 0 ? void 0 : newParticipantsList.some((newParticipant) => newParticipant.id === oldParticipant.id)));
    const isTransferredContact = newDataForPrimaryAgent.contactEventName === _constants__WEBPACK_IMPORTED_MODULE_0__.TRANSFER_COMPLETED;
    const isMonitored = isTransferredContact ? "false" : newDataForPrimaryAgent.isMonitored;
    const isSupervisorMonitoring = !!supervisorId && !!newDataForPrimaryAgent.monitorUserId && supervisorId === newDataForPrimaryAgent.monitorUserId;
    newParticipantsList === null || newParticipantsList === void 0 ? void 0 : newParticipantsList.forEach((participant) => {
        const existingDataForParticipant = (oldDataMap === null || oldDataMap === void 0 ? void 0 : oldDataMap.has(participant.id)) ? oldDataMap.get(participant.id) : undefined;
        const actionCellDetails = Object.assign(Object.assign({}, existingDataForParticipant === null || existingDataForParticipant === void 0 ? void 0 : existingDataForParticipant.actions), { agentId: participant.id, agentName: participant.name, supervisorId, monitoredBy: isMonitored === "true" ? newDataForPrimaryAgent.monitorFullName : "", isBarged: !!newDataForPrimaryAgent.isBarged && newDataForPrimaryAgent.isBarged === "true", isSupervisorMonitoring });
        const newDataForParticipant = Object.assign(Object.assign(Object.assign({}, _Utils__WEBPACK_IMPORTED_MODULE_3__.EMPTY_AGENT_DETAILS), existingDataForParticipant), { agentId: participant.id, agentName: participant.name, interactionId: newDataForPrimaryAgent.interactionId, isMonitored: newDataForPrimaryAgent.isMonitored, isBarged: newDataForPrimaryAgent.isBarged, monitorFullName: newDataForPrimaryAgent.monitorFullName, monitorUserId: newDataForPrimaryAgent.monitorUserId, contactPhoneNumber: newDataForPrimaryAgent.contactPhoneNumber, contactQueueName: newDataForPrimaryAgent.contactQueueName, participatingAgentList: newDataForPrimaryAgent.participatingAgentList, participants: newDataForPrimaryAgent.participants, activeParticipantsName: newDataForPrimaryAgent.activeParticipantsName, consultedParticipantName: newDataForPrimaryAgent.consultedParticipantName, recording: newDataForPrimaryAgent.recording, contactEventName: newDataForPrimaryAgent.contactEventName, actions: actionCellDetails });
        newDataForParticipants.push(newDataForParticipant);
        if (existingDataForParticipant) {
            existingDataForParticipants.push(existingDataForParticipant);
        }
    });
    removedParticipants === null || removedParticipants === void 0 ? void 0 : removedParticipants.forEach((participant) => {
        const existingDataForParticipant = (oldDataMap === null || oldDataMap === void 0 ? void 0 : oldDataMap.has(participant.id)) ? oldDataMap.get(participant.id) : undefined;
        const actionCellDetails = Object.assign(Object.assign({}, existingDataForParticipant === null || existingDataForParticipant === void 0 ? void 0 : existingDataForParticipant.actions), { agentId: participant.id, agentName: participant.name, supervisorId, monitoredBy: "", isBarged: false, isSupervisorMonitoring: false });
        const newDataForParticipant = Object.assign(Object.assign(Object.assign({}, _Utils__WEBPACK_IMPORTED_MODULE_3__.EMPTY_AGENT_DETAILS), existingDataForParticipant), { agentId: participant.id, agentName: participant.name, interactionId: "", isMonitored: "false", isBarged: "false", monitorFullName: "", monitorUserId: "", contactPhoneNumber: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, contactQueueName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, participants: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, activeParticipantsName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, consultedParticipantName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, recording: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, contactEventName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, actions: actionCellDetails, participatingAgentList: newDataForPrimaryAgent.participatingAgentList });
        newDataForParticipants.push(newDataForParticipant);
        if (existingDataForParticipant) {
            existingDataForParticipants.push(existingDataForParticipant);
        }
    });
    return { newDataForParticipants, existingDataForParticipants };
};
const updateContactStatsForDestinationAgent = (contactData, oldDataMap, newDataForPrimaryAgent, supervisorId, existingDataForPrimaryAgent) => {
    let newDataForDestinationAgent = {};
    let existingDataForDestinationAgent;
    if (contactData.data.destinationAgentId !== null && contactData.data.destinationAgentName !== null) {
        /** This block of code is used for populating Agent 2 details from
        destinationAgentId present in Agent 1 details and copying only contact related information **/
        existingDataForDestinationAgent = (oldDataMap === null || oldDataMap === void 0 ? void 0 : oldDataMap.has(contactData.data.destinationAgentId))
            ? oldDataMap.get(contactData.data.destinationAgentId)
            : undefined;
        const actionCellDetails = Object.assign(Object.assign({}, newDataForPrimaryAgent.actions), { agentId: contactData.data.destinationAgentId, agentName: contactData.data.destinationAgentName, supervisorId });
        newDataForDestinationAgent = Object.assign(Object.assign(Object.assign({}, _Utils__WEBPACK_IMPORTED_MODULE_3__.EMPTY_AGENT_DETAILS), existingDataForDestinationAgent), { agentId: contactData.data.destinationAgentId, agentName: contactData.data.destinationAgentName, interactionId: newDataForPrimaryAgent.interactionId, isMonitored: newDataForPrimaryAgent.isMonitored, isBarged: newDataForPrimaryAgent.isBarged, monitorFullName: newDataForPrimaryAgent.monitorFullName, monitorUserId: newDataForPrimaryAgent.monitorUserId, contactPhoneNumber: newDataForPrimaryAgent.contactPhoneNumber, contactQueueName: newDataForPrimaryAgent.contactQueueName, activeParticipantsName: newDataForPrimaryAgent.activeParticipantsName, consultedParticipantName: newDataForPrimaryAgent.consultedParticipantName, recording: newDataForPrimaryAgent.recording, contactEventName: newDataForPrimaryAgent.contactEventName, actions: actionCellDetails });
    }
    else if (existingDataForPrimaryAgent &&
        existingDataForPrimaryAgent.destinationAgentId &&
        existingDataForPrimaryAgent.destinationAgentName &&
        newDataForPrimaryAgent.contactEventName !== _constants__WEBPACK_IMPORTED_MODULE_0__.TRANSFER_COMPLETED) {
        // This block of code is used to reset the Agent2 details if consult/conference is over for Agent 2
        existingDataForDestinationAgent = (oldDataMap === null || oldDataMap === void 0 ? void 0 : oldDataMap.has(existingDataForPrimaryAgent === null || existingDataForPrimaryAgent === void 0 ? void 0 : existingDataForPrimaryAgent.destinationAgentId))
            ? oldDataMap.get(existingDataForPrimaryAgent === null || existingDataForPrimaryAgent === void 0 ? void 0 : existingDataForPrimaryAgent.destinationAgentId)
            : undefined;
        newDataForDestinationAgent = Object.assign(Object.assign(Object.assign({}, _Utils__WEBPACK_IMPORTED_MODULE_3__.EMPTY_AGENT_DETAILS), existingDataForDestinationAgent), { agentId: existingDataForPrimaryAgent.destinationAgentId, agentName: existingDataForPrimaryAgent.destinationAgentName, interactionId: "", isMonitored: "false", isBarged: "false", monitorFullName: "", monitorUserId: "", contactPhoneNumber: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, contactQueueName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, activeParticipantsName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, consultedParticipantName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, recording: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, contactEventName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, actions: { agentId: existingDataForPrimaryAgent.destinationAgentId, supervisorId } });
    }
    return {
        existingDataForDestinationAgent,
        newDataForDestinationAgent
    };
};
/**
 * Checks if row is removed , removes that object from the applied filters
 * @param comp
 * @param key
 * @param rowToRemove
 */
const deleteRemovedRowObjectFromFilter = (comp, key, rowToRemove) => {
    if (checkIfFilterAppliedExists(comp, key)) {
        const k = rowToRemove[key];
        if (Object.prototype.hasOwnProperty.call(comp.appliedFilters[key], k)) {
            delete comp.appliedFilters[key][k];
            disptachFilterDataUpdateEvent(key);
        }
    }
};
const refreshClientSideRowModel = (gridApi) => {
    gridApi === null || gridApi === void 0 ? void 0 : gridApi.refreshClientSideRowModel("everything");
};
const removeRowFromGrid = (rowToRemove, gridApi, comp, isServerSideGrid) => {
    isServerSideGrid
        ? gridApi === null || gridApi === void 0 ? void 0 : gridApi.applyServerSideTransactionAsync({ remove: rowToRemove })
        : gridApi === null || gridApi === void 0 ? void 0 : gridApi.applyTransactionAsync({ remove: rowToRemove }, () => refreshClientSideRowModel(gridApi));
    //update filters of column when row deleted
    rowToRemove.forEach((data) => {
        Object.keys(data).forEach((key) => {
            if (_Utils__WEBPACK_IMPORTED_MODULE_3__.filterColumnName.includes(key)) {
                deleteRemovedRowObjectFromFilter(comp, key, rowToRemove);
                updateAppliedFilter(comp, key, data);
                disptachFilterDataUpdateEvent(key);
            }
        });
        disptachFilterUpdateEvent(comp);
    });
};
const addRowInGrid = (newRowData, gridApi, comp, isServerSideGrid) => {
    isServerSideGrid
        ? gridApi === null || gridApi === void 0 ? void 0 : gridApi.applyServerSideTransactionAsync({ add: newRowData })
        : gridApi === null || gridApi === void 0 ? void 0 : gridApi.applyTransactionAsync({ add: newRowData }, () => refreshClientSideRowModel(gridApi));
    newRowData.forEach((newData) => {
        Object.keys(newData).forEach((key) => {
            if (_Utils__WEBPACK_IMPORTED_MODULE_3__.filterColumnName.includes(key)) {
                updateAppliedFilter(comp, key, newData);
                disptachFilterDataUpdateEvent(key);
            }
        });
        disptachFilterUpdateEvent(comp);
    });
};
const updateRowInGrid = (updatedRowData, gridApi, comp, isServerSideGrid) => {
    isServerSideGrid
        ? gridApi === null || gridApi === void 0 ? void 0 : gridApi.applyServerSideTransactionAsync({ update: updatedRowData })
        : gridApi === null || gridApi === void 0 ? void 0 : gridApi.applyTransactionAsync({ update: updatedRowData }, () => refreshClientSideRowModel(gridApi));
    updatedRowData.forEach((updatedData) => {
        Object.keys(updatedData).forEach((key) => {
            if (_Utils__WEBPACK_IMPORTED_MODULE_3__.filterColumnName.includes(key)) {
                updateAppliedFilter(comp, key, updatedData);
                disptachFilterDataUpdateEvent(key);
            }
        });
        disptachFilterUpdateEvent(comp);
    });
};
const isValidContactStats = (contactData) => {
    return (contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.CAPTURE_STARTED ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_STARTED ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE_REQUESTED ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE_STARTED ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_COMPLETED_CONFERENCE ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_STARTED_CONFERENCE ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_COMPLETED_CONSULT ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_STARTED_CONSULT ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_COMPLETED ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.TRANSFER_COMPLETED ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_COMPLETED ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE_COMPLETED ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.AGENTCONNECT_COMPLETED ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_STARTED ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.JOIN_CONFERENCE ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.EXIT_CONFERENCE ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.PRIMARY_OWNER_CHANGED ||
        contactData.monitorStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.MONITORING_ENDED);
};
const filterContactStatsData = (contactStatsData) => {
    return contactStatsData.filter((contactData) => contactData.data.channelType === _constants__WEBPACK_IMPORTED_MODULE_0__.TELEPHONY && isValidContactStats(contactData.data));
};
const getValidChannelDetails = (channelData) => {
    return (channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.CONNECTED ||
        channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.WRAP_UP ||
        channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.WRAP_UP_ASSISTANCE ||
        channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.POST_CALL_STARTED ||
        channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.POST_CALL_CONSULT_STARTED ||
        channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCING ||
        channelData.contactStatus === "" ||
        channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.ON_HOLD ||
        channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.CONNECTED_CONSULTING ||
        channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.IDLE_CONSULTING ||
        channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.CONSULTING ||
        channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE_CONSULTING ||
        channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_DONE || // remove consult-done after data changes
        channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_ERROR);
};
const filteredTelephonyChannelData = (channelStatusData) => {
    return channelStatusData.filter((channelData) => { var _a; return ((_a = channelData.data) === null || _a === void 0 ? void 0 : _a.channelType) === _constants__WEBPACK_IMPORTED_MODULE_0__.TELEPHONY && getValidChannelDetails(channelData.data); });
};
//getMappedDataFromGlobalStatus maps/updates the received globalstatus data with the TPW required format
const getMappedDataFromGlobalStatus = (newAgentData, oldAgentData, browserLanguage, supervisorAnalyserId) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const actionCellDetails = Object.assign(Object.assign({}, oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.actions), { agentEmail: newAgentData === null || newAgentData === void 0 ? void 0 : newAgentData.agentEmail, agentName: newAgentData === null || newAgentData === void 0 ? void 0 : newAgentData.agentName, agentId: newAgentData === null || newAgentData === void 0 ? void 0 : newAgentData.agentId, supervisorId: supervisorAnalyserId });
    const agentState = (0,_Utils__WEBPACK_IMPORTED_MODULE_3__.localiseAvailableState)(getAgentState(newAgentData.globalState, newAgentData.idleCodeName));
    const agentEmail = newAgentData.agentEmail ? newAgentData.agentEmail : oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.agentEmail;
    const changedBy = newAgentData.changedByRole ? newAgentData.changedByRole : null;
    const changedById = newAgentData.changedById ? newAgentData.changedById : null;
    const changedByName = newAgentData.changedByName ? newAgentData.changedByName : null;
    const reason = newAgentData.reason ? newAgentData.reason : null;
    const agentNameDetails = Object.assign(Object.assign({}, oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.agentNameDetails), { agentId: newAgentData.agentId, agentName: newAgentData.agentName, agentState,
        agentEmail });
    return Object.assign(Object.assign(Object.assign({}, _Utils__WEBPACK_IMPORTED_MODULE_3__.EMPTY_AGENT_DETAILS), oldAgentData), { agentId: newAgentData.agentId, agentName: newAgentData.agentName ? newAgentData.agentName : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, agentEmail, orgId: newAgentData.orgId, agentState, agentStateDuration: newAgentData.globalStateTimestamp !== 0 ? newAgentData.globalStateTimestamp.toString() : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, phoneNumber: newAgentData.agentPhone && newAgentData.agentPhone !== ""
            ? ((_a = newAgentData === null || newAgentData === void 0 ? void 0 : newAgentData.agentPhone) === null || _a === void 0 ? void 0 : _a.includes(_constants__WEBPACK_IMPORTED_MODULE_0__.WEB_RTC_PREFIX))
                ? `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:stationLogin.browser")}`
                : newAgentData.agentPhone
            : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, loginTime: newAgentData.lastLoginTime !== 0
            ? getDateFormat(newAgentData.lastLoginTime, browserLanguage !== null && browserLanguage !== void 0 ? browserLanguage : undefined)
            : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, siteName: newAgentData.siteName ? newAgentData.siteName : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, teamName: newAgentData.teamName ? newAgentData.teamName : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, 
        //marking channel status field as blank as they are received from different data set, will be appended nce that data set received
        channelsName: (_b = oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.channelsName) !== null && _b !== void 0 ? _b : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, contactStatus: (_c = oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.contactStatus) !== null && _c !== void 0 ? _c : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, contactStatusTime: (_d = oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.contactStatusTime) !== null && _d !== void 0 ? _d : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, contactQueueName: (_e = oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.contactQueueName) !== null && _e !== void 0 ? _e : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, totalContactDuration: (_f = oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.totalContactDuration) !== null && _f !== void 0 ? _f : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, agentInteractionTime: (_g = oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.agentInteractionTime) !== null && _g !== void 0 ? _g : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, interactionId: (_h = oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.interactionId) !== null && _h !== void 0 ? _h : "", actions: actionCellDetails, changedBy,
        changedById,
        changedByName,
        reason,
        agentNameDetails, skillProfile: (_j = newAgentData.skillsProfile) !== null && _j !== void 0 ? _j : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE });
};
const getMappedDataFromCmsAgentData = (agentData) => {
    return Object.assign(Object.assign({}, _Utils__WEBPACK_IMPORTED_MODULE_3__.EMPTY_AGENT_DETAILS), { agentId: agentData.agentId, agentName: agentData.agentName, agentEmail: agentData.agentEmail, agentState: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.Signedout"), agentNameDetails: {
            agentId: agentData.agentId,
            agentName: agentData.agentName,
            agentEmail: agentData.agentEmail,
            agentState: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.Signedout")
        } });
};
const getAgentInteractionTime = (data, contactStatus) => {
    const timestamp = data === null || data === void 0 ? void 0 : data.agentInteractionTimestamp;
    return timestamp && contactStatus !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE ? timestamp.toString() : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE;
};
const transformChannelStatus = (channelData, supervisorAnalyserId) => {
    var _a, _b, _c;
    const contactStatus = mapAgentContactStatus(channelData.contactStatus, _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE);
    // pass old data
    const actionCellDetails = {
        agentId: channelData.agentId,
        agentName: channelData.agentName,
        supervisorId: supervisorAnalyserId,
        isConsultCall: channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.CONNECTED_CONSULTING ||
            channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.IDLE_CONSULTING ||
            channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.CONSULTING ||
            channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE_CONSULTING,
        isReviewAndMonitorEnabled: isReviewAndMonitorEnabled(channelData.contactStatus),
        isWrapUp: channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.WRAP_UP,
        isWrapUpAssistance: channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.WRAP_UP_ASSISTANCE,
        isMainCallInPostCall: channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.POST_CALL_STARTED
    };
    return Object.assign(Object.assign({}, _Utils__WEBPACK_IMPORTED_MODULE_3__.EMPTY_AGENT_DETAILS), { agentId: channelData.agentId, agentName: channelData.agentName, interactionId: (_a = channelData.interactionId) !== null && _a !== void 0 ? _a : "", teamName: (_b = channelData.teamName) !== null && _b !== void 0 ? _b : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, siteName: (_c = channelData.siteName) !== null && _c !== void 0 ? _c : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, channelsName: "Voice 1/1", // need to remove after all media is supported
        contactStatus, contactStatusCode: channelData.contactStatus, contactQueueName: channelData.contactQueueName, contactStatusTime: channelData.contactStatusTimestamp !== 0 && contactStatus !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE
            ? channelData.contactStatusTimestamp.toString()
            : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, totalContactDuration: channelData.contactIngestionTimestamp !== 0 && contactStatus !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE
            ? channelData.contactIngestionTimestamp.toString()
            : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, agentInteractionTime: getAgentInteractionTime(channelData, contactStatus), actions: actionCellDetails });
};
//getMappedDataFromGlobalStatus maps/updates the received channelstatus data with the TPW required format
const getMappedDataFromChannelStatus = (newAgentData, oldAgentData, supervisorAnalyserId) => {
    var _a;
    const contactStatus = mapAgentContactStatus(newAgentData.contactStatus, (_a = oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.contactStatus) !== null && _a !== void 0 ? _a : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE);
    const actionCellDetails = Object.assign(Object.assign({}, oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.actions), { agentId: newAgentData.agentId, agentName: newAgentData.agentName, supervisorId: supervisorAnalyserId, isConsultCall: newAgentData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.CONNECTED_CONSULTING ||
            newAgentData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.IDLE_CONSULTING ||
            newAgentData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.CONSULTING ||
            newAgentData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE_CONSULTING, isReviewAndMonitorEnabled: isReviewAndMonitorEnabled(newAgentData.contactStatus), isWrapUp: newAgentData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.WRAP_UP, isWrapUpAssistance: newAgentData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.WRAP_UP_ASSISTANCE, isMainCallInPostCall: newAgentData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.POST_CALL_STARTED });
    const agentNameDetails = Object.assign(Object.assign({}, oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.agentNameDetails), { agentId: newAgentData.agentId, agentName: newAgentData.agentName });
    return Object.assign(Object.assign(Object.assign({}, _Utils__WEBPACK_IMPORTED_MODULE_3__.EMPTY_AGENT_DETAILS), oldAgentData), { agentId: newAgentData.agentId, agentName: newAgentData.agentName, interactionId: newAgentData.interactionId, teamName: newAgentData.teamName, siteName: newAgentData.siteName, channelsName: "Voice 1/1", // need to remove after all media is supported
        contactStatus, contactStatusCode: newAgentData.contactStatus, contactQueueName: newAgentData.contactQueueName ? newAgentData.contactQueueName : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, contactStatusTime: newAgentData.contactStatusTimestamp !== 0 && contactStatus !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE
            ? newAgentData.contactStatusTimestamp.toString()
            : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, totalContactDuration: newAgentData.contactIngestionTimestamp !== 0 && contactStatus !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE
            ? newAgentData.contactIngestionTimestamp.toString()
            : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, agentInteractionTime: getAgentInteractionTime(newAgentData, contactStatus), actions: actionCellDetails, agentNameDetails });
};
//getMappedDataFromGlobalStatus maps/updates the received contactstats data with the TPW required format
const getMappedDataFromContactStats = (newAgentData, oldAgentData, supervisorId, isMPCorPersistEnabled) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const isTransferredContact = newAgentData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.TRANSFER_COMPLETED;
    const isMonitored = isTransferredContact ? "false" : newAgentData.isMonitored;
    const isSupervisorMonitoring = !!supervisorId && !!newAgentData.monitorUserId && supervisorId === newAgentData.monitorUserId;
    const actionCellDetails = Object.assign(Object.assign({}, oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.actions), { agentId: newAgentData.agentId, agentName: newAgentData.agentName, monitoredBy: isMonitored === "true" ? newAgentData.monitorFullName : "", supervisorId, isBarged: !!newAgentData.isBarged && newAgentData.isBarged === "true", isSupervisorMonitoring });
    const participantDetails = getParticipantsDetails(newAgentData, newAgentData.eventName, isMPCorPersistEnabled, supervisorId);
    return Object.assign(Object.assign(Object.assign({}, _Utils__WEBPACK_IMPORTED_MODULE_3__.EMPTY_AGENT_DETAILS), oldAgentData), { agentId: newAgentData.agentId, agentName: newAgentData.agentName ? newAgentData.agentName : ((_a = oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.agentName) !== null && _a !== void 0 ? _a : ""), interactionId: (_b = newAgentData.interactionId) !== null && _b !== void 0 ? _b : "", isMonitored, isBarged: newAgentData.isBarged, monitorFullName: isTransferredContact ? "" : newAgentData.monitorFullName, monitorUserId: isTransferredContact ? "" : newAgentData.monitorUserId, contactPhoneNumber: newAgentData.contactDirection === _constants__WEBPACK_IMPORTED_MODULE_0__.INBOUND
            ? newAgentData.origin
            : ((_c = newAgentData.destination) !== null && _c !== void 0 ? _c : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE), contactQueueName: (_d = newAgentData.queueName) !== null && _d !== void 0 ? _d : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, participatingAgentList: newAgentData.participatingAgentList ? JSON.parse(newAgentData.participatingAgentList) : [], activeParticipantsName: (_e = participantDetails.activeParticipantsName) !== null && _e !== void 0 ? _e : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, consultedParticipantName: (_f = participantDetails.consultedParticipantName) !== null && _f !== void 0 ? _f : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, participants: (_g = participantDetails.participants) !== null && _g !== void 0 ? _g : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, recording: newAgentData.recording === "true" ? "On" : "Off", contactStatusTime: (_h = oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.contactStatusTime) !== null && _h !== void 0 ? _h : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, contactEventName: newAgentData.eventName, actions: actionCellDetails, destinationAgentId: newAgentData.destinationAgentId && newAgentData.destinationAgentId !== newAgentData.agentId
            ? newAgentData.destinationAgentId
            : null, destinationAgentName: newAgentData.destinationAgentName && newAgentData.destinationAgentId !== newAgentData.agentId
            ? newAgentData.destinationAgentName
            : null });
};
const convertGlobalStatusArrayToMap = (agentGlobalStatusData, browserLanguage, supervisorAnalyserId) => {
    const rowDataMap = new Map();
    agentGlobalStatusData === null || agentGlobalStatusData === void 0 ? void 0 : agentGlobalStatusData.forEach((agentData) => {
        //adding logic to filter logged out agents for now , till we receive all agents.
        if (agentData.data.globalState !== _constants__WEBPACK_IMPORTED_MODULE_0__.LOGGED_OUT) {
            rowDataMap.set(agentData.data.agentId, getMappedDataFromGlobalStatus(agentData.data, undefined, browserLanguage, supervisorAnalyserId));
        }
    });
    return rowDataMap;
};
const convertContactStatusArrayToMap = (contactStats, supervisorId, isMPCorPersistEnabled) => {
    const rowDataMap = new Map();
    contactStats === null || contactStats === void 0 ? void 0 : contactStats.forEach((contactData) => {
        //adding logic to filter logged out agents for now , till we receive all agents.
        const newDataForPrimaryAgent = getMappedDataFromContactStats(contactData.data, undefined, supervisorId, isMPCorPersistEnabled);
        if (isMPCorPersistEnabled) {
            const destinationDetails = getContactStatsDetailsForAllParticipants(contactData, undefined, newDataForPrimaryAgent, supervisorId).newDataForParticipants;
            destinationDetails.forEach((newDataForDestinationAgent) => {
                if (newDataForDestinationAgent === null || newDataForDestinationAgent === void 0 ? void 0 : newDataForDestinationAgent.agentId) {
                    rowDataMap.set(newDataForDestinationAgent.agentId, newDataForDestinationAgent);
                }
            });
            rowDataMap.set(contactData.data.agentId, newDataForPrimaryAgent);
        }
        else {
            rowDataMap.set(contactData.data.agentId, newDataForPrimaryAgent);
            const destinationDetails = updateContactStatsForDestinationAgent(contactData, undefined, newDataForPrimaryAgent, supervisorId);
            const newDataForDestinationAgent = destinationDetails.newDataForDestinationAgent;
            if (newDataForDestinationAgent === null || newDataForDestinationAgent === void 0 ? void 0 : newDataForDestinationAgent.agentId) {
                rowDataMap.set(newDataForDestinationAgent.agentId, newDataForDestinationAgent);
            }
        }
    });
    return rowDataMap;
};
const convertCmsAgentDataArrayToMap = (cmsAgentData) => {
    const rowDataMap = new Map();
    cmsAgentData === null || cmsAgentData === void 0 ? void 0 : cmsAgentData.forEach((agentData) => {
        rowDataMap.set(agentData.agentId, getMappedDataFromCmsAgentData(agentData));
    });
    return rowDataMap;
};
const convertChannelStatusArrayToMap = (agentChannelStatus, supervisorAnalyserId) => {
    const rowDataMap = new Map();
    agentChannelStatus === null || agentChannelStatus === void 0 ? void 0 : agentChannelStatus.forEach((channelData) => {
        //adding logic to filter logged out agents for now , till we receive all agents.
        rowDataMap.set(channelData.data.agentId, transformChannelStatus(channelData.data, supervisorAnalyserId));
    });
    return rowDataMap;
};
function handleLoggedInState(agentData, existingData, browserLanguage, supervisorAnalyserId, rowToUpdate, rowToAdd, rowDataMap) {
    const newData = getMappedDataFromGlobalStatus(agentData.data, existingData, browserLanguage, supervisorAnalyserId);
    if (existingData) {
        rowToUpdate.push(newData);
    }
    else {
        rowToAdd.push(newData);
    }
    rowDataMap.set(agentData.data.agentId, newData);
}
function handleLoggedOutState(agentData, existingData, rowToUpdate, rowToAdd, rowToRemove, rowDataMap, isShowSignedOutAgentsEnabled) {
    const newData = convertCmsAgentDataArrayToMap([getMappedDataFromCmsAgentData(agentData.data)]);
    newData.forEach((value) => {
        if (existingData) {
            if (isShowSignedOutAgentsEnabled) {
                rowToUpdate.push(value);
            }
            else {
                rowToRemove.push(existingData);
                rowDataMap.delete(agentData.data.agentId);
            }
        }
        else if (isShowSignedOutAgentsEnabled) {
            rowToAdd.push(value);
        }
    });
}
const updateExistingMapFromGlobalStatus = ({ agentGlobalStatusData, oldDataMap, browserLanguage, gridApi, comp, supervisorAnalyserId, isServerSideGrid, isShowSignedOutAgentsEnabled }) => {
    const rowDataMap = oldDataMap;
    const rowToRemove = [];
    const rowToUpdate = [];
    const rowToAdd = [];
    agentGlobalStatusData === null || agentGlobalStatusData === void 0 ? void 0 : agentGlobalStatusData.forEach((agentData) => {
        const existingData = oldDataMap.has(agentData.data.agentId) ? oldDataMap.get(agentData.data.agentId) : undefined;
        if (agentData.data.globalState !== _constants__WEBPACK_IMPORTED_MODULE_0__.LOGGED_OUT) {
            handleLoggedInState(agentData, existingData, browserLanguage, supervisorAnalyserId, rowToUpdate, rowToAdd, rowDataMap);
        }
        else {
            handleLoggedOutState(agentData, existingData, rowToUpdate, rowToAdd, rowToRemove, rowDataMap, isShowSignedOutAgentsEnabled);
        }
    });
    //remove old agent data that has been logged out if signed out agents is disabled
    if (!isShowSignedOutAgentsEnabled && rowToRemove.length > 0) {
        removeRowFromGrid(rowToRemove, gridApi, comp, isServerSideGrid);
    }
    if (rowToAdd.length > 0) {
        addRowInGrid(rowToAdd, gridApi, comp, isServerSideGrid);
    }
    if (rowToUpdate.length > 0) {
        updateRowInGrid(rowToUpdate, gridApi, comp, isServerSideGrid);
    }
    return rowDataMap;
};
const updateExistingMapFromChannelStatus = (agentChannelStatus, oldDataMap, gridApi, supervisorAnalyserId, comp, isServerSideGrid) => {
    const rowDataMap = oldDataMap;
    const rowToUpdate = [];
    const rowToAdd = [];
    agentChannelStatus === null || agentChannelStatus === void 0 ? void 0 : agentChannelStatus.forEach((channelData) => {
        if (channelData.operation !== _constants__WEBPACK_IMPORTED_MODULE_0__.DELETE) {
            const existingData = oldDataMap.has(channelData.data.agentId)
                ? oldDataMap.get(channelData.data.agentId)
                : undefined;
            const newData = getMappedDataFromChannelStatus(channelData.data, existingData, supervisorAnalyserId);
            if (existingData) {
                rowToUpdate.push(newData);
            }
            else {
                rowToAdd.push(newData);
            }
            rowDataMap.set(channelData.data.agentId, newData);
        }
    });
    if (rowToAdd.length > 0) {
        addRowInGrid(rowToAdd, gridApi, comp, isServerSideGrid);
    }
    if (rowToUpdate.length > 0) {
        updateRowInGrid(rowToUpdate, gridApi, comp, isServerSideGrid);
    }
    return rowDataMap;
};
const updateExistingMapForMPCorPersist = (contactData, oldDataMap, newDataForPrimaryAgent, supervisorId, rowDataMap, rowToUpdate) => {
    const destinationDetails = getContactStatsDetailsForAllParticipants(contactData, oldDataMap, newDataForPrimaryAgent, supervisorId);
    const newDataForParticipants = destinationDetails.newDataForParticipants;
    const existingDataForParticipants = destinationDetails.existingDataForParticipants;
    if (!newDataForParticipants.length) {
        rowDataMap.set(contactData.data.agentId, newDataForPrimaryAgent);
    }
    else {
        newDataForParticipants.forEach((newDataForDestinationAgent) => {
            if (newDataForDestinationAgent === null || newDataForDestinationAgent === void 0 ? void 0 : newDataForDestinationAgent.agentId) {
                rowDataMap.set(newDataForDestinationAgent.agentId, newDataForDestinationAgent);
            }
            if (existingDataForParticipants.find((participantData) => participantData.agentId === newDataForDestinationAgent.agentId)) {
                rowToUpdate.push(newDataForDestinationAgent);
            }
        });
    }
};
const updateExistingMapFromContactStats = (agentContacts, oldDataMap, gridApi, supervisorId, comp, isMPCorPersistEnabled, isServerSideGrid) => {
    const rowToUpdate = [];
    const rowToAdd = [];
    const rowDataMap = oldDataMap;
    agentContacts === null || agentContacts === void 0 ? void 0 : agentContacts.forEach((contactData) => {
        const existingDataForPrimaryAgent = oldDataMap.has(contactData.data.agentId)
            ? oldDataMap.get(contactData.data.agentId)
            : undefined;
        const newDataForPrimaryAgent = getMappedDataFromContactStats(contactData.data, existingDataForPrimaryAgent, supervisorId, isMPCorPersistEnabled);
        if (isMPCorPersistEnabled) {
            updateExistingMapForMPCorPersist(contactData, oldDataMap, newDataForPrimaryAgent, supervisorId, rowDataMap, rowToUpdate);
        }
        else {
            if (existingDataForPrimaryAgent) {
                rowToUpdate.push(newDataForPrimaryAgent);
            }
            else {
                rowToAdd.push(newDataForPrimaryAgent);
            }
            rowDataMap.set(contactData.data.agentId, newDataForPrimaryAgent);
            const destinationDetails = updateContactStatsForDestinationAgent(contactData, oldDataMap, newDataForPrimaryAgent, supervisorId, existingDataForPrimaryAgent);
            const newDataForDestinationAgent = destinationDetails.newDataForDestinationAgent;
            const existingDataForDestinationAgent = destinationDetails.existingDataForDestinationAgent;
            if (newDataForDestinationAgent === null || newDataForDestinationAgent === void 0 ? void 0 : newDataForDestinationAgent.agentId) {
                if (existingDataForDestinationAgent) {
                    rowToUpdate.push(newDataForDestinationAgent);
                }
                rowDataMap.set(newDataForDestinationAgent.agentId, newDataForDestinationAgent);
            }
        }
    });
    if (rowToAdd.length > 0) {
        addRowInGrid(rowToAdd, gridApi, comp, isServerSideGrid);
    }
    if (rowToUpdate.length > 0) {
        updateRowInGrid(rowToUpdate, gridApi, comp, isServerSideGrid);
    }
    return rowDataMap;
};


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/Utils.ts":
/*!*******************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/Utils.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EMPTY_AGENT_DETAILS: () => (/* binding */ EMPTY_AGENT_DETAILS),
/* harmony export */   columnHeaderMapping: () => (/* binding */ columnHeaderMapping),
/* harmony export */   disableForContactStatus: () => (/* binding */ disableForContactStatus),
/* harmony export */   durationColumns: () => (/* binding */ durationColumns),
/* harmony export */   filterColumnName: () => (/* binding */ filterColumnName),
/* harmony export */   fixedColumns: () => (/* binding */ fixedColumns),
/* harmony export */   getIsCheckboxChecked: () => (/* binding */ getIsCheckboxChecked),
/* harmony export */   getSignoutTooltip: () => (/* binding */ getSignoutTooltip),
/* harmony export */   hiddenGroupColumn: () => (/* binding */ hiddenGroupColumn),
/* harmony export */   initialFilterModel: () => (/* binding */ initialFilterModel),
/* harmony export */   isAgentSignoutDisabled: () => (/* binding */ isAgentSignoutDisabled),
/* harmony export */   localiseAvailableState: () => (/* binding */ localiseAvailableState)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");


const fixedColumns = {
    agentName: true,
    actions: true
};
const hiddenGroupColumn = {
    agentStateDuration: true,
    contactStatusTime: true,
    totalContactDuration: true,
    agentInteractionTime: true,
    loginTime: true
};
const getIsCheckboxChecked = (event) => {
    const path = event.composedPath();
    const checkboxElement = Array.from(path).find((element) => element.nodeName.toLowerCase() === "md-checkbox");
    return checkboxElement.checked;
};
const EMPTY_AGENT_DETAILS = {
    agentId: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    agentName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    agentEmail: "",
    agentState: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    agentStateDuration: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    phoneNumber: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    channelsName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    contactStatus: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    contactStatusCode: "",
    contactStatusTime: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    contactQueueName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    totalContactDuration: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    agentInteractionTime: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    loginTime: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    siteName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    teamName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    interactionId: "",
    contactEventName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    isMonitored: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    monitorFullName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    contactPhoneNumber: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    activeParticipantsName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    consultedParticipantName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    recording: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    actions: {},
    destinationAgentId: null,
    destinationAgentName: null,
    changedBy: null,
    changedById: null,
    changedByName: null,
    skillProfile: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE
};
const initialFilterModel = {
    agentName: {},
    siteName: {},
    teamName: {},
    loginTime: {},
    agentState: {},
    channelsName: {},
    phoneNumber: {},
    contactQueueName: {},
    contactStatus: {},
    agentNameDetails: {},
    skillProfile: {}
};
const columnHeaderMapping = () => {
    return {
        agentName: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.agentName"),
        agentState: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.agentState"),
        agentStateDuration: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.agentStateDuration"),
        phoneNumber: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.phoneNumber"),
        siteName: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.siteName"),
        teamName: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.teamName"),
        contactStatus: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.contactStatus"),
        contactStatusTime: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.contactStatusTime"),
        agentInteractionTime: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.agentInteractionTime"),
        totalContactDuration: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.totalContactDuration"),
        loginTime: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.loginTime"),
        channelsName: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.channelsName"),
        contactQueueName: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.contactQueueName"),
        agentNameDetails: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.agentName"),
        skillProfile: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.skillProfile")
    };
};
const durationColumns = [
    "agentStateDuration",
    "agentInteractionTime",
    "totalContactDuration",
    "contactStatusTime"
];
const filterColumnName = [
    "agentState",
    "phoneNumber",
    "siteName",
    "teamName",
    "contactStatus",
    "loginTime",
    "channelsName",
    "contactQueueName",
    "agentNameDetails"
];
const disableForContactStatus = [
    _constants__WEBPACK_IMPORTED_MODULE_0__.WRAP_UP,
    _constants__WEBPACK_IMPORTED_MODULE_0__.WRAP_UP_ASSISTANCE,
    _constants__WEBPACK_IMPORTED_MODULE_0__.POST_CALL_STARTED,
    _constants__WEBPACK_IMPORTED_MODULE_0__.CONNECTED_CONSULTING,
    _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE_CONSULTING,
    _constants__WEBPACK_IMPORTED_MODULE_0__.IDLE_CONSULTING,
    _constants__WEBPACK_IMPORTED_MODULE_0__.CONSULTING,
    _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    _constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_ERROR
];
const localiseAvailableState = (key) => {
    return key === _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.stateChange.available") : key;
};
const isAgentSignoutDisabled = (actionCellConfigs) => {
    if (actionCellConfigs.agentName && actionCellConfigs.agentId !== actionCellConfigs.supervisorId) {
        return actionCellConfigs.contactStatus !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE;
    }
    else {
        return true;
    }
};
const isSelf = (actionCellConfigs) => {
    return actionCellConfigs.agentId === actionCellConfigs.supervisorId;
};
const getSignoutTooltip = (actionCellConfigs, disabled) => {
    if (disabled) {
        return isSelf(actionCellConfigs) ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.selfSignoutWarningTooltip") : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.signoutBlockedTooltip");
    }
    else if (actionCellConfigs.signoutPending) {
        return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.signingoutTooltip");
    }
    else if (actionCellConfigs.signoutError) {
        return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.signingoutErrorTooltip");
    }
    else {
        return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.signoutTooltip");
    }
};


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/ActiveInteraction.scss":
/*!********************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/ActiveInteraction.scss ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host .md-alert-banner {
  padding: 16px;
}

.aid-modal .aid-img-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid var(--md-primary-seperator-color);
  padding-bottom: 16px;
}
.aid-modal .aid-img {
  width: 36px;
  height: 36px;
  border-radius: 100%;
}
.aid-modal .aid-name {
  margin: 6px 0 0 16px;
}
.aid-modal .aid-body {
  height: 340px;
  overflow-y: scroll;
}
.aid-modal .aid-body-no-scroll {
  overflow: hidden;
}
.aid-modal .aid-data {
  margin: 16px 0 0 0;
  height: 100%;
}
.aid-modal .aid-data-height-auto {
  margin: 16px 0 0 0;
  height: auto;
}
.aid-modal .aid-details-wrapper {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 8px;
  color: var(--md-secondary-text-color);
}
.aid-modal .aid-value-second {
  margin-left: 6px;
}
.aid-modal .aid-field-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 164px;
}
.aid-modal .aid-value {
  margin: 0;
}
.aid-modal .aid-banner-text-wrapper {
  display: flex;
  margin-left: -1.75rem;
}
.aid-modal .aid-warning {
  color: var(--md-alert-text-warning);
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  height: 36px;
  margin-top: 16px;
  display: flex;
  align-items: center;
}
.aid-modal .aid-banner-text-warning {
  color: var(--md-alert-text-warning);
  font-size: 14px;
  font-weight: 400;
  line-height: 17.5px;
  text-align: initial;
  width: 336px;
  margin-left: 8px;
}
.aid-modal .aid-banner-text {
  white-space: unset;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.aid-modal .aid-banner-text-info {
  color: var(--md-alert-text-theme);
  font-size: 14px;
  font-weight: 400;
  line-height: 17.5px;
  text-align: initial;
  width: 336px;
  margin-left: 8px;
}
.aid-modal .aid-banner-text-error {
  color: var(--md-alert-text-error);
  font-size: 14px;
  font-weight: 400;
  line-height: 17.5px;
  text-align: initial;
  width: 336px;
  margin-left: 8px;
}
.aid-modal .aid-banner-icon {
  height: 13.34px;
  width: 16px;
}
.aid-modal .md-alert-banner-wrapper {
  padding-right: 24px;
  padding-top: 16px;
  display: block;
}
.aid-modal .aid-error {
  color: var(--md-alert-error-text-color);
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  height: 36px;
  margin-top: 16px;
  display: flex;
  align-items: center;
}
.aid-modal .aid-warning-icon,
.aid-modal .aid-error-icon {
  margin-right: 10px;
}
.aid-modal .aid-info-wrapper {
  background-color: #c7f6ff;
  padding: 12px 16px;
  color: var(--color-blue-70);
  display: flex;
  margin-top: 16px;
}
.aid-modal .aid-error-wrapper {
  background-color: var(--md-red-10);
  padding: 12px 16px;
  color: var(--md-red-70);
  display: flex;
  margin-top: 16px;
  line-height: 17.5px;
}
.aid-modal .aid-info-icon {
  margin: -2px 8px 0 0;
}
.aid-modal .aid-btn-wrapper {
  margin-top: 24px;
}
.aid-modal .aid-btn-wrapper .aid-start {
  margin-left: 10px;
}
.aid-modal .aid-btn-wrapper .aid-start,
.aid-modal .aid-btn-wrapper .aid-close {
  float: right;
}
.aid-modal .aid-btn-wrapper .aid-monitoring-icon {
  margin-right: 8px;
}
.aid-modal .aid-nodata-wrapper {
  height: 440px;
  padding-top: 80px;
}
.aid-modal .aid-details-wip {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.aid-modal .aid-details-wip img {
  width: 96px;
  height: 78px;
}
.aid-modal .aid-details-wip-text {
  color: var(--md-primary-text-color);
}
.aid-modal .modal-header {
  font-size: var(--font-size-large);
  margin: 0;
}
@media (max-width: 736px) {
  .aid-modal .aid-body {
    height: 100%;
  }
  .aid-modal .aid-data {
    height: 100%;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/ActiveInteraction.ts":
/*!******************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/ActiveInteraction.ts ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ActiveInteraction: () => (/* binding */ ActiveInteraction)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _assets_styles_common_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../assets/styles/common.scss */ "./src/assets/styles/common.scss");
/* harmony import */ var _components_CountDownTimer_CountDownTimer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../components/CountDownTimer/CountDownTimer */ "./src/components/CountDownTimer/CountDownTimer.ts");
/* harmony import */ var _ActiveInteraction_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./ActiveInteraction.scss */ "./src/components/TeamPerformanceWidget/components/ActiveInteraction.scss");
/* harmony import */ var _AidValues__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./AidValues */ "./src/components/TeamPerformanceWidget/components/AidValues.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};











var ActiveInteraction;
(function (ActiveInteraction) {
    /**
     * @element agentx-wc-aid
     * @fires close-modal
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_4__.LitElement) {
        constructor() {
            super(...arguments);
            this.isModalOpen = false;
            this.isMCMEnabled = false;
            this.monitoringInProgress = false;
            this.errorText = "";
            this.role = "";
            this.isMPCorPersistEnabled = false;
            this.isPostCallEnabled = false;
            this.shouldTrackAid = true;
            this.startMonitoringTriggered = false;
            this.interactionDetails = {
                isDisconnected: false,
                interactionIsTransferred: false // Is interaction is closed by transfer or end
            };
            this.enableWarningTooltip = false;
            this.isStartMonitorFailed = false;
            this.liveRegionMessage = "";
            this.detail = {
                header: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.failedToLoad"),
                message: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.shareTrackId")
            };
            this.isDataUpdated = false;
            this.MONITORING_CALL_MESSAGE = "app:tpw.currentlyMonitoringCall";
            this.RACE_ERROR_REASON_CODE = 53;
            this.fixedVariables = [
                {
                    variableText: "app:tpw.ContactPhoneNumber",
                    variableName: "contactPhoneNumber"
                },
                {
                    variableText: "app:tpw.ContactQueue",
                    variableName: "contactQueueName"
                },
                {
                    variableText: "app:tpw.ActiveParticipants",
                    variableName: "activeParticipantsName"
                },
                {
                    variableText: "app:tpw.ConsultedParticipant",
                    variableName: "consultedParticipantName"
                },
                {
                    variableText: "app:tpw.ContactStatus",
                    variableName: "contactStatus"
                },
                {
                    variableText: "app:tpw.TimeInContactStatus",
                    variableName: "contactStatusTime"
                },
                {
                    variableText: "app:tpw.AgentInteractionTime",
                    variableName: "agentInteractionTime"
                },
                {
                    variableText: "app:tpw.TotalContactDuration",
                    variableName: "totalContactDuration"
                },
                {
                    variableText: "app:tpw.Recording",
                    variableName: "recording"
                }
            ];
            this.multiPartyFixedVariables = [
                {
                    variableText: "app:tpw.ContactPhoneNumber",
                    variableName: "contactPhoneNumber"
                },
                {
                    variableText: "app:tpw.ContactQueue",
                    variableName: "contactQueueName"
                },
                {
                    variableText: "app:tpw.Participants",
                    variableName: "participants"
                },
                {
                    variableText: "app:tpw.ContactStatus",
                    variableName: "contactStatus"
                },
                {
                    variableText: "app:tpw.TimeInContactStatus",
                    variableName: "contactStatusTime"
                },
                {
                    variableText: "app:tpw.AgentInteractionTime",
                    variableName: "agentInteractionTime"
                },
                {
                    variableText: "app:tpw.TotalContactDuration",
                    variableName: "totalContactDuration"
                },
                {
                    variableText: "app:tpw.Recording",
                    variableName: "recording"
                }
            ];
            this.closeAIDModal = () => {
                this.errorText = "";
                this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.TPW_MONITOR_MODAL, { detail: { modalIsOpen: false }, bubbles: false, composed: true }));
                this.isDataUpdated = false;
                this.startMonitoringTriggered = false;
                // Reset interaction details
                this.interactionDetails = Object.assign(Object.assign({}, this.interactionDetails), { isDisconnected: false, interactionIsTransferred: false // Weather check interaction closed by transfer or normal close
                 });
            };
            this.trackAIDClose = () => {
                var _a, _b;
                this.closeAIDModal();
                if (this.shouldTrackAid) {
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.telemetry.TELEM_EVENT.AID_CLOSED, {
                        SupervisorId: (_b = (_a = this.selectedAgentDetails.actions) === null || _a === void 0 ? void 0 : _a.supervisorId) !== null && _b !== void 0 ? _b : "",
                        Role: this.role
                    });
                }
            };
            this.closeAIDModalOnMonitoring = () => {
                this.shouldTrackAid = false;
                this.closeAIDModal();
            };
            this.setErrorText = (e) => __awaiter(this, void 0, void 0, function* () {
                const { reasonCode } = e.detail;
                this.shouldTrackAid = true;
                if (reasonCode === this.RACE_ERROR_REASON_CODE) {
                    this.errorText = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(this.MONITORING_CALL_MESSAGE);
                }
                else {
                    this.closeAIDModal();
                }
            });
            this.ariaLabelForMonitoringButton = () => {
                const disableTooltipMessage = this.getDisableTooltipMessage();
                const startMonitoringMessage = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.startMonitoring");
                let message;
                if (disableTooltipMessage) {
                    message = `${startMonitoringMessage}, ${disableTooltipMessage}`;
                }
                else {
                    message = startMonitoringMessage;
                }
                return message;
            };
            this.generateUUID = () => {
                let d = Date.now();
                return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
                    const r = (d + Math.random() * 16) % 16 | 0; // eslint-disable-line no-bitwise
                    d = Math.floor(d / 16);
                    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16); // eslint-disable-line no-bitwise
                });
            };
            this.isStartMonitoringDisabled = () => {
                var _a, _b, _c;
                return ((_c = (this.isInteractionDisconnected() ||
                    this.errorText !== "" ||
                    (this.selectedAgentDetails && ((_a = this.selectedAgentDetails) === null || _a === void 0 ? void 0 : _a.isMonitored) === "true") ||
                    this.monitoringInProgress ||
                    ((_b = this.selectedAgentDetails.actions) === null || _b === void 0 ? void 0 : _b.isConsultCall) ||
                    this.isInteractionInPostCall())) !== null && _c !== void 0 ? _c : false);
            };
            this.ifFixedVariablesAreUpdated = (oldValues) => {
                const newValues = this.selectedAgentDetails;
                return (oldValues.contactQueueName !== newValues.contactQueueName ||
                    oldValues.totalContactDuration !== newValues.totalContactDuration ||
                    oldValues.agentInteractionTime !== newValues.agentInteractionTime ||
                    oldValues.contactStatusTime !== newValues.contactStatusTime ||
                    oldValues.contactPhoneNumber !== newValues.contactPhoneNumber ||
                    oldValues.activeParticipantsName !== newValues.activeParticipantsName ||
                    oldValues.consultedParticipantName !== newValues.consultedParticipantName ||
                    oldValues.recording !== newValues.recording ||
                    oldValues.contactStatus !== newValues.contactStatus ||
                    oldValues.actions !== newValues.actions);
            };
            this.enableWarningContentTooltip = () => __awaiter(this, void 0, void 0, function* () {
                var _a;
                yield this.updateComplete;
                const element = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".aid-banner-text");
                if (element && this.isEllipsisActive(element)) {
                    // Enable the tooptip.
                    this.enableWarningTooltip = true;
                }
                else {
                    this.enableWarningTooltip = false;
                }
            });
            this.isEllipsisActive = (element) => {
                return element.offsetHeight < element.scrollHeight;
            };
        }
        attachEventListeners() {
            window.addEventListener("monitoring-offered", this.closeAIDModalOnMonitoring);
            window.addEventListener("monitoring-started", this.closeAIDModalOnMonitoring);
            window.addEventListener("monitoring-create-failed", this.setErrorText);
            window.addEventListener("monitoring-failed", this.setErrorText);
        }
        connectedCallback() {
            super.connectedCallback();
            this.attachEventListeners();
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            window.removeEventListener("monitoring-offered", this.closeAIDModalOnMonitoring);
            window.removeEventListener("monitoring-started", this.closeAIDModalOnMonitoring);
            window.removeEventListener("monitoring-create-failed", this.setErrorText);
            window.removeEventListener("monitoring-failed", this.setErrorText);
        }
        static get styles() {
            return [_ActiveInteraction_scss__WEBPACK_IMPORTED_MODULE_9__["default"], _assets_styles_common_scss__WEBPACK_IMPORTED_MODULE_7__["default"]];
        }
        isInteractionDisconnected() {
            // This function will return the interaction is disconnected or not.
            return this.interactionDetails.isDisconnected;
        }
        renderContent() {
            const agentDetails = this.selectedAgentDetails;
            const aidVariables = this.isMPCorPersistEnabled ? this.multiPartyFixedVariables : this.fixedVariables;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
        <dl>
          ${aidVariables.map((fixedVariable) => {
                var _a;
                const { variableName, variableText } = fixedVariable;
                // If interaction is disconnected, then will show the "-" only.
                const value = this.isInteractionDisconnected()
                    ? _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE
                    : ((_a = agentDetails[variableName]) !== null && _a !== void 0 ? _a : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE);
                if (value !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE) {
                    return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
                <div class="aid-details-wrapper">
                  <dt class="aid-field-ellipsis">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(variableText)}</dt>
                  <dd class="aid-value">
                    <agentx-aid-value .variableName=${variableName} .variableValue=${value}></agentx-aid-value>
                  </dd>
                </div>
              `;
                }
                else {
                    return undefined;
                }
            })}
        </dl>
      `;
        }
        startMonitoring() {
            var _a, _b, _c, _d;
            this.liveRegionMessage = `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.ringingMonitoring")} ${(_b = (_a = this.selectedAgentDetails) === null || _a === void 0 ? void 0 : _a.agentNameDetails) === null || _b === void 0 ? void 0 : _b.agentName}`;
            if (!this.startMonitoringTriggered) {
                this.startMonitoringTriggered = true; // Set true, Once the click the start monitoring button. This prevent multiple clicks
                const monitoringRequest = {
                    id: this.generateUUID(),
                    monitorType: "midcall",
                    trackingId: this.generateUUID(),
                    taskId: (_c = this.selectedAgentDetails) === null || _c === void 0 ? void 0 : _c.interactionId
                };
                (_d = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.aqm.supervisor) === null || _d === void 0 ? void 0 : _d.startMonitoring({ data: monitoringRequest }).then((data) => {
                    _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("event= MonitoringRequestCreated:", data);
                }).catch(() => {
                    _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error("event= MonitoringRequestCreatedFailed:");
                });
            }
        }
        retry() {
            //TODO
        }
        isConsultCall() {
            return (this.selectedAgentDetails.contactStatus === (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.contactStatus.consult").toString() ||
                this.selectedAgentDetails.contactStatus === (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.contactStatus.consulting").toString());
        }
        isInteractionInPostCall() {
            var _a;
            return this.isPostCallEnabled && ((_a = this.selectedAgentDetails.actions) === null || _a === void 0 ? void 0 : _a.isMainCallInPostCall);
        }
        isCallTransferred() {
            var _a, _b, _c, _d, _e;
            // Once receive transferred eventname, we need persist this.interactionDetails.interactionIsTransferred=true
            return (this.interactionDetails.interactionIsTransferred ||
                (!this.interactionDetails.interactionIsTransferred &&
                    _constants__WEBPACK_IMPORTED_MODULE_0__.CONTACT_TRANSFERRED_EVENTS.includes(((_a = this.selectedAgentDetails) === null || _a === void 0 ? void 0 : _a.contactEventName) || "") &&
                    !_constants__WEBPACK_IMPORTED_MODULE_0__.CONTACT_ACTIVE_EVENTS.includes(((_b = this.selectedAgentDetails) === null || _b === void 0 ? void 0 : _b.contactStatusCode) || "") &&
                    (((_c = this.selectedAgentDetails) === null || _c === void 0 ? void 0 : _c.contactStatusCode) === "" ||
                        ((_e = (_d = this.selectedAgentDetails) === null || _d === void 0 ? void 0 : _d.contactStatusCode) === null || _e === void 0 ? void 0 : _e.toLowerCase()) === _constants__WEBPACK_IMPORTED_MODULE_0__.WRAP_UP)));
        }
        updated(changedProperties) {
            var _a, _b, _c, _d, _e, _f;
            super.updated(changedProperties);
            const previousSelectedAgentDetails = changedProperties.get("selectedAgentDetails");
            if (changedProperties.has("selectedAgentDetails") &&
                previousSelectedAgentDetails &&
                !changedProperties.has("isModalOpen") &&
                this.isModalOpen &&
                !this.interactionDetails.isDisconnected) {
                this.isDataUpdated = this.ifFixedVariablesAreUpdated(previousSelectedAgentDetails) || this.isDataUpdated;
            }
            if (changedProperties.has("isModalOpen") && this.isModalOpen) {
                // While opening the modal reset the interaction error modal property values.
                this.interactionDetails = {
                    isDisconnected: false,
                    interactionIsTransferred: false
                };
            }
            if (changedProperties.has("selectedAgentDetails")) {
                if (previousSelectedAgentDetails &&
                    Object.keys(previousSelectedAgentDetails).length > 0 &&
                    ((_a = this.selectedAgentDetails) === null || _a === void 0 ? void 0 : _a.interactionId) !== "" &&
                    ((_b = this.selectedAgentDetails) === null || _b === void 0 ? void 0 : _b.interactionId) !== (previousSelectedAgentDetails === null || previousSelectedAgentDetails === void 0 ? void 0 : previousSelectedAgentDetails.interactionId)) {
                    // New interaction id are updated, So disable the warnings.
                    this.interactionDetails = {
                        isDisconnected: false,
                        interactionIsTransferred: false
                    };
                }
                else if (this.isCallTransferred()) {
                    // Interaction is Transferred.
                    this.interactionDetails = {
                        isDisconnected: true,
                        interactionIsTransferred: true
                    };
                }
                else if (((_c = this.selectedAgentDetails) === null || _c === void 0 ? void 0 : _c.contactEventName) === _constants__WEBPACK_IMPORTED_MODULE_0__.CONTACT_COMPLETED ||
                    ((_d = this.selectedAgentDetails) === null || _d === void 0 ? void 0 : _d.contactStatusCode) === _constants__WEBPACK_IMPORTED_MODULE_0__.WRAP_UP ||
                    ((_e = this.selectedAgentDetails) === null || _e === void 0 ? void 0 : _e.contactStatusCode) === _constants__WEBPACK_IMPORTED_MODULE_0__.CALL_ENDED ||
                    ((_f = this.selectedAgentDetails) === null || _f === void 0 ? void 0 : _f.interactionId) === "") {
                    // Interaction is disconnected.
                    this.interactionDetails = {
                        isDisconnected: true,
                        interactionIsTransferred: false
                    };
                }
                if (this.errorText !== "" &&
                    (!this.selectedAgentDetails.isMonitored || this.selectedAgentDetails.isMonitored === "false") &&
                    (!this.selectedAgentDetails.monitorFullName ||
                        this.selectedAgentDetails.monitorFullName === _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE)) {
                    this.errorText = "";
                    this.startMonitoringTriggered = false;
                }
            }
            this.enableWarningContentTooltip();
        }
        renderStartMonitoringButton() {
            return this.isMCMEnabled
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
            <div aria-live="assertive" class="sr-only">${this.liveRegionMessage}</div>
            <md-button
              class="aid-start-btn"
              ?disabled=${this.isStartMonitoringDisabled()}
              variant="primary"
              @click="${!this.isStartMonitoringDisabled() ? this.startMonitoring : ""}"
              type="submit"
              ariaLabel=${this.ariaLabelForMonitoringButton()}
            >
              <md-icon class="aid-monitoring-icon" iconSet="momentumDesign" name="monitoring-regular" size="18">
              </md-icon>
              ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.startMonitoring")}</md-button
            >
          `
                : ``;
        }
        getDisableTooltipMessage() {
            var _a, _b, _c, _d, _e;
            if ((_a = this.selectedAgentDetails.actions) === null || _a === void 0 ? void 0 : _a.isSupervisorMonitoring) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.cannotMonitor");
            }
            else if (this.interactionDetails.isDisconnected) {
                // Interaction is closed, after AID modal is open
                if (this.interactionDetails.interactionIsTransferred) {
                    // Interaction is Transferred.
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.interactionTransferredButton");
                }
                // Interaction is Ended.
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.interactionEndButton");
            }
            else if (((_b = this.selectedAgentDetails) === null || _b === void 0 ? void 0 : _b.monitorFullName) &&
                (this.errorText === (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(this.MONITORING_CALL_MESSAGE) || this.selectedAgentDetails.isMonitored === "true")) {
                if ((_c = this.selectedAgentDetails.actions) === null || _c === void 0 ? void 0 : _c.isBarged) {
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.cannotMonitorBargedCall");
                }
                else {
                    return ((_d = this.selectedAgentDetails) === null || _d === void 0 ? void 0 : _d.monitorFullName) + (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(this.MONITORING_CALL_MESSAGE);
                }
            }
            else if ((_e = this.selectedAgentDetails.actions) === null || _e === void 0 ? void 0 : _e.isConsultCall) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.cannotMonitorConsult");
            }
            else if (this.isInteractionInPostCall()) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.cannotMonitorPostCall");
            }
            return false;
        }
        renderModalFooter() {
            const toolTipMessage = this.getDisableTooltipMessage();
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
        <md-tooltip
          class="aid-start"
          placement="top"
          ?disabled=${!toolTipMessage ? true : false}
          message=${toolTipMessage || ""}
        >
          ${this.renderStartMonitoringButton()}
        </md-tooltip>
        <md-button
          class="aid-close"
          variant="secondary"
          ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.cancel")}
          @click="${this.closeAIDModal}"
          type="reset"
        >
          ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.cancel")}</md-button
        >
      `;
        }
        renderWarningElement() {
            const { errorMessage, bannerContent } = this.getWarningContent();
            if (errorMessage) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
          <md-tooltip class="aid-banner-content" message=${errorMessage} ?disabled=${!this.enableWarningTooltip}>
            ${bannerContent}
          </md-tooltip>
        `;
            }
            return lit_html__WEBPACK_IMPORTED_MODULE_5__.nothing;
        }
        getWarningContent() {
            var _a, _b, _c, _d, _e, _f;
            if (this.errorText === (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(this.MONITORING_CALL_MESSAGE) &&
                ((_a = this.selectedAgentDetails) === null || _a === void 0 ? void 0 : _a.monitorFullName) &&
                (this.selectedAgentDetails.isMonitored === "false" || this.selectedAgentDetails.isMonitored === null)) {
                // <!-- error banner when monitoringcreatefailed event is received -->
                const errorMessage = `${(_b = this.selectedAgentDetails) === null || _b === void 0 ? void 0 : _b.monitorFullName} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(this.MONITORING_CALL_MESSAGE)}`;
                return {
                    errorMessage,
                    bannerContent: (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
            <md-alert-banner class="md-alert-banner-wrapper" show type="error">
              <div class="aid-banner-text-wrapper">
                <md-icon
                  aria-hidden="true"
                  name="error-legacy-badge-filled"
                  iconSet="momentumDesign"
                  size="14"
                ></md-icon>
                <div class="aid-banner-text aid-banner-text-error">
                  <span aria-label="${errorMessage}">${errorMessage}</span>
                </div>
              </div>
            </md-alert-banner>
          `
                };
            }
            else if (this.selectedAgentDetails.isMonitored === "true" &&
                !((_c = this.selectedAgentDetails.actions) === null || _c === void 0 ? void 0 : _c.isSupervisorMonitoring)) {
                // <!-- warning banner to notify supervisor that call is monitored/barged by another supervisor -->
                const errorMessage = ((_d = this.selectedAgentDetails.actions) === null || _d === void 0 ? void 0 : _d.isBarged)
                    ? `${(_e = this.selectedAgentDetails) === null || _e === void 0 ? void 0 : _e.monitorFullName} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.supervisorBargedIn")}`
                    : `${(_f = this.selectedAgentDetails) === null || _f === void 0 ? void 0 : _f.monitorFullName} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(this.MONITORING_CALL_MESSAGE)}`;
                return {
                    errorMessage,
                    bannerContent: (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
            <md-alert-banner class="md-alert-banner-wrapper" show type="warning">
              <div class="aid-banner-text-wrapper">
                <md-icon aria-hidden="true" name="warning-badge-filled" iconSet="momentumDesign" size="14"></md-icon>
                <div class="aid-banner-text aid-banner-text-warning" aria-label="${errorMessage}">${errorMessage}</div>
              </div>
            </md-alert-banner>
          `
                };
            }
            else if (this.isInteractionDisconnected()) {
                // <!-- warning/error banner to notify supervisor that interaction is closed or transferred -->
                // Before click start monitoring, The agent is completed the interaction or transferred the interaction, then showing the "warning" type modal
                // While click start monitoring, simultaneously the agent is completed the interaction or transferred the interaction, then showing the "error" type modal
                const modalType = this.startMonitoringTriggered ? "error" : "warning";
                const errorMessage = this.interactionDetails.interactionIsTransferred
                    ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.interactionTransferred")
                    : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.interactionEnd");
                return {
                    errorMessage,
                    bannerContent: (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
            <md-alert-banner class="md-alert-banner-wrapper" show type="${modalType}">
              <div class="aid-banner-text-wrapper">
                <md-icon
                  aria-hidden="true"
                  name="${modalType === "error" ? "error-legacy-badge-filled" : "warning-badge-filled"}"
                  iconSet="momentumDesign"
                  size="14"
                ></md-icon>
                <div
                  aria-label="${errorMessage}"
                  class="aid-banner-text ${modalType === "error" ? "aid-banner-text-error" : "aid-banner-text-warning"}"
                >
                  ${errorMessage}
                </div>
              </div>
            </md-alert-banner>
          `
                };
            }
            else if (this.monitoringInProgress && this.selectedAgentDetails.isMonitored === "true") {
                // info banner when supervisor is already monitoring this call
                const errorMessage = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.cannotMonitor");
                return {
                    errorMessage,
                    bannerContent: (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
            <md-alert-banner class="md-alert-banner-wrapper" show type="default">
              <div class="aid-banner-text-wrapper">
                <md-icon aria-hidden="true" name="info-badge-filled" iconSet="momentumDesign" size="14"></md-icon>
                <div aria-label="${errorMessage}" class="aid-banner-text-info">${errorMessage}</div>
              </div>
            </md-alert-banner>
          `
                };
            }
            else {
                return lit_html__WEBPACK_IMPORTED_MODULE_5__.nothing;
            }
        }
        render() {
            var _a, _b, _c, _d;
            const HeaderText = this.isMCMEnabled ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.reviewAndMonitor") : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.review");
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
        <md-modal
          class="aid-modal"
          htmlId="modal-1"
          ?show=${this.isModalOpen}
          size="small"
          ariaLabelClose=${`${HeaderText} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.close")}`}
          headerLabel=${HeaderText}
          .hideFooter=${true}
          showCloseButton=${true}
          backdropClickExit=${true}
          @close-modal="${this.trackAIDClose}"
          >${this.selectedAgentDetails
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
                <div class="aid-img-wrapper">
                  <div>
                    <md-avatar
                      alt=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__.ifDefined)((_a = this.selectedAgentDetails) === null || _a === void 0 ? void 0 : _a.agentName)}
                      class="aid-img md-avatar md-avatar--medium"
                      title=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__.ifDefined)((_b = this.selectedAgentDetails) === null || _b === void 0 ? void 0 : _b.agentName)}
                    >
                    </md-avatar>
                  </div>
                  <div aria-label=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__.ifDefined)((_c = this.selectedAgentDetails) === null || _c === void 0 ? void 0 : _c.agentName)} class="aid-name">
                    ${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__.ifDefined)((_d = this.selectedAgentDetails) === null || _d === void 0 ? void 0 : _d.agentName)}
                  </div>
                </div>
                <div tabindex="0" role="group" class=${`aid-body`}>
                  ${this.renderWarningElement()}
                  <div class="aid-data-height-auto">${this.selectedAgentDetails && this.renderContent()}</div>
                </div>
                ${this.isDataUpdated
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
                      <div class="aid-warning">
                        <md-icon
                          class="aid-warning-icon"
                          name="warning-badge-filled"
                          iconSet="momentumDesign"
                          size="14"
                        ></md-icon
                        >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.isUpdated")}
                      </div>
                    `
                    : ``}
                ${this.errorText !== "" && this.errorText !== (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(this.MONITORING_CALL_MESSAGE)
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
                      <div class="aid-error">
                        <md-icon
                          class="aid-error-icon"
                          name="error-legacy-badge-filled"
                          iconSet="momentumDesign"
                          size="14"
                        ></md-icon
                        >${this.errorText}
                      </div>
                    `
                    : ``}
                <div slot="footer" class="aid-btn-wrapper">${this.renderModalFooter()}</div>
              `
                : (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
                <div class="aid-nodata-wrapper">
                  <agentx-wc-widget-error .detail=${this.detail} @reload=${this.retry}></agentx-wc-widget-error>
                </div>
              `}
        </md-modal>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
    ], Element.prototype, "isModalOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Object })
    ], Element.prototype, "selectedAgentDetails", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
    ], Element.prototype, "isMCMEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
    ], Element.prototype, "monitoringInProgress", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
    ], Element.prototype, "errorText", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
    ], Element.prototype, "role", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
    ], Element.prototype, "isMPCorPersistEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
    ], Element.prototype, "isPostCallEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "shouldTrackAid", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "startMonitoringTriggered", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "interactionDetails", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "enableWarningTooltip", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "isStartMonitorFailed", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "liveRegionMessage", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "detail", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "isDataUpdated", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "fixedVariables", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "multiPartyFixedVariables", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.customElement)("agentx-wc-aid")
    ], Element);
    ActiveInteraction.Element = Element;
})(ActiveInteraction || (ActiveInteraction = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/AidValues.scss":
/*!************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/AidValues.scss ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.aid-value {
  margin-left: 8px;
  width: 204px;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL1RlYW1QZXJmb3JtYW5jZVdpZGdldC9jb21wb25lbnRzL0FpZFZhbHVlcy5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsZ0JBQUE7RUFDQSxZQUFBO0VBQ0EsNEJBQUE7RUFDQSxvQkFBQTtFQUNBLHFCQUFBO0VBQ0EsZ0JBQUE7RUFDQSx1QkFBQTtBQUNGIiwic291cmNlc0NvbnRlbnQiOlsiLmFpZC12YWx1ZSB7XG4gIG1hcmdpbi1sZWZ0OiA4cHg7XG4gIHdpZHRoOiAyMDRweDtcbiAgLXdlYmtpdC1ib3gtb3JpZW50OiB2ZXJ0aWNhbDtcbiAgZGlzcGxheTogLXdlYmtpdC1ib3g7XG4gIC13ZWJraXQtbGluZS1jbGFtcDogMztcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgdGV4dC1vdmVyZmxvdzogZWxsaXBzaXM7XG59XG4iXSwic291cmNlUm9vdCI6IiJ9 */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/AidValues.ts":
/*!**********************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/AidValues.ts ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AidValue: () => (/* binding */ AidValue)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_CountDownTimer_CountDownTimer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../components/CountDownTimer/CountDownTimer */ "./src/components/CountDownTimer/CountDownTimer.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../constants */ "./src/constants.ts");
/* harmony import */ var _AidValues_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./AidValues.scss */ "./src/components/TeamPerformanceWidget/components/AidValues.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};





var AidValue;
(function (AidValue) {
    /**
     * @element agentx-aid-value
     * @fires close-modal
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this.variableName = "";
            this.variableValue = "";
            this.toolTipDisabled = true;
            this.disableTooltip = () => {
                let isTooltipVisible;
                if (this.valueContainer) {
                    const divInsideValueField = this.valueContainer.querySelector("div");
                    if (divInsideValueField) {
                        isTooltipVisible = (divInsideValueField === null || divInsideValueField === void 0 ? void 0 : divInsideValueField.offsetHeight) < (divInsideValueField === null || divInsideValueField === void 0 ? void 0 : divInsideValueField.scrollHeight);
                    }
                    this.toolTipDisabled = !isTooltipVisible;
                }
            };
        }
        connectedCallback() {
            const _super = Object.create(null, {
                connectedCallback: { get: () => super.connectedCallback }
            });
            return __awaiter(this, void 0, void 0, function* () {
                _super.connectedCallback.call(this);
            });
        }
        disconnectedCallback() {
            super.disconnectedCallback();
        }
        static get styles() {
            return _AidValues_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
        }
        updated(changedProperties) {
            if (changedProperties.has("variableValue")) {
                setTimeout(() => this.disableTooltip(), 300);
            }
        }
        firstUpdated() {
            setTimeout(() => this.disableTooltip(), 300);
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <md-tooltip
          message=${this.variableValue}
          ?disabled=${this.variableValue === _constants__WEBPACK_IMPORTED_MODULE_3__.TPW_EMPTY_COLUMN_VALUE || this.toolTipDisabled}
        >
          <div class="aid-value">
            ${_constants__WEBPACK_IMPORTED_MODULE_3__.TIMER_FIELDS.includes(this.variableName)
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
                  <agentx-wc-count-down-timer
                    duration="${this.variableValue}"
                    .isDurationTimer=${true}
                    .showDefaultHours=${false}
                  ></agentx-wc-count-down-timer>
                `
                : (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ` <div>${this.variableValue}</div> `}
          </div>
        </md-tooltip>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], Element.prototype, "variableName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], Element.prototype, "variableValue", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "toolTipDisabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.query)(".aid-value")
    ], Element.prototype, "valueContainer", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-aid-value")
    ], Element);
    AidValue.Element = Element;
})(AidValue || (AidValue = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/AppliedFilters.ts":
/*!***************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/AppliedFilters.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AppliedFilters: () => (/* binding */ AppliedFilters)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _assets_styles_common_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../assets/styles/common.scss */ "./src/assets/styles/common.scss");
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Utils */ "./src/components/TeamPerformanceWidget/Utils.ts");
/* harmony import */ var _style_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./style.scss */ "./src/components/TeamPerformanceWidget/components/style.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var AppliedFilters;
(function (AppliedFilters) {
    /**
     * @element agentx-wc-tpw-applied-filters
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
        constructor() {
            super(...arguments);
            this.appliedFilters = {};
            this.gridOptions = {};
            this.appliedGroups = [];
            this.isFilterApplied = false;
            this.isExpanded = false;
            this.columnWiseFilterCount = {};
            this.columnWiseFilters = {};
            this.updateFiltersAndFilterCount = () => {
                Object.keys(this.appliedFilters).forEach((columnField) => {
                    let columnFilterCount = 0;
                    const columnFilters = [];
                    Object.keys(this.appliedFilters[columnField]).forEach((columnData) => {
                        if (this.appliedFilters[columnField][columnData]) {
                            columnFilterCount++;
                            columnFilters.push(columnData);
                        }
                    });
                    if (columnFilterCount) {
                        this.isFilterApplied = true;
                    }
                    this.columnWiseFilterCount[columnField] = columnFilterCount;
                    this.columnWiseFilters[columnField] = columnFilters;
                });
            };
            this.handleExpandAppliedFilters = (event) => {
                if (!this.checkKeyboardEventKey(event)) {
                    return;
                }
                event.preventDefault();
                this.isExpanded = !this.isExpanded;
            };
            this.handleClearAllFilters = (event) => {
                if (!this.checkKeyboardEventKey(event)) {
                    return;
                }
                event.preventDefault();
                this.dispatchFilterUpdateEvent({
                    clearAllFilter: true
                });
            };
        }
        static get styles() {
            return [_style_scss__WEBPACK_IMPORTED_MODULE_7__["default"], _assets_styles_common_scss__WEBPACK_IMPORTED_MODULE_5__["default"]];
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            if (changedProperties.has("appliedFilters")) {
                this.isFilterApplied = false;
                this.updateFiltersAndFilterCount();
                this.requestUpdate();
            }
        }
        checkKeyboardEventKey(event) {
            if (event.type === "keydown") {
                const { code } = event;
                if (code !== _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Space && code !== _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Enter) {
                    return false;
                }
            }
            return true;
        }
        dispatchFilterUpdateEvent(updatedColumnFilter) {
            this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.TPW_FILTER_UPDATED, {
                bubbles: true,
                composed: true,
                detail: updatedColumnFilter
            }));
        }
        dispatchGroupFilterUpdateEvent(updatedColumnFilter) {
            this.dispatchEvent(new CustomEvent("tpw-group-filter-updated", {
                bubbles: true,
                composed: true,
                detail: updatedColumnFilter
            }));
        }
        handleRemoveColumnAllFilters(event, columnField) {
            if (!this.checkKeyboardEventKey(event)) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
            this.dispatchFilterUpdateEvent({
                field: columnField,
                data: {}
            });
        }
        handleRemoveColumnDataFilter(event, columnField, columnData) {
            if (!this.checkKeyboardEventKey(event)) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
            const updatedColumnFilter = {
                field: columnField,
                data: Object.assign(Object.assign({}, this.appliedFilters[columnField]), { [columnData]: false })
            };
            this.dispatchFilterUpdateEvent(updatedColumnFilter);
        }
        renderCollapsedView() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        ${Object.keys(this.columnWiseFilterCount).map((columnField) => {
                if (this.columnWiseFilterCount[columnField]) {
                    return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
              <md-chip
                role="button"
                aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.remove")} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.filter")} ${(0,_Utils__WEBPACK_IMPORTED_MODULE_6__.columnHeaderMapping)()[columnField]} (${this
                        .columnWiseFilterCount[columnField]}) "
                aria-describedby="filter-info-id"
                tooltipText=${this.columnWiseFilters[columnField].join(" ,")}
                tooltipPlacement="bottom"
                value="${`${(0,_Utils__WEBPACK_IMPORTED_MODULE_6__.columnHeaderMapping)()[columnField]} (${this.columnWiseFilterCount[columnField]})`}"
                class="applied-filters-chips filter-collapsed-view"
                @chip-interaction=${(event) => this.handleRemoveColumnAllFilters(event, columnField)}
                @click=${(event) => this.handleRemoveColumnAllFilters(event, columnField)}
                @keydown=${(event) => this.handleRemoveColumnAllFilters(event, columnField)}
              >
                <span class="sr-only" slot="custom-left-content" id="filter-info-id"
                  >${this.columnWiseFilters[columnField].join(" ,")}</span
                >
                <md-icon
                  name="icon-cancel_8"
                  slot="custom-right-content"
                  class="chip-cross-icon"
                  tabIndex="-1"
                ></md-icon>
              </md-chip>
            `;
                }
                else {
                    return lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing;
                }
            })}
      `;
        }
        renderExpandedView() {
            const appliedFiltersData = [];
            const columnsDataKeys = Object.keys(this.appliedFilters);
            for (const columnsDataKey of columnsDataKeys) {
                const columnsDataNestedKeys = this.appliedFilters[columnsDataKey];
                for (const i in columnsDataNestedKeys) {
                    if (columnsDataNestedKeys[i]) {
                        appliedFiltersData.push({
                            columnsDataKey,
                            colName: (0,_Utils__WEBPACK_IMPORTED_MODULE_6__.columnHeaderMapping)()[columnsDataKey],
                            colVal: i
                        });
                    }
                }
            }
            return appliedFiltersData.map((data) => {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
          <md-chip
            role="button"
            aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.remove")} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.filter")} ${data.colName}: ${data.colVal}"
            aria-describedby="data-filter-info"
            class="applied-filters-chips filter-expanded-view"
            tooltipText="${data.colName}: ${data.colVal}"
            tooltipPlacement="bottom"
            value="${data.colName}: ${data.colVal}"
            @chip-interaction=${(event) => this.handleRemoveColumnDataFilter(event, data.columnsDataKey, data.colVal)}
          >
            <span class="sr-only" slot="custom-left-content" id="data-filter-info"
              >${data.colName}: ${data.colVal}</span
            >
            <md-icon
              name="icon-cancel_8"
              slot="custom-right-content"
              class="chip-cross-icon"
              tabIndex="-1"
              @click=${(event) => this.handleRemoveColumnDataFilter(event, data.columnsDataKey, data.colVal)}
              @keydown=${(event) => this.handleRemoveColumnDataFilter(event, data.columnsDataKey, data.colVal)}
            ></md-icon>
          </md-chip>
        `;
            });
        }
        renderFilterActionButtons() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <md-link
          tag="span"
          ariaRole="button"
          class="applied-filters-expandCollapse-btn applied-filters-action-btn"
          @click=${(event) => this.handleExpandAppliedFilters(event)}
          @keydown=${(event) => this.handleExpandAppliedFilters(event)}
        >
          ${this.isExpanded ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.collapse") : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.expand")}
        </md-link>
        <md-link
          tag="span"
          ariaRole="button"
          class="applied-filters-action-btn"
          @click=${(event) => this.handleClearAllFilters(event)}
          @keydown=${(event) => this.handleClearAllFilters(event)}
        >
          ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.clearAll")}
        </md-link>
      `;
        }
        getAppliedGroupFilters(columnDefs, appliedGroupsBy) {
            const appliedGroupsData = appliedGroupsBy.map((a) => {
                var _a;
                return {
                    id: a.colId,
                    name: (_a = columnDefs === null || columnDefs === void 0 ? void 0 : columnDefs.find((b) => b.field === a.colId)) === null || _a === void 0 ? void 0 : _a.headerName
                };
            });
            return appliedGroupsData.map((data) => {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
          <md-chip
            role="button"
            aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.remove")} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.group")} ${data.name}"
            aria-describedby="group-filter-info"
            class="applied-groups-chips filter-expanded-view"
            tooltipText=${data.name}
            tooltipPlacement="bottom"
            value=${data.name}
            @chip-interaction=${(event) => this.onGroupFilterClear(data.id, event)}
          >
            <span class="sr-only" slot="custom-left-content" id="group-filter-info">${data.name}</span>
            <md-icon
              name="icon-cancel_8"
              slot="custom-right-content"
              class="chip-cross-icon"
              tabIndex="-1"
              @click=${(event) => this.onGroupFilterClear(data.id, event)}
              @keydown=${(event) => this.onGroupFilterClear(data.id, event)}
            ></md-icon>
          </md-chip>
        `;
            });
        }
        onGroupFilterClearAll(event) {
            if (!this.checkKeyboardEventKey(event)) {
                return;
            }
            event.preventDefault();
            this.dispatchGroupFilterUpdateEvent({
                clearAllFilter: true
            });
        }
        onGroupFilterClear(fieldId, event) {
            if (!this.checkKeyboardEventKey(event)) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
            this.dispatchGroupFilterUpdateEvent({
                field: fieldId
            });
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div>
          ${this.isFilterApplied
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                <div class="applied-filters-wrapper">
                  <span class="applied-filters__label">${`${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.filtersApplied")}:`} </span>
                  <span class="applied-group__chip">
                    ${this.isExpanded ? this.renderExpandedView() : this.renderCollapsedView()}
                  </span>
                  ${this.renderFilterActionButtons()}
                </div>
              `
                : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}
          ${this.appliedGroups.length > 0
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                <div class="applied-group-wrapper">
                  <span class="applied-group__label">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.groupBy")}: </span>
                  <span class="applied-group__chip">
                    ${this.getAppliedGroupFilters(this.gridOptions.columnDefs, this.appliedGroups)}
                  </span>
                  ${this.appliedGroups.length > 1
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                        <md-link
                          ariaRole="button"
                          data-testid="applied-group__clear-all"
                          class="applied-group__clear-all"
                          @click=${(event) => this.onGroupFilterClearAll(event)}
                          @keydown=${(event) => this.onGroupFilterClearAll(event)}
                          >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.clearAll")}
                        </md-link>
                      `
                    : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}
                </div>
              `
                : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Object })
    ], Element.prototype, "appliedFilters", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Object })
    ], Element.prototype, "gridOptions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Array })
    ], Element.prototype, "appliedGroups", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "isFilterApplied", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "isExpanded", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "columnWiseFilterCount", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "columnWiseFilters", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-tpw-applied-filters")
    ], Element);
    AppliedFilters.Element = Element;
})(AppliedFilters || (AppliedFilters = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/EmptyGrid.ts":
/*!**********************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/EmptyGrid.ts ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EmptyGrid: () => (/* binding */ EmptyGrid)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Common_EmptyStateWrapper_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Common/EmptyStateWrapper/EmptyStateWrapper */ "./src/components/Common/EmptyStateWrapper/EmptyStateWrapper.ts");
/* harmony import */ var _style_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./style.scss */ "./src/components/TeamPerformanceWidget/components/style.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var EmptyGrid;
(function (EmptyGrid) {
    /**
     * @element agentx-wc-tpw-empty-grid
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.isError = "1";
        }
        static get styles() {
            return _style_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
        }
        connectedCallback() {
            super.connectedCallback();
        }
        render() {
            return this.isError === "1"
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
            <div class="agentx-wc-tpw-empty-grid">
              <agentx-wc-empty-state-wrapper illustration-type="error-cloud">
                <div class="empty-grid-message-container">
                  <p class="empty-grid-message" role="alert">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.errorHeader")}</p>
                </div>
              </agentx-wc-empty-state-wrapper>
            </div>
          `
                : (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
            <div class="agentx-wc-tpw-empty-grid">
              <agentx-wc-empty-state-wrapper illustration-type="empty-state">
                <span role="alert" class="empty-grid-message">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.noData")}</span>
              </agentx-wc-empty-state-wrapper>
            </div>
          `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ reflect: true, attribute: "is-error" })
    ], Element.prototype, "isError", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-tpw-empty-grid")
    ], Element);
    EmptyGrid.Element = Element;
})(EmptyGrid || (EmptyGrid = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/ReviewAndMonitorWrapper.scss":
/*!**************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/ReviewAndMonitorWrapper.scss ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

* {
  /* BASE LEVEL < 100 */
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-index-tpw-header: 1;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-index-task-collapse-area: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-navigation-bar: 12;
  --z-index-task-list: 12;
  --z-index-wrap-up: 13;
  --z-index-sticky-header: 14;
  --z-index-shortcutkey-modal: 15;
  /* MID LEVEL FLOATING > 100 < 1000 */
  --z-index-notification: 150;
  /* SUPER LEVEL > 1000 */
  --z-index-modal: 1040;
  --z-index-popover: 1041;
  --z-index-callback-modal: 1042;
  /* This below order needs to be unchanged. Highest priority is for connection loss overlay,
         followed by error modal since error can occur during app load such as teams failure/register failure. */
  --z-index-app-full-overlay: 1050;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1200;
}

.review-monitor-wrapper md-button::part(button) {
  background-color: transparent;
}
.review-monitor-wrapper.list md-button {
  margin: 0;
}
.review-monitor-wrapper .rm-text {
  margin-top: 0;
  margin-bottom: 0;
  color: var(--md-primary-text-color);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
}
.review-monitor-wrapper .rm-text.disabled {
  color: var(--md-disabled-text-color);
}

.aid-tooltip {
  margin-top: 3px;
}

.aid-icon {
  height: calc(var(--space-token-even) * 10);
  width: calc(var(--space-token-even) * 10);
}

.btn-action {
  margin: calc(var(--space-token-even) * 6);
}

.aid-button:focus-visible {
  outline: none;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/ReviewAndMonitorWrapper.ts":
/*!************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/ReviewAndMonitorWrapper.ts ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ReviewAndMonitorWrapper: () => (/* binding */ ReviewAndMonitorWrapper)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ReviewAndMonitorWrapper_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./ReviewAndMonitorWrapper.scss */ "./src/components/TeamPerformanceWidget/components/ReviewAndMonitorWrapper.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





const reviewAndMonitor = "app:tpw.reviewAndMonitor";
const review = "app:tpw.review";
var ReviewAndMonitorWrapper;
(function (ReviewAndMonitorWrapper) {
    /**
     * @element agentx-wc-tpw-review-monitor-wrapper
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.agentId = "";
            this.isMCMEnabled = false;
            this.isList = false;
            this.isConsultCall = false;
            this.isDarkMode = false;
            this.isReviewMonitorEnabled = false;
        }
        static get styles() {
            return _ReviewAndMonitorWrapper_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
        }
        connectedCallback() {
            super.connectedCallback();
        }
        disconnectedCallback() {
            super.disconnectedCallback();
        }
        getReviewButton(disabled = false) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-button
          id=${this.agentId}
          aria-colindex="12"
          tabIndex="0"
          class="aid-button btn-action"
          ariaLabel="${this.isMCMEnabled ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(reviewAndMonitor) : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(review)}"
          size="size-none"
          .disabled=${disabled}
          color="color-none"
        >
          ${!disabled && !this.isList
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
                <img
                  class="aid-icon"
                  alt="${this.isMCMEnabled ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(reviewAndMonitor) : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(review)}"
                  src="${this.isDarkMode ? _constants__WEBPACK_IMPORTED_MODULE_0__.REVIEW_BUTTON_DARK : _constants__WEBPACK_IMPORTED_MODULE_0__.REVIEW_BUTTON_LIGHT}"
                />
              `
                : disabled && !this.isList
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
                  <img
                    class="aid-icon"
                    alt="${this.isMCMEnabled ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(reviewAndMonitor) : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(review)}"
                    src="${this.isDarkMode ? _constants__WEBPACK_IMPORTED_MODULE_0__.REVIEW_BUTTON_DARK_DISABLED : _constants__WEBPACK_IMPORTED_MODULE_0__.REVIEW_BUTTON_LIGHT_DISABLED}"
                  />
                `
                    : this.isList
                        ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
                    <p class="rm-text ${disabled ? "disabled" : ""}">
                      ${this.isMCMEnabled ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(reviewAndMonitor) : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(review)}
                    </p>
                  `
                        : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
        </md-button>
      `;
        }
        getTooltipMessage() {
            if (this.isConsultCall) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.cannotMonitorConsult");
            }
            else if (this.isMCMEnabled) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(reviewAndMonitor);
            }
            else {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(review);
            }
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="${`review-monitor-wrapper ${this.isList ? "list" : ""}`}">
          ${this.isReviewMonitorEnabled || this.isConsultCall
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
                <md-tooltip class="aid-tooltip" message="${this.getTooltipMessage()}" placement="top">
                  ${this.isConsultCall ? this.getReviewButton(true) : this.getReviewButton(false)}
                </md-tooltip>
              `
                : this.getReviewButton(true)}
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "agentId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isMCMEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isList", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isConsultCall", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isDarkMode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isReviewMonitorEnabled", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-tpw-review-monitor-wrapper")
    ], Element);
    ReviewAndMonitorWrapper.Element = Element;
})(ReviewAndMonitorWrapper || (ReviewAndMonitorWrapper = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/SignoutModal.scss":
/*!***************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/SignoutModal.scss ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.reset-table {
  color: var(--md-primary-text-color);
}
.reset-table::part(button):hover {
  background-color: var(--button-white-hover-bg-color);
  border-radius: var(--border-radius-large);
}

.signout-btn-wrapper .signout-submit {
  margin-left: 10px;
}
.signout-btn-wrapper .signout-submit,
.signout-btn-wrapper .signout-close {
  float: right;
  margin-right: 10px;
}

.header-width {
  width: 100%;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL1RlYW1QZXJmb3JtYW5jZVdpZGdldC9jb21wb25lbnRzL1NpZ25vdXRNb2RhbC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsbUNBQUE7QUFDRjtBQUNJO0VBQ0Usb0RBQUE7RUFDQSx5Q0FBQTtBQUNOOztBQUtFO0VBQ0UsaUJBQUE7QUFGSjtBQUlFOztFQUVFLFlBQUE7RUFDQSxrQkFBQTtBQUZKOztBQU1BO0VBQ0UsV0FBQTtBQUhGIiwic291cmNlc0NvbnRlbnQiOlsiLnJlc2V0LXRhYmxlIHtcbiAgY29sb3I6IHZhcigtLW1kLXByaW1hcnktdGV4dC1jb2xvcik7XG4gICY6OnBhcnQoYnV0dG9uKSB7XG4gICAgJjpob3ZlciB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1idXR0b24td2hpdGUtaG92ZXItYmctY29sb3IpO1xuICAgICAgYm9yZGVyLXJhZGl1czogdmFyKC0tYm9yZGVyLXJhZGl1cy1sYXJnZSk7XG4gICAgfVxuICB9XG59XG5cbi5zaWdub3V0LWJ0bi13cmFwcGVyIHtcbiAgLnNpZ25vdXQtc3VibWl0IHtcbiAgICBtYXJnaW4tbGVmdDogMTBweDtcbiAgfVxuICAuc2lnbm91dC1zdWJtaXQsXG4gIC5zaWdub3V0LWNsb3NlIHtcbiAgICBmbG9hdDogcmlnaHQ7XG4gICAgbWFyZ2luLXJpZ2h0OiAxMHB4O1xuICB9XG59XG5cbi5oZWFkZXItd2lkdGgge1xuICB3aWR0aDogMTAwJTtcbn1cbiJdLCJzb3VyY2VSb290IjoiIn0= */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/SignoutModal.ts":
/*!*************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/SignoutModal.ts ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SignoutModal: () => (/* binding */ SignoutModal)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html_lib_part__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html/lib/part */ "lit-html/lib/part");
/* harmony import */ var lit_html_lib_part__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html_lib_part__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _SignoutModal_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./SignoutModal.scss */ "./src/components/TeamPerformanceWidget/components/SignoutModal.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let SignoutModal = class SignoutModal extends lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement {
    constructor() {
        super(...arguments);
        this.isSignoutModalOpen = false;
    }
    static get styles() {
        return _SignoutModal_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
    }
    confirmAgentSignout() {
        this.dispatchEvent(new CustomEvent("confirm-signout"));
    }
    declineAgentSignout() {
        this.dispatchEvent(new CustomEvent("decline-signout"));
    }
    render() {
        var _a;
        return this.isSignoutModalOpen
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
          <md-modal
            applicationId="signout"
            ?show=${this.isSignoutModalOpen}
            id="signoutModal"
            size="dialog"
            .hideFooter=${true}
            headerLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.signoutAgentMenu")}
            ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.signoutAgentMenu")}
            tabindex="${"-1"}"
            ?showclosebutton=${false}
            .ariaLabelClose=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.closeSignoutAgentView")}
          >
            <div class="modal-body">
              <span
                >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.signoutAgentConfirmation", "", {
                defaultValue: (_a = this.selectedAgentDetails) === null || _a === void 0 ? void 0 : _a.agentName
            })}</span
              >
            </div>
            <div slot="footer" class="signout-btn-wrapper">
              <md-button
                class="signout-submit"
                variant="primary"
                @click="${this.confirmAgentSignout}"
                type="submit"
                ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.signout")}
              >
                ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.signout")}</md-button
              >
              <md-button
                class="signout-close"
                variant="secondary"
                ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.cancel")}
                type="reset"
                @click="${this.declineAgentSignout}"
              >
                ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.cancel")}</md-button
              >
            </div>
          </md-modal>
        `
            : lit_html_lib_part__WEBPACK_IMPORTED_MODULE_2__.nothing;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
], SignoutModal.prototype, "isSignoutModalOpen", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
], SignoutModal.prototype, "selectedAgentDetails", void 0);
SignoutModal = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-tpw-signout-modal")
], SignoutModal);



/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/StateSelector.ts":
/*!**************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/StateSelector.ts ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   StateSelector: () => (/* binding */ StateSelector)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _style_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./style.scss */ "./src/components/TeamPerformanceWidget/components/style.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




const AgentState = { Available: "Available", Idle: "Idle" };
var StateSelector;
(function (StateSelector) {
    /**
     * @element agentx-wc-tpw-state-selector
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.agentState = "";
        }
        static get styles() {
            return _style_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
        }
        getAgentStateDotClass() {
            switch (this.agentState) {
                case AgentState.Available:
                    return "agent-available-dot";
                case AgentState.Idle:
                    return "agent-idle-dot";
                default:
                    return "agent-idle-dot";
            }
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-chip
          class=${this.agentState === "Available" ? "agent-state-active" : "agent-state-idle"}
          value=${this.agentState}
        >
          <span slot="custom-left-content" class=${`agent-state-dot ${this.getAgentStateDotClass()}`}></span>
          <md-icon name="icon-arrow-down_16" slot="custom-right-content"></md-icon>
        </md-chip>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ reflect: true })
    ], Element.prototype, "agentState", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-tpw-state-selector")
    ], Element);
    StateSelector.Element = Element;
})(StateSelector || (StateSelector = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/WebexChat.scss":
/*!************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/WebexChat.scss ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.WebexChat {
  margin: 10rem;
  display: table-row;
}

.str-length {
  border: 1px solid var(--input-default-border-color, #ccc);
  padding: 8px 16px;
  display: flex;
  justify-content: flex-end;
  border-top: none;
  border-radius: 0 0 4px 4px;
  background-color: var(--md-input-chat-length-indicator-bg-color);
}
.str-length .length-label {
  font-size: 10px;
  line-height: 150%;
  color: var(--md-input-chat-length-indicator-color);
}
.str-length:hover {
  background-color: var(--md-input-chat-length-indicator-bg-color);
}
.str-length:focus {
  background-color: var(--md-input-chat-length-indicator-bg-color);
}

.btn-action {
  margin: calc(var(--space-token-even) * 6);
}
.btn-action::part(button) {
  height: 25px;
}

.action-container {
  margin-top: 25px;
  display: flex;
  justify-content: flex-end;
}
.action-container > md-button:first-child {
  order: 2;
}
.action-container > md-button:last-child {
  order: 1;
  margin-right: 8px;
}
.action-container > md-button.send-disabled::part(button) {
  cursor: not-allowed;
  background-color: var(--md-webex-chat-disable-bg-color, #dedede);
  color: var(--md-webex-chat-disable-color, #b2b2b2);
}
.action-container > md-button.send-disabled::part(button):focus, .action-container > md-button.send-disabled::part(button):focus-visible {
  border: none;
}

.icon-container .error-icon {
  position: absolute;
  top: -2px;
  right: -2px;
  color: var(--md-input-chat-error-color, #a12512);
}
.icon-container .error-icon md-icon::part(icon) {
  background-color: white;
  border-radius: 50%;
}

.header {
  display: flex;
  padding-bottom: 18px;
  justify-content: space-between;
}
.header .user-info {
  display: flex;
}
.header .user-info img {
  width: 28px;
  height: 28px;
  border-radius: 50%;
}
.header .user-info md-label {
  margin-top: 4px;
}
.header .user-info .name {
  font-size: 16px;
  font-weight: 900;
  margin: 0 0 0 8px;
}
.header .close-icon {
  height: 30px;
}
.header .close-icon:focus,
.header .close-icon :focus-visible {
  outline: none;
}
.header .close-icon md-button {
  cursor: pointer;
}
.header .close-icon md-button::part(button) {
  position: relative;
  top: -5px;
  right: -5px;
}

.error-msg {
  height: 23px;
}
.error-msg .error-label {
  color: var(--md-input-chat-error-color);
  font-size: 12px;
  line-height: 125%;
  margin-top: 8px;
  margin-bottom: 8px;
}
.error-msg .error-label md-icon::part(icon) {
  font-size: 10px;
}
.error-msg .error-label .error {
  margin-bottom: 2px;
}

.webex-md-input::part(md-input-container) {
  margin-bottom: 0;
}
.webex-md-input::part(input) {
  border-bottom: none;
  background-color: var(--md-input-chat-bg-color);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  padding: 8px 16px;
  max-height: 104px;
  height: 104px;
  font-size: 14px;
  line-height: 16px;
  color: var(--md-input-chat-color);
}
.webex-md-input::part(input):hover {
  background-color: var(--md-input-chat-bg-color);
}
.webex-md-input::part(input):focus {
  background-color: var(--md-input-chat-bg-color);
  border-color: var(--input-default-border-color, #ccc);
}

.webex-popup {
  padding: 16px;
  background-color: var(--md-input-bg-color);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/WebexChat.ts":
/*!**********************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/WebexChat.ts ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WebexChat: () => (/* binding */ WebexChat)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../TeamPerformanceUtils */ "./src/components/TeamPerformanceWidget/TeamPerformanceUtils.ts");
/* harmony import */ var _utils_WebexChat_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../utils/WebexChat.utils */ "./src/components/TeamPerformanceWidget/utils/WebexChat.utils.ts");
/* harmony import */ var _WebexChat_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./WebexChat.scss */ "./src/components/TeamPerformanceWidget/components/WebexChat.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};







var WebexChat;
(function (WebexChat) {
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
        constructor() {
            super(...arguments);
            this.isOpen = false;
            this.name = "";
            this.agentEmail = "";
            this.agentId = "";
            this.inputValue = "";
            this.error = "";
            this.isLoading = false;
            this.autoFocusEnabled = true;
            this.isComposing = false;
            this.handleOnSend = () => __awaiter(this, void 0, void 0, function* () {
                if (this.inputValue !== "") {
                    this.isLoading = true;
                    const agentId = this.agentId;
                    let isWebExSendingMessageError = false;
                    this.updateActionCellValue({ isWebExSendingMessage: true, isWebExSendingMessageError, agentId });
                    this.closeOverlay();
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.WEBEX_CHAT_TPW_MESSAGE_SEND, {
                        agentEmail: this.agentEmail
                    });
                    const status = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.webex.sendMessage(this.agentEmail, this.inputValue);
                    if (status) {
                        this.error = "";
                        this.inputValue = "";
                        (0,_utils_WebexChat_utils__WEBPACK_IMPORTED_MODULE_5__.setPersistedText)(this.name, this.agentEmail, "");
                        (0,_utils_WebexChat_utils__WEBPACK_IMPORTED_MODULE_5__.setPersistedError)(this.name, this.agentEmail, false);
                    }
                    else {
                        this.error = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:notifications.webexChatTPWErrorMessage");
                        (0,_utils_WebexChat_utils__WEBPACK_IMPORTED_MODULE_5__.setPersistedError)(this.name, this.agentEmail, true);
                        isWebExSendingMessageError = true;
                    }
                    this.isLoading = false;
                    setTimeout(() => {
                        this.updateActionCellValue({ isWebExSendingMessage: false, isWebExSendingMessageError, agentId });
                    }, 0);
                }
            });
            this.returnFocusToChatIcon = () => {
                var _a;
                const tooltipElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-tooltip md-button");
                tooltipElement === null || tooltipElement === void 0 ? void 0 : tooltipElement.setAttribute("tabindex", "0");
                tooltipElement === null || tooltipElement === void 0 ? void 0 : tooltipElement.focus({ focusVisible: true });
            };
            this.handleOnCancel = () => {
                (0,_utils_WebexChat_utils__WEBPACK_IMPORTED_MODULE_5__.setPersistedText)(this.name, this.agentEmail, "");
                (0,_utils_WebexChat_utils__WEBPACK_IMPORTED_MODULE_5__.setPersistedError)(this.name, this.agentEmail, false);
                this.inputValue = "";
                this.error = "";
                this.updateActionCellValue({
                    isWebExSendingMessage: false,
                    isWebExSendingMessageError: false,
                    agentId: this.agentId
                });
                this.closeOverlay();
            };
            this.handleCloseIconClick = () => {
                this.closeOverlay();
            };
            this.handleInputChange = (event) => {
                this.inputValue = event.detail.value;
                (0,_utils_WebexChat_utils__WEBPACK_IMPORTED_MODULE_5__.setPersistedText)(this.name, this.agentEmail, event.detail.value);
            };
            this.handleKeyDown = (event) => {
                //stopPropagation() is called to fix keyboard actions(copying, cutting, selecting all) to prevent bubbling up the these keyboard events in the hierarchy.
                event.stopPropagation();
                if (event.key === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Escape) {
                    this.handleCloseIconClick();
                    this.returnFocusToChatIcon();
                }
                else if (!event.shiftKey && (event.code === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Enter || event.key === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Enter) && !this.isComposing) {
                    event.preventDefault();
                    this.handleOnSend();
                    this.returnFocusToChatIcon();
                }
            };
            // function to close webex chat popover on keyboard navigation of 'close' icon inside the popover.
            this.handleCloseIconKeydown = (event) => {
                var _a, _b, _c;
                event.preventDefault();
                event.stopPropagation();
                if (event.key === "Tab" && !event.shiftKey) {
                    this.focusInputField();
                }
                else if (event.shiftKey && event.key === "Tab") {
                    const discardIcon = (_c = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".discard-btn")) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector("button");
                    if (discardIcon) {
                        discardIcon === null || discardIcon === void 0 ? void 0 : discardIcon.focus();
                    }
                }
                else if (this.standardKeyCheck(event) || event.key === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Escape) {
                    this.returnFocusToChatIcon();
                    event.preventDefault();
                    this.handleCloseIconClick();
                }
            };
            this.checkSendDisabled = (inputValue) => (inputValue === "" ? true : false);
            this.closeOverlay = () => {
                this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.HANDLE_WEBEX_CHAT_CLOSE_EVENT, {
                    composed: true,
                    bubbles: true
                }));
            };
            this.updateActionCellValue = (values) => {
                this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.UPDATE_ACTION_CELL_VALUE_EVENT, {
                    composed: true,
                    bubbles: true,
                    detail: Object.assign({}, values)
                }));
            };
        }
        static get styles() {
            return [_WebexChat_scss__WEBPACK_IMPORTED_MODULE_6__["default"]];
        }
        setAgentAvatarUrl() {
            this.agentAvatarUrl = (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_4__.getAvatarUrlFromCache)(this.agentId);
        }
        connectedCallback() {
            super.connectedCallback();
            this.updatePersistedError();
            this.addEventListener("compositionstart", this.handleCompositionStart.bind(this));
            this.addEventListener("compositionend", this.handleCompositionEnd.bind(this));
            this.addCloseIconListener();
        }
        handleCompositionStart(_event) {
            this.isComposing = true;
        }
        handleCompositionEnd(_event) {
            this.isComposing = false;
        }
        addCloseIconListener() {
            var _a;
            const closeIcon = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".close-icon");
            if (closeIcon && closeIcon.getAttribute("listener") !== "true") {
                closeIcon.addEventListener("keydown", this.handleCloseIconKeydown);
                closeIcon.setAttribute("listener", "true");
            }
        }
        updatePersistedError() {
            const isPersistedError = (0,_utils_WebexChat_utils__WEBPACK_IMPORTED_MODULE_5__.getPersistedError)(this.name, this.agentEmail);
            if (isPersistedError) {
                this.error = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:notifications.webexChatTPWErrorMessage");
            }
            else {
                this.error = "";
            }
        }
        update(changedProperties) {
            super.update(changedProperties);
            this.setAgentAvatarUrl();
            this.addCloseIconListener();
        }
        disconnectedCallback() {
            var _a, _b;
            (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".close-icon")) === null || _b === void 0 ? void 0 : _b.removeEventListener("keydown", this.handleCloseIconKeydown);
            this.removeEventListener("compositionstart", this.handleCompositionStart.bind(this));
            this.removeEventListener("compositionend", this.handleCompositionEnd.bind(this));
        }
        standardKeyCheck(event) {
            return event.key === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Space || event.code === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Space || event.key === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Enter || event.code === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Enter;
        }
        handleSendKeypress(event) {
            event.stopPropagation();
            if (this.standardKeyCheck(event)) {
                event.preventDefault();
                this.handleOnSend();
                this.returnFocusToChatIcon();
            }
            else if (event.key === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Escape) {
                this.handleCloseIconClick();
                this.returnFocusToChatIcon();
            }
        }
        handleCancelKeypress(event) {
            var _a, _b, _c, _d, _e, _f, _g;
            event.preventDefault();
            event.stopPropagation();
            if (this.standardKeyCheck(event)) {
                this.handleOnCancel();
                this.returnFocusToChatIcon();
            }
            else if (event.key === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Escape) {
                this.handleCloseIconClick();
                this.returnFocusToChatIcon();
            }
            else if (!(event === null || event === void 0 ? void 0 : event.shiftKey) && event.key === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Tab) {
                const closeIconElement = (_d = (_c = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".close-icon")) === null || _b === void 0 ? void 0 : _b.querySelector("md-button")) === null || _c === void 0 ? void 0 : _c.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector("button");
                setTimeout(function () {
                    closeIconElement === null || closeIconElement === void 0 ? void 0 : closeIconElement.focus();
                }, 0);
            }
            else if (event.shiftKey && event.key === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Tab) {
                const sendButton = (_g = (_f = (_e = this.shadowRoot) === null || _e === void 0 ? void 0 : _e.querySelector("md-button.send-btn")) === null || _f === void 0 ? void 0 : _f.shadowRoot) === null || _g === void 0 ? void 0 : _g.querySelector("button");
                if (sendButton) {
                    sendButton === null || sendButton === void 0 ? void 0 : sendButton.focus();
                }
                else {
                    this.focusInputField();
                }
            }
        }
        updated(_changedProperties) {
            super.updated(_changedProperties);
            if ((_changedProperties.has("agentEmail") || _changedProperties.has("isOpen")) && this.isOpen) {
                this.updatePersistedError();
                this.inputValue = (0,_utils_WebexChat_utils__WEBPACK_IMPORTED_MODULE_5__.getPersistedText)(this.name, this.agentEmail);
                setTimeout(() => {
                    this.focusInputField();
                }, 0);
            }
        }
        focusInputField() {
            var _a, _b, _c;
            const inputElement = (_c = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-input")) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector("textarea");
            inputElement === null || inputElement === void 0 ? void 0 : inputElement.focus();
        }
        handleInputBoxClicked(event) {
            event.stopPropagation();
        }
        render() {
            var _a;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div class="overlay-content webex-popup" role="dialog" aria-labelledby="webex-popup-title">
          <div class="header">
            <div class="user-info">
              <md-avatar
                title=${this.name}
                size=${28}
                src=${(_a = this.agentAvatarUrl) !== null && _a !== void 0 ? _a : ""}
                class="agent-avatar"
                aria-hidden="true"
              ></md-avatar>
              <md-label htmlFor="htmlId">
                <h3 id="webex-popup-title" class="name">${this.name}</h3>
              </md-label>
            </div>
            <div class="close-icon">
              <md-button
                variant="white"
                circle
                @button-click=${this.handleCloseIconClick}
                ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.close")}
              >
                <md-icon slot="icon" name="icon-cancel_16"></md-icon>
              </md-button>
            </div>
          </div>
          <md-input
            tab-index="0"
            class="webex-md-input"
            value=${this.inputValue}
            @input-change=${this.handleInputChange}
            style="border-bottom: 0"
            ui-grid-row="5"
            maxLength="1000"
            multiline
            containerSize="small-12"
            autofocus
            @click=${this.handleInputBoxClicked}
            @keydown=${this.handleKeyDown}
            placeholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:notifications.webexChatPlaceHolder", "", { defaultValue: this.name })}
            ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:notifications.webexChatPlaceHolder", "", { defaultValue: this.name }) +
                (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:notifications.stringLengthText", "", { defaultValue: `${this.inputValue.length}` })}
          >
          </md-input>
          <div class="str-length">
            <md-label htmlFor="htmlId">
              <span class="length-label">${this.inputValue.length}/1000</span>
            </md-label>
          </div>
          <div class="error-msg">
            ${this.error &&
                (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
              <md-label>
                <span class="error-label">
                  <md-icon slot="icon" name="icon-error_12"></md-icon>
                  <span class="error">${this.error}</span></span
                >
              </md-label>
            `}
          </div>
          <div class="action-container">
            <md-button
              @button-click=${this.handleOnSend}
              @keydown="${(event) => {
                this.handleSendKeypress(event);
            }}"
              ?disabled=${this.checkSendDisabled(this.inputValue)}
              class="${this.inputValue === "" ? "send-disabled" : "send-btn"}"
              color="blue"
            >
              <span slot="text">
                ${this.error ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:notifications.webexChatReSend") : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:notifications.webexChatSend")}</span
              >
            </md-button>
            <md-button
              @button-click=${this.handleOnCancel}
              class="discard-btn"
              variant="secondary"
              @keydown="${(event) => {
                this.handleCancelKeypress(event);
            }}"
            >
              <span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:notifications.webexChatDiscard")}</span>
            </md-button>
          </div>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean, attribute: "is-open" })
    ], Element.prototype, "isOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
    ], Element.prototype, "name", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
    ], Element.prototype, "agentEmail", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
    ], Element.prototype, "agentId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "inputValue", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "error", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "isLoading", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "agentAvatarUrl", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "autoFocusEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "tooltipElement", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("webex-chat")
    ], Element);
    WebexChat.Element = Element;
})(WebexChat || (WebexChat = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/agentStateSelector/agentStateSelectorInfinite/index.ts":
/*!****************************************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/agentStateSelector/agentStateSelectorInfinite/index.ts ***!
  \****************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TPWAgentStateSelector: () => (/* binding */ TPWAgentStateSelector)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/utils/WindowListenersHub */ "./src/utils/WindowListenersHub.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _list__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../list */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/list.ts");
/* harmony import */ var _scss_main_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../scss/main.scss */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/scss/main.scss");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../utils */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/utils/index.ts");
/* harmony import */ var _listError__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./listError */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/agentStateSelectorInfinite/listError.ts");
/* harmony import */ var _Common_SearchInput_searchInput__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../../Common/SearchInput/searchInput */ "./src/components/Common/SearchInput/searchInput.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};












var TPWAgentStateSelector;
(function (TPWAgentStateSelector) {
    /**
     * @element agentx-wc-tpw-agent-state-selector-infinite
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_5__.LitElement) {
        constructor() {
            super(...arguments);
            this.isWxccCoreDisallowPendingLogoutStateChangeEnabled = false;
            this.agentId = "";
            this.orgId = "";
            this.isOpen = false;
            this.items = [];
            this.searchQuery = "";
            this.searchMode = false;
            this.searchErrorForMinLength = false;
            this.currentPage = 0;
            this.totalRecords = 0;
            this.isPageLoading = false;
            this.isSearchPageLoading = false;
            this.pageFetchError = {
                isError: false,
                trackingId: ""
            };
            this.focusInputField = () => {
                var _a, _b, _c, _d;
                const inputElement = (_d = (_c = (_b = (_a = this.searchHandler) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("md-input")) === null || _c === void 0 ? void 0 : _c.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector("input");
                inputElement === null || inputElement === void 0 ? void 0 : inputElement.focus();
            };
            this.onStateSelectorOpen = () => __awaiter(this, void 0, void 0, function* () {
                this.loadNextPage();
                setTimeout(() => {
                    this.focusInputField();
                }, 0);
            });
            this.updateActionCellValue = (values) => {
                this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.UPDATE_ACTION_CELL_VALUE_EVENT, {
                    composed: true,
                    bubbles: true,
                    detail: Object.assign({}, values)
                }));
            };
            this.closeOverlay = () => {
                this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.STATE_CHANGE_OVERLAY_CLOSE_EVENT, {
                    composed: true,
                    bubbles: true
                }));
            };
            this.handleListItemChange = (event) => __awaiter(this, void 0, void 0, function* () {
                // agentStateChanging Flag is used to show the spinner on action cell component
                const agentId = this.agentId;
                this.updateActionCellValue({ agentStateChanging: true, agentId });
                this.closeOverlay();
                try {
                    const selectedValue = this.getSelectedAgentIdleCode(event.detail.selected[0]);
                    if (this.agentId) {
                        const payload = {
                            state: selectedValue.id === _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE_ID ? _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE : _constants__WEBPACK_IMPORTED_MODULE_0__.IDLE,
                            auxCodeId: selectedValue.id === _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE_ID ? " " : selectedValue.id,
                            lastStateChangeReason: "",
                            agentId: this.agentId
                        };
                        yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.aqm.supervisor.changeAgentState({ orgId: this.orgId, data: payload });
                        _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info(`[TPWAgentStateSelector] Agent state change success request}`);
                        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.AGENT_STATE_CHANGE, {
                            ChangedBy: _constants__WEBPACK_IMPORTED_MODULE_0__.SUPERVISOR,
                            CurrentState: selectedValue.name,
                            Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS
                        });
                        this.updateActionCellValue({
                            agentId,
                            agentStateChanging: false,
                            agentStateChangeError: false
                        });
                    }
                }
                catch (error) {
                    this.handleAgentStateChangeError(error, agentId);
                }
            });
            this.getFormattedIdleCodes = (item) => {
                return {
                    name: item.name,
                    id: item.id,
                    index: item.index,
                    ariaLabel: item.name,
                    template: (data) => {
                        return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `<agent-state-selector-list
            .isOpen=${this.isOpen}
            .agentStateOption=${data}
            .searchTerm="${this.searchQuery}"
          ></agent-state-selector-list>`;
                    }
                };
            };
            this.setLoadingState = (isSearchInitiatedNextPage, state) => {
                this.isPageLoading = state;
                if (isSearchInitiatedNextPage) {
                    this.isSearchPageLoading = state;
                }
            };
            this.setItems = (newItems, totalRecords, isSearchInitiatedNextPage) => {
                let availableRecordCount = 0;
                if (isSearchInitiatedNextPage) {
                    this.items = [];
                    this.totalRecords = 0;
                    this.currentPage = 0;
                }
                if (this.currentPage === 0 && (!this.searchQuery || (0,_utils__WEBPACK_IMPORTED_MODULE_9__.checkIfSearchMatchesAvailable)(this.searchQuery || ""))) {
                    const defaultItem = this.getFormattedIdleCodes((0,_utils__WEBPACK_IMPORTED_MODULE_9__.getDefaultAvailableIdleCode)((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.stateChange.available")));
                    this.items = [defaultItem];
                    availableRecordCount = 1;
                }
                if (!this.searchQuery) {
                    availableRecordCount = 1;
                }
                this.items = [...this.items, ...newItems];
                this.totalRecords = totalRecords + availableRecordCount;
                this.currentPage += 1;
            };
            this.loadNextPage = (event, isSearchInitiatedNextPage = false) => __awaiter(this, void 0, void 0, function* () {
                // Load more items
                if (this.isOpen === false) {
                    return;
                }
                try {
                    this.setLoadingState(isSearchInitiatedNextPage, true);
                    const { formattedListItems, totalRecords } = yield this.getListItems(this.currentPage, this.searchQuery);
                    if (this.isOpen && (this.searchMode || !this.searchErrorForMinLength)) {
                        this.setItems(formattedListItems, totalRecords, isSearchInitiatedNextPage);
                    }
                    this.setLoadingState(isSearchInitiatedNextPage, false);
                    this.pageFetchError = {
                        isError: false,
                        trackingId: ""
                    };
                }
                catch (error) {
                    this.setLoadingState(isSearchInitiatedNextPage, false);
                    this.pageFetchError = {
                        isError: true,
                        trackingId: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.getTrackingIdFromErrorObject)(error) : ""
                    };
                    _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error("event=loadNextPage | Error on fetching idle codes on Team Performance Widget Agent State Change Module", error);
                }
                finally {
                    this.setLoadingState(isSearchInitiatedNextPage, false);
                }
            });
            this.handleInputKeyDown = (event) => {
                if (event.detail.srcEvent) {
                    const { srcEvent } = event.detail;
                    if (srcEvent.key === "Tab" && srcEvent.shiftKey) {
                        event.detail.srcEvent.preventDefault();
                        // Focus to the md-advance-list-container
                        this.focusListComponent();
                    }
                }
            };
            this.getReasonAndReasonCodeFromErrorObject = (errorObj) => {
                var _a, _b, _c, _d;
                const reason = ((_b = (_a = errorObj === null || errorObj === void 0 ? void 0 : errorObj.details) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.reason) || "";
                const reasonCode = ((_d = (_c = errorObj === null || errorObj === void 0 ? void 0 : errorObj.details) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.reasonCode) || "";
                return [reason, reasonCode];
            };
        }
        static get styles() {
            return _scss_main_scss__WEBPACK_IMPORTED_MODULE_8__["default"];
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            if ((changedProperties.has("agentId") || changedProperties.has("isOpen")) && this.isOpen) {
                this.onStateSelectorOpen();
            }
            if (changedProperties.has("isOpen") && this.isOpen === false) {
                this.searchQuery = "";
                this.items = [];
                this.isPageLoading = false;
                this.currentPage = 0;
                this.totalRecords = 0;
                this.searchMode = false;
                this.searchErrorForMinLength = false;
                this.isSearchPageLoading = false;
                this.pageFetchError = {
                    isError: false,
                    trackingId: ""
                };
            }
        }
        getSelectedAgentIdleCodeId(filteredStateList) {
            const selectedIdleCodeId = filteredStateList === null || filteredStateList === void 0 ? void 0 : filteredStateList.find((stateOption) => {
                var _a;
                return stateOption.name === ((_a = this.selectedAgentDetails) === null || _a === void 0 ? void 0 : _a.agentState);
            });
            return (selectedIdleCodeId === null || selectedIdleCodeId === void 0 ? void 0 : selectedIdleCodeId.id) || "";
        }
        getSelectedAgentIdleCode(idleCodeId) {
            var _a;
            return (_a = this.items) === null || _a === void 0 ? void 0 : _a.find((stateOption) => {
                return stateOption.id === idleCodeId;
            });
        }
        handleAgentStateChangeError(error, agentId) {
            _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error(`event=agentStateChangeFailed | Tracking ID: ${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.getTrackingIdFromErrorObject)(error) : ""} | Updating agent state from team performance widget is failed : ${error}`, error);
            const [reason, reasonCode] = this.getReasonAndReasonCodeFromErrorObject(error);
            let message = "";
            if (this.isWxccCoreDisallowPendingLogoutStateChangeEnabled &&
                reason === _constants__WEBPACK_IMPORTED_MODULE_0__.STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT_REASON &&
                reasonCode === _constants__WEBPACK_IMPORTED_MODULE_0__.STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT_REASON_CODE) {
                message = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("tpw.stateChange.errorStateChangeInPendingLogout");
            }
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.AGENT_STATE_CHANGE, {
                ChangedBy: _constants__WEBPACK_IMPORTED_MODULE_0__.SUPERVISOR,
                Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED
            });
            this.updateActionCellValue({ agentId, agentStateChanging: false, agentStateChangeError: true });
            const failedEvent = new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.AGENT_STATE_CHANGE_FAILED, {
                detail: Object.assign(Object.assign({}, (this.isWxccCoreDisallowPendingLogoutStateChangeEnabled && { message: message || "" })), { trackingId: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.getTrackingIdFromErrorObject)(error) : null }),
                bubbles: true,
                composed: true
            });
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_3__.WINDOW_LISTENERS_HUB.dispatch(failedEvent);
        }
        getListItems(page, searchQuery = "") {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const response = yield (0,_utils__WEBPACK_IMPORTED_MODULE_9__.fetchItems)(this.orgId, this.agentId, page, searchQuery);
                    const formattedListItems = response.data.map((item) => this.getFormattedIdleCodes(item));
                    return { formattedListItems, totalRecords: response.meta.totalRecords };
                }
                catch (error) {
                    _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error("event=getListItems | Error on fetching idle codes on Team Performance Widget Agent State Change Module", error);
                    throw error;
                }
            });
        }
        getStatusIndicator() {
            if (this.isPageLoading && this.items.length > 0) {
                return [
                    {
                        id: "status-indicator",
                        name: "loading",
                        template: () => (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `<div class="infinite-scroll-spinner" part="spinner"><md-spinner size="18"></md-spinner></div>`
                    }
                ];
            }
            if (this.pageFetchError.isError && this.items.length > 0) {
                return [
                    {
                        id: "status-indicator",
                        name: "error",
                        template: () => (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `<agent-state-selector-list-error
                class="fetch-error"
                style="color: red;"
                trackingId="${this.pageFetchError.trackingId}"
                @error-retry="${this.loadNextPage}"
              >
              </agent-state-selector-list-error>`
                    }
                ];
            }
            return [];
        }
        getSelectedIdleCodeItem() {
            var _a, _b;
            const selectedItem = (_b = (_a = this.listElement) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('.default-wrapper[selected="true"]');
            return selectedItem;
        }
        focusListComponent() {
            var _a, _b;
            const selectedItem = this.getSelectedIdleCodeItem();
            if (selectedItem) {
                selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.focus();
            }
            else {
                const currentSelectedItem = (_b = (_a = this.listElement) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector(".md-advance-list-wrapper");
                currentSelectedItem === null || currentSelectedItem === void 0 ? void 0 : currentSelectedItem.focus();
            }
        }
        handleListKeyDown(event) {
            var _a, _b;
            if (event.key === "Tab" && !event.shiftKey) {
                const wrappers = Array.from(((_b = (_a = this.listElement) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelectorAll(".default-wrapper")) || []);
                const eventPath = event.composedPath();
                const fromListItem = wrappers.find((wrapper) => eventPath.includes(wrapper));
                if (fromListItem) {
                    event === null || event === void 0 ? void 0 : event.preventDefault();
                    // if on a list item focus on the input field
                    this.focusInputField();
                }
                else {
                    const selectedItem = this.getSelectedIdleCodeItem();
                    if (!selectedItem) {
                        event === null || event === void 0 ? void 0 : event.preventDefault();
                        this.focusInputField();
                    }
                }
            }
        }
        resetStates() {
            this.items = [];
            this.currentPage = 0;
            this.totalRecords = 0;
            this.pageFetchError = {
                isError: false,
                trackingId: ""
            };
        }
        renderState() {
            if (this.items.length === 0) {
                if (this.isPageLoading && (this.searchMode || !this.searchErrorForMinLength)) {
                    return (0,_utils__WEBPACK_IMPORTED_MODULE_9__.renderLoadingState)();
                }
                if (this.pageFetchError.isError) {
                    return (0,_utils__WEBPACK_IMPORTED_MODULE_9__.renderErrorState)((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:errorDetail:errorTitle"), (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:errorDetail:reloadButton"), this.onStateSelectorOpen);
                }
                if (this.searchErrorForMinLength) {
                    return (0,_utils__WEBPACK_IMPORTED_MODULE_9__.renderSearchError)((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.stateChange.searchError"));
                }
                if (this.searchMode) {
                    return (0,_utils__WEBPACK_IMPORTED_MODULE_9__.renderNoMatchFound)((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common:nomatchfound"));
                }
            }
            return lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing;
        }
        handleSearchCleared(event) {
            // Perform search without any search term
            this.resetStates();
            this.searchErrorForMinLength = false;
            this.searchMode = false;
            this.searchQuery = event.detail;
            this.loadNextPage(undefined, true);
        }
        handleSearchTooShort(event) {
            // Handle case when search term is less than 3 characters
            this.searchQuery = event.detail;
            this.resetStates();
            this.searchErrorForMinLength = true;
            this.searchMode = false;
        }
        handleSearchTermValid(event) {
            // Perform search with the valid search term
            this.resetStates();
            this.searchMode = true;
            this.searchErrorForMinLength = false;
            this.searchQuery = event.detail;
            this.loadNextPage(undefined, true);
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) ` <div class="tpw-agent-status">
        <search-input
          .isPageLoading=${this.isPageLoading}
          .isSearchPageLoading=${this.isSearchPageLoading}
          .reset=${this.isOpen}
          @input-keydown="${this.handleInputKeyDown}"
          @search-cleared="${this.handleSearchCleared}"
          @search-too-short="${this.handleSearchTooShort}"
          @search-term-valid="${this.handleSearchTermValid}"
        >
        </search-input>
        ${this.renderState()}
        ${this.isOpen
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
              <md-advance-list
                .items=${this.items.concat(this.getStatusIndicator())}
                .isLoading=${this.isPageLoading}
                .isError=${this.pageFetchError.isError}
                .value=${[this.getSelectedAgentIdleCodeId(this.items)]}
                containerHeight=${(0,_utils__WEBPACK_IMPORTED_MODULE_9__.getDynamicHeight)(this.items.length)}
                ariaRoleList="listbox"
                ariaLabelList="state selector"
                totalRecords=${this.totalRecords}
                @list-item-change=${this.handleListItemChange}
                @load-more=${this.loadNextPage}
                @keydown=${this.handleListKeyDown}
              >
              </md-advance-list>
            `
                : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
      </div>`;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ reflect: false, type: Boolean })
    ], Element.prototype, "isWxccCoreDisallowPendingLogoutStateChangeEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ reflect: true })
    ], Element.prototype, "agentId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ reflect: true })
    ], Element.prototype, "orgId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Object })
    ], Element.prototype, "selectedAgentDetails", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ reflect: true, type: Boolean })
    ], Element.prototype, "isOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "items", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "searchQuery", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "searchMode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "searchErrorForMinLength", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "currentPage", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "totalRecords", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isPageLoading", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isSearchPageLoading", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "pageFetchError", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.query)("md-advance-list")
    ], Element.prototype, "listElement", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.query)("search-input")
    ], Element.prototype, "searchHandler", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.customElement)("agentx-wc-tpw-agent-state-selector-infinite")
    ], Element);
    TPWAgentStateSelector.Element = Element;
})(TPWAgentStateSelector || (TPWAgentStateSelector = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/agentStateSelector/agentStateSelectorInfinite/listError.ts":
/*!********************************************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/agentStateSelector/agentStateSelectorInfinite/listError.ts ***!
  \********************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ChangeStateSelectorListError: () => (/* binding */ ChangeStateSelectorListError)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _scss_listError_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../scss/listError.scss */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/scss/listError.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var ChangeStateSelectorListError;
(function (ChangeStateSelectorListError) {
    /**
     * @element agent-state-selector-list
     * also used in  agentx-wc-teams-list-infinite for error handling
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this.trackingId = "";
        }
        static get styles() {
            return _scss_listError_scss__WEBPACK_IMPORTED_MODULE_2__["default"];
        }
        onRetry(event) {
            event.stopPropagation();
            this.dispatchEvent(new CustomEvent("error-retry", {
                detail: {},
                bubbles: true,
                composed: true
            }));
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div>
          <md-help-text messageType="error" class="infinite-scroll-error" style="{style}" aria-live="polite">
            <div class="error-block">
              <span>
                <span class="error-span-padding">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:commonWebComp.loadFail")}</span>
                <md-link
                  inline
                  class="infinite-scroll-retry-link"
                  aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:commonWebComp.tryAgain")}
                  @click="${this.onRetry}"
                  @keydown="${this.onRetry}"
                  tag="span"
                  data-testid="retry-page"
                >
                  ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:commonWebComp.tryAgain")}
                </md-link>
              </span>
              ${this.trackingId && this.trackingId !== ""
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<span class="tracking-error-block"
                    >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorModal.trackingIdLabel")} ${this.trackingId}</span
                  >`
                : null}
            </div>
          </md-help-text>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], Element.prototype, "trackingId", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agent-state-selector-list-error")
    ], Element);
    ChangeStateSelectorListError.Element = Element;
})(ChangeStateSelectorListError || (ChangeStateSelectorListError = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/agentStateSelector/index.ts":
/*!*************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/agentStateSelector/index.ts ***!
  \*************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AgentChangeStateSelector: () => (/* binding */ AgentChangeStateSelector)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/utils/WindowListenersHub */ "./src/utils/WindowListenersHub.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _list__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./list */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/list.ts");
/* harmony import */ var _scss_main_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./scss/main.scss */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/scss/main.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};










var AgentChangeStateSelector;
(function (AgentChangeStateSelector) {
    /**
     * @element agentx-wc-tpw-agent-state-selector
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_5__.LitElement) {
        constructor() {
            super(...arguments);
            this.isWxccCoreDisallowPendingLogoutStateChangeEnabled = false;
            this.agentId = "";
            this.orgId = "";
            this.isOpen = false;
            this.orgIdleCodes = { isFetchingSuccess: false, data: [] };
            this.searchTerm = "";
            this.isHighlightedItem = -1;
            this.selectedState = "";
            this.selectedIndex = 0;
            this.isLoading = false;
            this.isFetchError = false;
            this.list = [];
            this.filteredStateList = [];
            this.fetchOrganizationIdleCodes = () => __awaiter(this, void 0, void 0, function* () {
                try {
                    const response = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.abs.fetchIdleCodes({ orgId: this.orgId, accessType: "ALL" });
                    const events = new CustomEvent("update-org-idle-codes", {
                        detail: { isFetchingSuccess: true, response },
                        bubbles: true,
                        composed: true
                    });
                    _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_3__.WINDOW_LISTENERS_HUB.dispatch(events);
                    _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info(`event=fetchOrganizationIdleCodes | Successfully fetched organization idle codes on Team Performance Widget`);
                    return response;
                }
                catch (error) {
                    _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error("event=fetchOrganizationIdleCodes | Error on fetching organization idle codes on Team Performance Widget Agent State Change Module", error);
                    throw error;
                }
            });
            this.stateSelectorOpened = () => __awaiter(this, void 0, void 0, function* () {
                var _a;
                this.isLoading = true;
                try {
                    let idleCodes = [];
                    if (!this.orgIdleCodes.isFetchingSuccess) {
                        // Fetch the org idle codes in this component.
                        idleCodes = yield this.fetchOrganizationIdleCodes();
                    }
                    else {
                        idleCodes = (_a = this.orgIdleCodes.data) !== null && _a !== void 0 ? _a : [];
                    }
                    const { idleCodes: agentIdleCodes, accessIdleCode } = yield this.fetchAgentIdleCodes(this.orgId, this.agentId);
                    const defaultAvailableIdleCode = [
                        {
                            name: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.stateChange.available"),
                            id: _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE_ID,
                            isDefault: false,
                            isSystem: false
                        }
                    ];
                    let visibleStates = []; // Variable for update the idle code list from the API.
                    if (agentIdleCodes.length === 0 && accessIdleCode === _constants__WEBPACK_IMPORTED_MODULE_0__.ACCESS_IDLE_CODES.ALL) {
                        visibleStates.push(...idleCodes.filter((agentStateOption) => agentStateOption.isSystem === false));
                    }
                    else {
                        for (const code of agentIdleCodes) {
                            const agentIdleCode = idleCodes.find((agentStateOption) => agentStateOption.id === code);
                            if (agentIdleCode && agentIdleCode.isSystem === false) {
                                visibleStates.push(agentIdleCode);
                            }
                        }
                    }
                    if (visibleStates.length > 0) {
                        // sorting the list
                        visibleStates = visibleStates.sort((a, b) => a.name.localeCompare(b.name));
                    }
                    // Keep the "Available" state at the top of the list after the sorting API response.
                    const idleCodesList = [...defaultAvailableIdleCode, ...visibleStates];
                    this.list = idleCodesList;
                    this.filteredStateList = idleCodesList;
                    this.getSelectedAgentId(this.filteredStateList);
                    this.isFetchError = false;
                    setTimeout(() => {
                        this.focusInputField();
                    }, 0);
                }
                catch (_b) {
                    this.isFetchError = true;
                    setTimeout(() => {
                        this.focusRetryButton();
                    }, 0);
                }
                finally {
                    this.isLoading = false;
                }
            });
            this.focusInputField = () => {
                var _a, _b, _c;
                const inputElement = (_c = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-input")) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector("input");
                inputElement === null || inputElement === void 0 ? void 0 : inputElement.focus();
            };
            this.focusRetryButton = () => {
                var _a, _b, _c;
                const buttonElement = (_c = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById("reload-btn")) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector("button");
                buttonElement === null || buttonElement === void 0 ? void 0 : buttonElement.focus();
            };
            // The function is used to attach tab press event to the clear input button
            this.focusWhenClearInputButtonTabPress = () => {
                var _a, _b, _c, _d, _e, _f;
                const clearButton = (_c = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-input")) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector("md-button");
                const inputElement = (_f = (_e = (_d = this.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector("md-input")) === null || _e === void 0 ? void 0 : _e.shadowRoot) === null || _f === void 0 ? void 0 : _f.querySelector("input");
                const listItem = this.listElement.querySelector("md-list-item");
                // Determine the element that should receive focus
                const focusElement = listItem || inputElement;
                clearButton === null || clearButton === void 0 ? void 0 : clearButton.addEventListener("keydown", (event) => {
                    if (event.key === "Tab") {
                        setTimeout(() => {
                            focusElement === null || focusElement === void 0 ? void 0 : focusElement.focus();
                        }, 0);
                    }
                });
            };
            this.setFilteredStateList = () => {
                if (this.searchTerm === "") {
                    this.filteredStateList = this.list;
                    // No item should be highlighted when it shows all states
                    this.isHighlightedItem = -1;
                    this.getSelectedAgentId(this.filteredStateList);
                }
                else {
                    const filterStateList = this.list.filter((status) => status.name.toLowerCase().includes(this.searchTerm.toLowerCase()));
                    const isSelectedReasonPresent = filterStateList === null || filterStateList === void 0 ? void 0 : filterStateList.filter((status) => this.selectedState === status.name);
                    if ((isSelectedReasonPresent === null || isSelectedReasonPresent === void 0 ? void 0 : isSelectedReasonPresent.length) < 1) {
                        this.selectedIndex = -1;
                    }
                    this.filteredStateList = filterStateList;
                    // As soon as list is filtered, first item should be highlighted
                    this.isHighlightedItem = 0;
                }
            };
            this.handleSearch = (event) => {
                this.searchTerm = event.target.value;
                this.setFilteredStateList();
                // The function is used to attach tab press event to the clear input button when search is done
                setTimeout(() => {
                    this.focusWhenClearInputButtonTabPress();
                }, 0);
            };
            this.updateActionCellValue = (values) => {
                this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.UPDATE_ACTION_CELL_VALUE_EVENT, {
                    composed: true,
                    bubbles: true,
                    detail: Object.assign({}, values)
                }));
            };
            this.closeOverlay = () => {
                this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.STATE_CHANGE_OVERLAY_CLOSE_EVENT, {
                    composed: true,
                    bubbles: true
                }));
            };
            this.handleSelectValue = (event) => __awaiter(this, void 0, void 0, function* () {
                // agentStateChanging Flag is used to show the spinner on action cell component
                const agentId = this.agentId;
                this.updateActionCellValue({ agentStateChanging: true, agentId });
                this.closeOverlay();
                try {
                    const selectedValue = this.filteredStateList[event.detail.selected];
                    if (this.agentId) {
                        const payload = {
                            state: selectedValue.id === _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE_ID ? _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE : _constants__WEBPACK_IMPORTED_MODULE_0__.IDLE,
                            auxCodeId: selectedValue.id === _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE_ID ? " " : selectedValue.id,
                            lastStateChangeReason: "",
                            agentId: this.agentId
                        };
                        yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.aqm.supervisor.changeAgentState({ orgId: this.orgId, data: payload });
                        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.AGENT_STATE_CHANGE, {
                            ChangedBy: _constants__WEBPACK_IMPORTED_MODULE_0__.SUPERVISOR,
                            CurrentState: selectedValue.name,
                            Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS
                        });
                        this.updateActionCellValue({
                            agentId,
                            agentStateChanging: false,
                            agentStateChangeError: false
                        });
                    }
                }
                catch (error) {
                    _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error(`event=agentStateChangeFailed | Tracking ID: ${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.getTrackingIdFromErrorObject)(error) : ""} | Updating agent state from team performance widget is failed : ${error}`, error);
                    const [reason, reasonCode] = this.getReasonAndReasonCodeFromErrorObject(error);
                    let message = "";
                    if (this.isWxccCoreDisallowPendingLogoutStateChangeEnabled &&
                        reason === _constants__WEBPACK_IMPORTED_MODULE_0__.STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT_REASON &&
                        reasonCode === _constants__WEBPACK_IMPORTED_MODULE_0__.STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT_REASON_CODE) {
                        message = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("tpw.stateChange.errorStateChangeInPendingLogout");
                    }
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.AGENT_STATE_CHANGE, {
                        ChangedBy: _constants__WEBPACK_IMPORTED_MODULE_0__.SUPERVISOR,
                        Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED
                    });
                    this.updateActionCellValue({
                        agentId,
                        agentStateChanging: false,
                        agentStateChangeError: true
                    });
                    // Dispatch the event to show the error notification for agent state change failures.
                    const failedEvent = new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.AGENT_STATE_CHANGE_FAILED, {
                        detail: Object.assign(Object.assign({}, (this.isWxccCoreDisallowPendingLogoutStateChangeEnabled && { message: message || "" })), { trackingId: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.getTrackingIdFromErrorObject)(error) : null }),
                        bubbles: true,
                        composed: true
                    });
                    _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_3__.WINDOW_LISTENERS_HUB.dispatch(failedEvent);
                }
            });
            this.renderStatesList = () => {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <md-list
          class="menu-list state-selector-list"
          role="listbox"
          selected="${this.selectedIndex}"
          activated="${this.selectedIndex}"
          roving-prevent-focus="false"
          @list-item-change="${this.handleSelectValue}"
          @keydown="${this.handleListkeyDown}"
          label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.agentStateSelector")}
        >
          ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_7__.repeat)(this.filteredStateList, (agentStateOption, index) => (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
              <md-list-item
                slot="list-item"
                role="option"
                class="status-menu-item ${this.isHighlightedItem === index ? "state-item-highlight" : ""}"
                aria-label="${agentStateOption.name}"
                aria-selected="${this.selectedIndex === index}"
              >
                <agent-state-selector-list
                  .isOpen=${this.isOpen}
                  .agentStateOption=${agentStateOption}
                  .searchTerm="${this.searchTerm}"
                ></agent-state-selector-list>
              </md-list-item>
            `)}
        </md-list>
      `;
            };
            this.getReasonAndReasonCodeFromErrorObject = (errorObj) => {
                var _a, _b, _c, _d;
                const reason = ((_b = (_a = errorObj === null || errorObj === void 0 ? void 0 : errorObj.details) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.reason) || "";
                const reasonCode = ((_d = (_c = errorObj === null || errorObj === void 0 ? void 0 : errorObj.details) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.reasonCode) || "";
                return [reason, reasonCode];
            };
            this.handleListkeyDown = (event) => {
                event === null || event === void 0 ? void 0 : event.preventDefault();
                if ((event === null || event === void 0 ? void 0 : event.key) === "Tab") {
                    this.focusInputField();
                }
            };
            this.handleInputFocus = () => {
                if (this.listElement) {
                    this.listElement.setAttribute("roving-prevent-focus", "false");
                }
            };
            this.handleInputBlur = () => {
                if (this.listElement) {
                    this.listElement.removeAttribute("roving-prevent-focus");
                }
            };
            this.handleInputKeyDown = (event) => {
                if (event.detail.srcEvent) {
                    const { srcEvent } = event.detail;
                    if (srcEvent.key === "Tab" && srcEvent.shiftKey) {
                        event.detail.srcEvent.preventDefault();
                        // Focus to the md-list
                        const currentSelectedItem = this.listElement.querySelector("md-list-item[selected]");
                        if (currentSelectedItem) {
                            currentSelectedItem === null || currentSelectedItem === void 0 ? void 0 : currentSelectedItem.focus();
                        }
                    }
                }
            };
        }
        static get styles() {
            return _scss_main_scss__WEBPACK_IMPORTED_MODULE_9__["default"];
        }
        getSelectedAgentId(filteredStateList) {
            this.selectedIndex = filteredStateList.findIndex((stateOption) => { var _a; return stateOption.name === ((_a = this.selectedAgentDetails) === null || _a === void 0 ? void 0 : _a.agentState); });
            this.selectedIndex = this.selectedIndex === -1 ? 0 : this.selectedIndex;
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            if ((changedProperties.has("agentId") || changedProperties.has("isOpen")) && this.isOpen) {
                this.stateSelectorOpened();
            }
            if (changedProperties.has("isLoading")) {
                window.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.TPW_AGENT_STATE_SELECTOR_LOADING_CHANGED, {
                    detail: { isLoading: this.isLoading },
                    bubbles: true,
                    composed: true
                }));
            }
            if (changedProperties.has("isOpen") && this.isOpen === false) {
                this.searchTerm = "";
                this.filteredStateList = [];
                this.isHighlightedItem = -1;
                this.selectedState = "";
                this.selectedIndex = 0;
                this.list = [];
                this.isLoading = false;
            }
        }
        fetchAgentIdleCodes(orgId = "", agentId = "") {
            return __awaiter(this, void 0, void 0, function* () {
                const response = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.abs.fetchAgentIdleCodes({ orgId, agentId });
                return { idleCodes: response.idleCodes, accessIdleCode: response.accessIdleCode };
            });
        }
        connectedCallback() {
            var _a;
            super.connectedCallback();
            if (!((_a = this.orgIdleCodes) === null || _a === void 0 ? void 0 : _a.isFetchingSuccess)) {
                this.fetchOrganizationIdleCodes();
            }
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <div class="tpw-agent-status ${!this.isLoading ? "suppress-loading" : ""}">
          ${!this.isLoading && this.list.length > 0
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
                <div class="state-input-wrapper">
                  <md-input
                    id="pillSearchInput"
                    searchable
                    newMomentum
                    placeholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.search")}
                    clear
                    clearAriaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common:clear")}"
                    containerSize="medium-10"
                    htmlId="pillSearchInput"
                    name="pillSearchInput"
                    value="${this.searchTerm}"
                    type="text"
                    autoFocus
                    @input-change="${this.handleSearch}"
                    @input-focus="${this.handleInputFocus}"
                    @input-blur="${this.handleInputBlur}"
                    @input-keydown="${this.handleInputKeyDown}"
                  ></md-input>
                </div>
                ${this.renderStatesList()}
              `
                : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
          ${this.isLoading ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) ` <div class="state-loading"><md-spinner size="16"></md-spinner></div> ` : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
          ${!this.isLoading && (!this.filteredStateList || this.filteredStateList.length === 0) && this.list.length > 0
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
                <div class="state-no-match">
                  <agentx-wc-empty-state-wrapper
                    class="empty-state-wrapper"
                    illustration-type="empty-result"
                  ></agentx-wc-empty-state-wrapper>
                  <span class="empty-title">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common:nomatchfound")}</span>
                </div>
              `
                : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
          ${!this.isLoading && this.isFetchError
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
                <div class="state-error">
                  <agentx-wc-empty-state-wrapper
                    class="error-cloud-wrapper"
                    illustration-type="error-cloud"
                  ></agentx-wc-empty-state-wrapper>
                  <div class="error-container">
                    <p class="error-title">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:errorDetail:errorTitle")}</p>
                  </div>
                  <md-button @click=${() => this.stateSelectorOpened()} id="reload-btn" color="blue">
                    <span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:errorDetail:reloadButton")}</span>
                  </md-button>
                </div>
              `
                : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ reflect: false, type: Boolean })
    ], Element.prototype, "isWxccCoreDisallowPendingLogoutStateChangeEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ reflect: true })
    ], Element.prototype, "agentId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ reflect: true })
    ], Element.prototype, "orgId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Object })
    ], Element.prototype, "selectedAgentDetails", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ reflect: true, type: Boolean })
    ], Element.prototype, "isOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Object })
    ], Element.prototype, "orgIdleCodes", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "searchTerm", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isHighlightedItem", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "selectedState", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "selectedIndex", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isLoading", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isFetchError", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "list", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "filteredStateList", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.query)("md-list")
    ], Element.prototype, "listElement", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.customElement)("agentx-wc-tpw-agent-state-selector")
    ], Element);
    AgentChangeStateSelector.Element = Element;
})(AgentChangeStateSelector || (AgentChangeStateSelector = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/agentStateSelector/list.ts":
/*!************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/agentStateSelector/list.ts ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ChangeStateSelectorList: () => (/* binding */ ChangeStateSelectorList)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _scss_list_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./scss/list.scss */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/scss/list.scss");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./utils */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/utils/index.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var ChangeStateSelectorList;
(function (ChangeStateSelectorList) {
    /**
     * @element agent-state-selector-list
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.isOpen = false;
            this.agentStateOption = {
                name: "",
                isSystem: false,
                isDefault: false,
                id: "0"
            };
            this.searchTerm = "";
            this.isTextOverflow = true;
            this.HighlightText = (text = "", highlight = "") => {
                if (!highlight.trim()) {
                    return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` <span>${text}</span> `;
                }
                const regex = new RegExp(`(${(0,_utils__WEBPACK_IMPORTED_MODULE_4__.escapeRegExp)(highlight)})`, "gi");
                const parts = text.split(regex);
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <span class="highlight-span">
          ${parts
                    .filter((part) => part)
                    .map((part) => 
                // prettier-ignore
                regex.test(part)
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<b>${part}</b>`
                    : (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<span>${part}</span>`)}
        </span>
      `;
            };
            this.presenceIcon = (isAvailable) => {
                if (_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumAvatarEnabled) {
                    const iconName = isAvailable ? "active-presence-small-filled" : "recents-presence-badge-filled";
                    const iconClass = isAvailable ? "available-indicator new-momentum" : "default-indicator new-momentum";
                    return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<md-icon name="${iconName}" size="16" iconSet="momentumDesign" class=${iconClass}></md-icon>`;
                }
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `${(0,_utils__WEBPACK_IMPORTED_MODULE_4__.stateIndicator)(this.agentStateOption.id === _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE_ID ? _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE : this.agentStateOption.name)}`;
            };
        }
        static get styles() {
            return _scss_list_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            if (changedProperties.has("isOpen") && this.isOpen) {
                setTimeout(() => {
                    var _a;
                    const textContainer = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".agent-status-option-text");
                    let isTextOverflowing = true;
                    if (textContainer) {
                        isTextOverflowing = textContainer.offsetWidth < textContainer.scrollWidth;
                        if (isTextOverflowing) {
                            this.isTextOverflow = undefined;
                        }
                    }
                }, 100);
            }
        }
        render() {
            const text = this.agentStateOption.name === _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.stateChange.available") : this.agentStateOption.name;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <span class="agent-status-select-option-badge">
          <!-- Render the SVG Icon -->
          ${this.presenceIcon(this.agentStateOption.id === _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE_ID)}
        </span>
        <md-tooltip placement="top" message=${text} ?disabled=${this.isTextOverflow}>
          <div class="agent-status-option-text ellipsis-text">${this.HighlightText(text, this.searchTerm)}</div>
        </md-tooltip>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "agentStateOption", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "searchTerm", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "isTextOverflow", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agent-state-selector-list")
    ], Element);
    ChangeStateSelectorList.Element = Element;
})(ChangeStateSelectorList || (ChangeStateSelectorList = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/agentStateSelector/scss/list.scss":
/*!*******************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/agentStateSelector/scss/list.scss ***!
  \*******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host(agent-state-selector-list) {
  display: flex;
  gap: 0.5rem;
}

.agent-status-select-option-badge {
  display: inline-flex;
  align-items: center;
  align-self: center;
  justify-content: center;
  border-radius: 50%;
  height: 16px;
  width: 16px;
}

.agent-status-select-option-badge .available-indicator {
  background-color: var(--md-primary-one-bg-color, --md-primary-bg-color);
  color: var(--avatar-presence-active);
  border-radius: 50%;
  position: absolute;
}

.agent-status-select-option-badge .default-indicator {
  background-color: var(--md-primary-one-bg-color, --md-primary-bg-color);
  color: var(--avatar-presence-inactive);
  border-radius: 50%;
  position: absolute;
}

.agent-status-select-option-badge .default-indicator .new-momentum,
.agent-status-select-option-badge .available-indicator .new-momentum {
  background-color: transparent;
}

.status-indicator {
  box-sizing: border-box;
  color: var(--md-presence-away-bg-color);
  margin: 0;
}
.status-indicator.green-status {
  color: var(--md-green-60);
}
.status-indicator.yellow-status {
  color: var(--md-yellow-60);
}
.status-indicator.red-status {
  color: var(--md-presence-do-not-disturb-bg-color);
}

.agent-status-option-text {
  display: block;
  font-size: var(--font-size-medium);
  width: var(--full-menu-item-width);
}

.ellipsis-text {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.highlight-span {
  display: inline-table;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/agentStateSelector/scss/listError.scss":
/*!************************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/agentStateSelector/scss/listError.scss ***!
  \************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host(agent-state-selector-list-error) {
  display: flex;
}

.infinite-scroll-error {
  display: flex;
  padding-left: 15px;
  font-size: var(--font-size-small);
  color: var(--md-alert-error-text-color, --red-70-color);
  flex-direction: column;
}
.infinite-scroll-error .error-block {
  display: flex;
  flex-direction: column;
}
.infinite-scroll-error .error-block .error-span-padding {
  padding-right: 8px;
}
.infinite-scroll-error .error-block .tracking-error-block {
  display: inline-flex;
}
.infinite-scroll-error .error-block .infinite-scroll-retry-link::part(link) {
  font-size: var(--font-size-small);
  color: var(--md-alert-error-text-color, --red-70-color);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL1RlYW1QZXJmb3JtYW5jZVdpZGdldC9jb21wb25lbnRzL2FnZW50U3RhdGVTZWxlY3Rvci9zY3NzL2xpc3RFcnJvci5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBQTtBQUNGOztBQUNBO0VBQ0UsYUFBQTtFQUNBLGtCQUFBO0VBQ0EsaUNBQUE7RUFDQSx1REFBQTtFQUNBLHNCQUFBO0FBRUY7QUFERTtFQUNFLGFBQUE7RUFDQSxzQkFBQTtBQUdKO0FBRkk7RUFDRSxrQkFBQTtBQUlOO0FBRkk7RUFDRSxvQkFBQTtBQUlOO0FBRkk7RUFDRSxpQ0FBQTtFQUNBLHVEQUFBO0FBSU4iLCJzb3VyY2VzQ29udGVudCI6WyI6aG9zdChhZ2VudC1zdGF0ZS1zZWxlY3Rvci1saXN0LWVycm9yKSB7XG4gIGRpc3BsYXk6IGZsZXg7XG59XG4uaW5maW5pdGUtc2Nyb2xsLWVycm9yIHtcbiAgZGlzcGxheTogZmxleDtcbiAgcGFkZGluZy1sZWZ0OiAxNXB4O1xuICBmb250LXNpemU6IHZhcigtLWZvbnQtc2l6ZS1zbWFsbCk7XG4gIGNvbG9yOiB2YXIoLS1tZC1hbGVydC1lcnJvci10ZXh0LWNvbG9yLCAtLXJlZC03MC1jb2xvcik7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIC5lcnJvci1ibG9jayB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgIC5lcnJvci1zcGFuLXBhZGRpbmcge1xuICAgICAgcGFkZGluZy1yaWdodDogOHB4O1xuICAgIH1cbiAgICAudHJhY2tpbmctZXJyb3ItYmxvY2sge1xuICAgICAgZGlzcGxheTogaW5saW5lLWZsZXg7XG4gICAgfVxuICAgIC5pbmZpbml0ZS1zY3JvbGwtcmV0cnktbGluazo6cGFydChsaW5rKSB7XG4gICAgICBmb250LXNpemU6IHZhcigtLWZvbnQtc2l6ZS1zbWFsbCk7XG4gICAgICBjb2xvcjogdmFyKC0tbWQtYWxlcnQtZXJyb3ItdGV4dC1jb2xvciwgLS1yZWQtNzAtY29sb3IpO1xuICAgIH1cbiAgfVxufVxuIl0sInNvdXJjZVJvb3QiOiIifQ== */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/agentStateSelector/scss/main.scss":
/*!*******************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/agentStateSelector/scss/main.scss ***!
  \*******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`md-advance-list::part(spinner) {
  display: flex;
  justify-content: center;
}

.tpw-agent-status {
  --full-menu-item-width: calc(205px);
  --full-status-width: calc(260px);
  --full-half-width: calc(99px);
  --compact-status-width: calc(184px);
  --compact-menu-item-width: calc(150px);
  --compact-half-width: calc(61px);
  --state-input-height: calc(44px);
  --state-selector-height: calc(344px);
  --state-selector-min-height: calc(164px);
  --current-status-max-width: calc(1px);
  --agent-state-selector-padding: calc(8px);
  padding-top: 12px;
  padding-bottom: 8px;
  padding-left: 6px;
  padding-right: 6px;
}
.tpw-agent-status.suppress-loading {
  min-height: 150px;
}
.tpw-agent-status .menu-list {
  height: 100%;
  margin: 0;
  overflow-y: hidden;
  width: 98%;
}
.tpw-agent-status .status-menu-item {
  border: 0;
  border-radius: 0;
}
.tpw-agent-status .state-selector-list {
  align-content: flex-start;
  display: block;
  overflow: auto;
  overflow-x: hidden;
  max-height: 292px;
  padding-left: 2px;
  padding-right: 2px;
  padding-top: 2px;
}
.tpw-agent-status .state-selector-list md-list-item:last-child {
  padding-bottom: 0.125rem;
}
.tpw-agent-status .state-input-wrapper {
  height: var(--state-input-height);
  padding: 0px 2px;
}
.tpw-agent-status .state-input-wrapper md-input::part(md-input-container) {
  margin-bottom: 12px;
}
.tpw-agent-status .state-no-match {
  padding: 24px 24px;
  position: relative;
  top: 50%;
  text-align: center;
}
.tpw-agent-status .state-no-match .empty-title {
  font-size: var(--font-size-medium);
  margin: 0 calc(var(--space-token-even) * 8);
  margin-bottom: auto;
  color: var(--list-text-color, #121212);
}
.tpw-agent-status .state-no-match .empty-state-wrapper::part(container) {
  background-color: var(--md-secondary-white-bg-color);
}
.tpw-agent-status .state-no-match .empty-state-wrapper::part(img) {
  display: block;
  margin: auto;
  width: auto;
}
.tpw-agent-status .state-no-results {
  padding: 50px 0 40px 0;
  position: relative;
  top: 50%;
  text-align: center;
}
.tpw-agent-status .state-no-results span {
  font-size: var(--font-size-medium);
  margin: 0 calc(var(--space-token-even) * 8);
  margin-bottom: auto;
}
.tpw-agent-status .state-no-results .empty-state-wrapper::part(container) {
  background-color: var(--md-secondary-white-bg-color);
}
.tpw-agent-status .state-no-results .empty-state-wrapper::part(img) {
  display: block;
  margin: auto;
  width: auto;
}
.tpw-agent-status .search-block-error {
  display: flex;
  align-items: center;
  padding: 16px;
  min-height: 200px;
}
.tpw-agent-status .search-error {
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;
  font-size: var(--font-size-small);
}
.tpw-agent-status .state-item-highlight {
  background-color: var(--md-alert-info-bg-color, --md-alert-info-bg-color-default);
}
.tpw-agent-status .state-loading {
  height: 100px;
  min-height: 100px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tpw-agent-status .state-error {
  padding: 30px 0 16px 0;
  display: grid;
}
.tpw-agent-status .state-error .error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.tpw-agent-status .state-error .error-title {
  font-size: var(--font-size-medium);
  margin: 0 calc(var(--space-token-even) * 8);
  margin-bottom: auto;
  font-weight: 600;
  text-align: center;
  padding: 0;
  color: var(--list-text-color, #121212);
}
.tpw-agent-status .state-error .error-subtitle {
  font-size: var(--font-size-medium);
  margin: 0 calc(var(--space-token-even) * 8);
  margin-bottom: auto;
  text-align: center;
  padding: 0;
}
.tpw-agent-status .state-error .error-cloud-wrapper {
  height: auto;
}
.tpw-agent-status .state-error .error-cloud-wrapper::part(container) {
  background-color: var(--md-secondary-white-bg-color);
}
.tpw-agent-status .state-error .error-cloud-wrapper::part(img) {
  display: block;
  margin: auto;
  width: auto;
}
.tpw-agent-status .state-error md-button {
  margin: 24px auto auto auto;
}
@media (max-width: 736px) {
  .tpw-agent-status .agent-status .ax-current-status-label.half-width,
  .tpw-agent-status .agent-status .cumulativeStateTimer.ellipsis-timer {
    width: var(--compact-half-width);
  }
  .tpw-agent-status .state-menu-overlay::part(overlay-content) {
    width: var(--compact-status-width);
  }
  .tpw-agent-status .agent-state-button::part(button) {
    width: var(--compact-status-width);
  }
  .tpw-agent-status .agent-status-option-text {
    width: var(--compact-menu-item-width);
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/agentStateSelector/utils/index.ts":
/*!*******************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/agentStateSelector/utils/index.ts ***!
  \*******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   checkIfSearchMatchesAvailable: () => (/* binding */ checkIfSearchMatchesAvailable),
/* harmony export */   escapeRegExp: () => (/* binding */ escapeRegExp),
/* harmony export */   fetchItems: () => (/* binding */ fetchItems),
/* harmony export */   getDefaultAvailableIdleCode: () => (/* binding */ getDefaultAvailableIdleCode),
/* harmony export */   getDynamicHeight: () => (/* binding */ getDynamicHeight),
/* harmony export */   renderErrorState: () => (/* binding */ renderErrorState),
/* harmony export */   renderLoadingState: () => (/* binding */ renderLoadingState),
/* harmony export */   renderNoMatchFound: () => (/* binding */ renderNoMatchFound),
/* harmony export */   renderSearchError: () => (/* binding */ renderSearchError),
/* harmony export */   stateIndicator: () => (/* binding */ stateIndicator)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};




const reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
const reHasRegExpChar = RegExp(reRegExpChar.source);
const PAGE_SIZE = 100;
const escapeRegExp = (string) => {
    return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string || "";
};
const stateIndicator = (state) => {
    /* eslint-disable max-len */
    const getIndicator = () => {
        if (state === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.AgentState.Available) {
            return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
        <svg
          class="available-indicator"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          //sonar.issue.ignore.block.start
          <path
            d="M13.5 6.75C13.5 10.4779 10.4779 13.5 6.75 13.5C3.02208 13.5 0 10.4779 0 6.75C0 3.02208 3.02208 0 6.75 0C10.4779 0 13.5 3.02208 13.5 6.75ZM10.1084 3.65616L5.49972 8.26486L3.37523 6.14037C2.92891 5.69405 2.2053 5.69405 1.75898 6.14037C1.31267 6.58668 1.31267 7.3103 1.75898 7.75661L4.18335 10.181C4.19466 10.1923 4.20615 10.2033 4.21781 10.214L4.69229 10.6885C5.1386 11.1348 5.86222 11.1348 6.30854 10.6885L11.7247 5.27241C12.171 4.82609 12.171 4.10248 11.7247 3.65616C11.2783 3.20985 10.5547 3.20985 10.1084 3.65616Z"
            fill="currentColor"
          />
          //sonar.issue.ignore.block.end
        </svg>
      `;
        }
        else {
            return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
        <svg
          class="default-indicator"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          //sonar.issue.ignore.block.start
          <path
            d="M6.75 13.5C10.4779 13.5 13.5 10.4779 13.5 6.75C13.5 3.02208 10.4779 0 6.75 0C3.02208 0 0 3.02208 0 6.75C0 10.4779 3.02208 13.5 6.75 13.5ZM2.8125 5.625H10.6875C11.3088 5.625 11.8125 6.12868 11.8125 6.75C11.8125 7.37132 11.3088 7.875 10.6875 7.875H2.8125C2.19118 7.875 1.6875 7.37132 1.6875 6.75C1.6875 6.12868 2.19118 5.625 2.8125 5.625Z"
            fill="currentColor"
          />
          //sonar.issue.ignore.block.end
        </svg>
      `;
        }
    };
    return state ? getIndicator() : null;
};
const getDefaultAvailableIdleCode = (localizedName) => ({
    name: localizedName,
    id: "0",
    isDefault: false,
    isSystem: false
});
const getDynamicHeight = (itemsLength) => {
    const minHeight = Math.max(itemsLength * 40, 10);
    return `${Math.min(minHeight, 292)}px`;
};
const checkIfSearchMatchesAvailable = (searchQuery) => {
    if (searchQuery) {
        return _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE.toLocaleLowerCase().includes(searchQuery.toLocaleLowerCase());
    }
    return false;
};
const fetchItems = (orgId, agentId, page, searchTerm = "") => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const params = {
            orgId,
            page,
            search: searchTerm,
            pageSize: PAGE_SIZE,
            supervisedUserId: agentId,
            customFilter: "isSystemCode==false"
        };
        const response = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.abs.fetchPaginatedIdleCodes(params);
        return response;
    }
    catch (error) {
        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("event=fetchItems | Error on fetching idle codes on Team Performance Widget Agent State Change Module", error);
        throw error;
    }
});
const renderSearchError = (searchErrorMsg) => {
    return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
    <div class="search-block-error">
      <div class="search-error">
        <md-icon name="info-badge-filled" iconSet="momentumDesign" size="16" class="search-error-info"></md-icon>
        ${searchErrorMsg}
      </div>
    </div>
  `;
};
const renderNoMatchFound = (message) => {
    return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
    <div class="state-no-match">
      <agentx-wc-empty-state-wrapper
        class="empty-state-wrapper"
        illustration-type="empty-result"
      ></agentx-wc-empty-state-wrapper>
      <span class="empty-title">${message}</span>
    </div>
  `;
};
const renderLoadingState = () => {
    return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
    <div class="state-loading">
      <md-spinner size="18"></md-spinner>
    </div>
  `;
};
const renderErrorState = (message, retryButtonLabel, retryCB) => {
    return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
    <div class="state-error">
      <agentx-wc-empty-state-wrapper
        class="error-cloud-wrapper"
        illustration-type="error-cloud"
      ></agentx-wc-empty-state-wrapper>
      <div class="error-container">
        <p class="error-title">${message}</p>
      </div>
      <md-button @click=${() => retryCB()} id="reload-btn" color="blue">
        <span slot="text">${retryButtonLabel}</span>
      </md-button>
    </div>
  `;
};


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/skillProfile/SkillChangeSummaryView.scss":
/*!**************************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/skillProfile/SkillChangeSummaryView.scss ***!
  \**************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.skill-change-summary-view {
  display: block;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL1RlYW1QZXJmb3JtYW5jZVdpZGdldC9jb21wb25lbnRzL3NraWxsUHJvZmlsZS9Ta2lsbENoYW5nZVN1bW1hcnlWaWV3LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxjQUFBO0FBQ0YiLCJzb3VyY2VzQ29udGVudCI6WyIuc2tpbGwtY2hhbmdlLXN1bW1hcnktdmlldyB7XG4gIGRpc3BsYXk6IGJsb2NrO1xufVxuIl0sInNvdXJjZVJvb3QiOiIifQ== */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/skillProfile/SkillChangeSummaryView.ts":
/*!************************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/skillProfile/SkillChangeSummaryView.ts ***!
  \************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SkillChangeSummaryView: () => (/* binding */ SkillChangeSummaryView)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _SkillChangeSummaryView_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./SkillChangeSummaryView.scss */ "./src/components/TeamPerformanceWidget/components/skillProfile/SkillChangeSummaryView.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let SkillChangeSummaryView = class SkillChangeSummaryView extends lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement {
    static get styles() {
        return _SkillChangeSummaryView_scss__WEBPACK_IMPORTED_MODULE_1__["default"];
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) ` <div class="skill-change-summary-view"></div> `;
    }
};
SkillChangeSummaryView = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("skill-change-summary-view")
], SkillChangeSummaryView);



/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/skillProfile/SkillProfileDialog.scss":
/*!**********************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/skillProfile/SkillProfileDialog.scss ***!
  \**********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.name-renderer-container {
  margin-bottom: 8px;
}

.placeholder-view {
  flex: 1;
  margin-bottom: 8px;
  border: 1px dashed #ccc;
}

.button-wrapper {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.header-width {
  width: 100%;
}

.state-loading {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL1RlYW1QZXJmb3JtYW5jZVdpZGdldC9jb21wb25lbnRzL3NraWxsUHJvZmlsZS9Ta2lsbFByb2ZpbGVEaWFsb2cuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGtCQUFBO0FBQ0Y7O0FBRUE7RUFDRSxPQUFBO0VBQ0Esa0JBQUE7RUFDQSx1QkFBQTtBQUNGOztBQUVBO0VBQ0UsYUFBQTtFQUNBLHlCQUFBO0VBQ0EsUUFBQTtBQUNGOztBQUVBO0VBQ0UsV0FBQTtBQUNGOztBQUVBO0VBQ0UsWUFBQTtFQUNBLGFBQUE7RUFDQSxtQkFBQTtFQUNBLHVCQUFBO0FBQ0YiLCJzb3VyY2VzQ29udGVudCI6WyIubmFtZS1yZW5kZXJlci1jb250YWluZXIge1xuICBtYXJnaW4tYm90dG9tOiA4cHg7XG59XG5cbi5wbGFjZWhvbGRlci12aWV3IHtcbiAgZmxleDogMTtcbiAgbWFyZ2luLWJvdHRvbTogOHB4O1xuICBib3JkZXI6IDFweCBkYXNoZWQgI2NjYztcbn1cblxuLmJ1dHRvbi13cmFwcGVyIHtcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBmbGV4LWVuZDtcbiAgZ2FwOiA4cHg7XG59XG5cbi5oZWFkZXItd2lkdGgge1xuICB3aWR0aDogMTAwJTtcbn1cblxuLnN0YXRlLWxvYWRpbmcge1xuICBoZWlnaHQ6IDEwMCU7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xufVxuIl0sInNvdXJjZVJvb3QiOiIifQ== */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/skillProfile/SkillProfileDialog.ts":
/*!********************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/skillProfile/SkillProfileDialog.ts ***!
  \********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ActiveSkillView: () => (/* binding */ ActiveSkillView),
/* harmony export */   SkillProfileDialog: () => (/* binding */ SkillProfileDialog)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Common_CellRenderers_components_TableAgentNameElement__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../Common/CellRenderers/components/TableAgentNameElement */ "./src/components/Common/CellRenderers/components/TableAgentNameElement.ts");
/* harmony import */ var _SkillChangeSummaryView__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./SkillChangeSummaryView */ "./src/components/TeamPerformanceWidget/components/skillProfile/SkillChangeSummaryView.ts");
/* harmony import */ var _SkillProfileDialog_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./SkillProfileDialog.scss */ "./src/components/TeamPerformanceWidget/components/skillProfile/SkillProfileDialog.scss");
/* harmony import */ var _SkillSelectorView__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./SkillSelectorView */ "./src/components/TeamPerformanceWidget/components/skillProfile/SkillSelectorView.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};









var ActiveSkillView;
(function (ActiveSkillView) {
    ActiveSkillView["SKILL_SELECTOR_VIEW"] = "SKILL_SELECTOR_VIEW";
    ActiveSkillView["SKILL_CHANGE_SUMMARY_VIEW"] = "SKILL_CHANGE_SUMMARY_VIEW";
})(ActiveSkillView || (ActiveSkillView = {}));
let SkillProfileDialog = class SkillProfileDialog extends lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement {
    constructor() {
        super(...arguments);
        this.isOpen = false;
        this.agentName = "";
        this.agentEmail = "";
        this.orgId = "";
        this.activeView = ActiveSkillView.SKILL_SELECTOR_VIEW;
        this.isLoading = false;
        this.isError = false;
        this.skillProfiles = [];
        this.onSkillProfileSelectionChanged = (e) => {
            const { skillProfileId } = e.detail;
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[SkillProfileDialog] Skill profile selected: ${skillProfileId}`);
            //TODO: handle this, e.g. refresh the table of skills below
        };
    }
    static get styles() {
        return _SkillProfileDialog_scss__WEBPACK_IMPORTED_MODULE_7__["default"];
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.clearState();
        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[SkillProfileDialog] component removed from view");
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has("isOpen") && this.isOpen) {
            this.fetchInitialState();
        }
    }
    clearState() {
        this.isError = false;
        this.isLoading = false;
        this.skillProfiles = [];
    }
    fetchInitialState() {
        return __awaiter(this, void 0, void 0, function* () {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[SkillProfileDialog] fetchInitialState for ${this.agentName} in organization ${this.orgId}`);
            this.isLoading = true;
            yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.cms
                .fetchSkillProfiles({
                orgId: this.orgId
            })
                .then((response) => {
                this.isLoading = false;
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[SkillProfileDialog] ${response.length} skill profiles fetched successfully.`);
                this.skillProfiles = response;
            })
                .catch((error) => {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`[SkillProfileDialog] Error fetching skill profiles: ${error.message}`);
                this.isLoading = false;
                this.isError = true;
            });
        });
    }
    closeDialog() {
        this.isOpen = false;
        this.clearState();
        this.dispatchEvent(new CustomEvent("dialog-closed", { bubbles: true, composed: true }));
    }
    renderSkillSelectorFooter() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      <div slot="footer" class="button-wrapper">
        <md-button variant="secondary" @click="${this.onCancel}" ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("common.cancelButton")}">
          ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("common.cancelButton")}
        </md-button>
        <md-button
          variant="primary"
          @click="${this.onReviewChanges}"
          ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("tpw.skillProfile.reviewChanges")}"
          ?disabled="${this.isLoading || this.isError}"
        >
          ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("tpw.skillProfile.reviewChanges")}
        </md-button>
      </div>
    `;
    }
    renderSkillChangeSummaryFooter() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      <div slot="footer" class="button-wrapper">
        <md-button variant="secondary" @click="${this.onBack}" ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("common.backButton")}">
          ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("common.backButton")}
        </md-button>
        <md-button
          variant="primary"
          @click="${this.onConfirmChanges}"
          ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("tpw.skillProfile.confirmChanges")}"
          ?disabled="${this.isLoading || this.isError}"
        >
          ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("tpw.skillProfile.confirmChanges")}
        </md-button>
      </div>
    `;
    }
    renderFooter() {
        switch (this.activeView) {
            case ActiveSkillView.SKILL_SELECTOR_VIEW:
                return this.renderSkillSelectorFooter();
            case ActiveSkillView.SKILL_CHANGE_SUMMARY_VIEW:
                return this.renderSkillChangeSummaryFooter();
            default:
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) ``;
        }
    }
    renderSkillSelectorBody() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      <skill-selector-view
        .skillProfiles="${this.skillProfiles}"
        @on-selected-skill-profile-changed="${this.onSkillProfileSelectionChanged}"
      ></skill-selector-view>
    `;
    }
    renderSkillChangeSummaryBody() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) ` <skill-change-summary-view></skill-change-summary-view> `;
    }
    renderBody() {
        if (this.isLoading) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div class="state-loading">
          <md-spinner size="32"></md-spinner>
        </div>
      `;
        }
        else if (this.isError) {
            return lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing; // todo: add error state
        }
        else if (this.skillProfiles.length === 0) {
            return lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing; // todo: add empty state
        }
        switch (this.activeView) {
            case ActiveSkillView.SKILL_SELECTOR_VIEW:
                return this.renderSkillSelectorBody();
            case ActiveSkillView.SKILL_CHANGE_SUMMARY_VIEW:
                return this.renderSkillChangeSummaryBody();
            default:
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) ``;
        }
    }
    onCancel() {
        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("onCancel");
        this.closeDialog();
    }
    onReviewChanges() {
        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("onReviewChanges");
        this.activeView = ActiveSkillView.SKILL_CHANGE_SUMMARY_VIEW;
    }
    onBack() {
        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("onBack");
        this.activeView = ActiveSkillView.SKILL_SELECTOR_VIEW;
    }
    onConfirmChanges() {
        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("onConfirmChanges");
    }
    render() {
        if (!this.isOpen) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) ``;
        }
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      <md-modal
        class="dialog"
        applicationId="skillProfile"
        ?show=${this.isOpen}
        id="skillProfileModal"
        size="small"
        .hideFooter=${true}
        headerLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("tpw.skillProfile.default")}
        ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("tpw.skillProfile.default")}
        tabindex="${"-1"}"
        ?showclosebutton=${true}
        .ariaLabelClose=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("common.close")}
        @close-modal="${this.closeDialog}"
      >
        <div class="modal-body">
          <div class="name-renderer-container">
            <agentx-wc-table-agent-name .name=${this.agentName} .email=${this.agentEmail}></agentx-wc-table-agent-name>
          </div>
          ${this.renderBody()}
        </div>
        ${this.renderFooter()}
      </md-modal>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
], SkillProfileDialog.prototype, "isOpen", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
], SkillProfileDialog.prototype, "agentName", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
], SkillProfileDialog.prototype, "agentEmail", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
], SkillProfileDialog.prototype, "orgId", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
], SkillProfileDialog.prototype, "activeView", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], SkillProfileDialog.prototype, "isLoading", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], SkillProfileDialog.prototype, "isError", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], SkillProfileDialog.prototype, "skillProfiles", void 0);
SkillProfileDialog = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("skill-profile-dialog")
], SkillProfileDialog);



/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/skillProfile/SkillSelectorView.scss":
/*!*********************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/skillProfile/SkillSelectorView.scss ***!
  \*********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.skill-selector-view {
  display: flex;
  flex-direction: column;
  padding: 0 8px;
}

.select-profile-label {
  padding: 12px 0 4px 0;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL1RlYW1QZXJmb3JtYW5jZVdpZGdldC9jb21wb25lbnRzL3NraWxsUHJvZmlsZS9Ta2lsbFNlbGVjdG9yVmlldy5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBQTtFQUNBLHNCQUFBO0VBQ0EsY0FBQTtBQUNGOztBQUVBO0VBQ0UscUJBQUE7QUFDRiIsInNvdXJjZXNDb250ZW50IjpbIi5za2lsbC1zZWxlY3Rvci12aWV3IHtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgcGFkZGluZzogMCA4cHg7XG59XG5cbi5zZWxlY3QtcHJvZmlsZS1sYWJlbCB7XG4gIHBhZGRpbmc6IDEycHggMCA0cHggMDtcbn1cbiJdLCJzb3VyY2VSb290IjoiIn0= */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/skillProfile/SkillSelectorView.ts":
/*!*******************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/skillProfile/SkillSelectorView.ts ***!
  \*******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SkillSelectorView: () => (/* binding */ SkillSelectorView)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _SkillSelectorView_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./SkillSelectorView.scss */ "./src/components/TeamPerformanceWidget/components/skillProfile/SkillSelectorView.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






/**
@fires on-selected-skill-profile-changed
  **/
let SkillSelectorView = class SkillSelectorView extends lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement {
    constructor() {
        super(...arguments);
        this.skillProfiles = [];
        this.selectedSkillProfileId = "";
    }
    static get styles() {
        return _SkillSelectorView_scss__WEBPACK_IMPORTED_MODULE_5__["default"];
    }
    evt(name, detail) {
        this.dispatchEvent(new CustomEvent(name, { bubbles: true, composed: true, detail }));
        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[SkillSelectorView]: Dispatching event", name, detail);
    }
    handleSelectedSkillProfileChanged(e) {
        const newSelection = e.detail.option;
        this.evt("on-selected-skill-profile-changed", {
            skillProfileId: newSelection.id
        });
    }
    renderSkillSelector() {
        if (this.skillProfiles && this.skillProfiles.length > 0) {
            const defaultOption = this.skillProfiles.find((skillProfile) => skillProfile.id === this.selectedSkillProfileId);
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <label class="select-profile-label">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("tpw.skillProfile.selectProfileTitle")}</label>
        <md-dropdown
          class="skills-profile-dropdown"
          .title=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("tpw.skillProfile.selectProfilePlaceholder")}
          .options="${this.skillProfiles}"
          .defaultOption=${defaultOption || {}}
          option-id="id"
          option-value="name"
          ?newMomentum=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isMomentumV2Enabled}
          ?pill=${!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isMomentumV2Enabled}
          .visibleOptions=${3}
          custom-tab-index=${-1}
          @dropdown-selected=${this.handleSelectedSkillProfileChanged}
        >
        </md-dropdown>
      `;
        }
        else {
            return lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing;
        }
    }
    handleInitialFocus() {
        setTimeout(() => {
            var _a, _b, _c;
            (_c = (_b = (_a = this.skillsProfileDropDown) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("label")) === null || _c === void 0 ? void 0 : _c.focus();
        }, 1);
    }
    firstUpdated() {
        this.handleInitialFocus();
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `<div class="skill-selector-view">${this.renderSkillSelector()}</div>`;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Array })
], SkillSelectorView.prototype, "skillProfiles", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
], SkillSelectorView.prototype, "selectedSkillProfileId", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.query)(".skills-profile-dropdown")
], SkillSelectorView.prototype, "skillsProfileDropDown", void 0);
SkillSelectorView = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("skill-selector-view")
], SkillSelectorView);



/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/style.scss":
/*!********************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/style.scss ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.applied-filters-wrapper {
  padding: 0 1rem 1rem;
}

.applied-filters__label {
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  color: var(--md-primary-text-color);
}

.applied-group-wrapper {
  padding: 0 1rem 1rem;
}

.applied-group__label {
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  color: var(--md-primary-text-color);
}

.applied-group__clear-all {
  text-decoration: underline;
  margin-left: 9px;
}

.applied-filters-chips::part(chip) {
  background-color: var(--md-button-secondary-bg-color);
  border: 2px solid var(--md-button-secondary-hover-bg-color);
  padding: 8px 12px;
  border-radius: 20px;
  margin: 4px 0.5px;
  height: fit-content;
  width: fit-content;
  max-width: unset;
}

.applied-groups-chips::part(chip) {
  background-color: var(--md-button-secondary-bg-color);
  border: 2px solid var(--md-button-secondary-hover-bg-color);
  padding: 8px 12px;
  border-radius: 20px;
  margin: 0px 3px;
  height: fit-content;
  width: fit-content;
}

.applied-filters-action-btn {
  text-decoration: underline;
  display: inline-grid;
}

.applied-filters-expandCollapse-btn {
  margin: 0rem 1rem;
}

.applied-filters-separator {
  margin: 0 0.5rem;
  color: var(--md-primary-seperator-color);
}

.chip-cross-icon {
  margin-left: 0.5rem !important;
}

.tpw-empty-grid::part(img) {
  width: 25rem !important;
}

.agent-state-dot {
  height: 12px;
  width: 12px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 10px;
}

.agent-available-dot {
  background-color: var(--md-presence-active-bg-color);
}

.agent-idle-dot {
  background-color: var(--md-presence-away-bg-color);
}

.agent-state-active::part(chip) {
  background-color: var(--button-available-bg-color, #edfaf4) !important;
}

.agent-state-idle::part(chip) {
  background-color: var(--button-idle-bg-color, #f7f7f7) !important;
}

.agentx-wc-tpw-empty-grid {
  height: 100%;
}
.agentx-wc-tpw-empty-grid agentx-wc-empty-state-wrapper::part(img) {
  width: 85px;
}

.empty-grid-message {
  margin-top: 15px;
  text-align: center;
  margin-bottom: 0;
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  color: var(--md-primary-text-color);
}

.empty-grid-message-container {
  display: block;
}

.empty-grid-sub-message {
  text-align: center;
  font-weight: bold;
  margin-bottom: 0;
  margin-top: 10px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8uL3NyYy9jb21wb25lbnRzL1RlYW1QZXJmb3JtYW5jZVdpZGdldC9jb21wb25lbnRzL3N0eWxlLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUE7RUFDRSxvQkFBQTtBQURGOztBQUdBO0VBQ0UsZ0JBQUE7RUFDQSxlQUFBO0VBQ0EsaUJBQUE7RUFDQSxtQ0FBQTtBQUFGOztBQUdBO0VBQ0Usb0JBQUE7QUFBRjs7QUFFQTtFQUNFLGdCQUFBO0VBQ0EsZUFBQTtFQUNBLGlCQUFBO0VBQ0EsbUNBQUE7QUFDRjs7QUFFQTtFQUNFLDBCQUFBO0VBQ0EsZ0JBQUE7QUFDRjs7QUFFQTtFQUNFLHFEQUFBO0VBQ0EsMkRBQUE7RUFDQSxpQkFBQTtFQUNBLG1CQUFBO0VBQ0EsaUJBQUE7RUFDQSxtQkFBQTtFQUNBLGtCQUFBO0VBQ0EsZ0JBQUE7QUFDRjs7QUFFQTtFQUNFLHFEQUFBO0VBQ0EsMkRBQUE7RUFDQSxpQkFBQTtFQUNBLG1CQUFBO0VBQ0EsZUFBQTtFQUNBLG1CQUFBO0VBQ0Esa0JBQUE7QUFDRjs7QUFFQTtFQUNFLDBCQUFBO0VBQ0Esb0JBQUE7QUFDRjs7QUFFQTtFQUNFLGlCQUFBO0FBQ0Y7O0FBRUE7RUFDRSxnQkFBQTtFQUNBLHdDQUFBO0FBQ0Y7O0FBRUE7RUFDRSw4QkFBQTtBQUNGOztBQUlBO0VBQ0UsdUJBQUE7QUFERjs7QUFNQTtFQUNFLFlBQUE7RUFDQSxXQUFBO0VBQ0Esa0JBQUE7RUFDQSxxQkFBQTtFQUNBLGtCQUFBO0FBSEY7O0FBTUE7RUFDRSxvREFBQTtBQUhGOztBQU1BO0VBQ0Usa0RBQUE7QUFIRjs7QUFNQTtFQUNFLHNFQUFBO0FBSEY7O0FBTUE7RUFDRSxpRUFBQTtBQUhGOztBQU1BO0VBQ0UsWUFBQTtBQUhGO0FBS0k7RUFDRSxXQUFBO0FBSE47O0FBUUE7RUFDRSxnQkFBQTtFQUNBLGtCQUFBO0VBQ0EsZ0JBQUE7RUFDQSxnQkFBQTtFQUNBLGVBQUE7RUFDQSxpQkFBQTtFQUNBLG1DQUFBO0FBTEY7O0FBT0E7RUFDRSxjQUFBO0FBSkY7O0FBTUE7RUFDRSxrQkFBQTtFQUNBLGlCQUFBO0VBQ0EsZ0JBQUE7RUFDQSxnQkFBQTtBQUhGIiwic291cmNlc0NvbnRlbnQiOlsiLy9hZ2VudHgtd2MtdHB3LWFwcGxpZWQtZmlsdGVyc1xuXG4uYXBwbGllZC1maWx0ZXJzLXdyYXBwZXIge1xuICBwYWRkaW5nOiAwIDFyZW0gMXJlbTtcbn1cbi5hcHBsaWVkLWZpbHRlcnNfX2xhYmVsIHtcbiAgZm9udC13ZWlnaHQ6IDQwMDtcbiAgZm9udC1zaXplOiAxNHB4O1xuICBsaW5lLWhlaWdodDogMTAwJTtcbiAgY29sb3I6IHZhcigtLW1kLXByaW1hcnktdGV4dC1jb2xvcik7XG59XG5cbi5hcHBsaWVkLWdyb3VwLXdyYXBwZXIge1xuICBwYWRkaW5nOiAwIDFyZW0gMXJlbTtcbn1cbi5hcHBsaWVkLWdyb3VwX19sYWJlbCB7XG4gIGZvbnQtd2VpZ2h0OiA0MDA7XG4gIGZvbnQtc2l6ZTogMTRweDtcbiAgbGluZS1oZWlnaHQ6IDEwMCU7XG4gIGNvbG9yOiB2YXIoLS1tZC1wcmltYXJ5LXRleHQtY29sb3IpO1xufVxuXG4uYXBwbGllZC1ncm91cF9fY2xlYXItYWxsIHtcbiAgdGV4dC1kZWNvcmF0aW9uOiB1bmRlcmxpbmU7XG4gIG1hcmdpbi1sZWZ0OiA5cHg7XG59XG5cbi5hcHBsaWVkLWZpbHRlcnMtY2hpcHM6OnBhcnQoY2hpcCkge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1tZC1idXR0b24tc2Vjb25kYXJ5LWJnLWNvbG9yKTtcbiAgYm9yZGVyOiAycHggc29saWQgdmFyKC0tbWQtYnV0dG9uLXNlY29uZGFyeS1ob3Zlci1iZy1jb2xvcik7XG4gIHBhZGRpbmc6IDhweCAxMnB4O1xuICBib3JkZXItcmFkaXVzOiAyMHB4O1xuICBtYXJnaW46IDRweCAwLjVweDtcbiAgaGVpZ2h0OiBmaXQtY29udGVudDtcbiAgd2lkdGg6IGZpdC1jb250ZW50O1xuICBtYXgtd2lkdGg6IHVuc2V0O1xufVxuXG4uYXBwbGllZC1ncm91cHMtY2hpcHM6OnBhcnQoY2hpcCkge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1tZC1idXR0b24tc2Vjb25kYXJ5LWJnLWNvbG9yKTtcbiAgYm9yZGVyOiAycHggc29saWQgdmFyKC0tbWQtYnV0dG9uLXNlY29uZGFyeS1ob3Zlci1iZy1jb2xvcik7XG4gIHBhZGRpbmc6IDhweCAxMnB4O1xuICBib3JkZXItcmFkaXVzOiAyMHB4O1xuICBtYXJnaW46IDBweCAzcHg7XG4gIGhlaWdodDogZml0LWNvbnRlbnQ7XG4gIHdpZHRoOiBmaXQtY29udGVudDtcbn1cblxuLmFwcGxpZWQtZmlsdGVycy1hY3Rpb24tYnRuIHtcbiAgdGV4dC1kZWNvcmF0aW9uOiB1bmRlcmxpbmU7XG4gIGRpc3BsYXk6IGlubGluZS1ncmlkO1xufVxuXG4uYXBwbGllZC1maWx0ZXJzLWV4cGFuZENvbGxhcHNlLWJ0biB7XG4gIG1hcmdpbjogMHJlbSAxcmVtO1xufVxuXG4uYXBwbGllZC1maWx0ZXJzLXNlcGFyYXRvciB7XG4gIG1hcmdpbjogMCAwLjVyZW07XG4gIGNvbG9yOiB2YXIoLS1tZC1wcmltYXJ5LXNlcGVyYXRvci1jb2xvcik7XG59XG5cbi5jaGlwLWNyb3NzLWljb24ge1xuICBtYXJnaW4tbGVmdDogMC41cmVtICFpbXBvcnRhbnQ7XG59XG5cbi8vYWdlbnR4LXdjLXRwdy1lbXB0eS1ncmlkXG5cbi50cHctZW1wdHktZ3JpZDo6cGFydChpbWcpIHtcbiAgd2lkdGg6IDI1cmVtICFpbXBvcnRhbnQ7XG59XG5cbi8vYWdlbnR4LXdjLXRwdy1zdGF0ZS1zZWxlY3RvclxuXG4uYWdlbnQtc3RhdGUtZG90IHtcbiAgaGVpZ2h0OiAxMnB4O1xuICB3aWR0aDogMTJweDtcbiAgYm9yZGVyLXJhZGl1czogNTAlO1xuICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG4gIG1hcmdpbi1yaWdodDogMTBweDtcbn1cblxuLmFnZW50LWF2YWlsYWJsZS1kb3Qge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1tZC1wcmVzZW5jZS1hY3RpdmUtYmctY29sb3IpO1xufVxuXG4uYWdlbnQtaWRsZS1kb3Qge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1tZC1wcmVzZW5jZS1hd2F5LWJnLWNvbG9yKTtcbn1cblxuLmFnZW50LXN0YXRlLWFjdGl2ZTo6cGFydChjaGlwKSB7XG4gIGJhY2tncm91bmQtY29sb3I6IHZhcigtLWJ1dHRvbi1hdmFpbGFibGUtYmctY29sb3IsICNlZGZhZjQpICFpbXBvcnRhbnQ7XG59XG5cbi5hZ2VudC1zdGF0ZS1pZGxlOjpwYXJ0KGNoaXApIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tYnV0dG9uLWlkbGUtYmctY29sb3IsICNmN2Y3ZjcpICFpbXBvcnRhbnQ7XG59XG5cbi5hZ2VudHgtd2MtdHB3LWVtcHR5LWdyaWQge1xuICBoZWlnaHQ6IDEwMCU7XG4gIGFnZW50eC13Yy1lbXB0eS1zdGF0ZS13cmFwcGVyIHtcbiAgICAmOjpwYXJ0KGltZykge1xuICAgICAgd2lkdGg6IDg1cHg7XG4gICAgfVxuICB9XG59XG5cbi5lbXB0eS1ncmlkLW1lc3NhZ2Uge1xuICBtYXJnaW4tdG9wOiAxNXB4O1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gIG1hcmdpbi1ib3R0b206IDA7XG4gIGZvbnQtd2VpZ2h0OiA1MDA7XG4gIGZvbnQtc2l6ZTogMTRweDtcbiAgbGluZS1oZWlnaHQ6IDE5cHg7XG4gIGNvbG9yOiB2YXIoLS1tZC1wcmltYXJ5LXRleHQtY29sb3IpO1xufVxuLmVtcHR5LWdyaWQtbWVzc2FnZS1jb250YWluZXIge1xuICBkaXNwbGF5OiBibG9jaztcbn1cbi5lbXB0eS1ncmlkLXN1Yi1tZXNzYWdlIHtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuICBmb250LXdlaWdodDogYm9sZDtcbiAgbWFyZ2luLWJvdHRvbTogMDtcbiAgbWFyZ2luLXRvcDogMTBweDtcbn1cbiJdLCJzb3VyY2VSb290IjoiIn0= */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/contextMenu.scss":
/*!***************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/contextMenu.scss ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.kebab-menu-container {
  padding: 0 !important;
  max-height: calc(100vh - 48px);
}
.kebab-menu-container.overlay-content {
  width: max-content;
  background-color: var(--md-secondary-white-bg-color);
  border: 1px solid var(--md-menu-overlay-border-color, --gray-20);
  border-radius: 0.5rem;
  display: flex;
  justify-content: space-around;
  max-width: calc(100vw - var(--vw-padding) * 2);
}
.kebab-menu-container.overlay-content md-list md-list-item.agent-signout[disabled] md-tooltip {
  pointer-events: auto;
}
.kebab-menu-container .review-and-monitor.disabled-cursor {
  cursor: not-allowed;
}
.kebab-menu-container .review-monitor-wrapper md-button::part(button) {
  background-color: transparent;
}
.kebab-menu-container .review-monitor-wrapper.list md-button {
  margin: 0;
}
.kebab-menu-container .review-monitor-wrapper .rm-text {
  margin-top: 0;
  margin-bottom: 0;
  color: var(--md-primary-text-color);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
}
.kebab-menu-container .review-monitor-wrapper .rm-text.disabled {
  color: var(--md-disabled-text-color);
}
.kebab-menu-container .aid-tooltip {
  margin-top: 3px;
}
.kebab-menu-container .list-type-container {
  display: flex;
  width: 165px;
  align-items: center;
  justify-content: space-between;
}
.kebab-menu-container .list-type-container md-spinner {
  margin-left: 3px;
}
.kebab-menu-container .list-type-container .list-arrow-icon {
  position: absolute;
  align-items: center;
  right: 8px;
}
.kebab-menu-container .list-type-container .list-text-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.kebab-menu-container .list-type-container .error-icon {
  color: var(--md-input-chat-error-color, #a12512);
  margin-left: 3px;
}
.kebab-menu-container .list-type-container .error-icon md-icon::part(icon) {
  background-color: white;
  border-radius: 50%;
  height: 0;
  margin-top: 9px;
}
.kebab-menu-container .list-type-container .list-text {
  margin-top: 0;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  text-transform: capitalize;
}
.kebab-menu-container .list-type-container .list-text.disabled {
  color: var(--md-disabled-text-color);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/utils/KeyboardNavigationUtils.ts":
/*!*******************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/utils/KeyboardNavigationUtils.ts ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   checkForwardTabbing: () => (/* binding */ checkForwardTabbing),
/* harmony export */   getAllFocusableElementsOf: () => (/* binding */ getAllFocusableElementsOf),
/* harmony export */   getRowDetails: () => (/* binding */ getRowDetails),
/* harmony export */   onTabToNextCell: () => (/* binding */ onTabToNextCell),
/* harmony export */   suppressHeaderKeyboardEvent: () => (/* binding */ suppressHeaderKeyboardEvent),
/* harmony export */   suppressKeyboardEvent: () => (/* binding */ suppressKeyboardEvent)
/* harmony export */ });
/* harmony import */ var _components_Common_CellRenderers_CustomKeyboardNav__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/CellRenderers/CustomKeyboardNav */ "./src/components/Common/CellRenderers/CustomKeyboardNav.ts");

const GRID_CELL_CLASSNAME = "ag-cell";
const COLUMN_WIDTH_RESIZE = 2;
let rowDetails;
function getAllFocusableElementsOf(actionCell) {
    const focusableElements = [];
    if (actionCell) {
        const buttons = actionCell.querySelectorAll(".aid-button");
        if (buttons && buttons.length > 0) {
            buttons.forEach((element) => {
                if (!element.disabled) {
                    focusableElements.push(element);
                }
            });
        }
    }
    return focusableElements;
}
function getEventPath(event) {
    const path = [];
    let currentTarget = event.target;
    while (currentTarget) {
        path.push(currentTarget);
        currentTarget = currentTarget.parentElement;
    }
    return path;
}
function checkForwardTabbing(event, isTabForward, isTabBackward, focusableChildrenElements, actionCell, eGridCell) {
    var _a;
    let suppressEvent = false;
    const lastCellChildEl = focusableChildrenElements[focusableChildrenElements.length - 1];
    const firstCellChildEl = focusableChildrenElements[0];
    const activeElement = _components_Common_CellRenderers_CustomKeyboardNav__WEBPACK_IMPORTED_MODULE_0__["default"].getDeepActiveElement();
    // Suppress keyboard event if tabbing forward within the cell and the current focused element is not the last child
    if (isTabForward) {
        const isLastChildFocused = lastCellChildEl && activeElement === lastCellChildEl;
        if (!isLastChildFocused) {
            suppressEvent = true;
        }
        else {
            rowDetails = null;
        }
    }
    // Suppress keyboard event if tabbing backwards within the cell, and the current focused element is not the first child
    else if (isTabBackward) {
        const cellHasFocusedChildren = eGridCell !== activeElement;
        // Manually set focus to the last child element if cell doesn't have focused children
        if (!cellHasFocusedChildren) {
            lastCellChildEl === null || lastCellChildEl === void 0 ? void 0 : lastCellChildEl.focus();
            // Cancel keyboard press, so that it doesn't focus on the last child and then pass through the keyboard press to
            // move to the 2nd last child element
            event.preventDefault();
        }
        else {
            const getFocusableElements = getAllFocusableElementsOf(actionCell);
            let indexToFocus = -1; // Default index
            getFocusableElements.some((element, index) => {
                if (activeElement === element) {
                    indexToFocus = index - 1;
                    return true;
                }
                return false;
            });
            if (indexToFocus >= 0) {
                (_a = getFocusableElements[indexToFocus]) === null || _a === void 0 ? void 0 : _a.focus();
            }
            event.preventDefault();
        }
        const isFirstChildFocused = firstCellChildEl && activeElement === firstCellChildEl;
        if (!isFirstChildFocused) {
            suppressEvent = true;
        }
        else {
            rowDetails = null;
        }
    }
    return suppressEvent;
}
const suppressHeaderKeyboardEvent = (params) => {
    const { event, api, column } = params;
    const { key, altKey, shiftKey } = params.event;
    const isTabForward = key === "Tab" && shiftKey === false;
    const c = column;
    if (!c) {
        return false;
    }
    if (isTabForward && c.getColId() === "actions") {
        const actionCol = params.api.getAllDisplayedColumns().find((col) => col.getColId() === "actions");
        if (actionCol) {
            api.ensureColumnVisible(actionCol);
            // sets focus into the first grid cell
            setTimeout(() => {
                api.setFocusedCell(0, actionCol.getColId());
            }, 10);
        }
    }
    if (altKey && (key === "ArrowLeft" || key === "ArrowRight")) {
        event.preventDefault();
        const widthChange = key === "ArrowLeft" ? -COLUMN_WIDTH_RESIZE : COLUMN_WIDTH_RESIZE;
        const newWidth = params.column.getActualWidth() + widthChange;
        api.setColumnWidths([{ key: c, newWidth }]);
        return true;
    }
    return false;
};
const getRowDetails = (nodeRowIndex, api) => {
    var _a, _b;
    const lastRowIndex = api.getLastDisplayedRowIndex();
    return {
        currentRowIndex: nodeRowIndex,
        previousRowIndex: (_a = api.getDisplayedRowAtIndex(nodeRowIndex - 1)) === null || _a === void 0 ? void 0 : _a.rowIndex,
        nextRowIndex: (_b = api.getDisplayedRowAtIndex(nodeRowIndex + 1)) === null || _b === void 0 ? void 0 : _b.rowIndex,
        lastRowIndex
    };
};
function suppressKeyboardEvent(eventObj) {
    const { event, node, api } = eventObj;
    const { key, shiftKey } = event;
    const path = getEventPath(event);
    const isTabForward = key === "Tab" && shiftKey === false;
    const isTabBackward = key === "Tab" && shiftKey === true;
    let suppressEvent = false;
    rowDetails = getRowDetails(node.rowIndex, api);
    // Handle cell children tabbing
    if (isTabForward || isTabBackward) {
        const eGridCell = path.find((el) => {
            if (el.classList === undefined) {
                return false;
            }
            return el.classList.contains(GRID_CELL_CLASSNAME);
        });
        if (!eGridCell) {
            return suppressEvent;
        }
        const actionCell = eGridCell.querySelector(".ActionCell");
        const focusableChildrenElements = getAllFocusableElementsOf(actionCell);
        if (focusableChildrenElements.length > 0) {
            suppressEvent = checkForwardTabbing(event, isTabForward, isTabBackward, focusableChildrenElements, actionCell, eGridCell);
        }
        if (actionCell && focusableChildrenElements.length === 0) {
            rowDetails = null;
        }
    }
    return suppressEvent;
}
const onTabToNextCell = (params) => {
    const { previousCellPosition, nextCellPosition, backwards, api } = params;
    if (nextCellPosition) {
        const previousCell = previousCellPosition;
        const lastRowIndex = previousCell.rowIndex;
        let nextRowIndex = backwards ? lastRowIndex - 1 : lastRowIndex + 1;
        const lastIndex = api.getLastDisplayedRowIndex();
        if (nextRowIndex < 0) {
            nextRowIndex = -1;
        }
        if (nextRowIndex > lastIndex) {
            nextRowIndex = lastIndex;
        }
        const actionCol = params.api.getAllDisplayedColumns().find((col) => col.getColId() === "actions");
        if (!actionCol) {
            return false;
        }
        return {
            rowIndex: rowDetails ? rowDetails.currentRowIndex : nextRowIndex,
            column: actionCol,
            rowPinned: null
        };
    }
    return false;
};


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/utils/WebexChat.utils.ts":
/*!***********************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/utils/WebexChat.utils.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WEBEX_CHAT_STORAGE_ERROR_KEY: () => (/* binding */ WEBEX_CHAT_STORAGE_ERROR_KEY),
/* harmony export */   WEBEX_CHAT_STORAGE_KEY: () => (/* binding */ WEBEX_CHAT_STORAGE_KEY),
/* harmony export */   getAgentKey: () => (/* binding */ getAgentKey),
/* harmony export */   getPersistedError: () => (/* binding */ getPersistedError),
/* harmony export */   getPersistedText: () => (/* binding */ getPersistedText),
/* harmony export */   setPersistedError: () => (/* binding */ setPersistedError),
/* harmony export */   setPersistedText: () => (/* binding */ setPersistedText)
/* harmony export */ });
const WEBEX_CHAT_STORAGE_KEY = "tpw-webex-chat";
const WEBEX_CHAT_STORAGE_ERROR_KEY = "tpw-webex-chat-error";
// TODO: Remove Agent name when implementing TPW API
const getAgentKey = (agentName, email) => {
    agentName = agentName.replace(/ /g, "-").toLowerCase();
    return `${agentName}-${email}`;
};
const getPersistedText = (agentName, email) => {
    try {
        const storageData = window.sessionStorage.getItem(WEBEX_CHAT_STORAGE_KEY);
        if (storageData) {
            const parsedStorage = JSON.parse(storageData);
            return parsedStorage[getAgentKey(agentName, email)] || "";
        }
        else {
            return "";
        }
    }
    catch (_a) {
        return "";
    }
};
const setPersistedText = (agentName, email, value) => {
    const agentKey = getAgentKey(agentName, email);
    try {
        const storageData = window.sessionStorage.getItem(WEBEX_CHAT_STORAGE_KEY);
        if (storageData) {
            const parsedStorage = JSON.parse(storageData);
            if (value) {
                parsedStorage[agentKey] = value;
            }
            else {
                delete parsedStorage[agentKey];
            }
            window.sessionStorage.setItem(WEBEX_CHAT_STORAGE_KEY, JSON.stringify(parsedStorage));
        }
        else if (value) {
            const data = {
                [agentKey]: value
            };
            window.sessionStorage.setItem(WEBEX_CHAT_STORAGE_KEY, JSON.stringify(data));
        }
    }
    catch (_a) {
        if (value) {
            const data = {
                [agentKey]: value
            };
            window.sessionStorage.setItem(WEBEX_CHAT_STORAGE_KEY, JSON.stringify(data));
        }
    }
};
const getPersistedError = (agentName, email) => {
    try {
        const storageData = window.sessionStorage.getItem(WEBEX_CHAT_STORAGE_ERROR_KEY);
        if (storageData) {
            const parsedStorage = JSON.parse(storageData);
            return !!parsedStorage[getAgentKey(agentName, email)];
        }
        else {
            return false;
        }
    }
    catch (_a) {
        return false;
    }
};
const setPersistedError = (agentName, email, value) => {
    const agentKey = getAgentKey(agentName, email);
    try {
        const storageData = window.sessionStorage.getItem(WEBEX_CHAT_STORAGE_ERROR_KEY);
        if (storageData) {
            const parsedStorage = JSON.parse(storageData);
            if (value) {
                parsedStorage[agentKey] = value;
            }
            else {
                delete parsedStorage[agentKey];
            }
            window.sessionStorage.setItem(WEBEX_CHAT_STORAGE_ERROR_KEY, JSON.stringify(parsedStorage));
        }
        else if (value) {
            const data = {
                [agentKey]: value
            };
            window.sessionStorage.setItem(WEBEX_CHAT_STORAGE_ERROR_KEY, JSON.stringify(data));
        }
    }
    catch (_a) {
        if (value) {
            const data = { [agentKey]: value };
            window.sessionStorage.setItem(WEBEX_CHAT_STORAGE_ERROR_KEY, JSON.stringify(data));
        }
    }
};


/***/ }),

/***/ "./src/components/WebexWrapper/WebexWrapper.scss":
/*!*******************************************************!*\
  !*** ./src/components/WebexWrapper/WebexWrapper.scss ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  --nav-header-height: 64px;
  --commoon-space: 8px;
  --webex-header-width: 160px;
}

.webex-frame {
  border: none;
  width: 100%;
  height: 100%;
}

.webex-img {
  padding-right: calc(var(--space-token-even) * 6);
  vertical-align: bottom;
  height: calc(var(--space-token-even) * 8);
  width: calc(var(--space-token-even) * 10);
}

.modal-header {
  display: flex;
  align-items: center;
  max-width: var(--webex-header-width);
  overflow: hidden;
}

.camara-icon {
  margin-right: calc(var(--space-token-even) * 6);
  height: calc(var(--space-token-even) * 8);
}

#webex-wrapper-modal::part(minimize-floating) {
  right: --commoon-space;
  bottom: --commoon-space;
}

#webex-wrapper-modal::part(floating-body) {
  padding: 0;
  overflow: hidden;
}

#webex-wrapper-modal::part(floating) {
  min-width: 480px;
  min-height: 320px;
  user-select: text;
  overflow: hidden;
  z-index: calc(var(--z-index-task-collapse-area) + 1);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/WebexWrapper/WebexWrapper.ts":
/*!*****************************************************!*\
  !*** ./src/components/WebexWrapper/WebexWrapper.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WebexWrapper: () => (/* binding */ WebexWrapper)
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/config */ "./src/config.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _img_teams_icon_color_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @img/teams-icon-color.svg */ "./src/assets/images/teams-icon-color.svg");
/* harmony import */ var _img_teams_icon_color_svg__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_img_teams_icon_color_svg__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @uuip/unified-ui-platform-common-components */ "@uuip/unified-ui-platform-common-components");
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! axios */ "axios");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./../../utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _WebexWrapper_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./WebexWrapper.scss */ "./src/components/WebexWrapper/WebexWrapper.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};











var WebexWrapper;
(function (WebexWrapper) {
    /**
     * @element agentx-webex-wrapper
     * @fires agentx-webex-wrapper-close
     * @fires agentx-webex-minimize-restore
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_8__.LitElement) {
        constructor() {
            super(...arguments);
            this.webexEnabled = false;
            this.showModal = false;
            this.darkMode = false;
            this.minimize = false;
            this.agentId = "";
            this.agentEmailId = "";
            this.orgId = "";
            this.webexMeetingTimeStamp = 0;
            this.isWebexLogoutRequested = false;
            this.params = "camera *;microphone *;audio *";
            this.defaultOriginPosition = { x: 0, y: 0 };
            this.webexUrl = "";
            this.currentWindowWidth = window.innerWidth;
            this.lessWidth = 734;
            this.midWidth = 920;
            this.defaultWidth = 900;
            this.initial = false;
            this.webexWrapperTitle = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:common.webex");
            this.windowResizeHandler = () => {
                var _a, _b;
                const isModalInFullScreen = ((_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("#webex-wrapper-modal")) === null || _b === void 0 ? void 0 : _b.hasAttribute("full-screen")) || false;
                if (this.initial && isModalInFullScreen !== true) {
                    if (!this.showModal || this.minimize) {
                        this.containerRect = this.getHeightWidth();
                        this.location = this.getLocation();
                    }
                    else if (this.showModal &&
                        (localStorage.getItem("location") === null ||
                            window.innerWidth < this.lessWidth ||
                            this.currentWindowWidth < this.lessWidth)) {
                        this.location = this.getLocation();
                        this.containerRect = this.getHeightWidth();
                    }
                    this.currentWindowWidth = window.innerWidth;
                    this.minLocation = this.defaultOriginPosition;
                }
                this.initial = true;
            };
            this.defaultPosition = this.getLocation();
            this.windowResize = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_9__.throttle)(() => this.windowResizeHandler());
            this.containerRect = localStorage.getItem("resize") !== null
                ? JSON.parse(localStorage.getItem("resize") || "")
                : this.getHeightWidth();
            this.location = localStorage.getItem("location") !== null
                ? JSON.parse(localStorage.getItem("location") || "")
                : this.defaultPosition;
            this.minLocation = localStorage.getItem("min-location") !== null
                ? JSON.parse(localStorage.getItem("min-location") || "")
                : this.defaultOriginPosition;
        }
        getLocation() {
            if (window.innerWidth < this.lessWidth) {
                return this.defaultOriginPosition;
            }
            else if (window.innerWidth < this.midWidth) {
                return { x: window.innerWidth - window.innerWidth * 0.8, y: -(window.innerHeight * 0.7) };
            }
            else {
                return { x: window.innerWidth - this.defaultWidth, y: -(window.innerHeight * 0.7) };
            }
        }
        getHeightWidth() {
            if (window.innerWidth < this.lessWidth) {
                return {
                    width: window.innerWidth,
                    height: window.innerHeight * 0.8
                };
            }
            else if (window.innerWidth < this.midWidth) {
                return {
                    width: window.innerWidth * 0.8,
                    height: window.innerHeight * 0.7
                };
            }
            else {
                return { width: this.defaultWidth, height: window.innerHeight * 0.7 };
            }
        }
        resize(event) {
            var _a, _b;
            this.containerRect = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.size;
            localStorage.setItem("resize", JSON.stringify((_b = event === null || event === void 0 ? void 0 : event.detail) === null || _b === void 0 ? void 0 : _b.size));
        }
        saveLocation(event) {
            var _a, _b;
            if (((_a = this.containerRect) === null || _a === void 0 ? void 0 : _a.y) < 0) {
                // reset location if modal header is out of viewPort.
                this.location = this.getLocation();
            }
            else {
                this.location = (_b = event === null || event === void 0 ? void 0 : event.detail) === null || _b === void 0 ? void 0 : _b.transform;
            }
            localStorage.setItem("location", JSON.stringify(this.location));
        }
        saveMinLocation(event) {
            var _a, _b;
            this.minLocation = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.transform;
            localStorage.setItem("min-location", JSON.stringify((_b = event === null || event === void 0 ? void 0 : event.detail) === null || _b === void 0 ? void 0 : _b.transform));
        }
        static get styles() {
            return _WebexWrapper_scss__WEBPACK_IMPORTED_MODULE_10__["default"];
        }
        connectedCallback() {
            const _super = Object.create(null, {
                connectedCallback: { get: () => super.connectedCallback }
            });
            return __awaiter(this, void 0, void 0, function* () {
                _super.connectedCallback.call(this);
                window.addEventListener("resize", this.windowResize);
                if (this.agentId !== "" && this.webexEnabled) {
                    yield this.setTheme();
                }
            });
        }
        disconnectedCallback() {
            window.removeEventListener("resize", this.windowResize);
        }
        updated(changedProperties) {
            changedProperties.forEach((oldValue, propName) => __awaiter(this, void 0, void 0, function* () {
                if (propName === "showModal" && oldValue !== undefined && this.showModal) {
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.WEBEX_APP_OPENED);
                    this.setFocus();
                }
                else if (this.webexEnabled &&
                    this.agentId !== "" &&
                    (propName === "darkMode" || propName === "agentId" || propName === "webexEnabled") &&
                    oldValue !== undefined) {
                    yield this.setTheme();
                }
            }));
        }
        handleCloseModal() {
            var _a, _b;
            const event = new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_1__.AGENTX_WEBEX_WRAPPER_CLOSE, {
                detail: false,
                bubbles: true,
                composed: true
            });
            this.dispatchEvent(event);
            if (_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.webex) {
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.webex.getUserStatusForWebex((_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.conf) === null || _a === void 0 ? void 0 : _a.profile) === null || _b === void 0 ? void 0 : _b.agentId);
            }
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.WEBEX_APP_CLOSED);
        }
        handleMinimizeRestore() {
            var _a, _b;
            const event = new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_1__.AGENTX_WEBEX_MINIMIZE_RESTORE, {
                detail: false,
                bubbles: true,
                composed: true
            });
            this.dispatchEvent(event);
            if (_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.webex) {
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.webex.getUserStatusForWebex((_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.conf) === null || _a === void 0 ? void 0 : _a.profile) === null || _b === void 0 ? void 0 : _b.agentId);
            }
        }
        setTheme() {
            return __awaiter(this, void 0, void 0, function* () {
                const reqPayload = {
                    key: "web-color-theme-name",
                    value: this.darkMode ? "default" : "light",
                    orgId: this.orgId
                };
                const accToken = sessionStorage.getItem("accessToken");
                const url = `${_config__WEBPACK_IMPORTED_MODULE_0__.CONF.WEBEX_SETTING_SERVICE}/orgsettings/users/${this.agentId}`;
                const accessToken = `Bearer ${accToken}`;
                const headers = {
                    "Content-Type": "application/json",
                    Authorization: accessToken
                };
                return axios__WEBPACK_IMPORTED_MODULE_7___default().post(url, reqPayload, {
                    headers
                })
                    .then((response) => {
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info(`[Webex] | Webex theme change success: ${response}`);
                })
                    .catch((error) => {
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error(`[Webex] | Webex Theme change failed: ${error}`);
                });
            });
        }
        setFocus() {
            setTimeout(() => {
                var _a, _b, _c, _d, _e;
                const minBtn = (_e = (_d = (_c = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".webex-wrapper-modal")) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector("md-button.md-floating__minimize")) === null || _d === void 0 ? void 0 : _d.shadowRoot) === null || _e === void 0 ? void 0 : _e.querySelector("button");
                if (minBtn) {
                    minBtn.focus();
                }
            }, 50); //delay for modal to load
        }
        render() {
            if (this.agentEmailId !== "" && _config__WEBPACK_IMPORTED_MODULE_0__.CONF.WEBEX_APP_URL) {
                const url = this.isWebexLogoutRequested
                    ? new URL(`${_config__WEBPACK_IMPORTED_MODULE_0__.CONF.WEBEX_APP_URL}/signout`)
                    : new URL(_config__WEBPACK_IMPORTED_MODULE_0__.CONF.WEBEX_APP_URL);
                url.searchParams.set("autosignin", this.agentEmailId);
                url.searchParams.set("ccParent", "true");
                this.webexUrl = url.href;
            }
            return this.webexEnabled
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_8__.html) `
            <md-floating-modal
              id="webex-wrapper-modal"
              class="webex-wrapper-modal"
              label=${this.webexWrapperTitle}
              resize-aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:common.restoreScreenLabel")}
              maximize-aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:common.maximizeScreenLabel")}
              minimize-aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:common.minimizeModal")}
              close-aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:keyboardShortcutKeys.closeModal")}
              ?show=${this.showModal}
              ?minimize=${this.minimize}
              .position=${this.location}
              .minPosition=${this.minLocation}
              .containerRect=${this.containerRect}
              minimizable
              @floating-modal-close=${this.handleCloseModal}
              @floating-modal-minimize=${this.handleMinimizeRestore}
              @floating-modal-minimize-location=${this.saveMinLocation}
              @floating-modal-location=${this.saveLocation}
              @floating-modal-resize=${this.resize}
            >
              <div slot="header" class="modal-header">
                <img class="webex-img" alt=${this.webexWrapperTitle} src="${(_img_teams_icon_color_svg__WEBPACK_IMPORTED_MODULE_5___default())}" />
                ${this.minimize && this.webexMeetingTimeStamp
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_8__.html) `
                      <md-icon slot="icon" class="camara-icon" name="icon-camera_20"></md-icon>
                      <agentx-wc-task-list-timer startTimestamp=${this.webexMeetingTimeStamp}>
                      </agentx-wc-task-list-timer>
                    `
                    : (0,lit_element__WEBPACK_IMPORTED_MODULE_8__.html) ` ${this.webexWrapperTitle} `}
              </div>
              ${this.webexUrl !== ""
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_8__.html) `
                    <agentx-wc-iframe
                      src="${this.webexUrl}"
                      title=${this.webexWrapperTitle}
                      allowedParams="${this.params}"
                      ?is-dark-theme="${this.darkMode}"
                    >
                    </agentx-wc-iframe>
                  `
                    : null}
            </md-floating-modal>
          `
                : null;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_8__.property)({ type: Boolean })
    ], Element.prototype, "webexEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_8__.property)({ type: Boolean })
    ], Element.prototype, "showModal", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_8__.property)({ type: Boolean })
    ], Element.prototype, "darkMode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_8__.property)({ type: Boolean })
    ], Element.prototype, "minimize", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_8__.property)({ type: String })
    ], Element.prototype, "agentId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_8__.property)({ type: String })
    ], Element.prototype, "agentEmailId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_8__.property)({ type: String })
    ], Element.prototype, "orgId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_8__.property)({ type: Number })
    ], Element.prototype, "webexMeetingTimeStamp", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_8__.property)({ type: Boolean })
    ], Element.prototype, "isWebexLogoutRequested", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_8__.internalProperty)()
    ], Element.prototype, "params", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_8__.internalProperty)()
    ], Element.prototype, "defaultOriginPosition", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_8__.internalProperty)()
    ], Element.prototype, "webexUrl", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_8__.internalProperty)()
    ], Element.prototype, "currentWindowWidth", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_8__.internalProperty)()
    ], Element.prototype, "lessWidth", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_8__.internalProperty)()
    ], Element.prototype, "midWidth", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_8__.internalProperty)()
    ], Element.prototype, "defaultWidth", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_8__.internalProperty)()
    ], Element.prototype, "initial", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_8__.internalProperty)()
    ], Element.prototype, "webexWrapperTitle", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_8__.internalProperty)()
    ], Element.prototype, "defaultPosition", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_8__.property)({ type: Object })
    ], Element.prototype, "containerRect", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_8__.property)({ type: Object })
    ], Element.prototype, "location", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_8__.property)({ type: Object })
    ], Element.prototype, "minLocation", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_8__.customElement)("agentx-webex-wrapper")
    ], Element);
    WebexWrapper.Element = Element;
})(WebexWrapper || (WebexWrapper = {}));


/***/ }),

/***/ "./src/components/teamsListInfiniteScroll/index.ts":
/*!*********************************************************!*\
  !*** ./src/components/teamsListInfiniteScroll/index.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TeamsListInfiniteScroll: () => (/* binding */ TeamsListInfiniteScroll)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _teamsList_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./teamsList.scss */ "./src/components/teamsListInfiniteScroll/teamsList.scss");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _userStationLogin_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../userStationLogin/utils */ "./src/components/userStationLogin/utils.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _teamListItem__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./teamListItem */ "./src/components/teamsListInfiniteScroll/teamListItem.ts");
/* harmony import */ var _TeamPerformanceWidget_components_agentStateSelector_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../TeamPerformanceWidget/components/agentStateSelector/utils */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/utils/index.ts");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_9__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};










var TeamsListInfiniteScroll;
(function (TeamsListInfiniteScroll) {
    /**
     * @element agentx-wc-teams-list-infinite
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this.orgId = "";
            this.agentDbId = "";
            this.selectedTeamName = "";
            this.paginatedTeamResponse = {
                meta: {
                    links: {},
                    orgid: "",
                    page: 0,
                    pageSize: 0,
                    totalPages: 0,
                    totalRecords: 0
                },
                data: []
            };
            this.teamsMeta = "";
            this.items = [];
            this.isTeamsListModalOpen = false;
            this.currentPage = 0;
            this.totalRecords = 0;
            this.isPageLoading = false;
            this.initialLoad = false;
            this.pageFetchError = {
                isError: false,
                trackingId: ""
            };
            this.isSearchPageLoading = false;
            this.searchQuery = "";
            this.isInputInSearchMode = false;
            this.isSearchQueryTooShort = false;
            this.getFormattedTeamItems = (item) => {
                return {
                    name: item.teamName,
                    id: item.teamId,
                    index: 1,
                    ariaLabel: item.teamName,
                    template: (data) => {
                        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<team-list-item
            .isOpen=${this.isTeamsListModalOpen}
            .teamOption=${data}
            .searchTerm="${this.searchQuery}"
          ></team-list-item>`;
                    }
                };
            };
            this.setLoadingStart = (hasSearchInitiatedPageLoad = false) => {
                this.isPageLoading = true;
                if (hasSearchInitiatedPageLoad) {
                    this.isSearchPageLoading = true;
                }
            };
            this.setLoadingComplete = (hasSearchInitiatedPageLoad = false) => {
                this.isPageLoading = false;
                if (hasSearchInitiatedPageLoad) {
                    this.isSearchPageLoading = false;
                }
            };
            this.setItemsForAdvancedList = (newItems, totalRecords, isNewPage, hasSearchInitiatedPageLoad = false) => {
                if (hasSearchInitiatedPageLoad) {
                    this.items = [];
                    this.totalRecords = 0;
                    this.currentPage = 0;
                }
                this.totalRecords = totalRecords;
                this.items = isNewPage ? [...this.items, ...newItems] : newItems;
            };
            this.populateTeamList = () => {
                var _a, _b, _c;
                const defaultTeamName = (_c = (_b = (_a = this.items) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : "";
                if (this.initialLoad) {
                    this.searchQuery = this.selectedTeamName;
                    this.initialLoad = false;
                    this.selectedTeamName || (this.selectedTeamName = defaultTeamName);
                }
                if (this.searchQuery.length > 0) {
                    if (this.isSearchQueryTooShort) {
                        return;
                    }
                    else if (this.searchQuery.length < 3) {
                        this.handleShortSearch(new CustomEvent("search-too-short", { detail: this.searchQuery }));
                    }
                    else if (this.searchQuery.length >= 3) {
                        this.handleValidSearch(new CustomEvent("search-term-valid", { detail: this.searchQuery }));
                    }
                }
                else {
                    this.items = this.getItemsFromPaginatedResponse(this.paginatedTeamResponse);
                }
                if (this.isTeamsListModalOpen) {
                    const teamsMeta = JSON.parse(this.teamsMeta);
                    this.setItemsForAdvancedList(this.items, teamsMeta.totalRecords, false);
                }
                this.pageFetchError = {
                    isError: false,
                    trackingId: ""
                };
            };
            this.focusInputField = () => {
                var _a, _b, _c, _d;
                const inputElement = (_d = (_c = (_b = (_a = this.searchHandler) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("md-input")) === null || _c === void 0 ? void 0 : _c.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector("input");
                inputElement === null || inputElement === void 0 ? void 0 : inputElement.focus();
            };
            this.setFocusOnInputField = () => {
                setTimeout(() => {
                    this.focusInputField();
                }, 0);
            };
            this.tryAgainLoadTeamData = () => __awaiter(this, void 0, void 0, function* () {
                this.loadNextPage();
                this.setFocusOnInputField();
            });
            this.loadNextPage = (hasSearchInitiatedPageLoad = false) => __awaiter(this, void 0, void 0, function* () {
                if (!this.isTeamsListModalOpen) {
                    return;
                }
                try {
                    this.setLoadingStart(hasSearchInitiatedPageLoad);
                    if (hasSearchInitiatedPageLoad) {
                        this.isInputInSearchMode = true;
                    }
                    const { formattedListItems, totalRecords } = yield this.getTeamList(this.currentPage, this.searchQuery);
                    if (this.isTeamsListModalOpen && (this.isInputInSearchMode || !this.isSearchQueryTooShort)) {
                        this.setItemsForAdvancedList(formattedListItems, totalRecords, true, hasSearchInitiatedPageLoad);
                    }
                    this.setLoadingComplete(hasSearchInitiatedPageLoad);
                    this.pageFetchError = {
                        isError: false,
                        trackingId: ""
                    };
                    if (hasSearchInitiatedPageLoad && this.items.length > 0) {
                        this.isInputInSearchMode = false;
                    }
                }
                catch (error) {
                    this.setLoadingComplete(hasSearchInitiatedPageLoad);
                    this.pageFetchError = {
                        isError: true,
                        trackingId: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.getTrackingIdFromErrorObject)(error) : ""
                    };
                    _sdk__WEBPACK_IMPORTED_MODULE_5__.logger.error("event=loadNextPage | Error on fetching teams on station login module", error);
                }
                finally {
                    this.setLoadingComplete(hasSearchInitiatedPageLoad);
                }
            });
            this.handleListItemChange = (event) => {
                const selectedValue = this.getSelectedTeam(event.detail.selected[0]);
                /** Send the updated team details to user profile */
                this.selectedTeamName = selectedValue.name;
                this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_6__.TEAM_SELECT_EVENT, {
                    detail: { teamId: selectedValue.id, teamName: selectedValue.name },
                    bubbles: true,
                    composed: true
                }));
                this.searchQuery = this.selectedTeamName;
                this.toggleMenuOverlay(false);
            };
            this.setPageAndLoadData = () => {
                if (this.isPageLoading || this.items.length === 0) {
                    return;
                }
                this.currentPage += 1;
                this.loadNextPage();
            };
            this.handleSearchInputKeyDown = (event) => {
                const srcEvent = event.detail.srcEvent;
                if (srcEvent && srcEvent.key === "Tab" && srcEvent.shiftKey) {
                    event.detail.srcEvent.preventDefault();
                    // Focus to the md-advance-list-container
                    this.focusListComponent();
                }
            };
        }
        static get styles() {
            return [_teamsList_scss__WEBPACK_IMPORTED_MODULE_2__["default"]];
        }
        connectedCallback() {
            super.connectedCallback();
            this.initialLoad = true;
        }
        getItemsFromPaginatedResponse(paginatedTeamResponse) {
            return paginatedTeamResponse.data.map((item) => this.getFormattedTeamItems(item));
        }
        resetPropertiesForDisplay() {
            this.items = [];
            this.currentPage = 0;
            this.totalRecords = 0;
            this.pageFetchError = {
                isError: false,
                trackingId: ""
            };
            this.isInputInSearchMode = false;
        }
        onMenuOverlayClose(event) {
            event.stopPropagation();
            this.resetPropertiesForDisplay();
            this.isPageLoading = false;
            this.isSearchPageLoading = false;
            this.isTeamsListModalOpen = false;
        }
        onMenuOverlayOpen(event) {
            event.stopPropagation();
            this.isTeamsListModalOpen = true;
            this.populateTeamList();
            this.setFocusOnInputField();
        }
        getTeamList(page, searchQuery = "") {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const response = yield (0,_userStationLogin_utils__WEBPACK_IMPORTED_MODULE_4__.fetchTeamList)(this.orgId, page, this.agentDbId, searchQuery);
                    const formattedListItems = response.data.map((item) => this.getFormattedTeamItems(item));
                    return { formattedListItems, totalRecords: response.meta.totalRecords };
                }
                catch (error) {
                    _sdk__WEBPACK_IMPORTED_MODULE_5__.logger.error("event=getTeamList | Error on fetching idle codes on Team Performance Widget Agent State Change Module", error);
                    throw error;
                }
            });
        }
        getSelectedTeamId(teamList) {
            const selectedTeamId = teamList === null || teamList === void 0 ? void 0 : teamList.find((team) => {
                return team.name === this.selectedTeamName;
            });
            return (selectedTeamId === null || selectedTeamId === void 0 ? void 0 : selectedTeamId.id) || "";
        }
        getSelectedTeam(teamId) {
            var _a;
            return (_a = this.items) === null || _a === void 0 ? void 0 : _a.find((team) => {
                return team.id === teamId;
            });
        }
        toggleMenuOverlay(toOpen) {
            const searchInputElement = this.menuOverlay.children[0];
            if (searchInputElement) {
                searchInputElement.click();
            }
            this.isTeamsListModalOpen = toOpen;
        }
        getStatusIndicator() {
            if (this.items.length > 0) {
                if (this.isPageLoading) {
                    return [
                        {
                            id: "status-indicator",
                            name: "loading",
                            template: () => (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<div class="infinite-scroll-spinner" part="spinner"><md-spinner size="18"></md-spinner></div>`
                        }
                    ];
                }
                if (this.pageFetchError.isError) {
                    return [
                        {
                            id: "status-indicator",
                            name: "error",
                            template: () => (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<agent-state-selector-list-error
                  class="fetch-error"
                  style="color: red;"
                  trackingId="${this.pageFetchError.trackingId}"
                  @error-retry="${this.loadNextPage}"
                >
                </agent-state-selector-list-error>`
                        }
                    ];
                }
            }
            return [];
        }
        renderList() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <md-advance-list
          .items=${this.items.concat(this.getStatusIndicator())}
          .value=${[this.getSelectedTeamId(this.items)]}
          .isLoading=${this.isPageLoading}
          .isError=${this.pageFetchError.isError}
          .focusReset=${!this.isTeamsListModalOpen || this.isPageLoading}
          containerHeight=${(0,_TeamPerformanceWidget_components_agentStateSelector_utils__WEBPACK_IMPORTED_MODULE_8__.getDynamicHeight)(this.items.length || 1)}
          ariaRoleList="listbox"
          ariaLabelList="Team list"
          totalRecords=${this.totalRecords}
          @list-item-change=${this.handleListItemChange}
          @load-more=${this.setPageAndLoadData}
        ></md-advance-list>
      `;
        }
        renderErrorOrLoading() {
            if (this.items.length === 0) {
                if (this.isPageLoading && (this.isInputInSearchMode || !this.isSearchQueryTooShort)) {
                    return (0,_TeamPerformanceWidget_components_agentStateSelector_utils__WEBPACK_IMPORTED_MODULE_8__.renderLoadingState)();
                }
                if (this.pageFetchError.isError) {
                    return (0,_TeamPerformanceWidget_components_agentStateSelector_utils__WEBPACK_IMPORTED_MODULE_8__.renderErrorState)((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorDetail:errorTitle"), (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorDetail:reloadButton"), this.tryAgainLoadTeamData);
                }
            }
            if (this.isSearchQueryTooShort) {
                return (0,_TeamPerformanceWidget_components_agentStateSelector_utils__WEBPACK_IMPORTED_MODULE_8__.renderSearchError)((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.teamsSearchError") || "Enter a minimum of three characters to search for teams.");
            }
            if (this.isInputInSearchMode) {
                return (0,_TeamPerformanceWidget_components_agentStateSelector_utils__WEBPACK_IMPORTED_MODULE_8__.renderNoMatchFound)((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common:nomatchfound"));
            }
            return lit_html__WEBPACK_IMPORTED_MODULE_9__.nothing;
        }
        handleSearchCleared(event) {
            this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_6__.TEAM_SELECT_EVENT, {
                detail: {},
                bubbles: true,
                composed: true
            }));
            this.resetPropertiesForDisplay();
            this.items = this.getItemsFromPaginatedResponse(this.paginatedTeamResponse);
            const teamsMeta = JSON.parse(this.teamsMeta);
            this.setItemsForAdvancedList(this.items, teamsMeta.totalRecords, false);
            this.searchQuery = event.detail;
            this.isSearchQueryTooShort = false;
            this.setFocusOnInputField();
        }
        handleValidSearch(event) {
            this.resetPropertiesForDisplay();
            if (!this.isTeamsListModalOpen) {
                this.toggleMenuOverlay(true);
            }
            this.searchQuery = event.detail;
            this.isSearchQueryTooShort = false;
            this.loadNextPage(true);
            this.setFocusOnInputField();
        }
        handleShortSearch(event) {
            this.resetPropertiesForDisplay();
            if (!this.isTeamsListModalOpen) {
                this.toggleMenuOverlay(true);
            }
            this.searchQuery = event.detail;
            this.isSearchQueryTooShort = true;
            this.setFocusOnInputField();
        }
        focusListComponent() {
            var _a, _b;
            const currentSelectedItem = (_b = (_a = this.listElement) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector(".md-advance-list-wrapper");
            setTimeout(() => {
                currentSelectedItem === null || currentSelectedItem === void 0 ? void 0 : currentSelectedItem.focus();
            }, 0);
        }
        renderSearchInput() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<search-input
        presetValue=${this.selectedTeamName}
        slot="menu-trigger"
        .isPageLoading=${this.isPageLoading}
        .isSearchPageLoading=${this.isSearchPageLoading}
        .reset=${false}
        placeholder="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.selectTeam")}"
        ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.selectTeam")}"
        @input-keydown="${this.handleSearchInputKeyDown}"
        @search-cleared="${this.handleSearchCleared}"
        @search-term-valid="${this.handleValidSearch}"
        @search-too-short="${this.handleShortSearch}"
      >
      </search-input>`;
        }
        render() {
            const res = this.renderErrorOrLoading();
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="teams-list-infinite">
          <md-menu-overlay
            max-height="calc(100vh - 266.5px)"
            position="bottom"
            @menu-overlay-open=${(event) => {
                this.onMenuOverlayOpen(event);
            }}
            @menu-overlay-close=${(event) => {
                this.onMenuOverlayClose(event);
            }}
          >
            ${this.renderSearchInput()} ${this.renderList()}
            ${res !== lit_html__WEBPACK_IMPORTED_MODULE_9__.nothing ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<div class="state-div">${this.renderErrorOrLoading()}</div>` : ""}
          </md-menu-overlay>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "orgId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "agentDbId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "selectedTeamName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
    ], Element.prototype, "paginatedTeamResponse", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "teamsMeta", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "items", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "isTeamsListModalOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "currentPage", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "totalRecords", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "isPageLoading", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "initialLoad", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "pageFetchError", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "isSearchPageLoading", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "searchQuery", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "isInputInSearchMode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "isSearchQueryTooShort", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.query)("md-advance-list")
    ], Element.prototype, "listElement", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.query)("search-input")
    ], Element.prototype, "searchHandler", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.query)("md-menu-overlay")
    ], Element.prototype, "menuOverlay", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-teams-list-infinite")
    ], Element);
    TeamsListInfiniteScroll.Element = Element;
})(TeamsListInfiniteScroll || (TeamsListInfiniteScroll = {}));


/***/ }),

/***/ "./src/components/teamsListInfiniteScroll/teamListItem.ts":
/*!****************************************************************!*\
  !*** ./src/components/teamsListInfiniteScroll/teamListItem.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TeamListItem: () => (/* binding */ TeamListItem)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _teamsList_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./teamsList.scss */ "./src/components/teamsListInfiniteScroll/teamsList.scss");
/* harmony import */ var _Common_Utils_HighlightText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Common/Utils/HighlightText */ "./src/components/Common/Utils/HighlightText.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var TeamListItem;
(function (TeamListItem) {
    /**
     * @element team-list-item
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this.isOpen = false;
            this.teamOption = {
                name: "",
                id: ""
            };
            this.searchTerm = "";
            this.isTextOverflow = false;
        }
        static get styles() {
            return _teamsList_scss__WEBPACK_IMPORTED_MODULE_2__["default"];
        }
        render() {
            const text = this.teamOption.name;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <md-tooltip placement="top" message=${text} ?disabled=${!this.isTextOverflow}>
          <div class="team-list-item-text ellipsis-text">${(0,_Common_Utils_HighlightText__WEBPACK_IMPORTED_MODULE_3__.highlightText)(text, this.searchTerm)}</div>
        </md-tooltip>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "isOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
    ], Element.prototype, "teamOption", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], Element.prototype, "searchTerm", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "isTextOverflow", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("team-list-item")
    ], Element);
    TeamListItem.Element = Element;
})(TeamListItem || (TeamListItem = {}));


/***/ }),

/***/ "./src/components/teamsListInfiniteScroll/teamsList.scss":
/*!***************************************************************!*\
  !*** ./src/components/teamsListInfiniteScroll/teamsList.scss ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

.teams-list-infinite md-advance-list {
  width: 100%;
  min-height: fit-content;
  max-height: 292px;
}
.teams-list-infinite md-advance-list::part(advance-list-item-wrapper) {
  padding: calc(var(--space-token-even) * 4) calc(var(--space-token-even) * 6);
}
.teams-list-infinite :host(team-list-item) {
  display: flex;
}
.teams-list-infinite md-advance-list::part(spinner) {
  display: flex;
  justify-content: center;
  margin-top: 5px;
}
.teams-list-infinite md-menu-overlay::part(overlay) {
  top: -13px !important;
  width: 100% !important;
}
.teams-list-infinite md-menu-overlay::part(overlay-content) {
  width: 100% !important;
}
.teams-list-infinite .team-list-item-text {
  display: block;
  font-size: var(--font-size-medium);
  padding: 0 0 0 calc(var(--space-token-cardinal) * 2);
  width: var(--full-menu-item-width);
}
.teams-list-infinite .ellipsis-text {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.teams-list-infinite .highlight-span {
  display: inline-table;
}
.teams-list-infinite .state-loading {
  height: 100px;
  min-height: 100px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.teams-list-infinite .state-error {
  padding: calc(var(--space-token-even) * 15) 0 calc(var(--space-token-even) * 8) 0;
  display: grid;
}
.teams-list-infinite .state-error .error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.teams-list-infinite .state-error .error-title {
  font-size: var(--font-size-medium);
  margin: 0 calc(var(--space-token-even) * 8);
  margin-bottom: auto;
  font-weight: 600;
  text-align: center;
  padding: 0;
  color: var(--list-text-color, #121212);
}
.teams-list-infinite .state-error .error-subtitle {
  font-size: var(--font-size-medium);
  margin: 0 calc(var(--space-token-even) * 8);
  margin-bottom: auto;
  text-align: center;
  padding: 0;
}
.teams-list-infinite .state-error .error-cloud-wrapper {
  height: auto;
}
.teams-list-infinite .state-error .error-cloud-wrapper::part(container) {
  background-color: var(--md-secondary-white-bg-color);
}
.teams-list-infinite .state-error .error-cloud-wrapper::part(img) {
  display: block;
  margin: auto;
  width: auto;
}
.teams-list-infinite .state-error md-button {
  margin: calc(var(--space-token-even) * 12) auto auto auto;
}
.teams-list-infinite .search-block-error {
  display: flex;
  align-items: center;
  padding: calc(var(--space-token-even) * 8);
}
.teams-list-infinite .search-error {
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;
  font-size: var(--font-size-small);
}
.teams-list-infinite .state-no-match {
  padding: calc(var(--space-token-even) * 12) calc(var(--space-token-even) * 12);
  position: relative;
  text-align: center;
}
.teams-list-infinite .state-no-match .empty-title {
  font-size: var(--font-size-medium);
  margin: 0 calc(var(--space-token-even) * 8);
  margin-bottom: auto;
  color: var(--list-text-color, #121212);
}
.teams-list-infinite .state-no-match .empty-state-wrapper::part(container) {
  background-color: var(--md-secondary-white-bg-color);
}
.teams-list-infinite .state-no-match .empty-state-wrapper::part(img) {
  display: block;
  margin: auto;
  width: auto;
}
.teams-list-infinite md-menu-overlay search-input::part(search-input-wrapper) {
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
}
.teams-list-infinite .state-div {
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  max-height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--md-secondary-white-bg-color);
  border-radius: var(--border-radius-medium);
  box-shadow: var(--common-box-shadow);
  min-height: 100px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/userProfile/userProfile.scss":
/*!*****************************************************!*\
  !*** ./src/components/userProfile/userProfile.scss ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-10: 10px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

md-modal::part(modal-body) {
  overflow: visible;
}

.error-message {
  padding-left: 4px;
  margin-top: calc(var(--space-token-even) * 4);
}

.md-loading {
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}

.form {
  align-items: stretch;
  display: flex;
  flex-direction: column;
}

.sl-phone-format-container {
  display: flex;
}

.sl-phone-format-option {
  padding: 1em 1em 0.25em 0;
}

.sl-dn-input {
  margin-bottom: 1.5em;
}

.sl-tabs-container {
  height: auto;
}

.modal-content {
  padding: 0 24px;
}

.phone-format {
  padding: 16px 0 8px;
  color: var(--md-primary-text-color, #171b1f);
}
.phone-format md-radio {
  display: inline-block;
  margin-right: 14px;
}

.station-login-radio {
  color: var(--md-primary-text-color, #171b1f);
}
.station-login-radio md-radiogroup {
  display: inline-block;
  margin: 16px 0;
}

md-link::part(link) {
  color: var(--link-default);
  font-size: 12px;
}

.emergency-help-tooltip md-button::part(button) {
  width: 0;
  height: 0;
  margin: 5px 14px 0 5px;
}

.browser-label-container-emergency md-tooltip::part(tooltip_reference), .browser-label-container-emergency-helpText md-tooltip::part(tooltip_reference), .browser-label-container md-tooltip::part(tooltip_reference) {
  display: flex;
}

.station-login-radio-min md-radio:nth-child(1) {
  margin-right: 4rem;
}
.station-login-radio-min md-radio:nth-child(2) {
  margin-right: 0;
}

.station-login-radio-max md-radio::part(radio-label) {
  white-space: normal;
}
.station-login-radio-max md-radio::part(radio-wrapper) {
  max-height: 4rem;
}
.station-login-radio-max md-radio {
  margin-right: 1rem;
}

.remember-me-checkbox-wrapper {
  padding-top: 24px;
}

.remember-me-checkbox::part(checkbox-label) {
  z-index: 0;
}

.extension-format {
  padding-top: 5px;
}

.sl-combobox {
  color: var(--md-primary-text-color, #171b1f);
  padding: 0 2px;
}

.roles-combobox {
  margin-bottom: 20px;
}

.btn-submit {
  display: flex;
  justify-content: flex-end;
}

.teams-label {
  padding: 0 0 10px;
}

.footer-btn {
  margin-left: 0.75rem;
}

.browser-label-container-emergency, .browser-label-container-emergency-helpText, .browser-label-container {
  color: var(--md-secondary-text-color);
}

.browser-label-container {
  margin-bottom: 24px;
}

.browser-label-container-emergency-helpText {
  font-size: 12px;
  margin-top: 8px;
  margin-bottom: 24px;
}

@media screen and (max-height: 540px) {
  md-modal::part(modal-container) {
    max-height: calc(100vh - 2%);
  }
  md-modal::part(modal-content) {
    min-height: 100%;
    max-height: 100vh;
    overflow-y: auto;
  }
}
.phone-format md-radio::part(radio-label) {
  width: fit-content;
  max-width: 140px;
}

.info-icon {
  vertical-align: sub;
  margin-left: calc(var(--space-token-even) * 1.5);
}

.international-checkbox-wrapper {
  display: flex;
  color: var(--md-primary-text-color, #171b1f);
}
.international-checkbox-wrapper md-checkbox {
  margin-bottom: 12px;
}

.dial-number-label {
  display: flex;
}

.label-with-bottom-margin {
  margin-bottom: 10px;
}

md-phone-input::part(combobox) {
  width: 114px;
}
md-phone-input::part(md-input) {
  width: 100%;
}
md-phone-input::part(option) {
  justify-content: space-between;
}

.read-the-notification-wrapper {
  padding: 16px 2px 2px;
}

.read-the-notification::part(checkbox-label) {
  z-index: 0;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/userProfile/userProfile.ts":
/*!***************************************************!*\
  !*** ./src/components/userProfile/userProfile.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UserProfile: () => (/* binding */ UserProfile)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../constants */ "./src/constants.ts");
/* harmony import */ var _userProfile_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./userProfile.scss */ "./src/components/userProfile/userProfile.scss");
/* harmony import */ var _teamsListInfiniteScroll__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./../teamsListInfiniteScroll */ "./src/components/teamsListInfiniteScroll/index.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_13__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};















const trackingIdLabel = "app:errorModal:trackingIdLabel";
const extensionPlaceHolder = "app:stationLogin:extensionPlaceHolder";
const clearAriaLabel = "app:stationLogin.clear";
const dnStationLogin = "app:stationLogin.stationDnLabel";
const phoneInput = "md-phone-input";
const hiddenBtn = "#hiddenBtn";
const extensionInfo = "app:stationLogin.extensionInfo";
const modeOptionslabel = "app:stationLogin:modeOptionsLabel";
const phoneFormats = { international: "International", us: "US", other: "Other" };
var UserProfile;
(function (UserProfile) {
    /**
     * @element agentx-wc-user-profile
     * @fires selected-user-role
     * @fires login-start
     * @fires submit-busy
     * @fires on-component-update
     * @fires on-preferred-wx-call-answer-endpoint-selected
     * @fires modal-initialized
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_12__.MobxLitElement) {
        constructor() {
            super(...arguments);
            this.userRole = "";
            this.isMonitoringEnabled = false;
            this.isSubmit = false;
            this.selectedRoleName = _constants__WEBPACK_IMPORTED_MODULE_9__.AGENT;
            this.teamName = "";
            this.teamId = "";
            this.dialNumber = "";
            this.isExtensionUsed = false;
            this.isDefaultDnSet = false;
            this.extensionNumber = "";
            this.dialNumberValueForNonUS = "";
            this.defaultDn = "";
            this.isDefaultDnSetFromProfile = false;
            this.isInternational = false;
            this.isInternationalFromProfile = false;
            this.countryCallingCode = "";
            this.countryCodeValue = "";
            this.isRememberMyCredentials = false;
            this.auxCodeError = false;
            this.fetchUniqueTeamIdError = false;
            this.orgId = "";
            this.agentDbId = "";
            this.isSubmitProfile = "";
            this.teams = []; // From User Station Login.
            this.filteredTeamList = ""; // From Menu Component for Profile Settings.
            this.teamsMeta = ""; // From Menu Component for Profile Settings.
            this.isErrUnknown = false;
            this.isErrDNRegister = false;
            this.reasonCode = "";
            this.isDesktopReasonCodeEnabled = false;
            this.getErrorMsgForReasonCode = Function;
            this.isDNAlreadyInUse = false;
            this.isErrPhone = false;
            this.isErrPhoneExt = false;
            this.isExtAlreadyInUse = false;
            this.isErrExtRegister = false;
            this.isDNRegisterTimeOut = false;
            this.isTeamsEmpty = false;
            this.usesOtherDN = false;
            this.trackingId = "";
            this.isStationlogin = false;
            this.isExtensionUsedFromProfile = false;
            this.usesOtherDNFromProfile = false;
            this.isMonitoringEnabledFromProfile = false;
            this.phoneFormat = phoneFormats.other;
            this.phoneNumber = "";
            this.isMaximumSessionsReached = false;
            this.loginVoiceOptions = [];
            this.deviceType = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.constants.LoginVoiceOptions.AGENT_DN;
            this.deviceId = "";
            this.preferredWxCallAnswerEndpoints = [];
            this.selectedPreferredWxCallAnswerEndpointId = "";
            this.isWebRTCEnabled = false;
            this.isWebRtcUnsupportedBrowser = false;
            this.isMicrophoneAccessDenied = false;
            this.showEmergencyNotificationWebrtc = false;
            this.isEmergencyModalAlreadyDisplayed = false;
            this.isConsultTransferInfiniteScrollEnabled = false;
            this.isErrTeam = false;
            this.mode = "DN";
            this.isErrRole = false;
            this.displayRoleDropdown = true;
            this.displayTeamsDropdown = true;
            this.displayDNExtension = true;
            this.radioSelection = 0;
            this.isExtensionTooltipOpened = false;
            this.isIntenationalTooltipOpened = false;
            this.roleInfo = null;
            this.paginatedTeamResponse = {
                meta: {
                    links: {},
                    orgid: "",
                    page: 0,
                    pageSize: 0,
                    totalPages: 0,
                    totalRecords: 0
                },
                data: []
            };
            /**
             * Inserting hidden button inside the form so that autocomplete works
             * for firefox
             */
            this.hiddenAutoFillBtnDN = document.createElement("button");
            this.team = null;
            this.profile = null;
            // TODO: this should come from i18N.
            this.roles = [
                { roleId: "1", roleName: _constants__WEBPACK_IMPORTED_MODULE_9__.SUPERVISOR, roleDisplay: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:supervisorRole") },
                { roleId: "2", roleName: _constants__WEBPACK_IMPORTED_MODULE_9__.AGENT_AND_SUPERVISOR, roleDisplay: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:supervisorAndAgentRole") }
            ];
            this.defaultAuxCode = "";
            this.insertFromPaste = "insertFromPaste";
            this.teamsArray = [];
            this.defaultCountryCallingCode = "+1, United States of America, US";
            this.defaultCountryCodeValue = "+1";
            this.isValidISD = false;
            /** Handling team select from advance list */
            this.onTeamSelect = (e) => {
                const { teamName, teamId } = e.detail;
                this.teamName = teamName;
                this.teamId = teamId;
                this.team = teamName && teamId ? { teamId, teamName } : null;
                this.dispatchEventWhenComponentUpdates();
            };
        }
        connectedCallback() {
            super.connectedCallback();
            this.init();
            this.attachHiddenAttributesButton();
        }
        init() {
            var _a, _b;
            this.teams = this.filteredTeamList ? JSON.parse(this.filteredTeamList) : this.teams;
            if (this.isConsultTransferInfiniteScrollEnabled) {
                this.paginatedTeamResponse.data = this.teams;
                if (this.teamsMeta) {
                    try {
                        this.paginatedTeamResponse.meta = JSON.parse(this.teamsMeta);
                    }
                    catch (e) {
                        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("Failed to parse teamsMeta", e);
                        this.paginatedTeamResponse.meta = {
                            links: {},
                            orgid: "",
                            page: 0,
                            pageSize: 0,
                            totalPages: 0,
                            totalRecords: 0
                        };
                    }
                }
            }
            this.teamsArray = (_a = this.teams) === null || _a === void 0 ? void 0 : _a.map((team) => team.teamName);
            const defaultTeam = this.teams && this.teams.length > 0 ? this.teams[0].teamName : "";
            this.teamName = this.teamName ? this.teamName : defaultTeam;
            if (this.isConsultTransferInfiniteScrollEnabled) {
                this.team = {
                    teamId: this.teamId,
                    teamName: this.teamName
                };
            }
            this.setValuesFromProfile();
            this.displayControlsBasedOnRole();
            //Without this check if we have only one option with webrtc disabled,
            //devicetype will never be updated and will render the wrong section
            if (this.loginVoiceOptions.length === 1) {
                this.deviceType = this.loginVoiceOptions[0];
                this.setDeviceType();
            }
            if (this.isWebRTCEnabled) {
                // remove toUpperCase check when webrtc ff is GA
                if (this.deviceType === null ||
                    this.loginVoiceOptions.indexOf((_b = this.deviceType) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === -1 ||
                    !this.isRememberMyCredentials) {
                    this.deviceType = this.loginVoiceOptions[0];
                }
                this.setDeviceType();
            }
            else {
                this.setRadioButtonSelection();
            }
            this.getSelectedRole();
            // Adding a timeout as phone input takes some time to load and then the values will be populated from Preferences, focus needs to be done after that
            setTimeout(() => {
                this.handleInitialFocus();
                this.getRoleSelection();
            }, 10);
            this.dispatchEventWhenComponentUpdates();
        }
        /**
         * As profile is React component, boolean values doesn't apply correctly when passed from there
         * thus as a workaround setting it as string here
         */
        setValuesFromProfile() {
            if (!this.isStationlogin) {
                this.usesOtherDN = this.usesOtherDNFromProfile;
                this.isExtensionUsed = this.isExtensionUsedFromProfile;
                this.isMonitoringEnabled = this.isMonitoringEnabledFromProfile;
                this.isDefaultDnSet = this.isDefaultDnSetFromProfile;
                this.isInternational = this.isInternationalFromProfile;
            }
        }
        getDn() {
            if (this.isExtensionUsed) {
                return this.extensionNumber;
            }
            let countryCodeValueVar = "";
            if (this.phoneNumber !== "") {
                // send dn as empty if phonenumber is empty instead of +1 so that DN register failure doesnt happen
                countryCodeValueVar = this.countryCodeValue || this.defaultCountryCodeValue;
            }
            return this.ifInternationalFormat()
                ? `${countryCodeValueVar}${(0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.stripSpecialChar)(this.phoneNumber)}`
                : this.dialNumberValueForNonUS;
        }
        isUsesOtherFormat() {
            return this.phoneFormat === phoneFormats.other || this.countryCodeValue !== "+1";
        }
        setRadioButtonSelection() {
            this.radioSelection = this.isExtensionUsed ? 1 : 0;
            const format = this.isExtensionUsed ? "Extension" : "DN";
            this.setValuesOnRadioChange(format);
        }
        setDeviceType() {
            var _a;
            // remove toUpperCase check when webrtc ff is GA
            if (this.deviceType !== null) {
                this.radioSelection = this.loginVoiceOptions.indexOf((_a = this.deviceType) === null || _a === void 0 ? void 0 : _a.toUpperCase());
            }
            this.isExtensionUsed = this.deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.constants.LoginVoiceOptions.EXTENSION;
            this.isErrUnknown = false;
        }
        setValuesOnRadioChange(format) {
            this.mode = format;
            this.isExtensionUsed = format === "Extension";
            this.radioSelection = this.isExtensionUsed ? 1 : 0;
            this.isErrUnknown = false;
            this.isErrPhoneExt = false;
            this.isErrPhone = false;
        }
        displayControlsBasedOnRole() {
            const userRoleString = this.userRole;
            switch (userRoleString) {
                case _constants__WEBPACK_IMPORTED_MODULE_9__.AGENT: {
                    this.displayRoleDropdown = false;
                    this.displayTeamsDropdown = true;
                    this.displayDNExtension = true;
                    break;
                }
                case _constants__WEBPACK_IMPORTED_MODULE_9__.SUPERVISOR: {
                    this.displayDNExtension = this.isMonitoringEnabled;
                    this.displayRoleDropdown = false;
                    this.displayTeamsDropdown = false;
                    break;
                }
                // TODO: remove SUPERVISOR_AND_AGENT as UI determines the user role.
                case _constants__WEBPACK_IMPORTED_MODULE_9__.SUPERVISOR_AND_AGENT.replace(/\s/g, "").toLocaleLowerCase():
                case _constants__WEBPACK_IMPORTED_MODULE_9__.AGENT_AND_SUPERVISOR: {
                    if (this.selectedRoleName) {
                        this.handleDisplayOnRoleChange(this.selectedRoleName.toLocaleLowerCase());
                    }
                    else {
                        this.displayRoleDropdown = true;
                        this.displayTeamsDropdown = false;
                        this.displayDNExtension = false;
                    }
                    break;
                }
            }
        }
        /**
         * Toggles the display of UI Elements based upon Role coming from STORE and
         * when user changes role from the dropdown
         * @param selectedRoleName
         */
        handleDisplayOnRoleChange(selectedRoleName) {
            if (selectedRoleName === _constants__WEBPACK_IMPORTED_MODULE_9__.SUPERVISOR) {
                this.displayTeamsDropdown = false;
                this.displayRoleDropdown = true;
                this.displayDNExtension = this.isMonitoringEnabled;
            }
            else if (selectedRoleName === _constants__WEBPACK_IMPORTED_MODULE_9__.AGENT_AND_SUPERVISOR) {
                this.displayRoleDropdown = true;
                this.displayTeamsDropdown = true;
                this.displayDNExtension = true;
            }
        }
        attachHiddenAttributesButton() {
            this.hiddenAutoFillBtnDN.id = "hiddenBtn";
            this.hiddenAutoFillBtnDN.type = "submit";
            this.hiddenAutoFillBtnDN.onclick = (e) => {
                e.preventDefault();
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("hiddenAutoFillBtnDN clicked");
            };
            this.hiddenAutoFillBtnDN.style.display = "none";
        }
        attachAutoCompleteConditionally() {
            return this.ifInternationalFormat() ? "tel-national" : "tel";
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            changedProperties.forEach((oldValue, name) => {
                if (name === "isSubmit" && oldValue !== undefined) {
                    this.submitFromStationLogin();
                }
                if (name === "isSubmitProfile" && oldValue !== undefined) {
                    this.submitFromProfileSettings();
                }
            });
            this.setRovingPreventFocus();
            let inp;
            setTimeout(() => {
                var _a, _b, _c, _d;
                // setTimeout required as md-phone-input does not render
                if (this.isExtensionUsed || !this.ifInternationalFormat()) {
                    inp = (_a = this.form) === null || _a === void 0 ? void 0 : _a.querySelector("md-input");
                }
                else {
                    inp = (_c = (_b = this.internationalForm) === null || _b === void 0 ? void 0 : _b.querySelector(phoneInput)) === null || _c === void 0 ? void 0 : _c.shadowRoot.querySelector("md-input");
                    if (inp && !(inp === null || inp === void 0 ? void 0 : inp.shadowRoot.querySelector("form"))) {
                        // create form element and append to input element to support auto suggestion for md-phone-input component
                        const input = inp.shadowRoot.querySelector("input");
                        if (input) {
                            input.name = input.id = "input-name";
                            input.autocomplete = this.attachAutoCompleteConditionally();
                            const inputParent = input.parentElement;
                            if (inputParent) {
                                const formElement = document.createElement("form");
                                inputParent.insertBefore(formElement, input);
                                formElement.append(input);
                            }
                        }
                    }
                }
                if (!((_d = inp === null || inp === void 0 ? void 0 : inp.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector(hiddenBtn))) {
                    const form = inp === null || inp === void 0 ? void 0 : inp.shadowRoot.querySelector("form");
                    if (form) {
                        const input = inp.shadowRoot.querySelector("input");
                        input.autocomplete = this.attachAutoCompleteConditionally();
                        form.append(this.hiddenAutoFillBtnDN);
                    }
                }
            }, 50); // delay required for md-phone-input to render
        }
        setRovingPreventFocus() {
            if (this.telephonyRadio && !this.rolesDropDown) {
                this.telephonyRadio.rovingPreventFocus = true;
            }
        }
        handleRememberMeCheckBoxChange() {
            this.isRememberMyCredentials = !this.isRememberMyCredentials;
            this.dispatchEventWhenComponentUpdates();
        }
        handleSelectedRole(e) {
            var _a;
            if (e.detail.option) {
                this.roleInfo = e.detail.option;
            }
            else {
                this.roleInfo = null;
            }
            const selectedRoleName = (_a = this.roleInfo) === null || _a === void 0 ? void 0 : _a.roleName;
            selectedRoleName && this.handleDisplayOnRoleChange(selectedRoleName.toLocaleLowerCase());
            this.isErrUnknown = false;
            setTimeout(() => {
                this.handleInputFocus();
            }, 10);
            this.dispatchEventWhenComponentUpdates();
        }
        handleSelectedTeam(e) {
            if (e.detail.value) {
                const selectedTeam = this.teams.find((teamObj) => teamObj.teamName === e.detail.value);
                if (selectedTeam) {
                    this.team = selectedTeam;
                }
            }
            else {
                this.team = null;
                this.teamName = "";
            }
            this.dispatchEventWhenComponentUpdates();
        }
        setDialNumber(e) {
            var _a, _b;
            if (((_b = (_a = e === null || e === void 0 ? void 0 : e.detail) === null || _a === void 0 ? void 0 : _a.srcEvent) === null || _b === void 0 ? void 0 : _b.inputType) === this.insertFromPaste) {
                e.target.value = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.stripSpecialChar)(e.target.value);
            }
            this.dialNumberValueForNonUS = e.target.value;
            this.dispatchEventWhenComponentUpdates();
        }
        onDialNumberOrExtBlur() {
            this.dispatchEventWhenComponentUpdates();
        }
        setExtensionNumber(e) {
            var _a, _b;
            if (((_b = (_a = e === null || e === void 0 ? void 0 : e.detail) === null || _a === void 0 ? void 0 : _a.srcEvent) === null || _b === void 0 ? void 0 : _b.inputType) === this.insertFromPaste) {
                e.target.value = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.stripSpecialChar)(e.target.value);
            }
            this.extensionNumber = e.target.value;
            this.dispatchEventWhenComponentUpdates();
        }
        handleInputFocus() {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const inputField = (_c = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-input")) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector("input");
            const phoneField = (_h = (_g = (_f = (_e = (_d = this.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector(phoneInput)) === null || _e === void 0 ? void 0 : _e.shadowRoot) === null || _f === void 0 ? void 0 : _f.querySelector("md-input")) === null || _g === void 0 ? void 0 : _g.shadowRoot) === null || _h === void 0 ? void 0 : _h.querySelector("input");
            setTimeout(() => {
                if (inputField) {
                    inputField.focus();
                }
                else {
                    phoneField === null || phoneField === void 0 ? void 0 : phoneField.focus();
                }
            }, 1);
        }
        handleInitialFocus() {
            setTimeout(() => {
                var _a, _b, _c, _d, _e, _f;
                if (this.displayRoleDropdown) {
                    (_c = (_b = (_a = this.rolesDropDown) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("label")) === null || _c === void 0 ? void 0 : _c.focus();
                }
                else {
                    (_f = (_e = (_d = this.dnInfoIconButton) === null || _d === void 0 ? void 0 : _d.shadowRoot) === null || _e === void 0 ? void 0 : _e.querySelector("button")) === null || _f === void 0 ? void 0 : _f.focus();
                }
            }, 1);
        }
        submitLogin() {
            if (this.isStationlogin) {
                this.evt("submit-busy", { submitProperty: true });
                this.submitFromStationLogin();
            }
            else {
                this.submitFromProfileSettings();
            }
        }
        handleEnterKeypress(e) {
            if (e.key === _constants__WEBPACK_IMPORTED_MODULE_9__.Key.Enter) {
                this.submitLogin();
            }
        }
        handlePhoneInputKeydown(e) {
            const keyboardEvent = e.detail.srcEvent;
            if (keyboardEvent.key === _constants__WEBPACK_IMPORTED_MODULE_9__.Key.Enter) {
                this.submitLogin();
            }
        }
        handleUnSupportedBrowserError() {
            this.isErrUnknown = true;
            this.isWebRtcUnsupportedBrowser = true;
            this.trackingId = "";
            this.evt(_constants__WEBPACK_IMPORTED_MODULE_9__.PROFILE_SETTING_INVALID_DATA_EVENT, { isValid: false });
        }
        handleMicrophoneAccessDenied() {
            this.isErrUnknown = true;
            this.isMicrophoneAccessDenied = true;
            this.trackingId = "";
            this.evt(_constants__WEBPACK_IMPORTED_MODULE_9__.PROFILE_SETTING_INVALID_DATA_EVENT, { isValid: false });
        }
        /***
         * When Updating User Profile Settings
         */
        submitFromProfileSettings() {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            return __awaiter(this, void 0, void 0, function* () {
                if ((this.displayRoleDropdown && !this.roleInfo) || (this.displayTeamsDropdown && !this.team)) {
                    return;
                }
                let selectedRoleName = (_a = this.roleInfo) === null || _a === void 0 ? void 0 : _a.roleName;
                if (selectedRoleName) {
                    selectedRoleName = selectedRoleName === "agent_supervisor" ? "supervisorAgent" : selectedRoleName;
                    localStorage.setItem("userRole", selectedRoleName);
                }
                if (this.isWebRTCEnabled && this.deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.constants.LoginVoiceOptions.BROWSER) {
                    if (!this.isEmergencyModalAlreadyDisplayed && _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.featureflag.isDesktopEmergencyNotificationEnabled()) {
                        this.renderEmergencyNotificationBody();
                    }
                    this.setErrorFlags();
                    this.isErrUnknown = false;
                    _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[WebRtc] : Station Login Request from profile");
                    if (!(0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.isWebRtcSupportedBrowser)()) {
                        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[WebRtc] Unsupported Browser error");
                        this.handleUnSupportedBrowserError();
                        return;
                    }
                    try {
                        const mediaStream = yield navigator.mediaDevices.getUserMedia({ audio: true });
                        if (!mediaStream) {
                            this.handleMicrophoneAccessDenied();
                            return;
                        }
                        else {
                            mediaStream.getTracks().forEach((track) => track.stop());
                        }
                    }
                    catch (error) {
                        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[WebRtc] micrpophone access error", error);
                        this.handleMicrophoneAccessDenied();
                        return;
                    }
                }
                else if (this.displayDNExtension && !this.valid()) {
                    const inputField = this.isExtensionUsed && !this.ifInternationalFormat()
                        ? (_e = (_d = (_c = (_b = this.form) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector("md-input")) === null || _d === void 0 ? void 0 : _d.shadowRoot) === null || _e === void 0 ? void 0 : _e.querySelector("input")
                        : (_l = (_k = (_j = (_h = (_g = (_f = this.form) === null || _f === void 0 ? void 0 : _f.shadowRoot) === null || _g === void 0 ? void 0 : _g.querySelector(phoneInput)) === null || _h === void 0 ? void 0 : _h.shadowRoot) === null || _j === void 0 ? void 0 : _j.querySelector("md-input")) === null || _k === void 0 ? void 0 : _k.shadowRoot) === null || _l === void 0 ? void 0 : _l.querySelector("input");
                    setTimeout(() => inputField === null || inputField === void 0 ? void 0 : inputField.focus(), 1);
                    this.evt(_constants__WEBPACK_IMPORTED_MODULE_9__.PROFILE_SETTING_INVALID_DATA_EVENT, { isValid: false });
                    return;
                }
                this.evt(_constants__WEBPACK_IMPORTED_MODULE_9__.PROFILE_SETTING_INVALID_DATA_EVENT, { isValid: true });
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.shortcut.updateRegisterKeys();
                this.isWebRTCEnabled && this.deviceType === "BROWSER" ? (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.registerWebRTCShortcuts)() : (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.removeWebRTCShortcuts)();
                this.dispatchEventWhenComponentUpdates();
            });
        }
        setInternationalPhNumber(e) {
            this.phoneNumber = e.detail.phoneNumber;
            this.isValidISD = e.detail.phoneNumber && e.detail.isValid;
            this.dispatchEventWhenComponentUpdates();
        }
        submitFromStationLogin() {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            //storing original role here as to compare for role switch for telemetry
            const loggedInRole = this.selectedRoleName;
            // Update selectedRoleName in STORE.agent in case of Supervisor And Agent
            const selectedRoleName = (_a = this.roleInfo) === null || _a === void 0 ? void 0 : _a.roleName;
            if (this.displayRoleDropdown && selectedRoleName) {
                const roleData = { selectedRoleName };
                this.evt("selected-user-role", roleData);
            }
            if (this.isWebRTCEnabled && this.deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.constants.LoginVoiceOptions.BROWSER) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[WebRtc] : Station Login Request from StationLogin PopUP");
            }
            else {
                let inp;
                if (this.isExtensionUsed) {
                    inp = (_d = (_c = (_b = this.extForm) === null || _b === void 0 ? void 0 : _b.querySelector("md-input")) === null || _c === void 0 ? void 0 : _c.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector("input");
                }
                else {
                    inp = this.ifInternationalFormat()
                        ? (_g = (_f = (_e = this.form) === null || _e === void 0 ? void 0 : _e.querySelector(phoneInput)) === null || _f === void 0 ? void 0 : _f.shadowRoot) === null || _g === void 0 ? void 0 : _g.querySelector("md-input")
                        : (_k = (_j = (_h = this.form) === null || _h === void 0 ? void 0 : _h.querySelector("md-input")) === null || _j === void 0 ? void 0 : _j.shadowRoot) === null || _k === void 0 ? void 0 : _k.querySelector("input");
                }
                if (this.displayDNExtension && !this.valid()) {
                    const inputField = (_l = inp === null || inp === void 0 ? void 0 : inp.shadowRoot) === null || _l === void 0 ? void 0 : _l.querySelector("input");
                    setTimeout(() => inputField === null || inputField === void 0 ? void 0 : inputField.focus(), 1);
                    this.evt("submit-busy", { submitProperty: false });
                    this.handleInputFocus();
                    return;
                }
                if ((this.displayRoleDropdown && !this.roleInfo) || (this.displayTeamsDropdown && !this.team)) {
                    this.evt("submit-busy", { submitProperty: false });
                    return;
                }
            }
            this.evt("login-start", {
                profileDetail: this.getProfileDetails(),
                loggedInRole
            });
        }
        isValidPhone() {
            // Validate the phone number for international format
            if (this.ifInternationalFormat()) {
                return this.isValidISD && this.phoneNumber;
            }
            return this.dialNumberValueForNonUS;
        }
        valid() {
            this.setErrorFlags();
            // hardcoded check for US phone - was requested
            // "this.profile.regexUS" must be used later
            const regexUS = new RegExp("^(\\+1|1)?\\d{10}$");
            const regexOther = new RegExp("([A-Za-z0-9-_]+)");
            //regex for extension number validation (2 to 13 digits only allowed)
            // eslint-disable-next-line sonarjs/concise-regex
            const regexExtension = new RegExp("^[0-9]{2,18}$");
            this.isErrTeam = this.displayTeamsDropdown ? !this.team : false;
            this.isErrRole = this.displayRoleDropdown ? !this.roleInfo : false;
            if (this.isExtensionUsed) {
                this.isErrPhoneExt = !this.extensionNumber;
                if (this.isErrPhoneExt || this.isErrTeam || this.isErrRole) {
                    this.isErrUnknown = false;
                    this.isExtAlreadyInUse = false;
                    this.isErrExtRegister = false;
                    return false;
                }
                if (!regexExtension.test(this.extensionNumber)) {
                    this.isErrPhoneExt = true;
                    this.isErrUnknown = false;
                    this.isErrExtRegister = false;
                    this.isExtAlreadyInUse = false;
                    return false;
                }
            }
            else {
                if (this.phoneFormat === "US") {
                    if (regexUS.test(this.dialNumberValueForNonUS)) {
                        if (this.dialNumberValueForNonUS.length === 11) {
                            // only +1 prefix allowed not just 1
                            // hardcoded add "+" if 11 digits
                            this.dialNumberValueForNonUS = `+${this.dialNumberValueForNonUS}`;
                        }
                        else if (_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.featureflag.isSteeringDigitsAppendEnabled() &&
                            this.dialNumberValueForNonUS.length === 10) {
                            // hardcoded +1 for CX-6490.
                            this.dialNumberValueForNonUS = `+1${this.dialNumberValueForNonUS}`;
                        }
                    }
                    else {
                        this.isErrPhone = true;
                        this.isErrUnknown = false;
                        this.isErrDNRegister = false;
                        this.isDNAlreadyInUse = false;
                        return false;
                    }
                }
                if (this.ifInternationalFormat()) {
                    this.isErrPhone = !this.isValidPhone();
                }
                else if (this.isUsesOtherFormat() && !regexOther.test(this.dialNumberValueForNonUS)) {
                    this.isErrPhone = true;
                    this.isErrUnknown = false;
                    this.isErrDNRegister = false;
                    this.isDNAlreadyInUse = false;
                    return false;
                }
                if (this.isErrPhone || this.isErrTeam) {
                    this.isErrUnknown = false;
                    this.isErrDNRegister = false;
                    this.isErrExtRegister = false;
                    this.isDNAlreadyInUse = false;
                    this.isErrPhoneExt = false;
                    return false;
                }
            }
            if (this.isErrUnknown) {
                this.isErrUnknown = false;
            }
            if (this.isErrDNRegister) {
                this.isErrDNRegister = false;
            }
            if (this.isErrPhone) {
                this.isErrPhone = false;
            }
            if (this.isErrExtRegister) {
                this.isErrExtRegister = false;
            }
            if (this.isErrPhoneExt) {
                this.isErrPhoneExt = false;
            }
            return true;
        }
        onDNExtensionRadioChange(e) {
            const format = e.detail.selected;
            this.deviceType = e.detail.selected;
            this.setValuesOnRadioChange(format);
            this.dispatchEventWhenComponentUpdates();
        }
        onVoiceOptionChange(e) {
            this.deviceType = e.detail.selected;
            this.setDeviceType();
            this.dispatchEventWhenComponentUpdates();
        }
        handleKeyDown(e) {
            e.stopImmediatePropagation();
        }
        ifInternationalFormat() {
            return this.phoneFormat === phoneFormats.international;
        }
        handleFormatChange() {
            document.dispatchEvent(new CustomEvent("on-widget-update"));
            this.setErrorFlags();
            this.isErrUnknown = false;
            this.phoneFormat = this.ifInternationalFormat() ? phoneFormats.other : phoneFormats.international;
            this.isInternational = this.ifInternationalFormat();
            this.dispatchEventWhenComponentUpdates();
        }
        handleCountryChange(e) {
            var _a;
            const event = e.detail.srcEvent;
            if (event && event.detail) {
                if (!event.detail.value || !event.detail.value.id) {
                    this.countryCodeValue = "+1";
                    this.countryCallingCode = "";
                    return;
                }
                this.countryCodeValue = (_a = event.detail.selected[0]) === null || _a === void 0 ? void 0 : _a.value;
                this.countryCallingCode = event.detail.value.id;
                this.isValidISD = e.detail.isValid;
                if (e.detail.isValid) {
                    this.setErrorFlags();
                    this.isErrUnknown = false;
                }
                this.dispatchEventWhenComponentUpdates();
            }
        }
        getErrorMessage() {
            if (this.isErrPhone) {
                return `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:stationLoginInvalidNumber")}`;
            }
            else if (this.isErrDNRegister) {
                if (this.isDNAlreadyInUse) {
                    return `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:dnAlreadyInUse")} (${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(trackingIdLabel)}: ${this.trackingId})`;
                }
                return `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:dnRegisterFailure")} (${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(trackingIdLabel)}: ${this.trackingId})`;
            }
            return `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:stationLoginInvalidNumber")}`;
        }
        radioChange(e) {
            const format = e.detail.selected;
            this.deviceType = e.detail.selected;
            this.phoneFormat = format;
            this.dispatchEventWhenComponentUpdates();
        }
        setErrorFlags() {
            this.isErrUnknown = true;
            this.isErrDNRegister = false;
            this.isDNAlreadyInUse = false;
            this.isErrPhone = false;
            this.isErrPhoneExt = false;
            this.isExtAlreadyInUse = false;
            this.isErrExtRegister = false;
            this.isWebRtcUnsupportedBrowser = false;
            this.isMicrophoneAccessDenied = false;
        }
        // ROST: create decorator for custom event
        evt(name, detail) {
            this.dispatchEvent(new CustomEvent(name, { bubbles: true, composed: true, detail }));
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[User Profile]: Dispatching event", name, detail);
        }
        static get styles() {
            return _userProfile_scss__WEBPACK_IMPORTED_MODULE_10__["default"];
        }
        getSelectedRole() {
            if (!this.roleInfo) {
                const selectedRoleOption = this.roles.filter((role) => role.roleName.toLocaleLowerCase() === this.selectedRoleName.toLocaleLowerCase());
                this.roleInfo = selectedRoleOption[0];
            }
            return this.roleInfo;
        }
        getRoleSelection() {
            let focusRoleDropdown;
            if (this.selectedRoleName !== "agent" && this.selectedRoleName !== "" && this.isMonitoringEnabled === true) {
                focusRoleDropdown = false;
            }
            else {
                focusRoleDropdown = true;
            }
            return focusRoleDropdown;
        }
        getProfileDetails() {
            var _a, _b, _c, _d, _e, _f;
            return {
                roles: this.displayRoleDropdown
                    ? ((_b = (_a = this.roleInfo) === null || _a === void 0 ? void 0 : _a.roleName) === null || _b === void 0 ? void 0 : _b.split("_")) || ((_c = this.userRole) === null || _c === void 0 ? void 0 : _c.split("_"))
                    : (_d = this.userRole) === null || _d === void 0 ? void 0 : _d.split("_"),
                teamName: ((_e = this.team) === null || _e === void 0 ? void 0 : _e.teamName) ? this.team.teamName : this.teamName,
                teamId: ((_f = this.team) === null || _f === void 0 ? void 0 : _f.teamId) ? this.team.teamId : this.teamId,
                dnNumber: this.getDn(),
                isExtension: this.isExtensionUsed,
                usesOtherDN: this.isUsesOtherFormat() || this.countryCodeValue !== "+1",
                extensionNumber: this.extensionNumber || this.defaultDn || "",
                dialNumberValueForNonUS: this.dialNumberValueForNonUS,
                defaultDn: this.defaultDn,
                isDefaultDnSet: this.isDefaultDnSet,
                isInternational: this.ifInternationalFormat(),
                phoneNumber: this.isInternational ? this.phoneNumber : this.defaultDn || "",
                countryCallingCode: this.isInternational ? this.countryCallingCode || this.defaultCountryCallingCode : "",
                countryCodeValue: this.isInternational ? this.countryCodeValue || this.defaultCountryCodeValue : "",
                isRememberMyCredentials: this.isRememberMyCredentials,
                deviceType: this.deviceType,
                deviceId: this.deviceId,
                isEmergencyModalAlreadyDisplayed: this.isEmergencyModalAlreadyDisplayed
            };
        }
        /**
         * On any input field change dispatch event and handle in profile settings
         */
        dispatchEventWhenComponentUpdates() {
            const checkRole = this.displayRoleDropdown ? this.roleInfo : true;
            const dnInputValue = this.getDn();
            const checkDN = this.displayDNExtension ? dnInputValue : true;
            const checkTeam = this.displayTeamsDropdown ? this.team : true;
            const isDeviceTypeBrowser = this.isWebRTCEnabled && this.deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.constants.LoginVoiceOptions.BROWSER;
            const flg = checkRole && (checkDN || isDeviceTypeBrowser) && checkTeam ? false : true;
            const profileDetail = this.getProfileDetails();
            this.evt("on-component-update", {
                submitProperty: flg,
                profileDetail
            });
        }
        errorCodesCheck() {
            const errMsg = this.getErrorMsgForReasonCode(this.reasonCode);
            if (this.isDesktopReasonCodeEnabled && this.reasonCode && errMsg) {
                return [
                    {
                        type: "error",
                        message: `${errMsg}`
                    }
                ];
            }
            if (this.isErrPhone) {
                return [
                    {
                        type: "error",
                        message: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:stationLoginInvalidNumber")}`
                    }
                ];
            }
            if (this.isErrDNRegister) {
                if (this.isDNAlreadyInUse) {
                    return [
                        {
                            type: "error",
                            message: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:dnAlreadyInUse")} (${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(trackingIdLabel)}: ${this.trackingId})`
                        }
                    ];
                }
                return [
                    {
                        type: "error",
                        message: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:dnRegisterFailure")} (${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(trackingIdLabel)}: ${this.trackingId})`
                    }
                ];
            }
            if (this.isErrPhoneExt) {
                return [
                    {
                        type: "error",
                        message: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:stationLoginInvalidExtNumber")}`
                    }
                ];
            }
            if (this.isErrExtRegister) {
                if (this.isExtAlreadyInUse) {
                    return [
                        {
                            type: "error",
                            message: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:dnAlreadyInUse")} (${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(trackingIdLabel)}: ${this.trackingId})`
                        }
                    ];
                }
                return [
                    {
                        type: "error",
                        message: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:dnRegisterFailure")} (${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(trackingIdLabel)}: ${this.trackingId})`
                    }
                ];
            }
            return [];
        }
        renderExtensionForm() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <div class="extension-format">
          <md-form class="form-class" id="ext-form">
            <md-input
              clear
              clearAriaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.clearExtensionLabel")}"
              htmlId="dial-extension"
              ariaDescribedBy="dial-extension"
              ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(extensionInfo)}"
              type="tel"
              id="ext"
              placeholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(extensionPlaceHolder)}
              ?readOnly=${this.isDefaultDnSet}
              shape=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_13__.ifDefined)(!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled ? "pill" : undefined)}
              ?newMomentum=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled}
              class=${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_7__.classMap)({ err: this.isErrPhoneExt })}
              .value=${this.extensionNumber ? this.extensionNumber : ""}
              .secondaryLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(extensionInfo)}"
              @input-change=${this.setExtensionNumber}
              @input-blur=${this.onDialNumberOrExtBlur}
              @keypress=${this.handleEnterKeypress}
              .messageArr=${this.errorCodesCheck()}
            ></md-input>
          </md-form>
        </div>
      `;
        }
        renderDnForm() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <md-form class="form-class">
          <md-input
            clear
            clearAriaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(clearAriaLabel)} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(dnStationLogin)}"
            type="tel"
            id="dn"
            placeholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(dnStationLogin)}
            ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(dnStationLogin)}"
            class=${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_7__.classMap)({ err: this.isErrPhone })}
            ?readOnly=${this.isDefaultDnSet}
            ?disabled=${this.isDefaultDnSet}
            .value=${this.dialNumberValueForNonUS ? this.dialNumberValueForNonUS : ""}
            shape=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_13__.ifDefined)(!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled ? "pill" : undefined)}
            ?newMomentum=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled}
            @keydown=${this.handleKeyDown}
            @keypress=${this.handleEnterKeypress}
            @input-change=${this.setDialNumber}
            @input-blur=${this.onDialNumberOrExtBlur}
            .messageArr=${this.errorCodesCheck()}
          ></md-input>
        </md-form>
      `;
        }
        renderInternationalForm() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <md-form class="form-class" id="international-form">
          <md-phone-input
            type="tel"
            ?pill=${!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled}
            ?newMomentum=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled}
            id="international"
            name="international-value"
            .errorMessage=${this.getErrorMessage()}
            .value="${this.phoneNumber}"
            .countryCallingCode=${this.countryCallingCode}
            .numberPlaceholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:stationDnPlaceholder")}
            .countryCodeAriaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.countryCode")}
            .dialNumberAriaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.stationDnLabelAriaLabel")}
            ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(dnStationLogin)}"
            ?showErrorMessage=${this.ifInternationalFormat() &&
                (this.isErrPhone || this.isErrDNRegister || this.isDNAlreadyInUse)}
            @phoneinput-keydown="${(e) => {
                e.stopImmediatePropagation();
                this.handlePhoneInputKeydown(e.detail.srcEvent);
            }}"
            @phoneinput-change="${(e) => {
                e.stopImmediatePropagation();
                this.setInternationalPhNumber(e);
                this.setErrorFlags();
                this.isErrUnknown = false;
            }}"
            @phoneinput-blur="${(e) => {
                e.stopImmediatePropagation();
                this.setInternationalPhNumber(e);
            }}"
            @countrycode-change="${(e) => this.handleCountryChange(e)}"
            clear-icon-height="12px"
            clearAriaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(clearAriaLabel)} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(dnStationLogin)}"
          ></md-phone-input>
        </md-form>
      `;
        }
        renderTeam() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <div class="md-input-container sl-combobox" tabindex="-1">
          <label class="teams-label" for="teams" tabindex="-1">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.stationLoginTeamLabel")}</label>
          ${
            /** retaining the check here,
             * however when no team is present its a config error and agent has to sign out
             * even before the app loads. This logic is taken care. */
            this.isConsultTransferInfiniteScrollEnabled
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
                  <agentx-wc-teams-list-infinite
                    selectedTeamName="${this.teamName ? this.teamName : ""}"
                    agentDbId="${this.agentDbId}"
                    orgId="${this.orgId}"
                    teamsMeta="${this.teamsMeta}"
                    .paginatedTeamResponse="${this.paginatedTeamResponse}"
                    @on-team-selected="${this.onTeamSelect}"
                  ></agentx-wc-teams-list-infinite>
                `
                : !this.isTeamsEmpty
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
                    <md-combobox
                      placeholder="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.selectTeam")}"
                      ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.selectTeam")}"
                      search-result-aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.selectTeamOnSearch")}"
                      ?newMomentum=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled}
                      .options=${this.teamsArray}
                      .value=${[this.teamsArray.find((teamName) => teamName === this.teamName) || this.teamName]}
                      option-id="teamId"
                      option-value="teamName"
                      .visibleOptions=${3}
                      @change-selected="${this.handleSelectedTeam}"
                      no-options-i18n=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.noOptions")}
                      no-results-i18n=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.noResults")}
                      clear-icon-height="12px"
                      shape=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_13__.ifDefined)(!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled ? "pill" : undefined)}
                      clear-aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.clearTeamLabel")}"
                    ></md-combobox>
                  `
                    : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
        </div>
      `;
        }
        getUnknownErrorMessage() {
            if (this.isWebRTCEnabled && this.deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.constants.LoginVoiceOptions.BROWSER) {
                if (this.isMicrophoneAccessDenied) {
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:microphoneAccessDeniedError");
                }
                if (this.isWebRtcUnsupportedBrowser) {
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:browserUnsupportedError");
                }
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:stationLoginFailed");
            }
            if (this.isMaximumSessionsReached) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:maximumSessionsReachedError");
            }
            if (this.auxCodeError) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:auxiliaryCodeFailed");
            }
            if (this.fetchUniqueTeamIdError) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:fetchTeamIdFailed");
            }
            return this.isDNRegisterTimeOut
                ? this.isExtensionUsed
                    ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:extNumberRegisterTimeout")
                    : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:dnRegisterTimeout")
                : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:stationLoginFailed");
        }
        renderUnknownError() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <div part="message" class="error-message">
          <md-help-text .messageType=${"error"}>
            ${this.getUnknownErrorMessage()} ${this.trackingId ? `(${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(trackingIdLabel)}: ${this.trackingId})` : ""}
          </md-help-text>
        </div>
      `;
        }
        getLabel() {
            if (this.loginVoiceOptions.length === 1) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:stationLogin.${this.loginVoiceOptions[0].toLowerCase()}Label`);
            }
            return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.stationLoginVoiceLabel");
        }
        getToolTipInfoByLoginVoiceOptions() {
            if (this.loginVoiceOptions.length === 2) {
                if (this.loginVoiceOptions[0] === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.constants.LoginVoiceOptions.AGENT_DN) {
                    if (this.loginVoiceOptions[1] === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.constants.LoginVoiceOptions.EXTENSION) {
                        return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(extensionInfo);
                    }
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.loginVoiceDnBrowserInfo");
                }
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.loginVoiceExtBrowserInfo");
            }
            return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.loginVoiceInfo");
        }
        getTooltipInfo() {
            if (this.isWebRTCEnabled) {
                return this.getToolTipInfoByLoginVoiceOptions();
            }
            return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(extensionInfo);
        }
        dispatchAnnouncement(message) {
            window.dispatchEvent(new CustomEvent("ax-announcement-update", {
                detail: {
                    thisEvent: {
                        message
                    }
                }
            }));
        }
        getLabelSection() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <div class="dial-number-label">
          ${(0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
            <label
              tabindex="-1"
              class="${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_7__.classMap)({ "label-with-bottom-margin": this.loginVoiceOptions.length === 1 })}"
              >${this.getLabel()}</label
            >
          `}
          ${this.loginVoiceOptions.length > 1
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
                <md-tooltip
                  ?opened=${this.isExtensionTooltipOpened}
                  message=${this.getTooltipInfo()}
                  placement="bottom"
                >
                  <md-button
                    ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.extensionInfoButtonLabel")}"
                    circle
                    variant="ghost"
                    class="info-icon dn-info-icon-button"
                    size="20"
                    @focus=${() => {
                    this.isExtensionTooltipOpened = true;
                    this.dispatchAnnouncement(this.getTooltipInfo());
                }}
                    @blur=${() => (this.isExtensionTooltipOpened = false)}
                  >
                    <md-icon name="info-badge-filled" size="16" iconSet="momentumDesign"></md-icon>
                  </md-button>
                </md-tooltip>
              `
                : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
        </div>
      `;
        }
        handleKeyDownRadio(e) {
            if (this.telephonyRadio) {
                this.telephonyRadio.rovingPreventFocus = false;
            }
            this.handleEnterKeypress(e);
        }
        getRadioList() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <md-radiogroup
          class="station-login-radio-group"
          group-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(modeOptionslabel)}"
          alignment="horizontal"
          checked="${this.radioSelection}"
          @keydown=${this.handleKeyDownRadio}
          @radio-change=${(e) => this.onVoiceOptionChange(e)}
        >
          ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_8__.repeat)(this.loginVoiceOptions, (option) => (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
              <md-radio
                slot="radio"
                value="${option}"
                ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:stationLogin.${option.toLocaleLowerCase()}`)}"
                title="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:stationLogin.${option.toLocaleLowerCase()}`)}"
                >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:stationLogin.${option.toLocaleLowerCase()}`)}
              </md-radio>
            `)}
        </md-radiogroup>
      `;
        }
        renderBrowserSection() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <div class="browser-label-container">
          <label>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.browserInfo")}</label>
        </div>
      `;
        }
        renderEmergencyInfoSectionOnSecondLogin() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <div>
          <div class="browser-label-container-emergency">
            <label>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.browserInfo")}</label>
          </div>
          <div class="browser-label-container-emergency-helpText">
            <md-tooltip
              class="emergency-help-tooltip"
              placement="top"
              message=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:emergencyServiceNotification.updateCurrentAddInfoOnSecondSignIn")}
            >
              <md-button
                aria-label=${this.getTooltipInfo()}
                circle
                variant="ghost"
                class="info-icon"
                role="tooltip"
                size="16"
                @focus=${() => (this.isExtensionTooltipOpened = true)}
                @blur=${() => (this.isExtensionTooltipOpened = false)}
              >
                <md-icon name="info-badge-filled" size="16" iconSet="momentumDesign"></md-icon>
              </md-button>
              <label
                >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:emergencyServiceNotification.updateCurrentAddInfoOnSecondSignIn")}
                <md-link
                  inline
                  class="help-section-link"
                  aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:emergencyServiceNotification.seeHelpSection")}
                  tag="a"
                  href=${_constants__WEBPACK_IMPORTED_MODULE_9__.emergency911HelpLink}
                  target="_blank"
                  >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:emergencyServiceNotification.seeHelpSection")}</md-link
                >
              </label>
            </md-tooltip>
          </div>
        </div>
      `;
        }
        getInputField() {
            switch (this.deviceType) {
                case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.constants.LoginVoiceOptions.EXTENSION: {
                    return this.renderExtensionForm();
                }
                case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.constants.LoginVoiceOptions.BROWSER: {
                    if (_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.featureflag.isDesktopEmergencyNotificationEnabled() && this.isEmergencyModalAlreadyDisplayed) {
                        return this.renderEmergencyInfoSectionOnSecondLogin();
                    }
                    return this.renderBrowserSection();
                }
                default:
                    return this.renderDNSection();
            }
        }
        renderVoiceOptionSection() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        ${this.displayDNExtension // role base
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
              <div
                class="station-login-radio 
                ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_7__.classMap)({
                    "station-login-radio-min": this.loginVoiceOptions.length === 1,
                    "station-login-radio-max": this.loginVoiceOptions.length === 3
                })}"
              >
                ${this.getLabelSection()} ${this.loginVoiceOptions.length > 1 ? this.getRadioList() : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
              </div>
              ${this.getInputField()} ${this.renderWebexCallingDeviceSelectionSection()}
            `
                : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
      `;
        }
        renderDNSection() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <!-- International Checkbox -->
        <div class="international-checkbox-wrapper">
          <md-checkbox
            slot="checkbox"
            ?disabled="${this.isDefaultDnSet}"
            .checked="${this.ifInternationalFormat()}"
            @checkbox-change=${this.handleFormatChange}
            ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.internationalDialingFormat")}"
            >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.internationalDialingFormat")}</md-checkbox
          >
          <md-tooltip
            ?opened=${this.isIntenationalTooltipOpened}
            ?disabled="${this.isDefaultDnSet}"
            message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.internationalDialingFormatInfo")}"
            placement="top"
            ><md-button
              ?disabled="${this.isDefaultDnSet}"
              ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.internationalDialingFormatInfoButtonLabel")}"
              circle
              variant="ghost"
              class="info-icon international-info-btn"
              size="20"
              @focus=${() => {
                this.isIntenationalTooltipOpened = true;
                this.dispatchAnnouncement((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.internationalDialingFormatInfo"));
            }}
              @blur=${() => (this.isIntenationalTooltipOpened = false)}
            >
              <md-icon name="info-badge-filled" size="16" iconSet="momentumDesign"></md-icon>
            </md-button>
          </md-tooltip>
        </div>

        <!-- phone input -->
        ${this.ifInternationalFormat() ? this.renderInternationalForm() : this.renderDnForm()}
      `;
        }
        handleWxCallAnswerEndpointSelected(e) {
            const newSelection = e.detail.option;
            this.evt("on-preferred-wx-call-answer-endpoint-selected", {
                wxCallAnswerEndpointId: newSelection.id
            });
        }
        renderWebexCallingDeviceSelectionSection() {
            var _a;
            if (this.deviceType !== _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.constants.LoginVoiceOptions.BROWSER &&
                ((_a = this.preferredWxCallAnswerEndpoints) === null || _a === void 0 ? void 0 : _a.length) > 1) {
                const defaultOption = this.preferredWxCallAnswerEndpoints.find((endpoint) => endpoint.id === this.selectedPreferredWxCallAnswerEndpointId);
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) ` <div class="md-input-container sl-combobox roles-combobox">
          <label class="teams-label">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.userProfileSettingsWxCallAnswerEndpointLabel")}</label>
          <md-dropdown
            class="roles-dropdown"
            .title=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.userProfileSettingWxCallAnswerEndpointPlaceholder")}
            .options="${this.preferredWxCallAnswerEndpoints}"
            .defaultOption=${defaultOption || {}}
            option-id="id"
            option-value="name"
            ?newMomentum=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled}
            ?pill=${!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled}
            .visibleOptions=${3}
            @dropdown-selected=${this.handleWxCallAnswerEndpointSelected}
            custom-tab-index=${-1}
          >
          </md-dropdown>
        </div>`;
            }
            else {
                return lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing;
            }
        }
        handleCheckboxChange(e) {
            const checkbox = e.target;
            this.dispatchEvent(new CustomEvent("checkbox-state-changed", {
                detail: { checked: checkbox.checked },
                bubbles: true,
                composed: true
            }));
        }
        renderEmergencyNotificationBody() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <div class="emergency-notification-body">
          <agentx-wc-emergency-notification-content> </agentx-wc-emergency-notification-content>
          <div class="read-the-notification-wrapper">
            <md-checkbox
              id="readNotificationCheckbox"
              slot="checkbox"
              class="read-the-notification"
              @checkbox-change=${this.handleCheckboxChange}
            >
              ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:emergencyServiceNotification.readNotification")}
            </md-checkbox>
          </div>
        </div>
      `;
        }
        renderUserProfileContent() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <div class="user-profile">
          ${(0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
            <!-- Role Select -->
            ${this.displayRoleDropdown
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
                  <div class="md-input-container sl-combobox roles-combobox">
                    <label class="teams-label">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.stationLoginRoleLabel")}</label>
                    <md-dropdown
                      class="roles-dropdown"
                      .title="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.selectRole")}"
                      .options="${this.roles}"
                      option-id="roleId"
                      option-value="roleDisplay"
                      ?newMomentum=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled}
                      ?pill=${!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled}
                      .visibleOptions=${2}
                      @dropdown-selected="${this.handleSelectedRole}"
                      .defaultOption=${this.getSelectedRole()}
                      custom-tab-index=${-1}
                      .autofocus=${this.getRoleSelection()}
                    ></md-dropdown>
                  </div>
                `
                : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}

            <!-- Agent_DN | Extension Section -->
            ${this.isWebRTCEnabled
                ? this.renderVoiceOptionSection()
                : this.displayDNExtension
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
                    <div class="station-login-radio station-login-radio-min">
                      <div class="dial-number-label">
                        <label tabindex="-1" for="dial-number-label"
                          >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.stationLoginDNExtension")}</label
                        >
                        <md-tooltip
                          ?opened=${this.isExtensionTooltipOpened}
                          message=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(extensionInfo)}
                          placement="bottom"
                        >
                          <md-button
                            aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(extensionInfo)}
                            circle
                            variant="white"
                            class="info-icon dn-info-icon-button"
                            role="tooltip"
                            size="20"
                            @focus=${() => (this.isExtensionTooltipOpened = true)}
                            @blur=${() => (this.isExtensionTooltipOpened = false)}
                            @keydown=${this.handleKeyDown}
                          >
                            <md-icon name="info-badge-filled" size="16" iconSet="momentumDesign"></md-icon>
                          </md-button>
                        </md-tooltip>
                      </div>
                      <md-radiogroup
                        class="station-login-radio-group"
                        group-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.stationLoginDNExtension")}"
                        alignment="horizontal"
                        checked="${this.radioSelection}"
                        id="dial-number-label"
                        @keydown=${this.handleKeyDownRadio}
                        @radio-change=${(e) => this.onDNExtensionRadioChange(e)}
                      >
                        <md-radio slot="radio" value="DN" ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(dnStationLogin)}" title="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(dnStationLogin)}"
                          >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(dnStationLogin)}</md-radio
                        >
                        <md-radio
                          slot="radio"
                          value="Extension"
                          ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.extension")}"
                          title="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.extension")}"
                          >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.extension")}
                        </md-radio>
                      </md-radiogroup>
                    </div>

                    ${this.mode === "Extension" ? this.renderExtensionForm() : this.renderDNSection()}
                    ${this.renderWebexCallingDeviceSelectionSection()}
                  `
                    : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
          `}
          <!-- team select -->
          ${this.displayTeamsDropdown ? this.renderTeam() : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
          <!-- For React Agent Profile Component -->
          ${!this.isStationlogin
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
                <div class="remember-me-checkbox-wrapper">
                  <md-checkbox
                    slot="checkbox"
                    ?checked=${this.isRememberMyCredentials}
                    label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.rememberMeProfile")}"
                    class="remember-me-checkbox"
                    @checkbox-change=${() => this.handleRememberMeCheckBoxChange()}
                  >
                    ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.rememberMeProfile")}
                  </md-checkbox>
                </div>
              `
                : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
          <!-- Error Message -->
          ${this.isErrUnknown ? this.renderUnknownError() : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
        </div>
      `;
        }
        render() {
            return this.showEmergencyNotificationWebrtc && !this.isEmergencyModalAlreadyDisplayed
                ? this.renderEmergencyNotificationBody()
                : this.renderUserProfileContent();
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "userRole", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isMonitoringEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isSubmit", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "selectedRoleName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "teamName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "teamId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "dialNumber", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isExtensionUsed", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isDefaultDnSet", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "extensionNumber", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "dialNumberValueForNonUS", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "defaultDn", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isDefaultDnSetFromProfile", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isInternational", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isInternationalFromProfile", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "countryCallingCode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "countryCodeValue", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isRememberMyCredentials", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "auxCodeError", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "fetchUniqueTeamIdError", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "orgId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "agentDbId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "isSubmitProfile", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Array })
    ], Element.prototype, "teams", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "filteredTeamList", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "teamsMeta", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isErrUnknown", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isErrDNRegister", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "reasonCode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isDesktopReasonCodeEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Function })
    ], Element.prototype, "getErrorMsgForReasonCode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isDNAlreadyInUse", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isErrPhone", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isErrPhoneExt", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isExtAlreadyInUse", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isErrExtRegister", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isDNRegisterTimeOut", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isTeamsEmpty", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "usesOtherDN", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "trackingId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isStationlogin", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isExtensionUsedFromProfile", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "usesOtherDNFromProfile", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isMonitoringEnabledFromProfile", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "phoneFormat", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "phoneNumber", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isMaximumSessionsReached", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Array })
    ], Element.prototype, "loginVoiceOptions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "deviceType", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "deviceId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Array })
    ], Element.prototype, "preferredWxCallAnswerEndpoints", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "selectedPreferredWxCallAnswerEndpointId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isWebRTCEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isWebRtcUnsupportedBrowser", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isMicrophoneAccessDenied", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "showEmergencyNotificationWebrtc", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isEmergencyModalAlreadyDisplayed", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isConsultTransferInfiniteScrollEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isErrTeam", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "mode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isErrRole", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "displayRoleDropdown", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "displayTeamsDropdown", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "displayDNExtension", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "radioSelection", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isExtensionTooltipOpened", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isIntenationalTooltipOpened", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "roleInfo", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "paginatedTeamResponse", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.query)(".form-class")
    ], Element.prototype, "form", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.query)("#international-form")
    ], Element.prototype, "internationalForm", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.query)("#ext-form")
    ], Element.prototype, "extForm", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.query)(".footer-buttons")
    ], Element.prototype, "continueButton", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.query)(".dn-info-icon-button")
    ], Element.prototype, "dnInfoIconButton", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.query)(".roles-dropdown")
    ], Element.prototype, "rolesDropDown", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.query)(".station-login-radio-group")
    ], Element.prototype, "telephonyRadio", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.customElement)("agentx-wc-user-profile")
    ], Element);
    UserProfile.Element = Element;
})(UserProfile || (UserProfile = {}));


/***/ }),

/***/ "./src/components/userStationLogin/userStationLogin.scss":
/*!***************************************************************!*\
  !*** ./src/components/userStationLogin/userStationLogin.scss ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.sl-footer {
  padding-top: 11px;
  display: flex;
  flex-direction: column;
  width: 100%;
}

@media screen and (max-height: 540px) {
  md-modal::part(modal-container) {
    max-height: calc(100vh - 2%);
  }
  md-modal::part(modal-content) {
    min-height: 100%;
    max-height: 100vh;
    overflow-y: auto;
  }
}
.sl-form-label {
  color: var(--md-primary-text-color, #171b1f);
  display: block;
  font-family: "CiscoSansTT Regular", sans-serif;
  font-size: 16px;
  font-weight: 800;
  line-height: 24px;
  margin: 0;
  text-align: center;
}

md-modal::part(modal-body) {
  overflow: visible;
}

.md-loading {
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}

.modal-content {
  padding: 0 24px;
}

.btn-submit {
  display: flex;
  justify-content: flex-end;
}

.footer-btn {
  margin-left: 0.75rem;
}

.footer-buttons {
  display: flex;
  justify-content: flex-end;
}

.remember-me-checkbox-wrapper {
  padding-bottom: 15px;
}

.remember-me-checkbox::part(checkbox-label) {
  z-index: 0;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/userStationLogin/userStationLogin.ts":
/*!*************************************************************!*\
  !*** ./src/components/userStationLogin/userStationLogin.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UserStationLogin: () => (/* binding */ UserStationLogin)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../constants */ "./src/constants.ts");
/* harmony import */ var _EmergencyNotification_EmergencyNotificationContent__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../EmergencyNotification/EmergencyNotificationContent */ "./src/components/EmergencyNotification/EmergencyNotificationContent.ts");
/* harmony import */ var _teamsListInfiniteScroll__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./../teamsListInfiniteScroll */ "./src/components/teamsListInfiniteScroll/index.ts");
/* harmony import */ var _userStationLogin_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./userStationLogin.scss */ "./src/components/userStationLogin/userStationLogin.scss");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./utils */ "./src/components/userStationLogin/utils.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};













const cancelButtonLabel = "app:common.cancelButton";
const signOutButtonLabel = "app:common.signOutButton";
const EventLogoutConfirm = "logout-confirm";
const ErrId = "Service.aqm.configs.application";
const EventNameError = "login-error";
const phoneFormats = { international: "International", us: "US", other: "Other" };
var UserStationLogin;
(function (UserStationLogin) {
    /**
     * @element agentx-wc-user-station-login
     * @fires login-success
     * @fires @login-error
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_5__.LitElement) {
        constructor() {
            super(...arguments);
            this.isModalOpen = false;
            this.isAdvancedHeader = false;
            this.isDesktopReasonCodeEnabled = false;
            this.getErrorMsgForReasonCode = Function;
            this.roleFromMe = "";
            this.organizationId = "";
            this.meUserId = "";
            this.isMonitoringEnabled = false;
            this.selectedRoleName = _constants__WEBPACK_IMPORTED_MODULE_8__.AGENT;
            this.isDesktopMaxSessionLimitsEnabled = false;
            this.isDesktopMaerskAcqueonTeamId = false;
            this.isDesktopMSStateSyncEnabled = false;
            this.isDesktopEmergencyNotificationEnabled = false;
            this.isDesktopEnhancedSignInEnabled = false;
            this.phoneFormat = phoneFormats.international;
            this.phoneNumber = "";
            this.isRememberMyCredentials = false;
            this.isWebRTCEnabled = false;
            this.deviceType = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.LoginVoiceOptions.AGENT_DN;
            this.deviceId = "";
            this.reasonCode = "";
            this.isMaerskEnabled = false; // Default FF value is turned OFF.
            this.isDesktopAuxCodesInfiniteScrollEnabled = false;
            this.isConsultTransferInfiniteScrollEnabled = false;
            this.showEmergencyNotificationWebrtc = false;
            this.isEmergencyModalAlreadyDisplayed = false;
            this.availableExtensions = [];
            this.isInitializing = true;
            this.isSubmitBusy = false;
            this.isSubmitDisabled = true;
            this.isSubmitClicked = false;
            this.teamName = "";
            this.teamId = "";
            this.isTeamsEmpty = false;
            this.dialNumber = "";
            this.deviceTypeName = "";
            this.isDefaultDnSet = false;
            this.userRole = [];
            this.loginType = "DN"; // Used for telemetry.
            this.usesOtherDN = false;
            this.dialNumberValueForNonUS = "";
            this.defaultDn = "";
            this.isInternational = true;
            this.isPreferenceSaved = false;
            this.loginVoiceOptions = [];
            this.auxCodeConfig = {
                isError: false,
                fetchCompleted: false
            };
            this.fetchUniqueTeamIdError = false;
            // Station Login Error Flags
            this.isErrUnknown = false;
            this.isErrDNRegister = false;
            this.isDNAlreadyInUse = false;
            this.isErrPhone = false;
            this.isErrPhoneExt = false;
            this.isExtAlreadyInUse = false;
            this.isErrExtRegister = false;
            this.isDNRegisterTimeOut = false;
            this.isMaximumSessionsReached = false;
            this.isWebRtcUnsupportedBrowser = false;
            this.isMicrophoneAccessDenied = false;
            this.paginatedTeamResponse = {
                meta: {
                    links: {},
                    orgid: "",
                    page: 0,
                    pageSize: 0,
                    totalPages: 0,
                    totalRecords: 0
                },
                data: []
            };
            this.autoLoginType = _constants__WEBPACK_IMPORTED_MODULE_8__.AutoLoginType.None;
            this.profileChanged = false;
            // TODO: The types from Service.Conf holds good for Agent. Supervisor might not have all fields.
            this.profile = null;
            this.teams = [];
            this.selectedTeam = { teamId: "", teamName: "" };
            this.defaultAuxCode = "";
            this.extensionNumber = "";
            this.trackingId = "";
            this.isExtensionUsed = false;
            this.countryCodeValue = "+1"; // initial country code of US.
            this.countryCallingCode = "+1, United States of America, US";
            this.lang = localStorage.getItem("lng") || "en";
            this.getAuxCodeParameters = () => {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                return {
                    idleCodeConfig: {
                        accessType: (_a = this.profile) === null || _a === void 0 ? void 0 : _a.idleCodesAccess,
                        ids: (_b = this.profile) === null || _b === void 0 ? void 0 : _b.idleCodesList
                    },
                    wrapUpCodeConfig: {
                        accessType: (_e = (_d = (_c = this.profile) === null || _c === void 0 ? void 0 : _c.wrapUpData) === null || _d === void 0 ? void 0 : _d.wrapUpProps) === null || _e === void 0 ? void 0 : _e.wrapUpCodeAccess,
                        ids: ((_h = (_g = (_f = this.profile) === null || _f === void 0 ? void 0 : _f.wrapUpData) === null || _g === void 0 ? void 0 : _g.wrapUpProps) === null || _h === void 0 ? void 0 : _h.wrapUpCodesList) || []
                    }
                };
            };
            this.getDefaultWorkTypeCode = (auxCodesList, workTypeCode) => {
                var _a, _b;
                const response = auxCodesList.find((auxCode) => auxCode.workTypeCode === workTypeCode);
                return {
                    id: (_a = response === null || response === void 0 ? void 0 : response.id) !== null && _a !== void 0 ? _a : "",
                    name: (_b = response === null || response === void 0 ? void 0 : response.name) !== null && _b !== void 0 ? _b : ""
                };
            };
            // Handling team selection from infinite scroll team selection component
            this.onTeamSelect = (e) => {
                const { teamName, teamId } = e.detail;
                this.selectedTeam = { teamId, teamName };
            };
            this.isOnlySupervisor = () => {
                return this.getIfSupervisorRole() && this.isTeamsEmpty;
            };
            this.dispatchLoginError = (ctx, details, errorID, reasonVal) => {
                ctx.evt(EventNameError, {
                    id: errorID,
                    message: details.status && details.status === 400 && details.type === "Unauthorized"
                        ? "Token Unauthorized"
                        : "Config Failed",
                    trackingId: this.getTrackingID(details.trackingId),
                    reasonCode: ctx.reasonCode,
                    advancedHeader: ctx.advanceHeaderTracker(),
                    deviceType: ctx.deviceType,
                    loginType: ctx.loginType,
                    reason: reasonVal
                });
            };
            this.autologin = () => {
                var _a;
                this.autoLoginType = _constants__WEBPACK_IMPORTED_MODULE_8__.AutoLoginType.Supervisor;
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.trace("Login/Station/Supervisor/AutoLogin/Init");
                const stationLoginData = {
                    dnNumber: "",
                    isExtension: false,
                    teamId: null,
                    teamName: null,
                    roles: ["supervisor"],
                    usesOtherDN: false,
                    extensionNumber: "",
                    dialNumberValueForNonUS: "",
                    defaultDn: "",
                    isDefaultDnSet: false,
                    isInternational: false,
                    phoneNumber: "",
                    countryCallingCode: "",
                    countryCodeValue: "",
                    isRememberMyCredentials: false,
                    deviceType: null,
                    deviceId: ""
                };
                this.handleStationLoginSubmit({ profileDetail: stationLoginData, loggedInRole: (_a = this.userRole) === null || _a === void 0 ? void 0 : _a.join("_") }, true);
            };
            this.getSpecificIdleCode = (auxCodeId) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const response = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.abs.fetchIdleCodes({
                        orgId: this.organizationId,
                        accessType: "SPECIFIC",
                        ids: [auxCodeId]
                    });
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.debug("Login/Station/FetchIdleCodes/Success");
                    return response;
                }
                catch (error) {
                    if (error instanceof Error) {
                        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/FetchIdleCodes/Error", error.message);
                    }
                    else {
                        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/FetchIdleCodes/Error", "unknown error");
                    }
                    throw error;
                }
            });
            this.requestCILogout = () => {
                this.evt("ci-logout", {
                    userLogout: "station"
                });
            };
            this.cancelLogout = () => {
                this.isModalOpen = true;
            };
            this.logout = () => {
                const logoutResponse = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.agent.logout({ data: { logoutReason: "User requested logout" } });
                logoutResponse
                    .then(() => __awaiter(this, void 0, void 0, function* () {
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.debug("Login/Station/Logout/Success");
                    if (this.isWebRTCEnabled && this.deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.LoginVoiceOptions.BROWSER) {
                        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.trace("Login/Station/WebRtc/DeregisterWebCalling");
                        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.webCalling.deregisterWebCalling();
                    }
                }))
                    .catch((err) => {
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/Logout/Error", `${err}`);
                })
                    .finally(() => {
                    this.requestCILogout();
                });
            };
        }
        get dialPlanRegexes() {
            var _a, _b;
            return ((_b = (_a = this.dialPlan) === null || _a === void 0 ? void 0 : _a.dialPlanEntity) === null || _b === void 0 ? void 0 : _b.map((dialPlan) => dialPlan.regex)) || [];
        }
        get availableLoginVoiceOptions() {
            return this.isWebRTCEnabled
                ? this.loginVoiceOptions
                : this.loginVoiceOptions.filter((entry) => entry !== "BROWSER");
        }
        get preferenceVoiceOption() {
            if (!this.deviceType) {
                return this.isExtensionUsed ? "EXTENSION" : "AGENT_DN";
            }
            return this.deviceType === "BROWSER" ? "BROWSER" : this.deviceType === "EXTENSION" ? "EXTENSION" : "AGENT_DN";
        }
        get loginVoiceInfoTooltipMessage() {
            const voiceOptionInfoMessageMapping = {
                AGENT_DN: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.dialNumberInfoTooltip"),
                EXTENSION: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.extensionInfoTooltip"),
                BROWSER: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.desktopInfoTooltip")
            };
            const tooltipMessages = this.availableLoginVoiceOptions.map((option) => voiceOptionInfoMessageMapping[option]);
            return tooltipMessages.join(" / ");
        }
        get userStationLoginLocalization() {
            return {
                stationCredentials: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.stationCredentials"),
                confirmInteractionProperties: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.confirmInteractionProperties"),
                checkDetails: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.checkDetails"),
                rememberMe: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.enhancedRememberMe"),
                signOutButton: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.signOut"),
                confirmButton: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.confirm"),
                cancelButton: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.cancelButton"),
                continueButton: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.continueButton"),
                dialNumberSelectionTitle: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.dialNumberSelectionTitle"),
                dialNumberPlaceholder: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.dialNumberPlaceHolder"),
                dialNumberInvalid: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.stationLoginInvalidNumber"),
                extensionInfo: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.extensionInfo"),
                extensionPlaceHolder: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.extensionPlaceHolder"),
                extensionSelectionTitle: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.extension"),
                extensionInvalid: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.stationLoginInvalidExtNumber"),
                teamSelectionTitle: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.teamSelectionTitle"),
                selectTeam: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.selectTeam"),
                roleSelectionTitle: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.roleSelectionTitle"),
                selectRole: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.selectRole"),
                supervisorRole: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.supervisorRole"),
                supervisorAndAgentRole: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.supervisorAndAgentRole"),
                loginVoiceInfoButtonLabel: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.loginVoiceInfoButtonLabel"),
                loginVoiceInfo: this.loginVoiceInfoTooltipMessage,
                voiceSelectionTitle: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.voiceSelectionTitle"),
                voiceOptionDialNumber: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.agent_dn"),
                voiceOptionExtension: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.extension"),
                voiceOptionDesktop: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.browser"),
                emergencyNotificationTitle: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:emergencyServiceNotification.emergencyServiceNotification"),
                emergencyNotificationSubTitle: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:emergencyServiceNotification.dialingEmergencyServices"),
                emergencyNotificationContent: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:emergencyServiceNotification.dialingEmergencyServicesContent"),
                emergencyNotificationWarningMessage: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:emergencyServiceNotification.updateCurrentAddInfoOnSecondSignIn"),
                emergencyNotificationWarningLinkText: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:emergencyServiceNotification.seeHelpSection"),
                emergencyNotificationAcknowledgement: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:emergencyServiceNotification.readNotification")
            };
        }
        getTelephonyErrorInfo() {
            let errorType = "none";
            let errorMessage = "";
            const errMsg = this.getErrorMsgForReasonCode(this.reasonCode);
            if (this.isDesktopReasonCodeEnabled && this.reasonCode && errMsg) {
                if (this.deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.LoginVoiceOptions.AGENT_DN) {
                    errorType = "dialNumberError";
                }
                else if (this.deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.LoginVoiceOptions.EXTENSION) {
                    errorType = "extensionError";
                }
                return { errorType, errorMessage: errMsg };
            }
            if (this.isErrDNRegister) {
                errorType = "dialNumberError";
                errorMessage = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:dnRegisterFailure");
                if (this.isDNAlreadyInUse) {
                    errorMessage = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:dnAlreadyInUse");
                }
            }
            if (this.isErrExtRegister) {
                errorType = "extensionError";
                errorMessage = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:dnRegisterFailure");
                if (this.isExtAlreadyInUse) {
                    errorMessage = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:dnAlreadyInUse");
                }
            }
            return { errorType, errorMessage };
        }
        getUnknownErrorMessage() {
            if (this.isWebRTCEnabled && this.deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.LoginVoiceOptions.BROWSER) {
                if (this.isMicrophoneAccessDenied) {
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:microphoneAccessDeniedError");
                }
                if (this.isWebRtcUnsupportedBrowser) {
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:browserUnsupportedError");
                }
            }
            if (this.isMaximumSessionsReached) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:maximumSessionsReachedError");
            }
            if (this.fetchUniqueTeamIdError) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:fetchTeamIdFailed");
            }
            return this.isDNRegisterTimeOut
                ? this.deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.LoginVoiceOptions.EXTENSION
                    ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:extNumberRegisterTimeout")
                    : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:dnRegisterTimeout")
                : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:stationLoginFailed");
        }
        get errorInfo() {
            const error = this.getTelephonyErrorInfo();
            if (error.errorType === "none" && this.isErrUnknown) {
                error.errorType = "unknown";
                error.errorMessage = this.getUnknownErrorMessage();
            }
            if (error.errorMessage.length > 0) {
                const trackingIdEntry = `${this.trackingId ? ` (${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorModal:trackingIdLabel")}: ${this.trackingId})` : ""}`;
                error.errorMessage = `${error.errorMessage}${trackingIdEntry}`;
            }
            return { errorType: error.errorType, errorMessage: error.errorMessage };
        }
        advanceHeaderTracker() {
            if (this.isAdvancedHeader) {
                return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.ADVANCED_HEADER_ENABLED;
            }
            else {
                return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.ADVANCED_HEADER_DISABLED;
            }
        }
        // ROST: create decorator for custom event
        evt(name, detail) {
            this.dispatchEvent(new CustomEvent(name, { bubbles: true, composed: true, detail }));
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.trace(`Login/Event/Dispatch/${name}`, "", detail);
        }
        // TODO: login type in case of reload might not send correct data. Check.
        success(data, isReload) {
            data.loginType = this.loginType;
            data.advancedHeader = this.advanceHeaderTracker();
            data.isReload = isReload;
            if (this.isDesktopAuxCodesInfiniteScrollEnabled) {
                data.initialIdleCodes = this.initialIdleCodes;
            }
            data.systemIdleCodes = this.systemIdleCodes;
            this.evt("login-success", data);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.DARK_MODE_TOGGLE);
            this.isModalOpen = false;
        }
        static get styles() {
            return _userStationLogin_scss__WEBPACK_IMPORTED_MODULE_11__["default"];
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            changedProperties.forEach((oldValue, name) => {
                if (name === "isModalOpen" && oldValue !== undefined) {
                    if (this.isModalOpen) {
                        //Adding this logs to debug StaionLogin issues CX-5123
                        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.trace("Login/Station/Modal/Opened");
                    }
                    else if (this.isModalOpen === false) {
                        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.trace("Login/Station/Modal/Closed");
                    }
                }
            });
        }
        setDefaultAuxCode() {
            var _a;
            if (this.profile) {
                const defaultStateOption = (_a = this.profile.idleCodes) === null || _a === void 0 ? void 0 : _a.find((option) => option.isDefault);
                if (defaultStateOption) {
                    this.defaultAuxCode = defaultStateOption.id.toString();
                }
            }
        }
        updateWrapUpCodeConfig(currentDefaultAuxCodes, wrapUpCodes) {
            if (this.profile) {
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.updateWrapUpCodeConfig(wrapUpCodes);
                // Set default wrap up code to conf-service
                if (currentDefaultAuxCodes && (currentDefaultAuxCodes === null || currentDefaultAuxCodes === void 0 ? void 0 : currentDefaultAuxCodes.length) > 0) {
                    const defaultWrapUpCode = this.getDefaultWorkTypeCode(currentDefaultAuxCodes, "WRAP_UP_CODE");
                    if (defaultWrapUpCode) {
                        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.setDefaultWrapUpCode(defaultWrapUpCode);
                    }
                    else {
                        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.warn("Login/Station/FetchAuxCodes/DefaultWrapUpCodeNotFound");
                    }
                }
                this.profile = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.profile; // Update the profile values after fetching the aux codes.
            }
        }
        updateAuxCodes(idleCodes, wrapUpCodes) {
            if (this.profile) {
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.updateAuxCodeConfig(idleCodes, wrapUpCodes);
                this.profile = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.profile; // Update the profile values after fetching the aux codes.
                if (!this.isDesktopAuxCodesInfiniteScrollEnabled) {
                    this.setDefaultAuxCode();
                }
            }
        }
        fetchTeamDataById(selectTeamDbId) {
            return __awaiter(this, void 0, void 0, function* () {
                if (!this.profile) {
                    return false;
                }
                try {
                    const filterPayload = { dbId: selectTeamDbId };
                    const team = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.cms.fetchAllTeams(this.profile.orgId, filterPayload);
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.debug("Login/Station/FetchTeamById/Success", "", Object.assign({ orgId: this.profile.orgId, teamId: selectTeamDbId }, team));
                    if (Array.isArray(team) && team.length > 0) {
                        return team[0].id;
                    }
                    else {
                        this.isErrUnknown = true;
                        this.fetchUniqueTeamIdError = true;
                        return false;
                    }
                }
                catch (_error) {
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/FetchTeamById/Error", "", {
                        orgId: this.profile.orgId,
                        teamId: selectTeamDbId,
                        error: _error
                    });
                    this.isErrUnknown = true;
                    this.fetchUniqueTeamIdError = true;
                    return false;
                }
            });
        }
        setDefaultAuxCodes(currentDefaultAuxCodes, agentStateIdleCodes) {
            var _a;
            this.initialIdleCodes = agentStateIdleCodes;
            if (currentDefaultAuxCodes && (currentDefaultAuxCodes === null || currentDefaultAuxCodes === void 0 ? void 0 : currentDefaultAuxCodes.length) > 0) {
                // Set default idle code to conf-service
                const defaultIdleCode = this.getDefaultWorkTypeCode(currentDefaultAuxCodes, "IDLE_CODE");
                if (defaultIdleCode) {
                    this.defaultAuxCode = (_a = defaultIdleCode === null || defaultIdleCode === void 0 ? void 0 : defaultIdleCode.id.toString()) !== null && _a !== void 0 ? _a : "";
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.setDefaultIdleCode(defaultIdleCode);
                }
                else {
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.warn("Login/Station/FetchAuxCodes/DefaultIdleCodeNotFound");
                }
            }
        }
        fetchAuxCodes(shouldFetchDefaultIdleCode = false) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const { idleCodeConfig, wrapUpCodeConfig } = this.getAuxCodeParameters();
                    const response = yield (0,_utils__WEBPACK_IMPORTED_MODULE_12__.fetchAuxCodeValues)(this.organizationId, idleCodeConfig, wrapUpCodeConfig, this.isDesktopAuxCodesInfiniteScrollEnabled, shouldFetchDefaultIdleCode);
                    const [idleCodes, wrapUpCodes, defaultAuxCodes, systemIdleCodes] = response;
                    const allWrapUpCodes = wrapUpCodes;
                    if (this.isDesktopAuxCodesInfiniteScrollEnabled) {
                        const currentDefaultAuxCodes = defaultAuxCodes;
                        const agentStateIdleCodes = idleCodes;
                        const agentWrapUpCodes = wrapUpCodes;
                        this.setDefaultAuxCodes(currentDefaultAuxCodes, agentStateIdleCodes);
                        this.updateWrapUpCodeConfig(currentDefaultAuxCodes, agentWrapUpCodes);
                    }
                    else {
                        const allIdleCodes = idleCodes;
                        this.updateAuxCodes(allIdleCodes, allWrapUpCodes);
                    }
                    this.systemIdleCodes = systemIdleCodes;
                    this.auxCodeConfig.fetchCompleted = true;
                    this.auxCodeConfig.isError = false;
                    return true;
                }
                catch (error) {
                    this.trackingId = (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.getTrackingIdFromErrorObject)(error);
                    this.auxCodeConfig.fetchCompleted = false;
                    this.auxCodeConfig.isError = true;
                    this.isErrUnknown = true;
                    return false;
                }
            });
        }
        connectedCallback() {
            super.connectedCallback();
            this.init();
            window.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_8__.SUPERVISOR_AUTO_LOGIN_EVENT, this.autologin);
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            window.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_8__.SUPERVISOR_AUTO_LOGIN_EVENT, this.autologin);
        }
        getTrackingID(trackingIdValue) {
            return trackingIdValue.split("_").length > 1 ? trackingIdValue.split("_")[1] : trackingIdValue.split("_")[0];
        }
        getIfSupervisorRole() {
            return this.roleFromMe.toLocaleLowerCase() === _constants__WEBPACK_IMPORTED_MODULE_8__.SUPERVISOR.toLocaleLowerCase();
        }
        getDeviceType(deviceType, isExtension) {
            if (deviceType) {
                return this.isWebRTCEnabled ? deviceType === null || deviceType === void 0 ? void 0 : deviceType.toUpperCase() : deviceType;
            }
            return isExtension ? _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.LoginVoiceOptions.EXTENSION : _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.LoginVoiceOptions.AGENT_DN;
        }
        getLoginType(isExtension, roles) {
            const mode = isExtension ? "EXT" : "DN";
            // Agent & Agent + Supervisor: DN and Team should be present.
            // Only Supervisor: If monitoring enabled DN/EXT should be present.
            const isDnExtEnabled = (roles === null || roles === void 0 ? void 0 : roles.includes(_constants__WEBPACK_IMPORTED_MODULE_8__.AGENT)) || this.isMonitoringEnabled;
            return isDnExtEnabled ? mode : "NA";
        }
        /**
         * Determine userRole and update STORE.agent.userRole.
         * userRole possible values: ["agent"], ["supervisor"], and ["agent", "supervisor"]
         * Order ["agent", "supervisor"] is important for comparison done later.
         */
        updateUserRole() {
            let newUserRole;
            if (this.getIfSupervisorRole()) {
                newUserRole = this.isTeamsEmpty ? [_constants__WEBPACK_IMPORTED_MODULE_8__.SUPERVISOR] : [_constants__WEBPACK_IMPORTED_MODULE_8__.AGENT, _constants__WEBPACK_IMPORTED_MODULE_8__.SUPERVISOR];
            }
            else {
                newUserRole = [_constants__WEBPACK_IMPORTED_MODULE_8__.AGENT];
            }
            this.userRole = newUserRole;
        }
        // Error Handlers For SERVICE.conf.fetchProfile()
        init() {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
            return __awaiter(this, void 0, void 0, function* () {
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.debug("Login/Station/Init");
                this.profile = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.profile
                    ? _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.profile
                    : yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.fetchProfile(this.organizationId, this.meUserId, this.getIfSupervisorRole());
                if (this.isConsultTransferInfiniteScrollEnabled) {
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.updateProfileTeamsMeta((_a = this.profile) === null || _a === void 0 ? void 0 : _a.teamsMeta);
                }
                if (this.isWebRTCEnabled && ((_b = this.profile.loginVoiceOptions) === null || _b === void 0 ? void 0 : _b.length) === 0) {
                    this.evt("no-voice-options-error", {
                        header: "",
                        message: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.noLoginVoiceOptionsError"),
                        noExitOnEsc: true,
                        buttons: [{ type: "ok", label: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(signOutButtonLabel), onClick: this.logout }]
                    });
                    return;
                }
                this.loginVoiceOptions = this.profile.loginVoiceOptions || _constants__WEBPACK_IMPORTED_MODULE_8__.DEFAULT_DEVICE_TYPE;
                this.evt("update-analyser-id", {
                    analyzerId: (_c = this.profile.analyserUserId) !== null && _c !== void 0 ? _c : this.profile.agentDbId
                });
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.register({
                    AgentId: this.profile.agentId,
                    TenantId: this.profile.enterpriseId,
                    SiteId: this.profile.siteId,
                    OrgId: this.profile.orgId,
                    Locale: navigator.language,
                    [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.PLATFORM_TYPE]: window.matchMedia("(display-mode: standalone)").matches
                        ? "App"
                        : "Browser"
                });
                this.profile.teams.sort((t1, t2) => {
                    return t1.teamName.localeCompare(t2.teamName);
                });
                this.teams = this.profile.teams;
                this.isTeamsEmpty = !(this.teams && this.teams.length > 0 && ((_d = this.teams[0]) === null || _d === void 0 ? void 0 : _d.teamId));
                const defaultTeam = this.teams && this.teams.length > 0 ? this.teams[0].teamName : "";
                this.teamName = this.isTeamsEmpty ? "" : defaultTeam;
                this.teamId = this.isTeamsEmpty ? "" : this.teams[0].teamId;
                this.selectedTeam = { teamId: this.teamId, teamName: this.teamName };
                if (this.isConsultTransferInfiniteScrollEnabled) {
                    this.paginatedTeamResponse.data = this.teams;
                    this.paginatedTeamResponse.meta = (_e = this.profile.teamsMeta) !== null && _e !== void 0 ? _e : {
                        links: {},
                        orgid: "",
                        page: 0,
                        pageSize: 0,
                        totalPages: 0,
                        totalRecords: 0
                    };
                }
                this.defaultDn = this.profile.defaultDn || "";
                this.dialNumber = this.dialNumberValueForNonUS = this.extensionNumber = this.phoneNumber = this.defaultDn;
                this.isDefaultDnSet = ((_f = this.profile.defaultDn) === null || _f === void 0 ? void 0 : _f.length) > 0 ? this.profile.forceDefaultDnForAgent : false;
                this.dialPlan = this.profile.dialPlan;
                this.isMonitoringEnabled = this.profile.isCallMonitoringEnabled || false;
                this.isInternational = ((_g = this.profile.defaultDn) === null || _g === void 0 ? void 0 : _g.length) > 0 ? false : true;
                if (!this.isOnlySupervisor() &&
                    (((_j = (_h = this.profile) === null || _h === void 0 ? void 0 : _h.microsoftConfig) === null || _j === void 0 ? void 0 : _j.showUserDetailsMS) ||
                        (this.isDesktopMSStateSyncEnabled && ((_l = (_k = this.profile) === null || _k === void 0 ? void 0 : _k.microsoftConfig) === null || _l === void 0 ? void 0 : _l.stateSynchronizationMS)))) {
                    // Show user details in MS
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.trace("Login/Station/Dispatch/InitiateMSAuthFlow");
                    this.evt(_constants__WEBPACK_IMPORTED_MODULE_8__.INITIATE_MS_AUTH_LOGIN, { orgId: this.profile.orgId, microsoftConfig: (_m = this.profile) === null || _m === void 0 ? void 0 : _m.microsoftConfig });
                }
                if (!this.isMaerskEnabled) {
                    this.setDefaultAuxCode();
                }
                this.phoneFormat =
                    this.isDefaultDnSet || ((_o = this.profile.defaultDn) === null || _o === void 0 ? void 0 : _o.length) > 0 ? phoneFormats.other : phoneFormats.international;
                this.updateUserRole();
                this.requestUpdate();
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATION_LOGIN, [
                    (_q = (_p = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _p === void 0 ? void 0 : _p.SERVICE_PROVIDERS) === null || _q === void 0 ? void 0 : _q.webex_behavioral,
                    (_s = (_r = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _r === void 0 ? void 0 : _r.SERVICE_PROVIDERS) === null || _s === void 0 ? void 0 : _s.webex_business
                ]);
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.trace("Login/Station/Reload");
                yield this.agentReload();
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.agent.eAgentDNRegisterFailure.listen((data) => {
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.trace("Login/Station/AgentDNRegisterFailure", "", data);
                    this.isSubmitBusy = false;
                    const isNumberAlreadyInUse = data.data.reason === "DUPLICATE_LOCATION" && data.data.reasonCode === 400;
                    this.reasonCode = data.data.reasonCode;
                    if (this.isExtensionUsed) {
                        this.isErrExtRegister = true;
                        if (isNumberAlreadyInUse) {
                            this.isExtAlreadyInUse = true;
                        }
                        this.isErrPhoneExt = false;
                    }
                    else {
                        this.isErrDNRegister = true;
                        if (isNumberAlreadyInUse) {
                            this.isDNAlreadyInUse = true;
                        }
                        this.isErrPhone = false;
                    }
                    this.isErrUnknown = false;
                    this.trackingId = this.getTrackingID(data.data.trackingId);
                });
            });
        }
        fetchSavedPreferences() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const userPreferences = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.userPrefs.fetchUserPreferences({
                        orgId: this.organizationId,
                        userId: this.meUserId
                    });
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.trace("Login/Station/FetchUserPreferences/Success", "", userPreferences);
                    if (userPreferences) {
                        this.isPreferenceSaved = true;
                        const desktopPreference = JSON.parse(userPreferences.desktopPreference);
                        this.evt("update-user-preference-storage", userPreferences);
                        if (desktopPreference) {
                            yield this.processCommonFetchedPreferences(desktopPreference);
                            if (this.isDesktopEnhancedSignInEnabled) {
                                this.processEnhancedFetchedPreferences(desktopPreference);
                            }
                            else {
                                this.processLegacyFetchedPreferences(desktopPreference);
                            }
                        }
                    }
                    else {
                        this.isPreferenceSaved = false;
                    }
                }
                catch (_error) {
                    this.isPreferenceSaved = false;
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/FetchUserPreferences/Error", `${_error}`);
                    this.evt("save-update-user-prefs-failed", {
                        isPrefSaved: this.isPreferenceSaved
                    });
                }
                // Updating this flag here to know if preferences are already saved or not.
                // Using this flag to perform save/update action when called from user station login & user profile settings
                this.evt("update-flag-user-prefs-saved", {
                    isPrefSaved: this.isPreferenceSaved
                });
            });
        }
        processCommonFetchedPreferences(desktopPreference) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                this.selectedRoleName = desktopPreference.selectedRoleName;
                let teamName = ((_a = this.teams.find((team) => team.teamId === desktopPreference.teamId)) === null || _a === void 0 ? void 0 : _a.teamName) || "";
                if (teamName === "" && this.isConsultTransferInfiniteScrollEnabled) {
                    const { teamName: fetchedTeamName, teamId: fetchedTeamId } = yield this.getTeamNameAndId(desktopPreference.teamId);
                    teamName = fetchedTeamName || "";
                    desktopPreference.teamId = fetchedTeamId || "";
                    this.selectedRoleName = teamName;
                }
                if (teamName) {
                    this.teamName = teamName;
                    this.teamId = desktopPreference.teamId;
                    this.selectedTeam = { teamId: this.teamId, teamName: this.teamName };
                }
                this.extensionNumber = this.isDefaultDnSet
                    ? (_b = this.profile) === null || _b === void 0 ? void 0 : _b.defaultDn
                    : desktopPreference.extensionNumber || ((_c = this.profile) === null || _c === void 0 ? void 0 : _c.defaultDn);
                this.isExtensionUsed = desktopPreference.isExtension;
                this.isRememberMyCredentials = desktopPreference.isRememberMyCredentials;
                this.deviceType = this.getDeviceType(desktopPreference.deviceType, desktopPreference.isExtension);
                this.deviceId = desktopPreference.deviceId;
                this.isEmergencyModalAlreadyDisplayed = desktopPreference.isEmergencyModalAlreadyDisplayed;
            });
        }
        processEnhancedFetchedPreferences(desktopPreference) {
            var _a, _b;
            this.dialNumber = this.isDefaultDnSet
                ? (_a = this.profile) === null || _a === void 0 ? void 0 : _a.defaultDn
                : desktopPreference.dialNumber || ((_b = this.profile) === null || _b === void 0 ? void 0 : _b.defaultDn);
            this.dialNumberValueForNonUS = "";
            this.isInternational = false;
            this.phoneNumber = "";
            this.phoneFormat = phoneFormats.other;
            this.countryCallingCode = "";
            this.countryCodeValue = "";
        }
        processLegacyFetchedPreferences(desktopPreference) {
            var _a, _b, _c;
            this.dialNumberValueForNonUS = this.isDefaultDnSet
                ? (_a = this.profile) === null || _a === void 0 ? void 0 : _a.defaultDn
                : desktopPreference.dialNumberValueForNonUS || ((_b = this.profile) === null || _b === void 0 ? void 0 : _b.defaultDn);
            this.isInternational = this.isDefaultDnSet ? false : desktopPreference.isInternational;
            this.phoneNumber = this.isInternational ? desktopPreference.internationalPhoneNumber : (_c = this.profile) === null || _c === void 0 ? void 0 : _c.defaultDn;
            this.phoneFormat =
                !this.isDefaultDnSet && desktopPreference.isInternational ? phoneFormats.international : phoneFormats.other;
            this.countryCallingCode = desktopPreference.countryCallingCode || this.countryCallingCode;
            this.countryCodeValue = desktopPreference.countryCodeValue || this.countryCodeValue;
        }
        getUserProfileData() {
            return {
                role: this.userRole.join("_"),
                loginOption: this.preferenceVoiceOption,
                dialNumber: this.preferenceVoiceOption === "AGENT_DN" ? this.dialNumber : "",
                extensionNumber: this.preferenceVoiceOption === "EXTENSION" ? this.extensionNumber : "",
                team: { teamId: this.teamId, teamName: this.teamName }
            };
        }
        agentAutoLogin() {
            this.autoLoginType = _constants__WEBPACK_IMPORTED_MODULE_8__.AutoLoginType.Agent;
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.trace("Login/Station/Agent/AutoLogin/Init");
            const profileData = this.getUserProfileData();
            this.handleUserProfileDataAvailable(profileData);
        }
        // Error Handlers For SERVICE.aqm.agent.reload()
        agentReload() {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
            return __awaiter(this, void 0, void 0, function* () {
                if (!this.profile) {
                    return;
                }
                const reload = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.agent.reload();
                const shouldFetchAuxCodes = yield this.shouldFetchAuxCodes();
                if (shouldFetchAuxCodes && !this.auxCodeConfig.fetchCompleted && !this.isOnlySupervisor()) {
                    // For pure supervisor aux codes are not required.
                    const isAuxCodeUpdated = yield this.fetchAuxCodes(true);
                    if (!isAuxCodeUpdated) {
                        // Prevent the station login, Show the error message.
                        this.evt("aux-code-error", {});
                        return;
                    }
                }
                const { dn, agentId, teamId, auxCodeId, lastStateChangeTimestamp, lastIdleCodeChangeTimestamp, lastStateChangeReason, profileType, channelsMap, interactionIds, isExtension, roles, deviceType, deviceId } = reload.data;
                this.loginType = this.getLoginType(isExtension, undefined);
                // Load the team unique id, when isDesktopMaerskAcqueonTeamId FF is on.
                // This ID is required to use the acquon team id.
                let teamUniqueId = "";
                if (this.isDesktopMaerskAcqueonTeamId && teamId) {
                    teamUniqueId = yield this.fetchTeamDataById(teamId);
                    if (!teamUniqueId) {
                        // On Reload, Prevent the station login, Show the error message.
                        this.evt("acqueon-fetch-team-id-error", {});
                        return;
                    }
                }
                let subStatus = "Available";
                if (auxCodeId && auxCodeId !== "0") {
                    if (this.isDesktopAuxCodesInfiniteScrollEnabled) {
                        const idleCodeStatus = (_d = (_c = (_b = (_a = this.initialIdleCodes) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.find((c) => c.id.toString() === auxCodeId)) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : "";
                        if (!idleCodeStatus) {
                            const response = yield this.getSpecificIdleCode(auxCodeId);
                            if (response && (response === null || response === void 0 ? void 0 : response.length) > 0) {
                                subStatus = response[0].name;
                            }
                        }
                        else {
                            subStatus = idleCodeStatus;
                        }
                    }
                    else {
                        subStatus = (_f = (_e = this.profile.idleCodes.find((c) => c.id.toString() === auxCodeId)) === null || _e === void 0 ? void 0 : _e.name) !== null && _f !== void 0 ? _f : "";
                    }
                }
                let teamName = ((_g = this.profile.teams.find((team) => team.teamId === teamId)) === null || _g === void 0 ? void 0 : _g.teamName) || "";
                /** check if team exists */
                if (teamName === "" && this.isConsultTransferInfiniteScrollEnabled) {
                    const response = yield (0,_utils__WEBPACK_IMPORTED_MODULE_12__.fetchTeamList)(this.profile.orgId, 0, ((_h = this.profile) === null || _h === void 0 ? void 0 : _h.analyserUserId) || ((_j = this.profile) === null || _j === void 0 ? void 0 : _j.agentDbId), "", teamId);
                    teamName = response ? (_k = response.data[0]) === null || _k === void 0 ? void 0 : _k.teamName : "";
                }
                if (!teamName && !this.getIfSupervisorRole()) {
                    this.evt(EventLogoutConfirm, {
                        header: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorModal.header"),
                        message: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.teamDeletedError"),
                        noExitOnEsc: true,
                        buttons: [{ type: "ok", label: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(signOutButtonLabel), onClick: this.logout }]
                    });
                    return;
                }
                this.success({
                    dn,
                    agentId,
                    usesOtherDN: this.usesOtherDN,
                    isExtension,
                    teamId,
                    teamUniqueId,
                    teamName,
                    subStatus,
                    lastStateChangeTimestamp,
                    lastIdleCodeChangeTimestamp,
                    lastStateChangeReason: lastStateChangeReason ? lastStateChangeReason : "",
                    profileType,
                    interactionIds,
                    mmProfile: {
                        voiceCount: (_l = channelsMap["telephony"]) === null || _l === void 0 ? void 0 : _l.length,
                        chatCount: (_m = channelsMap["chat"]) === null || _m === void 0 ? void 0 : _m.length,
                        emailCount: (_o = channelsMap["email"]) === null || _o === void 0 ? void 0 : _o.length,
                        socialCount: (_p = channelsMap["social"]) === null || _p === void 0 ? void 0 : _p.length
                    },
                    defaultDn: this.defaultDn,
                    isDefaultDnSet: this.isDefaultDnSet,
                    userRole: this.userRole,
                    deviceType,
                    deviceId,
                    selectedRoleName: roles ? roles.join("_") : ""
                }, true);
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.debug("Login/Station/AgentReload/Success", "", {
                    isWebRTCEnabled: this.isWebRTCEnabled,
                    _deviceType: deviceType,
                    isWebRtcSupportedBrowser: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__.isWebRtcSupportedBrowser)()
                });
                if (this.isWebRTCEnabled &&
                    deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.LoginVoiceOptions.BROWSER &&
                    !(0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__.isWebRtcSupportedBrowser)()) {
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/UnsuportedBrowser/Logout/Confim", "", {
                        isWebRtcSupportedBrowser: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__.isWebRtcSupportedBrowser)()
                    });
                    this.evt(EventLogoutConfirm, {
                        header: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorModal.header"),
                        message: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:browserUnsupportedError"),
                        noExitOnEsc: true,
                        buttons: [{ type: "ok", label: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(signOutButtonLabel), onClick: this.logout }]
                    });
                    return;
                }
                this.isInitializing = false;
            });
        }
        showEmergencyModal() {
            return (this.isDesktopEmergencyNotificationEnabled &&
                this.deviceTypeName === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.LoginVoiceOptions.BROWSER &&
                !this.isEmergencyModalAlreadyDisplayed);
        }
        /** Inform UserProfile to start station login validation. */
        onSubmit() {
            if (!this.profile) {
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.warn("Login/Station/OnSubmit/NoProfile", "No Config profile after StationLogin");
                return;
            }
            /** On click of 'Continue' button on the emergency modal after 1st login, isEmergencyModalAlreadyDisplayed to be set to true.
            If true, the modal is NOT to be displayed again. If false, modal to be displayed again*/
            if (this.showEmergencyModal()) {
                this.isEmergencyModalAlreadyDisplayed = true;
            }
            this.isSubmitBusy = true;
            this.isSubmitClicked = !this.isSubmitClicked;
        }
        addTelemetryOnRoleSwitch(roleName, loggedInRole) {
            var _a, _b, _c, _d;
            if (loggedInRole && loggedInRole !== roleName) {
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.SWITCH_USER_ROLE, {
                    status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS,
                    LastUserRole: loggedInRole === _constants__WEBPACK_IMPORTED_MODULE_8__.AGENT_AND_SUPERVISOR ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.formRoleNameForTelemetry)(loggedInRole) : loggedInRole,
                    SwitchedRole: roleName === _constants__WEBPACK_IMPORTED_MODULE_8__.AGENT_AND_SUPERVISOR ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.formRoleNameForTelemetry)(roleName) : roleName,
                    Reason: "[Station Login] User switched Role",
                    AdvancedHeader: this.advanceHeaderTracker()
                }, [(_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.webex_behavioral, (_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.prometheus]);
            }
        }
        setErrorFlags() {
            this.isErrUnknown = true;
            this.isErrDNRegister = false;
            this.isDNAlreadyInUse = false;
            this.isErrPhone = false;
            this.isErrPhoneExt = false;
            this.isExtAlreadyInUse = false;
            this.isErrExtRegister = false;
            this.isSubmitBusy = false;
            this.isMaximumSessionsReached = false;
            this.isWebRtcUnsupportedBrowser = false;
            this.isMicrophoneAccessDenied = false;
        }
        isUsesOtherFormat() {
            return this.phoneFormat === phoneFormats.other;
        }
        handleUnSupportedBrowserError() {
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.trace("Login/Station/WebRtc/UnsupportedBrowser");
            setTimeout(() => {
                this.isSubmitBusy = false;
                this.isErrUnknown = true;
                this.isWebRtcUnsupportedBrowser = true;
                this.trackingId = "";
            }, 200); // need a delay to update the attributes.
        }
        handleMicrophoneAccessDenied() {
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.trace("Login/Station/WebRtc/MicrophoneAccessDenied");
            this.isSubmitBusy = false;
            this.isErrUnknown = true;
            this.isMicrophoneAccessDenied = true;
            this.trackingId = "";
        }
        shouldFetchAuxCodes() {
            if (this.isDesktopAuxCodesInfiniteScrollEnabled) {
                return true;
            }
            else {
                return this.isMaerskEnabled;
            }
        }
        submitLoginPreCheck() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!this.profile) {
                    this.isSubmitBusy = false;
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.warn("Login/Station/OnSubmit/NoProfile", "No Config profile after StationLogin");
                    return false;
                }
                this.isSubmitBusy = true;
                this.isErrUnknown = false;
                this.auxCodeConfig.isError = false;
                this.fetchUniqueTeamIdError = false;
                const shouldFetchAuxCodes = yield this.shouldFetchAuxCodes();
                if (shouldFetchAuxCodes && !this.auxCodeConfig.fetchCompleted && !this.isOnlySupervisor()) {
                    // For pure supervisor aux codes are not required.
                    const isAuxCodeUpdated = yield this.fetchAuxCodes(true);
                    if (!isAuxCodeUpdated) {
                        return false;
                    }
                }
                return true;
            });
        }
        checkForTeamId(selectedProfile) {
            return __awaiter(this, void 0, void 0, function* () {
                // Load the team unique ID when isDesktopMaerskAcqueonTeamId feature flag is on.
                // This ID is required to use the Acqueon team ID.
                if (this.isDesktopMaerskAcqueonTeamId && selectedProfile.teamId) {
                    const teamUniqueId = yield this.fetchTeamDataById(selectedProfile.teamId);
                    if (!teamUniqueId) {
                        // Prevent the station login and return an error.
                        return new Error();
                    }
                    return teamUniqueId;
                }
                return "";
            });
        }
        buildStationLoginData(initialDeviceId, selectedProfile) {
            var _a, _b, _c, _d, _e;
            return __awaiter(this, void 0, void 0, function* () {
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.register({
                    TeamId: selectedProfile.teamId,
                    TeamName: selectedProfile.teamName,
                    OrgId: this.organizationId
                });
                const ifSupervisorOnly = selectedProfile.roles.join("_") === "supervisor";
                const stationLoginData = {
                    dialNumber: (_a = selectedProfile.dnNumber) === null || _a === void 0 ? void 0 : _a.replace(/ /g, ""),
                    usesOtherDN: selectedProfile.usesOtherDN,
                    teamId: ifSupervisorOnly ? null : selectedProfile.teamId || "",
                    teamName: ifSupervisorOnly ? null : selectedProfile.teamName || "",
                    siteId: this.profile.siteId,
                    auxCodeId: this.defaultAuxCode.toString(),
                    isExtension: selectedProfile.isExtension,
                    roles: selectedProfile.roles
                };
                let didOverwriteDeviceId = false;
                if (this.isWebRTCEnabled) {
                    if (selectedProfile.deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.LoginVoiceOptions.BROWSER) {
                        // check BrowserCompatible for webRtc
                        if (!(0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__.isWebRtcSupportedBrowser)()) {
                            this.handleUnSupportedBrowserError();
                            return null;
                        }
                        // ask Media microphone access / check access allowed
                        try {
                            const mediaStream = yield navigator.mediaDevices.getUserMedia({ audio: true });
                            if (!mediaStream) {
                                this.handleMicrophoneAccessDenied();
                                return null;
                            }
                            else {
                                mediaStream.getTracks().forEach((track) => track.stop());
                            }
                        }
                        catch (error) {
                            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/WebRtc/MicrophoneAccessDenied", `${error}`);
                            this.handleMicrophoneAccessDenied();
                            return null;
                        }
                        initialDeviceId = `${_constants__WEBPACK_IMPORTED_MODULE_8__.WEB_RTC_PREFIX}${this.profile.agentId}`;
                        didOverwriteDeviceId = true;
                    }
                    stationLoginData.deviceId = initialDeviceId;
                    stationLoginData.deviceType = this.getDeviceType(selectedProfile.deviceType, selectedProfile.isExtension);
                    stationLoginData.dialNumber = initialDeviceId; // keep this for backward compatible. remove while FF cleanup.
                }
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATION_LOGIN_CLICKED, {
                    LoginType: this.loginType,
                    DeviceType: this.deviceType
                });
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATION_LOGIN, [
                    (_c = (_b = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _b === void 0 ? void 0 : _b.SERVICE_PROVIDERS) === null || _c === void 0 ? void 0 : _c.webex_behavioral,
                    (_e = (_d = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _d === void 0 ? void 0 : _d.SERVICE_PROVIDERS) === null || _e === void 0 ? void 0 : _e.webex_business
                ]);
                if (this.profile.skillProfileId &&
                    this.profile.skillProfileId !== "0" &&
                    this.profile.skillProfileId !== "null") {
                    stationLoginData.skillProfileId = this.profile.skillProfileId;
                }
                return { didOverwriteDeviceId, stationLoginData };
            });
        }
        checkAndSaveCredentials(deviceId, selectedProfile, updatedStationLoginData, autologin) {
            if (!autologin) {
                // Save Preferences only if Remember me checkbox is checked and its not an autologin
                /* Autologin scenario occurs when:
                 * Role is Supervisor only
                 * No teams are assigned
                 * Call Monitoring is disabled
                 */
                if (this.isRememberMyCredentials) {
                    const saveUpdateUserPref = this.isDesktopEnhancedSignInEnabled
                        ? this.getUserPreferencesToSaveEnhanced(updatedStationLoginData, selectedProfile, deviceId)
                        : this.getUserPreferencesToSave(updatedStationLoginData, selectedProfile, deviceId);
                    if (this.isDesktopEmergencyNotificationEnabled) {
                        const saveUpdateUserPrefEmergency = Object.assign(Object.assign({}, saveUpdateUserPref), { isEmergencyModalAlreadyDisplayed: this.isEmergencyModalAlreadyDisplayed });
                        this.evt("save-update-user-prefs", saveUpdateUserPrefEmergency);
                    }
                    else {
                        this.evt("save-update-user-prefs", saveUpdateUserPref);
                    }
                }
                else if (this.isDesktopEmergencyNotificationEnabled) {
                    // If remember me button is not checked save only isEmergencyModalAlreadyDisplayed flag
                    const saveUpdateUserPref = { isEmergencyModalAlreadyDisplayed: this.isEmergencyModalAlreadyDisplayed };
                    this.evt("save-update-user-prefs", saveUpdateUserPref);
                    this.evt("delete-user-preference-storage", {});
                }
                else {
                    // delete prefs
                    this.evt("delete-user-prefs", {});
                    this.evt("delete-user-preference-storage", {});
                }
            }
        }
        getUserPreferencesToSave(updatedStationLoginData, selectedProfile, deviceId) {
            var _a, _b;
            return {
                selectedRoleName: (_a = updatedStationLoginData.roles) === null || _a === void 0 ? void 0 : _a.join("_"),
                teamName: selectedProfile.teamName,
                teamId: selectedProfile.teamId,
                dialNumber: updatedStationLoginData.dialNumber,
                isExtension: updatedStationLoginData.isExtension || false,
                extensionNumber: selectedProfile.extensionNumber,
                dialNumberValueForNonUS: (_b = selectedProfile.dialNumberValueForNonUS) === null || _b === void 0 ? void 0 : _b.replace(/ /g, ""),
                isInternational: selectedProfile.isInternational ? true : false,
                internationalPhoneNumber: selectedProfile.isInternational ? (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__.stripSpecialChar)(selectedProfile.phoneNumber) : "",
                countryCallingCode: selectedProfile.isInternational ? selectedProfile.countryCallingCode : "",
                countryCodeValue: selectedProfile.isInternational ? selectedProfile.countryCodeValue : "",
                isRememberMyCredentials: selectedProfile.isRememberMyCredentials,
                deviceType: selectedProfile.deviceType,
                deviceId
            };
        }
        getUserPreferencesToSaveEnhanced(updatedStationLoginData, selectedProfile, deviceId) {
            var _a;
            return {
                selectedRoleName: (_a = updatedStationLoginData.roles) === null || _a === void 0 ? void 0 : _a.join("_"),
                teamName: selectedProfile.teamName,
                teamId: selectedProfile.teamId,
                dialNumber: updatedStationLoginData.deviceType === "AGENT_DN" ? updatedStationLoginData.dialNumber : "",
                isExtension: updatedStationLoginData.isExtension || false,
                extensionNumber: selectedProfile.extensionNumber,
                dialNumberValueForNonUS: "",
                isInternational: false,
                internationalPhoneNumber: "",
                countryCallingCode: "",
                countryCodeValue: "",
                isRememberMyCredentials: selectedProfile.isRememberMyCredentials,
                deviceType: selectedProfile.deviceType,
                deviceId
            };
        }
        /**
         * Fetch the team unique team name from the team id
         * @param selectedTeamId
         * @returns
         */
        getTeamNameAndId(selectedTeamId) {
            var _a, _b, _c, _d;
            return __awaiter(this, void 0, void 0, function* () {
                const agentDBId = ((_a = this.profile) === null || _a === void 0 ? void 0 : _a.analyserUserId) || ((_b = this.profile) === null || _b === void 0 ? void 0 : _b.agentDbId);
                try {
                    const response = yield (0,_utils__WEBPACK_IMPORTED_MODULE_12__.fetchTeamList)(this.organizationId, 0, agentDBId, "", selectedTeamId);
                    const teamName = response ? ((_c = response.data[0]) === null || _c === void 0 ? void 0 : _c.teamName) || "" : "";
                    let teamId = "";
                    if (selectedTeamId !== "" && selectedTeamId !== undefined) {
                        teamId = selectedTeamId;
                    }
                    else if (response) {
                        teamId = ((_d = response.data[0]) === null || _d === void 0 ? void 0 : _d.teamId) || "";
                    }
                    return { teamName, teamId };
                }
                catch (error) {
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/FetchTeamDataById/Error", `${error}`);
                    throw error;
                }
            });
        }
        finishAndNotifySuccess(loggedInRole, teamUniqueId, deviceId, selectedProfile, login, teamName) {
            var _a, _b, _c, _d, _e;
            return __awaiter(this, void 0, void 0, function* () {
                // to capture event only when role switch is in between supervisor or agent+supervisor
                if (loggedInRole === _constants__WEBPACK_IMPORTED_MODULE_8__.AGENT_AND_SUPERVISOR || loggedInRole === _constants__WEBPACK_IMPORTED_MODULE_8__.SUPERVISOR) {
                    this.addTelemetryOnRoleSwitch(selectedProfile.roles.join("_"), loggedInRole);
                }
                const { teamId, lastStateChangeTimestamp, lastIdleCodeChangeTimestamp, profileType, channelsMap, agentId, interactionIds } = login.data;
                const teamNameProfile = teamName;
                this.success({
                    dn: (_a = selectedProfile.dnNumber) === null || _a === void 0 ? void 0 : _a.replace(/ /g, ""),
                    agentId,
                    usesOtherDN: this.isUsesOtherFormat(),
                    isExtension: selectedProfile.isExtension,
                    teamId,
                    teamUniqueId,
                    teamName: teamNameProfile,
                    subStatus: this.profile.defaultIdleName,
                    profileType,
                    defaultDn: selectedProfile.defaultDn,
                    isDefaultDnSet: selectedProfile.isDefaultDnSet,
                    mmProfile: {
                        voiceCount: (_b = channelsMap["telephony"]) === null || _b === void 0 ? void 0 : _b.length,
                        chatCount: (_c = channelsMap["chat"]) === null || _c === void 0 ? void 0 : _c.length,
                        emailCount: (_d = channelsMap["email"]) === null || _d === void 0 ? void 0 : _d.length,
                        socialCount: (_e = channelsMap["social"]) === null || _e === void 0 ? void 0 : _e.length
                    },
                    lastIdleCodeChangeTimestamp,
                    lastStateChangeTimestamp,
                    interactionIds,
                    userRole: this.userRole,
                    deviceType: selectedProfile.deviceType,
                    deviceId,
                    selectedRoleName: selectedProfile.roles ? selectedProfile.roles.join("_") : ""
                }, false);
                this.evt("remove-state-change-banner", {});
            });
        }
        wasProfileChanged(role, onSubmitProfileDetails) {
            const previousProfile = this.getCurrentProfileDetails();
            if (!previousProfile) {
                return true;
            }
            const profileTheSame = onSubmitProfileDetails.deviceType === previousProfile.deviceType &&
                onSubmitProfileDetails.deviceId === previousProfile.deviceId &&
                onSubmitProfileDetails.teamId === previousProfile.teamId &&
                onSubmitProfileDetails.isExtension === previousProfile.isExtension &&
                onSubmitProfileDetails.extensionNumber === previousProfile.extensionNumber &&
                onSubmitProfileDetails.dialNumberValueForNonUS === previousProfile.dialNumberValueForNonUS &&
                onSubmitProfileDetails.isInternational === previousProfile.isInternational &&
                onSubmitProfileDetails.phoneNumber === previousProfile.phoneNumber;
            return !profileTheSame;
        }
        // Error Handlers For SERVICE.aqm.agent.stationLogin()
        handleStationLoginSubmit(stationLoginDetails, autologin = false) {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function* () {
                const success = yield this.submitLoginPreCheck();
                if (!success) {
                    return;
                }
                const loggedInRole = stationLoginDetails.loggedInRole;
                const selectedProfile = Object.assign({}, stationLoginDetails.profileDetail);
                let deviceId = (_a = selectedProfile.dnNumber) === null || _a === void 0 ? void 0 : _a.replace(/ /g, "");
                const teamUniqueId = yield this.checkForTeamId(selectedProfile);
                if (teamUniqueId instanceof Error) {
                    return;
                }
                let teamName = ((_b = this.profile.teams.find((team) => team.teamId === selectedProfile.teamId)) === null || _b === void 0 ? void 0 : _b.teamName) || "";
                if (teamName === "" && this.isConsultTransferInfiniteScrollEnabled) {
                    const { teamName: fetchedTeamName } = yield this.getTeamNameAndId(selectedProfile.teamId || "");
                    teamName = fetchedTeamName || "";
                }
                const stationLoginResult = yield this.buildStationLoginData(deviceId, selectedProfile);
                if (!stationLoginResult) {
                    return;
                }
                const { didOverwriteDeviceId, stationLoginData } = stationLoginResult;
                if (didOverwriteDeviceId) {
                    deviceId = stationLoginData === null || stationLoginData === void 0 ? void 0 : stationLoginData.deviceId;
                }
                this.profileChanged = this.wasProfileChanged(loggedInRole, selectedProfile);
                // TODO: API Dependency (1) Send Role (2) Empty DN/Team (3) Supervisor Only.
                const loginResult = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.agent.stationLogin({
                    data: stationLoginData
                });
                this.checkAndSaveCredentials(deviceId, selectedProfile, stationLoginData, autologin);
                this.finishAndNotifySuccess(loggedInRole, teamUniqueId.toString(), deviceId, selectedProfile, loginResult, teamName);
            });
        }
        handleUserProfileDataAvailable(data) {
            return __awaiter(this, void 0, void 0, function* () {
                if (this.isDesktopEmergencyNotificationEnabled &&
                    data.loginOption === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.LoginVoiceOptions.BROWSER &&
                    !this.isEmergencyModalAlreadyDisplayed) {
                    this.isEmergencyModalAlreadyDisplayed = true;
                }
                if (data.isRememberMeChecked !== undefined) {
                    this.isRememberMyCredentials = data.isRememberMeChecked;
                }
                const isExtension = data.loginOption === "EXTENSION";
                this.isExtensionUsed = isExtension;
                const selectedTeam = this.isConsultTransferInfiniteScrollEnabled ? this.selectedTeam : data.team;
                const stationLoginDetails = {
                    profileDetail: {
                        roles: this.userRole,
                        teamName: selectedTeam.teamName,
                        teamId: selectedTeam.teamId,
                        dnNumber: isExtension ? data.extensionNumber : data.dialNumber,
                        isExtension,
                        usesOtherDN: this.isUsesOtherFormat(),
                        extensionNumber: data.extensionNumber || this.defaultDn || "",
                        dialNumberValueForNonUS: this.defaultDn,
                        defaultDn: this.defaultDn,
                        isDefaultDnSet: this.isDefaultDnSet,
                        isInternational: this.isInternational,
                        phoneNumber: this.defaultDn,
                        countryCallingCode: "",
                        countryCodeValue: "",
                        isRememberMyCredentials: this.isRememberMyCredentials,
                        deviceType: data.loginOption,
                        deviceId: this.deviceId,
                        isEmergencyModalAlreadyDisplayed: this.isEmergencyModalAlreadyDisplayed
                    },
                    loggedInRole: data.role
                };
                this.handleStationLoginSubmit(stationLoginDetails);
            });
        }
        cancelStationLogin() {
            this.isModalOpen = false;
            this.isSubmitBusy = false;
            // Trigger confirmation modal for sign out
            this.evt(EventLogoutConfirm, {
                header: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.signoutConfirmHeader"),
                message: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.signoutConfirmMsg"),
                noExitOnEsc: true,
                buttons: [
                    {
                        type: "cancel",
                        label: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(cancelButtonLabel),
                        variant: "secondary",
                        onClick: this.cancelLogout
                    },
                    { type: "ok", label: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(signOutButtonLabel), onClick: this.requestCILogout }
                ]
            });
        }
        stationLoginSubmitClick() {
            if (this.showEmergencyModal()) {
                this.setEmergencyNotificationAlert(true);
            }
            else {
                this.onSubmit();
            }
        }
        handleRememberMeCheckBoxChange() {
            this.isRememberMyCredentials = !this.isRememberMyCredentials;
        }
        updateContinueButtonDisabledState(isDisabled) {
            var _a;
            const button = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById("continueButton");
            if (button) {
                button.disabled = isDisabled;
            }
            // On checkbox change, update the focusable elements
            this.resetFocusableElements();
        }
        setEmergencyNotificationAlert(show) {
            this.showEmergencyNotificationWebrtc = show;
            this.resetFocusableElements();
        }
        resetFocusableElements() {
            document.dispatchEvent(new CustomEvent("on-widget-update"));
        }
        renderEmergencyNotificationFooter() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <div class="footer-buttons" slot="footer">
          <md-button
            class="footer-btn"
            variant="secondary"
            @button-click="${() => this.setEmergencyNotificationAlert(false)}"
          >
            ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.cancelButton")}
          </md-button>
          <md-button
            @button-click="${() => this.onSubmit()}"
            id="continueButton"
            class="footer-btn"
            variant="primary"
            ?disabled=${true}
          >
            ${this.isSubmitBusy
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
                  <md-loading></md-loading>
                  ${this.updateContinueButtonDisabledState(true)}
                `
                : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.continueButton")}
          </md-button>
        </div>
      `;
        }
        renderStationLoginFooter() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <div class="sl-footer" slot="footer">
          <div class="remember-me-checkbox-wrapper">
            <md-checkbox
              slot="checkbox"
              ?checked=${this.isRememberMyCredentials}
              label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.rememberMe")}"
              class="remember-me-checkbox"
              @checkbox-change=${() => this.handleRememberMeCheckBoxChange()}
            >
              ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.rememberMe")}
            </md-checkbox>
          </div>

          <div class="footer-buttons">
            <md-button
              class="footer-btn"
              variant="secondary"
              @click="${this.cancelStationLogin}"
              ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(cancelButtonLabel)}"
            >
              ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(cancelButtonLabel)}
            </md-button>
            <md-button
              class="footer-btn"
              @button-click="${this.stationLoginSubmitClick}"
              variant="primary"
              ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.submit")}"
              ?disabled=${this.isSubmitDisabled || this.isSubmitBusy}
            >
              ${this.isSubmitBusy ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) ` <md-loading></md-loading> ` : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.submit")}
            </md-button>
          </div>
        </div>
      `;
        }
        renderFooter() {
            return this.showEmergencyNotificationWebrtc && !this.isEmergencyModalAlreadyDisplayed
                ? this.renderEmergencyNotificationFooter()
                : this.renderStationLoginFooter();
        }
        getStationModalLayout() {
            var _a, _b, _c;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <md-modal
          lang=${this.lang}
          .show=${this.isModalOpen}
          size="small"
          .hideFooter=${true}
          .hideHeader=${true}
          noExitOnEsc
          disableInitialFocus
          aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.stationCredentials")}
        >
          <div slot="header">
            <h2 class="sl-form-label">
              ${this.showEmergencyNotificationWebrtc && !this.isEmergencyModalAlreadyDisplayed
                ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:emergencyServiceNotification.emergencyServiceNotification")
                : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.stationCredentials")}
            </h2>
          </div>
          <agentx-wc-user-profile
            .isSubmit="${this.isSubmitClicked}"
            .reasonCode="${this.reasonCode}"
            .isDesktopReasonCodeEnabled="${this.isDesktopReasonCodeEnabled}"
            .getErrorMsgForReasonCode="${this.getErrorMsgForReasonCode}"
            .userRole="${this.userRole.join("_")}"
            .isExtensionUsed="${this.isExtensionUsed}"
            ?isMonitoringEnabled="${this.isMonitoringEnabled}"
            selectedRoleName="${this.selectedRoleName}"
            orgId="${this.organizationId}"
            agentDbId="${((_a = this.profile) === null || _a === void 0 ? void 0 : _a.analyserUserId) || ((_b = this.profile) === null || _b === void 0 ? void 0 : _b.agentDbId) || ""}"
            .dialNumber="${this.dialNumber}"
            ?isDefaultDnSet="${this.isDefaultDnSet}"
            .teams="${this.teams}"
            .teamsMeta=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_7__.ifDefined)(this.isConsultTransferInfiniteScrollEnabled ? JSON.stringify((_c = this.profile) === null || _c === void 0 ? void 0 : _c.teamsMeta) : undefined)}
            teamName="${this.teamName}"
            teamId="${this.teamId}"
            .usesOtherDN="${this.usesOtherDN}"
            defaultDn="${this.defaultDn}"
            extensionNumber="${this.extensionNumber}"
            .dialNumberValueForNonUS="${this.dialNumberValueForNonUS}"
            ?isInternational="${this.isInternational}"
            countryCallingCode="${this.countryCallingCode}"
            countryCodeValue="${this.countryCodeValue}"
            ?isRememberMyCredentials="${this.isRememberMyCredentials}"
            ?isErrUnknown="${this.isErrUnknown}"
            ?auxCodeError="${this.auxCodeConfig.isError}"
            ?fetchUniqueTeamIdError="${this.fetchUniqueTeamIdError}"
            ?isErrDNRegister="${this.isErrDNRegister}"
            ?isDNAlreadyInUse="${this.isDNAlreadyInUse}"
            ?isErrPhone="${this.isErrPhone}"
            ?isErrPhoneExt="${this.isErrPhoneExt}"
            ?isExtAlreadyInUse="${this.isExtAlreadyInUse}"
            ?isErrExtRegister="${this.isErrExtRegister}"
            ?isDNRegisterTimeOut="${this.isDNRegisterTimeOut}"
            ?isMaximumSessionsReached="${this.isDesktopMaxSessionLimitsEnabled && this.isMaximumSessionsReached}"
            ?isTeamsEmpty="${this.isTeamsEmpty}"
            trackingId="${this.trackingId}"
            ?isStationlogin=${true}
            phoneFormat="${this.phoneFormat}"
            phoneNumber="${this.phoneNumber}"
            deviceType=${this.getDeviceType(this.deviceType, this.isExtensionUsed)}
            deviceId=${this.deviceId}
            .loginVoiceOptions=${this.loginVoiceOptions}
            ?isWebRTCEnabled=${this.isWebRTCEnabled}
            ?isConsultTransferInfiniteScrollEnabled=${this.isConsultTransferInfiniteScrollEnabled}
            ?isWebRtcUnsupportedBrowser=${this.isWebRTCEnabled && this.isWebRtcUnsupportedBrowser}
            ?isMicrophoneAccessDenied=${this.isWebRTCEnabled && this.isMicrophoneAccessDenied}
            ?showEmergencyNotificationWebrtc=${this.showEmergencyNotificationWebrtc}
            ?isEmergencyModalAlreadyDisplayed=${this.isEmergencyModalAlreadyDisplayed}
            @submit-busy="${(e) => {
                this.isSubmitBusy = e.detail.submitProperty;
            }}"
            @on-component-update="${(e) => {
                this.isSubmitDisabled = e.detail.submitProperty;
                this.deviceTypeName = e.detail.profileDetail.deviceType;
            }}"
            @login-start="${(e) => this.handleStationLoginSubmit(e.detail)}"
            @checkbox-state-changed="${(e) => this.updateContinueButtonDisabledState(!e.detail.checked)}"
            @on-team-selected="${this.onTeamSelect}"
          ></agentx-wc-user-profile>

          <!-- Footer -->
          ${this.renderFooter()}
        </md-modal>
      `;
        }
        getCurrentProfileDetails() {
            return {
                roles: this.role ? [this.role] : [],
                teamName: this.teamName,
                teamId: this.teamId,
                dnNumber: this.dialNumber,
                isExtension: this.isExtensionUsed,
                usesOtherDN: this.usesOtherDN,
                extensionNumber: this.extensionNumber,
                dialNumberValueForNonUS: this.dialNumberValueForNonUS,
                defaultDn: this.defaultDn,
                isDefaultDnSet: this.isDefaultDnSet,
                isInternational: this.isInternational,
                phoneNumber: this.phoneNumber,
                countryCallingCode: this.countryCallingCode,
                countryCodeValue: this.countryCodeValue,
                isRememberMyCredentials: this.isRememberMyCredentials,
                deviceType: this.deviceType,
                deviceId: this.deviceId,
                isEmergencyModalAlreadyDisplayed: this.isEmergencyModalAlreadyDisplayed
            };
        }
        getEnhancedStationModalLayout() {
            var _a, _b, _c;
            const { errorType, errorMessage } = this.errorInfo;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <uuip-wc-user-station-login
          ?isModalOpen=${this.isModalOpen}
          ?isRememberMeChecked=${this.isRememberMyCredentials}
          ?isSubmitBusy=${this.isSubmitBusy}
          ?isDesktopEmergencyNotificationEnabled=${this.isDesktopEmergencyNotificationEnabled}
          ?isEmergencyNotificationAlreadyDisplayed=${this.isEmergencyModalAlreadyDisplayed}
          ?isExternalTeamSelection=${this.isConsultTransferInfiniteScrollEnabled}
          .defaultDialNumber=${this.dialNumber}
          ?isReadonlyNumber=${this.isDefaultDnSet}
          .defaultTeam=${{ teamId: this.teamId, teamName: this.teamName }}
          .errorType=${errorType}
          .errorMessage=${errorMessage}
          .dialPlanRegexStrings=${this.dialPlanRegexes}
          .extensions=${this.availableExtensions}
          .defaultExtension=${this.extensionNumber}
          ?isCallMonitoringEnabled=${this.isMonitoringEnabled}
          .loginVoiceOptions=${this.availableLoginVoiceOptions}
          .defaultVoiceOption=${this.preferenceVoiceOption}
          .preferenceRoleName=${this.selectedRoleName}
          .teams=${this.teams}
          .userRoles=${this.userRole}
          .localization=${this.userStationLoginLocalization}
          @signout-clicked=${this.cancelStationLogin}
          @confirm-clicked=${(e) => this.handleUserProfileDataAvailable(e.detail.data)}
          @component-updated=${(e) => {
                this.deviceType = e.detail.data.loginOption;
                this.isExtensionUsed = this.deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.LoginVoiceOptions.EXTENSION;
                this.isErrUnknown = false;
            }}
        >
          ${this.isConsultTransferInfiniteScrollEnabled
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
                <div slot="external-team-selection">
                  <agentx-wc-teams-list-infinite
                    selectedTeamName=${this.selectedTeam.teamName}
                    agentDbId=${((_a = this.profile) === null || _a === void 0 ? void 0 : _a.analyserUserId) || ((_b = this.profile) === null || _b === void 0 ? void 0 : _b.agentDbId) || ""}
                    orgId=${this.organizationId}
                    teamsMeta=${JSON.stringify((_c = this.profile) === null || _c === void 0 ? void 0 : _c.teamsMeta)}
                    .paginatedTeamResponse=${this.paginatedTeamResponse}
                  ></agentx-wc-teams-list-infinite>
                </div>
              `
                : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
        </uuip-wc-user-station-login>
      `;
        }
        getLoadingScreen() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) ` <agentx-wc-loading-screen></agentx-wc-loading-screen> `;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        ${this.isInitializing
                ? this.getLoadingScreen()
                : this.isDesktopEnhancedSignInEnabled
                    ? this.getEnhancedStationModalLayout()
                    : this.getStationModalLayout()}
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ attribute: false })
    ], Element.prototype, "isModalOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isAdvancedHeader", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isDesktopReasonCodeEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)()
    ], Element.prototype, "getErrorMsgForReasonCode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "roleFromMe", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)()
    ], Element.prototype, "organizationId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)()
    ], Element.prototype, "meUserId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isMonitoringEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "selectedRoleName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isDesktopMaxSessionLimitsEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isDesktopMaerskAcqueonTeamId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isDesktopMSStateSyncEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isDesktopEmergencyNotificationEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isDesktopEnhancedSignInEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)()
    ], Element.prototype, "phoneFormat", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "phoneNumber", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isRememberMyCredentials", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isWebRTCEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "deviceType", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "deviceId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "reasonCode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isMaerskEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isDesktopAuxCodesInfiniteScrollEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isConsultTransferInfiniteScrollEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "showEmergencyNotificationWebrtc", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isEmergencyModalAlreadyDisplayed", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Array })
    ], Element.prototype, "availableExtensions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isInitializing", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isSubmitBusy", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isSubmitDisabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isSubmitClicked", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "teamName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "teamId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isTeamsEmpty", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "dialNumber", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "deviceTypeName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isDefaultDnSet", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "userRole", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "loginType", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "usesOtherDN", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "dialNumberValueForNonUS", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "defaultDn", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isInternational", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isPreferenceSaved", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "loginVoiceOptions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "auxCodeConfig", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "initialIdleCodes", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "systemIdleCodes", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "fetchUniqueTeamIdError", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "dialPlan", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isErrUnknown", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isErrDNRegister", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isDNAlreadyInUse", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isErrPhone", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isErrPhoneExt", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isExtAlreadyInUse", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isErrExtRegister", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isDNRegisterTimeOut", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isMaximumSessionsReached", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isWebRtcUnsupportedBrowser", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isMicrophoneAccessDenied", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "paginatedTeamResponse", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "autoLoginType", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "profileChanged", void 0);
    __decorate([
        _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4__.Decorator.Handle({
            "Service.aqm.configs.application": ({ ctx, details }) => {
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/Config/Error", "", details);
                const reason = "Application Config Error";
                ctx.dispatchLoginError(ctx, details, ErrId, reason);
            },
            "Service.abs.fetchCmsInitConfig": ({ ctx, details }) => {
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/CMSConfig/Error", "", details);
                const reason = "CMS Config Error";
                ctx.dispatchLoginError(ctx, details, "Service.abs.fetchCmsInitConfig", reason);
            },
            "Service.aqm.reqs.TimeoutEvent": ({ ctx, details }) => {
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/Profile/TimeoutEvent", "", details);
                const errorDetails = {
                    type: "Timeout",
                    status: 408,
                    trackingId: "" // To do to fetch tracking id on timeout of updateAgentProfile
                };
                const reason = "Profile TimeoutEvent";
                ctx.dispatchLoginError(ctx, errorDetails, ErrId, reason);
            },
            "Service.aqm.reqs.Timeout": ({ ctx, details }) => {
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/AgentPropertyEvent/Timeout", "", { key: details === null || details === void 0 ? void 0 : details.key });
                const errorDetails = {
                    type: "Timeout",
                    status: 408,
                    trackingId: (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.getTrackingIdFromErrorObject)(details)
                };
                const reason = "Agent Property Timeout";
                ctx.dispatchLoginError(ctx, errorDetails, ErrId, reason);
            }
        })
    ], Element.prototype, "init", null);
    __decorate([
        _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4__.Decorator.Handle(function () {
            return __awaiter(this, void 0, void 0, function* () {
                if (this.userRole.join("_") === _constants__WEBPACK_IMPORTED_MODULE_8__.AGENT && this.isTeamsEmpty) {
                    this.evt(EventNameError, {
                        id: "Service.aqm.configs.teams",
                        message: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.initialProfileTeamFailed"),
                        trackingId: "",
                        reasonCode: this.reasonCode,
                        advancedHeader: this.advanceHeaderTracker(),
                        deviceType: this.deviceType,
                        loginType: this.loginType,
                        reason: "Teams Config Error On Reload"
                    });
                }
                else if (!(this.userRole.join("_") === _constants__WEBPACK_IMPORTED_MODULE_8__.SUPERVISOR && !this.isMonitoringEnabled)) {
                    yield this.fetchSavedPreferences();
                    this.requestUpdate();
                    if (this.isDesktopEnhancedSignInEnabled && this.isPreferenceSaved && this.isRememberMyCredentials) {
                        this.agentAutoLogin();
                        return;
                    }
                    this.isModalOpen = true;
                    this.isInitializing = false;
                }
                else {
                    this.isModalOpen = false;
                    this.autologin();
                }
            });
        })
    ], Element.prototype, "agentReload", null);
    __decorate([
        _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4__.Decorator.Exec(({ ctx, isExec }) => (ctx.isSubmitBusy = isExec), false),
        _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4__.Decorator.Handle(({ ctx, id, message }) => {
            ctx.isErrUnknown = true;
            ctx.isErrDNRegister = false;
            ctx.isDNAlreadyInUse = false;
            ctx.isErrPhone = false;
            ctx.isErrExtRegister = false;
            ctx.isExtAlreadyInUse = false;
            ctx.isErrPhoneExt = false;
            ctx.isSubmitBusy = false;
            ctx.evt(EventNameError, { id, message, trackingId: "" });
        }),
        _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4__.Decorator.Handle({
            "Service.aqm.agent.stationLogin": ({ ctx, details }) => {
                ctx.setErrorFlags();
                ctx.isSubmitBusy = false;
                if (ctx.isDesktopEnhancedSignInEnabled && ctx.autoLoginType === _constants__WEBPACK_IMPORTED_MODULE_8__.AutoLoginType.Agent) {
                    ctx.isInitializing = false;
                    ctx.isModalOpen = true;
                }
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/StationLogin/Error", "", details);
                ctx.trackingId = ctx.getTrackingID(details.trackingId);
                if (ctx.isModalOpen) {
                    ctx.evt(EventNameError, {
                        id: "Service.aqm.agent.stationLogin",
                        message: "Station Login API failed",
                        trackingId: ctx.trackingId,
                        advancedHeader: ctx.advanceHeaderTracker(),
                        loginType: ctx.loginType,
                        deviceType: ctx.deviceType,
                        reason: "Station Login API failed",
                        reasonCode: ctx.reasonCode
                    });
                }
                else {
                    ctx.evt(EventNameError, {
                        id: "Service.aqm.supervisor.stationLogin",
                        message: "Supervisor Station Login API failed",
                        trackingId: ctx.trackingId,
                        advancedHeader: ctx.advanceHeaderTracker(),
                        loginType: ctx.loginType,
                        deviceType: ctx.deviceType,
                        reason: "Station Login API failed",
                        reasonCode: ctx.reasonCode
                    });
                }
            },
            "Service.aqm.agent.stationLoginFailed": ({ ctx, details }) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/StationLoginNotifs/Error", "", details);
                ctx.isSubmitBusy = false;
                if (ctx.isDesktopEnhancedSignInEnabled && ctx.autoLoginType === _constants__WEBPACK_IMPORTED_MODULE_8__.AutoLoginType.Agent) {
                    ctx.isInitializing = false;
                    ctx.isModalOpen = true;
                }
                if (_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.featureflag.isFeatureFlagEnabled(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_ENABLE_LOGIN_1035_RECOVERY) &&
                    ((_a = details === null || details === void 0 ? void 0 : details.data) === null || _a === void 0 ? void 0 : _a.reasonCode) === 1035) {
                    if (!ctx.profileChanged) {
                        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.debug("Login/Station/AgentAlreadyExists/Reload", "Try reload since agent already exists and no change to Login Details");
                        ctx.agentReload();
                        ctx.profileChanged = true; // In the case of a reload resulting in a 1035, lets terminate the loop and logout
                    }
                    else {
                        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/AgentAlreadyExists/Error", "Login Details changed - show error screen", details);
                        ctx.logout();
                    }
                    return;
                }
                ctx.setErrorFlags();
                ctx.reasonCode = (_b = details === null || details === void 0 ? void 0 : details.data) === null || _b === void 0 ? void 0 : _b.reasonCode;
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/StationLoginNotifs/Error", "", details);
                if (((_c = details === null || details === void 0 ? void 0 : details.data) === null || _c === void 0 ? void 0 : _c.reasonCode) === 41) {
                    ctx.isDNRegisterTimeOut = true;
                }
                if (((_d = details === null || details === void 0 ? void 0 : details.data) === null || _d === void 0 ? void 0 : _d.reasonCode) === 1019) {
                    ctx.isMaximumSessionsReached = true;
                }
                ctx.trackingId = (_e = details.data) === null || _e === void 0 ? void 0 : _e.trackingId;
                if (ctx.isModalOpen) {
                    ctx.evt(EventNameError, {
                        id: "Service.aqm.agent.stationLoginFailed",
                        message: "Station Login Notifs failed",
                        trackingId: ctx.trackingId,
                        advancedHeader: ctx.advanceHeaderTracker(),
                        loginType: ctx.loginType,
                        deviceType: ctx.deviceType,
                        reason: (_f = details.data) === null || _f === void 0 ? void 0 : _f.reason,
                        reasonCode: (_g = details.data) === null || _g === void 0 ? void 0 : _g.reasonCode
                    });
                }
                else {
                    ctx.evt(EventNameError, {
                        id: "Service.aqm.supervisor.stationLoginFailed",
                        message: "Station Login Notifs failed",
                        trackingId: ctx.trackingId,
                        advancedHeader: ctx.advanceHeaderTracker(),
                        loginType: ctx.loginType,
                        deviceType: ctx.deviceType,
                        reason: (_h = details.data) === null || _h === void 0 ? void 0 : _h.reason,
                        reasonCode: (_j = details.data) === null || _j === void 0 ? void 0 : _j.reasonCode
                    });
                }
            },
            "Service.aqm.reqs.Timeout": ({ ctx, details }) => {
                var _a, _b;
                ctx.setErrorFlags();
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/StationLogin/Timeout", "", details);
                ctx.trackingId = ctx.getTrackingID((_b = (_a = details === null || details === void 0 ? void 0 : details.resAxios) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b.trackingid);
                ctx.evt(EventNameError, {
                    id: "Service.aqm.reqs.Timeout",
                    message: "Station Login failed",
                    advancedHeader: ctx.advanceHeaderTracker(),
                    loginType: ctx.loginType,
                    deviceType: ctx.deviceType,
                    trackingId: ctx.trackingId,
                    reason: "Station Login failed (Timeout)",
                    reasonCode: ctx.reasonCode
                });
            }
        })
    ], Element.prototype, "handleStationLoginSubmit", null);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.customElement)("agentx-wc-user-station-login")
    ], Element);
    UserStationLogin.Element = Element;
})(UserStationLogin || (UserStationLogin = {}));


/***/ }),

/***/ "./src/components/userStationLogin/utils.ts":
/*!**************************************************!*\
  !*** ./src/components/userStationLogin/utils.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FIRST_PAGE: () => (/* binding */ FIRST_PAGE),
/* harmony export */   IDLE_CODE: () => (/* binding */ IDLE_CODE),
/* harmony export */   escapeRegExp: () => (/* binding */ escapeRegExp),
/* harmony export */   fetchAuxCodeValues: () => (/* binding */ fetchAuxCodeValues),
/* harmony export */   fetchIdleCodes: () => (/* binding */ fetchIdleCodes),
/* harmony export */   fetchTeamList: () => (/* binding */ fetchTeamList),
/* harmony export */   fetchWrapUpCodes: () => (/* binding */ fetchWrapUpCodes)
/* harmony export */ });
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};


const IDLE_CODE = "IDLE_CODE";
const FIRST_PAGE = 0;
const reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
const reHasRegExpChar = RegExp(reRegExpChar.source);
const PAGE_SIZE = 100;
const fetchIdleCodes = (orgId, idleCodeConfig, isDesktopAuxCodesInfiniteScrollEnabled) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        if (isDesktopAuxCodesInfiniteScrollEnabled) {
            const params = { orgId, page: 0, pageSize: 100 };
            // This block will execute when "desktop-aux-codes-infinite-scrolling" feature flag is ON.
            const response = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.abs.fetchPaginatedIdleCodes(params);
            _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info(`event=fetchIdleCodes Successfully fetched ${response.data.length} idle codes for page: ${params.page} `);
            return response;
        }
        else {
            const params = { orgId, accessType: idleCodeConfig.accessType, ids: idleCodeConfig.ids };
            // This block will execute when "desktop-maersk-CX-11355" feature flag is ON and "desktop-aux-codes-infinite-scrolling" is OFF.
            const response = (yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.abs.fetchIdleCodes(params));
            _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info(`event=fetchIdleCodes Successfully fetched ${response.length} idle codes`);
            return Array.isArray(response) ? response : [];
        }
    }
    catch (error) {
        _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.error(`event=fetchIdleCodes | Tracking ID: ${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(error) : ""} | Fetching idle codes from aux code is failed : ${error}`, error);
        throw error;
    }
});
const fetchDefaultAuxCodes = (orgId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const params = { orgId };
        const response = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.abs.fetchDefaultAuxCodes(params);
        _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info(`event=fetchDefaultAuxCodes : Successfully fetched ${response.length} default aux codes`);
        return response;
    }
    catch (error) {
        _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.error(`event=fetchDefaultIdleCodes | Tracking ID: ${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(error) : ""} | Fetching default aux code is failed : ${error}`, error);
        throw error;
    }
});
const fetchFilteredIdleCodes = (orgId, customFilter, desktopProfileFilter) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const params = {
            orgId,
            page: 0,
            pageSize: 100,
            customFilter,
            desktopProfileFilter
        };
        const response = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.abs.fetchPaginatedIdleCodes(params);
        _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info(`event=fetchPaginatedIdleCodes Successfully fetched ${response.data.length} system idle codes for page: ${params.page} `);
        return response;
    }
    catch (error) {
        _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.error(`event=fetchPaginatedIdleCodes | Tracking ID: ${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(error) : ""} | Fetching system idle codes has failed : ${error}`, error);
        throw error;
    }
});
const fetchWrapUpCodes = (orgId, wrapUpCodeConfig, isDesktopAuxCodesInfiniteScrollEnabled) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        if (isDesktopAuxCodesInfiniteScrollEnabled) {
            const params = { orgId, page: FIRST_PAGE, pageSize: 100 };
            const response = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.abs.fetchPaginatedWrapUpCodes(params);
            _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info(`event=fetchWrapUpCodes Successfully fetched ${response.data.length} wrap up codes for page: ${params.page}`);
            return response;
        }
        else {
            const params = { orgId, accessType: wrapUpCodeConfig.accessType, ids: wrapUpCodeConfig.ids };
            const response = (yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.abs.fetchWrapUpCodes(params));
            _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info(`event=fetchWrapUpCodes Successfully fetched ${response.length} wrap up codes`);
            return Array.isArray(response) ? response : [];
        }
    }
    catch (error) {
        _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.error(`event=fetchWrapUpCodes | Tracking ID: ${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(error) : ""} | Fetching wrap up codes from aux code is failed : ${error}`, error);
        throw error;
    }
});
const fetchAuxCodeValues = (orgId, idleCodeConfig, wrapUpCodeConfig, isDesktopAuxCodesInfiniteScrollEnabled, shouldFetchDefaultIdleCode) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const apiCalls = [
            fetchIdleCodes(orgId, idleCodeConfig, isDesktopAuxCodesInfiniteScrollEnabled),
            fetchWrapUpCodes(orgId, wrapUpCodeConfig, isDesktopAuxCodesInfiniteScrollEnabled)
        ];
        if (isDesktopAuxCodesInfiniteScrollEnabled && shouldFetchDefaultIdleCode) {
            // fetch default aux code from api incase of infinite scroll
            apiCalls.push(fetchDefaultAuxCodes(orgId));
        }
        apiCalls.push(fetchFilteredIdleCodes(orgId, "isSystemCode==true", false)); // fetch ALL system idle codes
        const [idleCodes, wrapUpCodes, defaultAuxCodes, systemIdleCodes] = yield Promise.all(apiCalls);
        return [idleCodes, wrapUpCodes, defaultAuxCodes, systemIdleCodes];
    }
    catch (error) {
        _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.error(`event=fetchAuxCodeValues | Tracking ID: ${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(error) : ""} | Fetching fetchAuxCodeValues is failed : ${error}`, error);
        throw error;
    }
});
const fetchTeamList = (orgId, page, agentDbId, searchTerm = "", teamId = "") => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const params = {
            orgId,
            page,
            search: searchTerm,
            pageSize: PAGE_SIZE,
            customFilter: teamId !== "" ? `userId=="${agentDbId}";id=="${teamId}"` : `userId=="${agentDbId}"`
        };
        return yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.abs.fetchPaginatedTeamsList(params);
    }
    catch (error) {
        _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.error("event=fetchTeams | Error on fetching Teams List in Station Login Module", error);
        throw error;
    }
});
const escapeRegExp = (string) => {
    return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string || "";
};


/***/ }),

/***/ "./src/config.ts":
/*!***********************!*\
  !*** ./src/config.ts ***!
  \***********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CONF: () => (/* binding */ CONF),
/* harmony export */   setAgentxMfeWcBasedConfig: () => (/* binding */ setAgentxMfeWcBasedConfig)
/* harmony export */ });
/* eslint-disable @typescript-eslint/no-explicit-any */
const CONF = {};
function setAgentxMfeWcBasedConfig(config) {
    Object.keys(config).forEach((k) => (CONF[k] = config[k]));
}


/***/ }),

/***/ "./src/constants.ts":
/*!**************************!*\
  !*** ./src/constants.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ACCESS_IDLE_CODES: () => (/* binding */ ACCESS_IDLE_CODES),
/* harmony export */   ACTIONS: () => (/* binding */ ACTIONS),
/* harmony export */   AGENT: () => (/* binding */ AGENT),
/* harmony export */   AGENTCONNECT_COMPLETED: () => (/* binding */ AGENTCONNECT_COMPLETED),
/* harmony export */   AGENTX_WEBEX_MINIMIZE_RESTORE: () => (/* binding */ AGENTX_WEBEX_MINIMIZE_RESTORE),
/* harmony export */   AGENTX_WEBEX_WRAPPER_CLOSE: () => (/* binding */ AGENTX_WEBEX_WRAPPER_CLOSE),
/* harmony export */   AGENT_AND_SUPERVISOR: () => (/* binding */ AGENT_AND_SUPERVISOR),
/* harmony export */   AGENT_SIGNOUT_REASON: () => (/* binding */ AGENT_SIGNOUT_REASON),
/* harmony export */   AGENT_SIGNOUT_RESULT: () => (/* binding */ AGENT_SIGNOUT_RESULT),
/* harmony export */   AGENT_STATE_CHANGE_FAILED: () => (/* binding */ AGENT_STATE_CHANGE_FAILED),
/* harmony export */   APPLE_MESSAGE_DARK_SVG: () => (/* binding */ APPLE_MESSAGE_DARK_SVG),
/* harmony export */   APPLE_MESSAGE_LIGHT_SVG: () => (/* binding */ APPLE_MESSAGE_LIGHT_SVG),
/* harmony export */   AVAILABLE: () => (/* binding */ AVAILABLE),
/* harmony export */   AVAILABLE_CONSULTING: () => (/* binding */ AVAILABLE_CONSULTING),
/* harmony export */   AVAILABLE_ID: () => (/* binding */ AVAILABLE_ID),
/* harmony export */   AutoLoginType: () => (/* binding */ AutoLoginType),
/* harmony export */   BLIND_TRANSFER_COMPLETED: () => (/* binding */ BLIND_TRANSFER_COMPLETED),
/* harmony export */   CALLBACK_ACTIONS_LIST: () => (/* binding */ CALLBACK_ACTIONS_LIST),
/* harmony export */   CALLBACK_LIST_ITEM_SIZE: () => (/* binding */ CALLBACK_LIST_ITEM_SIZE),
/* harmony export */   CALL_ENDED: () => (/* binding */ CALL_ENDED),
/* harmony export */   CAPTURE_STARTED: () => (/* binding */ CAPTURE_STARTED),
/* harmony export */   CHANGED_BY_ROLE: () => (/* binding */ CHANGED_BY_ROLE),
/* harmony export */   CHANNEL_AVATAR_MAP: () => (/* binding */ CHANNEL_AVATAR_MAP),
/* harmony export */   CHANNEL_NAME_MAP: () => (/* binding */ CHANNEL_NAME_MAP),
/* harmony export */   CHANNEL_STATUS_MAP: () => (/* binding */ CHANNEL_STATUS_MAP),
/* harmony export */   CHEVRON_ICON: () => (/* binding */ CHEVRON_ICON),
/* harmony export */   COLUMN_MENU_FOCUS: () => (/* binding */ COLUMN_MENU_FOCUS),
/* harmony export */   CONFERENCE: () => (/* binding */ CONFERENCE),
/* harmony export */   CONFERENCE_COMPLETED: () => (/* binding */ CONFERENCE_COMPLETED),
/* harmony export */   CONFERENCE_REQUESTED: () => (/* binding */ CONFERENCE_REQUESTED),
/* harmony export */   CONFERENCE_STARTED: () => (/* binding */ CONFERENCE_STARTED),
/* harmony export */   CONFERENCING: () => (/* binding */ CONFERENCING),
/* harmony export */   CONNECTED: () => (/* binding */ CONNECTED),
/* harmony export */   CONNECTED_CONSULTING: () => (/* binding */ CONNECTED_CONSULTING),
/* harmony export */   CONSULTING: () => (/* binding */ CONSULTING),
/* harmony export */   CONSULT_COMPLETED: () => (/* binding */ CONSULT_COMPLETED),
/* harmony export */   CONSULT_DONE: () => (/* binding */ CONSULT_DONE),
/* harmony export */   CONSULT_ERROR: () => (/* binding */ CONSULT_ERROR),
/* harmony export */   CONSULT_REQUESTED: () => (/* binding */ CONSULT_REQUESTED),
/* harmony export */   CONSULT_STARTED: () => (/* binding */ CONSULT_STARTED),
/* harmony export */   CONTACT_ACTIVE_EVENTS: () => (/* binding */ CONTACT_ACTIVE_EVENTS),
/* harmony export */   CONTACT_COMPLETED: () => (/* binding */ CONTACT_COMPLETED),
/* harmony export */   CONTACT_DIRECTION: () => (/* binding */ CONTACT_DIRECTION),
/* harmony export */   CONTACT_STATS_HISTORICAL_EVENTS: () => (/* binding */ CONTACT_STATS_HISTORICAL_EVENTS),
/* harmony export */   CONTACT_TRANSFERRED_EVENTS: () => (/* binding */ CONTACT_TRANSFERRED_EVENTS),
/* harmony export */   DEFAULT_DEVICE_TYPE: () => (/* binding */ DEFAULT_DEVICE_TYPE),
/* harmony export */   DELETE: () => (/* binding */ DELETE),
/* harmony export */   DESKTOP: () => (/* binding */ DESKTOP),
/* harmony export */   DIGITAL_OUTBOUND: () => (/* binding */ DIGITAL_OUTBOUND),
/* harmony export */   EP_TRANSFER_COMPLETED: () => (/* binding */ EP_TRANSFER_COMPLETED),
/* harmony export */   EXIT_CONFERENCE: () => (/* binding */ EXIT_CONFERENCE),
/* harmony export */   FILTER_CHANGE_DELAY: () => (/* binding */ FILTER_CHANGE_DELAY),
/* harmony export */   FLOW_ACTIVITY: () => (/* binding */ FLOW_ACTIVITY),
/* harmony export */   HANDLE_AGENT_SIGNOUT_EVENT: () => (/* binding */ HANDLE_AGENT_SIGNOUT_EVENT),
/* harmony export */   HANDLE_AID_MODAL_EVENT: () => (/* binding */ HANDLE_AID_MODAL_EVENT),
/* harmony export */   HANDLE_SKILL_PROFILE_CHANGE_EVENT: () => (/* binding */ HANDLE_SKILL_PROFILE_CHANGE_EVENT),
/* harmony export */   HANDLE_STATE_CHANGE_EVENT: () => (/* binding */ HANDLE_STATE_CHANGE_EVENT),
/* harmony export */   HANDLE_WEBEX_CHAT_CLOSE_EVENT: () => (/* binding */ HANDLE_WEBEX_CHAT_CLOSE_EVENT),
/* harmony export */   HANDLE_WEBEX_CHAT_EVENT: () => (/* binding */ HANDLE_WEBEX_CHAT_EVENT),
/* harmony export */   HELP_LINK: () => (/* binding */ HELP_LINK),
/* harmony export */   HOLD_COMPLETED: () => (/* binding */ HOLD_COMPLETED),
/* harmony export */   HOLD_COMPLETED_CONFERENCE: () => (/* binding */ HOLD_COMPLETED_CONFERENCE),
/* harmony export */   HOLD_COMPLETED_CONSULT: () => (/* binding */ HOLD_COMPLETED_CONSULT),
/* harmony export */   HOLD_STARTED: () => (/* binding */ HOLD_STARTED),
/* harmony export */   HOLD_STARTED_CONFERENCE: () => (/* binding */ HOLD_STARTED_CONFERENCE),
/* harmony export */   HOLD_STARTED_CONSULT: () => (/* binding */ HOLD_STARTED_CONSULT),
/* harmony export */   ICON_SRC: () => (/* binding */ ICON_SRC),
/* harmony export */   IDLE: () => (/* binding */ IDLE),
/* harmony export */   IDLE_CONSULTING: () => (/* binding */ IDLE_CONSULTING),
/* harmony export */   INBOUND: () => (/* binding */ INBOUND),
/* harmony export */   INITIATE_MS_AUTH_LOGIN: () => (/* binding */ INITIATE_MS_AUTH_LOGIN),
/* harmony export */   JOIN_CONFERENCE: () => (/* binding */ JOIN_CONFERENCE),
/* harmony export */   Key: () => (/* binding */ Key),
/* harmony export */   LOGGED_OUT: () => (/* binding */ LOGGED_OUT),
/* harmony export */   MAX_CALLBACK_LIST_ITEMS: () => (/* binding */ MAX_CALLBACK_LIST_ITEMS),
/* harmony export */   MEDIA_TYPES: () => (/* binding */ MEDIA_TYPES),
/* harmony export */   MIN_CALLBACK_LIST_ITEMS: () => (/* binding */ MIN_CALLBACK_LIST_ITEMS),
/* harmony export */   MIN_WIDTH: () => (/* binding */ MIN_WIDTH),
/* harmony export */   MONITORING_ENDED: () => (/* binding */ MONITORING_ENDED),
/* harmony export */   MONITORING_ERROR: () => (/* binding */ MONITORING_ERROR),
/* harmony export */   MONITORING_HOLD: () => (/* binding */ MONITORING_HOLD),
/* harmony export */   MONITORING_REGULAR_DARK: () => (/* binding */ MONITORING_REGULAR_DARK),
/* harmony export */   MONITORING_REGULAR_LIGHT: () => (/* binding */ MONITORING_REGULAR_LIGHT),
/* harmony export */   MONITORING_REQUESTED: () => (/* binding */ MONITORING_REQUESTED),
/* harmony export */   MONITORING_STARTED: () => (/* binding */ MONITORING_STARTED),
/* harmony export */   MONITORING_UNHOLD: () => (/* binding */ MONITORING_UNHOLD),
/* harmony export */   ON_HOLD: () => (/* binding */ ON_HOLD),
/* harmony export */   OPEN_REVIEW_AND_MONITOR_MODAL: () => (/* binding */ OPEN_REVIEW_AND_MONITOR_MODAL),
/* harmony export */   OPEN_SEND_MESSAGE_MODAL: () => (/* binding */ OPEN_SEND_MESSAGE_MODAL),
/* harmony export */   OUTBOUND_TYPE: () => (/* binding */ OUTBOUND_TYPE),
/* harmony export */   OUTDIAL: () => (/* binding */ OUTDIAL),
/* harmony export */   OUT_DIAL: () => (/* binding */ OUT_DIAL),
/* harmony export */   POST_CALL_CONSULT_STARTED: () => (/* binding */ POST_CALL_CONSULT_STARTED),
/* harmony export */   POST_CALL_STARTED: () => (/* binding */ POST_CALL_STARTED),
/* harmony export */   PRESENCE_SYNC: () => (/* binding */ PRESENCE_SYNC),
/* harmony export */   PRIMARY_OWNER_CHANGED: () => (/* binding */ PRIMARY_OWNER_CHANGED),
/* harmony export */   PROFILE_SETTING_INVALID_DATA_EVENT: () => (/* binding */ PROFILE_SETTING_INVALID_DATA_EVENT),
/* harmony export */   Play: () => (/* binding */ Play),
/* harmony export */   QUEUE_TRANSFER_COMPLETED: () => (/* binding */ QUEUE_TRANSFER_COMPLETED),
/* harmony export */   REALTIME_FEED: () => (/* binding */ REALTIME_FEED),
/* harmony export */   RECORDS_ONE_HUNDRED: () => (/* binding */ RECORDS_ONE_HUNDRED),
/* harmony export */   REVIEW_BUTTON_DARK: () => (/* binding */ REVIEW_BUTTON_DARK),
/* harmony export */   REVIEW_BUTTON_DARK_DISABLED: () => (/* binding */ REVIEW_BUTTON_DARK_DISABLED),
/* harmony export */   REVIEW_BUTTON_LIGHT: () => (/* binding */ REVIEW_BUTTON_LIGHT),
/* harmony export */   REVIEW_BUTTON_LIGHT_DISABLED: () => (/* binding */ REVIEW_BUTTON_LIGHT_DISABLED),
/* harmony export */   SEARCH_THRESHOLD: () => (/* binding */ SEARCH_THRESHOLD),
/* harmony export */   SELECTED_CHANGE_DELAY: () => (/* binding */ SELECTED_CHANGE_DELAY),
/* harmony export */   SIGNED_OUT: () => (/* binding */ SIGNED_OUT),
/* harmony export */   STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT_REASON: () => (/* binding */ STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT_REASON),
/* harmony export */   STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT_REASON_CODE: () => (/* binding */ STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT_REASON_CODE),
/* harmony export */   STATE_CHANGE_OVERLAY_CLOSE_EVENT: () => (/* binding */ STATE_CHANGE_OVERLAY_CLOSE_EVENT),
/* harmony export */   STATE_PREVIEW_OPTIONS: () => (/* binding */ STATE_PREVIEW_OPTIONS),
/* harmony export */   SUBSCRIPTION_RESPONSE: () => (/* binding */ SUBSCRIPTION_RESPONSE),
/* harmony export */   SUPERVISOR: () => (/* binding */ SUPERVISOR),
/* harmony export */   SUPERVISOR_AND_AGENT: () => (/* binding */ SUPERVISOR_AND_AGENT),
/* harmony export */   SUPERVISOR_AUTO_LOGIN_EVENT: () => (/* binding */ SUPERVISOR_AUTO_LOGIN_EVENT),
/* harmony export */   TASKLIST_ITEMSTATUS: () => (/* binding */ TASKLIST_ITEMSTATUS),
/* harmony export */   TEAM_SELECT_EVENT: () => (/* binding */ TEAM_SELECT_EVENT),
/* harmony export */   TELEPHONY: () => (/* binding */ TELEPHONY),
/* harmony export */   TIMEOUT_TEN_MS: () => (/* binding */ TIMEOUT_TEN_MS),
/* harmony export */   TIMEOUT_THOUSAND_MS: () => (/* binding */ TIMEOUT_THOUSAND_MS),
/* harmony export */   TIMER_FIELDS: () => (/* binding */ TIMER_FIELDS),
/* harmony export */   TPW_AGENT_STATE_SELECTOR_LOADING_CHANGED: () => (/* binding */ TPW_AGENT_STATE_SELECTOR_LOADING_CHANGED),
/* harmony export */   TPW_CONTACT_UPDATE: () => (/* binding */ TPW_CONTACT_UPDATE),
/* harmony export */   TPW_DATA_WAIT_TIME: () => (/* binding */ TPW_DATA_WAIT_TIME),
/* harmony export */   TPW_EMPTY_COLUMN_VALUE: () => (/* binding */ TPW_EMPTY_COLUMN_VALUE),
/* harmony export */   TPW_FILTER_DATA_UPDATE: () => (/* binding */ TPW_FILTER_DATA_UPDATE),
/* harmony export */   TPW_FILTER_MODAL_UPDATED: () => (/* binding */ TPW_FILTER_MODAL_UPDATED),
/* harmony export */   TPW_FILTER_UPDATED: () => (/* binding */ TPW_FILTER_UPDATED),
/* harmony export */   TPW_MONITOR_MODAL: () => (/* binding */ TPW_MONITOR_MODAL),
/* harmony export */   TRANSFER_COMPLETED: () => (/* binding */ TRANSFER_COMPLETED),
/* harmony export */   UPDATE_ACTION_CELL_VALUE_EVENT: () => (/* binding */ UPDATE_ACTION_CELL_VALUE_EVENT),
/* harmony export */   VOICE_LABEL: () => (/* binding */ VOICE_LABEL),
/* harmony export */   WEBRTC_SHORTCUT_KEYS: () => (/* binding */ WEBRTC_SHORTCUT_KEYS),
/* harmony export */   WEB_RTC_PREFIX: () => (/* binding */ WEB_RTC_PREFIX),
/* harmony export */   WEB_RTC_STATUS: () => (/* binding */ WEB_RTC_STATUS),
/* harmony export */   WRAP_UP: () => (/* binding */ WRAP_UP),
/* harmony export */   WRAP_UP_ASSISTANCE: () => (/* binding */ WRAP_UP_ASSISTANCE),
/* harmony export */   WRAP_UP_COMPLETED: () => (/* binding */ WRAP_UP_COMPLETED),
/* harmony export */   channelAvatars: () => (/* binding */ channelAvatars),
/* harmony export */   channelList: () => (/* binding */ channelList),
/* harmony export */   channelOrder: () => (/* binding */ channelOrder),
/* harmony export */   emergency911HelpLink: () => (/* binding */ emergency911HelpLink),
/* harmony export */   helpPageLangCode: () => (/* binding */ helpPageLangCode),
/* harmony export */   presenceTypeMap: () => (/* binding */ presenceTypeMap)
/* harmony export */ });
const CONFERENCE = "conference";
const CONSULTING = "consulting";
const Play = "play";
var Key;
(function (Key) {
    Key["End"] = "End";
    Key["Home"] = "Home";
    Key["Enter"] = "Enter";
    Key["Tab"] = "Tab";
    Key["ArrowDown"] = "ArrowDown";
    Key["ArrowLeft"] = "ArrowLeft";
    Key["ArrowRight"] = "ArrowRight";
    Key["ArrowUp"] = "ArrowUp";
    Key["Delete"] = "Delete";
    Key["Space"] = "Space";
    Key["Escape"] = "Escape";
})(Key || (Key = {}));
const MEDIA_TYPES = {
    CHAT: "chat",
    EMAIL: "email",
    VOICE: "telephony",
    SOCIAL: "social",
    SMS: "sms",
    FACEBOOK: "facebook",
    WHATSAPP: "whatsapp",
    MIDCALL_MONITORING: "midcall telephony",
    APPLE_BUSINESS_CHAT: "appleMessages",
    GOOGLE_BUSINESS_CHAT: "googleMessages",
    OUTBOUND_AGENT_INITIATED_EMAIL: "outboundEmail",
    OUTBOUND_AGENT_INITIATED_SMS: "outboundSms"
};
const DEFAULT_DEVICE_TYPE = ["AGENT_DN", "EXTENSION"];
const WEB_RTC_PREFIX = "webrtc-";
const TASKLIST_ITEMSTATUS = {
    OUTBOUND_ICON: "outbound telephony",
    CALLBACK_ICON: "callback",
    CAMPAIGN_ICON: "progressive_campaign",
    PREVIEW_CAMPAIGN_ICON: "outbound-campaign"
};
const CONTACT_DIRECTION = {
    INBOUND: "INBOUND",
    OUTBOUND: "OUTBOUND"
};
const OUTBOUND_TYPE = {
    CAMPAIGN: "CAMPAIGN",
    COURTESY_CALLBACK: "COURTESY_CALLBACK",
    CALLBACK: "CALLBACK",
    PROGRESSIVE_CAMPAIGN: "PROGRESSIVE_CAMPAIGN",
    CAMPAIGN_OUTDIAL_CUSTOMER: "CAMPAIGN_OUTDIAL_CUSTOMER",
    CAMPAIGN_PREDICTIVE_OUTDIAL_CUSTOMER: "CAMPAIGN_PREDICTIVE_OUTDIAL_CUSTOMER",
    OUTDIAL_RESERVATION: "OUTDIAL_RESERVATION"
};
const SUPERVISOR = "supervisor";
const AGENT = "agent";
const SUPERVISOR_AND_AGENT = "supervisor and agent";
const AGENT_AND_SUPERVISOR = "agent_supervisor";
const channelList = [
    { name: "Voice", value: "telephony" },
    { name: "Chat", value: "chat" },
    { name: "Email", value: "email" },
    { name: "Social", value: "social" }
];
const LOGGED_OUT = "LoggedOut";
const SIGNED_OUT = "Signed Out";
const AVAILABLE = "Available";
const AVAILABLE_ID = "0";
const IDLE = "Idle";
const DELETE = "DELETE";
const TELEPHONY = "telephony";
const TIMER_FIELDS = ["contactStatusTime", "totalContactDuration", "agentInteractionTime"];
//tpw custom events
const TPW_FILTER_DATA_UPDATE = "tpw-filter-data-update";
const TPW_FILTER_UPDATED = "tpw-filter-updated";
const TPW_MONITOR_MODAL = "tpw-monitor-modal";
const TPW_EMPTY_COLUMN_VALUE = "-";
const TPW_CONTACT_UPDATE = "tpw-contact-update";
const TPW_FILTER_MODAL_UPDATED = "tpw-applied-filters-updated";
const TPW_AGENT_STATE_SELECTOR_LOADING_CHANGED = "tpw-agent-state-selector-loading-changed";
const ACTIONS = "actions";
const FLOW_ACTIVITY = "flow-activity";
const MONITORING_STARTED = "monitoring-started";
const MONITORING_ENDED = "monitoring-ended";
const MONITORING_REQUESTED = "monitoring-requested";
const MONITORING_HOLD = "monitoring-hold";
const MONITORING_UNHOLD = "monitoring-unhold";
const MONITORING_ERROR = "monitoring-error";
const CONTACT_COMPLETED = "contact-completed";
const CONTACT_STATS_HISTORICAL_EVENTS = [CONTACT_COMPLETED, "wrapup-completed", "treatment-completed", "parked"];
const INBOUND = "inbound";
const CONFERENCE_REQUESTED = "conference-requested";
const CONFERENCE_STARTED = "conference-started";
const HOLD_COMPLETED = "hold-completed";
const HOLD_COMPLETED_CONFERENCE = "hold-completed-conference";
const HOLD_COMPLETED_CONSULT = "hold-completed-consult";
const HOLD_STARTED_CONFERENCE = "hold-started-conference";
const CONSULT_REQUESTED = "consult-requested";
const CONSULT_STARTED = "consult-started";
const JOIN_CONFERENCE = "join-conference";
const EXIT_CONFERENCE = "exit-conference";
const PRIMARY_OWNER_CHANGED = "primary-owner-changed";
const TRANSFER_COMPLETED = "transfer-completed";
const QUEUE_TRANSFER_COMPLETED = "queueTransfer-completed";
const EP_TRANSFER_COMPLETED = "epTransfer-complete";
const BLIND_TRANSFER_COMPLETED = "blindTransfer-completed";
const WRAP_UP = "wrapup";
const WRAP_UP_ASSISTANCE = "wrapup-assistance";
const CALL_ENDED = "call-ended";
const OPEN_REVIEW_AND_MONITOR_MODAL = "open-review-and-monitor-modal";
const OPEN_SEND_MESSAGE_MODAL = "open-send-message-modal";
const FILTER_CHANGE_DELAY = 500;
const SELECTED_CHANGE_DELAY = 200;
const REALTIME_FEED = "RealtimeFeed";
const SUBSCRIPTION_RESPONSE = "SubscriptionResponse";
const CONNECTED_CONSULTING = "connected-consulting";
const IDLE_CONSULTING = "idle-consulting";
const AVAILABLE_CONSULTING = "available-consulting";
const CONNECTED = "connected";
const ON_HOLD = "on-hold";
const CONFERENCING = "conferencing";
const CONSULT_DONE = "consult-done";
const CONSULT_ERROR = "consult-error";
const CAPTURE_STARTED = "capture-started";
const HOLD_STARTED = "hold-started";
const HOLD_STARTED_CONSULT = "hold-completed-consult";
const WRAP_UP_COMPLETED = "wraup-completed";
const CONSULT_COMPLETED = "consult-completed";
const CONFERENCE_COMPLETED = "conference-completed";
const AGENTCONNECT_COMPLETED = "agentConnect-completed";
const POST_CALL_STARTED = "postcall-started-main";
const POST_CALL_CONSULT_STARTED = "postcall-started-consult";
const SEARCH_THRESHOLD = 3;
const PROFILE_SETTING_INVALID_DATA_EVENT = "profile-settings-invalid-data";
const HANDLE_AID_MODAL_EVENT = "handle-aid-modal";
const HANDLE_WEBEX_CHAT_EVENT = "handle-webex-chat";
const HANDLE_WEBEX_CHAT_CLOSE_EVENT = "webexchat-overlay-close";
const HANDLE_STATE_CHANGE_EVENT = "handle-state-change";
const HANDLE_SKILL_PROFILE_CHANGE_EVENT = "handle-skill-profile-change";
const HANDLE_AGENT_SIGNOUT_EVENT = "handle-agent-signout";
const UPDATE_ACTION_CELL_VALUE_EVENT = "update-actions-cell-value";
const STATE_CHANGE_OVERLAY_CLOSE_EVENT = "state-change-overlay-close";
const STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT_REASON = "STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT";
const STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT_REASON_CODE = 1087;
const REVIEW_BUTTON_LIGHT = "/images/illustrations/Monitoring-regular-light.svg";
const REVIEW_BUTTON_DARK = "/images/illustrations/Monitoring-regular-dark.svg";
const REVIEW_BUTTON_LIGHT_DISABLED = "/images/illustrations/LightMode-Monitoring-Disabled.svg";
const REVIEW_BUTTON_DARK_DISABLED = "/images/illustrations/DarkMode-Monitoring-Disabled.svg";
const SUPERVISOR_AUTO_LOGIN_EVENT = "supervisor-auto-login";
const CONTACT_TRANSFERRED_EVENTS = [
    TRANSFER_COMPLETED,
    QUEUE_TRANSFER_COMPLETED,
    EP_TRANSFER_COMPLETED,
    BLIND_TRANSFER_COMPLETED
];
// List of Contact status events, that define the interaction is active.
const CONTACT_ACTIVE_EVENTS = [
    "connected",
    "consulting",
    "on-hold",
    "hold-done",
    "consult-done",
    "consult",
    "conferencing",
    "available-consulting",
    "connected-consulting",
    "idle-consulting"
];
const AGENTX_WEBEX_WRAPPER_CLOSE = "agentx-webex-wrapper-close";
const AGENTX_WEBEX_MINIMIZE_RESTORE = "agentx-webex-minimize-restore";
const AGENT_STATE_CHANGE_FAILED = "agent-state-change-failed";
const AGENT_SIGNOUT_RESULT = "agent-signout-result";
const AGENT_SIGNOUT_REASON = "SupervisorSignout";
const HELP_LINK = {
    AGENT_HELP: "https://help.webex.com/en-us/landing/ld-sxjj9p-WebexContactCenter/Agent",
    SUPERVISOR_HELP: "https://help.webex.com/en-us/landing/ld-sxjj9p-WebexContactCenter/Supervisor"
};
const WEB_RTC_STATUS = {
    WEB_RTC_CONNECTED: "webRtcConnected",
    WEB_RTC_REGISTERING: "webRtcRegistering",
    WEB_RTC_DISCONNECTED: "webRtcDisconnected"
};
const ACCESS_IDLE_CODES = {
    ALL: "ALL",
    SPECIFIC: "SPECIFIC"
};
const CHANGED_BY_ROLE = {
    SELF: "SELF",
    SUPERVISOR: "SUPERVISOR",
    ADMIN: "ADMIN",
    SYSTEM: "SYSTEM"
};
const DESKTOP = "Desktop";
const APPLE_MESSAGE_DARK_SVG = "/images/illustrations/apple-messages-dark.svg";
const APPLE_MESSAGE_LIGHT_SVG = "/images/illustrations/apple-messages-light.svg";
const MONITORING_REGULAR_DARK = "/images/illustrations/Monitoring-regular-dark.svg";
const MONITORING_REGULAR_LIGHT = "/images/illustrations/Monitoring-regular-light.svg";
const TIMEOUT_THOUSAND_MS = 1000;
const MIN_WIDTH = "227px";
const INITIATE_MS_AUTH_LOGIN = "initiate-microsoft-auth-flow";
const TPW_DATA_WAIT_TIME = 20000;
const PRESENCE_SYNC = "PRESENCE_SYNC";
const emergency911HelpLink = "https://help.webex.com/mwjlgk";
const WEBRTC_SHORTCUT_KEYS = [
    {
        widgetElement: "agentx-react-interaction-control",
        group: "app:keyboardShortcutKeys.interactionControl.componentName",
        action: "app:keyboardShortcutKeys.interactionControl.muteOrUnmuteWebCall",
        modifierKeys: "ctrlKey_shiftKey",
        key: "n",
        role: "agent",
        deviceType: "BROWSER"
    },
    {
        widgetElement: "agentx-react-interaction-control",
        group: "app:keyboardShortcutKeys.interactionControl.componentName",
        action: "app:keyboardShortcutKeys.interactionControl.openKeyboard",
        modifierKeys: "ctrlKey_altKey",
        key: "k",
        role: "agent",
        deviceType: "BROWSER"
    }
];
const ICON_SRC = "icon src";
const DIGITAL_OUTBOUND = "app:outboundMessage";
const OUT_DIAL = "OUTDIAL";
const COLUMN_MENU_FOCUS = "column-menu-focus";
const OUTDIAL = "outdial";
const TIMEOUT_TEN_MS = 10;
const TEAM_SELECT_EVENT = "on-team-selected";
const CHEVRON_ICON = {
    UP: "arrow-up-bold",
    DOWN: "arrow-down-bold"
};
const RECORDS_ONE_HUNDRED = 100;
const helpPageLangCode = {
    bg: "bg-bg",
    // ca: "ca-es", // Catalan - Spain help page is not working so commented for fallback - en us
    "zh-cn": "zh-cn",
    "zh-tw": "zh-tw",
    hr: "hr-hr",
    cs: "cs-cz",
    da: "da-dk",
    uk: "uk-ua",
    nl: "nl-nl",
    en: "en-us",
    // "en-gb": "en-gb", // English - United Kingdom commented for fall back en us
    fi: "fi-fi",
    "fr-fr": "fr-fr",
    "de-de": "de-de",
    hu: "hu-hu",
    it: "it-it",
    ja: "ja-jp",
    ko: "ko-kr",
    no: "no-no",
    nb: "no-no",
    pl: "pl-pl",
    pt: "pt-br",
    "pt-br": "pt-br",
    ro: "ro-ro",
    ru: "ru-ru",
    sr: "sr-rs",
    sk: "sk-sk",
    sl: "sl-si",
    "es-co": "es-co",
    sv: "sv-se",
    tr: "tr-tr" // Turkish - Turkey
};
var AutoLoginType;
(function (AutoLoginType) {
    AutoLoginType["None"] = "none";
    AutoLoginType["Agent"] = "agent";
    AutoLoginType["Supervisor"] = "supervisor";
})(AutoLoginType || (AutoLoginType = {}));
const CALLBACK_LIST_ITEM_SIZE = 86;
const MIN_CALLBACK_LIST_ITEMS = 2;
const MAX_CALLBACK_LIST_ITEMS = 8;
const CALLBACK_ACTIONS_LIST = ["delete", "edit"];
const presenceTypeMap = new Map([
    ["idle", "idle"],
    ["available", "active"],
    ["engaged", "engaged"],
    ["engagedother", "engaged"],
    ["reserved", "engaged"],
    ["wrapup", "engaged"],
    ["rona", "rona"]
]);
const channelAvatars = {
    voice: {
        title: "Channel Call",
        type: "channel-call"
    },
    chat: {
        title: "Channel Chat",
        type: "channel-chat"
    },
    email: {
        title: "Channel Email",
        type: "channel-email-inbound"
    },
    social: {
        title: "Channel Social",
        type: "channel-social"
    }
};
// DO NOT CHANGE THE ORDER OF THE CHANNELS AS IT IS USED IN THE UI
const channelOrder = ["voice", "chat", "email", "social"];
const STATE_PREVIEW_OPTIONS = {
    voice: {
        agentState: "",
        idleCodeName: "",
        totalChannelCount: 0,
        availableChannelCount: 0,
        pendingIdle: false,
        stateChangeTimestamp: 0
    },
    chat: {
        agentState: "",
        idleCodeName: "",
        totalChannelCount: 0,
        availableChannelCount: 0,
        pendingIdle: false,
        stateChangeTimestamp: 0,
        lastIdleCodeChangeTimestamp: null
    },
    email: {
        agentState: "",
        idleCodeName: "",
        totalChannelCount: 0,
        availableChannelCount: 0,
        pendingIdle: false,
        stateChangeTimestamp: 0,
        lastIdleCodeChangeTimestamp: 0
    },
    social: {
        agentState: "",
        idleCodeName: "",
        totalChannelCount: 0,
        availableChannelCount: 0,
        pendingIdle: false,
        stateChangeTimestamp: 0
    }
};
const CHANNEL_AVATAR_MAP = {
    Voice: "channel-call",
    Chat: "channel-chat",
    Email: "channel-email-inbound",
    Social: "channel-social"
};
const CHANNEL_STATUS_MAP = {
    Available: "active",
    Idle: "idle",
    Engaged: "engaged",
    EngagedOther: "engagedOther",
    Reserved: "reserved",
    WrapUp: "wrapup",
    Rona: "rona"
};
const CHANNEL_NAME_MAP = {
    voice: "Voice",
    chat: "Chat",
    email: "Email",
    social: "Social"
};
const VOICE_LABEL = "Voice";


/***/ }),

/***/ "./src/mixins/i18nMixin.ts":
/*!*********************************!*\
  !*** ./src/mixins/i18nMixin.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   i18nMixin: () => (/* binding */ i18nMixin),
/* harmony export */   t: () => (/* binding */ t)
/* harmony export */ });
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__);


const i18nMixin = _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__.I18N.createMixin({ i18n: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.i18n });
function t(...args) {
    return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.i18n.t(...args);
}


/***/ }),

/***/ "./src/sdk.ts":
/*!********************!*\
  !*** ./src/sdk.ts ***!
  \********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   logger: () => (/* binding */ logger),
/* harmony export */   notifications: () => (/* binding */ notifications)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);

const objKeysToBeMasked = {
    ani: true,
    dn: true,
    agent_ani: true,
    dnis: true,
    email: true,
    callAssociatedData: true,
    title: true,
    text: true,
    agentName: true,
    agentMailId: true,
    userName: true,
    emails: true,
    sipAddresses: true
};
const logger = (0,_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.createLogger)("agentx-mfe-wc-based", objKeysToBeMasked);
const notifications = (0,_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.createNotifications)();


/***/ }),

/***/ "./src/utils/WindowListenersHub.ts":
/*!*****************************************!*\
  !*** ./src/utils/WindowListenersHub.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WINDOW_LISTENERS_HUB: () => (/* binding */ WINDOW_LISTENERS_HUB)
/* harmony export */ });
class WindowListenersHub {
    constructor() {
        this.listeners = {};
        this.listenersWrappers = {};
    }
    on(eventName, listener) {
        // One window listener per eventName
        if (!this.listeners[eventName]) {
            this.listeners[eventName] = [];
            this.listenersWrappers[eventName] = (e) => this.listeners[eventName].forEach((registeredListener) => registeredListener.call(registeredListener, e));
            window.addEventListener(eventName, this.listenersWrappers[eventName]);
        }
        this.listeners[eventName].push(listener);
        return () => this.off(eventName, listener);
    }
    off(eventName, listener) {
        if (this.listeners[eventName]) {
            const idx = this.listeners[eventName].findIndex((l) => l === listener);
            if (idx !== -1) {
                this.listeners[eventName].splice(idx, 1);
                if (this.listeners[eventName].length < 1) {
                    window.removeEventListener(eventName, this.listenersWrappers[eventName]);
                    delete this.listeners[eventName];
                    delete this.listenersWrappers[eventName];
                }
            }
        }
    }
    once(eventName, listener, onceConditionChecker) {
        const _listener = (...args) => {
            let res = true;
            if (typeof onceConditionChecker === "function") {
                res = onceConditionChecker(...args);
            }
            if (res) {
                listener(...args);
                this.off(eventName, _listener);
            }
        };
        this.on(eventName, _listener);
        return () => this.off(eventName, _listener);
    }
    dispatch(e) {
        window.dispatchEvent(e);
    }
    allOff(eventName) {
        const offEventName = (_eventName) => {
            if (_eventName in this.listeners) {
                let i = this.listeners[_eventName].length;
                while (i) {
                    const listener = this.listeners[_eventName][i - 1];
                    this.off(_eventName, listener);
                    i--;
                }
            }
        };
        if (eventName) {
            offEventName(eventName);
        }
        else {
            Object.keys(this.listeners).forEach((registeredEvent) => offEventName(registeredEvent));
        }
    }
}
const WINDOW_LISTENERS_HUB = new WindowListenersHub();


/***/ }),

/***/ "./src/utils/helpers.ts":
/*!******************************!*\
  !*** ./src/utils/helpers.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   checkForTelemetryTracking: () => (/* binding */ checkForTelemetryTracking),
/* harmony export */   debounce: () => (/* binding */ debounce),
/* harmony export */   formatTimeRangeForCallbackTitle: () => (/* binding */ formatTimeRangeForCallbackTitle),
/* harmony export */   getImageSrcTaskList: () => (/* binding */ getImageSrcTaskList),
/* harmony export */   getMediaChannelForTaskList: () => (/* binding */ getMediaChannelForTaskList),
/* harmony export */   getTimerLabel: () => (/* binding */ getTimerLabel),
/* harmony export */   isDigitalOutboundCase: () => (/* binding */ isDigitalOutboundCase),
/* harmony export */   isIconSrc: () => (/* binding */ isIconSrc),
/* harmony export */   isMicrophoneAccessDenied: () => (/* binding */ isMicrophoneAccessDenied),
/* harmony export */   isOutboundContact: () => (/* binding */ isOutboundContact),
/* harmony export */   isRegistered: () => (/* binding */ isRegistered),
/* harmony export */   isTaskItemCardVisible: () => (/* binding */ isTaskItemCardVisible),
/* harmony export */   isWebRtcSupportedBrowser: () => (/* binding */ isWebRtcSupportedBrowser),
/* harmony export */   makeAlphaNumericReadable: () => (/* binding */ makeAlphaNumericReadable),
/* harmony export */   makeTelephonyReadable: () => (/* binding */ makeTelephonyReadable),
/* harmony export */   naturalSort: () => (/* binding */ naturalSort),
/* harmony export */   registerWebRTCShortcuts: () => (/* binding */ registerWebRTCShortcuts),
/* harmony export */   removeWebRTCShortcuts: () => (/* binding */ removeWebRTCShortcuts),
/* harmony export */   stripSpecialChar: () => (/* binding */ stripSpecialChar),
/* harmony export */   throttle: () => (/* binding */ throttle),
/* harmony export */   updateTimerAriaLabel: () => (/* binding */ updateTimerAriaLabel)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_3__);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};




const throttle = (fn, delay = 1000 / 60) => {
    let lastTimeoutRef = undefined;
    let last = Date.now();
    // Throttling
    const next = (...args) => {
        const now = Date.now();
        window.clearTimeout(lastTimeoutRef);
        if (!last || now - last >= delay) {
            last = now;
            fn.call(fn, ...args);
        }
        else {
            lastTimeoutRef = window.setTimeout(() => next(...args), delay - (now - last));
        }
    };
    return (...args) => next(...args);
};
const isRegistered = (name) => {
    return document.createElement(name).constructor !== HTMLElement;
};
const isTaskItemCardVisible = (cardElement, cardContainerElement) => {
    const data = {
        arrowDir: "",
        isVisible: false
    };
    if (cardElement.getBoundingClientRect().top < 65 && cardContainerElement instanceof HTMLElement) {
        data.isVisible = false;
        data.arrowDir = "top";
    }
    else if (cardElement.getBoundingClientRect().top > cardContainerElement.clientHeight) {
        data.isVisible = false;
        data.arrowDir = "down";
    }
    else {
        data.isVisible = true;
    }
    return data;
};
/**
 * Debounce method to avoid repetative  call
 */
const debounce = (fn, time) => {
    let timer;
    return function (...args) {
        const func = () => fn.call({}, args[0]);
        clearTimeout(timer);
        timer = window.setTimeout(func, time);
    };
};
const checkForTelemetryTracking = (navigateTo) => {
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.setValueInCache(navigateTo, new Date().getTime());
};
const stripSpecialChar = (str) => {
    /*eslint no-useless-escape: "off"*/
    return str.replace(/[^\+?\d]/gi, "");
};
const checkSupportedBrowsers = () => {
    if (!navigator) {
        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[WebRTC]: navigator is not available");
    }
    const userAgent = (navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) || "";
    _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[WebRTC]: User Agent: ${userAgent}`);
    const supportedBrowsers = ["Chrome", "Edg", "Firefox"];
    const isSupported = !!supportedBrowsers.find((browser) => {
        return userAgent.includes(browser);
    });
    const isLegacyEdge = userAgent.includes("Edge");
    return isSupported && !isLegacyEdge;
};
const isWebRtcSupportedBrowser = () => {
    return checkSupportedBrowsers();
};
const isMicrophoneAccessDenied = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const mediaStream = yield navigator.mediaDevices.getUserMedia({ audio: true });
        if (!mediaStream) {
            return true;
        }
        else {
            mediaStream.getTracks().forEach((track) => track.stop());
        }
    }
    catch (error) {
        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[WebRtc] microphone access error", error);
        return true;
    }
    return false;
});
const registerWebRTCShortcuts = () => {
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.register(_constants__WEBPACK_IMPORTED_MODULE_0__.WEBRTC_SHORTCUT_KEYS);
};
const removeWebRTCShortcuts = () => {
    const shortcutKeyMap = Array.from(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.getRegisteredKeys().values());
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.unregisterAllKeys();
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.register(shortcutKeyMap.filter((data) => !data.deviceType || data.deviceType !== "BROWSER"));
};
const isOutboundContact = (direction, outboundType) => {
    return direction === _constants__WEBPACK_IMPORTED_MODULE_0__.CONTACT_DIRECTION.OUTBOUND && outboundType === _constants__WEBPACK_IMPORTED_MODULE_0__.OUT_DIAL;
};
const getMediaChannelForTaskList = (mediaChannel, direction, outboundType) => {
    if (isOutboundContact(direction, outboundType !== null && outboundType !== void 0 ? outboundType : "")) {
        if (mediaChannel && mediaChannel === _constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.EMAIL) {
            return _constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.OUTBOUND_AGENT_INITIATED_EMAIL;
        }
        if (mediaChannel && mediaChannel === _constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.SMS) {
            return _constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.OUTBOUND_AGENT_INITIATED_SMS;
        }
        return mediaChannel;
    }
    return mediaChannel;
};
/**
 *
 * @param mediaType
 * @param mediaChannel
 * @returns
 */
const getImageSrcTaskList = (mediaType, mediaChannel, isDarkMode, selected = false, contactDirection, outboundType) => {
    let imgSrc;
    const derivedMediaChannel = getMediaChannelForTaskList(mediaChannel, contactDirection, outboundType);
    if (mediaType === _constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.MIDCALL_MONITORING) {
        imgSrc = isDarkMode ? _constants__WEBPACK_IMPORTED_MODULE_0__.MONITORING_REGULAR_DARK : _constants__WEBPACK_IMPORTED_MODULE_0__.MONITORING_REGULAR_LIGHT;
    }
    else if (derivedMediaChannel &&
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.MEDIA_SUBCHANNEL_TYPES[derivedMediaChannel]) {
        if (selected) {
            imgSrc = isDarkMode
                ? _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.MEDIA_SUBCHANNEL_TYPES[derivedMediaChannel]["normal"].dark
                : _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.MEDIA_SUBCHANNEL_TYPES[derivedMediaChannel]["normal"].light;
        }
        else {
            imgSrc = isDarkMode
                ? _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.MEDIA_SUBCHANNEL_TYPES[derivedMediaChannel]["unselected"].dark
                : _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.MEDIA_SUBCHANNEL_TYPES[derivedMediaChannel]["unselected"].light;
        }
    }
    return imgSrc;
};
const isDigitalOutboundCase = (mediaChannel, contactDirection, outboundType) => {
    return (contactDirection === _constants__WEBPACK_IMPORTED_MODULE_0__.CONTACT_DIRECTION.OUTBOUND &&
        outboundType === _constants__WEBPACK_IMPORTED_MODULE_0__.OUT_DIAL &&
        (mediaChannel === _constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.EMAIL || mediaChannel === _constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.SMS));
};
/**
 *
 * @param mediaType
 * @param mediaChannel
 * @returns
 */
const isIconSrc = (mediaType, mediaChannel, contactDirection, outboundType) => {
    return (mediaType === _constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.MIDCALL_MONITORING ||
        isDigitalOutboundCase(mediaChannel !== null && mediaChannel !== void 0 ? mediaChannel : "", contactDirection, outboundType) ||
        (mediaChannel &&
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.MEDIA_SUBCHANNEL_TYPES[mediaChannel]
            ? true
            : false));
};
const getTimerLabel = (timer) => {
    const timeUnits = ["hour", "minute", "second"];
    const parts = timer
        .split(":")
        .map(Number)
        .map((value, i) => (value > 0 ? `${value} ${timeUnits[i]}${value !== 1 ? "s" : ""}` : ""))
        .filter(Boolean);
    return `${parts.join(", ")}`;
};
const makeTelephonyReadable = (num) => {
    return num ? num.split("").join(" ").replace(/ {2}/g, " ") : "";
};
const updateTimerAriaLabel = (timeStamp) => {
    const now = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.utc();
    const taskTime = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(timeStamp);
    const diff = now.diff(taskTime);
    const formattedDifference = diff.toFormat("hh:mm:ss");
    return getTimerLabel(formattedDifference);
};
const makeAlphaNumericReadable = (inputString) => {
    if (!inputString) {
        return "";
    }
    const isDigit = (char) => /\d/.test(char);
    const modifiedStr = inputString
        .split("")
        .map((char) => {
        if (isDigit(char)) {
            return ` ${char} `;
        }
        return char;
    })
        .join("");
    return modifiedStr.replace(/\s+/g, " ").trim();
};
const naturalSort = (a, b) => {
    return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
};
const formatTimeRangeForCallbackTitle = (startTime, endTime) => {
    const startParts = startTime.split(":");
    let startHour = parseInt(startParts[0], 10);
    const startMinutes = startParts[1];
    const startPeriod = startHour >= 12 ? "PM" : "AM";
    startHour = startHour % 12 || 12;
    const endParts = endTime.split(":");
    let endHour = parseInt(endParts[0], 10);
    const endMinutes = endParts[1];
    const endPeriod = endHour >= 12 ? "PM" : "AM";
    endHour = endHour % 12 || 12;
    return `${startHour}:${startMinutes}${startPeriod}-${endHour}:${endMinutes}${endPeriod}`;
};
/**
 * Validates the use-case for digital outbound contacts for auto-accept.
 * @param mediaChannel - i.e. email, sms etc.
 * @param contactDirection - i.e. INBOUND, OUTBOUND etc.
 * @param outboundType - i.e. OUTDIAL etc.
 * Returns a boolean.
 */


/***/ }),

/***/ "@adobe/lit-mobx":
/*!**********************************!*\
  !*** external "@adobe/lit-mobx" ***!
  \**********************************/
/***/ ((module) => {

"use strict";
module.exports = require("@adobe/lit-mobx");

/***/ }),

/***/ "@agentx/agentx-services":
/*!******************************************!*\
  !*** external "@agentx/agentx-services" ***!
  \******************************************/
/***/ ((module) => {

"use strict";
module.exports = require("@agentx/agentx-services");

/***/ }),

/***/ "@momentum-ui/web-components":
/*!**********************************************!*\
  !*** external "@momentum-ui/web-components" ***!
  \**********************************************/
/***/ ((module) => {

"use strict";
module.exports = require("@momentum-ui/web-components");

/***/ }),

/***/ "@open-wc/testing-helpers":
/*!*******************************************!*\
  !*** external "@open-wc/testing-helpers" ***!
  \*******************************************/
/***/ ((module) => {

"use strict";
module.exports = require("@open-wc/testing-helpers");

/***/ }),

/***/ "@popperjs/core":
/*!*********************************!*\
  !*** external "@popperjs/core" ***!
  \*********************************/
/***/ ((module) => {

"use strict";
module.exports = require("@popperjs/core");

/***/ }),

/***/ "@popperjs/core/lib/popper":
/*!********************************************!*\
  !*** external "@popperjs/core/lib/popper" ***!
  \********************************************/
/***/ ((module) => {

"use strict";
module.exports = require("@popperjs/core/lib/popper");

/***/ }),

/***/ "@uuip/unified-ui-platform-common-components":
/*!**************************************************************!*\
  !*** external "@uuip/unified-ui-platform-common-components" ***!
  \**************************************************************/
/***/ ((module) => {

"use strict";
module.exports = require("@uuip/unified-ui-platform-common-components");

/***/ }),

/***/ "@uuip/unified-ui-platform-sdk":
/*!************************************************!*\
  !*** external "@uuip/unified-ui-platform-sdk" ***!
  \************************************************/
/***/ ((module) => {

"use strict";
module.exports = require("@uuip/unified-ui-platform-sdk");

/***/ }),

/***/ "ag-charts-community":
/*!**************************************!*\
  !*** external "ag-charts-community" ***!
  \**************************************/
/***/ ((module) => {

"use strict";
module.exports = require("ag-charts-community");

/***/ }),

/***/ "ag-charts-enterprise":
/*!***************************************!*\
  !*** external "ag-charts-enterprise" ***!
  \***************************************/
/***/ ((module) => {

"use strict";
module.exports = require("ag-charts-enterprise");

/***/ }),

/***/ "ag-grid-enterprise":
/*!*************************************!*\
  !*** external "ag-grid-enterprise" ***!
  \*************************************/
/***/ ((module) => {

"use strict";
module.exports = require("ag-grid-enterprise");

/***/ }),

/***/ "axios":
/*!************************!*\
  !*** external "axios" ***!
  \************************/
/***/ ((module) => {

"use strict";
module.exports = require("axios");

/***/ }),

/***/ "lit-element":
/*!******************************!*\
  !*** external "lit-element" ***!
  \******************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-element");

/***/ }),

/***/ "lit-html":
/*!***************************!*\
  !*** external "lit-html" ***!
  \***************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-html");

/***/ }),

/***/ "lit-html/directives/class-map":
/*!************************************************!*\
  !*** external "lit-html/directives/class-map" ***!
  \************************************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-html/directives/class-map");

/***/ }),

/***/ "lit-html/directives/if-defined":
/*!*************************************************!*\
  !*** external "lit-html/directives/if-defined" ***!
  \*************************************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-html/directives/if-defined");

/***/ }),

/***/ "lit-html/directives/if-defined.js":
/*!****************************************************!*\
  !*** external "lit-html/directives/if-defined.js" ***!
  \****************************************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-html/directives/if-defined.js");

/***/ }),

/***/ "lit-html/directives/repeat":
/*!*********************************************!*\
  !*** external "lit-html/directives/repeat" ***!
  \*********************************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-html/directives/repeat");

/***/ }),

/***/ "lit-html/directives/repeat.js":
/*!************************************************!*\
  !*** external "lit-html/directives/repeat.js" ***!
  \************************************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-html/directives/repeat.js");

/***/ }),

/***/ "lit-html/directives/style-map":
/*!************************************************!*\
  !*** external "lit-html/directives/style-map" ***!
  \************************************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-html/directives/style-map");

/***/ }),

/***/ "lit-html/lib/part":
/*!************************************!*\
  !*** external "lit-html/lib/part" ***!
  \************************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-html/lib/part");

/***/ }),

/***/ "lit-virtualizer":
/*!**********************************!*\
  !*** external "lit-virtualizer" ***!
  \**********************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-virtualizer");

/***/ }),

/***/ "lodash":
/*!*************************!*\
  !*** external "lodash" ***!
  \*************************/
/***/ ((module) => {

"use strict";
module.exports = require("lodash");

/***/ }),

/***/ "luxon":
/*!************************!*\
  !*** external "luxon" ***!
  \************************/
/***/ ((module) => {

"use strict";
module.exports = require("luxon");

/***/ }),

/***/ "mobx":
/*!***********************!*\
  !*** external "mobx" ***!
  \***********************/
/***/ ((module) => {

"use strict";
module.exports = require("mobx");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "/";
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AgentPerformanceReports: () => (/* reexport safe */ _components_AgentPerformanceReports_AgentPerformanceReports__WEBPACK_IMPORTED_MODULE_8__.AgentPerformanceReports),
/* harmony export */   AgentPerformanceWidget: () => (/* reexport safe */ _components_AgentPerformanceWidget_AgentPerformanceWidget__WEBPACK_IMPORTED_MODULE_10__.AgentPerformanceWidget),
/* harmony export */   AgentXLoadingScreen: () => (/* reexport safe */ _components_StationLogin_AppLoadingScreen__WEBPACK_IMPORTED_MODULE_35__.AgentXLoadingScreen),
/* harmony export */   CallBackModal: () => (/* reexport safe */ _components_ScheduleAndManageCallBack_CallbackModal__WEBPACK_IMPORTED_MODULE_31__.CallBackModal),
/* harmony export */   CallbackForm: () => (/* reexport safe */ _components_ScheduleAndManageCallBack_CallBackForm__WEBPACK_IMPORTED_MODULE_30__.CallbackForm),
/* harmony export */   ChannelFilter: () => (/* reexport safe */ _components_SupervisorFilters_ChannelFilter_ChannelFilter__WEBPACK_IMPORTED_MODULE_36__.ChannelFilter),
/* harmony export */   ClosedTasksListTabPanel: () => (/* reexport safe */ _components_TasksTab_index__WEBPACK_IMPORTED_MODULE_4__.ClosedTasksListTabPanel),
/* harmony export */   CollapseArea: () => (/* reexport safe */ _components_CollapseArea_CollapseArea__WEBPACK_IMPORTED_MODULE_11__.CollapseArea),
/* harmony export */   CollapseToggler: () => (/* reexport safe */ _components_CollapseArea_components_CollapseToggler__WEBPACK_IMPORTED_MODULE_12__.CollapseToggler),
/* harmony export */   CountDownTimer: () => (/* reexport safe */ _components_CountDownTimer_CountDownTimer__WEBPACK_IMPORTED_MODULE_16__.CountDownTimer),
/* harmony export */   EvaluationManagerForm: () => (/* reexport safe */ _components_EvaluationManager_EvaluationManagerForm__WEBPACK_IMPORTED_MODULE_17__.EvaluationManagerForm),
/* harmony export */   EvaluationManagerTable: () => (/* reexport safe */ _components_EvaluationManager_EvaluationManagerTable__WEBPACK_IMPORTED_MODULE_18__.EvaluationManagerTable),
/* harmony export */   Frame: () => (/* reexport safe */ _components_Common_Frame_Frame__WEBPACK_IMPORTED_MODULE_13__.Frame),
/* harmony export */   GStateSelectorMenu: () => (/* reexport safe */ _components_AgentGStateSelector_GStateSelectorMenu_AgentGStateSelectorMenu__WEBPACK_IMPORTED_MODULE_47__.GStateSelectorMenu),
/* harmony export */   GranularStateSelector: () => (/* reexport safe */ _src_components_GranularStateSelector_GranularStateSelector__WEBPACK_IMPORTED_MODULE_6__.GranularStateSelector),
/* harmony export */   GranularStateSelectorIndicator: () => (/* reexport safe */ _src_components_GranularStateSelector_GranularStateSelectorIndicator__WEBPACK_IMPORTED_MODULE_7__.GranularStateSelectorIndicator),
/* harmony export */   GridWidget: () => (/* reexport safe */ _components_GridWidget_Grid__WEBPACK_IMPORTED_MODULE_19__.GridWidget),
/* harmony export */   IframeBase: () => (/* reexport safe */ _components_IframeBase_IframeBase__WEBPACK_IMPORTED_MODULE_20__.IframeBase),
/* harmony export */   IframeLogin: () => (/* reexport safe */ _components_IframeLogin_IframeLogin__WEBPACK_IMPORTED_MODULE_21__.IframeLogin),
/* harmony export */   ImiChatWrapper: () => (/* reexport safe */ _components_ImiChatWrapper_ImiChatWrapper__WEBPACK_IMPORTED_MODULE_22__.ImiChatWrapper),
/* harmony export */   InteractionsTabDetailsWidget: () => (/* reexport safe */ _components_InteractionsTab_index__WEBPACK_IMPORTED_MODULE_2__.InteractionsTabDetailsWidget),
/* harmony export */   InteractionsTabWidget: () => (/* reexport safe */ _components_InteractionsTab_index__WEBPACK_IMPORTED_MODULE_2__.InteractionsTabWidget),
/* harmony export */   IvrTranscripts: () => (/* reexport safe */ _components_IvrTranscripts_IvrTranscripts__WEBPACK_IMPORTED_MODULE_23__.IvrTranscripts),
/* harmony export */   MenuNotification: () => (/* reexport safe */ _components_MenuNotifications_MenuNotifications__WEBPACK_IMPORTED_MODULE_24__.MenuNotification),
/* harmony export */   MoreActionsWidget: () => (/* reexport safe */ _components_MoreActions_components_MoreActionsContainer_MoreActionsWidget__WEBPACK_IMPORTED_MODULE_25__.MoreActionsWidget),
/* harmony export */   Navigation: () => (/* reexport safe */ _components_Navigation_Navigation__WEBPACK_IMPORTED_MODULE_27__.Navigation),
/* harmony export */   PageHeader: () => (/* reexport safe */ _components_Common_Headers_index__WEBPACK_IMPORTED_MODULE_0__.PageHeader),
/* harmony export */   PanelFrame: () => (/* reexport safe */ _components_Common_Panel_index__WEBPACK_IMPORTED_MODULE_1__.PanelFrame),
/* harmony export */   PanelHeader: () => (/* reexport safe */ _components_Common_Headers_index__WEBPACK_IMPORTED_MODULE_0__.PanelHeader),
/* harmony export */   PanelLayout: () => (/* reexport safe */ _components_Common_Panel_index__WEBPACK_IMPORTED_MODULE_1__.PanelLayout),
/* harmony export */   QualityMonitoringWidget: () => (/* reexport safe */ _components_QualityMonitoringWidget_QualityMonitoring__WEBPACK_IMPORTED_MODULE_28__.QualityMonitoringWidget),
/* harmony export */   QueueDataWidget: () => (/* reexport safe */ _components_QueueStatsTab_index__WEBPACK_IMPORTED_MODULE_3__.QueueDataWidget),
/* harmony export */   QueueFilter: () => (/* reexport safe */ _components_SupervisorFilters_QueueFilter_QueueFilter__WEBPACK_IMPORTED_MODULE_37__.QueueFilter),
/* harmony export */   QueueInteractionsWidget: () => (/* reexport safe */ _components_QueueStatsTab_index__WEBPACK_IMPORTED_MODULE_3__.QueueInteractionsWidget),
/* harmony export */   QueueStatsDetail: () => (/* reexport safe */ _components_QueueStatsTab_index__WEBPACK_IMPORTED_MODULE_3__.QueueStatsDetail),
/* harmony export */   QueueStatsHeader: () => (/* reexport safe */ _components_QueueStatsTab_index__WEBPACK_IMPORTED_MODULE_3__.QueueStatsHeader),
/* harmony export */   QueueStatsLanding: () => (/* reexport safe */ _components_QueueStatsTab_index__WEBPACK_IMPORTED_MODULE_3__.QueueStatsLanding),
/* harmony export */   QueueStatsPerformanceDetailsView: () => (/* reexport safe */ _components_QueueStatsTab_index__WEBPACK_IMPORTED_MODULE_3__.QueueStatsPerformanceDetailsView),
/* harmony export */   QueueStatsWidgets: () => (/* reexport safe */ _components_QueueStatsTab_index__WEBPACK_IMPORTED_MODULE_3__.QueueStatsWidgets),
/* harmony export */   QueuedTasksListTabPanel: () => (/* reexport safe */ _components_TasksTab_index__WEBPACK_IMPORTED_MODULE_4__.QueuedTasksListTabPanel),
/* harmony export */   QueuesMonitoringWidget: () => (/* reexport safe */ _components_QueueStatsTab_index__WEBPACK_IMPORTED_MODULE_3__.QueuesMonitoringWidget),
/* harmony export */   RealtimeTranscript: () => (/* reexport safe */ _components_RealtimeTranscript_RealtimeTranscript__WEBPACK_IMPORTED_MODULE_29__.RealtimeTranscript),
/* harmony export */   ResetTabOrderAction: () => (/* reexport safe */ _components_MoreActions_components_ResetTabOrderAction_ResetTabOrderAction__WEBPACK_IMPORTED_MODULE_26__.ResetTabOrderAction),
/* harmony export */   ScreenPop: () => (/* reexport safe */ _components_ScreenPop_ScreenPop__WEBPACK_IMPORTED_MODULE_32__.ScreenPop),
/* harmony export */   ShortcutKey: () => (/* reexport safe */ _components_ShortcutKey_ShortcutKeyModal__WEBPACK_IMPORTED_MODULE_33__.ShortcutKey),
/* harmony export */   StatePreviewOverlay: () => (/* reexport safe */ _components_StateSelector_StatePreviewOverlay__WEBPACK_IMPORTED_MODULE_34__.StatePreviewOverlay),
/* harmony export */   TableHeaderWidget: () => (/* reexport safe */ _components_QueueStatsTab_index__WEBPACK_IMPORTED_MODULE_3__.TableHeaderWidget),
/* harmony export */   TaskList: () => (/* reexport safe */ _components_TaskList_TaskList__WEBPACK_IMPORTED_MODULE_39__.TaskList),
/* harmony export */   TaskListPanelWrapper: () => (/* reexport safe */ _components_TasksTab_index__WEBPACK_IMPORTED_MODULE_4__.TaskListPanelWrapper),
/* harmony export */   TasksTabList: () => (/* reexport safe */ _components_TasksTab_index__WEBPACK_IMPORTED_MODULE_4__.TasksTabList),
/* harmony export */   TeamFilter: () => (/* reexport safe */ _components_SupervisorFilters_TeamFilter_TeamFilter__WEBPACK_IMPORTED_MODULE_38__.TeamFilter),
/* harmony export */   TeamPerformance: () => (/* reexport safe */ _components_TeamPerformanceWidget_TeamPerformance__WEBPACK_IMPORTED_MODULE_40__.TeamPerformance),
/* harmony export */   TeamsListInfiniteScroll: () => (/* reexport safe */ _components_teamsListInfiniteScroll__WEBPACK_IMPORTED_MODULE_42__.TeamsListInfiniteScroll),
/* harmony export */   UserProfile: () => (/* reexport safe */ _components_userProfile_userProfile__WEBPACK_IMPORTED_MODULE_43__.UserProfile),
/* harmony export */   UserStationLogin: () => (/* reexport safe */ _components_userStationLogin_userStationLogin__WEBPACK_IMPORTED_MODULE_44__.UserStationLogin),
/* harmony export */   WcGridWidget: () => (/* reexport safe */ _components_Common_WcGrid__WEBPACK_IMPORTED_MODULE_14__.WcGridWidget),
/* harmony export */   WebexWrapper: () => (/* reexport safe */ _components_WebexWrapper_WebexWrapper__WEBPACK_IMPORTED_MODULE_45__.WebexWrapper),
/* harmony export */   WidgetError: () => (/* reexport safe */ _components_Common_WidgetError_WidgetError__WEBPACK_IMPORTED_MODULE_15__.WidgetError),
/* harmony export */   analyzerSessionHelper: () => (/* reexport safe */ _components_AgentPerformanceReports_AnalyzerSessionHelper__WEBPACK_IMPORTED_MODULE_9__.analyzerSessionHelper),
/* harmony export */   getAgentInteractionTime: () => (/* reexport safe */ _components_TeamPerformanceWidget_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_41__.getAgentInteractionTime),
/* harmony export */   getParticipantsDetails: () => (/* reexport safe */ _components_TeamPerformanceWidget_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_41__.getParticipantsDetails),
/* harmony export */   initAgentxMfeWcBased: () => (/* binding */ initAgentxMfeWcBased),
/* harmony export */   isMicrophoneAccessDenied: () => (/* reexport safe */ _utils_helpers__WEBPACK_IMPORTED_MODULE_46__.isMicrophoneAccessDenied),
/* harmony export */   isWebRtcSupportedBrowser: () => (/* reexport safe */ _utils_helpers__WEBPACK_IMPORTED_MODULE_46__.isWebRtcSupportedBrowser),
/* harmony export */   makeAlphaNumericReadable: () => (/* reexport safe */ _utils_helpers__WEBPACK_IMPORTED_MODULE_46__.makeAlphaNumericReadable),
/* harmony export */   mapAgentContactStatus: () => (/* reexport safe */ _components_TeamPerformanceWidget_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_41__.mapAgentContactStatus)
/* harmony export */ });
/* harmony import */ var _components_Common_Headers_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./components/Common/Headers/index */ "./src/components/Common/Headers/index.ts");
/* harmony import */ var _components_Common_Panel_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components/Common/Panel/index */ "./src/components/Common/Panel/index.ts");
/* harmony import */ var _components_InteractionsTab_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./components/InteractionsTab/index */ "./src/components/InteractionsTab/index.ts");
/* harmony import */ var _components_QueueStatsTab_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./components/QueueStatsTab/index */ "./src/components/QueueStatsTab/index.ts");
/* harmony import */ var _components_TasksTab_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./components/TasksTab/index */ "./src/components/TasksTab/index.ts");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./config */ "./src/config.ts");
/* harmony import */ var _src_components_GranularStateSelector_GranularStateSelector__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../src/components/GranularStateSelector/GranularStateSelector */ "./src/components/GranularStateSelector/GranularStateSelector.ts");
/* harmony import */ var _src_components_GranularStateSelector_GranularStateSelectorIndicator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../src/components/GranularStateSelector/GranularStateSelectorIndicator */ "./src/components/GranularStateSelector/GranularStateSelectorIndicator.ts");
/* harmony import */ var _components_AgentPerformanceReports_AgentPerformanceReports__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./components/AgentPerformanceReports/AgentPerformanceReports */ "./src/components/AgentPerformanceReports/AgentPerformanceReports.ts");
/* harmony import */ var _components_AgentPerformanceReports_AnalyzerSessionHelper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./components/AgentPerformanceReports/AnalyzerSessionHelper */ "./src/components/AgentPerformanceReports/AnalyzerSessionHelper.ts");
/* harmony import */ var _components_AgentPerformanceWidget_AgentPerformanceWidget__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./components/AgentPerformanceWidget/AgentPerformanceWidget */ "./src/components/AgentPerformanceWidget/AgentPerformanceWidget.ts");
/* harmony import */ var _components_CollapseArea_CollapseArea__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./components/CollapseArea/CollapseArea */ "./src/components/CollapseArea/CollapseArea.ts");
/* harmony import */ var _components_CollapseArea_components_CollapseToggler__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./components/CollapseArea/components/CollapseToggler */ "./src/components/CollapseArea/components/CollapseToggler.ts");
/* harmony import */ var _components_Common_Frame_Frame__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./components/Common/Frame/Frame */ "./src/components/Common/Frame/Frame.ts");
/* harmony import */ var _components_Common_WcGrid__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./components/Common/WcGrid */ "./src/components/Common/WcGrid/index.ts");
/* harmony import */ var _components_Common_WidgetError_WidgetError__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./components/Common/WidgetError/WidgetError */ "./src/components/Common/WidgetError/WidgetError.ts");
/* harmony import */ var _components_CountDownTimer_CountDownTimer__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./components/CountDownTimer/CountDownTimer */ "./src/components/CountDownTimer/CountDownTimer.ts");
/* harmony import */ var _components_EvaluationManager_EvaluationManagerForm__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./components/EvaluationManager/EvaluationManagerForm */ "./src/components/EvaluationManager/EvaluationManagerForm.ts");
/* harmony import */ var _components_EvaluationManager_EvaluationManagerTable__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./components/EvaluationManager/EvaluationManagerTable */ "./src/components/EvaluationManager/EvaluationManagerTable.ts");
/* harmony import */ var _components_GridWidget_Grid__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./components/GridWidget/Grid */ "./src/components/GridWidget/Grid.ts");
/* harmony import */ var _components_IframeBase_IframeBase__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./components/IframeBase/IframeBase */ "./src/components/IframeBase/IframeBase.ts");
/* harmony import */ var _components_IframeLogin_IframeLogin__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./components/IframeLogin/IframeLogin */ "./src/components/IframeLogin/IframeLogin.ts");
/* harmony import */ var _components_ImiChatWrapper_ImiChatWrapper__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./components/ImiChatWrapper/ImiChatWrapper */ "./src/components/ImiChatWrapper/ImiChatWrapper.ts");
/* harmony import */ var _components_IvrTranscripts_IvrTranscripts__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./components/IvrTranscripts/IvrTranscripts */ "./src/components/IvrTranscripts/IvrTranscripts.ts");
/* harmony import */ var _components_MenuNotifications_MenuNotifications__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./components/MenuNotifications/MenuNotifications */ "./src/components/MenuNotifications/MenuNotifications.ts");
/* harmony import */ var _components_MoreActions_components_MoreActionsContainer_MoreActionsWidget__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./components/MoreActions/components/MoreActionsContainer/MoreActionsWidget */ "./src/components/MoreActions/components/MoreActionsContainer/MoreActionsWidget.ts");
/* harmony import */ var _components_MoreActions_components_ResetTabOrderAction_ResetTabOrderAction__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./components/MoreActions/components/ResetTabOrderAction/ResetTabOrderAction */ "./src/components/MoreActions/components/ResetTabOrderAction/ResetTabOrderAction.ts");
/* harmony import */ var _components_Navigation_Navigation__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./components/Navigation/Navigation */ "./src/components/Navigation/Navigation.ts");
/* harmony import */ var _components_QualityMonitoringWidget_QualityMonitoring__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./components/QualityMonitoringWidget/QualityMonitoring */ "./src/components/QualityMonitoringWidget/QualityMonitoring.ts");
/* harmony import */ var _components_RealtimeTranscript_RealtimeTranscript__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./components/RealtimeTranscript/RealtimeTranscript */ "./src/components/RealtimeTranscript/RealtimeTranscript.ts");
/* harmony import */ var _components_ScheduleAndManageCallBack_CallBackForm__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./components/ScheduleAndManageCallBack/CallBackForm */ "./src/components/ScheduleAndManageCallBack/CallBackForm.ts");
/* harmony import */ var _components_ScheduleAndManageCallBack_CallbackModal__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./components/ScheduleAndManageCallBack/CallbackModal */ "./src/components/ScheduleAndManageCallBack/CallbackModal.ts");
/* harmony import */ var _components_ScreenPop_ScreenPop__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./components/ScreenPop/ScreenPop */ "./src/components/ScreenPop/ScreenPop.ts");
/* harmony import */ var _components_ShortcutKey_ShortcutKeyModal__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./components/ShortcutKey/ShortcutKeyModal */ "./src/components/ShortcutKey/ShortcutKeyModal.ts");
/* harmony import */ var _components_StateSelector_StatePreviewOverlay__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./components/StateSelector/StatePreviewOverlay */ "./src/components/StateSelector/StatePreviewOverlay.ts");
/* harmony import */ var _components_StationLogin_AppLoadingScreen__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./components/StationLogin/AppLoadingScreen */ "./src/components/StationLogin/AppLoadingScreen.ts");
/* harmony import */ var _components_SupervisorFilters_ChannelFilter_ChannelFilter__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./components/SupervisorFilters/ChannelFilter/ChannelFilter */ "./src/components/SupervisorFilters/ChannelFilter/ChannelFilter.ts");
/* harmony import */ var _components_SupervisorFilters_QueueFilter_QueueFilter__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./components/SupervisorFilters/QueueFilter/QueueFilter */ "./src/components/SupervisorFilters/QueueFilter/QueueFilter.ts");
/* harmony import */ var _components_SupervisorFilters_TeamFilter_TeamFilter__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ./components/SupervisorFilters/TeamFilter/TeamFilter */ "./src/components/SupervisorFilters/TeamFilter/TeamFilter.ts");
/* harmony import */ var _components_TaskList_TaskList__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./components/TaskList/TaskList */ "./src/components/TaskList/TaskList.ts");
/* harmony import */ var _components_TeamPerformanceWidget_TeamPerformance__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./components/TeamPerformanceWidget/TeamPerformance */ "./src/components/TeamPerformanceWidget/TeamPerformance.ts");
/* harmony import */ var _components_TeamPerformanceWidget_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ./components/TeamPerformanceWidget/TeamPerformanceUtils */ "./src/components/TeamPerformanceWidget/TeamPerformanceUtils.ts");
/* harmony import */ var _components_teamsListInfiniteScroll__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ./components/teamsListInfiniteScroll */ "./src/components/teamsListInfiniteScroll/index.ts");
/* harmony import */ var _components_userProfile_userProfile__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ./components/userProfile/userProfile */ "./src/components/userProfile/userProfile.ts");
/* harmony import */ var _components_userStationLogin_userStationLogin__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ./components/userStationLogin/userStationLogin */ "./src/components/userStationLogin/userStationLogin.ts");
/* harmony import */ var _components_WebexWrapper_WebexWrapper__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ./components/WebexWrapper/WebexWrapper */ "./src/components/WebexWrapper/WebexWrapper.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ./utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _components_AgentGStateSelector_GStateSelectorMenu_AgentGStateSelectorMenu__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ./components/AgentGStateSelector/GStateSelectorMenu/AgentGStateSelectorMenu */ "./src/components/AgentGStateSelector/GStateSelectorMenu/AgentGStateSelectorMenu.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
















































function initAgentxMfeWcBased(config) {
    return __awaiter(this, void 0, void 0, function* () {
        (0,_config__WEBPACK_IMPORTED_MODULE_5__.setAgentxMfeWcBasedConfig)(config);
    });
}

})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map